// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27none%27 viewBox=%270 0 20 20%27%3e%3cpath stroke=%27%236b7280%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%271.5%27 d=%27M6 8l4 4 4-4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/assets/img/icons/dropdown.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../public/assets/img/icons/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/assets/img/coming-soon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../public/assets/img/authentication/login-img.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../public/assets/img/authentication/register-img.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../../public/assets/img/authentication/forgot-password-img.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../../public/assets/img/authentication/reset-password-img.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../../public/assets/img/authentication/email-verification-img.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../../public/assets/img/icons/calendars.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700;800;900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/****** Utils ******/
.search-dropdown .search-info .customers li a img {
  transition: all 0.5s;
}

/******* Base *******/
body {
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  color: #5B6670;
  line-height: 1.5;
  background-color: #FAFBFE;
  overflow-y: auto;
  overflow-x: hidden;
}

::selection {
  background: #FF9F43;
  color: #ffffff;
  text-shadow: none;
}

img {
  max-width: 100%;
  height: auto;
  vertical-align: inherit;
}

* {
  outline: none;
}

button {
  transition: all 0.5s ease;
}
button:focus {
  box-shadow: none !important;
}

a {
  color: #FF9F43;
  cursor: pointer;
  text-decoration: none;
  transition: all 0.5s ease;
}
a:hover {
  color: #ff8510;
  transition: all 0.5s ease;
}
a:focus {
  outline: 0;
}

p {
  margin-bottom: 20px;
}
p:last-child {
  margin-bottom: 0;
}

strong {
  font-weight: 700;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  color: #1B2850;
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  margin-bottom: 0;
}

ol, ul {
  list-style: none;
  margin-block-end: 0;
  padding: 0;
}

ul {
  list-style: none;
}
ul.list-disc {
  list-style: disc;
  padding-left: 15px;
}
ul.list-disc ul {
  list-style-type: circle;
}
ul.list-decimal {
  list-style: decimal;
  padding-left: 15px;
}
ul.list-decimal ul {
  list-style-type: decimal;
}
ul.list-icon {
  list-style: none;
  padding-left: 0;
}
ul.list-icon > li {
  padding-left: 1.875rem;
  counter-increment: li;
}
ul.list-icon > li i,
ul.list-icon > li .feather-icon,
ul.list-icon > li .svg-icon {
  display: inline-block;
  height: 20px;
  width: 20px;
  text-align: center;
  margin-left: -1.25rem;
  position: relative;
  left: -10px;
  padding: 1px;
  top: -1px;
}
ul.list-icon > li i {
  font-size: 20px;
  top: 5px;
}
ul .btn-primary:not(:disabled):not(.disabled):active:focus, ul .btn-primary:not(:disabled):not(.disabled).active:focus {
  box-shadow: none;
}

.bg-primary {
  background-color: #FF9F43 !important;
}

.bg-secondary {
  background-color: #092C4C !important;
}

.bg-info {
  background-color: #17a2b8 !important;
}

.bg-success {
  background-color: #28C76F !important;
}

.bg-warning {
  background-color: #FF9900 !important;
}

.bg-danger {
  background-color: #FF0000 !important;
}

.bg-dark {
  background-color: #29344a !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

.bg-white {
  background-color: #ffffff !important;
}

.bg-pink {
  background-color: #ff63a5 !important;
}

.bg-purple {
  background-color: #7367F0 !important;
}

.bg-teal {
  background-color: #02a8b5 !important;
}

.bg-blue {
  background-color: #3577f1 !important;
}

.bg-primary {
  background-color: #FF9F43 !important;
}
.bg-primary.bg-opacity-10 {
  background-color: rgba(255, 159, 67, 0.1) !important;
}
.bg-primary.bg-opacity-25 {
  background-color: rgba(255, 159, 67, 0.25) !important;
}
.bg-primary.bg-opacity-50 {
  background-color: rgba(255, 159, 67, 0.5) !important;
}
.bg-primary.bg-opacity-75 {
  background-color: rgba(255, 159, 67, 0.75) !important;
}
.bg-primary.bg-opacity-100 {
  background-color: #ff9f43 !important;
}

.bg-secondary {
  background-color: #092C4C !important;
}
.bg-secondary.bg-opacity-10 {
  background-color: rgba(9, 44, 76, 0.1) !important;
}
.bg-secondary.bg-opacity-25 {
  background-color: rgba(9, 44, 76, 0.25) !important;
}
.bg-secondary.bg-opacity-50 {
  background-color: rgba(9, 44, 76, 0.5) !important;
}
.bg-secondary.bg-opacity-75 {
  background-color: rgba(9, 44, 76, 0.75) !important;
}
.bg-secondary.bg-opacity-100 {
  background-color: #092c4c !important;
}

.bg-info {
  background-color: #17a2b8 !important;
}
.bg-info.bg-opacity-10 {
  background-color: rgba(23, 162, 184, 0.1) !important;
}
.bg-info.bg-opacity-25 {
  background-color: rgba(23, 162, 184, 0.25) !important;
}
.bg-info.bg-opacity-50 {
  background-color: rgba(23, 162, 184, 0.5) !important;
}
.bg-info.bg-opacity-75 {
  background-color: rgba(23, 162, 184, 0.75) !important;
}
.bg-info.bg-opacity-100 {
  background-color: #17a2b8 !important;
}

.bg-success {
  background-color: #28C76F !important;
}
.bg-success.bg-opacity-10 {
  background-color: rgba(40, 199, 111, 0.1) !important;
}
.bg-success.bg-opacity-25 {
  background-color: rgba(40, 199, 111, 0.25) !important;
}
.bg-success.bg-opacity-50 {
  background-color: rgba(40, 199, 111, 0.5) !important;
}
.bg-success.bg-opacity-75 {
  background-color: rgba(40, 199, 111, 0.75) !important;
}
.bg-success.bg-opacity-100 {
  background-color: #28c76f !important;
}

.bg-warning {
  background-color: #FF9900 !important;
}
.bg-warning.bg-opacity-10 {
  background-color: rgba(255, 153, 0, 0.1) !important;
}
.bg-warning.bg-opacity-25 {
  background-color: rgba(255, 153, 0, 0.25) !important;
}
.bg-warning.bg-opacity-50 {
  background-color: rgba(255, 153, 0, 0.5) !important;
}
.bg-warning.bg-opacity-75 {
  background-color: rgba(255, 153, 0, 0.75) !important;
}
.bg-warning.bg-opacity-100 {
  background-color: #ff9900 !important;
}

.bg-danger {
  background-color: #FF0000 !important;
}
.bg-danger.bg-opacity-10 {
  background-color: rgba(255, 0, 0, 0.1) !important;
}
.bg-danger.bg-opacity-25 {
  background-color: rgba(255, 0, 0, 0.25) !important;
}
.bg-danger.bg-opacity-50 {
  background-color: rgba(255, 0, 0, 0.5) !important;
}
.bg-danger.bg-opacity-75 {
  background-color: rgba(255, 0, 0, 0.75) !important;
}
.bg-danger.bg-opacity-100 {
  background-color: red !important;
}

.bg-dark {
  background-color: #29344a !important;
}
.bg-dark.bg-opacity-10 {
  background-color: rgba(41, 52, 74, 0.1) !important;
}
.bg-dark.bg-opacity-25 {
  background-color: rgba(41, 52, 74, 0.25) !important;
}
.bg-dark.bg-opacity-50 {
  background-color: rgba(41, 52, 74, 0.5) !important;
}
.bg-dark.bg-opacity-75 {
  background-color: rgba(41, 52, 74, 0.75) !important;
}
.bg-dark.bg-opacity-100 {
  background-color: #29344a !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}
.bg-light.bg-opacity-10 {
  background-color: rgba(248, 249, 250, 0.1) !important;
}
.bg-light.bg-opacity-25 {
  background-color: rgba(248, 249, 250, 0.25) !important;
}
.bg-light.bg-opacity-50 {
  background-color: rgba(248, 249, 250, 0.5) !important;
}
.bg-light.bg-opacity-75 {
  background-color: rgba(248, 249, 250, 0.75) !important;
}
.bg-light.bg-opacity-100 {
  background-color: #f8f9fa !important;
}

.bg-primary {
  background-color: #FF9F43 !important;
  border: 1px solid #FF9F43 !important;
  color: #ffffff;
}

.bg-secondary {
  background-color: #092C4C !important;
  border: 1px solid #092C4C !important;
  color: #ffffff;
}

.bg-success {
  background-color: #28C76F !important;
  border: 1px solid #28C76F !important;
  color: #ffffff;
}

.bg-info {
  background-color: #17a2b8 !important;
  border: 1px solid #17a2b8 !important;
  color: #ffffff;
}

.bg-warning {
  background-color: #FF9900 !important;
  border: 1px solid #FF9900 !important;
  color: #ffffff;
}

.bg-danger {
  background-color: #FF0000 !important;
  border: 1px solid #FF0000 !important;
  color: #ffffff;
}

.bg-dark {
  background-color: #29344a !important;
  border: 1px solid #29344a !important;
  color: #ffffff;
}

.bg-light {
  background-color: #f8f9fa !important;
  border: 1px solid #f8f9fa !important;
  color: #ffffff;
}

.bg-black {
  background-color: #000000 !important;
  border: 1px solid #000000 !important;
  color: #ffffff;
}

.bg-purple {
  background-color: #7367F0 !important;
  border: 1px solid #7367F0 !important;
  color: #ffffff;
}

.bg-yellow {
  background-color: #ffff00 !important;
  border: 1px solid #ffff00 !important;
  color: #ffffff;
}

.bg-teal {
  background-color: #02a8b5 !important;
  border: 1px solid #02a8b5 !important;
  color: #ffffff;
}

.bg-soft-primary {
  background-color: #FFE2C7;
  color: #FF9F43;
}

.bg-soft-secondary {
  background-color: #B5C0C9;
  color: #092C4C;
}

.bg-soft-success {
  background-color: #BFEED4;
  color: #28C76F;
}

.bg-soft-danger {
  background-color: #FFB3B3;
  color: #FF0000;
}

.bg-soft-warning {
  background-color: #FFE0B3;
  color: #FF9900;
}

.bg-soft-info {
  background-color: rgba(23, 162, 184, 0.3);
  color: #17a2b8;
}

.bg-soft-light {
  background-color: rgba(248, 249, 250, 0.9);
  color: #5B6670;
}

.bg-soft-dark {
  background-color: rgba(41, 52, 74, 0.3);
  color: #ffffff;
}

bg-light {
  color: #5B6670;
}

.bg-primary-gradient {
  background: linear-gradient(to right, #FF9F43 0%, #8e77fa 100%) !important;
  color: #ffffff;
}

.bg-secondary-gradient {
  background: linear-gradient(to right, #092C4C 0%, #28b7f9 100%) !important;
  color: #ffffff;
}

.bg-warning-gradient {
  background: linear-gradient(to right, #FF9900 0%, #fbc434 100%) !important;
  color: #ffffff;
}

.bg-info-gradient {
  background: linear-gradient(to right, #17a2b8 0%, #00f2fe 100%) !important;
  color: #ffffff;
}

.bg-success-gradient {
  background: linear-gradient(to right, #28C76F 0%, #5cf9e2 100%) !important;
  color: #ffffff;
}

.bg-danger-gradient {
  background: linear-gradient(to right, #FF0000 0%, #fd4a68 100%) !important;
  color: #ffffff;
}

.bg-orange-gradient {
  background: linear-gradient(to right, #ffa500 0%, #FBB034 100%) !important;
  color: #ffffff;
}

.bg-purple-gradient {
  background: linear-gradient(to right, #7367F0 0%, #9b25b7 100%) !important;
  color: #ffffff;
}

.bg-teal-gradient {
  background: linear-gradient(to right, #02a8b5 0%, #0695DD 100%) !important;
  color: #ffffff;
}

.bg-light-gradient {
  background: linear-gradient(to right, #f8f9fa 0%, #D1D6DE 100%) !important;
  color: #000000;
}

.bg-dark-gradient {
  background: linear-gradient(to right, #29344a 0%, #54505D 100%) !important;
  color: #ffffff;
}

.bg-outline-primary {
  background-color: #ffffff;
  border: 1px solid #FF9F43;
  color: #FF9F43;
}

.bg-outline-secondary {
  background-color: #ffffff;
  border: 1px solid #092C4C;
  color: #092C4C;
}

.bg-outline-warning {
  background-color: #ffffff;
  border: 1px solid #FF9900;
  color: #FF9900;
}

.bg-outline-info {
  background-color: #ffffff;
  border: 1px solid #17a2b8;
  color: #17a2b8;
}

.bg-outline-success {
  background-color: #ffffff;
  border: 1px solid #28C76F;
  color: #28C76F;
}

.bg-outline-danger {
  background-color: #ffffff;
  border: 1px solid #FF0000;
  color: #FF0000;
}

.bg-outline-dark {
  background-color: #ffffff;
  border: 1px solid #29344a;
  color: #29344a;
}

.bg-outline-light {
  background-color: #ffffff;
  border: 1px solid #f8f9fa !important;
  color: #000000 !important;
}

.bg-primary-transparent {
  background-color: rgba(255, 159, 67, 0.1) !important;
  color: #FF9F43 !important;
}
.bg-primary-transparent:hover {
  background-color: rgba(255, 159, 67, 0.1) !important;
  color: #FF9F43 !important;
}

.bg-secondary-transparent {
  background-color: rgba(9, 44, 76, 0.1) !important;
  color: #092C4C !important;
}
.bg-secondary-transparent:hover {
  background-color: rgba(9, 44, 76, 0.1) !important;
  color: #092C4C !important;
}

.bg-info-transparent {
  background-color: rgba(23, 162, 184, 0.1) !important;
  color: #17a2b8 !important;
}
.bg-info-transparent:hover {
  background-color: rgba(23, 162, 184, 0.1) !important;
  color: #17a2b8 !important;
}

.bg-success-transparent {
  background-color: rgba(40, 199, 111, 0.1) !important;
  color: #28C76F !important;
}
.bg-success-transparent:hover {
  background-color: rgba(40, 199, 111, 0.1) !important;
  color: #28C76F !important;
}

.bg-warning-transparent {
  background-color: rgba(255, 153, 0, 0.1) !important;
  color: #FF9900 !important;
}
.bg-warning-transparent:hover {
  background-color: rgba(255, 153, 0, 0.1) !important;
  color: #FF9900 !important;
}

.bg-danger-transparent {
  background-color: rgba(255, 0, 0, 0.1) !important;
  color: #FF0000 !important;
}
.bg-danger-transparent:hover {
  background-color: rgba(255, 0, 0, 0.1) !important;
  color: #FF0000 !important;
}

.bg-light-transparent {
  background-color: rgba(248, 249, 250, 0.5) !important;
  color: #f8f9fa !important;
}
.bg-light-transparent:hover {
  background-color: rgba(248, 249, 250, 0.5) !important;
  color: #5B6670 !important;
}

.bg-gray-100 {
  background-color: #f3f6f9;
}

.bg-gray-200 {
  background-color: #eff2f7;
}

.bg-gray-300 {
  background-color: #e8ebed;
}

.bg-gray-400 {
  background-color: #dbe0e6;
}

.bg-gray-500 {
  background-color: #adb5bd;
}

.bg-gray-600 {
  background-color: #67748E;
}

.bg-gray-700 {
  background-color: #495057;
}

.bg-gray-800 {
  background-color: #343a40;
}

.bg-gray-900 {
  background-color: #212529;
}

.svg-primary {
  fill: #FF9F43;
}

.svg-secondary {
  fill: #092C4C;
}

.svg-success {
  fill: #28C76F;
}

.svg-danger {
  fill: #FF0000;
}

.svg-warning {
  fill: #FF9900;
}

.svg-white {
  fill: #ffffff;
}

.svg-black {
  fill: #000000;
}

.svg-pink {
  fill: #ff63a5;
}

.svg-orange {
  fill: #ffa500;
}

.svg-purple {
  fill: #7367F0;
}

.svg-indigo {
  fill: #4d5ddb;
}

.svg-info {
  fill: #17a2b8;
}

.svg-yellow {
  fill: #ffff00;
}

.svg-light {
  fill: #f8f9fa;
}

.svg-dark {
  fill: #29344a;
}

.svg-teal {
  fill: #02a8b5;
}

.svg-default {
  fill: #5B6670;
}

.color-container {
  width: 5rem;
  height: 5rem;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 3rem;
}

.text-container {
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
}

.color-box {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  margin-right: 0.75rem;
  margin-bottom: 0.75rem;
}

/******* Components ******/
.avatar {
  position: relative;
  height: 2.625rem;
  width: 2.625rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  color: #ffffff;
  font-weight: 500;
}
.avatar a.badge:hover {
  color: #ffffff;
}
.avatar img {
  width: 100%;
  height: 100%;
  border-radius: 4px;
}
.avatar.avatar-rounded {
  border-radius: 50%;
}
.avatar.avatar-rounded img {
  border-radius: 50%;
}
.avatar.avatar-radius-0 {
  border-radius: 0;
}
.avatar.avatar-radius-0 img {
  border-radius: 0;
}
.avatar .avatar-badge {
  position: absolute;
  inset-block-start: -4%;
  inset-inline-end: -0.375rem;
  width: 1.4rem;
  height: 1.4rem;
  font-size: 0.625rem;
  border: 2px solid #ffffff;
  border-radius: 50% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}
.avatar.online:before, .avatar.offline:before {
  position: absolute;
  content: "";
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  inset-inline-end: 0;
  inset-block-end: 0;
  border: 2px solid #ffffff !important;
  z-index: 1;
}
.avatar.online:before {
  background-color: #28C76F;
}
.avatar.offline:before {
  background-color: #adb5bd;
}
.avatar.avatar-xs {
  width: 1.25rem;
  height: 1.25rem;
  line-height: 1.25rem;
  font-size: 0.65rem;
}
.avatar.avatar-xs .avatar-badge {
  padding: 0.25rem;
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  font-size: 0.5rem;
  inset-block-start: -25%;
  inset-inline-end: -0.5rem;
}
.avatar.avatar-sm {
  width: 1.75rem;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 0.65rem;
}
.avatar.avatar-sm .avatar-badge {
  padding: 0.3rem;
  width: 1.1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  font-size: 0.5rem;
  inset-block-start: -28%;
  inset-inline-end: -0.45rem;
}
.avatar.avatar-sm.online:before, .avatar.avatar-sm.offline:before {
  width: 0.5rem;
  height: 0.5rem;
}
.avatar.avatar-md {
  width: 2.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  font-size: 0.8rem;
}
.avatar.avatar-md .avatar-badge {
  padding: 0.4rem;
  width: 1.2rem;
  height: 1.2rem;
  line-height: 1.2rem;
  font-size: 0.65rem;
  inset-block-start: -6%;
  inset-inline-end: -13%;
}
.avatar.avatar-md.online:before, .avatar.avatar-md.offline:before {
  width: 0.75rem;
  height: 0.75rem;
}
.avatar.avatar-md svg {
  width: 1.5rem;
  height: 1.5rem;
}
.avatar.avatar-lg {
  width: 3rem;
  height: 3rem;
  line-height: 3rem;
  font-size: 1rem;
}
.avatar.avatar-lg .avatar-badge {
  inset-block-start: -15%;
  inset-inline-end: -0.25%;
}
.avatar.avatar-lg.online:before, .avatar.avatar-lg.offline:before {
  width: 0.8rem;
  height: 0.8rem;
}
.avatar.avatar-lg svg {
  width: 1.8rem;
  height: 1.8rem;
}
.avatar.avatar-xl {
  width: 4rem;
  height: 4rem;
  line-height: 4rem;
  font-size: 1.25rem;
}
.avatar.avatar-xl .avatar-badge {
  inset-block-start: -8%;
  inset-inline-end: -0.2%;
}
.avatar.avatar-xl.online:before, .avatar.avatar-xl.offline:before {
  width: 0.95rem;
  height: 0.95rem;
}
.avatar.avatar-xxl {
  width: 5rem;
  height: 5rem;
  line-height: 5rem;
  font-size: 1.5rem;
}
.avatar.avatar-xxl .avatar-badge {
  inset-block-start: -4%;
  inset-inline-end: 0rem;
}
.avatar.avatar-xxl.online:before, .avatar.avatar-xxl.offline:before {
  width: 1.05rem;
  height: 1.05rem;
  inset-block-end: 0.25rem;
}
.avatar.avatar-xxxl {
  width: 6rem;
  height: 6rem;
  line-height: 6rem;
  font-size: 1.75rem;
}
.avatar.avatar-xxxl .avatar-badge {
  inset-block-start: -4%;
  inset-inline-end: 0rem;
}
.avatar.avatar-xxxl.online:before, .avatar.avatar-xxxl.offline:before {
  width: 1.05rem;
  height: 1.05rem;
  inset-block-end: 0.25rem;
}

.avatar-list-stacked {
  padding: 0;
}
.avatar-list-stacked.avatar-group-overlapped .avatar {
  margin-right: -0.875rem;
}
.avatar-list-stacked.avatar-group-overlapped .avatar:hover {
  z-index: 1;
}
.avatar-list-stacked.avatar-group-lg .avatar {
  width: 3.25rem;
  height: 3.25rem;
}
.avatar-list-stacked.avatar-group-lg .avatar > .initial-wrap {
  font-size: 0.95rem;
}
.avatar-list-stacked.avatar-group-lg.avatar-group-overlapped .avatar {
  margin-right: -1rem;
}
.avatar-list-stacked.avatar-group-sm .avatar {
  width: 2rem;
  height: 2rem;
}
.avatar-list-stacked.avatar-group-sm .avatar > .initial-wrap {
  font-size: 0.6rem;
}
.avatar-list-stacked.avatar-group-sm.avatar-group-overlapped .avatar {
  margin-right: -0.625rem;
}
.avatar-list-stacked .avatar {
  margin-inline-end: -0.875rem !important;
  border: 1px solid rgba(0, 0, 0, 0.05);
  vertical-align: middle;
  transition: transform ease 200ms;
}
.avatar-list-stacked .avatar:last-child {
  margin-inline-end: 0 !important;
}
.avatar-list-stacked .avatar:hover {
  z-index: 1;
  transform: translateY(-0.188rem);
}

.avatar-group {
  display: inline-flex;
}
.avatar-group .avatar {
  width: 2.625rem;
  height: 2.625rem;
}
.avatar-group .avatar .avatar-img,
.avatar-group .avatar > .initial-wrap {
  border: 2px solid #ffffff;
  font-size: 0.9rem;
}
.avatar-group.avatar-group-overlapped .avatar {
  margin-right: -0.875rem;
}
.avatar-group.avatar-group-overlapped .avatar:hover {
  z-index: 1;
}
.avatar-group.avatar-group-lg .avatar {
  width: 3.25rem;
  height: 3.25rem;
}
.avatar-group.avatar-group-lg .avatar > .initial-wrap {
  font-size: 0.95rem;
}
.avatar-group.avatar-group-lg.avatar-group-overlapped .avatar {
  margin-right: -1rem;
}
.avatar-group.avatar-group-sm .avatar {
  width: 2rem;
  height: 2rem;
}
.avatar-group.avatar-group-sm .avatar > .initial-wrap {
  font-size: 0.6rem;
}
.avatar-group.avatar-group-sm.avatar-group-overlapped .avatar {
  margin-right: -0.625rem;
}

.bootstrap-datetimepicker-widget table td.active,
.bootstrap-datetimepicker-widget table td.active:hover {
  background-color: #FF9900;
  text-shadow: unset;
}

.bootstrap-datetimepicker-widget table td.today:before {
  border-bottom-color: #FF9900;
}

.bootstrap-datetimepicker-widget table thead tr:first-child th:hover {
  background: transparent;
}

.bor-b1 {
  border-bottom: 1px solid #e8ebed;
}

.btn-submit {
  background: #FF9F43;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 20px;
  transition: all 0.2s ease;
}
.btn-submit:hover {
  background: #ff8510;
  color: #ffffff;
}
@media (max-width: 991.98px) {
  .btn-submit {
    min-width: auto;
  }
}

.btn-submit.chenge-btn {
  padding: 8px 12px;
}

.btn-cancel {
  background: #67748E;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  padding: 10px 20px;
  transition: all 0.5s ease;
}
.btn-cancel:hover {
  background: #424b52;
  color: #ffffff;
}
@media (max-width: 991.98px) {
  .btn-cancel {
    min-width: auto;
  }
}

.btn-cancel.add-cancel {
  padding: 8px 20px;
  min-width: 0;
}

.btn-submit.add-sale {
  padding: 8px 20px;
  min-width: 0;
}

.btn-primary {
  color: #ffffff;
  background-color: #FF9F43;
  border-color: #FF9F43;
}

.btn-previw {
  background: #FF0000;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  padding: 8px 20px;
  transition: all 0.5s ease;
}
.btn-previw:hover {
  background: #FF0000;
  color: #ffffff;
}
@media (max-width: 991.98px) {
  .btn-previw {
    min-width: auto;
  }
}

.btn-save {
  background: #FF9F43;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  padding: 8px 20px;
  transition: all 0.2s ease;
}
.btn-save:hover {
  background: #ff8510;
  color: #ffffff;
}
@media (max-width: 991.98px) {
  .btn-save {
    min-width: auto;
    padding: 5px 7px;
  }
}

.btn-reset {
  background: #5B6670;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
  border-radius: 5px;
  padding: 8px 20px;
  transition: all 0.2s ease;
}
.btn-reset:hover {
  background: #092C4C;
  color: #ffffff;
}
@media (max-width: 991.98px) {
  .btn-reset {
    min-width: auto;
    padding: 5px 7px;
  }
}

.btn-send {
  background: #FF9F43;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-send:hover {
  background: #ff8510;
  color: #ffffff;
}
.btn-send .send-mail {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-download {
  background: #092C4C;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-download:hover {
  background: #212529;
  color: #ffffff;
}
.btn-download .download {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-barcode {
  background: #FF0000;
  padding: 9px 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  margin-right: 15px;
  border-radius: 8px;
}
.btn-barcode:hover {
  background: #FF0000;
  color: #ffffff;
}
.btn-barcode .print {
  margin-right: 10px;
  width: 16px;
  height: 16px;
}

.btn-primary.add-em-payroll {
  padding: 9px 11px;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
}
.btn-primary.add-em-payroll .me-2 {
  width: 16px;
  height: 16px;
}

.swal2-actions .swal2-confirm.btn:active {
  background-color: #FF9F43;
  border-color: #FF9F43;
}

.btn-check:checked + .btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check) + .btn:active {
  background-color: #FF9F43;
  border-color: #FF9F43;
  color: #ffffff !important;
}

.modal .card {
  border: 0;
}

.search-input .btn-searchset:active {
  background-color: transparent;
  border-color: transparent;
}
.search-input .btn-searchset:active svg {
  color: #092C4C;
}

.input-blocks input[type=text].datetimepicker {
  padding-left: 35px;
}

.iti__country-list {
  z-index: 101;
}

button {
  cursor: pointer;
}
button:focus {
  outline: 0;
  box-shadow: none;
}

.btn {
  border-radius: 3px;
  padding: 0.625rem 1.25rem;
  padding: 0.5rem 0.85rem;
  font-size: 0.85rem;
  transition: all 0.5s;
  font-weight: 600;
}
.btn:focus {
  box-shadow: none !important;
}
.btn:hover {
  transition: all 0.5s;
}
.btn.btn-lg {
  padding: 0.65rem 1rem;
  font-size: 0.95rem;
}
.btn.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}
.btn.btn-primary {
  background-color: #FF9F43 !important;
  border: 1px solid #FF9F43 !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(255, 159, 67, 0.15);
}
.btn.btn-primary:hover, .btn.btn-primary:focus, .btn.btn-primary.focus, .btn.btn-primary:active, .btn.btn-primary.active {
  background-color: #ff8d1f !important;
  border: 1px solid #ff8d1f !important;
  box-shadow: 0 3px 10px rgba(255, 159, 67, 0.5);
  color: #ffffff !important;
}
.btn.btn-secondary {
  background-color: #092C4C !important;
  border: 1px solid #092C4C !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(9, 44, 76, 0.15);
}
.btn.btn-secondary:hover, .btn.btn-secondary:focus, .btn.btn-secondary.focus, .btn.btn-secondary:active, .btn.btn-secondary.active {
  background-color: #051a2c !important;
  border: 1px solid #051a2c !important;
  box-shadow: 0 3px 10px rgba(9, 44, 76, 0.5);
  color: #ffffff !important;
}
.btn.btn-success {
  background-color: #28C76F !important;
  border: 1px solid #28C76F !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(40, 199, 111, 0.15);
}
.btn.btn-success:hover, .btn.btn-success:focus, .btn.btn-success.focus, .btn.btn-success:active, .btn.btn-success.active {
  background-color: #22a95e !important;
  border: 1px solid #22a95e !important;
  box-shadow: 0 3px 10px rgba(40, 199, 111, 0.5);
  color: #ffffff !important;
}
.btn.btn-info {
  background-color: #17a2b8 !important;
  border: 1px solid #17a2b8 !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(23, 162, 184, 0.15);
}
.btn.btn-info:hover, .btn.btn-info:focus, .btn.btn-info.focus, .btn.btn-info:active, .btn.btn-info.active {
  background-color: #138698 !important;
  border: 1px solid #138698 !important;
  box-shadow: 0 3px 10px rgba(23, 162, 184, 0.5);
  color: #ffffff !important;
}
.btn.btn-warning {
  background-color: #FF9900 !important;
  border: 1px solid #FF9900 !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(255, 153, 0, 0.15);
}
.btn.btn-warning:hover, .btn.btn-warning:focus, .btn.btn-warning.focus, .btn.btn-warning:active, .btn.btn-warning.active {
  background-color: #db8400 !important;
  border: 1px solid #db8400 !important;
  box-shadow: 0 3px 10px rgba(255, 153, 0, 0.5);
  color: #ffffff !important;
}
.btn.btn-danger {
  background-color: #FF0000 !important;
  border: 1px solid #FF0000 !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(255, 0, 0, 0.15);
}
.btn.btn-danger:hover, .btn.btn-danger:focus, .btn.btn-danger.focus, .btn.btn-danger:active, .btn.btn-danger.active {
  background-color: #db0000 !important;
  border: 1px solid #db0000 !important;
  box-shadow: 0 3px 10px rgba(255, 0, 0, 0.5);
  color: #ffffff !important;
}
.btn.btn-dark {
  background-color: #29344a !important;
  border: 1px solid #29344a !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(41, 52, 74, 0.15);
}
.btn.btn-dark:hover, .btn.btn-dark:focus, .btn.btn-dark.focus, .btn.btn-dark:active, .btn.btn-dark.active {
  background-color: #1c2433 !important;
  border: 1px solid #1c2433 !important;
  box-shadow: 0 3px 10px rgba(41, 52, 74, 0.5);
  color: #ffffff !important;
}
.btn.btn-light {
  background-color: #f8f9fa !important;
  border: 1px solid #f8f9fa !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(248, 249, 250, 0.15);
}
.btn.btn-light:hover, .btn.btn-light:focus, .btn.btn-light.focus, .btn.btn-light:active, .btn.btn-light.active {
  background-color: #e3e7eb !important;
  border: 1px solid #e3e7eb !important;
  box-shadow: 0 3px 10px rgba(248, 249, 250, 0.5);
  color: #ffffff !important;
}
.btn.btn-black {
  background-color: #000000 !important;
  border: 1px solid #000000 !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
.btn.btn-black:hover, .btn.btn-black:focus, .btn.btn-black.focus, .btn.btn-black:active, .btn.btn-black.active {
  background-color: black !important;
  border: 1px solid black !important;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.5);
  color: #ffffff !important;
}
.btn.btn-purple {
  background-color: #7367F0 !important;
  border: 1px solid #7367F0 !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(115, 103, 240, 0.15);
}
.btn.btn-purple:hover, .btn.btn-purple:focus, .btn.btn-purple.focus, .btn.btn-purple:active, .btn.btn-purple.active {
  background-color: #5547ed !important;
  border: 1px solid #5547ed !important;
  box-shadow: 0 3px 10px rgba(115, 103, 240, 0.5);
  color: #ffffff !important;
}
.btn.btn-yellow {
  background-color: #ffff00 !important;
  border: 1px solid #ffff00 !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(255, 255, 0, 0.15);
}
.btn.btn-yellow:hover, .btn.btn-yellow:focus, .btn.btn-yellow.focus, .btn.btn-yellow:active, .btn.btn-yellow.active {
  background-color: #dbdb00 !important;
  border: 1px solid #dbdb00 !important;
  box-shadow: 0 3px 10px rgba(255, 255, 0, 0.5);
  color: #ffffff !important;
}
.btn.btn-teal {
  background-color: #02a8b5 !important;
  border: 1px solid #02a8b5 !important;
  color: #ffffff;
  box-shadow: 0 4px 20px rgba(2, 168, 181, 0.15);
}
.btn.btn-teal:hover, .btn.btn-teal:focus, .btn.btn-teal.focus, .btn.btn-teal:active, .btn.btn-teal.active {
  background-color: #028792 !important;
  border: 1px solid #028792 !important;
  box-shadow: 0 3px 10px rgba(2, 168, 181, 0.5);
  color: #ffffff !important;
}
.btn.btn-light {
  background-color: #f8f9fa;
  border: 1px solid #f8f9fa;
  color: #343a40 !important;
}
.btn.btn-light:hover, .btn.btn-light:focus, .btn.btn-light.focus, .btn.btn-light:active, .btn.btn-light.active {
  background-color: white;
  border: 1px solid white;
  box-shadow: 0 0 0 2px rgba(248, 249, 250, 0.08);
  color: #29344a !important;
}

.btn-group .btn {
  padding: 0.45rem 0.75rem;
}

.btn-group-lg .btn {
  padding: 0.65rem 1rem;
}

.btn-group-sm .btn {
  padding: 0.25rem 0.5rem;
}

.btn.btn-w-xs {
  min-width: 5.625rem;
}
.btn.btn-w-sm {
  min-width: 6.975rem;
}
.btn.btn-w-md {
  min-width: 8.125rem;
}
.btn.btn-w-lg {
  min-width: 9.375rem;
}

.btn-icon i {
  padding: 0rem;
  margin: -0.5rem;
}
.btn-icon.btn-sm {
  width: 1.75rem;
  height: 1.75rem;
  font-size: 0.8rem;
}
.btn-icon.btn-lg {
  width: 2.75rem;
  height: 2.75rem;
  font-size: 1.2rem;
}

.btn-list > button, .btn-list > a {
  margin: 0 0.375rem 0.375rem 0;
}

[dir=rtl] .btn-list button,
[dir=rtl] .btn-list div,
[dir=rtl] .btn-list a,
[dir=rtl] .btn-list input {
  margin: 0 0 0.375rem 0.375rem;
}

.btn-list {
  margin-block-end: -0.5rem;
}

.btn-square {
  border-radius: 0;
}

.btn-group-pill .btn:first-child {
  border-radius: 60px 0 0 60px;
}

.btn-group-pill .btn:last-child {
  border-radius: 0 60px 60px 0;
}

.btn-group-square .btn:first-child {
  border-radius: 0px 0 0 0px;
}

.btn-group-square .btn:last-child {
  border-radius: 0 0px 0px 0;
}

.btn.btn-primary-light {
  background-color: rgba(255, 159, 67, 0.1);
  color: #FF9F43;
}
.btn.btn-primary-light:hover, .btn.btn-primary-light:focus, .btn.btn-primary-light:active {
  background-color: #FF9F43;
  color: #ffffff;
  border-color: #FF9F43;
}
.btn.btn-secondary-light {
  background-color: rgba(9, 44, 76, 0.1);
  color: #092C4C;
}
.btn.btn-secondary-light:hover, .btn.btn-secondary-light:focus, .btn.btn-secondary-light:active {
  background-color: #092C4C;
  color: #ffffff;
  border-color: #092C4C;
}
.btn.btn-warning-light {
  background-color: rgba(255, 153, 0, 0.1);
  color: #FF9900;
}
.btn.btn-warning-light:hover, .btn.btn-warning-light:focus, .btn.btn-warning-light:active {
  background-color: #FF9900;
  color: #ffffff;
  border-color: #FF9900;
}
.btn.btn-info-light {
  background-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
}
.btn.btn-info-light:hover, .btn.btn-info-light:focus, .btn.btn-info-light:active {
  background-color: #17a2b8;
  color: #ffffff;
  border-color: #17a2b8;
}
.btn.btn-success-light {
  background-color: rgba(40, 199, 111, 0.1);
  color: #28C76F;
}
.btn.btn-success-light:hover, .btn.btn-success-light:focus, .btn.btn-success-light:active {
  background-color: #28C76F;
  color: #ffffff;
  border-color: #28C76F;
}
.btn.btn-danger-light {
  background-color: rgba(255, 0, 0, 0.1);
  color: #FF0000;
}
.btn.btn-danger-light:hover, .btn.btn-danger-light:focus, .btn.btn-danger-light:active {
  background-color: #FF0000;
  color: #ffffff;
  border-color: #FF0000;
}

.btn.btn-primary-ghost {
  background-color: transparent;
  color: #FF9F43;
  border: 1px solid #FF9F43;
}
.btn.btn-primary-ghost:active {
  color: #FF9F43;
  border: 1px solid #FF9F43;
  background-color: transparent;
}
.btn.btn-secondary-ghost {
  background-color: transparent;
  color: #092C4C;
  border: 1px solid #092C4C;
}
.btn.btn-secondary-ghost:active {
  color: #092C4C;
  border: 1px solid #092C4C;
  background-color: transparent;
}
.btn.btn-warning-ghost {
  background-color: transparent;
  color: #FF9900;
  border: 1px solid #FF9900;
}
.btn.btn-warning-ghost:active {
  color: #FF9900;
  border: 1px solid #FF9900;
  background-color: transparent;
}
.btn.btn-info-ghost {
  background-color: transparent;
  color: #17a2b8;
  border: 1px solid #17a2b8;
}
.btn.btn-info-ghost:active {
  color: #17a2b8;
  border: 1px solid #17a2b8;
  background-color: transparent;
}
.btn.btn-success-ghost {
  background-color: transparent;
  color: #28C76F;
  border: 1px solid #28C76F;
}
.btn.btn-success-ghost:active {
  color: #28C76F;
  border: 1px solid #28C76F;
  background-color: transparent;
}
.btn.btn-danger-ghost {
  background-color: transparent;
  color: #FF0000;
  border: 1px solid #FF0000;
}
.btn.btn-danger-ghost:active {
  color: #FF0000;
  border: 1px solid #FF0000;
  background-color: transparent;
}

.btn-list button {
  margin: 0 0.375rem 0.375rem 0;
}

.btn-outline-primary {
  border: 1px solid #FF9F43 !important;
  color: #FF9F43 !important;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary.focus, .btn-outline-primary:active, .btn-outline-primary.active {
  background-color: #FF9F43 !important;
  border: 1px solid #FF9F43 !important;
  box-shadow: 0 3px 10px rgba(255, 159, 67, 0.5);
  color: #ffffff !important;
}

.btn-outline-secondary {
  border: 1px solid #092C4C !important;
  color: #092C4C !important;
}
.btn-outline-secondary:hover, .btn-outline-secondary:focus, .btn-outline-secondary.focus, .btn-outline-secondary:active, .btn-outline-secondary.active {
  background-color: #092C4C !important;
  border: 1px solid #092C4C !important;
  box-shadow: 0 3px 10px rgba(9, 44, 76, 0.5);
  color: #ffffff !important;
}

.btn-outline-success {
  border: 1px solid #28C76F !important;
  color: #28C76F !important;
}
.btn-outline-success:hover, .btn-outline-success:focus, .btn-outline-success.focus, .btn-outline-success:active, .btn-outline-success.active {
  background-color: #28C76F !important;
  border: 1px solid #28C76F !important;
  box-shadow: 0 3px 10px rgba(40, 199, 111, 0.5);
  color: #ffffff !important;
}

.btn-outline-danger {
  border: 1px solid #FF0000 !important;
  color: #FF0000 !important;
}
.btn-outline-danger:hover, .btn-outline-danger:focus, .btn-outline-danger.focus, .btn-outline-danger:active, .btn-outline-danger.active {
  background-color: #FF0000 !important;
  border: 1px solid #FF0000 !important;
  box-shadow: 0 3px 10px rgba(255, 0, 0, 0.5);
  color: #ffffff !important;
}

.btn-outline-warning {
  border: 1px solid #FF9900 !important;
  color: #FF9900 !important;
}
.btn-outline-warning:hover, .btn-outline-warning:focus, .btn-outline-warning.focus, .btn-outline-warning:active, .btn-outline-warning.active {
  background-color: #FF9900 !important;
  border: 1px solid #FF9900 !important;
  box-shadow: 0 3px 10px rgba(255, 153, 0, 0.5);
  color: #ffffff !important;
}

.btn-outline-info {
  border: 1px solid #17a2b8 !important;
  color: #17a2b8 !important;
}
.btn-outline-info:hover, .btn-outline-info:focus, .btn-outline-info.focus, .btn-outline-info:active, .btn-outline-info.active {
  background-color: #17a2b8 !important;
  border: 1px solid #17a2b8 !important;
  box-shadow: 0 3px 10px rgba(23, 162, 184, 0.5);
  color: #ffffff !important;
}

.btn-outline-light {
  border: 1px solid #f8f9fa;
  color: #343a40 !important;
}
.btn-outline-light:hover, .btn-outline-light:focus, .btn-outline-light.focus, .btn-outline-light:active, .btn-outline-light.active {
  background-color: #f8f9fa;
  border: 1px solid #f8f9fa;
  color: #29344a !important;
}

.btn-outline-dark {
  border: 1px solid #29344a !important;
  color: #29344a !important;
}
.btn-outline-dark:hover, .btn-outline-dark:focus, .btn-outline-dark.focus, .btn-outline-dark:active, .btn-outline-dark.active {
  background-color: #29344a !important;
  border: 1px solid #29344a !important;
  box-shadow: 0 3px 10px rgba(41, 52, 74, 0.5);
  color: #ffffff !important;
}

.btn-soft-primary {
  background-color: #FFE2C7 !important;
  color: #FF9F43 !important;
}
.btn-soft-primary:hover, .btn-soft-primary:focus, .btn-soft-primary.focus, .btn-soft-primary:active, .btn-soft-primary.active {
  box-shadow: 0 3px 12px rgba(255, 159, 67, 0.2);
  border-color: #FF9F43;
}

.btn-soft-secondary {
  background-color: #B5C0C9 !important;
  color: #092C4C !important;
}
.btn-soft-secondary:hover, .btn-soft-secondary:focus, .btn-soft-secondary.focus, .btn-soft-secondary:active, .btn-soft-secondary.active {
  box-shadow: 0 3px 12px rgba(9, 44, 76, 0.2);
  border-color: #092C4C;
}

.btn-soft-success {
  background-color: #BFEED4 !important;
  color: #28C76F !important;
}
.btn-soft-success:hover, .btn-soft-success:focus, .btn-soft-success.focus, .btn-soft-success:active, .btn-soft-success.active {
  box-shadow: 0 3px 12px rgba(40, 199, 111, 0.2);
  border-color: #28C76F;
}

.btn-soft-danger {
  background-color: #FFB3B3 !important;
  color: #FF0000 !important;
}
.btn-soft-danger:hover, .btn-soft-danger:focus, .btn-soft-danger.focus, .btn-soft-danger:active, .btn-soft-danger.active {
  box-shadow: 0 3px 12px rgba(255, 0, 0, 0.2);
  border-color: #FF0000;
}

.btn-soft-warning {
  background-color: #FFE0B3 !important;
  color: #FF9900 !important;
}
.btn-soft-warning:hover, .btn-soft-warning:focus, .btn-soft-warning.focus, .btn-soft-warning:active, .btn-soft-warning.active {
  box-shadow: 0 3px 12px rgba(255, 153, 0, 0.2);
  border-color: #FF9900;
}

.btn-soft-info {
  background-color: rgba(23, 162, 184, 0.3) !important;
  color: #17a2b8 !important;
}
.btn-soft-info:hover, .btn-soft-info:focus, .btn-soft-info.focus, .btn-soft-info:active, .btn-soft-info.active {
  box-shadow: 0 3px 12px rgba(23, 162, 184, 0.2);
  border-color: #17a2b8;
}

.btn-soft-light {
  background-color: rgba(248, 249, 250, 0.9) !important;
  color: #5B6670 !important;
}
.btn-soft-light:hover, .btn-soft-light:focus, .btn-soft-light.focus, .btn-soft-light:active, .btn-soft-light.active {
  box-shadow: 0 3px 12px rgba(248, 249, 250, 0.2);
  border-color: #f8f9fa;
  border-color: #5B6670;
}

.btn-soft-dark {
  background-color: rgba(41, 52, 74, 0.3) !important;
  color: #ffffff !important;
}
.btn-soft-dark:hover, .btn-soft-dark:focus, .btn-soft-dark.focus, .btn-soft-dark:active, .btn-soft-dark.active {
  box-shadow: 0 3px 12px rgba(41, 52, 74, 0.2);
  border-color: #29344a;
}

.badge.badge-primary {
  background: rgba(255, 159, 67, 0.1);
  box-shadow: 0 1px 1px rgba(255, 159, 67, 0.5);
  color: #FF9F43;
}

.badge.badge-primary {
  background: #FF9F43;
  box-shadow: 0 1px 1px rgba(255, 159, 67, 0.5);
  color: #ffffff;
}
.badge.badge-soft-primary {
  background: rgba(255, 159, 67, 0.1);
  box-shadow: 0 1px 1px rgba(255, 159, 67, 0.5);
  color: #FF9F43;
}

.badge.badge-secondary {
  background: #092C4C;
  box-shadow: 0 1px 1px rgba(9, 44, 76, 0.5);
  color: #ffffff;
}
.badge.badge-soft-secondary {
  background: rgba(9, 44, 76, 0.1);
  box-shadow: 0 1px 1px rgba(9, 44, 76, 0.5);
  color: #092C4C;
}

.badge.badge-success {
  background: #28C76F;
  box-shadow: 0 1px 1px rgba(40, 199, 111, 0.5);
  color: #ffffff;
}
.badge.badge-soft-success {
  background: rgba(40, 199, 111, 0.1);
  box-shadow: 0 1px 1px rgba(40, 199, 111, 0.5);
  color: #28C76F;
}

.badge.badge-info {
  background: #17a2b8;
  box-shadow: 0 1px 1px rgba(23, 162, 184, 0.5);
  color: #ffffff;
}
.badge.badge-soft-info {
  background: rgba(23, 162, 184, 0.1);
  box-shadow: 0 1px 1px rgba(23, 162, 184, 0.5);
  color: #17a2b8;
}

.badge.badge-warning {
  background: #FF9900;
  box-shadow: 0 1px 1px rgba(255, 153, 0, 0.5);
  color: #ffffff;
}
.badge.badge-soft-warning {
  background: rgba(255, 153, 0, 0.1);
  box-shadow: 0 1px 1px rgba(255, 153, 0, 0.5);
  color: #FF9900;
}

.badge.badge-danger {
  background: #FF0000;
  box-shadow: 0 1px 1px rgba(255, 0, 0, 0.5);
  color: #ffffff;
}
.badge.badge-soft-danger {
  background: rgba(255, 0, 0, 0.1);
  box-shadow: 0 1px 1px rgba(255, 0, 0, 0.5);
  color: #FF0000;
}

.badge.badge-dark {
  background: #29344a;
  box-shadow: 0 1px 1px rgba(41, 52, 74, 0.5);
  color: #ffffff;
}
.badge.badge-soft-dark {
  background: rgba(41, 52, 74, 0.1);
  box-shadow: 0 1px 1px rgba(41, 52, 74, 0.5);
  color: #29344a;
}

.badge.badge-light {
  background: #f8f9fa;
  box-shadow: 0 1px 1px rgba(248, 249, 250, 0.5);
  color: #ffffff;
}
.badge.badge-soft-light {
  background: rgba(248, 249, 250, 0.1);
  box-shadow: 0 1px 1px rgba(248, 249, 250, 0.5);
  color: #f8f9fa;
}

.badge.badge-black {
  background: #000000;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  color: #ffffff;
}
.badge.badge-soft-black {
  background: rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.5);
  color: #000000;
}

.badge.badge-purple {
  background: #7367F0;
  box-shadow: 0 1px 1px rgba(115, 103, 240, 0.5);
  color: #ffffff;
}
.badge.badge-soft-purple {
  background: rgba(115, 103, 240, 0.1);
  box-shadow: 0 1px 1px rgba(115, 103, 240, 0.5);
  color: #7367F0;
}

.badge.badge-yellow {
  background: #ffff00;
  box-shadow: 0 1px 1px rgba(255, 255, 0, 0.5);
  color: #ffffff;
}
.badge.badge-soft-yellow {
  background: rgba(255, 255, 0, 0.1);
  box-shadow: 0 1px 1px rgba(255, 255, 0, 0.5);
  color: #ffff00;
}

.badge.badge-teal {
  background: #02a8b5;
  box-shadow: 0 1px 1px rgba(2, 168, 181, 0.5);
  color: #ffffff;
}
.badge.badge-soft-teal {
  background: rgba(2, 168, 181, 0.1);
  box-shadow: 0 1px 1px rgba(2, 168, 181, 0.5);
  color: #02a8b5;
}

.badge {
  padding: 0.25rem 0.45rem;
  text-transform: capitalize;
  font-weight: 600;
  letter-spacing: 0.5px;
  border-radius: 4px;
}
.badge.badge-xs {
  font-size: 10px;
  padding: 0px 5px;
  line-height: 18px;
}
.badge.badge-sm {
  font-size: 11px;
  padding: 5px 8px;
  line-height: 11px;
}
.badge.badge-md {
  font-size: 12px;
  padding: 5px 12px;
  line-height: 1.5;
}
.badge.badge-lg {
  font-size: 14px;
  padding: 0px 10px;
  line-height: 30px;
}
.badge.badge-xl {
  font-size: 16px;
  padding: 0px 15px;
  line-height: 35px;
}

.border-container {
  display: inline-block;
  width: 5rem;
  height: 5rem;
  margin: 0.25rem;
  background-color: #f8f9fa;
}

.border {
  border: 1px solid #dbe0e6 !important;
}
.border.border-dashed {
  border-style: dashed !important;
}
.border.border-dotted {
  border-style: dotted !important;
}
.border.border-primary {
  border: 1px solid #FF9F43 !important;
  opacity: 1;
}
.border.border-primary.border-opacity-10 {
  border-color: rgba(255, 159, 67, 0.1) !important;
}
.border.border-primary.border-opacity-25 {
  border-color: rgba(255, 159, 67, 0.25) !important;
}
.border.border-primary.border-opacity-50 {
  border-color: rgba(255, 159, 67, 0.5) !important;
}
.border.border-primary.border-opacity-75 {
  border-color: rgba(255, 159, 67, 0.75) !important;
}
.border.border-primary.border-opacity-100 {
  border-color: #ff9f43 !important;
}
.border.border-secondary {
  border: 1px solid #092C4C !important;
  opacity: 1;
}
.border.border-secondary.border-opacity-10 {
  border-color: rgba(9, 44, 76, 0.1) !important;
}
.border.border-secondary.border-opacity-25 {
  border-color: rgba(9, 44, 76, 0.25) !important;
}
.border.border-secondary.border-opacity-50 {
  border-color: rgba(9, 44, 76, 0.5) !important;
}
.border.border-secondary.border-opacity-75 {
  border-color: rgba(9, 44, 76, 0.75) !important;
}
.border.border-secondary.border-opacity-100 {
  border-color: #092c4c !important;
}
.border.border-info {
  border: 1px solid #17a2b8 !important;
  opacity: 1;
}
.border.border-info.border-opacity-10 {
  border-color: rgba(23, 162, 184, 0.1) !important;
}
.border.border-info.border-opacity-25 {
  border-color: rgba(23, 162, 184, 0.25) !important;
}
.border.border-info.border-opacity-50 {
  border-color: rgba(23, 162, 184, 0.5) !important;
}
.border.border-info.border-opacity-75 {
  border-color: rgba(23, 162, 184, 0.75) !important;
}
.border.border-info.border-opacity-100 {
  border-color: #17a2b8 !important;
}
.border.border-success {
  border: 1px solid #28C76F !important;
  opacity: 1;
}
.border.border-success.border-opacity-10 {
  border-color: rgba(40, 199, 111, 0.1) !important;
}
.border.border-success.border-opacity-25 {
  border-color: rgba(40, 199, 111, 0.25) !important;
}
.border.border-success.border-opacity-50 {
  border-color: rgba(40, 199, 111, 0.5) !important;
}
.border.border-success.border-opacity-75 {
  border-color: rgba(40, 199, 111, 0.75) !important;
}
.border.border-success.border-opacity-100 {
  border-color: #28c76f !important;
}
.border.border-warning {
  border: 1px solid #FF9900 !important;
  opacity: 1;
}
.border.border-warning.border-opacity-10 {
  border-color: rgba(255, 153, 0, 0.1) !important;
}
.border.border-warning.border-opacity-25 {
  border-color: rgba(255, 153, 0, 0.25) !important;
}
.border.border-warning.border-opacity-50 {
  border-color: rgba(255, 153, 0, 0.5) !important;
}
.border.border-warning.border-opacity-75 {
  border-color: rgba(255, 153, 0, 0.75) !important;
}
.border.border-warning.border-opacity-100 {
  border-color: #ff9900 !important;
}
.border.border-danger {
  border: 1px solid #FF0000 !important;
  opacity: 1;
}
.border.border-danger.border-opacity-10 {
  border-color: rgba(255, 0, 0, 0.1) !important;
}
.border.border-danger.border-opacity-25 {
  border-color: rgba(255, 0, 0, 0.25) !important;
}
.border.border-danger.border-opacity-50 {
  border-color: rgba(255, 0, 0, 0.5) !important;
}
.border.border-danger.border-opacity-75 {
  border-color: rgba(255, 0, 0, 0.75) !important;
}
.border.border-danger.border-opacity-100 {
  border-color: red !important;
}
.border.border-white {
  border: 1px solid #ffffff !important;
  opacity: 1;
}
.border.border-white.border-opacity-10 {
  border-color: rgba(255, 255, 255, 0.1) !important;
}
.border.border-white.border-opacity-25 {
  border-color: rgba(255, 255, 255, 0.25) !important;
}
.border.border-white.border-opacity-50 {
  border-color: rgba(255, 255, 255, 0.5) !important;
}
.border.border-white.border-opacity-75 {
  border-color: rgba(255, 255, 255, 0.75) !important;
}
.border.border-white.border-opacity-100 {
  border-color: white !important;
}
.border.border-light {
  border: 1px solid #f8f9fa !important;
  opacity: 1;
}
.border.border-light.border-opacity-10 {
  border-color: rgba(248, 249, 250, 0.1) !important;
}
.border.border-light.border-opacity-25 {
  border-color: rgba(248, 249, 250, 0.25) !important;
}
.border.border-light.border-opacity-50 {
  border-color: rgba(248, 249, 250, 0.5) !important;
}
.border.border-light.border-opacity-75 {
  border-color: rgba(248, 249, 250, 0.75) !important;
}
.border.border-light.border-opacity-100 {
  border-color: #f8f9fa !important;
}
.border.border-dark {
  border: 1px solid #29344a !important;
  opacity: 1;
}
.border.border-dark.border-opacity-10 {
  border-color: rgba(41, 52, 74, 0.1) !important;
}
.border.border-dark.border-opacity-25 {
  border-color: rgba(41, 52, 74, 0.25) !important;
}
.border.border-dark.border-opacity-50 {
  border-color: rgba(41, 52, 74, 0.5) !important;
}
.border.border-dark.border-opacity-75 {
  border-color: rgba(41, 52, 74, 0.75) !important;
}
.border.border-dark.border-opacity-100 {
  border-color: #29344a !important;
}
.border.border-orange {
  border: 1px solid #ffa500 !important;
  opacity: 1;
}
.border.border-orange.border-opacity-10 {
  border-color: rgba(255, 165, 0, 0.1) !important;
}
.border.border-orange.border-opacity-25 {
  border-color: rgba(255, 165, 0, 0.25) !important;
}
.border.border-orange.border-opacity-50 {
  border-color: rgba(255, 165, 0, 0.5) !important;
}
.border.border-orange.border-opacity-75 {
  border-color: rgba(255, 165, 0, 0.75) !important;
}
.border.border-orange.border-opacity-100 {
  border-color: orange !important;
}
.border.border-opacity-10 {
  --bs-border-opacity: 0.1 !important;
}
.border.border-opacity-25 {
  --bs-border-opacity: 0.25 !important;
}
.border.border-opacity-50 {
  --bs-border-opacity: 0.5 !important;
}
.border.border-opacity-75 {
  --bs-border-opacity: 0.75 !important;
}
.border.border-opacity-100 {
  --bs-border-opacity: 1 !important;
}
.border.border-1 {
  border-width: 1px !important;
}
.border.border-2 {
  border-width: 2px !important;
}
.border.border-3 {
  border-width: 3px !important;
}
.border.border-4 {
  border-width: 4px !important;
}
.border.border-5 {
  border-width: 5px !important;
}
.border.border-block-start-dashed {
  border-top-style: dashed;
}
.border.border-block-start-dotted {
  border-top-style: dotted;
}
.border.border-inline-end-dashed {
  border-inline-end-style: dashed;
}
.border.border-inline-end-dotted {
  border-inline-end-style: dotted;
}
.border.border-block-end-dashed {
  border-bottom-style: dashed;
}
.border.border-block-end-dotted {
  border-bottom-style: dotted;
}
.border.border-inline-start-dashed {
  border-inline-start-style: dashed;
}
.border.border-inline-start-dotted {
  border-inline-start-style: dotted;
}
.border.border-0 {
  border: 0 !important;
}
.border.border-top-0 {
  border-block-start: 0 !important;
}
.border.border-end-0 {
  border-inline-end: 0 !important;
}
.border.border-bottom-0 {
  border-block-end: 0 !important;
}
.border.border-start-0 {
  border-inline-start: 0 !important;
}

.border-top {
  border-top: 1px solid #dbe0e6 !important;
}
.border-top.border-block-start-dashed {
  border-top-style: dashed !important;
}
.border-top.border-block-start-dotted {
  border-top-style: dotted !important;
}
.border-top.border-primary {
  border-color: #FF9F43 !important;
}
.border-top.border-secondary {
  border-color: #092C4C !important;
}
.border-top.border-warning {
  border-color: #FF9900 !important;
}
.border-top.border-info {
  border-color: #17a2b8 !important;
}
.border-top.border-success {
  border-color: #28C76F !important;
}
.border-top.border-danger {
  border-color: #FF0000 !important;
}
.border-top.border-light {
  border-color: #f8f9fa !important;
}
.border-top.border-dark {
  border-color: #29344a !important;
}

.border-end {
  border-inline-end: 1px solid #dbe0e6 !important;
}
.border-end.border-inline-end-dashed {
  border-inline-end-style: dashed !important;
}
.border-end.border-inline-end-dotted {
  border-inline-end-style: dotted !important;
}
.border-end.border-primary {
  border-color: #FF9F43 !important;
}
.border-end.border-secondary {
  border-color: #092C4C !important;
}
.border-end.border-warning {
  border-color: #FF9900 !important;
}
.border-end.border-info {
  border-color: #17a2b8 !important;
}
.border-end.border-success {
  border-color: #28C76F !important;
}
.border-end.border-danger {
  border-color: #FF0000 !important;
}
.border-end.border-light {
  border-color: #f8f9fa !important;
}
.border-end.border-dark {
  border-color: #29344a !important;
}

.border-bottom {
  border-bottom: 1px solid #dbe0e6 !important;
}
.border-bottom.border-block-end-dashed {
  border-bottom-style: dashed !important;
}
.border-bottom.border-block-end-dotted {
  border-bottom-style: dotted !important;
}
.border-bottom.border-primary {
  border-color: #FF9F43 !important;
}
.border-bottom.border-secondary {
  border-color: #092C4C !important;
}
.border-bottom.border-warning {
  border-color: #FF9900 !important;
}
.border-bottom.border-info {
  border-color: #17a2b8 !important;
}
.border-bottom.border-success {
  border-color: #28C76F !important;
}
.border-bottom.border-danger {
  border-color: #FF0000 !important;
}
.border-bottom.border-light {
  border-color: #f8f9fa !important;
}
.border-bottom.border-dark {
  border-color: #29344a !important;
}

.border-start {
  border-inline-start: 1px solid #dbe0e6 !important;
}
.border-start.border-inline-start-dashed {
  border-inline-start-style: dashed !important;
}
.border-start.border-inline-start-dotted {
  border-inline-start-style: dotted !important;
}
.border-start.border-primary {
  border-color: #FF9F43 !important;
}
.border-start.border-secondary {
  border-color: #092C4C !important;
}
.border-start.border-warning {
  border-color: #FF9900 !important;
}
.border-start.border-info {
  border-color: #17a2b8 !important;
}
.border-start.border-success {
  border-color: #28C76F !important;
}
.border-start.border-danger {
  border-color: #FF0000 !important;
}
.border-start.border-light {
  border-color: #f8f9fa !important;
}
.border-start.border-dark {
  border-color: #29344a !important;
}

.br-1 {
  border-radius: 0.0625rem;
}

.br-2 {
  border-radius: 0.125rem;
}

.br-3 {
  border-radius: 0.1875rem;
}

.br-4 {
  border-radius: 0.25rem;
}

.br-5 {
  border-radius: 0.3125rem;
}

.br-6 {
  border-radius: 0.375rem;
}

.br-7 {
  border-radius: 0.4375rem;
}

.br-8 {
  border-radius: 0.5rem;
}

.br-9 {
  border-radius: 0.5625rem;
}

.br-10 {
  border-radius: 0.625rem;
}

.br-15 {
  border-radius: 0.9375rem;
}

.br-20 {
  border-radius: 1.25rem;
}

.rounded {
  border-radius: 4px !important;
}

.calendar-events {
  border: 1px solid transparent;
  cursor: move;
  padding: 10px 15px;
}

.calendar-events:hover {
  border-color: #e8ebed;
  background-color: #ffffff;
}

.calendar-events i {
  margin-right: 8px;
}

.calendar {
  float: left;
  margin-bottom: 0;
}

.fc-toolbar.fc-header-toolbar {
  margin-bottom: 1.5rem;
}

.none-border .modal-footer {
  border-top: none;
}

.fc-toolbar h2 {
  font-size: 18px;
  font-weight: 600;
  font-family: "Roboto", sans-serif;
  line-height: 30px;
  text-transform: uppercase;
}

.fc-day-grid-event .fc-time {
  font-family: "Roboto", sans-serif;
}

.fc-day {
  background: #ffffff;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active,
.fc-toolbar button:focus,
.fc-toolbar button:hover,
.fc-toolbar .ui-state-hover {
  z-index: 0;
}

.fc th.fc-widget-header {
  background: #e8ebed;
  font-size: 14px;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
}

.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #f3f3f3;
}

.fc-basic-view .fc-day-number,
.fc-basic-view .fc-week-number {
  padding: 2px 5px;
}

.fc-button {
  background: #f1f1f1;
  border: none;
  color: #797979;
  text-transform: capitalize;
  box-shadow: none !important;
  border-radius: 3px !important;
  margin: 0 3px !important;
  padding: 6px 12px !important;
  height: auto !important;
}

.fc-text-arrow {
  font-family: inherit;
  font-size: 16px;
}

.fc-state-hover {
  background: #f3f3f3;
}

.fc-state-highlight {
  background: #f0f0f0;
}

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #FF9F43 !important;
  color: #ffffff !important;
  text-shadow: none !important;
}

.fc-cell-overlay {
  background: #f0f0f0;
}

.fc-unthemed .fc-today {
  background: #ffffff;
}

.fc-event {
  border-radius: 2px;
  border: none;
  color: #ffffff !important;
  cursor: move;
  font-size: 13px;
  margin: 1px 7px;
  padding: 5px 5px;
  text-align: center;
}

.fc-basic-view td.fc-week-number span {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}

.fc-basic-view td.fc-day-number {
  padding-right: 8px;
  font-weight: 700;
  font-family: "Roboto", sans-serif;
}

.event-form .input-group .form-control {
  height: 40px;
}

.submit-section {
  text-align: center;
  margin-top: 40px;
}

.submit-btn {
  border-radius: 50px;
  font-size: 18px;
  font-weight: 600;
  min-width: 200px;
  padding: 10px 20px;
}

.apexcharts-legend.apexcharts-align-center.position-right {
  display: none;
}

.apexcharts-toolbar {
  display: none !important;
}

#sales_charts,
.chart-set {
  overflow: hidden;
}

.apexcharts-canvas {
  width: 100% !important;
}

.img-cropper .dropup .dropdown-toggle::after {
  content: "";
  display: none;
}

.dropdown-auto {
  overflow: auto;
}

.dropdown-divider {
  margin: 0;
}

.dropdown .dropdown-toggle:after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}
.dropdown .dropdown-toggle.btn-primary {
  color: #ffffff;
}
.dropdown .dropdown-menu {
  font-family: "Nunito", sans-serif;
}

.dropdown-menu {
  border-color: #dbe0e6;
  box-shadow: 0 1rem 1.125rem rgba(169, 169, 169, 0.15);
  font-size: 0.875rem;
  color: #5B6670;
  background-color: #ffffff;
  padding: 0;
  z-index: 10;
}

.dropdown-divider {
  border-color: #dbe0e6;
}

.dropdown-item-text {
  color: #5B6670;
}

.dropdown-header {
  color: #5B6670;
}

.dropdown-item {
  color: #5B6670;
  white-space: unset;
  padding: 0.5rem 0.9375rem;
  font-size: 0.8125rem;
}
.dropdown-item.disabled, .dropdown-item:disabled {
  color: #5B6670;
  opacity: 0.5;
}
.dropdown-item:not(.active):hover, .dropdown-item:not(.active):focus, .dropdown-item:not(.active):active {
  color: #FF9F43;
  background-color: rgba(255, 159, 67, 0.05);
}
.dropdown-item.active {
  background-color: #FF9F43 !important;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f078";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropup .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f077";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropend .dropdown-toggle::after {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.dropstart .dropdown-toggle::before {
  display: inline-block;
  margin-inline-start: 0.25rem;
  vertical-align: 0;
  content: "\\f053";
  font-family: "Font Awesome 5 Free";
  border: 0;
  font-size: 0.6rem;
  font-weight: 600;
}

.btn.dropdown-toggle-split {
  opacity: 0.85;
}

.dropdown-menu-dark {
  background-color: #29344a;
  border-color: rgba(255, 255, 255, 0.1);
}
.dropdown-menu-dark li a {
  color: #ffffff;
}

.btn-list a.dropdown-item {
  margin-block-end: 0;
}
.btn-list .btn-soft-success:hover {
  transform: translateY(0);
}
.btn-list .btn-soft-danger:hover {
  transform: translateY(0);
}
.dropdown-menu.dropdown-menu-primary {
  background-color: #FF9F43;
}
.dropdown-menu.dropdown-menu-primary li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-primary .dropdown-item:hover, .dropdown-menu.dropdown-menu-primary .dropdown-item:focus, .dropdown-menu.dropdown-menu-primary .dropdown-item:active, .dropdown-menu.dropdown-menu-primary .dropdown-item.active {
  color: #ffffff;
}
.dropdown-menu.dropdown-menu-secondary {
  background-color: #092C4C;
}
.dropdown-menu.dropdown-menu-secondary li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-secondary .dropdown-item:hover, .dropdown-menu.dropdown-menu-secondary .dropdown-item:focus, .dropdown-menu.dropdown-menu-secondary .dropdown-item:active, .dropdown-menu.dropdown-menu-secondary .dropdown-item.active {
  color: #ffffff;
}
.dropdown-menu.dropdown-menu-warning {
  background-color: #FF9900;
}
.dropdown-menu.dropdown-menu-warning li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-warning .dropdown-item:hover, .dropdown-menu.dropdown-menu-warning .dropdown-item:focus, .dropdown-menu.dropdown-menu-warning .dropdown-item:active, .dropdown-menu.dropdown-menu-warning .dropdown-item.active {
  color: #ffffff;
}
.dropdown-menu.dropdown-menu-info {
  background-color: #17a2b8;
}
.dropdown-menu.dropdown-menu-info li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-info .dropdown-item:hover, .dropdown-menu.dropdown-menu-info .dropdown-item:focus, .dropdown-menu.dropdown-menu-info .dropdown-item:active, .dropdown-menu.dropdown-menu-info .dropdown-item.active {
  color: #ffffff;
}
.dropdown-menu.dropdown-menu-success {
  background-color: #28C76F;
}
.dropdown-menu.dropdown-menu-success li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-success .dropdown-item:hover, .dropdown-menu.dropdown-menu-success .dropdown-item:focus, .dropdown-menu.dropdown-menu-success .dropdown-item:active, .dropdown-menu.dropdown-menu-success .dropdown-item.active {
  color: #ffffff;
}
.dropdown-menu.dropdown-menu-danger {
  background-color: #FF0000;
}
.dropdown-menu.dropdown-menu-danger li a {
  color: rgba(255, 255, 255, 0.9);
}
.dropdown-menu.dropdown-menu-danger .dropdown-item:hover, .dropdown-menu.dropdown-menu-danger .dropdown-item:focus, .dropdown-menu.dropdown-menu-danger .dropdown-item:active, .dropdown-menu.dropdown-menu-danger .dropdown-item.active {
  color: #ffffff;
}

.dropdown-menu.dropmenu-item-primary .dropdown-item:hover, .dropdown-menu.dropmenu-item-primary .dropdown-item:focus, .dropdown-menu.dropmenu-item-primary .dropdown-item:active, .dropdown-menu.dropmenu-item-primary .dropdown-item.active {
  background-color: rgba(255, 159, 67, 0.1) !important;
  color: #FF9F43;
}
.dropdown-menu.dropmenu-item-secondary .dropdown-item:hover, .dropdown-menu.dropmenu-item-secondary .dropdown-item:focus, .dropdown-menu.dropmenu-item-secondary .dropdown-item:active, .dropdown-menu.dropmenu-item-secondary .dropdown-item.active {
  background-color: rgba(9, 44, 76, 0.1) !important;
  color: #092C4C;
}
.dropdown-menu.dropmenu-item-warning .dropdown-item:hover, .dropdown-menu.dropmenu-item-warning .dropdown-item:focus, .dropdown-menu.dropmenu-item-warning .dropdown-item:active, .dropdown-menu.dropmenu-item-warning .dropdown-item.active {
  background-color: rgba(255, 153, 0, 0.1) !important;
  color: #FF9900;
}
.dropdown-menu.dropmenu-item-info .dropdown-item:hover, .dropdown-menu.dropmenu-item-info .dropdown-item:focus, .dropdown-menu.dropmenu-item-info .dropdown-item:active, .dropdown-menu.dropmenu-item-info .dropdown-item.active {
  background-color: rgba(23, 162, 184, 0.1) !important;
  color: #17a2b8;
}
.dropdown-menu.dropmenu-item-success .dropdown-item:hover, .dropdown-menu.dropmenu-item-success .dropdown-item:focus, .dropdown-menu.dropmenu-item-success .dropdown-item:active, .dropdown-menu.dropmenu-item-success .dropdown-item.active {
  background-color: rgba(var(--success-rgb), 0.1) !important;
  color: #28C76F;
}
.dropdown-menu.dropmenu-item-danger .dropdown-item:hover, .dropdown-menu.dropmenu-item-danger .dropdown-item:focus, .dropdown-menu.dropmenu-item-danger .dropdown-item:active, .dropdown-menu.dropmenu-item-danger .dropdown-item.active {
  background-color: rgba(var(--danger-rgb), 0.1) !important;
  color: #FF0000;
}

.dropdown-menu.dropmenu-light-primary {
  background-color: rgba(var(#092C4C), 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-primary .dropdown-item:hover, .dropdown-menu.dropmenu-light-primary .dropdown-item:focus, .dropdown-menu.dropmenu-light-primary .dropdown-item:active, .dropdown-menu.dropmenu-light-primary .dropdown-item.active {
  color: #ffffff;
  background-color: #FF9F43 !important;
}
.dropdown-menu.dropmenu-light-secondary {
  background-color: rgba(var(#092C4C), 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-secondary .dropdown-item:hover, .dropdown-menu.dropmenu-light-secondary .dropdown-item:focus, .dropdown-menu.dropmenu-light-secondary .dropdown-item:active, .dropdown-menu.dropmenu-light-secondary .dropdown-item.active {
  color: #ffffff;
  background-color: #092C4C !important;
}
.dropdown-menu.dropmenu-light-info {
  background-color: rgba(23, 162, 184, 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-info .dropdown-item:hover, .dropdown-menu.dropmenu-light-info .dropdown-item:focus, .dropdown-menu.dropmenu-light-info .dropdown-item:active, .dropdown-menu.dropmenu-light-info .dropdown-item.active {
  color: #ffffff;
  background-color: #17a2b8 !important;
}
.dropdown-menu.dropmenu-light-warning {
  background-color: rgba(255, 153, 0, 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-warning .dropdown-item:hover, .dropdown-menu.dropmenu-light-warning .dropdown-item:focus, .dropdown-menu.dropmenu-light-warning .dropdown-item:active, .dropdown-menu.dropmenu-light-warning .dropdown-item.active {
  color: #ffffff;
  background-color: #FF9900 !important;
}
.dropdown-menu.dropmenu-light-success {
  background-color: rgba(40, 199, 111, 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-success .dropdown-item:hover, .dropdown-menu.dropmenu-light-success .dropdown-item:focus, .dropdown-menu.dropmenu-light-success .dropdown-item:active, .dropdown-menu.dropmenu-light-success .dropdown-item.active {
  color: #ffffff;
  background-color: #28C76F !important;
}
.dropdown-menu.dropmenu-light-danger {
  background-color: rgba(var(--danger-rgb), 0.1);
  -webkit-backdrop-filter: blur(2rem);
          backdrop-filter: blur(2rem);
}
.dropdown-menu.dropmenu-light-danger .dropdown-item:hover, .dropdown-menu.dropmenu-light-danger .dropdown-item:focus, .dropdown-menu.dropmenu-light-danger .dropdown-item:active, .dropdown-menu.dropmenu-light-danger .dropdown-item.active {
  color: #ffffff;
  background-color: #FF0000 !important;
}

.dropdown-divider {
  margin: 0;
}

.bd-example > .dropdown-menu {
  position: static;
  display: block;
}

.icons-list {
  padding: 0;
  display: flex;
  flex-wrap: wrap;
}
.icons-list li {
  display: block;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 18px;
  border-radius: 50px;
  border: 1px solid #e6ebf1;
  color: #FF9F43;
  margin: 5px;
  box-shadow: 0 2px 3px rgb(215, 197, 255);
}

.progress {
  background-color: #e8ebed;
  height: 0.75rem;
  border-radius: 0.25rem;
}

.progress-stacked {
  background-color: #e8ebed;
}

.progress-bar {
  color: #ffffff;
  background-color: #FF9F43;
}

@keyframes progress-animate {
  0% {
    width: 0;
  }
}
.progress-animate {
  position: relative;
  border-radius: 0.625rem;
}
.progress-animate .progress-bar {
  position: relative;
  border-radius: 0.625rem;
  animation: 2s progress-animate;
}

.progress.progress-xs, .progress-stacked.progress-xs {
  height: 0.3125rem;
}
.progress.progress-sm, .progress-stacked.progress-sm {
  height: 0.5rem;
}
.progress.progress-lg, .progress-stacked.progress-lg {
  height: 1rem;
}
.progress.progress-xl, .progress-stacked.progress-xl {
  height: 1.25rem;
}

.progress-vertical {
  min-height: 250px;
  height: 250px;
  width: 10px;
  position: relative;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical .progress-bar {
  width: 100%;
}
.progress-vertical.progress-xl {
  width: 15px;
}
.progress-vertical.progress-lg {
  width: 12px;
}
.progress-vertical.progress-sm {
  width: 8px;
}
.progress-vertical.progress-xs {
  width: 5px;
}

.progress-vertical-bottom {
  min-height: 250px;
  height: 250px;
  position: relative;
  width: 10px;
  display: inline-block;
  margin-bottom: 0;
  margin-right: 20px;
}
.progress-vertical-bottom .progress-bar {
  width: 100%;
  bottom: 0;
  position: absolute;
}
.progress-vertical-bottom.progress-xl {
  width: 15px;
}
.progress-vertical-bottom.progress-lg {
  width: 12px;
}
.progress-vertical-bottom.progress-sm {
  width: 8px;
}
.progress-vertical-bottom.progress-xs {
  width: 5px;
}

.progress-custom {
  overflow: visible;
  position: relative;
}
.progress-custom .progress-bar {
  position: relative;
  overflow: visible;
}
.progress-custom .progress-bar:after {
  content: "";
  width: 1.15rem;
  height: 1.15rem;
  border-radius: 50%;
  box-shadow: 0 0.313rem 0.313rem rgba(255, 159, 67, 0.5);
  background: #ffffff;
  position: absolute;
  inset-inline-end: -0.375rem;
  inset-block-start: -0.375rem;
  border: 0.25rem solid #FF9F43;
}
.progress-custom .progress-bar.bg-secondary:after {
  border: 0.25rem solid #092C4C;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--secondary-rgb), 0.2);
}
.progress-custom .progress-bar.bg-warning:after {
  border: 0.25rem solid #FF9900;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--warning-rgb), 0.2);
}
.progress-custom .progress-bar.bg-info:after {
  border: 0.25rem solid #17a2b8;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--info-rgb), 0.2);
}
.progress-custom .progress-bar.bg-success:after {
  border: 0.25rem solid #28C76F;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--success-rgb), 0.2);
}
.progress-custom .progress-bar.bg-danger:after {
  border: 0.25rem solid #FF0000;
  box-shadow: 0 0.313rem 0.313rem rgba(var(--danger-rgb), 0.2);
}
.progress-custom .progress-bar-value {
  width: 1.875rem;
  height: 1.25rem;
  line-height: 1.25rem;
  border-radius: 0.188rem;
  background: #FF9F43;
  box-shadow: 0 0.313rem 0.313rem rgba(0, 0, 0, 0.4);
  font-size: 0.625rem;
  font-weight: 600;
  color: #ffffff;
  text-align: center;
  position: absolute;
  inset-block-end: 1.5rem;
  inset-inline-end: -0.688rem;
}
.progress-custom .progress-bar-value:after {
  content: "";
  border-block-start: 0.438rem solid #FF9F43;
  border-inline-start: 0.438rem solid transparent;
  border-inline-end: 0.438rem solid transparent;
  position: absolute;
  inset-block-end: -0.375rem;
  inset-inline-start: 28%;
}
.progress-custom .progress-bar-value.bg-secondary {
  background-color: #092C4C;
}
.progress-custom .progress-bar-value.bg-secondary:after {
  border-block-start: 0.438rem solid #092C4C;
}
.progress-custom .progress-bar-value.bg-success {
  background-color: #28C76F;
}
.progress-custom .progress-bar-value.bg-success:after {
  border-block-start: 0.438rem solid #28C76F;
}
.progress-custom .progress-bar-value.bg-warning {
  background-color: #FF9900;
}
.progress-custom .progress-bar-value.bg-warning:after {
  border-block-start: 0.438rem solid #FF9900;
}
.progress-custom .progress-bar-value.bg-danger {
  background-color: #FF0000;
}
.progress-custom .progress-bar-value.bg-danger:after {
  border-block-start: 0.438rem solid #FF0000;
}
.progress-custom .progress-bar-value.bg-info {
  background-color: #17a2b8;
}
.progress-custom .progress-bar-value.bg-info:after {
  border-block-start: 0.438rem solid #17a2b8;
}

[dir=rtl] .progress-bar-title {
  border-radius: 0 0.313rem 0.313rem 0;
}

.progress-item-1, .progress-item-2, .progress-item-3 {
  position: absolute;
  margin-block-start: -0.25rem;
  z-index: 1;
  height: 0.938rem;
  width: 0.938rem;
  border-radius: 1.563rem;
  background-color: #f8f9fa;
}

.progress-item-1 {
  inset-inline-start: 25%;
}

.progress-item-2 {
  inset-inline-start: 50%;
}

.progress-item-3 {
  inset-inline-start: 75%;
}

.custom-progress-3 {
  overflow: visible;
  border-radius: 0.625rem;
}
.custom-progress-3 .progress-bar {
  position: relative;
  overflow: visible;
  margin: 0.313rem;
  border-radius: 0.25rem;
}
.custom-progress-3 .progress-bar:before {
  content: "";
  position: absolute;
  width: 0.25rem;
  height: 0.25rem;
  inset-inline-start: 0.125rem;
  background-color: #ffffff;
  border-radius: 50%;
}
.custom-progress-3 .progress-bar .progress-bar-value {
  border: 0.125rem solid #FF9F43;
  width: 2.5rem;
  height: 1.563rem;
  line-height: 1.313rem;
  border-radius: 3.125rem;
  background: #ffffff;
  font-size: 0.625rem;
  font-weight: 600;
  color: #FF9F43;
  text-align: center;
  position: absolute;
  inset-inline-end: -0.625rem;
}
.custom-progress-3 .progress-bar .progress-bar-value.secondary {
  border: 0.125rem solid #092C4C;
  color: #092C4C;
}
.custom-progress-3 .progress-bar .progress-bar-value.warning {
  border: 0.125rem solid #FF9900;
  color: #FF9900;
}
.custom-progress-3 .progress-bar .progress-bar-value.info {
  border: 0.125rem solid #17a2b8;
  color: #17a2b8;
}
.custom-progress-3 .progress-bar .progress-bar-value.success {
  border: 0.125rem solid #28C76F;
  color: #28C76F;
}
.custom-progress-3 .progress-bar .progress-bar-value.danger {
  border: 0.125rem solid #FF0000;
  color: #FF0000;
}

.custom-progress-4.progress {
  background-color: rgba(255, 159, 67, 0.1);
  border-radius: 0.25rem;
}
.custom-progress-4.progress.secondary {
  background-color: rgba(9, 44, 76, 0.1);
}
.custom-progress-4.progress.secondary .progress-bar-label {
  color: #092C4C;
}
.custom-progress-4.progress.warning {
  background-color: rgba(255, 153, 0, 0.1);
}
.custom-progress-4.progress.warning .progress-bar-label {
  color: #FF9900;
}
.custom-progress-4.progress.info {
  background-color: rgba(23, 162, 184, 0.1);
}
.custom-progress-4.progress.info .progress-bar-label {
  color: #17a2b8;
}
.custom-progress-4.progress.success {
  background-color: rgba(40, 199, 111, 0.1);
}
.custom-progress-4.progress.success .progress-bar-label {
  color: #28C76F;
}
.custom-progress-4.progress.danger {
  background-color: rgba(255, 0, 0, 0.1);
}
.custom-progress-4.progress.danger .progress-bar-label {
  color: #FF0000;
}
.custom-progress-4.progress .progress-bar {
  border-radius: 0.25rem;
}
.custom-progress-4.progress .progress-bar-label {
  position: absolute;
  inset-inline-end: 0.313rem;
  font-weight: 600;
  font-size: 0.813rem;
  color: #FF9F43;
}

.page-link {
  color: #5B6670;
  background-color: #ffffff;
  border: 1px solid #dbe0e6;
}
.page-link:focus {
  box-shadow: none;
  background-color: #f8f9fa;
}
.page-link:hover {
  color: #FF9F43;
  background-color: #f8f9fa;
  border-color: #dbe0e6;
}

.page-item.active .page-link {
  color: #ffffff;
  background-color: #FF9F43;
  border-color: #FF9F43;
}

.disabled > .page-link, .page-link.disabled {
  color: #5B6670;
  background-color: #ffffff;
  border-color: #dbe0e6;
  opacity: 0.7;
}

[dir=rtl] .pagination .page-link .bx-chevron-left::before {
  content: "\\ea50";
}
[dir=rtl] .pagination .page-link .bx-chevron-right::before {
  content: "\\ea4d";
}
[dir=rtl] .pagination .page-link .ri-arrow-right-s-line:before {
  content: "\\ea64";
}
[dir=rtl] .pagination .page-link .ri-arrow-left-s-line:before {
  content: "\\ea6e";
}

.pagination-style-1 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-1 .pagination .page-item .page-link {
  border: 0;
  border-radius: 4px;
  font-size: 0.8125rem;
}
.pagination-style-1 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-1 .pagination .page-item.active .page-link {
  border-radius: 4px;
  background-color: #FF9F43;
  color: #ffffff;
}
.pagination-style-1 .pagination .page-item.active:hover .page-link {
  border-radius: 4px;
  background-color: #FF9F43;
  color: #ffffff;
}
.pagination-style-1 .pagination .page-item:hover .page-link {
  background-color: #f8f9fa;
  color: #FF9F43;
}

.pagination-style-2 .pagination {
  border-radius: 4px;
}
.pagination-style-2 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-2 .pagination .page-item .page-link {
  border: 0 !important;
  font-size: 0.8125rem;
}
.pagination-style-2 .pagination .page-item.active .page-link {
  background-color: #ffffff;
  color: #FF9F43;
  position: relative;
  font-weight: bold;
}
.pagination-style-2 .pagination .page-item.active .page-link:before {
  position: absolute;
  content: "";
  inset-block-end: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 0.1rem;
  background-color: #FF9F43;
}
.pagination-style-2 .pagination .page-item:hover .page-link {
  background-color: transparent;
}

.pagination-style-3 .pagination {
  border-radius: 50px;
  padding: 0.25rem;
  align-items: center;
}
.pagination-style-3 .pagination .page-item {
  margin: 0 0.25rem;
}
.pagination-style-3 .pagination .page-item .page-link {
  border: 0;
  border-radius: 50px;
  font-size: 0.8125rem;
}
.pagination-style-3 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-3 .pagination .page-item.active .page-link {
  background-color: #FF9F43;
  color: #ffffff;
}
.pagination-style-3 .pagination .page-item.active:hover .page-link {
  background-color: #FF9F43;
}
.pagination-style-3 .pagination .page-item:hover .page-link {
  background-color: #f8f9fa;
}

.pagination-style-4 .pagination .page-item .page-link {
  border: 0 !important;
  font-size: 0.8125rem;
  border-radius: 4px;
}
.pagination-style-4 .pagination .page-item .page-link i {
  font-weight: 600;
}
.pagination-style-4 .pagination .page-item.active .page-link {
  border: 0;
  border-radius: 4px;
  background-color: #FF9F43;
  color: #ffffff;
}
.pagination-style-4 .pagination .page-item.active:hover .page-link {
  background-color: #FF9F43;
}
.pagination-style-4 .pagination .page-item:hover .page-link {
  background-color: transparent;
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  color: #1B2850;
  font-family: "Nunito", sans-serif;
  font-weight: 700;
  margin-bottom: 0;
}

h1,
.h1 {
  font-size: 2rem;
}

h2,
.h2 {
  font-size: 1.75rem;
}

h3,
.h3 {
  font-size: 1.5rem;
}

h4,
.h4 {
  font-size: 1.125rem;
}

h5,
.h5 {
  font-size: 1rem;
}

h6,
.h6 {
  font-size: 0.875rem;
}

.fs-sm {
  font-size: 0.6875rem;
}

.fs-base {
  font-size: 0.875rem;
}

.fs-lg {
  font-size: 1.125rem;
}

.fs-1 {
  font-size: 0.0625rem;
}

.fs-2 {
  font-size: 0.125rem;
}

.fs-3 {
  font-size: 0.1875rem;
}

.fs-4 {
  font-size: 0.25rem;
}

.fs-5 {
  font-size: 0.3125rem;
}

.fs-6 {
  font-size: 0.375rem;
}

.fs-7 {
  font-size: 0.4375rem;
}

.fs-8 {
  font-size: 0.5rem;
}

.fs-9 {
  font-size: 0.5625rem;
}

.fs-10 {
  font-size: 0.625rem;
}

.fs-11 {
  font-size: 0.6875rem;
}

.fs-12 {
  font-size: 0.75rem;
}

.fs-13 {
  font-size: 0.8125rem;
}

.fs-14 {
  font-size: 0.875rem;
}

.fs-15 {
  font-size: 0.9375rem;
}

.fs-16 {
  font-size: 1rem;
}

.fs-17 {
  font-size: 1.0625rem;
}

.fs-18 {
  font-size: 1.125rem;
}

.fs-19 {
  font-size: 1.1875rem;
}

.fs-20 {
  font-size: 1.25rem;
}

.fs-21 {
  font-size: 1.3125rem;
}

.fs-22 {
  font-size: 1.375rem;
}

.fs-23 {
  font-size: 1.4375rem;
}

.fs-24 {
  font-size: 1.5rem;
}

.fs-25 {
  font-size: 1.5625rem;
}

.fs-26 {
  font-size: 1.625rem;
}

.fs-27 {
  font-size: 1.6875rem;
}

.fs-28 {
  font-size: 1.75rem;
}

.fs-29 {
  font-size: 1.8125rem;
}

.fs-30 {
  font-size: 1.875rem;
}

.fs-32 {
  font-size: 2rem;
}

.fs-34 {
  font-size: 2.125rem;
}

.fs-36 {
  font-size: 2.25rem;
}

.fs-38 {
  font-size: 2.375rem;
}

.fs-40 {
  font-size: 2.5rem;
}

.text-default {
  color: #5B6670 !important;
}

.text-muted {
  color: #9595b5 !important;
}

.text-primary {
  color: #FF9F43 !important;
  opacity: 1;
}
.text-primary.text-opacity-75 {
  color: rgba(255, 159, 67, 0.75) !important;
}
.text-primary.text-opacity-25 {
  color: rgba(255, 159, 67, 0.25) !important;
}
.text-primary.text-opacity-50 {
  color: rgba(255, 159, 67, 0.5) !important;
}

.text-secondary {
  color: #092C4C !important;
  opacity: 1;
}

.text-info {
  color: #17a2b8 !important;
  opacity: 1;
}

.text-success {
  color: #28C76F !important;
  opacity: 1;
}

.text-warning {
  color: #FF9900 !important;
  opacity: 1;
}

.text-danger {
  color: #FF0000 !important;
  opacity: 1;
}

.text-blue {
  color: #3577f1 !important;
}

.text-green {
  color: #1dd871 !important;
}

.text-pink {
  color: #ff63a5 !important;
}

.text-teal {
  color: #02a8b5 !important;
}

.text-orange {
  color: #ffa500 !important;
}

.text-indigo {
  color: #4d5ddb !important;
}

.text-purple {
  color: #7367F0 !important;
}

.text-dark {
  color: #29344a !important;
}

.text-light {
  color: #f8f9fa !important;
}

.text-gray {
  color: #adb5bd !important;
}

.text-black {
  color: #000000 !important;
}

.text-white {
  color: #ffffff !important;
}

.text-fixed-white {
  color: #ffffff !important;
}

.text-fixed-black {
  color: #000000 !important;
}

.text-gray-1 {
  color: #f3f6f9;
}

.text-gray-2 {
  color: #eff2f7;
}

.text-gray-3 {
  color: #e8ebed;
}

.text-gray-4 {
  color: #dbe0e6;
}

.text-gray-5 {
  color: #adb5bd;
}

.text-gray-6 {
  color: #67748E;
}

.text-gray-7 {
  color: #495057;
}

.text-gray-8 {
  color: #343a40;
}

.text-gray-9 {
  color: #212529;
}

a {
  text-decoration: none;
  color: #5B6670;
}
a:hover {
  --bs-text-opacity: 1;
  opacity: 1;
  color: #FF9F43;
}

.link-primary {
  color: #FF9F43 !important;
}
.link-primary:hover, .link-primary:focus, .link-primary:active {
  color: #FF9F43 !important;
}

.link-secondary {
  color: #092C4C !important;
}
.link-secondary:hover, .link-secondary:focus, .link-secondary:active {
  color: #092C4C !important;
}

.link-success {
  color: #28C76F !important;
}
.link-success:hover, .link-success:focus, .link-success:active {
  color: #28C76F !important;
}

.link-danger {
  color: #FF0000 !important;
}
.link-danger:hover, .link-danger:focus, .link-danger:active {
  color: #FF0000 !important;
}

.link-warning {
  color: #FF9900 !important;
}
.link-warning:hover, .link-warning:focus, .link-warning:active {
  color: #FF9900 !important;
}

.link-info {
  color: #17a2b8 !important;
}
.link-info:hover, .link-info:focus, .link-info:active {
  color: #17a2b8 !important;
}

.link-light {
  color: #f8f9fa !important;
}
.link-light:hover, .link-light:focus, .link-light:active {
  color: #f8f9fa !important;
}

.link-dark {
  color: #29344a !important;
}
.link-dark:hover, .link-dark:focus, .link-dark:active {
  color: #29344a !important;
}

hr.text-danger {
  border-color: #FF0000 !important;
}

.blockquote-container {
  padding: 1.25rem;
  border-left: 4px solid #dbe0e6;
  position: relative;
}
.blockquote-container.text-end {
  border-right: 4px solid #dbe0e6;
  border-left: 0;
}

.blockquote.custom-blockquote {
  font-size: 0.85rem;
  font-weight: 600;
  padding: 1rem;
  border-radius: 4px;
  position: relative;
}
.blockquote.custom-blockquote:before {
  content: "\\f10d";
  font-family: "Fontawesome";
  z-index: 0;
  font-size: 2rem;
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0.5rem;
}
.blockquote.custom-blockquote.primary {
  background-color: rgba(255, 159, 67, 0.1);
  border-inline-start: 2px solid #FF9F43;
}
.blockquote.custom-blockquote.primary:before {
  color: rgba(255, 159, 67, 0.1);
}
.blockquote.custom-blockquote.secondary {
  background-color: rgba(9, 44, 76, 0.1);
  border-inline-start: 2px solid #092C4C;
}
.blockquote.custom-blockquote.secondary:before {
  color: rgba(9, 44, 76, 0.1);
}
.blockquote.custom-blockquote.info {
  background-color: rgba(23, 162, 184, 0.1);
  border-inline-start: 2px solid #17a2b8;
}
.blockquote.custom-blockquote.info:before {
  color: rgba(23, 162, 184, 0.1);
}
.blockquote.custom-blockquote.warning {
  background-color: rgba(255, 153, 0, 0.1);
  border-inline-start: 2px solid #FF9900;
}
.blockquote.custom-blockquote.warning:before {
  color: rgba(255, 153, 0, 0.1);
}
.blockquote.custom-blockquote.success {
  background-color: rgba(40, 199, 111, 0.1);
  border-inline-start: 2px solid #28C76F;
}
.blockquote.custom-blockquote.success:before {
  color: rgba(40, 199, 111, 0.1);
}
.blockquote.custom-blockquote.danger {
  background-color: rgba(255, 0, 0, 0.1);
  border-inline-start: 2px solid #FF0000;
}
.blockquote.custom-blockquote.danger:before {
  color: rgba(255, 0, 0, 0.1);
}

[data-theme-mode=dark] .shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(33, 37, 41, 0.3) !important;
}
[data-theme-mode=dark] .shadow {
  box-shadow: 0 0.5rem 1rem rgba(33, 37, 41, 0.3) !important;
}
[data-theme-mode=dark] .shadow-lg {
  box-shadow: 0 1rem 3rem rgba(33, 37, 41, 0.3) !important;
}

@media screen and (min-width: 576px) {
  .w-sm-auto {
    width: auto;
  }
}
[dir=rtl] .text-break {
  word-wrap: break-word !important;
  word-break: break-word !important;
}

.transform-none {
  transform: none !important;
}

.w-9 {
  width: 9px;
}

.h-9 {
  height: 9px;
}

.list-circle {
  list-style: circle;
  padding-left: 2rem;
}

.alert {
  padding: 0.625rem 0.85rem;
  border-radius: 4px;
  font-size: 0.8125rem;
}
.alert.alert-dismissible {
  padding: 0.625rem 2.25rem 0.625rem 0.85rem;
}
.alert i {
  font-size: 20px;
}
.alert .btn-close {
  background-image: none;
  padding: 0.85rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alert .btn-close i {
  font-size: 18px;
  line-height: 18px;
}
.alert:last-child {
  margin-bottom: 0;
}
.alert .alert-link {
  font-weight: 600;
}

[dir=rtl] .alert.alert-dismissible {
  padding: 0.625rem 0.85rem 0.625rem 2.25rem;
}

.alert-warning {
  background-color: rgba(255, 153, 0, 0.1);
  color: #FF9900;
  border-color: rgba(255, 153, 0, 0.1);
}
.alert-warning .alert-link {
  color: #FF9900;
}
.alert-warning .btn-close {
  color: #FF9900;
}
.alert-warning .btn-close.custom-close {
  background-color: #FF9900;
  color: #ffffff;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  padding: 0.85rem;
}

.alert-primary {
  background-color: rgba(255, 159, 67, 0.1);
  color: #FF9F43;
  border-color: rgba(255, 159, 67, 0.1);
}
.alert-primary .alert-link {
  color: #FF9F43;
}
.alert-primary .custom-alert-icon {
  color: #FF9F43;
}
.alert-primary .btn-close {
  color: #FF9F43;
}
.alert-primary .btn-close.custom-close {
  background-color: #FF9F43;
  color: #ffffff;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  padding: 0.85rem;
}

.alert-secondary {
  background-color: rgba(9, 44, 76, 0.1);
  color: #092C4C;
  border-color: rgba(9, 44, 76, 0.1);
}
.alert-secondary .alert-link {
  color: #092C4C;
}
.alert-secondary .btn-close {
  color: #092C4C;
}
.alert-secondary .btn-close.custom-close {
  background-color: #092C4C;
  color: #ffffff;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  padding: 0.85rem;
}

.alert-success {
  background-color: rgba(40, 199, 111, 0.1);
  color: #28C76F;
  border-color: rgba(40, 199, 111, 0.1);
}
.alert-success .alert-link {
  color: #28C76F;
}
.alert-success .btn-close {
  color: #28C76F;
}
.alert-success .btn-close.custom-close {
  background-color: #28C76F;
  color: #ffffff;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  padding: 0.85rem;
}

.alert-info {
  background-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
  border-color: rgba(23, 162, 184, 0.1);
}
.alert-info .alert-link {
  color: #17a2b8;
}
.alert-info .btn-close {
  color: #17a2b8;
}
.alert-info .btn-close.custom-close {
  background-color: #17a2b8;
  color: #ffffff;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  padding: 0.85rem;
}

.alert-danger {
  background-color: rgba(255, 0, 0, 0.1);
  color: #FF0000;
  border-color: rgba(255, 0, 0, 0.1);
}
.alert-danger .alert-link {
  color: #FF0000;
}
.alert-danger .btn-close {
  color: #FF0000;
}
.alert-danger .btn-close.custom-close {
  background-color: #FF0000;
  color: #ffffff;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  padding: 0.85rem;
}

.alert-light {
  background-color: #f8f9fa;
  color: #5B6670;
  border-color: #f8f9fa;
}
.alert-light .alert-link {
  color: #5B6670;
}
.alert-light .btn-close {
  color: #5B6670;
}
.alert-light .btn-close.custom-close {
  background-color: #f8f9fa;
  color: #ffffff;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  padding: 0.85rem;
}

.alert-dark {
  background-color: rgba(41, 52, 74, 0.1);
  color: #5B6670;
  border-color: rgba(41, 52, 74, 0.1);
}
.alert-dark .alert-link {
  color: #5B6670;
}
.alert-dark .btn-close {
  color: #ffffff;
}
.alert-dark .btn-close.custom-close {
  background-color: #29344a;
  color: #ffffff;
  opacity: 1;
  border-radius: 50px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  padding: 0.85rem;
}

.alert-solid-primary {
  background-color: #FF9F43;
  color: #ffffff;
  border-color: #FF9F43;
}
.alert-solid-primary .btn-close {
  color: #ffffff;
}

.alert-solid-secondary {
  background-color: #092C4C;
  color: #ffffff;
  border-color: #092C4C;
}
.alert-solid-secondary .btn-close {
  color: #ffffff;
}

.alert-solid-warning {
  background-color: #FF9900;
  color: #ffffff;
  border-color: #FF9900;
}
.alert-solid-warning .btn-close {
  color: #ffffff;
}

.alert-solid-info {
  background-color: #17a2b8;
  color: #ffffff;
  border-color: #17a2b8;
}
.alert-solid-info .btn-close {
  color: #ffffff;
}

.alert-solid-success {
  background-color: #28C76F;
  color: #ffffff;
  border-color: #28C76F;
}
.alert-solid-success .btn-close {
  color: #ffffff;
}

.alert-solid-danger {
  background-color: #FF0000;
  color: #ffffff;
  border-color: #FF0000;
}
.alert-solid-danger .btn-close {
  color: #ffffff;
}

.alert-solid-light {
  background-color: #f8f9fa;
  color: #5B6670;
  border-color: #dbe0e6;
}

.alert-solid-dark {
  background-color: #29344a;
  color: #ffffff;
  border-color: #29344a;
}
.alert-solid-dark .btn-close {
  color: #ffffff;
}

.alert-outline-primary {
  background-color: #ffffff;
  color: #FF9F43;
  border-color: #FF9F43;
}
.alert-outline-primary .btn-close {
  color: #FF9F43;
}

.alert-outline-secondary {
  background-color: #ffffff;
  color: #092C4C;
  border-color: #092C4C;
}
.alert-outline-secondary .btn-close {
  color: #092C4C;
}

.alert-outline-info {
  background-color: #ffffff;
  color: #17a2b8;
  border-color: #17a2b8;
}
.alert-outline-info .btn-close {
  color: #17a2b8;
}

.alert-outline-warning {
  background-color: #ffffff;
  color: #FF9900;
  border-color: #FF9900;
}
.alert-outline-warning .btn-close {
  color: #FF9900;
}

.alert-outline-success {
  background-color: #ffffff;
  color: #28C76F;
  border-color: #28C76F;
}
.alert-outline-success .btn-close {
  color: #28C76F;
}

.alert-outline-danger {
  background-color: #ffffff;
  color: #FF0000;
  border-color: #FF0000;
}
.alert-outline-danger .btn-close {
  color: #FF0000;
}

.alert-outline-light {
  background-color: #ffffff;
  color: #5B6670;
  border-color: #f8f9fa;
}

.alert-outline-dark {
  background-color: #ffffff;
  color: #29344a;
  border-color: #29344a;
}
.alert-outline-dark .btn-close {
  color: #29344a;
}

.alert-primary.custom-alert-icon {
  border-inline-start: 0.313rem solid #FF9F43 !important;
  color: #9595b5;
  background-color: #ffffff;
  border: 1px solid #dbe0e6;
  font-size: 0.813rem;
}
.alert-primary.custom-alert-icon .btn-close {
  color: #5B6670;
}
.alert-primary.custom-alert-icon > i {
  color: #FF9F43;
}

.alert-secondary.custom-alert-icon {
  border-inline-start: 0.313rem solid #092C4C !important;
  color: #9595b5;
  background-color: #ffffff;
  border: 1px solid #dbe0e6;
  font-size: 0.813rem;
}
.alert-secondary.custom-alert-icon .btn-close {
  color: #5B6670;
}
.alert-secondary.custom-alert-icon > i {
  color: #092C4C;
}

.alert-warning.custom-alert-icon {
  border-inline-start: 0.313rem solid #FF9900 !important;
  color: #9595b5;
  background-color: #ffffff;
  border: 1px solid #dbe0e6;
  font-size: 0.813rem;
}
.alert-warning.custom-alert-icon .btn-close {
  color: #5B6670;
}
.alert-warning.custom-alert-icon > i {
  color: #FF9900;
}

.alert-danger.custom-alert-icon {
  border-inline-start: 0.313rem solid #FF0000 !important;
  color: #9595b5;
  background-color: #ffffff;
  border: 1px solid #dbe0e6;
  font-size: 0.813rem;
}
.alert-danger.custom-alert-icon .btn-close {
  color: #5B6670;
}
.alert-danger.custom-alert-icon > i {
  color: #FF0000;
}

.alert-success.custom-alert-icon {
  border-inline-start: 0.313rem solid #28C76F !important;
  color: #9595b5;
  background-color: #ffffff;
  border: 1px solid #dbe0e6;
  font-size: 0.813rem;
}
.alert-success.custom-alert-icon .btn-close {
  color: #5B6670;
}

.alert-info.custom-alert-icon {
  border-inline-start: 0.313rem solid #17a2b8 !important;
  color: #9595b5;
  background-color: #ffffff;
  border: 1px solid #dbe0e6;
  font-size: 0.813rem;
}
.alert-info.custom-alert-icon .btn-close {
  color: #5B6670;
}

.alert-light.custom-alert-icon {
  border-inline-start: 0.313rem solid #f8f9fa !important;
  color: #9595b5;
  background-color: #ffffff;
  border: 1px solid #dbe0e6;
  font-size: 0.813rem;
}
.alert-light.custom-alert-icon .btn-close {
  color: #5B6670;
}

.alert-dark.custom-alert-icon {
  border-inline-start: 0.313rem solid #29344a !important;
  color: #9595b5;
  background-color: #ffffff;
  border: 1px solid #dbe0e6;
  font-size: 0.813rem;
}
.alert-dark.custom-alert-icon .btn-close {
  color: #5B6670;
}

.custom-alert1 {
  margin-block-end: 0;
  background-color: #ffffff;
  border: 0;
  padding: 1.25rem;
  color: #5B6670;
}
.custom-alert1 p {
  margin-block-end: 2.5rem;
  color: #9595b5;
  font-size: 0.8rem;
}
.custom-alert1 .custom-alert-icon {
  font-size: 40px;
  margin-bottom: 0.85rem;
}
.custom-alert1 .custom-alert-icon i {
  font-size: 40px;
}
.custom-alert1 .btn-close {
  padding: 0;
  margin-block-end: 1rem;
}
.custom-alert1.alert-primary {
  border-block-start: 0.313rem solid #FF9F43;
}
.custom-alert1.alert-primary .custom-alert-icon {
  color: #FF9F43;
}
.custom-alert1.alert-secondary {
  border-block-start: 0.313rem solid #092C4C;
}
.custom-alert1.alert-secondary .custom-alert-icon {
  color: #092C4C;
}
.custom-alert1.alert-warning {
  border-block-start: 0.313rem solid #FF9900;
}
.custom-alert1.alert-warning .custom-alert-icon {
  color: #FF9900;
}
.custom-alert1.alert-danger {
  border-block-start: 0.313rem solid #FF0000;
}
.custom-alert1.alert-danger .custom-alert-icon {
  color: #FF0000;
}

.alert-img {
  display: flex;
  align-items: center;
}
.alert-img .avatar {
  border: 1px solid rgba(0, 0, 0, 0.1);
}

@media screen and (max-width: 400px) {
  .btn-close.custom-close {
    margin: 9px 9px 9px 0;
  }
}
.op-1-1 {
  opacity: 1;
}

.op-0 {
  opacity: 0;
}

.op-1 {
  opacity: 0.1;
}

.op-2 {
  opacity: 0.2;
}

.op-3 {
  opacity: 0.3;
}

.op-4 {
  opacity: 0.4;
}

.op-5 {
  opacity: 0.5;
}

.op-6 {
  opacity: 0.6;
}

.op-7 {
  opacity: 0.7;
}

.op-8 {
  opacity: 0.8;
}

.op-9 {
  opacity: 0.9;
}

.custom-popover {
  --bs-popover-max-width: 12.5rem;
  --bs-popover-border-color: #FF9F43;
  --bs-popover-header-bg: #FF9F43;
  --bs-popover-header-color: #ffffff;
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 0.5rem;
}

.popover {
  background-color: #ffffff;
  border: 1px solid #dbe0e6;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  font-size: 0.8rem;
  border-radius: 4px;
  z-index: 999;
}
.popover .popover-header {
  background-color: #ffffff;
  border-block-end: 1px solid #dbe0e6;
}
.popover .popover-body {
  color: #5B6670;
}
.popover.only-body {
  border-radius: 0.3rem;
}

.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after,
.bs-popover-top > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before,
.bs-popover-top > .popover-arrow::before {
  border-top-color: #f8f9fa;
}

.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after,
.bs-popover-end > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before,
.bs-popover-end > .popover-arrow::before {
  border-right-color: #f8f9fa;
}

.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after,
.bs-popover-start > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before,
.bs-popover-start > .popover-arrow::before {
  border-left-color: #f8f9fa;
}

.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after,
.bs-popover-bottom > .popover-arrow::after,
.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before,
.bs-popover-bottom > .popover-arrow::before,
.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before,
.bs-popover-bottom .popover-header::before {
  border-bottom-color: #f8f9fa;
}

.header-primary .popover-header {
  background-color: #FF9F43;
  color: #ffffff;
}
.header-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-primary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FF9F43;
}

.header-secondary .popover-header {
  background-color: #092C4C;
  color: #ffffff;
}
.header-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-secondary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #092C4C;
}

.header-warning .popover-header {
  background-color: #FF9900;
  color: #ffffff;
}
.header-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-warning.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FF9900;
}

.header-info .popover-header {
  background-color: #17a2b8;
  color: #ffffff;
}
.header-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-info.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #17a2b8;
}

.header-success .popover-header {
  background-color: #28C76F;
  color: #ffffff;
}
.header-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-success.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #28C76F;
}

.header-danger .popover-header {
  background-color: #FF0000;
  color: #ffffff;
}
.header-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .header-danger.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before {
  border-bottom-color: #FF0000;
}

.popover-primary.popover {
  border: 1px solid #FF9F43;
}
.popover-primary.popover .popover-header {
  background-color: #FF9F43;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-primary.popover .popover-body {
  background-color: #FF9F43;
  color: #ffffff;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-primary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-primary.bs-popover-top > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-primary.bs-popover-top > .popover-arrow::before {
  border-top-color: #FF9F43;
}
.popover-primary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-primary.bs-popover-end > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-primary.bs-popover-end > .popover-arrow::before {
  border-right-color: #FF9F43;
}
.popover-primary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-primary.bs-popover-start > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-primary.bs-popover-start > .popover-arrow::before {
  border-left-color: #FF9F43;
}
.popover-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-primary.bs-popover-bottom > .popover-arrow::after, .popover-primary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-primary.bs-popover-bottom > .popover-arrow::before, .popover-primary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-primary.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FF9F43;
}

.popover-secondary.popover {
  border: 1px solid #092C4C;
}
.popover-secondary.popover .popover-header {
  background-color: #092C4C;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-secondary.popover .popover-body {
  background-color: #092C4C;
  color: #ffffff;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-secondary.bs-popover-top > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-secondary.bs-popover-top > .popover-arrow::before {
  border-top-color: #092C4C;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-secondary.bs-popover-end > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-secondary.bs-popover-end > .popover-arrow::before {
  border-right-color: #092C4C;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-secondary.bs-popover-start > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-secondary.bs-popover-start > .popover-arrow::before {
  border-left-color: #092C4C;
}
.popover-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-secondary.bs-popover-bottom > .popover-arrow::after, .popover-secondary.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-secondary.bs-popover-bottom > .popover-arrow::before, .popover-secondary.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-secondary.bs-popover-bottom .popover-header::before {
  border-bottom-color: #092C4C;
}

.popover-warning.popover {
  border: 1px solid #FF9900;
}
.popover-warning.popover .popover-header {
  background-color: #FF9900;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-warning.popover .popover-body {
  background-color: #FF9900;
  color: #ffffff;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-warning.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-warning.bs-popover-top > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-warning.bs-popover-top > .popover-arrow::before {
  border-top-color: #FF9900;
}
.popover-warning.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-warning.bs-popover-end > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-warning.bs-popover-end > .popover-arrow::before {
  border-right-color: #FF9900;
}
.popover-warning.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-warning.bs-popover-start > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-warning.bs-popover-start > .popover-arrow::before {
  border-left-color: #FF9900;
}
.popover-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-warning.bs-popover-bottom > .popover-arrow::after, .popover-warning.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-warning.bs-popover-bottom > .popover-arrow::before, .popover-warning.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-warning.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FF9900;
}

.popover-info.popover {
  border: 1px solid #17a2b8;
}
.popover-info.popover .popover-header {
  background-color: #17a2b8;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-info.popover .popover-body {
  background-color: #17a2b8;
  color: #ffffff;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-info.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-info.bs-popover-top > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-info.bs-popover-top > .popover-arrow::before {
  border-top-color: #17a2b8;
}
.popover-info.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-info.bs-popover-end > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-info.bs-popover-end > .popover-arrow::before {
  border-right-color: #17a2b8;
}
.popover-info.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-info.bs-popover-start > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-info.bs-popover-start > .popover-arrow::before {
  border-left-color: #17a2b8;
}
.popover-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-info.bs-popover-bottom > .popover-arrow::after, .popover-info.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-info.bs-popover-bottom > .popover-arrow::before, .popover-info.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-info.bs-popover-bottom .popover-header::before {
  border-bottom-color: #17a2b8;
}

.popover-success.popover {
  border: 1px solid #28C76F;
}
.popover-success.popover .popover-header {
  background-color: #28C76F;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-success.popover .popover-body {
  background-color: #28C76F;
  color: #ffffff;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-success.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-success.bs-popover-top > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-success.bs-popover-top > .popover-arrow::before {
  border-top-color: #28C76F;
}
.popover-success.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-success.bs-popover-end > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-success.bs-popover-end > .popover-arrow::before {
  border-right-color: #28C76F;
}
.popover-success.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-success.bs-popover-start > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-success.bs-popover-start > .popover-arrow::before {
  border-left-color: #28C76F;
}
.popover-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-success.bs-popover-bottom > .popover-arrow::after, .popover-success.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-success.bs-popover-bottom > .popover-arrow::before, .popover-success.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-success.bs-popover-bottom .popover-header::before {
  border-bottom-color: #28C76F;
}

.popover-danger.popover {
  border: 1px solid #FF0000;
}
.popover-danger.popover .popover-header {
  background-color: #FF0000;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-danger.popover .popover-body {
  background-color: #FF0000;
  color: #ffffff;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-danger.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-danger.bs-popover-top > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-danger.bs-popover-top > .popover-arrow::before {
  border-top-color: #FF0000;
}
.popover-danger.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-danger.bs-popover-end > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-danger.bs-popover-end > .popover-arrow::before {
  border-right-color: #FF0000;
}
.popover-danger.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-danger.bs-popover-start > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-danger.bs-popover-start > .popover-arrow::before {
  border-left-color: #FF0000;
}
.popover-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-danger.bs-popover-bottom > .popover-arrow::after, .popover-danger.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-danger.bs-popover-bottom > .popover-arrow::before, .popover-danger.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-danger.bs-popover-bottom .popover-header::before {
  border-bottom-color: #FF0000;
}

.popover-purple.popover {
  border: 1px solid #7367F0;
}
.popover-purple.popover .popover-header {
  background-color: #7367F0;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-purple.popover .popover-body {
  background-color: #7367F0;
  color: #ffffff;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-purple.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-purple.bs-popover-top > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-purple.bs-popover-top > .popover-arrow::before {
  border-top-color: #7367F0;
}
.popover-purple.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-purple.bs-popover-end > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-purple.bs-popover-end > .popover-arrow::before {
  border-right-color: #7367F0;
}
.popover-purple.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-purple.bs-popover-start > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-purple.bs-popover-start > .popover-arrow::before {
  border-left-color: #7367F0;
}
.popover-purple.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-purple.bs-popover-bottom > .popover-arrow::after, .popover-purple.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-purple.bs-popover-bottom > .popover-arrow::before, .popover-purple.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-purple.bs-popover-bottom .popover-header::before {
  border-bottom-color: #7367F0;
}

.popover-teal.popover {
  border: 1px solid #02a8b5;
}
.popover-teal.popover .popover-header {
  background-color: #02a8b5;
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border-radius: 0.3rem 0.3rem 0 0;
}
.popover-teal.popover .popover-body {
  background-color: #02a8b5;
  color: #ffffff;
  border-radius: 0 0 0.3rem 0.3rem;
}
.popover-teal.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-teal.bs-popover-top > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-teal.bs-popover-top > .popover-arrow::before {
  border-top-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-teal.bs-popover-end > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-teal.bs-popover-end > .popover-arrow::before {
  border-right-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-teal.bs-popover-start > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-teal.bs-popover-start > .popover-arrow::before {
  border-left-color: #02a8b5;
}
.popover-teal.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-teal.bs-popover-bottom > .popover-arrow::after, .popover-teal.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-teal.bs-popover-bottom > .popover-arrow::before, .popover-teal.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-teal.bs-popover-bottom .popover-header::before {
  border-bottom-color: #02a8b5;
}

.popover-primary-light.popover {
  border: 1px solid rgba(255, 159, 67, 0.1);
}
.popover-primary-light.popover .popover-header {
  background-color: rgba(255, 159, 67, 0.1);
  border-block-end: 1px solid rgba(255, 159, 67, 0.1);
  color: #FF9F43;
  border-radius: 0;
}
.popover-primary-light.popover .popover-body {
  background-color: rgba(255, 159, 67, 0.1);
  color: #FF9F43;
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-primary-light.bs-popover-top > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-primary-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(255, 159, 67, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-primary-light.bs-popover-end > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-primary-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(255, 159, 67, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-primary-light.bs-popover-start > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-primary-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(255, 159, 67, 0.1);
}
.popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-primary-light.bs-popover-bottom > .popover-arrow::after, .popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-primary-light.bs-popover-bottom > .popover-arrow::before, .popover-primary-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-primary-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(255, 159, 67, 0.1);
}

.popover-secondary-light.popover {
  border: 1px solid rgba(9, 44, 76, 0.1);
}
.popover-secondary-light.popover .popover-header {
  background-color: rgba(9, 44, 76, 0.1);
  border-block-end: 1px solid rgba(9, 44, 76, 0.1);
  color: #092C4C;
  border-radius: 0;
}
.popover-secondary-light.popover .popover-body {
  background-color: rgba(9, 44, 76, 0.1);
  color: #092C4C;
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-secondary-light.bs-popover-top > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-secondary-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--secondary-rgb), 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-secondary-light.bs-popover-end > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-secondary-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(9, 44, 76, 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-secondary-light.bs-popover-start > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-secondary-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--secondary-rgb), 0.1);
}
.popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-secondary-light.bs-popover-bottom > .popover-arrow::after, .popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-secondary-light.bs-popover-bottom > .popover-arrow::before, .popover-secondary-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-secondary-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--secondary-rgb), 0.1);
}

.popover-warning-light.popover {
  border: 1px solid rgba(255, 153, 0, 0.1);
}
.popover-warning-light.popover .popover-header {
  background-color: rgba(255, 153, 0, 0.1);
  border-block-end: 1px solid rgba(255, 153, 0, 0.1);
  color: #FF9900;
  border-radius: 0;
}
.popover-warning-light.popover .popover-body {
  background-color: rgba(255, 153, 0, 0.1);
  color: #FF9900;
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-warning-light.bs-popover-top > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-warning-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(255, 153, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-warning-light.bs-popover-end > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-warning-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(255, 153, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-warning-light.bs-popover-start > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-warning-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(255, 153, 0, 0.1);
}
.popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-warning-light.bs-popover-bottom > .popover-arrow::after, .popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-warning-light.bs-popover-bottom > .popover-arrow::before, .popover-warning-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-warning-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(255, 153, 0, 0.1);
}

.popover-info-light.popover {
  border: 1px solid rgba(23, 162, 184, 0.1);
}
.popover-info-light.popover .popover-header {
  background-color: rgba(23, 162, 184, 0.1);
  border-block-end: 1px solid rgba(23, 162, 184, 0.1);
  color: #17a2b8;
  border-radius: 0;
}
.popover-info-light.popover .popover-body {
  background-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
}
.popover-info-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-info-light.bs-popover-top > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-info-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(23, 162, 184, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-info-light.bs-popover-end > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-info-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(23, 162, 184, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-info-light.bs-popover-start > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-info-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(23, 162, 184, 0.1);
}
.popover-info-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-info-light.bs-popover-bottom > .popover-arrow::after, .popover-info-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-info-light.bs-popover-bottom > .popover-arrow::before, .popover-info-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-info-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(23, 162, 184, 0.1);
}

.popover-success-light.popover {
  border: 1px solid rgba(40, 199, 111, 0.1);
}
.popover-success-light.popover .popover-header {
  background-color: rgba(40, 199, 111, 0.1);
  border-block-end: 1px solid rgba(40, 199, 111, 0.1);
  color: #28C76F;
  border-radius: 0;
}
.popover-success-light.popover .popover-body {
  background-color: rgba(40, 199, 111, 0.1);
  color: #28C76F;
}
.popover-success-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-success-light.bs-popover-top > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-success-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(40, 199, 111, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-success-light.bs-popover-end > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-success-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(40, 199, 111, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-success-light.bs-popover-start > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-success-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(40, 199, 111, 0.1);
}
.popover-success-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-success-light.bs-popover-bottom > .popover-arrow::after, .popover-success-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-success-light.bs-popover-bottom > .popover-arrow::before, .popover-success-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-success-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(40, 199, 111, 0.1);
}

.popover-danger-light.popover {
  border: 1px solid rgba(255, 0, 0, 0.1);
}
.popover-danger-light.popover .popover-header {
  background-color: rgba(255, 0, 0, 0.1);
  border-block-end: 1px solid rgba(255, 0, 0, 0.1);
  color: #FF0000;
  border-radius: 0;
}
.popover-danger-light.popover .popover-body {
  background-color: rgba(255, 0, 0, 0.1);
  color: #FF0000;
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-danger-light.bs-popover-top > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-danger-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(255, 0, 0, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-danger-light.bs-popover-end > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-danger-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(255, 0, 0, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-danger-light.bs-popover-start > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-danger-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(255, 0, 0, 0.1);
}
.popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-danger-light.bs-popover-bottom > .popover-arrow::after, .popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-danger-light.bs-popover-bottom > .popover-arrow::before, .popover-danger-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-danger-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(255, 0, 0, 0.1);
}

.popover-purple-light.popover {
  border: 1px solid rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.popover .popover-header {
  background-color: rgba(var(--purple-rgb), 0.1);
  border-block-end: 1px solid rgba(var(--purple-rgb), 0.1);
  color: #7367F0;
  border-radius: 0;
}
.popover-purple-light.popover .popover-body {
  background-color: rgba(var(--purple-rgb), 0.1);
  color: #7367F0;
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-purple-light.bs-popover-top > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-purple-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-purple-light.bs-popover-end > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-purple-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-purple-light.bs-popover-start > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-purple-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--purple-rgb), 0.1);
}
.popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-purple-light.bs-popover-bottom > .popover-arrow::after, .popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-purple-light.bs-popover-bottom > .popover-arrow::before, .popover-purple-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-purple-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--purple-rgb), 0.1);
}

.popover-teal-light.popover {
  border: 1px solid rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.popover .popover-header {
  background-color: rgba(var(--teal-rgb), 0.1);
  border-block-end: 1px solid rgba(var(--teal-rgb), 0.1);
  color: #02a8b5;
  border-radius: 0;
}
.popover-teal-light.popover .popover-body {
  background-color: rgba(var(--teal-rgb), 0.1);
  color: #02a8b5;
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, .popover-teal-light.bs-popover-top > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=top] > .popover-arrow::before, .popover-teal-light.bs-popover-top > .popover-arrow::before {
  border-top-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::after, .popover-teal-light.bs-popover-end > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=right] > .popover-arrow::before, .popover-teal-light.bs-popover-end > .popover-arrow::before {
  border-right-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::after, .popover-teal-light.bs-popover-start > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=left] > .popover-arrow::before, .popover-teal-light.bs-popover-start > .popover-arrow::before {
  border-left-color: rgba(var(--teal-rgb), 0.1);
}
.popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::after, .popover-teal-light.bs-popover-bottom > .popover-arrow::after, .popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] > .popover-arrow::before, .popover-teal-light.bs-popover-bottom > .popover-arrow::before, .popover-teal-light.bs-popover-auto[data-popper-placement^=bottom] .popover-header::before, .popover-teal-light.bs-popover-bottom .popover-header::before {
  border-bottom-color: rgba(var(--teal-rgb), 0.1);
}

.timeline {
  position: relative;
  list-style: none;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0 20px;
}
.timeline:before {
  content: " ";
  position: absolute;
  width: 3px;
  margin-left: -1.5px;
  background-color: #e8ebed;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
}
.timeline > li {
  position: relative;
  margin-bottom: 20px;
}
.timeline > li::before, .timeline > li::after {
  content: " ";
  display: table;
}
.timeline > li > .timeline-panel {
  float: left;
  position: relative;
  width: 46%;
  padding: 20px;
  border: 1px solid #adb5bd;
  border-radius: 0.25rem;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
}
.timeline > li > .timeline-panel::before {
  content: " ";
  display: inline-block;
  position: absolute;
  border-top: 8px solid transparent;
  border-right: 0 solid #adb5bd;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #adb5bd;
  position: absolute;
  top: 26px;
  right: -8px;
}
.timeline > li > .timeline-panel::after {
  content: " ";
  display: inline-block;
  position: absolute;
  top: 27px;
  right: -7px;
  border-top: 7px solid transparent;
  border-right: 0 solid #ffffff;
  border-bottom: 7px solid transparent;
  border-left: 7px solid #ffffff;
}

.timeline > li:after {
  clear: both;
}

.timeline > li > .timeline-badge {
  z-index: 1;
  width: 50px;
  height: 50px;
  margin-left: -25px;
  text-align: center;
  font-size: 1.4em;
  line-height: 50px;
  color: #ffffff;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  top: 16px;
  left: 50%;
}

.timeline > li.timeline-inverted > .timeline-panel {
  float: right;
}
.timeline > li.timeline-inverted > .timeline-panel::before {
  right: auto;
  left: -8px;
  border-right-width: 8px;
  border-left-width: 0;
}
.timeline > li.timeline-inverted > .timeline-panel::after {
  right: auto;
  left: -7px;
  border-right-width: 7px;
  border-left-width: 0;
}

.timeline-badge.primary {
  background-color: #FF9F43;
}

.timeline-badge.success {
  background-color: #28C76F;
}

.timeline-badge.warning {
  background-color: #FF9900;
}

.timeline-badge.danger {
  background-color: #FF0000;
}

.timeline-badge.info {
  background-color: #17a2b8;
}

.timeline-title {
  margin-top: 0;
  color: inherit;
  font-weight: regular;
}

.timeline-body > p,
.timeline-body > ul {
  margin-bottom: 0;
}

.timeline-body > p + p {
  margin-top: 5px;
}

.form-control {
  border-color: #e9edf6;
  color: #5B6670;
  background-color: #ffffff;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.6;
  border-radius: 0.35rem;
  padding: 0.5rem 0.85rem;
}
.form-control:focus {
  box-shadow: none;
  border-color: #e9edf6;
  background-color: #ffffff;
  box-shadow: 0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.05);
  color: #5B6670;
}

.form-control[type=file] {
  padding: 0.3rem 0.5rem;
}
.form-control[type=file].form-control-sm {
  padding: 0.25rem 0.5rem !important;
}
.form-control[type=file].form-control-lg {
  padding: 0.5rem 1rem !important;
}

.form-label {
  font-size: 14px;
  font-weight: 600;
  color: #5B6670;
  margin-bottom: 8px;
}

.form-text {
  color: #9595b5;
}

.form-control-light {
  background-color: #f8f9fa;
  border: 0;
}
.form-control-light:focus {
  background-color: #f8f9fa;
}

.form-control-primary {
  background-color: rgba(255, 159, 67, 0.1);
  border: 0;
  color: #FF9F43;
}
.form-control-primary:focus {
  background-color: rgba(255, 159, 67, 0.1);
  color: #FF9F43;
}

.form-input-color {
  height: 2.25rem;
  width: 2.25rem;
  border-radius: 4px;
  overflow: hidden;
  padding: 0;
}

.form-floating > .form-control-plaintext ~ label,
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  color: #9595b5;
}

.form-floating > .form-control:not(:placeholder-shown) ~ label::after {
  background-color: transparent;
}

.form-select {
  background-color: #ffffff;
  border: 1px solid #e9edf6;
  color: #5B6670;
  font-size: 14px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 1.25rem;
  line-height: 2;
}
.form-select option {
  background-color: #ffffff;
  padding: 0.35rem 0.75rem;
  border-radius: 0.25rem;
  margin-block-end: 0.25rem;
}
.form-select option:last-child {
  margin-block-end: 0;
}
.form-select option:checked {
  background-color: rgba(var(#FF9F43), 0.2);
  color: #FF9F43;
}
.form-select option:select {
  background-color: rgba(var(#FF9F43), 0.2);
  color: #FF9F43;
}
.form-select option:hover {
  background-color: rgba(var(#FF9F43), 0.2);
  color: #FF9F43;
}
.form-select option:focus {
  background-color: rgba(var(#FF9F43), 0.2);
  color: #FF9F43;
}

.form-check-input {
  width: 0.9rem;
  height: 0.9rem;
  background-color: #ffffff;
  border: 1px solid #e9edf6;
}
.form-check-input:checked {
  background-color: #FF9F43;
  border-color: #FF9F43;
}
.form-check-input.form-checked-outline:checked {
  background-color: transparent;
  border-color: #FF9F43;
}
.form-check-input.form-checked-secondary:checked {
  background-color: #092C4C;
  border-color: #092C4C;
}
.form-check-input.form-checked-warning:checked {
  background-color: #FF9900;
  border-color: #FF9900;
}
.form-check-input.form-checked-info:checked {
  background-color: #17a2b8;
  border-color: #17a2b8;
}
.form-check-input.form-checked-success:checked {
  background-color: #28C76F;
  border-color: #28C76F;
}
.form-check-input.form-checked-danger:checked {
  background-color: #FF0000;
  border-color: #FF0000;
}
.form-check-input.form-checked-light:checked {
  background-color: #f8f9fa;
  border-color: #f8f9fa;
}
.form-check-input.form-checked-dark:checked {
  background-color: #29344a;
  border-color: #29344a;
}
.form-check-input:focus {
  box-shadow: none;
}

.form-checked-outline:checked[type=checkbox] {
  background-image: none;
  position: relative;
  background-color: transparent;
}
.form-checked-outline:checked[type=checkbox]:before {
  content: "\\f633";
  font-family: bootstrap-icons !important;
  position: absolute;
  color: #FF9F43;
  width: 0.625rem;
  height: 0.625rem;
  inset-block-start: -1px;
  inset-inline-start: 0px;
  font-size: 0.688rem;
}
.form-checked-outline:checked[type=checkbox].form-checked-secondary:before {
  color: #092C4C;
}
.form-checked-outline:checked[type=checkbox].form-checked-warning:before {
  color: #FF9900;
}
.form-checked-outline:checked[type=checkbox].form-checked-info:before {
  color: #17a2b8;
}
.form-checked-outline:checked[type=checkbox].form-checked-success:before {
  color: #28C76F;
}
.form-checked-outline:checked[type=checkbox].form-checked-danger:before {
  color: #FF0000;
}
.form-checked-outline:checked[type=checkbox].form-checked-light:before {
  color: #f8f9fa;
}
.form-checked-outline:checked[type=checkbox].form-checked-dark:before {
  color: #29344a;
}

.form-checked-outline:checked[type=radio] {
  background-image: none;
  position: relative;
  background-color: transparent;
}
.form-checked-outline:checked[type=radio]:before {
  content: "\\f309";
  font-family: bootstrap-icons !important;
  position: absolute;
  color: #FF9F43;
  width: 0.625rem;
  height: 0.625rem;
  inset-block-start: -1.13rem;
  inset-inline-start: -0.6rem;
  font-size: 2rem;
}
.form-checked-outline:checked[type=radio].form-checked-secondary:before {
  color: #092C4C;
}
.form-checked-outline:checked[type=radio].form-checked-warning:before {
  color: #FF9900;
}
.form-checked-outline:checked[type=radio].form-checked-info:before {
  color: #17a2b8;
}
.form-checked-outline:checked[type=radio].form-checked-success:before {
  color: #28C76F;
}
.form-checked-outline:checked[type=radio].form-checked-danger:before {
  color: #FF0000;
}
.form-checked-outline:checked[type=radio].form-checked-light:before {
  color: #f8f9fa;
}
.form-checked-outline:checked[type=radio].form-checked-dark:before {
  color: #29344a;
}

fieldset:disabled .btn {
  color: #ffffff;
  background-color: #FF9F43;
  border-color: #FF9F43;
}

.form-select:focus {
  border-color: rgba(var(#FF9F43), 0.5);
  outline: 0;
  box-shadow: none;
}

.btn-check:focus + .btn,
.btn:focus {
  background-color: none;
  border-color: none;
  outline: 0;
}

.btn-check:active + .btn:focus,
.btn-check:checked + .btn:focus,
.btn.active:focus,
.btn.show:focus,
.btn:active:focus {
  box-shadow: none;
}

.form-control:disabled,
.form-select:disabled {
  background-color: #f8f9fa;
  color: #5B6670;
}

.form-control-plaintext {
  color: #5B6670;
}

.form-control::-webkit-file-upload-button {
  color: #5B6670;
  background-color: #f7f8f9;
}

.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {
  background-color: #f7f8f9;
}

.form-control:focus::-webkit-input-placeholder, .form-control:focus::placeholder {
  padding-inline-start: 0.3rem;
  -webkit-transition: padding-inline-start 0.1s ease-in;
  transition: padding-inline-start 0.1s ease-in;
}
.form-control::-webkit-input-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.7;
  color: #5B6670;
  padding-inline-start: 0px;
  -webkit-transition: padding-inline-start 0.1s ease-in;
  transition: padding-inline-start 0.1s ease-in;
}
.form-control:-moz-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #5B6670;
}
.form-control::-moz-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #5B6670;
}
.form-control:-ms-input-placeholder {
  font-size: 0.8rem;
  font-weight: 500;
  opacity: 0.4;
  color: #5B6670;
}

.form-control-sm {
  font-size: 0.8rem;
  padding: 0.25rem 0.8rem;
}

.form-control-lg {
  font-size: 1rem;
  padding: 0.5rem 1rem;
}

.form-check-md .form-check-input {
  width: 1.15rem;
  height: 1.15rem;
}
.form-check-md.form-switch .form-check-input {
  width: 2.25rem;
}
.form-check-md label {
  margin-inline-start: 0.5rem;
  font-size: 0.95rem;
  margin-block-start: 3px;
}

.form-check-lg .form-check-input {
  width: 1.35rem;
  height: 1.35rem;
}
.form-check-lg.form-switch .form-check-input {
  width: 2.5rem;
}
.form-check-lg label {
  margin-inline-start: 0.5rem;
  font-size: 1rem;
  margin-block-start: 3px;
}

.toggle {
  width: 3.75rem;
  height: 1.563rem;
  background-color: #f8f9fa;
  margin-inline-start: 0.625rem;
  margin-block-end: 0.313rem;
  padding: 0.125rem;
  border-radius: 0.188rem;
  position: relative;
  overflow: hidden;
  transition: all 0.2s ease;
}
.toggle span {
  position: absolute;
  inset-block-start: 0.188rem;
  inset-block-end: 0.25rem;
  inset-inline-start: 0.188rem;
  display: block;
  width: 1.25rem;
  border-radius: 0.125rem;
  background-color: #ffffff;
  box-shadow: 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.45);
  cursor: pointer;
  transition: all 0.2s ease;
}
.toggle span::before {
  content: "on";
  inset-inline-start: -1.563rem;
}
.toggle span::after {
  content: "off";
  inset-inline-end: -1.813rem;
  color: #9595b5;
}
.toggle span::before, .toggle span::after {
  position: absolute;
  font-size: 0.625rem;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  inset-block-start: 0.188rem;
  line-height: 1.38;
  transition: all 0.2s ease;
}
.toggle.on {
  background-color: rgba(var(#FF9F43), 0.3);
}
.toggle.on span {
  background-color: #FF9F43;
}
.toggle.on span::before {
  color: #FF9F43;
}
.toggle.on.toggle-secondary {
  background-color: rgba(9, 44, 76, 0.4);
}
.toggle.on.toggle-secondary span {
  background-color: #092C4C;
}
.toggle.on.toggle-secondary span::before {
  color: #092C4C;
}
.toggle.on.toggle-warning {
  background-color: rgba(255, 153, 0, 0.4);
}
.toggle.on.toggle-warning span {
  background-color: #FF9900;
}
.toggle.on.toggle-warning span::before {
  color: #FF9900;
}
.toggle.on.toggle-info {
  background-color: rgba(23, 162, 184, 0.4);
}
.toggle.on.toggle-info span {
  background-color: #17a2b8;
}
.toggle.on.toggle-info span::before {
  color: #17a2b8;
}
.toggle.on.toggle-success {
  background-color: rgba(40, 199, 111, 0.4);
}
.toggle.on.toggle-success span {
  background-color: #28C76F;
}
.toggle.on.toggle-success span::before {
  color: #28C76F;
}
.toggle.on.toggle-danger {
  background-color: rgba(255, 0, 0, 0.4);
}
.toggle.on.toggle-danger span {
  background-color: #FF0000;
}
.toggle.on.toggle-danger span::before {
  color: #FF0000;
}
.toggle.on.toggle-light {
  background-color: rgba(248, 249, 250, 0.4);
}
.toggle.on.toggle-light span {
  background-color: #f8f9fa;
}
.toggle.on.toggle-light span::before, .toggle.on.toggle-light span::after {
  color: #9595b5;
}
.toggle.on.toggle-dark {
  background-color: rgba(41, 52, 74, 0.4);
}
.toggle.on.toggle-dark span {
  background-color: #29344a;
}
.toggle.on.toggle-dark span::before {
  color: #ffffff;
}
.toggle.on span {
  inset-inline-start: 2.313rem;
}
.toggle.on.toggle-sm span {
  inset-inline-start: 2.313rem;
}
.toggle.on.toggle-sm span::before {
  inset-block-start: -1px;
  inset-inline-start: -1.563rem;
}
.toggle.on.toggle-lg span {
  inset-inline-start: 2.563rem;
}
.toggle.on.toggle-lg span::before {
  inset-block-start: 0.5rem;
  inset-inline-start: -1.75rem;
}
.toggle.toggle-sm {
  height: 1.063rem;
  width: 3.125rem;
}
.toggle.toggle-sm span {
  width: 0.625rem;
  height: 0.625rem;
}
.toggle.toggle-sm span::after {
  inset-inline-end: -1.875rem;
  inset-block-start: -1px;
}
.toggle.toggle-lg {
  height: 2.125rem;
  width: 4.5rem;
}
.toggle.toggle-lg span {
  width: 1.75rem;
}
.toggle.toggle-lg span::after {
  inset-block-start: 0.5rem;
  inset-inline-end: -1.938rem;
}

.custom-toggle-switch > input[type=checkbox] {
  display: none;
}

.custom-toggle-switch > label {
  cursor: pointer;
  height: 0;
  position: relative;
  width: 2.5rem;
}

.label-primary {
  background: #FF9F43;
  color: #ffffff;
}

.label-secondary {
  background: #092C4C;
  color: #ffffff;
}

.label-warning {
  background: #FF9900;
  color: #ffffff;
}

.label-info {
  background: #17a2b8;
  color: #ffffff;
}

.label-success {
  background: #28C76F;
  color: #ffffff;
}

.label-danger {
  background: #FF0000;
  color: #ffffff;
}

.label-light {
  background: #f8f9fa;
  color: #ffffff;
}

.label-dark {
  background: #29344a;
  color: #ffffff;
}

.custom-toggle-switch > input[type=checkbox]:checked + label::before {
  background: inherit;
  opacity: 0.5;
}

.custom-toggle-switch > label::before {
  background: #9595b5;
  box-shadow: inset 0px 0px 0.625rem rgba(255, 255, 255, 0.5);
  border-radius: 0.5rem;
  content: "";
  height: 1rem;
  margin-block-start: -0.5rem;
  position: absolute;
  opacity: 0.3;
  transition: all 0.4s ease-in-out;
  width: 2.5rem;
}
.custom-toggle-switch > label::after {
  background: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 0 0.313rem rgba(228, 229, 237, 0.8);
  content: "";
  height: 1.5rem;
  inset-inline-start: -0.25rem;
  margin-block-start: -0.5rem;
  position: absolute;
  inset-block-start: -0.25rem;
  transition: all 0.3s ease-in-out;
  width: 1.5rem;
}

.custom-toggle-switch > input[type=checkbox]:checked + label::after {
  background: inherit;
  inset-inline-start: 50%;
}

.custom-toggle-switch.toggle-sm > label::before {
  height: 10px;
  width: 27px;
  border-radius: 10px;
}

.custom-toggle-switch.toggle-sm input[type=checkbox]:checked + label::after {
  inset-inline-start: 13px;
}

.custom-toggle-switch.toggle-sm > label::after {
  height: 17px;
  width: 17px;
  border-radius: 50%;
}

.custom-toggle-switch.toggle-lg > label::before {
  height: 27px;
  width: 55px;
  border-radius: 20px;
}

.custom-toggle-switch.toggle-lg input[type=checkbox]:checked + label::after {
  inset-inline-start: 77%;
}

.custom-toggle-switch.toggle-lg > label::after {
  height: 35px;
  width: 35px;
  margin-block-start: -8px;
  border-radius: 50%;
}

.form-floating > .form-control-plaintext::placeholder,
.form-floating > .form-control::placeholder {
  color: transparent !important;
}

.form-floating > .form-control,
.form-floating > .form-control-plaintext,
.form-floating > .form-select {
  height: calc(3.5rem - 4px);
}

.form-floating.floating-primary label {
  color: #FF9F43;
  opacity: 1;
}
.form-floating.floating-primary input {
  border: 1px solid #FF9F43;
}
.form-floating.floating-primary > .form-control:focus ~ label {
  color: #FF9F43 !important;
}
.form-floating.floating-secondary label {
  color: #092C4C;
  opacity: 1;
}
.form-floating.floating-secondary input {
  border: 1px solid #092C4C;
}
.form-floating.floating-secondary > .form-control:focus ~ label {
  color: #092C4C !important;
}
.form-floating.floating-warning label {
  color: #FF9900;
  opacity: 1;
}
.form-floating.floating-warning input {
  border: 1px solid #FF9900;
}
.form-floating.floating-warning > .form-control:focus ~ label {
  color: #FF9900 !important;
}
.form-floating.floating-info label {
  color: #17a2b8;
  opacity: 1;
}
.form-floating.floating-info input {
  border: 1px solid #17a2b8;
}
.form-floating.floating-info > .form-control:focus ~ label {
  color: #17a2b8 !important;
}
.form-floating.floating-success label {
  color: #28C76F;
  opacity: 1;
}
.form-floating.floating-success input {
  border: 1px solid #28C76F;
}
.form-floating.floating-success > .form-control:focus ~ label {
  color: #28C76F !important;
}
.form-floating.floating-danger label {
  color: #FF0000;
  opacity: 1;
}
.form-floating.floating-danger input {
  border: 1px solid #FF0000;
}
.form-floating.floating-danger > .form-control:focus ~ label {
  color: #FF0000 !important;
}

.form-floating > .form-control-plaintext ~ label::after,
.form-floating > .form-control:focus ~ label::after,
.form-floating > .form-control:not(:placeholder-shown) ~ label::after,
.form-floating > .form-select ~ label::after {
  background-color: #ffffff;
  border-radius: 4px;
}

.form-wizard-1 {
  border-bottom: 0;
  border-radius: 50px;
}
.form-wizard-1 .nav-link {
  border: 0;
}
.form-wizard-1.nav-tabs .nav-item {
  margin-inline-end: 1rem;
  position: relative;
}
.form-wizard-1.nav-tabs .nav-link {
  padding: 0.25rem 0.4rem;
  color: #9595b5;
  display: flex;
  align-items: center;
  border-radius: 50px;
  border: 2px solid transparent;
}
.form-wizard-1.nav-tabs .nav-link i {
  font-size: 12px;
  padding: 4px;
  line-height: 1;
  border-radius: 50px;
  border: 2px solid #dbe0e6;
}
.form-wizard-1.nav-tabs .nav-link:focus, .form-wizard-1.nav-tabs .nav-link:hover {
  border: 2px solid transparent;
}
.form-wizard-1.nav-tabs .nav-link.active {
  border: 2px solid #FF9F43;
  border-radius: 50px;
  color: #FF9F43;
  background-color: transparent;
}
.form-wizard-1.nav-tabs .nav-link.active i {
  border: 2px solid #FF9F43;
}
.form-wizard-1 .nav-item:focus-visible {
  outline: none;
}

.form-control.is-valid:focus,
.was-validated .form-control:valid:focus {
  border-color: #28C76F;
  box-shadow: none;
}

.form-control.is-valid,
.was-validated .form-control:valid {
  border-color: #28C76F;
}

.form-control-color {
  width: 1.75rem;
  height: 1.75rem;
  overflow: hidden;
  padding: 0;
}

.example-picker .pcr-button {
  border-radius: 0.35rem !important;
  overflow: hidden;
}

[dir=rtl] [type=email],
[dir=rtl] [type=number],
[dir=rtl] [type=tel],
[dir=rtl] [type=url] {
  direction: rtl;
}

.form-select.is-invalid:not([multiple]):not([size]) {
  padding-right: 1.125rem;
  background-size: 16px 28px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.invoice-quantity-container .input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: 0;
}

input[type=range]::-webkit-slider-runnable-track {
  background-color: #f8f9fa;
}

[dir=rtl] .form-checked-outline:checked[type=checkbox]:before {
  inset-inline-start: 1px;
}

.form-check {
  min-height: inherit !important;
}

.col-form-label-lg,
.col-form-label-sm,
.col-form-label {
  font-weight: 600;
}

#exampleColorInput::-webkit-color-swatch-wrapper {
  direction: rtl;
}

[data-theme-mode=dark] input[type=week]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=month]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=date]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=datetime-local]::-webkit-calendar-picker-indicator, [data-theme-mode=dark] input[type=time]::-webkit-calendar-picker-indicator {
  filter: invert(1);
}

[dir=rtl] input[type=week], [dir=rtl] input[type=month], [dir=rtl] input[type=date], [dir=rtl] input[type=datetime-local], [dir=rtl] input[type=time] {
  text-align: end;
}

caption {
  color: #9595b5;
}

.table-active {
  --bs-table-color-state: var(--default-text-color);
}

.table {
  color: #5B6670;
  border-color: #dbe0e6;
  margin-block-end: 0;
}
.table .checkboxs {
  margin-bottom: 15px;
}
.table tbody tr th {
  font-weight: 500;
}
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  line-height: 1.462;
  font-size: 0.813rem;
  white-space: nowrap;
}
.table thead tr th {
  font-weight: 600;
  font-size: 15px;
}
.table.table-sm > :not(caption) > * > * {
  padding: 0.3rem;
}
.table.table-dark {
  color: rgba(0, 0, 0, 0.7);
  border-color: rgba(255, 255, 255, 0.1);
}
.table .thead-primary th {
  background-color: #FF9F43;
  color: #ffffff;
}
.table .thead-secondary th {
  background-color: #092C4C;
  color: #ffffff;
}
.table .thead-info th {
  background-color: #17a2b8;
  color: #ffffff;
}
.table .thead-warning th {
  background-color: #FF9900;
  color: #ffffff;
}
.table .thead-danger th {
  background-color: #FF0000;
  color: #ffffff;
}
.table .thead-success th {
  background-color: #28C76F;
  color: #ffffff;
}
.table .thead-dark th {
  background-color: #29344a;
  color: #ffffff;
}
.table .thead-light th {
  background-color: #f8f9fa;
  color: #29344a;
}
.table.table-primary {
  background-color: #ffffff;
  color: #000000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.2);
}
.table.table-primary.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--primary-rgb), 0.2);
  color: #000000;
}
.table.table-primary.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--primary-rgb), 0.4);
  color: #ffffff;
}
.table.table-primary .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--primary-rgb));
  color: #ffffff;
}
.table.table-secondary {
  background-color: #ffffff;
  color: #000000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.2);
}
.table.table-secondary.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--secondary-rgb), 0.2);
  color: #000000;
}
.table.table-secondary.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--secondary-rgb), 0.4);
  color: #ffffff;
}
.table.table-secondary .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--secondary-rgb));
  color: #ffffff;
}
.table.table-warning {
  background-color: #ffffff;
  color: #000000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.2);
}
.table.table-warning.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--warning-rgb), 0.2);
  color: #000000;
}
.table.table-warning.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--warning-rgb), 0.4);
  color: #ffffff;
}
.table.table-warning .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--warning-rgb));
  color: #ffffff;
}
.table.table-success {
  background-color: #ffffff;
  color: #000000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--success-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.2);
}
.table.table-success.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--success-rgb), 0.2);
  color: #000000;
}
.table.table-success.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--success-rgb), 0.4);
  color: #ffffff;
}
.table.table-success .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--success-rgb));
  color: #ffffff;
}
.table.table-danger {
  background-color: #ffffff;
  color: #000000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.2);
}
.table.table-danger.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--danger-rgb), 0.2);
  color: #000000;
}
.table.table-danger.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--danger-rgb), 0.4);
  color: #ffffff;
}
.table.table-danger .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--danger-rgb));
  color: #ffffff;
}
.table.table-info {
  background-color: #ffffff;
  color: #000000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--info-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.2);
}
.table.table-info.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--info-rgb), 0.2);
  color: #000000;
}
.table.table-info.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--info-rgb), 0.4);
  color: #ffffff;
}
.table.table-info .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--info-rgb));
  color: #ffffff;
}
.table.table-light {
  background-color: #ffffff;
  color: #000000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--light-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.2);
}
.table.table-light.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--light-rgb), 0.2);
  color: #000000;
}
.table.table-light.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--light-rgb), 0.4);
  color: #ffffff;
}
.table.table-light .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--light-rgb));
  color: #ffffff;
}
.table.table-dark {
  background-color: #ffffff;
  color: #000000;
  --bs-table-color-state: \$black;
  border-color: var(--bs-table-border-color);
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.05);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.2);
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.2);
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.2);
}
.table.table-dark.table-striped > tbody > tr:nth-of-type(odd) > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--dark-rgb), 0.2);
  color: #000000;
}
.table.table-dark.table.table-hover > tbody > tr:hover > * {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgba(var(--dark-rgb), 0.4);
  color: #ffffff;
}
.table.table-dark .table-active {
  background-color: var(--bs-table-accent-bg);
  --bs-table-accent-bg: rgb(var(--dark-rgb));
  color: #ffffff;
}
.table.table-bordered.border-primary tbody,
.table.table-bordered.border-primary td,
.table.table-bordered.border-primary tfoot,
.table.table-bordered.border-primary th,
.table.table-bordered.border-primary thead,
.table.table-bordered.border-primary tr {
  border-color: rgba(255, 159, 67, 0.1);
}
.table.table-bordered.border-info tbody,
.table.table-bordered.border-info td,
.table.table-bordered.border-info tfoot,
.table.table-bordered.border-info th,
.table.table-bordered.border-info thead,
.table.table-bordered.border-info tr {
  border-color: rgba(23, 162, 184, 0.1);
}
.table.table-bordered.border-secondary tbody,
.table.table-bordered.border-secondary td,
.table.table-bordered.border-secondary tfoot,
.table.table-bordered.border-secondary th,
.table.table-bordered.border-secondary thead,
.table.table-bordered.border-secondary tr {
  border-color: rgba(9, 44, 76, 0.1);
}
.table.table-bordered.border-warning tbody,
.table.table-bordered.border-warning td,
.table.table-bordered.border-warning tfoot,
.table.table-bordered.border-warning th,
.table.table-bordered.border-warning thead,
.table.table-bordered.border-warning tr {
  border-color: rgba(255, 153, 0, 0.1);
}
.table.table-bordered.border-success tbody,
.table.table-bordered.border-success td,
.table.table-bordered.border-success tfoot,
.table.table-bordered.border-success th,
.table.table-bordered.border-success thead,
.table.table-bordered.border-success tr {
  border-color: rgba(40, 199, 111, 0.1);
}
.table.table-bordered.border-danger tbody,
.table.table-bordered.border-danger td,
.table.table-bordered.border-danger tfoot,
.table.table-bordered.border-danger th,
.table.table-bordered.border-danger thead,
.table.table-bordered.border-danger tr {
  border-color: rgba(255, 0, 0, 0.1);
}
.table.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: rgba(var(--dark-rgb),0.0125);
  color: #5B6670;
}
.table.table-striped-columns > :not(caption) > tr > :nth-child(2n) {
  --bs-table-accent-bg: rgba(var(--dark-rgb),0.025);
  color: #5B6670;
}
.table tbody.table-group-divider {
  border-top: 1px solid #dbe0e6;
}
.table.table-hover > tbody > tr:hover > * {
  --bs-table-accent-bg: #f7f8f9;
  color: #5B6670;
}
.table .table-active {
  --bs-table-accent-bg: #f8f9fa;
  color: #5B6670;
}
.table thead.table-primary {
  background-color: #ffffff;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000000;
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.5);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-secondary {
  background-color: #ffffff;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000000;
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.5);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-warning {
  background-color: #ffffff;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000000;
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.5);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-success {
  background-color: #ffffff;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000000;
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.5);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--success-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-danger {
  background-color: #ffffff;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000000;
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.5);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-info {
  background-color: #ffffff;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000000;
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.5);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--info-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-light {
  background-color: #ffffff;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000000;
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.5);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--light-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}
.table thead.table-dark {
  background-color: #ffffff;
  color: var(--bs-table-color);
  --bs-table-color-state: #000;
  --bs-table-color: #000000;
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.5);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.5);
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.5);
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color);
}

.table-primary {
  --bs-table-color: #000000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--primary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--primary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgba(var(--primary-rgb), 0.3);
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: rgba(var(--primary-rgb), 0.1);
  background-color: #ffffff;
}

.table-secondary {
  --bs-table-color: #000000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--secondary-rgb), 0.1);
  --bs-table-border-color: rgba(var(--secondary-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgba(var(--secondary-rgb), 0.3);
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: rgba(var(--secondary-rgb), 0.1);
  background-color: #ffffff;
}

.table-warning {
  --bs-table-color: #000000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--warning-rgb), 0.1);
  --bs-table-border-color: rgba(var(--warning-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgba(var(--warning-rgb), 0.3);
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: rgba(var(--warning-rgb), 0.1);
  background-color: #ffffff;
}

.table-success {
  --bs-table-color: #000000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--success-rgb), 0.1);
  --bs-table-border-color: rgba(var(--success-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgba(var(--success-rgb), 0.3);
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: rgba(var(--success-rgb), 0.1);
  background-color: #ffffff;
}

.table-info {
  --bs-table-color: #000000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--info-rgb), 0.1);
  --bs-table-border-color: rgba(var(--info-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgba(var(--info-rgb), 0.3);
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: rgba(var(--info-rgb), 0.1);
  background-color: #ffffff;
}

.table-danger {
  --bs-table-color: #000000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--danger-rgb), 0.1);
  --bs-table-border-color: rgba(var(--danger-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgba(var(--danger-rgb), 0.3);
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: rgba(var(--danger-rgb), 0.1);
  background-color: #ffffff;
}

.table-dark {
  --bs-table-color: #000000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--dark-rgb), 0.1);
  --bs-table-border-color: rgba(var(--dark-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgba(var(--dark-rgb), 0.3);
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: rgba(var(--dark-rgb), 0.1);
  background-color: #ffffff;
}

.table-light {
  --bs-table-color: #000000;
  --bs-table-color-state: \$black;
  --bs-table-bg: rgba(var(--light-rgb), 0.1);
  --bs-table-border-color: rgba(var(--light-rgb), 0.1);
  --bs-table-striped-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-striped-color: #000000;
  --bs-table-active-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-active-color: #000000;
  --bs-table-hover-bg: rgba(var(--light-rgb), 0.3);
  --bs-table-hover-color: #000000;
  color: #000000;
  border-color: rgba(var(--light-rgb), 0.1);
  background-color: #ffffff;
}

[data-theme-mode=dark] .table-dark {
  border-color: rgba(0, 0, 0, 0.025);
}

[dir=rtl] .table {
  margin-inline-end: 1px;
}

.table {
  margin: 0;
}
.table tbody tr td {
  color: #495057;
  font-size: 14px;
}
.table tbody tr td .product-img img {
  border: 0;
}
.table tbody tr td .userslist-img {
  width: 35px;
  height: 35px;
  margin-right: 8px;
}
.table tbody tr td .userslist-img img {
  border-radius: 0;
}
.table tbody tr td .userslist-img.bg-img img {
  border: 1px solid var(--stroke-table, #E8EBED);
  background: lightgray 50%/cover no-repeat;
}
.table tbody tr td a {
  color: #092C4C;
  font-size: 14px;
  font-weight: 400;
  line-height: normal;
}
.table tbody tr td a.product-img {
  margin-right: 5px;
  flex-shrink: 0;
}
.table tbody tr td a .info-img {
  margin-right: 8px;
  width: 16px;
  height: 16px;
}
.table tbody tr td a:hover {
  color: #FF9F43;
}
.table tbody tr td a:hover i {
  color: #FF9F43;
}
.table tbody tr td .emp-name {
  line-height: 1;
}
.table tbody tr td .emp-name a {
  color: #092C4C;
}
.table tbody tr td .emp-name p {
  line-height: 2;
  font-size: 15px;
  font-weight: 500;
  color: #5B6670;
}
.table tbody tr td .emp-name .role {
  line-height: unset;
}
.table tbody tr td .product-imgs {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 40px;
  height: 40px;
  background: #FFEBD8;
  font-size: 14px;
  color: #FF9F43 !important;
  font-weight: 500;
  margin-right: 10px;
}
.table tbody tr .data-header {
  font-weight: 600;
  color: #092C4C;
  font-size: 15px;
  border-bottom: none;
}
.table tbody tr .ref-number {
  color: #7367F0;
}
.table tbody tr.active {
  border-bottom: 0;
}
.table tbody tr.active td {
  font-size: 18px;
  color: #495057;
  font-weight: 600;
  border-bottom: 0;
}
.table tbody .loss-highlight td {
  font-weight: 700;
  color: #092C4C;
  font-size: 14px;
  border-top: 1px solid #e8ebed;
}
.table tbody .userimgname {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.table tbody .userimgname img {
  margin-right: 8px;
  border-radius: 6px;
}
.table tbody .purchase-count td {
  padding-bottom: 20px;
}
.table .Expense-list tr td {
  padding: 15px 17px;
}
.table .Expense-list tr td a {
  margin-bottom: 0;
}
.table .sales-list tr td {
  padding: 20px 17px;
}
.table .Expense-list-blk tr td {
  padding: 20px 17px;
}

.new tbody tr td {
  border-bottom: none;
}

.table-height {
  min-height: 300px;
}
@media (max-width: 991.98px) {
  .table-height {
    min-height: auto;
    margin-bottom: 15px;
  }
}

.max-widthauto {
  max-width: 100% !important;
}

.dataTables_filter + .dataTables_filter {
  display: none;
}

.dataview .dataTables_length,
.dataview .dataTables_info,
.dataview .dataTables_paginate {
  display: none !important;
}

.dataTables_length label:before {
  content: "Showing 10 of 40 Results";
  margin-right: 5px;
}

.dataTables_length {
  float: left;
  font-size: 12px;
}

.productimgname {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.productimgname a {
  color: #092C4C;
  font-weight: 500;
}
.productimgname .view-product {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 50px;
  height: 50px;
  border-radius: 6px;
  background: #F8F8F8;
}

.input-blocks .calc-no {
  width: 50px !important;
  text-align: center;
}

.table .input-blocks input[type=text] {
  height: 40px;
}
.table .scanner-set {
  width: 40px;
  height: 40px;
}

.card.table-list-card .card-body {
  padding: 0;
}
.card.table-list-card .table-top {
  padding: 24px 24px 0;
}
.card.table-list-card .table-responsive {
  padding: 24px;
  border-top: 1px solid #dbe0e6;
}
.card.table-list-card .table-responsive .dataTables_wrapper {
  border: 0;
  padding: 0;
}
.card.table-list-card .tabs-set .nav-tabs {
  padding: 24px 24px 0;
  margin-bottom: 0;
}

.table.profit-table thead {
  background-color: #FAFBFE;
  border-radius: 8px 8px 0px 0px;
}
.table.profit-table thead tr:hover {
  background-color: #FAFBFE;
}
.table.profit-table tbody td {
  border-bottom: 0;
}
.table.profit-table tbody .profit-table-bg td {
  color: #092C4C;
  font-weight: 700;
  border-top: 1px solid #f3f6f9;
  background-color: #FAFBFE;
}
.table.profit-table tbody .table-heading:hover {
  background-color: #ffffff;
}
.table.profit-table tbody .table-heading td {
  color: #092C4C;
  font-weight: 700;
}

.profit-table-top .daterange-wraper {
  margin: 0 10px;
}
.profit-table-top .daterange-wraper input {
  padding-left: 35px;
}

table td .shield {
  width: 14px;
  height: 14px;
}

.paysilp-table-border {
  border: 1px solid #f3f6f9;
}
.paysilp-table-border th {
  border-right: 1px solid #f3f6f9;
  border-left: 1px solid #f3f6f9;
  padding: 15px;
  font-weight: 700;
  font-size: 16px;
}

.paysilp-table-borders td {
  border-right: 1px solid #f3f6f9;
  border-left: 1px solid #f3f6f9;
  padding: 5px 15px;
  color: #5B6670;
}

.payslip-border-bottom {
  border: 1px solid #f3f6f9;
}
.payslip-border-bottom th {
  padding: 5px 15px;
  font-weight: 700;
  font-size: 16px;
}
.payslip-border-bottom td {
  color: #5B6670;
}

.emp-details {
  margin: 20px 0;
}
.emp-details .pay-slip-salery h6 {
  font-weight: 700 !important;
  margin-bottom: 10px;
  font-size: 18px !important;
}
.emp-details .emp-name-id.pay-slip-salery {
  margin-right: 30px;
}

@media (max-width: 575px) {
  .slip-logo {
    flex-shrink: 0;
    margin-right: 15px;
  }
}

.product-name-slip h4 {
  color: #FF9F43;
  font-weight: 700;
  font-size: 18px;
}

.pay-slip-box .modal-header {
  border-radius: 8px 8px 0 0;
}
.pay-slip-box .custom-modal-body {
  padding: 0;
}
.pay-slip-box .card {
  border: 0;
  border-radius: 0 0 10px 10px;
}
.pay-slip-box .card .card-body {
  padding: 20px;
}
.pay-slip-box .card .card-body .emp-details.justify-content-start {
  max-width: 760px;
  margin: 20px auto 20px;
}

.accordion-button {
  background-color: #ffffff;
  color: #5B6670;
  padding: 0.75rem 1rem;
  font-size: 0.85rem;
  font-weight: 500;
}
.accordion-button:not(.collapsed) {
  color: #5B6670;
  background-color: #f7f8f9;
  box-shadow: none;
}
.accordion-button:focus {
  border-color: rgba(255, 159, 67, 0.3);
  box-shadow: none;
}
.accordion-button:after, .accordion-button:not(.collapsed)::after {
  background-image: none;
}
.accordion-button:after {
  content: "\\f078";
  font-family: "Fontawesome";
  font-size: 12px;
  line-height: 1;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3.125rem;
  color: #5B6670;
}

.accordion-body {
  padding: 0.75rem 1rem;
  font-size: 0.8125rem;
  color: #9595b5;
}

.accordion-item {
  color: #5B6670;
  background-color: #ffffff;
  border: 1px solid #dbe0e6;
}

.accordions-items-seperate .accordion-item:not(:first-of-type) {
  margin-block-start: 0.5rem;
}
.accordions-items-seperate .accordion-item {
  border-block-start: 1px solid #dbe0e6;
  border-radius: 4px;
  overflow: hidden;
}

.accordion-item:last-of-type {
  border-bottom-right-radius: 0.35rem;
  border-bottom-left-radius: 0.35rem;
}

.accordion-item:first-of-type {
  border-top-left-radius: 0.35rem;
  border-top-right-radius: 0.35rem;
}

.accordion.accordion-primary .accordion-button {
  background-color: rgba(255, 159, 67, 0.1);
  color: #FF9F43;
}
.accordion.accordion-primary .accordion-button:after {
  background-color: #FF9F43;
  color: #ffffff;
}
.accordion.accordion-primary .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-primary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}
.accordion.accordion-secondary .accordion-button {
  background-color: rgba(9, 44, 76, 0.1);
  color: #092C4C;
}
.accordion.accordion-secondary .accordion-button:after {
  background-color: #092C4C;
  color: #ffffff;
}
.accordion.accordion-secondary .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-secondary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}
.accordion.accordion-success .accordion-button {
  background-color: rgba(40, 199, 111, 0.1);
  color: #28C76F;
}
.accordion.accordion-success .accordion-button:after {
  background-color: #28C76F;
  color: #ffffff;
}
.accordion.accordion-success .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-success .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}
.accordion.accordion-danger .accordion-button {
  background-color: rgba(255, 0, 0, 0.1);
  color: #FF0000;
}
.accordion.accordion-danger .accordion-button:after {
  background-color: #FF0000;
  color: #ffffff;
}
.accordion.accordion-danger .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-danger .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}
.accordion.accordion-warning .accordion-button {
  background-color: rgba(255, 153, 0, 0.1);
  color: #FF9900;
}
.accordion.accordion-warning .accordion-button:after {
  background-color: #FF9900;
  color: #ffffff;
}
.accordion.accordion-warning .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-warning .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}
.accordion.accordion-info .accordion-button {
  background-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
}
.accordion.accordion-info .accordion-button:after {
  background-color: #17a2b8;
  color: #ffffff;
}
.accordion.accordion-info .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-info .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}

.accordion.accordion-solid-primary .accordion-button {
  background-color: #FF9F43;
  color: #ffffff;
}
.accordion.accordion-solid-primary .accordion-button:after {
  background-color: #ffffff;
  color: #FF9F43;
}
.accordion.accordion-solid-primary .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-solid-primary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}
.accordion.accordion-solid-secondary .accordion-button {
  background-color: #092C4C;
  color: #ffffff;
}
.accordion.accordion-solid-secondary .accordion-button:after {
  background-color: #ffffff;
  color: #092C4C;
}
.accordion.accordion-solid-secondary .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-solid-secondary .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}
.accordion.accordion-solid-success .accordion-button {
  background-color: #28C76F;
  color: #ffffff;
}
.accordion.accordion-solid-success .accordion-button:after {
  background-color: #ffffff;
  color: #28C76F;
}
.accordion.accordion-solid-success .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-solid-success .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}
.accordion.accordion-solid-danger .accordion-button {
  background-color: #FF0000;
  color: #ffffff;
}
.accordion.accordion-solid-danger .accordion-button:after {
  background-color: #ffffff;
  color: #FF0000;
}
.accordion.accordion-solid-danger .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-solid-danger .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}
.accordion.accordion-solid-warning .accordion-button {
  background-color: #FF9900;
  color: #ffffff;
}
.accordion.accordion-solid-warning .accordion-button:after {
  background-color: #ffffff;
  color: #FF9900;
}
.accordion.accordion-solid-warning .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-solid-warning .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}
.accordion.accordion-solid-info .accordion-button {
  background-color: #17a2b8;
  color: #ffffff;
}
.accordion.accordion-solid-info .accordion-button:after {
  background-color: #ffffff;
  color: #17a2b8;
}
.accordion.accordion-solid-info .accordion-button.collapsed {
  background-color: #ffffff;
  color: #5B6670;
}
.accordion.accordion-solid-info .accordion-button.collapsed:after {
  background-color: #f7f8f9;
  color: #5B6670;
}

.accordion.accordion-border-primary .accordion-item {
  border: 1px solid #FF9F43;
}
.accordion.accordion-border-primary .accordion-button {
  background-color: #ffffff;
  color: #FF9F43;
  border-block-end: 0px;
}
.accordion.accordion-border-primary .accordion-button:after {
  background-color: #ffffff;
  color: #FF9F43;
  border: 1px solid #FF9F43;
}
.accordion.accordion-border-primary .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FF9F43;
}
.accordion.accordion-border-secondary .accordion-item {
  border: 1px solid #092C4C;
}
.accordion.accordion-border-secondary .accordion-button {
  background-color: #ffffff;
  color: #092C4C;
  border-block-end: 0px;
}
.accordion.accordion-border-secondary .accordion-button:after {
  background-color: #ffffff;
  color: #092C4C;
  border: 1px solid #092C4C;
}
.accordion.accordion-border-secondary .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #092C4C;
}
.accordion.accordion-border-success .accordion-item {
  border: 1px solid #28C76F;
}
.accordion.accordion-border-success .accordion-button {
  background-color: #ffffff;
  color: #28C76F;
  border-block-end: 0px;
}
.accordion.accordion-border-success .accordion-button:after {
  background-color: #ffffff;
  color: #28C76F;
  border: 1px solid #28C76F;
}
.accordion.accordion-border-success .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #28C76F;
}
.accordion.accordion-border-danger .accordion-item {
  border: 1px solid #FF0000;
}
.accordion.accordion-border-danger .accordion-button {
  background-color: #ffffff;
  color: #FF0000;
  border-block-end: 0px;
}
.accordion.accordion-border-danger .accordion-button:after {
  background-color: #ffffff;
  color: #FF0000;
  border: 1px solid #FF0000;
}
.accordion.accordion-border-danger .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FF0000;
}
.accordion.accordion-border-warning .accordion-item {
  border: 1px solid #FF9900;
}
.accordion.accordion-border-warning .accordion-button {
  background-color: #ffffff;
  color: #FF9900;
  border-block-end: 0px;
}
.accordion.accordion-border-warning .accordion-button:after {
  background-color: #ffffff;
  color: #FF9900;
  border: 1px solid #FF9900;
}
.accordion.accordion-border-warning .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #FF9900;
}
.accordion.accordion-border-info .accordion-item {
  border: 1px solid #17a2b8;
}
.accordion.accordion-border-info .accordion-button {
  background-color: #ffffff;
  color: #17a2b8;
  border-block-end: 0px;
}
.accordion.accordion-border-info .accordion-button:after {
  background-color: #ffffff;
  color: #17a2b8;
  border: 1px solid #17a2b8;
}
.accordion.accordion-border-info .accordion-button:not(.collapsed) {
  border-block-end: 1px solid #17a2b8;
}

.accordion.accordionicon-none .accordion-button:after {
  display: none;
}

.accordion.accordionicon-left .accordion-button {
  padding-inline-start: 2.5rem;
}
.accordion.accordionicon-left .accordion-button:after {
  position: absolute;
  inset-inline-start: 0.625rem;
}

.accordion.accordion-customicon1 .accordion-button:after {
  content: "+";
  font-family: "Fontawesome";
  background-color: #f7f8f9;
}
.accordion.accordion-customicon1 .accordion-button:not(.collapsed)::after {
  content: "\\f068";
  font-family: "Fontawesome";
  background-color: #ffffff;
}

.customized-accordion .accordion-item.custom-accordion-primary .accordion-button {
  background-color: rgba(255, 159, 67, 0.1);
  border-inline-start: 0.25rem solid rgba(255, 159, 67, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-primary .accordion-button:after {
  background-color: rgba(255, 159, 67, 0.6);
  color: #ffffff;
}
.customized-accordion .accordion-item.custom-accordion-primary .accordion-body {
  background-color: rgba(255, 159, 67, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(255, 159, 67, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-button {
  background-color: rgba(9, 44, 76, 0.1);
  border-inline-start: 0.25rem solid rgba(9, 44, 76, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-button:after {
  background-color: rgba(9, 44, 76, 0.6);
  color: #ffffff;
}
.customized-accordion .accordion-item.custom-accordion-secondary .accordion-body {
  background-color: rgba(9, 44, 76, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(9, 44, 76, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-button {
  background-color: rgba(255, 153, 0, 0.1);
  border-inline-start: 0.25rem solid rgba(255, 153, 0, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-button:after {
  background-color: rgba(255, 153, 0, 0.6);
  color: #ffffff;
}
.customized-accordion .accordion-item.custom-accordion-warning .accordion-body {
  background-color: rgba(255, 153, 0, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(255, 153, 0, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-button {
  background-color: rgba(23, 162, 184, 0.1);
  border-inline-start: 0.25rem solid rgba(23, 162, 184, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-button:after {
  background-color: rgba(23, 162, 184, 0.6);
  color: #ffffff;
}
.customized-accordion .accordion-item.custom-accordion-info .accordion-body {
  background-color: rgba(23, 162, 184, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(23, 162, 184, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-button {
  background-color: rgba(40, 199, 111, 0.1);
  border-inline-start: 0.25rem solid rgba(40, 199, 111, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-button:after {
  background-color: rgba(40, 199, 111, 0.6);
  color: #ffffff;
}
.customized-accordion .accordion-item.custom-accordion-success .accordion-body {
  background-color: rgba(40, 199, 111, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(40, 199, 111, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-button {
  background-color: rgba(255, 0, 0, 0.1);
  border-inline-start: 0.25rem solid rgba(255, 0, 0, 0.6);
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-button:after {
  background-color: rgba(255, 0, 0, 0.6);
  color: #ffffff;
}
.customized-accordion .accordion-item.custom-accordion-danger .accordion-body {
  background-color: rgba(255, 0, 0, 0.1);
  padding-block-start: 0;
  border-inline-start: 0.25rem solid rgba(255, 0, 0, 0.6);
}

.page-header-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  content: var(--bs-breadcrumb-divider, "\\ea65");
  font-family: "tabler-icons" !important;
}

[dir=rtl] .page-header-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  content: var(--bs-breadcrumb-divider, "\\ea64");
  font-family: "tabler-icons" !important;
}

.breadcrumb .breadcrumb-item a {
  color: #9595b5;
}
.breadcrumb .breadcrumb-item.active {
  color: #FF9F43;
}

.breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  opacity: 0.4;
}

.breadcrumb-arrow .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f101";
  font-family: "Fontawesome" !important;
}

.breadcrumb-pipe .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f061";
  font-family: "Fontawesome" !important;
}

.breadcrumb-line .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "-";
}

.breadcrumb-dot .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "•";
}

.breadcrumb-divide .breadcrumb-item + .breadcrumb-item::before {
  color: #9595b5;
  content: "\\f054";
  font-family: "Fontawesome" !important;
}

.breadcrumb-separatorless .breadcrumb-item + .breadcrumb-item::before {
  content: "";
  display: none;
}

.breadcrumb-colored {
  padding: 12px 15px;
  border-radius: 4px;
}
.breadcrumb-colored li a {
  color: #ffffff;
}
.breadcrumb-colored .breadcrumb-item a {
  color: #ffffff;
}
.breadcrumb-colored .breadcrumb-item.active {
  color: #ffffff;
  opacity: 0.8;
}
.breadcrumb-colored .breadcrumb-item + .breadcrumb-item a {
  color: #ffffff;
}
.breadcrumb-colored .breadcrumb-item + .breadcrumb-item::before {
  color: #ffffff;
}

.embedded-breadcrumb:before {
  opacity: 0.7;
}

[data-theme-mode=dark] .embedded-breadcrumb:before {
  filter: invert(1);
}

.card {
  margin-bottom: 1.5rem;
  background-color: #ffffff;
  transition: all 0.5s ease-in-out;
  position: relative;
  border-radius: 4px;
  border: 1px solid #dbe0e6;
  box-shadow: none;
}
.card .card-body {
  padding: 1.25rem;
}
.card .card-title {
  font-size: 18px;
  font-weight: 700;
  text-transform: capitalize;
}
.card .card-header {
  border-color: #dbe0e6;
  position: relative;
  background: transparent;
  padding: 1rem 1.25rem 1rem;
}
.card .card-header .card-title {
  margin-bottom: 0rem;
}
.card .card-header .subtitle {
  padding-top: 0.3125rem;
  font-size: 0.875rem;
  line-height: 1.5;
}
.card .card-footer {
  border-color: #dbe0e6;
  background: transparent;
  padding: 1rem 1.25rem 1rem;
}

.card-group .card {
  margin-bottom: 1.5rem;
}

.card.custom-card {
  border-radius: 4px;
  border: 0;
  background-color: #ffffff;
  position: relative;
  margin-block-end: 1.5rem;
  width: 100%;
}
.card.custom-card .card-header {
  padding: 1rem 1.25rem;
  background-color: transparent !important;
  border-block-end: 1px solid #dbe0e6;
  display: flex;
  align-items: center;
  position: relative;
  flex-wrap: wrap;
  gap: 0.25rem;
}
.card.custom-card .card-header:first-child {
  border-radius: 0.625rem 0.625rem 0 0;
}
.card.custom-card .card-header .card-title {
  position: relative;
  margin-block-end: 0;
  font-size: 0.9375rem;
  font-weight: 700;
  text-transform: capitalize;
}
.card.custom-card .card-header .card-title .subtitle {
  margin-block-end: 0;
  text-transform: initial;
}
.card.custom-card .card-footer {
  background-color: transparent !important;
  border-block-start: 1px solid #dbe0e6;
  padding: 1rem 1.5rem;
  font-size: 14px;
}
.card.custom-card .card-body {
  padding: 1.5rem;
  color: #5B6670;
}
.card.custom-card .card-link {
  font-size: 0.75rem;
}
.card .card-text {
  font-size: 0.813rem;
}
.card .footer-card-icon {
  width: 60px;
  height: 60px;
}
.card.overlay-card {
  position: relative;
  overflow: hidden;
  color: rgba(255, 255, 255, 0.9);
}
.card.overlay-card .card-header {
  border-block-end: 1px solid rgba(255, 255, 255, 0.1);
}
.card.overlay-card .card-footer {
  border-block-start: 1px solid rgba(255, 255, 255, 0.1);
}
.card.overlay-card .over-content-bottom {
  top: auto;
}
.card.overlay-card:before {
  content: "";
  inset-inline-start: 0;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  background-color: rgba(0, 0, 0, 0.2);
  position: absolute;
}
.card.card-bg-primary {
  background-color: #FF9F43;
  color: #ffffff;
}
.card.card-bg-primary .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-primary .card-header:before {
  background-color: #ffffff;
}
.card.card-bg-primary .card-body {
  color: #ffffff;
}
.card.card-bg-primary .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-secondary {
  background-color: #092C4C;
  color: #ffffff;
}
.card.card-bg-secondary .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-secondary .card-header:before {
  background-color: #ffffff;
}
.card.card-bg-secondary .card-body {
  color: #ffffff;
}
.card.card-bg-secondary .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-warning {
  background-color: #FF9900;
  color: #ffffff;
}
.card.card-bg-warning .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-warning .card-header:before {
  background-color: #ffffff;
}
.card.card-bg-warning .card-body {
  color: #ffffff;
}
.card.card-bg-warning .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-info {
  background-color: #17a2b8;
  color: #ffffff;
}
.card.card-bg-info .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-info .card-header:before {
  background-color: #ffffff;
}
.card.card-bg-info .card-body {
  color: #ffffff;
}
.card.card-bg-info .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-success {
  background-color: #28C76F;
  color: #ffffff;
}
.card.card-bg-success .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-success .card-header:before {
  background-color: #ffffff;
}
.card.card-bg-success .card-body {
  color: #ffffff;
}
.card.card-bg-success .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-danger {
  background-color: #FF0000;
  color: #ffffff;
}
.card.card-bg-danger .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-danger .card-header:before {
  background-color: #ffffff;
}
.card.card-bg-danger .card-body {
  color: #ffffff;
}
.card.card-bg-danger .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-light {
  background-color: #f8f9fa;
  color: #5B6670;
}
.card.card-bg-light .card-header {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #5B6670;
  border-block-end: #dbe0e6;
}
.card.card-bg-light .card-body {
  color: #5B6670;
}
.card.card-bg-light .card-footer {
  background-color: rgba(0, 0, 0, 0.05) !important;
  color: #5B6670;
  border-block-start: #dbe0e6;
}
.card.card-bg-dark {
  background-color: #29344a;
  color: #ffffff;
}
.card.card-bg-dark .card-header {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-end: 1px solid rgba(255, 255, 255, 0.2);
}
.card.card-bg-dark .card-header:before {
  background-color: #ffffff;
}
.card.card-bg-dark .card-body {
  color: #ffffff;
}
.card.card-bg-dark .card-footer {
  background-color: rgba(255, 255, 255, 0.1) !important;
  color: #ffffff;
  border-block-start: 1px solid rgba(255, 255, 255, 0.2);
}
.card .card-anchor {
  position: absolute;
  top: 0;
  inset-inline-end: 0;
  bottom: 0;
  inset-inline-start: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
}
.card .collapse-close {
  display: none;
}
.card.card .collapsed .collapse-close {
  display: block;
}
.card.card .collapsed .collapse-open {
  display: none;
}
.card.card-fullscreen {
  position: fixed;
  top: 0;
  inset-inline-start: 0;
  inset-inline-start: 0;
  bottom: 0;
  z-index: 9999;
  margin: 0;
}

.cals-icon {
  font-size: 50px;
  color: #adb5bd;
}

.callout {
  padding: 1.25rem;
  margin-block-start: 1.25rem;
  margin-block-end: 1.25rem;
  background-color: #f8f9fa;
  border-inline-start: 0.25rem solid #dbe0e6;
}

.callout-info {
  background-color: rgba(23, 162, 184, 0.075);
  border-color: rgba(23, 162, 184, 0.5);
}

.callout-warning {
  background-color: rgba(255, 153, 0, 0.075);
  border-color: rgba(255, 153, 0, 0.5);
}

.callout-danger {
  background-color: rgba(255, 0, 0, 0.075);
  border-color: rgba(255, 0, 0, 0.5);
}

.btn-facebook {
  background-color: #3B5998;
  color: #ffffff;
  border: 1px solid #3B5998;
}
.btn-facebook:hover, .btn-facebook:focus, .btn-facebook:active {
  background-color: #3B5998 !important;
  color: #ffffff !important;
  border: 1px solid #3B5998 !important;
}

.btn-instagram {
  background: #f09433;
  background: linear-gradient(45deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%);
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#f09433", endColorstr="#bc1888",GradientType=1 );
  color: #ffffff;
  border: 1px solid transparent;
}
.btn-instagram:hover, .btn-instagram:focus, .btn-instagram:active {
  color: #ffffff;
  border: 1px solid transparent;
}

.btn-twitter {
  background-color: #00ACEE;
  color: #ffffff;
  border: 1px solid #00ACEE;
}
.btn-twitter:hover, .btn-twitter:focus, .btn-twitter:active {
  background-color: #00ACEE !important;
  color: #ffffff !important;
  border: 1px solid #00ACEE !important;
}

.btn-icon {
  width: 2.313rem;
  height: 2.313rem;
  font-size: 0.95rem;
  flex-shrink: 0;
}

.btn-wave {
  display: inline-block !important;
}

@media (max-width: 575px) {
  .overlay-card .card-text {
    font-size: 0.613rem !important;
  }
}
@media (max-width: 400px) {
  .overlay-card .card-text {
    font-size: 0.413rem !important;
  }
}
.tooltip.tooltip-primary .tooltip-inner {
  background-color: #FF9F43;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FF9F43;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FF9F43;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FF9F43;
}
.tooltip.tooltip-primary.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-primary.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FF9F43;
}
.tooltip.tooltip-secondary .tooltip-inner {
  background-color: #092C4C;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #092C4C;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #092C4C;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #092C4C;
}
.tooltip.tooltip-secondary.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-secondary.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #092C4C;
}
.tooltip.tooltip-warning .tooltip-inner {
  background-color: #FF9900;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FF9900;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FF9900;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FF9900;
}
.tooltip.tooltip-warning.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-warning.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FF9900;
}
.tooltip.tooltip-info .tooltip-inner {
  background-color: #17a2b8;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #17a2b8;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #17a2b8;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #17a2b8;
}
.tooltip.tooltip-info.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-info.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #17a2b8;
}
.tooltip.tooltip-success .tooltip-inner {
  background-color: #28C76F;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #28C76F;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #28C76F;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #28C76F;
}
.tooltip.tooltip-success.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-success.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #28C76F;
}
.tooltip.tooltip-danger .tooltip-inner {
  background-color: #FF0000;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #FF0000;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #FF0000;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #FF0000;
}
.tooltip.tooltip-danger.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-danger.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #FF0000;
}
.tooltip.tooltip-dark .tooltip-inner {
  background-color: #29344a;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #29344a;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #29344a;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #29344a;
}
.tooltip.tooltip-dark.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-dark.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #29344a;
}
.tooltip.tooltip-dark .tooltip-inner {
  color: #ffffff;
}
.tooltip.tooltip-light .tooltip-inner {
  background-color: #f8f9fa;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=top] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-top .tooltip-arrow::before {
  border-top-color: #f8f9fa;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=right] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-end .tooltip-arrow::before {
  border-right-color: #f8f9fa;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=left] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-start .tooltip-arrow::before {
  border-left-color: #f8f9fa;
}
.tooltip.tooltip-light.bs-tooltip-auto[data-popper-placement^=bottom] .tooltip-arrow::before, .tooltip.tooltip-light.bs-tooltip-end .tooltip-arrow::before {
  border-bottom-color: #f8f9fa;
}
.tooltip.tooltip-light .tooltip-inner {
  color: #5B6670;
}

.nav-item {
  margin-inline-end: 0.5rem;
}
.nav-item:last-child {
  margin-inline-end: 0;
}

.nav-link {
  color: #5B6670;
  border-radius: 4px;
  font-weight: 600;
}
.nav-link.active {
  background-color: rgba(255, 159, 67, 0.1);
  color: #FF9F43;
}

.navbar-brand {
  color: #5B6670;
}
.navbar-brand:focus, .navbar-brand:hover {
  color: #5B6670;
  opacity: 0.9;
}

.navbar-nav .nav-link.active,
.navbar-nav .show > .nav-link {
  color: #FF9F43;
}

.nav-link.disabled {
  color: #5B6670;
  opacity: 0.3;
}

.nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
  color: rgba(41, 52, 74, 0.5);
}

.navbar-text {
  color: #5B6670;
}

.navbar-dark.bg-dark .nav-link,
.navbar-dark.bg-dark .navbar-brand {
  color: #ffffff;
}
.navbar-dark .navbar-nav .nav-link.active,
.navbar-dark .navbar-nav .show > .nav-link {
  color: #ffffff;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #ffffff;
  background-color: #FF9F43;
}

.nav.nav-style-1 {
  border: 0;
}
.nav.nav-style-1 .nav-item {
  margin-inline-end: 0.25rem;
}
.nav.nav-style-1 .nav-item:last-child {
  margin-inline-end: 0;
}
.nav.nav-style-1 .nav-link.active {
  background-color: rgba(255, 159, 67, 0.1);
  color: #FF9F43;
}
.nav.nav-style-1 .nav-link.active:hover {
  background: rgba(255, 159, 67, 0.1);
}
.nav.nav-style-1 .nav-link:hover {
  background: transparent;
  color: #FF9F43;
}

.nav.nav-style-2 .nav-item .nav-link {
  border-block-start: 3px solid transparent;
}
.nav.nav-style-2 .nav-item .nav-link.active {
  background-color: rgba(255, 159, 67, 0.1);
  border-block-start: 3px solid #FF9F43;
  color: #FF9F43;
}

.nav.nav-style-3 .nav-link {
  border-radius: 0;
}
.nav.nav-style-3 .nav-link {
  border-block-end: 3px solid transparent;
}
.nav.nav-style-3 .nav-link.active {
  background-color: transparent;
  border-block-end: 3px solid #FF9F43;
  color: #FF9F43;
}

.nav.nav-style-4 {
  border: 0;
}
.nav.nav-style-4 .nav-link {
  color: #9595b5;
  border: 0;
}
.nav.nav-style-4 .nav-link {
  margin-bottom: 3px;
}
.nav.nav-style-4 .nav-link.active {
  background-color: #f8f9fa;
  color: #5B6670;
  border: 0;
}
.nav.nav-style-4 .nav-link:hover, .nav.nav-style-4 .nav-link:focus {
  border: 0;
}
.nav.nav-style-4 .nav-link:hover {
  background-color: #f8f9fa;
  color: #5B6670;
}

.nav-tabs.nav-style-5 {
  border: 0;
}
.nav-tabs.nav-style-5 .nav-link {
  color: #9595b5;
  border: 0;
  margin-bottom: 3px;
}
.nav-tabs.nav-style-5 .nav-link.active {
  background-color: #FF9F43;
  color: #ffffff;
  border: 0;
}
.nav-tabs.nav-style-5 .nav-link:hover, .nav-tabs.nav-style-5 .nav-link:focus {
  border: 0;
  background-color: #FF9F43;
  color: #ffffff;
}

.nav-style-6 {
  border: 0;
}
.nav-style-6.nav-pills .nav-link.active {
  border: 1px solid #FF9F43;
  border-block-end: 2px solid #FF9F43;
  background-color: transparent;
  color: #FF9F43;
}

.nav-tabs-header {
  border: 0 !important;
}
.nav-tabs-header .nav-item {
  margin-inline-end: 0.5rem;
}
.nav-tabs-header .nav-item:last-child {
  margin-inline-end: 0;
}
.nav-tabs-header .nav-item .nav-link {
  border: 1px solid transparent;
  font-size: 0.8rem;
  padding: 0.4rem 0.5rem;
  font-weight: 500;
}
.nav-tabs-header .nav-item .nav-link.active {
  background: rgba(255, 159, 67, 0.1);
  color: #FF9F43;
  border: 1px solid transparent;
}
.nav-tabs-header .nav-item .nav-link:hover, .nav-tabs-header .nav-item .nav-link:focus {
  border: 1px solid transparent;
  background-color: transparent;
  color: #FF9F43;
}

.nav-tabs-footer {
  border: 0;
}
.nav-tabs-footer .nav-item {
  margin-inline-end: 0.5rem;
}
.nav-tabs-footer .nav-item:last-child {
  margin-inline-end: 0;
}
.nav-tabs-footer .nav-item .nav-link {
  background-color: transparent;
  color: #FF9F43;
  border: 1px solid #FF9F43;
  font-size: 0.8rem;
}
.nav-tabs-footer .nav-item .nav-link.active {
  background: #FF9F43;
  color: #ffffff;
  border: 1px solid #FF9F43;
}
.nav-tabs-footer .nav-item .nav-link:hover, .nav-tabs-footer .nav-item .nav-link:focus {
  border: 1px solid #FF9F43;
  background-color: transparent;
  color: #FF9F43;
}

.vertical-tabs-2 {
  border: 0;
}
.vertical-tabs-2 .nav-item {
  margin-inline-end: 0.5rem;
}
.vertical-tabs-2 .nav-item:last-child {
  margin-inline-end: 0;
}
.vertical-tabs-2 .nav-item .nav-link {
  min-width: 7.5rem;
  max-width: 7.5rem;
  text-align: center;
  border: 1px solid #dbe0e6;
  margin-bottom: 0.5rem;
  color: #9595b5;
  background-color: #f8f9fa;
}
.vertical-tabs-2 .nav-item .nav-link i {
  font-size: 1rem;
}
.vertical-tabs-2 .nav-item .nav-link.active {
  background-color: #FF9F43;
  color: #ffffff;
  position: relative;
}
.vertical-tabs-2 .nav-item .nav-link.active:before {
  content: "";
  position: absolute;
  inset-inline-end: -0.5rem;
  inset-block-start: 38%;
  transform: rotate(45deg);
  width: 1rem;
  height: 1rem;
  background-color: #FF9F43;
}
.vertical-tabs-2 .nav-item .nav-link.active:hover {
  color: #ffffff;
}
.vertical-tabs-2 .nav-item .nav-link:hover {
  color: #FF9F43;
}

.vertical-tabs-3 {
  border: 0;
}
.vertical-tabs-3 .nav-item {
  border: 0;
  margin-inline-end: 0.5rem;
}
.vertical-tabs-3 .nav-item:last-child {
  margin-inline-end: 0;
}
.vertical-tabs-3 .nav-item .nav-link {
  min-width: 160px;
  max-width: 160px;
  border: 1px solid #FF9F43;
  padding: 1.3rem;
  margin-block-end: 0.5rem;
}
.vertical-tabs-3 .nav-item .nav-link i {
  width: 2rem;
  height: 2rem;
  line-height: 2rem;
  text-align: center;
  font-size: 1rem;
  background: #FF9F43;
  color: #ffffff;
  border-radius: 3.125rem;
  font-weight: 500;
}
.vertical-tabs-3 .nav-item .nav-link.active {
  background: #FF9F43;
  border: 1px solid #FF9F43;
  color: #ffffff;
}
.vertical-tabs-3 .nav-item .nav-link.active:hover {
  background: #FF9F43;
  border: 1px solid #FF9F43;
  color: #ffffff;
}
.vertical-tabs-3 .nav-item .nav-link.active i {
  background: #ffffff;
  color: #FF9F43;
}
.vertical-tabs-3 .nav-item .nav-link:hover, .vertical-tabs-3 .nav-item .nav-link:focus {
  border: 1px solid #FF9F43;
  color: #FF9F43;
  background: transparent;
}

.nav.tab-style-1 {
  border-block-end: 0;
  padding: 0.65rem;
  background-color: #f8f9fa;
  border-radius: 7px;
  margin-block-end: 1rem;
}
.nav.tab-style-1 .nav-item {
  margin-inline-end: 0.5rem;
}
.nav.tab-style-1 .nav-item:last-child {
  margin-inline-end: 0;
}
.nav.tab-style-1 .nav-link {
  border-radius: 7px;
  padding: 0.35rem 1rem;
}
.nav.tab-style-1 .nav-link.active {
  background-color: #FF9F43 !important;
  color: #ffffff !important;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  transition: color 0.15s ease-in;
}

.nav-tabs.tab-style-1 .nav-link:hover {
  background: transparent;
  color: #FF9F43;
}

.tab-style-2 {
  border-block-end: 0;
}
.tab-style-2 .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-2 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-2 .nav-item .nav-link {
  border: 0;
}
.tab-style-2 .nav-item .nav-link i {
  width: 1.875rem;
  height: 1.875rem;
  padding: 0.4rem;
  border-radius: 50px;
  background-color: #f8f9fa;
  color: #5B6670;
  display: inline-block;
}
.tab-style-2 .nav-item .nav-link:hover {
  border: 0;
  background: transparent;
  color: #FF9F43;
}
.tab-style-2 .nav-item .nav-link:hover i {
  color: #FF9F43;
}
.tab-style-2 .nav-item .nav-link.active {
  background-color: transparent;
  position: relative;
  border: 0;
  color: #FF9F43;
}
.tab-style-2 .nav-item .nav-link.active i {
  background-color: rgba(255, 159, 67, 0.1);
  color: #FF9F43;
}
.tab-style-2 .nav-item .nav-link.active:before {
  content: "";
  position: absolute;
  inset-inline-start: 0;
  inset-inline-end: 0;
  inset-block-end: 0;
  width: 100%;
  height: 0.175rem;
  background-color: #FF9F43;
  border-radius: 50px;
}

.tab-style-3 {
  border-block-end: 0;
}
.tab-style-3 .nav-item {
  position: relative;
  margin-inline-end: 0.5rem;
}
.tab-style-3 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-3 .nav-item .nav-link {
  position: relative;
  border: 0;
  font-size: 0.75rem;
}
.tab-style-3 .nav-item .nav-link:before {
  position: absolute;
  content: "";
  inset-block-end: -1.063rem;
  inset-inline-end: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 0.1rem;
  background-color: #f8f9fa;
  border-radius: 50%;
}
.tab-style-3 .nav-item .nav-link:after {
  position: absolute;
  content: "";
  inset-block-end: -2rem;
  inset-inline-start: 1.75rem;
  inset-inline-end: 0;
  inset-inline-start: 30%;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #ffffff;
  border-radius: 50%;
  border: 2px solid #dbe0e6;
}
.tab-style-3 .nav-item .nav-link.home:after {
  content: "1";
}
.tab-style-3 .nav-item .nav-link.about:after {
  content: "2";
}
.tab-style-3 .nav-item .nav-link.services:after {
  content: "3";
}
.tab-style-3 .nav-item .nav-link:hover {
  border: 0;
  background: transparent;
  color: #FF9F43;
}
.tab-style-3 .nav-item .nav-link.active {
  background-color: transparent;
  border: 0;
  color: #FF9F43;
}
.tab-style-3 .nav-item .nav-link.active:before {
  background-color: #FF9F43;
}
.tab-style-3 .nav-item .nav-link.active:after {
  border-color: #FF9F43;
  color: #FF9F43;
}

.tab-style-4.nav-tabs {
  border: 0;
}
.tab-style-4.nav-tabs .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-4.nav-tabs .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-4.nav-tabs .nav-link {
  border: 0;
}
.tab-style-4.nav-tabs .nav-link:hover {
  border: 0;
  background: transparent;
  color: #FF9F43;
}
.tab-style-4.nav-tabs .nav-link.active {
  background-color: transparent;
  border: 0;
  color: #FF9F43;
  position: relative;
  overflow: hidden;
}
.tab-style-4.nav-tabs .nav-link.active::before {
  position: absolute;
  content: "";
  width: 0.75rem;
  inset-block-start: 31px;
  transform: rotate(45deg);
  inset-inline-start: 47%;
  overflow: hidden;
  z-index: 1;
  height: 0.75rem;
  background-color: #FF9F43;
  border: 1px solid #FF9F43;
}
.tab-style-4.nav-tabs .nav-link.active:after {
  position: absolute;
  content: "";
  width: 40%;
  height: 1px;
  inset-inline-start: 30%;
  inset-block-end: 0;
  background-color: #FF9F43;
}

#tab-style-4 .tab-pane.active {
  border: 1px solid #FF9F43;
  background-color: #FF9F43;
  color: #ffffff;
  padding: 16px;
  border-radius: 7px;
}

.tab-style-5 .nav-item {
  margin-inline-end: 0.5rem;
}
.tab-style-5 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-5 .nav-item .nav-link.active {
  background: #FF9F43;
}

.tab-style-6 {
  border: 0;
  background-color: #ffffff;
  border-radius: 7px;
  color: #FF9F43;
  padding: 0.5rem;
}
.tab-style-6 .nav-item {
  border: 0;
  margin-inline-end: 0.5rem;
}
.tab-style-6 .nav-item:last-child {
  margin-inline-end: 0;
}
.tab-style-6 .nav-item .nav-link {
  color: #FF9F43;
  padding: 0.5rem 1rem;
  font-size: 0.813rem;
  border: 0;
  font-weight: 500;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.tab-style-6 .nav-item .nav-link.active {
  border: 0;
  background-color: #FF9F43;
  color: #ffffff;
  border: 0;
  box-shadow: 0px 3px 10px 0px rgba(var(--dark-rgb), 0.05);
}
.tab-style-6 .nav-item .nav-link:hover, .tab-style-6 .nav-item .nav-link:focus {
  border: 0;
}

.tab-style-7 .nav-link {
  margin-block-end: 0.5rem;
  font-size: 0.813rem;
  color: #9595b5;
  text-align: left;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.tab-style-7 .nav-link:active, .tab-style-7 .nav-link.active {
  background-color: rgba(255, 159, 67, 0.1);
  color: #FF9F43;
}

.nav-style-1 .nav-item .nav-link.active {
  background-color: rgba(255, 159, 67, 0.1);
  color: #FF9F43;
}

@media screen and (max-width: 400px) {
  .tab-style-4 .nav-link {
    padding-inline: 0.5rem;
  }
}
.nav-tabs {
  border-bottom: 0;
}
.nav-tabs.nav-tabs-bottom li {
  margin-bottom: -1px;
}
.nav-tabs .nav-link {
  margin-bottom: -1px;
  background: 0 0;
  border: 1px solid transparent;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
.nav-tabs .nav-link.active {
  border-color: #e8ebed;
}
.nav-tabs li a {
  color: #67748E;
  border-bottom-width: 2px;
}
.nav-tabs li a.active {
  border-color: transparent;
  border-bottom-color: #FF9F43;
  background-color: transparent;
  transition: all 0.2s ease;
}

.nav-tabs .nav-tabs-solid {
  background-color: #ffffff;
  border: 0;
}
.nav-tabs .nav-tabs-solid .active {
  background-color: #FF9F43;
  border-color: #FF9F43;
  color: #ffffff;
}

.nav-tabs .nav-link:hover {
  border-color: transparent;
  color: #FF9F43;
}
.nav-tabs.nav-tabs-top li a {
  border-width: 2px 0 0 0;
}
.nav-tabs.nav-tabs-top li a.active {
  border-top-color: #FF9F43;
  border-radius: 0;
}
.nav-tabs.nav-tabs-top li a:hover {
  border-top-color: #FF9F43;
  background-color: transparent;
  border-radius: 0;
}
.nav-tabs.nav-tabs-bottom li a {
  border-width: 0 0 2px 0;
}
.nav-tabs.nav-tabs-bottom li a.active, .nav-tabs.nav-tabs-bottom li a:hover {
  border-bottom-color: #FF9F43;
  background: transparent;
  border-radius: 0;
}
.nav-tabs.nav-tabs-solid {
  background-color: #ffffff;
  border: 0;
}
.nav-tabs.nav-tabs-solid.nav-tabs-rounded li a.active {
  background-color: #FF9F43;
  border-color: #FF9F43;
  color: #ffffff;
  border-radius: 50px;
}
.nav-tabs.nav-tabs-solid li a.active {
  background-color: #FF9F43;
  border-color: #FF9F43;
  color: #ffffff;
  border-radius: 0;
}

.nav-link:hover {
  color: #FF9F43;
}

.page-menu .nav-tabs li a {
  font-size: 16px;
}

.tabs-set .nav-tabs {
  border-bottom: 0;
  margin-bottom: 20px;
}
.tabs-set .nav-tabs .nav-link {
  color: #092C4C;
  padding: 8px 15px;
  font-size: 16px;
  font-weight: 700;
  border: 0;
  min-width: 120px;
  margin-right: 10px;
  border-radius: 8px;
  background: var(--Stroke, rgba(145, 158, 171, 0.3));
}
.tabs-set .nav-tabs .nav-link:focus {
  border-color: transparent;
}
.tabs-set .nav-tabs .nav-link:hover {
  border-color: transparent;
}
.tabs-set .nav-tabs .nav-link.active {
  border: 0;
  border-bottom: 2px solid #FF9F43;
  background: #FF9F43;
  color: #ffffff;
}

.tabs-sets .nav-tabs {
  border-bottom: 0;
  margin: 0 0 40px;
}
.tabs-sets .nav-tabs .nav-link {
  color: #000000;
  font-size: 14px;
  font-weight: 700;
  border: 0;
  background: #e8ebed;
  margin-right: 10px;
  padding: 8px 15px;
  border-radius: 8px;
  transition: all 0.5s ease;
}
.tabs-sets .nav-tabs .nav-link:focus, .tabs-sets .nav-tabs .nav-link:hover, .tabs-sets .nav-tabs .nav-link.active {
  background: #FF9F43;
  color: #ffffff;
}

@media (max-width: 768px) {
  .nav-tabs {
    border-bottom: 0;
    position: relative;
    background-color: #ffffff;
    border: 1px solid #eee;
    padding: 5px 0;
    border-radius: 3px;
  }
}
.ribbon1 {
  position: absolute;
  inset-block-start: -6.1px;
  inset-inline-end: 10px;
  color: #ffffff;
  z-index: 1;
}
.ribbon1:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 20px solid transparent;
  border-inline-end: 24px solid transparent;
  border-block-start: 13px solid #FF0000;
}
.ribbon1 span {
  position: relative;
  display: block;
  text-align: center;
  background: #FF0000;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-start-end-radius: 8px;
}
.ribbon1 span:before, .ribbon1 span:after {
  position: absolute;
  content: "";
}
.ribbon1 span:before {
  height: 6px;
  width: 6px;
  inset-inline-start: -6px;
  inset-block-start: 0;
  background: #FF0000;
}
.ribbon1 span:after {
  height: 6px;
  width: 8px;
  inset-inline-start: -8px;
  inset-block-start: 0;
  border-radius: 8px 8px 0 0;
  background: #FF0000;
}

.ribbone {
  width: 100%;
  position: relative;
  background-size: cover;
  text-transform: uppercase;
  color: #ffffff;
  width: 150px;
  height: 150px;
  overflow: hidden;
  position: absolute;
  z-index: 6;
}
.ribbone::after {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid;
}
.ribbone::before {
  position: absolute;
  z-index: -1;
  content: "";
  display: block;
  border: 5px solid;
}
.ribbone span {
  position: absolute;
  display: block;
  width: 225px;
  padding: 3px 0;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  color: #ffffff;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  text-transform: capitalize;
  text-align: center;
  font-size: 11px;
}

.ribbone1 {
  position: absolute;
  inset-block-start: -6.1px;
  inset-inline-start: 10px;
  z-index: 1;
}
.ribbone1:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 20px solid transparent;
  border-inline-end: 24px solid transparent;
  border-block-start: 13px solid #FF0000;
}
.ribbone1 span {
  position: relative;
  display: block;
  text-align: center;
  background: #FF0000;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-start-end-radius: 8px;
}
.ribbone1 span:after {
  position: absolute;
  content: "";
  height: 6px;
  width: 8px;
  inset-inline-start: -8px;
  inset-block-start: 0;
  border-radius: 8px 8px 0 0;
  background: #FF0000;
}
.ribbone1 span:before {
  position: absolute;
  content: "";
  height: 6px;
  width: 6px;
  inset-inline-start: -6px;
  inset-block-start: 0;
  background: #FF0000;
}

.arrow-ribbone-left {
  color: #ffffff;
  padding: 2px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-start: 0;
  z-index: 6;
  font-size: 13px;
}

.arrow-ribbone-left.bg-purple:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #7367F0;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-danger:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 112px solid transparent;
  border-inline-start: 12px solid #FF0000;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-primary:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-secondary:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #092C4C;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-success:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #FF9F43;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-info:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #17a2b8;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-warning:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #FF9900;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-pink:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -12px;
  border-block-start: 12px solid transparent;
  border-inline-start: 12px solid #ff63a5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-left.bg-teal:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #02a8b5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right {
  color: #ffffff;
  padding: 2px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-end: 0;
  z-index: 6;
  font-size: 13px;
}

.arrow-ribbone-right.bg-purple:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #7367F0;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-danger:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FF0000;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-primary:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-secondary:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #092C4C;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-success:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FF9F43;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-info:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #17a2b8;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-warning:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #FF9900;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-pink:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #ff63a5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone-right.bg-teal:before {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-start: -12px;
  border-block-start: 12px solid transparent;
  border-inline-end: 12px solid #02a8b5;
  border-block-end: 11px solid transparent;
  width: 0;
}

.arrow-ribbone2 {
  color: #ffffff;
  padding: 3px 8px;
  position: absolute;
  inset-block-start: 10px;
  inset-inline-start: -1px;
  z-index: 6;
  font-size: 30px;
}
.arrow-ribbone2:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -24px;
  border-block-start: 24px solid transparent;
  border-block-end: 24px solid transparent;
  width: 0;
}

.power-ribbone {
  width: 56px;
  height: 56px;
  overflow: hidden;
  position: absolute;
  z-index: 6;
}
.power-ribbone span {
  position: absolute;
  display: block;
  width: 82px;
  padding: 8px 0;
  color: #ffffff;
  font: 500 16px/1 Lato, sans-serif;
  text-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  text-transform: capitalize;
  text-align: center;
}

.power-ribbone-top-left {
  inset-block-start: -6px;
  inset-inline-start: -9px;
}
.power-ribbone-top-left span {
  inset-inline-end: -5px;
  inset-block-start: 1px;
  transform: rotate(-45deg);
}
.power-ribbone-top-left span i {
  transform: rotate(45deg);
  padding-block-start: 2px;
  padding-inline-start: 7px;
}

.power-ribbone-bottom-left {
  inset-block-end: -6px;
  inset-inline-start: -9px;
}
.power-ribbone-bottom-left span {
  inset-inline-end: -5px;
  inset-block-end: 1px;
  transform: rotate(45deg);
}
.power-ribbone-bottom-left span i {
  transform: rotate(-45deg);
  padding-block-end: 2px;
  padding-inline-start: 7px;
}

.power-ribbone-top-right {
  inset-block-start: -6px;
  inset-inline-end: -9px;
}
.power-ribbone-top-right span {
  inset-inline-start: -5px;
  inset-block-start: 1px;
  transform: rotate(45deg);
}
.power-ribbone-top-right span i {
  transform: rotate(-45deg);
  padding-block-start: 2px;
  padding-inline-end: 7px;
}

.power-ribbone-bottom-right {
  inset-block-end: -6px;
  inset-inline-end: -9px;
}
.power-ribbone-bottom-right span {
  inset-inline-start: -5px;
  inset-block-end: 1px;
  transform: rotate(-45deg);
}
.power-ribbone-bottom-right span i {
  transform: rotate(45deg);
  padding-block-end: 2px;
  padding-inline-end: 7px;
}

.ribbone-top-left {
  inset-block-start: -10px;
  inset-inline-start: -10px;
}
.ribbone-top-left::after {
  border-block-start-color: transparent;
  border-inline-start-color: transparent;
  inset-block-end: 50px;
  inset-inline-start: 0;
}
.ribbone-top-left::before {
  border-block-start-color: transparent;
  border-inline-start-color: transparent;
  inset-block-start: 0;
  inset-inline-end: 50px;
}
.ribbone-top-left span {
  inset-inline-end: 0px;
  inset-block-start: 24px;
  transform: rotate(-45deg);
}

.ribbone-top-right {
  inset-block-start: -10px;
  inset-inline-end: -10px;
}
.ribbone-top-right::after {
  border-block-start-color: transparent;
  border-inline-end-color: transparent;
  inset-block-end: 50px;
  inset-inline-end: 0;
}
.ribbone-top-right::before {
  border-block-start-color: transparent;
  border-inline-end-color: transparent;
  inset-block-start: 0;
  inset-inline-start: 50px;
}
.ribbone-top-right span {
  inset-inline-start: 0px;
  inset-block-start: 24px;
  transform: rotate(45deg);
}

.ribbone-warning-right {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-end: 10px;
  color: #ffffff;
}
.ribbone-warning-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #FF9900;
  z-index: 6;
}
.ribbone-warning-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FF9900;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-end-radius: 10px;
  z-index: 6;
}
.ribbone-warning-right span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #FF9900;
  height: 6px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 0;
  border-start-start-radius: 50px;
  border-start-end-radius: 0;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-warning-right span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 3px;
  background: #FF9900;
}
.ribbone-warning-right i {
  color: #ffffff;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-danger-right {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-end: 10px;
  color: #ffffff;
}
.ribbone-danger-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #FF0000;
  z-index: 6;
}
.ribbone-danger-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FF0000;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-end-radius: 10px;
  z-index: 6;
}
.ribbone-danger-right span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #FF0000;
  height: 6px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 0;
  border-start-start-radius: 50px;
  border-start-end-radius: 0;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-danger-right span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-start: -9px;
  inset-block-start: 3px;
  background: #FF0000;
}
.ribbone-danger-right i {
  color: #ffffff;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-success-left {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-start: 10px;
  color: #ffffff;
}
.ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #28C76F;
  z-index: 6;
}
.ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #28C76F;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-start-radius: 10px;
  z-index: 6;
}
.ribbone-success-left span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #28C76F;
  height: 6px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 0;
  border-start-start-radius: 0;
  border-start-end-radius: 50px;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-success-left span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 3px;
  background: #28C76F;
}
.ribbone-success-left i {
  color: #ffffff;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-info-left {
  position: absolute;
  inset-block-start: -8px;
  inset-inline-start: 10px;
  color: #ffffff;
}
.ribbone-info-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-inline-start: 17px solid transparent;
  border-inline-end: 17px solid transparent;
  border-block-start: 10px solid #17a2b8;
  z-index: 6;
}
.ribbone-info-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #17a2b8;
  font-size: 13px;
  line-height: 1;
  padding: 10px 2px 5px;
  border-start-start-radius: 10px;
  z-index: 6;
}
.ribbone-info-left span:after {
  position: absolute;
  content: "";
  inset-inline-end: -6px;
  background: #17a2b8;
  height: 6px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 0;
  border-start-start-radius: 0;
  border-start-end-radius: 50px;
  border-end-start-radius: 0;
  border-end-end-radius: 0;
}
.ribbone-info-left span:before {
  position: absolute;
  content: "";
  height: 5px;
  width: 10px;
  inset-inline-end: -9px;
  inset-block-start: 3px;
  background: #17a2b8;
}
.ribbone-info-left i {
  color: #ffffff;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-success-left {
  position: absolute;
  inset-inline-start: 10px;
  color: #ffffff;
}
.bookmark-ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-start: 0;
  border-inline-start: 18px solid #28C76F;
  border-inline-end: 18px solid #28C76F;
  border-block-end: 10px solid transparent;
}
.bookmark-ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #28C76F;
  font-size: 13px;
  line-height: 1;
  padding: 12px 3px 20px;
  z-index: 6;
}
.bookmark-ribbone-success-left i {
  color: #ffffff;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-danger-left {
  position: absolute;
  inset-inline-start: 10px;
  color: #ffffff;
  width: 30px;
}
.bookmark-ribbone-danger-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-start: 0;
  border-inline-start: 15px solid #FF0000;
  border-inline-end: 15px solid #FF0000;
  border-block-end: 8px solid transparent;
}
.bookmark-ribbone-danger-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #FF0000;
  font-size: 12px;
  line-height: 1;
  padding: 12px 0px;
  z-index: 6;
}
.bookmark-ribbone-danger-left i {
  color: #ffffff;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-ribbone-secondary-right {
  position: absolute;
  inset-inline-end: 10px;
  color: #ffffff;
  width: 30px;
}
.bookmark-ribbone-secondary-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-inline-end: 0;
  border-inline-start: 15px solid #092C4C;
  border-inline-end: 15px solid #092C4C;
  border-block-end: 8px solid transparent;
}
.bookmark-ribbone-secondary-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #092C4C;
  font-size: 11px;
  line-height: 1;
  padding: 12px 0px;
  z-index: 6;
}
.bookmark-ribbone-secondary-right i {
  color: #ffffff;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-sideleft-ribbone-success-left {
  position: absolute;
  inset-block-start: 10px;
  color: #ffffff;
}
.bookmark-sideleft-ribbone-success-left:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-block-start: 0;
  inset-inline-end: -8px;
  border-block-start: 13px solid #28C76F;
  border-block-end: 13px solid #28C76F;
  border-inline-end: 8px solid transparent;
}
.bookmark-sideleft-ribbone-success-left span {
  position: relative;
  display: block;
  text-align: center;
  background: #28C76F;
  font-size: 11px;
  padding: 5px 13px;
  z-index: 6;
  height: 26px;
}
.bookmark-sideleft-ribbone-success-left i {
  color: #ffffff;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.bookmark-sideright-ribbone-primary-right {
  position: absolute;
  inset-block-start: 10px;
  inset-inline-end: 0;
  color: #ffffff;
}
.bookmark-sideright-ribbone-primary-right:after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  z-index: 6;
  inset-block-start: 0;
  inset-inline-start: -8px;
  border-block-start: 13px solid #FF9F43;
  border-block-end: 13px solid #FF9F43;
  border-inline-start: 8px solid transparent;
}
.bookmark-sideright-ribbone-primary-right span {
  position: relative;
  display: block;
  text-align: center;
  background: #FF9F43;
  font-size: 11px;
  padding: 5px 13px;
  z-index: 6;
  height: 26px;
}
.bookmark-sideright-ribbone-primary-right i {
  color: #ffffff;
  font-size: 16px;
  padding-inline-start: 7px;
  padding-inline-end: 7px;
}

.ribbone-1 span:after {
  position: absolute;
  content: "";
}

.arrow-ribbone-2 {
  color: #ffffff;
  padding: 3px 8px;
  position: absolute;
  z-index: 6;
  font-size: 20px;
}
.arrow-ribbone-2:before {
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  content: "";
  inset-inline-end: -24px;
  border-block-start: 16px solid transparent;
  border-inline-start: 24px solid #7367F0;
  border-block-end: 16px solid transparent;
  width: 0;
}

.ribbone-card {
  overflow: hidden;
}

.fullwidth-primary-ribbons .bar {
  color: #ffffff;
  background-color: #FF9F43;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #f8f9fa;
}
.fullwidth-primary-ribbons .bar span {
  position: absolute;
}
.fullwidth-primary-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-primary-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-primary-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-color: #FF9F43 #FF9F43 #FF9F43 transparent;
  border-block-start-color: #FF9F43;
  border-inline-end-color: #FF9F43;
  border-block-end-color: #FF9F43;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-primary-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FF9F43;
  border-inline-end-color: transparent;
  border-block-end-color: #FF9F43;
  border-inline-start-color: #FF9F43;
  inset-inline-end: -30px;
}

.fullwidth-secondary-ribbons .bar {
  color: #ffffff;
  background-color: #092C4C;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #f8f9fa;
}
.fullwidth-secondary-ribbons .bar span {
  position: absolute;
}
.fullwidth-secondary-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #092C4C;
  border-inline-end-color: #092C4C;
  border-block-end-color: #092C4C;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-secondary-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #092C4C;
  border-inline-end-color: transparent;
  border-block-end-color: #092C4C;
  border-inline-start-color: #092C4C;
  inset-inline-end: -30px;
}

.fullwidth-arrow-warning-ribbons .bar {
  color: #ffffff;
  background-color: #FF9900;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #f8f9fa;
}
.fullwidth-arrow-warning-ribbons .bar span {
  position: absolute;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FF9900;
  border-inline-end-color: #FF9900;
  border-block-end-color: #FF9900;
  border-inline-start-color: transparent;
  inset-inline-start: -30px;
}
.fullwidth-arrow-warning-ribbons .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start: 18px solid transparent;
  border-inline-start: 18px solid #FF9900;
  border-block-end: 18px solid transparent;
  border-inline-end: transparent;
  inset-inline-end: -20px;
  inset-block-start: -2px;
}

.fullwidth-arrow-danger-ribbons-right .bar {
  color: #ffffff;
  background-color: #FF0000;
  padding: 5px;
  text-align: center;
  position: relative;
  border: 2px transparent solid;
  box-shadow: 0 10px 30px -10px #f8f9fa;
}
.fullwidth-arrow-danger-ribbons-right .bar span {
  position: absolute;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(1) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-end: -2px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(3) {
  border-style: solid;
  border-width: 11px;
  z-index: -1;
  border-color: transparent;
  inset-block-start: 31px;
  inset-inline-start: -2px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(2) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start-color: #FF0000;
  border-inline-end-color: transparent;
  border-block-end-color: #FF0000;
  border-inline-start-color: #FF0000;
  inset-inline-end: -30px;
}
.fullwidth-arrow-danger-ribbons-right .bar span:nth-child(4) {
  inset-block-start: 18px;
  border-style: solid;
  border-width: 18px;
  z-index: -2;
  border-block-start: 18px solid transparent;
  border-inline-end: 18px solid #FF0000;
  border-block-end: 18px solid transparent;
  border-inline-start: transparent;
  inset-inline-start: -20px;
  inset-block-start: -2px;
}

.power-ribbone span svg {
  width: 15px;
  height: 15px;
}

.ribbone-card .card-body {
  padding: 25px;
}

.ribbone-row .feather-zap {
  width: 15px;
  height: 15px;
}

[data-bs-toggle=card-fullscreen] svg {
  width: 15px;
  height: 15px;
}

[data-bs-toggle=card-remove] svg {
  width: 15px;
  height: 15px;
}

svg.collapse-open, svg.collapse-close {
  width: 15px;
  height: 15px;
}

.btn-icon.btn-danger-light {
  color: #FF1A1A;
  background: #FFE6E6;
}

.live-rating.badge {
  background: #D4F4E2;
  color: #3ECD7D;
}

@media (min-width: 576px) {
  .mx-sm-7 {
    margin-inline: 3rem !important;
  }
}
[dir=rtl] .power-ribbone-top-left span {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-top-left span i {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-bottom-left span {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-bottom-left span i {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-top-right span {
  transform: rotate(-45deg);
}
[dir=rtl] .power-ribbone-top-right span i {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-bottom-right span {
  transform: rotate(45deg);
}
[dir=rtl] .power-ribbone-bottom-right span i {
  transform: rotate(-45deg);
}
[dir=rtl] .ribbone-top-left span {
  transform: rotate(45deg);
}
[dir=rtl] .ribbone-top-right span {
  transform: rotate(-45deg);
}
[dir=rtl] .ribbon-price .badge {
  transform: rotate(-45deg);
}

.modal-barcode ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.modal-barcode ul li {
  border-radius: 7px;
  width: 25%;
  margin-bottom: 10px;
  padding: 0 5px;
}
@media (max-width: 991.98px) {
  .modal-barcode ul li {
    width: 50%;
  }
}
.modal-barcode ul li a {
  border: 1px solid #dbe0e6;
  border-radius: 10px;
  display: block;
  padding: 10px;
  text-align: center;
}

.modal .modal-title {
  font-weight: 700;
}
@media (max-width: 991.98px) {
  .modal .modal-title {
    font-size: 16px;
  }
}
.modal .logo-lg img {
  width: 150px;
}
.modal .close,
.modal .btn-close {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #FF4D4D;
  opacity: 1;
  font-size: 12px;
  width: 22px;
  height: 22px;
  border: 0;
  font-weight: 700;
  background-color: transparent;
  border-radius: 50px;
}
.modal .close:hover,
.modal .btn-close:hover {
  background-color: transparent;
  color: #ffffff;
}
.modal .modal-footer {
  border: 0;
  justify-content: flex-start;
}
.modal .modal-footer .btn {
  min-width: 130px;
  padding: 12px;
}
@media (max-width: 991.98px) {
  .modal .modal-footer .btn {
    min-width: auto;
    padding: 7px 12px;
  }
}
.modal .modal-footer .btn-print {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #FF9F43;
  color: #FF9F43;
}
.modal .modal-footer .btn-print img {
  margin-left: 10px;
}
.modal .modal-footer .btn-print:hover {
  background: #FF9F43;
  color: #ffffff;
}
.modal .modal-footer .btn-print:hover img {
  filter: brightness(0) invert(1);
}
.modal .modal-footer .btn-secondary {
  background: #092C4C;
}
.modal .modal-footer .btn-secondary:hover {
  box-shadow: inset 0 0px 0px 100px #ffffff;
  color: #092C4C !important;
}
.modal .modal-dialog.right-slider-modal {
  margin: 0;
  margin-left: auto;
  max-width: 1102px;
}
.modal .modal-dialog.add-centered {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  max-width: 1192px;
}
.modal .modal-dialog.sales-details-modal {
  max-width: 1192px;
}
.modal .modal-dialog.edit-sales-modal {
  max-width: 1192px;
}
.modal .edit-add.card.edit-expense {
  border: 1px solid rgba(0, 0, 0, 0.2);
}
.modal .note-editor.note-frame.card {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
}

.offcanvas.offcanvas-end {
  width: auto !important;
}

.offcanvas.offcanvas-end.em-payrol-add {
  max-width: 1192px !important;
}

.modal.animated .modal-dialog {
  transform: translate(0, 0);
}
.modal.effect-scale .modal-dialog {
  transform: scale(0.7);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-scale.show .modal-dialog {
  transform: scale(1);
  opacity: 1;
}
.modal.effect-slide-in-right .modal-dialog {
  transform: translateX(20%);
  opacity: 0;
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.modal.effect-slide-in-right.show .modal-dialog {
  transform: translateX(0);
  opacity: 1;
}
.modal.effect-slide-in-bottom .modal-dialog {
  transform: translateY(20%);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-slide-in-bottom.show .modal-dialog {
  transform: translateY(0);
  opacity: 1;
}
.modal.effect-newspaper .modal-dialog {
  transform: scale(0) rotate(720deg);
  opacity: 0;
}
.modal.effect-newspaper.show ~ .modal-backdrop, .modal.effect-newspaper .modal-dialog {
  transition: all 0.5s;
}
.modal.effect-newspaper.show .modal-dialog {
  transform: scale(1) rotate(0deg);
  opacity: 1;
}
.modal.effect-fall {
  perspective: 1300px;
}
.modal.effect-fall .modal-dialog {
  transform-style: preserve-3d;
  transform: translateZ(600px) rotateX(20deg);
  opacity: 0;
}
.modal.effect-fall.show .modal-dialog {
  transition: all 0.3s ease-in;
  transform: translateZ(0px) rotateX(0deg);
  opacity: 1;
}
.modal.effect-flip-horizontal {
  perspective: 1300px;
}
.modal.effect-flip-horizontal .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateY(-70deg);
  transition: all 0.3s;
  opacity: 0;
}
.modal.effect-flip-horizontal.show .modal-dialog {
  transform: rotateY(0deg);
  opacity: 1;
}
.modal.effect-flip-vertical {
  perspective: 1300px;
}
.modal.effect-flip-vertical .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateX(-70deg);
  transition: all 0.3s;
  opacity: 0;
}
.modal.effect-flip-vertical.show .modal-dialog {
  transform: rotateX(0deg);
  opacity: 1;
}
.modal.effect-super-scaled .modal-dialog {
  transform: scale(2);
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-super-scaled.show .modal-dialog {
  transform: scale(1);
  opacity: 1;
}
.modal.effect-sign {
  perspective: 1300px;
}
.modal.effect-sign .modal-dialog {
  transform-style: preserve-3d;
  transform: rotateX(-60deg);
  transform-origin: 50% 0;
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-sign.show .modal-dialog {
  transform: rotateX(0deg);
  opacity: 1;
}
.modal.effect-rotate-bottom {
  perspective: 1300px;
}
.modal.effect-rotate-bottom .modal-dialog {
  transform-style: preserve-3d;
  transform: translateY(100%) rotateX(90deg);
  transform-origin: 0 100%;
  opacity: 0;
  transition: all 0.3s ease-out;
}
.modal.effect-rotate-bottom.show .modal-dialog {
  transform: translateY(0%) rotateX(0deg);
  opacity: 1;
}
.modal.effect-rotate-left {
  perspective: 1300px;
}
.modal.effect-rotate-left .modal-dialog {
  transform-style: preserve-3d;
  transform: translateZ(100px) translateX(-30%) rotateY(90deg);
  transform-origin: 0 100%;
  opacity: 0;
  transition: all 0.3s;
}
.modal.effect-rotate-left.show .modal-dialog {
  transform: translateZ(0px) translateX(0%) rotateY(0deg);
  opacity: 1;
}

.grid-showcase {
  margin-bottom: -10px;
}
.grid-showcase span, .grid-showcase .grid-wrapper {
  display: block;
  padding: 10px;
  margin-bottom: 10px;
  text-align: center;
  background-color: rgba(242, 243, 247, 0.7);
}

.grid-align {
  margin-bottom: -16px;
}

.grid-align .row {
  padding: 15px 0;
  min-height: 7rem;
  margin-bottom: 16px;
}

.grid-vertical {
  min-height: 150px;
  padding: 10px;
  color: #000000;
}

table.table-bordered thead tr th p {
  margin-bottom: 0;
}

/******* Vendors ******/
.select2-container {
  min-width: 100% !important;
  z-index: 99;
}
.select2-container .select2-selection--single {
  height: 40px;
}

.select2-container--default .select2-selection--single {
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  border-radius: 5px;
}
.select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #5B6670;
  line-height: 38px;
  border-radius: 5px;
  padding-left: 10px;
  font-size: 14px;
  font-weight: 400;
}
.select2-container--default .select2-selection--single .select {
  width: 219px;
}
.select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 40px;
  right: 6px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow b {
  position: absolute;
  top: 50%;
  left: 50%;
  border-color: #637381;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
  height: 0;
  margin-left: -6px;
  margin-top: -3px;
  width: 0;
  transform: rotate(45deg) translateY(-50%);
  -webkit-transform: rotate(45deg) translateY(-50%);
  -ms-transform: rotate(45deg) translateY(-50%);
}

.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: #000000;
  border-width: 2px 0 0 2px;
  margin-top: 3px;
  padding: 3px;
}

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #FF9F43;
  color: #ffffff;
}

.select2-container--focus .select2-selection--single {
  background: #ffffff !important;
  border-color: #FF9F43;
}

span.select2-container.select2-container--default.select2-container--open {
  z-index: 9999;
}

.select2-container--classic .select2-selection--single,
.select2-container--default .select2-selection--single,
.select2-container--default .select2-selection--single .select2-selection__rendered,
.select2-container--default .select2-selection--single .select2-selection__arrow,
.select2-container--default .select2-selection--multiple,
.select2-container--classic .select2-selection--single .select2-selection__arrow,
.select2-container--classic .select2-selection--single .select2-selection__rendered {
  border-color: #dbe0e6;
  color: #5B6670;
  height: 40px;
  line-height: 40px;
}

.select2-container--default .select2-selection--multiple {
  line-height: 27px;
  height: auto;
  min-height: 40px;
}

.select2-container--classic .select2-selection--multiple .select2-selection__choice,
.select2-container--default .select2-selection--multiple .select2-selection__choice,
.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  background-color: #17a2b8;
  border-color: #17a2b8;
  color: #ffffff;
}

table.dataTable > thead .sorting:after,
table.dataTable > thead .sorting_asc:after,
table.dataTable > thead .sorting_desc:after,
table.dataTable > thead .sorting_asc_disabled:after,
table.dataTable > thead .sorting_desc_disabled:after {
  right: 0.5em !important;
  content: "\\f107" !important;
  font-family: "Font Awesome 5 Free";
  bottom: 12px !important;
  color: #BABFC7 !important;
  font-size: 12px !important;
  opacity: 1 !important;
  position: absolute;
}

table.dataTable > thead .sorting:before,
table.dataTable > thead .sorting_asc:before,
table.dataTable > thead .sorting_desc:before,
table.dataTable > thead .sorting_asc_disabled:before,
table.dataTable > thead .sorting_desc_disabled:before {
  right: 0.5em !important;
  content: "\\f106" !important;
  font-family: "Font Awesome 5 Free";
  top: 12px !important;
  color: #BABFC7 !important;
  font-size: 12px !important;
  opacity: 1 !important;
  position: absolute;
}

.dataTables_paginate .paging_numbers {
  float: right;
}

.dataTables_info {
  float: right;
  padding-right: 15px;
  font-size: 12px;
  color: #495057;
  font-weight: 600;
}

.custom-select {
  min-width: 80px;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 95% 50%;
}

.dataTables_paginate .pagination li {
  margin: 0 5px;
}
.dataTables_paginate .pagination li a {
  background: var(--Stroke, rgba(145, 158, 171, 0.3));
  border-radius: 85px !important;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5B6670;
}
.dataTables_paginate .pagination li a:hover {
  background: #FF9F43;
  color: #ffffff;
}
.dataTables_paginate .pagination li.active a.page-link {
  background: #FF9F43;
  border-color: #FF9F43;
  border-radius: 85px;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dataTables_paginate .pagination li.previous.disabled {
  width: 20px;
}
.dataTables_paginate .pagination li.previous.disabled a {
  background-color: transparent;
  border: 0;
  width: 20px;
}
.dataTables_paginate .pagination li.next.disabled {
  width: 20px;
}
.dataTables_paginate .pagination li.next.disabled a {
  background-color: transparent;
  border: 0;
  width: 20px;
}

.dataTables_length,
.dataTables_paginate {
  margin-top: 15px !important;
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 23px;
}

table.dataTable thead > tr > th.no-sort.sorting_asc:before {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting_asc::after {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting:before {
  display: none;
}

table.dataTable thead > tr > th.no-sort.sorting::after {
  display: none;
}

/****** Layout ******/
.page-wrapper {
  transition: all 0.5s ease;
  margin: 0 0 0 260px;
  padding: 66px 0 0;
  position: relative;
  left: 0;
  transition: all 0.2s ease;
}
@media (max-width: 991.98px) {
  .page-wrapper {
    margin: 0;
    padding: 60px 0 0;
  }
}
.page-wrapper .content {
  padding: 24px;
  padding-bottom: 0;
}
@media (max-width: 991.98px) {
  .page-wrapper .content {
    padding: 15px;
  }
}
.page-wrapper .content .add-item.new-sale-items {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 100%;
}

.page-wrapper.details-blk {
  padding: 0;
  margin: 0;
}

.page-wrapper-new {
  background: #ffffff;
  padding: 24px;
  border-radius: 8px;
}
.page-wrapper-new .card {
  border: none;
}
.page-wrapper-new .card .card-body {
  border-top: 1px solid #f3f6f9;
}
.page-wrapper-new .page-header {
  margin-bottom: 40px;
}
.page-wrapper-new .page-header h4 {
  font-size: 20px;
}
.page-wrapper-new .page-header .page-btn .btn-added {
  padding: 8px 8px;
}

.sidebarrightmenu .page-wrapper {
  margin: 0 0 0 350px;
}
@media (max-width: 991.98px) {
  .sidebarrightmenu .page-wrapper {
    margin: 0;
  }
}

.card .card-header .dropset {
  color: #67748E;
  padding: 0 10px;
}
.card .card-body .loss-data {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.card .card-body .loss-data .input-groupicon {
  margin-right: 10px;
}
@media (max-width: 575px) {
  .card .card-body .loss-data {
    display: block;
  }
}
.card .card-body .input-blocks label span {
  color: #FF0000;
}
.card .card-body .text-title {
  margin-bottom: 20px;
}
.card .card-body .text-title p {
  font-size: 16px;
  font-weight: 600;
  color: #092C4C;
}
.card .card-body .payroll-info {
  border-bottom: 1px solid #f3f6f9;
}
.card .card-body .payroll-info .status-updates {
  margin-left: 25%;
}
.card .card-body .payroll-info .status-updates .form-check-input:checked {
  background-color: #FF9F43;
  border-color: #FF9F43;
}
.card .card-body .payroll-info .status-updates .form-check-input:focus {
  box-shadow: none;
  border-color: #f3f6f9;
}
.card .card-body .payroll-title {
  margin: 20px 0 20px 0;
}
.card .card-body .payroll-title p {
  font-size: 16px;
  font-weight: 600;
  color: #092C4C;
}
.card .card-body .sub-form {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f3f6f9;
}
.card .card-body .sub-form .subadd-btn .btn-add {
  border-radius: 8px;
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: #092C4C;
  color: #ffffff;
  padding: 7px 9px;
  margin-left: 20px;
  margin-bottom: -11px;
}
.card .card-body .view-btn {
  text-align: end;
}
.card .card-body .summary-blk {
  margin-bottom: 15px;
}
.card .card-body .summary-blk p {
  font-size: 14px;
  font-weight: 600;
  color: #092C4C;
}
.card .card-body .details td .view-product {
  border-radius: 6px;
  background: #F8F8F8;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.card .card-body .details td a {
  border-radius: 8px;
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
}
.card .card-body .details td a .feather-trash-2 {
  width: 14px;
  height: 14px;
  color: #FF0000;
}
.card .card-body .payslip-month {
  justify-content: space-between;
  align-items: center;
}
.card .card-body .payslip-month .month-of-slip h4 {
  font-weight: 700;
}
.card .card-body .emp-details {
  justify-content: space-between;
  align-items: center;
  background: #FAFBFE;
  padding: 10px;
}
.card .card-body .emp-details .emp-name-id h6 {
  font-size: 15px;
  font-weight: 600;
}
.card .card-body .emp-details .emp-name-id h6 span {
  font-size: 15px;
  font-weight: 400;
  color: #5B6670;
}
.card .card-body .emp-details .emp-location-info h6 {
  font-size: 15px;
  font-weight: 600;
}
.card .card-body .emp-details .emp-location-info h6 span {
  font-size: 15px;
  font-weight: 400;
  color: #5B6670;
}

.btn-white {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  background-color: #ffffff;
  border: 1px solid rgba(145, 158, 171, 0.32);
  color: #092C4C;
  padding: 3px 10px;
  border-radius: 5px;
  min-width: 90px;
}
.btn-white:hover {
  border: 1px solid rgba(145, 158, 171, 0.32);
}

.mail-search .form-control {
  height: 40px;
}

.inputcheck {
  display: block;
  position: relative;
  padding-left: 25px;
  cursor: pointer;
  color: #000000;
  font-weight: 500;
  font-size: 14px;
}
.inputcheck input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.inputcheck input:checked ~ .checkmark:after {
  display: block;
}
.inputcheck .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 20px;
  width: 20px;
  border: 1px solid #e8ebed;
  background: #f8f9fa;
  border-radius: 5px;
}
.inputcheck .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.inputcheck .checkmark:after {
  position: absolute;
  top: 3px;
  left: 6px;
  width: 5px;
  height: 10px;
  border: solid #FF9F43;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
}
.inputcheck input:checked ~ .checkmark {
  border: 1px solid #FF9F43;
}

.animation-tada {
  animation: tada 1.5s ease infinite;
}

.quantity-btn svg {
  stroke: 1px;
  width: 16px;
  height: 16px;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  border-radius: 50px !important;
}

::-webkit-scrollbar-track {
  background: #e8ebed;
}

::-webkit-scrollbar-thumb {
  background: #FF9F43;
}

::-webkit-scrollbar-thumb:hover {
  background: #e8ebed;
}

.swal2-header .swal2-title {
  font-size: 18px;
}

.none {
  display: none !important;
}

.text-red {
  color: #FF0000 !important;
}

.text-green {
  color: #28C76F !important;
}

.input-blocks input[type=text]:focus {
  border-color: #e9edf6;
}

.input-group .scanner-set {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FF9F43;
  border-radius: 5px !important;
  width: 40px;
  color: #ffffff;
  font-weight: 600;
  padding: 0;
}
.input-group .scanner-set:hover {
  background: #1B2850;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  border-radius: 50px !important;
}

::-webkit-scrollbar-track {
  background: #e8ebed;
}

::-webkit-scrollbar-thumb {
  background: #FF9F43;
}

::-webkit-scrollbar-thumb:hover {
  background: #e8ebed;
}

.swal2-header .swal2-title {
  font-size: 18px;
}

.none {
  display: none !important;
}

.text-red {
  color: #FF0000 !important;
}

.text-green {
  color: #28C76F !important;
}

.input-blocks input[type=text]:focus {
  border-color: #e9edf6;
}

.page-header {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 24px;
}
.page-header .breadcrumb {
  margin-bottom: 0;
}
@media (max-width: 575px) {
  .page-header {
    margin-bottom: 20px;
    flex-direction: column;
    align-items: self-start;
  }
}
.page-header h3 {
  font-weight: 700;
  color: #092C4C;
  font-size: 18px;
}
@media (max-width: 991.98px) {
  .page-header h3 {
    font-size: 14px;
  }
}
.page-header h4 {
  font-weight: 700;
  color: #092C4C;
  font-size: 18px;
  margin-bottom: 5px;
}
@media (max-width: 991.98px) {
  .page-header h4 {
    font-size: 18px;
  }
}
.page-header h6 {
  font-size: 14px;
  color: #495057;
  font-weight: 400;
}
@media (max-width: 991.98px) {
  .page-header h6 {
    font-size: 12px;
  }
}
@media (max-width: 575px) {
  .page-header h6 {
    font-size: 12px;
    margin-bottom: 20px;
  }
}
.page-header .btn-filter {
  background: #FF9F43;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 0;
}
.page-header .btn-filter:hover {
  background: linear-gradient(46.62deg, #FF9F43 0%, #423B93 93.64%);
}
.page-header .page-btn {
  margin-left: 10px;
}
@media (max-width: 575px) {
  .page-header .page-btn {
    margin-left: 0;
    margin-top: 20px;
  }
}
.page-header .btn-added {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #FF9F43;
  padding: 8px 11px;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
}
.page-header .btn-added:active {
  color: #ffffff;
}
.page-header .btn-added img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added {
    padding: 10px 10px;
  }
}
.page-header .btn-added:hover {
  background: #1B2850;
}
.page-header .btn-added .me-2 {
  width: 16px;
  height: 16px;
}
.page-header .btn-added.downloader {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #092C4C;
  padding: 9px 11px;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
  margin: 0 15px 0 15px;
}
.page-header .btn-added.downloader img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added.downloader {
    padding: 10px 10px;
  }
}
.page-header .btn-added.downloader:hover {
  background: #FF9F43;
}
.page-header .btn-added.downloader .me-2 {
  width: 16px;
  height: 16px;
}
.page-header .btn-added.printer {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  background: #FF0000;
  padding: 9px 11px;
  color: #ffffff;
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
}
.page-header .btn-added.printer img {
  filter: brightness(0) invert(1);
}
@media (max-width: 991.98px) {
  .page-header .btn-added.printer {
    padding: 10px 10px;
  }
}
.page-header .btn-added.printer:hover {
  background: #092C4C;
}
.page-header .btn-added.printer .me-2 {
  width: 16px;
  height: 16px;
}
@media (max-width: 767px) {
  .page-header .add-item {
    display: block !important;
  }
  .page-header .add-item .page-btn {
    margin-left: 0;
  }
}
@media (max-width: 575px) {
  .page-header .add-item .page-btn {
    margin-left: 0;
    margin-bottom: 24px;
  }
}
.page-header .add-item .page-title.modal-datail {
  line-height: 2;
}
.page-header .add-item.d-flex {
  margin-right: auto;
}
.page-header .add-item.payslip-list {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 100%;
}

.page-header.paysilp-header {
  padding: 24px;
  margin-bottom: 0;
  border-radius: 8px 8px 0px 0px;
  background: #FAFBFE;
}

.table-top {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 25px;
}
@media (max-width: 575px) {
  .table-top {
    flex-wrap: wrap;
    flex-direction: column;
    align-items: flex-start;
  }
  .table-top .wordset {
    margin-top: 25px;
  }
}

.search-set {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.search-set .search-input {
  position: relative;
  margin-right: 15px;
}
.search-set .search-input input[type=search] {
  height: 38px;
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: var(--White, #FFF);
  width: 298px;
  border-radius: 8px;
  padding: 10px;
}
.search-set .search-input input[type=search]::placeholder {
  color: #000000;
}
@media (max-width: 1199.98px) {
  .search-set .search-input input[type=search] {
    width: 220px;
  }
}
@media (max-width: 991.98px) {
  .search-set .search-input input[type=search] {
    width: 200px;
  }
}
@media (max-width: 575px) {
  .search-set .search-input input[type=search] {
    width: auto;
  }
}
.search-set .search-input .btn-searchset {
  border-radius: 50px;
  position: absolute;
  top: 0;
  right: 0;
  border: 0;
}
.search-set .search-input .btn-searchset .feather-search {
  width: 14px;
  height: 14px;
}

.search-path {
  margin-left: auto;
}
@media (max-width: 575px) {
  .search-path {
    margin-right: 0;
    margin-left: 0;
  }
}
@media (max-width: 575px) {
  .search-path {
    margin-top: 24px;
  }
}
.search-path .info-img {
  width: 16px;
  height: 16px;
  color: #ffffff;
}
.search-path .btn-filter {
  background: #FF9F43;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 0;
  margin-right: 15px;
}
.search-path .btn-filter span {
  display: none;
}
.search-path .btn-filter:hover {
  background: #1B2850;
}
.search-path .btn-filter.setclose {
  background: #FF0000;
}
.search-path .btn-filter.setclose > img {
  display: none;
}
.search-path .btn-filter.setclose span {
  display: block;
}
.search-path .btn-filter.setclose span img {
  display: block;
}
.search-path .btn-filter span {
  display: none;
}
.search-path .btn-filter > img {
  display: block;
}

.form-sort {
  position: relative;
  width: 149px;
  height: 38px;
}
.form-sort .info-img {
  position: absolute;
  top: 50%;
  z-index: 100;
  width: 16px;
  height: 16px;
  left: 0;
  margin-left: 10px;
  color: #5B6670;
  transform: translateY(-50%);
  line-height: normal;
}
@media (max-width: 575px) {
  .form-sort {
    margin-top: 24px;
  }
}

.swal2-actions .swal2-confirm {
  margin-right: 10px;
}

.wordset ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.wordset ul li {
  margin: 0 10px;
}
.wordset ul li a {
  display: block;
}

.custom-control.custom-checkbox .checkboxs {
  line-height: 1;
}

.custom-control.custom-checkbox .checkmarks {
  border-radius: 5px;
}

.custom-control.custom-checkbox .checkboxs input {
  cursor: auto;
}

.checkboxs {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.checkboxs input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}
.checkboxs input ~ .checkmarks {
  border: 1px solid #adb5bd;
  border-radius: 5px;
}
.checkboxs input:checked ~ .checkmarks {
  background-color: #FF9F43;
  border-color: #FF9F43;
}
.checkboxs input:checked ~ .checkmarks:after {
  display: block;
}
.checkboxs .checkmarks {
  height: 15px;
  width: 15px;
  position: absolute;
  top: 0;
  left: 0;
}
.checkboxs .checkmarks:after {
  content: "";
  position: absolute;
  display: none;
}
.checkboxs .checkmarks:after {
  left: 4px;
  top: 1px;
  width: 5px;
  height: 9px;
  border: solid #ffffff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
}

th .checkboxs .checkmarks, td .checkboxs .checkmarks {
  width: 18px;
  height: 18px;
}
th .checkboxs .checkmarks::after, td .checkboxs .checkmarks::after {
  left: 6px;
  top: 3px;
}

.image-upload {
  border: 1px solid rgba(145, 158, 171, 0.32);
  position: relative;
  margin-bottom: 35px;
  border-radius: 5px;
}
.image-upload:hover {
  background: #f3f6f9;
}
.image-upload input[type=file] {
  width: 100%;
  opacity: 0;
  height: 100px;
  position: relative;
  z-index: 9;
  cursor: pointer;
}
.image-upload .image-uploads {
  text-align: center;
  width: 100%;
  padding: 20px 0;
  border-radius: 5px;
  position: absolute;
  top: 0;
}
.image-upload .image-uploads h4 {
  font-size: 14px;
  font-weight: 500;
  color: #092C4C;
}
.image-upload.image-upload-new input[type=file] {
  height: 258px;
}
.image-upload.image-upload-new .image-uploads {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 100%;
  flex-direction: column;
}

.checktoggle {
  background-color: rgba(115, 103, 240, 0.2);
  border-radius: 12px;
  cursor: pointer;
  display: block;
  font-size: 0;
  height: 13px;
  margin-bottom: 0;
  position: relative;
  width: 25px;
}
.checktoggle:after {
  content: " ";
  display: block;
  transform: translate(2px, -50%);
  width: 10px;
  height: 10px;
  background-color: #ffffff;
  transition: left 300ms ease, transform 300ms ease;
  border-radius: 50%;
  transform: translate(2px, -50%);
  -webkit-transform: translate(2px, -50%);
  -ms-transform: translate(2px, -50%);
  position: absolute;
  top: 50%;
  left: 0;
}

.check:checked + .checktoggle:after {
  background-color: #ffffff;
  left: 100%;
  transform: translate(calc(-90% - 3px), -45%);
}

.check {
  display: block;
  margin: 0;
  padding: 0;
  width: 0;
  height: 0;
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  position: absolute;
}
.check:checked + .checktoggle {
  background-color: #28C76F;
}

#filter_inputs, #filter_inputs1, #filter_inputs2, #filter_inputs3 {
  border: 0;
  margin: 0;
}
#filter_inputs .card-body, #filter_inputs1 .card-body, #filter_inputs2 .card-body, #filter_inputs3 .card-body {
  padding: 0 24px 24px 24px;
}

.authentication-check .checkboxs {
  padding-left: 22px;
}
.authentication-check .checkboxs .checkmarks {
  border-radius: 5px;
  top: 4px;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: stretch;
  width: 100%;
}

#filter_inputs,
#filter_inputs1,
#filter_inputs2 {
  display: none;
}

.input-blocks {
  margin-bottom: 25px;
  position: relative;
}
.input-blocks .info-img {
  position: absolute;
  top: 50%;
  z-index: 100;
  width: 16px;
  height: 16px;
  left: 4px;
  margin-left: 10px;
  color: #5B6670;
  transform: translateY(-50%);
  line-height: normal;
}
.input-blocks .info-img.status-icon {
  margin-top: 2px;
}
.input-blocks label {
  margin-bottom: 8px;
  color: #092C4C;
  font-weight: 500;
  font-size: 14px;
  display: block;
}
.input-blocks label .manitory {
  color: #FF0000;
}
.input-blocks .input-groupicon {
  position: relative;
}
.input-blocks .input-groupicon .addonset {
  position: absolute;
  right: 12px;
  top: 50%;
  line-height: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
@media (max-width: 991.98px) {
  .input-blocks .input-groupicon .addonset {
    display: none;
  }
}
.input-blocks .input-groupicon.select-code input[type=text],
.input-blocks .input-groupicon.select-code input[type=password] {
  padding: 0;
}
.input-blocks .input-groupicon.select-code input[type=text]::placeholder,
.input-blocks .input-groupicon.select-code input[type=password]::placeholder {
  padding-left: 10px !important;
}
.input-blocks input[type=text],
.input-blocks input[type=password], .input-blocks input[type=email] {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #092C4C;
  padding: 10px 10px;
  border-radius: 5px;
  width: 100%;
}
.input-blocks .display-btn {
  color: #ffffff;
  border-radius: 8px;
  background: #092C4C;
  padding: 10px 34px;
  font-size: 14px;
  font-weight: 700;
}
.input-blocks .display-btn .info-img {
  position: absolute;
  top: 50%;
  z-index: 999;
  width: 16px;
  height: 16px;
  left: 5px;
  margin-left: 10px;
  margin-right: 8px;
  color: #ffffff;
  transform: translateY(-50%);
  line-height: normal;
}
.input-blocks .btn-filters {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FF9F43;
  color: #ffffff;
  width: 89px;
  height: 38px;
  border-radius: 8px;
  padding: 0;
}
.input-blocks .btn-filters:hover {
  background: #1B2850;
}
.input-blocks .btn-filters:active {
  color: #ffffff;
  background: #1B2850;
}
.input-blocks .btn-filters .feather-search {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.input-blocks textarea {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 100px;
  width: 100%;
  font-size: 14px;
  font-weight: 400;
  color: #000000;
  padding: 10px 15px;
  border-radius: 5px;
}
.input-blocks .text-form {
  width: 100%;
}

.input-blocks.date-group {
  margin-top: 29px;
}

.bd-placeholder-img {
  margin: 0.125rem;
}

.h-250 {
  height: 250px;
}

[data-layout-mode=dark_mode] {
  --bs-heading-color: \$black-bg;
  --dt-html-background: \$black-bg;
  background-color: #141432;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .searchinputs input {
  border-color: #141432;
  background: #2c2c50;
}
[data-layout-mode=dark_mode] h1, [data-layout-mode=dark_mode] .h1, [data-layout-mode=dark_mode] h2, [data-layout-mode=dark_mode] .h2, [data-layout-mode=dark_mode] h3, [data-layout-mode=dark_mode] .h3, [data-layout-mode=dark_mode] h4, [data-layout-mode=dark_mode] .h4, [data-layout-mode=dark_mode] h5, [data-layout-mode=dark_mode] .h5, [data-layout-mode=dark_mode] h6, [data-layout-mode=dark_mode] .h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode][data-nav-color=grey] .header {
  background: #141432;
}
[data-layout-mode=dark_mode][data-nav-color=grey] .header .user-menu .nav-item-box > a {
  background: #2c2c50;
}
[data-layout-mode=dark_mode][data-nav-color=grey] .sidebar .slimScrollDiv, [data-layout-mode=dark_mode][data-nav-color=grey] .sidebars .slimScrollDiv {
  background: #141432;
}
[data-layout-mode=dark_mode][data-nav-color=grey] .searchinputs input {
  border-color: #141432;
  background: #2c2c50;
}
[data-layout-mode=dark_mode][data-layout-style=collapsed][data-nav-color=grey] aside {
  background: #141432;
}
[data-layout-mode=dark_mode][data-layout-style=horizontal] .sidebar.horizontal-sidebar {
  background: #141432;
  border-top-color: #2c2c50;
}
[data-layout-mode=dark_mode][data-layout-style=horizontal] .horizontal-sidebar .sidebar-menu > ul > li.submenu ul {
  background: #141432;
}
[data-layout-mode=dark_mode][data-layout-style=modern] .page-wrapper .content {
  background: #141432;
}
[data-layout-mode=dark_mode]:root {
  --dt-html-background: \$black-bg;
}
[data-layout-mode=dark_mode][data-layout-style=collapsed] aside {
  background-color: #141432;
}
[data-layout-mode=dark_mode] .fc-unthemed th, [data-layout-mode=dark_mode] .fc-unthemed td, [data-layout-mode=dark_mode] .fc-unthemed thead, [data-layout-mode=dark_mode] .fc-unthemed tbody, [data-layout-mode=dark_mode] .fc-unthemed .fc-divider, [data-layout-mode=dark_mode] .fc-unthemed .fc-row, [data-layout-mode=dark_mode] .fc-unthemed .fc-popover {
  border-color: #2c2c50 !important;
}
[data-layout-mode=dark_mode] div#global-loader {
  background-color: #141432 !important;
}
[data-layout-mode=dark_mode] body {
  background-color: #141432;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] body.header-collapse .header .header-left {
  background-color: #141432;
}
[data-layout-mode=dark_mode] body.mini-sidebar .header-left .logo-white {
  display: none !important;
}
[data-layout-mode=dark_mode] body.expand-menu .header-left .logo-white {
  display: block !important;
}
[data-layout-mode=dark_mode] body .page-wrapper-new {
  background-color: #141432;
}
[data-layout-mode=dark_mode] body label, [data-layout-mode=dark_mode] body .form-label, [data-layout-mode=dark_mode] body .form-control, [data-layout-mode=dark_mode] body .notes-summernote p {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .header {
  background: #141432;
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .header .header-left {
  border-color: #353570;
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .header .header-left .logo-normal {
  display: none;
}
[data-layout-mode=dark_mode] .header .header-left .logo-white {
  display: block !important;
}
[data-layout-mode=dark_mode] table {
  background: #141432;
  --bs-table-bg: transparent;
}
[data-layout-mode=dark_mode] .sidebar {
  border-right: 1px solid #353570;
  background-color: #141432;
}
[data-layout-mode=dark_mode] .sidebar .slimScrollDiv {
  background: #141432;
}
[data-layout-mode=dark_mode] .sidebar.collapsed-sidebar {
  border: 0;
}
[data-layout-mode=dark_mode] .sidebar .sidebar-menu > ul > li.submenu ul {
  background: #141432;
  border-radius: 5px;
  padding: 10px 0;
}
[data-layout-mode=dark_mode] .sidebar .sidebar-menu > ul > li.submenu ul li a {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .sidebar .sidebar-menu > ul > li a img {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);
}
[data-layout-mode=dark_mode] .sidebar .sidebar-menu > ul > li a span {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .sidebar .sidebar-menu > ul > li a:hover img {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .sidebar .sidebar-menu > ul > li a:hover svg {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);
}
[data-layout-mode=dark_mode] .sidebar .sidebar-menu > ul > li .submenu-hdr {
  color: #adb5bd !important;
}
[data-layout-mode=dark_mode] .sidebar .sidebar-menu > ul > li.submenu-open ul, [data-layout-mode=dark_mode] .sidebars .sidebar-menu > ul > li.submenu-open ul {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .page-wrapper {
  background: #141432;
}
[data-layout-mode=dark_mode] .page-wrapper.page-wrapper-three .content {
  background: #141432;
}
[data-layout-mode=dark_mode] #toggle_btn:before {
  border: 2px solid #97A2D2;
}
[data-layout-mode=dark_mode] .user-menu.nav > li > a.select-store .user-info .user-name {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .user-info .user-name {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .user-menu .nav-item-box > a {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .header-left.active #toggle_btn:after {
  border: 2px solid #97A2D2;
}
[data-layout-mode=dark_mode] .dash-widget {
  background: #1d1d42;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .dash-widget .dash-widgetcontent h5 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .dash-widget .dash-widgetcontent h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .page-header h4, [data-layout-mode=dark_mode] .page-header h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .form-control {
  color: #97A2D2;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] select.form-control:focus {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .input-blocks label {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .dataTables_info {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .setvaluecash ul li a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .inbox-menu li a i {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .card {
  background-color: #1d1d42;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .card .card-header {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .card .card-header .card-title {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .card .card-body .card-title {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .modal-content {
  background-color: #212529;
}
[data-layout-mode=dark_mode] .modal-content .modal-header {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .inputcheck {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .custom_radio {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .fc th.fc-widget-header {
  background-color: #212529;
  border-color: #2c2c50;
}
[data-layout-mode=dark_mode] .fc-day {
  background-color: #212529 !important;
}
[data-layout-mode=dark_mode] .chat-cont-left .chat-scroll .media .media-body .user-name, [data-layout-mode=dark_mode] .chat-cont-left .chat-scroll .media .media-body .user-last-chat {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .chat-cont-left .chat-scroll .media.active, [data-layout-mode=dark_mode] .chat-cont-left .chat-scroll .media:hover {
  background: #1B2850;
}
[data-layout-mode=dark_mode] .chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box p {
  color: #092C4C;
}
[data-layout-mode=dark_mode] .inbox-menu li a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .increment-decrement .quantity-field {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .select2-results__options {
  color: #343a40;
}
[data-layout-mode=dark_mode] .image-upload .image-uploads h4 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .horizontal-sidebar {
  background: #141432;
  border-top: 1px solid #353570;
}
[data-layout-mode=dark_mode] .horizontal-sidebar.side-three {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .horizontal-sidebar .sidebar-menu > ul > li > a span {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .horizontal-sidebar .sidebar-menu > ul > li > a img, [data-layout-mode=dark_mode] .horizontal-sidebar .sidebar-menu > ul > li > a svg {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue- rotate(165deg) brightness(93%) contrast(88%);
}
[data-layout-mode=dark_mode] .horizontal-sidebar .sidebar-menu > ul > li.submenu ul {
  background: #141432;
}
[data-layout-mode=dark_mode] .horizontal-sidebar .sidebar-menu > ul > li.submenu ul li a {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .horizontal-sidebar .sidebar-menu > ul > li.submenu ul li img, [data-layout-mode=dark_mode] .horizontal-sidebar .sidebar-menu > ul > li.submenu ul li svg {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%) !important;
}
[data-layout-mode=dark_mode] .horizontal-sidebar .sidebar-menu > ul > li.submenu ul li > ul {
  box-shadow: none;
}
[data-layout-mode=dark_mode] .sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a svg {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);
}
[data-layout-mode=dark_mode] .sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu ul li a {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .table thead {
  background: #141432;
  border-bottom: 1px solid #141432;
}
[data-layout-mode=dark_mode] .table thead tr:hover {
  background: transparent;
}
[data-layout-mode=dark_mode] .table thead tr th {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .table tbody tr:hover {
  background: transparent;
}
[data-layout-mode=dark_mode] .table tbody tr td {
  color: #97A2D2;
  border-bottom: 1px solid #353570;
  background: #1d1d42;
}
[data-layout-mode=dark_mode] .table tbody tr td a {
  color: #97A2D2 !important;
}
[data-layout-mode=dark_mode] .table tbody tr td a:hover {
  color: #FF9F43 !important;
}
[data-layout-mode=dark_mode] .table tbody tr td.action-table-data .edit-delete-action a:hover {
  background-color: rgb(40, 142, 199);
  border-color: rgb(40, 142, 199);
}
[data-layout-mode=dark_mode] .table tbody tr td.action-table-data .edit-delete-action .confirm-text:hover {
  background-color: #FF0000;
  border-color: #FF0000;
}
[data-layout-mode=dark_mode] .table tbody tr td.action-table-data a .action-eye {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .sidebar.collapsed-sidebar .ui-aside .nav-item .nav-link {
  border-bottom: #353570;
}
[data-layout-mode=dark_mode] .sidebar.collapsed-sidebar .sidebar-menu ul li a img {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);
}
[data-layout-mode=dark_mode] .select2-results__option {
  background: #212529;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .custom-file-container label {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .select2-dropdown {
  border: 2px solid #26264e;
}
[data-layout-mode=dark_mode] .swal2-popup {
  background-color: #212529;
}
[data-layout-mode=dark_mode] .swal2-popup .swal2-title {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .swal2-popup .swal2-html-container {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .searchinputs input {
  border: 1px solid #353570;
  background: #1d1d42;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .searchinputs input::placeholder {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .image-upload-new .productviewscontent .productviewsname h2, [data-layout-mode=dark_mode] .image-upload-new .productviewscontent .productviewsname h3 {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .split-card::before, [data-layout-mode=dark_mode] .split-card::after {
  background: #353570;
}
[data-layout-mode=dark_mode] input[type=email] {
  border: 1px solid #495057;
}
[data-layout-mode=dark_mode] .tabs-set .nav-tabs .nav-link {
  background: #141432;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .tabs-set .nav-tabs .nav-link.active {
  background: #FF9F43;
  color: #ffffff;
}
[data-layout-mode=dark_mode] .bor-b1 {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .total-order ul li {
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .total-order ul li:first-child {
  border-top: 1px solid #353570;
}
[data-layout-mode=dark_mode] .total-order ul li h4 {
  border-right: 1px solid #353570;
}
[data-layout-mode=dark_mode] hr {
  background-color: #353570;
  border-top: 1px solid #353570;
}
[data-layout-mode=dark_mode] .inputcheck .checkmark {
  background: transparent;
}
[data-layout-mode=dark_mode] .productset {
  background-color: #212529;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .productset .productsetcontent h4 {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .graph-sets .btn-light {
  background-color: #141432 !important;
  color: #adb5bd !important;
  border: 1px solid #353570 !important;
  box-shadow: none;
}
[data-layout-mode=dark_mode] .graph-sets .btn-light:hover {
  color: #adb5bd !important;
}
[data-layout-mode=dark_mode] .graph-sets .btn-white {
  background-color: #141432;
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .graph-sets .btn-white:hover {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .graph-sets .dropdown-menu {
  background-color: #141432;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .graph-sets .dropdown-menu .dropdown-item {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .graph-sets .dropdown-menu .dropdown-item:hover {
  color: #adb5bd;
  background: #212529;
}
[data-layout-mode=dark_mode] .view-all-link a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .view-all-link a:hover {
  color: #FF9F43;
}
[data-layout-mode=dark_mode] .header .dropdown-menu {
  background: #141432;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .order-list .orderid h4, [data-layout-mode=dark_mode] .order-list .orderid h5 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .productimg .productcontet h4 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .topnav-dropdown-header {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .topnav-dropdown-header .notification-title {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .topnav-dropdown-footer {
  border-top: 1px solid #353570;
}
[data-layout-mode=dark_mode] .topnav-dropdown-footer a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .topnav-dropdown-footer a:hover {
  color: #FF9F43;
}
[data-layout-mode=dark_mode] .user-menu.nav > li > a.select-store {
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .custom-file-container .custom-file-container__custom-file__custom-file-control__button {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .notifications .notification-list li {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .notifications .notification-list li .noti-title {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .notifications .notification-list li .noti-details {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .notifications .notification-list li .notification-time {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .user-menu.nav li.flag-nav .dropdown-menu .dropdown-item {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .user-menu.nav li.flag-nav .dropdown-menu .dropdown-item.active {
  color: #ffffff;
}
[data-layout-mode=dark_mode] .user-menu.nav li.flag-nav .dropdown-menu .dropdown-item:hover {
  background: #212529 url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat calc(100% - 12px) center;
}
[data-layout-mode=dark_mode] .user-menu.nav.nav > li > a.dropdown-toggle.nav-link.show {
  background: #212529;
}
[data-layout-mode=dark_mode] .profilename .profileset h5, [data-layout-mode=dark_mode] .profilename .profileset h6 {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .header .menu-drop-user .dropdown-item {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .header .menu-drop-user .dropdown-item:hover {
  color: #adb5bd;
  background: #212529;
}
[data-layout-mode=dark_mode] .card.bg-white {
  background-color: #212529 !important;
}
[data-layout-mode=dark_mode] .card .card-header {
  background-color: #1d1d42;
}
[data-layout-mode=dark_mode] .card .card-header .dropset {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .card .card-footer {
  background-color: #212529;
}
[data-layout-mode=dark_mode] .custom-file-container .custom-file-container__custom-file__custom-file-control {
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .custom-file-container .custom-file-container__custom-file__custom-file-control .custom-file-container__custom-file__custom-file-control__button {
  border-left: 1px solid #353570;
}
[data-layout-mode=dark_mode] .scanner-set img {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);
  width: 16px;
}
[data-layout-mode=dark_mode] .dropdown-menu {
  background: #141432;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .dropdown-menu .dropdown-item {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .dropdown-menu .dropdown-item:hover {
  color: #adb5bd;
  background: #212529;
}
[data-layout-mode=dark_mode] .page-header h3 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .search-set .search-input input[type=search] {
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .search-set .search-input input[type=search]::placeholder {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .input-blocks input[type=text], [data-layout-mode=dark_mode] .input-blocks input[type=password],
[data-layout-mode=dark_mode] .select2-container--default .select2-selection--single,
[data-layout-mode=dark_mode] .select2-container--focus .select2-selection--single, [data-layout-mode=dark_mode] .form-control, [data-layout-mode=dark_mode] .form-select,
[data-layout-mode=dark_mode] .select2-container--default .select2-selection--multiple {
  background: #1d1d42 !important;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .input-blocks input[type=text]::placeholder, [data-layout-mode=dark_mode] .input-blocks input[type=password]::placeholder,
[data-layout-mode=dark_mode] .select2-container--default .select2-selection--single::placeholder,
[data-layout-mode=dark_mode] .select2-container--focus .select2-selection--single::placeholder, [data-layout-mode=dark_mode] .form-control::placeholder, [data-layout-mode=dark_mode] .form-select::placeholder,
[data-layout-mode=dark_mode] .select2-container--default .select2-selection--multiple::placeholder {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .select2-container--default .select2-results__option[aria-selected=true] {
  background: #212529 !important;
  color: #97A2D2 !important;
}
[data-layout-mode=dark_mode] .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #97A2D2;
  border-color: #353570;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .select2-container--default .select2-selection--single {
  border-color: #353570;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .select2-container--focus .select2-selection--single {
  border-color: #353570;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .input-blocks input[type=text]:focus {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .custom-file-container .custom-file-container__custom-file__custom-file-control {
  background: #212529;
  color: #97A2D2;
  border-color: transparent;
}
[data-layout-mode=dark_mode] .input-group-text {
  background: #212529;
  color: #97A2D2;
  border: 1.5px solid rgba(145, 158, 171, 0.32);
}
[data-layout-mode=dark_mode] .image-upload:hover {
  background: #212529;
}
[data-layout-mode=dark_mode] .productdetails > ul > li h4 {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .profile-set .profile-top .profile-contentname h2 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .total-order ul li h4 {
  background: #212529;
}
[data-layout-mode=dark_mode] .total-order ul li h5 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .product-details {
  background: #212529;
}
[data-layout-mode=dark_mode] .product-details h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .comp-section .card-header {
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .comp-section .nav-tabs.nav-tabs-solid {
  background-color: #212529;
}
[data-layout-mode=dark_mode] .list-group-item {
  background: #212529;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .bg-white {
  background-color: #212529 !important;
}
[data-layout-mode=dark_mode] .section-header .section-title {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .breadcrumb .breadcrumb-item a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .product-list ul li .productviews .productviewscontent .productviewsname h2, [data-layout-mode=dark_mode] .product-list ul li .productviews .productviewscontent .productviewsname h3 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: #97A2D2;
}
[data-layout-mode=dark_mode] .alertify .ajs-header {
  background: #212529;
}
[data-layout-mode=dark_mode] .alertify .ajs-dialog {
  background: #212529;
}
[data-layout-mode=dark_mode] .alertify .ajs-footer {
  background: #212529;
}
[data-layout-mode=dark_mode] .alertify .ajs-footer .ajs-buttons .ajs-button {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .bs-popover-auto[data-popper-placement^=top] > .popover-arrow::after, [data-layout-mode=dark_mode] .bs-popover-top > .popover-arrow::after {
  border-top-color: #353570;
}
[data-layout-mode=dark_mode] .popover {
  background-color: #212529;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .popover .popover-header {
  background-color: #212529;
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .popover .popover-body {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .scroll-demo {
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .timeline:before {
  background-color: #353570;
}
[data-layout-mode=dark_mode] .timeline > li > .timeline-panel {
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .timeline > li > .timeline-panel::before {
  border-top: 8px solid transparent;
  border-right: 0 solid #353570;
  border-bottom: 8px solid transparent;
  border-left: 8px solid #353570;
}
[data-layout-mode=dark_mode] .timeline > li > .timeline-panel::after {
  border-top: 7px solid transparent;
  border-right: 0 solid #353570;
  border-bottom: 7px solid transparent;
  border-left: 7px solid #353570;
}
[data-layout-mode=dark_mode] .timeline > li.timeline-inverted > .timeline-panel:after {
  border-right-width: 7px;
  border-left-width: 0;
}
[data-layout-mode=dark_mode] .timeline > li.timeline-inverted > .timeline-panel::before {
  border-right-width: 8px;
  border-left-width: 0;
}
[data-layout-mode=dark_mode] .twitter-bs-wizard .twitter-bs-wizard-nav .nav-link::after {
  background-color: #353570;
}
[data-layout-mode=dark_mode] .btn-white {
  background-color: #141432;
  border: 1px solid #353570;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .calendar-events:hover {
  background-color: #353570;
  border: 1px solid #353570;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .fc-button {
  color: #97A2D2;
  background: #092C4C;
  text-shadow: none;
}
[data-layout-mode=dark_mode] .sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a span {
  color: #adb5bd !important;
}
[data-layout-mode=dark_mode] .sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a img, [data-layout-mode=dark_mode] .sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a svg {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);
}
[data-layout-mode=dark_mode] .cardhead .card-header {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .sidebar-content {
  background: #212529;
}
[data-layout-mode=dark_mode] .sidebar-content .sidebar-header {
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .sidebar-content .sidebar-header h5 {
  color: #ffffff;
}
[data-layout-mode=dark_mode] .sidebar-content .sidebar-header a img {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);
}
[data-layout-mode=dark_mode] .sidebar-content .switch-wrapper {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .sidebar-content .layout-wrap .status-text {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .sidebar-content .layout-wrap .status-toggle .checktoggle {
  background: #97A2D2;
}
[data-layout-mode=dark_mode] .login-logo.logo-normal {
  display: none;
}
[data-layout-mode=dark_mode] .login-logo.logo-white {
  display: block !important;
}
[data-layout-mode=dark_mode] .login-wrapper .login-content .login-userheading h3, [data-layout-mode=dark_mode] .login-wrapper .login-content .login-userheading h4 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .login-wrapper .login-content .form-login label {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .login-wrapper .login-content .signinform h4 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .login-wrapper .login-content .signinform h4 a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .login-wrapper .login-content .form-sociallink ul li a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .login-wrapper .login-content .form-sociallink ul li a:hover {
  color: #ffffff;
}
[data-layout-mode=dark_mode] .login-wrapper .login-content .form-login input {
  background: #212529 !important;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .login-wrapper .login-content .form-login input::placeholder {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .welcome {
  background-color: #141432;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .table-top-head li a {
  background-color: #141432;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .table-top-head li a svg {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .table-top-head li a:hover {
  background: #1B2850;
}
[data-layout-mode=dark_mode] .sales-cards .card h3, [data-layout-mode=dark_mode] .sales-cards .card p {
  color: #97A2D2 !important;
}
[data-layout-mode=dark_mode] .main-chat-blk .all-chats {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat-member-details .member-details ul li span, [data-layout-mode=dark_mode] .main-chat-blk .chat-member-details .member-details ul li h5 {
  color: #67748E;
}
[data-layout-mode=dark_mode] .main-chat-blk .right-sidebar .right-sidebar-wrap {
  background: #141432;
}
[data-layout-mode=dark_mode] .main-chat-blk .sidebar-body .profile-name {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat-page-wrapper .setting-title-head h4 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat-page-wrapper .left-chat-title {
  border-bottom-color: #67748E;
  background: #141432;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat-page-wrapper .dropdown-menu {
  background: #141432;
  border-color: #67748E;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item i {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .top-online-contacts {
  background: #141432;
}
[data-layout-mode=dark_mode] .main-chat-blk .sidebar-body {
  background: #141432;
}
[data-layout-mode=dark_mode] .main-chat-blk .sidebar .user-list li a {
  border-color: #67748E;
}
[data-layout-mode=dark_mode] .main-chat-blk .sidebar .user-list li .users-list-body h5, [data-layout-mode=dark_mode] .main-chat-blk .sidebar .user-list li .users-list-body p {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {
  color: #B8BCC9 !important;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat {
  background: #141432;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat .chat-header {
  background: #141432;
  box-shadow: none;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat .chat-header .user-details h5, [data-layout-mode=dark_mode] .main-chat-blk .chat .chat-header .user-details small {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat .chat-header li a i {
  color: #67748E;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
  border-right-color: #67748E;
}
[data-layout-mode=dark_mode] .part-name.sub-part-name, [data-layout-mode=dark_mode] .recession-meet-blk .partispant-blk span a {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .part-name.sub-part-name h4, [data-layout-mode=dark_mode] .recession-meet-blk .partispant-blk span a h4 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .more-icon a {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .recession-meet-blk .reccession-head h5 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .welcome button, [data-layout-mode=dark_mode] .welcome a {
  border-color: #353570;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .bar-code-view {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .productdetails > ul > li {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .productdetails > ul > li h4 {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .productdetails > ul > li:last-child {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .productdetails > ul > li:first-child {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .right-user-side .slimscroll {
  background: #141432;
  border-color: #67748E;
}
[data-layout-mode=dark_mode] .right-user-side .slimscroll .left-chat-title {
  background: #092C4C;
  border-bottom-color: #67748E !important;
}
[data-layout-mode=dark_mode] .right-user-side .slimscroll .left-chat-title .chat-title h4 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .right-user-side .slimscroll .chat-footer {
  background: #141432;
}
[data-layout-mode=dark_mode] .right-user-side.right-side-party .slimscroll {
  background: #141432;
  border-color: #67748E;
}
[data-layout-mode=dark_mode] .right-user-side.right-side-party .slimscroll .left-chat-title {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .right-user-side.right-side-party .slimscroll .left-chat-title .chat-title h4 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .right-user-side.right-side-party .slimscroll .chat-footer {
  background: #141432;
}
[data-layout-mode=dark_mode] .right-user-side.right-side-party .slimscroll .card-body-blk .user-list .user-list-item {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .history-modal-profile .right-sidebar-profile {
  background: #141432;
}
[data-layout-mode=dark_mode] .modal-profile-detail .modal-userlist li {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .fc-unthemed td {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .notes-dash {
  background: #141432;
  border-color: #353570;
}
[data-layout-mode=dark_mode] .notes-dash .notes-top-head {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .notes-dash .notes-top-head h5 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .notes-dash .content-submenu-tag h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .notes-page-wrapper .content .section-bulk-wrap {
  background: #141432;
  box-shadow: 0px 4px 60px 0px rgba(0, 0, 0, 0.7);
}
[data-layout-mode=dark_mode] .notes-page-wrapper .content .section-card-body .notes-card-details {
  background: #141432;
  box-shadow: 0px 4px 60px 0px rgba(0, 0, 0, 0.1);
  border-color: #353570;
}
[data-layout-mode=dark_mode] .notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body a {
  color: #5B6670;
}
[data-layout-mode=dark_mode] .notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content h4 a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .notes-page-wrapper .content .section-card-body .dropdown-menu {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .notes-page-wrapper .content .notes-card-body .dropdown-menu {
  border-color: #353570;
  box-shadow: unset;
}
[data-layout-mode=dark_mode] .notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a {
  color: #5B6670;
}
[data-layout-mode=dark_mode] .notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content h4 a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .todo-today-content .todo-today-header h3 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .todo-wrapper-list {
  background: #141432;
  border-color: #353570;
}
[data-layout-mode=dark_mode] .todo-wrapper-list .todo-inbox-check .todo-wrapper-list-content h4 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .dropdown-menu.notes-menu a.dropdown-item {
  color: #adb5bd;
}
[data-layout-mode=dark_mode] .notes-header h3 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .custom-modal-header {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .custom-modal-header .page-title h4 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .search-set .search-input .btn-searchset {
  color: #5B6670;
}
[data-layout-mode=dark_mode] .accordion {
  background: transparent;
  --bs-accordion-bg: \$card-dark-bg;
}
[data-layout-mode=dark_mode] .accordion .accordion-item {
  background: #1d1d42;
}
[data-layout-mode=dark_mode] .accordion-card-one .accordion-item .accordion-button:not(.collapsed) {
  background: transparent !important;
}
[data-layout-mode=dark_mode] .accordion-card-one .accordion-item .accordion-button .addproduct-icon h5 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .card .card-body.add-product .text-editor.add-list.add .custom-filed {
  background: transparent;
}
[data-layout-mode=dark_mode] .bootstrap-tagsinput {
  background: #141432;
  border: 1px solid #495057;
}
[data-layout-mode=dark_mode] .product-quantity {
  background: #141432;
}
[data-layout-mode=dark_mode] .product-quantity span {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .product-quantity input {
  background: #141432;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .searchinputs.list input {
  background: #141432;
}
[data-layout-mode=dark_mode] .table-tab ul li button.nav-link {
  color: #97A2D2;
  background-color: #1d1d42;
}
[data-layout-mode=dark_mode] .table-top-head li .status-toggle {
  background: #141432;
}
[data-layout-mode=dark_mode] .barcode-content-list {
  background: #141432;
}
[data-layout-mode=dark_mode] .barcode-content-list .search-modal-header {
  background: #212529;
}
[data-layout-mode=dark_mode] .barcode-content-list .paper-search-size .search-toggle-list p {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .barcode-scanner-link {
  background: #141432;
}
[data-layout-mode=dark_mode] .barcode-scanner-link h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .seacrh-barcode-item .searchInput {
  background: #141432;
}
[data-layout-mode=dark_mode] .barcode-scan-header h5 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .modal-body-table {
  background: #212529;
}
[data-layout-mode=dark_mode] span.customer-toggle, [data-layout-mode=dark_mode] .status-label {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .layout-drop-item .drop-item-head h5, [data-layout-mode=dark_mode] p {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .total-employees {
  background: #141432;
}
[data-layout-mode=dark_mode] .total-employees h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .employee-grid-profile {
  border-color: #495057;
  background: #141432;
}
[data-layout-mode=dark_mode] .employee-grid-profile ul.department {
  background: #212529;
}
[data-layout-mode=dark_mode] .employee-grid-profile ul.department li {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .employee-grid-profile .profile-info.department-profile-info {
  background: #212529;
}
[data-layout-mode=dark_mode] aside {
  border-color: #353570;
}
[data-layout-mode=dark_mode] aside.product-order-list .block-section {
  border-color: #353570;
}
[data-layout-mode=dark_mode] aside.product-order-list .btn-block {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .product-wrap .product-list .action a {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .pos-categories, [data-layout-mode=dark_mode] aside, [data-layout-mode=dark_mode] .pos-products .product-info .img-bg {
  background: #141432;
}
[data-layout-mode=dark_mode] aside.product-order-list .order-total, [data-layout-mode=dark_mode] aside.product-order-list .order-total table {
  background: #212529;
}
[data-layout-mode=dark_mode] .product-wrap .product-list {
  box-shadow: none;
  background: #212529;
}
[data-layout-mode=dark_mode] .pos-categories h5, [data-layout-mode=dark_mode] .pos-categories h6, [data-layout-mode=dark_mode] .order-list h5, [data-layout-mode=dark_mode] .order-list h6, [data-layout-mode=dark_mode] .pos-products .product-info h6.product-name a, [data-layout-mode=dark_mode] .product-wrap .product-list .qty-item .dec, [data-layout-mode=dark_mode] .product-wrap .product-list .qty-item .inc, [data-layout-mode=dark_mode] aside.product-order-list .payment-method .methods .default-cover a span, [data-layout-mode=dark_mode] .product-wrap .product-list .info h6 a, [data-layout-mode=dark_mode] .file-manager aside h5, [data-layout-mode=dark_mode] .file-manager aside ul li a, [data-layout-mode=dark_mode] .file-manager h4, [data-layout-mode=dark_mode] .file-manager h6 a, [data-layout-mode=dark_mode] .file-manager .accordion .accordion-item .accordion-button::after, [data-layout-mode=dark_mode] .fc-toolbar h2, [data-layout-mode=dark_mode] .file-manager, [data-layout-mode=dark_mode] .file-manager .card, [data-layout-mode=dark_mode] .search-dropdown .search-info h6, [data-layout-mode=dark_mode] .search-dropdown .search-info h6 svg, [data-layout-mode=dark_mode] .search-set .search-input .btn-searchset .feather-search {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .file-manager aside .dropdown > a .feather-16, [data-layout-mode=dark_mode] .file-manager aside ul li a .feather-16, [data-layout-mode=dark_mode] .file-manager .project-plan ul li, [data-layout-mode=dark_mode] .file-manager .project-plan label, [data-layout-mode=dark_mode] .file-manager .page-header .btn-added .feather-16 {
  color: #ffffff;
}
[data-layout-mode=dark_mode] aside.product-order-list .head, [data-layout-mode=dark_mode] .file-manager .info, [data-layout-mode=dark_mode] .file-manager .folders {
  background: #212529;
}
[data-layout-mode=dark_mode] .file-manager .folders {
  border-color: #353570;
  background: #1d1d42;
}
[data-layout-mode=dark_mode] .file-manager .folders, [data-layout-mode=dark_mode] .file-manager .info {
  box-shadow: none;
}
[data-layout-mode=dark_mode] aside.product-order-list .payment-method .methods .default-cover img {
  filter: invert(75%) sepia(66%) saturate(1955%) hue-rotate(327deg) brightness(103%) contrast(102%);
}
[data-layout-mode=dark_mode] .page-wrapper .content.settings-content, [data-layout-mode=dark_mode] .sidebars {
  background: #141432;
}
[data-layout-mode=dark_mode] .sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a span {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a.active {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a.active.subdrop {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a svg {
  color: #67748E;
}
[data-layout-mode=dark_mode] .security-settings ul li .security-btn .manage-btn {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .security-settings ul li .security-type .security-icon {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .connected-app-card ul {
  background: #141432;
  box-shadow: 0px 4px 60px 0px #343a40;
}
[data-layout-mode=dark_mode] .connected-app-card ul li .integration-btn a {
  background: #092C4C;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .header-left #toggle_btn svg, [data-layout-mode=dark_mode] .btn-row .btn svg {
  color: #ffffff;
}
[data-layout-mode=dark_mode] .table.profit-table thead, [data-layout-mode=dark_mode] .table.profit-table tbody .profit-table-bg td {
  background: #092C4C;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .comming-soon-pg .coming-soon-box {
  background: #092C4C;
  opacity: 0.9;
}
[data-layout-mode=dark_mode] .comming-soon-pg .coming-soon-box .coming-soon-timer li {
  background: #092C4C;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .comming-soon-pg .coming-soon-box .coming-soon-timer li span {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .login-wrapper.bg-img .login-content {
  background: #092C4C;
  opacity: 0.9;
}
[data-layout-mode=dark_mode] .login-wrapper .login-content .login-logo {
  display: none;
}
[data-layout-mode=dark_mode] .pos-modal .modal-header, [data-layout-mode=dark_mode] .pos-modal#hold-order h2 {
  background: #141432;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .pos-modal#orders .order-body .record table {
  background: transparent;
}
[data-layout-mode=dark_mode] .tabs_wrapper ul.tabs li {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .pos-category .default-cover h6 a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .pos-category .default-cover span {
  color: #B8BCC9;
}
[data-layout-mode=dark_mode] .pos-category .owl-item {
  background: #092C4C;
  box-shadow: none;
  border-color: #353570;
}
[data-layout-mode=dark_mode] .pos-category .owl-item h6 a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] aside.product-order-list h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] aside.product-order-list .head h5 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] #print-receipt .modal-body .tax-invoice span, [data-layout-mode=dark_mode] #print-receipt .modal-body table thead th, [data-layout-mode=dark_mode] #print-receipt .modal-body table tbody tr table tr:last-child td {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] aside.product-order-list .order-total table tr td {
  border-bottom: none;
}
[data-layout-mode=dark_mode] #print-receipt .modal-body table {
  background: none;
}
[data-layout-mode=dark_mode] .sidebar-footer {
  background: #141432;
}
[data-layout-mode=dark_mode] .sidebar-content .theme-head h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] table tbody td.action-table-data a {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .disabled > .page-link {
  color: #67748E;
}
[data-layout-mode=dark_mode] .apply-leave {
  background: #1d1d42;
}
[data-layout-mode=dark_mode] .card .card-body .payslip-month .month-of-slip h4 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .paysilp-table-border th, [data-layout-mode=dark_mode] .payslip-border-bottom th {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .card .card-body .emp-details .emp-name-id h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .card .card-body .emp-details .emp-name-id span {
  color: #5B6670;
}
[data-layout-mode=dark_mode] .card .card-body .emp-details .emp-location-info h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .card .card-body .emp-details .emp-location-info span {
  color: #5B6670;
}
[data-layout-mode=dark_mode] .pay-slip-box .card .card-body .emp-details.justify-content-start {
  background: #141432;
}
[data-layout-mode=dark_mode] .card .card-body .emp-details {
  background: #141432;
}
[data-layout-mode=dark_mode] .connected-app-card ul li .security-title h5, [data-layout-mode=dark_mode] .appearance-settings h6, [data-layout-mode=dark_mode] .logo-company li .logo-info h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .localization-info .setting-info h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .login-wrapper .login-content.user-login .login-userset {
  background: #1d1d42;
  border-color: #1d1d42;
  box-shadow: unset;
}
[data-layout-mode=dark_mode] .custom-alert1 {
  background: #212529;
}
[data-layout-mode=dark_mode] .custom-alert-icon {
  background: #212529 !important;
}
[data-layout-mode=dark_mode] .accordion-button, [data-layout-mode=dark_mode] .accordion .accordion-button.collapsed {
  background: transparent !important;
}
[data-layout-mode=dark_mode] .accordion-button::after, [data-layout-mode=dark_mode] .accordion .accordion-button.collapsed::after {
  background: #212529;
}
[data-layout-mode=dark_mode] .accordion-body {
  background: #1d1d42;
}
[data-layout-mode=dark_mode] .offcanvas {
  background: #1d1d42;
  color: #97A2D2 !important;
}
[data-layout-mode=dark_mode] .activity .activity-list li {
  background-color: #141432;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .activity .activity-list li .activity-content {
  background-color: #141432;
}
[data-layout-mode=dark_mode] .activity .activity-list li a {
  color: #495057;
}
[data-layout-mode=dark_mode] .activity .activity-list li a:hover {
  color: #FF9F43;
}
[data-layout-mode=dark_mode] .activity .activity-list li a.name {
  color: #dbe0e6;
}
[data-layout-mode=dark_mode] .activity .activity-list li a.name:hover {
  color: #FF9F43;
}
[data-layout-mode=dark_mode] .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background: #FF9F43 !important;
  color: #fff !important;
}
[data-layout-mode=dark_mode] .profile-pic-upload .profile-pic span {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .search-dropdown .search-info {
  border-bottom: 1px solid #67748E;
}
[data-layout-mode=dark_mode] .card .card-body.add-product .addproduct-icon {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .add-product .add-icon a {
  color: #B8BCC9;
}
[data-layout-mode=dark_mode] .table-list-card .table-responsive {
  border-top: 1px solid #353570;
}
[data-layout-mode=dark_mode] .appearance-settings .theme-type-images .theme-image {
  background: #092C4C;
  border-color: #092C4C;
  box-shadow: 0px 4px 60px 0px rgba(0, 0, 0, 0.1);
}
[data-layout-mode=dark_mode] .attendance-widget .card .card-body .card.attendance {
  background: #141432;
}
[data-layout-mode=dark_mode] .audio-call-group ul li .user-audio-call h5 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .record-time span {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .bank-box.active::after {
  background-color: #343a40;
}
[data-layout-mode=dark_mode] .bank-box .bank-header .bank-name h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .bank-box .bank-header .bank-name p {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .bank-box .bank-info h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .sidebars.settings-sidebar .sidebar-menu .menu-arrow {
  background-color: #97A2D2;
}
[data-layout-mode=dark_mode] .sidebars.settings-sidebar .sidebar-menu .menu-arrow::before {
  border-left: 1px solid #000000;
  border-bottom: 1px solid #000000;
  color: #000000;
}
[data-layout-mode=dark_mode] .legendLabel {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat .chat-body .messages .chats .message-content {
  background: #092C4C;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat .chat-body .messages .file-download {
  background: #092C4C;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat .chat-body .messages .file-download .file-details span.file-name {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat .chat-body .messages .file-download .file-details ul li {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat_form {
  border: 1px solid #353570;
  box-shadow: 0px 4px 4px #343a40;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat-date {
  background: #092C4C;
  color: #97A2D2;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat-date:before {
  background-color: #353570;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat-line:before {
  background-color: #353570;
}
[data-layout-mode=dark_mode] .notes-page-wrapper .content .page-add-notes {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .file-manager aside {
  box-shadow: 0px 4px 60px 0px rgba(0, 0, 0, 0.7);
}
[data-layout-mode=dark_mode] .file-manager aside h5 {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .seprator-lg {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .pos-modal.upload-modal .modal-body ul li h6 a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .pos-modal.upload-modal .modal-body p {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .social-media-icons li a i {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .employee-grid-profile .dropdown.profile-action svg {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .login-wrapper .login-content .login-userset .my-4 p {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .alert-secondary {
  background-color: rgba(9, 44, 76, 0.8);
  color: #ffffff;
  border-color: rgba(9, 44, 76, 0.8);
}
[data-layout-mode=dark_mode] .badge.text-dark {
  color: #ffffff;
}
[data-layout-mode=dark_mode] .btn-outline-secondary {
  border: 1px solid #3577f1 !important;
  color: #3577f1 !important;
}
[data-layout-mode=dark_mode] .btn-outline-light {
  border: 1px solid #f8f9fa;
  color: #f8f9fa !important;
}
[data-layout-mode=dark_mode] .btn.text-dark {
  color: #ffffff !important;
}
[data-layout-mode=dark_mode] .callout-info {
  background-color: rgba(23, 162, 184, 0.25);
  border-color: rgba(23, 162, 184, 0.5);
  color: #ffffff;
}
[data-layout-mode=dark_mode] .callout-warning {
  background-color: rgba(255, 153, 0, 0.25);
  border-color: rgba(255, 153, 0, 0.5);
  color: #ffffff;
}
[data-layout-mode=dark_mode] .callout-danger {
  background-color: rgba(255, 0, 0, 0.25);
  border-color: rgba(255, 0, 0, 0.5);
  color: #ffffff;
}
[data-layout-mode=dark_mode] .grid-vertical {
  color: #fff;
}
[data-layout-mode=dark_mode] .grid-vertical .bg-light {
  background-color: transparent !important;
}
[data-layout-mode=dark_mode] .grid-showcase .text-dark {
  color: #ffffff !important;
}
[data-layout-mode=dark_mode] .btn.btn-secondary-light {
  background-color: rgba(9, 44, 76, 0.5);
  color: #489be6;
}
[data-layout-mode=dark_mode] .nav-tabs .nav-tabs-rounded {
  border-radius: 50px;
}
[data-layout-mode=dark_mode] .card .card-footer {
  background-color: transparent;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .file-manager .all-files {
  box-shadow: 0px 4px 60px 0px rgba(0, 0, 0, 0.7);
}
[data-layout-mode=dark_mode] .form-floating > .form-control-plaintext ~ label::after {
  background-color: transparent;
}
[data-layout-mode=dark_mode] .form-select {
  border-color: #495057;
}
[data-layout-mode=dark_mode] .productdetails > ul > li h6 {
  color: #ffffff;
}
[data-layout-mode=dark_mode] .connected-app-card ul {
  box-shadow: 0px 4px 6px 0px rgba(231, 231, 231, 0.17);
}
[data-layout-mode=dark_mode] .login-wrapper .login-content.user-login .login-userset {
  box-shadow: 0px 4px 6px 0px rgba(190, 190, 190, 0.27);
}
[data-layout-mode=dark_mode] .sales-cards .card.color-info h3 {
  color: #ffffff !important;
}
[data-layout-mode=dark_mode] .sales-cards .card.color-info p {
  color: #ffffff !important;
}
[data-layout-mode=dark_mode] .table.table-borderless tr td .head-text {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .accordion .accordion-item {
  background: transparent;
}
[data-layout-mode=dark_mode] .card-text {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .login-wrapper.login-new .login-content.user-login .login-userset form .otp-box input {
  background: transparent;
}
[data-layout-mode=dark_mode] .file-manager .accordion .accordion-item {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .main-chat-blk .review-files p {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat-action-col > a {
  color: #5B6670;
}
[data-layout-mode=dark_mode] .social-authent-settings .connected-app-card ul li:first-child {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .notes-page-wrapper .content .section-notes-slider {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .notes-dash .notes-top-head-submenu {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .login-body .login-wrapper .terms li a {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .input-blocks .bootstrap-tagsinput .tag {
  background: #1d1d42;
  color: #97A2D2;
  border-color: #495057;
}
[data-layout-mode=dark_mode] .company-info {
  border-bottom: 1px solid #353570;
}
[data-layout-mode=dark_mode] .apply-leave .leave-apply .leave-date p {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:hover {
  color: #1B2850;
}
[data-layout-mode=dark_mode] .form-floating > .form-control:not(:placeholder-shown) ~ label::after {
  background-color: transparent;
}
[data-layout-mode=dark_mode] .form-select option {
  background-color: transparent;
}
[data-layout-mode=dark_mode] .selected-language {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .file-manager aside {
  box-shadow: 0px 4px 60px 0px rgba(0, 0, 0, 0.7);
}
[data-layout-mode=dark_mode] .file-manager aside h6 {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .table {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .table tr th {
  border-color: #353570;
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .table.table-primary tr th {
  background-color: #1d1d42;
}
[data-layout-mode=dark_mode] .pos-category .owl-nav button.owl-next, [data-layout-mode=dark_mode] .pos-category .owl-nav button.owl-prev {
  background-color: #1d1d42;
  border: 1px solid #353570;
}
[data-layout-mode=dark_mode] .pos-category .owl-nav button.owl-next i, [data-layout-mode=dark_mode] .pos-category .owl-nav button.owl-prev i {
  color: #97A2D2;
}
[data-layout-mode=dark_mode] .select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: #353570;
}
[data-layout-mode=dark_mode] .select2-container--default .select2-selection--multiple {
  border-color: #353570;
}
[data-layout-mode=dark_mode] textarea::placeholder {
  color: #97A2D2;
}

.header {
  background: #ffffff;
  border-bottom: 1px solid #dbe0e6;
  height: 66px;
  z-index: 999;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  transition: all 0.5s ease;
}
.header .flag-nav > a img {
  border-radius: 50%;
  width: 22px;
  height: 22px;
}
.header .searchinputs {
  transition: all 0.2s ease;
}
.header .dropdown-menu {
  transition: all 0.5s ease;
  transform: translate(0px, 100px);
  -webkit-transform: translate(0px, 100px);
  -ms-transform: translate(0px, 100px);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);
  border: 0;
  margin-top: 10px;
}
.header .dropdown-menu.menu-drop-user {
  margin-top: 7px !important;
}
@media (max-width: 991.98px) {
  .header .dropdown-menu {
    transition: none;
  }
}
.header .header-left {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  float: left;
  height: 66px;
  position: relative;
  text-align: center;
  width: 260px;
  z-index: 1;
  padding: 0 24px;
  transition: all 0.5s ease;
  border-right: 1px solid #dbe0e6;
  border-bottom: 1px solid #dbe0e6;
}
.header .header-left .logo {
  display: inline-block;
  line-height: 0;
}
.header .header-left .logo img {
  width: 140px;
}
@media (max-width: 991.98px) {
  .header .header-left .logo {
    text-align: center;
    width: 100%;
  }
  .header .header-left .logo img {
    width: 140px;
  }
}
.header .header-left .logo-small {
  display: none;
}
@media (max-width: 991.98px) {
  .header .header-left {
    position: absolute;
    width: 100%;
  }
}
@media (max-width: 991.98px) {
  .header .header-left #toggle_btn {
    display: none;
  }
}
@media (min-width: 991.98px) {
  .header #toggle_btn {
    float: left;
    font-size: 26px;
    line-height: 50px;
  }
  .header #toggle_btn .bar-icon {
    display: inline-block;
    width: 21px;
  }
  .header #toggle_btn .bar-icon span {
    background-color: #ffffff;
    display: block;
    float: left;
    height: 2px;
    width: 21px;
    margin: 0 0 5px;
    border-radius: 50px;
  }
  .header #toggle_btn .bar-icon span:nth-child(2) {
    width: 15px;
  }
}
.header .page-title-box {
  float: left;
  height: 60px;
  margin-bottom: 0;
  padding: 17px 20px;
  border-radius: 0;
}
@media (max-width: 991.98px) {
  .header .page-title-box {
    display: none;
  }
}
.header .page-title-box a {
  color: #FF9F43;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid #FF9F43;
  margin: 0;
  padding: 5px;
  border-radius: 5px;
}
.header .page-title-box a:hover {
  background: #FF9F43;
  color: #ffffff;
}
.header .mobile_btn {
  display: none;
  float: left;
}
@media (max-width: 991.98px) {
  .header .mobile_btn {
    color: #FF9F43;
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    width: 60px;
    z-index: 10;
    padding: 0 20px;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
  }
}
.header .responsive-search {
  display: none;
  color: #ffffff;
  font-size: 20px;
  height: 60px;
  line-height: 60px;
  padding: 0 15px;
}
@media (max-width: 991.98px) {
  .header .responsive-search {
    display: block;
  }
}
.header .top-nav-search form {
  position: relative;
}
@media (max-width: 991.98px) {
  .header .top-nav-search form {
    display: none;
  }
}
.header .top-nav-search form .form-control {
  background-color: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.15);
  height: 40px;
  padding: 10px 50px 10px 15px;
  border-radius: 50px;
}
.header .top-nav-search form .form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.7);
}
.header .top-nav-search form .btn {
  background-color: transparent;
  border-color: transparent;
  color: rgba(255, 255, 255, 0.7);
  min-height: 40px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 991.98px) {
  .header .top-nav-search.active form {
    display: block;
    position: absolute;
    left: 0;
  }
  .header .top-nav-search.active form .form-control {
    background-color: #ffffff;
  }
  .header .top-nav-search.active form .btn {
    background-color: transparent;
    border-color: transparent;
    min-height: 40px;
    position: absolute;
    top: 0;
    right: 0;
    padding: 7px 15px;
  }
}
.header .userset {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.header .userset .usernames {
  line-height: initial;
  text-align: right;
  padding-right: 10px;
}
.header .userset .usernames span {
  display: block;
  line-height: initial;
}
.header .menu-drop-user .dropdown-item {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #67748E;
  padding: 7px 10px !important;
}
.header .menu-drop-user .dropdown-item svg {
  stroke-width: 1px;
  margin-right: 10px;
  width: 18px;
}
.header .menu-drop-user .logout {
  color: #FF0000;
}
@media (max-width: 991.98px) {
  .header .has-arrow .dropdown-toggle > span:nth-child(2) {
    display: none;
  }
  .header .has-arrow .dropdown-toggle:after {
    display: none !important;
  }
}
.header .profilename .user-img .status {
  bottom: 10px;
}
.header .user-img {
  display: inline-block;
  position: relative;
}
.header .user-img img {
  width: 38px;
  border-radius: 50%;
}
.header .user-img .status {
  border: 2px solid #ffffff;
  height: 10px;
  width: 10px;
  margin: 0;
  position: absolute;
  right: 0;
  bottom: 30px;
  border-radius: 50%;
  display: inline-block;
  background: #28C76F;
}
.header .mobile-user-menu {
  color: #ffffff;
  display: none;
  float: right;
  font-size: 24px;
  height: 60px;
  line-height: 60px;
  text-align: right;
  width: 60px;
  z-index: 10;
  padding: 0 20px;
  position: absolute;
  top: 0;
  right: 0;
}
@media (max-width: 991.98px) {
  .header .mobile-user-menu {
    display: block;
  }
}
.header .mobile-user-menu a {
  color: #FF9F43;
  padding: 0;
}
.header .mobile-user-menu a::after {
  display: none;
}
.header .mobile-user-menu .dropdown-menu {
  padding: 0;
}
.header .mobile-user-menu .dropdown-menu a {
  color: #343a40;
  line-height: 40px;
  padding: 0 10px;
}

.logo-small img {
  width: 30px;
}

@media (min-width: 992px) {
  .mini-sidebar.expand-menu .header-left {
    flex-direction: row;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    -ms-flex-pack: space-between;
  }
  .mini-sidebar .header-left {
    display: flex;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    width: 80px;
    padding: 0;
    flex-direction: column;
  }
  .mini-sidebar .header-left .logo-small {
    display: block;
    padding: 10px 0 0;
  }
  .mini-sidebar .header-left .logo {
    display: none;
  }
  .mini-sidebar .menu-arrow {
    display: none !important;
  }
  .mini-sidebar .chat-user {
    display: none !important;
  }
  .mini-sidebar .user-menu .badge {
    display: flex !important;
  }
  .mini-sidebar.expand-menu .menu-arrow {
    display: block !important;
  }
  .mini-sidebar.expand-menu .chat-user {
    display: block !important;
  }
  .mini-sidebar.expand-menu .logo-small {
    display: none;
  }
  .mini-sidebar.expand-menu .logo {
    display: block;
  }
  .mini-sidebar.expand-menu #toggle_btn {
    opacity: 1;
  }
  .mini-sidebar.expand-menu .header-left {
    padding: 0 20px;
    display: flex;
  }
  .mini-sidebar .noti-dot:before {
    display: none;
  }
}
.header-pos.header {
  position: relative;
}

.searchpart {
  position: fixed;
  top: 0;
  right: 0;
  height: 100vh;
  background: #ffffff;
  z-index: 100000;
  width: 350px;
  margin-right: -350px;
  transition: all 0.5s ease;
  box-shadow: 0 0px 7px rgba(0, 0, 0, 0.2);
}
.searchpart.active {
  margin-right: 0;
}
.searchpart .searchcontent {
  padding: 20px;
  display: block;
  height: 100%;
}
.searchpart .searchhead {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border-bottom: 1px solid #B8BCC9;
  color: #343a40;
}
.searchpart .searchcontents {
  padding: 25px 0;
}
.searchpart .searchparts {
  position: relative;
}
.searchpart .searchparts input[type=text] {
  width: 100%;
  height: 50px;
  border: 1px solid #B8BCC9;
  padding: 0 15px;
  border-radius: 50px;
}
.searchpart .searchparts .btn-searchs {
  position: absolute;
  top: 5px;
  right: 10px;
  background: #FF9F43;
  border-radius: 50px;
  color: #ffffff;
}
.searchpart .recentsearch {
  margin-top: 15px;
  border-top: 1px solid #adb5bd;
  padding-top: 15px;
}
.searchpart .recentsearch h2 {
  font-size: 16px;
  margin-bottom: 25px;
  color: #343a40;
  font-weight: 700;
}
.searchpart .recentsearch li {
  border-bottom: 1px solid #adb5bd;
  padding: 10px;
}
.searchpart .recentsearch li h6 {
  font-size: 14px;
}
.searchpart .searchhead h3 {
  font-weight: 600;
  font-size: 20px;
}

.header-pos {
  padding: 10px;
  background: #ffffff;
  margin-bottom: 20px;
  border-bottom: 1px solid #e8ebed;
  height: 80px;
}
@media (max-width: 991.98px) {
  .header-pos {
    padding: 10px;
    height: auto;
  }
}
.header-pos #mobile_btn {
  display: none;
  float: left;
}
@media (max-width: 991.98px) {
  .header-pos #mobile_btn {
    color: #FF9F43;
    font-size: 24px;
    height: 60px;
    line-height: 60px;
    width: 60px;
    z-index: 10;
    padding: 0 20px;
    position: absolute;
    top: 0;
    left: 0;
    display: block;
  }
}

.header-pos.header .topnav-dropdown-header {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  height: 40px;
  padding: 10px;
}
.header-pos.header .topnav-dropdown-header .clear-noti {
  color: #FF4D4D !important;
  float: right;
  font-size: 11px !important;
  text-transform: uppercase;
}
.header-pos.header .topnav-dropdown-footer {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border-top: 1px solid #e8ebed;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
}
.header-pos.header .topnav-dropdown-footer a {
  display: block;
  text-align: center;
  color: #343a40;
  padding: 5px 12px;
  font-size: 12px !important;
}
.header-pos.header .user-menu.nav li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  height: 40px;
}
.header-pos.header .user-menu.nav li a {
  color: #092C4C;
  line-height: normal;
  height: auto;
  font-size: 15px;
  padding: 0 8px;
}
.header-pos.header .user-menu.nav li a.dropdown-toggle.nav-link.show {
  background: transparent;
}
.header-pos.header .user-menu.nav li.notification-message {
  height: auto;
}
.header-pos.header .user-img img {
  margin-top: 0;
}
.header-pos.header .user-img .status {
  border: 2px solid #ffffff;
  height: 10px;
  width: 10px;
  margin: 0;
  border-radius: 50%;
  display: inline-block;
  background: #28C76F;
  position: absolute;
  bottom: 6px;
  left: 0;
}

@media (max-width: 991.98px) {
  .header-pos.header .user-menu {
    display: none;
  }
}
.header-pos.header .user-menu .noti-content .notification-list a {
  line-height: normal;
  height: auto;
  padding: 8px;
}

.header-split {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
@media (max-width: 991.98px) {
  .header-split {
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
  }
}
@media (max-width: 991.98px) {
  .header-split .header-menu {
    display: none;
  }
}
.header-split .header-menu ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.header-split .header-menu ul li {
  margin-right: 10px;
}
.header-split .header-menu ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border: 1px solid #e8ebed;
  color: #000000;
  border-radius: 5px;
  padding: 5px 8px;
}
.header-split .header-menu ul li a.links {
  border: 0;
}
.header-split .header-menu ul li a:hover {
  background: #FF9F43;
  color: #ffffff;
}
.header-split .header-menu ul li a:hover img {
  filter: brightness(0) invert(1);
}
.header-split .header-menu ul li.mobile-show {
  display: block;
}
@media (max-width: 991.98px) {
  .header-split .header-menu ul li.mobile-show {
    display: block;
  }
}

.mobile-show {
  display: none;
}
@media (max-width: 991.98px) {
  .mobile-show {
    display: block;
  }
}

.header-menus {
  position: absolute;
  right: 30px;
  display: none;
}
@media (max-width: 991.98px) {
  .header-menus {
    display: block;
  }
}

.bar-icon {
  display: inline-block;
  width: 31px;
  margin-top: 20px;
}
.bar-icon span {
  background-color: #FF9F43;
  display: block;
  float: left;
  height: 3px;
  margin-bottom: 7px;
  width: 31px;
  border-radius: 2px;
  transition: all 0.5s;
}
.bar-icon span:nth-child(2) {
  width: 16px;
}

.menu-opened .slide-nav .bar-icon {
  display: inline-block;
  width: 31px;
  margin-top: 20px;
}
.menu-opened .slide-nav .bar-icon span:first-child {
  position: relative;
  top: 10px;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
}
.menu-opened .slide-nav .bar-icon span:nth-child(2) {
  display: none;
}
.menu-opened .slide-nav .bar-icon span:last-child {
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  -ms-transform: rotate(135deg);
}

hr {
  border-top: 1px solid #e8ebed;
  opacity: 1;
}

.profilename {
  padding: 0px;
}
.profilename .profileset {
  display: flex;
  padding: 10px 10px 3px;
}
.profilename .profileset h6 {
  font-size: 14px;
  color: #092C4C;
  font-weight: 500;
}
.profilename .profileset h5 {
  font-size: 14px;
  color: #67748E;
}
.profilename .profileset .profilesets {
  margin-left: 10px;
}
.profilename .profileset .user-img img {
  margin-top: 0;
}
.profilename .dropdown-item {
  padding: 8px 5px !important;
}

.show .user-info::after {
  transform: rotate(-140deg);
  top: 10px;
}

.feather-40 {
  width: 40px;
  height: 40px;
}

.feather-26 {
  width: 26px;
  height: 26px;
}

.feather-20 {
  width: 20px;
  height: 20px;
}

.feather-14 {
  width: 14px;
  height: 14px;
}

.feather-16 {
  width: 16px;
  height: 16px;
}

.user-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: relative;
  padding: 0 30px 0 0;
}
@media (max-width: 1199.98px) {
  .user-info span.user-detail {
    display: none;
  }
}
.user-info::after {
  content: "";
  width: 8px;
  height: 8px;
  border-top: 0;
  border-left: 0;
  border-right: 2px solid #1B2950;
  border-bottom: 2px solid #1B2950;
  border-radius: 1px;
  transform: rotate(45deg);
  transition: all 0.5s;
  top: 8px;
  position: absolute;
  right: 12px;
}
@media (max-width: 1199.98px) {
  .user-info::after {
    top: 12px;
  }
}
.user-info .user-role {
  display: block;
  color: #67748E;
  font-size: 12px;
}
.user-info .user-letter {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #ffffff;
  width: 36px;
  height: 36px;
  border-radius: 6px;
  font-weight: 600;
  font-size: 15px;
  margin-right: 10px;
  border: 1px solid #dbe0e6;
}
@media (max-width: 1199.98px) {
  .user-info .user-letter {
    margin-right: 0;
  }
}
.user-info .user-letter img {
  border-radius: 6px;
}
.user-info .user-name {
  font-size: 15px;
  font-weight: 600;
  color: #1B2950;
  display: flex;
  align-items: center;
}
.user-info .user-name img {
  margin-left: 10px;
}

.user-menu {
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin: 0;
  position: relative;
  padding-right: 15px;
  height: 100%;
  transition: all 0.5s ease;
}
@media (max-width: 991.98px) {
  .user-menu {
    display: none;
  }
}
.user-menu > li {
  margin-left: 18px;
  margin-inline-end: 0;
}
@media (max-width: 1199.98px) {
  .user-menu > li {
    margin-left: 8px;
  }
}
.user-menu > li svg {
  width: 18px;
  color: #67748E;
}
.user-menu > li a:hover svg {
  color: #FF9F43;
}
.user-menu .dropdown-toggle::after {
  border: 0;
  display: none;
}
.user-menu .nav-searchinputs {
  margin-right: auto;
  margin-left: 25px;
}
.user-menu .nav-item-box > a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #f3f6f9;
  border-radius: 6px;
  width: 36px;
  height: 36px;
  position: relative;
}
.user-menu .nav-item-box > a:hover {
  background: #EEF3F5;
}
.user-menu.nav > li > a {
  padding: 0;
  display: flex;
  line-height: normal;
  color: #092C4C;
}
.user-menu.nav > li > a .badge {
  color: #ffffff;
  font-weight: 700;
  position: absolute;
  top: -7px;
  right: -7px;
  background: #FF9F43;
  width: 20px;
  height: 20px;
  font-size: 10px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.user-menu.nav > li > a i {
  font-size: 20px;
  line-height: 60px;
}
.user-menu.nav > li.flag-nav a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.user-menu.nav > li.flag-nav a .dropdown-menu {
  max-height: 150px;
  min-width: 120px;
  overflow-y: auto;
}
.user-menu.nav > li.flag-nav a .dropdown-menu .dropdown-item {
  padding: 5px 15px;
}
.user-menu.nav > li.flag-nav .dropdown-menu {
  padding: 15px;
  min-width: 210px;
}
.user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item {
  padding: 10px 10px;
  color: #67748E;
  border-radius: 10px;
  transition: none;
}
.user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item.active {
  color: #ffffff;
}
.user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item.active, .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item:hover {
  background: #F7F7F7 url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat calc(100% - 12px) center;
}
.user-menu.nav > li.flag-nav .dropdown-menu a img {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 10px;
}

.searchinputs {
  padding: 0;
  position: relative;
}
.searchinputs input {
  width: 300px;
  height: 36px;
  border: 1px solid #f3f6f9;
  background: #f3f6f9;
  padding: 0 16px;
  border-radius: 8px;
}
@media (max-width: 1199.98px) {
  .searchinputs input {
    width: 170px;
  }
}
.searchinputs .search-addon span {
  z-index: 9;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 5px;
  cursor: pointer;
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}

.searchinputs .search-addon svg {
  opacity: 0;
  transition: all 0.5s ease;
  color: #FF4D4D;
}
.searchinputs.show .search-addon svg {
  opacity: 1;
}

.search-dropdown {
  width: 300px;
  height: 315px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  padding: 20px;
  border-radius: 10px;
  background: #ffffff;
  margin-top: 0;
  overflow-y: auto;
}
.search-dropdown .search-info {
  margin: 0 0 15px 0;
  padding: 0 0 15px 0;
  border-bottom: 1px solid #dbe0e6;
  font-size: 14px;
  color: #5B6670;
}
.search-dropdown .search-info:last-child {
  border-bottom: none;
  margin: 0;
  padding: 0;
}
.search-dropdown .search-info h6 {
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #092C4C;
  margin-bottom: 15px;
}
.search-dropdown .search-info h6 svg {
  width: 16px;
  margin-right: 6px;
  color: #092C4C;
}
.search-dropdown .search-info .search-tags {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.search-dropdown .search-info .search-tags li {
  margin-right: 10px;
}
.search-dropdown .search-info .search-tags li:last-child {
  margin-right: 0;
}
.search-dropdown .search-info .search-tags li:hover a {
  background: #FF9F43;
  color: #ffffff;
}
.search-dropdown .search-info .search-tags li a {
  padding: 5px 10px;
  background: #e8ebed;
  border-radius: 50px;
  color: #5B6670;
}
.search-dropdown .search-info .customers li {
  margin-bottom: 15px;
}
.search-dropdown .search-info .customers li:hover a {
  color: #FF9F43;
}
.search-dropdown .search-info .customers li:hover a img {
  border-color: #FF9F43;
}
.search-dropdown .search-info .customers li:last-child {
  margin-bottom: 0;
}
.search-dropdown .search-info .customers li a {
  color: #5B6670;
  font-size: 15px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.search-dropdown .search-info .customers li a img {
  width: 30px;
  height: 30px;
  border-radius: 100%;
  border: 1px solid #f3f6f9;
}

.user-menu.nav > li > a.dropdown-toggle.nav-link.select-store.show {
  background: none;
}
.user-menu.nav > li > a.select-store {
  padding: 4px 10px;
  border: 1px solid #dbe0e6;
  border-radius: 6px;
}
@media (max-width: 1199.98px) {
  .user-menu.nav > li > a.select-store {
    padding: 6px 5px;
  }
}
.user-menu.nav > li > a.select-store .user-info {
  padding: 3px 25px 3px 0;
}
@media (max-width: 1199.98px) {
  .user-menu.nav > li > a.select-store .user-info {
    padding-right: 15px;
  }
}
.user-menu.nav > li > a.select-store .user-info .user-letter {
  width: 20px;
  height: 20px;
  margin-right: 6px;
  border: 0;
}
.user-menu.nav > li > a.select-store .user-info .user-letter img {
  border-radius: 100%;
}
.user-menu.nav > li > a.select-store .user-info .user-name {
  font-size: 13px;
  font-weight: 500;
  color: #092C4C;
}
.user-menu.nav > li > a.select-store .user-info:after {
  top: 33%;
  transform: translateY(-33%);
  transform: rotate(45deg);
  border-color: #5B6670;
  right: 6px;
}

.select-store-dropdown .dropdown-menu .dropdown-item {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.select-store-dropdown .dropdown-menu .dropdown-item img {
  margin-right: 8px;
  width: 20px;
  height: 20px;
  border-radius: 100%;
  border: 1px solid #f3f6f9;
}

.header-collapse .user-menu {
  height: 0;
  display: none;
}
.header-collapse .page-wrapper {
  padding-top: 0;
}
.header-collapse .header {
  border-bottom: none;
  background: transparent;
  width: 260px;
}
.header-collapse .header .header-left {
  background: #ffffff;
}
.header-collapse .welcome #collapse-header.active {
  background: #FF9F43;
  border-color: #FF9F43;
}
.header-collapse .welcome #collapse-header.active svg {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  color: #ffffff;
}

.page-wrapper-one {
  margin-left: 0px;
  padding-top: 130px;
}

.header-one .header-left {
  border-right: 0 !important;
  padding: 25px;
}

.logo-white {
  display: none !important;
}

.sidebar.horizontal-sidebar {
  position: fixed;
  width: 100%;
  height: 68px;
  background: #ffffff;
  border-top: 1px solid #dbe0e6;
  box-shadow: 0px 4px 14px rgba(198, 198, 198, 0.25);
  z-index: 500;
}
.sidebar.horizontal-sidebar .sidebar-menu {
  padding: 0 15px;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li {
  margin-bottom: 0;
  margin-right: 20px;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li.submenu ul li a.active {
  color: #FF9F43;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li > a {
  padding: 22px 15px;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li > a.active {
  background: transparent;
}
@media (max-width: 1199.98px) {
  .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a {
    padding: 22px 5px;
  }
}
@media (max-width: 1199.98px) and (max-width: 1199.98px) {
  .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a span {
    font-size: 14px;
  }
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li > a:hover {
  background: transparent;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li > a:hover span {
  color: #FF9F43;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li > a:hover img, .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a:hover svg {
  filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li > a img {
  top: 0 !important;
  width: auto;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li a {
  font-weight: 500;
  font-size: 15px;
  color: #67748E;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li a img {
  position: relative;
  top: 3px;
  width: 18px;
  margin-right: 7px;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li a svg {
  width: 18px;
  margin-right: 7px;
}
@media (max-width: 1199.98px) {
  .sidebar.horizontal-sidebar .sidebar-menu > ul > li a svg {
    margin-right: 5px;
  }
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li .menu-arrow {
  position: initial;
  transform: rotate(90deg);
  margin-left: 15px;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul {
  position: absolute;
  width: 250px;
  height: auto;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a {
  padding: 8px 15px !important;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a .menu-arrow {
  float: right;
  margin-right: 15px;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a i {
  margin-right: 7px;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a img {
  position: relative;
  top: 3px;
  width: 18px;
  margin-right: 7px;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a svg {
  width: 18px;
  margin-right: 7px;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu ul {
  box-shadow: 0px 4px 14px rgba(198, 198, 198, 0.25);
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu ul {
  position: relative;
  padding: 0;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu ul li a {
  padding: 8px 10px 8px 40px !important;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu.submenu-two ul li a {
  margin-left: 10px;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu.submenu-two.submenu-three ul li a {
  margin-left: 20px;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li a {
  padding: 8px 15px !important;
}
.sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li a::after {
  content: none !important;
}
@media (max-width: 1199.98px) {
  .sidebar.horizontal-sidebar .sidebar-menu > ul > li {
    margin-right: 0;
  }
}

@media (min-width: 992px) {
  .hide-sidebar {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .horizontal-sidebar {
    display: none;
  }
  .page-wrapper-one {
    padding-top: 60px;
  }
}
.header-two .header-left {
  border: 0 !important;
  padding: 0 10px;
}
.header-two .top-nav-search {
  float: left;
  margin-left: 10px;
}
.header-two .top-nav-search .btn {
  left: 0;
  right: auto !important;
}
.header-two .top-nav-search .searchinputs input {
  z-index: 1;
}

.sidebar.sidebar-two {
  left: auto;
  top: 90px;
  border: 0 !important;
}
.sidebar.sidebar-two .sidebar-menu > ul > li.submenu ul li a {
  display: flex !important;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.sidebar.sidebar-two .sidebar-menu > ul > li.submenu ul li a img {
  width: 18px;
}
.sidebar.sidebar-two .sidebar-menu > ul > li.submenu ul li a span {
  margin-left: 10px;
}
.sidebar.sidebar-two .sidebar-menu > ul > li.submenu ul li a::after {
  content: none;
}
.sidebar.sidebar-two .sidebar-menu > ul > li.submenu ul li a .menu-arrow {
  top: 10px;
}
.sidebar.sidebar-two .sidebar-menu > ul > li.submenu ul li ul li a {
  padding: 8px 8px 8px 64px;
}
.sidebar.sidebar-two .sidebar-menu .menu-arrow {
  position: absolute;
  top: 12px;
  right: 15px;
}

.page-wrapper-two .dash-widget .dash-widgetcontent {
  margin-left: 10px;
}

@media (max-width: 991.98px) {
  .sidebar.sidebar-two {
    left: 0;
    top: 60px;
  }
}
@media (max-width: 991.98px) {
  .header-block {
    display: block !important;
  }
}

.page-wrapper-three {
  margin-left: 0;
  padding-top: 0;
}
.page-wrapper-three .content {
  background: #FAFBFE;
  border-radius: 20px;
  margin-top: -82px;
}

.header-three {
  position: relative;
}
.header-three .header-left {
  border-right: 0 !important;
  padding: 25px;
}

.logo-white {
  display: none !important;
}

.sidebar.side-three.horizontal-sidebar {
  position: relative;
  top: 0;
  width: 100%;
  height: 150px;
  background: #1B2950;
  border-top: 1px solid #dbe0e6;
  box-shadow: 0px 4px 14px rgba(198, 198, 198, 0.25);
  z-index: unset;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu {
  padding: 0 15px;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li {
  margin-bottom: 0;
  margin-right: 20px;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a {
  padding: 22px 15px;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a img, .sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a svg {
  filter: brightness(0) invert(1);
  margin-right: 0;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a:hover {
  background: transparent;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a:hover span {
  color: #FF9F43 !important;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a:hover img, .sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a:hover svg {
  filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a img {
  top: 0 !important;
  width: auto;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -10px;
  width: 1px;
  height: 15px;
  background: #6B7A99;
  transform: translateY(-50%);
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a span {
  color: #ffffff !important;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li a {
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li a img {
  position: relative;
  top: 3px;
  width: 18px;
  margin-right: 7px;
  filter: brightness(0) invert(1);
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li a svg {
  width: 18px;
  margin-right: 7px;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li a:hover img, .sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li a:hover svg {
  filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li .menu-arrow {
  position: initial;
  transform: rotate(90deg);
  margin-left: 15px;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul {
  position: absolute;
  width: 250px;
  height: auto;
  z-index: 1;
  background: #1B2950;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a {
  padding: 8px 15px !important;
  color: #ffffff;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a .menu-arrow {
  float: right;
  margin-right: 15px;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a i {
  margin-right: 7px;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a img {
  position: relative;
  top: 3px;
  width: 18px;
  margin-right: 7px;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a svg {
  width: 18px;
  margin-right: 7px;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a:hover {
  color: #FF9F43;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a:hover img {
  filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu ul {
  box-shadow: none;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu ul {
  position: relative;
  padding: 0;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu ul li a {
  padding: 8px 10px 8px 40px !important;
  color: #ffffff;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li a {
  padding: 8px 15px !important;
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li a::after {
  content: none !important;
}
@media (max-width: 1199.98px) {
  .sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li {
    margin-right: 0;
  }
}
.sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li:last-child > a::before {
  content: none;
}

@media (min-width: 992px) {
  .hide-sidebar {
    display: none;
  }
}
@media (max-width: 991.98px) {
  .header-three {
    position: fixed;
  }
  .horizontal-sidebar {
    display: none;
  }
  .page-wrapper-three {
    padding-top: 60px;
  }
  .page-wrapper-three .content {
    margin-top: 0;
  }
}
.sidebar.collapsed-sidebar {
  border: 0;
  box-shadow: 0px 4px 14px rgba(198, 198, 198, 0.25);
  display: none;
}
.sidebar.collapsed-sidebar .sidebar-menu {
  display: flex;
  border-radius: 0 20px 20px 0;
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside {
  float: left;
  width: 100%;
  max-width: 66px;
  margin-left: 0px;
  color: rgba(255, 255, 255, 0.5);
  transition: all 0.299s;
  margin: 0;
  padding: 0;
  box-shadow: 0px 0 14px rgba(198, 198, 198, 0.25);
  min-height: 100vh;
  border: 0;
  position: fixed;
  left: 0;
  z-index: 999;
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs {
  padding: 14px 14px 0;
  border: 0;
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item {
  margin-bottom: 10px;
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link {
  padding: 5px;
  width: 38px;
  height: 38px;
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link:hover {
  background-color: #FF9F43;
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link:hover img {
  filter: brightness(0) invert(1);
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link:hover svg {
  color: #ffffff;
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link:active, .sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link.active {
  background-color: #FF9F43;
  border: 0;
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link:active img, .sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link.active img {
  filter: brightness(0) invert(1);
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link:active svg, .sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link.active svg {
  color: #ffffff;
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link:active::after, .sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link.active::after {
  content: none;
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item .nav-link::before {
  content: none;
}
.sidebar.collapsed-sidebar .sidebar-menu .ui-aside .nav-tabs .nav-item:last-child .nav-link {
  border-bottom: 0;
}
.sidebar.collapsed-sidebar .tab-content-four {
  padding-top: 20px;
  margin-left: 80px;
  width: 100%;
}
.sidebar.collapsed-sidebar .sidebar-menu {
  padding: 0 20px 0 0;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 10px 15px 10px 25px;
  position: relative;
  color: #67748E;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a svg {
  width: 18px;
  color: #67748E;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a img {
  width: 18px;
  color: #67748E;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a:hover {
  color: #FF9F43;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a:hover img {
  filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a:hover span {
  color: #FF9F43;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a:hover svg {
  color: #FF9F43;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  background: #adb5bd;
  width: 5px;
  height: 5px;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a.active {
  color: #FF9F43;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a.active svg {
  color: #FF9F43;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a.active img {
  filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a.active span {
  color: #FF9F43;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a span {
  margin-left: 0;
  font-size: 15px;
  font-weight: 500;
  color: #67748E;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a .menu-arrow {
  display: inline-block;
  font-family: "Font Awesome 5 Free";
  text-rendering: auto;
  line-height: 40px;
  font-size: 18px;
  line-height: 18px;
  position: absolute;
  top: 12px;
  right: 0px;
  transform: translate(0, 0);
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transition: all 0.2s ease;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a .menu-arrow.inside-submenu {
  right: 15px;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a .menu-arrow.inside-submenu.inside-submenu-two {
  right: 15px;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li a.subdrop .menu-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.sidebar.collapsed-sidebar .sidebar-menu ul li.submenu.submenu-two ul li a {
  margin-left: 10px;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li.submenu.submenu-three ul li a {
  margin-left: 20px;
}
.sidebar.collapsed-sidebar .sidebar-menu ul li ul li a {
  padding: 10px 15px 10px 25px;
  left: 14px;
}

.header-four .header-left {
  border-right: 0 !important;
}

.page-wrapper-four {
  margin-left: 250px;
}

@media (max-width: 992px) {
  .page-wrapper-four {
    margin-left: 0;
  }
}
div#global-loader {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #ffffff;
  position: fixed;
  z-index: 999999;
  width: 100%;
  height: 100vh;
}
div#global-loader .whirly-loader:not(:required) {
  animation: whirly-loader 1.25s linear infinite;
  background: transparent;
  box-shadow: 0 26px 0 6px #FF9F43, 0.90971px 26.05079px 0 5.93333px #FF9F43, 1.82297px 26.06967px 0 5.86667px #FF9F43, 2.73865px 26.05647px 0 5.8px #FF9F43, 3.65561px 26.01104px 0 5.73333px #FF9F43, 4.57274px 25.93327px 0 5.66667px #FF9F43, 5.48887px 25.8231px 0 5.6px #FF9F43, 6.40287px 25.68049px 0 5.53333px #FF9F43, 7.31358px 25.50548px 0 5.46667px #FF9F43, 8.21985px 25.2981px 0 5.4px #FF9F43, 9.12054px 25.05847px 0 5.33333px #FF9F43, 10.01448px 24.78672px 0 5.26667px #FF9F43, 10.90054px 24.48302px 0 5.2px #FF9F43, 11.77757px 24.1476px 0 5.13333px #FF9F43, 12.64443px 23.78072px 0 5.06667px #FF9F43, 13.5px 23.38269px 0 5px #FF9F43, 14.34315px 22.95384px 0 4.93333px #FF9F43, 15.17277px 22.49455px 0 4.86667px #FF9F43, 15.98776px 22.00526px 0 4.8px #FF9F43, 16.78704px 21.48643px 0 4.73333px #FF9F43, 17.56953px 20.93855px 0 4.66667px #FF9F43, 18.33418px 20.36217px 0 4.6px #FF9F43, 19.07995px 19.75787px 0 4.53333px #FF9F43, 19.80582px 19.12626px 0 4.46667px #FF9F43, 20.5108px 18.468px 0 4.4px #FF9F43, 21.1939px 17.78379px 0 4.33333px #FF9F43, 21.85416px 17.07434px 0 4.26667px #FF9F43, 22.49067px 16.34043px 0 4.2px #FF9F43, 23.10251px 15.58284px 0 4.13333px #FF9F43, 23.68881px 14.80241px 0 4.06667px #FF9F43, 24.24871px 14px 0 4px #FF9F43, 24.7814px 13.1765px 0 3.93333px #FF9F43, 25.28607px 12.33284px 0 3.86667px #FF9F43, 25.76198px 11.46997px 0 3.8px #FF9F43, 26.2084px 10.58888px 0 3.73333px #FF9F43, 26.62462px 9.69057px 0 3.66667px #FF9F43, 27.01001px 8.77608px 0 3.6px #FF9F43, 27.36392px 7.84648px 0 3.53333px #FF9F43, 27.68577px 6.90284px 0 3.46667px #FF9F43, 27.97502px 5.94627px 0 3.4px #FF9F43, 28.23116px 4.97791px 0 3.33333px #FF9F43, 28.4537px 3.99891px 0 3.26667px #FF9F43, 28.64223px 3.01042px 0 3.2px #FF9F43, 28.79635px 2.01364px 0 3.13333px #FF9F43, 28.91571px 1.00976px 0 3.06667px #FF9F43, 29px 0 0 3px #FF9F43, 29.04896px -1.01441px 0 2.93333px #FF9F43, 29.06237px -2.03224px 0 2.86667px #FF9F43, 29.04004px -3.05223px 0 2.8px #FF9F43, 28.98185px -4.07313px 0 2.73333px #FF9F43, 28.88769px -5.09368px 0 2.66667px #FF9F43, 28.75754px -6.1126px 0 2.6px #FF9F43, 28.59138px -7.12863px 0 2.53333px #FF9F43, 28.38926px -8.14049px 0 2.46667px #FF9F43, 28.15127px -9.1469px 0 2.4px #FF9F43, 27.87755px -10.1466px 0 2.33333px #FF9F43, 27.56827px -11.1383px 0 2.26667px #FF9F43, 27.22365px -12.12075px 0 2.2px #FF9F43, 26.84398px -13.09268px 0 2.13333px #FF9F43, 26.42956px -14.05285px 0 2.06667px #FF9F43, 25.98076px -15px 0 2px #FF9F43, 25.49798px -15.93291px 0 1.93333px #FF9F43, 24.98167px -16.85035px 0 1.86667px #FF9F43, 24.43231px -17.75111px 0 1.8px #FF9F43, 23.85046px -18.63402px 0 1.73333px #FF9F43, 23.23668px -19.49789px 0 1.66667px #FF9F43, 22.5916px -20.34157px 0 1.6px #FF9F43, 21.91589px -21.16393px 0 1.53333px #FF9F43, 21.21024px -21.96384px 0 1.46667px #FF9F43, 20.4754px -22.74023px 0 1.4px #FF9F43, 19.71215px -23.49203px 0 1.33333px #FF9F43, 18.92133px -24.2182px 0 1.26667px #FF9F43, 18.10379px -24.91772px 0 1.2px #FF9F43, 17.26042px -25.58963px 0 1.13333px #FF9F43, 16.39217px -26.23295px 0 1.06667px #FF9F43, 15.5px -26.84679px 0 1px #FF9F43, 14.58492px -27.43024px 0 0.93333px #FF9F43, 13.64796px -27.98245px 0 0.86667px #FF9F43, 12.69018px -28.50262px 0 0.8px #FF9F43, 11.7127px -28.98995px 0 0.73333px #FF9F43, 10.71663px -29.4437px 0 0.66667px #FF9F43, 9.70313px -29.86317px 0 0.6px #FF9F43, 8.67339px -30.2477px 0 0.53333px #FF9F43, 7.6286px -30.59666px 0 0.46667px #FF9F43, 6.57001px -30.90946px 0 0.4px #FF9F43, 5.49886px -31.18558px 0 0.33333px #FF9F43, 4.41643px -31.42451px 0 0.26667px #FF9F43, 3.32401px -31.6258px 0 0.2px #FF9F43, 2.22291px -31.78904px 0 0.13333px #FF9F43, 1.11446px -31.91388px 0 0.06667px #FF9F43, 0 -32px 0 0 #FF9F43, -1.11911px -32.04713px 0 -0.06667px #FF9F43, -2.24151px -32.05506px 0 -0.13333px #FF9F43, -3.36582px -32.02361px 0 -0.2px #FF9F43, -4.49065px -31.95265px 0 -0.26667px #FF9F43, -5.61462px -31.84212px 0 -0.33333px #FF9F43, -6.73634px -31.69198px 0 -0.4px #FF9F43, -7.8544px -31.50227px 0 -0.46667px #FF9F43, -8.9674px -31.27305px 0 -0.53333px #FF9F43, -10.07395px -31.00444px 0 -0.6px #FF9F43, -11.17266px -30.69663px 0 -0.66667px #FF9F43, -12.26212px -30.34982px 0 -0.73333px #FF9F43, -13.34096px -29.96429px 0 -0.8px #FF9F43, -14.4078px -29.54036px 0 -0.86667px #FF9F43, -15.46126px -29.07841px 0 -0.93333px #FF9F43, -16.5px -28.57884px 0 -1px #FF9F43, -17.52266px -28.04212px 0 -1.06667px #FF9F43, -18.52792px -27.46878px 0 -1.13333px #FF9F43, -19.51447px -26.85936px 0 -1.2px #FF9F43, -20.48101px -26.21449px 0 -1.26667px #FF9F43, -21.42625px -25.53481px 0 -1.33333px #FF9F43, -22.34896px -24.82104px 0 -1.4px #FF9F43, -23.2479px -24.07391px 0 -1.46667px #FF9F43, -24.12186px -23.29421px 0 -1.53333px #FF9F43, -24.96967px -22.48279px 0 -1.6px #FF9F43, -25.79016px -21.64052px 0 -1.66667px #FF9F43, -26.58223px -20.76831px 0 -1.73333px #FF9F43, -27.34477px -19.86714px 0 -1.8px #FF9F43, -28.07674px -18.938px 0 -1.86667px #FF9F43, -28.7771px -17.98193px 0 -1.93333px #FF9F43, -29.44486px -17px 0 -2px #FF9F43, -30.07908px -15.99333px 0 -2.06667px #FF9F43, -30.67884px -14.96307px 0 -2.13333px #FF9F43, -31.24325px -13.91039px 0 -2.2px #FF9F43, -31.7715px -12.83652px 0 -2.26667px #FF9F43, -32.26278px -11.74269px 0 -2.33333px #FF9F43, -32.71634px -10.63018px 0 -2.4px #FF9F43, -33.13149px -9.5003px 0 -2.46667px #FF9F43, -33.50755px -8.35437px 0 -2.53333px #FF9F43, -33.84391px -7.19374px 0 -2.6px #FF9F43, -34.14px -6.0198px 0 -2.66667px #FF9F43, -34.39531px -4.83395px 0 -2.73333px #FF9F43, -34.60936px -3.63759px 0 -2.8px #FF9F43, -34.78173px -2.43218px 0 -2.86667px #FF9F43, -34.91205px -1.21916px 0 -2.93333px #FF9F43, -35px 0 0 -3px #FF9F43, -35.04531px 1.22381px 0 -3.06667px #FF9F43, -35.04775px 2.45078px 0 -3.13333px #FF9F43, -35.00717px 3.6794px 0 -3.2px #FF9F43, -34.92345px 4.90817px 0 -3.26667px #FF9F43, -34.79654px 6.13557px 0 -3.33333px #FF9F43, -34.62643px 7.36007px 0 -3.4px #FF9F43, -34.41316px 8.58016px 0 -3.46667px #FF9F43, -34.15683px 9.79431px 0 -3.53333px #FF9F43, -33.85761px 11.001px 0 -3.6px #FF9F43, -33.5157px 12.19872px 0 -3.66667px #FF9F43, -33.13137px 13.38594px 0 -3.73333px #FF9F43, -32.70493px 14.56117px 0 -3.8px #FF9F43, -32.23675px 15.72291px 0 -3.86667px #FF9F43, -31.72725px 16.86968px 0 -3.93333px #FF9F43, -31.17691px 18px 0 -4px #FF9F43, -30.58627px 19.11242px 0 -4.06667px #FF9F43, -29.95589px 20.2055px 0 -4.13333px #FF9F43, -29.28642px 21.27783px 0 -4.2px #FF9F43, -28.57852px 22.32799px 0 -4.26667px #FF9F43, -27.83295px 23.35462px 0 -4.33333px #FF9F43, -27.05047px 24.35635px 0 -4.4px #FF9F43, -26.23192px 25.33188px 0 -4.46667px #FF9F43, -25.37819px 26.27988px 0 -4.53333px #FF9F43, -24.49018px 27.1991px 0 -4.6px #FF9F43, -23.56888px 28.0883px 0 -4.66667px #FF9F43, -22.6153px 28.94626px 0 -4.73333px #FF9F43, -21.6305px 29.77183px 0 -4.8px #FF9F43, -20.61558px 30.56385px 0 -4.86667px #FF9F43, -19.57168px 31.32124px 0 -4.93333px #FF9F43, -18.5px 32.04294px 0 -5px #FF9F43, -17.40175px 32.72792px 0 -5.06667px #FF9F43, -16.27818px 33.37522px 0 -5.13333px #FF9F43, -15.1306px 33.98389px 0 -5.2px #FF9F43, -13.96034px 34.55305px 0 -5.26667px #FF9F43, -12.76875px 35.08186px 0 -5.33333px #FF9F43, -11.55724px 35.56951px 0 -5.4px #FF9F43, -10.32721px 36.01527px 0 -5.46667px #FF9F43, -9.08014px 36.41843px 0 -5.53333px #FF9F43, -7.81748px 36.77835px 0 -5.6px #FF9F43, -6.54075px 37.09443px 0 -5.66667px #FF9F43, -5.25147px 37.36612px 0 -5.73333px #FF9F43, -3.95118px 37.59293px 0 -5.8px #FF9F43, -2.64145px 37.77443px 0 -5.86667px #FF9F43, -1.32385px 37.91023px 0 -5.93333px #FF9F43;
  display: inline-block;
  height: 8px;
  overflow: hidden;
  position: relative;
  text-indent: -9999px;
  width: 8px;
  transform-origin: 50% 50%;
  -webkit-transform-origin: 50% 50%;
  -ms-transform-origin: 50% 50%;
  border-radius: 100%;
}

@keyframes loader {
  to {
    left: -100vw;
  }
}
@keyframes whirly-loader {
  0% {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(1turn);
  }
}
.sidebar, .sidebars {
  display: flex;
  background-color: #ffffff;
  border-right: 1px solid transparent;
  margin-top: 0;
  z-index: 1001;
  position: fixed;
  top: 66px;
  bottom: 0;
  left: 0;
  transition: all 0.5s ease;
  border-right: 1px solid #dbe0e6;
  width: 260px;
}
@media (max-width: 991.98px) {
  .sidebar, .sidebars {
    margin-left: -575px;
    transition: all 0.4s ease;
    z-index: 1041;
    background: #ffffff;
  }
}
@media (max-width: 575px) {
  .sidebar, .sidebars {
    width: 100%;
  }
}
.sidebar .slimScrollDiv, .sidebars .slimScrollDiv {
  background: #ffffff;
  border-right: 1px solid transparent;
}
@media (max-width: 575px) {
  .sidebar .slimScrollDiv, .sidebars .slimScrollDiv {
    width: 100% !important;
  }
}
.sidebar .sidebar-menu, .sidebars .sidebar-menu {
  padding: 24px;
}
.sidebar .sidebar-menu > ul > li, .sidebars .sidebar-menu > ul > li {
  margin-bottom: 24px;
}
.sidebar .sidebar-menu > ul > li.active a, .sidebars .sidebar-menu > ul > li.active a {
  color: #ffffff;
}
.sidebar .sidebar-menu > ul > li.active svg, .sidebars .sidebar-menu > ul > li.active svg {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li svg, .sidebars .sidebar-menu > ul > li svg {
  min-width: 16px;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.sidebar .sidebar-menu > ul > li > a, .sidebars .sidebar-menu > ul > li > a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 10px 15px;
  position: relative;
  color: #092C4C;
}
.sidebar .sidebar-menu > ul > li > a svg, .sidebars .sidebar-menu > ul > li > a svg {
  color: #637381;
}
.sidebar .sidebar-menu > ul > li > a img, .sidebars .sidebar-menu > ul > li > a img {
  width: 18px;
  color: #637381;
}
.sidebar .sidebar-menu > ul > li > a:hover, .sidebars .sidebar-menu > ul > li > a:hover {
  background: rgba(254, 159, 67, 0.08);
  color: #FE9F43;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li > a:hover img, .sidebars .sidebar-menu > ul > li > a:hover img {
  filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);
}
.sidebar .sidebar-menu > ul > li > a:hover span, .sidebars .sidebar-menu > ul > li > a:hover span {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li > a:hover svg, .sidebars .sidebar-menu > ul > li > a:hover svg {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li > a.active, .sidebars .sidebar-menu > ul > li > a.active {
  background: rgba(254, 159, 67, 0.08);
  color: #FE9F43;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li > a.active svg, .sidebars .sidebar-menu > ul > li > a.active svg {
  color: #ffffff;
}
.sidebar .sidebar-menu > ul > li > a.active img, .sidebars .sidebar-menu > ul > li > a.active img {
  filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);
}
.sidebar .sidebar-menu > ul > li > a.active span, .sidebars .sidebar-menu > ul > li > a.active span {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li > a.active .menu-arrow, .sidebars .sidebar-menu > ul > li > a.active .menu-arrow {
  background: #FFEDDC;
}
.sidebar .sidebar-menu > ul > li > a.active .menu-arrow::before, .sidebars .sidebar-menu > ul > li > a.active .menu-arrow::before {
  border-color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li > a span, .sidebars .sidebar-menu > ul > li > a span {
  font-size: 15px;
  font-weight: 500;
  color: #67748E;
}
.sidebar .sidebar-menu > ul > li.active a, .sidebars .sidebar-menu > ul > li.active a {
  background: rgba(254, 159, 67, 0.08);
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul > li.active a img, .sidebars .sidebar-menu > ul > li.active a img {
  filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);
}
.sidebar .sidebar-menu > ul > li.active a span, .sidebars .sidebar-menu > ul > li.active a span {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li.submenu ul, .sidebars .sidebar-menu > ul > li.submenu ul {
  border-bottom: 1px solid rgba(222, 226, 230, 0.5);
  padding: 10px 0;
  display: none;
}
.sidebar .sidebar-menu > ul > li.submenu ul li a, .sidebars .sidebar-menu > ul > li.submenu ul li a {
  font-weight: 500;
  font-size: 14px;
  color: #092C4C;
  position: relative;
  display: block;
  padding: 8px 8px 8px 40px;
}
.sidebar .sidebar-menu > ul > li.submenu ul li a.active, .sidebars .sidebar-menu > ul > li.submenu ul li a.active {
  color: #092C4C;
}
.sidebar .sidebar-menu > ul > li.submenu ul li a.active:after, .sidebars .sidebar-menu > ul > li.submenu ul li a.active:after {
  background: #FE9F43;
  border: 2px solid #FDB;
}
.sidebar .sidebar-menu > ul > li.submenu ul li a::after, .sidebars .sidebar-menu > ul > li.submenu ul li a::after {
  content: "";
  background: rgba(50, 71, 92, 0.38);
  width: 8px;
  height: 8px;
  border: 2px solid #ffffff;
  border-radius: 50px;
  position: absolute;
  top: 16px;
  left: 16px;
}
.sidebar .sidebar-menu > ul > li.submenu ul li a:hover, .sidebars .sidebar-menu > ul > li.submenu ul li a:hover {
  color: #FF9F43;
}
.sidebar .sidebar-menu > ul > li.submenu ul li a:hover:after, .sidebars .sidebar-menu > ul > li.submenu ul li a:hover:after {
  background: #FE9F43;
  border: 2px solid #FDB;
}
.sidebar .sidebar-menu > ul > li.submenu-open ul, .sidebars .sidebar-menu > ul > li.submenu-open ul {
  border-bottom: 1px solid #e8ebed;
  padding: 0 0 14px 0;
  display: block;
}
.sidebar .sidebar-menu > ul > li.submenu-open ul li a, .sidebars .sidebar-menu > ul > li.submenu-open ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  font-weight: 500;
  font-size: 15px;
  color: #67748E;
  position: relative;
  width: 100%;
  padding: 10px 10px 10px 18px;
}
.sidebar .sidebar-menu > ul > li.submenu-open ul li a span, .sidebars .sidebar-menu > ul > li.submenu-open ul li a span {
  white-space: nowrap;
  font-size: 14px;
  color: #5B6670;
}
.sidebar .sidebar-menu > ul > li.submenu-open ul li a.active, .sidebars .sidebar-menu > ul > li.submenu-open ul li a.active {
  color: #FF9F43;
}
.sidebar .sidebar-menu > ul > li.submenu-open ul li a.active a span, .sidebars .sidebar-menu > ul > li.submenu-open ul li a.active a span {
  color: #FF9F43;
}
.sidebar .sidebar-menu > ul > li.submenu-open ul li a.active:after, .sidebars .sidebar-menu > ul > li.submenu-open ul li a.active:after {
  background: #FE9F43;
  border: 2px solid #FDB;
}
.sidebar .sidebar-menu > ul > li.submenu-open ul li a:hover, .sidebars .sidebar-menu > ul > li.submenu-open ul li a:hover {
  color: #FF9F43;
}
.sidebar .sidebar-menu > ul > li.submenu-open ul li a:hover:after, .sidebars .sidebar-menu > ul > li.submenu-open ul li a:hover:after {
  background: #FE9F43;
  border: 2px solid #FDB;
}
.sidebar .sidebar-menu > ul > li.submenu-open ul li a:hover span, .sidebars .sidebar-menu > ul > li.submenu-open ul li a:hover span {
  color: #FF9F43;
}
.sidebar .sidebar-menu > ul > li.submenu-open ul > li.active a, .sidebars .sidebar-menu > ul > li.submenu-open ul > li.active a {
  background: rgba(254, 159, 67, 0.08);
  border-radius: 5px;
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul > li.submenu-open ul > li.active a span, .sidebars .sidebar-menu > ul > li.submenu-open ul > li.active a span {
  color: #FF9F43;
}
.sidebar .sidebar-menu > ul > li.submenu-open .submenu-hdr, .sidebars .sidebar-menu > ul > li.submenu-open .submenu-hdr {
  font-weight: 600;
  font-size: 14px;
  color: #1B2950;
  margin: 0 0 14px 0;
}
.sidebar .sidebar-menu > ul > li.submenu-open:first-child h6, .sidebars .sidebar-menu > ul > li.submenu-open:first-child h6 {
  margin-top: 0;
}
.sidebar .sidebar-menu > ul > li.submenu-open .submenu ul, .sidebars .sidebar-menu > ul > li.submenu-open .submenu ul {
  border: 0;
  padding-top: 0;
  padding-bottom: 0;
}
.sidebar .sidebar-menu > ul li.active a, .sidebars .sidebar-menu > ul li.active a {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul li.active svg, .sidebars .sidebar-menu > ul li.active svg {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul li .submenu > a.active, .sidebars .sidebar-menu > ul li .submenu > a.active {
  background: rgba(254, 159, 67, 0.08);
  color: #FE9F43;
  border-radius: 5px;
}
.sidebar .sidebar-menu > ul li .submenu > a.active span, .sidebars .sidebar-menu > ul li .submenu > a.active span {
  color: #FE9F43;
}
.sidebar .sidebar-menu > ul li .submenu > a.active .menu-arrow, .sidebars .sidebar-menu > ul li .submenu > a.active .menu-arrow {
  background: #FFEDDC;
}
.sidebar .sidebar-menu > ul li .submenu > a.active .menu-arrow::before, .sidebars .sidebar-menu > ul li .submenu > a.active .menu-arrow::before {
  border-color: #FE9F43;
}
.sidebar .sidebar-menu > ul li .submenu .submenu-two > a.active, .sidebars .sidebar-menu > ul li .submenu .submenu-two > a.active {
  background: transparent;
}
.sidebar .sidebar-menu .submenu-open:last-child, .sidebars .sidebar-menu .submenu-open:last-child {
  margin-bottom: 0;
}
.sidebar .sidebar-menu .submenu-open:last-child ul, .sidebars .sidebar-menu .submenu-open:last-child ul {
  border-bottom: none;
  padding-bottom: 0;
}
.sidebar .sidebar-menu .submenu-open .submenu.submenu-two ul li a, .sidebars .sidebar-menu .submenu-open .submenu.submenu-two ul li a {
  margin-left: 45px;
}
.sidebar .sidebar-menu .submenu-open .submenu.submenu-two.submenu-three ul li a, .sidebars .sidebar-menu .submenu-open .submenu.submenu-two.submenu-three ul li a {
  margin-left: 65px;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a, .sidebars .sidebar-menu .submenu-open .submenu ul li a {
  margin-left: 25px;
  padding-bottom: 4px;
  font-size: 14px;
  color: #B8BCC9;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a::after, .sidebars .sidebar-menu .submenu-open .submenu ul li a::after {
  content: "";
  background: rgba(50, 71, 92, 0.38);
  width: 8px;
  height: 8px;
  border: 2px solid #ffffff;
  border-radius: 50px;
  position: absolute;
  top: 16px;
  left: 0;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a:hover, .sidebars .sidebar-menu .submenu-open .submenu ul li a:hover {
  color: #FF9F43;
}
.sidebar .sidebar-menu .submenu-open .submenu ul li a:hover:after, .sidebars .sidebar-menu .submenu-open .submenu ul li a:hover:after {
  background: #FE9F43;
  border: 2px solid #FDB;
}
.sidebar .sidebar-menu .menu-arrow, .sidebars .sidebar-menu .menu-arrow {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  text-rendering: auto;
  line-height: 40px;
  font-size: 18px;
  line-height: 16px;
  background: rgba(27, 41, 80, 0.04);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  position: absolute;
  top: 12px;
  right: 15px;
  transform: translate(0, 0);
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
  transition: all 0.2s ease;
}
.sidebar .sidebar-menu .menu-arrow::before, .sidebars .sidebar-menu .menu-arrow::before {
  height: 5px;
  width: 5px;
  border-top: 0;
  content: "";
  border-left: 0;
  border-right: 1px solid #5B6670;
  border-bottom: 1px solid #5B6670;
  transform: rotate(-45deg);
  position: absolute;
  left: 5px;
  top: 5px;
}
.sidebar .sidebar-menu .menu-arrow.inside-submenu, .sidebars .sidebar-menu .menu-arrow.inside-submenu {
  right: 40px;
}
.sidebar .sidebar-menu .menu-arrow.inside-submenu.inside-submenu-two, .sidebars .sidebar-menu .menu-arrow.inside-submenu.inside-submenu-two {
  right: 60px;
}
.sidebar .sidebar-menu.subdrop .menu-arrow, .sidebars .sidebar-menu.subdrop .menu-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  background: #FFEDDC;
}
.sidebar .nav-link, .sidebars .nav-link {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 10px;
  color: #092C4C;
  position: relative;
}
.sidebar .nav-link.active, .sidebars .nav-link.active {
  color: #FF9F43;
  background: transparent;
  position: relative;
}
.sidebar .nav-link.active:after, .sidebars .nav-link.active:after {
  content: "";
  border-width: 10px;
  border-color: transparent #FF9F43 transparent transparent;
  border-style: solid;
  position: absolute;
  top: 36px;
  right: 0;
}
.sidebar .sidebar-left, .sidebars .sidebar-left {
  width: 100px;
  box-shadow: 5px 0px 15px rgba(0, 0, 0, 0.05);
}
.sidebar .sidebar-right, .sidebars .sidebar-right {
  width: 250px;
  height: 100%;
  transition: all 0.2s ease;
  display: none;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right, .sidebars .sidebar-right {
    width: calc(100% - 70px);
  }
}
.sidebar .sidebar-right .slimScrollDiv, .sidebars .sidebar-right .slimScrollDiv {
  width: 250px !important;
  overflow: visible !important;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right .slimScrollDiv, .sidebars .sidebar-right .slimScrollDiv {
    width: 100% !important;
  }
}
.sidebar .sidebar-right .tab-content, .sidebars .sidebar-right .tab-content {
  padding: 20px 20px 40px;
}
@media (max-width: 991.98px) {
  .sidebar .sidebar-right .tab-content, .sidebars .sidebar-right .tab-content {
    padding: 10px;
  }
}
.sidebar .sidebar-right p, .sidebars .sidebar-right p {
  font-size: 10px;
  color: #adb5bd;
  text-transform: uppercase;
  font-weight: 700;
  margin-bottom: 10px;
}
.sidebar .sidebar-right ul, .sidebars .sidebar-right ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.sidebar .sidebar-right ul li.active a, .sidebars .sidebar-right ul li.active a {
  background: linear-gradient(46.62deg, #FF9F43 0%, #423B93 93.64%);
  color: #ffffff;
}
.sidebar .sidebar-right ul li a, .sidebars .sidebar-right ul li a {
  font-weight: 400;
  font-size: 14px;
  color: #092C4C;
}
.sidebar .sidebar-right ul li a.active, .sidebars .sidebar-right ul li a.active {
  color: #FF9F43;
}
.sidebar .sidebar-right .menu-arrow, .sidebars .sidebar-right .menu-arrow {
  transition: transform 0.15s;
  display: inline-block;
  font-family: "Font Awesome 5 Free";
  text-rendering: auto;
  line-height: 40px;
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 18px;
  top: 0px;
  position: relative;
  font-weight: 700;
  transform: translate(0, 0);
  -webkit-transform: translate(0, 0);
  -ms-transform: translate(0, 0);
}
.sidebar .sidebar-right .menu-arrow:before, .sidebars .sidebar-right .menu-arrow:before {
  content: "\\f105";
}
.sidebar .sub-menu a, .sidebars .sub-menu a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.sidebar li a.subdrop .menu-arrow, .sidebars li a.subdrop .menu-arrow {
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.sidebar .nav-items .nav-link, .sidebars .nav-items .nav-link {
  display: flex;
  flex-direction: column;
  border-radius: 0;
  border-bottom: 1px solid #dbe0e6;
  padding: 20px 0;
  transition: all 0.4s ease;
}
.sidebar .nav-items .nav-link:hover, .sidebars .nav-items .nav-link:hover {
  box-shadow: 0 0 0 150px #423B93 inset;
  color: #ffffff;
}
.sidebar .nav-items .nav-link span, .sidebars .nav-items .nav-link span {
  margin-top: 15px;
  font-weight: 500;
}
.sidebar .sidemenu a, .sidebars .sidemenu a {
  width: 100%;
  font-weight: 500;
  display: block;
  border-radius: 5px;
  margin: 0 0 10px;
  padding: 10px;
}
.sidebar .sidemenu a:hover, .sidebars .sidemenu a:hover {
  background: linear-gradient(46.62deg, #FF9F43 0%, #423B93 93.64%);
  color: #ffffff;
}
.sidebar .sidemenu a:hover svg, .sidebars .sidemenu a:hover svg {
  color: #ffffff;
}
.sidebar .sidemenu a svg, .sidebars .sidemenu a svg {
  stroke-width: 1px;
}

.header-left #toggle_btn {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: absolute;
  opacity: 1;
  background: #FF9F43;
  right: -13px;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  color: #ffffff;
  cursor: pointer;
}
.header-left #toggle_btn svg {
  transform: rotate(180deg);
}
.header-left #toggle_btn:hover {
  background: #ff8510;
}
.header-left.active svg {
  transform: rotate(0) !important;
}

@media (min-width: 991.98px) {
  .mini-sidebar .page-wrapper {
    margin-left: 80px;
  }
  .mini-sidebar .header-left #toggle_btn {
    opacity: 0;
  }
  .mini-sidebar .header-left #toggle_btn:after {
    border: 0;
  }
  .mini-sidebar.expand-menu .header-left #toggle_btn {
    opacity: 1;
  }
  .mini-sidebar .sidebar-right {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li a span {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li .submenu-hdr {
    display: none;
  }
  .mini-sidebar .sidebar .sidebar-menu ul li svg {
    margin-right: 0;
  }
  .mini-sidebar .sidebar {
    width: 80px;
    overflow: hidden;
  }
  #toggle_btn {
    display: flex;
    align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    float: left;
    margin-left: 15px;
  }
}
body.mini-sidebar .sidebar .sidebar-menu > ul > li.submenu-open ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-weight: 500;
  font-size: 15px;
  color: #67748E;
  position: relative;
  width: 100%;
  padding: 10px;
}
body.mini-sidebar.expand-menu .sidebar .sidebar-menu > ul > li.submenu-open ul li a {
  justify-content: left;
  -webkit-justify-content: left;
  -ms-flex-pack: left;
  padding-left: 18px;
}

.sidebarrightmenu .sidebar-right {
  display: block;
}

.slide-nav .sidebar {
  margin-left: 0;
}

.sidebar-overlay {
  display: none;
  height: 100%;
  width: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.6);
  position: fixed;
  top: 60px;
  left: 0;
}
.sidebar-overlay.opened {
  display: block;
}

.nosidebar .sidebar {
  left: -350px;
}
.nosidebar .page-wrapper {
  margin: 0;
}
.nosidebar #toggle_btn svg {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}

.mini-sidebar .active.subdrop ~ ul {
  display: none !important;
}

.mini-sidebar.expand-menu .active.subdrop ~ ul {
  display: block !important;
}

.active.subdrop ~ ul {
  display: block !important;
}

.sidebar.horizontal-sidebar.sidebar-one .submenu ul {
  background: #FAFBFE;
}

.topnav-dropdown-header {
  border-bottom: 1px solid #e8ebed;
  text-align: center;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
}
.topnav-dropdown-header .notification-title {
  color: #343a40;
  display: block;
  float: left;
  font-size: 14px;
}
.topnav-dropdown-header .clear-noti {
  color: #FF4D4D;
  float: right;
  font-size: 11px;
  text-transform: uppercase;
}

.notifications .noti-content {
  height: 290px;
  width: 350px;
  overflow-y: auto;
  position: relative;
}
.notifications .notification-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.notifications .notification-list li {
  margin-top: 0;
  border-bottom: 1px solid #f3f6f9;
  font-size: 14px;
}
.notifications .notification-list li a {
  display: block;
  padding: 12px;
  border-radius: 2px;
}
.notifications .notification-list li .avatar {
  width: 34px;
  height: 34px;
  margin: 0 10px 0 0;
  border-radius: 50%;
}
.notifications .notification-list li .avatar img {
  border-radius: 50%;
}
.notifications .notification-list li .noti-title {
  color: #343a40;
  font-weight: 500;
}
.notifications .notification-list li .noti-details {
  color: #adb5bd;
  margin: 0;
}
.notifications .notification-list li p.noti-time {
  margin: 0;
}
.notifications .notification-list li .notification-time {
  font-size: 12px;
  line-height: 1.35;
  color: #67748E;
}
.notifications .notification-list li .list-item {
  border: 0;
  padding: 0;
  position: relative;
}
.notifications .notification-list li .list-item .list-left {
  height: 48px;
  position: absolute;
  width: 48px;
}
.notifications .notification-list li .list-item .list-body {
  padding: 0 0 0 50px;
}
.notifications .notification-list li .list-item .list-body .message-author {
  color: #343a40;
  float: left;
  font-weight: 500;
  width: 175px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.notifications .notification-list li .list-item .list-body .message-time {
  color: #67748E;
  float: right;
  font-size: 11px;
}
.notifications .notification-list li .list-item .list-body .message-content {
  color: #343a40;
  font-size: 13px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.topnav-dropdown-footer {
  border-top: 1px solid #e8ebed;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
  padding: 0 12px;
}
.topnav-dropdown-footer a {
  display: block;
  text-align: center;
  color: #343a40;
}

.list-left {
  height: 48px;
  position: absolute;
  width: 48px;
}

.list-body {
  padding: 0 0 0 50px;
}
.list-body .message-author {
  color: #343a40;
  float: left;
  font-weight: 500;
  width: 175px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.list-body .message-time {
  color: #67748E;
  float: right;
  font-size: 11px;
}
.list-body .message-content {
  color: #343a40;
  font-size: 13px;
  display: block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.activity {
  width: 100%;
}
.activity .activity-box {
  position: relative;
}
.activity .activity-list {
  list-style: none;
  padding: 0;
  margin: 0;
  position: relative;
}
.activity .activity-list li {
  background-color: #ffffff;
  position: relative;
  border: 1px solid #dbe0e6;
  margin: 0 0 10px;
  padding: 20px 10px 10px;
  font-size: 15px;
}
.activity .activity-list li .activity-user {
  height: 50px;
  margin: 0;
  padding: 0;
  width: 50px;
  position: absolute;
  top: 12px;
  left: 8px;
}
.activity .activity-list li .activity-content {
  background-color: #ffffff;
  position: relative;
  margin: 0 0 0 60px;
  padding: 0;
}
.activity .activity-list li .time {
  color: #adb5bd;
  display: block;
  font-size: 12px;
  line-height: 1.35;
}
.activity .activity-list li a.name {
  color: #000000;
}
.activity .activity-list li a {
  color: #092C4C;
  font-weight: 600;
  font-size: 15px;
}
.activity .activity-list li a img {
  width: 50px;
  height: 50px;
  border-radius: 5px;
}

.account-page .customizer-links, .error-page .customizer-links {
  display: none;
}

.customizer-links {
  position: fixed;
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  background: #ffa500;
  border-radius: 10px 0px 0px 10px;
  z-index: 3;
  width: 41px;
  height: 38px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  flex-wrap: wrap;
  transition: all 0.3s ease;
}
.customizer-links:hover {
  background: #1B2850;
}
.customizer-links ul li {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.customizer-links ul li:last-child {
  border-bottom: 0;
}
.customizer-links ul li a {
  padding: 5px;
  text-align: center;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 5px;
}
.customizer-links ul li a svg {
  color: #ffffff;
  width: 16px;
  height: 16px;
}

.sidebar-settings {
  width: 450px;
  background-color: #ffffff;
  position: fixed;
  top: 0;
  right: -450px;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 9999;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-y: scroll;
  transition: ease all 0.8s;
}
.sidebar-settings.show-settings {
  right: 0;
  transition: ease all 0.8s;
  -ms-overflow-style: none;
  scrollbar-width: none;
  overflow-y: scroll;
  width: 100%;
}

.sidebar-content {
  max-width: 450px;
  width: 100%;
  position: absolute;
  top: 0;
  right: 0;
  background: #ffffff;
  height: 100vh;
  overflow-x: hidden;
}
.sidebar-content .sidebar-header {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 20px;
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background-color: #FF9F43;
}
.sidebar-content .sidebar-header h5 {
  font-size: 20px;
  color: #ffffff;
  font-weight: 700;
  margin-bottom: 0;
  text-transform: uppercase;
}
@media (max-width: 991.98px) {
  .sidebar-content .sidebar-header h5 {
    font-size: 18px;
  }
}
.sidebar-content .sidebar-header p {
  color: #ffffff;
}
.sidebar-content .sidebar-header a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #ffffff;
  width: 26px;
  height: 26px;
  border-radius: 5px;
  color: #ffffff;
}
.sidebar-content .sidebar-header a svg {
  width: 15px;
  height: 15px;
  color: #ffffff;
}
.sidebar-content .theme-head {
  margin-bottom: 20px;
}
.sidebar-content .theme-head h6 {
  color: #5B6670;
  font-weight: 700;
  font-size: 18px;
}
.sidebar-content .sidebar-body {
  padding: 20px;
}
.sidebar-content .sidebar-body .theme-title {
  font-size: 18px;
  font-weight: 700;
  color: #67748E;
  margin-bottom: 10px;
}

.switch-wrapper {
  border-bottom: 1px solid #dbe0e6;
  margin: 0 0 20px;
  padding: 0 0 20px;
}
.switch-wrapper #dark-mode-toggle {
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.switch-wrapper #dark-mode-toggle .light-mode {
  border-radius: 5px 0 0 5px;
}
.switch-wrapper #dark-mode-toggle .dark-mode {
  border-radius: 0 5px 5px 0;
}
.switch-wrapper #dark-mode-toggle .light-mode, .switch-wrapper #dark-mode-toggle .dark-mode {
  background: #dbe0e6;
  font-size: 16px;
  color: #000000;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 11px 18px;
  cursor: pointer;
}
.switch-wrapper #dark-mode-toggle .light-mode img, .switch-wrapper #dark-mode-toggle .dark-mode img {
  filter: brightness(0) saturate(100%);
}
.switch-wrapper #dark-mode-toggle .light-mode.active, .switch-wrapper #dark-mode-toggle .dark-mode.active {
  background: #ffa500;
  color: #ffffff;
}
.switch-wrapper #dark-mode-toggle .light-mode.active img, .switch-wrapper #dark-mode-toggle .dark-mode.active img {
  filter: brightness(0) invert(1);
}

.layout-wrap {
  margin-bottom: 20px;
}
.layout-wrap .status-toggle .checktoggle {
  background: #000000;
  width: 25px;
  height: 15px;
}
.layout-wrap .status-toggle .checktoggle :after {
  width: 12px;
  height: 12px;
  right: 4px;
}
.layout-wrap .layout-img img {
  max-width: 120px;
}
.layout-wrap .status-text {
  font-size: 16px;
  color: #000000;
}

.layout-link {
  position: relative;
  z-index: 9;
  width: 100%;
  height: 100%;
  display: inline-block;
}

.theme-mode {
  margin: 0 0 20px;
  padding: 0;
}
.theme-mode .theme-body-main {
  padding: 20px 20px 0;
}
.theme-mode .layout-wrap .check + label {
  text-align: center;
  cursor: pointer;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-direction: column;
}
.theme-mode .layout-wrap .check + label img {
  border-radius: 8px;
  border: 1px solid #f3f6f9;
}
.theme-mode .layout-wrap .check + label .theme-name {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #5B6670;
  font-weight: 700;
  font-size: 14px;
  margin-top: 10px;
  position: relative;
}
.theme-mode .layout-wrap .check + label .theme-name::before {
  content: "";
  width: 14px;
  height: 14px;
  border: 1px solid rgba(145, 158, 171, 0.3019607843);
  display: block;
  margin-right: 5px;
  border-radius: 50%;
}
.theme-mode .layout-wrap .check:checked + label img {
  border-color: #FF9F43;
}
.theme-mode .layout-wrap .check:checked + label .theme-name::after {
  content: "";
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background-color: #FF9F43;
  position: absolute;
  left: 4px;
}

@media (max-width: 991.98px) {
  #layout_mode {
    display: none;
  }
}

.sidebar-footer {
  position: sticky;
  padding: 20px;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
  box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);
  z-index: 110;
}

[data-layout-style=box][data-direction=rtl] body .page-wrapper .content {
  padding-left: 0;
  padding-right: 24px;
}
[data-layout-style=box] body {
  margin: auto;
  position: relative;
}
[data-layout-style=box] body .header {
  z-index: 9999;
  left: 100px;
  right: 100px;
}
[data-layout-style=box] body .sidebar {
  left: 100px;
}
[data-layout-style=box] body .page-wrapper {
  margin: 0 100px 0 380px;
}
[data-layout-style=box] body .page-wrapper .content {
  padding-right: 0;
}
[data-layout-style=box] body .page-wrapper.pos-pg-wrapper {
  margin-left: 80px !important;
}
@media (max-width: 1399px) {
  [data-layout-style=box] body .header {
    left: 70px;
    right: 70px;
  }
  [data-layout-style=box] body .sidebar {
    left: 70px;
  }
  [data-layout-style=box] body .page-wrapper {
    margin: 0 70px 0 350px;
  }
  [data-layout-style=box] body .page-wrapper.pos-pg-wrapper {
    margin-left: 50px !important;
  }
}
@media (max-width: 1199.98px) {
  [data-layout-style=box] body .header {
    left: 30px;
    right: 30px;
  }
  [data-layout-style=box] body .sidebar {
    left: 30px;
  }
  [data-layout-style=box] body .page-wrapper {
    margin: 0 30px 0 310px;
  }
  [data-layout-style=box] body .page-wrapper.pos-pg-wrapper {
    margin-left: 10px !important;
  }
}
@media (max-width: 991.98px) {
  [data-layout-style=box] body .header {
    left: 0;
    right: 0;
  }
  [data-layout-style=box] body .sidebar {
    left: 0;
  }
  [data-layout-style=box] body .page-wrapper {
    margin: 0;
  }
  [data-layout-style=box] body .page-wrapper .content {
    padding-right: 15px;
  }
}

[data-layout-style=collapsed][data-nav-color=grey] aside {
  background: #eff2f7;
}
[data-layout-style=collapsed][data-nav-color=dark] aside {
  background: #141432;
}
[data-layout-style=collapsed] .sidebar {
  display: none;
}
[data-layout-style=collapsed] .sidebar.collapsed-sidebar {
  display: block;
}
[data-layout-style=collapsed] .sidebar.collapsed-sidebar .nav-item {
  margin-right: 0;
}
[data-layout-style=collapsed] .sidebar.collapsed-sidebar .nav-item a:hover {
  background: transparent;
}
@media (max-width: 991.98px) {
  [data-layout-style=collapsed] .sidebar {
    display: block;
  }
  [data-layout-style=collapsed] .sidebar.collapsed-sidebar {
    display: none;
  }
}

[data-layout-style=horizontal] .sidebar {
  display: none;
}
[data-layout-style=horizontal] .sidebar.horizontal-sidebar {
  display: block;
}
@media (max-width: 991.98px) {
  [data-layout-style=horizontal] .sidebar {
    display: block;
  }
  [data-layout-style=horizontal] .sidebar.horizontal-sidebar {
    display: none;
  }
}
[data-layout-style=horizontal] .sidebar .sidebar-menu > ul > li > a.active svg {
  color: #FF9F43;
}
[data-layout-style=horizontal] .page-wrapper {
  margin-left: 0;
  padding-top: 140px;
}
[data-layout-style=horizontal] .header #toggle_btn {
  display: none;
}
[data-layout-style=horizontal] .sidebar .sidebar-menu > ul > li.submenu ul {
  background: rgb(246, 246, 246);
}
[data-layout-style=horizontal] .sidebar .sidebar-menu .nav > li > ul {
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
}
[data-layout-style=horizontal] body.header-collapse .header {
  display: none;
}
[data-layout-style=horizontal] body.header-collapse .horizontal-sidebar {
  top: 0;
  border-top: 0;
}
[data-layout-style=horizontal] body.header-collapse .page-wrapper {
  padding-top: 60px;
}
@media (max-width: 991.98px) {
  [data-layout-style=horizontal] .sidebar.collapsed-sidebar {
    display: none;
  }
  [data-layout-style=horizontal] .page-wrapper {
    padding-top: 80px;
  }
}

[data-layout-style=modern] .header {
  position: relative;
}
[data-layout-style=modern] .header #toggle_btn {
  display: none;
}
[data-layout-style=modern] .sidebar {
  display: none;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar {
  display: block;
  background: #141432;
  height: 150px;
  position: static;
  z-index: unset;
  border-top-color: #637381;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu {
  padding: 0 15px;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li {
  margin-bottom: 0;
  margin-right: 20px;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a {
  padding: 22px 15px;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a img, [data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a svg {
  filter: brightness(0) invert(1);
  margin-right: 0;
}
@media (max-width: 1199.98px) {
  [data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a {
    padding: 22px 5px;
  }
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a:hover {
  background: transparent;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a:hover span {
  color: #FF9F43 !important;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a:hover img, [data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a:hover svg {
  filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a img {
  top: 0 !important;
  width: auto;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a::before {
  content: "";
  position: absolute;
  top: 50%;
  right: -10px;
  width: 1px;
  height: 15px;
  background: #6B7A99;
  transform: translateY(-50%);
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a span {
  color: #ffffff !important;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li a {
  font-weight: 500;
  font-size: 15px;
  color: #ffffff;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li a img {
  position: relative;
  top: 3px;
  width: 18px;
  margin-right: 7px;
  filter: brightness(0) invert(1);
}
@media (max-width: 1199.98px) {
  [data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li a img {
    margin-right: 5px;
  }
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li a svg {
  width: 18px;
  margin-right: 7px;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li a:hover img, [data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li a:hover svg {
  filter: brightness(0) invert(1);
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li .menu-arrow {
  position: initial;
  transform: rotate(90deg);
  margin-left: 15px;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul {
  position: absolute;
  width: 250px;
  height: auto;
  z-index: 101;
  background: #1B2950;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a {
  padding: 8px 15px !important;
  color: #ffffff;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a ul li a.active span {
  color: #FF9F43;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a .menu-arrow {
  float: right;
  margin-right: 15px;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a i {
  margin-right: 7px;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a img {
  position: relative;
  top: 3px;
  width: 18px;
  margin-right: 7px;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a svg {
  width: 18px;
  margin-right: 7px;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a:hover {
  color: #FF9F43;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a:hover img {
  filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu ul {
  box-shadow: none;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu ul {
  position: relative;
  padding: 0;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu ul li a {
  padding: 8px 10px 8px 40px !important;
  color: #ffffff;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li a {
  padding: 8px 15px !important;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li a::after {
  content: none !important;
}
@media (max-width: 1199.98px) {
  [data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li {
    margin-right: 0;
  }
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li:last-child > a::before {
  content: none;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a span {
  color: #ffffff !important;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li > a.active span {
  color: #FF9F43 !important;
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu a svg {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);
}
[data-layout-style=modern] .sidebar.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu ul li a {
  color: #adb5bd;
}
[data-layout-style=modern] .sidebar ul.nav {
  justify-content: center;
}
[data-layout-style=modern] .page-wrapper {
  margin-left: 0;
  padding-top: 0;
}
[data-layout-style=modern] .page-wrapper .content {
  max-width: 1280px;
  margin: -90px auto 0 auto;
  background: #ffffff;
  border-radius: 20px;
  padding-bottom: 20px;
}
@media (max-width: 1199.98px) {
  [data-layout-style=modern] .page-wrapper .content {
    max-width: 950px;
  }
}

[data-nav-color=dark] .header {
  background: #141432;
  border-bottom: 1px solid #434548;
}
[data-nav-color=dark] .header .header-left {
  border-right: 1px solid #67748E;
  border-bottom: 1px solid #434548;
}
[data-nav-color=dark] .header .header-left .logo-normal {
  display: none;
}
[data-nav-color=dark] .header .header-left .logo-white {
  display: block !important;
}
[data-nav-color=dark] .header .searchinputs input {
  color: #97A2D2;
  border-color: #141432;
  background: #2c2c50;
}
[data-nav-color=dark] .header .searchinputs input::placeholder {
  color: #adb5bd;
}
[data-nav-color=dark] .mini-sidebar .header-left .logo-white {
  display: none !important;
}
[data-nav-color=dark] .mini-sidebar .header-left .logo-small {
  display: block !important;
}
[data-nav-color=dark] .mini-sidebar.expand-menu .logo-small {
  display: none !important;
}
[data-nav-color=dark] .mini-sidebar.expand-menu .logo-white {
  display: block !important;
}
[data-nav-color=dark] #toggle_btn:before {
  border: 2px solid #97A2D2;
}
[data-nav-color=dark] .user-menu.nav > li > a.select-store .user-info .user-name {
  color: #97A2D2;
}
[data-nav-color=dark] .user-info .user-name {
  color: #97A2D2;
}
[data-nav-color=dark] .user-menu .nav-item-box > a {
  background: #2c2c50;
}
[data-nav-color=dark] .header-left.active #toggle_btn:after {
  border: 2px solid #97A2D2;
}
[data-nav-color=dark] .sidebar {
  border-right: 1px solid #67748E;
  background-color: #141432;
}
[data-nav-color=dark] .sidebar .slimScrollDiv {
  background: #141432;
}
[data-nav-color=dark] .sidebar .sidebar-menu > ul > li.submenu ul {
  background: #141432;
  border-radius: 5px;
  padding: 10px 0;
}
[data-nav-color=dark] .sidebar .sidebar-menu > ul > li.submenu ul li a {
  color: #adb5bd;
}
[data-nav-color=dark] .sidebar .sidebar-menu > ul > li a img {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);
}
[data-nav-color=dark] .sidebar .sidebar-menu > ul > li a span {
  color: #adb5bd;
}
[data-nav-color=dark] .sidebar .sidebar-menu > ul > li a:hover img {
  color: #adb5bd;
}
[data-nav-color=dark] .sidebar .sidebar-menu > ul > li a:hover svg {
  filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);
}
[data-nav-color=dark] .sidebar .sidebar-menu > ul > li .submenu-hdr {
  color: #adb5bd;
}

[data-nav-color=grey] .header {
  background: #eff2f7;
}
[data-nav-color=grey] .header .user-menu .nav-item-box > a {
  background: #ffffff;
}
[data-nav-color=grey] .sidebar .slimScrollDiv, [data-nav-color=grey] .sidebars .slimScrollDiv {
  background: #eff2f7;
}
[data-nav-color=grey] .searchinputs input {
  border-color: #eff2f7;
  background: #ffffff;
}

[data-direction=rtl][data-layout-style=collapsed] .sidebar.collapsed-sidebar .sidebar-menu ul li a {
  padding: 10px 25px 10px 15px;
}
[data-direction=rtl][data-layout-style=collapsed] .sidebar.collapsed-sidebar .sidebar-menu ul li a::before {
  right: 10px;
  left: auto;
}
[data-direction=rtl][data-layout-style=collapsed] .sidebar.collapsed-sidebar .sidebar-menu ul li a .menu-arrow {
  left: 15px;
  right: auto;
}
[data-direction=rtl][data-layout-style=collapsed] .sidebar.collapsed-sidebar .tab-content-four {
  margin-right: 10px;
  margin-left: 0;
}
[data-direction=rtl] body {
  direction: rtl;
}
[data-direction=rtl] body .me-2 {
  margin-left: 0.5rem !important;
  margin-right: 0 !important;
}
[data-direction=rtl] body .ms-2 {
  margin-right: 0.5rem !important;
  margin-left: 0 !important;
}
[data-direction=rtl] body .header .header-left {
  float: right;
  border-left: 1px solid #DEE2E6;
}
[data-direction=rtl] body .header .header-left #toggle_btn {
  left: -13px;
  right: auto;
}
@media (min-width: 991.98px) {
  [data-direction=rtl] body .header .header-left #toggle_btn {
    float: right;
    font-size: 26px;
    line-height: 50px;
    margin-right: 15px;
    margin-left: 0;
  }
  [data-direction=rtl] body .header .header-left #toggle_btn .bar-icon {
    display: inline-block;
    width: 21px;
  }
  [data-direction=rtl] body .header .header-left #toggle_btn .bar-icon span {
    background-color: #ffffff;
    display: block;
    float: right;
    height: 2px;
    width: 21px;
    margin: 0 0 5px;
    border-radius: 50px;
  }
  [data-direction=rtl] body .header .header-left #toggle_btn .bar-icon span:nth-child(2) {
    width: 15px;
  }
}
[data-direction=rtl] body .header .user-menu .nav-searchinputs {
  margin-left: auto;
  margin-right: 25px;
}
[data-direction=rtl] body .header .user-menu > li > a.select-store .user-info {
  padding: 3px 0px 3px 25px;
}
@media (max-width: 1199.98px) {
  [data-direction=rtl] body .header .user-menu > li > a.select-store .user-info {
    padding-right: 0;
    padding-left: 15px;
  }
}
[data-direction=rtl] body .header .user-menu > li > a.select-store .user-info .user-letter {
  margin-right: 0;
  margin-left: 10px;
}
[data-direction=rtl] body .header .user-menu > li > a.select-store .user-info:after {
  right: auto;
  left: 6px;
}
[data-direction=rtl] body .header .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item.active, [data-direction=rtl] body .header .user-menu.nav > li.flag-nav .dropdown-menu .dropdown-item:hover {
  background: #F7F7F7 url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat calc(12% - 12px) center;
}
[data-direction=rtl] body .header .user-menu.nav > li.flag-nav .dropdown-menu a img {
  margin-right: 0;
  margin-left: 10px;
}
[data-direction=rtl] body .header .user-info {
  padding: 0 0 0 30px;
}
[data-direction=rtl] body .header .user-info::after {
  left: 12px;
  right: auto;
}
[data-direction=rtl] body .header .user-info .user-letter {
  margin-left: 10px;
  margin-right: 0;
}
[data-direction=rtl] body .header .select-store-dropdown .dropdown-menu .dropdown-item img {
  margin-left: 8px;
  margin-right: 0;
}
[data-direction=rtl] body .sidebar, [data-direction=rtl] body .sidebars {
  right: 0;
  left: auto;
}
[data-direction=rtl] body .sidebar .sidebar-menu .menu-arrow, [data-direction=rtl] body .sidebars .sidebar-menu .menu-arrow {
  left: 15px;
  right: auto;
}
[data-direction=rtl] body .sidebar .sidebar-menu ul li svg, [data-direction=rtl] body .sidebars .sidebar-menu ul li svg {
  margin-left: 10px;
  margin-right: 0;
}
[data-direction=rtl] body .sidebar .sidebar-menu .submenu-open .submenu ul li a, [data-direction=rtl] body .sidebars .sidebar-menu .submenu-open .submenu ul li a {
  margin-right: 25px;
  margin-left: 0;
  padding: 10px 18px 10px 10px;
}
[data-direction=rtl] body .sidebar .sidebar-menu .submenu-open .submenu ul li a::after, [data-direction=rtl] body .sidebars .sidebar-menu .submenu-open .submenu ul li a::after {
  right: 0;
  left: auto;
}
[data-direction=rtl] body .page-wrapper {
  margin: 0 260px 0 0;
}
[data-direction=rtl] body .customizer-links {
  left: 0;
  right: auto;
  border-radius: 0 10px 10px 0px;
}
[data-direction=rtl] body .sidebar-settings {
  left: -450px;
  right: auto;
}
[data-direction=rtl] body .sidebar-settings.show-settings {
  left: 0;
  right: auto;
}
[data-direction=rtl] body .sidebar-settings .sidebar-content {
  left: 0;
  right: auto;
}
[data-direction=rtl] body .sidebar-settings .sidebar-content .layout-wrap .check + label .theme-name::before {
  content: "";
  margin-left: 5px;
  margin-right: 0;
  border-radius: 50%;
}
[data-direction=rtl] body .sidebar-settings .sidebar-content .layout-wrap .check:checked + label .theme-name::after {
  content: "";
  right: 4px;
  left: auto;
}
[data-direction=rtl] body .dash-widget .dash-widgetcontent {
  margin-right: 20px;
  margin-left: 0;
}
[data-direction=rtl] body table.dataTable thead th, [data-direction=rtl] body table.dataTable thead td, [data-direction=rtl] body table.dataTable tfoot th, [data-direction=rtl] body table.dataTable tfoot td {
  text-align: right;
}
[data-direction=rtl] body .graph-sets > ul li {
  margin-left: 35px;
  margin-right: 0;
}
[data-direction=rtl] body .table tbody tr td a.product-img {
  margin-left: 5px;
  margin-right: 0;
}
[data-direction=rtl] body table.dataTable > thead .sorting:after,
[data-direction=rtl] body table.dataTable > thead .sorting_asc:after,
[data-direction=rtl] body table.dataTable > thead .sorting_desc:after,
[data-direction=rtl] body table.dataTable > thead .sorting_asc_disabled:after,
[data-direction=rtl] body table.dataTable > thead .sorting_desc_disabled:after {
  left: 0.5em !important;
  right: auto !important;
}
[data-direction=rtl] body table.dataTable > thead .sorting:before,
[data-direction=rtl] body table.dataTable > thead .sorting_asc:before,
[data-direction=rtl] body table.dataTable > thead .sorting_desc:before,
[data-direction=rtl] body table.dataTable > thead .sorting_asc_disabled:before,
[data-direction=rtl] body table.dataTable > thead .sorting_desc_disabled:before {
  left: 0.5em !important;
  right: auto !important;
}
[data-direction=rtl] body table.dataTable thead > tr > th.sorting, [data-direction=rtl] body table.dataTable thead > tr > th.sorting_asc {
  padding-left: 25px;
  padding-right: 17px;
}
@media (min-width: 991.98px) {
  [data-direction=rtl] .mini-sidebar .page-wrapper {
    margin-right: 80px;
  }
}
[data-direction=rtl] .page-header .page-btn {
  margin-right: 15px;
  margin-left: 0;
}
[data-direction=rtl] .page-header .add-item.d-flex {
  margin-left: auto;
  margin-right: 0;
}
[data-direction=rtl] .search-set .search-input .btn-searchset {
  left: 0;
  right: auto;
}

.sidebar.horizontal-sidebar {
  display: none;
}

.pos-modal .modal-header h5 {
  margin-bottom: 0;
}

.modal button.close {
  font-size: 20px;
}
.modal button.close:hover {
  background: #FF0000;
}

.custom-modal-header .page-title h4 {
  margin-bottom: 0;
}

.product-wrap .product-list .info span {
  margin-bottom: 7px;
  display: inline-block;
}
.product-wrap .product-list .info h6 a {
  margin-bottom: 5px;
  display: inline-block;
}

.tabs_wrapper ul.tabs li.active span {
  color: #ffffff;
}

/****** Pages ******/
.main-chat-blk .slimscroll {
  height: calc(100vh - 60px) !important;
}
.main-chat-blk .slimscroll-active-sidebar a {
  color: #5B6670;
}
.main-chat-blk .emoj-group ul {
  display: flex;
  align-items: center;
}
.main-chat-blk .emoj-group ul li + li {
  margin-left: 10px;
}
.main-chat-blk .emoj-group ul li a {
  width: 34px;
  height: 34px;
  background: #f6f7f8;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .emoj-group ul li a i {
  color: #424242;
}
.main-chat-blk .message-content {
  position: relative;
}
.main-chat-blk .message-content:hover .emoj-group {
  opacity: 1;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group {
  position: absolute;
  top: 50%;
  right: -100px;
  opacity: 0;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  transform: translate(0, -50%);
}
.main-chat-blk .rig-emoji-group {
  position: absolute;
  right: 210px;
}
.main-chat-blk .wrap-emoji-group {
  position: absolute;
  right: 290px;
}
.main-chat-blk .emoj-group-list-foot {
  display: none;
  position: absolute;
  top: -50px;
  left: -90px;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group-list-foot ul {
  display: flex;
  align-items: center;
  background: #f6f7f8;
  border-radius: 50px;
  padding: 5px;
}
.main-chat-blk .emoj-group-list-foot ul li a {
  padding: 0;
  display: flex;
  align-items: center;
}
.main-chat-blk .emoj-group-list-foot ul li.add-emoj a {
  background: #EDEDED;
}
.main-chat-blk .emoj-group-list-foot ul li.add-emoj a i {
  font-size: 20px;
  color: #424242;
}
.main-chat-blk .down-emoji-circle {
  position: absolute;
  left: 10px !important;
  top: -38px !important;
}
.main-chat-blk .emoj-action-foot .down-emoji-circle ul {
  padding: 10px;
}
.main-chat-blk .down-emoji-circle ul li + li {
  margin-left: 14px;
}
.main-chat-blk .emoj-action-foot .down-emoji-circle ul li:last-child a {
  width: 34px;
  height: 34px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-page-wrapper .content {
  padding: 0;
}
.main-chat-blk .chat-page-wrapper .sidebar {
  position: initial;
}
@media (max-width: 991.98px) {
  .main-chat-blk .chat-page-wrapper .sidebar {
    margin-left: 0;
  }
}
.main-chat-blk .chat-page-wrapper .left-chat-title {
  padding: 24px;
  border-bottom: 1px solid #E0E0E0;
  min-height: 72px;
}
.main-chat-blk .chat-page-wrapper .setting-title-head h4 {
  font-size: 18px;
  color: #092C4C;
  font-weight: 700;
}
.main-chat-blk .chat-page-wrapper .chat .slimscroll {
  height: calc(100vh - 135px) !important;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item {
  font-size: 14px;
  cursor: pointer;
  padding: 7px 14px;
  font-weight: 500;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item i {
  font-size: 16px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item span {
  float: right;
  font-size: 18px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item.active {
  background: none;
  color: inherit;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:focus,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:hover,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:active {
  background-color: #e6e6e6;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu {
  background: #ffffff;
  border: 1px solid #E5E7EB;
  box-sizing: border-box;
  box-shadow: 0px 4px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  min-width: 173px;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item {
  margin: 0;
  position: relative;
  display: flex;
  align-items: center;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu.chat-drop-menu .dropdown-item i {
  font-size: 16px;
  color: #424242;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:hover,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:focus,
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:active {
  background-color: #F8ECFF;
}
.main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item span {
  margin-right: 10px;
  display: flex;
  align-items: center;
}
.main-chat-blk .chat-page-wrapper .contact-close_call {
  display: flex;
  align-items: center;
}
@keyframes wave {
  0%, 100%, 60% {
    transform: initial;
  }
  30% {
    transform: translateY(-5px);
  }
}
.main-chat-blk .chat {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  background: #ffffff;
}
.main-chat-blk .chat .chat-header {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  padding: 15px 24px;
  align-items: center;
  border-bottom: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: var(--White, #FFF);
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  position: relative;
}
.main-chat-blk .chat .chat-header .user-details {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .chat .chat-header .user-details figure {
  margin-right: 1rem;
}
.main-chat-blk .chat .chat-header .user-details h5 {
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
  line-height: 1;
  color: #212529;
}
.main-chat-blk .chat .chat-header .chat-options ul {
  margin-bottom: 0;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a {
  font-size: 14px;
  color: #212529;
  cursor: pointer;
  width: 40px;
  height: 40px;
  padding: 0;
  border: none;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a i {
  font-size: 20px;
}
.main-chat-blk .chat .chat-header .chat-options ul > li > a:not(.no-bg):hover {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}
.main-chat-blk .chat .chat-body {
  flex: 1 1;
  padding: 24px;
  padding-bottom: 40px;
}
.main-chat-blk .chat .chat-body:not(.no-message) {
  overflow: hidden;
}
.main-chat-blk .chat .chat-body .messages {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  align-items: flex-start;
  -webkit-align-items: flex-start;
}
.main-chat-blk .chat .chat-body .messages .chats {
  max-width: 75%;
  margin-bottom: 1.5rem;
  display: flex;
  display: -webkit-flex;
}
.main-chat-blk .chat .chat-body .messages .chats:last-child {
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .avatar {
  margin-right: 1rem;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time h5 {
  font-size: 15px;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time {
  color: #ffffff;
  margin-top: 2px;
  font-size: 12px;
  font-weight: 400;
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time i {
  color: rgba(247, 247, 247, 0.5);
}
.main-chat-blk .chat .chat-body .messages .chats .chat-time .time i img {
  width: 14px;
  height: auto;
  margin-left: 2px;
  vertical-align: 0px;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content {
  border-radius: 0px 15px 15px 15px;
  background: var(--light-color, #F6F7F8);
  padding: 14px 20px;
  color: #212529;
  font-size: 14px;
  font-weight: 400;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.031372549);
}
.main-chat-blk .chat .chat-body .messages .chats .message-content a {
  color: #299cdb;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.award-link a {
  color: #212529;
  margin-bottom: 2px;
  display: block;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.award-link img {
  border-radius: 10px;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.chat-award-link a {
  display: flex;
}
.main-chat-blk .chat .chat-body .messages .chats .message-content.fancy-msg-box .image-not-download span {
  position: absolute;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-chat-blk .chat .chat-body .messages .chat-profile-name h6 {
  margin-bottom: 0;
  color: #212529;
  font-weight: 600;
  font-size: 15px;
}
.main-chat-blk .chat .chat-body .messages .chat-profile-name h6 span {
  font-size: 12px;
  color: #adb5bd;
  font-weight: 400;
  padding-left: 10px;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right {
  margin-left: auto;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-time {
  justify-content: flex-end;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content {
  border-radius: 15px 0px 15px 15px;
  background: rgba(255, 159, 67, 0.12);
  color: #212529;
  padding: 15px;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time {
  justify-content: flex-start;
  -webkit-justify-content: flex-start;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time .time {
  color: #adb5bd;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .message-content .chat-time .time i {
  color: #299cdb;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns {
  order: 2;
  -webkit-order: 2;
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  -webkit-flex-wrap: wrap;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns .chat-action-col {
  width: 20px;
  text-align: center;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-action-btns .chat-read-col {
  display: flex;
  display: -webkit-flex;
  align-items: flex-end;
  -webkit-align-items: flex-end;
  padding-bottom: 22px;
  color: #67748E;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-content {
  order: 1;
  -webkit-order: 1;
}
.main-chat-blk .chat .chat-body .messages .chats.chats-right .chat-avatar {
  padding: 8px 0px 0 15px;
}
.main-chat-blk .chat .chat-body .messages .download-col {
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .download-col ul {
  list-style: none;
  padding: 0;
  margin: 0 0 5px 0;
  display: flex;
  display: -webkit-flex;
}
.main-chat-blk .chat .chat-body .messages .download-col ul li + li {
  margin-left: 5px;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col {
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col a > img {
  border: 1px solid transparent;
  width: 80px;
  border-radius: 8px;
}
.main-chat-blk .chat .chat-body .messages .download-col .image-download-col.image-not-download a > img {
  filter: blur(1px);
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action a {
  color: #ffffff;
  font-size: 10px;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .chat .chat-body .messages .download-col .download-action div img {
  width: 13px;
}
.main-chat-blk .chat .chat-body .messages .file-download {
  position: relative;
  background: #e8ebed;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 7px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
  bottom: 14px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action a {
  color: #ffffff;
  font-size: 10px;
  color: #343a40;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .chat .chat-body .messages .file-download .download-action div img {
  width: 13px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-type {
  width: 54px;
  height: 54px;
  background-color: #ffffff;
  border-radius: 4px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-type i {
  color: #adb5bd;
  font-size: 24px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details span.file-name {
  color: #212529;
  display: inline-block;
  width: 100%;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details span.file-size {
  color: #adb5bd;
  display: inline-block;
  width: 100%;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul {
  display: flex;
  align-items: center;
  padding: 0;
  margin-bottom: 0;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li {
  list-style: none;
  color: #212529;
  font-size: 14px;
  position: relative;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 13px;
  background: #C2C2C2;
  right: -8px;
  top: 5px;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li:last-child::before {
  display: none;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li a {
  color: #FF9F43;
}
.main-chat-blk .chat .chat-body .messages .file-download .file-details ul li + li {
  padding-left: 15px;
}
.main-chat-blk .chat .chat-body.no-message {
  -webkit-user-select: none;
          user-select: none;
}
.main-chat-blk .chat .chat-footer {
  position: relative;
}
.main-chat-blk .chat .chat-footer form {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  position: relative;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
}
@media (max-width: 991.98px) {
  .main-chat-blk .chat .chat-footer form {
    padding-bottom: 15px;
  }
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn {
  margin-left: 0px;
  color: #dbe0e6;
  font-size: 20px;
  padding: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn:last-child {
  margin-right: 0;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  background: #FF9F43;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #ffffff !important;
  margin-left: 10px;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:hover {
  background-color: #ffffff;
  border-color: #343a40;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:hover i {
  color: #343a40;
}
.main-chat-blk .chat .chat-footer form .form-buttons .btn.send-btn:focus {
  box-shadow: none;
}
.main-chat-blk .chat .chat-footer form .specker-col span {
  color: #343a40;
  font-size: 25px;
}
.main-chat-blk .chat .chat-footer form .attach-col {
  right: inherit;
  left: 60px;
}
.main-chat-blk .chat .chat-footer form .attach-col i {
  color: #343a40;
  font-size: 20px;
}
.main-chat-blk .chat .chat-footer form .smile-col {
  right: inherit;
  left: 15px;
}
.main-chat-blk .chat .chat-footer form .smile-col i {
  color: #343a40;
  font-size: 20px;
  font-size: 22px;
}
.main-chat-blk .chat .chat-footer form .smile-foot {
  margin-right: 10px;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle {
  width: 38px;
  height: 38px;
  background: #ffffff;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle:hover {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}
.main-chat-blk .chat .chat-footer form .smile-foot .action-circle i {
  color: #212529;
  font-size: 18px;
}
.main-chat-blk .chat .chat-footer form .form-control::-webkit-input-placeholder {
  color: #212529;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control::-moz-placeholder {
  color: #212529;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control:-ms-input-placeholder {
  color: #212529;
  opacity: 1;
}
.main-chat-blk .chat .chat-footer form .form-control:-moz-placeholder {
  color: #212529;
  opacity: 1;
}
.main-chat-blk .chat-options ul.list-inline .list-inline-item {
  margin-bottom: 0;
}
.main-chat-blk .last-seen {
  color: #212529;
  font-size: 14px;
}
.main-chat-blk .user_callog {
  display: flex;
  margin-top: 0px;
}
.main-chat-blk .calllog_p {
  margin-left: 5px;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline-item a {
  background: #FF9F43;
  width: 38px;
  height: 38px;
  border-radius: 50px;
  color: #212529;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #ffffff;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline-item a:hover {
  background: #1b2950;
  color: #ffffff;
}
.main-chat-blk .chat-options.chat-option-profile .list-inline {
  border-bottom: 1px solid #EDEDED;
  margin-bottom: 0;
  padding-bottom: 15px;
}
.main-chat-blk .last-seen-profile span {
  color: #212529;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 12px;
  display: block;
}
.main-chat-blk .header_button {
  position: absolute;
  right: 5px;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  background: #ffa977;
  bottom: 40px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .btn-warning:hover {
  color: #ffffff;
  background-color: #FFB269;
  border-color: #FFA956;
}
.main-chat-blk .right_sidebar_profile {
  margin-top: 0px;
}
.main-chat-blk .account_details {
  background-color: #e8ebed;
  border-color: #dbe0e6;
  border-radius: 5px !important;
  border-bottom: 0 !important;
}
.main-chat-blk .security_details {
  background-color: #e8ebed;
  border-color: #dbe0e6;
  border-radius: 5px !important;
  border-bottom: 0 !important;
}
.main-chat-blk .close_icon {
  font-size: 18px;
}
.main-chat-blk .button_plus {
  margin-left: 0px;
}
.main-chat-blk .chat-search {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  opacity: 0;
  visibility: hidden;
}
.main-chat-blk .chat-search input[type=text] {
  padding: 8px 8px 8px 35px;
  width: 100%;
  min-height: 47px;
  border-radius: 0px 0px 5px 5px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
  background-color: #ffffff;
  color: #212529;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .chat-search input[type=text]:hover {
  border-color: #eff2f7;
}
.main-chat-blk .chat-search input[type=text]:focus {
  border-color: #eff2f7;
}
.main-chat-blk .chat-search input[type=text]:focus-visible {
  border-color: #eff2f7;
}
.main-chat-blk .chat-search.visible-chat {
  opacity: 1;
  visibility: visible;
  top: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  z-index: 9;
}
.main-chat-blk .form-control-feedback {
  z-index: 2;
  display: block;
  text-align: center;
  pointer-events: none;
  color: rgba(0, 0, 0, 0.4);
  position: absolute;
  left: 13px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.main-chat-blk .form-control-feedback i {
  font-size: 16px;
  color: #212529;
}
.main-chat-blk .user-chat-search {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  opacity: 0;
  visibility: hidden;
}
.main-chat-blk .user-chat-search input[type=text] {
  padding: 8px 8px 8px 35px;
  width: 100%;
  min-height: 47px;
  border-radius: 0px 0px 5px 5px;
  border: 1px solid #E5E7EB;
  font-size: 13px;
  background-color: #ffffff;
  color: #212529;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .user-chat-search input[type=text]:hover {
  border-color: #eff2f7;
}
.main-chat-blk .user-chat-search input[type=text]:focus {
  border-color: #eff2f7;
}
.main-chat-blk .user-chat-search input[type=text]:focus-visible {
  border-color: #eff2f7;
}
.main-chat-blk .user-chat-search.visible-chat {
  opacity: 1;
  visibility: visible;
  top: 100%;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
  z-index: 9;
}
.main-chat-blk .all-chats {
  position: relative;
}
.main-chat-blk .close-btn-chat {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #212529;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  position: absolute;
  right: 12px;
  top: 9px;
  cursor: pointer;
}
.main-chat-blk .user-close-btn-chat {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #212529;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  position: absolute;
  right: 12px;
  top: 9px;
  cursor: pointer;
}
.main-chat-blk .main_content {
  width: 100% !important;
}
.main-chat-blk .avatar-main {
  height: 50px;
  width: 50px;
}
.main-chat-blk .archive-btn {
  border: 1px solid #008024;
  color: #67748E;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 500;
  padding: 2px 6px;
  margin-right: 1.5rem;
}
.main-chat-blk .archive-btn-grey {
  border: 1px solid #909090;
  color: #adb5bd;
  border-radius: 4px;
  font-size: 9px;
  font-weight: 500;
  padding: 2px 6px;
  margin-top: 0.25rem;
}
.main-chat-blk .right_sidebar_icon {
  list-style: none;
}
.main-chat-blk .btn.btn-outline-light:hover {
  background: #e6e6e6;
}
.main-chat-blk .chat-avatar {
  padding: 8px 15px 0 8px;
  display: flex;
  display: -webkit-flex;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  flex-shrink: 0;
}
.main-chat-blk .chat-profile-name {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.main-chat-blk .chat-profile-name .chat-action-col a {
  display: flex;
}
.main-chat-blk .delete-pop-btn .btn-primary {
  margin: 0 0 0 10px;
}
.main-chat-blk .delete-model-head {
  padding: 40px;
}
.main-chat-blk .delete-model-head .modal-header {
  padding: 0;
  margin-bottom: 32px;
}
.main-chat-blk .delete-model-head .modal-body {
  padding: 0;
}
.main-chat-blk .delete-chat-notify {
  margin-bottom: 32px;
}
.main-chat-blk .delete-chat-notify .form-check {
  margin-bottom: 14px;
}
.main-chat-blk .chats.chats-right {
  flex-direction: row-reverse;
}
.main-chat-blk .message-star {
  display: flex;
  align-items: center;
}
.main-chat-blk .message-star .avatar {
  width: 26px;
  height: 26px;
  margin-right: 10px;
}
.main-chat-blk .message-star .avatar img {
  width: 100%;
}
.main-chat-blk .message-star h6 {
  color: #212529;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 0;
}
.main-chat-blk .message-star h6 span i {
  color: #FFB84D;
}
.main-chat-blk .chat-voice-group ul {
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 0;
  margin-bottom: 0;
}
.main-chat-blk .chat-voice-group ul li span {
  width: 28px;
  height: 28px;
  background: #FF9F43;
  border-radius: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .chat-voice-group li {
  margin-bottom: 0;
  color: #212529;
  font-size: 14px;
  font-weight: 400;
  list-style: none;
}
.main-chat-blk .chat-voice-group li + li {
  padding-left: 10px;
}
.main-chat-blk .file-download-col .download-action {
  position: absolute;
  right: 8px;
  bottom: 8px;
  line-height: 0;
}
.main-chat-blk .file-download-col .download-action a {
  color: #ffffff;
  font-size: 10px;
}
.main-chat-blk .file-download-col .download-action div + div {
  margin-left: 8px;
}
.main-chat-blk .file-download-col .download-action div img {
  width: 13px;
}
.main-chat-blk .file-download-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .file-download-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .file-download-col ul li {
  float: left;
  width: 50%;
  padding: 5px;
}
.main-chat-blk .file-download-col ul li .image-download-col {
  position: relative;
}
.main-chat-blk .file-download-col ul li .image-download-col a > img {
  width: 100%;
}
.main-chat-blk .file-download-col ul li.full-width {
  width: 100%;
}
.main-chat-blk .chat-select .select2-container .select2-selection--single {
  border: 0;
  height: 24px;
}
.main-chat-blk .chat-select .select2-container .select2-selection--single .select2-selection__rendered {
  padding-right: 40px;
  padding-left: 0px;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__rendered {
  color: #adb5bd;
  font-size: 18px;
  font-weight: normal;
  line-height: 24px;
  font-weight: 600;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 24px;
  right: 7px;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--single .select2-selection__arrow b {
  border-color: #495057;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
  height: 0;
  left: 50%;
  margin-left: -5px;
  margin-top: -5px;
  position: absolute;
  top: 50%;
  width: 0;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
}
.main-chat-blk .chat-select .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #3A5670;
}
.main-chat-blk .chat-select .select2-container--default .select2-selection--multiple {
  border: 1px solid #ddd;
  min-height: 40px;
}
.main-chat-blk .chat-select .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: #495057;
  border-width: 2px 0 0 2px;
  padding: 3px;
  margin-top: -5px;
  border-color: #495057;
  border-style: solid;
  border-width: 0 2px 2px 0;
  padding: 3px;
}
.main-chat-blk .chat-select .select2-container--default.form-control-sm .select2-selection--single .select2-selection__arrow {
  top: 7px;
}
.main-chat-blk .chat-select .select2-container--open .select2-dropdown--below {
  margin-top: 10px;
}
.main-chat-blk .success-pass {
  margin-bottom: 40px;
  text-align: center;
}
.main-chat-blk .review-files p {
  margin-bottom: 5px;
  color: #212529;
  font-size: 14px;
}
.main-chat-blk .like-chat-grp ul {
  padding: 0;
  margin-bottom: 0;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-top: 10px;
}
.main-chat-blk .like-chat-grp ul li {
  list-style: none;
}
.main-chat-blk .like-chat-grp ul li a {
  border: 1px solid #E0E0E0;
  border-radius: 50px;
  padding: 3px 12px;
  display: block;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #212529;
  font-weight: 400;
  font-size: 14px;
}
.main-chat-blk .like-chat-grp ul li a img {
  margin-left: 5px;
}
.main-chat-blk .like-chat-grp ul li + li {
  margin-left: 10px;
}
.main-chat-blk .like-chat-grp ul li.like-chat a {
  background: #FEF6DC;
}
.main-chat-blk .like-chat-grp ul li.comment-chat a {
  background: #FFE8E9;
}
.main-chat-blk .chat-line {
  margin: 0px 0 20px;
  position: relative;
  text-align: center;
  width: 100%;
}
.main-chat-blk .chat-line:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  background-color: #e8ebed;
  width: 100%;
  height: 1px;
}
.main-chat-blk .chat-date {
  border-radius: 100px;
  background: #e8ebed;
  color: #212529;
  font-size: 14px;
  padding: 4px 20px;
  display: inline-block;
  font-weight: 400;
  position: relative;
  border: 1px solid #E0E0E0;
}
.main-chat-blk .chat + .sidebar-group {
  margin-right: 0px;
}
.main-chat-blk .chat + .sidebar-group .sidebar {
  margin-right: 0px;
}
.main-chat-blk .group-comman-theme {
  padding: 0 24px;
}
.main-chat-blk .group-comman-theme h6 {
  margin-bottom: 15px;
}
.main-chat-blk .group-comman-theme ul {
  padding: 0;
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #EDEDED;
}
.main-chat-blk .group-comman-theme ul li {
  display: flex;
  align-items: center;
  list-style: none;
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 10px;
}
.main-chat-blk .group-comman-theme ul li:last-child {
  margin-bottom: 0;
}
.main-chat-blk .group-comman-theme ul li .avatar {
  flex-shrink: 0;
  margin-right: 10px;
}
.main-chat-blk .theme-content h6 {
  margin-bottom: 6px;
  color: #212529;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .theme-content p {
  margin-bottom: 0;
  text-align: start;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  color: #212529;
  font-size: 14px;
}
.main-chat-blk .chat-message-grp {
  padding: 24px;
  padding-top: 0;
}
.main-chat-blk .chat-message-grp ul {
  padding: 0;
}
.main-chat-blk .chat-message-grp ul li {
  list-style: none;
  margin-bottom: 15px;
}
.main-chat-blk .chat-message-grp ul li:last-child {
  margin-bottom: 0px;
}
.main-chat-blk .chat-message-grp ul li a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .chat-message-grp ul li a:hover .stared-group h6 {
  color: #343a40;
}
.main-chat-blk .stared-group {
  display: flex;
  align-items: center;
}
.main-chat-blk .stared-group span {
  width: 30px;
  height: 30px;
  border-radius: 6px;
  margin-right: 10px;
  background: #F6F7F8;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.main-chat-blk .stared-group span i {
  font-size: 16px;
}
.main-chat-blk .stared-group h6 {
  font-size: 15px;
  font-weight: 500;
  color: #5B6670;
  margin-bottom: 0;
}
.main-chat-blk .star-message {
  background: #FEF6DC;
}
.main-chat-blk .star-message i {
  color: #FFB84D;
}
.main-chat-blk .mute-message {
  background: rgba(235, 253, 255, 0.9803921569);
}
.main-chat-blk .mute-message i {
  color: #299cdb;
}
.main-chat-blk .block-message {
  background: #FFE8E9;
}
.main-chat-blk .block-message i {
  color: #7367F0;
}
.main-chat-blk .report-message {
  background: #F8ECFF;
}
.main-chat-blk .report-message i {
  color: #092C4C;
}
.main-chat-blk .delete-message {
  background: #FFE8E9;
}
.main-chat-blk .delete-message i {
  color: #FF3333;
}
.main-chat-blk .count-group {
  display: flex;
  align-items: center;
}
.main-chat-blk .count-group span {
  width: 16px;
  height: 16px;
  border-radius: 50px;
  color: #ffffff;
  font-size: 10px;
  background: #FF9F43;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 5px;
}
.main-chat-blk .count-group i {
  color: #424242;
  font-size: 16px;
}
.main-chat-blk .nav.nav-tabs.chat-tabs .nav-item .nav-link {
  font-size: 16px;
  font-weight: bold;
  color: #ffffff;
  background-color: transparent;
  border: 0;
}
.main-chat-blk .nav.nav-tabs.chat-tabs .nav-item .nav-link.active {
  font-size: 16px;
  font-weight: bold;
  color: #FFB269;
}
.main-chat-blk .header-top ul li a {
  color: #000000;
  font-size: 18px;
}
.main-chat-blk .set-search {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  border-radius: 50px;
  width: 28px;
  height: 28px;
}
.main-chat-blk .set-search:hover {
  background: #F5F5F5;
  border-color: #f3f6f9;
}
.main-chat-blk .header-action {
  list-style: none;
  margin: 0;
  padding: 0;
}
.main-chat-blk .header-action li {
  display: inline-block;
  margin-left: 10px;
}
.main-chat-blk .header-action li a {
  color: #212529;
  font-size: 18px;
}
.main-chat-blk .user-list {
  border-radius: 0.25rem;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
}
.main-chat-blk .user-list li a {
  padding: 17px 20px;
  display: flex;
  display: -webkit-flex;
  cursor: pointer;
  border-radius: 6px;
  margin-bottom: 10px;
  border: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}
.main-chat-blk .user-list li .avatar {
  margin-right: 0.8rem;
  display: inline-block;
  margin-bottom: 0;
  height: 46px;
  width: 46px;
  border-radius: 50%;
  position: relative;
  z-index: 0;
}
.main-chat-blk .user-list li .avatar .letter-avatar {
  width: 45px;
  height: 45px;
  border-radius: 45px;
  margin-right: 0.8rem;
  margin-bottom: 0;
  position: relative;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  background-color: #dbe0e6;
  font-size: 16px;
  font-weight: 600;
  color: #423B93;
}
.main-chat-blk .user-list li a.admin-shade {
  box-shadow: none;
}
.main-chat-blk .user-list .avatar > a > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .user-list .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar-away::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #ffffff;
  z-index: 9;
  background-color: #ffff00;
}
.main-chat-blk .avatar-offline::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #ffffff;
  z-index: 9;
}
.main-chat-blk .avatar-online::before {
  content: "";
  position: absolute;
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  top: 0px;
  right: 2px;
  border: 2px solid #ffffff;
  z-index: 9;
  background-color: #1dd871;
}
.main-chat-blk .animate-typing-col {
  color: #28C76F;
}
.main-chat-blk .animate-typing-col .dot {
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  margin-right: -1px;
  background: #0D9B35;
  animation: wave 1.3s linear infinite;
  opacity: 0.6;
}
.main-chat-blk .animate-typing-col .dot:nth-child(2) {
  animation-delay: -1.1s;
}
.main-chat-blk .animate-typing-col .dot:nth-child(3) {
  animation-delay: -0.9s;
}
.main-chat-blk .chat_form {
  border-radius: 20px;
  margin-right: 0px;
  background: #ffffff;
  border: 1px solid #C2C2C2;
  box-shadow: 0px 4px 4px #F5F8FF;
  border-radius: 6px;
  height: 40px;
  padding: 10px 10px;
}
.main-chat-blk .contact-close a {
  color: #212529;
  opacity: 0.5;
  border-color: #e8ebed;
}
.main-chat-blk .main-wrapper .content .sidebar-group.right-sidebar .sidebar {
  width: 310px;
}
.main-chat-blk .primary-title {
  color: #FFB269;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
}
.main-chat-blk .primary-title i {
  font-size: 14px;
}
.main-chat-blk .contact-action {
  padding: 0;
  margin: 0;
  list-style: none;
}
.main-chat-blk .contact-action li {
  padding: 11px 0;
  border-bottom: 1px solid #f1f1f1;
}
.main-chat-blk .contact-action li a {
  color: #212529;
  color: #212529;
  font-size: 14px;
  font-weight: bold;
}
.main-chat-blk .contact-action li.report-contact a {
  color: #FF0000;
}
.main-chat-blk .contact-action li.delete-chat a {
  color: #FF0000;
}
.main-chat-blk .contact-action li.sign-out a {
  color: #FF0000;
}
.main-chat-blk .left-sidebar {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
}
.main-chat-blk .left-sidebar-wrap {
  background: #FBFBFB;
  overflow: hidden;
  width: 448px;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  flex: 1 1;
}
.main-chat-blk .right-sidebar {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  background-color: #f8f9fa;
  opacity: 100%;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  position: relative;
  width: 320px;
}
.main-chat-blk .right-sidebar .right-sidebar-wrap {
  background-color: #ffffff;
  border-left: 1px solid #E0E0E0;
  border-radius: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  height: calc(100vh - 0px);
}
.main-chat-blk .right-sidebar .right-sidebar-wrap .sidebar-body {
  padding: 0;
}
.main-chat-blk .right-sidebar .right-sidebar-wrap .right-sidebar-profile {
  padding: 24px;
  padding-bottom: 0;
  margin-bottom: 15px;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #212529;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile.close-star {
  color: #FF9900;
}
.main-chat-blk .right-sidebar .contact-close_call .close_profile.close-trash {
  color: #FF0000;
}
.main-chat-blk .right-sidebar.video-right-sidebar {
  width: 371px;
}
.main-chat-blk .right-sidebar.video-right-sidebar .chat {
  margin-left: 0 !important;
  display: block;
}
.main-chat-blk .right-sidebar.video-right-sidebar .chat .chat-body {
  padding-bottom: 110px;
}
.main-chat-blk .video-call-chat .left-chat-title.with-bg {
  background: transparent;
}
.main-chat-blk .video-call-chat .left-chat-title {
  border: 0;
}
.main-chat-blk .video-call-chat .chat-title h4 {
  font-size: 18px;
  font-weight: 600;
  color: #212529;
}
.main-chat-blk .video-call-chat .chat-title span {
  font-size: 12px;
  font-weight: 400;
  color: #212529;
}
.main-chat-blk .chat.video-call-chat .chat-body {
  background-image: none;
}
.main-chat-blk .chat.video-call-chat .chat-body .messages .chats .message-content {
  background: #F5F5F5;
}
.main-chat-blk .chat.video-call-chat .chat-body .messages .chats.chats-right .message-content {
  background: #F8ECFF;
}
.main-chat-blk .member-details {
  margin-bottom: 10px;
}
.main-chat-blk .chat-member-details {
  padding: 0 24px;
}
.main-chat-blk .chat-member-details .member-details ul {
  padding: 0;
  border-bottom: 1px solid #EDEDED;
}
.main-chat-blk .chat-member-details .member-details ul li {
  list-style: none;
  margin-bottom: 15px;
}
.main-chat-blk .chat-member-details .member-details ul li h6 {
  font-size: 15px;
  font-weight: 400;
  color: #212529;
  margin-bottom: 5px;
}
.main-chat-blk .chat-member-details .member-details ul li h5 {
  font-size: 15px;
  font-weight: 500;
  color: #212529;
  margin-bottom: 0px;
}
.main-chat-blk .chat-member-details .member-details ul li span {
  font-size: 16px;
  font-weight: 400;
  color: #212529;
}
.main-chat-blk .chat-member-details .member-details ul li a {
  font-size: 15px;
  font-weight: 500;
  color: #343a40;
  border-radius: 100px;
  padding: 5px;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-member-details .member-details ul li a:hover {
  color: #212529;
}
.main-chat-blk .chat-member-details .member-details ul li a + a {
  margin-left: 10px;
}
.main-chat-blk .right-sidebar.show-right-sidebar {
  margin-right: 0;
}
.main-chat-blk .right-sidebar.video-right-sidebar.show-right-sidebar {
  margin-right: 0;
}
.main-chat-blk .right-sidebar.hide-right-sidebar {
  margin-right: -320px;
}
.main-chat-blk .right-sidebar.video-right-sidebar.hide-right-sidebar {
  margin-right: -371px;
}
.main-chat-blk .status-modal .custom-status-close {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #212529;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}
.main-chat-blk .group-description .description-sub h5 span a {
  width: 25px;
  height: 25px;
  border-radius: 25px;
  color: #212529;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  -webkit-justify-content: center;
  align-items: center;
  -webkit-align-items: center;
  border-color: #f3f6f9;
}
.main-chat-blk .list_group_notread {
  color: #FFB269 !important;
}
.main-chat-blk .chat-cont-type {
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .chat-cont-type .chat-type-wrapper {
  margin-bottom: 0;
}
.main-chat-blk .chat-cont-type .chat-type-wrapper p {
  color: #adb5bd;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 0;
}
.main-chat-blk .group-type-radio {
  display: block;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  user-select: none;
  font-size: 16px;
  font-weight: 400;
  color: #212529;
  margin-right: 24px;
}
.main-chat-blk .group-type-radio input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}
.main-chat-blk .group-type-radio input:checked ~ .checkmark {
  background-color: #343a40;
}
.main-chat-blk .group-type-radio input:checked ~ .checkmark:after {
  display: block;
}
.main-chat-blk .group-type-radio .checkmark:after {
  top: 4px;
  left: 4px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: white;
}
.main-chat-blk .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #ffffff;
  border: 1px solid #E4E4E4;
  border-radius: 50%;
}
.main-chat-blk .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}
.main-chat-blk .pass-login label {
  color: #212529;
  font-size: 14px;
  font-weight: 500;
}
.main-chat-blk .select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #343a40 !important;
}
.main-chat-blk .right-sidebar-profile > .avatar {
  background: rgba(66, 11, 161, 0.1);
}
.main-chat-blk .group_img {
  position: relative;
  display: inline-block;
}
.main-chat-blk .group-name-search {
  margin-bottom: 14px;
}
.main-chat-blk .parti-wrapper {
  margin-bottom: 14px;
  display: flex;
  align-items: center;
}
.main-chat-blk .group_header {
  width: 38px !important;
  height: 38px !important;
  border: 2px solid #ffffff;
}
.main-chat-blk .last-chat-time i.missed-col {
  width: 17px;
  display: inline-block;
  margin-top: 10px;
}
.main-chat-blk .last-chat-time i.missed-col img {
  max-width: 100%;
  height: auto;
}
.main-chat-blk .right-sidebar-head {
  padding: 0px 24px;
}
.main-chat-blk .right-sidebar-head h5 {
  font-size: 15px;
  font-weight: 600;
  color: #212529;
  margin-bottom: 0px;
}
.main-chat-blk .right-sidebar-head.share-media .share-media-blk {
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 10px;
  margin-bottom: 15px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav-tabs {
  margin-bottom: 15px;
  padding: 5px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item.active {
  background: #FF9F43;
  border-radius: 6px;
  color: #212529;
  color: #ffffff;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item {
  padding: 2px 10px;
  font-size: 14px;
  color: #212529;
  font-weight: 500;
  border: 0;
  margin-right: 10px;
  background: #FAFBFE;
  color: #092C4C;
  border-radius: 6px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .nav .nav-item:last-child {
  margin-right: 0px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li {
  margin: 0px 6px 6px 0px;
  position: relative;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li img {
  border-radius: 8px;
  width: 84px;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li span {
  position: absolute;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li span i {
  font-size: 20px;
  color: #ffffff;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li:hover span i {
  color: #e8ebed;
}
.main-chat-blk .right-sidebar-head.share-media .about-media-tabs .share-media-img li.blur-media img {
  filter: blur(2px);
}
.main-chat-blk .media-file {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 15px;
}
.main-chat-blk .media-file:last-child {
  margin-bottom: 0;
}
.main-chat-blk .media-doc-blk {
  display: flex;
  align-items: center;
}
.main-chat-blk .media-doc-blk span {
  width: 50px;
  height: 50px;
  border-radius: 5px;
  background: #F5F5F5;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 10px;
}
.main-chat-blk .media-doc-blk span i {
  font-size: 24px;
}
.main-chat-blk .document-detail ul {
  padding: 0;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.main-chat-blk .document-detail ul li {
  list-style: none;
  color: #212529;
  font-size: 14px;
  font-weight: 400;
  position: relative;
}
.main-chat-blk .document-detail ul li::before {
  content: "";
  position: absolute;
  width: 1px;
  height: 13px;
  background: #C2C2C2;
  right: -8px;
  top: 5px;
}
.main-chat-blk .document-detail ul li:last-child::before {
  display: none;
}
.main-chat-blk .document-detail ul li + li {
  padding-left: 15px;
}
.main-chat-blk .document-detail h6 {
  color: #212529;
  font-size: 15px;
  font-weight: 500;
}
.main-chat-blk .media-download a {
  color: #212529;
}
.main-chat-blk .social-media-col {
  margin-top: 35px;
}
.main-chat-blk .social-media-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .social-media-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .social-media-col ul li {
  float: left;
}
.main-chat-blk .social-media-col ul li a {
  color: #423B93;
  font-size: 18px;
}
.main-chat-blk .social-media-col ul li + li {
  margin-left: 10px;
}
.main-chat-blk .social-media-col h6 {
  font-weight: 600;
  color: #000000;
  font-size: 15px;
  margin-bottom: 20px;
}
.main-chat-blk .media-link-grp {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.main-chat-blk .media-link-detail h6 a {
  color: #212529;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 5px;
}
.main-chat-blk .media-link-detail span a {
  color: #212529;
  font-size: 14px;
  font-weight: 400;
  word-break: break-all;
}
.main-chat-blk .media-link-detail a:hover {
  color: #343a40;
}
.main-chat-blk .share-media-blk a {
  color: #343a40;
  font-weight: 500;
}
.main-chat-blk .link-img {
  flex-shrink: 0;
}
.main-chat-blk .link-img img {
  border-radius: 4px;
  margin-right: 10px;
}
.main-chat-blk .settings-col {
  margin-top: 35px;
}
.main-chat-blk .settings-col h6 {
  font-weight: 600;
  color: #000000;
  font-size: 15px;
  margin-bottom: 20px;
}
.main-chat-blk .settings-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .settings-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .settings-col ul li {
  color: #67748E;
  font-weight: 500;
}
.main-chat-blk .settings-col ul li + li {
  margin-top: 15px;
}
.main-chat-blk .settings-col .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 23px;
  margin-bottom: 0;
  margin-right: 10px;
}
.main-chat-blk .settings-col .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.main-chat-blk .settings-col .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #adb5bd;
  transition: 0.4s;
}
.main-chat-blk .settings-col .slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 4px;
  bottom: 4px;
  background-color: #ffffff;
  transition: 0.4s;
}
.main-chat-blk .settings-col input:checked + .slider {
  background-color: #3577f1;
}
.main-chat-blk .settings-col input:checked + .slider:before {
  transform: translateX(16px);
}
.main-chat-blk .settings-col input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}
.main-chat-blk .settings-col .slider.round {
  border-radius: 34px;
}
.main-chat-blk .settings-col .slider.round:before {
  border-radius: 50%;
}
.main-chat-blk .report-col {
  margin-top: 35px;
  padding: 12px;
  padding-bottom: 50px;
}
.main-chat-blk .report-col:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .report-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .report-col ul:after {
  content: "";
  display: table;
  clear: both;
}
.main-chat-blk .report-col ul li {
  display: block;
  width: 100%;
  font-weight: 500;
  position: relative;
}
.main-chat-blk .report-col ul li a {
  color: #FF0000;
  padding-left: 25px;
}
.main-chat-blk .report-col ul li a span {
  position: absolute;
  left: 0;
  top: 0px;
  font-size: 16px;
}
.main-chat-blk .report-col ul li + li {
  margin-top: 19px;
}
.main-chat-blk .load-more-btn {
  font-weight: 600;
  margin-top: 10px;
}
.main-chat-blk .load-more-btn i {
  background: #0057FF;
  border-radius: 50%;
  height: 12px;
  width: 12px;
  color: #ffffff;
  line-height: 8px;
  font-size: 12px;
  vertical-align: top;
}
.main-chat-blk .chat-message-grp.chat-encrypt {
  padding-bottom: 0;
}
.main-chat-blk .chat-message-grp.chat-encrypt ul {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .participants-list {
  padding: 0px 24px;
}
.main-chat-blk .participants-list .participants-list-group h6.parti-search {
  font-size: 20px !important;
  display: flex;
  align-items: center;
}
.main-chat-blk .participants-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .participants-list ul li {
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  background-color: #ffffff;
  padding: 10px;
}
.main-chat-blk .participants-list ul li + li {
  margin-top: 10px;
}
.main-chat-blk .participants-list .users-list-body {
  flex: 1 1;
  position: relative;
  min-width: 0px;
  display: flex;
  display: -webkit-flex;
  width: 100%;
}
.main-chat-blk .participants-list .users-list-body h5 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #212529;
}
.main-chat-blk .participants-list .users-list-body p {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0;
  color: #212529;
  font-size: 14px;
  font-weight: 400;
}
.main-chat-blk .participants-list .admin-profiles {
  display: inline-block;
  color: #343a40;
  border-radius: 6px;
  font-size: 12px;
  padding: 2px 10px;
  font-weight: 500;
  background: #F8ECFF;
}
.main-chat-blk .participants-list .admin-profiles:hover {
  background: #680A83;
  color: #ffffff;
}
.main-chat-blk .participants-list-group {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .participants-list-group h6 {
  margin-bottom: 15px;
  font-size: 15px;
  font-weight: 500;
  color: #212529;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .chat-message-grp.group-exits {
  padding: 0px 24px;
  padding-bottom: 30px;
}
.main-chat-blk .grp-delete .chat-action-col {
  display: flex;
  align-items: center;
  height: 100%;
}
.main-chat-blk .grp-delete .chat-action-col > a {
  color: #adb5bd;
}
.main-chat-blk .chat-action-col > a {
  color: #212529;
}
.main-chat-blk .darkmode-btn {
  width: 35px;
  height: 32px;
  background-color: #3577f1;
  border: 1px solid #FBFBFB;
  border-radius: 5px;
  color: #ffffff;
  font-size: 16px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  margin: 0 auto;
}
.main-chat-blk .darkmode-btn:hover {
  color: #ffffff;
}
.main-chat-blk .darkmode-btn:focus {
  color: #ffffff;
}
.main-chat-blk .add-contacts-btn {
  width: 25px;
  height: 25px;
  border-radius: 30px;
  background-color: #343a40;
  color: #ffffff;
  font-size: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  margin: 0 auto;
}
.main-chat-blk .add-contacts-btn:hover {
  color: #ffffff;
}
.main-chat-blk .add-contacts-btn:focus {
  color: #ffffff;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link {
  color: #343a40;
  border: 0;
  border-radius: 10px;
  font-weight: 500;
  padding: 6px 25px;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link:hover {
  color: #343a40;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link + .nav-link {
  margin-left: 10px;
}
.main-chat-blk .group-call-tab .nav-tabs .nav-link.active {
  background-color: rgba(90, 7, 139, 0.1);
  color: #343a40;
}
.main-chat-blk .group-call-tab nav {
  padding: 0 15px 20px;
  position: relative;
}
.main-chat-blk .group-call-tab nav:before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: #dbe0e6;
  height: 1px;
}
.main-chat-blk .header_image {
  width: 195px;
}
.main-chat-blk .chat_avator_img {
  position: relative;
}
.main-chat-blk .group_img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.main-chat-blk .dreams_chat {
  width: 40px;
  height: 40px;
  object-fit: cover;
}
.main-chat-blk .voice_pop {
  padding-right: 17px;
}
.main-chat-blk .status_carousel {
  margin-top: 50px;
}
.main-chat-blk .carousel_img {
  width: 650px;
  height: 434px;
}
.main-chat-blk .video_content {
  min-height: 200px;
  margin-top: 70px;
}
.main-chat-blk .voice-call-content {
  min-height: 200px;
}
.main-chat-blk .chatimage img {
  width: 120px;
  height: 120px;
}
.main-chat-blk .send-btn_status {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  color: #ffffff !important;
  background-color: #FFA977 !important;
  margin-left: 15px;
  font-size: 22px;
}
.main-chat-blk .status_telegram {
  color: #ffffff;
}
.main-chat-blk .media-lists {
  display: flex;
  justify-content: flex-start;
  margin: 0 -5px 0px;
  flex-wrap: wrap;
}
.main-chat-blk .media-lists .media-image {
  margin: 5px;
  flex-basis: 74px;
  min-width: 74px;
}
.main-chat-blk .media-lists .media-image img {
  max-width: 100%;
}
.main-chat-blk .avatar-group .avatar + .avatar {
  margin-left: -0.75rem;
}
.main-chat-blk .list-group-item {
  background-color: inherit;
  border-color: #ebebeb;
}
.main-chat-blk ul.list-inline .list-inline-item {
  margin-bottom: 0.5rem;
}
.main-chat-blk .form-control {
  border-radius: 5px;
}
.main-chat-blk .form-control:focus {
  box-shadow: none;
  border-color: #e6e6e6;
}
.main-chat-blk .custom-control-label {
  line-height: 25px;
}
.main-chat-blk .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #0a80ff;
}
.main-chat-blk .open_drop {
  color: #ffffff !important;
}
.main-chat-blk .send-btn_status:focus {
  box-shadow: none !important;
  border-color: #ffa977 !important;
}
.main-chat-blk .avatar {
  display: inline-block;
  margin-bottom: 0;
  height: 48px;
  width: 48px;
  border-radius: 50%;
}
.main-chat-blk .avatar .avatar-title {
  color: #ffffff;
  background: #680A83;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  font-size: 19px;
  font-weight: 600;
}
.main-chat-blk .avatar > a {
  width: 100%;
  height: 100%;
  display: block;
  transition: color 0.3s;
  color: #0a80ff;
}
.main-chat-blk .avatar > a > img,
.main-chat-blk .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar.avatar-sm {
  height: 1.3rem;
  width: 1.3rem;
}
.main-chat-blk .avatar.avatar-sm .avatar-title {
  font-size: 14px;
}
.main-chat-blk .avatar.avatar-lg {
  height: 3.8rem;
  width: 3.8rem;
}
.main-chat-blk .avatar.avatar-lg .avatar-title {
  font-size: 29px;
}
.main-chat-blk .avatar.avatar-xl {
  height: 100px;
  width: 100px;
}
.main-chat-blk .header_drop_icon {
  border-radius: 6px;
}
.main-chat-blk .accordion-col .accordion-title {
  cursor: pointer;
  padding: 15px 0 8px;
}
.main-chat-blk .accordion-col .accordion-title .primary-title i {
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transform: rotate(90deg);
  -webkit-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
}
.main-chat-blk .accordion-col .accordion-title.active .primary-title i {
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  transform: rotate(270deg);
  -webkit-transform: rotate(270deg);
  -ms-transform: rotate(270deg);
}
.main-chat-blk .accordion-col .accordion-content {
  border-bottom: 1px solid #e6e6e6;
  padding-bottom: 15px;
}
.main-chat-blk .accordion-col .accordion-content:last-child {
  border-bottom: 0;
}
.main-chat-blk .accordion-col .accordion-content h6 {
  font-size: 14px;
}
.main-chat-blk .status-right {
  font-weight: 500;
  color: #444444;
  font-size: 16px;
  text-align: center;
}
.main-chat-blk .status-right p {
  margin-top: 20px;
  margin-bottom: 0;
}
.main-chat-blk .star-drop .btn-outline-light {
  color: #424242;
  border: 0;
  padding: 0;
}
.main-chat-blk .star-drop .btn-outline-light i {
  font-size: 20px;
}
.main-chat-blk .star-drop .btn.btn-outline-light:hover {
  background: transparent;
  border: 0;
}
.main-chat-blk .chat.star-chat-group {
  background-image: none;
}
.main-chat-blk .chat.star-chat-group .chat-body {
  background-image: none;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats {
  max-width: 100%;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content {
  background: #F5F5F5;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content.award-link a {
  word-break: break-all;
}
.main-chat-blk .chat.star-chat-group .chat-body .messages .chats .message-content.award-link img {
  max-width: 100%;
}
.main-chat-blk .chat .chat-body .messages .chats.forward-chat-msg {
  display: none;
}
.main-chat-blk .chats.forward-chat-msg {
  background: #EDEDED;
  border-radius: 15px;
  padding: 20px;
  border-left: 2px solid #680A83;
}
.main-chat-blk .chats.forward-chat-msg .chat-avatar {
  padding: 0;
  padding-right: 15px;
}
.main-chat-blk .chat-title h4 a {
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  color: #4B0973;
  margin-bottom: 0;
}
.main-chat-blk .left-chat-title .add-section > a {
  width: 30px;
  height: 30px;
  background-color: #680A83;
  border-radius: 30px;
  color: #ffffff;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  font-size: 13px;
}
.main-chat-blk .add-section ul {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-chat-blk .add-section ul li {
  float: left;
  border-radius: 50px;
  width: 28px;
  height: 28px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
}
.main-chat-blk .add-section ul li + li {
  margin-left: 10px;
}
.main-chat-blk .add-section ul li a {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  font-size: 20px;
}
.main-chat-blk .all-chats .add-section ul li:hover {
  background-color: #F5F5F5;
  border-color: #F5F5F5;
}
.main-chat-blk .online {
  color: #008024;
  font-weight: 500;
}
.main-chat-blk .top-online-contacts {
  padding: 24px 24px 0px;
}
.main-chat-blk .fav-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 15px;
}
.main-chat-blk .fav-title h6 {
  margin-bottom: 0;
  font-size: 18px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.main-chat-blk .fav-title h6 i {
  font-size: 22px;
}
.main-chat-blk .fav-title a {
  margin-bottom: 0;
  color: #FF9F43;
  font-weight: 500;
}
.main-chat-blk .fav-title a:hover {
  color: #0A0A0A;
}
.main-chat-blk .top-contacts-box .profile-img {
  position: relative;
  width: 46px;
  height: 46px;
}
.main-chat-blk .top-contacts-box .profile-img img {
  max-width: 100%;
  height: auto;
  border-radius: 50px;
}
.main-chat-blk .profile-name span {
  color: #585858;
  font-size: 12px;
  display: inline-block;
  margin-top: 9px;
}
.main-chat-blk .top-contacts-box .profile-img.online:before {
  content: "";
  position: absolute;
  right: 0;
  transform: translateX(-50%);
  -webkit-transform: translateX(-50%);
  -ms-transform: translateX(-50%);
  top: 0px;
  background-color: #49E073;
  width: 10px;
  height: 10px;
  border: 2px solid #ffffff;
  border-radius: 50px;
}
.main-chat-blk .dropdown-menu .dropdown-item span.edit-profile-icon,
.main-chat-blk .dropdown-menu .dropdown-item span.profile-icon-col {
  font-size: 15px;
}
.main-chat-blk .avatar {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 46px;
  flex-shrink: 0;
}
.main-chat-blk .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.main-chat-blk .avatar-title {
  width: 100%;
  height: 100%;
  background-color: #650681;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-chat-blk .avatar-away::before,
.main-chat-blk .avatar-offline::before,
.main-chat-blk .avatar-online::before {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 25%;
  height: 25%;
  border-radius: 50%;
  content: "";
  border: 2px solid #ffffff;
}
.main-chat-blk .avatar-online::before {
  background-color: #00e65b;
}
.main-chat-blk .avatar-offline::before {
  background-color: #ff0100;
}
.main-chat-blk .avatar-away::before {
  background-color: #ffbc34;
}
.main-chat-blk .avatar .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar .rounded {
  border-radius: 6px !important;
}
.main-chat-blk .avatar .avatar-title {
  font-size: 18px;
}
.main-chat-blk .avatar-xs {
  width: 1.65rem;
  height: 1.65rem;
}
.main-chat-blk .avatar-xs .border {
  border-width: 2px !important;
}
.main-chat-blk .avatar-xs .rounded {
  border-radius: 4px !important;
}
.main-chat-blk .avatar-xs .avatar-title {
  font-size: 10px;
}
.main-chat-blk .avatar-xs.avatar-away::before,
.main-chat-blk .avatar-xs.avatar-offline::before,
.main-chat-blk .avatar-xs.avatar-online::before {
  border-width: 1px;
}
.main-chat-blk .avatar-sm {
  width: 2.5rem;
  height: 2.5rem;
}
.main-chat-blk .avatar-sm .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar-sm .rounded {
  border-radius: 4px !important;
}
.main-chat-blk .avatar-sm .avatar-title {
  font-size: 15px;
}
.main-chat-blk .avatar-sm.avatar-away::before,
.main-chat-blk .avatar-sm.avatar-offline::before,
.main-chat-blk .avatar-sm.avatar-online::before {
  border-width: 2px;
}
.main-chat-blk .avatar-lg {
  width: 3.75rem;
  height: 3.75rem;
}
.main-chat-blk .avatar-lg .border {
  border-width: 3px !important;
}
.main-chat-blk .avatar-lg .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-lg .avatar-title {
  font-size: 24px;
}
.main-chat-blk .avatar-lg.avatar-away::before,
.main-chat-blk .avatar-lg.avatar-offline::before,
.main-chat-blk .avatar-lg.avatar-online::before {
  border-width: 3px;
}
.main-chat-blk .avatar-xl {
  width: 5rem;
  height: 5rem;
}
.main-chat-blk .avatar-xl .border {
  border-width: 4px !important;
}
.main-chat-blk .avatar-xl .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-xl .avatar-title {
  font-size: 28px;
}
.main-chat-blk .avatar-xl.avatar-away::before,
.main-chat-blk .avatar-xl.avatar-offline::before,
.main-chat-blk .avatar-xl.avatar-online::before {
  border-width: 4px;
}
.main-chat-blk .avatar-xxl {
  width: 5.125rem;
  height: 5.125rem;
}
.main-chat-blk .avatar-xxl .border {
  border-width: 6px !important;
}
.main-chat-blk .avatar-xxl .rounded {
  border-radius: 8px !important;
}
.main-chat-blk .avatar-xxl .avatar-title {
  font-size: 30px;
}
.main-chat-blk .avatar-xxl.avatar-away::before,
.main-chat-blk .avatar-xxl.avatar-offline::before,
.main-chat-blk .avatar-xxl.avatar-online::before {
  border-width: 4px;
}
.main-chat-blk .avatar-group {
  display: flex;
  display: -webkit-flex;
  padding-left: 15px;
  margin-left: auto;
  margin-right: 15px;
  cursor: pointer;
}
.main-chat-blk .avatar-group .avatar + .avatar {
  margin-left: -0.75rem;
}
.main-chat-blk .avatar-group .avatar-xs + .avatar-xs {
  margin-left: -15px;
}
.main-chat-blk .avatar-group .avatar-sm + .avatar-sm {
  margin-left: -0.625rem;
}
.main-chat-blk .avatar-group .avatar-lg + .avatar-lg {
  margin-left: -1rem;
}
.main-chat-blk .avatar-group .avatar-xl + .avatar-xl {
  margin-left: -1.28125rem;
}
.main-chat-blk .avatar-group .avatar:hover {
  z-index: 1;
}
.main-chat-blk .avatar-group.group-col {
  display: block;
}
.main-chat-blk .avatar-group.group-col > div {
  display: flex;
  display: -webkit-flex;
  padding-bottom: 5px;
}
.main-chat-blk .avatar-group.group-col .avatar {
  margin-right: 0;
}
.main-chat-blk .contact-close {
  float: right;
  left: 95%;
  right: 0px;
  position: relative;
  top: 5%;
}
.main-chat-blk .status_contactclose {
  float: right;
  left: 95%;
  right: 0px;
  position: relative;
  top: 1%;
}
.main-chat-blk .status-active {
  border: 4px solid #650681;
}
.main-chat-blk .avatar.avatar-xl .avatar-title {
  font-size: 39px;
}
.main-chat-blk .nav.nav-tabs {
  border: none;
  line-height: 2;
}
.main-chat-blk .badge {
  padding: 5px 10px;
  font-size: 11px;
}
.main-chat-blk .badge.badge-success {
  background: #0abb87;
}
.main-chat-blk .badge.badge-danger {
  background: #fd397a;
}
.main-chat-blk .badge.badge-secondary {
  background: dimgray;
}
.main-chat-blk .badge.badge-info {
  background: #00bcd4;
}
.main-chat-blk .badge.badge-warning {
  background: #ffb822;
}
.main-chat-blk .badge.badge-dark {
  background: #3a3f51;
}
.main-chat-blk .badge.badge-primary {
  background: #0a80ff;
}
.main-chat-blk .badge.badge-light {
  background: #e6e6e6;
}
.main-chat-blk .btn {
  position: relative;
}
.main-chat-blk .btn .badge {
  padding: 2px 6px;
  right: 7px;
  top: -7px;
  position: absolute;
}
.main-chat-blk .input-group .input-group-text {
  font-size: 14px;
}
.main-chat-blk .tooltip > .tooltip-inner {
  text-align: left;
  max-width: 500px;
  --bs-tooltip-bg: \$primary;
}
.main-chat-blk .tooltip {
  --bs-tooltip-bg: \$primary;
}
.main-chat-blk .tooltip .arrow {
  display: none;
  background-color: #FF9F43;
}
.main-chat-blk .tooltip .tooltip-inner {
  background-color: #FF9F43;
}
.main-chat-blk .sticky-top {
  z-index: auto;
}
.main-chat-blk .tab-content {
  padding-top: 30px;
}
.main-chat-blk .tab-content .form-item {
  margin-bottom: 0.8rem;
}
.main-chat-blk .main-wrapper {
  overflow: hidden;
}
.main-chat-blk .main-wrapper .content {
  display: flex;
  display: -webkit-flex;
}
.main-chat-blk .main-wrapper .content .sidebar-group {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  position: relative;
  z-index: 99;
  width: 340px;
}
@media (max-width: 767px) {
  .main-chat-blk .main-wrapper .content .sidebar-group {
    width: 100%;
  }
}
.main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
  background: #ffffff;
  overflow: hidden;
  width: 340px !important;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  border-right: 1px solid rgb(224, 224, 224);
}
@media (max-width: 767px) {
  .main-chat-blk .main-wrapper .content .sidebar-group .sidebar {
    width: 100% !important;
  }
}
.main-chat-blk .main-wrapper .content .sidebar-group .sidebar:not(.active) {
  display: none;
}
.main-chat-blk .header-top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 30px;
  font-weight: 600;
  background-color: #680A83;
}
.main-chat-blk .header-top .logo {
  margin-top: 0 !important;
}
.main-chat-blk .header-top > span {
  font-size: 22px;
}
.main-chat-blk .header-top ul {
  margin-bottom: 0;
  display: flex;
}
.main-chat-blk .header-top ul.header-action {
  margin-top: 14px !important;
}
.main-chat-blk .chat-header ul {
  margin-bottom: 0;
}
.main-chat-blk .chat-header ul li:not(.list-inline-item) {
  margin-bottom: 0;
  width: 48px;
  margin-right: 15px !important;
}
.main-chat-blk .chat-header ul li:last-child {
  margin-right: 0 !important;
}
.main-chat-blk .sidebar-body {
  flex: 1 1;
  overflow: auto;
  padding: 24px 24px 10px;
  width: 100%;
}
.main-chat-blk .pin-chat img {
  margin-right: 6px;
}
.main-chat-blk .sidebar-body .profile-name {
  font-weight: 600;
  color: #0A0A0A;
  font-size: 18px;
  margin-bottom: 0;
}
.main-chat-blk .online-profile {
  position: relative;
}
.main-chat-blk .online-profile span {
  position: relative;
  color: #565656;
  font-size: 13px;
  padding-left: 10px;
}
.main-chat-blk .online-profile span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 7px;
  background-color: #49E073;
  width: 8px;
  height: 8px;
  border-radius: 50px;
}
.main-chat-blk .close_profile4 {
  color: #000000;
  border-color: #e6e6e6;
}
.main-chat-blk .sidebar .user-list li a {
  padding: 10px;
  display: flex;
  display: -webkit-flex;
  cursor: pointer;
  margin-bottom: 15px;
  border: 1px solid #E0E0E0;
  box-shadow: none;
  border-radius: 5px;
  position: relative;
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}
.main-chat-blk .sidebar .user-list li a:hover {
  background-color: rgba(254, 159, 67, 0.08);
  border: 1px solid rgba(254, 159, 67, 0.08);
  transition: ease all 0.5s;
  -webkit-transition: ease all 0.5s;
  -ms-transition: ease all 0.5s;
}
.main-chat-blk .sidebar .user-list li.item-typing {
  background-color: #F1F6FF;
}
.main-chat-blk .sidebar .user-list li figure {
  margin-right: 1rem;
}
.main-chat-blk .sidebar .user-list li .users-list-body {
  flex: 1 1;
  position: relative;
  min-width: 0px;
  display: flex;
}
.main-chat-blk .lock-icon {
  color: #000000;
}
.main-chat-blk .sidebar .user-list li .users-list-body > div:first-child {
  min-width: 0;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}
.main-chat-blk .parti-notify-check {
  margin-bottom: 0 !important;
  display: flex;
  align-items: center;
}
.main-chat-blk .sidebar .user-list li .users-list-body h5 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 3px;
  color: #0A0A0A;
}
.main-chat-blk .sidebar .user-list li .users-list-body p {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 0;
  color: #232323;
  font-size: 14px;
}
.main-chat-blk .sidebar .user-list li .users-list-body p.missed-call-col {
  color: #DE3E44;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time {
  padding-left: 15px;
  position: relative;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .text-muted {
  color: #424242 !important;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 5px;
  display: block;
  text-align: right;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .contact-toggle {
  color: #680A83;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .new-message-count {
  width: 20px;
  height: 20px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  -webkit-align-items: center;
  justify-content: center;
  -webkit-justify-content: center;
  line-height: 0;
  font-size: 11px;
  background-color: #FF9F43;
  color: #ffffff;
  border-radius: 50%;
  margin-left: auto;
  margin-top: 10px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.main-chat-blk .sidebar .user-list li .users-list-body .last-chat-time .chat-toggle {
  position: absolute;
  right: 0;
  bottom: 0;
  opacity: 0;
  text-align: right;
  transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  width: 18px;
  height: 24px;
}
.main-chat-blk .sidebar .user-list li.unread h5 {
  color: #ffffff;
}
.main-chat-blk .sidebar .user-list li.unread p {
  color: #ffffff;
}
.main-chat-blk .sidebar .user-list li.unread .text-muted {
  color: rgba(255, 255, 255, 0.4) !important;
}
.main-chat-blk .sidebar .user-list li.user-list-item.item-typing .users-list-body p {
  color: #0D9B35;
}
.main-chat-blk .rightside_tab {
  padding-top: 5px !important;
}
.main-chat-blk .chat-pin {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  -webkit-justify-content: end;
  -ms-flex-pack: end;
}
.main-chat-blk .chat-pin .green-check {
  color: #0D9B35;
}
.main-chat-blk .chat-pin img {
  width: 10px;
}
.main-chat-blk .chat-pin .check {
  color: #53BDEB;
}
.main-chat-blk .select-message-box {
  margin-top: 50px;
}
.main-chat-blk .select-message-box h4 {
  margin-bottom: 5px;
}
.main-chat-blk .select-message-box p {
  margin-top: 0;
  margin-bottom: 24px;
  color: #424242;
  font-size: 16px;
  font-weight: 400;
}
.main-chat-blk .select-message-box .btn i {
  font-size: 15px;
}
.main-chat-blk .group-description {
  padding: 0px 24px;
}
.main-chat-blk .group-description .description-sub {
  border-bottom: 1px solid #EDEDED;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.main-chat-blk .group-description h5 {
  font-size: 15px;
  font-weight: 500;
  color: #0A0A0A;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.main-chat-blk .group-description h5 a:hover {
  color: #650681 !important;
}
.main-chat-blk .group-description p {
  color: #424242;
  font-size: 16px;
  font-weight: 400;
  margin-bottom: 10px;
}
.main-chat-blk .group-description p.description-date {
  color: #424242;
  font-size: 12px;
  font-weight: 400;
  margin-bottom: 0px;
}
.main-chat-blk .encrypted-message p {
  font-size: 12px;
  color: #424242;
  font-weight: 400;
  margin-bottom: 0;
}
.main-chat-blk .group-view-all {
  margin-top: 10px;
}
.main-chat-blk .group-view-all a {
  color: #680A83;
  font-size: 14px;
  font-weight: 500;
}
.main-chat-blk .group-view-all a:hover {
  color: #0A0A0A;
}
.main-chat-blk .exit-bg-message {
  background: #FFE8E9;
}
.main-chat-blk .exit-bg-message i {
  color: #DE3E44;
}
.main-chat-blk .disapper-message {
  background: #E7FAF2;
}
.main-chat-blk .disapper-message i {
  color: #1BA345;
}
.main-chat-blk .group-setting-msg {
  background: #F8ECFF;
}
.main-chat-blk .group-setting-msg i {
  color: #680A83;
}
.main-chat-blk .group-setting .stared-group span {
  width: 50px;
  height: 50px;
}
.main-chat-blk .edit-set-details p {
  font-size: 14px;
  font-weight: 400;
  color: #424242;
  margin-bottom: 0;
}
.main-chat-blk .group-send-msg {
  background: #FEF6DC;
}
.main-chat-blk .parcipant-check p a {
  color: #680A83;
}
.main-chat-blk .select-group-chat .dropdown-toggle::after {
  display: none;
}
.main-chat-blk .select-group-chat .dropdown-toggle i {
  margin-left: 15px;
}
.main-chat-blk .select-group-chat .dropdown-toggle:hover {
  color: #0A0A0A;
}
.main-chat-blk .select-group-chat .dropdown-toggle {
  font-weight: 600;
  color: #0A0A0A;
  font-size: 18px;
}
.main-chat-blk .select-group-chat .dropdown-menu .dropdown-item {
  font-size: 14px;
  font-weight: 400;
  color: #0A0A0A;
}
.main-chat-blk .select-group-chat .dropdown-menu li:first-child .dropdown-item:hover {
  border-radius: 5px 5px 0 0;
}
.main-chat-blk .select-group-chat .dropdown-menu li:last-child .dropdown-item:hover {
  border-radius: 0 0 5px 5px;
}
.main-chat-blk .dropzone {
  background: #ffffff;
  border: 1px dashed #C2C2C2;
  border-radius: 5px;
  padding: 10px;
  min-height: 70px;
  text-align: center;
}
.main-chat-blk .dropzone.dz-clickable .dz-message {
  display: none;
}
.main-chat-blk .dropzone p {
  margin-bottom: 10px;
  font-size: 16px;
  font-weight: 500;
  color: #0A0A0A;
}
.main-chat-blk .dropzone span {
  color: #424242;
  font-size: 14px;
  font-weight: 400;
}
.main-chat-blk .uplaod-image img {
  border-radius: 20px;
}
.main-chat-blk .upload-img-file .modal-body {
  padding: 0;
}
.main-chat-blk .upload-img-file .modal-content {
  position: relative;
}
.main-chat-blk .upload-img-file .modal-header {
  position: absolute;
  top: 0;
  z-index: 9;
  left: 0;
  right: 0;
}
.main-chat-blk .upload-image-list {
  display: flex;
  align-items: center;
}
.main-chat-blk .upload-image-list li + li {
  margin-left: 10px;
}
.main-chat-blk .upload-img-file .modal-header .close {
  background-color: transparent;
  color: #ffffff;
}
.main-chat-blk .check-star i {
  color: #FEC001;
}
.main-chat-blk .emoj-group-list {
  display: none;
  position: absolute;
  top: -50px;
  left: -90px;
  transition: all 0.5s ease;
  -moz-transition: all 0.5s ease;
  -o-transition: all 0.5s ease;
  -ms-transition: all 0.5s ease;
  -webkit-transition: all 0.5s ease;
}
.main-chat-blk .emoj-group-list ul {
  display: flex;
  align-items: center;
  background: #f6f7f8;
  border-radius: 50px;
  padding: 5px;
}
.main-chat-blk .emoj-group-list ul li a {
  padding: 0;
}
.main-chat-blk .emoj-group-list ul li.add-emoj a {
  background: #EDEDED;
}
.main-chat-blk .emoj-group-list ul li.add-emoj a i {
  font-size: 20px;
  color: #424242;
}
.main-chat-blk .chat .slimscroll {
  height: calc(100vh - 60px) !important;
}
.main-chat-blk .settings-option {
  display: none;
  text-align: right;
}
.main-chat-blk .settings-option a {
  font-size: 15px;
  font-weight: 500;
  color: #680A83;
}
.main-chat-blk .empty-dark-img {
  display: none;
}
.main-chat-blk .bootstrap-datetimepicker-widget span {
  position: relative;
}

.chat-window .card .card-header {
  background-color: #ffffff;
  border-bottom: 1px solid #e8ebed;
}
.chat-window .badge-success {
  background-color: #28C76F !important;
}

.chat-page .footer {
  display: none;
}

.chat-search .input-group .form-control {
  margin: 0;
  padding: 0 0 0 36px;
  height: 46px;
}
.chat-search .input-group .input-group-prepend {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #495057;
  pointer-events: none;
  z-index: 4;
  position: absolute;
  top: 0;
  right: 15px;
  bottom: 0;
}

.chat-cont-left .chat-scroll {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
  padding: 0;
}
.chat-cont-left .chat-scroll .media {
  border-bottom: 1px solid #e8ebed;
  margin: 0;
  padding: 10px;
  transition: all 0.2s;
}
.chat-cont-left .chat-scroll .media.active {
  background-color: #f3f6f9;
}
.chat-cont-left .chat-scroll .media:hover {
  background-color: #f3f6f9;
}
.chat-cont-left .chat-scroll .media .media-img-wrap {
  margin: 0 15px 0 0;
  position: relative;
}
.chat-cont-left .chat-scroll .media .media-img-wrap .avatar > img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.chat-cont-left .chat-scroll .media .media-body {
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.chat-cont-left .chat-scroll .media .media-body .user-name {
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #092C4C;
  font-size: 16px;
  font-weight: 700;
}
.chat-cont-left .chat-scroll .media .media-body .user-last-chat {
  color: #343a40;
  font-size: 14px;
  line-height: 24px;
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-cont-left .chat-scroll .media .media-body .last-chat-time {
  color: #67748E;
  font-size: 13px;
}
.chat-cont-left .chat-scroll .media .media-body div:last-child {
  text-align: right;
}

.chat-cont-right {
  transition: all 0.4s;
}
.chat-cont-right .chat-scroll {
  max-height: calc(100vh - 293px);
  overflow-y: auto;
}
.chat-cont-right .msg_head .back-user-list {
  display: none;
  margin: 0 0 0 -10px;
  padding: 0 10px;
}
.chat-cont-right .img_cont {
  position: relative;
  height: 45px;
  width: 45px;
}
.chat-cont-right .img_cont .user_img {
  height: 45px;
  min-width: 45px;
  width: 45px;
  border: 1.5px solid #FF9F43;
}
.chat-cont-right .user_info {
  margin: 0 auto 0 15px;
  padding: 0;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.chat-cont-right ul.list-unstyled {
  margin: 0 auto;
  padding: 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent {
  margin-bottom: 20px;
}
.chat-cont-right ul.list-unstyled .media.sent .avatar {
  order: 3;
  height: 30px;
  width: 30px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body {
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin: 0 20px 0 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box {
  margin: 0;
  padding: 0 0 0 50px;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box + .msg-box {
  margin: 5px 0 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box p {
  margin: 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box:first-child::before {
  border-bottom: 6px solid transparent;
  border-left: 6px solid #e3e3e3;
  border-top: 6px solid #e3e3e3;
  border-right: 6px solid transparent;
  content: "";
  height: 0;
  width: 0;
  position: absolute;
  top: 0;
  right: -12px;
  left: auto;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box > div {
  margin: 0;
  padding: 10px 15px;
  border-radius: 10px;
  background-color: #e3e3e3;
  display: inline-block;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box:first-child > div {
  border-radius: 10px 0 10px 10px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments {
  display: flex;
  margin: 0 -1px;
  padding: 4px 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment {
  position: relative;
  max-width: 130px;
  overflow: hidden;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000000;
  content: "";
  opacity: 0.4;
  transition: all 0.4s;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attachment:hover .chat-attach-download {
  opacity: 1;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments > div {
  margin: 0 1px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments img {
  max-width: 100%;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-attachments .chat-attach-download {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: all 0.4s;
  color: #ffffff;
  width: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.2);
  text-align: center;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin: 5px 0 0;
  padding: 0;
  flex-wrap: wrap;
  clear: both;
  flex-direction: row-reverse;
  list-style: none;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info li {
  margin: 0;
  padding: 0 0 0 16px;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info li:not(:last-child)::after {
  position: absolute;
  top: 50%;
  right: auto;
  left: 8px;
  transform: translate(-50%, -50%);
  background: #FF9F43;
  content: "";
  height: 4px;
  width: 4px;
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info .chat-time {
  color: rgba(50, 65, 72, 0.4);
}
.chat-cont-right ul.list-unstyled .media.sent .media-body .chat-msg-info a {
  color: #343a40;
}
.chat-cont-right ul.list-unstyled .media.received {
  position: relative;
  margin-bottom: 20px;
}
.chat-cont-right ul.list-unstyled .media.received .media-body {
  position: relative;
  margin: 0 0 0 20px;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.received .media-body::before {
  border-bottom: 6px solid transparent;
  border-right: 6px solid #FF9F43;
  border-top: 6px solid #FF9F43;
  border-left: 6px solid transparent;
  content: "";
  height: 0;
  position: absolute;
  top: 0px;
  right: auto;
  left: -6px;
  width: 0;
}
.chat-cont-right ul.list-unstyled .media.received .media-body > div {
  margin: 0;
  padding: 10px 15px;
  border-radius: 10px;
  background-color: #FF9F43;
  display: table;
  position: relative;
}
.chat-cont-right ul.list-unstyled .media.received .media-body > div p {
  color: #ffffff;
  margin: 0;
  padding: 0;
}
.chat-cont-right ul.list-unstyled .media.received .msg-box {
  display: block;
}
.chat-cont-right ul.list-unstyled .media.received .msg-box + .msg-box {
  margin-top: 5px;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
  margin: 5px 0 0;
  padding: 0;
  clear: both;
  list-style: none;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-info .chat-time {
  color: rgba(255, 255, 255, 0.8);
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments {
  display: flex;
  margin: 0 -1px;
  padding: 4px 0;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment {
  position: relative;
  max-width: 130px;
  overflow: hidden;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment:before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: #000000;
  content: "";
  opacity: 0.4;
  transition: all 0.4s;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attachment:hover .chat-attach-download {
  opacity: 1;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments > div {
  margin: 0 1px;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments img {
  max-width: 100%;
}
.chat-cont-right ul.list-unstyled .media.received .chat-msg-attachments .chat-attach-download {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transition: all 0.4s;
  opacity: 0;
  color: #ffffff;
  width: 32px;
  line-height: 32px;
  background: rgba(255, 255, 255, 0.2);
  text-align: center;
}
.chat-cont-right ul.list-unstyled .chat-date {
  font-size: 14px;
  margin: 1.875rem 0;
  overflow: hidden;
  position: relative;
  text-align: center;
  text-transform: capitalize;
}
.chat-cont-right ul.list-unstyled .chat-date:before {
  background-color: #e0e3e4;
  content: "";
  height: 1px;
  margin-right: 28px;
  position: absolute;
  top: 50%;
  right: 50%;
  width: 100%;
}
.chat-cont-right ul.list-unstyled .chat-date:after {
  background-color: #e0e3e4;
  content: "";
  height: 1px;
  margin: 0 0 0 28px;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
}

.card-footer {
  background-color: #ffffff;
  border-top: 1px solid #e8ebed;
  margin: 0;
  padding: 1rem 1.5rem;
}
.card-footer .type_msg {
  background-color: rgba(0, 0, 0, 0.1) !important;
  border: 0 !important;
  overflow-y: auto;
}

@media (max-width: 992px) {
  .chat-window.chat-slide .chat-cont-right {
    right: 0;
    opacity: 1;
    visibility: visible;
  }
  .chat-cont-right {
    position: absolute;
    right: -100px;
    opacity: 0;
    visibility: hidden;
    z-index: 99;
  }
  .chat-cont-right .msg_head .back-user-list {
    display: flex;
    align-items: center;
  }
}
.msg-typing {
  width: auto;
  height: 24px;
  padding-top: 8px;
}
.msg-typing span {
  height: 8px;
  width: 8px;
  float: left;
  background-color: #ffffff;
  display: block;
  opacity: 0.4;
  margin: 0 1px;
  border-radius: 50%;
}
.msg-typing span:nth-of-type(1) {
  animation: 1s blink infinite 0.33333s;
}
.msg-typing span:nth-of-type(2) {
  animation: 1s blink infinite 0.66666s;
}
.msg-typing span :nth-of-type(3) {
  animation: 1s blink infinite 0.99999s;
}

@keyframes blink {
  50% {
    opacity: 1;
  }
}
.phone-call-icon svg {
  width: 18px;
}
.phone-call-icon .income-success {
  color: #28C76F;
}
.phone-call-icon .income-success-missed {
  color: #FF0000;
}

.history-modal-profile .content {
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile {
  background: #FAFBFE;
  border-radius: 8px;
  padding: 24px;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a {
  background: #FF9F43;
  width: 40px;
  height: 40px;
  border-radius: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.history-modal-profile .right-sidebar-profile .list-inline-item a:hover {
  background: #1b2950;
  color: #ffffff;
}
.history-modal-profile .right-sidebar-profile .avatar {
  margin-bottom: 24px;
  width: 150px;
  height: 150px;
}
.history-modal-profile .right-sidebar-profile .avatar img {
  border-radius: 8px;
}

.modal-profile-detail .modal-userlist li {
  font-size: 14px;
  color: #000000;
  margin-bottom: 10px;
}
.modal-profile-detail .modal-userlist li span {
  display: block;
  color: #5B6670;
}
.modal-profile-detail .modal-userlist li:last-child {
  margin-bottom: 0;
}

.inbox-menu {
  display: inline-block;
  width: 100%;
  margin: 0 0 20px;
  padding: 0;
}
.inbox-menu li {
  display: inline-block;
  width: 100%;
}
.inbox-menu li a {
  color: #333;
  display: inline-block;
  padding: 10px 15px;
  width: 100%;
  font-weight: 600;
  text-transform: capitalize;
  transition: 0.3s ease;
}
.inbox-menu li a:hover {
  background: rgba(33, 33, 33, 0.05);
}
.inbox-menu li a i {
  font-size: 16px;
  padding-right: 10px;
  color: #878787;
}

.compose-btn {
  margin-bottom: 25px;
}

.top-action-left .btn-group {
  margin-bottom: 5px;
}
.top-action-left .dropdown-toggle {
  height: 40px;
}
.top-action-left .dropdown-toggle::after {
  display: none;
}

.table-inbox .starred.fas.fa-star {
  color: #FF9900;
}
.table-inbox .checked {
  background-color: #e8ebed;
}
.table-inbox tbody tr td {
  font-size: 14px;
  color: #092C4C;
}

.unread .name,
.unread .subject,
.unread .mail-date {
  color: #000000;
  font-weight: 700;
}

.email-header .btn-white {
  min-width: auto;
  height: 38px;
}
.email-header .btn-white i {
  margin-left: 5px;
}

.error-box {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  flex-direction: column;
}

.comming-soon-pg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: 100vh;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 991.98px) {
  .comming-soon-pg {
    height: 100%;
  }
}
.comming-soon-pg .coming-soon-box {
  width: 800px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 10px;
  padding: 40px;
  text-align: center;
}
@media (max-width: 1199.98px) {
  .comming-soon-pg .coming-soon-box {
    padding: 20px 40px;
    max-width: 800px;
  }
}
@media (max-width: 991.98px) {
  .comming-soon-pg .coming-soon-box {
    width: auto;
    padding: 30px;
    margin: 20px;
  }
}
@media (max-width: 575px) {
  .comming-soon-pg .coming-soon-box {
    padding: 15px;
    margin: 10px;
  }
}
.comming-soon-pg .coming-soon-box .pos-logo {
  margin-bottom: 30px;
}
@media (max-width: 1199.98px) {
  .comming-soon-pg .coming-soon-box .pos-logo {
    margin-bottom: 20px;
  }
}
.comming-soon-pg .coming-soon-box span {
  font-size: 24px;
  color: #67748E;
  font-weight: 700;
}
.comming-soon-pg .coming-soon-box h1 {
  font-size: 60px;
  font-weight: 700;
  line-height: normal;
}
@media (max-width: 1199.98px) {
  .comming-soon-pg .coming-soon-box h1 {
    font-size: 50px;
  }
}
@media (max-width: 991.98px) {
  .comming-soon-pg .coming-soon-box h1 {
    font-size: 40px;
  }
}
@media (max-width: 575px) {
  .comming-soon-pg .coming-soon-box h1 {
    font-size: 28px;
  }
}
.comming-soon-pg .coming-soon-box h1 span {
  font-size: 60px;
  color: #FF9F43;
}
@media (max-width: 1199.98px) {
  .comming-soon-pg .coming-soon-box h1 span {
    font-size: 50px;
  }
}
@media (max-width: 991.98px) {
  .comming-soon-pg .coming-soon-box h1 span {
    font-size: 40px;
  }
}
@media (max-width: 575px) {
  .comming-soon-pg .coming-soon-box h1 span {
    font-size: 28px;
  }
}
.comming-soon-pg .coming-soon-box p {
  font-size: 15px;
  max-width: 400px;
  text-align: center;
  margin: auto;
}
.comming-soon-pg .coming-soon-box .coming-soon-timer {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin: 30px 0;
}
@media (max-width: 1199.98px) {
  .comming-soon-pg .coming-soon-box .coming-soon-timer {
    margin: 20px 0;
  }
}
.comming-soon-pg .coming-soon-box .coming-soon-timer li {
  border: 1px solid #eff2f7;
  background-color: #ffffff;
  font-size: 16px;
  width: 85px;
  height: 85px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 16px;
  font-weight: 500;
  flex-direction: column;
  margin-right: 14px;
  color: #67748E;
}
@media (max-width: 575px) {
  .comming-soon-pg .coming-soon-box .coming-soon-timer li {
    width: 50px;
    height: 50px;
    margin-right: 5px;
  }
}
.comming-soon-pg .coming-soon-box .coming-soon-timer li span {
  color: #092C4C;
  font-size: 32px;
  line-height: normal;
}
@media (max-width: 575px) {
  .comming-soon-pg .coming-soon-box .coming-soon-timer li span {
    font-size: 20px;
  }
}
.comming-soon-pg .coming-soon-box .coming-soon-timer li.seperate-dot {
  color: #092C4C;
  width: auto;
  height: auto;
  border: 0;
  border-radius: 0;
  background-color: transparent;
}
.comming-soon-pg .coming-soon-box .coming-soon-timer li:last-child {
  margin-right: 0;
}
.comming-soon-pg .coming-soon-box .subscribe-form {
  position: relative;
}
.comming-soon-pg .coming-soon-box .subscribe-form .subscribe-btn {
  position: absolute;
  bottom: 10px;
  right: 10px;
}
.comming-soon-pg .coming-soon-box .subscribe-form input {
  height: 58px;
  padding-right: 130px;
}
.comming-soon-pg .coming-soon-box .subscribe-form label {
  color: #092C4C;
  font-weight: 600;
}
.comming-soon-pg .coming-soon-box .social-media-icons {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-top: 30px;
}
@media (max-width: 1199.98px) {
  .comming-soon-pg .coming-soon-box .social-media-icons {
    margin-top: 20px;
  }
}
.comming-soon-pg .coming-soon-box .social-media-icons li {
  margin-right: 5px;
}
.comming-soon-pg .coming-soon-box .social-media-icons li:last-child {
  margin-right: 0;
}
.comming-soon-pg .coming-soon-box .social-media-icons li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 32px;
  height: 32px;
  background-color: #092C4C;
  border-radius: 5px;
}
.comming-soon-pg .coming-soon-box .social-media-icons li a:hover {
  background-color: #FF9F43;
}
.comming-soon-pg .coming-soon-box .social-media-icons li a i {
  color: #ffffff;
}

.login-wrapper {
  width: 100%;
  overflow: hidden;
  height: 100vh;
  flex-wrap: wrap;
  display: flex;
}
.login-wrapper.bg-img {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.login-wrapper.bg-img .login-content {
  background: rgba(255, 255, 255, 0.8);
  -webkit-backdrop-filter: blur(17px);
          backdrop-filter: blur(17px);
}
.login-wrapper.bg-img.register-wrap {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}
.login-wrapper.bg-img.forgot-pass-wrap {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}
.login-wrapper.bg-img.reset-pass-wrap {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.login-wrapper.bg-img.email-veri-wrap {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}
.login-wrapper .login-content {
  width: 50%;
  height: 100vh;
  padding: 24px;
  overflow: auto;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  flex-wrap: wrap;
}
@media (max-width: 991.98px) {
  .login-wrapper .login-content {
    width: 100%;
  }
}
.login-wrapper .login-content .login-logo {
  display: block;
  max-width: 150px;
  margin: auto;
}
.login-wrapper .login-content .login-logo img {
  margin-bottom: 25px;
}
@media (max-width: 991.98px) {
  .login-wrapper .login-content .login-userset {
    margin-top: 30px;
  }
}
.login-wrapper .login-content .login-userset .my-4 {
  margin-top: 50px !important;
}
.login-wrapper .login-content .login-userset .my-4 p {
  font-size: 14px;
  color: #092C4C;
  margin-bottom: 0;
  font-weight: 400;
}
.login-wrapper .login-content .login-userset form .otp-box {
  margin-bottom: 34px;
}
.login-wrapper .login-content .login-userset form .otp-box input {
  width: 74px;
  height: 74px;
  background: #ffffff;
  border: 1px solid #E1E1E1;
  border-radius: 8px;
  text-align: center;
  margin-right: 15px;
  font-weight: 700;
  font-size: 26px;
  color: #000000;
  outline: none;
}
@media (max-width: 575px) {
  .login-wrapper .login-content .login-userset form .otp-box input {
    width: 50px;
    height: 50px;
  }
}
.login-wrapper .login-content .login-userset form .otp-box input::placeholder {
  color: #74788d;
}
.login-wrapper .login-content .login-userset form .otp-box input:last-child {
  margin-right: 0px;
}
.login-wrapper .login-content .login-userset .Otp-expire {
  border-radius: 8px;
  background: rgba(255, 0, 0, 0.05);
  padding: 10px 12px;
  max-width: 200px;
  margin: auto;
}
.login-wrapper .login-content .login-userset .Otp-expire p {
  color: #FF0000;
  font-size: 14px;
  font-weight: 400;
}
.login-wrapper .login-content .login-userheading {
  margin: 0 0 24px;
}
.login-wrapper .login-content .login-userheading h3 {
  font-size: 24px;
  font-weight: 700;
  margin: 0 0 10px;
  color: #000000;
}
.login-wrapper .login-content .login-userheading h4 {
  font-size: 15px;
  font-weight: 400;
  color: #092C4C;
  line-height: 1.4;
}
.login-wrapper .login-content .login-userheading .verfy-mail-content {
  max-width: 400px;
  margin-bottom: 40px;
}
.login-wrapper .login-content .form-login {
  margin-bottom: 15px;
}
.login-wrapper .login-content .form-login label {
  width: 100%;
  color: #092C4C;
  margin-bottom: 10px;
  font-size: 15px;
  font-weight: 400;
}
.login-wrapper .login-content .form-login .form-addons {
  position: relative;
}
.login-wrapper .login-content .form-login .form-addons img {
  position: absolute;
  top: 16px;
  right: 20px;
}
.login-wrapper .login-content .form-login input {
  width: 100%;
  height: 40px;
  border: 1px solid rgba(145, 158, 171, 0.32);
  border-radius: 5px;
  padding: 0 15px;
  transition: all 0.2s ease;
}
.login-wrapper .login-content .form-login input:focus {
  border: 1px solid #FF9F43;
}
.login-wrapper .login-content .form-login .btn-login {
  width: 100%;
  font-weight: 700;
  font-size: 14px;
  background: #FF9F43;
  border-color: #FF9F43;
  padding: 10px;
  transition: all 0.5s ease;
  margin-top: 5px;
  color: #ffffff;
}
.login-wrapper .login-content .form-login .btn-login:hover {
  box-shadow: 0 50px #ffffff inset !important;
  color: #FF9F43;
}
.login-wrapper .login-content .form-login .alreadyuser {
  margin-bottom: 15px;
}
.login-wrapper .login-content .form-login .alreadyuser h4 {
  font-size: 14px;
  font-weight: 400;
  color: #B8BCC9;
}
.login-wrapper .login-content .form-login .alreadyuser h4 a {
  color: #FF9F43;
  font-weight: 600;
}
.login-wrapper .login-content .form-login .custom-control.custom-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 575px) {
  .login-wrapper .login-content .form-login .custom-control.custom-checkbox {
    justify-content: start;
  }
}
.login-wrapper .login-content .form-login .custom-control.custom-checkbox .custom-control-input {
  width: auto;
  height: auto;
}
.login-wrapper .login-content .form-login .custom-control.custom-checkbox .custom-control-label {
  margin-bottom: 0;
  margin-left: 8px;
}
.login-wrapper .login-content .form-login .forgot-link {
  color: #FF0000;
  font-size: 15px;
  font-weight: 600;
}
.login-wrapper .login-content .signinform {
  margin-bottom: 23px;
}
.login-wrapper .login-content .signinform h4 {
  font-size: 15px;
  font-weight: 400;
  color: #092C4C;
}
@media (max-width: 575px) {
  .login-wrapper .login-content .signinform h4 {
    font-size: 14px;
  }
}
.login-wrapper .login-content .signinform h4 a {
  color: #092C4C;
  font-weight: 700;
  font-size: 14px;
}
.login-wrapper .login-content .signinform .hover-a.resend {
  color: #FF0000;
}
.login-wrapper .login-content .form-setlogin {
  text-align: center;
  position: relative;
  color: #B8BCC9;
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 23px;
}
.login-wrapper .login-content .form-setlogin h4 {
  position: relative;
  font-size: 14px;
  color: #5B6670;
  font-weight: 700;
}
.login-wrapper .login-content .form-setlogin h4:after {
  content: "";
  background: #B8BCC9;
  width: 21px;
  height: 1px;
  position: absolute;
  top: 10px;
  left: 200px;
}
@media (max-width: 991.98px) {
  .login-wrapper .login-content .form-setlogin h4:after {
    height: 0px;
  }
}
.login-wrapper .login-content .form-setlogin h4:before {
  content: "";
  background: #B8BCC9;
  width: 21px;
  height: 1px;
  position: absolute;
  top: 10px;
  right: 200px;
}
@media (max-width: 991.98px) {
  .login-wrapper .login-content .form-setlogin h4:before {
    height: 0px;
  }
}
.login-wrapper .login-content .form-setlogin.or-text {
  max-width: 365px;
  margin: auto;
}
.login-wrapper .login-content .toggle-password {
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #B8BCC9;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.login-wrapper .login-content .toggle-password:hover {
  color: #FF9F43;
}
.login-wrapper .login-content .toggle-passwords {
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #B8BCC9;
  font-size: 18px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 10px;
}
.login-wrapper .login-content .toggle-passwords:hover {
  color: #FF9F43;
}
.login-wrapper .login-content .pass-group {
  position: relative;
  font-size: 14px;
}
.login-wrapper .login-content .pass-group .fas {
  font-size: 13px;
  color: #939ea8;
}
.login-wrapper .login-content .form-sociallink {
  margin-top: 25px;
}
.login-wrapper .login-content .form-sociallink ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.login-wrapper .login-content .form-sociallink ul li {
  text-align: center;
  margin-right: 10px;
}
@media (max-width: 575px) {
  .login-wrapper .login-content .form-sociallink ul li {
    width: 100%;
    margin-bottom: 20px;
  }
}
.login-wrapper .login-content .form-sociallink ul li:last-child {
  padding-right: 0;
}
@media (max-width: 575px) {
  .login-wrapper .login-content .form-sociallink ul li:last-child {
    padding-right: 0;
  }
}
.login-wrapper .login-content .form-sociallink ul li a {
  color: #092C4C;
  width: 100%;
  border: 1px solid rgba(145, 158, 171, 0.23);
  background: #ffffff;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 10px;
  margin: 0 10px 0 0;
  padding: 15px 53px;
  font-weight: 500;
}
.login-wrapper .login-content .form-sociallink ul li a:hover {
  background: #FF9F43;
  color: #ffffff;
}
.login-wrapper .login-content .form-sociallink ul li a img {
  width: 24px;
  height: 24px;
}
.login-wrapper .login-content .form-sociallink ul li .facebook-logo {
  border-radius: 10px;
  background: #1877F2;
}
.login-wrapper .login-content .form-sociallink ul li .apple-logo {
  border-radius: 10px;
  background: #000000;
}
.login-wrapper .login-content.user-login {
  width: 100%;
  padding: 0;
  overflow: hidden;
  flex-wrap: nowrap;
  flex-direction: column;
  height: auto;
  margin: 50px 0;
}
.login-wrapper .login-content.user-login .login-userset {
  background: #ffffff;
  box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);
  margin: 0;
  padding: 40px;
  border: 1px solid #e8ebed;
}
.login-wrapper .login-img {
  width: 50%;
}
@media (max-width: 991.98px) {
  .login-wrapper .login-img {
    display: none;
  }
}
.login-wrapper .login-img img {
  width: 100%;
  height: 100vh;
}
.login-wrapper .login-userset .login-logo.login-info {
  display: block;
  max-width: 150px;
  margin: auto;
}
.login-wrapper .login-logo {
  max-width: 150px;
  margin: auto;
}

.login-wrapper.login-new {
  overflow: auto;
  height: 100vh;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.login-wrapper.login-new .login-content.user-login .login-userset form .otp-box {
  margin-bottom: 34px;
}
.login-wrapper.login-new .login-content.user-login .login-userset form .otp-box input {
  width: 74px;
  height: 74px;
  background: #ffffff;
  border: 1px solid #E1E1E1;
  border-radius: 8px;
  text-align: center;
  margin-right: 15px;
  font-weight: 700;
  font-size: 26px;
  color: #000000;
  outline: none;
}
@media (max-width: 575px) {
  .login-wrapper.login-new .login-content.user-login .login-userset form .otp-box input {
    width: 40px;
    height: 40px;
  }
}

@media (max-width: 575px) {
  .copyright-text p {
    text-align: center;
    max-width: 215px;
  }
}

.authentication-check .custom-checkbox .checkboxs span {
  top: 0;
}

.hover-a {
  position: relative;
}
.hover-a:after {
  content: "";
  height: 2px;
  width: 100%;
  background: #FF9F43;
  transform: scale(0);
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  transition: all 0.3s ease;
  position: absolute;
  bottom: -3px;
  left: 0;
}
.hover-a:hover:after {
  transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
}
.hover-a:hover {
  color: #FF9F43 !important;
}

.login-body {
  display: table;
  height: 100vh;
  min-height: 100vh;
  margin: auto;
  position: relative;
}
.login-body::after {
  content: "";
  background-repeat: no-repeat;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
.login-body .login-wrapper {
  width: 100%;
  height: 100%;
  display: table-cell;
  vertical-align: top;
  padding-top: 1.875rem;
}
.login-body .login-wrapper .logo-dark {
  max-width: 180px;
  margin: auto;
  margin-bottom: auto;
  display: block;
}
.login-body .login-wrapper .loginbox {
  background: var(--White, #ffffff);
  box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);
  display: flex;
  margin: 1.875rem auto;
  max-width: 450px;
  width: 100%;
}
.login-body .login-wrapper .loginbox .login-right {
  align-items: center;
  display: flex;
  justify-content: center;
  padding: 2rem;
  width: auto;
}
.login-body .login-wrapper .loginbox .login-right .login-right-wrap {
  max-width: 100%;
  flex: auto;
}
.login-body .login-wrapper .loginbox .login-right .login-right-wrap .login-info {
  text-align: center;
  margin-bottom: 24px;
}
.login-body .login-wrapper .loginbox .login-right .login-right-wrap .login-info img {
  border-radius: 100px;
  border: 2px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: lightgray 50%/cover no-repeat;
}
.login-body .login-wrapper .loginbox .login-right .login-right-wrap .login-info p {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 24px;
}
.login-body .login-wrapper .loginbox .login-right .login-right-wrap .login-info h5 {
  font-size: 18px;
  font-weight: 700;
  margin-top: 20px;
}
.login-body .login-wrapper .loginbox .login-right .login-right-wrap form .btn-primary {
  border-radius: 5px;
  padding: 5px 163px;
  background: #FF9F43;
  font-weight: 700;
  transition: all 0.5s ease;
}
.login-body .login-wrapper .loginbox .login-right .login-right-wrap form .btn-primary:hover {
  color: #FF9F43;
  border-color: unset;
}
.login-body .login-wrapper .loginbox .login-right .login-right-wrap form .input-blocks {
  margin: 0 0 24px 0;
}
.login-body .login-wrapper .loginbox .login-right .login-right-wrap form .input-blocks input[type=password] {
  padding: 10px 10px;
}
.login-body .login-wrapper .terms {
  justify-content: center;
}
.login-body .login-wrapper .terms li {
  margin-right: 20px;
}
.login-body .login-wrapper .terms li:last-child {
  margin-right: 0;
}

.product-list ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-bottom: 15px;
  flex-wrap: wrap;
}
.product-list ul.pagination li {
  width: auto;
  padding: 0;
}
.product-list ul li {
  width: 25%;
  padding: 0 15px;
}
@media (max-width: 991.98px) {
  .product-list ul li {
    width: 50%;
    padding: 0 5px;
  }
}
@media (max-width: 575px) {
  .product-list ul li {
    width: 100%;
    padding: 0;
  }
}
.product-list ul li .productviews {
  border: 1px solid rgba(145, 158, 171, 0.32);
  margin: 0 0 10px;
  padding: 15px 15px 10px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border-radius: 5px;
}
.product-list ul li .productviews .productviewsimg img {
  max-width: 48px;
  max-height: 48px;
}
.product-list ul li .productviews .productviewscontent {
  margin-left: 10px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: calc(100% - 48px);
}
.product-list ul li .productviews .productviewscontent .productviewsname h2 {
  font-weight: 500;
  font-size: 14px;
  color: #000000;
}
.product-list ul li .productviews .productviewscontent .productviewsname h3 {
  color: #092C4C;
  font-size: 13px;
  font-weight: 400;
}
.product-list ul li .productviews .productviewscontent a {
  color: #FF4D4D;
  font-weight: 700;
  border-radius: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 20px;
  width: 22px;
  height: 22px;
}
.product-list ul li .productviews .productviewscontent a:hover {
  background: #FF4D4D;
  color: #ffffff;
}

.bar-code-view {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 282px;
  border: 1px solid #dbe0e6;
  padding: 15px;
  margin-bottom: 20px;
  max-width: 100%;
}

.input-checkset ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.input-checkset ul li {
  margin-right: 30px;
}
@media (max-width: 991.98px) {
  .input-checkset ul li {
    margin-right: 10px;
  }
}

@media (max-width: 991.98px) {
  .productdetails .product-bar li {
    border: 1px solid #dbe0e6;
  }
  .productdetails .product-bar li:first-child {
    border: 1px solid #dbe0e6;
  }
  .productdetails .product-bar h4 {
    width: 50%;
    border-right: 1px solid #dbe0e6;
  }
  .productdetails .product-bar h6 {
    width: 50%;
  }
}
.productdetails.productdetailnew {
  margin-bottom: 25px;
}
.productdetails.productdetailnew ul li h4 {
  width: 50%;
}
.productdetails.productdetailnew ul li h6 {
  width: 50%;
}
.productdetails.productdetailnew ul li h6.manitorygreen {
  color: #0F9D58;
}
.productdetails.productdetailnew ul li h6.manitoryblue {
  color: #2AA4F4;
}
.productdetails > ul > li {
  border: 1px solid #dbe0e6;
  border-top: 0;
  display: flex;
  flex-wrap: wrap;
}
@media (max-width: 991.98px) {
  .productdetails > ul > li {
    border: 0;
  }
}
.productdetails > ul > li h4 {
  color: #092C4C;
  font-size: 14px;
  font-weight: 500;
  width: 30%;
  border-right: 1px solid #dbe0e6;
  padding: 10px;
}
@media (max-width: 991.98px) {
  .productdetails > ul > li h4 {
    width: 100%;
    border-right: 0;
  }
}
.productdetails > ul > li h6 {
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  width: 70%;
  padding: 10px;
}
@media (max-width: 991.98px) {
  .productdetails > ul > li h6 {
    width: 100%;
  }
}
.productdetails > ul > li .input-checkset {
  padding: 10px;
  color: #000000;
  font-size: 14px;
  font-weight: 500;
  width: 70%;
}
.productdetails > ul > li:first-child {
  border-top: 1px solid #dbe0e6;
}
@media (max-width: 991.98px) {
  .productdetails > ul > li:first-child {
    border: 0;
  }
}
@media (max-width: 991.98px) {
  .productdetails.product-respon {
    overflow: hidden;
  }
  .productdetails.product-respon ul {
    overflow: auto;
  }
  .productdetails.product-respon ul .input-checkset li {
    margin-bottom: 15px;
  }
}

.slider-product {
  text-align: center;
  width: 100%;
}
.slider-product img {
  width: auto !important;
  margin: 0 0 10px;
}
@media (max-width: 991.98px) {
  .slider-product img {
    height: auto;
  }
}
.slider-product h4 {
  font-size: 14px;
  color: #092C4C;
  font-weight: 500;
}
.slider-product h6 {
  font-size: 13px;
  font-weight: 400;
  color: #092C4C;
}

.slider-product-details .owl-carousel .owl-nav {
  position: relative;
}
.slider-product-details .owl-carousel .owl-nav button {
  width: 21px;
  height: 21px;
  color: #212529;
  border: 1px solid #212529;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: absolute;
  top: -30px;
  border-radius: 50px;
}
.slider-product-details .owl-carousel .owl-nav button:hover {
  background: #212529;
  color: #ffffff;
}
.slider-product-details .owl-carousel .owl-nav button span {
  font-size: 16px;
}
.slider-product-details .owl-carousel .owl-nav .owl-next {
  position: absolute;
  top: -30px;
  right: 0;
}

.requiredfield {
  margin-bottom: 15px;
}
@media (max-width: 991.98px) {
  .requiredfield {
    margin-bottom: 10px;
  }
}
.requiredfield h4 {
  font-size: 14px;
  color: #67748E;
}

.action-set {
  width: 18px;
  height: 18px;
  display: inline-block;
  font-size: 11px;
  border-radius: 50px;
}

.badges {
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  padding: 5px 10px;
  border-radius: 8px;
  color: #ffffff;
  text-align: center;
  min-width: 80px;
}
.badges.bg-lightgreen {
  background: #28C76F;
}
.badges.bg-lightred {
  background: #FF4D4D;
}
.badges.bg-lightyellow {
  background: #FF9900;
}
.badges.bg-lightpurple {
  background: rgb(115, 103, 240);
}
.badges.bg-lightgrey {
  background: #67748E;
}
.badges.unstatus-badge {
  background-color: #FF0000;
}
.badges.status-badge {
  background-color: #28C76F;
}

.badge-bgsuccess {
  border-radius: 5px;
  background: #28C76F;
  padding: 3px 10px;
  font-size: 14px;
}

.badge-bgdanger {
  border-radius: 5px;
  background: #FF0000;
  padding: 3px 19px;
  font-size: 14px;
}

.badges.order-badge {
  border-radius: 5px;
  background: #FF9900;
  padding: 1px 10px;
}

.badge-linesuccess, .badges-success {
  color: #28C76F;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid #28C76F;
  font-size: 14px;
}

.badge-linedanger, .badge-linedangered {
  color: #FF0000;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid #FF0000;
  font-size: 14px;
}

span.badge.badges-warning {
  padding: 5px 10px;
}

.add-icon span, .add-icon a {
  width: 40px;
  height: 40px;
  background: #FF9F43;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 5px;
}
@media (max-width: 575px) {
  .add-icon span, .add-icon a {
    position: relative;
    left: -5px;
    z-index: 10000;
  }
}
.add-icon .choose-add {
  width: 40px;
  height: 40px;
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: #092C4C;
  border-radius: 8px;
}
@media (max-width: 575px) {
  .add-icon .choose-add {
    position: relative;
    left: -5px;
    z-index: 10000;
  }
}
.add-icon .choose-add .plus {
  color: #ffffff;
  width: 16px;
  height: 16px;
}
.add-icon a:hover {
  background: #1B2850;
}

.cal-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-repeat: no-repeat;
  background-position: 95% 50%;
}

.calc-no {
  background: #f8f9fa;
  border: 0 !important;
}

.total-order {
  max-width: 430px;
  width: 100%;
  margin: 30px 30px 30px auto;
}
.total-order ul {
  margin: 0;
  padding: 0;
}
.total-order ul li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border: 1px solid #f8f9fa;
  border-top: 0;
}
.total-order ul li h4 {
  width: 50%;
  color: #67748E;
  font-size: 14px;
  font-weight: 500;
  padding: 10px;
  border-right: 1px solid #f8f9fa;
  background: #FAFBFE;
}
.total-order ul li h5 {
  color: #5B6670;
  font-size: 14px;
  padding: 10px;
  font-weight: 400;
  text-align: right;
  width: 50%;
}
.total-order ul li:first-child {
  border-top: 1px solid #f8f9fa;
}
.total-order ul li.total h5 {
  color: #092C4C;
  font-weight: 700;
}
.total-order ul li.total h4 {
  color: #495057;
  font-weight: 700;
}

.card-sales-split {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding-bottom: 25px;
  border-bottom: 1px solid #e8ebed;
}
@media (max-width: 991.98px) {
  .card-sales-split {
    padding-bottom: 10px;
  }
}
@media (max-width: 575px) {
  .card-sales-split {
    flex-direction: column;
  }
  .card-sales-split ul {
    margin-top: 15px;
  }
}
.card-sales-split h2 {
  font-size: 14px;
  font-weight: 600;
}
.card-sales-split ul {
  display: flex;
}
.card-sales-split li {
  margin: 0 15px;
}

.image-upload-new {
  min-height: 258px;
}
.image-upload-new .productviewscontent {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  text-align: left;
  margin-top: 15px;
}
.image-upload-new .productviewscontent .productviewsname h2 {
  font-weight: 500;
  font-size: 14px;
  color: #000000;
}
.image-upload-new .productviewscontent .productviewsname h3 {
  color: #092C4C;
  font-size: 13px;
  font-weight: 400;
}
.image-upload-new .productviewscontent a {
  width: 22px;
  height: 22px;
  color: #FF4D4D;
  font-weight: 700;
  border-radius: 50px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 18px;
}
.image-upload-new .productviewscontent a:hover {
  background: #FF4D4D;
  color: #ffffff;
}
.image-upload-new .productviews {
  width: 100%;
  padding: 0 10px;
}

.uploadedimage .image-uploads {
  max-width: 100%;
}

.productviewset {
  padding-left: 18px;
  position: relative;
}
.productviewset .productviewsimg {
  max-width: 94px;
}
.productviewset .productviewscontent a {
  background: #ffffff;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 5px;
  position: absolute;
  top: 4px;
  left: 82px;
}

.profile-set {
  margin-bottom: 30px;
}
.profile-set .profile-head {
  height: 109px;
  background: linear-gradient(90deg, #FF4D4D 0%, #FF9F43 100%);
  border-radius: 0 10px 0 0;
}
@media (max-width: 991.98px) {
  .profile-set .profile-head {
    border-radius: 10px;
  }
}
.profile-set .profile-top {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
@media (max-width: 767px) {
  .profile-set .profile-top {
    flex-direction: column;
  }
}
.profile-set .profile-top .profile-content {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
@media (max-width: 767px) {
  .profile-set .profile-top .profile-content {
    flex-direction: column;
  }
}
.profile-set .profile-top .profile-contentimg {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-top: -40px;
  width: 130px;
  position: relative;
  border: 10px solid #ffffff;
  border-radius: 50%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.2509803922);
}
.profile-set .profile-top .profile-contentimg img {
  border-radius: 50px;
}
.profile-set .profile-top .profileupload input[type=file] {
  opacity: 0;
  width: 34px;
  height: 34px;
  display: block;
  z-index: 9;
  cursor: pointer;
  position: absolute;
  bottom: 10px;
  left: 42px;
}
.profile-set .profile-top .profileupload a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FF9F43;
  width: 34px;
  height: 34px;
  z-index: 1;
  border-radius: 50px;
  position: absolute;
  bottom: 10px;
  left: 41px;
}
.profile-set .profile-top .profile-contentname {
  padding-left: 20px;
}
@media (max-width: 767px) {
  .profile-set .profile-top .profile-contentname {
    text-align: center;
    padding: 20px 0 20px 0;
  }
}
.profile-set .profile-top .profile-contentname h2 {
  font-size: 18px;
  color: #092C4C;
  font-weight: 700;
}
.profile-set .profile-top .profile-contentname h4 {
  color: #777;
  font-size: 14px;
}

.pass-group {
  position: relative;
}
.pass-group .toggle-password,
.pass-group .toggle-passworda {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  transform: translateY(-50%);
  cursor: pointer;
  width: 30px;
  height: 30px;
  color: #67748E;
  font-size: 14px;
  border-radius: 50%;
  position: absolute;
  top: 50%;
  right: 10px;
}

.table-tab ul {
  margin-bottom: 24px;
}
.table-tab ul li {
  margin-right: 10px;
}
.table-tab ul li:last-child {
  margin-right: 0;
}
.table-tab ul li button.nav-link {
  font-weight: 700;
  padding: 10px;
  line-height: normal;
  color: #092C4C;
  background-color: #dbe0e6;
}
.table-tab ul li button.nav-link.active {
  background-color: #FF9F43;
  color: #ffffff;
}
@media (max-width: 575px) {
  .table-tab .nav-pills {
    display: flex;
    justify-content: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
  }
}

.badge.badge-bgdanger {
  background-color: rgba(255, 0, 0, 0.06);
  color: #FF0000;
  padding: 5px 10px;
}

button.swal2-styled.swal2-confirm {
  background-color: #FF9F43;
}
button.swal2-styled.swal2-confirm:hover {
  background-color: #092C4C;
}

table tbody td.action-table-data {
  display: flex;
}
table tbody td.action-table-data a {
  height: 31px;
  width: 31px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 8px;
}
table tbody td.action-table-data a .feather-edit {
  color: #3577f1;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-edit {
  color: #5B6670;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .feather-trash-2 {
  color: #FF0000;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .feather-eye {
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-download {
  color: #3577f1;
  width: 14px;
  height: 14px;
}
table tbody td.action-table-data a .action-eye {
  color: #092C4C;
  width: 14px;
  height: 14px;
}
table tbody .productimgname {
  min-width: 200px;
}
table tbody .productimgname a.stock-img.product-img {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 8px;
}
table tbody .productimgname a.stock-img.product-img img {
  width: 50px;
  height: 50px;
  max-width: 100%;
  margin-right: 0;
}
table .edit-delete-action {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  height: 50px;
}
table .edit-delete-action a {
  padding: 0;
}
table .edit-delete-action.data-view {
  min-height: 52px;
}
table .edit-delete-action.data-row {
  height: auto;
}
table .edit-delete-action.data {
  height: 44px;
}

.table-top-head {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 575px) {
  .table-top-head.low-stock-top-head {
    flex-wrap: wrap;
    justify-content: start;
  }
}
.table-top-head.low-stock-top-head li {
  margin-bottom: 10px;
}
.table-top-head.low-stock-top-head li:last-child {
  margin-right: 0;
}
.table-top-head li {
  margin-right: 10px;
  flex-shrink: 0;
}
.table-top-head li:last-child {
  margin-right: 0;
}
.table-top-head li #collapse-header {
  margin-right: 0;
}
@media (max-width: 991.98px) {
  .table-top-head li #collapse-header {
    display: none;
  }
}
.table-top-head li a {
  height: 38px;
  width: 38px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #e8ebed;
  background: #ffffff;
  border-radius: 8px;
  padding: 6px;
  font-size: 18px;
}
.table-top-head li a svg {
  height: 20px;
}
.table-top-head li a:hover {
  background: #e3e3e3;
}
.table-top-head li a label {
  margin-right: 10px;
}
.table-top-head li a.btn-secondary {
  background-color: #092C4C;
  color: #ffffff;
  padding: 10px;
  font-weight: 700;
  font-size: 14px;
}
.table-top-head li a.btn-secondary:hover {
  background-color: #FF9F43;
}
.table-top-head li a.btn-secondary svg {
  width: 16px;
  margin-right: 5px;
  color: #ffffff;
}
@media (max-width: 767px) {
  .table-top-head li a.btn-secondary {
    padding: 5px;
    font-size: 14px;
  }
}
.table-top-head li a .action-edit.sales-action {
  color: #3577f1;
}
.table-top-head li .status-toggle {
  height: 38px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #f3f6f9;
  background: #ffffff;
  border-radius: 8px;
  padding: 6px 10px;
}
.table-top-head li .status-toggle label {
  margin-right: 10px;
}

.custom-modal-header {
  background: #FAFBFE;
  padding: 24px;
}
.custom-modal-header .page-title h4 {
  font-size: 18px;
  font-weight: 700;
  color: #092C4C;
}

.custom-modal-body {
  padding: 24px;
}
.custom-modal-body .input-blocks {
  margin-right: 0;
}
.custom-modal-body label {
  font-size: 15px;
  font-weight: 400;
}

.status-label {
  color: #212B36;
}

.modal-footer-btn {
  margin-top: 40px;
  text-align: right;
}
.modal-footer-btn a {
  min-width: auto;
}
@media (max-width: 575px) {
  .modal-footer-btn a {
    padding: 10px 10px;
  }
}

.status-toggle.modal-status label {
  height: 15px;
  width: 32px;
  background-color: #B9B9C3;
  margin-bottom: 0;
}

.status-toggle.modal-status label::after {
  top: 7px;
}

td p.description-para {
  max-width: 400px;
  white-space: break-spaces;
}

.form-sort .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 35px;
}
.form-sort span.select2-container.select2-container--default.select2-container--open {
  z-index: 99;
}

#filter_inputs .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 35px;
}
#filter_inputs input {
  padding-left: 35px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
#filter_inputs span.select2-container.select2-container--default.select2-container--open {
  z-index: 98;
}

#filter_inputs1 .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 35px;
}
#filter_inputs1 input {
  padding-left: 35px;
}
#filter_inputs1 span.select2-container.select2-container--default.select2-container--open {
  z-index: 98;
}

#filter_inputs2 .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 35px;
}
#filter_inputs2 input {
  padding-left: 35px;
}
#filter_inputs2 span.select2-container.select2-container--default.select2-container--open {
  z-index: 98;
}

.summer-description-box .card .card-header {
  padding: 8px;
  border-bottom: 1px solid rgba(145, 158, 171, 0.32);
}
.summer-description-box .note-editor {
  border: 1px solid rgba(145, 158, 171, 0.32);
}
.summer-description-box .note-editable {
  height: 150px !important;
}
.summer-description-box .note-resizebar {
  display: none;
}

.table tbody td a.view-note {
  color: #3577f1;
  font-weight: 700;
}

.userimgname .product-img {
  display: inherit;
  width: 35px;
  height: 35px;
  margin-right: 8px;
}

.modal-body-table {
  background-color: #F6F7F8;
  padding: 24px;
  margin-bottom: 20px;
  border-radius: 8px;
}

.product-quantity {
  border: 1px solid #dbe0e6;
  background-color: #FAFBFE;
  width: 105px;
  height: 40px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 8px;
}
.product-quantity input {
  width: 35px;
  border: 0;
  background-color: #FAFBFE;
  text-align: center;
  height: 35px !important;
}
.product-quantity span {
  color: #092C4C;
  font-size: 0;
  cursor: pointer;
}
.product-quantity span .plus-circle-qty {
  width: 20px;
  height: 20px;
}
.product-quantity span .feather-search-qty {
  width: 20px;
  height: 20px;
}

.modal-dialog.stock-adjust-modal {
  max-width: 800px;
}
.modal-dialog.stock-adjust-modal .dataTables_length, .modal-dialog.stock-adjust-modal .dataTables_info, .modal-dialog.stock-adjust-modal .dataTables_paginate {
  display: none;
}

.input-blocks.search-form input {
  padding-left: 30px;
}
.input-blocks.search-form svg {
  position: absolute;
  left: 10px;
  top: 37px;
  width: 15px;
}

.badge badge-linedanger {
  background-color: rgba(255, 0, 0, 0.06);
  color: #FF0000;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 14px;
}

.input-groupicon.calender-input input {
  padding-left: 27px;
}

span.customer-toggle {
  color: #092C4C;
}

span.unlimited-text {
  color: #5B6670;
  margin-top: 5px;
  display: inline-block;
}

.modal-title-head h6 {
  font-size: 16px;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.modal-title-head h6 svg {
  width: 15px;
  color: #FF9F43;
  margin-right: 5px;
}

#phone, #phone2, #phone3 {
  padding-left: 50px;
}

.total-employees {
  background-color: #FAFBFE;
  padding: 10px 8px;
  margin-right: 24px;
  border-radius: 8px;
}
.total-employees h6 {
  font-size: 14px;
  color: #092C4C;
  font-weight: 700;
  display: flex;
  align-items: center;
}
.total-employees h6 svg {
  width: 15px;
  margin-right: 5px;
}
.total-employees h6 span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  font-size: 10px;
  width: 18px;
  height: 18px;
  background-color: #FF0000;
  color: #ffffff;
  border-radius: 50%;
  margin-left: 5px;
}

.search-path.search-path-new .btn-list, .search-path.search-path-new .btn-grid {
  width: 36px;
  height: 36px;
  background-color: #FAFBFE;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  color: #092C4C;
  margin-right: 15px;
  border-radius: 8px;
}
.search-path.search-path-new .btn-list.active, .search-path.search-path-new .btn-grid.active {
  background-color: #FF9F43;
  color: #ffffff;
}
.search-path.search-path-new .btn-list.active:hover, .search-path.search-path-new .btn-grid.active:hover {
  background-color: #092C4C;
  color: #ffffff;
}
.search-path.search-path-new .btn-list svg, .search-path.search-path-new .btn-grid svg {
  width: 18px;
  height: 18px;
}
.search-path.search-path-new .btn-list:hover, .search-path.search-path-new .btn-grid:hover {
  background-color: #FF9F43;
  color: #ffffff;
}
@media (max-width: 575px) {
  .search-path.search-path-new .form-sort {
    margin-top: 0;
  }
}

.layout-box {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FF9F43;
  color: #ffffff;
  border-radius: 8px;
}
.layout-box:hover {
  background-color: #092C4C;
  color: #ffffff;
}

td span.emp-team {
  display: block;
  line-height: normal;
}

.badges-inactive {
  border: 1px solid #FF0000;
  color: #FF0000;
  padding: 2px 10px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
}

.success-email-send.modal-body {
  padding: 24px;
}
.success-email-send.modal-body span svg {
  width: 40px;
  height: 40px;
  color: #28C76F;
  margin-bottom: 20px;
}
.success-email-send.modal-body h4 {
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 5px;
}
.success-email-send.modal-body p {
  font-size: 15px;
}
.success-email-send.modal-body a.btn {
  padding: 10px 20px;
}

.layout-drop-item {
  width: 350px;
  max-height: 400px;
  overflow-y: scroll;
  padding: 20px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  background: #ffffff;
  border-radius: 8px;
  position: absolute;
  right: 0;
  margin-top: 10px;
  z-index: 101;
  display: none;
}
.layout-drop-item .drop-item-head {
  border-bottom: 1px solid rgba(145, 158, 171, 0.3);
  margin: 0 0 20px;
  padding: 0 0 20px;
}
.layout-drop-item .drop-item-head h5 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}
.layout-drop-item .drop-item-head p {
  font-size: 14px;
}
.layout-drop-item ul li {
  margin-bottom: 20px;
}
.layout-drop-item ul li span {
  display: flex;
  align-items: center;
}
.layout-drop-item ul li span svg {
  width: 16px;
  margin-right: 5px;
}
.layout-drop-item ul li:last-child {
  margin-bottom: 0;
}

.layout-hide-box {
  position: relative;
}

.layout-show-box .layout-drop-item {
  display: block;
}

@media (max-width: 767px) {
  .table-top.table-top-new {
    flex-direction: column;
    align-items: self-start;
  }
}
.table-top.table-top-new .search-path {
  margin-left: 0;
}
@media (max-width: 767px) {
  .table-top.table-top-new .search-path {
    margin-top: 24px;
  }
}
@media (max-width: 575px) {
  .table-top.table-top-new .search-path {
    flex-direction: column;
    align-items: self-start;
  }
}
@media (max-width: 575px) {
  .table-top.table-top-new .search-path .form-sort {
    margin-top: 20px;
  }
}
@media (max-width: 767px) {
  .table-top.table-top-new .search-set {
    flex-direction: column;
    align-items: flex-start;
  }
  .table-top.table-top-new .search-set .total-employees {
    margin: 0 0 20px 0;
  }
}

.badge-applied {
  background-color: #7367F0;
  padding: 2px 10px;
  color: #ffffff;
  border-radius: 5px;
}

.badge-approved {
  background-color: #28C76F;
  padding: 2px 10px;
  color: #ffffff;
  border-radius: 5px;
}

.badge-reject {
  background-color: #FF0000;
  padding: 2px 10px;
  color: #ffffff;
  border-radius: 5px;
}

.table tbody tr td a.reason-for-reject {
  color: #3577f1;
  font-weight: 600;
}

.note-editor.note-frame.card {
  margin-bottom: 0;
}

table tbody td.action-table-data a.cancel-circle {
  border: 0;
  padding: 0;
}
table tbody td.action-table-data a.cancel-circle svg {
  color: #FF9F43;
}
table tbody td.action-table-data a.cancel-circle:hover {
  background-color: transparent;
}
table tbody td.action-table-data a.cancel-circle:hover svg {
  color: #FF0000 !important;
}

.apply-leave {
  background-color: #FAFBFE;
  border-radius: 8px;
}
.apply-leave .leave-apply {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 10px;
}
@media (max-width: 575px) {
  .apply-leave .leave-apply {
    flex-direction: column;
    align-items: flex-start;
  }
}
.apply-leave .leave-apply .leave-date {
  margin-right: 70px;
}
.apply-leave .leave-apply .leave-date span {
  color: #5B6670;
}
.apply-leave .leave-apply .leave-date p {
  color: #092C4C;
}
@media (max-width: 575px) {
  .apply-leave .leave-apply .leave-date {
    margin-right: 0;
    margin-bottom: 20px;
  }
}
.apply-leave .leave-apply .leave-time {
  width: 175px;
}

.input-blocks .bootstrap-tagsinput {
  width: 100%;
  padding: 0 0.75rem;
  box-shadow: none;
  line-height: 40px;
}
.input-blocks .bootstrap-tagsinput .tag {
  background-color: #e8ebed;
  color: #092C4C;
  padding: 3px 10px;
  border-radius: 4px;
  position: relative;
  z-index: 1;
}
.input-blocks .bootstrap-tagsinput .tag .remove::after {
  color: #5B6670;
}
.input-blocks .bootstrap-tagsinput input {
  position: static;
  width: auto;
  border: none;
}
.input-blocks span.tag-text {
  color: #5B6670;
  font-size: 13px;
}

.table tbody tr td .sales-dropdown-list a {
  padding: 10px 20px;
}

.no-pagination .pagination {
  display: none;
}

#collapse-header.active {
  background-color: #FF9F43;
  border-color: unset;
}
#collapse-header.active svg {
  color: #ffffff;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
}
#collapse-header.active:hover svg {
  color: #ffffff;
}

.edit-delete-action a:hover {
  background-color: rgb(40, 142, 199);
  border-color: rgb(40, 142, 199);
}
.edit-delete-action a:hover svg {
  color: #ffffff !important;
}
.edit-delete-action a.confirm-text:hover {
  background-color: #FF0000;
  border-color: #FF0000;
}
.edit-delete-action a.edit-icon:hover {
  background-color: #092C4C;
  border-color: #092C4C;
}

.modal table.table thead > tr > th.sorting:before {
  display: none !important;
}
.modal table.table thead > tr > th.sorting:after {
  display: none !important;
}

.profit-head .input-blocks .info-img {
  color: #092C4C;
}
.profit-head .input-blocks input {
  padding-left: 35px;
}

.profile-pic-upload .profile-pic.brand-pic {
  width: 110px;
  height: 105px;
  position: relative;
}
.profile-pic-upload .profile-pic.brand-pic .remove-photo {
  position: absolute;
  right: 8px;
  top: 10px;
  background: #FF0000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 4px;
}
.profile-pic-upload .profile-pic.brand-pic .remove-photo svg {
  color: #ffffff;
  width: 14px;
  height: 14px;
}

.sales-details-items {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
}
@media (max-width: 767px) {
  .sales-details-items {
    flex-direction: column;
    align-items: start;
  }
}
@media (max-width: 767px) {
  .sales-details-items .details-item {
    margin-bottom: 20px;
  }
}
.sales-details-items .details-item h6 {
  margin-bottom: 15px;
  font-size: 15px;
  color: #092C4C;
}
.sales-details-items .details-item p {
  font-size: 14px;
  color: #5B6670;
}
.sales-details-items .details-item h5 {
  color: #28C76F;
  font-size: 15px;
}
.sales-details-items .details-item h5 span {
  display: block;
  color: #5B6670;
}

.order-text {
  color: #092C4C;
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 15px;
}

.profile-head-action .badge-linesuccess {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 3px 10px;
  height: 24px;
}
.profile-head-action .badge-linedanger {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding: 3px 10px;
  height: 24px;
}

.user.product-list {
  align-items: center;
}
.user.product-list .emping.d-flex {
  align-items: center;
}
.user.product-list .emping.d-flex a img {
  border-radius: 6px;
  margin-right: 8px;
}

.war-add #phone {
  height: 38px;
}

.war-edit-phone #phone2, .war-edit-phone #phone3 {
  height: 38px;
}

.user.product-list a img {
  border-radius: 6px;
  margin-right: 8px;
}

.user.user.product-list .emping a {
  align-items: center;
}

.modal.show .modal-dialog.purchase {
  max-width: 1140px;
}

.page-header .btn-added.color {
  background-color: #092C4C;
}
.page-header .btn-added.color:hover {
  background-color: #FF9F43;
  color: #ffffff;
}

.input-blocks.download {
  float: right;
}

.feather-plus-circles {
  color: #ffffff;
}

.add-icon.plus a {
  color: #092C4C;
}

.import-btn {
  float: right;
  margin-bottom: 20px;
}

.image-upload.download input[type=file] {
  height: 150px;
}

.image-upload.download {
  border-radius: 5px;
  border: 1px dashed var(--Subtitle, #B8BCC9);
  margin-bottom: 0;
}

.modal-footer-btn.download-file {
  margin-top: 0;
  margin-bottom: 15px;
}

.main-wrappers {
  background-color: #FAFBFE;
}
.main-wrappers.pos-page .sidebar {
  display: none;
}
@media (max-width: 991.98px) {
  .main-wrappers.pos-page .sidebar {
    display: block;
  }
}
.main-wrappers.pos-page #toggle_btn {
  display: none;
}

.menu-opened .pos-page.slide-nav .sidebar {
  margin-left: 0;
}
.menu-opened .pos-page .sidebar {
  margin-left: -100%;
}

.product-view {
  width: 100%;
  border: 1px solid #e8ebed;
  margin-bottom: 20px;
}
.product-view:hover {
  border: 1px solid #FF9F43;
}
.product-view .product-viewimg {
  position: relative;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  max-height: 120px;
  overflow: hidden;
}
.product-view .product-viewimg h6 {
  background: #28C76F;
  color: #ffffff;
  font-size: 8px;
  font-weight: 600;
  padding: 3px;
  position: absolute;
  bottom: 0;
  left: 0;
}
.product-view .product-viewcontent {
  padding: 13px;
}
.product-view .product-viewcontent h3 {
  font-size: 14px;
  color: #000000;
  font-weight: 500;
}
.product-view .product-viewcontent h4 {
  font-size: 12px;
  color: #67748E;
  font-weight: 500;
  margin-bottom: 5px;
}
.product-view .product-viewcontent h5 {
  font-size: 14px;
  color: #67748E;
  font-weight: 500;
}

.main-set {
  padding: 0 30px;
}
@media (max-width: 991.98px) {
  .main-set {
    padding: 0 10px;
  }
}

.text-underline {
  position: relative;
}
.text-underline::after {
  content: "";
  background: #67748E;
  width: 10px;
  height: 2px;
  position: absolute;
  bottom: 12px;
  left: 10px;
}

.select-split {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-bottom: 20px;
}
.select-split .select-group {
  width: calc(100% - 55px);
}
.select-split .btn-filters {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin: 0 0 0 15px;
  padding: 0;
}
.select-split .select2-container--default .select2-selection--single {
  background-color: #ffffff;
  border: 1px solid #e8ebed;
  height: 40px;
  border-radius: 4px;
}
.select-split .select2-container--default .select2-selection--single .select2-selection__rendered {
  line-height: 40px;
}
.select-split .select2-container--default .select2-selection--single .select2-selection__arrow {
  height: 40px;
}

.table tr:hover .productimg .productcontet h4 img {
  opacity: 1;
}

.table-product tr th {
  font-weight: 600;
  color: #67748E;
  font-size: 14px;
}
.table-product tr td {
  font-weight: 600;
  color: #67748E;
  font-size: 14px;
}

.btn-totallabel {
  color: #ffffff;
  background: #7367F0;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border-radius: 5px;
  margin: 0 0 15px;
  padding: 12px;
}
.btn-totallabel h5 {
  font-size: 14px;
  margin: 0;
  font-weight: 600;
}
.btn-totallabel h6 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
}

.setvaluecash {
  margin: 0 0 15px 0;
}
.setvaluecash ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.setvaluecash ul li {
  width: 33%;
  margin-right: 10px;
}
.setvaluecash ul li:last-child {
  margin: 0;
}
.setvaluecash ul li a {
  border: 1px solid #e8ebed;
  color: #000000;
  font-size: 14px;
  font-weight: 600;
  min-height: 95px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  flex-direction: column;
  padding: 10px 20px;
}
.setvaluecash ul li a:hover {
  border: 1px solid #7367F0;
  color: #7367F0;
}
.setvaluecash ul li a img {
  margin-bottom: 10px;
}

.setvalue {
  padding: 15px 0;
}
.setvalue ul li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 10px;
}
.setvalue ul li h5 {
  font-size: 13px;
  font-weight: 500;
}
.setvalue ul li h6 {
  font-size: 13px;
  font-weight: 500;
}
.setvalue ul li.total-value h5 {
  font-size: 16px;
  font-weight: 600;
  color: #7367F0;
}
.setvalue ul li.total-value h6 {
  font-size: 16px;
  font-weight: 600;
  color: #7367F0;
}

.product-lists {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border: 1px solid #FAFBFE;
  box-shadow: 0px 4px 4px 0px rgba(237, 237, 237, 0.2509803922);
  margin: 0 0 15px;
  padding: 15px;
}
@media (max-width: 568px) {
  .product-lists {
    flex-direction: column;
  }
  .product-lists li {
    margin: 10px 0;
  }
}

.increment-decrement .input-groups {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-top: 10px;
}
.increment-decrement .input-groups input[type=button] {
  background-color: transparent;
  font-size: 20px;
  border: 1px solid #adb5bd;
  border-radius: 4px;
  height: 20px;
  width: 20px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-top: 0px;
  line-height: 0;
  padding: 0;
  color: #adb5bd;
}
.increment-decrement .quantity-field {
  width: 30px;
  text-align: center;
  background-color: transparent;
  float: left;
  border: 0;
}

.productimg {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.productimg .productimgs {
  width: 82px;
  margin-right: 13px;
}
.productimg .productimgs img {
  width: 82px;
  height: 82px;
  object-fit: cover;
}
.productimg .productcontet h4 {
  font-size: 14px;
  color: #000000;
  font-weight: 600;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-bottom: 5px;
}
.productimg .productcontet h4 img {
  opacity: 0;
  margin-top: 5px;
  display: block;
}
.productimg .productlinkset {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.productimg .productlinkset h5 {
  background: #FF9F43;
  color: #ffffff;
  font-size: 12px;
  border-radius: 5px;
  margin-right: 10px;
  padding: 2px 10px;
}
.productimg .productlinkset a {
  position: relative;
  top: 2px;
}

.product-table {
  height: 34vh;
  overflow: auto;
}
@media (max-width: 991.98px) {
  .product-table {
    height: auto;
  }
}

.btn-set {
  margin: 15px 0 25px;
}
.btn-set h4 {
  font-weight: 700;
}

.product-detils {
  height: 70vh;
  overflow-y: auto;
  overflow-x: hidden;
}
@media (max-width: 991.98px) {
  .product-detils {
    height: auto;
  }
}

.tab-set {
  margin-bottom: 20px;
}
.tab-set ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.tab-set ul li {
  width: 48%;
  text-align: center;
  margin-right: 5px;
}
@media (max-width: 575px) {
  .tab-set ul li {
    width: 100%;
    margin-right: 0;
  }
}
.tab-set ul li:last-child {
  margin: 0;
  width: 50%;
}
@media (max-width: 575px) {
  .tab-set ul li:last-child {
    width: 100%;
  }
}
.tab-set ul li a {
  background: #495057;
  width: 100%;
  display: block;
  color: #ffffff;
  font-weight: 600;
  border-radius: 5px;
  padding: 10px;
}
@media (max-width: 575px) {
  .tab-set ul li a {
    border-radius: 0;
  }
}
.tab-set ul li.active a {
  background: #FF9F43;
}

#delete .modal-body .btn {
  min-width: 100px;
  padding: 10px;
}

.owl-product {
  padding-top: 35px;
}
.owl-product .owl-nav {
  margin-top: 10px;
  position: absolute;
  top: -10px;
  right: 0;
}
.owl-product .owl-nav button {
  border-radius: 50px !important;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 19px;
  position: relative;
  height: 19px;
  background: #ffffff !important;
  color: #7367F0 !important;
}
.owl-product .owl-nav button span {
  font-size: 0;
}
.owl-product .owl-nav button.owl-next span:before {
  position: absolute;
  top: 2px;
  right: 5px;
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 900;
  font-size: 10px;
  color: #1A54C7;
}
.owl-product .owl-nav button.owl-prev span:before {
  content: "\\f053";
  font-family: "Font Awesome 5 Free";
  font-style: normal;
  font-weight: 900;
  font-size: 10px;
  color: #1A54C7;
  position: absolute;
  top: 2px;
  right: 7px;
}
.owl-product .owl-nav button:hover {
  background: #1A54C7 !important;
}
.owl-product .owl-nav button:hover span:before {
  color: #ffffff;
}

.actionproduct {
  text-align: right;
  margin-bottom: 15px;
}
.actionproduct ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: flex-end;
  -webkit-justify-content: end;
  -ms-flex-pack: end;
}
.actionproduct ul li {
  margin-left: 10px;
}

.btn-pos ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  flex-wrap: wrap;
}
.btn-pos ul li {
  margin-right: 1px;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .btn-pos ul li {
    width: 48%;
  }
}
@media (max-width: 575px) {
  .btn-pos ul li {
    width: 100%;
    margin-right: 10px;
  }
}
.btn-pos ul li a.btn {
  color: #888B94;
  font-size: 10px;
  width: 100%;
  padding: 5px 12px;
  background: #e8ebed;
  border-radius: 50px;
  border: 1px solid #e8ebed;
  display: flex;
  padding: 5px 12px;
}
@media (max-width: 991.98px) {
  .btn-pos ul li a.btn {
    min-width: auto;
    padding: 6px 15px;
  }
}
.btn-pos ul li a.btn:hover {
  border: 1px solid #EA5455;
  color: #EA5455;
  background: rgba(234, 84, 85, 0.06);
}
.btn-pos ul li a.btn-hold {
  background: #FF9900;
}
.btn-pos ul li a.btn-quation {
  background: #67748E;
}
.btn-pos ul li a.btn-void {
  background: #D0512E;
}
.btn-pos ul li a.btn-payment {
  background: #28C76F;
}
.btn-pos ul li a.btn-recent {
  background: #FF9F43;
}

.calculator-set .calculatortotal {
  margin-bottom: 15px;
}
.calculator-set .calculatortotal h4 {
  width: 100%;
  background: #FF9F43;
  text-align: center;
  color: #ffffff;
  font-size: 36px;
  font-weight: 700;
  border-radius: 5px;
}
.calculator-set ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.calculator-set ul li {
  width: 33.3%;
  text-align: center;
}
.calculator-set ul li a {
  width: 100%;
  border: 1px solid #adb5bd;
  font-size: 24px;
  font-weight: 500;
  display: block;
  color: #000000;
  border-radius: 0;
  padding: 10px;
}
.calculator-set ul li a.btn-closes {
  background: #FF4D4D;
}
.calculator-set ul li a.btn-reverse {
  background: #2E7D32;
}
.calculator-set ul li a:hover {
  background: #f3f6f9;
}

.hold-order {
  text-align: center;
  margin: 15px 0;
}
.hold-order h2 {
  padding: 0 0 30px;
  color: #FF9F43;
  font-size: 36px;
  font-weight: 700;
}

.para-set {
  margin-bottom: 30px;
}
.para-set p {
  color: #495057;
  font-size: 13px;
  font-weight: 500;
}

.delete-order {
  text-align: center;
}

.btn-set h4 {
  background: #FF9F43;
  text-align: center;
  color: #ffffff;
  border-radius: 5px;
  padding: 10px;
}

.header-menuset {
  padding: 15px;
}
.header-menuset ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-wrap: wrap;
}
.header-menuset ul li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  width: 50%;
  margin-bottom: 10px;
}
@media (max-width: 991.98px) {
  .header-menuset ul li {
    width: 100%;
  }
}
.header-menuset ul li .win-maximize {
  display: none;
}
.header-menuset ul li a {
  border: 1px solid #FF9F43;
  width: 95%;
  text-align: center;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FF9F43;
  color: #ffffff;
  padding: 10px;
}
.header-menuset ul li a img {
  filter: brightness(0) invert(1);
}

.invoice-load-btn {
  text-align: center;
  margin-top: 20px;
}
.invoice-load-btn .btn {
  font-weight: 700;
  font-size: 16px;
  color: #FF9F43;
  min-width: 150px;
  background: #ffffff;
  border: 2px solid #FF9F43;
  display: inline-flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  border-radius: 6px;
  padding: 12px 15px;
}
.invoice-load-btn .btn span {
  display: inline-block;
  width: 25px;
  height: 25px;
  margin-right: 8px;
  vertical-align: 0;
  border: 3px solid rgba(252, 136, 3, 0.4901960784);
  border-right-color: #FF9F43;
  animation: 0.75s linear infinite spinner-border;
  border-radius: 50%;
}
.invoice-load-btn .btn:hover {
  background: #FF9F43;
  color: #ffffff;
}
.invoice-load-btn .btn:hover span {
  border: 3px solid #ffffff;
  border-right-color: #ffffff;
}

.form-new .input-blocks input {
  height: 50px;
  background: #f8f9fa;
}
.form-new .input-blocks .scanner-set {
  min-width: 50px;
  position: relative;
  left: -2px;
}

.product-details {
  background: #ffffff;
  border-radius: 5px;
  padding: 10px;
  box-shadow: 0px 4px 4px 0px rgba(237, 237, 237, 0.2509803922);
  border: 1px solid #F8F8F8 !important;
  height: 105px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  flex-direction: column;
}
.product-details:hover {
  background: #7367F0;
}
.product-details:hover h6 {
  color: #ffffff;
}
.product-details.active {
  background-color: #7367F0 !important;
}
.product-details.active h6 {
  color: #ffffff;
}
.product-details img {
  width: auto !important;
}
.product-details h6 {
  font-size: 13px;
  color: #000000;
  margin-top: 10px;
}

.btn-scanner-set {
  background: #7367F0;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  max-width: 160px;
  margin-left: auto;
  color: #ffffff;
  font-size: 14px;
  font-weight: 700;
}
.btn-scanner-set:hover {
  background: #FF9F43;
  color: #ffffff;
}

.split-card {
  margin: 0 0 15px;
  border: 1px dashed #FAFBFE;
  position: relative;
}
.split-card::before {
  position: absolute;
  content: "";
  background: #FAFBFE;
  width: 22px;
  height: 22px;
  border-radius: 50px;
  top: -10px;
  left: -10px;
}
.split-card::after {
  position: absolute;
  content: "";
  background: #FAFBFE;
  width: 22px;
  height: 22px;
  border-radius: 50px;
  top: -10px;
  right: -10px;
}

.totalitem {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 15px;
}
.totalitem h4 {
  padding: 7px 13px;
  background: #F8F8F8;
  color: #7367F0;
  font-size: 12px;
  font-weight: 700;
  border-radius: 50px;
}
.totalitem a {
  font-size: 14px;
  color: #EA5455;
  font-weight: 700;
}

.card.card-order {
  border: 0;
}

.btn-adds {
  border: 2px solid #28C76F;
  color: #28C76F;
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  font-weight: 600;
  margin-bottom: 20px;
}
.btn-adds:hover {
  background: #28C76F;
  color: #ffffff;
}

.order-list {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 25px;
}
.order-list .orderid h4 {
  font-size: 18px;
  font-weight: 700;
  color: #5E5873;
  margin-bottom: 0;
}
.order-list .orderid h5 {
  font-size: 14px;
  font-weight: 400;
  color: #000000;
}
.order-list .actionproducts > ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.order-list .actionproducts > ul > li {
  margin-left: 15px;
}
.order-list .actionproducts > ul > li .deletebg {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #ffffff;
  box-shadow: 0px 4px 14px 0px rgba(199, 199, 199, 0.2509803922);
  width: 30px;
  height: 30px;
  border-radius: 5px;
}

.tabs_wrapper .owl-product {
  margin-bottom: 25px;
}

.productset {
  border: 1px solid #F8F8F8;
  box-shadow: 0px 4px 4px 0px rgba(237, 237, 237, 0.2509803922);
  background: #ffffff;
  margin: 0 0 25px;
  border-radius: 5px;
  position: relative;
  width: 100%;
  overflow: hidden;
}
.productset:hover {
  border: 1px solid #7367F0;
}
.productset .check-product {
  display: none;
  width: 34px;
  height: 23px;
  color: #ffffff;
  position: absolute;
  left: 0;
  top: 0;
  background: #7367F0;
  border-radius: 4px 0;
}
.productset.active {
  border: 1px solid #7367F0;
}
.productset.active .check-product {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.productset:hover .productsetimg img {
  transform: scale(1.2);
}
.productset:hover .productsetimg h6 {
  transform: translatey(0);
}
.productset .productsetimg {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: relative;
  overflow: hidden;
}
.productset .productsetimg img {
  transition: all 0.5s;
  border-radius: 5px 5px 0px 0px;
}
@media (max-width: 991.98px) {
  .productset .productsetimg img {
    max-height: 150px;
  }
}
.productset .productsetimg h6 {
  position: absolute;
  background: #FF9F43;
  color: #ffffff;
  font-size: 10px;
  padding: 5px;
  border-radius: 5px;
  top: 20px;
  right: 20px;
  transform: translatey(-60px);
  transition: all 0.5s;
}
.productset .productsetcontent {
  padding: 13px;
  text-align: center;
}
.productset .productsetcontent h4 {
  font-size: 14px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 13px;
}
.productset .productsetcontent h5 {
  color: #6E6B7B;
  font-size: 12px;
}
.productset .productsetcontent h6 {
  color: #EA5455;
  margin: 0 0 0 auto;
  font-weight: 600;
  font-size: 14px;
}

.tabs_wrapper ul.tabs {
  display: inline-block;
  width: 100%;
  padding-left: 0;
}
.tabs_wrapper ul.tabs li {
  list-style: none;
  cursor: pointer;
  display: inline-block;
  border-radius: 5px;
  color: white;
  font-family: sans-serif;
  width: 100%;
}
.tabs_wrapper ul.tabs li.active {
  background-color: #FF9F43;
  border-color: #FF9F43;
}
.tabs_wrapper ul.tabs li.active h6 a {
  color: #ffffff;
}
.tabs_wrapper ul.tabs li.active .product-details {
  background: transparent;
  border: 0 !important;
}
.tabs_wrapper ul.tabs li.active .product-details h6 {
  color: #ffffff;
}
.tabs_wrapper .tabs_container {
  padding-top: 0px;
  display: inline-block;
  width: 100%;
}
.tabs_wrapper .tabs_container .tab_content {
  display: none;
  width: 100%;
}
.tabs_wrapper .tabs_container .tab_content.active {
  display: inline-block;
}

.btn-icon {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}

.pos-design .btn-row {
  padding: 24px;
}
.pos-design .btn-row a {
  display: flex;
  align-items: center;
}
.pos-design .btn-row a:last-child {
  margin-right: 0;
}
.pos-design .pos-wrapper {
  --bs-gutter-x: 0;
}

@media (max-width: 575px) {
  .btn-row {
    flex-direction: column;
  }
}
.btn-row .btn {
  font-size: 14px;
  color: #ffffff;
  margin: 0 10px 0 0;
  padding: 10px;
  border-radius: 4px;
}
@media (max-width: 575px) {
  .btn-row .btn {
    margin: 0 0 15px 0;
    width: 100%;
  }
}
.btn-row .btn:last-child {
  margin-bottom: 0;
}

.pos-categories h5, .pos-categories h6, .order-list h5, .order-list h6 {
  color: #092C4C;
}
.pos-categories h5, .order-list h5 {
  font-size: 18px;
  font-weight: 700;
}

.btn-info {
  background-color: #3577f1;
  border-color: #3577f1;
}
.btn-info:hover {
  background-color: #FF9F43;
  border-color: #FF9F43;
}

.btn-primary {
  background-color: #FF9F43;
  border-color: #FF9F43;
}
.btn-primary:hover {
  background-color: #092C4C;
  border-color: #092C4C;
}
@media (max-width: 991.98px) {
  .btn-primary {
    margin-top: 10px;
  }
}
@media (max-width: 767px) {
  .btn-primary {
    margin-top: 10px;
  }
}
@media (max-width: 575px) {
  .btn-primary {
    margin-top: 10px;
  }
}

.btn-secondary {
  background-color: #092C4C;
  border-color: #092C4C;
}
.btn-secondary:hover {
  background-color: #FF9F43;
  border-color: #FF9F43;
}

.btn-danger {
  background-color: #FF0000;
  border-color: #FF0000;
}
.btn-danger:hover {
  background-color: #092C4C;
  border-color: #092C4C;
}

.btn-success {
  background-color: #28C76F;
  border-color: #28C76F;
}
.btn-success:hover {
  background-color: #092C4C;
  border-color: #092C4C;
}

.owl-carousel .owl-nav {
  margin: 0;
  position: absolute;
  top: -60px;
  right: 0;
}
.owl-carousel .owl-nav button {
  margin-top: 0;
  margin-bottom: 0;
}
.owl-carousel .owl-nav button.owl-next, .owl-carousel .owl-nav button.owl-prev {
  position: relative;
  width: 28px;
  height: 28px;
  border-radius: 28px;
}
.owl-carousel .owl-nav button.owl-next i, .owl-carousel .owl-nav button.owl-prev i {
  color: #FF9F43;
}
.owl-carousel .owl-nav button.owl-next:hover, .owl-carousel .owl-nav button.owl-prev:hover {
  background-color: #092C4C;
  border-color: #092C4C;
}

.pos-categories {
  background-color: #f8f9fa;
  padding: 24px;
  border-collapse: collapse;
}

.pos-category {
  margin-bottom: 24px;
  height: 125px;
}
.pos-category .owl-item {
  background-color: #ffffff;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  flex-wrap: wrap;
  text-align: center;
  cursor: pointer;
  border: 1px solid #f3f6f9;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  transition: all 0.5s ease;
  border-radius: 8px;
  margin-left: -0.1px !important;
}
.pos-category .owl-item li {
  padding: 15px 0;
}
.pos-category .owl-item a img {
  transition: all 0.5s ease;
  min-width: 40px;
  width: 40px;
  height: 40px;
  margin: 0 auto;
}
.pos-category .owl-item h6 {
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 10px;
  width: 100%;
  margin-bottom: 5px;
}
.pos-category .owl-item h6 a {
  color: #092C4C;
}
.pos-category .owl-item span {
  color: #5B6670;
}
.pos-category .owl-item:hover {
  border-color: #FF9F43;
  border-radius: 5px;
}
.pos-category .owl-item:hover h6 a {
  color: #FF9F43;
}
.pos-category .owl-item:hover a img {
  transform: scale(1.2);
}
.pos-category .owl-nav button.owl-next {
  margin-left: 5px;
}
.pos-category .owl-nav button.owl-prev {
  margin-right: 5px;
}
.pos-category .owl-nav button.owl-next, .pos-category .owl-nav button.owl-prev {
  background-color: #ffffff;
  border: 1px solid #f3f6f9;
}
.pos-category .owl-nav button.owl-next i, .pos-category .owl-nav button.owl-prev i {
  color: #092C4C;
}
.pos-category .owl-nav button.owl-next:hover, .pos-category .owl-nav button.owl-prev:hover {
  background-color: #FF9F43;
  border-color: #FF9F43;
}
.pos-category .owl-nav button.owl-next:hover i, .pos-category .owl-nav button.owl-prev:hover i {
  color: #ffffff;
}

.pos-products .product-info {
  padding: 15px;
  color: #B8BCC9;
  transition: all 0.5s ease;
}
.pos-products .product-info .img-bg {
  height: 117px;
  background-color: #f3f6f9;
  border-radius: 10px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-bottom: 10px;
  position: relative;
}
.pos-products .product-info .img-bg img {
  transition: all 0.5s ease;
}
.pos-products .product-info .img-bg span {
  transition: all 0.5s ease;
  position: absolute;
  top: 0;
  right: 0;
  width: 18px;
  height: 18px;
  border-radius: 100%;
  background: #28C76F;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  display: none;
}
.pos-products .product-info .img-bg span svg {
  color: #ffffff;
  position: absolute;
  top: 1px;
  left: 1px;
}
.pos-products .product-info h6 {
  font-size: 15px;
  font-weight: 700;
}
.pos-products .product-info h6.cat-name a {
  color: #B8BCC9;
}
.pos-products .product-info h6.product-name a {
  color: #092C4C;
}
.pos-products .product-info .price {
  margin-top: 17px;
}
.pos-products .product-info .price span {
  color: #7367F0;
}
.pos-products .product-info .price p {
  color: #FF9F43;
}
.pos-products .product-info:hover, .pos-products .product-info.active {
  border-color: #FF9F43;
}
.pos-products .product-info:hover .img-bg img, .pos-products .product-info.active .img-bg img {
  transform: scale(1.2);
}
.pos-products .product-info:hover .img-bg span, .pos-products .product-info.active .img-bg span {
  display: block;
}

.product-wrap {
  height: 34vh;
  overflow: auto;
}
.product-wrap .product-list {
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  margin: 0 0 10px 0;
  padding: 10px;
}
.product-wrap .product-list .product-info {
  width: 60%;
}
.product-wrap .product-list .product-info .img-bg {
  width: 83px;
  height: 83px;
  background-color: #FAFBFE;
  border-radius: 10px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 10px;
}
.product-wrap .product-list .info span {
  background-color: #FF9F43;
  border-radius: 3px;
  font-weight: 600;
  color: #ffffff;
  font-size: 14px;
  padding: 0 10px;
  min-width: 64px;
}
.product-wrap .product-list .info h6 {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 0;
}
.product-wrap .product-list .info h6 a {
  color: #092C4C;
}
.product-wrap .product-list .info p {
  font-size: 15px;
  font-weight: 600;
  color: #5B6670;
}
.product-wrap .product-list .qty-item {
  position: relative;
  margin-right: 7px;
}
.product-wrap .product-list .qty-item input {
  padding: 1px 9px;
  background: #FAFBFE;
  border-radius: 8px;
  height: 28px;
  width: 71px;
  text-align: center;
  font-size: 14px;
}
.product-wrap .product-list .qty-item .dec, .product-wrap .product-list .qty-item .inc {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  color: #092C4C;
  transition: all 0.5s ease;
}
.product-wrap .product-list .qty-item .dec:hover, .product-wrap .product-list .qty-item .inc:hover {
  color: #FF9F43;
}
.product-wrap .product-list .qty-item .dec {
  left: 9px;
}
.product-wrap .product-list .qty-item .inc {
  right: 9px;
}
.product-wrap .product-list .action a {
  padding: 7px;
  border-radius: 8px;
  border: 1px solid #f3f6f9;
  cursor: pointer;
}
.product-wrap .product-list .action a.edit-icon {
  color: #3577f1;
}
.product-wrap .product-list .action a.edit-icon:hover {
  background-color: #3577f1;
  border-color: #3577f1;
  color: #ffffff;
}
.product-wrap .product-list .action a.delete-icon {
  color: #FF0000;
}
.product-wrap .product-list .action a.delete-icon:hover {
  background-color: #FF0000;
  border-color: #FF0000;
  color: #ffffff;
}

aside {
  height: 100%;
  padding: 24px;
  background-color: #ffffff;
  border-left: 1px solid #f3f6f9;
}
aside.product-order-list h6 {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #1B2850;
}
aside.product-order-list .block-section {
  margin: 20px 0 20px 0;
  padding: 0 0 20px 0;
  border-bottom: 1px solid #f3f6f9;
}
aside.product-order-list .head {
  background-color: #FAFBFE;
  border-radius: 8px;
  padding: 10px;
}
aside.product-order-list .head h5 {
  color: #092C4C;
  font-size: 18px;
  font-weight: 700;
}
aside.product-order-list .head span {
  color: #5B6670;
  font-size: 15px;
  font-weight: 500;
}
aside.product-order-list .customer-info .input-block {
  margin-bottom: 10px;
}
aside.product-order-list .customer-info .input-block .btn {
  min-width: 40px;
  min-height: 40px;
  margin: 0 0 0 10px;
  padding: 5px;
}
aside.product-order-list .product-added .head-text {
  margin-bottom: 20px;
}
aside.product-order-list .product-added .head-text .trash svg {
  margin-right: 8px;
}
aside.product-order-list .product-added h6 .count {
  width: 15px;
  height: 15px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background: #FF9F43;
  border-radius: 100%;
  color: #ffffff;
  font-size: 10px;
  font-weight: 600;
  margin: 0 0 0 7px;
}
aside.product-order-list .selling-info {
  margin-bottom: 24px;
}
aside.product-order-list .selling-info .input-block label {
  margin-bottom: 5px;
}
aside.product-order-list .selling-info .input-block .select2-container--default .select2-selection--single .select2-selection__rendered {
  border-radius: 5px;
  border-color: #353570;
}
aside.product-order-list .order-total {
  background-color: #f3f6f9;
  padding: 24px;
  border-radius: 8px;
}
aside.product-order-list .order-total table tr td {
  padding: 0 0 15px 0;
  color: #5B6670;
  font-size: 15px;
  font-weight: 500;
  background: transparent;
}
aside.product-order-list .order-total table tr td.danger {
  color: #FF0000;
}
aside.product-order-list .order-total table tr:last-child td {
  padding: 20px 0 0 0;
  font-size: 16px;
  font-weight: 600;
}
aside.product-order-list .payment-method .methods .item {
  padding: 0 7px;
}
@media (max-width: 991.98px) {
  aside.product-order-list .payment-method .methods .item {
    padding-bottom: 15px;
  }
}
aside.product-order-list .payment-method .methods .default-cover {
  transition: all 0.5s ease;
}
aside.product-order-list .payment-method .methods .default-cover a {
  box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);
  padding: 10px 15px;
  text-align: center;
  display: block;
  font-size: 15px;
  color: #092C4C;
}
aside.product-order-list .payment-method .methods .default-cover a span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  display: block;
}
aside.product-order-list .payment-method .methods .default-cover:hover {
  background-color: #eff2f7;
  border-color: #FF9F43;
}
aside.product-order-list .payment-method .methods .default-cover:hover img {
  filter: invert(75%) sepia(66%) saturate(1955%) hue-rotate(327deg) brightness(103%) contrast(102%);
}
aside.product-order-list .btn-block {
  margin: 20px 0 20px 0;
  padding: 0 0 20px 0;
  border-bottom: 1px solid #f3f6f9;
}
aside.product-order-list .btn-block .btn {
  font-size: 14px;
  font-weight: 700;
  padding: 13px 10px;
}
aside.product-order-list .btn-row {
  padding: 0;
}
aside.product-order-list .btn-row .btn {
  margin-right: 5px;
  border-radius: 4px;
  font-size: 14px;
}
aside.product-order-list .btn-row .btn.btn-info {
  background-color: #7367F0;
  border-color: #7367F0;
}
aside.product-order-list .btn-row .btn.btn-danger {
  background-color: #FF0000;
  border-color: #FF0000;
}
aside.product-order-list .btn-row .btn.btn-success {
  background-color: #28C76F;
  border-color: #28C76F;
}
aside.product-order-list .btn-row .btn:hover {
  background-color: #092C4C;
  border-color: #092C4C;
}

#payment-completed .modal-body {
  padding: 40px;
}
#payment-completed .modal-body .icon-head {
  margin-bottom: 10px;
}
#payment-completed .modal-body .icon-head svg {
  color: #28C76F;
}
#payment-completed .modal-body h4 {
  font-size: 20px;
  font-weight: 700;
}
#payment-completed .modal-body .modal-footer .btn:hover {
  color: #ffffff;
}

#print-receipt {
  color: #5B6670;
}
#print-receipt .modal-dialog {
  width: 424px;
}
#print-receipt .modal-body {
  padding: 30px;
  color: #5B6670;
}
#print-receipt .modal-body h6 {
  font-size: 16px;
}
#print-receipt .modal-body .info h6 {
  margin: 10px 0;
  font-weight: normal;
}
#print-receipt .modal-body .info a {
  color: #5B6670;
}
#print-receipt .modal-body .tax-invoice h6 {
  margin: 10px 0;
  font-weight: 600;
  position: relative;
}
#print-receipt .modal-body .tax-invoice h6:after, #print-receipt .modal-body .tax-invoice h6:before {
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  content: "";
  border-top: 1px dashed #5B6670;
  width: 35%;
}
#print-receipt .modal-body .tax-invoice h6:before {
  position: absolute;
  top: 50%;
  left: 0;
}
#print-receipt .modal-body .tax-invoice h6:after {
  position: absolute;
  top: 50%;
  right: 0;
}
#print-receipt .modal-body .tax-invoice .invoice-user-name {
  margin-bottom: 10px;
}
#print-receipt .modal-body .tax-invoice span {
  color: #092C4C;
}
#print-receipt .modal-body table thead th {
  color: #092C4C;
  width: auto;
  min-width: auto;
  padding: 5px;
  border-top: 1px dashed #5B6670;
  border-bottom: 1px dashed #5B6670;
}
#print-receipt .modal-body table tbody tr td {
  padding: 5px;
}
#print-receipt .modal-body table tbody tr table {
  border-top: 1px dashed #5B6670;
}
#print-receipt .modal-body table tbody tr table tr:last-child td {
  font-weight: 500;
  font-size: 15px;
  color: #092C4C;
}
#print-receipt .modal-body .invoice-bar {
  border-top: 1px dashed #5B6670;
  padding: 20px 0 0 0;
}
#print-receipt .modal-body .btn {
  width: 200px;
}

.pos-modal .modal-header {
  background-color: #FAFBFE;
}
.pos-modal .modal-header h5 {
  font-size: 18px;
  font-weight: 700;
}
.pos-modal#hold-order h2 {
  font-size: 36px;
  font-weight: 700;
  color: #212529;
  margin-bottom: 10px;
  background-color: #FAFBFE;
  border-radius: 10px;
}
.pos-modal#hold-order .input-block label {
  margin-bottom: 5px;
}
.pos-modal#hold-order p {
  margin-top: 20px;
}
.pos-modal#recents .table tbody tr td {
  padding: 10px 15px;
}
.pos-modal .badge {
  padding: 5px 10px;
  font-size: 15px;
  font-weight: normal;
}
.pos-modal#orders .modal-dialog {
  max-width: 575px;
}
.pos-modal#orders .order-body {
  height: 50vh;
  overflow: auto;
}
.pos-modal#orders .order-body .default-cover {
  border: 1px solid #f3f6f9;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  border-radius: 8px;
}
.pos-modal#orders .order-body .record {
  font-size: 15px;
}
.pos-modal#orders .order-body .record td {
  padding-bottom: 15px;
}
.pos-modal#orders .order-body .record tr:last-child td {
  padding-bottom: 0;
}
.pos-modal#orders .order-body .record .colon {
  padding: 0 10px;
  color: #092C4C;
}
.pos-modal#orders .order-body .record .text {
  color: #5B6670;
  white-space: nowrap;
}
.pos-modal#orders .order-body p {
  font-size: 15px;
  background-color: #FAFBFE;
  border-radius: 8px;
}
.pos-modal#orders .order-body .search-set .search-input {
  width: 100%;
}
.pos-modal#orders .order-body .search-set .search-input label {
  width: 100%;
}
.pos-modal#orders .order-body .search-set .search-input label input {
  width: 100%;
}
.pos-modal.upload-modal .modal-body .drag-drop {
  position: relative;
  padding: 20px;
  border: 1px dashed #B8BCC9;
}
.pos-modal.upload-modal .modal-body .drag-drop input[type=file] {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.pos-modal.upload-modal .modal-body span {
  font-size: 13px;
  font-weight: 500;
  color: #5B6670;
}
.pos-modal.upload-modal .modal-body p {
  font-size: 16px;
  font-weight: 600;
  color: #092C4C;
  margin-bottom: 0;
}
.pos-modal.upload-modal .modal-body .progress {
  height: 6px;
  border-radius: 5px;
}
.pos-modal.upload-modal .modal-body ul li {
  margin: 0 0 15px 0;
  padding: 15px;
  border-radius: 8px;
  border: 1px solid #f3f6f9;
}
.pos-modal.upload-modal .modal-body ul li h6 a {
  font-size: 16px;
  font-weight: 600;
  color: #092C4C;
}
.pos-modal.upload-modal .modal-body ul li h6 a svg {
  color: #28C76F;
}
.pos-modal.upload-modal .modal-body ul li h6:hover a {
  color: #FF9F43;
}
.pos-modal.upload-modal .modal-body ul li:last-child {
  margin-bottom: 0;
}
.pos-modal#upload-message .modal-dialog {
  position: fixed;
  bottom: 0px;
  right: 24px;
  margin: 0px;
  left: auto;
  top: calc(100% - 300px);
  width: 600px;
}
.pos-modal#upload-message .progress {
  height: 6px;
  border-radius: 5px;
}

label span {
  color: #FF0000;
}

.wordset ul li a {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  border: 1px solid #f3f6f9;
  color: #092C4C;
  display: flex;
  align-items: center;
  justify-content: center;
}

.w-85 {
  width: 85%;
}

.search-order .search-input {
  width: 100%;
}
.search-order .dataTables_filter label {
  width: 100%;
}

.search-set.search-order .search-input input[type=search] {
  width: 100%;
}

.tabs-sets .wordset li {
  margin-right: 8px;
  margin-left: 0;
}
.tabs-sets .wordset li:last-child {
  margin-right: 0;
}

.page-wrapper .page-header .back-btn {
  display: flex;
  gap: 10px;
}
.page-wrapper .page-header .back-btn .page-display a {
  padding: 7px;
  background-color: #092C4C;
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
}

.card .card-body.add-product .addproduct-icon {
  margin: 0 0 20px 0px;
  padding: 0 0 20px 0;
  border-bottom: 1px solid rgba(145, 158, 171, 0.3);
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
}
.card .card-body.add-product .addproduct-icon h5 {
  font-size: 16px;
  font-weight: 600;
}
.card .card-body.add-product .addproduct-icon h5 .add-info {
  color: #FF9F43;
  margin-right: 7px;
}
.card .card-body.add-product .text-editor.add-list {
  padding-top: 10px;
  width: 100%;
}
.card .card-body.add-product .text-editor.add-list h5 {
  padding-left: 0;
}
.card .card-body.add-product .text-editor.add-list.add {
  padding-top: 10px;
}
.card .card-body.add-product .text-editor.add-list.add .addproduct-icon {
  padding-left: 0;
}
.card .card-body.add-product .text-editor.add-list.add .image-upload {
  margin-bottom: 0;
  width: 137px;
  height: 123px;
  border: 1px dashed rgba(145, 158, 171, 0.32);
}
.card .card-body.add-product .text-editor.add-list.add .image-upload .image-uploads {
  padding: 43px 0;
}
.card .card-body.add-product .text-editor.add-list.add .custom-filed {
  display: flex;
  padding: 10px;
  background-color: #FAFBFE;
  margin-bottom: 20px;
}
.card .card-body.add-product .text-editor.add-list.add .custom-filed .input-block.add-lists {
  display: flex;
  gap: 20px;
  align-items: center;
}
@media (max-width: 767px) {
  .card .card-body.add-product .text-editor.add-list.add .custom-filed .input-block.add-lists {
    flex-wrap: wrap;
  }
}
.card .card-body.add-product .text-editor.add-list.add .custom-filed .input-block.add-lists .checkboxs {
  margin-bottom: 0;
  padding-left: 23px;
}
.card .card-body.add-product .text-editor.add-list.add .custom-filed .input-block.add-lists .checkboxs .checkmarks {
  top: 3px;
}

.input-blocks.add-product input[type=text] {
  padding: 6px 15px;
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 5px;
}

.input-block.add-product.list {
  position: relative;
}

.btn-primaryadd {
  position: absolute;
  top: 32px;
  right: 4px;
  padding: 5px 10px;
  background-color: #FF9F43;
  font-size: 14px;
  color: #ffffff;
}
.btn-primaryadd:hover {
  border: 1px solid #FF9F43;
  color: #FF9F43;
}

.input-block input.form-control.list {
  color: #878A99;
}

.edit-add h6 {
  font-size: 16px;
}

.edit-add {
  font-size: 15px;
}
.edit-add.card {
  border: none;
  margin: 0;
}
.edit-add.card .note-editor.note-frame {
  margin: 0px;
}
.edit-add.card .note-editor.note-frame .note-editing-area .note-editable {
  height: 130px !important;
}
.edit-add.card p {
  margin-top: 10px;
}

.input-blocks.add-products .form-check-input:checked {
  background-color: #FF9F43;
  border-color: #FF9F43;
}

.input-blocks.add-product.date input[type=text] {
  padding: 6px 6px 6px 39px;
}

.input-blocks.add-product.date .input-groupicon .addonset {
  left: 12px;
  top: 48%;
}

.btn-addproduct {
  float: right;
}

.addproduct-icon a {
  color: #092C4C;
  border: 1px solid;
  padding: 1px;
  border-radius: 25px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  width: 20px;
  height: 20px;
}
.addproduct-icon a svg {
  height: 17px;
}

.card .card-body.add-product .addproduct-icon.list {
  padding-left: 0;
}

.add-newplus {
  display: flex;
  justify-content: space-between;
}

.plus-down-add {
  margin-right: 5px;
  width: 14px;
  height: 14px;
  position: relative;
  top: -2px;
}

.add-newplus span {
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
}

.add-choosen {
  display: flex;
}
@media (max-width: 767px) {
  .add-choosen {
    flex-wrap: wrap;
  }
}
.add-choosen .phone-img {
  position: relative;
  width: 137px;
  height: 123px;
  border-radius: 10px;
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  text-align: center;
  margin-left: 20px;
}
@media (max-width: 767px) {
  .add-choosen .phone-img {
    margin-bottom: 10px;
    margin-left: 0;
  }
}
.add-choosen .phone-img img {
  padding: 10px;
}
.add-choosen .phone-img a {
  position: absolute;
  right: 3px;
  top: 3px;
  background: #FF0000;
  border-radius: 3px;
  width: 16px;
  height: 16px;
  color: #ffffff;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.add-choosen .phone-img a:hover {
  color: #ffffff;
  background: #e61414;
}

.custom_radio, .custom_radio_one {
  color: #5B6670;
  position: relative;
  font-size: 15px;
  padding-left: 25px;
  margin-bottom: 10px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  font-weight: 400;
}

.custom_radio input, .custom_radio_one input {
  position: absolute;
  opacity: 0;
  padding: 0;
}

.custom_radio .checkmark, .custom_radio_one .checkmark {
  position: absolute;
  top: 2px;
  left: 0;
  height: 15px;
  width: 15px;
  background-color: transparent;
  border: 1px solid rgba(145, 158, 171, 0.3);
  border-radius: 50%;
  transition: all 0.3s ease-in-out;
}

.custom_radio .checkmark:after, .custom_radio_one .checkmark:after {
  display: block;
  content: "";
  position: absolute;
  top: 4px;
  left: 4px;
  opacity: 0;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #FF9F43;
  visibility: visible;
  transform: scale(0.1);
  -webkit-transform: scale(0.1);
  -ms-transform: scale(0.1);
  transition: all 0.3s ease-in-out;
}

.custom_radio.active input ~ .checkmark:after,
.custom_radio_one.active input ~ .checkmark:after {
  transform: scale(1);
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  opacity: 1;
  visibility: visible;
}

.custom_radio.active input ~ .checkmark {
  border: 1px solid #FF9F43;
}

.single-pill-product .nav-link {
  padding: 0;
}
.single-pill-product .nav-pills.list .nav-item button::before {
  top: 2px;
  left: 0px;
}
.single-pill-product .nav-pills.list .nav-item button.active::after {
  top: 6px !important;
  left: 4px !important;
}
.single-pill-product .form-check-label {
  cursor: pointer;
}

.nav-pills.list .nav-link.active {
  background-color: transparent;
  color: #5B6670;
}

.nav-pills.list .nav-link {
  background-color: transparent;
  color: #5B6670;
}

.add-icon.tab a {
  background-color: #092C4C;
  color: #ffffff;
}

.nav-pills.list .nav-item button {
  position: relative;
}

.nav-pills.list .nav-item button::before {
  content: "";
  width: 15px;
  height: 15px;
  border: 1px solid #E0E0E0;
  border-radius: 50%;
  position: absolute;
  top: 11px;
  left: 12px;
}

.nav-pills.list .nav-item button.active::after {
  content: "";
  width: 7px;
  height: 7px;
  background: #FF9F43;
  border-radius: 50%;
  position: absolute;
  top: 15px;
  left: 16px;
}

.nav-pills.list .nav-item button.active::before {
  border-color: #FF9F43;
}

.add-icon.tab-icon .feather-trashs {
  background-color: #ffffff;
  color: #FF0000;
}

.add-icon.tab-icon a {
  background-color: #ffffff;
  font-size: 11px;
  width: 34px;
  padding: 0;
}

.input-blocks.filter-add {
  margin-right: 0px;
  margin-bottom: 0px;
}
.input-blocks.filter-add .input-blocks.add-product {
  margin-bottom: 20px;
  margin-right: 7px;
}

.addproduct-icon.list.icon h5 img {
  position: relative;
  top: 5px;
  padding-right: 5px;
}

#filter_inputs .table-responsive.product-list input {
  padding-left: 10px;
}

table tbody td.action-table-data a .add-checkbox {
  border: none;
  padding: 0;
}

.feather-pluses {
  color: #092C4C;
  width: 14px;
  height: 14px;
}

.checkboxs.add-listcheck {
  padding-left: 24px;
}

.searchinputs.list input {
  width: 357px;
  position: relative;
  padding: 10px 31px 10px 10px;
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  background: #ffffff;
}

.feather-16.icon {
  position: absolute;
  top: 10px;
  right: 10px;
}

.modal-footer-btn.popup {
  margin-top: 0;
}

.search-dropdown.idea {
  height: auto;
}

.badges-warning {
  color: #FF9900;
  padding: 2px 10px;
  border-radius: 8px;
  border: 1px solid #FF9900;
  font-size: 14px;
  font-weight: 600;
  min-width: 80px;
}

.badge.badge-linedangered {
  color: #FF0000;
  padding: 2px 10px;
  border-radius: 8px;
  border: 1px solid #FF0000;
  font-size: 14px;
  font-weight: 600;
  min-width: 80px;
}

.input-blocks .info-imgs {
  position: absolute;
  top: 14px;
  z-index: 100;
  width: 16px;
  height: 16px;
  left: 5px;
  margin-left: 5px;
  color: #5B6670;
}

.add-product .add-icon a {
  background-color: #092C4C;
  color: #ffffff;
}
@media (max-width: 767px) {
  .add-product .add-icon a {
    z-index: 1;
  }
}
.add-product .add-icon a:hover {
  background-color: #FF9F43;
}

.new-employee-field.product .card-title-head h6 {
  font-weight: 600;
  font-size: 16px;
  align-items: center;
  margin: 0;
  padding: 0;
  border-bottom: none;
}

.new-employee-field.product .card-title-head {
  margin: 0 0 20px;
  padding: 0 0 20px;
  border-bottom: 1px solid rgba(145, 158, 171, 0.3);
  display: flex;
  justify-content: space-between;
}

.new-employee-field.product .card-title-head a {
  color: #878A99;
  border: 1px solid;
  padding: 3px;
  border-radius: 25px;
}

.accordion-card-one .accordion-item {
  border: 0;
}
.accordion-card-one .accordion-item .accordion-button {
  padding: 0;
  box-shadow: none;
}
.accordion-card-one .accordion-item .accordion-button .addproduct-icon h5 {
  display: flex;
  align-items: center;
}
.accordion-card-one .accordion-item .accordion-button .addproduct-icon h5 svg {
  width: 16px;
  height: 16px;
  top: unset;
}
.accordion-card-one .accordion-item .accordion-button::after {
  display: none;
}
.accordion-card-one .accordion-item .accordion-button:not(.collapsed) {
  background-color: #ffffff;
}
.accordion-card-one .accordion-item .accordion-button:not(.collapsed) .accordion-item {
  margin-bottom: 40px;
}
.accordion-card-one .accordion-item .accordion-button.collapsed .addproduct-icon a svg {
  transform: rotate(180deg);
}
.accordion-card-one .accordion-item .accordion-body {
  padding: 0;
}

.selected-hide-color {
  display: none;
}

.selected-color-add .selected-hide-color {
  display: flex;
  align-items: center;
}

.variant-table {
  display: none;
}

.variant-select {
  height: 40px;
}

.variant-table {
  padding: 0;
  background: transparent;
}
.variant-table div.dataTables_wrapper div.dataTables_paginate {
  display: none;
}
.variant-table .dataTables_filter,
.variant-table .dataTables_length {
  display: none;
}

.notes-page-wrapper .content {
  padding: 24px;
}
.notes-page-wrapper .content .page-add-notes {
  border-bottom: 1px solid #dbe0e6;
  padding-bottom: 25px;
  position: relative;
  margin-bottom: 0;
}
@media (max-width: 767px) {
  .notes-page-wrapper .content .page-add-notes {
    flex-direction: column;
    align-items: start;
  }
}
.notes-page-wrapper .content .page-add-notes .notes-tog {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  position: absolute;
  bottom: -12px;
  border-radius: 30px;
  background: #1B2850;
  color: #ffffff;
  width: 24px;
  height: 24px;
  padding: 5px;
}
@media (max-width: 991.98px) {
  .notes-page-wrapper .content .page-add-notes .notes-tog {
    display: none;
  }
}
.notes-page-wrapper .content .section-bulk-wrap {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin: 30px 0 24px 0;
  padding: 20px;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
}
@media (max-width: 767px) {
  .notes-page-wrapper .content .section-bulk-wrap {
    flex-direction: column;
    align-items: start;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
@media (max-width: 767px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
    margin-bottom: 20px;
  }
}
@media (max-width: 575px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type {
    margin-bottom: 0;
    flex-direction: column;
    align-items: self-start;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk {
  margin-right: 8px;
  height: 40px;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk .select2-container .selection .select2-selection .select2-selection__rendered {
  padding-left: 10px !important;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added {
  background: #092C4C;
  padding: 8px 20px;
  color: #ffffff;
  font-size: 15px;
  font-weight: 400;
  margin-right: 15px;
  height: 38px;
}
.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added:hover {
  background: #FF9F43;
}
@media (max-width: 575px) {
  .notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .btn-added {
    margin: 20px 0;
  }
}
.notes-page-wrapper .content .section-bulk-wrap .form-sort .fa-filter {
  z-index: 100 !important;
  position: absolute;
  top: 15px;
  left: 15px;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-notes-slider {
  position: relative;
  padding-bottom: 40px;
  border-bottom: 1px solid #dbe0e6;
}
.notes-page-wrapper .content .section-notes-slider .notes-content {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
}
.notes-page-wrapper .content .section-notes-slider .notes-content .notes-close a {
  color: #FF0000;
  font-size: 15px;
  font-weight: 400;
}
.notes-page-wrapper .content .section-notes-slider .notes-content .notes-close a i {
  margin-right: 6px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card {
  padding: 24px;
  border-radius: 8px;
  background: rgba(255, 159, 67, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card.medium {
  background: rgba(116, 41, 248, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card.high {
  background: rgba(234, 84, 85, 0.03);
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged {
  border-radius: 8px;
  border: 1px solid #FF9900;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FF9900;
  font-size: 14px;
  font-weight: 600;
  display: flex;
  align-items: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged i {
  font-size: 7px;
  margin-right: 4px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged.medium {
  color: #7429F8;
  border: 1px solid #7429F8;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body p.badged.high {
  color: #FF0000;
  border: 1px solid #FF0000;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #092C4C;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-card-body a.dropdown-item:hover {
  color: #ffffff;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content {
  margin: 24px 0;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content h4 a {
  margin-bottom: 10px;
  color: #092C4C;
  font-size: 16px;
  font-weight: 600;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content h4 a:hover {
  color: #FF9900;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-content p {
  color: #5B6670;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a {
  margin-right: 15px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a span {
  width: 32px;
  height: 32px;
  display: flex;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo a span img {
  border-radius: 100px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.medium-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.medium-square i {
  color: #28C76F;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.high-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.high-square i {
  color: #FF9900;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.low-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo span.low-square i {
  color: #288EC7;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #288EC7;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p i.fa-draw-polygon {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p.medium {
  color: #28C76F;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-logo p.high {
  color: #FF9900;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete span .fa-star {
  color: #FF9900;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.notes-page-wrapper .content .section-notes-slider .notes-card .notes-slider-widget .notes-star-delete span .feather-trash-2 {
  color: #FF0000;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-card-body {
  padding-top: 40px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details {
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #ffffff;
  box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);
  padding: 24px;
  margin-bottom: 24px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  border-radius: 8px;
  border: 1px solid #FF9900;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FF9900;
  font-size: 14px;
  font-weight: 600;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged i {
  font-size: 7px;
  margin-right: 4px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged.medium {
  color: #7429F8;
  border: 1px solid #7429F8;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body p.badged.high {
  color: #FF0000;
  border: 1px solid #FF0000;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #092C4C;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item span svg {
  width: 14px;
  height: 14px;
  color: #5B6670;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-card-body .dropdown-item:hover span svg {
  color: #ffffff;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content {
  padding: 20px 0;
  border-bottom: 1px solid #dbe0e6;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content h4 a {
  color: #092C4C;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 5px;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content h4 a:hover {
  color: #FF9900;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content .wrap-cal {
  color: #5B6670;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content .wrap-cal svg {
  margin-right: 5px;
  width: 16px;
  height: 16px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-wrap-content p {
  color: #5B6670;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget.notes-widget-profile {
  padding-top: 20px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo a {
  margin-right: 15px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo a span img {
  border-radius: 100px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.medium-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.medium-square i {
  color: #28C76F;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.high-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.high-square i {
  color: #FF9900;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.low-square {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo span.low-square i {
  color: #288EC7;
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p {
  color: #288EC7;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p i.fa-draw-polygon {
  margin-right: 5px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p.medium {
  color: #28C76F;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-logo p.high {
  color: #FF9900;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete span .feather-star {
  color: #5B6670;
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.notes-page-wrapper .content .section-card-body .notes-card-details .notes-slider-widget .notes-star-delete span .feather-trash-2 {
  color: #FF0000;
  width: 16px;
  height: 16px;
}

.notes-card-details .notes-card-body a {
  color: #092C4C;
}

.star-todo-inbox svg {
  width: 13px;
  height: 13px;
  color: #5B6670;
}

.inbox-call-profile {
  border-radius: 5px;
  background: #E92990;
  border: 1px solid #E92990;
  padding: 4px 10px;
  font-size: 14px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 20px;
}
.inbox-call-profile:hover {
  color: #E92990;
  background: #ffffff;
}

.notes-tog i {
  transform: rotate(180deg);
}
.notes-tog.active i {
  transform: rotate(0deg);
}

.section-bulk-wrap .form-sort {
  position: relative;
}
.section-bulk-wrap .form-sort svg.feather-filter {
  position: absolute;
  z-index: 101;
  width: 16px;
  height: 16px;
  top: 12px;
  left: 10px;
}

.page-add-notes.active svg {
  transform: rotate(0) !important;
}

.dropdown-menu.notes-menu {
  z-index: 99999;
}
.dropdown-menu.notes-menu a.dropdown-item {
  color: #092C4C;
  font-size: 15px;
  font-weight: 400;
  display: flex;
  align-items: center;
  padding: 10px 20px;
}
.dropdown-menu.notes-menu a.dropdown-item:hover {
  background: #FF9900;
  color: #ffffff;
}
.dropdown-menu.notes-menu a.dropdown-item:hover svg {
  color: #ffffff;
}
.dropdown-menu.notes-menu span {
  margin-right: 8px;
}
.dropdown-menu.notes-menu svg {
  width: 14px;
  height: 14px;
  color: #5B6670;
}

.edit-note-head a {
  border-radius: 30px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #ffffff;
  color: #092C4C;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
}
.edit-note-head a:hover {
  border-radius: 20px;
  background: #FF9F43;
  color: #ffffff;
}

.custom-modal-body .select2-container .selection .select2-selection .select2-selection__rendered {
  padding-left: 10px !important;
}

.bulk-con-wrap {
  width: 100%;
}

.section-bulk-widget {
  transition: 0.6s all;
}

.section-notes-dashboard {
  display: none;
  transition: 0.6s all;
}

.notes-tog i {
  transition: 0.5s all;
}

.notes-tag-left .notes-tog i {
  transform: rotate(360deg);
  transition: 0.5s all;
}

.budgeted-role-notes {
  width: 100%;
}

.notes-summernote .card {
  margin-bottom: 0 !important;
}

.dropdown-item:active {
  background: transparent;
}

.notes-summernote p {
  color: #5B6670;
  font-size: 15px;
  font-weight: 400;
}

.notes-dash {
  margin-top: 30px;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid rgba(145, 158, 171, 0.3);
  background: #ffffff;
  transition: 0.6s all;
}
.notes-dash .notes-top-head {
  border-bottom: 1px solid #dbe0e6;
}
.notes-dash .notes-top-head h5 {
  font-size: 18px;
  font-weight: 700;
  color: #092C4C;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}
.notes-dash .notes-top-head h5 svg {
  width: 19px;
  height: 19px;
  margin-right: 6px;
  color: #5B6670;
}
.notes-dash .notes-top-head-submenu {
  padding: 15px 0;
  border-bottom: 1px solid #dbe0e6;
}
.notes-dash .notes-top-head-submenu ul {
  padding: 15px 0;
}
.notes-dash .notes-top-head-submenu ul li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  padding: 10px;
}
.notes-dash .notes-top-head-submenu ul li.active {
  border-radius: 10px;
  background: #092C4C;
}
.notes-dash .notes-top-head-submenu ul li.active svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-dash .notes-top-head-submenu ul li.active p {
  color: #ffffff;
}
.notes-dash .notes-top-head-submenu ul li p {
  font-size: 15px;
  font-weight: 600;
  color: #5B6670;
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.notes-dash .notes-top-head-submenu ul li p svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-dash .notes-top-head-submenu ul li span {
  display: flex;
  width: 18px;
  height: 18px;
  padding: 0px 3px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #FF9F43;
  color: #ffffff;
}
.notes-dash .content-submenu-tag {
  margin-top: 15px;
  padding: 10px;
}
.notes-dash .content-submenu-tag h6 {
  font-size: 16px;
  font-weight: 600;
  color: #092C4C;
}
.notes-dash .content-submenu-tag ul {
  padding: 10px 0;
}
.notes-dash .content-submenu-tag ul.tags-list {
  margin-bottom: 24px;
}
.notes-dash .content-submenu-tag ul li {
  font-size: 15px;
  font-weight: 400;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.personal span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.personal span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.personal a {
  color: #288EC7;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.social span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.social span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.social a {
  color: #FF9900;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.work span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.work span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.work a {
  color: #28C76F;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.public span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.public span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.public a {
  color: #A02F7A;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.medium span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.medium span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.medium a {
  color: #7367F0;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.high span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.high span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.high a {
  color: #FF0000;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li.low span {
  margin-right: 8px;
}
.notes-dash .content-submenu-tag ul li.low span i {
  transform: rotate(45deg);
  font-size: 10px;
}
.notes-dash .content-submenu-tag ul li.low a {
  color: #FF9900;
  display: flex;
  align-items: center;
}
.notes-dash .content-submenu-tag ul li + li {
  margin-top: 10px;
}

.notes-logo a {
  display: flex;
  align-items: center;
}
.notes-logo a span {
  width: 32px;
  height: 32px;
}
.notes-logo a span img {
  border-radius: 32px;
}

.notes-top-head-submenu {
  padding: 15px 0;
  border-bottom: 1px solid #dbe0e6;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px;
  font-size: 15px;
  font-weight: 600;
  color: #5B6670;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  border-radius: 10px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox.active {
  border-radius: 10px;
  background: #212B36;
  padding: 10px;
  color: #ffffff;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox.active svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox:hover {
  background: #212B36;
  color: #ffffff;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.notes-top-head-submenu .nav.todo-inbox button.todo-inbox span {
  display: flex;
  width: 20px;
  height: 20px;
  padding: 0px 3px;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  background: #FF9F43;
  color: #ffffff;
}

.notes-trash-btn {
  background: #FF0000;
  color: #ffffff;
  border-radius: 8px;
  margin: 4px 0 20px 0;
  padding: 10px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notes-trash-btn span {
  display: flex;
  align-items: center;
}
.notes-trash-btn span svg {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}

.delete-popup {
  padding: 24px;
  border-radius: 8px;
  background: #ffffff;
}
.delete-popup .delete-image {
  margin-bottom: 20px;
}
.delete-popup .delete-heads {
  text-align: center;
}
.delete-popup .delete-heads h4 {
  color: #092C4C;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 5px;
}
.delete-popup .delete-heads p {
  color: #5B6670;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 0px;
}
.delete-popup .delete-footer {
  text-align: center;
}

.edit-page-title {
  display: flex;
  align-items: center;
}
.edit-page-title h4 {
  font-size: 18px;
  font-weight: 700;
  color: #092C4C;
  margin-bottom: 0;
  margin-right: 10px;
}
.edit-page-title p {
  font-size: 15px;
  font-weight: 400;
  color: #288EC7;
}

.edit-head-view {
  margin-bottom: 20px;
  border-bottom: rgba(145, 158, 171, 0.3);
}
.edit-head-view h6 {
  font-size: 16px;
  font-weight: 600;
  color: #092C4C;
  margin-bottom: 15px;
}
.edit-head-view p {
  font-size: 15px;
  font-weight: 400;
  color: #5B6670;
  margin-bottom: 15px;
}
.edit-head-view p.badged {
  border-radius: 8px;
  border: 1px solid #FF9900;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FF9900;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}
.edit-head-view p.badged i {
  font-size: 7px;
  margin-right: 7px;
}

.edit-footer-menu a {
  background-color: #FF0000;
}

.edit-noted-head a span i.fa-trash-alt {
  color: #FF0000;
  margin-right: 10px;
}
.edit-noted-head a span i.fa-star {
  color: #FF9900;
}

.edit-head-view p.badged.high {
  border-radius: 8px;
  border: 1px solid #FF0000;
  padding: 4px 10px;
  margin-bottom: 0;
  color: #FF0000;
  font-size: 14px;
  font-weight: 600;
  display: inline-flex;
  align-items: center;
}
.edit-head-view p.badged.high i {
  font-size: 7px;
  margin-right: 7px;
}

.people-profile-pic {
  border: none !important;
  margin-left: 14px;
  position: relative;
}
.people-profile-pic img {
  border-radius: 10px;
}
.people-profile-pic a {
  position: absolute;
  top: 15px;
  right: 7px;
}
.people-profile-pic a .x-square-add {
  border-radius: 3px;
  background: #FF0000;
  color: #ffffff;
}

.people-customer-walk {
  max-width: 35px;
}

.custom-pagination .paginations {
  align-items: center;
}
.custom-pagination .paginations span {
  display: flex;
  align-items: center;
  color: #5B6670;
  width: 16px;
  height: 16px;
}
.custom-pagination .paginations span .fa-chevron-left {
  margin-right: 8px;
}
.custom-pagination .paginations .page-wrap li a {
  margin-right: 8px;
  border-radius: 85px;
  background: #dbe0e6;
  color: #5B6670;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  width: 30px;
  height: 30px;
  padding: 5px;
  justify-content: center;
  align-items: center;
}
.custom-pagination .paginations .page-wrap li a.active {
  background: #FF9F43;
  color: #ffffff;
}
.custom-pagination .paginations .page-wrap li :hover {
  background: #FF9F43;
  color: #ffffff;
  transition: 0.3s all;
}

.section-notes-slider .notes-slider.owl-carousel .owl-nav {
  top: -44px;
  right: unset;
  left: 150px;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button {
  background-color: transparent;
  width: 15px;
  height: auto;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button i {
  color: #092C4C;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button:hover {
  background-color: transparent;
}
.section-notes-slider .notes-slider.owl-carousel .owl-nav button:hover i {
  color: #FF9F43;
}

.employee-grid-profile {
  text-align: center;
  background: #ffffff;
  border-radius: 8px;
  margin: 0 0 24px;
  padding: 15px;
  box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);
  border: 1px solid #dbe0e6;
}
.employee-grid-profile .profile-head {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 24px;
}
.employee-grid-profile .profile-head .profile-head-action {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.employee-grid-profile .profile-head .profile-head-action .badge badge-linedanger {
  background: #ffffff;
  border: 1px solid #FF0000;
  padding: 2px 10px;
}
.employee-grid-profile .profile-head .dep-name h5 {
  font-size: 18px;
  font-weight: 700;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.employee-grid-profile .profile-head .dep-name h5::before {
  content: "";
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin-right: 5px;
}
.employee-grid-profile .profile-head .dep-name h5.active::before {
  background: #28C76F;
}
.employee-grid-profile .profile-head .dep-name h5.inactive::before {
  background: #FF0000;
}
.employee-grid-profile .profile-info {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  flex-direction: column;
  margin-bottom: 15px;
}
.employee-grid-profile .profile-info .profile-pic {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  margin-bottom: 15px;
  position: relative;
}
.employee-grid-profile .profile-info .profile-pic img {
  border-radius: 8px;
}
.employee-grid-profile .profile-info .profile-pic.active-profile::after {
  content: "";
  background: #28C76F;
  border-radius: 50%;
  position: absolute;
  right: -3px;
  bottom: -3px;
  padding: 3px;
  border: 3px solid #ffffff;
}
.employee-grid-profile .profile-info.department-profile-info {
  background-color: #f3f6f9;
  padding: 15px;
  border-radius: 10px;
}
.employee-grid-profile .profile-info.department-profile-info .profile-pic {
  width: 40px;
  height: 40px;
  margin-bottom: 8px;
}
.employee-grid-profile .profile-info.department-profile-info h4 {
  font-size: 15px;
}
.employee-grid-profile .profile-info h5 {
  color: #FF9F43;
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 10px;
}
.employee-grid-profile .profile-info h4 {
  font-size: 18px;
  font-weight: 700;
}
.employee-grid-profile .profile-info span {
  font-size: 15px;
}
.employee-grid-profile ul.department {
  display: flex;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  text-align: left;
  background-color: #f3f6f9;
  padding: 15px;
  border-radius: 8px;
}
.employee-grid-profile ul.department li {
  color: #092C4C;
  font-weight: 500;
  font-size: 15px;
}
.employee-grid-profile ul.department li span {
  display: block;
  color: #5B6670;
  margin-top: 5px;
}
.employee-grid-profile .dropdown-toggle::after {
  display: none;
}
.employee-grid-profile .dropdown.profile-action svg {
  color: #092C4C;
}
.employee-grid-profile .dropdown.profile-action .dropdown-menu {
  padding: 0;
  right: 0px !important;
  margin-top: 10px !important;
  left: unset !important;
  min-width: 130px;
}
.employee-grid-profile .dropdown.profile-action .dropdown-menu a.dropdown-item + a {
  margin-top: 0;
}
.employee-grid-profile .dropdown.profile-action ul li a svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.employee-grid-profile .dropdown.profile-action ul li a:hover svg {
  color: #ffffff;
}

.hide-head .header {
  display: none;
}
.hide-head .sidebar {
  top: 0;
}
.hide-head .page-wrapper {
  padding-top: 0;
}
.hide-head .full-height svg {
  transform: rotate(180deg);
}

.card-title-head h6 {
  font-weight: 600;
  font-size: 16px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin: 0 0 20px;
  padding: 0 0 20px;
  border-bottom: 1px solid rgba(145, 158, 171, 0.3);
}
.card-title-head h6 svg {
  width: 20px;
  margin-right: 5px;
  color: #FF9F43;
}

.new-employee-field .image-upload {
  width: 120px;
  height: 38px;
  border: 0;
  background-color: #FF9F43;
}
.new-employee-field .image-upload input[type=file] {
  height: 38px;
}
.new-employee-field .image-upload .image-uploads {
  top: 8px;
  padding: 0;
}
.new-employee-field .image-upload .image-uploads h4 {
  color: #ffffff;
  font-size: 15px;
  line-height: normal;
}

.profile-pic-upload {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  margin-bottom: 24px;
}
.profile-pic-upload .profile-pic {
  width: 120px;
  height: 120px;
  border: 1px dashed #5B6670;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border-radius: 10px;
  margin-right: 24px;
  position: relative;
  flex-shrink: 0;
}
.profile-pic-upload .profile-pic span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  flex-direction: column;
}
.profile-pic-upload .profile-pic span svg {
  margin-right: 0;
}
.profile-pic-upload .profile-pic .close-img {
  padding: 2px;
  position: absolute;
  top: 10px;
  right: 12px;
}
.profile-pic-upload .profile-pic .close-img .info-img {
  width: 12px;
  height: 12px;
  color: #ffffff;
  border-radius: 3px;
  background: #FF0000;
}
.profile-pic-upload.edit-pic .profile-pic {
  border: 0;
}
.profile-pic-upload.edit-pic .profile-pic img {
  border-radius: 10px;
}
.profile-pic-upload.edit-pic .profile-pic .user-editer {
  border-radius: 0;
}

.pass-info .input-blocks svg {
  position: absolute;
  right: 10px;
  top: 36px;
  width: 15px;
  left: unset;
}

.new-employee-field .other-info {
  margin: 15px 0;
}

.team-members {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
}
.team-members li ul {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.team-members li ul li {
  margin-left: -7px;
}
.team-members li ul li a {
  display: inline-block;
  width: 24px;
  height: 24px;
}
.team-members li ul li a img {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #ffffff;
}
.team-members li ul li:first-child {
  margin-left: 0;
}
.team-members li ul li:last-child a {
  position: relative;
}
.team-members li ul li:last-child a::after {
  content: "";
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.7) 0%, rgba(0, 0, 0, 0.7) 100%);
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  border-radius: 50%;
  border: 2px solid #ffffff;
}
.team-members li ul li:last-child a span {
  color: #ffffff;
  position: absolute;
  left: 5px;
  z-index: 1;
  top: 3px;
  font-size: 13px;
}

.dataTables_info {
  display: none;
}

div.dataTables_wrapper div.dataTables_length select {
  display: none;
}

.input-blocks .form-icon {
  position: relative;
}
.input-blocks .form-icon input {
  padding-left: 30px;
}
.input-blocks .form-icon .cus-icon {
  position: absolute;
  left: 10px;
  top: 9px;
}
.input-blocks .form-icon .cus-icon svg {
  width: 14px;
  color: #5B6670;
}
.input-blocks.custom-form-check {
  margin: 15px 0;
}

.modal .input-blocks {
  margin-bottom: 15px;
}

.checkboxs.modal-table-check {
  line-height: normal;
  margin-right: 13px;
  margin-bottom: 0;
  padding-left: 25px;
  display: inline-block;
}
.checkboxs.modal-table-check .checkmarks {
  top: 3px;
}
.checkboxs.modal-table-check input ~ .checkmarks {
  border-radius: 5px;
}
.checkboxs.modal-table-check input:checked ~ .checkmarks {
  border-color: #FF9F43;
}

.no-pagination .dataTables_length, .no-pagination .paging_numbers {
  display: none;
}

.modal-table-tab .nav-link {
  background-color: rgba(145, 158, 171, 0.3);
  color: #5B6670;
  padding: 10px 20px;
  margin-right: 10px;
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: 700;
}
.modal-table-tab .nav-link.active {
  background-color: #FF9F43;
  color: #ffffff;
}

.modal-table-item h4 {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 20px;
  color: #092C4C;
}

.break-title h4 {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px;
  color: #092C4C;
}

@media (max-width: 1199.98px) {
  .table-top-new .search-set .search-input input[type=search] {
    width: 140px;
  }
  .table-top-new .total-employees {
    margin-right: 10px;
  }
  .table-top-new .search-path .btn-filter, .table-top-new .search-path .btn-filter {
    margin-right: 10px;
  }
}
@media (max-width: 991.98px) {
  .table-top-new .search-set .search-input input[type=search] {
    width: 200px;
  }
}

.page-header .page-btn.import {
  margin-left: 15px;
}
@media (max-width: 575px) {
  .page-header .page-btn.import {
    margin-left: 0;
  }
}

.summer-description-box.transfer {
  margin-bottom: 0;
}
.summer-description-box.transfer p {
  color: #5B6670;
}

.summer-description-box.transfer .note-editor {
  margin-bottom: 10px;
}

.modal-body-table.total-orders {
  margin-bottom: 0;
}

.image-upload .image-uploads h4 span {
  color: #FF9F43;
}

.modal-dialog.payment {
  min-width: 1439px;
}

.input-blocks.image-upload-down {
  margin-bottom: 15px;
}

.badges.status-badge.ordered {
  background-color: #FF9900;
}

.input-blocks.leave-table {
  margin-bottom: 0;
  width: 98px;
}

.page-header .page-btn.attendance {
  margin-left: 0px;
}

@media (max-width: 767px) {
  .page-header.transfer {
    display: block;
  }
}
@media (max-width: 767px) {
  .page-header.transfer .table-top-head {
    justify-content: flex-start;
    margin-top: 24px;
    margin-bottom: 24px;
  }
}
@media (max-width: 767px) {
  .page-header.transfer .purchase-pg-btn .page-btn:first-child {
    margin-left: 0;
    margin-top: 0;
  }
}
@media (max-width: 575px) {
  .page-header.transfer .purchase-pg-btn {
    flex-direction: column;
    align-items: self-start;
  }
}

.attendance-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
}
@media (max-width: 575px) {
  .attendance-header {
    display: block;
  }
}
.attendance-header .attendance-content {
  display: flex;
  align-items: center;
}
.attendance-header .attendance-content h3 {
  font-size: 20px;
  flex-shrink: 0;
  margin-left: 10px;
}
.attendance-header .attendance-content h3 span {
  color: #5B6670;
}

@media (max-width: 575px) {
  .table-top-head.employe {
    justify-content: flex-start;
    margin-top: 24px;
  }
}

.attendance-widget .card .card-body h5 {
  display: flex;
  justify-content: space-between;
  font-size: 20px;
  align-items: center;
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(145, 158, 171, 0.3);
  margin-bottom: 24px;
}
.attendance-widget .card .card-body h5 span {
  font-size: 13px;
  color: #7367F0;
}
.attendance-widget .card .card-body .card.attendance {
  display: flex;
  padding: 30px 10px;
  align-items: center;
  background-color: #FAFBFE;
  flex-direction: row;
  margin-bottom: 24px;
}
.attendance-widget .card .card-body .card.attendance img {
  width: 48px;
  height: 48px;
  padding-right: 15px;
}

.modal-attendance-btn {
  display: flex;
  gap: 10px;
}

.warming-card {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.warming-card h4 {
  color: #FF9F43;
  font-size: 20px;
  border-radius: 8px;
  width: 64px;
  height: 64px;
  background: rgba(255, 159, 67, 0.09);
  padding: 20px;
  margin-bottom: 14px;
}
.warming-card h6 {
  font-size: 16px;
}

.danger-card {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.danger-card h4 {
  color: #FF0000;
  font-size: 20px;
  width: 64px;
  height: 64px;
  border-radius: 8px;
  background: rgba(255, 0, 0, 0.09);
  padding: 20px;
  margin-bottom: 14px;
}
.danger-card h6 {
  font-size: 16px;
}

.light-card {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.light-card h4 {
  color: #7367F0;
  font-size: 20px;
  width: 64px;
  height: 64px;
  border-radius: 8px;
  background: rgba(115, 103, 240, 0.09);
  padding: 20px;
  margin-bottom: 14px;
}
.light-card h6 {
  font-size: 16px;
}

.success-card {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.success-card h4 {
  color: #7367F0;
  font-size: 20px;
  width: 64px;
  height: 64px;
  border-radius: 8px;
  background: rgba(115, 103, 240, 0.09);
  padding: 20px;
  margin-bottom: 14px;
}
.success-card h6 {
  font-size: 16px;
}

.widget-attend {
  display: flex;
}
@media (max-width: 991.98px) {
  .widget-attend {
    flex-wrap: wrap;
    justify-content: center;
  }
}

.box-attend {
  padding: 10px;
  text-align: center;
  width: 100%;
}

.progress-bar-success {
  background-color: #28C76F;
}

.progress-bar-warning {
  background-color: #FF9900;
}

.progress-bar-danger {
  background-color: #FF0000;
}

.progress.attendance {
  width: 127px;
  height: 7px;
}

.badges-inactive.Holiday {
  color: #7367F0;
  border: 1px solid #7367F0;
}

.modal-deletecontent {
  padding: 24px;
}
.modal-deletecontent .feather-xcircircle {
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  color: #FF0000;
  margin: auto;
}
.modal-deletecontent h4 {
  padding: 20px 0 5px 0;
  text-align: center;
  color: #092C4C;
  font-size: 20px;
  font-weight: 700;
}
.modal-deletecontent p {
  text-align: center;
  color: #5B6670;
  font-size: 15px;
  font-weight: 400;
}
.modal-deletecontent .modal-footer-btn.delete {
  text-align: center;
}

.page-wrapper .content.settings-content {
  background-color: #ffffff;
  padding-bottom: 24px;
}

.settings-pg-header {
  padding-bottom: 24px;
  border-bottom: 1px solid rgba(145, 158, 171, 0.3);
}

.sidebars.settings-sidebar {
  position: relative;
  z-index: 1;
  top: unset;
  left: unset;
  bottom: unset;
  width: 309px;
  margin-right: 24px;
  border-right: 0;
  border: 1px solid rgba(145, 158, 171, 0.3);
  border-radius: 8px;
}
@media (max-width: 1399px) {
  .sidebars.settings-sidebar {
    width: 250px;
  }
}
@media (max-width: 1199.98px) {
  .sidebars.settings-sidebar {
    width: 200px;
    margin-right: 15px;
  }
}
@media (max-width: 991.98px) {
  .sidebars.settings-sidebar {
    display: none;
  }
}
.sidebars.settings-sidebar .slimScrollDiv {
  background-color: transparent;
  width: 309px !important;
}
@media (max-width: 1399px) {
  .sidebars.settings-sidebar .slimScrollDiv {
    width: 250px !important;
  }
}
@media (max-width: 1199.98px) {
  .sidebars.settings-sidebar .slimScrollDiv {
    width: 200px !important;
  }
}
.sidebars.settings-sidebar .theiaStickySidebar {
  width: 100% !important;
  margin-top: 10px;
}
.sidebars.settings-sidebar .sidebar-menu {
  padding: 10px 15px;
}
@media (max-width: 1199.98px) {
  .sidebars.settings-sidebar .sidebar-menu {
    padding: 10px 8px;
  }
}
.sidebars.settings-sidebar .sidebar-menu .menu-arrow {
  background-color: #ffffff;
  right: 5px;
}
.sidebars.settings-sidebar .sidebar-menu .menu-arrow::before {
  border-left: 1px solid #5B6670;
  border-bottom: 1px solid #5B6670;
  border-right: none;
  color: #5B6670;
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul {
  margin: 0;
  border-bottom: 0;
  padding: 0;
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a.active {
  background-color: #ffffff;
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a.active.subdrop {
  background-color: #ffffff;
  margin-bottom: 10px;
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a.active .menu-arrow {
  background-color: #ffffff;
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a.active .menu-arrow::before {
  border-color: #5B6670;
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a.subdrop .menu-arrow {
  background-color: #ffffff;
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  color: #092C4C;
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a svg {
  color: #092C4C;
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a span {
  color: #092C4C;
  font-weight: 600;
  font-size: 16px;
}
@media (max-width: 1199.98px) {
  .sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu a span {
    font-size: 14px;
  }
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu ul li a {
  margin-left: 0;
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu ul li a::after {
  display: none;
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu ul li a.active {
  background-color: rgba(254, 159, 67, 0.08);
  color: #FF9F43;
  border-radius: 8px;
  padding: 10px 18px;
}
.sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu ul li a.active::after {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #FF9F43;
  right: 10px;
  left: unset;
  border: 0;
  position: absolute;
  display: block;
}

.settings-page-wrap {
  flex: 1 1;
}
.settings-page-wrap .setting-title h4 {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(145, 158, 171, 0.3);
}
.settings-page-wrap .card-title-head h6 {
  border-bottom: 0;
  padding-bottom: 0;
}
.settings-page-wrap .new-employee-field span {
  color: #5B6670;
  font-size: 14px;
  display: block;
  margin-top: 5px;
}

.table-top-head .feather-rotate-ccw {
  height: 16px;
}

.security-settings .no-pagination .dataTables_filter {
  display: none;
}
.security-settings .no-pagination table {
  margin-top: 24px !important;
}
.security-settings .no-pagination table thead > tr > th.sorting:before {
  display: none;
}
.security-settings .no-pagination table thead > tr > th.sorting:after {
  display: none;
}
.security-settings ul li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
}
.security-settings ul li:last-child {
  margin-bottom: 0;
}
@media (max-width: 575px) {
  .security-settings ul li {
    display: block;
  }
}
.security-settings ul li .security-type {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
@media (max-width: 575px) {
  .security-settings ul li .security-type {
    margin-bottom: 20px;
  }
}
.security-settings ul li .security-type .security-icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background-color: #FAFBFE;
  border-radius: 10px;
  margin-right: 10px;
  flex-shrink: 0;
}
.security-settings ul li .security-type .security-icon svg {
  color: #FF9F43;
}
.security-settings ul li .security-title h5 {
  font-size: 14px;
  font-weight: 700;
}
.security-settings ul li .security-title p {
  color: #5B6670;
  font-size: 15px;
}
.security-settings ul li .security-btn .btn-danger {
  background-color: #FF0000;
}
.security-settings ul li .security-btn .btn-danger:hover {
  border-color: #092C4C;
  background-color: #092C4C;
}
.security-settings ul li .security-btn .badges-connected {
  background: rgba(40, 199, 111, 0.05);
  color: #28C76F;
  border: 1px solid #28C76F;
  padding: 3px 6px;
  border-radius: 6px;
}
.security-settings ul li .security-btn .fa-check-circle {
  color: #28C76F;
}
.security-settings ul li .security-btn .remove-red {
  color: #FF0000;
  font-weight: 700;
}
.security-settings ul li .security-btn .manage-btn {
  border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.3));
  padding: 8px 20px;
  color: #092C4C;
  border-radius: 5px;
}

.mini-sidebar .sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu .menu-arrow {
  display: block !important;
}
.mini-sidebar .sidebars.settings-sidebar .sidebar-menu .submenu-open ul .submenu .subdrop ~ ul {
  display: block !important;
}

.settings-bottom-btn {
  margin-top: 40px;
}

.connected-app-card.email-setting .security-title h5 {
  font-weight: 700;
  font-size: 18px;
}
.connected-app-card ul {
  background-color: #ffffff;
  padding: 24px;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  border-radius: 8px;
  margin-bottom: 24px;
}
.connected-app-card ul li {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: space-between;
  -webkit-justify-content: space-between;
  -ms-flex-pack: space-between;
  margin-bottom: 20px;
}
.connected-app-card ul li:last-child {
  margin-bottom: 0;
}
.connected-app-card ul li .connect-btn a {
  border: 1px solid #28C76F;
  color: #28C76F;
  background-color: rgba(40, 199, 111, 0.05);
  padding: 3px 5px;
  border-radius: 5px;
  font-size: 14px;
}
.connected-app-card ul li .connect-btn.not-connect a {
  border-color: #f3f6f9;
  color: #092C4C;
  background-color: #ffffff;
  font-weight: 600;
}
.connected-app-card ul li .security-title h5 {
  font-weight: 600;
  font-size: 16px;
}
.connected-app-card ul li .system-app-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background-color: #FAFBFE;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-right: 8px;
  flex-shrink: 0;
}
.connected-app-card ul li p {
  font-size: 13px;
  color: #5B6670;
  font-weight: 500;
  margin-top: 5px;
}
.connected-app-card ul li .integration-btn a {
  border: 1px solid #f3f6f9;
  color: #092C4C;
  background-color: #ffffff;
  border-radius: 8px;
  padding: 5px 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
}

.company-info {
  border-bottom: 1px solid #f3f6f9;
  margin-bottom: 24px;
}

.logo-company li {
  margin-bottom: 20px;
}
@media (max-width: 575px) {
  .logo-company li {
    flex-direction: column !important;
    align-items: start !important;
  }
}
.logo-company li .logo-info {
  margin-right: 100px;
}
@media (max-width: 1199.98px) {
  .logo-company li .logo-info {
    margin-right: 40px;
  }
}
@media (max-width: 575px) {
  .logo-company li .logo-info {
    margin-bottom: 20px;
  }
}
.logo-company li .logo-info h6 {
  font-size: 14px;
  font-weight: 700;
}
.logo-company li .logo-info p {
  font-size: 13px;
}
.logo-company li .profile-pic-upload {
  margin-right: 100px;
}
.logo-company li .profile-pic-upload .image-upload {
  width: 135px;
}
.logo-company li .profile-pic-upload .image-upload h4 svg {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.logo-company li .new-logo {
  text-align: right;
}
@media (max-width: 575px) {
  .logo-company li .new-logo {
    text-align: left;
    margin-left: 0 !important;
    margin-top: 20px;
  }
}
.logo-company li .new-logo a {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  border: 1px solid #f3f6f9;
  border-radius: 8px;
  position: relative;
}
.logo-company li .new-logo a span {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  background-color: #FF0000;
  border-radius: 5px;
  position: absolute;
  right: 4px;
  top: 4px;
}
.logo-company li .new-logo a span svg {
  color: #ffffff;
}

.localization-select {
  width: 200px;
  margin-bottom: 20px;
}
@media (max-width: 1199.98px) {
  .localization-select {
    width: 150px;
  }
}
.localization-select.fixed-width {
  width: 70px;
}
.localization-select.fixed-width span {
  color: #5B6670;
}
.localization-select.width-custom {
  width: 150px;
}

textarea {
  resize: none;
}

.localization-info .setting-info {
  margin-bottom: 20px;
}
.localization-info .setting-info h6 {
  font-size: 14px;
  font-weight: 700;
}
.localization-info .setting-info p {
  color: #5B6670;
}

.appearance-settings h6 {
  font-size: 14px;
  font-weight: 700;
}
.appearance-settings p {
  color: #5B6670;
}
.appearance-settings .theme-type-images .theme-image {
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  background: #ffffff;
  border-radius: 8px;
  border: 2px solid #ffffff;
  padding: 10px;
  margin-right: 10px;
  text-align: center;
}
.appearance-settings .theme-type-images .theme-image:last-child {
  margin-right: 0;
}
.appearance-settings .theme-type-images .theme-image span {
  font-weight: 500;
  margin-top: 10px;
  display: block;
}
.appearance-settings .theme-type-images .theme-image.active {
  border-color: #FF9F43;
}
.appearance-settings .theme-type-images .theme-image.active span {
  color: #FF9F43;
}

.theme-colors ul {
  display: flex;
  align-items: center;
}
.theme-colors ul li {
  margin-right: 10px;
}
.theme-colors ul li span {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #FF9F43;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}
.theme-colors ul li span.active {
  background-color: rgba(255, 159, 67, 0.3);
}
.theme-colors ul li span.active:after {
  content: "";
  width: 25px;
  height: 25px;
  background-color: #FF9F43;
  border-radius: 50%;
  opacity: 1;
}
.theme-colors ul li span.theme-violet {
  background-color: rgb(115, 103, 240);
}
.theme-colors ul li span.theme-violet.active {
  background-color: rgba(115, 103, 240, 0.3);
}
.theme-colors ul li span.theme-violet.active:after {
  background-color: rgb(115, 103, 240);
}
.theme-colors ul li span.theme-blue {
  background-color: rgb(40, 142, 199);
}
.theme-colors ul li span.theme-blue.active {
  background-color: rgba(40, 142, 199, 0.3);
}
.theme-colors ul li span.theme-blue.active:after {
  background-color: rgb(40, 142, 199);
}
.theme-colors ul li span.theme-brown {
  background-color: rgb(210, 100, 0);
}
.theme-colors ul li span.theme-brown.active {
  background-color: rgba(210, 100, 0, 0.3);
}
.theme-colors ul li span.theme-brown.active:after {
  background-color: rgb(210, 100, 0);
}
.theme-colors ul li:last-child {
  margin-right: 0;
}

.input-notify-info {
  color: #5B6670;
  margin-top: 5px;
}
.input-notify-info span {
  color: #FF9F43;
}

.pos-payment-method {
  flex-wrap: wrap;
}
.pos-payment-method .custom-checkbox {
  margin-right: 24px;
  margin-bottom: 20px;
}
.pos-payment-method .custom-checkbox .checkboxs .checkmarks {
  top: -1px;
}
.pos-payment-method .custom-checkbox .checkboxs {
  padding-left: 21px;
}

.setting-gateway a svg {
  color: rgb(91, 102, 112);
  width: 18px;
  height: 18px;
}

.social-authent-settings .connected-app-card ul li:first-child {
  padding-bottom: 20px;
  border-bottom: 1px solid #f3f6f9;
}

.bank-settings .btn-list, .bank-settings .btn-grid {
  background-color: #FAFBFE;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  margin-block-end: unset;
}
.bank-settings .btn-list svg, .bank-settings .btn-grid svg {
  width: 18px;
  height: 18px;
  color: #092C4C;
}
.bank-settings .btn-list.active, .bank-settings .btn-grid.active {
  background-color: #FF9F43;
}
.bank-settings .btn-list.active svg, .bank-settings .btn-grid.active svg {
  color: #ffffff;
}

.bank-box {
  background: #092C4C;
  padding: 40px;
  border-radius: 8px;
  border: 1px solid #092C4C;
  position: relative;
  margin-bottom: 24px;
}
.bank-box.active {
  border-color: #28C76F;
}
.bank-box.active::after {
  position: absolute;
  top: -8px;
  right: -8px;
  content: "\\f058";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
  color: #3ECD7D;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.bank-box .bank-header .bank-name {
  margin-bottom: 24px;
}
.bank-box .bank-header .bank-name h6 {
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}
.bank-box .bank-header .bank-name p {
  color: #ffffff;
}
.bank-box .bank-info span {
  color: #5B6670;
  font-size: 13px;
}
.bank-box .bank-info h6 {
  color: #ffffff;
  font-size: 18px;
  font-weight: 500;
}

.bank-action-btn {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.bank-action-btn a {
  border: 1px solid #f3f6f9;
  border-radius: 8px;
}
.bank-action-btn a svg {
  width: 14px;
  height: 14px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.bank-action-btn a svg.feather-edit {
  color: #3577f1;
}
.bank-action-btn a svg.feather-trash-2 {
  color: #FF0000;
}

.storage-icon h6 {
  font-weight: 600;
  font-size: 16px;
}

svg.filter-icon {
  width: 18px;
  height: 18px;
  color: #ffffff;
}

.search-path .btn-filter.setclose > .filter-icon {
  display: none;
}

.page-header .select-language .select2-container .select2-selection--single {
  height: 41px;
  width: 160px;
}

.language-progress .progress-bar-warning {
  width: 80%;
}
.language-progress .progress-bar-success {
  width: 100%;
}
.language-progress .progress-bar-violet {
  background-color: #7367F0;
  width: 5%;
}
.language-progress .progress-bar-violet-two {
  background-color: #7367F0;
  width: 40%;
}
.language-progress span {
  position: absolute;
  right: 0;
  top: -20px;
  color: #092C4C;
}

.table tbody td.action-table-data .language-action a {
  border: 0;
  color: #ffffff;
}
.table tbody td.action-table-data .language-action a:hover {
  background-color: #FF9F43;
}
.table tbody td.action-table-data .language-action a.language-import {
  background-color: #FAFBFE;
}
.table tbody td.action-table-data .language-action a.language-import svg {
  color: #092C4C;
  width: 18px;
  height: 18px;
}
.table tbody td.action-table-data .language-action a.language-import:hover {
  background-color: #FF9F43;
}
.table tbody td.action-table-data .language-action a.language-import:hover svg {
  color: #ffffff;
}
.table tbody td.action-table-data .language-action .checkboxs .checkmarks {
  top: -5px;
}

.selected-language {
  border: 1px solid #f3f6f9;
  padding: 5px 10px;
  border-radius: 8px;
  color: #092C4C;
}

.back-btn a.btn-translation {
  background-color: #f3f6f9;
  border-radius: 5px;
  font-weight: 500;
}
.back-btn a.btn-translation svg {
  color: #092C4C;
}
.back-btn a.btn-translation:hover {
  background-color: #FF9F43;
  color: #ffffff;
}
.back-btn a.btn-translation:hover svg {
  color: #ffffff;
}

td span.file-data {
  color: #3577f1;
  font-weight: 500;
}

th.fixed-width {
  width: 570px;
}

.file-manager {
  color: #5B6670;
}
.file-manager .search-dropdown {
  height: auto;
}
.file-manager .form-sort {
  width: auto;
}
.file-manager .form-sort .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-right: 27px;
}
.file-manager .form-sort.owned-by {
  margin-right: 10px;
}
.file-manager.notes-page-wrapper .content .page-add-notes {
  padding-bottom: 30px;
  margin-bottom: 30px;
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap {
  margin-top: 0;
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap .form-sort svg.fa-filter {
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
.file-manager.notes-page-wrapper .content .section-bulk-wrap .bulk-action-type .select-bluk {
  margin-right: 15px;
}
.file-manager .page-header .btn-added {
  margin-left: 10px;
}
@media (max-width: 575px) {
  .file-manager .page-header .form-sort {
    margin-top: 0;
    margin-bottom: 15px;
  }
}
@media (max-width: 575px) {
  .file-manager .page-header .table-top-head {
    margin-bottom: 15px;
  }
}
@media (max-width: 991.98px) {
  .file-manager .page-header .table-top-head li:last-child {
    margin-right: 0;
  }
}
@media (max-width: 767px) {
  .file-manager .bulk-action-type {
    align-items: start !important;
  }
}
@media (max-width: 575px) {
  .file-manager .bulk-action-type {
    display: block !important;
  }
}
@media (max-width: 767px) {
  .file-manager .bulk-action-type .form-sort {
    margin-top: 0;
    margin-bottom: 15px;
    width: 100%;
  }
}
.file-manager aside {
  border: 1px solid #dbe0e6;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  border-radius: 8px;
}
.file-manager aside h5 {
  font-size: 18px;
  font-weight: 700;
  border-bottom: 1px solid #f3f6f9;
  margin: 0 0 15px 0;
  padding: 0 0 15px 0;
}
.file-manager aside .btn {
  font-weight: 700;
}
.file-manager aside .dropdown > a {
  width: auto;
  height: auto;
  color: #ffffff;
  border-radius: 8px;
}
.file-manager aside .dropdown > a:hover, .file-manager aside .dropdown > a:focus {
  border-color: #092C4C;
  background: #092C4C;
}
.file-manager aside .dropdown ul {
  width: 100%;
}
.file-manager aside .dropdown ul li a {
  font-size: 15px;
}
.file-manager aside ul li a {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  color: #5B6670;
  font-size: 14px;
  font-weight: 600;
  margin: 0 0 5px 0;
  padding: 7px 10px;
  border-radius: 5px;
}
.file-manager aside ul li a span {
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
}
.file-manager aside ul li a:hover, .file-manager aside ul li a.active {
  background: #092C4C;
  color: #ffffff;
}
.file-manager aside span {
  font-size: 13px;
  font-weight: 500;
}
.file-manager aside h6 {
  font-size: 16px;
  font-weight: 600;
  position: relative;
  z-index: 2;
}
.file-manager aside .space-manager {
  color: #ffffff;
  background: #092C4C;
  border-radius: 8px;
  position: relative;
}
.file-manager aside .space-manager img {
  position: absolute;
  top: 0;
  right: 0;
}
.file-manager aside .space-manager h6 a {
  color: #ffffff;
}
.file-manager aside .space-manager p {
  color: #B8BCC9;
}
.file-manager .progress {
  height: 6px;
  border-radius: 5px;
}
.file-manager .search-set .search-input input[type=search] {
  width: 170px;
  height: 40px;
}
.file-manager .budgeted-role-notes .search-set .search-input input[type=search] {
  width: 298px;
}
.file-manager h4 {
  font-size: 18px;
  font-weight: 600;
}
.file-manager h6 {
  font-size: 16px;
  font-weight: 600;
}
.file-manager h6 a {
  color: #092C4C;
}
.file-manager h6 a:hover {
  color: #FF9F43;
}
.file-manager .overview .detail a.bg {
  border-radius: 8px 8px 0 0;
}
.file-manager .overview .detail a.bg span {
  width: 66px;
  height: 66px;
  border-radius: 100%;
}
.file-manager .overview .detail a.bg span img {
  transition: all 0.5s ease;
}
.file-manager .overview .detail a:hover img {
  transform: scale(1.2);
}
.file-manager .info {
  border-radius: 0 0 8px 8px;
  padding: 15px;
  background: #ffffff;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
}
.file-manager .info span {
  color: #5B6670;
  font-size: 13px;
}
.file-manager .folders {
  border: 1px solid #f3f6f9;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  border-radius: 8px;
  background: #ffffff;
  width: 320px;
}
.file-manager .folders h6 {
  width: 100%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-right: 8px;
}
.file-manager .dropdown > a {
  color: #092C4C;
  width: 25px;
  height: 25px;
  transition: all 0.5s ease;
  border-radius: 100%;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
.file-manager .dropdown > a:hover {
  background: #FF9F43;
}
.file-manager .dropdown > a:hover i {
  color: #ffffff;
}
.file-manager .project-plan {
  font-size: 13px;
  font-weight: 600;
  margin-top: 10px;
}
.file-manager .project-plan label {
  color: #092C4C;
  margin-right: 9px;
  font-size: 13px;
}
.file-manager .project-plan ul li {
  font-size: 13px;
  position: relative;
  padding: 0 9px 0 14px;
  color: #5B6670;
}
.file-manager .project-plan ul li:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  width: 5px;
  height: 5px;
  background: #dbe0e6;
  border-radius: 5px;
}
.file-manager .avatar-wrap a svg {
  color: #5B6670;
}
.file-manager .avatar-wrap a:hover svg {
  color: #FF9F43;
}
.file-manager .accordion {
  border: none;
  --bs-accordion-border-width: none;
}
.file-manager .accordion .accordion-item {
  border: none;
  border-bottom: 1px solid #f3f6f9;
  background: none;
}
.file-manager .accordion .accordion-item:last-of-type {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
  border-bottom: none;
}
.file-manager .accordion .accordion-item .accordion-button {
  background: none;
  border: none;
  font-size: 18px;
  font-weight: 600;
  color: #092C4C;
  padding: 0;
  display: inline-block;
  width: auto;
}
.file-manager .accordion .accordion-item .accordion-button:after {
  transition: all 0.8s ease;
  background-image: none;
  content: "View All";
  font-family: "Nunito", sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #5B6670;
  transform: none;
  width: 60px;
  text-align: right;
}
.file-manager .accordion .accordion-item .accordion-button:not(.collapsed)::after {
  content: "Hide";
}
.file-manager .accordion .accordion-item .accordion-button.collapsed {
  padding: 0;
}
.file-manager .accordion .accordion-item .accordion-button:hover:after {
  color: #FF9F43;
}
.file-manager .accordion .accordion-item .accordion-body {
  border: none;
  padding: 0;
}
.file-manager .accordion .accordion-item .accordion-body .head img {
  min-width: 32px;
  width: 32px;
  height: 32px;
}
.file-manager .accordion .accordion-item .accordion-body .owl-carousel {
  padding-top: 15px;
}
.file-manager .owl-carousel .owl-item {
  margin-left: -0.1px !important;
}
.file-manager .owl-carousel .dropdown-menu {
  left: auto !important;
  right: 0 !important;
  top: 27px !important;
  transform: none !important;
  background: #ffffff !important;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  z-index: 99999 !important;
}
.file-manager .owl-carousel .owl-nav {
  top: -26px;
  left: 43px;
  display: inline-table;
}
.file-manager .owl-carousel .owl-nav button {
  margin-top: 0;
  margin-bottom: 0;
  background: none;
  cursor: pointer;
}
.file-manager .owl-carousel .owl-nav button.owl-next, .file-manager .owl-carousel .owl-nav button.owl-prev {
  position: relative;
  width: 15px;
}
.file-manager .owl-carousel .owl-nav button.owl-next i, .file-manager .owl-carousel .owl-nav button.owl-prev i {
  color: #5B6670;
}
.file-manager .owl-carousel .owl-nav button.owl-next:hover, .file-manager .owl-carousel .owl-nav button.owl-prev:hover {
  background: none;
}
.file-manager .owl-carousel .owl-nav button.owl-next:hover i, .file-manager .owl-carousel .owl-nav button.owl-prev:hover i {
  color: #FF9F43;
}
.file-manager .owl-carousel.folders-carousel .owl-nav {
  left: 75px;
}
.file-manager .owl-carousel.video-section .owl-nav {
  left: 60px;
}
.file-manager .owl-carousel.video-section .info a svg {
  color: #5B6670;
}
.file-manager .all-files {
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  border: none;
}
.file-manager .all-files .btn-grp a {
  padding: 6px 8px;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
}
@media (max-width: 575px) {
  .file-manager .all-files .btn-grp a {
    margin-bottom: 15px;
    display: inline-block;
  }
}
.file-manager .all-files .btn-grp a.btn-outline-secondary {
  color: #5B6670;
  background: #FAFBFE;
  border-color: #FAFBFE;
}
.file-manager .all-files .btn-grp a:hover {
  background: #092C4C;
  border-color: #092C4C;
  color: #ffffff;
}
.file-manager .all-files .table tbody tr td {
  display: table-cell;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}
.file-manager .all-files .table tbody tr td a {
  font-size: 14px;
  font-weight: 500;
}
.file-manager .all-files .table tbody tr td a.product-img img {
  width: 32px;
  height: 32px;
  border: 0;
}
.file-manager #file-delete {
  font-size: 14px;
}

.color-primary {
  color: #5B6670;
}

.icon-select {
  position: relative;
  width: 149px;
  height: 38px;
}
.icon-select .icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  z-index: 100;
}
.icon-select .select2-container--default .select2-selection--single .select2-selection__rendered {
  padding-left: 30px;
}

.bg-light-orange {
  background: #FFECD9;
}
.bg-light-orange span {
  background: #FFECD9;
}

.bg-light-red {
  background: #FFCCCC;
}
.bg-light-red span {
  background: #FFCCCC;
}

.bg-light-green {
  background: #BFEED4;
}
.bg-light-green span {
  background: #BFEED4;
}

.seprator-sm {
  margin: 0 0 24px 0;
  padding: 0 0 9px 0;
  border-bottom: 1px solid #f3f6f9;
}

.seprator-lg {
  margin: 0 0 24px 0;
  padding: 0 0 24px 0;
  border-bottom: 1px solid #f3f6f9;
}

.group-avatar .avatar {
  position: relative;
  width: 43px;
  height: 43px;
  line-height: 43px;
  margin: 0;
}
.group-avatar .avatar + .avatar {
  margin-left: -1.2rem;
}
.group-avatar .avatar:hover {
  z-index: 1;
}
.group-avatar .count a {
  color: #28C76F;
  line-height: 27px;
  font-size: 13px;
  font-weight: 500;
}
.group-avatar .count a:hover {
  color: #FF9F43;
}
.group-avatar .avatar img {
  display: block;
  border-radius: 100%;
  width: 100%;
  border: 2px solid #ffffff;
}

.video-section .item {
  opacity: 0.4;
  transition: 0.4s ease all;
  transform: scale(0.8);
}

@media (max-width: 1000px) {
  .video-section .item {
    margin: 0;
    transform: scale(0.9);
  }
}
.video-section .active .item {
  opacity: 1;
  transform: scale(1);
}

.video-section .owl-item {
  -webkit-backface-visibility: hidden;
  -webkit-transform: translateZ(0) scale(1, 1);
}

.video-section video {
  max-width: 100%;
  height: 100%;
  border-radius: 10px 10px 0 0;
}

.delete-alert {
  padding: 10px 20px;
  background: #FFCCCC;
  border: none;
  border-radius: 8px;
}
.delete-alert p {
  font-size: 15px;
}
.delete-alert .btn {
  font-weight: 700;
}

.deleted-info {
  display: none;
}
.deleted-info .bin-bg {
  width: 184px;
  height: 184px;
  border-radius: 100%;
  background: #f8f9fa;
  margin: 0 auto;
}

.popup-toggle {
  cursor: pointer;
}

.toggle-sidebar {
  width: 456px;
  padding: 25px;
  position: fixed;
  right: -456px;
  top: 0;
  height: 100%;
  background: #ffffff;
  z-index: 100001;
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;
  overflow-y: auto;
  transition: all 0.5s ease;
}
@media (max-width: 575px) {
  .toggle-sidebar {
    width: 320px;
    right: -320px;
  }
}
.toggle-sidebar.open-sidebar {
  right: 0;
  transition: all 0.5s ease;
}
.toggle-sidebar .head .color-primary:hover {
  color: #FF0000;
}
.toggle-sidebar h4, .toggle-sidebar h5 {
  font-weight: 700;
}
.toggle-sidebar h4 {
  font-size: 20px;
}
.toggle-sidebar h5 {
  font-size: 18px;
}
.toggle-sidebar h6 {
  font-size: 15px;
  font-weight: 600;
}
.toggle-sidebar .nav-tabs {
  border-bottom: 1px solid #f3f6f9;
}
.toggle-sidebar .nav-tabs .nav-link {
  padding: 8px 20px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 8px;
  border: none;
  background: #FAFBFE;
  color: #092C4C;
}
.toggle-sidebar .nav-tabs .nav-link:hover, .toggle-sidebar .nav-tabs .nav-link.active {
  background: #FF9F43;
  color: #ffffff;
}
.toggle-sidebar .tab-content .tab-pane ul li h6 {
  margin-bottom: 5px;
}
.toggle-sidebar .tab-content .tab-pane ul li p.location {
  background: #FAFBFE;
  border: 1px solid #f3f6f9;
  border-radius: 5px;
  padding: 5px;
  display: inline-block;
}
.toggle-sidebar .tab-content .tab-pane ul li p.location img {
  width: 20px;
  height: 20px;
}
.toggle-sidebar .tab-content .tab-pane ul li .note-editor.note-airframe .note-statusbar, .toggle-sidebar .tab-content .tab-pane ul li .note-editor.note-frame .note-statusbar {
  border-top: none;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span a {
  display: inline-flex;
  margin-right: 3px;
  padding-right: 3px;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span:first-child a {
  margin-right: 10px;
  padding-right: 10px;
  border-right: 1px solid #f3f6f9;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span:last-child a {
  margin-right: 0;
  padding-right: 0;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span .add {
  background: #FF9F43;
  color: #ffffff;
}
.toggle-sidebar .tab-content .tab-pane .avatar-access span .add:hover {
  background: #092C4C;
}
.toggle-sidebar p {
  color: #5B6670;
  font-size: 15px;
}
.toggle-sidebar .show-all {
  font-weight: 700;
}
.toggle-sidebar .show-all:hover {
  color: #092C4C;
}

.text-danger {
  color: #FF0000 !important;
}

.avatar-md {
  width: 45px;
  height: 45px;
  border-radius: 45px;
}

.text-secondary {
  color: #092C4C !important;
}

.text-primary {
  color: #FF9F43 !important;
}

.text-default {
  color: #5B6670;
}

.css-1u9des2-indicatorSeparator {
  display: none;
}

.ant-tooltip {
  display: none;
}

:where(.css-dev-only-do-not-override-1qhpsh8).ant-picker-outlined {
  background: #ffffff;
  border-width: 1px;
  border-style: solid;
  border-color: #dbe0e6;
  width: 300px;
  height: 40px;
}

.ant-picker-suffix {
  display: none;
}

.swal2-confirm {
  background-color: #ff8d1f !important;
  border: 1px solid #ff8d1f !important;
  box-shadow: 0 3px 10px rgba(255, 159, 67, 0.5);
  color: #ffffff !important;
}

.worldmap__figure-container {
  height: 247px !important;
}

.badge.badge-linesuccess a,
.badges-success {
  color: #28c76f;
}

.filterdatepicker {
  width: 217px;
  height: 43px;
}

.ant-table-wrapper .ant-table-column-title {
  z-index: 0 !important;
}

.toast-header .btn.btn-close {
  display: none;
}

.text-primary .toast-body {
  background: rgba(255, 159, 67, 0.1) !important;
}

.swal2-container .swal2-title {
  font-size: 18px !important;
}

.rsw-toolbar {
  height: 40px !important;
}

.rsw-ce {
  height: 350px !important;
}

.linestripe {
  text-decoration: line-through;
  opacity: 0.5;
}

.clipboardcopyedvalue {
  color: orange;
}

#infoToast .toast-body {
  color: #17a2b8;
  background-color: #e7f6f8;
}

#primaryToast .toast-body,
#warningToast .toast-body {
  color: #ff9f43;
  background-color: #fff5ec;
}

#secondaryToast .toast-body {
  color: #092c4c;
  background-color: #e6e9ed;
}

#successToast .toast-body {
  color: #28c76f;
  background-color: #e9f9f0;
}

#dangerToast .toast-body {
  color: #ff0000;
  background-color: #ffe5e5;
}

.formsearch {
  height: 38px;
  width: 275px;
}

.css-1p3m7a8-multiValue {
  background-color: #17a2b8 !important;
}

.twitter-bs-wizard .twitter-bs-wizard-nav .step-icon {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 54px;
  border: 1px solid rgba(81, 86, 190, 0.2);
  color: #5156be;
  text-align: center;
  border-radius: 50%;
  position: relative;
  z-index: 1;
  font-size: 20px;
}

.twitter-bs-wizard .twitter-bs-wizard-nav .nav-link {
  font-size: 14px;
  position: relative;
}

.twitter-bs-wizard .twitter-bs-wizard-nav .nav-link::after {
  content: "";
  position: absolute;
  width: 75%;
  height: 2px;
  background-color: #e9e9ef;
  left: 62%;
  top: 50%;
  transform: translateY(-50%);
}

.custom-search {
  position: relative;
  top: -28px;
  left: 10px;
}

.daterange-wraper {
  border: 0px solid;
  border-radius: 4px;
  border-color: hsl(0, 0%, 80%);
}

[data-layout-style=horizontal] .sidebar {
  display: none;
}
[data-layout-style=horizontal] .sidebar.horizontal-sidebar {
  display: block;
}
@media (max-width: 991.98px) {
  [data-layout-style=horizontal] .sidebar {
    display: block;
  }
  [data-layout-style=horizontal] .sidebar.horizontal-sidebar {
    display: none;
  }
}
[data-layout-style=horizontal] .sidebar .sidebar-menu > ul > li > a.active svg {
  color: #FF9F43;
}
[data-layout-style=horizontal] .page-wrapper {
  margin-left: 0;
  padding-top: 140px;
}
[data-layout-style=horizontal] .header #toggle_btn {
  display: none;
}
[data-layout-style=horizontal] .sidebar .sidebar-menu > ul > li.submenu ul {
  background: rgb(246, 246, 246);
}
[data-layout-style=horizontal] .sidebar .sidebar-menu .nav > li > ul {
  max-height: 400px;
  overflow-x: hidden;
  overflow-y: auto;
}
[data-layout-style=horizontal] body.header-collapse .header {
  display: none;
}
[data-layout-style=horizontal] body.header-collapse .horizontal-sidebar {
  top: 0;
  border-top: 0;
}
[data-layout-style=horizontal] body.header-collapse .page-wrapper {
  padding-top: 60px;
}
@media (max-width: 991.98px) {
  [data-layout-style=horizontal] .sidebar.collapsed-sidebar {
    display: none;
  }
  [data-layout-style=horizontal] .page-wrapper {
    padding-top: 80px;
  }
}

[data-nav-color=grey] .sidebar {
  background: #eff2f7;
}

:where(.css-dev-only-do-not-override-1b0bdye).ant-pagination .ant-pagination-item-active {
  font-weight: 600;
  border-color: #ff9f43;
  border-radius: 15px;
  background-color: #ff9f43;
  color: #fff;
}

:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper .ant-table-pagination.ant-pagination {
  margin: 0px 0;
}

.ant-select-selection-item {
  border: none !important;
}

ul.tabs.owl-carousel.pos-category {
  display: flex;
}

.tabs_wrapper ul.tabs div {
  background-color: #ffffff;
  display: -ms-flexbox;
  padding: 15px 0;
  margin-right: 8px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  flex-wrap: wrap;
  text-align: center;
  cursor: pointer;
  border: 1px solid #f3f6f9;
  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);
  transition: all 0.5s ease;
  border-radius: 8px;
  margin-left: -0.1px !important;
}

.tabs_wrapper ul.tabs li h6 {
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 10px;
  width: 100%;
  margin-bottom: 5px;
}

.tabs_wrapper ul.tabs li span {
  color: #5b6670;
}

.tabs_wrapper ul.tabs li:last-child {
  margin-right: 0;
}

.pos-design .tabs_wrapper .slick-arrow.slick-prev::before {
  content: "\\f053";
  width: 12px;
  height: 12px;
  font-size: 12px;
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  color: #092c4c;
}

.pos-design .tabs_wrapper .slick-arrow.slick-next::before {
  content: "\\f054";
  width: 12px;
  height: 12px;
  font-size: 12px;
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  color: #092c4c;
}

.pos-categories {
  position: relative;
}

:where(.css-dev-only-do-not-override-1b0bdye).ant-picker-dropdown {
  z-index: 2000 !important;
}

.mini-sidebar .active.subdrop ~ ul {
  display: none !important;
}

.pos-category .slick-slide {
  list-style: none;
  cursor: pointer;
  display: inline-block;
  border-radius: 5px;
  color: white;
  font-family: sans-serif;
  padding: 15px 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-right: 8px;
}

.pos-category .slick-track .slick-slide:last-child {
  margin-right: 0;
}

.pos-slick-item a {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pos-slick-item span {
  color: #5b6670;
}

.pos-slick-item h6 {
  font-size: 15px;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-top: 10px;
  width: 100%;
  margin-bottom: 5px;
}

.owl-carousel.pos-category .slick-prev {
  left: unset;
  right: 60px;
  top: -50px;
  background-color: white;
  width: 28px;
  height: 28px;
  border-radius: 28px;
}

.owl-carousel.pos-category .slick-prev:hover,
.owl-carousel.pos-category .slick-next:hover {
  background-color: #ff9f43;
}

.owl-carousel.pos-category .slick-next {
  left: unset;
  right: 20px;
  top: -50px;
  background-color: white;
  width: 28px;
  height: 28px;
  border-radius: 28px;
}

.ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell {
  background: white !important;
}

.ant-table-wrapper tfoot > tr > td {
  position: relative;
  padding: 2px 16px;
  overflow-wrap: break-word;
}

:where(.css-dev-only-do-not-override-1b0bdye).ant-checkbox-checked .ant-checkbox-inner {
  background-color: #ff9f43;
  border-color: #ff9f43;
}

.iconsize {
  height: 16px !important;
}

[data-layout-mode=dark_mode] .ant-table-content table thead.ant-table-thead tr th {
  background: #141432;
  border-bottom: 1px solid #141432;
}

[data-layout-mode=dark_mode] .ant-table-content table thead.ant-table-thead tr th {
  background: #141432;
  border-bottom: 1px solid #141432;
}

[data-layout-mode=dark_mode] :where(.css-dev-only-do-not-override-1b0bdye).ant-checkbox .ant-checkbox-inner {
  background: #141432;
}

[data-layout-mode=dark_mode] .ant-spin-nested-loading .ant-spin-container ul.ant-pagination.ant-table-pagination {
  background: #1d1d42;
}

[data-layout-mode=dark_mode] :where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper .ant-table-tbody .ant-table-row.ant-table-row-selected > .ant-table-cell {
  background: #141432 !important;
}

.ant-table-content table thead.ant-table-thead tr th {
  background: none;
}

:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper .ant-table-column-sorters::after {
  content: none;
}

:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before,
:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper .ant-table-thead > tr > td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  content: none;
}

:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper .ant-table-thead th.ant-table-column-has-sorters:hover {
  background: none;
}

.ant-table-content table tr.ant-table-row:hover {
  background: none;
}

:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper .ant-table-tbody .ant-table-row > .ant-table-cell-row-hover {
  background: none;
}

:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper .ant-table-tbody > tr > td {
  padding-right: 10px;
}

ul.ant-pagination.ant-table-pagination li button.ant-pagination-item-link {
  color: #67748e;
}

[data-layout-mode=dark_mode] .css-13cymwt-control {
  background-color: #1d1d42;
  border: 1px solid #67748E;
}

[data-layout-mode=dark_mode] .css-t3ipsp-control {
  background-color: #1d1d42;
}

[data-layout-mode=dark_mode] .css-1nmdiq5-menu {
  background-color: #1d1d42;
}

.css-1fdsijx-ValueContainer .css-1dimb5e-singleValue {
  color: #67748e;
}

.ant-table-cell .action-table-data {
  border-bottom: 0 !important;
}

.ant-table-cell .action-table-data:hover {
  background: none;
}

.ant-table-cell.ant-table-cell-row-hover .action-table-data {
  background: none;
}

.table-top-head li a.btn {
  width: 100%;
}

.section-notes-slider .notes-slider .slick-list .slick-slide div {
  margin-left: 12px !important;
}

.css-b62m3t-container .css-13cymwt-control {
  border-color: #dbe0e6;
  color: #5b6670;
  height: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
}

.css-b62m3t-container .css-t3ipsp-control {
  border-color: #dbe0e6;
  box-shadow: none;
  height: 40px;
}

.css-b62m3t-container .css-t3ipsp-control:hover {
  border-color: #dbe0e6;
}

div.css-b62m3t-container .react-select__option--is-focused {
  background-color: #ff9f43;
  color: #fff;
}

div.css-b62m3t-container .react-select__option--is-selected {
  background-color: #ff9f43;
  color: #fff;
}

.css-b62m3t-container .css-13cymwt-control:hover {
  border-color: #dbe0e6;
}

div.react-select__placeholder.css-1jqq78o-placeholder {
  text-overflow: ellipsis;
  white-space: nowrap;
}

.css-1fdsijx-ValueContainer .css-1dimb5e-singleValue {
  overflow: unset;
}

.img-select .css-1jqq78o-placeholder,
.img-select .css-1dimb5e-singleValue {
  padding-left: 25px;
}

.img-select.recent-select-notes .react-select__single-value.css-1dimb5e-singleValue {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.react-select__control.css-13cymwt-control .react-select__value-container.css-1fdsijx-ValueContainer .react-select__input-container.css-qbdosj-Input input {
  height: inherit;
}

.product-list ul li.ant-pagination-item {
  width: 32px;
  padding: 0;
}

.product-list ul li.ant-pagination-prev,
.product-list ul li.ant-pagination-next {
  width: 32px;
  padding: 0;
}

div.fc .fc-button-primary:not(:disabled).fc-button-active,
div.fc .fc-button-primary:not(:disabled):active {
  background-color: #ff9f43;
  border-color: #ff9f43;
  color: var(--fc-button-text-color);
  text-transform: capitalize;
}

div.fc .fc-button-primary {
  background-color: #ff9f43;
  border-color: #ff9f43;
  color: var(--fc-button-text-color);
  text-transform: capitalize;
}

.fc .fc-button-primary:disabled {
  background-color: #ff9f43;
  border-color: #ff9f43;
  color: var(--fc-button-text-color);
}

div.ant-picker.ant-picker-outlined {
  border: 1px solid rgba(145, 158, 171, 0.32);
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  color: #092c4c;
  padding: 10px 10px;
  border-radius: 5px;
  width: 100%;
}

.ant-picker-suffix span {
  display: none;
}

div.ant-picker .ant-picker-input input {
  padding-left: 25px !important;
}

.input-blocks .react-select__control input[type=text],
.input-blocks .react-select__control input[type=password],
.input-blocks .react-select__control input[type=email] {
  height: 0px;
}

.modal-header {
  justify-content: space-between;
}

.searchInput div.icon svg {
  position: absolute;
  left: 0px;
  top: 21px;
  height: 15px;
  width: 15px;
  text-align: center;
  line-height: 55px;
  color: #5b6670;
  cursor: pointer;
}

.ant-picker-dropdown {
  z-index: 9999;
}

table tbody div.action-table-data a {
  border: 1px solid rgba(145, 158, 171, 0.3);
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 8px;
}

table tbody div.action-table-data a .feather-view {
  width: 14px;
  height: 14px;
}

table tbody div.action-table-data a .feather-trash-2 {
  color: #ff0000;
  width: 14px;
  height: 14px;
}

table tbody div.action-table-data a .feather-edit {
  color: #3577f1;
  width: 14px;
  height: 14px;
}

.orange-text {
  color: orange;
}

div.ant-picker.ant-picker-outlined {
  box-shadow: none;
}

#panelsStayOpen-collapseOne .slick-slider div.slick-slide > div,
#panelsStayOpen-collapseTwo .slick-slider div.slick-slide > div,
.join-contents .slick-slider div.slick-slide > div {
  margin-right: 10px;
}

.table-top-head .feather-rotate-ccw {
  height: 16px;
}

.table-top-head li a svg {
  color: #092c4c;
}

.table-top-head li a svg {
  height: 16px;
}

#collapse-header svg {
  height: 20px;
}

.stickybar {
  position: sticky;
  top: 0;
}

.input-blocks.daterange-wraper input[type=text] {
  padding: 10px 10px 10px 35px !important;
}

#DataTables_Table_0_filter.dataTables_filter.custom-data-table-react {
  justify-content: end;
  display: flex;
}

div.rc-slider-track,
.rc-slider-tracks {
  background-color: #ff9f43;
}

div.rc-slider-handle {
  border: solid 2px #ff9f43;
}

span.rc-slider-dot-active {
  border-color: #ff9f43;
}

div.rc-slider-handle:active {
  border-color: #ff9f43;
  box-shadow: 0 0 5px #ff9f43;
  cursor: grabbing;
}

.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
  border-color: #ff9f43;
  box-shadow: 0 0 0 5px #ff9f43;
}

.react-select-min-width .css-b62m3t-container {
  min-width: 70px;
}

table tbody td > div.action-table-data a .feather-edit {
  color: #3577f1;
  width: 14px;
  height: 14px;
}

table tbody td > div.action-table-data a {
  border: 1px solid rgba(145, 158, 171, 0.3);
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  justify-content: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  padding: 8px;
}

.input-groupicon .ant-picker.ant-picker-outlined {
  display: flex;
  align-items: center;
}

table tbody td .action-table-data a .action-eye {
  color: #092c4c;
  width: 14px;
  height: 14px;
}

table tbody td .action-table-data a .action-download {
  color: #3577f1;
  width: 14px;
  height: 14px;
}

table tbody td .action-table-data a .action-edit {
  color: #5b6670;
  width: 14px;
  height: 14px;
}

.custom-active-hassubroute-false a {
  background: rgba(254, 159, 67, 0.08);
  border-radius: 5px;
  color: #fe9f43;
}

.custom-active-hassubroute-false a span.custom-active-span,
.custom-active-hassubroute-false a svg {
  color: #fe9f43 !important;
}

.input-blocks.search-form i {
  position: absolute;
  left: 10px;
  top: 44px;
  width: 15px;
}

@media (min-width: 991.98px) {
  .expand-menu.mini-sidebar .sidebar {
    width: 260px;
  }
}
.expand-menu.mini-sidebar .sidebar-right {
  display: block;
  transition: all 0.2s ease;
}
.expand-menu.mini-sidebar .sidebar .sidebar-menu ul > li > a {
  padding: 10px 15px;
}
.expand-menu.mini-sidebar .sidebar .sidebar-menu ul > li > a span {
  display: inline-block;
  line-height: 0;
}
.expand-menu.mini-sidebar .sidebar .sidebar-menu ul > li svg {
  margin-right: 10px;
}
.expand-menu.mini-sidebar .sidebar .sidebar-menu .submenu-hdr {
  display: block;
}
.expand-menu.mini-sidebar .header-left {
  width: 260px;
}

.expand-menu.mini-sidebar .sidebar .sidebar-menu ul > li > a {
  padding: 18px 15px;
}
.expand-menu.mini-sidebar .sidebar.collapsed-sidebar .sidebar-menu ul li a::before {
  left: 0;
}
.expand-menu.mini-sidebar .sidebar.collapsed-sidebar .sidebar-menu ul li ul li a {
  padding: 10px 15px 10px 25px;
}

div.rc-slider-handle:hover {
  border-color: #ff8d1f;
}

div.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {
  border-color: #ff8d1f;
  box-shadow: 0 0 0 5px #ff8d1f;
}

.total-order.max-widthauto ul {
  margin-top: 20px;
}

.feather-dashboard {
  color: #fff;
}

:where(.css-mzwlov).ant-table-wrapper .ant-table-thead > tr > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before, :where(.css-mzwlov).ant-table-wrapper .ant-table-thead > tr > td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {
  position: absolute;
  top: 50%;
  inset-inline-end: 0;
  width: 1px;
  height: 1.6em;
  background-color: transparent;
  transform: translateY(-50%);
  transition: background-color 0.2s;
  content: "";
}

.edit-delete-action a:hover i.feather-edit,
.edit-delete-action a:hover i.feather-trash-2 {
  color: #ffffff !important;
}

#collapse-header.active {
  border: none;
}

.modal .content {
  padding: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/style/scss/main.scss","webpack://./src/style/scss/utils/_mixins.scss","webpack://./src/style/scss/base/_base.scss","webpack://./src/style/scss/utils/_variables.scss","webpack://./src/style/scss/base/_background.scss","webpack://./src/style/scss/components/_avatar.scss","webpack://./src/style/scss/components/_boostrap.scss","webpack://./src/style/scss/components/_button.scss","webpack://./src/style/scss/components/_badge.scss","webpack://./src/style/scss/components/_border.scss","webpack://./src/style/scss/components/_calendar.scss","webpack://./src/style/scss/components/_chart.scss","webpack://./src/style/scss/components/_dropdown.scss","webpack://./src/style/scss/components/_icons.scss","webpack://./src/style/scss/components/_progress.scss","webpack://./src/style/scss/components/_pagination.scss","webpack://./src/style/scss/components/_typography.scss","webpack://./src/style/scss/components/_alerts.scss","webpack://./src/style/scss/components/_popovers.scss","webpack://./src/style/scss/components/_forms.scss","webpack://./src/style/scss/components/_tables.scss","webpack://./src/style/scss/components/_accordion.scss","webpack://./src/style/scss/components/_breadcrumb.scss","webpack://./src/style/scss/components/_cards.scss","webpack://./src/style/scss/components/_tooltips.scss","webpack://./src/style/scss/components/_navs-tabs.scss","webpack://./src/style/scss/components/_ribbon.scss","webpack://./src/style/scss/components/_popup.scss","webpack://./src/style/scss/components/_grid.scss","webpack://./src/style/scss/vendors/_select2.scss","webpack://./src/style/scss/vendors/_datatables.scss","webpack://./src/style/scss/layout/_content.scss","webpack://./src/style/scss/layout/_common.scss","webpack://./src/style/scss/layout/_darktheme.scss","webpack://./src/style/scss/layout/_header.scss","webpack://./src/style/scss/layout/_header-one.scss","webpack://./src/style/scss/layout/_header-two.scss","webpack://./src/style/scss/layout/_header-three.scss","webpack://./src/style/scss/layout/_header-four.scss","webpack://./src/style/scss/layout/_loader.scss","webpack://./src/style/scss/layout/_sidebar.scss","webpack://./src/style/scss/layout/_notification.scss","webpack://./src/style/scss/layout/_sidebar-settings.scss","webpack://./src/style/scss/layout/_theme-settings.scss","webpack://./src/style/scss/pages/_chat.scss","webpack://./src/style/scss/pages/_email.scss","webpack://./src/style/scss/pages/_error.scss","webpack://./src/style/scss/pages/_login.scss","webpack://./src/style/scss/pages/_product.scss","webpack://./src/style/scss/pages/_profile.scss","webpack://./src/style/scss/pages/_stocks.scss","webpack://./src/style/scss/pages/_product-list.scss","webpack://./src/style/scss/pages/_pos.scss","webpack://./src/style/scss/pages/_pos-design.scss","webpack://./src/style/scss/pages/_add-product.scss","webpack://./src/style/scss/pages/_notes.scss","webpack://./src/style/scss/pages/_employees-grid.scss","webpack://./src/style/scss/pages/_transfer-list.scss","webpack://./src/style/scss/pages/_attendance-employee.scss","webpack://./src/style/scss/pages/_settings.scss","webpack://./src/style/scss/pages/_file-manager.scss","webpack://./src/style/scss/pages/_customisedstyle.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,oBAAA;ACmJA;EAIE,oBAAA;AD9IF;;AALA,qBAAA;AEJA;EACC,iCCYqB;EDXrB,eC2Pc;ED1Pd,cCgKY;ED/JZ,gBAAA;EACA,yBCiKS;EDhKT,gBAAA;EACA,kBAAA;AFaD;;AEXA;EACE,mBCQQ;EDPR,cCqBM;EDpBN,iBAAA;AFcF;;AEZA;EACC,eAAA;EACA,YAAA;EACA,uBAAA;AFeD;;AEbA;EACC,aAAA;AFgBD;;AEdA;ED0EE,yBCzEmB;AFmBrB;AElBC;EACC,2BAAA;AFoBF;;AEjBA;EACC,cCXS;EDYT,eAAA;EACA,qBAAA;EDiEC,yBChEmB;AFsBrB;AErBC;EACC,cCfc;EF6Ed,yBC7DoB;AFyBtB;AEvBC;EACC,UAAA;AFyBF;;AEtBA;EACC,mBAAA;AFyBD;AExBC;EACC,gBAAA;AF0BF;;AEvBA;EACC,gBCvCkB;AHiEnB;;AExBA;EACG,cCiHW;EDhHX,iCCvCmB;EDwCrB,gBC5CkB;ED6ChB,gBAAA;AF2BH;;AEzBA;EACE,gBAAA;EACA,mBAAA;EACA,UAAA;AF4BF;;AE1BA;EACE,gBAAA;AF6BF;AE5BC;EACE,gBAAA;EACA,kBAAA;AF8BH;AE7BG;EACE,uBAAA;AF+BL;AE5BC;EACE,mBAAA;EACA,kBAAA;AF8BH;AE7BG;EACE,wBAAA;AF+BL;AE5BC;EACE,gBAAA;EACA,eAAA;AF8BH;AE7BG;EACE,sBAAA;EACA,qBAAA;AF+BL;AE9BK;;;EAGE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;AFgCP;AE7BK;EACE,eC+JQ;ED9JR,QAAA;AF+BP;AEtBe;EACI,gBAAA;AFwBnB;;AIrIA;EACI,oCAAA;AJwIJ;;AItIA;EACI,oCAAA;AJyIJ;;AIvIA;EACI,oCAAA;AJ0IJ;;AIxIA;EACI,oCAAA;AJ2IJ;;AIzIA;EACI,oCAAA;AJ4IJ;;AI1IA;EACI,oCAAA;AJ6IJ;;AI3IA;EACI,oCAAA;AJ8IJ;;AI5IA;EACI,oCAAA;AJ+IJ;;AI7IA;EACI,oCAAA;AJgJJ;;AI9IA;EACI,oCAAA;AJiJJ;;AI/IA;EACI,oCAAA;AJkJJ;;AIhJA;EACI,oCAAA;AJmJJ;;AIjJA;EACI,oCAAA;AJoJJ;;AIjJA;EACI,oCAAA;AJoJJ;AInJI;EACI,oDAAA;AJqJR;AInJI;EACI,qDAAA;AJqJR;AInJI;EACI,oDAAA;AJqJR;AInJI;EACI,qDAAA;AJqJR;AInJI;EACI,oCAAA;AJqJR;;AIlJA;EACI,oCAAA;AJqJJ;AIpJI;EACI,iDAAA;AJsJR;AIpJI;EACI,kDAAA;AJsJR;AIpJI;EACI,iDAAA;AJsJR;AIpJI;EACI,kDAAA;AJsJR;AIpJI;EACI,oCAAA;AJsJR;;AInJA;EACI,oCAAA;AJsJJ;AIrJI;EACI,oDAAA;AJuJR;AIrJI;EACI,qDAAA;AJuJR;AIrJI;EACI,oDAAA;AJuJR;AIrJI;EACI,qDAAA;AJuJR;AIrJI;EACI,oCAAA;AJuJR;;AIpJA;EACI,oCAAA;AJuJJ;AItJI;EACI,oDAAA;AJwJR;AItJI;EACI,qDAAA;AJwJR;AItJI;EACI,oDAAA;AJwJR;AItJI;EACI,qDAAA;AJwJR;AItJI;EACI,oCAAA;AJwJR;;AIrJA;EACI,oCAAA;AJwJJ;AIvJI;EACI,mDAAA;AJyJR;AIvJI;EACI,oDAAA;AJyJR;AIvJI;EACI,mDAAA;AJyJR;AIvJI;EACI,oDAAA;AJyJR;AIvJI;EACI,oCAAA;AJyJR;;AItJA;EACI,oCAAA;AJyJJ;AIxJI;EACI,iDAAA;AJ0JR;AIxJI;EACI,kDAAA;AJ0JR;AIxJI;EACI,iDAAA;AJ0JR;AIxJI;EACI,kDAAA;AJ0JR;AIxJI;EACI,gCAAA;AJ0JR;;AIvJA;EACI,oCAAA;AJ0JJ;AIzJI;EACI,kDAAA;AJ2JR;AIzJI;EACI,mDAAA;AJ2JR;AIzJI;EACI,kDAAA;AJ2JR;AIzJI;EACI,mDAAA;AJ2JR;AIzJI;EACI,oCAAA;AJ2JR;;AIxJA;EACI,oCAAA;AJ2JJ;AI1JI;EACI,qDAAA;AJ4JR;AI1JI;EACI,sDAAA;AJ4JR;AI1JI;EACI,qDAAA;AJ4JR;AI1JI;EACI,sDAAA;AJ4JR;AI1JI;EACI,oCAAA;AJ4JR;;AIvJI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AHuTR;;AI7JI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AH6TR;;AInKI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AHmUR;;AIzKI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AHyUR;;AI/KI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AH+UR;;AIrLI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AHqVR;;AI3LI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AH2VR;;AIjMI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AHiWR;;AIvMI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AHuWR;;AI7MI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AH6WR;;AInNI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AHmXR;;AIzNI;EACI,oCAAA;EACA,oCAAA;EACA,cD7JA;AHyXR;;AIzNA;EACI,yBDjJU;ECkJV,cDhLM;AH4YV;;AI1NA;EACI,yBD1IY;EC2IZ,cDlLQ;AH+YZ;;AI3NA;EACI,yBDnIU;ECoIV,cDpLM;AHkZV;;AI5NA;EACI,yBDjHS;ECkHT,cDlLK;AHiZT;;AI7NA;EACI,yBDhIU;ECiIV,cDxLM;AHwZV;;AI9NA;EACI,yCAAA;EACA,cD9LG;AH+ZP;;AI/NA;EACI,0CAAA;EACA,cDvDS;AHyRb;;AIhOA;EACI,uCAAA;EACA,cD9LI;AHiaR;;AIjOA;EACE,cD9DW;AHkSb;;AIjOA;EACE,0EAAA;EACA,cDtMM;AH0aR;;AIlOA;EACE,0EAAA;EACA,cD1MM;AH+aR;;AInOA;EACE,0EAAA;EACA,cD9MM;AHobR;;AIpOA;EACE,0EAAA;EACA,cDlNM;AHybR;;AIrOA;EACE,0EAAA;EACA,cDtNM;AH8bR;;AItOA;EACE,0EAAA;EACA,cD1NM;AHmcR;;AIvOA;EACE,0EAAA;EACA,cD9NM;AHwcR;;AIxOA;EACE,0EAAA;EACA,cDlOM;AH6cR;;AIzOA;EACE,0EAAA;EACA,cDtOM;AHkdR;;AI1OA;EACE,0EAAA;EACA,cDzOM;AHsdR;;AI3OA;EACE,0EAAA;EACA,cD9OM;AH4dR;;AI5OA;EACE,yBDjPM;ECkPN,yBAAA;EACA,cDjQQ;AHgfV;;AI7OA;EACE,yBDtPM;ECuPN,yBAAA;EACA,cDpQU;AHofZ;;AI9OA;EACE,yBD3PM;EC4PN,yBAAA;EACA,cDnQQ;AHofV;;AI/OA;EACE,yBDhQM;ECiQN,yBAAA;EACA,cD1QK;AH4fP;;AIhPA;EACE,yBDrQM;ECsQN,yBAAA;EACA,cDjRQ;AHogBV;;AIjPA;EACE,yBD1QM;EC2QN,yBAAA;EACA,cDhRO;AHogBT;;AIlPA;EACE,yBD/QM;ECgRN,yBAAA;EACA,cDnRK;AHwgBP;;AInPA;EACE,yBDpRM;ECqRN,oCAAA;EACA,yBAAA;AJsPF;;AIpPA;EACI,oDAAA;EACA,yBAAA;AJuPJ;AItPI;EACI,oDAAA;EACA,yBAAA;AJwPR;;AIrPA;EACI,iDAAA;EACA,yBAAA;AJwPJ;AIvPI;EACI,iDAAA;EACA,yBAAA;AJyPR;;AItPA;EACI,oDAAA;EACA,yBAAA;AJyPJ;AIxPI;EACI,oDAAA;EACA,yBAAA;AJ0PR;;AIvPA;EACI,oDAAA;EACA,yBAAA;AJ0PJ;AIzPI;EACI,oDAAA;EACA,yBAAA;AJ2PR;;AIxPA;EACI,mDAAA;EACA,yBAAA;AJ2PJ;AI1PI;EACI,mDAAA;EACA,yBAAA;AJ4PR;;AIzPA;EACI,iDAAA;EACA,yBAAA;AJ4PJ;AI3PI;EACI,iDAAA;EACA,yBAAA;AJ6PR;;AI1PA;EACI,qDAAA;EACA,yBAAA;AJ6PJ;AI5PI;EACI,qDAAA;EACA,yBAAA;AJ8PR;;AI3PA;EACI,yBDtPO;AHofX;;AI5PA;EACI,yBDxPO;AHufX;;AI7PA;EACI,yBD1PO;AH0fX;;AI9PA;EACI,yBD5PO;AH6fX;;AI/PA;EACI,yBD9PO;AHggBX;;AIhQA;EACI,yBDhQO;AHmgBX;;AIjQA;EACI,yBDlQO;AHsgBX;;AIlQA;EACI,yBDpQO;AHygBX;;AInQA;EACI,yBDtQO;AH4gBX;;AIpQA;EACI,aD1XM;AHioBV;;AIrQA;EACI,aD3XQ;AHmoBZ;;AItQA;EACI,aD5XM;AHqoBV;;AIvQA;EACI,aDzXK;AHmoBT;;AIxQA;EACI,aD9XM;AHyoBV;;AIzQA;EACI,aD3XI;AHuoBR;;AI1QA;EACI,aD7XI;AH0oBR;;AI3QA;EACI,aD9XG;AH4oBP;;AI5QA;EACI,aD3XK;AH0oBT;;AI7QA;EACI,aDrYK;AHqpBT;;AI9QA;EACI,aDhYK;AHipBT;;AI/QA;EACI,aDrZG;AHuqBP;;AIhRA;EACI,aDrYK;AHwpBT;;AIjRA;EACE,aDpZM;AHwqBR;;AIlRA;EACE,aDxZK;AH6qBP;;AInRA;EACE,aDpZK;AH0qBP;;AIpRA;EACE,aDzRW;AHgjBb;;AIrRA;EACE,WAAA;EACA,YAAA;EACA,kBDxNc;ECyNd,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;AJwRF;;AItRA;EACE,uBAAA;EACA,kBDhOc;ECiOd,sDDxNW;AHifb;;AIvRA;EACI,WAAA;EACA,YAAA;EACA,kBDtOY;ECuOZ,qBAAA;EACA,sBAAA;AJ0RJ;;AAnuBA,0BAAA;AKRA;EACI,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBFkOY;EEjOZ,cFwBI;EEvBJ,gBFFiB;AHivBrB;AK9uBI;EACI,cFqBA;AH2tBR;AK9uBI;EACI,WAAA;EACA,YAAA;EACA,kBFyNQ;AHuhBhB;AK9uBI;EACI,kBAAA;ALgvBR;AK/uBQ;EACI,kBAAA;ALivBZ;AK9uBI;EACI,gBAAA;ALgvBR;AK/uBQ;EACI,gBAAA;ALivBZ;AK9uBI;EACI,kBAAA;EACA,sBAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ALgvBR;AK7uBQ;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;EACA,oCAAA;EACA,UAAA;AL+uBZ;AK5uBI;EACI,yBFnCE;AHixBV;AK5uBI;EACI,yBFmEG;AH2qBX;AK5uBI;EACI,cAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AL8uBR;AK7uBQ;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,yBAAA;AL+uBZ;AK5uBI;EACI,cAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AL8uBR;AK7uBQ;EACI,eAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;EACA,uBAAA;EACA,0BAAA;AL+uBZ;AK5uBY;EACI,aAAA;EACA,cAAA;AL8uBhB;AK1uBI;EACI,aAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AL4uBR;AK3uBQ;EACI,eAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,sBAAA;AL6uBZ;AK1uBY;EACI,cAAA;EACA,eAAA;AL4uBhB;AKzuBQ;EACI,aAAA;EACA,cAAA;AL2uBZ;AKxuBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AL0uBR;AKzuBQ;EACI,uBAAA;EACA,wBAAA;AL2uBZ;AKxuBY;EACI,aAAA;EACA,cAAA;AL0uBhB;AKvuBQ;EACI,aAAA;EACA,cAAA;ALyuBZ;AKtuBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;ALwuBR;AKvuBQ;EACI,sBAAA;EACA,uBAAA;ALyuBZ;AKtuBY;EACI,cAAA;EACA,eAAA;ALwuBhB;AKpuBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;ALsuBR;AKruBQ;EACI,sBAAA;EACA,sBAAA;ALuuBZ;AKpuBY;EACI,cAAA;EACA,eAAA;EACA,wBAAA;ALsuBhB;AKluBI;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;ALouBR;AKnuBQ;EACI,sBAAA;EACA,sBAAA;ALquBZ;AKluBY;EACI,cAAA;EACA,eAAA;EACA,wBAAA;ALouBhB;;AK/tBA;EACI,UAAA;ALkuBJ;AKhuBQ;EACI,uBAAA;ALkuBZ;AKjuBY;EACI,UAAA;ALmuBhB;AK9tBQ;EACI,cAAA;EACA,eAAA;ALguBZ;AK/tBY;EACI,kBAAA;ALiuBhB;AK9tBQ;EACI,mBAAA;ALguBZ;AK5tBQ;EACI,WAAA;EACA,YAAA;AL8tBZ;AK7tBY;EACI,iBAAA;AL+tBhB;AK5tBQ;EACI,uBAAA;AL8tBZ;AK3tBI;EACI,uCAAA;EACA,qCAAA;EACA,sBAAA;EACA,gCAAA;AL6tBR;AK5tBQ;EACI,+BAAA;AL8tBZ;AK5tBQ;EACI,UAAA;EACA,gCAAA;AL8tBZ;;AK1tBA;EAGC,oBAAA;AL6tBD;AK5tBC;EACC,eAAA;EACA,gBAAA;AL8tBF;AK7tBE;;EAEC,yBAAA;EACA,iBAAA;AL+tBH;AK3tBE;EACC,uBAAA;AL6tBH;AK5tBG;EACC,UAAA;AL8tBJ;AKztBE;EACC,cAAA;EACA,eAAA;AL2tBH;AK1tBG;EACC,kBAAA;AL4tBJ;AKztBE;EACC,mBAAA;AL2tBH;AKvtBE;EACC,WAAA;EACA,YAAA;ALytBH;AKxtBG;EACC,iBAAA;AL0tBJ;AKvtBE;EACC,uBAAA;ALytBH;;AMr/BA;;EAEC,yBHwBS;EGvBT,kBAAA;ANw/BD;;AMt/BA;EACC,4BHoBS;AHq+BV;;AMv/BA;EACI,uBAAA;AN0/BJ;;AMx/BA;EACI,gCAAA;AN2/BJ;;AOvgCA;EACI,mBJiBM;EIhBN,cJ8BI;EI7BJ,eJ0PW;EIzPX,gBJKe;EFoGhB,kBMxG+B;EN2FhC,yBM1FsB;AP4gCxB;AO3gCI;EACI,mBJWQ;EIVR,cJuBA;AHs/BR;ACp+BI;EMlDJ;IAYQ,eAAA;EP8gCN;AACF;;AO5gCA;EACI,iBAAA;AP+gCJ;;AO7gCA;EACI,mBJ6GO;EI5GP,cJYI;EIXJ,eJwOW;EIvOX,gBJbe;EFoGhB,kBMtF+B;ENyEhC,yBMxEsB;APkhCxB;AOjhCI;EACI,mBAAA;EACA,cJKA;AH8gCR;AC5/BI;EMhCJ;IAYQ,eAAA;EPohCN;AACF;;AOlhCA;EACI,iBAAA;EACA,YAAA;APqhCJ;;AOnhCA;EACI,iBAAA;EACA,YAAA;APshCJ;;AOphCA;EACI,cJVI;EIWJ,yBJzBM;EI0BN,qBJ1BM;AHijCV;;AOrhCA;EACI,mBJnBK;EIoBL,cJhBI;EIiBJ,eJ4MW;EI3MX,gBJzCe;EI0Cf,kBAAA;EN0DD,iBMzD+B;EN4ChC,yBM3CsB;AP0hCxB;AOzhCI;EACI,mBJ3BC;EI4BD,cJxBA;AHmjCR;ACjiCI;EMJJ;IAaQ,eAAA;EP4hCN;AACF;;AO1hCA;EACI,mBJ7CM;EI8CN,cJhCI;EIiCJ,eJ4LW;EI3LX,gBJzDe;EI0Df,kBAAA;EN0CD,iBMzC+B;EN4BhC,yBM3BsB;AP+hCxB;AO9hCI;EACI,mBJpDQ;EIqDR,cJxCA;AHwkCR;ACtjCI;EMYJ;IAaQ,eAAA;IACA,gBAAA;EPiiCN;AACF;;AO/hCA;EACI,mBJmFS;EIlFT,cJjDI;EIkDJ,eJ2KW;EI1KX,gBJ1Ee;EI2Ef,kBAAA;ENyBD,iBMxB+B;ENWhC,yBMVsB;APoiCxB;AOniCI;EACI,mBJpEI;EIqEJ,cJzDA;AH8lCR;AC5kCI;EM6BJ;IAaQ,eAAA;IACA,gBAAA;EPsiCN;AACF;;AOpiCA;EACI,mBJ/EM;EF2FP,iBMX+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBJpGe;EIqGf,eJ+IW;EI9IX,kBAAA;EACA,kBAAA;APuiCJ;AOtiCI;EACI,mBJ/FQ;EIgGR,cJnFA;AH2nCR;AOtiCI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;APwiCR;;AOriCA;EACI,mBJxGQ;EFyFT,iBMgB+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBJ/He;EIgIf,eJoHW;EInHX,kBAAA;EACA,kBAAA;APwiCJ;AOviCI;EACI,mBJVG;EIWH,cJ9GA;AHupCR;AOviCI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;APyiCR;;AOtiCA;EACI,mBJ3HK;EFiFN,iBM2C+B;EAG9B,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,gBJ1Je;EI2Jf,eJyFW;EIxFX,kBAAA;EACA,kBAAA;APyiCJ;AOxiCI;EACI,mBJ5IC;EI6ID,cJzIA;AHmrCR;AOxiCI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AP0iCR;;AOtiCA;EACI,iBAAA;EACA,WAAA;EACA,gBJ5Ke;EI6Kf,eJuEW;EItEX,kBAAA;APyiCJ;AOxiCI;EACI,WAAA;EACA,YAAA;AP0iCR;;AOviCA;EACI,yBJ5KM;EI6KN,qBJ7KM;AHutCV;;AOxiCA;EACI,yBJhLM;EIiLN,qBJjLM;EIkLN,yBAAA;AP2iCJ;;AOxiCI;EACI,SAAA;AP2iCR;;AOtiCQ;EACI,6BAAA;EACA,yBAAA;APyiCZ;AOxiCY;EACI,cJ7LJ;AHuuCZ;;AOniCQ;EACI,kBAAA;APsiCZ;;AOliCA;EACI,YAAA;APqiCJ;;AOniCA;EACI,eAAA;APsiCJ;AOriCI;EACI,UAAA;EACA,gBAAA;APuiCR;;AOpiCA;EACI,kBJEe;EIDf,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBJrOmB;AH4wCvB;AOtiCI;EACI,2BAAA;APwiCR;AOtiCI;EACI,oBAAA;APwiCR;AOtiCI;EACI,qBAAA;EACA,kBAAA;APwiCR;AOtiCI;EACI,uBAAA;EACA,kBAAA;APwiCR;AOpiCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,+CAAA;APsiCZ;AOriCY;EAKI,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,yBAAA;APmiChB;AOhjCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,4CAAA;APkjCZ;AOjjCY;EAKI,oCAAA;EACA,oCAAA;EACA,2CAAA;EACA,yBAAA;AP+iChB;AO5jCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,+CAAA;AP8jCZ;AO7jCY;EAKI,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,yBAAA;AP2jChB;AOxkCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,+CAAA;AP0kCZ;AOzkCY;EAKI,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,yBAAA;APukChB;AOplCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,8CAAA;APslCZ;AOrlCY;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,yBAAA;APmlChB;AOhmCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,4CAAA;APkmCZ;AOjmCY;EAKI,oCAAA;EACA,oCAAA;EACA,2CAAA;EACA,yBAAA;AP+lChB;AO5mCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,6CAAA;AP8mCZ;AO7mCY;EAKI,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,yBAAA;AP2mChB;AOxnCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,gDAAA;AP0nCZ;AOznCY;EAKI,oCAAA;EACA,oCAAA;EACA,+CAAA;EACA,yBAAA;APunChB;AOpoCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,0CAAA;APsoCZ;AOroCY;EAKI,kCAAA;EACA,kCAAA;EACA,yCAAA;EACA,yBAAA;APmoChB;AOhpCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,gDAAA;APkpCZ;AOjpCY;EAKI,oCAAA;EACA,oCAAA;EACA,+CAAA;EACA,yBAAA;AP+oChB;AO5pCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,8CAAA;AP8pCZ;AO7pCY;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,yBAAA;AP2pChB;AOxqCQ;EACI,oCAAA;EACA,oCAAA;EACA,cJjOJ;EIkOI,8CAAA;AP0qCZ;AOzqCY;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,yBAAA;APuqChB;AOnqCI;EACI,yBJjPA;EIkPA,yBAAA;EACA,yBAAA;APqqCR;AOpqCQ;EAKI,uBAAA;EACA,uBAAA;EACA,+CAAA;EACA,yBAAA;APkqCZ;;AO5pCI;EACE,wBAAA;AP+pCN;;AO3pCI;EACE,qBAAA;AP8pCN;;AO1pCI;EACE,uBAAA;AP6pCN;;AOzpCI;EACE,mBAAA;AP4pCN;AO1pCI;EACE,mBAAA;AP4pCN;AO1pCI;EACE,mBAAA;AP4pCN;AO1pCI;EACE,mBAAA;AP4pCN;;AOxpCI;EACE,aAAA;EACA,eAAA;AP2pCN;AOzpCI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AP2pCN;AOzpCI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;AP2pCN;;AOvpCI;EACE,6BAAA;AP0pCN;;AOrpCM;;;;EAIE,6BAAA;APwpCR;;AOnpCE;EACE,yBAAA;APspCJ;;AOppCE;EACE,gBAAA;APupCJ;;AOrpCA;EACI,4BAAA;APwpCJ;;AOtpCE;EACE,4BAAA;APypCJ;;AOtpCE;EACE,0BAAA;APypCJ;;AOvpCE;EACE,0BAAA;AP0pCJ;;AOvpCE;EACE,yCAAA;EACA,cJjWM;AH2/CV;AOzpCI;EAGE,yBJrWI;EIsWJ,cJxVE;EIyVF,qBJvWI;AHggDV;AOtpCE;EACE,sCAAA;EACA,cJ1WQ;AHkgDZ;AOvpCI;EAGE,yBJ9WM;EI+WN,cJnWE;EIoWF,qBJhXM;AHugDZ;AOppCE;EACE,wCAAA;EACA,cJ/WM;AHqgDV;AOrpCI;EAGE,yBJnXI;EIoXJ,cJ9WE;EI+WF,qBJrXI;AH0gDV;AOlpCE;EACE,yCAAA;EACA,cJ5XG;AHghDP;AOnpCI;EAGE,yBJhYC;EIiYD,cJzXE;EI0XF,qBJlYC;AHqhDP;AOhpCE;EACE,yCAAA;EACA,cJzYM;AH2hDV;AOjpCI;EAGE,yBJ7YI;EI8YJ,cJpYE;EIqYF,qBJ/YI;AHgiDV;AO9oCE;EACE,sCAAA;EACA,cJ9YK;AH8hDT;AO/oCI;EAGE,yBJlZG;EImZH,cJ/YE;EIgZF,qBJpZG;AHmiDT;;AO1oCE;EACE,6BAAA;EACA,cJraM;EIsaN,yBAAA;AP6oCJ;AO5oCI;EACE,cJxaI;EIyaJ,yBAAA;EACA,6BAAA;AP8oCN;AO3oCE;EACE,6BAAA;EACA,cJ7aQ;EI8aR,yBAAA;AP6oCJ;AO5oCI;EACE,cJhbM;EIibN,yBAAA;EACA,6BAAA;AP8oCN;AO3oCE;EACE,6BAAA;EACA,cJjbM;EIkbN,yBAAA;AP6oCJ;AO5oCI;EACE,cJpbI;EIqbJ,yBAAA;EACA,6BAAA;AP8oCN;AO3oCE;EACE,6BAAA;EACA,cJ7bG;EI8bH,yBAAA;AP6oCJ;AO5oCI;EACE,cJhcC;EIicD,yBAAA;EACA,6BAAA;AP8oCN;AO3oCE;EACE,6BAAA;EACA,cJzcM;EI0cN,yBAAA;AP6oCJ;AO5oCI;EACE,cJ5cI;EI6cJ,yBAAA;EACA,6BAAA;AP8oCN;AO3oCE;EACE,6BAAA;EACA,cJ7cK;EI8cL,yBAAA;AP6oCJ;AO5oCI;EACE,cJhdG;EIidH,yBAAA;EACA,6BAAA;AP8oCN;;AOzoCE;EACE,6BAAA;AP4oCJ;;AOzoCA;EACI,oCAAA;EACA,yBAAA;AP4oCJ;AO3oCI;EAKI,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,yBAAA;APyoCR;;AOtoCA;EACI,oCAAA;EACA,yBAAA;APyoCJ;AOxoCI;EAKI,oCAAA;EACA,oCAAA;EACA,2CAAA;EACA,yBAAA;APsoCR;;AOnoCA;EACI,oCAAA;EACA,yBAAA;APsoCJ;AOroCI;EAKI,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,yBAAA;APmoCR;;AOhoCA;EACI,oCAAA;EACA,yBAAA;APmoCJ;AOloCI;EAKI,oCAAA;EACA,oCAAA;EACA,2CAAA;EACA,yBAAA;APgoCR;;AO7nCA;EACI,oCAAA;EACA,yBAAA;APgoCJ;AO/nCI;EAKI,oCAAA;EACA,oCAAA;EACA,6CAAA;EACA,yBAAA;AP6nCR;;AO1nCA;EACI,oCAAA;EACA,yBAAA;AP6nCJ;AO5nCI;EAKI,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,yBAAA;AP0nCR;;AOvnCA;EACI,yBAAA;EACA,yBAAA;AP0nCJ;AOznCI;EAKI,yBJpjBA;EIqjBA,yBAAA;EACA,yBAAA;APunCR;;AOpnCA;EACI,oCAAA;EACA,yBAAA;APunCJ;AOtnCI;EAKI,oCAAA;EACA,oCAAA;EACA,4CAAA;EACA,yBAAA;APonCR;;AOjnCA;EACI,oCAAA;EACA,yBAAA;APonCJ;AOnnCI;EAKG,8CAAA;EACA,qBJ7lBG;AH8sDV;;AO9mCA;EACI,oCAAA;EACA,yBAAA;APinCJ;AOhnCI;EAKG,2CAAA;EACA,qBJvmBK;AHqtDZ;;AO3mCA;EACI,oCAAA;EACA,yBAAA;AP8mCJ;AO7mCI;EAKG,8CAAA;EACA,qBJjnBG;AH4tDV;;AOxmCA;EACI,oCAAA;EACA,yBAAA;AP2mCJ;AO1mCI;EAKG,2CAAA;EACA,qBJvnBE;AH+tDT;;AOrmCA;EACI,oCAAA;EACA,yBAAA;APwmCJ;AOvmCI;EAKG,6CAAA;EACA,qBJroBG;AH0uDV;;AOlmCA;EACI,oDAAA;EACA,yBAAA;APqmCJ;AOpmCI;EAKG,8CAAA;EACA,qBJnpBA;AHqvDP;;AO/lCA;EACI,qDAAA;EACA,yBAAA;APkmCJ;AOjmCI;EAKG,+CAAA;EACA,qBJxpBC;EIypBD,qBJrhBM;AHonDb;;AO5lCA;EACI,kDAAA;EACA,yBAAA;AP+lCJ;AO9lCI;EAKG,4CAAA;EACA,qBJtqBA;AHkwDP;;AQ/xDI;EACI,mCAAA;EACA,6CAAA;EACA,cLcE;AHoxDV;;AQ5xDQ;EACI,mBAAA;EACA,6CAAA;EACA,cLmBJ;AH4wDR;AQ7xDQ;EACI,mCAAA;EACA,6CAAA;EACA,cLkIG;AH6pDf;;AQvyDQ;EACI,mBAAA;EACA,0CAAA;EACA,cLmBJ;AHuxDR;AQxyDQ;EACI,gCAAA;EACA,0CAAA;EACA,cLkIG;AHwqDf;;AQlzDQ;EACI,mBAAA;EACA,6CAAA;EACA,cLmBJ;AHkyDR;AQnzDQ;EACI,mCAAA;EACA,6CAAA;EACA,cLkIG;AHmrDf;;AQ7zDQ;EACI,mBAAA;EACA,6CAAA;EACA,cLmBJ;AH6yDR;AQ9zDQ;EACI,mCAAA;EACA,6CAAA;EACA,cLkIG;AH8rDf;;AQx0DQ;EACI,mBAAA;EACA,4CAAA;EACA,cLmBJ;AHwzDR;AQz0DQ;EACI,kCAAA;EACA,4CAAA;EACA,cLkIG;AHysDf;;AQn1DQ;EACI,mBAAA;EACA,0CAAA;EACA,cLmBJ;AHm0DR;AQp1DQ;EACI,gCAAA;EACA,0CAAA;EACA,cLkIG;AHotDf;;AQ91DQ;EACI,mBAAA;EACA,2CAAA;EACA,cLmBJ;AH80DR;AQ/1DQ;EACI,iCAAA;EACA,2CAAA;EACA,cLkIG;AH+tDf;;AQz2DQ;EACI,mBAAA;EACA,8CAAA;EACA,cLmBJ;AHy1DR;AQ12DQ;EACI,oCAAA;EACA,8CAAA;EACA,cLkIG;AH0uDf;;AQp3DQ;EACI,mBAAA;EACA,wCAAA;EACA,cLmBJ;AHo2DR;AQr3DQ;EACI,8BAAA;EACA,wCAAA;EACA,cLkIG;AHqvDf;;AQ/3DQ;EACI,mBAAA;EACA,8CAAA;EACA,cLmBJ;AH+2DR;AQh4DQ;EACI,oCAAA;EACA,8CAAA;EACA,cLkIG;AHgwDf;;AQ14DQ;EACI,mBAAA;EACA,4CAAA;EACA,cLmBJ;AH03DR;AQ34DQ;EACI,kCAAA;EACA,4CAAA;EACA,cLkIG;AH2wDf;;AQr5DQ;EACI,mBAAA;EACA,4CAAA;EACA,cLmBJ;AHq4DR;AQt5DQ;EACI,kCAAA;EACA,4CAAA;EACA,cLkIG;AHsxDf;;AQp5DA;EACI,wBAAA;EACA,0BAAA;EACA,gBLjBmB;EKkBnB,qBAAA;EACA,kBL8MY;AHysDhB;AQt5DI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;ARw5DR;AQt5DI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;ARw5DR;AQt5DI;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;ARw5DR;AQt5DI;EACI,eLiNO;EKhNP,iBAAA;EACA,iBAAA;ARw5DR;AQt5DI;EACI,eL8MO;EK7MP,iBAAA;EACA,iBAAA;ARw5DR;;AS38DA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBN0BI;AHo7DR;;AS58DA;EACI,oCAAA;AT+8DJ;AS98DI;EACI,+BAAA;ATg9DR;AS98DI;EACI,+BAAA;ATg9DR;AS98DI;EACI,oCAAA;EACA,UAAA;ATg9DR;AS/8DQ;EACI,gDAAA;ATi9DZ;AS/8DQ;EACI,iDAAA;ATi9DZ;AS/8DQ;EACI,gDAAA;ATi9DZ;AS/8DQ;EACI,iDAAA;ATi9DZ;AS/8DQ;EACI,gCAAA;ATi9DZ;AS98DI;EACI,oCAAA;EACA,UAAA;ATg9DR;AS/8DQ;EACI,6CAAA;ATi9DZ;AS/8DQ;EACI,8CAAA;ATi9DZ;AS/8DQ;EACI,6CAAA;ATi9DZ;AS/8DQ;EACI,8CAAA;ATi9DZ;AS/8DQ;EACI,gCAAA;ATi9DZ;AS98DI;EACI,oCAAA;EACA,UAAA;ATg9DR;AS/8DQ;EACI,gDAAA;ATi9DZ;AS/8DQ;EACI,iDAAA;ATi9DZ;AS/8DQ;EACI,gDAAA;ATi9DZ;AS/8DQ;EACI,iDAAA;ATi9DZ;AS/8DQ;EACI,gCAAA;ATi9DZ;AS98DI;EACI,oCAAA;EACA,UAAA;ATg9DR;AS/8DQ;EACI,gDAAA;ATi9DZ;AS/8DQ;EACI,iDAAA;ATi9DZ;AS/8DQ;EACI,gDAAA;ATi9DZ;AS/8DQ;EACI,iDAAA;ATi9DZ;AS/8DQ;EACI,gCAAA;ATi9DZ;AS98DI;EACI,oCAAA;EACA,UAAA;ATg9DR;AS/8DQ;EACI,+CAAA;ATi9DZ;AS/8DQ;EACI,gDAAA;ATi9DZ;AS/8DQ;EACI,+CAAA;ATi9DZ;AS/8DQ;EACI,gDAAA;ATi9DZ;AS/8DQ;EACI,gCAAA;ATi9DZ;AS98DI;EACI,oCAAA;EACA,UAAA;ATg9DR;AS/8DQ;EACI,6CAAA;ATi9DZ;AS/8DQ;EACI,8CAAA;ATi9DZ;AS/8DQ;EACI,6CAAA;ATi9DZ;AS/8DQ;EACI,8CAAA;ATi9DZ;AS/8DQ;EACI,4BAAA;ATi9DZ;AS98DI;EACI,oCAAA;EACA,UAAA;ATg9DR;AS/8DQ;EACI,iDAAA;ATi9DZ;AS/8DQ;EACI,kDAAA;ATi9DZ;AS/8DQ;EACI,iDAAA;ATi9DZ;AS/8DQ;EACI,kDAAA;ATi9DZ;AS/8DQ;EACI,8BAAA;ATi9DZ;AS98DI;EACI,oCAAA;EACA,UAAA;ATg9DR;AS/8DQ;EACI,iDAAA;ATi9DZ;AS/8DQ;EACI,kDAAA;ATi9DZ;AS/8DQ;EACI,iDAAA;ATi9DZ;AS/8DQ;EACI,kDAAA;ATi9DZ;AS/8DQ;EACI,gCAAA;ATi9DZ;AS98DI;EACI,oCAAA;EACA,UAAA;ATg9DR;AS/8DQ;EACI,8CAAA;ATi9DZ;AS/8DQ;EACI,+CAAA;ATi9DZ;AS/8DQ;EACI,8CAAA;ATi9DZ;AS/8DQ;EACI,+CAAA;ATi9DZ;AS/8DQ;EACI,gCAAA;ATi9DZ;AS98DI;EACI,oCAAA;EACA,UAAA;ATg9DR;AS/8DQ;EACI,+CAAA;ATi9DZ;AS/8DQ;EACI,gDAAA;ATi9DZ;AS/8DQ;EACI,+CAAA;ATi9DZ;AS/8DQ;EACI,gDAAA;ATi9DZ;AS/8DQ;EACI,+BAAA;ATi9DZ;AS98DI;EACI,mCAAA;ATg9DR;AS98DI;EACI,oCAAA;ATg9DR;AS98DI;EACI,mCAAA;ATg9DR;AS98DI;EACI,oCAAA;ATg9DR;AS98DI;EACI,iCAAA;ATg9DR;AS98DI;EACI,4BAAA;ATg9DR;AS98DI;EACI,4BAAA;ATg9DR;AS98DI;EACI,4BAAA;ATg9DR;AS98DI;EACI,4BAAA;ATg9DR;AS98DI;EACI,4BAAA;ATg9DR;AS98DI;EACI,wBAAA;ATg9DR;AS98DI;EACI,wBAAA;ATg9DR;AS98DI;EACI,+BAAA;ATg9DR;AS98DI;EACI,+BAAA;ATg9DR;AS98DI;EACI,2BAAA;ATg9DR;AS98DI;EACI,2BAAA;ATg9DR;AS98DI;EACI,iCAAA;ATg9DR;AS98DI;EACI,iCAAA;ATg9DR;AS98DI;EACI,oBAAA;ATg9DR;AS98DI;EACI,gCAAA;ATg9DR;AS98DI;EACI,+BAAA;ATg9DR;AS98DI;EACI,8BAAA;ATg9DR;AS98DI;EACI,iCAAA;ATg9DR;;AS78DA;EACI,wCAAA;ATg9DJ;AS/8DI;EACI,mCAAA;ATi9DR;AS/8DI;EACI,mCAAA;ATi9DR;AS/8DI;EACI,gCAAA;ATi9DR;AS/8DI;EACI,gCAAA;ATi9DR;AS/8DI;EACI,gCAAA;ATi9DR;AS/8DI;EACI,gCAAA;ATi9DR;AS/8DI;EACI,gCAAA;ATi9DR;AS/8DI;EACI,gCAAA;ATi9DR;AS/8DI;EACI,gCAAA;ATi9DR;AS/8DI;EACI,gCAAA;ATi9DR;;AS98DA;EACI,+CAAA;ATi9DJ;ASh9DI;EACI,0CAAA;ATk9DR;ASh9DI;EACI,0CAAA;ATk9DR;ASh9DI;EACI,gCAAA;ATk9DR;ASh9DI;EACI,gCAAA;ATk9DR;ASh9DI;EACI,gCAAA;ATk9DR;ASh9DI;EACI,gCAAA;ATk9DR;ASh9DI;EACI,gCAAA;ATk9DR;ASh9DI;EACI,gCAAA;ATk9DR;ASh9DI;EACI,gCAAA;ATk9DR;ASh9DI;EACI,gCAAA;ATk9DR;;AS/8DA;EACI,2CAAA;ATk9DJ;ASj9DI;EACI,sCAAA;ATm9DR;ASj9DI;EACI,sCAAA;ATm9DR;ASj9DI;EACI,gCAAA;ATm9DR;ASj9DI;EACI,gCAAA;ATm9DR;ASj9DI;EACI,gCAAA;ATm9DR;ASj9DI;EACI,gCAAA;ATm9DR;ASj9DI;EACI,gCAAA;ATm9DR;ASj9DI;EACI,gCAAA;ATm9DR;ASj9DI;EACI,gCAAA;ATm9DR;ASj9DI;EACI,gCAAA;ATm9DR;;ASh9DA;EACI,iDAAA;ATm9DJ;ASl9DI;EACI,4CAAA;ATo9DR;ASl9DI;EACI,4CAAA;ATo9DR;ASl9DI;EACI,gCAAA;ATo9DR;ASl9DI;EACI,gCAAA;ATo9DR;ASl9DI;EACI,gCAAA;ATo9DR;ASl9DI;EACI,gCAAA;ATo9DR;ASl9DI;EACI,gCAAA;ATo9DR;ASl9DI;EACI,gCAAA;ATo9DR;ASl9DI;EACI,gCAAA;ATo9DR;ASl9DI;EACI,gCAAA;ATo9DR;;ASj9DA;EACI,wBAAA;ATo9DJ;;ASl9DA;EACI,uBAAA;ATq9DJ;;ASn9DA;EACI,wBAAA;ATs9DJ;;ASp9DA;EACI,sBAAA;ATu9DJ;;ASr9DA;EACI,wBAAA;ATw9DJ;;ASt9DA;EACI,uBAAA;ATy9DJ;;ASv9DA;EACI,wBAAA;AT09DJ;;ASx9DA;EACI,qBAAA;AT29DJ;;ASz9DA;EACI,wBAAA;AT49DJ;;AS19DA;EACI,uBAAA;AT69DJ;;AS39DA;EACI,wBAAA;AT89DJ;;AS59DA;EACI,sBAAA;AT+9DJ;;AS79DA;EACI,6BAAA;ATg+DJ;;AU55EA;EACI,6BAAA;EACA,YAAA;ET2GD,kBS1G4B;AV+5E/B;;AU75EA;EACC,qBPuHU;EOtHP,yBPyBI;AHu4ER;;AU95EA;EACI,iBAAA;AVi6EJ;;AU/5EA;EACC,WAAA;EACA,gBAAA;AVk6ED;;AUh6EA;EACI,qBAAA;AVm6EJ;;AUj6EA;EACC,gBAAA;AVo6ED;;AUl6EA;EACC,ePyOc;EOxOd,gBPhBsB;EOiBtB,iCAAA;EACA,iBAAA;EACA,yBAAA;AVq6ED;;AUn6EA;EACC,iCAAA;AVs6ED;;AUp6EA;EACC,mBPDO;AHw6ER;;AUr6EA;;;;;EAKC,UAAA;AVw6ED;;AUt6EA;EACC,mBPkFU;EOjFV,ePiNc;EOhNd,iBAAA;EACA,eAAA;EACA,yBAAA;AVy6ED;;AUv6EA;;;;;;;EAOC,qBAAA;AV06ED;;AUx6EA;;EAEI,gBAAA;AV26EJ;;AUz6EA;EACC,mBAAA;EACA,YAAA;EACA,cAAA;EACA,0BAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;EACA,4BAAA;EACA,uBAAA;AV46ED;;AU16EA;EACC,oBAAA;EACA,ePoLc;AHyvEf;;AU36EA;EACC,mBAAA;AV86ED;;AU56EA;EACC,mBAAA;AV+6ED;;AU76EA;;;EAGC,oCAAA;EACA,yBAAA;EACA,4BAAA;AVg7ED;;AU96EA;EACC,mBAAA;AVi7ED;;AU/6EA;EACC,mBP9DO;AHg/ER;;AUh7EA;EACC,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AVm7ED;;AUj7EA;EACC,kBAAA;EACA,gBPnGkB;EOoGlB,iCAAA;AVo7ED;;AUl7EA;EACC,kBAAA;EACA,gBPxGkB;EOyGlB,iCAAA;AVq7ED;;AUn7EA;EACC,YAAA;AVs7ED;;AUp7EA;EACC,kBAAA;EACA,gBAAA;AVu7ED;;AUr7EA;EACI,mBAAA;EACA,ePmIW;EOlIX,gBPtHmB;EOuHnB,gBAAA;EACA,kBAAA;AVw7EJ;;AWxjFA;EACI,aAAA;AX2jFJ;;AWzjFA;EACI,wBAAA;AX4jFJ;;AW1jFA;;EAEI,gBAAA;AX6jFJ;;AW3jFA;EACI,sBAAA;AX8jFJ;;AYtkFG;EACC,WAAA;EACA,aAAA;AZykFJ;;AYpkFA;EACC,cAAA;AZukFD;;AYrkFA;EACC,SAAA;AZwkFD;;AYnkFE;EACI,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBTnBiB;AHylFvB;AYnkFE;EACC,cTCK;AHokFR;AYlkFC;EACC,iCTtBoB;AH0lFtB;;AYjkFA;EACE,qBTuFS;EStFT,qDAAA;EACA,mBAAA;EACA,cTyHW;ESxHX,yBTXM;ESYN,UAAA;EACA,WAAA;AZokFF;;AYlkFA;EACE,qBT8ES;AHu/EX;;AYlkFA;EACE,cT+GW;AHs9Eb;;AYnkFA;EACE,cT4GW;AH09Eb;;AYpkFA;EACE,cTyGW;ESxGX,kBAAA;EACA,yBAAA;EACA,oBAAA;AZukFF;AYrkFE;EAEE,cTkGS;ESjGT,YAAA;AZskFJ;AYnkFI;EAGE,cTtDI;ESuDJ,0CAAA;AZmkFN;AYhkFE;EACE,oCAAA;AZkkFJ;;AY/jFA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBThFqB;AHkpFvB;;AYhkFA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBT1FqB;AH6pFvB;;AYhkFA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBTrGqB;AHwqFvB;;AYjkFA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBT/GqB;AHmrFvB;;AYlkFA;EACE,qBAAA;EACA,4BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kCAAA;EACA,SAAA;EACA,iBAAA;EACA,gBTzHqB;AH8rFvB;;AYnkFA;EACE,aAAA;AZskFF;;AYnkFA;EACE,yBT1GK;ES2GL,sCAAA;AZskFF;AYrkFE;EACE,cT3GI;AHkrFR;;AYnkFC;EACC,mBAAA;AZskFF;AYnkFE;EACC,wBAAA;AZqkFH;AYjkFE;EACC,wBAAA;AZmkFH;AY5iFE;EAbE,yBTjJM;AH6sFV;AY3jFI;EACE,+BAAA;AZ6jFN;AY1jFM;EAIE,cT5IA;AHqsFR;AYljFE;EAhBE,yBT/IQ;AHotFZ;AYpkFI;EACE,+BAAA;AZskFN;AYnkFM;EAIE,cT5IA;AH8sFR;AYxjFE;EAnBE,yBTzIM;AHutFV;AY7kFI;EACE,+BAAA;AZ+kFN;AY5kFM;EAIE,cT5IA;AHutFR;AY9jFE;EAtBE,yBT3IG;AHkuFP;AYtlFI;EACE,+BAAA;AZwlFN;AYrlFM;EAIE,cT5IA;AHguFR;AYpkFE;EAzBE,yBT7IM;AH6uFV;AY/lFI;EACE,+BAAA;AZimFN;AY9lFM;EAIE,cT5IA;AHyuFR;AY1kFE;EA5BE,yBTvIK;AHgvFT;AYxmFI;EACE,+BAAA;AZ0mFN;AYvmFM;EAIE,cT5IA;AHkvFR;;AY5kFM;EAIE,oDAAA;EACA,cTzLE;AHqwFV;AYtkFM;EAIE,iDAAA;EACA,cTlMI;AHuwFZ;AY/jFM;EAIE,mDAAA;EACA,cTvME;AHqwFV;AYxjFM;EAIE,oDAAA;EACA,cTpND;AH2wFP;AYjjFM;EAIE,0DAAA;EACA,cTjOE;AHixFV;AY1iFM;EAIE,yDAAA;EACA,cTtOC;AH+wFT;;AYvhFE;EACE,yCAAA;EAZA,mCAAA;UAAA,2BAAA;AZuiFJ;AYriFM;EAIE,cT/OA;ESgPA,oCAAA;AZoiFR;AY5hFE;EACE,yCAAA;EAhBA,mCAAA;UAAA,2BAAA;AZ+iFJ;AY7iFM;EAIE,cT/OA;ESgPA,oCAAA;AZ4iFR;AYhiFE;EACE,yCAAA;EApBA,mCAAA;UAAA,2BAAA;AZujFJ;AYrjFM;EAIE,cT/OA;ESgPA,oCAAA;AZojFR;AYpiFE;EACE,wCAAA;EAxBA,mCAAA;UAAA,2BAAA;AZ+jFJ;AY7jFM;EAIE,cT/OA;ESgPA,oCAAA;AZ4jFR;AYxiFE;EACE,yCAAA;EA5BA,mCAAA;UAAA,2BAAA;AZukFJ;AYrkFM;EAIE,cT/OA;ESgPA,oCAAA;AZokFR;AY5iFE;EACE,8CAAA;EAhCA,mCAAA;UAAA,2BAAA;AZ+kFJ;AY7kFM;EAIE,cT/OA;ESgPA,oCAAA;AZ4kFR;;AY/iFA;EACE,SAAA;AZkjFF;;AYhjFA;EACE,gBAAA;EACA,cAAA;AZmjFF;;Aar2FA;EACI,UAAA;EAGE,aAAA;EAEA,eAAA;Abw2FN;Aav2FM;EACE,cAAA;EACA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,eV4OO;EF5Hb,mBY/GuB;EACjB,yBAAA;EACA,cVLE;EF0FP,WYpF6B;EZwH9B,wCAAA;ADovFF;;Acp4FA;EACI,yBX4HO;EW3HP,eAAA;EACA,sBAAA;Adu4FJ;;Acr4FA;EACI,yBXuHO;AHixFX;;Act4FA;EACI,cXuBI;EWtBJ,yBXQM;AHi4FV;;Act4FA;EACI;IACI,QAAA;Edy4FN;AACF;Acv4FA;EACI,kBAAA;EACA,uBAAA;Ady4FJ;Acx4FI;EACI,kBAAA;EACA,uBAAA;EACA,8BAAA;Ad04FR;;Act4FI;EACI,iBAAA;Ady4FR;Acv4FI;EACI,cAAA;Ady4FR;Acv4FI;EACI,YAAA;Ady4FR;Acv4FI;EACI,eAAA;Ady4FR;;Act4FA;EACI,iBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;Ady4FJ;Acv4FI;EACI,WAAA;Ady4FR;Act4FI;EACI,WAAA;Adw4FR;Acr4FI;EACI,WAAA;Adu4FR;Acp4FI;EACI,UAAA;Ads4FR;Acn4FI;EACI,UAAA;Adq4FR;;Acl4FA;EACI,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;Adq4FJ;Acn4FI;EACI,WAAA;EACA,SAAA;EACA,kBAAA;Adq4FR;Acl4FI;EACI,WAAA;Ado4FR;Acj4FI;EACI,WAAA;Adm4FR;Ach4FI;EACI,UAAA;Adk4FR;Ac/3FI;EACI,UAAA;Adi4FR;;Ac93FA;EACI,iBAAA;EACA,kBAAA;Adi4FJ;Ach4FI;EACI,kBAAA;EACA,iBAAA;Adk4FR;Acj4FQ;EACI,WAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,uDAAA;EACA,mBXjFJ;EWkFI,kBAAA;EACA,2BAAA;EACA,4BAAA;EACA,6BAAA;Adm4FZ;Acj4FQ;EACI,6BAAA;EACA,+DAAA;Adm4FZ;Acj4FQ;EACI,6BAAA;EACA,6DAAA;Adm4FZ;Acj4FQ;EACI,6BAAA;EACA,0DAAA;Adm4FZ;Acj4FQ;EACI,6BAAA;EACA,6DAAA;Adm4FZ;Acj4FQ;EACI,6BAAA;EACA,4DAAA;Adm4FZ;Ach4FI;EACI,eAAA;EACA,eAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBX/HE;EWgIF,kDAAA;EACA,mBAAA;EACA,gBX5Ie;EW6If,cXrHA;EWsHA,kBAAA;EACA,kBAAA;EACA,uBAAA;EACA,2BAAA;Adk4FR;Acj4FQ;EACI,WAAA;EACA,0CAAA;EACA,+CAAA;EACA,6CAAA;EACA,kBAAA;EACA,0BAAA;EACA,uBAAA;Adm4FZ;Acj4FQ;EACI,yBXhJA;AHmhGZ;Acl4FY;EACI,0CAAA;Ado4FhB;Acj4FQ;EACI,yBXpJF;AHuhGV;Acl4FY;EACI,0CAAA;Ado4FhB;Acj4FQ;EACI,yBXtJF;AHyhGV;Acl4FY;EACI,0CAAA;Ado4FhB;Acj4FQ;EACI,yBX1JH;AH6hGT;Acl4FY;EACI,0CAAA;Ado4FhB;Acj4FQ;EACI,yBXpKL;AHuiGP;Acl4FY;EACI,0CAAA;Ado4FhB;;Ac93FI;EACI,oCAAA;Adi4FR;;Ac93FA;EACI,kBAAA;EACH,4BAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACG,yBXhLI;AHijGR;;Ac/3FA;EACC,uBAAA;Adk4FD;;Ach4FA;EACC,uBAAA;Adm4FD;;Acj4FA;EACC,uBAAA;Ado4FD;;Acl4FA;EACI,iBAAA;EACA,uBAAA;Adq4FJ;Acp4FI;EACI,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,sBAAA;Ads4FR;Acr4FQ;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,4BAAA;EACA,yBXxMJ;EWyMI,kBAAA;Adu4FZ;Acr4FQ;EACI,8BAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;EACA,uBAAA;EACA,mBXjNJ;EWkNI,mBAAA;EACA,gBX3OW;EW4OX,cXlOF;EWmOE,kBAAA;EACA,kBAAA;EACA,2BAAA;Adu4FZ;Act4FY;EACI,8BAAA;EACA,cXtOJ;AH8mGZ;Act4FY;EACI,8BAAA;EACA,cXpON;AH4mGV;Act4FY;EACI,8BAAA;EACA,cX1OT;AHknGP;Act4FY;EACI,8BAAA;EACA,cXhPN;AHwnGV;Act4FY;EACI,8BAAA;EACA,cX9OP;AHsnGT;;Acl4FI;EACI,yCAAA;EACA,sBAAA;Adq4FR;Acp4FQ;EACI,sCAAA;Ads4FZ;Acr4FY;EACI,cXlQJ;AHyoGZ;Acp4FQ;EACI,wCAAA;Ads4FZ;Acr4FY;EACI,cXlQN;AHyoGV;Acp4FQ;EACI,yCAAA;Ads4FZ;Acr4FY;EACI,cX1QT;AHipGP;Acp4FQ;EACI,yCAAA;Ads4FZ;Acr4FY;EACI,cXlRN;AHypGV;Acp4FQ;EACI,sCAAA;Ads4FZ;Acr4FY;EACI,cXlRP;AHypGT;Acp4FQ;EACI,sBAAA;Ads4FZ;Acp4FQ;EACI,kBAAA;EACA,0BAAA;EACA,gBX/SW;EWgTX,mBAAA;EACA,cXvSF;AH6qGV;;Ae/rGA;EACI,cZkKS;EYjKT,yBZ8BI;EY7BJ,yBAAA;AfksGJ;AejsGI;EACI,gBAAA;EACA,yBZyBA;AH0qGR;AejsGI;EACI,cZSE;EYRF,yBZqBA;EYpBA,qBZmHG;AHglGX;;AehsGA;EACI,cZiBI;EYhBJ,yBZEM;EYDN,qBZCM;AHksGV;;AejsGA;EACI,cZ+IS;EY9IT,yBZWI;EYVJ,qBZwGO;EYvGP,YAAA;AfosGJ;;Ae9rGY;EACI,gBAAA;AfisGhB;Ae/rGY;EACI,gBAAA;AfisGhB;Ae/rGY;EACI,gBAAA;AfisGhB;Ae/rGY;EACI,gBAAA;AfisGhB;;Ae3rGI;EACI,iBAAA;Af8rGR;Ae7rGQ;EACI,SAAA;EACA,kBZwLI;EYvLJ,oBAAA;Af+rGZ;Ae9rGY;EACI,gBZ5CO;AH4uGvB;Ae5rGY;EACI,kBZgLA;EY/KA,yBZxCN;EYyCM,cZ3BR;AHytGR;Ae3rGgB;EACI,kBZ0KJ;EYzKI,yBZ9CV;EY+CU,cZjCZ;AH8tGR;AexrGY;EACI,yBZxCR;EYyCQ,cZtDN;AHgvGV;;AerrGA;EACI,kBZ2JY;AH6hGhB;AevrGI;EACI,iBAAA;AfyrGR;AexrGQ;EACI,oBAAA;EACA,oBAAA;Af0rGZ;AevrGY;EACI,yBZvDR;EYwDQ,cZtEN;EYuEM,kBAAA;EACA,iBAAA;AfyrGhB;AexrGgB;EACI,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,yBZhFV;AH0wGV;AerrGY;EACI,6BAAA;AfurGhB;;AelrGA;EACI,mBAAA;EACA,gBAAA;EACA,mBAAA;AfqrGJ;AeprGI;EACI,iBAAA;AfsrGR;AerrGQ;EACI,SAAA;EACA,mBAAA;EACA,oBAAA;AfurGZ;AetrGY;EACI,gBZhHO;AHwyGvB;AeprGY;EACI,yBZ3GN;EY4GM,cZ9FR;AHoxGR;AenrGgB;EACI,yBZhHV;AHqyGV;AehrGY;EACI,yBZzGR;AH2xGR;;Ae3qGQ;EACI,oBAAA;EACA,oBAAA;EACA,kBZuFI;AHulGhB;Ae7qGY;EACI,gBZ5IO;AH2zGvB;Ae3qGY;EACI,SAAA;EACA,kBZ+EA;EY9EA,yBZzIN;EY0IM,cZ5HR;AHyyGR;Ae1qGgB;EACI,yBZ9IV;AH0zGV;AevqGY;EACI,6BAAA;AfyqGhB;;AgB/0GA;;;;;;;;;;;;EAYE,cbwJY;EavJZ,iCAAA;EACA,gBbLiB;EaMjB,gBAAA;AhBk1GF;;AgBh1GA;;EAEE,eAAA;AhBm1GF;;AgBh1GA;;EAEE,kBAAA;AhBm1GF;;AgBj1GA;;EAEE,iBAAA;AhBo1GF;;AgBl1GA;;EAEE,mBAAA;AhBq1GF;;AgBn1GA;;EAEE,eAAA;AhBs1GF;;AgBp1GA;;EAEE,mBAAA;AhBu1GF;;AgBr1GA;EACE,oBAAA;AhBw1GF;;AgBt1GA;EACE,mBAAA;AhBy1GF;;AgBv1GA;EACE,mBAAA;AhB01GF;;AgBt1GA;EACE,oBAAA;AhBy1GF;;AgBv1GA;EACE,mBAAA;AhB01GF;;AgBx1GA;EACE,oBAAA;AhB21GF;;AgBz1GA;EACE,kBAAA;AhB41GF;;AgB11GA;EACE,oBAAA;AhB61GF;;AgB31GA;EACE,mBAAA;AhB81GF;;AgB51GA;EACE,oBAAA;AhB+1GF;;AgB71GA;EACE,iBAAA;AhBg2GF;;AgB91GA;EACE,oBAAA;AhBi2GF;;AgB/1GA;EACE,mBAAA;AhBk2GF;;AgBh2GA;EACE,oBAAA;AhBm2GF;;AgBj2GA;EACE,kBAAA;AhBo2GF;;AgBl2GA;EACE,oBAAA;AhBq2GF;;AgBn2GA;EACE,mBAAA;AhBs2GF;;AgBp2GA;EACE,oBAAA;AhBu2GF;;AgBr2GA;EACE,eAAA;AhBw2GF;;AgBt2GA;EACE,oBAAA;AhBy2GF;;AgBv2GA;EACE,mBAAA;AhB02GF;;AgBx2GA;EACE,oBAAA;AhB22GF;;AgBz2GA;EACE,kBAAA;AhB42GF;;AgB12GA;EACE,oBAAA;AhB62GF;;AgB32GA;EACE,mBAAA;AhB82GF;;AgB52GA;EACE,oBAAA;AhB+2GF;;AgB72GA;EACE,iBAAA;AhBg3GF;;AgB92GA;EACE,oBAAA;AhBi3GF;;AgB/2GA;EACE,mBAAA;AhBk3GF;;AgBh3GA;EACE,oBAAA;AhBm3GF;;AgBj3GA;EACE,kBAAA;AhBo3GF;;AgBl3GA;EACE,oBAAA;AhBq3GF;;AgBn3GA;EACE,mBAAA;AhBs3GF;;AgBp3GA;EACE,eAAA;AhBu3GF;;AgBr3GA;EACE,mBAAA;AhBw3GF;;AgBt3GA;EACE,kBAAA;AhBy3GF;;AgBv3GA;EACE,mBAAA;AhB03GF;;AgBx3GA;EACE,iBAAA;AhB23GF;;AgBx3GA;EACE,yBAAA;AhB23GF;;AgBz3GA;EACE,yBAAA;AhB43GF;;AgB13GA;EACE,yBAAA;EACA,UAAA;AhB63GF;AgB53GE;EACE,0CAAA;AhB83GJ;AgB53GE;EACE,0CAAA;AhB83GJ;AgB53GE;EACE,yCAAA;AhB83GJ;;AgB33GA;EACE,yBAAA;EACA,UAAA;AhB83GF;;AgB53GA;EACE,yBAAA;EACA,UAAA;AhB+3GF;;AgB73GA;EACE,yBAAA;EACA,UAAA;AhBg4GF;;AgB93GA;EACE,yBAAA;EACA,UAAA;AhBi4GF;;AgB/3GA;EACE,yBAAA;EACA,UAAA;AhBk4GF;;AgBh4GA;EACE,yBAAA;AhBm4GF;;AgBj4GA;EACE,yBAAA;AhBo4GF;;AgBl4GA;EACE,yBAAA;AhBq4GF;;AgBn4GA;EACE,yBAAA;AhBs4GF;;AgBp4GA;EACE,yBAAA;AhBu4GF;;AgBr4GA;EACE,yBAAA;AhBw4GF;;AgBt4GA;EACE,yBAAA;AhBy4GF;;AgBv4GA;EACE,yBAAA;AhB04GF;;AgBx4GA;EACE,yBAAA;AhB24GF;;AgBz4GA;EACE,yBAAA;AhB44GF;;AgB14GA;EACE,yBAAA;AhB64GF;;AgB34GA;EACE,yBAAA;AhB84GF;;AgB54GA;EACE,yBAAA;AhB+4GF;;AgB74GA;EACE,yBAAA;AhBg5GF;;AgB94GA;EACE,cbtHS;AHugHX;;AgB/4GA;EACE,cbxHS;AH0gHX;;AgBh5GA;EACE,cb1HS;AH6gHX;;AgBj5GA;EACE,cb5HS;AHghHX;;AgBl5GA;EACE,cb9HS;AHmhHX;;AgBn5GA;EACE,cbhIS;AHshHX;;AgBp5GA;EACE,cblIS;AHyhHX;;AgBr5GA;EACE,cbpIS;AH4hHX;;AgBt5GA;EACE,cbtIS;AH+hHX;;AgBt5GA;EACE,qBAAA;EACA,cb3GW;AHogHb;AgBv5GE;EACE,oBAAA;EACA,UAAA;EACA,cbjQM;AH0pHV;;AgBr5GA;EACE,yBAAA;AhBw5GF;AgBv5GE;EAGE,yBAAA;AhBu5GJ;;AgBp5GA;EACE,yBAAA;AhBu5GF;AgBt5GE;EAGE,yBAAA;AhBs5GJ;;AgBn5GA;EACE,yBAAA;AhBs5GF;AgBr5GE;EAGE,yBAAA;AhBq5GJ;;AgBl5GA;EACE,yBAAA;AhBq5GF;AgBp5GE;EAGE,yBAAA;AhBo5GJ;;AgBj5GA;EACE,yBAAA;AhBo5GF;AgBn5GE;EAGE,yBAAA;AhBm5GJ;;AgBh5GA;EACE,yBAAA;AhBm5GF;AgBl5GE;EAGE,yBAAA;AhBk5GJ;;AgB/4GA;EACE,yBAAA;AhBk5GF;AgBj5GE;EAGE,yBAAA;AhBi5GJ;;AgB94GA;EACE,yBAAA;AhBi5GF;AgBh5GE;EAGE,yBAAA;AhBg5GJ;;AgB54GE;EACE,gCAAA;AhB+4GJ;;AgB34GA;EACE,gBAAA;EACA,8BAAA;EACA,kBAAA;AhB84GF;AgB74GE;EACE,+BAAA;EACA,cAAA;AhB+4GJ;;AgB54GA;EACE,kBAAA;EACA,gBbhWqB;EaiWrB,aAAA;EACA,kBbjIc;EakId,kBAAA;AhB+4GF;AgB94GE;EACE,gBAAA;EACA,0Bb/VW;EagWX,UAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,0BAAA;AhBg5GJ;AgB94GE;EACE,yCAAA;EACA,sCAAA;AhBg5GJ;AgB/4GI;EACE,8BAAA;AhBi5GN;AgB94GE;EACE,sCAAA;EACA,sCAAA;AhBg5GJ;AgB/4GI;EACE,2BAAA;AhBi5GN;AgB94GE;EACE,yCAAA;EACA,sCAAA;AhBg5GJ;AgB/4GI;EACE,8BAAA;AhBi5GN;AgB94GE;EACE,wCAAA;EACA,sCAAA;AhBg5GJ;AgB/4GI;EACE,6BAAA;AhBi5GN;AgB94GE;EACE,yCAAA;EACA,sCAAA;AhBg5GJ;AgB/4GI;EACE,8BAAA;AhBi5GN;AgB94GE;EACE,sCAAA;EACA,sCAAA;AhBg5GJ;AgB/4GI;EACE,2BAAA;AhBi5GN;;AgB34GE;EACE,+DAAA;AhB84GJ;AgB54GE;EACE,0DAAA;AhB84GJ;AgB54GE;EACE,wDAAA;AhB84GJ;;AgB14GA;EACE;IACE,WAAA;EhB64GF;AACF;AgBz4GE;EACE,gCAAA;EACA,iCAAA;AhB24GJ;;AgBx4GA;EACE,0BAAA;AhB24GF;;AgBz4GA;EACE,UAAA;AhB44GF;;AgB14GA;EACE,WAAA;AhB64GF;;AgB34GA;EACI,kBAAA;EACA,kBAAA;AhB84GJ;;AiBl1HA;EACE,yBAAA;EACA,kBduOc;EctOd,oBAAA;AjBq1HF;AiBp1HE;EACE,0CAAA;AjBs1HJ;AiBp1HE;EACE,edyPW;AH6lHf;AiBp1HE;EACE,sBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AjBs1HJ;AiBr1HI;EACE,ed+OS;Ec9OT,iBAAA;AjBu1HN;AiBp1HE;EACE,gBAAA;AjBs1HJ;AiBp1HE;EACE,gBdjBmB;AHu2HvB;;AiBl1HE;EACE,0CAAA;AjBq1HJ;;AiB10HA;EACE,wCAAA;EACA,cdjBQ;EckBR,oCAAA;AjB60HF;AiB50HE;EACE,cdpBM;AHk2HV;AiB50HE;EACE,cdvBM;AHq2HV;AiB70HI;EAhBF,yBdRQ;EcSR,cdHM;EcIN,UAAA;EACA,mBAAA;EACA,sDd4MW;Ec3MX,gBAAA;AjBg2HF;;AiBh1HA;EACE,yCAAA;EACA,cdvCQ;EcwCR,qCAAA;AjBm1HF;AiBl1HE;EACE,cd1CM;AH83HV;AiBl1HE;EACD,cd7CS;AHi4HV;AiBl1HE;EACE,cdhDM;AHo4HV;AiBn1HI;EAjCF,yBdhBQ;EciBR,cdHM;EcIN,UAAA;EACA,mBAAA;EACA,sDd4MW;Ec3MX,gBAAA;AjBu3HF;;AiBt1HA;EACE,sCAAA;EACA,cdtDU;EcuDV,kCAAA;AjBy1HF;AiBx1HE;EACE,cdzDQ;AHm5HZ;AiBx1HE;EACE,cd5DQ;AHs5HZ;AiBz1HI;EA/CF,yBddU;EceV,cdHM;EcIN,UAAA;EACA,mBAAA;EACA,sDd4MW;Ec3MX,gBAAA;AjB24HF;;AiB51HA;EACE,yCAAA;EACA,cdlEQ;EcmER,qCAAA;AjB+1HF;AiB91HE;EACE,cdrEM;AHq6HV;AiB91HE;EACE,cdxEM;AHw6HV;AiB/1HI;EA7DF,yBdZQ;EcaR,cdHM;EcIN,UAAA;EACA,mBAAA;EACA,sDd4MW;Ec3MX,gBAAA;AjB+5HF;;AiBl2HA;EACE,yCAAA;EACA,cd9EK;Ec+EL,qCAAA;AjBq2HF;AiBp2HE;EACE,cdjFG;AHu7HP;AiBp2HE;EACE,cdpFG;AH07HP;AiBr2HI;EA3EF,yBdVK;EcWL,cdHM;EcIN,UAAA;EACA,mBAAA;EACA,sDd4MW;Ec3MX,gBAAA;AjBm7HF;;AiBx2HA;EACE,sCAAA;EACA,cdxFO;EcyFP,kCAAA;AjB22HF;AiB12HE;EACE,cd3FK;AHu8HT;AiB12HE;EACE,cd9FK;AH08HT;AiB32HI;EAzFF,yBdNO;EcOP,cdHM;EcIN,UAAA;EACA,mBAAA;EACA,sDd4MW;Ec3MX,gBAAA;AjBu8HF;;AiB92HA;EACE,yBdlGM;EcmGN,cdiCW;EchCX,qBdpGM;AHq9HR;AiBh3HE;EACE,cd8BS;AHo1Hb;AiBh3HE;EACE,cd2BS;AHu1Hb;AiBj3HI;EAvGF,yBdHM;EcIN,cdHM;EcIN,UAAA;EACA,mBAAA;EACA,sDd4MW;Ec3MX,gBAAA;AjB29HF;;AiBp3HA;EACE,uCAAA;EACA,cdmBW;EclBX,mCAAA;AjBu3HF;AiBt3HE;EACE,cdgBS;AHw2Hb;AiBt3HE;EACE,cdtHI;AH8+HR;AiBv3HI;EArHF,yBdJK;EcKL,cdHM;EcIN,UAAA;EACA,mBAAA;EACA,sDd4MW;Ec3MX,gBAAA;AjB++HF;;AiBl3HA;EAPE,yBd3IQ;Ec4IR,cd9HM;Ec+HN,qBd7IQ;AH0gIV;AiB53HE;EACE,cdjII;AH+/HR;;AiBx3HA;EAVE,yBdzIU;Ec0IV,cd9HM;Ec+HN,qBd3IU;AHihIZ;AiBr4HE;EACE,cdjII;AHwgIR;;AiB93HA;EAbE,yBdnIQ;EcoIR,cd9HM;Ec+HN,qBdrIQ;AHohIV;AiB94HE;EACE,cdjII;AHihIR;;AiBp4HA;EAhBE,yBdrIK;EcsIL,cd9HM;Ec+HN,qBdvIK;AH+hIP;AiBv5HE;EACE,cdjII;AH0hIR;;AiB14HA;EAnBE,yBdvIQ;EcwIR,cd9HM;Ec+HN,qBdzIQ;AH0iIV;AiBh6HE;EACE,cdjII;AHmiIR;;AiBh5HA;EAtBE,yBdjIO;EckIP,cd9HM;Ec+HN,qBdnIO;AH6iIT;AiBz6HE;EACE,cdjII;AH4iIR;;AiBt5HA;EACE,yBdxJM;EcyJN,cdrBW;EcsBX,qBd3DS;AHo9HX;;AiBv5HA;EA9BE,yBd/HK;EcgIL,cd9HM;Ec+HN,qBdjIK;AH0jIP;AiBx7HE;EACE,cdjII;AH2jIR;;AiBr5HA;EAPE,yBd/JM;EcgKN,cd9KQ;Ec+KR,qBd/KQ;AH+kIV;AiB/5HE;EACE,cdjLM;AHklIV;;AiB35HA;EAVE,yBd/JM;EcgKN,cd5KU;Ec6KV,qBd7KU;AHslIZ;AiBx6HE;EACE,cd/KQ;AHylIZ;;AiBj6HA;EAbE,yBd/JM;EcgKN,cdxKK;EcyKL,qBdzKK;AH2lIP;AiBj7HE;EACE,cd3KG;AH8lIP;;AiBv6HA;EAhBE,yBd/JM;EcgKN,cdtKQ;EcuKR,qBdvKQ;AHkmIV;AiB17HE;EACE,cdzKM;AHqmIV;;AiB76HA;EAnBE,yBd/JM;EcgKN,cd1KQ;Ec2KR,qBd3KQ;AH+mIV;AiBn8HE;EACE,cd7KM;AHknIV;;AiBn7HA;EAtBE,yBd/JM;EcgKN,cdpKO;EcqKP,qBdrKO;AHknIT;AiB58HE;EACE,cdvKK;AHqnIT;;AiBz7HA;EACE,yBdzLM;Ec0LN,cdvDW;EcwDX,qBd5LM;AHwnIR;;AiB17HA;EA9BE,yBd/JM;EcgKN,cdlKK;EcmKL,qBdnKK;AH+nIP;AiB39HE;EACE,cdrKG;AHkoIP;;AiBt7HA;EATE,sDAAA;EACA,cd1DW;Ec2DX,yBdnMM;EcoMN,yBAAA;EACA,mBAAA;AjBm8HF;AiBl8HE;EACE,cdpES;AHwgIb;AiB/7HE;EACD,cd3NS;AH4pIV;;AiB97HA;EAfE,sDAAA;EACA,cd1DW;Ec2DX,yBdnMM;EcoMN,yBAAA;EACA,mBAAA;AjBi9HF;AiBh9HE;EACE,cdpES;AHshIb;AiBv8HE;EACD,cd/NW;AHwqIZ;;AiBt8HA;EArBE,sDAAA;EACA,cd1DW;Ec2DX,yBdnMM;EcoMN,yBAAA;EACA,mBAAA;AjB+9HF;AiB99HE;EACE,cdpES;AHoiIb;AiB/8HE;EACD,cd/NS;AHgrIV;;AiB98HA;EA3BE,sDAAA;EACA,cd1DW;Ec2DX,yBdnMM;EcoMN,yBAAA;EACA,mBAAA;AjB6+HF;AiB5+HE;EACE,cdpES;AHkjIb;AiBv9HE;EACD,cdnOQ;AH4rIT;;AiBt9HA;EAjCE,sDAAA;EACA,cd1DW;Ec2DX,yBdnMM;EcoMN,yBAAA;EACA,mBAAA;AjB2/HF;AiB1/HE;EACE,cdpES;AHgkIb;;AiB99HA;EApCE,sDAAA;EACA,cd1DW;Ec2DX,yBdnMM;EcoMN,yBAAA;EACA,mBAAA;AjBsgIF;AiBrgIE;EACE,cdpES;AH2kIb;;AiBt+HA;EAvCE,sDAAA;EACA,cd1DW;Ec2DX,yBdnMM;EcoMN,yBAAA;EACA,mBAAA;AjBihIF;AiBhhIE;EACE,cdpES;AHslIb;;AiB9+HA;EA1CE,sDAAA;EACA,cd1DW;Ec2DX,yBdnMM;EcoMN,yBAAA;EACA,mBAAA;AjB4hIF;AiB3hIE;EACE,cdpES;AHimIb;;AiBt/HA;EACE,mBAAA;EACA,yBdhPM;EciPN,SAAA;EACA,gBAAA;EACA,cdhHW;AHymIb;AiBx/HE;EACE,wBAAA;EACA,cd9GS;Ec+GT,iBAAA;AjB0/HJ;AiBx/HE;EACD,edhBc;EciBX,sBAAA;AjB0/HJ;AiBz/HC;EACC,ednBa;AH8gIf;AiBx/HE;EACE,UAAA;EACA,sBAAA;AjB0/HJ;AiBx/HE;EACE,0CAAA;AjB0/HJ;AiBz/HC;EACC,cdrRQ;AHgxIV;AiBx/HE;EACE,0CAAA;AjB0/HJ;AiBz/HC;EACC,cdzRU;AHoxIZ;AiBx/HE;EACE,0CAAA;AjB0/HJ;AiBz/HC;EACC,cdzRQ;AHoxIV;AiBx/HE;EACE,0CAAA;AjB0/HJ;AiBz/HC;EACC,cd7RO;AHwxIT;;AiBv/HA;EACE,aAAA;EACA,mBAAA;AjB0/HF;AiBz/HE;EACE,oCAAA;AjB2/HJ;;AiBx/HA;EACE;IACE,qBAAA;EjB2/HF;AACF;AiBz/HA;EACI,UAAA;AjB2/HJ;;AiBz/HA;EACI,UAAA;AjB4/HJ;;AiB1/HA;EACI,YAAA;AjB6/HJ;;AiB3/HA;EACI,YAAA;AjB8/HJ;;AiB5/HA;EACI,YAAA;AjB+/HJ;;AiB7/HA;EACI,YAAA;AjBggIJ;;AiB9/HA;EACI,YAAA;AjBigIJ;;AiB//HA;EACI,YAAA;AjBkgIJ;;AiBhgIA;EACI,YAAA;AjBmgIJ;;AiBjgIA;EACI,YAAA;AjBogIJ;;AiBlgIA;EACI,YAAA;AjBqgIJ;;AkB72IA;EACE,+BAAA;EACA,kCAAA;EACA,+BAAA;EACA,kCAAA;EACA,iCAAA;EACA,mCAAA;AlBg3IF;;AkB92IA;EACE,yBfuBM;EetBN,yBAAA;EACA,sDfuOW;EetOX,iBAAA;EACA,kBf4Nc;Ee3Nd,YAAA;AlBi3IF;AkBh3IE;EACE,yBfgBI;EefJ,mCAAA;AlBk3IJ;AkBh3IE;EACE,cf+IS;AHmuIb;AkBh3IE;EACE,qBAAA;AlBk3IJ;;AkB/2IA;;;;EAIE,yBfCM;AHi3IR;;AkBh3IA;;;;EAIE,2BfLM;AHw3IR;;AkBj3IA;;;;EAIE,0BfXM;AH+3IR;;AkBl3IA;;;;;;EAME,4BfnBM;AHw4IR;;AkBj3IE;EACE,yBfrCM;EesCN,cfxBI;AH44IR;AkBl3IE;EAEE,4Bf1CM;AH65IV;;AkBz3IE;EACE,yBfnCQ;EeoCR,cfxBI;AHo5IR;AkB13IE;EAEE,4BfxCQ;AHm6IZ;;AkBj4IE;EACE,yBf7BM;Ee8BN,cfxBI;AH45IR;AkBl4IE;EAEE,4BflCM;AHq6IV;;AkBz4IE;EACE,yBf/BG;EegCH,cfxBI;AHo6IR;AkB14IE;EAEE,4BfpCG;AH+6IP;;AkBj5IE;EACE,yBfjCM;EekCN,cfxBI;AH46IR;AkBl5IE;EAEE,4BftCM;AHy7IV;;AkBz5IE;EACE,yBf3BK;Ee4BL,cfxBI;AHo7IR;AkB15IE;EAEE,4BfhCK;AH27IT;;AkBr4IE;EACI,yBAAA;AlBw4IN;AkBv4II;EACE,yBfnEI;EeoEJ,oDAAA;EACA,cfvDE;EewDF,gCAAA;AlBy4IN;AkBv4II;EACE,yBfzEI;Ee0EJ,cf5DE;Ee6DF,gCAAA;AlBy4IN;AkBt4IE;EAIE,yBflFM;AHu9IV;AkBn4IE;EAIE,2BfxFM;AH09IV;AkBh4IE;EAIE,0Bf9FM;AH69IV;AkB73IE;EAME,4BftGM;AHg+IV;;AkBh6IE;EACI,yBAAA;AlBm6IN;AkBl6II;EACE,yBfjEM;EekEN,oDAAA;EACA,cfvDE;EewDF,gCAAA;AlBo6IN;AkBl6II;EACE,yBfvEM;EewEN,cf5DE;Ee6DF,gCAAA;AlBo6IN;AkBj6IE;EAIE,yBfhFQ;AHg/IZ;AkB95IE;EAIE,2BftFQ;AHm/IZ;AkB35IE;EAIE,0Bf5FQ;AHs/IZ;AkBx5IE;EAME,4BfpGQ;AHy/IZ;;AkB37IE;EACI,yBAAA;AlB87IN;AkB77II;EACE,yBf3DI;Ee4DJ,oDAAA;EACA,cfvDE;EewDF,gCAAA;AlB+7IN;AkB77II;EACE,yBfjEI;EekEJ,cf5DE;Ee6DF,gCAAA;AlB+7IN;AkB57IE;EAIE,yBf1EM;AHqgJV;AkBz7IE;EAIE,2BfhFM;AHwgJV;AkBt7IE;EAIE,0BftFM;AH2gJV;AkBn7IE;EAME,4Bf9FM;AH8gJV;;AkBt9IE;EACI,yBAAA;AlBy9IN;AkBx9II;EACE,yBf7DC;Ee8DD,oDAAA;EACA,cfvDE;EewDF,gCAAA;AlB09IN;AkBx9II;EACE,yBfnEC;EeoED,cf5DE;Ee6DF,gCAAA;AlB09IN;AkBv9IE;EAIE,yBf5EG;AHkiJP;AkBp9IE;EAIE,2BflFG;AHqiJP;AkBj9IE;EAIE,0BfxFG;AHwiJP;AkB98IE;EAME,4BfhGG;AH2iJP;;AkBj/IE;EACI,yBAAA;AlBo/IN;AkBn/II;EACE,yBf/DI;EegEJ,oDAAA;EACA,cfvDE;EewDF,gCAAA;AlBq/IN;AkBn/II;EACE,yBfrEI;EesEJ,cf5DE;Ee6DF,gCAAA;AlBq/IN;AkBl/IE;EAIE,yBf9EM;AH+jJV;AkB/+IE;EAIE,2BfpFM;AHkkJV;AkB5+IE;EAIE,0Bf1FM;AHqkJV;AkBz+IE;EAME,4BflGM;AHwkJV;;AkB5gJE;EACI,yBAAA;AlB+gJN;AkB9gJI;EACE,yBfzDG;Ee0DH,oDAAA;EACA,cfvDE;EewDF,gCAAA;AlBghJN;AkB9gJI;EACE,yBf/DG;EegEH,cf5DE;Ee6DF,gCAAA;AlBghJN;AkB7gJE;EAIE,yBfxEK;AHolJT;AkB1gJE;EAIE,2Bf9EK;AHulJT;AkBvgJE;EAIE,0BfpFK;AH0lJT;AkBpgJE;EAME,4Bf5FK;AH6lJT;;AkBviJE;EACI,yBAAA;AlB0iJN;AkBziJI;EACE,yBfnDG;EeoDH,oDAAA;EACA,cfvDE;EewDF,gCAAA;AlB2iJN;AkBziJI;EACE,yBfzDG;Ee0DH,cf5DE;Ee6DF,gCAAA;AlB2iJN;AkBxiJE;EAIE,yBflEK;AHymJT;AkBriJE;EAIE,2BfxEK;AH4mJT;AkBliJE;EAIE,0Bf9EK;AH+mJT;AkB/hJE;EAME,4BftFK;AHknJT;;AkBlkJE;EACI,yBAAA;AlBqkJN;AkBpkJI;EACE,yBfhDC;EeiDD,oDAAA;EACA,cfvDE;EewDF,gCAAA;AlBskJN;AkBpkJI;EACE,yBftDC;EeuDD,cf5DE;Ee6DF,gCAAA;AlBskJN;AkBnkJE;EAIE,yBf/DG;AHioJP;AkBhkJE;EAIE,2BfrEG;AHooJP;AkB7jJE;EAIE,0Bf3EG;AHuoJP;AkB1jJE;EAME,4BfnFG;AH0oJP;;AkB1hJI;EACI,yCAAA;AlB6hJR;AkB5hJM;EACE,yCAAA;EACA,mDAAA;EACA,cfxIE;EeyIF,gBAAA;AlB8hJR;AkB5hJM;EACE,yCAAA;EACA,cf7IE;AH2qJV;AkB3hJI;EAIE,yCAAA;AlB0hJN;AkBxhJI;EAIE,2CAAA;AlBuhJN;AkBrhJI;EAIE,0CAAA;AlBohJN;AkBlhJI;EAME,4CAAA;AlB+gJN;;AkB3gJI;EACI,sCAAA;AlB8gJR;AkB7gJM;EACE,sCAAA;EACA,gDAAA;EACA,cf/KI;EegLJ,gBAAA;AlB+gJR;AkB7gJM;EACE,sCAAA;EACA,cfpLI;AHmsJZ;AkB5gJI;EAIE,iDAAA;AlB2gJN;AkBzgJI;EAIE,wCAAA;AlBwgJN;AkBtgJI;EAIE,kDAAA;AlBqgJN;AkBngJI;EAME,oDAAA;AlBggJN;;AkB5/II;EACI,wCAAA;AlB+/IR;AkB9/IM;EACE,wCAAA;EACA,kDAAA;EACA,cflNE;EemNF,gBAAA;AlBggJR;AkB9/IM;EACE,wCAAA;EACA,cfvNE;AHutJV;AkB7/II;EAIE,wCAAA;AlB4/IN;AkB1/II;EAIE,0CAAA;AlBy/IN;AkBv/II;EAIE,yCAAA;AlBs/IN;AkBp/II;EAME,2CAAA;AlBi/IN;;AkB7+II;EACI,yCAAA;AlBg/IR;AkB/+IM;EACE,yCAAA;EACA,mDAAA;EACA,cf7PD;Ee8PC,gBAAA;AlBi/IR;AkB/+IM;EACE,yCAAA;EACA,cflQD;AHmvJP;AkB9+II;EAIE,yCAAA;AlB6+IN;AkB3+II;EAIE,2CAAA;AlB0+IN;AkBx+II;EAIE,0CAAA;AlBu+IN;AkBr+II;EAME,4CAAA;AlBk+IN;;AkB99II;EACI,yCAAA;AlBi+IR;AkBh+IM;EACE,yCAAA;EACA,mDAAA;EACA,cfxSE;EeySF,gBAAA;AlBk+IR;AkBh+IM;EACE,yCAAA;EACA,cf7SE;AH+wJV;AkB/9II;EAIE,yCAAA;AlB89IN;AkB59II;EAIE,2CAAA;AlB29IN;AkBz9II;EAIE,0CAAA;AlBw9IN;AkBt9II;EAME,4CAAA;AlBm9IN;;AkB/8II;EACI,sCAAA;AlBk9IR;AkBj9IM;EACE,sCAAA;EACA,gDAAA;EACA,cf3UC;Ee4UD,gBAAA;AlBm9IR;AkBj9IM;EACE,sCAAA;EACA,cfhVC;AHmyJT;AkBh9II;EAIE,sCAAA;AlB+8IN;AkB78II;EAIE,wCAAA;AlB48IN;AkB18II;EAIE,uCAAA;AlBy8IN;AkBv8II;EAME,yCAAA;AlBo8IN;;AkBh8II;EACI,8CAAA;AlBm8IR;AkBl8IM;EACE,8CAAA;EACA,wDAAA;EACA,cf9WC;Ee+WD,gBAAA;AlBo8IR;AkBl8IM;EACE,8CAAA;EACA,cfnXC;AHuzJT;AkBj8II;EAIE,8CAAA;AlBg8IN;AkB97II;EAIE,gDAAA;AlB67IN;AkB37II;EAIE,+CAAA;AlB07IN;AkBx7II;EAME,iDAAA;AlBq7IN;;AkBj7II;EACI,4CAAA;AlBo7IR;AkBn7IM;EACE,4CAAA;EACA,sDAAA;EACA,cfpZD;EeqZC,gBAAA;AlBq7IR;AkBn7IM;EACE,4CAAA;EACA,cfzZD;AH80JP;AkBl7II;EAIE,4CAAA;AlBi7IN;AkB/6II;EAIE,8CAAA;AlB86IN;AkB56II;EAIE,6CAAA;AlB26IN;AkBz6II;EAME,+CAAA;AlBs6IN;;AkBn6IA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EjBnXD,ciBoXyB;EjBnXzB,oBiBmXiC;AlBu6IpC;AkBt6II;EACE,YAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,yBfzWK;EFzBT,kBiBmYwB;EjBlYxB,MiBkYiC;EjBhYjC,SiBgYwC;EjB/XxC,SiB+X0C;AlB26I5C;AkBz6II;EACE,kBAAA;EACA,mBAAA;AlB26IN;AkB16IM;EACI,YAAA;EACD,cAAA;AlB46IT;AkB16IM;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;EjBjXR,sBiBkX2B;EjBtW3B,yCAAA;ADqxJF;AkB76IY;EACI,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;EjB3Zd,kBiB4ZkC;EjB3ZlC,SiB2Z2C;EjB1Z3C,WiB0ZgD;AlBi7IlD;AkB/6Ic;EACI,YAAA;EACA,qBAAA;EjBhahB,kBiBiaoC;EjBhapC,SiBga6C;EjB/Z7C,WiB+ZkD;EAClC,iCAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;AlBm7IlB;;AkB96IA;EACE,WAAA;AlBi7IF;;AkB/6IA;EACE,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cfzfM;Ee0fN,gBAAA;EjBtZA,kBiBuZmB;EjBvbnB,kBiBwboB;EjBvbpB,SiBub6B;EjBpb7B,SiBob4C;AlBo7I9C;;AkBl7IA;EACE,YAAA;AlBq7IF;AkBp7IE;EACI,WAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;AlBs7IN;AkBp7II;EACI,WAAA;EACA,UAAA;EACA,uBAAA;EACA,oBAAA;AlBs7IR;;AkBn7IA;EACE,yBf5hBQ;AHk9JV;;AkBp7IA;EACE,yBf3hBQ;AHk9JV;;AkBr7IA;EACE,yBf1hBQ;AHk9JV;;AkBt7IA;EACE,yBf3hBO;AHo9JT;;AkBv7IA;EACE,yBfliBK;AH49JP;;AkBx7IA;EACE,aAAA;EACA,cAAA;EACA,oBAAA;AlB27IF;;AkBz7IA;;EAEE,gBAAA;AlB47IF;;AkB17IA;EACE,eAAA;AlB67IF;;AmBngKA;EACE,qBhBqOa;EgBpOb,chBiKW;EgBhKX,yBhB4KgB;EgB3KhB,mBAAA;EACA,gBhBCmB;EgBAnB,gBAAA;EACA,sBAAA;EACA,uBAAA;AnBsgKF;AmBpgKE;EACE,gBAAA;EACA,qBhB0NW;EgBzNX,yBhBmBI;EgBlBJ,sDAAA;EACA,chBoJS;AHk3Jb;;AmBngKA;EACE,sBAAA;AnBsgKF;AmBrgKE;EACE,kCAAA;AnBugKJ;AmBrgKE;EACE,+BAAA;AnBugKJ;;AmBpgKA;EACE,ehBiOa;EgBhOb,gBhBrBqB;EgBsBrB,chBqIW;EgBpIX,kBAAA;AnBugKF;;AmBpgKA;EACE,chBqIW;AHk4Jb;;AmBpgKA;EACE,yBhBRM;EgBSN,SAAA;AnBugKF;AmBrgKE;EACE,yBhBZI;AHmhKR;;AmBpgKA;EACE,yCAAA;EACA,SAAA;EACA,chB/BQ;AHsiKV;AmBrgKE;EACE,yCAAA;EACA,chBnCM;AH0iKV;;AmBpgKA;EACE,eAAA;EACA,cAAA;EACA,kBhB8Kc;EgB7Kd,gBAAA;EACA,UAAA;AnBugKF;;AmBrgKA;;;;EAIE,chBqGW;AHm6Jb;;AmBtgKA;EACE,6BAAA;AnBygKF;;AmBvgKA;EACE,yBhBsGgB;EgBrGhB,yBAAA;EACA,chBwFW;EgBvFX,ehB3Ee;EgB4Ef,yDAAA;EACA,wBAAA;EACA,cAAA;AnB0gKF;AmBzgKE;EACE,yBhBjDI;EgBkDJ,wBAAA;EACA,sBAAA;EACA,yBAAA;AnB2gKJ;AmB1gKI;EACE,mBAAA;AnB4gKN;AmBzgKE;EACE,yCAAA;EACA,chBzEM;AHolKV;AmBzgKE;EACE,yCAAA;EACA,chB7EM;AHwlKV;AmBzgKE;EACE,yCAAA;EACA,chBjFM;AH4lKV;AmBzgKE;EACE,yCAAA;EACA,chBrFM;AHgmKV;;AmBxgKA;EACE,aAAA;EACA,cAAA;EACA,yBhB7EM;EgB8EN,yBAAA;AnB2gKF;AmB1gKE;EACE,yBhB9FM;EgB+FN,qBhB/FM;AH2mKV;AmBzgKI;EACE,6BAAA;EACA,qBhBpGI;AH+mKV;AmBvgKI;EACE,yBhBvGM;EgBwGN,qBhBxGM;AHinKZ;AmBrgKI;EACE,yBhBvGI;EgBwGJ,qBhBxGI;AH+mKV;AmBngKI;EACE,yBhB/GC;EgBgHD,qBhBhHC;AHqnKP;AmBjgKI;EACE,yBhBvHI;EgBwHJ,qBhBxHI;AH2nKV;AmB//JI;EACE,yBhBvHG;EgBwHH,qBhBxHG;AHynKT;AmB7/JI;EACE,yBhB1HE;EgB2HF,qBhB3HE;AH0nKR;AmB3/JI;EACE,yBhBjIC;EgBkID,qBhBlIC;AH+nKP;AmB1/JE;EACE,gBAAA;AnB4/JJ;;AmBz/JA;EACE,sBAAA;EACA,kBAAA;EACA,6BAAA;AnB4/JF;AmB1/JE;EACE,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,chB9JM;EgB+JN,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;AnB4/JJ;AmBx/JI;EACE,chBtKM;AHgqKZ;AmBr/JI;EACE,chBtKI;AH6pKV;AmBl/JI;EACE,chB9KC;AHkqKP;AmB/+JI;EACE,chBtLI;AHuqKV;AmB5+JI;EACE,chBtLG;AHoqKT;AmBz+JI;EACE,chBzLE;AHoqKR;AmBt+JI;EACE,chBhMC;AHwqKP;;AmBp+JA;EACE,sBAAA;EACA,kBAAA;EACA,6BAAA;AnBu+JF;AmBr+JE;EACE,gBAAA;EACA,uCAAA;EACA,kBAAA;EACA,chBzNM;EgB0NN,eAAA;EACA,gBAAA;EACA,2BAAA;EACA,2BAAA;EACA,eAAA;AnBu+JJ;AmBn+JI;EACE,chBjOM;AHssKZ;AmBh+JI;EACE,chBjOI;AHmsKV;AmB79JI;EACE,chBzOC;AHwsKP;AmB19JI;EACE,chBjPI;AH6sKV;AmBv9JI;EACE,chBjPG;AH0sKT;AmBp9JI;EACE,chBpPE;AH0sKR;AmBj9JI;EACE,chB3PC;AH8sKP;;AmB/8JA;EACE,chB9PM;EgB+PN,yBhB7QQ;EgB8QR,qBhB9QQ;AHguKV;;AmBh9JA;EACE,qCAAA;EACA,UAAA;EACA,gBAAA;AnBm9JF;;AmBj9JA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;AnBo9JF;;AmBl9JA;;;;;EAKE,gBAAA;AnBq9JF;;AmBj9JE;;EACE,yBhBxRI;EgByRJ,chBrJS;AH0mKb;;AmBl9JA;EACE,chBzJW;AH8mKb;;AmBn9JA;EACE,chB5JW;EgB6JX,yBhBvJmB;AH6mKrB;;AmBp9JA;EACE,yBhB1JmB;AHinKrB;;AmBn9JI;EAEE,4BAAA;EACA,qDAAA;EAAA,6CAAA;AnBq9JN;AmBl9JE;EACE,iBAAA;EACA,gBhBxUiB;EgByUjB,YAAA;EACA,chB9KS;EgB+KT,yBAAA;EACA,qDAAA;EAAA,6CAAA;AnBo9JJ;AmBl9JE;EACE,iBAAA;EACA,gBhBhViB;EgBiVjB,YAAA;EACA,chBtLS;AH0oKb;AmBl9JE;EACE,iBAAA;EACA,gBhBtViB;EgBuVjB,YAAA;EACA,chB5LS;AHgpKb;AmBl9JE;EACE,iBAAA;EACA,gBhB5ViB;EgB6VjB,YAAA;EACA,chBlMS;AHspKb;;AmBj9JA;EACE,iBAAA;EACA,uBAAA;AnBo9JF;;AmBl9JA;EACE,eAAA;EACA,oBAAA;AnBq9JF;;AmBj9JE;EACE,cAAA;EACA,eAAA;AnBo9JJ;AmBh9JI;EACE,cAAA;AnBk9JN;AmB98JE;EACE,2BAAA;EACA,kBAAA;EACA,uBAAA;AnBg9JJ;;AmB38JE;EACE,cAAA;EACA,eAAA;AnB88JJ;AmB18JI;EACE,aAAA;AnB48JN;AmBx8JE;EACE,2BAAA;EACA,eAAA;EACA,uBAAA;AnB08JJ;;AmBv8JA;EACE,cAAA;EACA,gBAAA;EACA,yBhB1XM;EgB2XN,6BAAA;EACA,0BAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;AnB08JF;AmBx8JE;EACE,kBAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;EACA,cAAA;EACA,cAAA;EACA,uBAAA;EACA,yBhB1YI;EgB2YJ,qDAAA;EACA,eAAA;EACA,yBAAA;AnB08JJ;AmBx8JI;EACE,aAAA;EACA,6BAAA;AnB08JN;AmBv8JI;EACE,cAAA;EACA,2BAAA;EACA,chB/QO;AHwtKb;AmBt8JI;EAEE,kBAAA;EACA,mBAAA;EACA,gBhBvbe;EgBwbf,qBAAA;EACA,yBAAA;EACA,2BAAA;EACA,iBAAA;EACA,yBAAA;AnBu8JN;AmBn8JE;EACE,yCAAA;AnBq8JJ;AmBn8JI;EACE,yBhBzbI;AH83KV;AmBn8JM;EACE,chB5bE;AHi4KV;AmBj8JI;EACE,sCAAA;AnBm8JN;AmBj8JM;EACE,yBhBlcI;AHq4KZ;AmBj8JQ;EACE,chBrcE;AHw4KZ;AmB97JI;EACE,wCAAA;AnBg8JN;AmB97JM;EACE,yBhBxcE;AHw4KV;AmB97JQ;EACE,chB3cA;AH24KV;AmB37JI;EACE,yCAAA;AnB67JN;AmB37JM;EACE,yBhBtdD;AHm5KP;AmB37JQ;EACE,chBzdH;AHs5KP;AmBx7JI;EACE,yCAAA;AnB07JN;AmBx7JM;EACE,yBhBpeE;AH85KV;AmBx7JQ;EACE,chBveA;AHi6KV;AmBr7JI;EACE,sCAAA;AnBu7JN;AmBr7JM;EACE,yBhB1eC;AHi6KT;AmBr7JQ;EACE,chB7eD;AHo6KT;AmBl7JI;EACE,0CAAA;AnBo7JN;AmBl7JM;EACE,yBhBnfA;AHu6KR;AmBl7JQ;EAEE,chB9WG;AHiyKb;AmB96JI;EACE,uCAAA;AnBg7JN;AmB96JM;EACE,yBhBjgBD;AHi7KP;AmB96JQ;EACE,chBlgBF;AHk7KR;AmB36JI;EACE,4BAAA;AnB66JN;AmB16JI;EACE,4BAAA;AnB46JN;AmB16JM;EACE,uBAAA;EACA,6BAAA;AnB46JR;AmBx6JI;EACE,4BAAA;AnB06JN;AmBx6JM;EACE,yBAAA;EACA,4BAAA;AnB06JR;AmBr6JE;EACE,gBAAA;EACA,eAAA;AnBu6JJ;AmBr6JI;EACE,eAAA;EACA,gBAAA;AnBu6JN;AmBr6JM;EACE,2BAAA;EACA,uBAAA;AnBu6JR;AmBl6JE;EACE,gBAAA;EACA,aAAA;AnBo6JJ;AmBl6JI;EACE,cAAA;AnBo6JN;AmBl6JM;EACE,yBAAA;EACA,2BAAA;AnBo6JR;;AmB/5JA;EACE,aAAA;AnBk6JF;;AmBh6JA;EACE,eAAA;EACA,SAAA;EACA,kBAAA;EACA,aAAA;AnBm6JF;;AmBh6JA;EACE,mBhBplBQ;EgBqlBR,chBvkBM;AH0+KR;;AmBh6JA;EACE,mBhBvlBU;EgBwlBV,chB5kBM;AH++KR;;AmBh6JA;EACE,mBhBtlBQ;EgBulBR,chBjlBM;AHo/KR;;AmBh6JA;EACE,mBhB7lBK;EgB8lBL,chBtlBM;AHy/KR;;AmBh6JA;EACE,mBhBpmBQ;EgBqmBR,chB3lBM;AH8/KR;;AmBh6JA;EACE,mBhBnmBO;EgBomBP,chBhmBM;AHmgLR;;AmBh6JA;EACE,mBhBrmBM;EgBsmBN,chBrmBM;AHwgLR;;AmBh6JA;EACE,mBhB3mBK;EgB4mBL,chB1mBM;AH6gLR;;AmBh6JA;EACE,mBAAA;EACA,YAAA;AnBm6JF;;AmBh6JE;EACE,mBhB3eS;EgB4eT,2DAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,YAAA;EACA,gCAAA;EACA,aAAA;AnBm6JJ;AmBh6JE;EACE,mBhBhoBI;EgBioBJ,mBAAA;EACA,iDAAA;EACA,WAAA;EACA,cAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;EACA,2BAAA;EACA,gCAAA;EACA,aAAA;AnBk6JJ;;AmB/5JA;EACE,mBAAA;EACA,uBAAA;AnBk6JF;;AmB/5JA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AnBk6JF;;AmB/5JA;EACE,wBAAA;AnBk6JF;;AmB/5JA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;AnBk6JF;;AmB/5JA;EACE,YAAA;EACA,WAAA;EACA,mBAAA;AnBk6JF;;AmB/5JA;EACE,uBAAA;AnBk6JF;;AmB/5JA;EACE,YAAA;EACA,WAAA;EACA,wBAAA;EACA,kBAAA;AnBk6JF;;AmB75JI;;EACE,6BAAA;AnBi6JN;;AmB75JA;;;EAGE,0BAAA;AnBg6JF;;AmB55JI;EACE,chBhtBI;EgBitBJ,UAAA;AnB+5JN;AmB55JI;EACE,yBAAA;AnB85JN;AmB55JI;EACE,yBAAA;AnB85JN;AmBz5JI;EACE,chB5tBM;EgB6tBN,UAAA;AnB25JN;AmBx5JI;EACE,yBAAA;AnB05JN;AmBx5JI;EACE,yBAAA;AnB05JN;AmBr5JI;EACE,chBpuBI;EgBquBJ,UAAA;AnBu5JN;AmBp5JI;EACE,yBAAA;AnBs5JN;AmBp5JI;EACE,yBAAA;AnBs5JN;AmBj5JI;EACE,chBpvBC;EgBqvBD,UAAA;AnBm5JN;AmBh5JI;EACE,yBAAA;AnBk5JN;AmBh5JI;EACE,yBAAA;AnBk5JN;AmB74JI;EACE,chBpwBI;EgBqwBJ,UAAA;AnB+4JN;AmB54JI;EACE,yBAAA;AnB84JN;AmB54JI;EACE,yBAAA;AnB84JN;AmBz4JI;EACE,chB5wBG;EgB6wBH,UAAA;AnB24JN;AmBx4JI;EACE,yBAAA;AnB04JN;AmBx4JI;EACE,yBAAA;AnB04JN;;AmBt4JA;;;;EAIE,yBhBxxBM;EgByxBN,kBhBhlBc;AHy9KhB;;AmBv4JA;EACE,gBAAA;EACA,mBAAA;AnB04JF;AmBx4JE;EACE,SAAA;AnB04JJ;AmBt4JI;EACE,uBAAA;EACA,kBAAA;AnBw4JN;AmBr4JI;EACE,uBAAA;EACA,chBnqBO;EgBoqBP,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,6BAAA;AnBu4JN;AmBr4JM;EACE,eAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,yBAAA;AnBu4JR;AmBp4JM;EAEE,6BAAA;AnBq4JR;AmBl4JM;EACE,yBAAA;EACA,mBAAA;EACA,chB/0BE;EgBg1BF,6BAAA;AnBo4JR;AmBl4JQ;EACE,yBAAA;AnBo4JV;AmB93JE;EACE,aAAA;AnBg4JJ;;AmB73JA;;EAEE,qBhB31BQ;EgB41BR,gBAAA;AnBg4JF;;AmB93JA;;EAEE,qBhBh2BQ;AHiuLV;;AmB/3JA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;AnBk4JF;;AmB/3JE;EACE,iCAAA;EACA,gBAAA;AnBk4JJ;;AmB93JE;;;;EAIE,cAAA;AnBi4JJ;;AmB93JA;EACE,uBAAA;EACA,2EAAA;AnBi4JF;;AmB/3JA;EAKE,cAAA;AnB83JF;;AmB53JA;EACE,yBhBz3BM;AHwvLR;;AmB53JE;EACE,uBAAA;AnB+3JJ;;AmB53JA;EACE,8BAAA;AnB+3JF;;AmB73JA;;;EAGE,gBhB75BqB;AH6xLvB;;AmB93JA;EACE,cAAA;AnBi4JF;;AmBx3JM;EACE,iBAAA;AnB23JR;;AmBp3JI;EAKE,eAAA;AnBm3JN;;AoBvxLA;EACE,cjB6IW;AH6oLb;;AoBxxLA;EACE,iDAAA;ApB2xLF;;AoB5vLA;EACE,cjBqGW;EiBpGX,qBjB+DS;EiB9DT,mBAAA;ApB+vLF;AoB9vLE;EACE,mBAAA;ApBgwLJ;AoB5vLM;EACE,gBjBhEa;AH8zLrB;AoB1vLE;;EAEE,gBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;ApB4vLJ;AoB1vLE;EACE,gBjB5EmB;EiB6EnB,eAAA;ApB4vLJ;AoB1vLE;EACE,eAAA;ApB4vLJ;AoB1vLE;EACE,yBjB2BM;EiB1BN,sCAAA;ApB4vLJ;AoB1vLE;EACI,yBjB7EI;EiB8EJ,cjBhEE;AH4zLR;AoB1vLE;EACI,yBjB/EM;EiBgFN,cjBpEE;AHg0LR;AoB1vLE;EACI,yBjB/EC;EiBgFD,cjBxEE;AHo0LR;AoB1vLE;EACI,yBjBjFI;EiBkFJ,cjB5EE;AHw0LR;AoB1vLE;EACI,yBjBnFG;EiBoFH,cjBhFE;AH40LR;AoB1vLE;EACI,yBjB7FI;EiB8FJ,cjBpFE;AHg1LR;AoB1vLE;EACI,yBjBzFC;EiB0FD,cjBxFE;AHo1LR;AoB1vLE;EACI,yBjB5FE;EiB6FF,cjB9FC;AH01LP;AoB1vLE;EA7HA,yBjB+BM;EiB9BN,cjB+BM;EiB9BN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;ApB03LF;AoBz3LE;EACE,2CAAA;EACA,mDAAA;EACA,cjBoBI;AHu2LR;AoBz3LE;EACE,2CAAA;EACA,mDAAA;EACA,cjBcI;AH62LR;AoBz3LE;EACE,2CAAA;EACA,6CAAA;EACA,cjBSI;AHk3LR;AoBjxLE;EAhIA,yBjB+BM;EiB9BN,cjB+BM;EiB9BN,8BAAA;EACA,0CAAA;EACA,8CAAA;EACA,yDAAA;EACA,sDAAA;EACA,qDAAA;EACA,oDAAA;ApBo5LF;AoBn5LE;EACE,2CAAA;EACA,qDAAA;EACA,cjBoBI;AHi4LR;AoBn5LE;EACE,2CAAA;EACA,qDAAA;EACA,cjBcI;AHu4LR;AoBn5LE;EACE,2CAAA;EACA,+CAAA;EACA,cjBSI;AH44LR;AoBxyLE;EAnIA,yBjB+BM;EiB9BN,cjB+BM;EiB9BN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;ApB86LF;AoB76LE;EACE,2CAAA;EACA,mDAAA;EACA,cjBoBI;AH25LR;AoB76LE;EACE,2CAAA;EACA,mDAAA;EACA,cjBcI;AHi6LR;AoB76LE;EACE,2CAAA;EACA,6CAAA;EACA,cjBSI;AHs6LR;AoB/zLE;EAtIA,yBjB+BM;EiB9BN,cjB+BM;EiB9BN,8BAAA;EACA,0CAAA;EACA,4CAAA;EACA,uDAAA;EACA,oDAAA;EACA,mDAAA;EACA,kDAAA;ApBw8LF;AoBv8LE;EACE,2CAAA;EACA,mDAAA;EACA,cjBoBI;AHq7LR;AoBv8LE;EACE,2CAAA;EACA,mDAAA;EACA,cjBcI;AH27LR;AoBv8LE;EACE,2CAAA;EACA,6CAAA;EACA,cjBSI;AHg8LR;AoBt1LE;EAzIA,yBjB+BM;EiB9BN,cjB+BM;EiB9BN,8BAAA;EACA,0CAAA;EACA,2CAAA;EACA,sDAAA;EACA,mDAAA;EACA,kDAAA;EACA,iDAAA;ApBk+LF;AoBj+LE;EACE,2CAAA;EACA,kDAAA;EACA,cjBoBI;AH+8LR;AoBj+LE;EACE,2CAAA;EACA,kDAAA;EACA,cjBcI;AHq9LR;AoBj+LE;EACE,2CAAA;EACA,4CAAA;EACA,cjBSI;AH09LR;AoB72LE;EA5IA,yBjB+BM;EiB9BN,cjB+BM;EiB9BN,8BAAA;EACA,0CAAA;EACA,yCAAA;EACA,oDAAA;EACA,iDAAA;EACA,gDAAA;EACA,+CAAA;ApB4/LF;AoB3/LE;EACE,2CAAA;EACA,gDAAA;EACA,cjBoBI;AHy+LR;AoB3/LE;EACE,2CAAA;EACA,gDAAA;EACA,cjBcI;AH++LR;AoB3/LE;EACE,2CAAA;EACA,0CAAA;EACA,cjBSI;AHo/LR;AoBp4LE;EA/IA,yBjB+BM;EiB9BN,cjB+BM;EiB9BN,8BAAA;EACA,0CAAA;EACA,0CAAA;EACA,qDAAA;EACA,kDAAA;EACA,iDAAA;EACA,gDAAA;ApBshMF;AoBrhME;EACE,2CAAA;EACA,iDAAA;EACA,cjBoBI;AHmgMR;AoBrhME;EACE,2CAAA;EACA,iDAAA;EACA,cjBcI;AHygMR;AoBrhME;EACE,2CAAA;EACA,2CAAA;EACA,cjBSI;AH8gMR;AoB35LE;EAlJA,yBjB+BM;EiB9BN,cjB+BM;EiB9BN,8BAAA;EACA,0CAAA;EACA,yCAAA;EACA,oDAAA;EACA,iDAAA;EACA,gDAAA;EACA,+CAAA;ApBgjMF;AoB/iME;EACE,2CAAA;EACA,gDAAA;EACA,cjBoBI;AH6hMR;AoB/iME;EACE,2CAAA;EACA,gDAAA;EACA,cjBcI;AHmiMR;AoB/iME;EACE,2CAAA;EACA,0CAAA;EACA,cjBSI;AHwiMR;AoBh7LM;;;;;;EAME,qCAAA;ApBk7LR;AoB96LM;;;;;;EAME,qCAAA;ApBg7LR;AoB56LM;;;;;;EAME,kCAAA;ApB86LR;AoB16LM;;;;;;EAME,oCAAA;ApB46LR;AoBx6LM;;;;;;EAME,qCAAA;ApB06LR;AoBt6LM;;;;;;EAME,kCAAA;ApBw6LR;AoBp6LE;EACE,kDAAA;EACA,cjBnDS;AHy9Lb;AoBp6LE;EACE,iDAAA;EACA,cjBvDS;AH69Lb;AoBp6LE;EACE,6BAAA;ApBs6LJ;AoBp6LE;EACE,6BAAA;EACA,cjB9DS;AHo+Lb;AoBp6LE;EACE,6BAAA;EACA,cjBlES;AHw+Lb;AoBn6LI;EAvMF,yBjBDM;EiBEN,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,iCAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;ApB6mMF;AoB96LI;EA1MF,yBjBDM;EiBEN,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,8CAAA;EACA,wDAAA;EACA,sDAAA;EACA,iCAAA;EACA,qDAAA;EACA,oDAAA;EACA,4BAAA;EACA,0CAAA;ApB2nMF;AoBz7LI;EA7MF,yBjBDM;EiBEN,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,iCAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;ApByoMF;AoBp8LI;EAhNF,yBjBDM;EiBEN,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,iCAAA;EACA,mDAAA;EACA,kDAAA;EACA,4BAAA;EACA,0CAAA;ApBupMF;AoB/8LI;EAnNF,yBjBDM;EiBEN,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,2CAAA;EACA,qDAAA;EACA,mDAAA;EACA,iCAAA;EACA,kDAAA;EACA,iDAAA;EACA,4BAAA;EACA,0CAAA;ApBqqMF;AoB19LI;EAtNF,yBjBDM;EiBEN,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,+CAAA;EACA,4BAAA;EACA,0CAAA;ApBmrMF;AoBr+LI;EAzNF,yBjBDM;EiBEN,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,0CAAA;EACA,oDAAA;EACA,kDAAA;EACA,iCAAA;EACA,iDAAA;EACA,gDAAA;EACA,4BAAA;EACA,0CAAA;ApBisMF;AoBh/LI;EA5NF,yBjBDM;EiBEN,4BAAA;EACA,4BAAA;EACA,yBAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,+CAAA;EACA,4BAAA;EACA,0CAAA;ApB+sMF;;AoBz/LA;EAnNE,yBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,iCAAA;EACA,mDAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EACA,cAAA;EACA,2CAAA;EACA,yBAAA;ApBgtMF;;AoBtgMA;EAtNE,yBAAA;EACA,8BAAA;EACA,8CAAA;EACA,wDAAA;EACA,sDAAA;EACA,iCAAA;EACA,qDAAA;EACA,gCAAA;EACA,oDAAA;EACA,+BAAA;EACA,cAAA;EACA,6CAAA;EACA,yBAAA;ApBguMF;;AoBnhMA;EAzNE,yBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,iCAAA;EACA,mDAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EACA,cAAA;EACA,2CAAA;EACA,yBAAA;ApBgvMF;;AoBhiMA;EA5NE,yBAAA;EACA,8BAAA;EACA,4CAAA;EACA,sDAAA;EACA,oDAAA;EACA,iCAAA;EACA,mDAAA;EACA,gCAAA;EACA,kDAAA;EACA,+BAAA;EACA,cAAA;EACA,2CAAA;EACA,yBAAA;ApBgwMF;;AoB7iMA;EA/NE,yBAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,+CAAA;EACA,+BAAA;EACA,cAAA;EACA,wCAAA;EACA,yBAAA;ApBgxMF;;AoB1jMA;EAlOE,yBAAA;EACA,8BAAA;EACA,2CAAA;EACA,qDAAA;EACA,mDAAA;EACA,iCAAA;EACA,kDAAA;EACA,gCAAA;EACA,iDAAA;EACA,+BAAA;EACA,cAAA;EACA,0CAAA;EACA,yBAAA;ApBgyMF;;AoBvkMA;EArOE,yBAAA;EACA,8BAAA;EACA,yCAAA;EACA,mDAAA;EACA,iDAAA;EACA,iCAAA;EACA,gDAAA;EACA,gCAAA;EACA,+CAAA;EACA,+BAAA;EACA,cAAA;EACA,wCAAA;EACA,yBAAA;ApBgzMF;;AoBplMA;EAxOE,yBAAA;EACA,8BAAA;EACA,0CAAA;EACA,oDAAA;EACA,kDAAA;EACA,iCAAA;EACA,iDAAA;EACA,gCAAA;EACA,gDAAA;EACA,+BAAA;EACA,cAAA;EACA,yCAAA;EACA,yBAAA;ApBg0MF;;AoBhmME;EACE,kCAAA;ApBmmMJ;;AoB/lME;EACE,sBAAA;ApBkmMJ;;AoB/lMA;EACI,SAAA;ApBkmMJ;AoB/lMY;EACI,cjBxKL;EiByKK,ejB7CD;AH8oMf;AoB/lMoB;EACI,SAAA;ApBimMxB;AoB9lMgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ApBgmMpB;AoB/lMoB;EACI,gBAAA;ApBimMxB;AoB7lMoB;EACI,8CAAA;EACA,yCAAA;ApB+lMxB;AoB5lMgB;EACI,cjB3SR;EiB4SQ,ejBnEL;EiBoEK,gBjB3TC;EiB4TD,mBAAA;ApB8lMpB;AoB7lMoB;EACI,iBAAA;EACA,cAAA;ApB+lMxB;AoB7lMoB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;ApB+lMxB;AoB7lMoB;EACI,cjB3Td;AH05MV;AoB9lMwB;EACI,cjB7TlB;AH65MV;AoB5lMgB;EACI,cAAA;ApB8lMpB;AoB7lMoB;EACI,cjBlUZ;AHi6MZ;AoB7lMoB;EACI,cAAA;EACA,ejB5FT;EiB6FS,gBjBpVH;EiBqVG,cjBzLX;AHwxMb;AoB7lMoB;EACI,kBAAA;ApB+lMxB;AoB5lMgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,ejBlHL;EiBmHK,yBAAA;EACA,gBjB1WC;EiB2WD,kBAAA;ApB8lMpB;AoB3lMY;EACI,gBjB9WO;EiB+WP,cjBnWJ;EiBoWI,ejB1HD;EiB2HC,mBAAA;ApB6lMhB;AoB3lMY;EACI,cjB1VP;AHu7MT;AoB3lMY;EACI,gBAAA;ApB6lMhB;AoB5lMgB;EACI,ejBjIL;EiBkIK,cjBjQT;EiBkQS,gBjB3XG;EiB4XH,gBAAA;ApB8lMpB;AoBzlMY;EACI,gBjBjYG;EiBkYH,cjBvXJ;EiBwXI,ejB3YC;EiB4YD,6BAAA;ApB2lMhB;AoBxlMQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ApB0lMZ;AoBzlMY;EACI,iBAAA;EACA,kBAAA;ApB2lMhB;AoBtlMY;EACI,oBAAA;ApBwlMhB;AoBjlMQ;EACI,kBAAA;ApBmlMZ;AoBllMY;EACI,gBAAA;ApBolMhB;AoB7kMY;EACI,kBAAA;ApB+kMhB;AoBzkMY;EACI,kBAAA;ApB2kMhB;;AoBjkMY;EACI,mBAAA;ApBokMhB;;AoB/jMA;EACI,iBAAA;ApBkkMJ;ACz9MI;EmBsZJ;IAGQ,gBAAA;IACA,mBAAA;EpBokMN;AACF;;AoBlkMA;EACI,0BAAA;ApBqkMJ;;AoBlkMI;EACI,aAAA;ApBqkMR;;AoBjkMI;;;EAGI,wBAAA;ApBokMR;;AoBjkMA;EACI,mCAAA;EACA,iBAAA;ApBokMJ;;AoBlkMA;EACI,WAAA;EACA,ejBzOW;AH8yMf;;AoBnkMA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ApBskMJ;AoBrkMI;EACI,cjB1dI;EiB2dJ,gBjBxea;AH+iNrB;AoBrkMI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ApBukMR;;AoBnkMI;EACI,sBAAA;EACA,kBAAA;ApBskMR;;AoBjkMQ;EACI,YAAA;ApBokMZ;AoBjkMI;EACI,WAAA;EACA,YAAA;ApBmkMR;;AoB/jMI;EACI,UAAA;ApBkkMR;AoBhkMI;EACI,oBAAA;ApBkkMR;AoBhkMI;EACI,aAAA;EACA,6BAAA;ApBkkMR;AoBjkMQ;EACI,SAAA;EACA,UAAA;ApBmkMZ;AoB/jMQ;EACI,oBAAA;EACA,gBAAA;ApBikMZ;;AoB5jMI;EACI,yBAAA;EACA,8BAAA;ApB+jMR;AoB7jMY;EACI,yBAAA;ApB+jMhB;AoBzjMQ;EACI,gBAAA;ApB2jMZ;AoBxjMY;EACI,cjBriBJ;EiBsiBI,gBjBjjBG;EiBkjBH,6BAAA;EACA,yBAAA;ApB0jMhB;AoBtjMY;EACI,yBjBjiBR;AHylNR;AoBtjMY;EACI,cjBhjBJ;EiBijBI,gBjB5jBG;AHonNnB;;AoBljMI;EACI,cAAA;ApBqjMR;AoBpjMQ;EACI,kBAAA;ApBsjMZ;;AoBhjMQ;EACI,WAAA;EACA,YAAA;ApBmjMZ;;AoB/iMA;EACI,yBAAA;ApBkjMJ;AoBjjMI;EACI,+BAAA;EACA,8BAAA;EACA,aAAA;EACA,gBjBvlBW;EiBwlBX,ejBlWO;AHq5Mf;;AoB/iMI;EACI,+BAAA;EACA,8BAAA;EACA,iBAAA;EACA,cjBtcK;AHw/Mb;;AoB/iMA;EACI,yBAAA;ApBkjMJ;AoBjjMI;EACI,iBAAA;EACA,gBjBvmBW;EiBwmBX,ejBlXO;AHq6Mf;AoBjjMI;EACI,cjBjdK;AHogNb;;AoBhjMA;EACI,cAAA;ApBmjMJ;AoBjjMQ;EACI,2BAAA;EACA,mBAAA;EACA,0BAAA;ApBmjMZ;AoBhjMI;EACI,kBAAA;ApBkjMR;;ACjoNI;EmBklBJ;IAEQ,cAAA;IACA,kBAAA;EpBkjMN;AACF;;AoB/iMI;EACI,cjB1nBE;EiB2nBF,gBjBpoBW;EiBqoBX,ejB9YO;AHg8Mf;;AoB9iMI;EACI,0BAAA;ApBijMR;AoB/iMI;EACI,UAAA;ApBijMR;AoB/iMI;EACI,SAAA;EACA,4BAAA;ApBijMR;AoBhjMQ;EACI,aAAA;ApBkjMZ;AoBjjMY;EACI,gBAAA;EACA,sBAAA;ApBmjMhB;;AqBltNA;EACI,yBlB+BI;EkB9BJ,clBiKS;EkBhKT,qBAAA;EACA,kBAAA;EACA,gBlBEiB;AHmtNrB;AqBptNI;EACI,clB4JK;EkB3JL,yBlBiKa;EkBhKb,gBAAA;ArBstNR;AqBptNI;EACI,qCAAA;EACA,gBAAA;ArBstNR;AqBptNI;EACI,sBAAA;ArBstNR;AqBptNI;EACI,gBAAA;EACA,0BlBLO;EkBMP,elBsOO;EkBrOP,cAAA;EACA,yBlBSA;EkBRA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAAA;EACA,clBuIK;AH+kNb;;AqBntNA;EACI,qBAAA;EACA,oBAAA;EACA,clBsIS;AHglNb;;AqBptNA;EACI,clB8HS;EkB7HT,yBlBNI;EkBOJ,yBAAA;ArButNJ;;AqBptNI;EACI,0BAAA;ArButNR;AqBrtNI;EACI,qCAAA;EACA,kBlB0LQ;EkBzLR,gBAAA;ArButNR;;AqBptNA;EACI,mCAAA;EACA,kCAAA;ArButNJ;;AqBrtNA;EACI,+BAAA;EACA,gCAAA;ArBwtNJ;;AqBptNQ;EACI,yCAAA;EACA,clB7CF;AHowNV;AqBttNY;EACI,yBlB/CN;EkBgDM,clBlCR;AH0vNR;AqBttNY;EACI,yBlBrCR;EkBsCQ,clB6FH;AH2nNb;AqBvtNgB;EACI,yBlBiGC;EkBhGD,clB0FP;AH+nNb;AqBntNQ;EACI,sCAAA;EACA,clB7DA;AHkxNZ;AqBptNY;EACI,yBlB/DJ;EkBgEI,clBpDR;AH0wNR;AqBptNY;EACI,yBlBvDR;EkBwDQ,clB2EH;AH2oNb;AqBrtNgB;EACI,yBlB+EC;EkB9ED,clBwEP;AH+oNb;AqBjtNQ;EACI,yCAAA;EACA,clB7EF;AHgyNV;AqBltNY;EACI,yBlB/EN;EkBgFM,clBtER;AH0xNR;AqBltNY;EACI,yBlBzER;EkB0EQ,clByDH;AH2pNb;AqBntNgB;EACI,yBlB6DC;EkB5DD,clBsDP;AH+pNb;AqB/sNQ;EACI,sCAAA;EACA,clBzFH;AH0yNT;AqBhtNY;EACI,yBlB3FP;EkB4FO,clBxFR;AH0yNR;AqBhtNY;EACI,yBlB3FR;EkB4FQ,clBuCH;AH2qNb;AqBjtNgB;EACI,yBlB2CC;EkB1CD,clBoCP;AH+qNb;AqB7sNQ;EACI,wCAAA;EACA,clB7GF;AH4zNV;AqB9sNY;EACI,yBlB/GN;EkBgHM,clB1GR;AH0zNR;AqB9sNY;EACI,yBlB7GR;EkB8GQ,clBqBH;AH2rNb;AqB/sNgB;EACI,yBlByBC;EkBxBD,clBkBP;AH+rNb;AqB3sNQ;EACI,yCAAA;EACA,clBjIL;AH80NP;AqB5sNY;EACI,yBlBnIT;EkBoIS,clB5HR;AH00NR;AqB5sNY;EACI,yBlB/HR;EkBgIQ,clBGH;AH2sNb;AqB7sNgB;EACI,yBlBOC;EkBND,cAAA;ArB+sNpB;;AqBvsNQ;EACI,yBlB1JF;EkB2JE,clB7IJ;AHu1NR;AqBzsNY;EACI,yBlB/IR;EkBgJQ,clB9JN;AHy2NV;AqBzsNY;EACI,yBlBnJR;EkBoJQ,clBjBH;AH4tNb;AqB1sNgB;EACI,yBlBbC;EkBcD,clBpBP;AHguNb;AqBtsNQ;EACI,yBlB1KA;EkB2KA,clB/JJ;AHu2NR;AqBvsNY;EACI,yBlBjKR;EkBkKQ,clB9KJ;AHu3NZ;AqBvsNY;EACI,yBlBrKR;EkBsKQ,clBnCH;AH4uNb;AqBxsNgB;EACI,yBlB/BC;EkBgCD,clBtCP;AHgvNb;AqBpsNQ;EACI,yBlB1LF;EkB2LE,clBjLJ;AHu3NR;AqBrsNY;EACI,yBlBnLR;EkBoLQ,clB9LN;AHq4NV;AqBrsNY;EACI,yBlBvLR;EkBwLQ,clBrDH;AH4vNb;AqBtsNgB;EACI,yBlBjDC;EkBkDD,clBxDP;AHgwNb;AqBlsNQ;EACI,yBlBtMH;EkBuMG,clBnMJ;AHu4NR;AqBnsNY;EACI,yBlBrMR;EkBsMQ,clB1MP;AH+4NT;AqBnsNY;EACI,yBlBzMR;EkB0MQ,clBvEH;AH4wNb;AqBpsNgB;EACI,yBlBnEC;EkBoED,clB1EP;AHgxNb;AqBhsNQ;EACI,yBlB1NF;EkB2NE,clBrNJ;AHu5NR;AqBjsNY;EACI,yBlBvNR;EkBwNQ,clB9NN;AHi6NV;AqBjsNY;EACI,yBlB3NR;EkB4NQ,clBzFH;AH4xNb;AqBlsNgB;EACI,yBlBrFC;EkBsFD,clB5FP;AHgyNb;AqB9rNQ;EACI,yBlB9OL;EkB+OK,clBvOJ;AHu6NR;AqB/rNY;EACI,yBlBzOR;EkB0OQ,clBlPT;AHm7NP;AqB/rNY;EACI,yBlB7OR;EkB8OQ,clB3GH;AH4yNb;AqBhsNgB;EACI,yBlBvGC;EkBwGD,clB9GP;AHgzNb;;AqB1rNQ;EACI,yBAAA;ArB6rNZ;AqB3rNQ;EACI,yBlB7PJ;EkB8PI,clB5QF;EkB6QE,qBAAA;ArB6rNZ;AqB5rNY;EACI,yBlBjQR;EkBkQQ,clBhRN;EkBiRM,yBAAA;ArB8rNhB;AqB5rNY;EACI,mCAAA;ArB8rNhB;AqBzrNQ;EACI,yBAAA;ArB2rNZ;AqBzrNQ;EACI,yBlB/QJ;EkBgRI,clB5RA;EkB6RA,qBAAA;ArB2rNZ;AqB1rNY;EACI,yBlBnRR;EkBoRQ,clBhSJ;EkBiSI,yBAAA;ArB4rNhB;AqB1rNY;EACI,mCAAA;ArB4rNhB;AqBvrNQ;EACI,yBAAA;ArByrNZ;AqBvrNQ;EACI,yBlBjSJ;EkBkSI,clB5SF;EkB6SE,qBAAA;ArByrNZ;AqBxrNY;EACI,yBlBrSR;EkBsSQ,clBhTN;EkBiTM,yBAAA;ArB0rNhB;AqBxrNY;EACI,mCAAA;ArB0rNhB;AqBrrNQ;EACI,yBAAA;ArBurNZ;AqBrrNQ;EACI,yBlBnTJ;EkBoTI,clBxTH;EkByTG,qBAAA;ArBurNZ;AqBtrNY;EACI,yBlBvTR;EkBwTQ,clB5TP;EkB6TO,yBAAA;ArBwrNhB;AqBtrNY;EACI,mCAAA;ArBwrNhB;AqBnrNQ;EACI,yBAAA;ArBqrNZ;AqBnrNQ;EACI,yBlBrUJ;EkBsUI,clB5UF;EkB6UE,qBAAA;ArBqrNZ;AqBprNY;EACI,yBlBzUR;EkB0UQ,clBhVN;EkBiVM,yBAAA;ArBsrNhB;AqBprNY;EACI,mCAAA;ArBsrNhB;AqBjrNQ;EACI,yBAAA;ArBmrNZ;AqBjrNQ;EACI,yBlBvVJ;EkBwVI,clBhWL;EkBiWK,qBAAA;ArBmrNZ;AqBlrNY;EACI,yBlB3VR;EkB4VQ,clBpWT;EkBqWS,yBAAA;ArBorNhB;AqBlrNY;EACI,mCAAA;ArBorNhB;;AqB7qNQ;EACI,aAAA;ArBgrNZ;;AqB1qNQ;EACI,4BAAA;ArB6qNZ;AqB5qNY;EACI,kBAAA;EACA,4BAAA;ArB8qNhB;;AqBtqNY;EACI,YAAA;EACA,0BlB7YD;EkB8YC,yBlBpPK;AH65NrB;AqBvqNY;EACI,gBAAA;EACZ,0BlBlZW;EkBmZC,yBlBlYR;AH2iOR;;AqBjqNY;EACI,yCAAA;EACA,0DAAA;ArBoqNhB;AqBnqNgB;EACI,yCAAA;EACA,clB/YZ;AHojOR;AqBlqNY;EACI,yCAAA;EACA,sBAAA;EACA,0DAAA;ArBoqNhB;AqBhqNY;EACI,sCAAA;EACA,uDAAA;ArBkqNhB;AqBjqNgB;EACI,sCAAA;EACA,clB9ZZ;AHikOR;AqBhqNY;EACI,sCAAA;EACA,sBAAA;EACA,uDAAA;ArBkqNhB;AqB9pNY;EACI,wCAAA;EACA,yDAAA;ArBgqNhB;AqB/pNgB;EACI,wCAAA;EACA,clB7aZ;AH8kOR;AqB9pNY;EACI,wCAAA;EACA,sBAAA;EACA,yDAAA;ArBgqNhB;AqB5pNY;EACI,yCAAA;EACA,0DAAA;ArB8pNhB;AqB7pNgB;EACI,yCAAA;EACA,clB5bZ;AH2lOR;AqB5pNY;EACI,yCAAA;EACA,sBAAA;EACA,0DAAA;ArB8pNhB;AqB1pNY;EACI,yCAAA;EACA,0DAAA;ArB4pNhB;AqB3pNgB;EACI,yCAAA;EACA,clB3cZ;AHwmOR;AqB1pNY;EACI,yCAAA;EACA,sBAAA;EACA,0DAAA;ArB4pNhB;AqBxpNY;EACI,sCAAA;EACA,uDAAA;ArB0pNhB;AqBzpNgB;EACI,sCAAA;EACA,clB1dZ;AHqnOR;AqBxpNY;EACI,sCAAA;EACA,sBAAA;EACA,uDAAA;ArB0pNhB;;AsBzpOE;EACE,8CAAA;EACA,sCAAA;AtB4pOJ;;AsBvpOI;EACE,8CAAA;EACA,sCAAA;AtB0pON;;AsBppOI;EACE,cnBuJO;AHggOb;AsBppOI;EACE,cnBHI;AHypOV;;AsBlpOA;EACE,cnB8IW;EmB7IX,YAAA;AtBqpOF;;AsBlpOE;EACE,cnByIS;EmBxIT,gBAAA;EACA,qCAAA;AtBqpOJ;;AsBjpOE;EACE,cnBkIS;EmBjIT,gBAAA;EACA,qCAAA;AtBopOJ;;AsBhpOE;EACE,cnB2HS;EmB1HT,YAAA;AtBmpOJ;;AsB/oOE;EACE,cnBqHS;EmBpHT,YAAA;AtBkpOJ;;AsB9oOE;EACE,cnB+GS;EmB9GT,gBAAA;EACA,qCAAA;AtBipOJ;;AsB7oOE;EACE,WAAA;EACA,aAAA;AtBgpOJ;;AsB7oOA;EACE,kBAAA;EACA,kBnBmKc;AH6+NhB;AsB9oOE;EACC,cnBzCK;AHyrOR;AsB5oOI;EACD,cnB9CK;AH4rOR;AsB5oOE;EACC,cnBjDK;EmBkDL,YAAA;AtB8oOH;AsB3oOM;EACE,cnBtDA;AHmsOR;AsB3oOG;EACC,cnBzDI;AHssOR;;AsBxoOA;EACE,YAAA;AtB2oOF;;AsBxoOE;EACE,iBAAA;AtB2oOJ;;AuB9uOA;EACI,qBAAA;EACA,yBpB8BI;EoB7BJ,gCAAA;EACA,kBAAA;EACA,kBpBoOY;EoBnOZ,yBAAA;EACA,gBAAA;AvBivOJ;AuBhvOI;EACI,gBAAA;AvBkvOR;AuBhvOI;EACI,epBoPO;EoBnPP,gBpBJW;EoBKX,0BAAA;AvBkvOR;AuBhvOI;EACI,qBpB6GG;EoB5GH,kBAAA;EACA,uBAAA;EACA,0BAAA;AvBkvOR;AuBjvOQ;EACI,mBAAA;AvBmvOZ;AuBjvOQ;EACI,sBAAA;EACA,mBAAA;EACA,gBAAA;AvBmvOZ;AuBhvOI;EACI,qBpB+FG;EoB9FH,uBAAA;EACA,0BAAA;AvBkvOR;;AuB9uOE;EACI,qBAAA;AvBivON;;AuB7uOE;EACA,kBpB8Lc;EoB7Ld,SAAA;EACA,yBpBbM;EoBcN,kBAAA;EACA,wBAAA;EACA,WAAA;AvBgvOF;AuB/uOE;EACE,qBAAA;EACA,wCAAA;EACA,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,YAAA;AvBivOJ;AuBhvOI;EACE,oCAAA;AvBkvON;AuBhvOI;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBpBxDa;EoByDb,0BAAA;AvBkvON;AuBjvOM;EACE,mBAAA;EACA,uBAAA;AvBmvOR;AuB/uOE;EACE,wCAAA;EACA,qCAAA;EACA,oBAAA;EACA,epB5Ea;AH6zOjB;AuB/uOE;EACE,eAAA;EACA,cpBkFS;AH+pOb;AuB/uOE;EACE,kBAAA;AvBivOJ;AuB9uOE;EACE,mBAAA;AvBgvOJ;AuB9uOE;EACE,WAAA;EACA,YAAA;AvBgvOJ;AuB9uOE;EACE,kBAAA;EACA,gBAAA;EACA,+BAAA;AvBgvOJ;AuB/uOI;EACE,oDAAA;AvBivON;AuB/uOI;EACE,sDAAA;AvBivON;AuB/uOI;EACE,SAAA;AvBivON;AuB/uOI;EACE,WAAA;EACA,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,oCAAA;EACA,kBAAA;AvBivON;AuB9uOE;EACE,yBpBpGM;EoBqGN,cpBvFI;AHu0OR;AuB/uOI;EACE,qDAAA;EACA,cpB1FE;EoB2FF,oDAAA;AvBivON;AuBhvOM;EACE,yBpB7FA;AH+0OR;AuB/uOI;EACE,cpBjGE;AHk1OR;AuB/uOI;EACE,qDAAA;EACA,cpBrGE;EoBsGF,sDAAA;AvBivON;AuB9uOE;EACE,yBpBtHQ;EoBuHR,cpB3GI;AH21OR;AuB/uOI;EACE,qDAAA;EACA,cpB9GE;EoB+GF,oDAAA;AvBivON;AuBhvOM;EACE,yBpBjHA;AHm2OR;AuB/uOI;EACE,cpBrHE;AHs2OR;AuB/uOI;EACE,qDAAA;EACA,cpBzHE;EoB0HF,sDAAA;AvBivON;AuB9uOE;EACE,yBpBpIM;EoBqIN,cpB/HI;AH+2OR;AuB/uOI;EACE,qDAAA;EACA,cpBlIE;EoBmIF,oDAAA;AvBivON;AuBhvOM;EACE,yBpBrIA;AHu3OR;AuB/uOI;EACE,cpBzIE;AH03OR;AuB/uOI;EACE,qDAAA;EACA,cpB7IE;EoB8IF,sDAAA;AvBivON;AuB9uOE;EACE,yBpB1JG;EoB2JH,cpBnJI;AHm4OR;AuB/uOI;EACE,qDAAA;EACA,cpBtJE;EoBuJF,oDAAA;AvBivON;AuBhvOM;EACE,yBpBzJA;AH24OR;AuB/uOI;EACE,cpB7JE;AH84OR;AuB/uOI;EACE,qDAAA;EACA,cpBjKE;EoBkKF,sDAAA;AvBivON;AuB9uOE;EACE,yBpBhLM;EoBiLN,cpBvKI;AHu5OR;AuB/uOI;EACE,qDAAA;EACA,cpB1KE;EoB2KF,oDAAA;AvBivON;AuBhvOM;EACE,yBpB7KA;AH+5OR;AuB/uOI;EACE,cpBjLE;AHk6OR;AuB/uOI;EACE,qDAAA;EACA,cpBrLE;EoBsLF,sDAAA;AvBivON;AuB9uOE;EACE,yBpB9LK;EoB+LL,cpB3LI;AH26OR;AuB/uOI;EACE,qDAAA;EACA,cpB9LE;EoB+LF,oDAAA;AvBivON;AuBhvOM;EACE,yBpBjMA;AHm7OR;AuB/uOI;EACE,cpBrME;AHs7OR;AuB/uOI;EACE,qDAAA;EACA,cpBzME;EoB0MF,sDAAA;AvBivON;AuB9uOE;EACE,yBpB/MI;EoBgNJ,cpB5ES;AH4zOb;AuB/uOI;EACE,gDAAA;EACA,cpB/EO;EoBgFP,yBpBrHK;AHs2OX;AuB/uOI;EACE,cpBnFO;AHo0Ob;AuB/uOI;EACE,gDAAA;EACA,cpBvFO;EoBwFP,2BpB7HK;AH82OX;AuB9uOE;EACE,yBpBjOG;EoBkOH,cpBhOI;AHg9OR;AuB/uOI;EACE,qDAAA;EACA,cpBnOE;EoBoOF,oDAAA;AvBivON;AuBhvOM;EACE,yBpBtOA;AHw9OR;AuB/uOI;EACE,cpB1OE;AH29OR;AuB/uOI;EACE,qDAAA;EACA,cpB9OE;EoB+OF,sDAAA;AvBivON;AuB9uOE;EACE,kBAAA;EACA,MAAA;EACA,mBAAA;EACA,SAAA;EACA,qBAAA;EACA,UAAA;EACA,oBAAA;EACA,WAAA;AvBgvOJ;AuB9uOE;EACE,aAAA;AvBgvOJ;AuB7uOI;EACE,cAAA;AvB+uON;AuB7uOI;EACE,aAAA;AvB+uON;AuB5uOE;EACE,eAAA;EACA,MAAA;EACA,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,aAAA;EACA,SAAA;AvB8uOJ;;AuB3uOA;EACI,epBtCW;EoBuCX,cpBpLO;AHk6OX;;AuB5uOA;EACE,gBAAA;EACA,2BAAA;EACA,yBAAA;EACA,yBpB1RM;EoB2RN,0CAAA;AvB+uOF;;AuB7uOA;EACE,2CAAA;EACA,qCAAA;AvBgvOF;;AuB9uOA;EACE,0CAAA;EACA,oCAAA;AvBivOF;;AuB/uOA;EACE,wCAAA;EACA,kCAAA;AvBkvOF;;AuBhvOA;EACE,yBpBvJS;EoBwJT,cpB1SM;EoB2SN,yBAAA;AvBmvOF;AuBlvOE;EAGE,oCAAA;EACA,yBAAA;EACA,oCAAA;AvBkvOJ;;AuB/uOA;EACE,mBAAA;EAiBA,mGAAA;EAQA,mHAAA;EACA,cpB/UM;EoBgVN,6BAAA;AvB6tOF;AuB5tOE;EAGE,cpBpVI;EoBqVJ,6BAAA;AvB4tOJ;;AuBztOA;EACE,yBpBtMQ;EoBuMR,cpB1VM;EoB2VN,yBAAA;AvB4tOF;AuB3tOE;EAGE,oCAAA;EACA,yBAAA;EACA,oCAAA;AvB2tOJ;;AuBxtOA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AvB2tOJ;;AuBztOA;EACI,gCAAA;AvB4tOJ;;AuBztOA;EAEM;IACI,8BAAA;EvB2tOR;AACF;AuBxtOA;EAEM;IACI,8BAAA;EvBytOR;AACF;AwBhnPI;EACE,yBrBeI;AHmmPV;AwBhnPI;EAEE,yBrBWI;AHsmPV;AwB/mPI;EAEE,2BrBOI;AHymPV;AwB9mPI;EAEE,0BrBGI;AH4mPV;AwB7mPI;EAEE,4BrBDI;AH+mPV;AwB/nPI;EACE,yBrBiBM;AHgnPZ;AwB/nPI;EAEE,yBrBaM;AHmnPZ;AwB9nPI;EAEE,2BrBSM;AHsnPZ;AwB7nPI;EAEE,0BrBKM;AHynPZ;AwB5nPI;EAEE,4BrBCM;AH4nPZ;AwB9oPI;EACE,yBrBuBI;AHynPV;AwB9oPI;EAEE,yBrBmBI;AH4nPV;AwB7oPI;EAEE,2BrBeI;AH+nPV;AwB5oPI;EAEE,0BrBWI;AHkoPV;AwB3oPI;EAEE,4BrBOI;AHqoPV;AwB7pPI;EACE,yBrBqBC;AH0oPP;AwB7pPI;EAEE,yBrBiBC;AH6oPP;AwB5pPI;EAEE,2BrBaC;AHgpPP;AwB3pPI;EAEE,0BrBSC;AHmpPP;AwB1pPI;EAEE,4BrBKC;AHspPP;AwB5qPI;EACE,yBrBmBI;AH2pPV;AwB5qPI;EAEE,yBrBeI;AH8pPV;AwB3qPI;EAEE,2BrBWI;AHiqPV;AwB1qPI;EAEE,0BrBOI;AHoqPV;AwBzqPI;EAEE,4BrBGI;AHuqPV;AwB3rPI;EACE,yBrByBG;AHoqPT;AwB3rPI;EAEE,yBrBqBG;AHuqPT;AwB1rPI;EAEE,2BrBiBG;AH0qPT;AwBzrPI;EAEE,0BrBaG;AH6qPT;AwBxrPI;EAEE,4BrBSG;AHgrPT;AwB1sPI;EACE,yBrB2BC;AHirPP;AwB1sPI;EAEE,yBrBuBC;AHorPP;AwBzsPI;EAEE,2BrBmBC;AHurPP;AwBxsPI;EAEE,0BrBeC;AH0rPP;AwBvsPI;EAEE,4BrBWC;AH6rPP;AwBjrPI;EACE,crBXE;AH8rPR;AwB5tPI;EACE,yBrB4BE;AHksPR;AwB5tPI;EAEE,yBrBwBE;AHqsPR;AwB3tPI;EAEE,2BrBoBE;AHwsPR;AwB1tPI;EAEE,0BrBgBE;AH2sPR;AwBztPI;EAEE,4BrBYE;AH8sPR;AwB7rPI;EACE,crBkHO;AH6kPb;;AyBhvPA;EACI,yBAAA;AzBmvPJ;AyBlvPI;EACE,oBAAA;AzBovPN;;AyBjvPE;EACE,ctB4JS;EsB3JT,kBtBiOY;EsBhOZ,gBtBDmB;AHqvPvB;AyBnvPI;EACE,yCAAA;EACA,ctBMI;AH+uPV;;AyBlvPE;EACE,ctBmJS;AHkmPb;AyBpvPI;EACE,ctBiJO;EsBhJP,YAAA;AzBsvPN;;AyBnvPE;;EAEE,ctBNM;AH4vPV;;AyBpvPE;EACE,ctBwIS;EsBvIT,YAAA;AzBuvPJ;;AyBrvPE;EACE,4BAAA;AzBwvPJ;;AyBtvPE;EACE,ctBiIS;AHwnPb;;AyBrvPM;;EAEE,ctBRA;AHgwPR;AyBrvPI;;EAEE,ctBbE;AHowPR;;AyBpvPE;;EAEE,ctBlBI;EsBmBJ,yBtBjCM;AHwxPV;;AyBpvPA;EACE,SAAA;AzBuvPF;AyBtvPE;EACE,0BAAA;AzBwvPJ;AyBvvPI;EACE,oBAAA;AzByvPN;AyBrvPI;EACI,yCAAA;EACA,ctB/CE;AHsyPV;AyBtvPQ;EACE,mCAAA;AzBwvPV;AyBrvPI;EACI,uBAAA;EACA,ctBtDE;AH6yPV;;AyBlvPE;EACE,yCAAA;AzBqvPJ;AyBpvPI;EACE,yCAAA;EACA,qCAAA;EACA,ctBhEI;AHszPV;;AyBjvPE;EACE,gBAAA;AzBovPJ;AyBlvPE;EACE,uCAAA;AzBovPJ;AyBlvPE;EACE,6BAAA;EACA,mCAAA;EACA,ctB9EM;AHk0PV;;AyBjvPA;EACE,SAAA;AzBovPF;AyBnvPE;EACE,ctBkES;EsBjET,SAAA;AzBqvPJ;AyBnvPE;EACE,kBAAA;AzBqvPJ;AyBpvPI;EACE,yBtB7EE;EsB8EF,ctBsDO;EsBrDP,SAAA;AzBsvPN;AyBpvPI;EAEE,SAAA;AzBqvPN;AyBnvPI;EACI,yBtBtFA;EsBuFA,ctB6CK;AHwsPb;;AyBjvPA;EACE,SAAA;AzBovPF;AyBnvPE;EACE,ctB2CS;EsB1CT,SAAA;EACA,kBAAA;AzBqvPJ;AyBlvPI;EACE,yBtBjHI;EsBkHJ,ctBpGE;EsBqGF,SAAA;AzBovPN;AyBlvPI;EAEE,SAAA;EACA,yBtBxHI;EsByHJ,ctB3GE;AH81PR;;AyB/uPA;EACE,SAAA;AzBkvPF;AyBhvPI;EACE,yBAAA;EACA,mCAAA;EACA,6BAAA;EACA,ctBpII;AHs3PV;;AyB9uPA;EACE,oBAAA;AzBivPF;AyBhvPE;EACE,yBAAA;AzBkvPJ;AyBjvPI;EACE,oBAAA;AzBmvPN;AyBjvPI;EACE,6BAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBtB9Je;AHi5PrB;AyBlvPM;EACE,mCAAA;EACA,ctBtJE;EsBuJF,6BAAA;AzBovPR;AyBlvPM;EACE,6BAAA;EACA,6BAAA;EACA,ctB5JE;AHg5PV;;AyB/uPA;EACE,SAAA;AzBkvPF;AyBjvPE;EACE,yBAAA;AzBmvPJ;AyBlvPI;EACE,oBAAA;AzBovPN;AyBlvPI;EACE,6BAAA;EACA,ctB1KI;EsB2KJ,yBAAA;EACA,iBAAA;AzBovPN;AyBnvPM;EACE,mBtB9KE;EsB+KF,ctBjKA;EsBkKA,yBAAA;AzBqvPR;AyBnvPM;EACE,yBAAA;EACA,6BAAA;EACC,ctBrLC;AH06PV;;AyBhvPA;EACE,SAAA;AzBmvPF;AyBlvPE;EACE,yBAAA;AzBovPJ;AyBnvPI;EACE,oBAAA;AzBqvPN;AyBnvPI;EACE,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,ctBjDO;EsBkDP,yBtB3LE;AHg7PR;AyBpvPM;EACE,eAAA;AzBsvPR;AyBpvPM;EACE,yBtB7ME;EsB8MF,ctBhMA;EsBiMA,kBAAA;AzBsvPR;AyBrvPQ;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,wBAAA;EACA,WAAA;EACA,YAAA;EACA,yBtBxNA;AH+8PV;AyBrvPQ;EACE,ctB7MF;AHo8PR;AyBpvPM;EACE,ctB/NE;AHq9PV;;AyBjvPA;EACE,SAAA;AzBovPF;AyBnvPE;EACE,SAAA;EACA,yBAAA;AzBqvPJ;AyBpvPI;EACE,oBAAA;AzBsvPN;AyBpvPI;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,wBAAA;AzBsvPN;AyBrvPM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBtBxPE;EsByPF,ctB3OA;EsB4OA,uBAAA;EACA,gBtBtQa;AH6/PrB;AyBrvPM;EACE,mBtB9PE;EsB+PF,yBAAA;EACA,ctBlPA;AHy+PR;AyBtvPQ;EACE,mBtBlQA;EsBmQA,yBAAA;EACA,ctBtPF;AH8+PR;AyBtvPQ;EACE,mBtBzPF;EsB0PE,ctBxQA;AHggQV;AyBrvPM;EACE,yBAAA;EACA,ctB7QE;EsB8QA,uBAAA;AzBuvPV;;AyBlvPA;EACE,mBAAA;EACA,gBAAA;EACA,yBtBzQM;EsB0QN,kBAAA;EACA,sBAAA;AzBqvPF;AyBpvPE;EACE,yBAAA;AzBsvPJ;AyBrvPI;EACE,oBAAA;AzBuvPN;AyBpvPE;EACE,kBAAA;EACA,qBAAA;AzBsvPJ;AyBrvPI;EACE,oCAAA;EACA,yBAAA;EACA,sDtBrEO;EsBsEP,+BAAA;AzBuvPN;;AyBjvPQ;EACA,uBAAA;EACA,ctB9SE;AHkiQV;;AyB9uPA;EACE,mBAAA;AzBivPF;AyBhvPE;EACE,yBAAA;AzBkvPJ;AyBjvPI;EACE,oBAAA;AzBmvPN;AyBjvPI;EACE,SAAA;AzBmvPN;AyBlvPM;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBtBrTA;EsBsTA,ctBlLK;EsBmLL,qBAAA;AzBovPR;AyBlvPM;EACE,SAAA;EACA,uBAAA;EACA,ctBzUE;AH6jQV;AyBnvPQ;EACE,ctB3UA;AHgkQV;AyBlvPM;EACE,6BAAA;EACA,kBAAA;EACA,SAAA;EACA,ctBlVE;AHskQV;AyBnvPQ;EACE,yCAAA;EACA,ctBrVA;AH0kQV;AyBnvPQ;EACE,WAAA;EACA,kBAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,yBtB/VA;EsBgWA,mBAAA;AzBqvPV;;AyB/uPA;EACE,mBAAA;AzBkvPF;AyBjvPE;EACE,kBAAA;EACA,yBAAA;AzBmvPJ;AyBlvPI;EACE,oBAAA;AzBovPN;AyBlvPI;EACE,kBAAA;EACA,SAAA;EACA,kBAAA;AzBovPN;AyBnvPM;EACE,kBAAA;EACA,WAAA;EACA,0BAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,cAAA;EACA,yBtB7WA;EsB8WA,kBAAA;AzBqvPR;AyBnvPM;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBtB3XA;EsB4XA,kBAAA;EACA,yBAAA;AzBqvPR;AyBnvPM;EACE,YAAA;AzBqvPR;AyBnvPM;EACE,YAAA;AzBqvPR;AyBnvPM;EACE,YAAA;AzBqvPR;AyBnvPM;EACE,SAAA;EACA,uBAAA;EACA,ctBzZE;AH8oQV;AyBnvPM;EACE,6BAAA;EACA,SAAA;EACA,ctB9ZE;AHmpQV;AyBpvPQ;EACE,yBtBhaA;AHspQV;AyBpvPQ;EACE,qBtBnaA;EsBoaA,ctBpaA;AH0pQV;;AyB/uPE;EACE,SAAA;AzBkvPJ;AyBjvPI;EACE,yBAAA;AzBmvPN;AyBlvPM;EACE,oBAAA;AzBovPR;AyBjvPI;EACE,SAAA;AzBmvPN;AyBlvPM;EACE,SAAA;EACA,uBAAA;EACA,ctBxbE;AH4qQV;AyBlvPM;EACE,6BAAA;EACA,SAAA;EACA,ctB7bE;EsB8bF,kBAAA;EACA,gBAAA;AzBovPR;AyBnvPQ;EACE,kBAAA;EACA,WAAA;EACA,cAAA;EACA,uBAAA;EACA,wBAAA;EACA,uBAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,yBtB1cA;EsB2cA,yBAAA;AzBqvPV;AyBnvPQ;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBtBpdA;AHysQV;;AyB/uPA;EACE,yBAAA;EACA,yBtB5dQ;EsB6dR,ctB/cM;EsBgdN,aAAA;EACE,kBAAA;AzBkvPJ;;AyB/uPE;EACE,yBAAA;AzBkvPJ;AyBjvPI;EACE,oBAAA;AzBmvPN;AyBjvPI;EACE,mBtBxeI;AH2tQV;;AyB/uPA;EACE,SAAA;EACA,yBtBheM;EsBieN,kBAAA;EACA,ctBhfQ;EsBifR,eAAA;AzBkvPF;AyBjvPE;EACE,SAAA;EACA,yBAAA;AzBmvPJ;AyBlvPI;EACE,oBAAA;AzBovPN;AyBlvPI;EACE,ctBzfI;EsB0fJ,oBAAA;EACA,mBAAA;EACA,SAAA;EACA,gBtBxgBe;EsB2gBf,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AzBovPN;AyBnvPM;EACE,SAAA;EACA,yBtBtgBE;EsBugBF,ctBzfA;EsB0fA,SAAA;EACA,wDAAA;AzBqvPR;AyBnvPM;EAEE,SAAA;AzBovPR;;AyB9uPE;EACE,wBAAA;EACA,mBAAA;EACA,ctBhYS;EsBiYT,gBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AzBivPJ;AyBhvPI;EAEE,yCAAA;EACA,ctBjiBI;AHkxQV;;AyB1uPM;EACE,yCAAA;EACA,ctB1iBE;AHuxQV;;AyBxuPA;EAEI;IACE,sBAAA;EzB0uPJ;AACF;AyBtuPA;EACI,gBAAA;AzBwuPJ;AyBtuPQ;EACI,mBAAA;AzBwuPZ;AyBruPI;EACI,mBAAA;EACA,eAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;AzBuuPR;AyBtuPQ;EACE,qBtB1dC;AHksQX;AyBpuPQ;EACI,ctB5dD;EsB6dC,wBAAA;AzBsuPZ;AyBruPY;EACI,yBAAA;EACA,4BtB9kBN;EsB+kBM,6BAAA;ExBjgBd,yBwBkgBkC;AzByuPpC;;AyBnuPI;EACI,yBtBzkBA;EsB0kBA,SAAA;AzBsuPR;AyBruPQ;EACI,yBtB1lBF;EsB2lBE,qBtB3lBF;EsB4lBE,ctB9kBJ;AHqzQR;;AyBjuPQ;EACI,yBAAA;EACA,ctBpmBF;AHw0QV;AyB/tPY;EACI,uBAAA;AzBiuPhB;AyBhuPgB;EACI,yBtB5mBV;EFkHR,gBwB2fmC;AzBkuPrC;AyBhuPgB;EACI,yBtBhnBV;EsBinBU,6BAAA;ExB/flB,gBwBggBmC;AzBkuPrC;AyB3tPY;EACI,uBAAA;AzB6tPhB;AyB5tPgB;EACI,4BtB5nBV;EsB6nBU,uBAAA;ExB3gBlB,gBwB4gBmC;AzB8tPrC;AyBztPI;EACI,yBtBtnBA;EsBunBA,SAAA;AzB2tPR;AyBvtPoB;EACI,yBtB1oBd;EsB2oBc,qBtB3oBd;EsB4oBc,ctB9nBhB;EFoGN,mBwB2hBuC;AzBytPzC;AyBltPgB;EACI,yBtBrpBV;EsBspBU,qBtBtpBV;EsBupBU,ctBzoBZ;EFoGN,gBwBsiBmC;AzBotPrC;;AyB7sPI;EACI,ctBhqBE;AHg3QV;;AyB1sPY;EACI,etB1bD;AHuoQf;;AyBvsPI;EACI,gBAAA;EACA,mBAAA;AzB0sPR;AyBzsPQ;EACI,ctB/qBA;EFyFT,iBwBulBuC;EAC9B,etBtcG;EsBucH,gBtB7rBO;EsB8rBP,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mDAAA;AzB2sPZ;AyBzsPY;EACI,yBAAA;AzB2sPhB;AyBzsPY;EACI,yBAAA;AzB2sPhB;AyBzsPY;EACI,SAAA;EACA,gCAAA;EACA,mBtBpsBN;EsBqsBM,ctBvrBR;AHk4QR;;AyBrsPI;EACI,gBAAA;ExBlnBL,gBwBmnB6B;AzBwsPhC;AyBvsPQ;EACI,ctBhsBJ;EsBisBI,etBjuBK;EsBkuBL,gBtB1tBO;EsB2tBP,SAAA;EACA,mBtBxmBD;EsBymBC,kBAAA;ExBznBT,iBwB0nBuC;ExBnmBxC,kBwBomB2B;ExBxoB3B,yBwByoB8B;AzB2sPhC;AyB1sPY;EACI,mBtBztBN;EsB0tBM,ctB5sBR;AHw5QR;;ACt4QI;EwBgsBA;IACI,gBAAA;IACA,kBAAA;IACA,yBtBrtBA;IsBstBA,sBAAA;IxBzoBL,cwB0oBmC;IxBnnBpC,kBwBonBuB;EzB0sPvB;AACF;A0Bn8QA;EACE,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cvB4BM;EuB3BN,UAAA;A1Bq8QF;A0Bp8QE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;A1Bs8QJ;A0Bp8QE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBvBSK;EuBRL,evByOW;EuBxOX,cAAA;EACA,sBAAA;EACA,4BAAA;A1Bs8QJ;A0Br8QI;EAEE,kBAAA;EACA,WAAA;A1Bs8QN;A0Bp8QI;EACE,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBvBNG;AH48QT;A0Bp8QI;EACE,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBvBdG;AHo9QT;;A0Bl8QA;EACE,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cvBnBM;EuBoBN,YAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;A1Bq8QF;A0Bp8QE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;A1Bs8QJ;A0Bp8QE;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;A1Bs8QJ;A0Bp8QE;EACE,kBAAA;EACA,cAAA;EACA,YAAA;EACA,cAAA;EACA,yCAAA;EACA,cvB7CI;EuB8CJ,yCAAA;EACA,0BAAA;EACA,kBAAA;EACA,eAAA;A1Bs8QJ;;A0Bn8QA;EACE,kBAAA;EACA,yBAAA;EACA,wBAAA;EACA,UAAA;A1Bs8QF;A0Br8QE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;A1Bu8QJ;A0Br8QE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBvB1EK;EuB2EL,evBsJW;EuBrJX,cAAA;EACA,sBAAA;EACA,4BAAA;A1Bu8QJ;A0Bt8QI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,0BAAA;EACA,mBvBvFG;AH+hRT;A0Bt8QI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,wBAAA;EACA,oBAAA;EACA,mBvBhGG;AHwiRT;;A0Bp8QA;EACE,cvBjGM;EuBkGN,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,UAAA;EACA,eAAA;A1Bu8QF;;A0Bp8QE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;A1Bu8QJ;;A0Bn8QE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,2CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;A1Bs8QJ;;A0Bl8QE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;A1Bq8QJ;;A0Bj8QE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;A1Bo8QJ;;A0Bh8QE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;A1Bm8QJ;;A0B/7QE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;A1Bk8QJ;;A0B97QE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;A1Bi8QJ;;A0B77QE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;A1Bg8QJ;;A0B57QE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;A1B+7QJ;;A0B57QA;EACE,cvBvOM;EuBwON,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,UAAA;EACA,eAAA;A1B+7QF;;A0B57QE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;A1B+7QJ;;A0B37QE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;A1B87QJ;;A0B17QE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;A1B67QJ;;A0Bz7QE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;A1B47QJ;;A0Bx7QE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;A1B27QJ;;A0Bv7QE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;A1B07QJ;;A0Bt7QE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;A1By7QJ;;A0Br7QE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;A1Bw7QJ;;A0Bp7QE;EACE,kBAAA;EACA,qBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,QAAA;A1Bu7QJ;;A0Bp7QA;EACE,cvB7WM;EuB8WN,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,UAAA;EACA,evB7Ia;AHokRf;A0Bt7QE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,wCAAA;EACA,QAAA;A1Bw7QJ;;A0Br7QA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;A1Bw7QF;A0Bv7QE;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,cAAA;EACA,cvB3YI;EuB4YJ,iCAAA;EACA,yCAAA;EACA,0BAAA;EACA,kBAAA;A1By7QJ;;A0Bt7QA;EACE,uBAAA;EACA,wBAAA;A1By7QF;A0Bx7QE;EACE,sBAAA;EACA,sBAAA;EACA,yBAAA;A1B07QJ;A0Bz7QI;EACE,wBAAA;EACA,wBAAA;EACA,yBAAA;A1B27QN;;A0Bv7QA;EACE,qBAAA;EACA,wBAAA;A1B07QF;A0Bz7QE;EACE,sBAAA;EACA,oBAAA;EACA,wBAAA;A1B27QJ;A0B17QI;EACE,yBAAA;EACA,sBAAA;EACA,yBAAA;A1B47QN;;A0Bx7QA;EACE,uBAAA;EACA,sBAAA;A1B27QF;A0B17QE;EACE,wBAAA;EACA,sBAAA;EACA,wBAAA;A1B47QJ;A0B37QI;EACE,yBAAA;EACA,wBAAA;EACA,uBAAA;A1B67QN;;A0Bz7QA;EACE,qBAAA;EACA,sBAAA;A1B47QF;A0B37QE;EACE,wBAAA;EACA,oBAAA;EACA,yBAAA;A1B67QJ;A0B57QI;EACE,wBAAA;EACA,sBAAA;EACA,uBAAA;A1B87QN;;A0B17QA;EACE,wBAAA;EACA,yBAAA;A1B67QF;A0B57QE;EACE,qCAAA;EACA,sCAAA;EACA,qBAAA;EACA,qBAAA;A1B87QJ;A0B57QE;EACE,qCAAA;EACA,sCAAA;EACA,oBAAA;EACA,sBAAA;A1B87QJ;A0B57QE;EACE,qBAAA;EACA,uBAAA;EACA,yBAAA;A1B87QJ;;A0B37QA;EACE,wBAAA;EACA,uBAAA;A1B87QF;A0B77QE;EACE,qCAAA;EACA,oCAAA;EACA,qBAAA;EACA,mBAAA;A1B+7QJ;A0B77QE;EACE,qCAAA;EACA,oCAAA;EACA,oBAAA;EACA,wBAAA;A1B+7QJ;A0B77QE;EACE,uBAAA;EACA,uBAAA;EACA,wBAAA;A1B+7QJ;;A0B57QA;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,cvBxfM;AHu7RR;A0B97QE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;A1Bg8QJ;A0B97QE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBvB7gBM;EuB8gBN,eAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,UAAA;A1Bg8QJ;A0B/7QI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBvBvhBI;EuBwhBJ,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;A1Bi8QN;A0B/7QI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBvBxiBI;AHy+RV;A0B97QE;EACE,cvBtiBI;EuBuiBJ,evBxUW;EuByUX,yBAAA;EACA,uBAAA;A1Bg8QJ;;A0B77QA;EACE,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,cvBhjBM;AHg/RR;A0B/7QE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;A1Bi8QJ;A0B/7QE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBvBnkBK;EuBokBL,eAAA;EACA,cAAA;EACA,qBAAA;EACA,6BAAA;EACA,UAAA;A1Bi8QJ;A0Bh8QI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBvB7kBG;EuB8kBH,WAAA;EACA,WAAA;EACA,wBAAA;EACA,oBAAA;EACA,+BAAA;EACA,0BAAA;EACA,0BAAA;EACA,wBAAA;A1Bk8QN;A0Bh8QI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,sBAAA;EACA,mBvB9lBG;AHgiST;A0B/7QE;EACE,cvB9lBI;EuB+lBJ,evBhYW;EuBiYX,yBAAA;EACA,uBAAA;A1Bi8QJ;;A0B97QA;EACE,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,cvBxmBM;AHyiSR;A0Bh8QE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;A1Bk8QJ;A0Bh8QE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBvBjoBM;EuBkoBN,eAAA;EACA,cAAA;EACA,qBAAA;EACA,+BAAA;EACA,UAAA;A1Bk8QJ;A0Bj8QI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBvB3oBI;EuB4oBJ,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,wBAAA;A1Bm8QN;A0Bj8QI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBvB5pBI;AH+lSV;A0Bh8QE;EACE,cvBtpBI;EuBupBJ,evBxbW;EuBybX,yBAAA;EACA,uBAAA;A1Bk8QJ;;A0B/7QA;EACE,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,cvBhqBM;AHkmSR;A0Bj8QE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,2CAAA;EACA,yCAAA;EACA,sCAAA;EACA,UAAA;A1Bm8QJ;A0Bj8QE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBvBvrBG;EuBwrBH,eAAA;EACA,cAAA;EACA,qBAAA;EACA,+BAAA;EACA,UAAA;A1Bm8QJ;A0Bl8QI;EACE,kBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBvBjsBC;EuBksBD,WAAA;EACA,WAAA;EACA,sBAAA;EACA,oBAAA;EACA,4BAAA;EACA,6BAAA;EACA,0BAAA;EACA,wBAAA;A1Bo8QN;A0Bl8QI;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBvBltBC;AHspSP;A0Bj8QE;EACE,cvB9sBI;EuB+sBJ,evBhfW;EuBifX,yBAAA;EACA,uBAAA;A1Bm8QJ;;A0Bh8QA;EACE,kBAAA;EACA,wBAAA;EACA,cvBvtBM;AH0pSR;A0Bl8QE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,uCAAA;EACA,qCAAA;EACA,wCAAA;A1Bo8QJ;A0Bl8QE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBvBjvBM;EuBkvBN,eAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;A1Bo8QJ;A0Bl8QE;EACE,cvB9uBI;EuB+uBJ,evBhhBW;EuBihBX,yBAAA;EACA,uBAAA;A1Bo8QJ;;A0Bj8QA;EACE,kBAAA;EACA,wBAAA;EACA,cvBvvBM;EuBwvBN,WAAA;A1Bo8QF;A0Bn8QE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,qBAAA;EACA,uCAAA;EACA,qCAAA;EACA,uCAAA;A1Bq8QJ;A0Bn8QE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBvB5wBK;EuB6wBL,eAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;A1Bq8QJ;A0Bn8QE;EACE,cvB/wBI;EuBgxBJ,evBjjBW;EuBkjBX,yBAAA;EACA,uBAAA;A1Bq8QJ;;A0Bl8QA;EACE,kBAAA;EACA,sBAAA;EACA,cvBxxBM;EuByxBN,WAAA;A1Bq8QF;A0Bp8QE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;EACA,uCAAA;EACA,qCAAA;EACA,uCAAA;A1Bs8QJ;A0Bp8QE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBvBrzBQ;EuBszBR,eAAA;EACA,cAAA;EACA,iBAAA;EACA,UAAA;A1Bs8QJ;A0Bp8QE;EACE,cvBhzBI;EuBizBJ,evBllBW;EuBmlBX,yBAAA;EACA,uBAAA;A1Bs8QJ;;A0Bn8QA;EACE,kBAAA;EACA,uBAAA;EACA,cvBzzBM;AH+vSR;A0Br8QE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,sBAAA;EACA,sCAAA;EACA,oCAAA;EACA,wCAAA;A1Bu8QJ;A0Br8QE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBvBp1BM;EuBq1BN,eAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;A1Bu8QJ;A0Br8QE;EACE,cvBj1BI;EuBk1BJ,evBnnBW;EuBonBX,yBAAA;EACA,uBAAA;A1Bu8QJ;;A0Bp8QA;EACE,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cvB31BM;AHkySR;A0Bt8QE;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;EACA,wBAAA;EACA,sCAAA;EACA,oCAAA;EACA,0CAAA;A1Bw8QJ;A0Bt8QE;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,mBvB13BM;EuB23BN,eAAA;EACA,iBAAA;EACA,UAAA;EACA,YAAA;A1Bw8QJ;A0Bt8QE;EACE,cvBn3BI;EuBo3BJ,evBrpBW;EuBspBX,yBAAA;EACA,uBAAA;A1Bw8QJ;;A0Bn8QI;EACE,kBAAA;EACA,WAAA;A1Bs8QN;;A0Bl8QA;EACE,cvBl4BM;EuBm4BN,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,evBrqBa;AH0mSf;A0Bp8QE;EACE,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,WAAA;EACA,uBAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,QAAA;A1Bs8QJ;;A0Bn8QA;EACE,gBAAA;A1Bs8QF;;A0Bn8QE;EACE,cvBz5BI;EuB05BJ,yBvBx6BM;EuBy6BN,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;A1Bs8QJ;A0Br8QI;EACE,kBAAA;A1Bu8QN;A0Bt8QM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;A1Bw8QR;A0Bt8QM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;A1Bw8QR;A0Bt8QM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iDAAA;EACA,iCvBt8BE;EuBu8BF,gCvBv8BE;EuBw8BF,+BvBx8BE;EuBy8BF,sCAAA;EACA,yBAAA;A1Bw8QR;A0Bt8QM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCvBj9BE;EuBk9BF,oCAAA;EACA,+BvBn9BE;EuBo9BF,kCvBp9BE;EuBq9BF,uBAAA;A1Bw8QR;;A0Bl8QE;EACE,cvB98BI;EuB+8BJ,yBvB39BQ;EuB49BR,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;A1Bq8QJ;A0Bp8QI;EACE,kBAAA;A1Bs8QN;A0Br8QM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;A1Bu8QR;A0Br8QM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;A1Bu8QR;A0Br8QM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCvBx/BI;EuBy/BJ,gCvBz/BI;EuB0/BJ,+BvB1/BI;EuB2/BJ,sCAAA;EACA,yBAAA;A1Bu8QR;A0Br8QM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCvBngCI;EuBogCJ,oCAAA;EACA,+BvBrgCI;EuBsgCJ,kCvBtgCI;EuBugCJ,uBAAA;A1Bu8QR;;A0Bj8QE;EACE,cvBlgCI;EuBmgCJ,yBvBzgCM;EuB0gCN,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;A1Bo8QJ;A0Bn8QI;EACE,kBAAA;A1Bq8QN;A0Bp8QM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;A1Bs8QR;A0Bp8QM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;A1Bs8QR;A0Bp8QM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCvBtiCE;EuBuiCF,gCvBviCE;EuBwiCF,+BvBxiCE;EuByiCF,sCAAA;EACA,yBAAA;A1Bs8QR;A0Bp8QM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,uCAAA;EACA,wCAAA;EACA,8BAAA;EACA,uBAAA;EACA,uBAAA;A1Bs8QR;;A0Bh8QE;EACE,cvBvjCI;EuBwjCJ,yBvB5jCK;EuB6jCL,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,qCAAA;A1Bm8QJ;A0Bl8QI;EACE,kBAAA;A1Bo8QN;A0Bn8QM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,sBAAA;A1Bq8QR;A0Bn8QM;EACE,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,uBAAA;EACA,wBAAA;A1Bq8QR;A0Bn8QM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,iCvBzlCC;EuB0lCD,oCAAA;EACA,+BvB3lCC;EuB4lCD,kCvB5lCC;EuB6lCD,uBAAA;A1Bq8QR;A0Bn8QM;EACE,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,0CAAA;EACA,qCAAA;EACA,wCAAA;EACA,gCAAA;EACA,yBAAA;EACA,uBAAA;A1Bq8QR;;A0B97QI;EACE,WAAA;EACA,YAAA;A1Bi8QN;;A0B57QE;EACE,aAAA;A1B+7QJ;;A0B37QE;EACE,WAAA;EACA,YAAA;A1B87QJ;;A0B17QE;EACE,WAAA;EACA,YAAA;A1B67QJ;;A0Bz7QE;EACE,WAAA;EACA,YAAA;A1B47QJ;;A0Bx7QE;EACE,WAAA;EACA,YAAA;A1B27QJ;;A0Bv7QE;EACE,cvB/kCS;EuBglCT,mBvBxlCS;AHkhTb;;A0Bt7QE;EACE,mBvBlnCU;EuBmnCV,cvB5mCU;AHqiTd;;A0Bt7QA;EACE;IACE,8BAAA;E1By7QF;AACF;A0Bt7QE;EACE,wBAAA;A1Bw7QJ;A0Br7QE;EACE,yBAAA;A1Bu7QJ;A0Bp7QE;EACE,yBAAA;A1Bs7QJ;A0Bn7QE;EACE,wBAAA;A1Bq7QJ;A0Bl7QE;EACE,yBAAA;A1Bo7QJ;A0Bj7QE;EACE,wBAAA;A1Bm7QJ;A0Bh7QE;EACE,wBAAA;A1Bk7QJ;A0B/6QE;EACE,yBAAA;A1Bi7QJ;A0B96QE;EACE,wBAAA;A1Bg7QJ;A0B76QE;EACE,yBAAA;A1B+6QJ;A0B56QE;EACE,yBAAA;A1B86QJ;;A2BvpTI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,eAAA;A3B0pTR;A2BzpTQ;E1B0HN,kB0BzH2B;EACjB,UAAA;EACA,mBAAA;EACA,cAAA;A3B2pTZ;ACvnTI;E0BxCI;IAMQ,UAAA;E3B6pTd;AACF;A2B5pTY;EACI,yBAAA;E1BiHd,mB0BhH+B;EACjB,cAAA;EACA,aAAA;EACA,kBAAA;A3B8pThB;;A2BvpTI;EACI,gBxBtBW;AHgrTnB;ACvoTI;E0BpBA;IAGQ,exB8NG;EH87Sb;AACF;A2BzpTE;EACC,YAAA;A3B2pTH;A2BxpTI;;EAII,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,cxB4CK;EwB3CL,UAAA;EACA,exBqMO;EwBpMP,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBxBjDW;EwBkDX,6BAAA;E1ByEN,mB0BxEuB;A3B0pTzB;A2BzpTQ;;EACI,6BAAA;EACA,cxB/BJ;AH2rTR;A2BzpTI;EACG,SAAA;EACA,2BAAA;A3B2pTP;A2B1pTQ;EACI,gBAAA;E1BuCT,a0BtCuC;A3B4pT1C;ACjrTI;E0BmBI;IAIQ,eAAA;I1BoCb,iB0BnC2C;E3B8pT5C;AACF;A2B5pTQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,cxBtEF;AHouTV;A2B7pTY;EACI,iBAAA;A3B+pThB;A2B7pTY;EACI,mBxB3EN;EwB4EM,cxB9DR;AH6tTR;A2B9pTgB;EACI,+BAAA;A3BgqTpB;A2B5pTQ;EACI,mBxBjFA;AH+uTZ;A2B7pTY;E1B0CV,yCAAA;E0BxCc,yBAAA;A3BiqThB;A2B5pTI;EACI,SAAA;EACA,iBAAA;EACA,iBAAA;A3B8pTR;A2B3pTI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;A3B6pTR;A2B3pTI;EACI,iBAAA;A3B6pTR;A2B3pTI;EACI,iBAAA;A3B6pTR;A2B3pTI;EACI,oCAAA;A3B6pTR;A2B3pTI;EACI,+CAAA;A3B6pTR;;A2B1pTA;EACI,sBAAA;A3B6pTJ;;A2B3pTA;EACI,4BAAA;A3B8pTJ;;A2B1pTI;EACI,0BAAA;A3B6pTR;A2B1pTQ;EACI,qBAAA;EACA,UAAA;EACA,oBAAA;A3B4pTZ;A2B1pTQ;EACI,mBAAA;EACA,UAAA;A3B4pTZ;A2BxpTQ;EACI,0BAAA;EACA,UAAA;EACA,sDAAA;A3B0pTZ;A2BxpTQ;EACI,wBAAA;EACA,UAAA;A3B0pTZ;A2BtpTQ;EACI,0BAAA;EACA,UAAA;EACA,oBAAA;A3BwpTZ;A2BtpTQ;EACI,wBAAA;EACA,UAAA;A3BwpTZ;A2BppTQ;EACI,kCAAA;EACA,UAAA;A3BspTZ;A2BppTQ;EACI,oBAAA;A3BspTZ;A2BppTQ;EACI,gCAAA;EACA,UAAA;A3BspTZ;A2BnpTI;EAGI,mBAAA;A3BqpTR;A2BppTQ;EAEI,4BAAA;EACA,2CAAA;EACA,UAAA;A3BspTZ;A2BppTQ;EACI,4BAAA;EACA,wCAAA;EACA,UAAA;A3BspTZ;A2BnpTI;EACI,mBAAA;A3BqpTR;A2BppTQ;EAEI,4BAAA;EACA,0BAAA;EACA,oBAAA;EACA,UAAA;A3BspTZ;A2BppTQ;EACI,wBAAA;EACA,UAAA;A3BspTZ;A2BnpTI;EACI,mBAAA;A3BqpTR;A2BppTQ;EAEI,4BAAA;EACA,0BAAA;EACA,oBAAA;EACA,UAAA;A3BspTZ;A2BppTQ;EACI,wBAAA;EACA,UAAA;A3BspTZ;A2BlpTQ;EACI,mBAAA;EACA,UAAA;EACA,oBAAA;A3BopTZ;A2BlpTQ;EACI,mBAAA;EACA,UAAA;A3BopTZ;A2BjpTI;EACI,mBAAA;A3BmpTR;A2BlpTQ;EAEI,4BAAA;EACA,0BAAA;EACA,uBAAA;EACA,UAAA;EACA,oBAAA;A3BopTZ;A2BlpTQ;EACI,wBAAA;EACA,UAAA;A3BopTZ;A2BjpTI;EACI,mBAAA;A3BmpTR;A2BlpTQ;EAEI,4BAAA;EACA,0CAAA;EACA,wBAAA;EACA,UAAA;EACA,6BAAA;A3BopTZ;A2BlpTQ;EACI,uCAAA;EACA,UAAA;A3BopTZ;A2BjpTI;EACI,mBAAA;A3BmpTR;A2BlpTQ;EAEI,4BAAA;EACA,4DAAA;EACA,wBAAA;EACA,UAAA;EACA,oBAAA;A3BopTZ;A2BlpTQ;EACI,uDAAA;EACA,UAAA;A3BopTZ;;A4B17TA;EACE,oBAAA;A5B67TF;A4B57TE;EACE,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;A5B87TJ;;A4B37TA;EACE,oBAAA;A5B87TF;;A4B57TA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;A5B+7TF;;A4B77TA;EACE,iBAAA;EACA,aAAA;EACA,czBYM;AHo7TR;;A4B97TA;EACE,gBAAA;A5Bi8TF;;AAt7TA,uBAAA;A6BnCA;EACI,0BAAA;EACA,WAAA;A7B69TJ;A6B59TI;EACI,YAAA;A7B89TR;;A6B19TI;EACI,yDAAA;E5B2HN,kB4B1HuB;A7B69TzB;A6B59TQ;EACI,c1BuJC;E0BtJD,iBAAA;E5BuHV,kB4BtH2B;EACjB,kBAAA;EACA,e1B6OG;E0B5OH,gB1BXS;AHy+TrB;A6B59TQ;EACI,YAAA;A7B89TZ;A6B59TQ;EACI,YAAA;EACA,UAAA;A7B89TZ;;A6B19TA;E5BwEE,kB4BvEoB;E5BwEpB,Q4BxE6B;E5B2E7B,S4B3E2C;EACzC,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,QAAA;E5B0BF,yC4BzBqB;E5B0BrB,iD4B1BqB;E5B2BrB,6C4B3BqB;A7Bi+TvB;;A6B/9TA;EACI,qB1BRI;E0BSJ,yBAAA;EACA,eAAA;E5BkED,Y4BjE+B;A7Bk+TlC;;A6Bh+TA;EACI,mB1B7BM;E0B8BN,c1BhBI;AHm/TR;;A6Bh+TI;EACI,8BAAA;EACA,qB1BnCE;AHsgUV;;A6Bh+TA;EACI,aAAA;A7Bm+TJ;;A6Bj+TA;;;;;;;EAOI,qB1B4DO;E0B3DP,c1BgGS;E0B/FT,YAAA;EACA,iBAAA;A7Bo+TJ;;A6Bj+TA;EACI,iBAAA;EACA,YAAA;EACA,gBAAA;A7Bo+TJ;;A6Bj+TA;;;EAGI,yB1BzDG;E0B0DH,qB1B1DG;E0B2DH,c1BnDI;AHuhUR;;A8BvjUA;;;;;EAKI,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,uBAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;A9B0jUJ;;A8BxjUA;;;;;EAKI,uBAAA;EACA,2BAAA;EACA,kCAAA;EACA,oBAAA;EACA,yBAAA;EACA,0BAAA;EACA,qBAAA;EACA,kBAAA;A9B2jUJ;;A8BzjUA;EACI,YAAA;A9B4jUJ;;A8B1jUA;EACI,YAAA;EACA,mBAAA;EACA,e3ByNW;E2BxNX,c3B8FO;E2B7FP,gB3B5BmB;AHylUvB;;A8B3jUA;EACI,eAAA;EACA,qEAAA;A9B8jUJ;;A8B3jUI;E7BiED,a6BhE6B;A9B8jUhC;A8B7jUQ;EACI,mDAAA;EACA,8BAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;A9B+jUZ;A8B9jUY;EACI,mB3BrCN;E2BsCM,c3BxBR;AHwlUR;A8B7jUQ;EACI,mB3B1CF;E2B2CE,qB3B3CF;EFkHR,mB6BtE2B;EACjB,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A9B+jUZ;A8B7jUQ;EACI,WAAA;A9B+jUZ;A8B9jUY;EACI,6BAAA;EACA,SAAA;EACA,WAAA;A9BgkUhB;A8B7jUQ;EACI,WAAA;A9B+jUZ;A8B9jUY;EACI,6BAAA;EACA,SAAA;EACA,WAAA;A9BgkUhB;;A8B3jUA;;EAEI,2BAAA;A9B8jUJ;;A8B5jUA;EACI,iBAAA;A9B+jUJ;;A8B7jUA;EACI,aAAA;A9BgkUJ;;A8B9jUA;EACI,aAAA;A9BikUJ;;A8B/jUA;EACI,aAAA;A9BkkUJ;;A8BhkUA;EACI,aAAA;A9BmkUJ;;AApoUA,qBAAA;A+BvCA;E9BgGE,yB8B/FsB;E9B2GrB,mB8B1G0B;E9B2G1B,iB8B3GuC;E9BkGxC,kB8BjGoB;E9BqGpB,O8BrG4C;E9B6F5C,yB8B5FsB;A/BqrUxB;ACvoUI;E8BlDJ;I9B4GG,S8BtG8B;I9BuG9B,iB8BvGkC;E/BwrUnC;AACF;A+BvrUI;E9BqGD,a8BpGmC;EAC9B,iBAAA;A/ByrUR;ACjpUI;E8B1CA;I9BqGD,a8BjGuC;E/B2rUxC;AACF;A+B1rUQ;EACI,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;A/B4rUZ;;A+BvrUA;EACI,UAAA;EACA,SAAA;A/B0rUJ;;A+BxrUA;EACI,mB5BCI;E4BAJ,aAAA;EACA,kBAAA;A/B2rUJ;A+B1rUI;EACI,YAAA;A/B4rUR;A+B3rUQ;EACI,6BAAA;A/B6rUZ;A+B1rUI;EACI,mBAAA;A/B4rUR;A+B3rUQ;EACI,e5BsNG;AHu+Tf;A+B1rUY;EACI,gBAAA;A/B4rUhB;;A+BtrUI;E9BuDD,mB8BtD6B;A/ByrUhC;AC7rUI;E8BGA;I9BuDD,S8BpDiC;E/B2rUlC;AACF;;A+BtrUQ;EACI,c5BiED;EFnBR,e8B7CuC;A/ByrU1C;A+BrrUQ;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;A/BurUZ;A+BtrUY;EACI,kBAAA;A/BwrUhB;AC/sUI;E8BkBI;IAQQ,cAAA;E/ByrUd;AACF;A+BrrUgB;EACI,c5BtDX;AH6uUT;A+BnrUQ;EACI,mBAAA;A/BqrUZ;A+BprUY;EACI,e5BsKD;E4BrKC,gB5BlFO;E4BmFP,c5BvEJ;AH6vUZ;A+BnrUQ;EACI,gCAAA;A/BqrUZ;A+BprUY;EACI,gBAAA;A/BsrUhB;A+BnrUgB;EACI,yB5BnFV;E4BoFU,qB5BpFV;AHywUV;A+BnrUgB;EACI,gBAAA;EACA,qB5BiBT;AHoqUX;A+BjrUQ;EACI,qBAAA;A/BmrUZ;A+BlrUY;EACI,e5B8ID;E4B7IC,gB5B1GO;E4B2GP,c5B/FJ;AHmxUZ;A+BjrUQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;A/BmrUZ;A+BjrUgB;EACI,kBAAA;EACA,yDAAA;EACA,mB5B3GR;E4B4GQ,c5BhGZ;E4BiGY,gBAAA;EACA,iBAAA;EACA,oBAAA;A/BmrUpB;A+B/qUQ;EACI,eAAA;A/BirUZ;A+B/qUQ;EACI,mBAAA;A/BirUZ;A+BhrUY;EACI,e5BgHD;E4B/GC,gB5BtIO;E4BuIP,c5B3HJ;AH6yUZ;A+B7qUgB;EACI,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A/B+qUpB;A+B5qUgB;EACI,kBAAA;EACA,yDAAA;A/B8qUpB;A+B7qUoB;EACI,WAAA;EACA,YAAA;EACA,c5BxIf;AHuzUT;A+B1qUQ;EACI,8BAAA;EACA,mBAAA;A/B4qUZ;A+B1qUgB;EACI,gB5BrKD;AHi1UnB;A+BxqUQ;EACI,8BAAA;EACC,mBAAA;EACA,mBAAA;EACA,aAAA;A/B0qUb;A+BxqUgB;EACI,e5BqEL;E4BpEK,gB5BlLG;AH41UvB;A+BzqUoB;EACI,e5BkET;E4BjES,gB5BvLH;E4BwLG,c5B3BX;AHssUb;A+BtqUgB;EACI,e5B0DL;E4BzDK,gB5B7LG;AHq2UvB;A+BvqUoB;EACI,e5BuDT;E4BtDS,gB5BlMH;E4BmMG,c5BtCX;AH+sUb;;A+BjqUA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,yB5B3LI;E4B4LJ,2CAAA;EACA,c5BzMQ;EFyFT,iB8BiH+B;E9B1FhC,kB8B2FmB;EACjB,eAAA;A/BoqUJ;A+BnqUI;EACI,2CAAA;A/BqqUR;;A+BjqUI;EACI,YAAA;A/BoqUR;;A+BjqUA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,c5B9MI;E4B+MJ,gB5BzOiB;E4B0OjB,e5BhPa;AHo5UjB;A+BnqUI;E9B9IF,kB8B+IwB;EAClB,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;A/BqqUR;A+BnqUY;EACI,cAAA;A/BqqUhB;A+BjqUM;E9B1JJ,kB8B2JwB;E9B1JxB,M8B0JiC;E9BvJjC,O8BuJ6C;EACvC,YAAA;EACA,WAAA;EACA,yBAAA;EACA,mB5BpOA;EFqGN,kB8BgIuB;A/BqqUzB;A+BpqUQ;EACI,WAAA;EACA,kBAAA;EACA,aAAA;A/BsqUZ;A+BpqUQ;E9BtKN,kB8BuK4B;E9BtK5B,Q8BsKqC;E9BnKrC,S8BmKmD;EACzC,UAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;E9BhNV,wB8BiN6B;E9BhN7B,gC8BgN6B;E9B/M7B,4B8B+M6B;A/B0qU/B;A+BrqUQ;EACI,yBAAA;A/BuqUZ;;A+BnqUA;EACI,kCAAA;A/BsqUJ;;A+BnqUI;EACI,WAAA;EACA,WAAA;EACA,YAAA;A/BsqUR;;AgCv8UA;EACI,UAAA;EACA,WAAA;EACA,8BAAA;AhC08UJ;;AgCx8UA;EACI,mB7BuHO;AHo1UX;;AgCz8UA;EACI,mB7BSM;AHm8UV;;AgC18UA;EACI,mB7BiHO;AH41UX;;AgC18UI;EACI,e7BgPO;AH6tUf;;AgC18UA;EACI,wBAAA;AhC68UJ;;AgC38UA;EACI,yBAAA;AhC88UJ;;AgC58UA;EACI,yBAAA;AhC+8UJ;;AgC38UQ;EACI,qB7BuMG;AHuwUf;;AgCz8UI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mB7B5BE;E6B6BF,6BAAA;EACA,WAAA;EACA,c7BjBA;E6BkBA,gB7B1Ce;E6B2Cf,UAAA;AhC48UR;AgC38UQ;EACI,mB7B+GE;AH81Ud;;AgCz8UA;EACI,UAAA;EACA,WAAA;EACA,8BAAA;AhC48UJ;;AgC18UA;EACI,mB7B8DO;AH+4UX;;AgC38UA;EACI,mB7BhDM;AH8/UV;;AgC58UA;EACI,mB7BwDO;AHu5UX;;AgC58UI;EACI,e7BuLO;AHwxUf;;AgC58UA;EACI,wBAAA;AhC+8UJ;;AgC78UA;EACI,yBAAA;AhCg9UJ;;AgC98UA;EACI,yBAAA;AhCi9UJ;;AgC58UQ;EACI,qB7B6IG;AHk0Uf;;AgC38UA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AhC88UJ;AgC78UI;EACI,gBAAA;AhC+8UR;ACtgVI;E+B2CJ;IAeQ,mBAAA;IACA,sBAAA;IACA,uBAAA;EhCg9UN;AACF;AgC/8UI;EACI,gB7BxGW;E6ByGX,c7B9FI;E6B+FJ,e7B6IO;AHo0Uf;AClhVI;E+B8DA;IAKQ,e7BpHK;EHukVf;AACF;AgCj9UI;EACI,gB7BhHW;E6BiHX,c7BtGI;E6BuGJ,e7BqIO;E6BpIP,kBAAA;AhCm9UR;AC7hVI;E+BsEA;IAMQ,e7BkIG;EHm1Ub;AACF;AgCn9UI;EACI,e7BjIS;E6BkIT,c7BFG;E6BGH,gB7B9Ha;AHmlVrB;ACviVI;E+B+EA;IAKQ,e7BqHG;EHk2Ub;AACF;AC5iVI;E+B+EA;IAQQ,e7BkHG;I6BjHH,mBAAA;EhCy9UV;AACF;AgCv9UI;EACI,mB7B5HE;E6B6HF,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,UAAA;AhCy9UR;AgCx9UQ;EACI,iEAAA;AhC09UZ;AgCv9UI;EACI,iBAAA;AhCy9UR;ACvkVI;E+B6GA;IAGQ,cAAA;IACA,gBAAA;EhC29UV;AACF;AgCz9UI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mB7B3JE;E6B4JF,iBAAA;EACA,c7B/IA;E6BgJA,gB7BvKW;E6BwKX,e7B4EO;E6B3EP,kBAAA;AhC29UR;AgC19UQ;EACI,c7BpJJ;AHgnVR;AgC19UQ;EACI,+BAAA;AhC49UZ;ACjmVI;E+BoHA;IAoBQ,kBAAA;EhC69UV;AACF;AgC59UQ;EACI,mB7BzBE;AHu/Ud;AgC59UQ;EACI,WAAA;EACA,YAAA;AhC89UZ;AgC39UI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mB7BvLI;E6BwLJ,iBAAA;EACA,c7B7KA;E6B8KA,gB7BrMW;E6BsMX,e7B8CO;E6B7CP,kBAAA;EACA,qBAAA;AhC69UR;AgC59UQ;EACI,+BAAA;AhC89UZ;AC/nVI;E+BkJA;IAkBQ,kBAAA;EhC+9UV;AACF;AgC99UQ;EACI,mB7BvMF;AHuqVV;AgC99UQ;EACI,WAAA;EACA,YAAA;AhCg+UZ;AgC79UI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mB7B3MC;E6B4MD,iBAAA;EACA,c7BzMA;E6B0MA,gB7BjOW;E6BkOX,e7BkBO;E6BjBP,kBAAA;AhC+9UR;AgC99UQ;EACI,+BAAA;AhCg+UZ;AC5pVI;E+B8KA;IAiBQ,kBAAA;EhCi+UV;AACF;AgCh+UQ;EACI,mB7BhOA;AHksVZ;AgCh+UQ;EACI,WAAA;EACA,YAAA;AhCk+UZ;ACxqVI;E+ByMA;IAEQ,yBAAA;EhCi+UV;EgCh+UU;IACI,cAAA;EhCk+Ud;AACF;AChrVI;E+BgNI;IAES,cAAA;IACA,mBAAA;EhCk+Uf;AACF;AgCh+UQ;EACI,cAAA;AhCk+UZ;AgC/9UI;EACI,kBAAA;AhCi+UR;AgC/9UI;EACI,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;AhCi+UR;;AgC99UA;EACI,aAAA;EACA,gBAAA;EACA,8BAAA;EACA,mB7BvHM;AHwlVV;;AgC99UA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AhCi+UJ;ACztVI;E+B8OJ;IAYQ,eAAA;IACA,sBAAA;IACA,uBAAA;EhCm+UN;EgCl+UM;IACI,gBAAA;EhCo+UV;AACF;;AgCh+UA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AhCm+UJ;AgCl+UI;EACI,kBAAA;EACA,kBAAA;AhCo+UR;AgCn+UQ;EACI,YAAA;EACA,yDAAA;EACA,8BAAA;EACA,YAAA;E/B/LV,kB+BgM2B;EACjB,aAAA;AhCq+UZ;AgCp+UY;EACI,c7BtSR;AH4wVR;AC3vVI;E+B6QI;IAWQ,YAAA;EhCu+Ud;AACF;AChwVI;E+B6QI;IAcQ,YAAA;EhCy+Ud;AACF;ACrwVI;E+B6QI;IAiBQ,WAAA;EhC2+Ud;AACF;AgCz+UQ;E/B/MN,mB+BiN2B;E/BjP3B,kB+BkP4B;E/BjP5B,M+BiPqC;E/BhPrC,Q+BgPuC;EAC7B,SAAA;AhC4+UZ;AgC3+UY;EACI,WAAA;EACA,YAAA;AhC6+UhB;;AgCx+UA;EACI,iBAAA;AhC2+UJ;ACzxVI;E+B6SJ;IAGQ,eAAA;IACA,cAAA;EhC6+UN;AACF;AC/xVI;E+B6SJ;IAOQ,gBAAA;EhC++UN;AACF;AgC9+UI;EACI,WAAA;EACA,YAAA;EACA,c7B3UA;AH2zVR;AgC9+UI;EACI,mB7B5VE;E6B6VF,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,UAAA;EACA,kBAAA;AhCg/UR;AgC/+UQ;EACI,aAAA;AhCi/UZ;AgC/+UQ;EACI,mB7B5NE;AH6sVd;AgC/+UQ;EACI,mB7BvWH;AHw1VT;AgCh/UY;EACI,aAAA;AhCk/UhB;AgCh/UY;EACI,cAAA;AhCk/UhB;AgCj/UgB;EACI,cAAA;AhCm/UpB;AgC/+UQ;EACI,aAAA;AhCi/UZ;AgC/+UQ;EACI,cAAA;AhCi/UZ;;AgC7+UA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;AhCg/UJ;AgC/+UI;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,iBAAA;EACA,c7B/PK;E6BgQL,2BAAA;EACA,mBAAA;AhCi/UR;ACn2VI;E+BoWJ;IAiBQ,gBAAA;EhCk/UN;AACF;;AgC/+UI;EACI,kBAAA;AhCk/UR;;AgC9+UI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AhCi/UR;AgCh/UQ;E/B3UL,c+B4UiC;AhCk/UpC;AgCj/UY;EACI,cAAA;AhCm/UhB;;AgC9+UA;EACI,cAAA;AhCi/UJ;;AgC/+UA;EACI,kBAAA;AhCk/UJ;;AgCh/UA;EACI,YAAA;AhCm/UJ;;AgCj/UA;EACI,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AhCo/UJ;AgCn/UI;EACI,kBAAA;EACA,UAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;AhCq/UR;AgCp/UQ;EACI,yBAAA;EACA,kBAAA;AhCs/UZ;AgCp/UU;EACE,yB7BxcF;E6BycE,qB7BzcF;AH+7VV;AgCp/UU;EACE,cAAA;AhCs/UZ;AgCn/UI;EACI,YAAA;EACA,WAAA;E/B/XN,kB+BgYwB;E/B/XxB,M+B+XiC;E/B5XjC,O+B4X6C;AhCu/U/C;AgCt/UQ;EACI,WAAA;EACA,kBAAA;EACA,aAAA;AhCw/UZ;AgCt/UQ;EACI,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBAAA;E/BjbV,wB+Bkb6B;E/Bjb7B,gC+Bib6B;E/Bhb7B,4B+Bgb6B;AhC0/U/B;;AgCp/UQ;EACI,WAAA;EACA,YAAA;AhCu/UZ;AgCt/UY;EACI,SAAA;EACA,QAAA;AhCw/UhB;;AgCn/UA;EACI,2CAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AhCs/UJ;AgCr/UI;EACI,mB7B5YG;AHm4VX;AgCr/UI;EACI,WAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AhCu/UR;AgCr/UI;EACI,kBAAA;EACA,WAAA;E/BtaL,e+BuamC;E/BhZpC,kB+BiZuB;E/BjbvB,kB+BkbwB;E/BjbxB,M+BibiC;AhCw/UnC;AgCv/UQ;EACI,e7BvhBK;E6BwhBL,gB7BlhBS;E6BmhBT,c7BtgBA;AH+/VZ;AgCr/UQ;EACI,aAAA;AhCu/UZ;AgCr/UQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;EACA,sBAAA;AhCu/UZ;;AgCn/UA;EACI,0CAAA;E/B7aF,mB+B8amB;EACjB,eAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AhCs/UJ;AgCr/UI;EACI,YAAA;EACA,cAAA;EACA,+BAAA;EACA,WAAA;EACA,YAAA;EACA,yB7BhiBA;E6BiiBA,iDAAA;E/B7bN,kB+B8bwB;E/BngBxB,+B+BogByB;E/BngBzB,uC+BmgByB;E/BlgBzB,mC+BkgByB;E/B/dzB,kB+BgewB;E/B/dxB,Q+B+diC;E/B5djC,O+B4d+C;AhC2/UjD;;AgCx/UA;EACI,yB7BxiBI;E6ByiBJ,UAAA;EACA,4CAAA;AhC2/UJ;;AgCz/UA;EACI,cAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,oBAAA;EACA,kBAAA;AhC4/UJ;AgC1/UQ;EACI,yB7BlkBF;AH8jWV;;AgCx/UA;EACI,SAAA;EACA,SAAA;AhC2/UJ;AgC1/UI;EACI,yBAAA;AhC4/UR;;AgCx/UI;EACI,kBAAA;AhC2/UR;AgC1/UQ;EACI,kBAAA;EACA,QAAA;AhC4/UZ;;AgCx/UA;EACI,kBAAA;EAGA,aAAA;EACA,iBAAA;EACA,oBAAA;EACA,WAAA;AhC2/UJ;;AgCz/UA;;;EAGI,aAAA;AhC4/UJ;;AgC1/UA;EACI,mBAAA;EACA,kBAAA;AhC6/UJ;AgC5/UI;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,c7BleK;E6BmeL,2BAAA;EACA,mBAAA;AhC8/UR;AgC5/UI;EACG,eAAA;AhC8/UP;AgC5/UI;EACI,kBAAA;EACA,c7B1nBI;E6B2nBJ,gB7BxoBa;E6ByoBb,e7B/oBS;E6BgpBT,cAAA;AhC8/UR;AgC7/UQ;EACI,c7BvnBH;AHsnWT;AgC5/UI;EACI,kBAAA;AhC8/UR;AgC7/UQ;EACI,kBAAA;EACA,WAAA;EACA,QAAA;EACA,cAAA;E/B7lBV,2B+B8lB6B;E/B7lB7B,mC+B6lB6B;E/B5lB7B,+B+B4lB6B;AhCigV/B;AC5mWI;E+BsmBI;IAOO,aAAA;EhCmgVb;AACF;AgC9/UQ;;EAEI,UAAA;AhCggVZ;AgC//UY;;EACI,6BAAA;AhCkgVhB;AgC7/UI;;EAEI,2CAAA;EACA,YAAA;EACA,e7BjrBS;E6BkrBT,gB7B5qBa;E6B6qBb,c7BhqBI;EFyFT,kB+BwkBmC;E/BjjBpC,kB+BkjBuB;EACjB,WAAA;AhC+/UR;AgC5/UI;EACI,c7B3pBA;E6B4pBA,kBAAA;EACA,mB7BzqBI;E6B0qBJ,kBAAA;EACA,e7B9rBS;E6B+rBT,gB7BvrBW;AHqrWnB;AgC7/UQ;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,iBAAA;EACA,c7B1qBJ;E6B2qBI,2BAAA;EACA,mBAAA;AhC+/UZ;AgC5/UI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mB7BvsBE;E6BwsBF,c7B1rBA;E6B2rBA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AhC8/UR;AgC7/UQ;EACI,mB7B5jBE;AH2jWd;AgC7/UQ;EACI,c7BnsBJ;E6BosBI,mB7BhkBE;AH+jWd;AgC7/UQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AhC+/UZ;AgC5/UI;EACI,2CAAA;EACA,aAAA;EACA,WAAA;EACA,e7B/uBS;E6BgvBT,gB7B3uBa;E6B4uBb,c7BjtBA;EF4EL,kB+BsoBmC;E/B/mBpC,kB+BgnBuB;AhC8/UzB;AgC5/UI;EACI,WAAA;AhC8/UR;;AgC1/UA;EACI,gBAAA;AhC6/UJ;;AgC1/UA;EACI,gBAAA;AhC6/UJ;;AgC3/UA;EACI,aAAA;AhC8/UJ;;AiCjwWA;EA4CI,6BAAA;EACA,+BAAA;EA2CA,yB9BkFO;E8BjFP,c9BoFU;AH2lWd;AiCvwWI;EACI,qB9BwKG;E8BvKH,mB9B2KG;AH8lWX;AiCvwWI;EACI,c9BuKM;AHkmWd;AiCtwWQ;EACI,mB9BgKD;AHwmWX;AiCvwWY;EACI,mB9BkKL;AHumWX;AiCtwWQ;EACI,mB9B0JD;AH8mWX;AiCtwWQ;EACI,qB9BuJD;E8BtJC,mB9B0JD;AH8mWX;AiCnwWY;EACI,mB9BgJL;AHqnWX;AiChwWQ;EACI,mB9B0ID;E8BzIC,yB9B6ID;AHqnWX;AiChwWQ;EACI,mB9BsID;AH4nWX;AiC9vWQ;EACI,mB9BiID;AH+nWX;AiC3vWI;EACI,+BAAA;AjC6vWR;AiC1vWQ;EACI,yB9BuHD;AHqoWX;AiCzvWI;EACI,gCAAA;AjC2vWR;AiCzvWI;EACI,oCAAA;AjC2vWR;AiCzvWI;EACI,yB9B6GG;E8B5GH,c9B+GM;AH4oWd;AiCxvWgB;EACI,yB9BwGT;AHkpWX;AiCpvWY;EACI,wBAAA;AjCsvWhB;AiClvWY;EACI,yBAAA;AjCovWhB;AiCjvWQ;EACI,yB9BwFD;AH2pWX;AiCjvWQ;EACI,c9BwFE;AH2pWd;AiC9uWI;EACI,mB9B+EG;E8B9EH,gCAAA;AjCgvWR;AiC/uWQ;EACI,qB9B8EL;E8B7EK,gCAAA;AjCivWZ;AiChvWY;EACI,aAAA;AjCkvWhB;AiChvWY;EACI,yBAAA;AjCkvWhB;AiC9uWI;EACI,mB9BiEG;E8BhEH,0BAAA;AjCgvWR;AiC9uWI;EACI,+BAAA;EACA,yB9B4DG;AHorWX;AiC/uWQ;EACI,mB9B0DD;AHurWX;AiC/uWQ;EACI,SAAA;AjCivWZ;AiC7uWgB;EACI,mB9BkDT;E8BjDS,kBAAA;EACA,eAAA;AjC+uWpB;AiC7uWwB;EACI,c9BEjB;AH6uWX;AiC1uWoB;EACI,2HAAA;AjC4uWxB;AiC1uWoB;EACI,c9BPb;AHmvWX;AiCzuWwB;EACI,c9BXjB;AHsvWX;AiCzuWwB;EACI,2HAAA;AjC2uW5B;AiCvuWgB;EACI,yBAAA;AjCyuWpB;AiCpuWI;EACI,gCAAA;AjCsuWR;AiCpuWI;EACI,mB9BeG;AHutWX;AiCpuWY;EACI,mB9BYL;AH0tWX;AiCjuWQ;EACI,yBAAA;AjCmuWZ;AiC/tWQ;EACI,c9BIE;AH6tWd;AiC9tWI;EACI,cAAA;AjCguWR;AiC5tWY;EACI,mB9B9JJ;AH43WZ;AiCxtWY;EACI,yBAAA;AjC0tWhB;AiCttWI;EACI,mB9BnBO;E8BoBP,yBAAA;AjCwtWR;AiCttWY;EACI,c9BrBF;AH6uWd;AiCttWY;EACI,c9BxBF;AHgvWd;AiCntWQ;EACI,c9B9BE;AHmvWd;AiCltWI;EACI,c9BlCM;E8BmCN,yBAAA;AjCotWR;AiCjtWQ;EACI,c9BvCE;AH0vWd;AiChtWI;EACI,c9B3CM;AH6vWd;AiChtWI;EACI,c9B9CM;AHgwWd;AiChtWI;EACI,c9BjDM;AHmwWd;AiChtWI;EACI,c9BpDM;AHswWd;AiChtWI;EACI,yB9BzDO;E8B0DP,yBAAA;AjCktWR;AiCjtWQ;EACI,qB9B3DL;AH8wWP;AiCltWY;EACI,c9B5DF;AHgxWd;AiChtWY;EACI,c9BjEF;AHmxWd;AiC9sWI;EACI,yB9BhHG;AHg0WX;AiC/sWQ;EACI,gCAAA;AjCitWZ;AiC9sWI;EACI,c9B5EM;AH4xWd;AiC9sWI;EACI,c9B/EM;AH+xWd;AiC9sWI;EACI,yB9B5HG;E8B6HH,qB9BlFG;AHkyWX;AiC7sWI;EACI,oCAAA;AjC+sWR;AiC1sWY;EACI,c9B7FF;AHyyWd;AiCzsWQ;EACI,mB9B1GE;AHqzWd;AiCxsWI;EACI,c9B9PI;AHw8WZ;AiCtsWY;EACI,c9B1GF;AHkzWd;AiCpsWI;EACI,c9B/GM;AHqzWd;AiCpsWI;EACI,c9B7JG;AHm2WX;AiCpsWI;EACI,c9BrHM;AH2zWd;AiCpsWI;EACI,mB9B3HG;E8B4HH,6BAAA;AjCssWR;AiCrsWQ;EACI,qB9B5HL;AHm0WP;AiCnsWgB;EACI,c9B9KT;AHm3WX;AiCnsWgB;EACI,4HAAA;AjCqsWpB;AiClsWY;EACI,mB9B1IL;AH80WX;AiClsWoB;EACI,c9BxLb;AH43WX;AiClsWoB;EACI,sIAAA;AjCosWxB;AiCjsWoB;EACI,gBAAA;AjCmsWxB;AiC1rWY;EACI,2HAAA;AjC4rWhB;AiCzrWQ;EACI,c9B7MD;AHw4WX;AiCvrWQ;EACI,mB9BvKD;E8BwKC,gCAAA;AjCyrWZ;AiCvrWgB;EACI,uBAAA;AjCyrWpB;AiCvrWgB;EACI,c9B3KN;AHo2Wd;AiClrWgB;EACI,uBAAA;AjCorWpB;AiClrWgB;EACI,c9BtLN;E8BuLM,gCAAA;EACA,mB9B1LL;AH82Wf;AiCnrWoB;EACI,yBAAA;AjCqrWxB;AiCprWwB;EACI,yBAAA;AjCsrW5B;AiChrWgC;EACI,mCAAA;EACA,+BAAA;AjCkrWpC;AiC9qWgC;EACI,yB9B1V3B;E8B2V2B,qB9B3V3B;AH2gXT;AiC3qW4B;EACI,c9BhNlB;AH63Wd;AiCpqWI;EACI,sB9B3ND;AHi4WP;AiCpqWI;EACI,2HAAA;AjCsqWR;AiCpqWI;EACI,mB9B1QG;E8B2QH,c9BjOM;AHu4Wd;AiCpqWI;EACI,c9BpOM;AH04Wd;AiCpqWI;EACI,yBAAA;AjCsqWR;AiCpqWI;EACI,yB9BpRG;AH07WX;AiCrqWQ;EACI,c9B5OE;AHm5Wd;AiCrqWQ;EACI,c9B/OE;AHs5Wd;AiCnqWQ;EACI,yBAAA;EACA,mB9BvPG;E8BwPH,c9BtPE;AH25Wd;AiCpqWY;EACI,c9BtSL;AH48WX;AiCjqWQ;EACI,c9B5SD;AH+8WX;AiC/pWQ;EACI,mB9BpQL;AHq6WP;AiC9pWI;EACI,yBAAA;AjCgqWR;AiC9pWI;EACI,mB9B7QG;E8B8QH,c9B3QM;AH26Wd;AiC/pWQ;EACI,mB9BxaF;E8ByaE,c9B3ZJ;AH4jXR;AiC9pWI;EACI,gCAAA;AjCgqWR;AiC9pWI;EACI,yBAAA;AjCgqWR;AiC/pWQ;EACI,6BAAA;AjCiqWZ;AiC/pWQ;EACI,+BAAA;AjCiqWZ;AiC9pWI;EACI,yB9B/RD;E8BgSC,6BAAA;AjCgqWR;AiC9pWI;EACI,uBAAA;AjCgqWR;AiC9pWI;EACI,yB9B/UG;E8BgVH,yBAAA;AjCgqWR;AiC9pWY;EACI,c9BvVL;AHu/WX;AiC3pWQ;EACI,oCAAA;EACA,yBAAA;EACA,oCAAA;EACA,gBAAA;AjC6pWZ;AiC5pWY;EACG,yBAAA;AjC8pWf;AiC3pWQ;EACI,yB9B3TD;E8B4TC,c9BvWD;AHogXX;AiC5pWY;EACG,c9BzWJ;AHugXX;AiC3pWQ;EACI,yB9BlUD;E8BmUC,yBAAA;AjC6pWZ;AiC5pWY;EACI,c9BhXL;AH8gXX;AiC7pWgB;EACG,c9BlXR;E8BmXQ,mB9B/WR;AH8gXX;AiCzpWQ;EACI,c9B5UE;AHu+Wd;AiC1pWY;EACI,c9BzeN;AHqoXV;AiCvpWQ;EACI,mB9BvVD;E8BwVC,c9BrVE;AH8+Wd;AiCrpWQ;EACI,c9B1VE;AHi/Wd;AiCnpWI;EACI,c9B/VM;AHo/Wd;AiClpWI;EACI,gCAAA;AjCopWR;AiCnpWQ;EACI,c9BrWE;AH0/Wd;AiClpWI;EACI,6BAAA;AjCopWR;AiCnpWQ;EACI,c9B3WE;AHggXd;AiCppWY;EACI,c9BxgBN;AH8pXV;AiClpWI;EACI,yBAAA;AjCopWR;AiClpWI;EACI,c9BrXM;AHygXd;AiChpWY;EACI,gCAAA;AjCkpWhB;AiCjpWgB;EACI,c9B5XN;AH+gXd;AiCjpWgB;EACI,c9B7aT;AHgkXX;AiCjpWgB;EACI,c9BhbT;AHmkXX;AiC1oWoB;EACI,c9B1bb;AHskXX;AiC3oWwB;EACI,c9B3hBpB;AHwqXR;AiC3oWwB;EACG,8FAAA;AjC6oW3B;AiCloW4B;EACI,mB9BvcrB;AH2kXX;AiC1nWY;EACI,c9BtdL;AHklXX;AiCtnWY;EACI,c9B7dL;AHqlXX;AiCvnWgB;EACG,c9B/dR;E8BgeQ,mB9B5dR;AHqlXX;AiCnnWQ;EACI,oCAAA;AjCqnWZ;AiCnnWQ;EACI,yB9B9bG;AHmjXf;AiCpnWY;EACI,c9B5eL;AHkmXX;AiCnnWQ;EACI,yB9B5eD;AHimXX;AiClnWI;EACI,yBAAA;AjConWR;AiCnnWQ;EACI,8BAAA;AjCqnWZ;AiCjnWQ;EACI,2HAAA;EACA,WAAA;AjCmnWZ;AiChnWI;EACI,mB9BrdG;E8BsdH,c9BndM;AHqkXd;AiCjnWQ;EACI,c9BngBD;AHsnXX;AiClnWY;EACG,c9BrgBJ;E8BsgBI,mB9BlgBJ;AHsnXX;AiC/mWQ;EACI,c9B9dE;AH+kXd;AiC5mWY;EACG,yBAAA;AjC8mWf;AiC7mWe;EACK,c9BteN;AHqlXd;AiC1mWI;;;;EAII,8BAAA;EACA,c9BhfM;AH4lXd;AiC3mWQ;;;;EACI,c9BlfE;AHkmXd;AiC7mWI;EACI,8BAAA;EACA,yBAAA;AjC+mWR;AiC7mWI;EACI,c9B1fM;E8B2fN,qB9B5fD;E8B6fC,yBAAA;AjC+mWR;AiC7mWI;EACI,qB9BhgBD;E8BigBC,yBAAA;AjC+mWR;AiC7mWI;EACI,qB9BpgBD;E8BqgBC,yBAAA;AjC+mWR;AiC3mWY;EACI,qB9B1gBT;AHunXP;AiCxmWQ;EACI,mB9BzjBD;E8B0jBC,c9BhhBE;E8BihBD,yBAAA;AjC0mWb;AiCvmWI;EACI,mB9B/jBG;E8BgkBH,c9BthBM;E8BuhBN,6CAAA;AjCymWR;AiCtmWQ;EACK,mB9BrkBF;AH6qXX;AiClmWgB;EACI,c9BhlBT;AHorXX;AiC/lWI;EACI,c9BxiBM;AHyoXd;AiC5lWgB;EACI,mB9BxlBT;AHsrXX;AiC5lWgB;EACI,c9BjjBN;AH+oXd;AiCzlWI;EACI,mB9BjmBG;AH4rXX;AiC1lWQ;EACI,c9BzjBE;AHqpXd;AiCxlWQ;EACI,yBAAA;AjC0lWZ;AiCxlWO;EACK,yB9B3mBD;AHqsXX;AiCvlWI;EACI,mB9B/mBG;E8BgnBH,c9BtkBM;AH+pXd;AiCvlWI;EACI,oCAAA;AjCylWR;AiCtlWQ;EACI,c9B7kBE;AHqqXd;AiCrlWI;EACI,c9BjlBM;AHwqXd;AiCnlWY;EACI,c9BtlBF;AH2qXd;AiCjlWI;EACI,qB9B3lBM;AH8qXd;AiChlWQ;EACI,mB9BzoBD;AH2tXX;AiChlWQ;EACI,mB9B5oBD;AH8tXX;AiChlWQ;EACI,mB9B/oBD;AHiuXX;AiCjlWY;EACI,c9BvmBF;AH0rXd;AiC/kWI;EACI,yB9B7mBD;AH8rXP;AiC/kWI;EACI,yB9BzpBG;E8B0pBH,yBAAA;AjCilWR;AiChlWQ;EACI,yB9B5pBD;E8B6pBC,gCAAA;AjCklWZ;AiChlWQ;EACI,c9BtnBE;AHwsXd;AiC/kWI;EACI,yBAAA;AjCilWR;AiC/kWI;EACI,yB9B9nBD;AH+sXP;AiC9kWQ;EACI,yBAAA;AjCglWZ;AiC/kWY;EACI,iCAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;AjCilWhB;AiC/kWY;EACI,iCAAA;EACA,6BAAA;EACA,oCAAA;EACA,8BAAA;AjCilWhB;AiC9kWQ;EACI,uBAAA;EACA,oBAAA;AjCglWZ;AiC9kWQ;EACI,uBAAA;EACA,oBAAA;AjCglWZ;AiC7kWI;EACI,yB9B1pBD;AHyuXP;AiC7kWI;EACI,yB9B/pBG;E8BgqBH,yBAAA;EACA,c9B9pBM;AH6uXd;AiC7kWI;EACI,yB9BlqBD;E8BmqBC,yBAAA;EACA,c9BnqBM;AHkvXd;AiC7kWI;EACI,c9BtqBM;E8BuqBN,mB9Bh0BI;E8Bi0BJ,iBAAA;AjC+kWR;AiC5kWQ;EACI,yBAAA;AjC8kWZ;AiC5kWQ;EACI,2HAAA;AjC8kWZ;AiC3kWI;EACI,gCAAA;AjC6kWR;AiC3kWI;EACI,mB9BhuBG;AH6yXX;AiC5kWQ;EACI,yBAAA;AjC8kWZ;AiC7kWY;EACI,c9Bv0BR;AHs5XR;AiC7kWY;EACI,2HAAA;AjC+kWhB;AiC5kWQ;EACI,gCAAA;AjC8kWZ;AiC3kWY;EACK,c9BrsBH;AHkxXd;AiC3kWY;EACI,mB9BxsBF;AHqxXd;AiCzkWI;EACI,aAAA;AjC2kWR;AiCzkWI;EACI,yBAAA;AjC2kWR;AiCvkWY;EACI,c9BrtBF;AH8xXd;AiCrkWY;EACI,c9B1tBF;AHiyXd;AiCnkWY;EACI,c9B/tBF;AHoyXd;AiCpkWgB;EACI,c9BjuBN;AHuyXd;AiClkWQ;EACI,c9BtuBE;AH0yXd;AiCnkWY;EACI,c9Br3BR;AH07XR;AiCjkWY;EACI,8BAAA;EACA,c9B9uBF;AHizXd;AiClkWgB;EACI,c9BhvBN;AHozXd;AiC/jWI;EACI,yB9BzvBG;E8B0vBH,c9BvvBM;AHwzXd;AiC7jWY;EACI,yB9B/vBL;E8BgwBK,yBAAA;AjC+jWhB;AiC9jWgB;EACI,c9B/vBN;AH+zXd;AiC9jWgB;EACI,mB9B3wBN;AH20Xd;AiCzjWY;EACI,yBAAA;AjC2jWhB;AiCtjWQ;EACI,mB9Bz6BA;AHi+XZ;AiCrjWY;EACI,c9Bj0BL;AHw3XX;AiCpjWQ;EACI,mB9B3xBD;AHi1XX;AiCnjWY;EACI,c9B5xBF;AHi1Xd;AiChjWgB;EACI,c9BlyBN;AHo1Xd;AiC/iWY;EACI,4B9Bn1BL;E8Bo1BK,mB9B1yBL;AH21XX;AiC/iWY;EACI,mB9B7yBL;E8B8yBK,qB9Bx1BL;AHy4XX;AiChjWgB;EACI,c9B7yBN;AH+1Xd;AiCjjWoB;EACI,c9B/yBV;AHk2Xd;AiC9iWQ;EACI,mB9BxzBD;AHw2XX;AiC9iWQ;EACI,mB9B3zBD;AH22XX;AiC3iWoB;EACI,qB9B32Bb;AHw5XX;AiC1iWwB;EACI,c9Bl0Bd;AH82Xd;AiCziW4B;EACI,yBAAA;AjC2iWhC;AiCpiWQ;EACI,mB9Bj1BD;AHu3XX;AiCriWY;EACI,mB9Bn1BL;E8Bo1BK,gBAAA;AjCuiWhB;AiCriWoB;EACI,c9Bp1BV;AH23Xd;AiCliWwB;EACI,cAAA;AjCoiW5B;AiC/hWY;EACI,c9Bh2BF;AHi4Xd;AiC7hWY;EACI,2B9Bl5BL;AHi7XX;AiC3hWI;EACI,mB9BngCI;AHgiYZ;AiC5hWQ;EACI,c9B52BE;AH04Xd;AiC3hWI;EACI,mB9BzgCI;AHsiYZ;AiC3hWI;EACI,c9Bn3BM;AHg5Xd;AiC1hWQ;EACI,qB9Bx3BL;E8By3BK,c9Bx3BE;AHo5Xd;AiCzhWI;EACI,qB9B73BD;AHw5XP;AiCvhWY;EACI,qB9Bl4BT;AH25XP;AiCxhWgB;EACI,qB9Bp4Bb;AH85XP;AiCxhWgB;EACI,qB9Bv4Bb;AHi6XP;AiCxhWgB;EACI,qB9B14Bb;AHo6XP;AiCphWQ;EACI,mB9Bn5BD;E8Bo5BC,qB9B97BD;AHo9XX;AiCrhWY;EACI,mB9B5iCJ;E8B6iCI,uCAAA;AjCuhWhB;AiCthWgB;EACI,c9Bt5BN;AH86Xd;AiCrhWY;EACI,mB9B75BL;AHo7XX;AiCnhWY;EACI,mB9Bl6BL;E8Bm6BK,qB9B78BL;AHk+XX;AiCphWgB;EACI,mB9B3jCR;AHilYZ;AiCrhWoB;EACI,c9Bp6BV;AH27Xd;AiCphWgB;EACI,mB9B36BT;AHi8XX;AiCphWgB;EACI,mB9BpkCR;AH0lYZ;AiCjhWI;EACI,mB9Bp7BG;AHu8XX;AiCjhWI;EACI,c9Bp7BM;AHu8Xd;AiCjhWI;EACI,c9Bv7BM;AH08Xd;AiCjhWI;EACI,mB9B77BG;E8B87BH,qB9B57BD;AH+8XP;AiClhWQ;EACI,gCAAA;AjCohWZ;AiCnhWY;EACI,c9B/7BF;AHo9Xd;AiClhWQ;EACI,c9Bn8BE;AHu9Xd;AiC/gWY;EACI,mB9B58BL;E8B68BK,+CAAA;AjCihWhB;AiC9gWgB;EACI,mB9Bj9BT;E8Bk9BS,+CAAA;EACA,qB9Bj9Bb;AHi+XP;AiC9gWwB;EACI,c9B79Bf;AH6+Xb;AiC3gW4B;EACI,c9Bz9BlB;AHs+Xd;AiCxgWgB;EACI,qB9Bh+Bb;AH0+XP;AiCtgWgB;EACI,qB9Br+Bb;E8Bs+Ba,iBAAA;AjCwgWpB;AiClgWwB;EACI,c9Bt/Bf;AH0/Xb;AiC//V4B;EACI,c9Bl/BlB;AHm/Xd;AiCz/VI;EACI,c9B3/BM;AHs/Xd;AiCz/VI;EACI,mB9BjgCG;E8BkgCH,qB9BhgCD;AH2/XP;AiCx/VgB;EACI,c9BngCN;AH6/Xd;AiCr/VI;EACI,c9BvjCG;AH8iYX;AiCr/VI;EACI,c9B5gCM;AHmgYd;AiCr/VI;EACI,mB9BxqCI;AH+pYZ;AiCr/VY;EACI,c9BlhCF;AHygYd;AiCn/VI;EACI,cAAA;AjCq/VR;AiCn/VI;EACI,uBAAA;EACA,gCAAA;AjCq/VR;AiCp/VQ;EACI,mB9B/hCG;AHqhYf;AiCl/VQ;EACI,kCAAA;AjCo/VZ;AiCl/VQ;EACI,c9BriCE;AHyhYd;AiCj/VI;EACI,uBAAA;AjCm/VR;AiCj/VI;EACI,mB9B/iCG;E8BgjCH,yBAAA;AjCm/VR;AiCj/VI;EACI,mB9BnjCG;AHsiYX;AiCl/VQ;EACI,c9BljCE;AHsiYd;AiCl/VQ;EACI,mB9BxjCD;E8ByjCC,c9BtjCE;AH0iYd;AiCj/VI;EACI,mB9B7jCG;AHgjYX;AiCj/VI;EACI,c9B7jCM;E8B8jCN,yB9BhkCO;AHmjYf;AiCh/VQ;EACI,mB9BrkCD;AHujYX;AiC/+VI;EACI,mB9BzkCG;AH0jYX;AiCh/VQ;EACI,mB9BlnCD;AHomYX;AiC9+VgB;EACI,c9B7kCN;AH6jYd;AiC3+VI;EACI,mB9BtlCG;AHmkYX;AiC5+VQ;EACI,c9BrlCE;AHmkYd;AiC3+VI;EACI,mB9B5lCG;AHykYX;AiC3+VI;EACI,c9B5lCM;AHykYd;AiC3+VI;EACI,mB9BzoCG;AHsnYX;AiC3+VI;EACI,c9BlmCM;AH+kYd;AiC3+VI;EACI,c9BrmCM;AHklYd;AiC3+VI;EACI,mB9B3mCG;AHwlYX;AiC5+VQ;EACI,c9B1mCE;AHwlYd;AiC3+VI;EACI,qB9B1pCG;E8B2pCH,mB9BlnCG;AH+lYX;AiC5+VQ;EACI,mB9B3pCD;AHyoYX;AiC7+VY;EACI,c9BnnCF;AHkmYd;AiC5+VQ;EACI,mB9BjqCD;AH+oYX;AiC3+VI;EACI,qB9B5nCD;AHymYP;AiC3+VY;EACI,qB9B/nCT;AH4mYP;AiC3+VY;EACI,qB9BloCT;AH+mYP;AiCz+VI;EACI,qB9BvoCD;AHknYP;AiCz+VI;EACI,mB9B5oCG;AHunYX;AiCz+VI;EACI,mB9BtrCG;AHiqYX;AiCz+VI;EACI,gBAAA;EACA,mB9B1rCG;AHqqYX;AiCz+VI;EACI,c9BnpCM;AH8nYd;AiCz+VI;EACI,c9BnyCA;AH8wYR;AiCz+VI;EACI,mB9BnsCG;AH8qYX;AiCz+VI;EACI,qB9B7pCD;E8B8pCC,mB9B/pCO;AH0oYf;AiCz+VI;EACI,gBAAA;AjC2+VR;AiCz+VI;EACI,iGAAA;AjC2+VR;AiCz+VI;EACI,mB9BzqCG;AHopYX;AiCn+V4B;EACI,c9B/qClB;AHopYd;AiCn+V4B;EACI,mB9B30CpB;AHgzYZ;AiCp+VgC;EACI,mB9B70CxB;AHmzYZ;AiCn+V4B;EACI,cAAA;AjCq+VhC;AiC19VgB;EACI,c9BpsCN;AHgqYd;AiCz9VoB;EACI,mB9Bj2CZ;AH4zYZ;AiCr9VI;EACI,mB9BltCG;E8BmtCH,oCAAA;AjCu9VR;AiCt9VQ;EACI,mB9B32CA;E8B42CA,c9BntCE;AH2qYd;AiCr9VI;EACI,c9Bp2CA;AH2zYR;AiCr9VI;EACI,mB9Bn3CI;E8Bo3CJ,c9B3tCM;AHkrYd;AiCr9VI;EACI,mB9Bv3CI;E8Bw3CJ,YAAA;AjCu9VR;AiCt9VQ;EACI,mB9B13CA;E8B23CA,c9BluCE;AH0rYd;AiCv9VY;EACI,c9BpuCF;AH6rYd;AiCr9VI;EACI,mB9Bl4CI;E8Bm4CJ,YAAA;AjCu9VR;AiCr9VI;EACI,aAAA;AjCu9VR;AiCr9VI;EACI,mB9BnvCG;E8BovCH,c9BjvCM;AHwsYd;AiCp9VQ;EACI,uBAAA;AjCs9VZ;AiCn9VI;EACI,mB9Bl5CI;AHu2YZ;AiCj9VY;EACI,c9B9vCF;AHitYd;AiCj9VY;EACI,cAAA;AjCm9VhB;AiCh9VQ;EACI,mB9B95CA;E8B+5CA,gBAAA;EACA,qB9BxwCL;AH0tYP;AiCh9VgB;EACI,c9B1wCN;AH4tYd;AiC58VQ;EACI,c9BjxCE;AH+tYd;AiC38VY;EACI,c9BrxCF;AHkuYd;AiCx8VI;EACI,c9B3xCM;AHquYd;AiCx8VI;EACI,mBAAA;AjC08VR;AiCx8VI;EACI,gBAAA;AjC08VR;AiCx8VI;EACI,mB9BvyCG;AHivYX;AiCx8VI;EACI,c9BvyCM;AHivYd;AiCx8VI;EACI,mB9Bn8CI;AH64YZ;AiCx8VI;EACI,cAAA;AjC08VR;AiCx8VI;EACI,mB9BlzCO;AH4vYf;AiCx8VI;EACI,c9BnzCM;AH6vYd;AiCx8VI;EACI,c9BtzCM;AHgwYd;AiCt8VY;EACI,c9B3zCF;AHmwYd;AiCt8VY;EACI,cAAA;AjCw8VhB;AiCp8VY;EACI,c9Bn0CF;AHywYd;AiCp8VY;EACI,cAAA;AjCs8VhB;AiCl8VI;EACI,mB9B90CG;AHkxYX;AiCl8VI;EACI,mB9Bj1CG;AHqxYX;AiCl8VI;EACI,c9Bj1CM;AHqxYd;AiCl8VI;EACI,c9Bp1CM;AHwxYd;AiCl8VI;EACI,mB9Bz1CO;E8B01CP,qB9B11CO;E8B21CP,iBAAA;AjCo8VR;AiCl8VI;EACI,mBAAA;AjCo8VR;AiCl8VI;EACI,8BAAA;AjCo8VR;AiCl8VI;EACI,kCAAA;AjCo8VR;AiCn8VQ;EACI,mBAAA;AjCq8VZ;AiCl8VI;EACI,mB9B12CO;AH8yYf;AiCl8VI;EACI,mB9B72CO;E8B82CP,yBAAA;AjCo8VR;AiCh8VY;EACI,yB9Bp3CL;E8Bq3CK,yBAAA;AjCk8VhB;AiCj8VgB;EACI,yB9Bv3CT;AH0zYX;AiCj8VgB;EACI,c9Bn6CT;AHs2YX;AiCl8VoB;EACI,c9BphDd;AHw9YV;AiCl8VoB;EACI,c9B36Cb;AH+2YX;AiCn8VwB;EACI,c9BzhDlB;AH89YV;AiC97VI;EACI,8BAAA;EACA,sBAAA;AjCg8VR;AiC57VY;EACI,c9B54CF;AH00Yd;AiCz7VQ;EACI,gCAAA;AjC27VZ;AiCr7VgB;EACI,qB9B15Cb;AHi1YP;AiCh7VY;EACI,c9Bz6CJ;AH21YZ;AiC76VQ;EACI,6BAAA;AjC+6VZ;AiC16VY;EACI,mB9BtkDJ;E8BukDI,qB9BvkDJ;E8BwkDI,+CAAA;AjC46VhB;AiCr6VgB;EACI,mB9B17CT;AHi2YX;AiC95VoB;EACI,c9Bj8CV;AHi2Yd;AiCz5VQ;EACI,c9Bz8CE;AHo2Yd;AiCt5Va;EACG,yB9B1/CL;AHk5YX;AiCn5VgB;EACI,c9Br9CN;AH02Yd;AiCn5VgB;EACI,c9Bx9CN;AH62Yd;AiCh5VY;EACI,c9B99CF;AHg3Yd;AiC54VY;EACI,yB9Br+CF;AHm3Yd;AiC74VgB;EACI,8BAAA;EACA,gCAAA;EACA,c9BrnDZ;AHogZR;AiC14VI;EACI,c9B/+CM;AH23Yd;AiCt4VoB;EACI,mB9B/oDZ;E8BgpDY,c9Bv/CV;AH+3Yd;AiCr4VgB;EACI,mB9BppDR;AH2hZZ;AiCp4V4B;EACI,c9B//ClB;AHq4Yd;AiCl4V4B;EACI,c9BpgDlB;AHw4Yd;AiC73VQ;EACI,yBAAA;EACA,+BAAA;AjC+3VZ;AiC73VQ;EACI,mB9BzqDA;E8B0qDA,c9BjhDE;E8BkhDF,yBAAA;AjC+3VZ;AiC93VY;EACI,yB9BrhDT;AHq5YP;AiC53VY;EACI,yB9B1hDT;AHw5YP;AiCx3VY;EACI,gCAAA;AjC03VhB;AiCr3VQ;EACI,+CAAA;AjCu3VZ;AiCt3VY;EACI,gCAAA;AjCw3VhB;AiCp3VI;EACI,gCAAA;AjCs3VR;AiC/2VwB;EACI,c9BrjDd;AHs6Yd;AiC52VY;EACI,c9B3jDF;AHy6Yd;AiC12VI;EACI,c9BhkDM;AH46Yd;AiC12VI;EACI,c9BnkDM;AH+6Yd;AiC12VI;EACI,c9BtkDM;AHk7Yd;AiC12VI;EACI,sCAAA;EACA,c9BvtDA;E8BwtDA,kCAAA;AjC42VR;AiCz2VQ;EACI,c9B5tDJ;AHukZR;AiCx2VI;EACI,oCAAA;EACA,yBAAA;AjC02VR;AiCx2VI;EACI,yBAAA;EACA,yBAAA;AjC02VR;AiCv2VQ;EACI,yBAAA;AjCy2VZ;AiCt2VI;EACI,0CAAA;EACA,qCAAA;EACA,c9B/uDA;AHulZR;AiCt2VI;EACI,yCAAA;EACA,oCAAA;EACA,c9BpvDA;AH4lZR;AiCt2VI;EACI,uCAAA;EACA,kCAAA;EACA,c9BzvDA;AHimZR;AiCt2VI;EACI,WAAA;AjCw2VR;AiCv2VQ;EACI,wCAAA;AjCy2VZ;AiCr2VQ;EACI,yBAAA;AjCu2VZ;AiCp2VI;EACI,sCAAA;EACA,cAAA;AjCs2VR;AiCn2VQ;EACI,mBAAA;AjCq2VZ;AiCj2VQ;EACI,6BAAA;EACA,c9BroDE;AHw+Yd;AiCh2VI;EACI,+CAAA;AjCk2VR;AiC71VgB;EACI,6BAAA;AjC+1VpB;AiC11VI;EACI,qB9BjsDG;AH6hZX;AiCx1VY;EACI,c9BvyDR;AHioZR;AiCr1VQ;EACI,qDAAA;AjCu1VZ;AiCl1VY;EACI,qDAAA;AjCo1VhB;AiC90VY;EACI,yBAAA;AjCg1VhB;AiC90VY;EACI,yBAAA;AjCg1VhB;AiCz0VgB;EACI,c9BxrDN;AHmgZd;AiCr0VQ;EACI,uBAAA;AjCu0VZ;AiCp0VI;EACI,c9BnsDM;AHygZd;AiCj0VY;EACI,uBAAA;AjCm0VhB;AiC/zVI;EACI,gCAAA;AjCi0VR;AiC/zVI;EACI,c9BjtDM;AHkhZd;AiC/zVI;EACI,c9B9tDK;AH+hZb;AiC/zVI;EACI,gCAAA;AjCi0VR;AiC7zVY;EACI,gCAAA;AjC+zVhB;AiC3zVoB;EACI,gCAAA;AjC6zVxB;AiCvzVI;EACI,gCAAA;AjCyzVR;AiCtzVQ;EACI,c9B5uDE;AHoiZd;AiCrzVI;EACI,mB9BlvDO;E8BmvDP,c9BjvDM;E8BkvDN,qB9B9xDG;AHqlZX;AiCrzVI;EACI,gCAAA;AjCuzVR;AiCrzVI;EACI,c9BxvDM;AH+iZd;AiCrzVI;EACI,c9BpwDM;AH2jZd;AiCrzVI;EACI,6BAAA;AjCuzVR;AiCpzVQ;EACI,6BAAA;AjCszVZ;AiCnzVI;EACI,c9BtwDM;AH2jZd;AiClzVQ;EACI,+CAAA;AjCozVZ;AiCnzVY;EACA,c9B5wDE;AHikZd;AiCjzVI;EACI,qB9BlxDD;AHqkZP;AiCjzVY;EACI,qB9BrxDT;E8BsxDS,c9BrxDF;AHwkZd;AiC9yVgB;EACI,yB9B7xDL;AH6kZf;AiC1yVQ;EACI,yB9BpyDG;E8BqyDH,yBAAA;AjC4yVZ;AiC3yVY;EACI,c9BryDF;AHklZd;AiCvyVY;EACI,qB9B7yDT;AHslZP;AiCtyVQ;EACK,qB9BjzDN;AHylZP;AiCpyVQ;EACI,c9BrzDE;AH2lZd;;AkCxwZA;EACI,mB/B+BI;E+B9BJ,gCAAA;EACA,YAAA;EACA,YAAA;EjCgGF,eiC/FoB;EjCgGpB,MiChG0B;EjCiG1B,QiCjG4B;EjCmG5B,OiCnGmC;EjC2FnC,yBiC1FsB;AlCgxZxB;AkC7wZY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AlC+wZhB;AkC3wZI;EjCgFF,yBiC/E0B;AlC+wZ5B;AkC7wZI;EjC6EF,yBiC5E0B;EjC2C1B,gCiC1CyB;EjC2CzB,wCiC3CyB;EjC4CzB,oCiC5CyB;EACnB,gDAAA;EACA,SAAA;EACA,gBAAA;AlCmxZR;AkClxZQ;EACI,0BAAA;AlCoxZZ;AC5vZI;EiC/BA;IAUQ,gBAAA;ElCqxZV;AACF;AkCnxZI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EjC8DL,eiC7DmC;EjCgDpC,yBiC/C0B;EACpB,+BAAA;EACA,gCAAA;AlCuxZR;AkCtxZQ;EACI,qBAAA;EACA,cAAA;AlCwxZZ;AkCvxZY;EACI,YAAA;AlCyxZhB;AC/xZI;EiCEI;IAOQ,kBAAA;IACA,WAAA;ElC0xZd;EkCzxZc;IACI,YAAA;ElC2xZlB;AACF;AkCxxZQ;EACI,aAAA;AlC0xZZ;AC3yZI;EiClBA;IAsCQ,kBAAA;IACA,WAAA;ElC2xZV;AACF;ACjzZI;EiC0BG;IACK,aAAA;ElC0xZV;AACF;AC70ZI;EiCsDI;IACI,WAAA;IACA,e/BiLG;I+BhLH,iBAAA;ElC0xZV;EkCxxZU;IACI,qBAAA;IACA,WAAA;ElC0xZd;EkCzxZc;IACI,yB/B1DZ;I+B2DY,cAAA;IACA,WAAA;IACA,WAAA;IACA,WAAA;IjCcjB,eiCbyC;IjCqC1C,mBiCpCmC;ElC2xZnC;EkC1xZkB;IACI,WAAA;ElC4xZtB;AACF;AkCtxZI;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EjCCL,kBAAA;EAuBD,gBiCtBuB;AlCwxZzB;ACp1ZI;EiCuDA;IAOQ,aAAA;ElC0xZV;AACF;AkCzxZQ;EACI,c/BjGF;E+BkGE,e/BsIG;E+BrIH,gB/B5GO;E+B6GP,yBAAA;EjCVT,SiCWiC;EjCVjC,YiCUoC;EjCarC,kBiCZ2B;AlC4xZ7B;AkC3xZY;EACI,mB/BxGN;E+ByGM,c/B3FR;AHw3ZR;AkCzxZI;EACI,aAAA;EACA,WAAA;AlC2xZR;AC12ZI;EiC6EA;IAIQ,c/BjHF;I+BkHE,e/B+HG;I+B9HH,YAAA;IACA,iBAAA;IACA,WAAA;IACA,WAAA;IjC3BT,eiC4BuC;IjCrCxC,kBiCsC4B;IjCrC5B,MiCqCqC;IjClCrC,OiCkCiD;IACvC,cAAA;ElC+xZV;AACF;AkC5xZI;EACI,aAAA;EACA,c/BjHA;E+BkHA,e/B+GO;E+B9GP,YAAA;EACA,iBAAA;EjCvCL,eiCwCmC;AlC8xZtC;ACj4ZI;EiC6FA;IAQQ,cAAA;ElCgyZV;AACF;AkC7xZQ;EACI,kBAAA;AlC+xZZ;ACz4ZI;EiCyGI;IAGQ,aAAA;ElCiyZd;AACF;AkChyZY;EACI,0CAAA;EACA,2CAAA;EACA,YAAA;EjCtDb,4BiCuD2C;EjChC5C,mBiCiC+B;AlCkyZjC;AkCjyZgB;EACI,+BAAA;AlCmyZpB;AkChyZY;EACI,6BAAA;EACA,yBAAA;EACA,+BAAA;EACA,gBAAA;EjC1Ed,kBiC2EgC;EjC1EhC,MiC0EyC;EjCzEzC,QiCyE2C;AlCoyZ7C;ACj6ZI;EiCkIY;IACI,cAAA;IjCjFlB,kBiCkFoC;IjC9EpC,OiC8E4D;ElCmyZ5D;EkClyZkB;IACI,yB/BxJhB;EH47ZN;EkClyZkB;IACI,6BAAA;IACA,yBAAA;IACA,gBAAA;IjCzFtB,kBiC0FwC;IjCzFxC,MiCyFiD;IjCxFjD,QiCwFmD;IjCjFlD,iBiCkFmD;ElCsyZpD;AACF;AkCjyZI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlCmyZR;AkClyZQ;EACI,oBAAA;EACA,iBAAA;EACA,mBAAA;AlCoyZZ;AkCnyZY;EACI,cAAA;EACA,oBAAA;AlCqyZhB;AkChyZQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,c/B9FD;E+B+FC,4BAAA;AlCkyZZ;AkCjyZY;EACI,iBAAA;EACA,kBAAA;EACA,WAAA;AlCmyZhB;AkChyZQ;EACI,c/B3MH;AH6+ZT;ACv9ZI;EiC4LgB;IACI,aAAA;ElC8xZtB;EkC3xZc;IACI,wBAAA;ElC6xZlB;AACF;AkCvxZY;EACI,YAAA;AlCyxZhB;AkCrxZI;EACI,qBAAA;EACA,kBAAA;AlCuxZR;AkCtxZQ;EACI,WAAA;EjC/HV,kBiCgI2B;AlCwxZ7B;AkCtxZQ;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EjC7JT,SiC8JiC;EjCtKlC,kBiCuK4B;EjCrK5B,QiCqK0C;EjCpK1C,YiCoK4C;EjCvI5C,kBiCwI2B;EACjB,qBAAA;EACA,mB/BxPF;AHkhaV;AkCvxZI;EACI,c/BlPA;E+BmPA,aAAA;EACA,YAAA;EACA,e/BlBO;E+BmBP,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,WAAA;EjC7KL,eiC8KmC;EjCvLpC,kBiCwLwB;EjCvLxB,MiCuLiC;EjCtLjC,QiCsLmC;AlC2xZrC;ACrgaI;EiC+NA;IAaQ,cAAA;ElC6xZV;AACF;AkC5xZQ;EACI,c/B/QF;E+BgRE,UAAA;AlC8xZZ;AkC7xZY;EACI,aAAA;AlC+xZhB;AkC5xZQ;EACI,UAAA;AlC8xZZ;AkC7xZY;EACI,c/BxKL;E+ByKK,iBAAA;EjC9Lb,eiC+L2C;AlC+xZ9C;;AkC1xZA;EACI,WAAA;AlC6xZJ;;ACpjaI;EiC4RQ;IACI,mBAAA;IACA,8BAAA;IACA,sCAAA;IACA,4BAAA;ElC4xZd;EkCzxZM;IAGI,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,sBAAA;IACA,uBAAA;IACA,+BAAA;IACA,qBAAA;IACA,WAAA;IjC3NT,UiC4NuC;IAC9B,sBAAA;ElC2xZV;EkC1xZU;IACI,cAAA;IACA,iBAAA;ElC4xZd;EkC1xZU;IACI,aAAA;ElC4xZd;EkCzxZM;IACI,wBAAA;ElC2xZV;EkCzxZM;IACI,wBAAA;ElC2xZV;EkCxxZU;IACI,wBAAA;ElC0xZd;EkCtxZU;IACI,yBAAA;ElCwxZd;EkCtxZU;IACI,yBAAA;ElCwxZd;EkCtxZU;IACI,aAAA;ElCwxZd;EkCtxZU;IACI,cAAA;ElCwxZd;EkCtxZU;IACG,UAAA;ElCwxZb;EkCtxZU;IjCjQT,eiCkQ2C;IAC9B,aAAA;ElCwxZd;EkCnxZU;IACI,aAAA;ElCqxZd;AACF;AkChxZI;EACI,kBAAA;AlCkxZR;;AkC/wZA;EjC5RE,eiC6RoB;EjC5RpB,MiC4R0B;EjC3R1B,QiC2R4B;EAC1B,aAAA;EACA,mB/BnWI;E+BoWJ,eAAA;EACA,YAAA;EACA,oBAAA;EjCtSF,yBiCuSsB;EjCvPtB,wCAAA;ADghaF;AkCvxZI;EACI,eAAA;AlCyxZR;AkCvxZI;EjC/RD,aiCgSmC;EAC9B,cAAA;EACA,YAAA;AlCyxZR;AkCvxZI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,gCAAA;EACA,c/B1RG;AHmjaX;AkCvxZI;EjCjTD,eiCkTmC;AlCyxZtC;AkCtxZI;EACI,kBAAA;AlCwxZR;AkCvxZQ;EACI,WAAA;EACA,YAAA;EACA,yBAAA;EjC1TT,eiC2TuC;EjCpSxC,mBiCqS2B;AlCyxZ7B;AkCvxZQ;EjCvUN,kBiCwU4B;EjCvU5B,QiCuUqC;EjCtUrC,WiCsUyC;EAC/B,mB/B3ZF;EFkHR,mBiC0S2B;EACjB,c/B/YJ;AH0qaR;AkCxxZI;EACI,gBAAA;EACA,6BAAA;EACA,iBAAA;AlC0xZR;AkCzxZQ;EACI,e/BxLG;E+ByLH,mBAAA;EACA,c/BvTD;E+BwTC,gB/BjbO;AH4sanB;AkCzxZQ;EACI,gCAAA;EjChVT,aiCiVuC;AlC2xZ1C;AkC1xZY;EACI,e/B/bC;AH2tajB;AkCxxZI;EACI,gB/B7be;E+B8bf,e/BrMO;AH+9Zf;;AkCvxZA;EjC5VG,aiC6V+B;EAC9B,mB/B3aI;E+B4aJ,mBAAA;EACA,gCAAA;EACA,YAAA;AlC0xZJ;ACtraI;EiCuZJ;IjC5VG,aiCmWmC;IAC9B,YAAA;ElC4xZN;AACF;AkC3xZI;EACI,aAAA;EACA,WAAA;AlC6xZR;AChsaI;EiCiaA;IAIQ,c/BrcF;I+BscE,e/BrNG;I+BsNH,YAAA;IACA,iBAAA;IACA,WAAA;IACA,WAAA;IjC/WT,eiCgXuC;IjCzXxC,kBiC0X4B;IjCzX5B,MiCyXqC;IjCtXrC,OiCsXiD;IACvC,cAAA;ElCiyZV;AACF;;AkC5xZQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,YAAA;EjClYT,aiCmYuC;AlC+xZ1C;AkC9xZY;EACI,yBAAA;EACA,YAAA;EACA,0BAAA;EACA,yBAAA;AlCgyZhB;AkC7xZQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,6BAAA;EACA,e/BxQG;E+ByQH,YAAA;EACA,iBAAA;AlC+xZZ;AkC9xZY;EACI,cAAA;EACA,kBAAA;EACA,c/BvYL;EFrBR,iBiC6Z2C;EAC9B,0BAAA;AlCgyZhB;AkC5xZY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,YAAA;AlC8xZhB;AkC7xZiB;EACG,c/BpgBR;E+BqgBQ,mBAAA;EACA,YAAA;EACA,e/B7RL;E+B8RK,cAAA;AlC+xZpB;AkC7xZwB;EACI,uBAAA;AlC+xZ5B;AkC3xZgB;EACI,YAAA;AlC6xZpB;AkCxxZY;EACI,aAAA;AlC0xZhB;AkCxxZY;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EjC5ad,kBiC6a+B;EACjB,qBAAA;EACA,mB/B7hBN;EF8ER,kBiCgdgC;EjC7chC,WiC6cmD;EjC5cnD,OiC4cuD;AlC4xZzD;;AC9xaI;EiCygBI;IAEQ,aAAA;ElCwxZd;AACF;AkCrxZoB;EACG,mBAAA;EACA,YAAA;EjCtdpB,YiCudkD;AlCuxZrD;;AkChxZA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AlCmxZJ;ACrzaI;EiCyhBJ;IAWQ,uBAAA;IACA,+BAAA;IACA,qBAAA;ElCqxZN;AACF;AC5zaI;EiCwiBA;IAEQ,aAAA;ElCsxZV;AACF;AkCrxZQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlCuxZZ;AkCtxZY;EACI,kBAAA;AlCwxZhB;AkCvxZgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,c/B9kBZ;EFmGN,kBiC4emC;EjCngBlC,gBiCogB+C;AlCyxZlD;AkCxxZoB;EACI,SAAA;AlC0xZxB;AkCxxZoB;EACI,mB/BpmBd;E+BqmBc,c/BvlBhB;AHi3aR;AkCzxZwB;EACI,+BAAA;AlC2xZ5B;AkCvxZgB;EACI,cAAA;AlCyxZpB;ACr2aI;EiC2kBY;IAGQ,cAAA;ElC2xZtB;AACF;;AkCrxZA;EACI,aAAA;AlCwxZJ;AC92aI;EiCqlBJ;IAGQ,cAAA;ElC0xZN;AACF;;AkCxxZA;EACI,kBAAA;EACA,WAAA;EACA,aAAA;AlC2xZJ;ACz3aI;EiC2lBJ;IAKQ,cAAA;ElC6xZN;AACF;;AkC3xZA;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;AlC8xZJ;AkC7xZI;EACI,yB/BxoBE;E+ByoBF,cAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AlC+xZR;AkC9xZQ;EACI,WAAA;AlCgyZZ;;AkC1xZQ;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;AlC6xZZ;AkC3xZgB;EACI,kBAAA;EACA,SAAA;EjCjnBlB,wBiCknBqC;EjCjnBrC,gCiCinBqC;EjChnBrC,4BiCgnBqC;AlC+xZvC;AkC7xZgB;EACG,aAAA;AlC+xZnB;AkC7xZgB;EjCvnBd,yBiCwnBqC;EjCvnBrC,iCiCunBqC;EjCtnBrC,6BiCsnBqC;AlCiyZvC;;AkC3xZA;EACI,6BAAA;EACA,UAAA;AlC8xZJ;;AkC5xZA;EjCplBG,YiCqlB+B;AlC+xZlC;AkC9xZI;EAGI,aAAA;EjCzlBL,sBiC0lBmC;AlCgyZtC;AkC/xZQ;EACI,e/BxsBK;E+BysBL,c/BtrBA;E+BurBA,gB/BpsBS;AHq+arB;AkC/xZQ;EACI,e/B7sBK;E+B8sBL,c/B/kBD;AHg3aX;AkC/xZQ;EACI,iBAAA;AlCiyZZ;AkC/xZQ;EACI,aAAA;AlCiyZZ;AkC9xZI;EACI,2BAAA;AlCgyZR;;AkC3xZQ;EACI,0BAAA;EACA,SAAA;AlC8xZZ;;AkC1xZA;EACI,WAAA;EACA,YAAA;AlC6xZJ;;AkC3xZA;EACI,WAAA;EACA,YAAA;AlC8xZJ;;AkC5xZA;EACI,WAAA;EACA,YAAA;AlC+xZJ;;AkC7xZA;EACI,WAAA;EACA,YAAA;AlCgyZJ;;AkC9xZA;EACI,WAAA;EACA,YAAA;AlCiyZJ;;AkC/xZA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,mBAAA;AlCkyZJ;ACn/aI;EiCmtBI;IAEQ,aAAA;ElCkyZd;AACF;AkC/xZI;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;EACA,+BAAA;EACA,gCAAA;EACA,kBAAA;EACA,wBAAA;EACA,oBAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;AlCiyZR;ACvgbI;EiCytBA;IAeQ,SAAA;ElCmyZV;AACF;AkCjyZE;EACE,cAAA;EACA,cAAA;EACA,eAAA;AlCmyZJ;AkCjyZE;EAGE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,c/B5wBI;E+B6wBJ,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gB/BxyBmB;E+ByyBnB,e/BnjBW;E+BojBX,kBAAA;EACA,yBAAA;AlCmyZJ;ACpibI;EiCgvBF;IAmBM,eAAA;ElCqyZN;AACF;AkCpyZI;EjCnrBF,kBiCorBuB;AlCsyZzB;AkCnyZE;EACE,e/B9jBW;E+B+jBX,gB/BrzBmB;E+BszBnB,cAAA;EACA,aAAA;EACA,mBAAA;AlCqyZJ;AkCnyZE;EACE,iBAAA;AlCqyZJ;;AkClyZA;EACI,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EjChvBF,yBiCivBsB;AlCuyZxB;ACtkbI;EiCoxBJ;IAaQ,aAAA;ElCyyZN;AACF;AkCxyZI;EACI,iBAAA;EACA,oBAAA;AlC0yZR;AC/kbI;EiCmyBA;IAIQ,gBAAA;ElC4yZV;AACF;AkC3yZQ;EACI,WAAA;EACA,cAAA;AlC6yZZ;AkC1yZY;EACI,c/B/0BN;AH2nbV;AkCvyZQ;EACI,SAAA;EACA,aAAA;AlCyyZZ;AkCtyZI;EACI,kBAAA;EACA,iBAAA;AlCwyZR;AkCtyZI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mB/B9vBG;E+B+vBH,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AlCwyZR;AkCvyZQ;EACI,mBAAA;AlCyyZZ;AkCpyZQ;EACI,UAAA;EACA,aAAA;EACA,mBAAA;EACA,c/Bp3BA;AH0pbZ;AkCryZY;EACI,c/B12BR;E+B22BQ,gB/Bl4BG;EF2FjB,kBiCwyBgC;EjCvyBhC,SiCuyByC;EjCtyBzC,WiCsyB8C;EAChC,mB/B33BN;E+B43BM,WAAA;EACA,YAAA;EACA,e/BvpBD;E+B0pBC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlCyyZhB;AkCvyZY;EACI,e/B3pBD;E+B4pBC,iBAAA;AlCyyZhB;AkCryZa;EAGG,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlCuyZhB;AkCtyZgB;EACI,iBAAA;EACA,gBAAA;EACA,gBAAA;AlCwyZpB;AkCvyZoB;EjC/zBjB,iBiCg0BmD;AlCyyZtD;AkCryZY;EACI,aAAA;EACA,gBAAA;AlCuyZhB;AkCtyZgB;EjCv0Bb,kBiCw0B+C;EAC9B,cAAA;EACA,mBAAA;EACA,gBAAA;AlCwyZpB;AkCvyZoB;EACI,c/B15BhB;AHmsbR;AkCvyZoB;EACI,8FAAA;AlCyyZxB;AkCryZoB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AlCuyZxB;;AkC/xZA;EjCh2BG,UiCi2BgC;EAC/B,kBAAA;AlCkyZJ;AkCjyZI;EACI,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mB/Bz1BG;EFdR,eiCw2BoC;EjCj1BrC,kBiCk1BuB;AlCmyZzB;ACvsbI;EiC85BA;IAQQ,YAAA;ElCqyZV;AACF;AkClyZQ;EACI,UAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EjCl2BV,kBiCm2B2B;EACjB,eAAA;EjCp4BV,kBiCq4B4B;EjCp4B5B,QiCo4BqC;EjCn4BrC,WiCm4ByC;EjC16BzC,2BiC26B6B;EjC16B7B,mCiC06B6B;EjCz6B7B,+BiCy6B6B;AlCwyZ/B;;AkClyZQ;EACI,UAAA;EjCj5BV,yBiCk5B8B;EACpB,c/Bn5BC;AH0rbb;AkClyZY;EACI,UAAA;AlCoyZhB;;AkC/xZA;EACI,YAAA;EACA,aAAA;EACA,sD/B/wBS;E+BgxBT,aAAA;EjC93BF,mBiC+3BmB;EACjB,mB/Bp+BI;E+Bq+BJ,aAAA;EACA,gBAAA;AlCkyZJ;AkCjyZI;EjC35BD,kBiC45B6B;EjC35B7B,mBiC25ByC;EACpC,gCAAA;EACA,e/B7wBO;E+B8wBP,c/Bx2BK;AH4obb;AkCnyZQ;EACI,mBAAA;EjCj6BT,SiCk6BiC;EjCj6BjC,UiCi6BoC;AlCsyZvC;AkCpyZQ;EACI,e/BpxBG;E+BqxBH,gB/BzgCO;E+B4gCP,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,c/BrgCA;E+BsgCA,mBAAA;AlCsyZZ;AkCryZY;EACI,WAAA;EACA,iBAAA;EACA,c/B1gCJ;AHizbZ;AkCpyZQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlCsyZZ;AkCryZY;EACI,kBAAA;AlCuyZhB;AkCtyZgB;EACI,eAAA;AlCwyZpB;AkCryZoB;EACI,mB/B7hCd;E+B8hCc,c/BhhChB;AHuzbR;AkCpyZgB;EjCt8Bb,iBiCu8B+C;EAC9B,mB/Bx7BT;EFOT,mBiCk7BmC;EACjB,c/Bp5BP;AH0rbb;AkCjyZY;EACI,mBAAA;AlCmyZhB;AkCjyZoB;EACI,c/B9iCd;AHi1bV;AkClyZwB;EACI,qB/BhjClB;AHo1bV;AkChyZgB;EACI,gBAAA;AlCkyZpB;AkChyZgB;EACI,c/Bv6BP;E+Bw6BO,e/B70BL;E+Bg1BK,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AlCkyZpB;AkCjyZoB;EACI,WAAA;EACA,YAAA;EjCn9BtB,mBiCo9BuC;EACjB,yBAAA;AlCmyZxB;;AkCrxZwB;EACI,gBAAA;AlCwxZ5B;AkCnxZY;EACI,iBAAA;EACA,yBAAA;EjC3+Bd,kBiC4+B+B;AlCqxZjC;ACn1bI;EiC2jCQ;IAKQ,gBAAA;ElCuxZlB;AACF;AkCtxZgB;EACI,uBAAA;AlCwxZpB;AC31bI;EiCkkCY;IAGQ,mBAAA;ElC0xZtB;AACF;AkCzxZoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;AlC2xZxB;AkC1xZwB;EjC1/BtB,mBiC2/B2C;AlC4xZ7C;AkCzxZoB;EACI,e/Bv4BT;E+Bw4BS,gB/B7nCH;E+B8nCG,c/BjnCZ;AH44bZ;AkCzxZoB;EACI,QAAA;EjCzkCtB,2BiC0kCyC;EACnB,wBAAA;EACA,qB/Bx+BX;E+By+BW,UAAA;AlC6xZxB;;AkCpxZQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AlCuxZZ;AkCtxZY;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EjC3hCd,mBiC4hC+B;EACjB,yBAAA;AlCwxZhB;;AkCjxZI;EACI,SAAA;EACA,aAAA;AlCoxZR;AkClxZI;EACI,cAAA;AlCoxZR;AkClxZI;EACI,mBAAA;EACA,uBAAA;EACA,YAAA;AlCoxZR;AkCnxZQ;EACI,mB/BppCJ;AHy6bR;AkChxZY;EACI,mB/BxqCN;E+ByqCM,qB/BzqCN;AH27bV;AkCjxZgB;EjC7nCd,yBiC8nCqC;EjC7nCrC,iCiC6nCqC;EjC5nCrC,6BiC4nCqC;EACnB,c/B9pCZ;AHm7bR;;AmCn9bA;EACI,gBAAA;EACA,kBAAA;AnCs9bJ;;AmCn9bI;EACI,0BAAA;ElCuGL,akCtGmC;AnCs9btC;;AmCn9bA;EACI,wBAAA;AnCs9bJ;;AmCp9bA;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,mBhCeI;EgCdJ,6BAAA;EACA,kDAAA;EACA,YAAA;AnCu9bJ;AmCt9bI;ElCwFD,ekCvFmC;AnCw9btC;AmCt9bW;EAUK,gBAAA;EACA,kBAAA;AnC+8bhB;AmCt9bwB;EACI,chCXlB;AHm+bV;AmCj9bgB;ElCyEb,kBkCrE+C;AnCg9blD;AmCn9boB;EACI,uBAAA;AnCq9bxB;ACz8bI;EkCdY;IlCyEb,iBkCnEmD;EnCq9bpD;AACF;AC98bI;EkCPoB;IAEQ,ehC5Cf;EHmgcf;AACF;AmCp9boB;EACI,uBAAA;AnCs9bxB;AmCr9bwB;EACI,chClClB;AHy/bV;AmCr9bwB;EACI,8HAAA;AnCu9b5B;AmCp9boB;EACI,iBAAA;EACA,WAAA;AnCs9bxB;AmCn9bgB;EACI,gBhCzDC;EgC0DD,ehC6LL;EgC5LK,chC8DT;AHu5bX;AmCp9boB;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;AnCs9bxB;AmCp9boB;EACI,WAAA;EACA,iBAAA;AnCs9bxB;AC/+bI;EkCuBgB;IAIQ,iBAAA;EnCw9b1B;AACF;AmCr9bgB;EACI,iBAAA;EACA,wBAAA;EACA,iBAAA;AnCu9bpB;AmCr9bgB;EACI,kBAAA;EACA,YAAA;EACA,YAAA;AnCu9bpB;AmCp9b4B;EACI,4BAAA;AnCs9bhC;AmCr9bgC;EACI,YAAA;EACA,kBAAA;AnCu9bpC;AmCr9bgC;EACI,iBAAA;AnCu9bpC;AmCr9bgC;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;AnCu9bpC;AmCr9bgC;EACI,WAAA;EACA,iBAAA;AnCu9bpC;AmCp9b4B;EACI,kDAAA;AnCs9bhC;AmCp9b4B;EACI,kBAAA;ElCP7B,UkCQ2D;AnCs9b9D;AmCp9boC;EACI,qCAAA;AnCs9bxC;AmC/8bwC;EACI,iBAAA;AnCi9b5C;AmC18b4C;EACI,iBAAA;AnC48bhD;AmCr8bwB;EACI,4BAAA;AnCu8b5B;AmCt8b4B;EACI,wBAAA;AnCw8bhC;ACxicI;EkC1BO;IAgIQ,eAAA;EnCs8bjB;AACF;;ACpkcI;EkCoIA;IACI,aAAA;EnCo8bN;AACF;ACnjcI;EkCkHA;IACI,aAAA;EnCo8bN;EmCl8bE;IACI,iBAAA;EnCo8bN;AACF;AoC5mcI;EACI,oBAAA;EnC2GL,emC1GmC;ApC8mctC;AoC5mcI;EACI,WAAA;EACA,iBAAA;ApC8mcR;AoC7mcQ;EACI,OAAA;EACA,sBAAA;ApC+mcZ;AoC5mcY;EACI,UAAA;ApC8mchB;;AoCxmcI;EACI,UAAA;EACA,SAAA;EACA,oBAAA;ApC2mcR;AoClmcgC;EAGI,wBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ApComcpC;AoCnmcoC;EACI,WAAA;ApCqmcxC;AoCnmcoC;EACI,iBAAA;ApCqmcxC;AoCnmcoC;EACI,aAAA;ApCqmcxC;AoCnmcoC;EACI,SAAA;ApCqmcxC;AoChmcwC;EACI,yBAAA;ApCkmc5C;AoCzlcY;EACI,kBAAA;EACA,SAAA;EACA,WAAA;ApC2lchB;;AoCplcQ;EACI,iBAAA;ApCulcZ;;AChncI;EmC8BA;IACI,OAAA;IACA,SAAA;EpCslcN;AACF;ACvncI;EmCmCJ;IAEQ,yBAAA;EpCslcN;AACF;;AqC9qcA;EACI,cAAA;EACA,cAAA;ArCircJ;AqChrcI;EACI,mBlCkKE;EkCjKF,mBAAA;EACA,iBAAA;ArCkrcR;;AqC/qcA;EACI,kBAAA;ArCkrcJ;AqCjrcI;EACI,0BAAA;EpCiGL,aoChGmC;ArCmrctC;;AqChrcA;EACI,wBAAA;ArCmrcJ;;AqCjrcA;EACI,kBAAA;EACA,MAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,kDAAA;EACA,cAAA;ArCorcJ;AqCnrcI;EpCiFD,eoChFmC;ArCqrctC;AqCnrcW;EACK,gBAAA;EACA,kBAAA;ArCqrchB;AqCprcgB;EpC2Eb,kBoC1E+C;ArCsrclD;AqCrrcoB;EACI,+BAAA;EACA,eAAA;ArCurcxB;AqCrrcoB;EACI,uBAAA;ArCurcxB;AqCtrcwB;EACI,yBAAA;ArCwrc5B;AqCtrcwB;EACI,8HAAA;ArCwrc5B;AqCrrcoB;EACI,iBAAA;EACA,WAAA;ArCurcxB;AqCrrcoB;EACI,WAAA;EpC8CtB,kBoC7CwC;EpC8CxC,QoC9CkD;EpC+ClD,YoC/CuD;EACjC,UAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;ArCyrcxB;AqCrrcoB;EACI,yBAAA;ArCurcxB;AqCprcgB;EACI,gBlC7DC;EkC8DD,elCyLL;EkCxLK,clCtCZ;AH4tcR;AqCrrcoB;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,+BAAA;ArCurcxB;AqCrrcoB;EACI,WAAA;EACA,iBAAA;ArCurcxB;AqCprcwB;EACI,8HAAA;ArCsrc5B;AqClrcgB;EACI,iBAAA;EACA,wBAAA;EACA,iBAAA;ArCorcpB;AqClrcgB;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,mBAAA;ArCorcpB;AqCjrc4B;EACI,4BAAA;EACA,clCvExB;AH0vcR;AqClrcgC;EACI,YAAA;EACA,kBAAA;ArCorcpC;AqClrcgC;EACI,iBAAA;ArCorcpC;AqClrcgC;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;ArCorcpC;AqClrcgC;EACI,WAAA;EACA,iBAAA;ArCorcpC;AqClrcgC;EACI,clCxG1B;AH4xcV;AqCnrcoC;EACI,8HAAA;ArCqrcxC;AqCjrc4B;EACI,gBAAA;ArCmrchC;AqCjrc4B;EACI,kBAAA;EpCvB7B,UoCwB2D;ArCmrc9D;AqCjrcoC;EACI,qCAAA;EACA,clCzGhC;AH4xcR;AqC9qcwB;EACI,4BAAA;ArCgrc5B;AqC/qc4B;EACI,wBAAA;ArCirchC;AChxcI;EoCnBO;IAwHQ,eAAA;ErC+qcjB;AACF;AqC5qcwB;EACI,aAAA;ArC8qc5B;;AC/ycI;EoC0IA;IACI,aAAA;ErCyqcN;AACF;AC9xcI;EoCwHA;IACI,eAAA;ErCyqcN;EqCvqcE;IACI,aAAA;ErCyqcN;EqCvqcE;IACI,iBAAA;ErCyqcN;EqCxqcM;IACI,aAAA;ErC0qcV;AACF;AsC91cA;EACI,SAAA;EACA,kDAAA;EACA,aAAA;AtCg2cJ;AsC/1cI;EAGI,aAAA;EACA,4BAAA;AtCi2cR;AsCh2cQ;EACI,WAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;ErCkFV,sBqCjF+B;ErC6F9B,SqC5FiC;ErC6FjC,UqC7FoC;EAC3B,gDAAA;EACA,iBAAA;EACA,SAAA;EACA,eAAA;EACA,OAAA;EACA,YAAA;AtCq2cZ;AsCp2cY;ErCsFT,oBqCrF2C;EAC9B,SAAA;AtCs2chB;AsCr2cY;EACR,mBAAA;AtCu2cJ;AsCt2cgB;ErCiFb,YqChF+C;EAC7C,WAAA;EACA,YAAA;AtCw2cL;AsCv2coB;EACI,yBnCfd;AHw3cV;AsCx2cwB;EACjB,+BAAA;AtC02cP;AsCx2cM;EACC,cnCNC;AHg3cR;AsCv2coB;EACd,yBnCxBI;EmCkCc,SAAA;AtCg2cxB;AsCz2cwB;EACjB,+BAAA;AtC22cP;AsCz2cM;EACC,cnCfC;AH03cR;AsCz2cwB;EACI,aAAA;AtC22c5B;AsCv2coB;EACI,aAAA;AtCy2cxB;AsCr2coB;EACA,gBAAA;AtCu2cpB;AsCh2cI;EACI,iBAAA;EACA,iBAAA;EACA,WAAA;AtCk2cR;AsCz1cI;ErC8BD,mBqC7BmC;AtC21ctC;AsCz1cY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ErCqBb,4BqCpB2C;EAC9B,kBAAA;EACA,cnCqCL;AHszcX;AsC11cgB;EACI,WAAA;EACA,cnCkCT;AH0zcX;AsC11cgB;EACI,WAAA;EACA,cnC8BT;AH8zcX;AsC11cgB;EACI,cnCnFV;AH+6cV;AsC31coB;EACI,8HAAA;AtC61cxB;AsC31coB;EACI,cnCxFd;AHq7cV;AsC31coB;EACI,cnC3Fd;AHw7cV;AsC11cgB;EACI,WAAA;ErCblB,kBqCcoC;ErCbpC,QqCa8C;ErCV9C,UqCU+D;EAC7C,2BAAA;EACA,mBnCWT;EmCVS,UAAA;EACA,WAAA;AtC81cpB;AsC51cgB;EACI,cnCvGV;AHq8cV;AsC71coB;EACI,cnCzGd;AHw8cV;AsC71coB;EACI,8HAAA;AtC+1cxB;AsC71coB;EACI,cnC/Gd;AH88cV;AsC51cgB;EACI,cAAA;EACA,enCwHL;EmCvHK,gBnChIC;EmCiID,cnCRT;AHs2cX;AsC51cgB;EACI,qBAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;EACA,enCiHL;EmChHK,iBAAA;ErC5ClB,kBqC6CoC;ErC5CpC,SqC4C6C;ErC3C7C,UqC2CkD;ErClFlD,0BqCmFqC;ErClFrC,kCqCkFqC;ErCjFrC,8BqCiFqC;ErClDrC,yBqCmDsC;AtCo2cxC;AsCn2coB;EACI,WAAA;AtCq2cxB;AsCp2cwB;EACI,WAAA;AtCs2c5B;AsCj2coB;ErC7FlB,wBqC8FyC;ErC7FzC,gCqC6FyC;ErC5FzC,4BqC4FyC;AtCq2c3C;AsC91cwB;EACI,iBAAA;AtCg2c5B;AsCx1cwB;EACI,iBAAA;AtC01c5B;AsCn1coB;ErCxEjB,4BqCyEmD;EAC9B,UAAA;AtCq1cxB;;AsC70cI;EACI,0BAAA;AtCg1cR;;AsC70cA;EACI,kBAAA;AtCg1cJ;;ACl+cI;EqCsJA;IACI,cAAA;EtCg1cN;AACF;AuC1hdA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBpCsBI;EoCrBJ,eAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;AvC4hdJ;AuC1hdI;EACI,8CAAA;EACA,uBAAA;EACA,g3OAAA;EACA,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,UAAA;EtC+GN,yBsC9GgC;EtC+GhC,iCsC/GgC;EtCgHhC,6BsChHgC;EtC0GhC,mBsCzGuB;AvC8hdzB;;AuC3hdA;EACI;IAAI,YAAA;EvC+hdN;AACF;AuCjhdA;EACI;IAEI,uBAAA;EvC6hdN;EuC1hdE;IAEI,wBAAA;EvC4hdN;AACF;AwCnldA;EAGI,aAAA;EACA,yBrC4BI;EqC3BJ,mCAAA;EACA,aAAA;EACA,aAAA;EvC6FF,euC5FoB;EvC6FpB,SuC7F0B;EvC+F1B,SuC/FoC;EvCgGpC,OuChGsC;EvCwFtC,yBuCvFsB;EACpB,+BAAA;EACA,YAAA;AxC0ldJ;ACnjdI;EuClDJ;IAaQ,mBAAA;IvCmFN,yBuClF0B;IACpB,aAAA;IACA,mBrCgBA;EH8kdN;AACF;AC7jdI;EuClDJ;IAmBQ,WAAA;ExCgmdN;AACF;AwC/ldI;EACI,mBrCUA;EqCTA,mCAAA;AxCimdR;ACtkdI;EuC7BA;IAIQ,sBAAA;ExCmmdV;AACF;AwCjmdI;EvCiFD,auChFmC;AxCmmdtC;AwC/ldY;EACI,mBAAA;AxCimdhB;AwC/ldoB;EACI,crCLhB;AHsmdR;AwC/ldoB;EACI,cAAA;AxCimdxB;AwC9ldgB;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AxCgmdpB;AwC9ldgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EvCsDjB,kBuCrD+C;EAC9B,kBAAA;EACA,crCtCR;AHsodZ;AwC/ldoB;EACI,cAAA;AxCimdxB;AwC/ldoB;EACI,WAAA;EACA,cAAA;AxCimdxB;AwC/ldoB;EACI,oCAAA;EACA,cAAA;EACA,kBAAA;AxCimdxB;AwChmdwB;EACI,iGAAA;AxCkmd5B;AwChmdwB;EACI,cAAA;AxCkmd5B;AwChmdwB;EACI,cAAA;AxCkmd5B;AwC/ldoB;EACI,oCAAA;EACA,cAAA;EACA,kBAAA;AxCimdxB;AwChmdwB;EACI,crCrDpB;AHupdR;AwChmdwB;EACI,iGAAA;AxCkmd5B;AwChmdwB;EACI,cAAA;AxCkmd5B;AwChmdwB;EACI,mBAAA;AxCkmd5B;AwCjmd4B;EACI,qBAAA;AxCmmdhC;AwC/ldoB;EACI,erCyJT;EqCxJS,gBrC/FH;EqCgGG,crCyBb;AHwkdX;AwC7ldoB;EACI,oCAAA;EACA,kBAAA;AxC+ldxB;AwC9ldwB;EACI,iGAAA;AxCgmd5B;AwC9ldwB;EACI,cAAA;AxCgmd5B;AwC3ldoB;EACI,iDAAA;EvCXrB,euCYmD;EAC9B,aAAA;AxC6ldxB;AwC3ld4B;EACG,gBrCtHV;EqCuHU,erC7Hd;EqC8Hc,crC3GnB;EqC4GmB,kBAAA;EACA,cAAA;EvCpB5B,yBuCqB0D;AxC6ld7D;AwC5ld+B;EACI,crChHvB;AH8sdZ;AwC7ldmC;EACC,mBAAA;EACA,sBAAA;AxC+ldpC;AwC5ld+B;EACC,WAAA;EACA,kCAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EvCX9B,mBuCY+C;EvC5C/C,kBuC6CgD;EvC5ChD,SuC4CyD;EvCzCzD,UuCyCwE;AxCgmd1E;AwC9ld+B;EACI,crClIzB;AHkudV;AwC/ldmC;EACC,mBAAA;EACA,sBAAA;AxCimdpC;AwCzldoB;EACI,gCAAA;EvCnDrB,mBuCoDmD;EAC9B,cAAA;AxC2ldxB;AwCzld4B;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBrCpKX;EqCqKW,erCkFjB;EqCjFiB,cAAA;EACA,kBAAA;EACA,WAAA;EvClE7B,4BuCmE2D;AxC2ld9D;AwC1ld+B;EACC,mBAAA;EACA,erClLf;EqCmLe,crCjBnB;AH6mdb;AwC1ld+B;EACI,crCrKzB;AHiwdV;AwC1lduC;EACK,crCxKlC;AHowdV;AwCzldmC;EACC,mBAAA;EACA,sBAAA;AxC2ldpC;AwCxld+B;EACI,crCjLzB;AH2wdV;AwCzldmC;EACC,mBAAA;EACA,sBAAA;AxC2ldpC;AwCzldmC;EACK,crCvL9B;AHkxdV;AwCpldwB;EACI,oCAAA;EACA,kBAAA;EACA,cAAA;AxCsld5B;AwCrld4B;EACI,crCnMtB;AH0xdV;AwClldoB;EACI,gBrCnND;EqCoNC,erC3NP;EqC4NO,cAAA;EACA,kBAAA;AxColdxB;AwCjldwB;EACI,aAAA;AxCmld5B;AwC/kdwB;EAEI,SAAA;EACA,cAAA;EACA,iBAAA;AxCgld5B;AwCzkdoB;EACI,cAAA;AxC2kdxB;AwCzkdoB;EACI,cAAA;AxC2kdxB;AwCtkdwB;EACI,oCAAA;EACA,cAAA;EACA,kBAAA;AxCwkd5B;AwCvkd4B;EACI,cAAA;AxCykdhC;AwCvkd4B;EACI,mBAAA;AxCykdhC;AwCxkdgC;EACI,qBAAA;AxC0kdpC;AwClkdwB;EACI,uBAAA;AxCokd5B;AwC3jdY;EACI,gBAAA;AxC6jdhB;AwC5jdgB;EACI,mBAAA;EACA,iBAAA;AxC8jdpB;AwCvjd4B;EACI,iBAAA;AxCyjdhC;AwCljdgC;EACI,iBAAA;AxCojdpC;AwC5idwB;EACA,iBAAA;EACA,mBAAA;EACA,erCpTP;EqCqTO,crCjJZ;AH+rdZ;AwC7idwB;EACI,WAAA;EACA,kCAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EvCxL1B,mBuCyL2C;EvCzN3C,kBuC0N4C;EvCzN5C,SuCyNqD;EvCtNrD,OuCsNoE;AxCijdtE;AwC/id4B;EACI,crC/StB;AHg2dV;AwChjdgC;EACA,mBAAA;EACA,sBAAA;AxCkjdhC;AwC1idQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,oBAAA;EACA,iBAAA;EACA,erCxFG;EqCyFH,iBAAA;EACA,kCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EvCzPV,kBuC0P4B;EvCzP5B,SuCyPqC;EvCxPrC,WuCwP0C;EvC/R1C,0BuCgS6B;EvC/R7B,kCuC+R6B;EvC9R7B,8BuC8R6B;EvC/P7B,yBuCgQ8B;AxCkjdhC;AwCjjdY;EACI,WAAA;EACA,UAAA;EACA,aAAA;EACA,WAAA;EACA,cAAA;EACA,+BAAA;EACA,gCAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;AxCmjdhB;AwCjjdY;EACI,WAAA;AxCmjdhB;AwCljdgB;EACI,WAAA;AxCojdpB;AwC/idY;EvCvTV,wBuCwTiC;EvCvTjC,gCuCuTiC;EvCtTjC,4BuCsTiC;EACnB,mBAAA;AxCmjdhB;AwC/idI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EvCxRL,auCyRmC;EAC9B,crCnXI;EqCoXJ,kBAAA;AxCijdR;AwChjdQ;EACI,crCxXF;EqCyXE,uBAAA;EACA,kBAAA;AxCkjdZ;AwCjjdY;EACI,WAAA;EACA,kBAAA;EACA,yDAAA;EACA,mBAAA;EvC7Sd,kBuC8SgC;EvC7ShC,SuC6SyC;EvC5SzC,QuC4S8C;AxCqjdhD;AwChjdI;EACI,YAAA;EvCxQN,4CAAA;AD6zdF;AwCljdI;EACI,YAAA;EACA,YAAA;EvC7TN,yBuC8T0B;EACpB,aAAA;AxCsjdR;ACn6dI;EuCyWA;IAMQ,wBAAA;ExCwjdV;AACF;AwCvjdQ;EACI,uBAAA;EACA,4BAAA;AxCyjdZ;AC56dI;EuCiXI;IAIQ,sBAAA;ExC2jdd;AACF;AwCzjdQ;EvC7TL,uBuC8TuC;AxC2jd1C;ACp7dI;EuCwXI;IvC7TL,auCgU0C;ExC6jd3C;AACF;AwC3jdQ;EACI,erCxLG;EqCyLH,crCnTD;EqCoTC,yBAAA;EACA,gBrC3aO;EqC4aP,mBAAA;AxC6jdZ;AwC3jdQ;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AxC6jdZ;AwC1jdoB;EACI,iEAAA;EACA,crC/ZhB;AH29dR;AwCzjdgB;EACI,gBrC7bC;EqC8bD,erCncH;EqCocG,crCjbR;AH4+dZ;AwC1jdoB;EACI,crCrbd;AHi/dV;AwCvjdQ;EAGI,2BAAA;EACA,qBAAA;EACA,kCAAA;EACA,oBAAA;EACA,iBAAA;EACA,erCpNG;EqCqNH,mCAAA;EACA,kCAAA;EACA,iBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBrCjdO;EFsDjB,0BuC4Z6B;EvC3Z7B,kCuC2Z6B;EvC1Z7B,8BuC0Z6B;AxC2jd/B;AwC1jdY;EACI,gBAAA;AxC4jdhB;AwCvjdI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AxCyjdR;AwCrjdY;EvChbV,wBuCibiC;EvChbjC,gCuCgbiC;EvC/ajC,4BuC+aiC;AxCyjdnC;AwCpjdQ;EAGI,aAAA;EAEA,sBAAA;EvCtXV,gBuCuX2B;EACjB,gCAAA;EvC/YT,euCgZuC;EvC7ZxC,yBuC8Z8B;AxCwjdhC;AwCvjdY;EACI,qCAAA;EACA,crCjeR;AH0heR;AwCvjdY;EACI,gBAAA;EACA,gBrC9fK;AHujerB;AwCnjdQ;EACI,WAAA;EACA,gBrCtgBS;EqCugBT,cAAA;EvC1YV,kBuC2Y2B;EvCna1B,gBuCoakC;EvCnalC,auCma4C;AxCsjd/C;AwCrjdY;EACI,iEAAA;EACA,crCnfR;AH0ieR;AwCtjdgB;EACI,crCrfZ;AH6ieR;AwCrjdY;EACI,iBAAA;AxCujdhB;;AwChjdQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,mBrC1hBF;EqC2hBE,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,crCjhBJ;EqCkhBI,eAAA;AxCmjdZ;AwCljdY;EACI,yBAAA;AxCojdhB;AwCljdY;EACI,mBrCpiBA;AHwlehB;AwCjjdQ;EACI,+BAAA;AxCmjdZ;;ACnleI;EuCuiBI;IACI,iBAAA;ExCgjdV;EwC7idU;IACI,UAAA;ExC+idd;EwC9idc;IACG,SAAA;ExCgjdjB;EwC1idc;IACI,UAAA;ExC4idlB;EwCxidM;IACI,aAAA;ExC0idV;EwCnid0B;IACI,aAAA;ExCqid9B;EwClidsB;IACI,aAAA;ExCoid1B;EwClidsB;IACI,eAAA;ExCoid1B;EwC9hdM;IACI,WAAA;IACA,gBAAA;ExCgidV;EwC9/cE;IAGI,aAAA;IACA,mBAAA;IACA,yBAAA;IACA,sBAAA;IACA,uBAAA;IACA,+BAAA;IACA,qBAAA;IACA,WAAA;IACA,iBAAA;ExCggdN;AACF;AwC5/cQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBrCjqBS;EqCkqBT,erC3aG;EqC4aH,cAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;AxC8/cZ;AwCz/cY;EACI,qBAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;AxC2/chB;;AwCp/cI;EACI,cAAA;AxCu/cR;;AwCn/cI;EACI,cAAA;AxCs/cR;;AwCn/cA;EACI,aAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,oCAAA;EvCvmBF,euCwmBoB;EvCvmBpB,SuCumB0B;EvCpmB1B,OuComByC;AxCw/c3C;AwCv/cI;EACI,cAAA;AxCy/cR;;AwCr/cI;EACI,YAAA;AxCw/cR;AwCt/cI;EACI,SAAA;AxCw/cR;AwCr/cQ;EvC1pBN,yBuC2pB6B;EvC1pB7B,iCuC0pB6B;EvCzpB7B,6BuCypB6B;AxCy/c/B;;AwCp/cI;EACI,wBAAA;AxCu/cR;;AwCn/cI;EACI,yBAAA;AxCs/cR;;AwCn/cA;EACI,yBAAA;AxCs/cJ;;AwC9+cgB;EACI,mBrC5kBV;AH6jeV;;AyCnueA;EACI,gCAAA;EACA,kBAAA;EACA,etCwPW;EsCvPX,YAAA;EACA,iBAAA;ExCwGD,ewCvG+B;AzCsuelC;AyCrueI;EACI,ctC0HG;EsCzHH,cAAA;EACA,WAAA;EACA,etCVS;AHivejB;AyCrueI;EACI,ctCkFK;EsCjFL,YAAA;EACA,etC0OO;EsCzOP,yBAAA;AzCuueR;;AyCnueI;EACI,aAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AzCsueR;AyCpueI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;AzCsueR;AyCrueQ;EACI,aAAA;EACA,gCAAA;EACA,etCjCK;AHwwejB;AyCtueY;EACI,cAAA;ExCyEb,awCxE2C;ExC+F5C,kBwC9F+B;AzCwuejC;AyCtueY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;AzCwuehB;AyCvuegB;EACI,kBAAA;AzCyuepB;AyCtueY;EACI,ctCgFL;EsC/EK,gBtC5CK;AHoxerB;AyCtueY;EACI,ctCyEL;EFnBR,SwCrDqC;AzCwuexC;AyCtueY;ExCmDT,SwClDqC;AzCwuexC;AyCtueY;EACI,etC8LD;EsC7LC,iBAAA;EACA,ctCiEL;AHuqeX;AyCtueY;EACI,SAAA;EACA,UAAA;EACA,kBAAA;AzCwuehB;AyCvuegB;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AzCyuepB;AyCvuegB;ExCmCb,mBwClC+C;AzCyuelD;AyCxueoB;EACI,ctCqDb;EsCpDa,WAAA;EACA,gBtCxEH;EsCyEG,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AzC0uexB;AyCxueoB;EACI,ctCwCb;EsCvCa,YAAA;EACA,etCgKT;AH0kef;AyCxueoB;EACI,ctCqCb;EsCpCa,etC8JT;EsC7JS,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AzC0uexB;;AyCnueA;EACI,6BAAA;EACA,etC+IW;EsC9IX,YAAA;EACA,iBAAA;ExCDD,ewCE+B;AzCsuelC;AyCrueI;EACI,cAAA;EACA,kBAAA;EACA,ctCeG;AHwteX;;AyCpueA;EACI,YAAA;EACA,kBAAA;EACA,WAAA;AzCuueJ;;AyCrueA;ExCdG,mBwCe+B;AzCwuelC;AyCvueI;EACI,ctCIG;EsCHH,WAAA;EACA,gBtCzHa;EsC0Hb,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AzCyueR;AyCvueI;EACI,ctCTG;EsCUH,YAAA;EACA,etC+GO;AH0nef;AyCvueI;EACI,ctCZG;EsCaH,etC6GO;EsC5GP,cAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AzCyueR;;AyCtueA;EACI,WAAA;AzCyueJ;AyCxueI;EACI,kBAAA;AzC0ueR;AyCxueI;EACI,gBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;AzC0ueR;AyCzueQ;EACI,yBtClIJ;EsCmII,kBAAA;EACA,yBAAA;ExCxDT,gBwCyDiC;ExCxDjC,uBwCwD6C;EACpC,etCwFG;AHopef;AyC3ueY;EACI,YAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;ExCvEd,kBwCwEgC;ExCvEhC,SwCuEyC;ExCpEzC,SwCoEwD;AzC+ue1D;AyC7ueY;EACI,yBtC/IR;EsCgJQ,kBAAA;ExCpEb,kBwCqEqC;ExCpErC,UwCoEiD;AzCgvepD;AyC9ueY;EACI,ctCrDL;EsCsDK,cAAA;EACA,etCqED;EsCpEC,iBAAA;AzCgvehB;AyC9ueY;EACI,ctCzJR;AHy4eR;AyC9ueY;EACI,ctCzKJ;EsC0KI,gBtCtLO;EsCuLP,etC+DD;AHiref;AyC/uegB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AzCivepB;;A0Cp7eA;EACE,aAAA;A1Cu7eF;;A0Cr7eA;EzCiGE,eyChGoB;EzCiGpB,QyCjG0B;EzCkG1B,QyClG8B;EzC2D9B,2ByC1DqB;EzC2DrB,mCyC3DqB;EzC4DrB,+ByC5DqB;EACnB,mBvCmCK;EuClCL,gCAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EAEA,eAAA;EzC2EF,yByC1EsB;A1C87exB;A0C77eI;EACI,mBvC4IM;AHmzed;A0C57eQ;EACI,iDAAA;A1C87eZ;A0C77eY;EACI,gBAAA;A1C+7ehB;A0C77eY;EACI,YAAA;EACA,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;A1C+7ehB;A0C97egB;EACI,cvCdZ;EuCeY,WAAA;EACA,YAAA;A1Cg8epB;;A0C17eA;EACI,YAAA;EACA,yBvCxBI;EFoEN,eyC3CoB;EzC4CpB,MyC5C0B;EzC6C1B,ayC7C4B;EAC1B,aAAA;EACA,oCAAA;EACA,aAAA;EACA,kBAAA;EACA,wBAAA;EACA,qBAAA;EACA,kBAAA;EzCgCF,yByC/BsB;A1Ci8exB;A0Ch8eI;EACI,QAAA;EzC6BN,yByC5B0B;EACpB,wBAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;A1Co8eR;;A0Cj8eA;EACI,gBAAA;EACA,WAAA;EzCuBF,kByCtBoB;EzCuBpB,MyCvB6B;EzCwB7B,QyCxB+B;EAC7B,mBvC/CI;EuCgDJ,aAAA;EACA,kBAAA;A1Cs8eJ;A0Cr8eI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EzCkBL,ayCjBmC;EAC9B,gBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,yBvChFE;AHuhfV;A0Ct8eQ;EACI,evC6JG;EuC5JH,cvCrEJ;EuCsEI,gBvC7FO;EuC8FP,gBAAA;EACA,yBAAA;A1Cw8eZ;AC9/eI;EyCiDI;IAOQ,evCsJD;EHozeb;AACF;A0Cx8eQ;EACI,cvC9EJ;AHwhfR;A0Cx8eQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cvC9FJ;AHwifR;A0Cz8eY;EACI,WAAA;EACA,YAAA;EACA,cvClGR;AH6ifR;A0Cv8eI;EACI,mBAAA;A1Cy8eR;A0Cx8eQ;EACI,cvC0BC;EuCzBD,gBvCjIO;EuCkIP,evCqHG;AHq1ef;A0Cv8eI;EzCjCD,ayCkCmC;A1Cy8etC;A0Cx8eQ;EACI,evC+GG;EuC9GH,gBvCzIO;EuC0IP,cvCnBD;EuCoBC,mBAAA;A1C08eZ;;A0Ct8eA;EACI,gCAAA;EzC7CD,gByC8CyB;EzC7CzB,iByC6CmC;A1C08etC;A0Cz8eI;EAGI,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A1C28eR;A0C18eQ;EACI,0BAAA;A1C48eZ;A0C18eQ;EACI,0BAAA;A1C48eZ;A0C18eQ;EACI,mBvC3CD;EuC4CC,evCqFG;EuCpFH,cvC1IJ;EuC6II,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EzCpET,kByCqEuC;EAC9B,eAAA;A1C48eZ;A0C38eY;EACI,oCAAA;A1C68ehB;A0C38eY;EACI,mBvC/IP;EuCgJO,cvCzJR;AHsmfR;A0C58egB;EACI,+BAAA;A1C88epB;;A0Cx8eA;EACI,mBAAA;A1C28eJ;A0Cz8eQ;EACI,mBvCpKJ;EuCqKI,WAAA;EACA,YAAA;A1C28eZ;A0C18eY;EACI,WAAA;EACA,YAAA;EACA,UAAA;A1C48ehB;A0Cv8eQ;EACI,gBAAA;A1Cy8eZ;A0Ct8eI;EACI,evC0CO;EuCzCP,cvCrLA;AH6nfR;;A0Cr8eA;EACI,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;A1Cw8eJ;;A0Ct8eA;EzCpHG,gByCwHyB;EzCvHzB,UyCuHkC;A1Cu8erC;A0C18eI;EACI,oBAAA;A1C48eR;A0Cv8eY;EACI,kBAAA;EACA,eAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;A1Cy8ehB;A0Cx8egB;EACI,kBAAA;EACA,yBAAA;A1C08epB;A0Cx8egB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,cvC5FP;EuC6FO,gBvCvPD;EuCwPC,evChQH;EuCiQG,gBAAA;EACA,kBAAA;A1C08epB;A0Cz8eoB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,mDAAA;EACA,cAAA;EACA,iBAAA;EACA,kBAAA;A1C28exB;A0Cr8eoB;EACI,qBvChQd;AHusfV;A0Cp8ewB;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBvCxQlB;EuCyQkB,kBAAA;EACA,SAAA;A1Cs8e5B;;AChrfI;EyCkPJ;IAEQ,aAAA;E1Ci8eN;AACF;;A0C/7eA;EACI,gBAAA;EACA,aAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,yBvC/QI;EuCgRJ,sDAAA;EACA,YAAA;A1Ck8eJ;;A2C/ufgB;EACI,eAAA;EACA,mBAAA;A3CkvfpB;A2C7ufI;EACI,YAAA;EACA,kBAAA;A3C+ufR;A2C9ufQ;EACI,aAAA;EACA,WAAA;EACA,YAAA;A3CgvfZ;A2C9ufQ;EACI,WAAA;A3CgvfZ;A2C9ufQ;EACI,uBAAA;A3CgvfZ;A2C/ufY;EACI,gBAAA;A3CivfhB;A2C/ufY;EACI,4BAAA;A3CivfhB;AC3tfI;E0ClBQ;IACI,UAAA;IACA,WAAA;E3Cgvfd;E2C9ufU;IACI,UAAA;E3Cgvfd;E2C9ufU;IACI,sBAAA;E3Cgvfd;E2C/ufc;IACI,4BAAA;E3CivflB;AACF;AC1ufI;E0CHQ;IACI,UAAA;IACA,WAAA;E3Cgvfd;E2C9ufU;IACI,UAAA;E3Cgvfd;E2C9ufU;IACI,sBAAA;E3Cgvfd;E2C/ufc;IACI,4BAAA;E3CivflB;AACF;ACzvfI;E0CaQ;IACI,OAAA;IACA,QAAA;E3C+ufd;E2C7ufU;IACI,OAAA;E3C+ufd;E2C7ufU;IACI,SAAA;E3C+ufd;E2C9ufc;IACI,mBAAA;E3CgvflB;AACF;;A2CzufQ;EACI,mBxC0CD;AHksfX;A2CxufQ;EACI,mBxCmFD;AHupfX;A2CvufI;EACI,aAAA;A3CyufR;A2CxufQ;EACI,cAAA;A3C0ufZ;A2CzufY;EACI,eAAA;A3C2ufhB;A2CzufoB;EACI,uBAAA;A3C2ufxB;AC3xfI;E0CwCA;IAcQ,cAAA;E3CyufV;E2CxufU;IACI,aAAA;E3C0ufd;AACF;;A2C1tfI;EACI,aAAA;A3C6tfR;A2C5tfQ;EACI,cAAA;A3C8tfZ;AC1yfI;E0CyEA;IAMQ,cAAA;E3C+tfV;E2C9tfU;IACI,aAAA;E3Cgufd;AACF;A2C9tfQ;EACI,cxCrHF;AHq1fV;A2C7tfI;EACI,cAAA;EACA,kBAAA;A3C+tfR;A2C7tfI;EACI,aAAA;A3C+tfR;A2C5tfQ;EACI,8BAAA;A3C8tfZ;A2C1tfgB;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;A3C4tfpB;A2CrtfY;EACI,aAAA;A3CutfhB;A2CrtfY;EACI,MAAA;EACA,aAAA;A3CutfhB;A2CrtfY;EACI,iBAAA;A3CutfhB;AC90fI;E0C6HQ;IACI,aAAA;E3Cotfd;E2CjtfM;IACI,iBAAA;E3CmtfV;AACF;;A2C9sfI;EACI,kBAAA;A3CitfR;A2ChtfQ;EACI,aAAA;A3CktfZ;A2C/sfI;EACI,aAAA;A3CitfR;A2ChtfQ;EACI,cAAA;EACA,mBxC1BD;EwC2BC,aAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;A3CktfZ;A2CjtfY;E1C5FT,e0C6F2C;A3Cmtf9C;A2CjtfmB;EACK,gBAAA;EACA,kBAAA;A3CmtfxB;A2CltfwB;E1ClGrB,kB0CmGuD;A3Cotf1D;A2Cntf4B;EACI,+BAAA;EACA,eAAA;A3CqtfhC;ACt3fI;E0C6JoB;I1ClGrB,iB0CyG2D;E3Cstf5D;AACF;A2Crtf4B;EACI,uBAAA;A3CutfhC;A2CttfgC;EACI,yBAAA;A3CwtfpC;A2CttfgC;EACI,8HAAA;A3CwtfpC;A2Crtf4B;EACI,iBAAA;EACA,WAAA;A3CutfhC;A2Crtf4B;EACI,WAAA;E1ClI9B,kB0CmIgD;E1ClIhD,Q0CkI0D;E1CjI1D,Y0CiI+D;EACjC,UAAA;EACA,YAAA;EACA,mBAAA;EACA,2BAAA;A3CytfhC;A2Crtf4B;EACI,yBAAA;A3CutfhC;A2CptfwB;EACI,gBxC7OP;EwC8OO,exCSb;EwCRa,cxCtNpB;AH46fR;A2Crtf4B;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;EACA,+BAAA;A3CutfhC;ACj6fI;E0CqMwB;IAOQ,iBAAA;E3CytflC;AACF;A2Cvtf4B;EACI,WAAA;EACA,iBAAA;A3CytfhC;A2CttfgC;EACI,+BAAA;A3CwtfpC;A2CptfwB;EACI,iBAAA;EACA,wBAAA;EACA,iBAAA;A3Cstf5B;A2CptfwB;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;A3Cstf5B;A2CntfoC;EACI,4BAAA;EACA,cxC1PhC;AH+8fR;A2ChtfwD;EACI,cxC9QlD;AHg+fV;A2C5sfwC;EACI,YAAA;EACA,kBAAA;A3C8sf5C;A2C5sfwC;EACI,iBAAA;A3C8sf5C;A2C5sfwC;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,iBAAA;A3C8sf5C;A2C5sfwC;EACI,WAAA;EACA,iBAAA;A3C8sf5C;A2C5sfwC;EACI,cxCtSlC;AHo/fV;A2C7sf4C;EACI,8HAAA;A3C+sfhD;A2C3sfoC;EACI,gBAAA;A3C6sfxC;A2C3sfoC;EACI,kBAAA;E1CrNrC,U0CsNmE;A3C6sftE;A2C3sf4C;EACI,qCAAA;EACA,cxCvSxC;AHo/fR;A2CxsfgC;EACI,4BAAA;A3C0sfpC;A2CzsfoC;EACI,wBAAA;A3C2sfxC;ACx+fI;E0C0Je;IAyIQ,eAAA;E3CysfzB;AACF;A2CtsfgC;EACI,aAAA;A3CwsfpC;A2CjsfoB;EACI,yBAAA;A3CmsfxB;A2ChsfwB;EACI,yBAAA;A3Cksf5B;A2C5rfwB;EACI,2HAAA;A3C8rf5B;A2C3rfoB;EACI,cxClPb;AH+6fX;A2CvrfY;EACI,uBAAA;A3CyrfhB;A2CrrfI;EACI,cAAA;EACA,cAAA;A3CurfR;A2CtrfQ;EACI,iBAAA;EACA,yBAAA;EACA,mBxClWJ;EwCmWI,mBAAA;EACA,oBAAA;A3CwrfZ;AC1ggBI;E0C6UI;IAOQ,gBAAA;E3C0rfd;AACF;;A2CrrfI;EACI,mBxCnOG;EwCoOH,gCAAA;A3CwrfR;A2CvrfQ;EACI,+BAAA;EACA,gCAAA;A3CyrfZ;A2CxrfY;EACI,aAAA;A3C0rfhB;A2CxrfY;EACI,yBAAA;A3C0rfhB;A2CtrfY;EACI,cxC9OF;EwC+OE,qBxClPL;EwCmPK,mBxC/OL;AHu6fX;A2CvrfgB;EACI,cxChST;AHy9fX;A2ClrfY;EACI,wBAAA;A3CorfhB;A2ClrfY;EACI,yBAAA;A3CorfhB;A2ChrfY;EACI,wBAAA;A3CkrfhB;A2ChrfY;EACI,yBAAA;A3CkrfhB;A2C7qfQ;EACI,yBAAA;A3C+qfZ;A2C3qfQ;EACI,cxChRE;AH67fd;A2C1qfI;EACI,cxCpRM;AHg8fd;A2CxqfY;EACI,mBxCxRL;AHk8fX;A2CpqfY;EACI,yBAAA;A3CsqfhB;A2ClqfI;EACI,+BAAA;EACA,yBxCzSG;AH68fX;A2CnqfQ;EACI,mBxC3SD;AHg9fX;A2CjqfgB;EACI,mBxChTT;EwCiTS,kBAAA;EACA,eAAA;A3CmqfpB;A2CjqfwB;EACI,cxChWjB;AHmggBX;A2C9pfoB;EACI,2HAAA;A3CgqfxB;A2C9pfoB;EACI,cxCzWb;AHyggBX;A2C7pfwB;EACI,cxC7WjB;AH4ggBX;A2C7pfwB;EACI,2HAAA;A3C+pf5B;A2C3pfgB;EACI,cxCrXT;AHkhgBX;;A2CtpfI;EACI,mBxChYG;AHyhgBX;A2CxpfQ;EACI,mBxC9dJ;AHwngBR;A2CvpfI;EACI,mBxCtYG;AH+hgBX;A2CvpfI;EACI,qBxCzYG;EwC0YH,mBxCteA;AH+ngBR;;A2CjpfoB;EACI,4BAAA;A3CopfxB;A2CnpfwB;EACI,WAAA;EACA,UAAA;A3Cqpf5B;A2CnpfwB;EACI,UAAA;EACA,WAAA;A3Cqpf5B;A2ChpfY;EACI,kBAAA;EACA,cAAA;A3CkpfhB;A2C9ofI;EACI,cAAA;A3CgpfR;A2C/ofQ;EACI,8BAAA;EACA,0BAAA;A3CipfZ;A2C/ofQ;EACI,+BAAA;EACA,yBAAA;A3CipfZ;A2C9ofY;EACI,YAAA;EACA,8BAAA;A3CgpfhB;A2C/ofgB;EACI,WAAA;EACA,WAAA;A3CipfpB;ACvqgBI;E0CyhBgB;IACI,YAAA;IACA,exClTT;IwCmTS,iBAAA;IACA,kBAAA;IACA,cAAA;E3CipftB;E2ChpfsB;IACI,qBAAA;IACA,WAAA;E3Ckpf1B;E2Cjpf0B;IACI,yBxC9hBxB;IwC+hBwB,cAAA;IACA,YAAA;IACA,WAAA;IACA,WAAA;I1Ctd7B,e0CudqD;I1C/btD,mB0Cgc+C;E3Cmpf/C;E2Clpf8B;IACI,WAAA;E3CopflC;AACF;A2C5ofgB;EACI,iBAAA;EACA,kBAAA;A3C8ofpB;A2Czof4B;EACI,yBAAA;A3C2ofhC;AChrgBI;E0CoiBwB;IAGQ,gBAAA;IACA,kBAAA;E3C6oflC;AACF;A2C5ofgC;EACI,eAAA;EACA,iBAAA;A3C8ofpC;A2C5ofgC;EACI,WAAA;EACA,SAAA;A3C8ofpC;A2CnofoC;EACI,6FAAA;A3CqofxC;A2CjofoC;EACI,eAAA;EACA,iBAAA;A3CmofxC;A2C3nfY;EACI,mBAAA;A3C6nfhB;A2C5nfgB;EACI,UAAA;EACA,WAAA;A3C8nfpB;A2C5nfgB;EACI,iBAAA;EACA,eAAA;A3C8nfpB;A2CxnfwB;EACI,gBAAA;EACA,eAAA;A3C0nf5B;A2CpnfQ;EACI,QAAA;EACA,UAAA;A3CsnfZ;A2CpnfgB;EACI,UAAA;EACA,WAAA;A3CsnfpB;A2ClnfwB;EACI,iBAAA;EACA,eAAA;A3Conf5B;A2C5mfgC;EACI,kBAAA;EACA,cAAA;EACA,4BAAA;A3C8mfpC;A2C7mfoC;EACI,QAAA;EACA,UAAA;A3C+mfxC;A2CtmfQ;EACI,mBAAA;A3CwmfZ;A2CtmfQ;EACI,OAAA;EACA,WAAA;EACA,8BAAA;A3CwmfZ;A2CtmfQ;EACI,YAAA;EACA,WAAA;A3CwmfZ;A2CvmfY;EACI,OAAA;EACA,WAAA;A3CymfhB;A2CvmfY;EACI,OAAA;EACA,WAAA;A3CymfhB;A2CpmfgC;EACI,WAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;A3CsmfpC;A2C/lfoC;EACI,WAAA;EACA,UAAA;EACA,UAAA;A3CimfxC;A2CvlfY;EACI,kBAAA;EACA,cAAA;A3CylfhB;A2CtlfQ;EACI,iBAAA;A3CwlfZ;A2CtlfQ;EACI,iBAAA;EACA,eAAA;A3CwlfZ;A2CllfwB;EACI,gBAAA;EACA,eAAA;A3Colf5B;A2C9kfQ;;;;;EAKI,sBAAA;EACA,sBAAA;A3CglfZ;A2C9kfQ;;;;;EAKI,sBAAA;EACA,sBAAA;A3CglfZ;A2C9kfQ;EACI,kBAAA;EACA,mBAAA;A3CglfZ;ACl0gBI;E0CuvBQ;IACI,kBAAA;E3C8kfd;AACF;A2C3kfI;EACI,kBAAA;EACA,cAAA;A3C6kfR;A2C3kfI;EACI,iBAAA;EACA,eAAA;A3C6kfR;A2C3kfI;EACI,OAAA;EACA,WAAA;A3C6kfR;;A2CxkfI;EACI,aAAA;A3C2kfR;;A2CrkfQ;EACI,gBAAA;A3CwkfZ;;A2ClkfQ;EACI,exCpjBG;AHyngBf;A2CpkfY;EACI,mBxC3xBP;AHi2gBT;;A2C/jfQ;EACI,gBAAA;A3CkkfZ;;A2C3jfG;EACC,kBAAA;EACY,qBAAA;A3C8jfhB;A2C3jfgB;EACI,kBAAA;EACA,qBAAA;A3C6jfpB;;A2CpjfG;EACC,cxCvzBI;AH82gBR;;AAx1gBA,oBAAA;A4CrDI;EACF,qCAAA;A5Ci5gBF;A4C94gBQ;EACI,czC6JC;AHmvgBb;A4C54gBI;EAGI,aAAA;EAGA,mBAAA;A5C84gBR;A4C54gBI;EACI,iBAAA;A5C84gBR;A4C54gBI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A5C84gBR;A4C54gBI;EACI,cAAA;A5C84gBR;A4C54gBI;EACI,kBAAA;A5C84gBR;A4C54gBI;EACI,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;A5C84gBR;A4C34gBI;EACI,kBAAA;EACA,QAAA;EACA,aAAA;EACA,UAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;EAGA,6BAAA;A5C64gBR;A4C34gBI;EACI,kBAAA;EACA,YAAA;A5C64gBR;A4C34gBI;EACI,kBAAA;EACA,YAAA;A5C64gBR;A4C34gBI;EACI,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;A5C64gBR;A4C34gBI;EAGI,aAAA;EAGA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;A5C64gBR;A4C34gBI;EACI,UAAA;EACN,aAAA;EACA,mBAAA;A5C64gBF;A4C34gBI;EACI,mBAAA;A5C64gBR;A4C34gBI;EACI,ezCyJO;EyCxJP,cAAA;A5C64gBR;A4C14gBI;EACI,kBAAA;EACA,qBAAA;EACA,qBAAA;A5C44gBR;A4C14gBI;EACI,aAAA;A5C44gBR;A4C14gBI;EACI,iBAAA;A5C44gBR;A4C14gBI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A5C44gBR;A4Cz4gBE;EACC,UAAA;A5C24gBH;A4Cz4gBE;EACC,iBAAA;A5C24gBH;AC79gBI;E2CiFF;IAGE,cAAA;E5C64gBF;AACF;A4C34gBE;EACC,aAAA;EACA,gCAAA;EACA,gBAAA;A5C64gBH;A4C14gBG;EACC,ezCgHW;EyC/GX,czC7HQ;EyC8HR,gBzCzIe;AHqhhBnB;A4Cz4gBE;EACC,sCAAA;A5C24gBH;A4Cz4gBE;EACC,ezCoGY;EyCnGZ,eAAA;EACA,iBAAA;EACA,gBzCrJkB;EyCsJlB,cAAA;A5C24gBH;A4Cz4gBE;EACC,ezC+FY;EyC9FZ,cAAA;A5C24gBH;A4Cx4gBE;EACC,YAAA;EACA,ezC0FY;EyCzFZ,cAAA;A5C04gBH;A4Cv4gBE;EACC,gBAAA;EACA,cAAA;A5Cy4gBH;A4Ct4gBE;;;EAGC,yBAAA;A5Cw4gBH;A4Ct4gBE;EACC,mBzCrJK;EyCsJL,yBAAA;EACA,sBAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;A5Cw4gBH;A4Cr4gBE;EACC,SAAA;EACA,kBAAA;EAGA,aAAA;EAGA,mBAAA;A5Cu4gBH;A4Cr4gBE;EACC,ezCuDY;EyCtDZ,cAAA;A5Cu4gBH;A4Cr4gBE;;;EAGC,yBAAA;A5Cu4gBH;A4Cr4gBE;EACC,kBAAA;EAGA,aAAA;EAGA,mBAAA;A5Cu4gBH;A4Cr4gBE;EAGC,aAAA;EAGA,mBAAA;A5Cu4gBH;A4Cz3gBA;EACC;IAEC,kBAAA;E5Cq4gBA;E4Cn4gBD;IAEC,2BAAA;E5Cq4gBA;AACF;A4Cn4gBA;EACC,SAAA;EACA,aAAA;EACA,sBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,mBzC9NO;AHmmhBR;A4Cp4gBC;EACC,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,sCAAA;EACA,kBAAA;EACA,mBAAA;EACM,gEAAA;EACA,8BAAA;EACA,sDAAA;EACN,kBAAA;A5Cs4gBF;A4Cr4gBE;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;A5Cu4gBH;A4Ct4gBG;EACC,kBAAA;A5Cw4gBJ;A4Ct4gBG;EACC,ezCrBW;EyCsBX,gBzC5QmB;EyC6QnB,kBAAA;EACA,cAAA;EACA,czCpJO;AH4hhBX;A4Cp4gBG;EACC,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;A5Cs4gBJ;A4Cp4gBK;EACC,ezCtCS;EyCuCT,czCjKK;EyCkKL,eAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;A5Cs4gBN;A4Cr4gBM;EACC,ezChDQ;AHu7gBf;A4Cp4gBO;EACC,yBzC1LG;EyC2LH,qBzC3LG;AHikhBX;A4C93gBC;EACC,SAAA;EACA,aAAA;EACA,oBAAA;A5Cg4gBF;A4C/3gBE;EACC,gBAAA;A5Ci4gBH;A4C/3gBE;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,uBAAA;EACA,+BAAA;A5Ci4gBH;A4Ch4gBG;EACC,cAAA;EACA,qBAAA;EACA,aAAA;EACA,qBAAA;A5Ck4gBJ;A4Cj4gBI;EACC,gBAAA;A5Cm4gBL;A4Cj4gBI;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gBAAA;A5Cm4gBL;A4Cl4gBK;EACC,kBAAA;A5Co4gBN;A4Cl4gBK;EACC,ezChGS;EyCiGT,gBAAA;A5Co4gBN;A4Cl4gBK;EACC,czClUE;EyCmUF,eAAA;EACA,eAAA;EACA,gBzC/Ve;AHmuhBrB;A4Cn4gBM;EACC,+BAAA;A5Cq4gBP;A4Cp4gBO;EACC,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;A5Cs4gBR;A4Cj4gBI;EACC,iCAAA;EACe,uCAAA;EACf,kBAAA;EACA,czClPM;EyCmPN,ezCzHU;EyC0HV,gBzCjXgB;EyCkXhB,uDAAA;A5Cm4gBL;A4Cl4gBK;EACC,czCnVC;AHuthBP;A4Ch4gBK;EACC,czC5PK;EyC6PL,kBAAA;EACA,cAAA;A5Ck4gBN;A4Ch4gBK;EACC,mBAAA;A5Ck4gBN;A4C93gBK;EACC,aAAA;A5Cg4gBN;A4C33gBM;EACC,kBAAA;EACA,czChXC;EyCiXD,eAAA;EACA,gBzC3Yc;EyC4Yd,kBAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;A5C63gBP;A4Cv3gBI;EACC,gBAAA;EACA,czC7RM;EyC8RN,gBzCzZkB;EyC0ZlB,ezCpKU;AH6hhBf;A4Cx3gBK;EACC,eAAA;EACA,czCtSK;EyCuSL,gBzChae;EyCiaf,kBAAA;A5C03gBN;A4Ct3gBG;EACC,iBAAA;A5Cw3gBJ;A4Cv3gBI;EACC,yBAAA;A5Cy3gBL;A4Cv3gBI;EACC,iCAAA;EACe,oCAAA;EACf,czChTM;EyCiTN,aAAA;A5Cy3gBL;A4Cx3gBK;EACC,2BAAA;EACA,mCAAA;A5C03gBN;A4Cz3gBM;EACC,czC1TI;AHqrhBX;A4C13gBO;EACC,czCpZD;AHgxhBP;A4Cv3gBI;EACC,QAAA;EACA,gBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,uBAAA;EACA,uBAAA;EACA,+BAAA;A5Cy3gBL;A4Cx3gBK;EACC,WAAA;EACA,kBAAA;A5C03gBN;A4Cx3gBK;EACC,aAAA;EACA,qBAAA;EACA,qBAAA;EACA,6BAAA;EACA,oBAAA;EACA,czCnVK;AH6shBX;A4Cv3gBI;EACC,QAAA;EACA,gBAAA;A5Cy3gBL;A4Cv3gBI;EACC,uBAAA;A5Cy3gBL;A4Ct3gBG;EACC,kBAAA;A5Cw3gBJ;A4Cv3gBI;EACC,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,qBAAA;A5Cy3gBL;A4Cx3gBK;EACC,gBAAA;A5C03gBN;A4Cv3gBI;EACC,kBAAA;A5Cy3gBL;A4Cv3gBM;EACC,6BAAA;EACA,WAAA;EACA,kBAAA;A5Cy3gBP;A4Cn3gBM;EAEC,iBAAA;A5Cq3gBP;A4Cj3gBI;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;A5Cm3gBL;A4Cl3gBK;EACC,czCleE;EyCmeF,eAAA;A5Co3gBN;A4Cl3gBK;EACC,gBAAA;A5Co3gBN;A4Cj3gBM;EACC,WAAA;A5Cm3gBP;A4C92gBG;EAqBC,kBAAA;EACA,mBzCxaO;EyCyaP,mBAAA;EACA,aAAA;EACA,kBAAA;A5C41gBJ;A4Cp3gBI;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;A5Cs3gBL;A4Cr3gBK;EACC,czCvfE;EyCwfF,eAAA;EACA,czCvZK;AH8whBX;A4Cr3gBK;EACC,gBAAA;A5Cu3gBN;A4Cp3gBM;EACC,WAAA;A5Cs3gBP;A4C72gBI;EACC,WAAA;EACA,YAAA;EACA,yBzC5gBG;EyC6gBH,kBAAA;A5C+2gBL;A4C92gBK;EACC,czChbK;EyCibL,ezC7SS;AH6phBf;A4C52gBK;EACC,czClbK;EyCmbL,qBAAA;EACA,WAAA;EACA,ezC1TS;EyC2TT,gBzCljBe;AHg6hBrB;A4C52gBK;EACC,czC7bK;EyC8bL,qBAAA;EACA,WAAA;A5C82gBN;A4C52gBK;EAGC,aAAA;EAGA,mBAAA;EACA,UAAA;EACA,gBAAA;A5C82gBN;A4C72gBM;EACC,gBAAA;EACA,czCxcI;EyCycJ,ezC/UQ;EyCgVR,kBAAA;A5C+2gBP;A4C92gBO;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;A5Cg3gBR;A4C72gBQ;EACC,aAAA;A5C+2gBT;A4C52gBO;EACC,czC3kBE;AHy7hBV;A4C32gBM;EACC,kBAAA;A5C62gBP;A4Ct2gBC;EACC,yBAAA;UAAA,iBAAA;A5Cw2gBF;A4Ct2gBC;EACC,kBAAA;A5Cw2gBF;A4Cv2gBE;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aAAA;A5Cy2gBH;AC76hBI;E2C2jBF;IAWE,oBAAA;E5C22gBF;AACF;A4Cz2gBI;EACC,gBAAA;EACA,czC/fM;EyCggBN,ezC7XU;EyC8XV,UAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;A5C22gBL;A4C12gBK;EACC,eAAA;A5C42gBN;A4Cz2gBI;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACe,mBzC7nBV;EyC8nBL,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;A5C22gBL;A4C12gBK;EACC,yBzCtnBE;EyCunBF,qBzCrhBK;AHi4hBX;A4C32gBM;EACC,czCvhBI;AHo4hBX;A4C12gBK;EACC,gBAAA;A5C42gBN;A4Cv2gBI;EACC,czCjiBM;EyCkiBN,eAAA;A5Cy2gBL;A4Ct2gBG;EAKC,cAAA;EACA,UAAA;A5Co2gBJ;A4Cz2gBI;EACC,czCviBM;EyCwiBN,ezCzaU;AHoxhBf;A4Ct2gBG;EAMC,cAAA;EACA,UAAA;A5Cm2gBJ;A4Cz2gBI;EACC,czC/iBM;EyCgjBN,ezCjbU;EyCkbV,ezCjbU;AH4xhBf;A4Ct2gBG;EACC,kBAAA;A5Cw2gBJ;A4Cv2gBI;EACC,WAAA;EACA,YAAA;EACA,mBzC7pBG;EyC8pBH,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A5Cy2gBL;A4Cx2gBK;EACC,yBzC9kBK;EyC+kBL,qBzC/kBK;AHy7hBX;A4Cx2gBK;EACC,czC1kBK;EyC2kBL,ezC9cS;AHwzhBf;A4Cr2gBI;EACC,czCjlBM;EyCklBN,UAAA;A5Cu2gBL;A4Cr2gBI;EACC,czCrlBM;EyCslBN,UAAA;A5Cu2gBL;A4Cr2gBI;EACC,czCzlBM;EyC0lBN,UAAA;A5Cu2gBL;A4Cr2gBI;EACC,czC7lBM;EyC8lBN,UAAA;A5Cu2gBL;A4C91gBE;EACC,gBAAA;A5Cg2gBH;A4C51gBA;EACC,czC7mBU;EyC8mBV,ezCpfc;AHk1hBf;A4C51gBA;EACC,aAAA;EACA,eAAA;A5C81gBD;A4C51gBA;EACC,gBAAA;A5C81gBD;A4C11gBE;EACC,mBzC3uBO;EyC4uBP,WAAA;EACA,YAAA;EACA,mBAAA;EACA,czC9nBQ;EyC+nBR,UAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,czC5uBK;AHwkiBR;A4C31gBG;EACC,mBAAA;EACA,czC/uBI;AH4kiBR;A4Cz1gBC;EACC,gCAAA;EACA,gBAAA;EACA,oBAAA;A5C21gBF;A4Cv1gBC;EACC,czCxpBS;EyCypBT,ezC/hBa;EyCgiBb,gBzCvxBmB;EyCwxBnB,mBAAA;EACA,cAAA;A5Cy1gBF;A4Ct1gBA;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,ezC3iBc;EyC4iBd,czCzwBO;EyC0wBP,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;A5Cw1gBD;A4Cr1gBC;EACC,czCtxBM;EyCuxBN,yBzClwBY;EyCmwBZ,qBzClwBY;AHyliBd;A4Cp1gBA;EACC,eAAA;A5Cs1gBD;A4Cp1gBA;EACC,yBzClsBU;EyCmsBV,qBzClsBU;EyCmsBV,6BAAA;EACA,2BAAA;A5Cs1gBD;A4Cp1gBA;EACC,yBzCxsBU;EyCysBV,qBzCxsBU;EyCysBV,6BAAA;EACA,2BAAA;A5Cs1gBD;A4Cp1gBA;EACC,ezC3kBc;AHi6hBf;A4Cp1gBA;EACC,gBAAA;A5Cs1gBD;A4Cp1gBA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;A5Cs1gBD;A4Cr1gBC;EACC,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,yBzCj0BM;EyCk0BN,czC/tBS;EyCguBT,ezCrmBa;EyCsmBb,gBzC71BmB;AHoriBrB;A4Ct1gBE;EACC,qBzC1uBQ;AHkkiBX;A4Ct1gBE;EACC,qBzC7uBQ;AHqkiBX;A4Ct1gBE;EACC,qBzChvBQ;AHwkiBX;A4Cp1gBA;EACC,UAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;A5Cs1gBD;A4Cp1gBA;EACC,UAAA;EACA,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;A5Cs1gBD;A4Cr1gBC;EACC,ezCvoBa;EyCwoBb,czCpwBS;AH2liBX;A4Cp1gBA;EACC,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;EACA,kBAAA;A5Cs1gBD;A4Cr1gBC;EACC,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,8BAAA;EACA,yBAAA;EACA,eAAA;EACA,yBzC33BM;EyC43BN,czCzxBS;EyC0xBT,ezC/pBa;EyCgqBb,gBzCv5BmB;AH8uiBrB;A4Ct1gBE;EACC,qBzCpyBQ;AH4niBX;A4Ct1gBE;EACC,qBzCvyBQ;AH+niBX;A4Ct1gBE;EACC,qBzC1yBQ;AHkoiBX;A4Cp1gBA;EACC,UAAA;EACA,mBAAA;EACA,SAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,UAAA;A5Cs1gBD;A4Cp1gBA;EACC,kBAAA;A5Cs1gBD;A4Cp1gBA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,czCvzBU;EyCwzBV,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;A5Cs1gBD;A4Cp1gBA;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,czCv0BU;EyCw0BV,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,eAAA;A5Cs1gBD;A4Cp1gBA;EACC,sBAAA;A5Cs1gBD;A4Cp1gBA;EACC,YAAA;EACA,WAAA;A5Cs1gBD;A4Cp1gBA;EACC,yBAAA;EACA,czC/1BU;EyCg2BV,kBAAA;EACA,eAAA;EACA,gBzC39BoB;EyC49BpB,gBAAA;EACA,oBAAA;A5Cs1gBD;A4Cp1gBA;EACC,yBAAA;EACA,czCz2BU;EyC02BV,kBAAA;EACA,cAAA;EACA,gBzCp+BoB;EyCq+BpB,gBAAA;EACA,mBAAA;A5Cs1gBD;A4Cp1gBA;EACC,gBAAA;A5Cs1gBD;A4Cn1gBC;EACC,mBAAA;A5Cq1gBF;A4Cl1gBA;EACC,uBAAA;EACA,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;A5Co1gBD;A4Cl1gBA;EAGC,aAAA;EAGA,mBAAA;EACA,kBAAA;A5Co1gBD;A4Cl1gBE;EAGC,aAAA;A5Co1gBH;A4C/0gBC;EACC,kBAAA;A5Ci1gBF;A4C90gBA;EACC,aAAA;A5Cg1gBD;A4C/0gBC;EACC,UAAA;EACA,mBAAA;A5Ci1gBF;A4C/0gBC;EACC,UAAA;A5Ci1gBF;A4C90gBA;EACC,mBAAA;A5Cg1gBD;A4C/0gBC;EACC,mBAAA;A5Ci1gBF;A4C90gBA;EACC,2BAAA;A5Ci1gBD;A4C90gBA;EAGC,aAAA;EAGA,mBAAA;A5Cg1gBD;A4C/0gBC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;A5Ci1gBF;A4Ch1gBE;EACC,WAAA;A5Ck1gBH;A4C/0gBC;EACC,czCr7BS;EyCs7BT,ezC3zBa;EyC4zBb,gBzCnjCmB;EyCojCnB,gBAAA;A5Ci1gBF;A4C/0gBG;EACC,czCz+BU;AH0ziBd;A4C30gBC;EAGC,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,UAAA;EACA,gBAAA;A5C60gBF;A4C30gBG;EACC,WAAA;EACA,YAAA;EACA,mBzClkCM;EyCmkCN,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A5C60gBJ;A4Cz0gBC;EACC,gBAAA;EACA,czCj+BS;EyCk+BT,ezCx2Ba;EyCy2Bb,gBzChmCmB;EyCimCnB,gBAAA;A5C20gBF;A4Cz0gBC;EACC,kBAAA;A5C20gBF;A4Cv0gBC;EACC,kBAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;A5Cy0gBF;A4Cx0gBE;EACC,czCplCK;EyCqlCL,eAAA;A5C00gBH;A4Cx0gBE;EACC,gBAAA;A5C00gBH;A4Cv0gBG;EACC,WAAA;A5Cy0gBJ;A4Cr0gBC;EACC,WAAA;EACA,cAAA;EACA,WAAA;A5Cu0gBF;A4Cr0gBC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;A5Cu0gBF;A4Ct0gBE;EACC,WAAA;EACA,UAAA;EACA,YAAA;A5Cw0gBH;A4Cv0gBG;EACC,kBAAA;A5Cy0gBJ;A4Cv0gBK;EACC,WAAA;A5Cy0gBN;A4Cp0gBE;EACC,WAAA;A5Cs0gBH;A4Ch0gBE;EACC,SAAA;EACA,YAAA;A5Ck0gBH;A4Cj0gBG;EACC,mBAAA;EACA,iBAAA;A5Cm0gBJ;A4C7zgBG;EACC,czC1iCO;EyC2iCP,ezC16BW;EyC26BX,mBAAA;EACA,iBAAA;EACA,gBzCrqCmB;AHo+iBvB;A4C7zgBG;EACC,YAAA;EACA,UAAA;A5C+zgBJ;A4C9zgBI;EACC,qBzCljCM;EyCmjCN,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,QAAA;EACA,wBAAA;EACA,gCAAA;A5Cg0gBL;A4C5zgBE;EACC,yBzCpoCa;AHk8iBhB;A4C5zgBE;EACC,sBAAA;EACA,gBAAA;A5C8zgBH;A4CxzgBI;EACC,qBzC9kCM;EyC+kCN,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,qBzCllCM;EyCmlCN,mBAAA;EACA,yBAAA;EACA,YAAA;A5C0zgBL;A4CnzgBG;EACC,QAAA;A5CqzgBJ;A4ChzgBE;EACC,gBAAA;A5CkzgBH;A4C9ygBA;EACC,mBAAA;EACA,kBAAA;A5CgzgBD;A4C7ygBC;EACC,kBAAA;EACA,czC5mCS;EyC6mCT,ezCn/Ba;AHkyiBf;A4C3ygBC;EACC,UAAA;EACA,gBAAA;EAGA,aAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;A5C6ygBF;A4C5ygBE;EACC,gBAAA;A5C8ygBH;A4C7ygBG;EACC,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,czC1oCO;EyC2oCP,gBzCxwCiB;EyCywCjB,ezClhCW;AHi0iBf;A4C9ygBI;EACC,gBAAA;A5CgzgBL;A4C5ygBE;EACC,iBAAA;A5C8ygBH;A4C3ygBG;EACC,mBAAA;A5C6ygBJ;A4CzygBG;EACC,mBAAA;A5C2ygBJ;A4CtygBA;EACC,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;A5CwygBD;A4CvygBC;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,yBzCprCS;EyCqrCT,WAAA;EACA,WAAA;A5CyygBF;A4CtygBA;EACC,oBAAA;EACG,mBzC3rCO;EyC4rCV,czCtrCU;EyCurCV,ezC7jCc;EyC8jCd,iBAAA;EACA,qBAAA;EACA,gBzCvzCoB;EyCwzCpB,kBAAA;EACA,yBAAA;A5CwygBD;A4CtygBA;EACC,iBAAA;A5CwygBD;A4CvygBC;EACC,iBAAA;A5CyygBF;A4CtygBA;EACC,eAAA;A5CwygBD;A4CvygBC;EACC,mBAAA;A5CyygBF;A4CvygBC;EACC,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,gCAAA;A5CyygBF;A4CxygBE;EAGC,aAAA;EAGA,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;A5C0ygBH;A4CzygBG;EACC,gBAAA;A5C2ygBJ;A4CzygBG;EACC,cAAA;EACA,kBAAA;A5C2ygBJ;A4CrygBC;EACC,kBAAA;EACA,czCvuCS;EyCwuCT,ezC7mCa;EyC8mCb,gBzCr2CmB;AH4ojBrB;A4CrygBC;EACC,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,czCnvCS;EyCovCT,ezC1nCa;AHi6iBf;A4CpygBA;EACC,aAAA;EACA,cAAA;A5CsygBD;A4CrygBC;EACC,UAAA;A5CuygBF;A4CtygBE;EACC,gBAAA;EACA,mBAAA;A5CwygBH;A4CvygBG;EACC,kBAAA;A5CyygBJ;A4CvygBG;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A5CyygBJ;A4CtygBM;EACC,czChxCI;AHwjjBX;A4ChygBA;EAGC,aAAA;EAGA,mBAAA;A5CkygBD;A4CjygBC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A5CmygBF;A4ClygBE;EACC,ezClrCY;AHs9iBf;A4CjygBC;EACC,ezCvrCa;EyCwrCb,gBzC/6CmB;EyCg7CnB,czCpxCW;EyCqxCX,gBAAA;A5CmygBF;A4ChygBA;EACC,mBAAA;A5CkygBD;A4CjygBC;EACC,czCz2CY;AH4ojBd;A4ChygBA;EACC,6CAAA;A5CkygBD;A4CjygBC;EACC,czC75CK;AHgsjBP;A4ChygBA;EACC,mBAAA;A5CkygBD;A4CjygBC;EACC,czCx6CO;AH2sjBT;A4ChygBA;EACC,mBAAA;A5CkygBD;A4CjygBC;EACC,czC57CU;AH+tjBZ;A4ChygBA;EACC,mBAAA;A5CkygBD;A4CjygBC;EACC,czCr3CW;AHwpjBb;A4ChygBA;EAGC,aAAA;EAGA,mBAAA;A5CkygBD;A4CjygBC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,czCp8CM;EyCq8CN,eAAA;EACA,mBzCp9CQ;EyCu9CR,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;A5CmygBF;A4CjygBC;EACC,cAAA;EACA,ezCrvCa;AHwhjBf;A4C9xgBE;EACC,ezC3vCY;EyC4vCZ,iBAAA;EACA,czC59CK;EyC69CL,6BAAA;EACA,SAAA;A5CgygBH;A4C9xgBE;EACC,ezClwCY;EyCmwCZ,iBAAA;EACA,czC98CW;AH8ujBd;A4CzxgBG;EACC,czC1+CI;EyC2+CJ,ezC5wCW;AHuijBf;A4CtxgBA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,ezCtxCc;EyCuxCd,mBAAA;EACA,WAAA;EACA,YAAA;A5CwxgBD;A4CvxgBC;EACC,mBAAA;EACA,qBzCh6CS;AHyrjBX;A4CtxgBA;EACC,gBAAA;EACA,SAAA;EACA,UAAA;A5CwxgBD;A4CvxgBC;EACC,qBAAA;EACA,iBAAA;A5CyxgBF;A4CxxgBE;EACC,czCn6CQ;EyCo6CR,ezCvyCY;AHikjBf;A4CtxgBA;EACC,sBAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,eAAA;EACA,gBAAA;A5CwxgBD;A4CtxgBE;EACC,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,SAAA;EACA,yCAAA;A5CwxgBH;A4CtxgBE;EACC,oBAAA;EACA,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;A5CwxgBH;A4CvxgBG;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,oBAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,yBzCt9CO;EyCu9CP,ezCt1CW;EyCu1CX,gBzC9kDmB;EyC+kDnB,czCjjDK;AH00jBT;A4CtxgBE;EACC,gBAAA;A5CwxgBH;A4CnxgBG;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A5CqxgBJ;A4ClxgBE;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A5CoxgBH;A4C/wgBC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,UAAA;EACA,yBzC9kDO;AH+1jBT;A4C7wgBC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,UAAA;A5C+wgBF;A4C3wgBC;EACC,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,yBAAA;EACA,UAAA;EACA,yBzC9mDM;AH23jBR;A4C1wgBA;EACC,czCpoDS;AHg5jBV;A4C3wgBC;EACC,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EAEA,oCAAA;EACA,YAAA;A5C6wgBF;A4C5wgBE;EAEC,sBAAA;A5C8wgBH;A4C5wgBE;EAEC,sBAAA;A5C8wgBH;A4C1wgBA;EACC,mBAAA;EACA,iBAAA;EACA,mBzClpDO;EyCmpDP,yBAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;A5C4wgBD;A4CzwgBC;EACC,czCxjDS;EyCyjDT,YAAA;EACA,qBzChkDS;AH20jBX;A4CrwgBG;EACC,YAAA;A5CuwgBJ;A4ClwgBA;EACC,czCrpDa;EyCspDb,ezC98Cc;EyC+8Cd,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;A5CowgBD;A4CnwgBC;EACC,ezCp9Ca;AHytjBf;A4ClwgBA;EACC,UAAA;EACA,SAAA;EACA,gBAAA;A5CowgBD;A4CnwgBC;EACC,eAAA;EACA,gCAAA;A5CqwgBF;A4CpwgBE;EACC,czCzlDQ;EyC0lDR,czC1lDQ;EyC2lDR,ezCj+CY;EyCk+CZ,iBAAA;A5CswgBH;A4ClwgBE;EACC,czCxsDM;AH48jBT;A4ChwgBE;EACC,czC7sDM;AH+8jBT;A4C9vgBE;EACC,czCltDM;AHk9jBT;A4C5vgBA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,yBAAA;EACA,iCAAA;EACA,6BAAA;A5C8vgBD;A4C5vgBA;EACC,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,SAAA;A5C8vgBD;A4C5vgBA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EAEA,yBzC3uDO;EyC4uDP,aAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,kBAAA;EACA,YAAA;A5C8vgBD;A4C7vgBC;EACC,yBzClvDM;EyCmvDN,8BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;A5C+vgBF;A4C9vgBE;EACC,UAAA;A5CgwgBH;A4C9vgBE;EACC,aAAA;EACA,iBAAA;EACA,mBAAA;A5CgwgBH;A4C5vgBE;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,czCnqDQ;EyCoqDR,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;A5C8vgBH;A4C7vgBG;EACC,czCpxDM;AHmhkBV;A4C7vgBG;EACC,czCrxDK;AHohkBT;A4C1vgBA;EACC,YAAA;A5C4vgBD;A4C3vgBC;EAIC,yBAAA;EACA,cAAA;A5C0vgBF;A4C9vgBE;EACC,qBAAA;A5CgwgBH;A4CzvgBC;EACC,uBAAA;A5C2vgBF;A4CzvgBC;EACC,SAAA;A5C2vgBF;A4CxvgBE;EACC,ezCzkDY;EyC0kDZ,gBzCl0DoB;EyCm0DpB,czCxsDQ;AHk8jBX;A4CxvgBE;EACC,eAAA;EACA,gBzCz0DkB;EyC00DlB,czC7sDQ;AHu8jBX;A4CrvgBC;EACC,sBAAA;A5CuvgBF;A4CpvgBI;EACC,mBAAA;A5CsvgBL;A4ClvgBI;EACC,mBAAA;A5CovgBL;A4C9ugBA;EACC,mBAAA;A5CgvgBD;A4C9ugBA;EACC,eAAA;A5CgvgBD;A4C9ugBE;EACC,UAAA;EACA,gCAAA;A5CgvgBH;A4C/ugBG;EACC,gBAAA;EACA,mBAAA;A5CivgBJ;A4ChvgBI;EACC,ezCpnDU;EyCqnDV,gBzC72DgB;EyC82DhB,czCjvDM;EyCkvDN,kBAAA;A5CkvgBL;A4ChvgBI;EACC,ezC1nDU;EyC2nDV,gBzCl3DgB;EyCm3DhB,czCvvDM;EyCwvDN,kBAAA;A5CkvgBL;A4ChvgBI;EACC,ezC/nDU;EyCgoDV,gBzCz3DgB;EyC03DhB,czC7vDM;AH++jBX;A4ChvgBI;EACC,ezCroDU;EyCsoDV,gBzC73DgB;EyC83DhB,czCnwDM;EyCowDN,oBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;A5CkvgBL;A4CjvgBK;EACC,czC1wDK;AH6/jBX;A4ChvgBI;EACC,iBAAA;A5CkvgBL;A4C5ugBA;EACC,eAAA;A5C8ugBD;A4C5ugBA;EACC,eAAA;A5C8ugBD;A4C5ugBA;EACC,oBAAA;A5C8ugBD;A4C5ugBA;EACC,oBAAA;A5C8ugBD;A4C3ugBC;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,czCryDS;EyCsyDT,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,yBzCpzDS;EyCqzDT,qBzCrzDS;AHkikBX;A4CtugBI;EACC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,czCxzDM;EyCyzDN,aAAA;EACA,qBAAA;EACA,uBAAA;EACA,+BAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBzCv0DM;AH+ikBX;A4ClugBA;EACC,yBAAA;A5CougBD;A4ClugBA;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;A5CougBD;A4CnugBC;EACC,gBAAA;A5CqugBF;A4CpugBE;EACC,czCn1DQ;EyCo1DR,eAAA;EACA,gBzC98DkB;EyC+8DlB,gBAAA;A5CsugBH;A4ClugBA;EACC,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,ezC5tDc;EyC6tDd,yBAAA;EAGA,iBAAA;EACA,ezCpuDc;EyCquDd,gBzC99DoB;EyC+9DpB,czCl2DU;EyCm2DV,kBAAA;A5CougBD;A4CnugBC;EACC,kBAAA;EACA,UAAA;EACA,eAAA;A5CqugBF;A4ClugBI;EACC,yBzC52DM;AHglkBX;A4CnugBK;EACC,cAAA;A5CqugBN;A4C9tgBE;EACC,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;A5CgugBH;A4C5tgBA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,yBzCv+DO;EyCw+DP,yBAAA;EACA,kBAAA;A5C8tgBD;A4C7tgBC;EACC,WAAA;EACA,kBAAA;EACA,aAAA;A5C+tgBF;A4C3tgBC;EACC,czC/4DS;EyCg5DT,ezCtxDa;EyCuxDb,gBzC7gEmB;AH0ukBrB;A4CztgBC;EACC,oCAAA;A5C2tgBF;A4CvtgBC;EACC,kCAAA;A5CytgBF;A4CttgBA;EACC,kBAAA;EACA,qBAAA;A5CwtgBD;A4CttgBA;EACC,mBAAA;A5CwtgBD;A4CttgBA;EACC,mBAAA;EACA,aAAA;EACA,mBAAA;A5CwtgBD;A4CttgBA;EACC,sBAAA;EACA,uBAAA;EACA,yBAAA;A5CwtgBD;A4CrtgBC;EACC,WAAA;EACA,qBAAA;EACA,gBAAA;A5CutgBF;A4CttgBE;EACC,eAAA;EACA,YAAA;A5CwtgBH;A4CptgBA;EACC,iBAAA;A5CstgBD;A4CrtgBC;EACC,ezCl0Da;EyCm0Db,gBzCzjEqB;EyC0jErB,czC/7DS;EyCg8DT,kBAAA;A5CutgBF;A4CntgBC;EACC,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A5CqtgBF;A4CntgBC;EAQC,gCAAA;EACA,oBAAA;EACA,mBAAA;A5C8sgBF;A4CvtgBE;EACC,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;A5CytgBH;A4CntgBG;EACC,mBzC9kEM;EyC+kEN,kBAAA;EACA,czC/9DO;EyCg+DP,czCnkEI;AHwxkBR;A4CntgBG;EACC,iBAAA;EACA,ezC12DW;EyC22DX,czCr+DO;EyCs+DP,gBzClmEiB;EyCmmEjB,SAAA;EACA,kBAAA;EACA,mBzCt8DM;EyCu8DN,czCzlEQ;EyC0lER,kBAAA;A5CqtgBJ;A4CptgBI;EACC,iBAAA;A5CstgBL;A4CjtgBG;EACC,uBAAA;EACA,kBAAA;A5CmtgBJ;A4CltgBI;EACC,kBAAA;EACA,WAAA;A5CotgBL;A4CltgBI;EAKC,kBAAA;EACA,czClmEG;EyCmmEH,eAAA;EACA,gBzC7nEgB;EyC8nEhB,kBAAA;EACA,QAAA;EACA,SAAA;EAGA,gCAAA;A5CgtgBL;A4C7tgBK;EACC,ezC73DS;EyC83DT,czC/lEE;AH8zkBR;A4ChtgBM;EACC,czClhEI;AHoukBX;A4C5sgBI;EACC,iBAAA;A5C8sgBL;A4CxsgBA;EAGC,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;A5C0sgBD;A4CzsgBC;EACC,gBAAA;A5C2sgBF;A4CxsgBA;EAGC,aAAA;EAGA,mBAAA;A5C0sgBD;A4CzsgBC;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EAGA,aAAA;EAGA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;A5C2sgBF;A4C1sgBE;EACC,ezC/7DY;AH2okBf;A4CvsgBC;EACC,UAAA;EACA,gBAAA;EAGA,aAAA;EAGA,mBAAA;A5CysgBF;A4CxsgBE;EACC,gBAAA;EACA,czC/kEQ;EyCglER,ezCt9DY;EyCu9DZ,gBzC9sEkB;EyC+sElB,kBAAA;A5C0sgBH;A4CzsgBG;EACC,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,WAAA;EACA,QAAA;A5C2sgBJ;A4CxsgBI;EACC,aAAA;A5C0sgBL;A4CtsgBE;EACC,kBAAA;A5CwsgBH;A4CrsgBC;EACC,czCvmES;EyCwmET,ezC7+Da;EyC8+Db,gBzCruEmB;AH46kBrB;A4CnsgBC;EACC,czC9mES;AHmzkBX;A4ClsgBA;EACC,gBAAA;A5CosgBD;A4CnsgBC;EACC,WAAA;EACA,cAAA;EACA,WAAA;A5CqsgBF;A4CnsgBC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;A5CqsgBF;A4CpsgBE;EACC,WAAA;A5CssgBH;A4CrsgBG;EACC,czC5tEK;EyC6tEL,ezCngEW;AH0skBf;A4CpsgBE;EACC,iBAAA;A5CssgBH;A4CnsgBC;EACC,gBzCnwEqB;EyCowErB,czC3uEM;EyC4uEN,ezC/gEa;EyCghEb,mBAAA;A5CqsgBF;A4ClsgBA;EAGC,aAAA;EAGA,mBAAA;EACA,mBAAA;A5CosgBD;A4ChsgBE;EACC,czC1pEQ;EyC2pER,ezChiEY;EyCiiEZ,gBzCxxEkB;EyCyxElB,kBAAA;A5CksgBH;A4C9rgBE;EACC,czClqEQ;EyCmqER,ezCziEY;EyC0iEZ,gBzCjyEkB;EyCkyElB,qBAAA;A5CgsgBH;A4C5rgBE;EACC,czC3qEQ;AHy2kBX;A4CzrgBC;EACC,czCjrES;EyCkrET,gBzC7yEmB;AHw+kBrB;A4CxrgBA;EACC,cAAA;A5C0rgBD;A4CzrgBC;EACC,kBAAA;EACA,kBAAA;A5C2rgBF;A4CxrgBA;EAOC,gBAAA;A5CorgBD;A4C1rgBC;EACC,gBzCxzEqB;EyCyzErB,czChyEM;EyCiyEN,ezCpkEa;EyCqkEb,mBAAA;A5C4rgBF;A4CzrgBC;EACC,WAAA;EACA,cAAA;EACA,WAAA;A5C2rgBF;A4CzrgBC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;A5C2rgBF;A4C1rgBE;EACC,czChtEQ;EyCitER,gBzC10EkB;AHsglBrB;A4C1rgBE;EACC,gBAAA;A5C4rgBH;A4CzrgBC;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;A5C2rgBF;A4C1rgBE;EACC,UAAA;EACA,QAAA;EACA,SAAA;A5C4rgBH;A4CzrgBC;EACC,kBAAA;EACA,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,yBzC5uES;EyC8uET,gBAAA;A5C2rgBF;A4C1rgBE;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,yBzCr1EK;EyCu1EL,gBAAA;A5C4rgBH;A4CxrgBE;EACC,yBzCx1EI;AHkhlBP;A4CzrgBG;EAGC,2BAAA;A5C2rgBJ;A4CxrgBE;EACC,2BAAA;A5C0rgBH;A4CvrgBC;EACC,mBAAA;A5CyrgBF;A4CxrgBE;EACC,kBAAA;A5C0rgBH;A4CtrgBA;EACC,gBAAA;EACA,aAAA;EACA,oBAAA;A5CwrgBD;A4CvrgBC;EACC,WAAA;EACA,cAAA;EACA,WAAA;A5CyrgBF;A4CvrgBC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;A5CyrgBF;A4CxrgBE;EACC,WAAA;EACA,cAAA;EACA,WAAA;A5C0rgBH;A4CxrgBE;EACC,cAAA;EACA,WAAA;EACA,gBzC55EkB;EyC65ElB,kBAAA;A5C0rgBH;A4CzrgBG;EACC,czC14EK;EyC24EL,kBAAA;A5C2rgBJ;A4C1rgBI;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,ezC7qEU;AHy2kBf;A4CxrgBE;EACC,gBAAA;A5C0rgBH;A4CtrgBA;EACC,gBzC96EsB;EyC+6EtB,gBAAA;A5CwrgBD;A4CvrgBC;EACC,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,czC75EM;EyC85EN,gBAAA;EACA,eAAA;EACA,mBAAA;A5CyrgBF;A4CtrgBA;EACC,iBAAA;A5CwrgBD;A4CvrgBC;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;A5CyrgBF;A4CtrgBA;EACC,iBAAA;A5CwrgBD;A4CtrgBE;EACC,0BAAA;EACA,aAAA;EACA,mBAAA;A5CwrgBH;A4CrrgBC;EACC,gBAAA;EACA,UAAA;EACA,SAAA;A5CurgBF;A4CtrgBE;EACC,yBAAA;EACA,kBAAA;EACA,yBzC37EK;EyC47EL,aAAA;A5CwrgBH;A4CtrgBE;EACC,gBAAA;A5CwrgBH;A4CrrgBC;EAmBC,SAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,qBAAA;EACA,WAAA;A5CqqgBF;A4C5rgBE;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,ezCzuEY;EyC0uEZ,gBzCj+EkB;EyCk+ElB,kBAAA;EACA,czCv2EQ;AHqilBX;A4C5rgBE;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,czC92EQ;EyC+2ER,ezCrvEY;EyCsvEZ,gBzC7+EkB;AH2qlBrB;A4CrrgBC;EACC,qBAAA;EACA,czC53ES;EyC63ET,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,gBzC3/EmB;EyC4/EnB,mBAAA;A5CurgBF;A4CtrgBE;EACC,mBAAA;EACA,czCt+EK;AH8plBR;A4CprgBA;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;A5CsrgBD;A4CrrgBC;EACC,mBAAA;EACA,ezClxEa;EyCmxEb,gBzC1gFmB;EyC2gFnB,czC/4ES;EyCk5ET,aAAA;EAGA,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A5CurgBF;A4CprgBA;EACC,iBAAA;EACA,oBAAA;A5CsrgBD;A4CnrgBC;EACC,aAAA;EACA,mBAAA;EACA,YAAA;A5CqrgBF;A4CprgBE;EACC,czCz6EQ;AH+llBX;A4CjrgBC;EACC,czC36ES;AH8llBX;A4ChrgBA;EACC,WAAA;EACA,YAAA;EACA,yBzChhFM;EyCihFN,yBAAA;EACA,kBAAA;EACA,czCvhFO;EyCwhFP,ezCzzEc;EyC0zEd,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;A5CkrgBD;A4CjrgBC;EACC,czCjiFM;AHotlBR;A4CjrgBC;EACC,czCpiFM;AHutlBR;A4ChrgBA;EAOC,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBzC/8EU;EyCg9EV,czCljFO;EyCmjFP,eAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;A5C4qgBD;A4C9rgBC;EACC,czCziFM;AHyulBR;A4C9rgBC;EACC,czC5iFM;AH4ulBR;A4C9qgBE;EACC,czC79EQ;EyC89ER,SAAA;EACA,mBAAA;EACA,gBzC3lFkB;EyC4lFlB,iBAAA;A5CgrgBH;A4C/qgBG;EACC,czCn+EO;AHoplBX;A4C9qgBE;EACC,iBAAA;A5CgrgBH;A4C9qgBE;EACC,uCAAA;EACA,czC3+EQ;AH2plBX;A4C7qgBC;EACC,oBAAA;EACA,kBAAA;A5C+qgBF;A4C9qgBE;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,yBzC3/EQ;EyC4/ER,WAAA;A5CgrgBH;A4C3qgBA;EACC,YAAA;A5C6qgBD;A4C1qgBA;EACC,kBAAA;A5C4qgBD;A4CzqgBA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A5C2qgBD;A4CxqgBA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A5C0qgBD;A4CvqgBA;EACC,mBAAA;A5CyqgBD;A4CtqgBA;EACC,gBAAA;A5CwqgBD;A4CrqgBA;EACC,YAAA;EACA,aAAA;A5CuqgBD;A4CpqgBA;EACC,iBAAA;EACA,gBAAA;A5CsqgBD;A4CnqgBA;EACC,iBAAA;A5CqqgBD;A4ClqgBA;EACC,YAAA;EACA,aAAA;A5CoqgBD;A4CjqgBA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;EACA,oCAAA;EACA,iBAAA;EACA,ezCt7Ec;AHyllBf;A4ChqgBA;EACC,czC5pFO;AH8zlBR;A4C/pgBA;EACC,aAAA;EACA,2BAAA;EACA,kBAAA;EACA,eAAA;A5CiqgBD;A4C9pgBA;EACC,WAAA;EACA,gBAAA;EACA,eAAA;A5CgqgBD;A4C7pgBA;EACC,eAAA;A5C+pgBD;A4C5pgBA;EACC,qBAAA;A5C8pgBD;A4C3pgBA;EACC,yBAAA;EACA,qBAAA;A5C6pgBD;A4C1pgBA;EACC,qBAAA;A5C4pgBD;A4CzpgBA;EACC,kBAAA;A5C2pgBD;A4CxpgBA;EACC,gBAAA;EACA,qBAAA;A5C0pgBD;A4CvpgBA;EACC,iBAAA;A5CypgBD;A4CtpgBA;EACC,yBAAA;A5CwpgBD;A4CrpgBA;EACC,yBAAA;A5CupgBD;A4CppgBA;EACC,2BAAA;EACA,gCAAA;A5CspgBD;A4CnpgBA;EACC,qBAAA;EACA,gBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;A5CqpgBD;A4ClpgBA;EACC,czChuFO;EyCiuFP,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBzCjwFsB;AHq5lBvB;A4CjpgBA;EACC,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,cAAA;A5CmpgBD;A4ChpgBA;;EAEC,WAAA;EACA,YAAA;EACA,iBAAA;A5CkpgBD;A4C/ogBA;EACC,cAAA;EACA,aAAA;A5CipgBD;A4C9ogBA;EACC,ezCpiFc;AHorlBf;A4C7ogBA;EACC,cAAA;EACA,aAAA;A5C+ogBD;A4C5ogBA;EACC,eAAA;A5C8ogBD;A4C3ogBA;EACC,aAAA;EACA,YAAA;A5C6ogBD;A4C1ogBA;EACC,kBAAA;A5C4ogBD;A4CzogBA;EACC,eAAA;EACA,mBAAA;A5C2ogBD;A4CxogBA;EACC,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,wBAAA;EACA,gCAAA;EACA,4BAAA;A5C0ogBD;A4CvogBA;EACC,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;A5CyogBD;A4CtogBA;EACC,gCAAA;EACA,oBAAA;A5CwogBD;A4CrogBA;EACC,gBAAA;A5CuogBD;A4CpogBA;EACC,ezC1lFc;AHgulBf;A4CjogBA;EACC,gBzCt1FoB;EyCu1FpB,cAAA;EACA,ezChmFc;EyCimFd,kBAAA;A5CmogBD;A4ChogBA;EACC,gBAAA;EACA,gBAAA;A5CkogBD;A4C/ngBA;EACC,cAAA;EACA,SAAA;EACA,UAAA;A5CiogBD;A4C9ngBA;EACC,ezC9mFc;AH8ulBf;A4C7ngBA;EACC,uBAAA;EACA,SAAA;A5C+ngBD;A4C5ngBA;EACC,sBAAA;A5C8ngBD;A4C3ngBA;EACC,sBAAA;A5C6ngBD;A4C1ngBA;EACI,eAAA;A5C4ngBJ;A4CzngBA;EACC,mBAAA;A5C2ngBD;A4CxngBA;EACI,qBAAA;A5C0ngBJ;A4CvngBA;EACI,eAAA;A5CyngBJ;A4CvngBA;EACC,aAAA;A5CyngBD;A4CvngBA;EACC,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;A5CyngBD;A4CvngBA;EACC,UAAA;EACA,mBAAA;A5CyngBD;A4CtngBA;EACC,ezChqFc;EyCiqFd,gBzCr5FkB;EyCs5FlB,yBAAA;EACA,cAAA;EACA,gBAAA;A5CwngBD;A4CrngBA;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,czCz4FO;EyC04FP,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,eAAA;A5CungBD;A4CpngBA;EACC,gBAAA;EACA,UAAA;EACA,SAAA;A5CsngBD;A4CnngBA;EACC,WAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACG,uBAAA;EACA,+BAAA;A5CqngBJ;A4ClngBA;EACC,iBAAA;A5CongBD;A4CjngBA;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,ezC9sFc;AHi0lBf;A4CjngBA;EACE,yBAAA;EACA,qBAAA;A5CmngBF;A4ChngBA;EACC,cAAA;EACA,gBzCj9FoB;AHmkmBrB;A4C/mgBA;EACC,sBAAA;A5CingBD;A4C/mgBA;EAGI,aAAA;EAGH,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;A5CingBD;A4C/mgBA;EACC,gBAAA;EACA,ezC5uFc;EyC6uFd,gBzCr+FsB;EyCw+FnB,aAAA;EAGH,mBAAA;A5CingBD;A4C/mgBA;EACC,ezCpvFc;AHq2lBf;A4C/mgBA;EACC,gBAAA;EACA,czCx+FS;EyCy+FT,gBzCp/FoB;AHqmmBrB;A4C/mgBA;EACC,cAAA;A5CingBD;A4C9mgBA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;A5CgngBD;A4C7mgBA;EACC,eAAA;EACA,YAAA;EACA,mBAAA;A5C+mgBD;A4C5mgBA;EACC,cAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;A5C8mgBD;A4C3mgBA;EACC,WAAA;EACA,kBAAA;EACA,QAAA;EACA,2BAAA;EACA,mCAAA;EACA,+BAAA;EACA,QAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;A5C6mgBD;A4C1mgBA;;EAEC,ezCvyFc;AHm5lBf;A4CzmgBA;EACC,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;A5C2mgBD;A4CxmgBA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;A5C0mgBD;A4CvmgBA;EACC,WAAA;EACA,YAAA;EACA,yBAAA;EACA,czC1hGO;EyC2hGP,aAAA;EACA,mBAAA;EACA,uBAAA;A5CymgBD;A4CtmgBA;;;EAGC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,yBAAA;A5CwmgBD;A4CrmgBA;EACC,yBAAA;A5CumgBD;A4CpmgBA;EACC,yBAAA;A5CsmgBD;A4CnmgBA;EACC,yBAAA;A5CqmgBD;A4ClmgBA;EACC,4BAAA;A5ComgBD;A4CjmgBA;EACC,6BAAA;A5CmmgBD;A4ChmgBA;EACC,ezCl2Fc;AHo8lBf;A4C/lgBA;EACC,cAAA;EACA,eAAA;A5CimgBD;A4C9lgBA;EACC,4BAAA;A5CgmgBD;A4C7lgBA;EACC,6BAAA;A5C+lgBD;A4C5lgBA;EACC,eAAA;A5C8lgBD;A4C3lgBA;;;EAGC,iBAAA;A5C6lgBD;A4C1lgBA;EACC,aAAA;EACA,cAAA;A5C4lgBD;A4CzlgBA;EACC,4BAAA;A5C2lgBD;A4CxlgBA;EACC,6BAAA;A5C0lgBD;A4CvlgBA;EACC,ezC54Fc;AHq+lBf;A4CtlgBA;;;EAGC,iBAAA;A5CwlgBD;A4CrlgBA;EACC,cAAA;EACA,eAAA;A5CulgBD;A4CplgBA;EACC,4BAAA;A5CslgBD;A4CnlgBA;EACC,6BAAA;A5CqlgBD;A4CllgBA;EACC,ezC95Fc;AHk/lBf;A4CjlgBA;;;EAGC,iBAAA;A5CmlgBD;A4ChlgBA;EACC,WAAA;EACA,YAAA;A5CklgBD;A4C/kgBA;EACC,4BAAA;A5CilgBD;A4C9kgBA;EACC,6BAAA;A5CglgBD;A4C7kgBA;EACC,ezCn7Fc;AHkgmBf;A4C5kgBA;;;EAGC,iBAAA;A5C8kgBD;A4C3kgBA;EACC,eAAA;EACA,gBAAA;A5C6kgBD;A4C1kgBA;EACC,4BAAA;A5C4kgBD;A4CzkgBA;EACC,6BAAA;A5C2kgBD;A4CxkgBA;EACC,ezCz8Fc;AHmhmBf;A4CvkgBA;;;EAGC,iBAAA;A5CykgBD;A4CtkgBA;EACC,aAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;A5CwkgBD;A4CrkgBA;EACC,qBAAA;A5CukgBD;A4CpkgBA;EACC,kBAAA;A5CskgBD;A4CnkgBA;EACC,sBAAA;A5CqkgBD;A4ClkgBA;EACC,kBAAA;A5CokgBD;A4CjkgBA;EACC,wBAAA;A5CmkgBD;A4ChkgBA;EACC,UAAA;A5CkkgBD;A4C/jgBA;EACC,cAAA;A5CikgBD;A4C9jgBA;EACC,aAAA;EACA,qBAAA;EACA,mBAAA;A5CgkgBD;A4C7jgBA;EACC,eAAA;A5C+jgBD;A4C5jgBA;EACC,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;A5C8jgBD;A4C3jgBA;EACC,YAAA;EACA,SAAA;EACA,UAAA;EACA,kBAAA;EACA,OAAA;A5C6jgBD;A4C1jgBA;EACC,yBAAA;A5C4jgBD;A4CzjgBA;EACC,eAAA;A5C2jgBD;A4CxjgBA;EACC,YAAA;EACA,cAAA;A5C0jgBD;A4CvjgBA;EACC,iBAAA;EACA,eAAA;A5CyjgBD;A4CtjgBA;EACC,mBAAA;A5CwjgBD;A4CrjgBA;EACC,mBAAA;A5CujgBD;A4CpjgBA;EACC,mBAAA;A5CsjgBD;A4CnjgBA;EACC,mBAAA;A5CqjgBD;A4CljgBA;EACC,mBAAA;A5CojgBD;A4CjjgBA;EACC,mBAAA;A5CmjgBD;A4ChjgBA;EACC,mBAAA;A5CkjgBD;A4C/igBA;EACC,mBAAA;A5CijgBD;A4C9igBA;EACC,kBAAA;A5CgjgBD;A4C7igBA;EACC,gBAAA;EACA,UAAA;EACA,SAAA;EACA,kBAAA;A5C+igBD;A4C5igBA;EACC,ezCxlGc;AHsomBf;A4C3igBA;EACI,gBAAA;EACA,gBAAA;EACA,yBAAA;A5C6igBJ;A4C3igBA;EACI,yBAAA;A5C6igBJ;A4C3igBA;EACC,aAAA;EACA,yBzCh1GS;AH63mBV;A4C3igBA;EACC,yBzCn1GS;AHg4mBV;A4C1igBA;EACC,aAAA;A5C4igBD;A4CzigBA;EACC,iBAAA;A5C2igBD;A4CxigBA;EACC,qBAAA;A5C0igBD;A4CvigBA;EAEC,gBAAA;A5CwigBD;A4CrigBA;EACC,aAAA;EACA,qBAAA;A5CuigBD;A4CpigBA;EACC,aAAA;EACA,qBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;A5CsigBD;ACx3mBI;E2C40GJ;IAQE,WAAA;E5CwigBA;AACF;A4CrigBA;EACC,mBzC32GO;EyC42GP,gBAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,0CAAA;A5CuigBD;ACt4mBI;E2Cw1GJ;IASE,sBAAA;E5CyigBA;AACF;A4CtigBA;EACC,aAAA;A5CwigBD;A4CrigBA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBzCv5GsB;EyCw5GtB,yBAAA;A5CuigBD;A4CpigBA;EACC,wBAAA;A5CsigBD;A4CnigBA;EACC,ezCtqGc;AH2smBf;A4CligBA;EACC,gBAAA;EACA,aAAA;A5CoigBD;A4CjigBA;EACC,2BAAA;A5CmigBD;A4ChigBA;EACC,gBAAA;A5CkigBD;A4C/hgBA;EACC,gBAAA;EACA,WAAA;EACA,6BAAA;A5CiigBD;A4C9hgBA;EACC,0BAAA;A5CgigBD;A4C7hgBA;EACC,SAAA;EACA,cAAA;EACA,uBAAA;EACA,WAAA;A5C+hgBD;A4C7hgBA;EACC,iBAAA;A5C+hgBD;A4C7hgBA;EACC,gBzCp8GsB;EyCq8GtB,cAAA;EACA,ezC9sGc;EyC+sGd,gBAAA;A5C+hgBD;A4C5hgBA;EACC,kBAAA;A5C8hgBD;A4C3hgBA;EACC,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;A5C6hgBD;A4C1hgBA;EACC,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,yBAAA;EACA,UAAA;EACA,WAAA;EACA,mBAAA;A5C4hgBD;A4CzhgBA;EACC,czCx8GO;EyCy8GP,qBAAA;A5C2hgBD;A4CxhgBA;EACC,aAAA;EACA,aAAA;EACA,qBAAA;EACA,eAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;A5C0hgBD;A4CvhgBA;EACC,0CAAA;EACA,0CAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;A5CyhgBD;A4CthgBA;EACC,yBAAA;A5CwhgBD;A4CrhgBA;EACC,kBAAA;A5CuhgBD;A4CphgBA;EACC,SAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;A5CshgBD;A4CnhgBA;EACC,cAAA;A5CqhgBD;A4ClhgBA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;A5CohgBD;A4ClhgBA;EACC,2BAAA;EACA,aAAA;EACA,mBAAA;A5CohgBD;A4CjhgBA;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,ezCzyGc;EyC0yGd,gBzCjiHoB;EyCkiHpB,kBAAA;EACA,cAAA;A5CmhgBD;A4ChhgBA;EACC,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,ezCtzGc;AHw0mBf;A4ChhgBA;EACC,cAAA;A5CkhgBD;A4ChhgBA;EACC,kBAAA;EACA,kBAAA;A5CkhgBD;A4C/ggBA;EACC,yBAAA;EACA,gBzCzjHoB;EyC0jHpB,eAAA;EACA,kBAAA;EACA,cAAA;EACA,iBAAA;A5CihgBD;A4C/ggBA;EACC,cAAA;A5CihgBD;A4C9ggBA;EACC,WAAA;EACA,YAAA;EACA,aAAA;EACA,qBAAA;EACA,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,+BAAA;EACA,cAAA;EACA,eAAA;EACA,yBzClkHS;EyCmkHT,czCrjHO;EyCsjHP,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;A5CghgBD;A4C7ggBA;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,WAAA;EACA,YAAA;A5C+ggBD;A4C5ggBA;EACC,czC5kHO;AH0lnBR;A4C3ggBA;EACC,czChlHO;AH6lnBR;A4C1ggBA;EACC,0CAAA;A5C4ggBD;A4CzggBA;EACC,cAAA;A5C2ggBD;A4CxggBA;EACC,2BAAA;A5C0ggBD;A4CxggBA;EAGI,aAAA;EAGH,mBAAA;EACA,yBAAA;EACA,4BAAA;EACA,kBAAA;A5C0ggBD;A4CzggBC;EACC,cAAA;A5C2ggBF;A4CxggBA;EACC,WAAA;A5C0ggBD;A4CxggBA;EACC,cAAA;A5C0ggBD;A4CxggBA;EACC,gBAAA;A5C0ggBD;A4CxggBA;EACC,kBAAA;A5C0ggBD;A4CxggBA;EACC,aAAA;EACA,mBAAA;EACA,cAAA;EACA,ezC75Gc;EyC85Gd,gBzCvpHoB;AHiqnBrB;A4CxggBA;EACC,ezCl6Gc;AH46mBf;A4CvggBA;EACC,iBAAA;A5CyggBD;A4CvggBA;EACC,gCAAA;EACA,oBAAA;EACA,mBAAA;A5CyggBD;A4CvggBA;EACC,ezC96Gc;EyC+6Gd,gBzCtqHoB;EyCuqHpB,cAAA;EACA,mBAAA;EAGG,aAAA;EAGH,mBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;A5CyggBD;A4CvggBA;EACC,yBAAA;A5CyggBD;A4CvggBA;EACC,cAAA;EACA,ezCh8Gc;EyCi8Gd,gBzC1rHoB;EyC2rHpB,mBAAA;A5CyggBD;A4CvggBA;EACC,cAAA;EACA,eAAA;EACA,gBzChsHoB;EyCisHpB,kBAAA;A5CyggBD;A4CvggBA;EACC,eAAA;EACA,cAAA;EACA,gBzCtsHoB;EyCusHpB,gBAAA;A5CyggBD;A4CvggBA;EACC,gBAAA;A5CyggBD;A4CvggBA;EACC,cAAA;EACA,ezCv9Gc;EyCw9Gd,gBzC9sHoB;AHutnBrB;A4CvggBA;EACC,cAAA;A5CyggBD;A4CvggBA;EACC,mBAAA;A5CyggBD;A4CvggBA;EACC,cAAA;A5CyggBD;A4CvggBA;EACC,mBAAA;A5CyggBD;A4CvggBA;EACC,cAAA;A5CyggBD;A4CvggBA;EACC,mBAAA;A5CyggBD;A4CvggBA;EACC,cAAA;A5CyggBD;A4CvggBA;EACC,WAAA;EACA,YAAA;A5CyggBD;A4CvggBA;EACC,ezCp/Gc;EyCq/Gd,gBzC5uHoB;EyC6uHpB,cAAA;EACA,gBAAA;A5CyggBD;A4CvggBA;EACC,mBAAA;A5CyggBD;A4CvggBA;EACC,cAAA;A5CyggBD;A4CvggBA;EACC,aAAA;A5CyggBD;A4CvggBA;EACC,iBAAA;A5CyggBD;A4CvggBA;EACC,cAAA;A5CyggBD;A4CvggBA;EACC,gBzC9vHsB;EyC+vHtB,cAAA;EACA,ezCxgHc;AHihnBf;A4CvggBA;EACC,ezC9gHc;EyC+gHd,gBzCtwHoB;EyCuwHpB,cAAA;A5CyggBD;A4CvggBA;EACC,0BAAA;A5CyggBD;A4CvggBA;EACC,0BAAA;A5CyggBD;A4CvggBA;EACC,mBzCtvHO;EyCuvHP,0BAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;A5CyggBD;A4CvggBA;EACC,aAAA;A5CyggBD;A4CvggBA;EACC,mBAAA;EACA,ezCniHc;EyCoiHd,gBzC5xHoB;EyC6xHpB,cAAA;A5CyggBD;A4CvggBA;EACC,cAAA;EACA,ezC3iHc;EyC4iHd,gBzCnyHoB;AH4ynBrB;A4CvggBA;EACC,mBAAA;A5CyggBD;A4CvggBA;EACC,UAAA;A5CyggBD;A4CvggBA;EACC,kBAAA;A5CyggBD;A4CvggBA;EACC,kBAAA;EACA,MAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;A5CyggBD;A4CvggBA;EAGI,aAAA;EAGH,mBAAA;A5CyggBD;A4CvggBA;EACC,iBAAA;A5CyggBD;A4CvggBA;EACC,6BAAA;EACA,czCxyHO;AHiznBR;A4CvggBA;EACC,cAAA;A5CyggBD;A4CvggBA;EACC,aAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACG,8BAAA;EACA,4BAAA;EACA,6BAAA;EACA,iCAAA;A5CyggBJ;A4CvggBA;EAGI,aAAA;EAGH,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;A5CyggBD;A4CvggBA;EACC,UAAA;A5CyggBD;A4CvggBA;EACC,mBAAA;A5CyggBD;A4CvggBA;EACC,ezCzmHc;EyC0mHd,cAAA;A5CyggBD;A4CvggBA;EACC,qCAAA;A5CyggBD;A4CvggBA;EACC,aAAA;EACA,iBAAA;A5CyggBD;A4CvggBA;EACC,ezCvnHc;EyCwnHd,gBzC/2HoB;EyCg3HpB,cAAA;A5CyggBD;A4CvggBA;EACC,aAAA;A5CyggBD;A4CvggBA;EACC,kBAAA;A5CyggBD;;A4CnggBQ;EACI,yBzCp2HJ;EyCq2HI,gCAAA;A5CsggBZ;A4CnggBI;EACI,oCAAA;A5CqggBR;;A4CjggBI;EACI,aAAA;A5CoggBR;;A4C//fQ;E3CvyHL,S2CwyHiC;E3CvyHjC,mB2CuyHmC;EAC1B,YAAA;A5CmggBZ;A4CjggBQ;EAGL,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACS,czC7xHD;EyC8xHC,oBAAA;EACA,UAAA;E3C5zHV,kB2C6zH4B;E3C5zH5B,M2C4zHqC;E3C3zHrC,W2C2zHuC;E3C1zHvC,S2C0zH4C;A5CsggB9C;;A4CjggBI;EACI,+BAAA;EACA,gBAAA;EACA,UAAA;A5CoggBR;A4CnggBQ;EACI,gCAAA;E3C/zHT,S2Cg0HiC;E3C/zHjC,a2C+zHmC;E3C50HpC,oB2C60H8B;A5CwggBhC;A4CvggBY;EACI,yBzCpzHL;AH6znBX;A4CvggBY;EACI,yBzCvzHL;AHg0nBX;A4CvggBY;E3Cx0HT,kB2Cy0HqC;EACxB,kBAAA;A5CyggBhB;A4CxggBgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A5C0ggBpB;A4CvggBY;EAGF,aAAA;EACA,8BAAA;EACH,sCAAA;EACA,4BAAA;A5CyggBP;A4CxggBgB;EACI,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,czCr7HR;EyCs7HQ,ezC3sHL;EyC4sHK,gBzCl8HD;AH48nBnB;A4CxggBgB;EACI,czC50HT;EyC60HS,ezC98HH;EyC+8HG,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A5C0ggBpB;A4CxggBgB;EACI,czCv1HT;EyCw1HS,ezC5tHL;AHsunBf;A4CvggBoB;EACI,iBAAA;A5CyggBxB;;A4CjggBA;E3Cp4HE,oB2Cq4HsB;A5CsggBxB;A4CrggBI;EACI,+BAAA;EACA,gBAAA;A5CuggBR;A4CnggBQ;EACI,aAAA;E3Cj4HT,mB2Ck4HiC;E3Cj4HjC,e2Ci4H8C;A5CsggBjD;A4CnggBI;EACI,kBAAA;EACA,YAAA;EACA,WAAA;A5CqggBR;A4CpggBQ;EACI,YAAA;EACA,eAAA;EACA,WAAA;EACA,2BAAA;A5CsggBZ;A4CnggBI;E3Ch5HD,qB2Ci5H6B;E3Ch5H7B,U2Cg5H2C;EACtC,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A5CsggBR;A4CpggBI;E3Cv5HD,c2Cw5H6B;E3Cv5H7B,U2Cu5HoC;EAC/B,WAAA;A5CuggBR;A4CrggBY;EACI,mBAAA;A5CuggBhB;A4CtggBgB;EACI,QAAA;EACA,YAAA;EACA,WAAA;A5CwggBpB;A4CtggBgB;EAGL,aAAA;EAGJ,qBAAA;EAEA,sBAAA;E3C16HJ,kB2C26HyC;E3C16HzC,U2C06HqD;A5CyggBxD;A4CxggBoB;E3C56HjB,S2C66H6C;E3C56H7C,mB2C46H+C;EAC1B,kBAAA;A5C2ggBxB;A4C1ggBwB;E3C/6HrB,e2Cg7HiD;E3C/6HjD,U2C+6HyD;A5C6ggB5D;A4C3ggBwB;E3Cl7HrB,S2Cm7HiD;E3Cl7HjD,U2Ck7HmD;A5C8ggBtD;A4C5ggBwB;EACI,oCAAA;EACA,8BAAA;EACA,6BAAA;EACA,mCAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;E3Cp8H1B,kB2Cq8H4C;E3Cp8H5C,M2Co8HqD;E3Cn8HrD,Y2Cm8HuD;E3Cj8HvD,U2Ci8HkE;A5CihgBpE;A4C/ggBuB;E3C/7HpB,S2Cg8HiD;E3C/7HjD,kB2C+7HmD;E3Cx6HpD,mB2Cy6H2C;EACjB,yBAAA;EACA,qBAAA;EACA,kBAAA;A5CkhgB5B;A4ChhgBwB;E3C96HtB,+B2C+6H2C;A5CkhgB7C;A4C/ggBoB;EAGR,aAAA;E3C78HT,c2C88H6C;E3C78H7C,c2C68HoD;EAC/B,WAAA;A5CkhgBxB;A4CjhgBwB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;A5CmhgB5B;A4ClhgB4B;E3C59H1B,kB2C69HgD;E3C59HhD,M2C49HyD;E3C39HzD,Q2C29H2D;E3C19H3D,S2C09H6D;E3Cz9H7D,O2Cy9H+D;EACjC,mBzCjiIxB;EyCkiIwB,WAAA;EACA,YAAA;E3Cp+H9B,oB2Cq+HkD;A5C0hgBpD;A4CvhgBgC;EACI,UAAA;A5CyhgBpC;A4CrhgBuB;EACK,aAAA;A5CuhgB5B;A4CphgBwB;EACI,eAAA;A5CshgB5B;A4CphgBwB;E3Ch/HtB,kB2Ci/H4C;E3Ch/H5C,Q2Cg/HqD;E3C7+HrD,S2C6+HmE;EACzC,gCAAA;EACA,UAAA;E3Cv/H1B,oB2Cw/H8C;EACpB,czCzjIpB;EyC0jIoB,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;A5C0hgB5B;A4CvhgBoB;EAGZ,aAAA;EACa,mBAAA;EACb,yBAAA;EACA,sBAAA;E3C1/HL,e2C2/H6C;E3C1/H7C,U2C0/HqD;EAEhD,eAAA;EACgB,WAAA;EACA,2BAAA;EACA,gBAAA;A5C0hgBxB;A4CzhgBwB;E3CjgIrB,S2CkgIiD;E3CjgIjD,mB2CigImD;EAC1B,kBAAA;A5C4hgB5B;A4C1hgB4B;E3C7gI1B,kB2C8gIgD;E3C7gIhD,Q2C6gIyD;E3C5gIzD,W2C4gI6D;E3C1gI7D,S2C0gIuE;EACzC,gCAAA;EACA,mBzClmItB;EyCmmIsB,WAAA;EACA,WAAA;EACA,UAAA;A5C+hgBhC;A4C5hgBwB;EACI,4BAAA;A5C8hgB5B;A4C5hgBwB;EACI,czC5/HjB;AH0hoBX;A4CzhgBY;EACI,kBAAA;EACA,mBAAA;A5C2hgBhB;A4C1hgBgB;EACI,kBAAA;E3C3hIjB,kB2C4hIyC;E3C3hIzC,U2C2hIoD;A5C6hgBvD;A4C5hgBoB;EACI,oCAAA;EACA,+BAAA;EACA,6BAAA;EACA,kCAAA;EACA,WAAA;EACA,SAAA;E3C3iItB,kB2C4iIwC;E3C3iIxC,Q2C2iIiD;E3C1iIjD,W2C0iIqD;E3CxiIrD,U2CwiI+D;EACzC,QAAA;A5CiigBxB;A4C/hgBoB;E3CviIjB,S2CwiI6C;E3CviI7C,kB2CuiI+C;E3ChhIhD,mB2CihIuC;EACjB,yBzCpoId;EyCqoIc,cAAA;EACA,kBAAA;A5CkigBxB;A4CjigBwB;EACI,czC1nIpB;EF4EL,S2C+iIiD;E3C9iIjD,U2C8iImD;A5CoigBtD;A4ChigBgB;EACI,cAAA;A5CkigBpB;A4CjigBoB;EACI,eAAA;A5CmigBxB;A4C/hgBY;EAGR,aAAA;EACM,mBAAA;EACN,yBAAA;EACA,sBAAA;EAEE,eAAA;E3ClkIH,e2CmkIqC;E3ClkIrC,U2CkkI6C;EAChC,WAAA;EACA,gBAAA;A5CkigBhB;A4CjigBgB;EACI,+BAAA;A5CmigBpB;A4ChigBY;EAGR,aAAA;E3C7kID,c2C8kIqC;E3C7kIrC,c2C6kI4C;EAC/B,WAAA;A5CmigBhB;A4CligBgB;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;A5CoigBpB;A4CnigBoB;E3C5lIlB,kB2C6lIwC;E3C5lIxC,M2C4lIiD;E3C3lIjD,Q2C2lImD;E3C1lInD,S2C0lIqD;E3CzlIrD,O2CylIuD;EACjC,mBzCjqIhB;EyCkqIgB,WAAA;EACA,YAAA;E3CpmItB,oB2CqmI0C;A5C2igB5C;A4CxigBwB;EACI,UAAA;A5C0igB5B;A4CtigBe;EACK,aAAA;A5CwigBpB;A4CrigBgB;EACI,eAAA;A5CuigBpB;A4CrigBgB;E3ChnId,kB2CinIoC;E3ChnIpC,Q2CgnI6C;E3C7mI7C,S2C6mI2D;E3CtpI3D,gC2CupIqC;E3CtpIrC,wC2CspIqC;E3CrpIrC,oC2CqpIqC;E3CtnIrC,oB2CunIsC;EACpB,UAAA;EACA,czCzrIZ;EyC0rIY,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,kBAAA;A5C6igBpB;A4CvigBQ;EACI,ezCnuIK;EyCouIL,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,0BAAA;A5CyigBZ;A4CxigBY;EACI,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;E3C1oId,kB2C2oIgC;E3C1oIhC,Q2C0oIyC;E3CzoIzC,U2CyoI6C;EAC/B,WAAA;A5C4igBhB;A4C1igBY;EACI,yBAAA;EACA,WAAA;EACA,WAAA;E3CzoIb,kB2C0oIqC;E3ClpItC,kB2CmpIgC;E3ClpIhC,Q2CkpIyC;E3C/oIzC,S2C+oIuD;EACzC,WAAA;A5C8igBhB;;A4CxigBA;EACI,yBzC/tII;EyCguIJ,6BAAA;E3CppID,S2CqpIyB;E3CppIzB,oB2CopI2B;A5C4igB9B;A4C3igBI;EACI,+CAAA;EACA,oBAAA;EACA,gBAAA;A5C6igBR;;AChwoBI;E2CutIA;IACI,QAAA;IACA,UAAA;IACA,mBAAA;E5C6igBN;E4C1igBE;I3C3qIF,kB2C4qIwB;I3C1qIxB,a2C0qIwC;IAClC,UAAA;IACA,kBAAA;IACA,WAAA;E5C6igBN;E4C3igBE;IACI,aAAA;IACA,mBAAA;E5C6igBN;AACF;A4C1igBA;EACI,WAAA;EACA,YAAA;EACA,gBAAA;A5C4igBJ;A4C3igBC;EACC,WAAA;EACA,UAAA;EACA,WAAA;EACA,yBzCnwIM;EyCowIN,cAAA;EACA,YAAA;E3CzrIC,a2C0rIuB;E3ClqIxB,kB2CmqIiB;A5C6igBnB;A4C5igBE;EACC,qCAAA;A5C8igBH;A4C5igBE;EACC,qCAAA;A5C8igBH;A4C5igBE;EACC,qCAAA;A5C8igBH;;A4C1igBA;EACC;IACC,UAAA;E5C6igBA;AACF;A4CzigBC;EACC,WAAA;A5C2igBF;A4CzigBC;EACC,czCxyIQ;AHm1oBV;A4CzigBC;EACC,czCryIO;AHg1oBT;;A4CvigBC;EACC,aAAA;A5C0igBF;A4CxigBC;EACC,mBzCnqIQ;EyCoqIR,kBAAA;EACA,aAAA;A5C0igBF;A4CxigBG;EACC,mBzC5zIM;EyC6zIN,WAAA;EACA,YAAA;EACA,mBAAA;EAGY,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A5C0igBhB;A4CzigBI;EACC,mBAAA;EACA,czC7zIG;AHw2oBR;A4CvigBE;EACC,mBAAA;EACA,YAAA;EACA,aAAA;A5CyigBH;A4CxigBG;EACC,kBAAA;A5C0igBJ;;A4CnigBE;EACC,ezCjnIY;EyCknIZ,czC90IK;EyC+0IL,mBAAA;A5CsigBH;A4CrigBG;EACC,cAAA;EACA,czChtIS;AHuvoBb;A4CrigBG;EACC,gBAAA;A5CuigBJ;;A6C75oBA;EACI,qBAAA;EAEA,WAAA;E5CyGD,gB4CxGyB;E5CyGzB,U4CzGkC;A7Cg6oBrC;A6C/5oBI;EACI,qBAAA;EACA,WAAA;A7Ci6oBR;A6Ch6oBQ;EACI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,gB1CLW;E0CMX,0BAAA;EAGA,qBAAA;A7Ck6oBZ;A6Cj6oBY;EACI,kCAAA;A7Cm6oBhB;A6Cj6oBY;EACI,e1CyOD;E0CxOC,mBAAA;EACA,cAAA;A7Cm6oBhB;;A6C95oBA;EACI,mBAAA;A7Ci6oBJ;;A6C95oBI;EACI,kBAAA;A7Ci6oBR;A6C/5oBI;EACI,YAAA;A7Ci6oBR;A6Ch6oBQ;EACI,aAAA;A7Ck6oBZ;;A6C75oBI;EACI,c1CnBE;AHm7oBV;A6C95oBI;EACI,yB1C6EG;AHm1oBX;A6C55oBY;EACI,e1CwMD;E0CvMC,c1ClCJ;AHg8oBZ;;A6Cx5oBI;;;EAGI,c1C9BA;E0C+BA,gB1CvDW;AHk9oBnB;;A6Cv5oBI;EACI,eAAA;EACA,YAAA;A7C05oBR;A6Cz5oBQ;EACI,gBAAA;A7C25oBZ;;A8Cn+oBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EAEA,sBAAA;A9Cs+oBJ;;A8Cp+oBA;EACI,yDAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A9Cu+oBJ;ACh9oBI;E6CrCJ;IAgBQ,YAAA;E9Cy+oBN;AACF;A8Cx+oBI;EACI,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;A9C0+oBR;AC59oBI;E6CnBA;IAOQ,kBAAA;IACA,gBAAA;E9C4+oBV;AACF;ACl+oBI;E6CnBA;IAWQ,WAAA;IACA,aAAA;IACA,YAAA;E9C8+oBV;AACF;ACz+oBI;E6CnBA;IAgBQ,aAAA;IACA,YAAA;E9Cg/oBV;AACF;A8C/+oBQ;EACI,mBAAA;A9Ci/oBZ;ACl/oBI;E6CAI;IAGQ,mBAAA;E9Cm/oBd;AACF;A8Cj/oBQ;EACI,e3C0MG;E2CzMH,c3CsED;E2CrEC,gB3ClDO;AHqipBnB;A8Cj/oBQ;EACI,e3CgNG;E2C/MH,gB3CtDO;E2CuDP,mBAAA;A9Cm/oBZ;ACjgpBI;E6CWI;IAKQ,e3C0MD;EH2yoBb;AACF;ACtgpBI;E6CWI;IAQQ,e3CqMD;EHkzoBb;AACF;AC3gpBI;E6CWI;IAWQ,e3C6LD;EH4zoBb;AACF;A8Cx/oBY;EACI,e3CmMD;E2ClMC,c3C1DN;AHojpBV;ACphpBI;E6CwBQ;IAIQ,e3C8LL;EH8zoBb;AACF;ACzhpBI;E6CwBQ;IAOQ,e3CyLL;EHq0oBb;AACF;AC9hpBI;E6CwBQ;IAUQ,e3CiLL;EH+0oBb;AACF;A8C7/oBQ;EACI,e3CqKG;E2CpKH,gBAAA;EACA,kBAAA;EACA,YAAA;A9C+/oBZ;A8C7/oBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,cAAA;A9C+/oBZ;ACrjpBI;E6C4CI;IAYQ,cAAA;E9CigpBd;AACF;A8ChgpBY;EACI,yBAAA;EACA,yB3C9ER;E2C+EQ,e3CgJD;E2C/IC,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,e3CmID;E2ClIC,gB3CtHK;E2CuHL,sBAAA;EACA,kBAAA;EACA,cAAA;A9CkgpBhB;AChlpBI;E6C0DQ;IAsBQ,WAAA;IACA,YAAA;IACA,iBAAA;E9CogpBlB;AACF;A8CngpBgB;EACI,c3CnHR;E2CoHQ,e3C+HL;E2C9HK,mBAAA;A9CqgpBpB;AC5lpBI;E6CoFY;IAKQ,e3CsHT;EHi5oBb;AACF;A8CrgpBgB;EACI,c3C3HR;E2C4HQ,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,6BAAA;A9CugpBpB;A8CrgpBgB;EACI,eAAA;A9CugpBpB;A8CngpBQ;EACI,kBAAA;A9CqgpBZ;A8CpgpBY;EACI,kBAAA;EACA,YAAA;EACA,WAAA;A9CsgpBhB;A8CpgpBY;EACI,YAAA;EACA,oBAAA;A9CsgpBhB;A8CpgpBY;EACI,c3CnJJ;E2CoJI,gB3ChKO;AHsqpBvB;A8CngpBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,gBAAA;A9CqgpBZ;ACxopBI;E6CyHI;IAYQ,gBAAA;E9CugpBd;AACF;A8CtgpBY;EACI,iBAAA;A9CwgpBhB;A8CvgpBgB;EACI,eAAA;A9CygpBpB;A8CvgpBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,yB3CtLR;E2CuLQ,kBAAA;A9CygpBpB;A8CxgpBoB;EACI,yB3C3Ld;AHqspBV;A8CxgpBoB;EACI,c3ChLhB;AH0rpBR;;A+C1tpBA;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EAEA,eAAA;EAGA,aAAA;A/C6tpBJ;A+C5tpBI;EACI,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,2BAAA;A/C8tpBR;A+C7tpBQ;EACI,oCAAA;EACA,mCAAA;UAAA,2BAAA;A/C+tpBZ;A+C7tpBQ;EACI,yDAAA;A/C+tpBZ;A+C7tpBQ;EACI,yDAAA;A/C+tpBZ;A+C7tpBQ;EACI,yDAAA;A/C+tpBZ;A+C7tpBQ;EACI,yDAAA;A/C+tpBZ;A+C5tpBI;EACI,UAAA;EACA,aAAA;E9C4EL,a8C3EmC;EAC9B,cAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,eAAA;A/C8tpBR;ACztpBI;E8CnBA;IAgBQ,WAAA;E/CgupBV;AACF;A+C/tpBQ;EACI,cAAA;EACA,gBAAA;EACA,YAAA;A/CiupBZ;A+ChupBY;EACI,mBAAA;A/CkupBhB;ACtupBI;E8COI;IAEQ,gBAAA;E/CiupBd;AACF;A+ChupBY;EACI,2BAAA;A/CkupBhB;A+CjupBgB;EACI,e5C6LL;E4C5LK,c5C7CR;E4C8CQ,gBAAA;EACA,gB5C7DC;AHgypBrB;A+ChupBY;EACI,mBAAA;A/CkupBhB;A+CjupBgB;EACI,WAAA;EACA,YAAA;EACA,mB5C3CZ;E4C4CY,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gB5CvED;E4CwEC,e5CmLL;E4ClLK,c5CjDZ;E4CkDY,aAAA;A/CmupBpB;ACpwpBI;E8CsBY;IAaQ,WAAA;IACA,YAAA;E/CqupBtB;AACF;A+ClupBY;EACI,cAAA;A/CoupBhB;A+ClupBY;EACI,iBAAA;A/CoupBhB;A+ClupBS;EACO,kBAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;A/CoupBhB;A+ClupBY;EAEI,c5C7EP;E4C8EO,e5CmJD;E4ClJC,gB5CrGK;AHw0pBrB;A+C/tpBQ;E9CHL,gB8CIkC;A/CiupBrC;A+ChupBa;EACG,e5CiJD;E4ChJC,gB5C1GG;EFmGhB,gB8CQsC;EACzB,c5CpFR;AHszpBR;A+ChupBa;EACG,e5CsID;E4CrIC,gB5CnHK;E4CoHL,c5CtGJ;E4CuGI,gBAAA;A/CkupBhB;A+ChupBY;EACI,gBAAA;EACA,mBAAA;A/CkupBhB;A+C/tpBQ;EACI,mBAAA;A/CiupBZ;A+ChupBY;EACI,WAAA;EACA,c5ClHJ;E4CmHI,mBAAA;EACA,e5CsHD;E4CrHC,gB5CnIK;AHq2pBrB;A+ChupBY;EACI,kBAAA;A/CkupBhB;A+CjupBgB;E9CzCd,kB8C0CoC;E9CzCpC,S8CyC6C;E9CxC7C,W8CwCkD;A/CqupBpD;A+CjupBY;EACI,WAAA;EACA,YAAA;EACA,2CAAA;E9CjBd,kB8CkB+B;E9CzC9B,e8C0C2C;E9CvD5C,yB8CwDkC;A/CqupBpC;A+CpupBgB;EACI,yBAAA;A/CsupBpB;A+CnupBY;EACI,WAAA;EACA,gB5CtJG;E4CuJH,e5C6FD;E4C5FC,mB5C/IN;E4CgJM,qB5ChJN;EF2FP,a8CsD2C;E9CnE5C,yB8CoEkC;EACpB,eAAA;EACA,c5CtIR;AH62pBR;A+CtupBgB;EACG,2CAAA;EACA,c5CvJT;AH+3pBV;A+CrupBY;EACI,mBAAA;A/CuupBhB;A+CtupBgB;EACI,e5C9KH;E4C+KG,gB5C1KC;E4C2KD,c5CZR;AHovpBZ;A+CvupBoB;EACI,c5CjKd;E4CkKc,gB5C5KD;AHq5pBvB;A+CrupBY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;A/CuupBhB;ACh3pBI;E8CsIQ;IAKQ,sBAAA;E/CyupBlB;AACF;A+CxupBgB;EACI,WAAA;EACA,YAAA;A/C0upBpB;A+CxupBgB;EACI,gBAAA;EACA,gBAAA;A/C0upBpB;A+CvupBY;EACI,c5C7KP;E4C8KO,e5CoDD;E4CnDC,gB5CnMO;AH46pBvB;A+CtupBQ;EACI,mBAAA;A/CwupBZ;A+CvupBY;EACI,e5C6CD;E4C5CC,gB5C5MK;E4C6ML,c5C/LJ;AHw6pBZ;AC14pBI;E8C8JQ;IAKQ,e5CpNH;EH+7pBf;AACF;A+C1upBgB;EACI,c5CpMR;E4CqMQ,gB5ChND;E4CiNC,e5CmCL;AHyspBf;A+CzupBY;EACI,c5ClMP;AH66pBT;A+CxupBQ;EACI,kBAAA;EACA,kBAAA;EACA,c5C/DA;E4CgEA,e5CpOK;E4CqOL,gB5ChOS;E4CiOT,mBAAA;A/C0upBZ;A+CzupBY;EACI,kBAAA;EACA,e5CzOC;E4C0OD,c5CxEH;E4CyEG,gB5CnOG;AH88pBnB;A+C1upBgB;EACI,WAAA;EACA,mB5C1ER;E4C2EQ,WAAA;EACA,WAAA;E9C7IlB,kB8C8IoC;E9C7IpC,S8C6I6C;E9C1I7C,W8C0I4D;A/C8upB9D;AC96pBI;E8C2LY;IAOQ,WAAA;E/CgvpBtB;AACF;A+C9upBgB;EACI,WAAA;EACA,mB5CpFR;E4CqFQ,WAAA;EACA,WAAA;E9CvJlB,kB8CwJoC;E9CvJpC,S8CuJ6C;E9CtJ7C,Y8CsJkD;A/CkvpBpD;AC57pBI;E8CqMY;IAOQ,WAAA;E/CovpBtB;AACF;A+ChvpBQ;EACI,gBAAA;EACC,YAAA;A/CkvpBb;A+ChvpBQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,c5CtGA;E4CuGA,e5CZG;E4CeH,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E9CjJV,kB8CkJ2B;E9CvN3B,2B8CwN6B;E9CvN7B,mC8CuN6B;E9CtN7B,+B8CsN6B;E9CnL7B,kB8CoL4B;E9CnL5B,Q8CmLqC;E9ClLrC,W8CkLyC;A/CsvpB3C;A+CrvpBY;EACI,c5CxQN;AH+/pBV;A+CpvpBQ;EACI,eAAA;EACA,WAAA;EACA,YAAA;EACA,c5C5HA;E4C6HA,e5ClCG;E4CqCH,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E9CvKV,kB8CwK2B;E9C7O3B,2B8C8O6B;E9C7O7B,mC8C6O6B;E9C5O7B,+B8C4O6B;E9CzM7B,kB8C0M4B;E9CzM5B,Q8CyMqC;E9CxMrC,W8CwMyC;A/C0vpB3C;A+CzvpBY;EACI,c5C9RN;AHyhqBV;A+CxvpBQ;EACI,kBAAA;EACA,e5CpTK;AH8iqBjB;A+CzvpBY;EACI,e5C3DD;E4C4DC,cAAA;A/C2vpBhB;A+CxvpBQ;EACI,gBAAA;A/C0vpBZ;A+CzvpBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,eAAA;A/C2vpBhB;A+C1vpBgB;EACI,kBAAA;EACA,kBAAA;A/C4vpBpB;AClhqBI;E8CoRY;IAIQ,WAAA;IACA,mBAAA;E/C8vpBtB;AACF;A+C5vpBoB;EACI,gBAAA;A/C8vpBxB;AC3hqBI;E8C4RgB;IAGQ,gBAAA;E/CgwpB1B;AACF;A+C9vpBoB;EACI,c5CjUZ;E4CkUY,WAAA;EACA,2CAAA;EACA,mB5CxThB;E4C2TgB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E9C7NtB,mB8C8NuC;E9CtPtC,kB8CuP6C;E9CtP7C,kB8CsPyD;EACpC,gB5C7VH;AH8lqBrB;A+ChwpBwB;EACI,mB5CpVlB;E4CqVkB,c5CvUpB;AHykqBR;A+ChwpBwB;EACI,WAAA;EACA,YAAA;A/CkwpB5B;A+C/vpBoB;EACI,mBAAA;EACA,mBAAA;A/CiwpBxB;A+C/vpBoB;EACI,mBAAA;EACA,mB5CnVhB;AHolqBR;A+C3vpBI;EACI,WAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;A/C6vpBR;A+C5vpBQ;EACI,mB5CnWJ;E4CoWI,sDAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;A/C8vpBZ;A+C3vpBI;EACI,UAAA;A/C6vpBR;ACtlqBI;E8CwVA;IAGQ,aAAA;E/C+vpBV;AACF;A+C9vpBS;EACG,WAAA;EACA,aAAA;A/CgwpBZ;A+C5vpBQ;EACI,cAAA;EACA,gBAAA;EACA,YAAA;A/C8vpBZ;A+C1vpBI;EACI,gBAAA;EACA,YAAA;A/C4vpBR;;A+CzvpBA;EACI,cAAA;EACA,aAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A/C4vpBJ;A+CzvpBY;EACI,mBAAA;A/C2vpBhB;A+C1vpBgB;EACI,WAAA;EACA,YAAA;EACA,mB5CpZZ;E4CqZY,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gB5ChbD;E4CibC,e5CtLL;E4CuLK,c5C1ZZ;E4C2ZY,aAAA;A/C4vpBpB;ACtoqBI;E8C+XY;IAaQ,WAAA;IACA,YAAA;E/C8vpBtB;AACF;;AC5oqBI;E8CqZA;IAEQ,kBAAA;IACA,gBAAA;E/C0vpBV;AACF;;A+CpvpBY;EACI,MAAA;A/CuvpBhB;;A+ClvpBA;EACI,kBAAA;A/CqvpBJ;A+CpvpBI;EACI,WAAA;EACA,WAAA;EACA,WAAA;EACA,mB5C3cE;EF6CR,mB8C+ZyB;E9C9ZzB,2B8C8ZyB;E9C7ZzB,uB8C6ZyB;E9C9XzB,yB8C+X0B;E9C3X1B,kB8C4XwB;E9CzXxB,Y8CyX2C;E9CxX3C,O8CwXgD;A/C4vpBlD;A+C1vpBI;E9CnaF,mB8CoayB;E9CnazB,2B8CmayB;E9ClazB,uB8CkayB;A/C8vpB3B;A+C5vpBI;EACI,yBAAA;A/C8vpBR;;A+C3vpBA;EACI,cAAA;EACA,aAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;A/C8vpBJ;A+C7vpBI;EACI,WAAA;EACA,4BAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;A/C+vpBR;A+C7vpBI;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,qBAAA;A/C+vpBR;A+C9vpBQ;EACI,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;A/CgwpBZ;A+C9vpBQ;EACI,iCAAA;EACA,sDAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,WAAA;A/CgwpBZ;A+C/vpBY;EACI,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,aAAA;EACA,WAAA;A/CiwpBhB;A+ChwpBgB;EACI,eAAA;EACA,UAAA;A/CkwpBpB;A+CjwpBoB;EACI,kBAAA;EACA,mBAAA;A/CmwpBxB;A+ClwpBwB;EACI,oBAAA;EACA,yDAAA;EACA,yCAAA;A/CowpB5B;A+ClwpBwB;EACI,e5C/Rb;E4CgSa,gB5CphBT;E4CqhBS,mBAAA;A/CowpB5B;A+ClwpBwB;EACI,e5CjSb;E4CkSa,gB5CzhBT;E4C0hBS,gBAAA;A/CowpB5B;A+ChwpBwB;EACI,kBAAA;EACA,kBAAA;EACA,mB5CxhBlB;E4CyhBkB,gB5CliBT;E4CmiBS,yBAAA;A/CkwpB5B;A+CjwpB4B;EACI,c5C5hBtB;E4C6hBsB,mBAAA;A/CmwpBhC;A+ChwpBwB;EACI,kBAAA;A/CkwpB5B;A+CjwpB4B;EACI,kBAAA;A/CmwpBhC;A+C5vpBQ;EACI,uBAAA;A/C8vpBZ;A+C7vpBY;EACI,kBAAA;A/C+vpBhB;A+C9vpBgB;EACI,eAAA;A/CgwpBpB;;AgDh0qBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,eAAA;AhDm0qBR;AgDj0qBY;EACI,WAAA;EACA,UAAA;AhDm0qBhB;AgDh0qBQ;EACI,UAAA;E/C2FT,e+C1FuC;AhDk0qB1C;ACnyqBI;E+CjCI;IAIQ,UAAA;I/CwFb,c+CvF2C;EhDo0qB5C;AACF;ACzyqBI;E+CjCI;IAQQ,WAAA;I/CoFb,U+CnF2C;EhDs0qB5C;AACF;AgDr0qBY;EACI,2CAAA;E/C+Eb,gB+C9EqC;E/C+ErC,uB+C/E+C;EAGlC,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;AhDw0qBhB;AgDt0qBoB;EACI,eAAA;EACA,gBAAA;AhDw0qBxB;AgDp0qBgB;EACI,iBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,wBAAA;AhDs0qBpB;AgDn0qBwB;EACI,gB7CrDP;E6CsDO,e7C5DX;E6C6DW,c7C7BpB;AHk2qBR;AgDl0qBwB;EACI,c7C9ChB;E6C+CgB,e7CyLb;E6CxLa,gB7C9DP;AHk4qBrB;AgDj0qBoB;EACI,c7CwBX;E6CvBW,gB7ChEL;EF2HjB,mB+C1DuC;EAGjB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,e7C6KT;E6C5KS,WAAA;EACA,YAAA;AhDm0qBxB;AgDl0qBwB;EACI,mB7CQf;E6CPe,c7CzDpB;AH63qBR;;AgD3zqBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,YAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;AhD8zqBJ;;AgD3zqBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,eAAA;AhD8zqBR;AgD7zqBQ;EACI,kBAAA;AhD+zqBZ;AC14qBI;E+C0EI;IAGQ,kBAAA;EhDi0qBd;AACF;;AC/4qBI;E+CqFQ;IACC,yBAAA;EhD8zqBX;EgD7zqBc;IACI,yBAAA;EhD+zqBlB;EgD5zqBU;IACI,UAAA;IACA,+BAAA;EhD8zqBd;EgD5zqBU;IACI,UAAA;EhD8zqBd;AACF;AgD1zqBI;EACI,mBAAA;AhD4zqBR;AgDxzqBgB;EACI,UAAA;AhD0zqBpB;AgDxzqBgB;EACI,UAAA;AhD0zqBpB;AgDzzqBoB;EACI,cAAA;AhD2zqBxB;AgDzzqBoB;EACI,cAAA;AhD2zqBxB;AgDpzqBO;EACK,yBAAA;EACA,aAAA;EAGA,aAAA;EAEA,eAAA;AhDszqBZ;ACv7qBI;E+C0HG;IASK,SAAA;EhDwzqBV;AACF;AgDvzqBY;EACI,c7CpKJ;E6CqKI,e7CxLC;E6CyLD,gB7CnLK;E6CoLL,UAAA;EACA,+BAAA;E/C/Eb,a+CgF2C;AhDyzqB9C;ACp8qBI;E+CqIQ;IAQQ,WAAA;IACA,eAAA;EhD2zqBlB;AACF;AgDzzqBY;EACI,c7CnKR;E6CoKQ,e7CpMC;E6CqMD,gB7C/LK;E6CgML,UAAA;E/C1Fb,a+C2F2C;AhD2zqB9C;ACj9qBI;E+CiJQ;IAOQ,WAAA;EhD6zqBlB;AACF;AgD3zqBY;EACI,aAAA;EACA,c7C9KR;E6C+KQ,e7C/MC;E6CgND,gB7C1MK;E6C2ML,UAAA;AhD6zqBhB;AgD3zqBY;EACI,6BAAA;AhD6zqBhB;ACh+qBI;E+CkKQ;IAGQ,SAAA;EhD+zqBlB;AACF;ACr+qBI;E+C2KI;IACI,gBAAA;EhD6zqBV;EgD5zqBU;IACI,cAAA;EhD8zqBd;EgD5zqBgB;IACE,mBAAA;EhD8zqBlB;AACF;;AgDvzqBA;EACI,kBAAA;EACA,WAAA;AhD0zqBJ;AgDzzqBI;EACI,sBAAA;EACA,gBAAA;AhD2zqBR;ACz/qBI;E+C4LA;IAIQ,YAAA;EhD6zqBV;AACF;AgD1zqBI;EACI,e7CtPS;E6CuPT,c7CpOI;E6CqOJ,gB7ClPa;AH8irBrB;AgDzzqBI;EACI,e7CDO;E6CEP,gB7CxPa;E6CyPb,c7C3OI;AHsirBZ;;AgDrzqBQ;EACI,kBAAA;AhDwzqBZ;AgDtzqBY;EACI,WAAA;EACA,YAAA;EACA,c7CxIL;E6CyIK,yBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E/CjLd,kB+CkLgC;E/CjLhC,U+CiLyC;E/ClJzC,mB+CmJ+B;AhDyzqBjC;AgDxzqBgB;EACI,mB7CtJT;E6CuJS,c7C1PZ;AHojrBR;AgDxzqBgB;EACI,e7C9BL;AHw1qBf;AgDvzqBY;E/C5LV,kB+C6LgC;E/C5LhC,U+C4LyC;E/C3LzC,Q+C2L+C;AhD2zqBjD;;AgDrzqBA;EACI,mBAAA;AhDwzqBJ;AC9irBI;E+CqPJ;IAGQ,mBAAA;EhD0zqBN;AACF;AgDzzqBI;EACI,e7ChDO;E6CiDP,c7C9KG;AHy+qBX;;AgDvzqBA;EACI,WAAA;EACA,YAAA;EACA,qBAAA;EACA,e7C5DW;EFtHb,mB+CmLmB;AhD0zqBrB;;AgDxzqBA;EACI,e7CzTa;E6C0Tb,gB7CpTiB;E6CqTjB,qBAAA;E/C/MD,iB+CgN+B;E/CzLhC,kB+C0LmB;EACjB,c7C/RI;E6CgSJ,kBAAA;EACA,eAAA;AhD2zqBJ;AgD1zqBI;EACI,mB7C7SE;AHymrBV;AgD1zqBI;EACI,mB7CtOK;AHkirBb;AgD1zqBI;EACI,mB7C/SE;AH2mrBV;AgD1zqBI;EACI,8BAAA;AhD4zqBR;AgD1zqBI;EACI,mB7C/MG;AH2grBX;AgD1zqBI;EACI,yB7CtTC;AHknrBT;AgD1zqBI;EACI,yB7C/TE;AH2nrBV;;AgDzzqBA;EACI,kBAAA;EACA,mB7CpUM;E6CqUN,iBAAA;EACA,e7C/FW;AH25qBf;;AgD1zqBA;EACI,kBAAA;EACA,mB7CpUK;E6CqUL,iBAAA;EACA,e7CrGW;AHk6qBf;;AgD3zqBA;EACI,kBAAA;EACA,mB7C5UM;E6C6UN,iBAAA;AhD8zqBJ;;AgD5zqBA;EACI,c7CpVM;EFuFP,iB+C8P+B;E/CvOhC,kB+CwOmB;EACjB,yBAAA;EACA,e7C7Wa;AH4qrBjB;;AgD5zqBA;EACI,c7CtVK;EFiFN,iB+CsQ+B;E/C/OhC,kB+CgPmB;EACjB,yBAAA;EACA,e7CrXa;AHorrBjB;;AgDzzqBQ;E/C/QL,iB+CgRuC;AhD4zqB1C;;AgDtzqBI;EACI,WAAA;EACA,YAAA;EACA,mB7CpXE;E6CuXF,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E/C3QN,kB+C4QuB;AhDyzqBzB;ACvprBI;E+CiVA;IAeQ,kBAAA;IACA,UAAA;IACA,cAAA;EhD2zqBV;AACF;AgDzzqBI;EACI,WAAA;EACA,YAAA;EACA,yDAAA;EACA,mB7CvYI;EFgHV,kB+CwRuB;AhD2zqBzB;ACrqrBI;E+CqWA;IAOQ,kBAAA;IACA,UAAA;IACA,cAAA;EhD6zqBV;AACF;AgD5zqBQ;EACI,c7CnYJ;E6CoYI,WAAA;EACA,YAAA;AhD8zqBZ;AgD3zqBI;EACI,mB7CrQM;AHkkrBd;;AgD1zqBA;EACI,yDAAA;EACA,4BAAA;EACA,4BAAA;AhD6zqBJ;;AgD3zqBA;EACI,mB7CnZI;E6CoZJ,oBAAA;AhD8zqBJ;;AgD5zqBA;EACI,gBAAA;EACA,WAAA;E/C3UD,2B+C4UyB;AhD+zqB5B;AgD9zqBI;E/C7UD,S+C8U6B;E/C7U7B,U+C6U+B;AhDi0qBlC;AgDh0qBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,aAAA;AhDk0qBZ;AgDj0qBY;EACI,UAAA;EACA,c7CtUL;E6CuUK,e7CtcC;E6CucD,gB7CjcK;EFsGlB,a+C4V2C;EAC9B,+BAAA;EACA,mB7CrSN;AHwmrBV;AgDj0qBY;EACI,c7C3SH;E6C4SG,e7C9cC;EF4Gd,a+CmW2C;EAC9B,gB7C3cK;E6C4cL,iBAAA;EACA,UAAA;AhDm0qBhB;AgDj0qBY;EACI,6BAAA;AhDm0qBhB;AgDj0qBY;EACI,c7CrcJ;E6CscI,gB7CjdG;AHoxrBnB;AgDj0qBY;EACI,c7C5VL;E6C6VK,gB7CrdG;AHwxrBnB;;AgD9zqBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,oBAAA;EACA,gCAAA;AhDi0qBJ;AC7vrBI;E+CibJ;IAaQ,oBAAA;EhDm0qBN;AACF;AClwrBI;E+CibJ;IAgBQ,sBAAA;EhDq0qBN;EgDp0qBM;IACI,gBAAA;EhDs0qBV;AACF;AgDp0qBI;EACI,e7CxfS;E6CyfT,gB7Clfe;AHwzrBvB;AgDp0qBI;EAGI,aAAA;AhDs0qBR;AgDp0qBI;EACI,cAAA;AhDs0qBR;;AgDn0qBA;EACI,iBAAA;AhDs0qBJ;AgDr0qBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,gBAAA;EACA,gBAAA;AhDu0qBR;AgDr0qBW;EACC,gB7C9gBS;E6C+gBT,e7CrhBK;E6CshBL,c7CtfJ;AH6zrBR;AgDr0qBW;EACC,c7CtgBA;E6CugBA,e7C/RG;E6CgSH,gB7CthBS;AH61rBrB;AgDp0qBQ;EACI,WAAA;EACA,YAAA;EACA,c7ClcC;E6CmcD,gB7C1hBO;EF2HjB,mB+Cga2B;EAGjB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,e7C9SG;AHonrBf;AgDr0qBY;EACI,mB7ChdH;E6CidG,c7CjhBR;AHw1rBR;AgDn0qBI;EACI,WAAA;E/CzcL,e+C0cmC;AhDq0qBtC;;AgDj0qBI;EACI,eAAA;AhDo0qBR;;AgDj0qBA;EACI,kBAAA;EACA,kBAAA;AhDo0qBJ;AgDn0qBI;EACI,eAAA;AhDq0qBR;AgDn0qBI;EACI,mB7CtiBA;E6CuiBA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;E/C7cN,kB+C8cuB;E/C9evB,kB+C+ewB;E/C9exB,Q+C8eiC;E/C3ejC,U+C2e+C;AhDu0qBjD;;AiD15rBA;EACI,mBAAA;AjD65rBJ;AiD55rBI;EACI,aAAA;EACA,4DAAA;EhDgIN,yBgD/HuB;AjD85rBzB;ACj3rBI;EgDhDA;IhDkIF,mBgD7H2B;EjDg6rB3B;AACF;AiD95rBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AjDg6rBR;ACj4rBI;EgDxCA;IAWQ,sBAAA;EjDk6rBV;AACF;AiDj6rBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AjDm6rBZ;AC94rBI;EgD3BI;IAQQ,sBAAA;EjDq6rBd;AACF;AiDn6rBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,0BAAA;EhDqFV,kBgDpF2B;EACjB,uDAAA;AjDq6rBZ;AiDp6rBY;EhDkFV,mBgDjF+B;AjDs6rBjC;AiDl6rBY;EACI,UAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,eAAA;EhDuCd,kBgDtCgC;EhDyChC,YgDzCmD;EhD0CnD,UgD1CwD;AjDs6rB1D;AiDp6rBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mB9CxDN;E8CyDM,WAAA;EACA,YAAA;EACA,UAAA;EhDuDd,mBgDtD+B;EhDsB/B,kBgDrBgC;EhDwBhC,YgDxBmD;EhDyBnD,UgDzBwD;AjDw6rB1D;AiDr6rBQ;EACI,kBAAA;AjDu6rBZ;ACx8rBI;EgDgCI;IAGQ,kBAAA;IhDwBb,sBgDvB2C;EjDy6rB5C;AACF;AiDx6rBY;EACI,e9CuKD;E8CtKC,c9CtEJ;E8CuEI,gB9ClFG;AH4/rBnB;AiDx6rBY;EACI,WAAA;EACA,e9C9FC;AHwgsBjB;;AiDr6rBA;EACI,kBAAA;AjDw6rBJ;AiDv6rBI;;EAII,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,2BAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,c9CWG;E8CVH,e9CrHS;EFmIf,kBgDbuB;EhDnBvB,kBgDoBwB;EhDnBxB,QgDmBiC;EhDlBjC,WgDkBqC;AjD26rBvC;;AkDlisBI;EACI,mBAAA;AlDqisBR;AkDpisBQ;EACI,kBAAA;AlDsisBZ;AkDrisBY;EACI,eAAA;AlDuisBhB;AkDrisBY;EACI,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,c/CQJ;E+CPI,yB/CiHL;AHs7rBX;AkDtisBgB;EACI,yB/CGV;E+CFU,c/CgBZ;AHwhsBR;ACtgsBI;EiD7BA;IAIQ,aAAA;IACA,uBAAA;IACA,+BAAA;IACA,qBAAA;ElDqisBV;AACF;;AkDjisBI;EACI,uCAAA;EACA,c/CPC;E+CQD,iBAAA;AlDoisBR;;AkDjisBA;EACI,yB/CtBM;AH0jsBV;AkDnisBI;EACI,yB/CtBI;AH2jsBZ;;AkD/hsBY;EAGI,aAAA;AlDkisBhB;AkDjisBgB;EACI,YAAA;EACA,WAAA;EACA,0CAAA;EACf,yB/CxBG;E+CyBY,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;AlDmisBpB;AkDlisBoB;EACI,c/CjCjB;E+CkCiB,WAAA;EACA,YAAA;AlDoisBxB;AkDlisBoB;EACG,c/CyFV;E+CxFU,WAAA;EACC,YAAA;AlDoisBxB;AkDlisBoB;EACI,c/CnDf;E+CoDe,WAAA;EACA,YAAA;AlDoisBxB;AkDlisBoB;EACI,WAAA;EACA,YAAA;AlDoisBxB;AkDlisBoB;EACI,c/CpDjB;E+CqDiB,WAAA;EACA,YAAA;AlDoisBxB;AkDjisBoB;EACI,c/C1EZ;E+C2EY,WAAA;EACA,YAAA;AlDmisBxB;AkD7hsBQ;EACI,gBAAA;AlD+hsBZ;AkD7hsBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;AlD+hsBpB;AkD9hsBoB;EACI,WAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;AlDgisBxB;AkD1hsBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;AlD4hsBR;AkD3hsBQ;EACI,UAAA;AlD6hsBZ;AkDzhsBI;EACI,gBAAA;AlD2hsBR;AkDzhsBI;EACI,YAAA;AlD2hsBR;AkDzhsBI;EACI,YAAA;AlD2hsBR;;AkDxhsBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AlD2hsBJ;AC1osBI;EiDgHA;IAEQ,eAAA;IACD,sBAAA;ElD4hsBT;AACF;AkD3hsBQ;EACI,mBAAA;AlD6hsBZ;AkD5hsBY;EACI,eAAA;AlD8hsBhB;AkD1hsBI;EACI,kBAAA;EACA,cAAA;AlD4hsBR;AkD3hsBQ;EACI,eAAA;AlD6hsBZ;AkD3hsBQ;EACI,eAAA;AlD6hsBZ;AChqsBI;EiDkII;IAGQ,aAAA;ElD+hsBd;AACF;AkD7hsBQ;EACI,YAAA;EACA,WAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,mB/CvKJ;E+CwKI,kBAAA;EACA,YAAA;EACA,eAAA;AlD+hsBZ;AkD9hsBY;EACI,YAAA;AlDgisBhB;AkD9hsBY;EACI,mBAAA;AlDgisBhB;AkD9hsBY;EACI,kBAAA;AlDgisBhB;AkD9hsBY;EACI,yB/CjMJ;E+CkMI,c/CtLR;E+CuLQ,aAAA;EACA,gB/C/MG;E+CgNH,e/CxNC;AHwvsBjB;AkD/hsBgB;EACI,yB/CzMV;AH0usBV;AkD/hsBgB;EACI,WAAA;EACA,iBAAA;EACA,c/ChMZ;AHiusBR;AC/ssBI;EiDkKQ;IAeQ,YAAA;IACA,e/CnOH;EHqwsBf;AACF;AkDhisBY;EACI,c/CpMT;AHsusBP;AkD/hsBQ;EACI,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,mB/CvNJ;E+CwNI,kBAAA;EACA,iBAAA;AlDiisBZ;AkDhisBY;EACI,kBAAA;AlDkisBhB;;AkD7hsBA;EACG,mB/C3FO;E+C4FP,aAAA;AlDgisBH;AkD9hsBI;EACI,e/CLO;E+CMP,gB/C7PW;E+C8PX,c/CnPI;AHmxsBZ;;AkD5hsBA;EACI,aAAA;AlD+hsBJ;AkD9hsBI;EACI,eAAA;AlDgisBR;AkD9hsBI;EACI,e/CnBO;E+CoBP,gB/C5Qa;AH4ysBrB;;AkD7hsBA;EACI,cAAA;AlDgisBJ;;AkD9hsBA;EACI,gBAAA;EACA,iBAAA;AlDiisBJ;AkDhisBI;EACI,eAAA;AlDkisBR;AC5wsBI;EiDyOA;IAGQ,kBAAA;ElDoisBV;AACF;;AkDjisBA;EACI,YAAA;EACA,WAAA;EACA,yBAAA;EACA,gBAAA;AlDoisBJ;;AkDlisBA;EACI,QAAA;AlDqisBJ;;AkDjisBQ;EACI,gBAAA;EACA,yBAAA;AlDoisBZ;;AkD/hsBI;EACI,kBAAA;AlDkisBR;AkDhisBI;EACI,WAAA;AlDkisBR;;AkD9hsBI;EACI,kBAAA;AlDiisBR;AkD/hsBI;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;AlDiisBR;AkD/hsBI;EACI,WAAA;AlDiisBR;;AkD7hsBI;EACI,kBAAA;AlDgisBR;AkD9hsBI;EACI,kBAAA;AlDgisBR;AkD9hsBI;EACI,WAAA;AlDgisBR;;AkD5hsBI;EACI,kBAAA;AlD+hsBR;AkD7hsBI;EACI,kBAAA;AlD+hsBR;AkD7hsBI;EACI,WAAA;AlD+hsBR;;AkD3hsBI;EACI,YAAA;EACA,kDAAA;AlD8hsBR;AkD5hsBI;EACI,2CAAA;AlD8hsBR;AkD5hsBI;EACI,wBAAA;AlD8hsBR;AkD5hsBI;EACI,aAAA;AlD8hsBR;;AkDxhsBY;EACI,c/C9UT;E+C+US,gB/C1WG;AHq4sBnB;;AkDphsBI;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AlDuhsBR;;AkDphsBA;EACI,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;AlDuhsBJ;;AkDrhsBA;EACI,yBAAA;EACA,yB/CnOM;E+CoON,YAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;AlDwhsBJ;AkDvhsBI;EACI,WAAA;EACA,SAAA;EACA,yB/CnPE;E+CoPF,kBAAA;EACN,uBAAA;AlDyhsBF;AkDvhsBI;EACI,c/C1YI;E+C2YJ,YAAA;EACA,eAAA;AlDyhsBR;AkDxhsBQ;EACI,WAAA;EACA,YAAA;AlD0hsBZ;AkDxhsBQ;EACI,WAAA;EACA,YAAA;AlD0hsBZ;;AkDthsBA;EACI,gBAAA;AlDyhsBJ;AkDxhsBI;EACI,aAAA;AlD0hsBR;;AkDthsBI;EACI,kBAAA;AlDyhsBR;AkDvhsBI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;AlDyhsBR;;AkDthsBA;EACI,uCAAA;EACA,c/ClaK;E+CmaL,kBAAA;EACA,iBAAA;EACA,e/Chca;AHy9sBjB;;AkDvhsBA;EACI,kBAAA;AlD0hsBJ;;AkDvhsBI;EACI,c/CpbI;AH88sBZ;;AkDthsBI;EACI,c/C1SK;E+C2SL,eAAA;EACA,qBAAA;AlDyhsBR;;AkDrhsBI;EACI,e/CrNO;E+CsNP,aAAA;EACA,mBAAA;EACA,mBAAA;AlDwhsBR;AkDvhsBQ;EACI,WAAA;EACA,c/CxcF;E+CycE,iBAAA;AlDyhsBZ;;AkDrhsBA;EACI,kBAAA;AlDwhsBJ;;AkDthsBA;EACI,yB/C7TM;E+C8TN,iBAAA;EACA,kBAAA;EACA,kBAAA;AlDyhsBJ;AkDxhsBI;EACI,e/CveS;E+CweT,c/CrdI;E+CsdJ,gB/CjeW;E+CkeX,aAAA;EACA,mBAAA;AlD0hsBR;AkDxhsBQ;EACI,WAAA;EACA,iBAAA;AlD0hsBZ;AkDxhsBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,e/CnQG;E+CoQH,WAAA;EACA,YAAA;EACA,yB/CneH;E+CoeG,c/CheJ;E+CieI,kBAAA;EACA,gBAAA;AlD0hsBZ;;AkDrhsBI;EACI,WAAA;EACA,YAAA;EACA,yB/CpWE;E+CuWF,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,c/ChgBI;E+CigBJ,kBAAA;EACA,kBAAA;AlDwhsBR;AkDvhsBQ;EACI,yB/CtgBF;E+CugBE,c/CzfJ;AHkhtBR;AkDxhsBY;EACI,yB/CvgBJ;E+CwgBI,c/C5fR;AHshtBR;AkDvhsBQ;EACI,WAAA;EACA,YAAA;AlDyhsBZ;AkDvhsBQ;EACI,yB/ClhBF;E+CmhBE,c/CrgBJ;AH8htBR;AC5gtBI;EiDsfA;IAEQ,aAAA;ElDwhsBV;AACF;;AkDrhsBA;EACI,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mB/CxiBM;E+CyiBN,c/C3hBI;E+C4hBJ,kBAAA;AlDwhsBJ;AkDvhsBI;EACI,yB/C1iBI;E+C2iBJ,c/C/hBA;AHwjtBR;;AkDphsBQ;EACI,cAAA;EACA,mBAAA;AlDuhsBZ;;AkDnhsBA;EACI,yBAAA;EACA,c/ChjBK;E+CijBL,iBAAA;EACA,e/CjVW;E+CkVX,gB/CvkBmB;E+CwkBnB,kBAAA;AlDshsBJ;;AkDphsBA;EACI,aAAA;AlDuhsBJ;AkDrhsBQ;EACI,WAAA;EACA,YAAA;EACA,c/ClkBF;E+CmkBE,mBAAA;AlDuhsBZ;AkDphsBI;EACI,e/C5VO;E+C6VP,gB/CrlBW;E+CslBX,kBAAA;AlDshsBR;AkDphsBI;EACI,e/CpWO;AH03sBf;AkDphsBI;EACI,kBAAA;AlDshsBR;;AkDnhsBA;EACI,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,sDAAA;EACA,mB/C9kBI;E+C+kBJ,kBAAA;EACA,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AlDshsBJ;AkDrhsBI;EACI,iDAAA;EjD1gBL,gBiD2gB6B;EjD1gB7B,iBiD0gBuC;AlDwhsB1C;AkDvhsBQ;EACI,e/C1XG;E+C2XH,gB/ClnBW;E+CmnBX,mBAAA;AlDyhsBZ;AkDvhsBQ;EACI,e/C7nBK;AHsptBjB;AkDrhsBQ;EACI,mBAAA;AlDuhsBZ;AkDthsBY;EACI,aAAA;EACA,mBAAA;AlDwhsBhB;AkDvhsBgB;EACI,WAAA;EACA,iBAAA;AlDyhsBpB;AkDthsBY;EACI,gBAAA;AlDwhsBhB;;AkDnhsBA;EACI,kBAAA;AlDshsBJ;;AkDnhsBI;EACI,cAAA;AlDshsBR;;AC3ntBI;EiDymBA;IAEQ,sBAAA;IACA,uBAAA;ElDqhsBV;AACF;AkDphsBQ;EACI,cAAA;AlDshsBZ;ACrotBI;EiD8mBI;IAGQ,gBAAA;ElDwhsBd;AACF;AC1otBI;EiD8mBI;IAMQ,sBAAA;IACA,uBAAA;ElD0hsBd;AACF;AChptBI;EiDwnBQ;IAEQ,gBAAA;ElD0hsBlB;AACF;ACrptBI;EiD8nBI;IAEQ,sBAAA;IACA,uBAAA;ElDyhsBd;EkDxhsBc;IACI,kBAAA;ElD0hsBlB;AACF;;AkDrhsBA;EACI,yB/C1pBK;E+C2pBL,iBAAA;EACA,c/C9pBI;E+C+pBJ,kBAAA;AlDwhsBJ;;AkDthsBA;EACI,yB/C5qBM;E+C6qBN,iBAAA;EACA,c/CpqBI;E+CqqBJ,kBAAA;AlDyhsBJ;;AkDvhsBA;EACI,yB/C5qBK;E+C6qBL,iBAAA;EACA,c/C1qBI;E+C2qBJ,kBAAA;AlD0hsBJ;;AkDxhsBA;EACI,c/C1qBG;E+C2qBH,gB/CvsBmB;AHkutBvB;;AkDzhsBA;EACI,gBAAA;AlD4hsBJ;;AkD1hsBA;EACI,SAAA;EACA,UAAA;AlD6hsBJ;AkD5hsBI;EACI,c/CtsBE;AHoutBV;AkD5hsBI;EACI,6BAAA;AlD8hsBR;AkD7hsBQ;EACI,yBAAA;AlD+hsBZ;;AkD3hsBA;EACI,yB/C5jBM;E+C6jBN,kBAAA;AlD8hsBJ;AkD7hsBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;AlD+hsBR;ACxttBI;EiDkrBA;IASQ,sBAAA;IACA,uBAAA;ElDiisBV;AACF;AkDhisBQ;EACI,kBAAA;AlDkisBZ;AkDjisBY;EACI,c/ChlBH;AHmntBb;AkDjisBY;EACI,c/CluBJ;AHqwtBZ;ACvutBI;EiD8rBI;IASQ,eAAA;IACA,mBAAA;ElDoisBd;AACF;AkDlisBQ;EACI,YAAA;AlDoisBZ;;AkD/hsBI;EACI,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AlDkisBR;AkDjisBQ;EACI,yB/C5oBD;E+C6oBC,c/CtvBA;E+CuvBA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AlDmisBZ;AkDjisBgB;EACI,c/C9mBP;AHiptBb;AkD/hsBQ;EACI,gBAAA;EACA,WAAA;EACA,YAAA;AlDiisBZ;AkD9hsBI;EACI,c/CznBK;E+C0nBL,e/CjiBO;AHiktBf;;AkD7hsBA;EACI,kBAAA;AlDgisBJ;;AkD7hsBI;EACI,aAAA;AlDgisBR;;AkD7hsBA;EACI,yB/CvxBM;E+CwxBN,mBAAA;AlDgisBJ;AkD/hsBI;EACI,c/C5wBA;E+C6wBA,yBAAA;EACA,iCAAA;EACA,6BAAA;AlDiisBR;AkD9hsBQ;EACI,c/CnxBJ;AHmztBR;;AkD1hsBQ;EACI,mCAAA;EACA,+BAAA;AlD6hsBZ;AkD5hsBY;EACI,yBAAA;AlD8hsBhB;AkD1hsBY;EACI,yB/CtyBP;E+CuyBO,qB/CvyBP;AHm0tBT;AkDxhsBY;EACI,yB/CpzBJ;E+CqzBI,qB/CrzBJ;AH+0tBZ;;AkDnhsBQ;EACI,wBAAA;AlDshsBZ;AkDphsBQ;EACI,wBAAA;AlDshsBZ;;AkDhhsBQ;EACI,c/Cv0BA;AH01tBZ;AkDjhsBQ;EACI,kBAAA;AlDmhsBZ;;AkD/gsBA;EACI,YAAA;EACA,aAAA;EACA,kBAAA;AlDkhsBJ;AkDjhsBI;EACI,kBAAA;EACA,UAAA;EACA,SAAA;EACA,mB/C90BC;E+C+0BD,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AlDmhsBR;AkDlhsBQ;EACI,c/Cl1BJ;E+Cm1BI,WAAA;EACA,YAAA;AlDohsBZ;;AkDhhsBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AlDmhsBJ;ACn2tBI;EiDs0BJ;IAYQ,sBAAA;IACA,kBAAA;ElDqhsBN;AACF;ACz2tBI;EiDq1BA;IAEQ,mBAAA;ElDshsBV;AACF;AkDrhsBQ;EACI,mBAAA;EACA,e/C/oBG;E+CgpBH,c/C13BA;AHi5tBZ;AkDrhsBQ;EACI,e/Ch5BK;E+Ci5BL,c/C/uBC;AHswtBb;AkDrhsBQ;EACI,c/C/3BF;E+Cg4BE,e/CxpBG;AH+qtBf;AkDthsBY;EACI,cAAA;EACA,c/CtvBH;AH8wtBb;;AkDnhsBA;EACI,c/C34BQ;E+C44BR,gB/Cx5BmB;E+Cy5BnB,e/Ch6Ba;E+Ci6Bb,mBAAA;AlDshsBJ;;AkDnhsBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;AlDshsBR;AkDphsBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,iBAAA;EACA,YAAA;AlDshsBR;;AmD58tBI;EACI,mBAAA;AnD+8tBR;AmD78tBY;EACA,mBAAA;AnD+8tBZ;AmD78tBQ;EACI,kBAAA;EACA,iBAAA;AnD+8tBZ;;AmDx8tBA;EACI,YAAA;AnD28tBJ;;AmDz8tBA;EACI,YAAA;AnD48tBJ;;AmD18tBA;EACI,kBAAA;EACA,iBAAA;AnD68tBJ;;AmD38tBA;EACI,mBAAA;AnD88tBJ;;AmD58tBA;EACE,iBAAA;AnD+8tBF;;AmD78tBA;EACI,yBhDbQ;AH69tBZ;AmD/8tBI;EACI,yBhDjBE;EgDkBF,chDJA;AHq9tBR;;AmD98tBA;EACI,YAAA;AnDi9tBJ;;AmD/8tBA;EACI,chDXI;AH69tBR;;AmDh9tBA;EACI,chD1BQ;AH6+tBZ;;AmDj9tBA;EACI,YAAA;EACA,mBAAA;AnDo9tBJ;;AmDl9tBA;EACI,aAAA;AnDq9tBJ;;AmDn9tBA;EACI,kBAAA;EACJ,2CAAA;EACA,gBAAA;AnDs9tBA;;AmDp9tBA;EACI,aAAA;EACA,mBAAA;AnDu9tBJ;;AoDrhuBA;EACI,yBjDqKM;AHm3tBV;AoDthuBQ;EACI,aAAA;ApDwhuBZ;AC1+tBI;EmD/CI;IAGQ,cAAA;EpD0huBd;AACF;AoDxhuBQ;EACI,aAAA;ApD0huBZ;;AoDnhuBY;EACI,cAAA;ApDshuBhB;AoDnhuBQ;EACI,kBAAA;ApDqhuBZ;;AoDjhuBA;EACI,WAAA;EACA,yBAAA;EACA,mBAAA;ApDohuBJ;AoDnhuBI;EACI,yBAAA;ApDqhuBR;AoDnhuBI;EACI,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,gBAAA;ApDqhuBR;AoDphuBQ;EACI,mBjDzBF;EiD0BE,cjDhBJ;EiDiBI,cjDsME;EiDrMF,gBjD1CW;EFqGpB,YmD1DuC;EnDiDxC,kBmDhD4B;EnDmD5B,SmDnD+C;EnDoD/C,OmDpDiD;ApDwhuBnD;AoDrhuBI;EnDsDD,amDrDmC;ApDuhuBtC;AoDthuBQ;EACI,ejDzDK;EiD0DL,cjD1BJ;EiD2BI,gBjDrDS;AH6kuBrB;AoDthuBQ;EACI,ejD4LG;EiD3LH,cjDgED;EiD/DC,gBjD1DS;EiD2DT,kBAAA;ApDwhuBZ;AoDthuBQ;EACI,ejDpEK;EiDqEL,cjD0DD;EiDzDC,gBjDhES;AHwluBrB;;AoDphuBA;EnDkCG,emDjC+B;ApDuhuBlC;ACjjuBI;EmDyBJ;InDkCG,emD/BmC;EpDyhuBpC;AACF;;AoDvhuBA;EACI,kBAAA;ApD0huBJ;AoDzhuBI;EACI,WAAA;EACA,mBjD2CG;EiD1CH,WAAA;EACA,WAAA;EnDaN,kBmDZwB;EnDexB,YmDf2C;EnDgB3C,UmDhBgD;ApD6huBlD;;AoD1huBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;ApD6huBJ;AoD5huBI;EACI,wBAAA;ApD8huBR;AoD5huBI;EACI,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EnDLL,kBmDM6B;EnDL7B,UmDKyC;ApD+huB5C;AoD5huBQ;EACI,yBjDtFJ;EiDuFI,yBAAA;EACA,YAAA;EnDYV,kBmDX2B;ApD8huB7B;AoD7huBY;EACI,iBAAA;ApD+huBhB;AoD7huBY;EACI,YAAA;ApD+huBhB;;AoDphuBwB;EACI,UAAA;ApDuhuB5B;;AoD7guBQ;EACI,gBjD7IW;EiD8IX,cjDtBD;EiDuBC,ejDtJK;AHsquBjB;AoD9guBQ;EACI,gBjDlJW;EiDmJX,cjD3BD;EiD4BC,ejD3JK;AH2quBjB;;AoD5guBA;EACI,cjDjII;EiDkIJ,mBjDhIK;EiDmIL,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EnDvCF,kBmDwCmB;EnDhElB,gBmDiEyB;EnDhEzB,amDgEmC;ApDghuBtC;AoD/guBI;EACI,ejD9KS;EiD+KT,SAAA;EACA,gBjDzKe;AH0ruBvB;AoD/guBI;EACI,SAAA;EACA,ejDpLS;EiDqLT,gBjD9Ke;AH+ruBvB;;AoD9guBA;EACI,kBAAA;ApDihuBJ;AoDhhuBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ApDkhuBR;AoDjhuBQ;EACI,UAAA;EACA,kBAAA;ApDmhuBZ;AoDlhuBY;EACI,SAAA;ApDohuBhB;AoDlhuBY;EACI,yBAAA;EACA,cjDzKR;EiD0KQ,ejD1MC;EiD2MD,gBjDpMO;EiDqMP,gBAAA;EnDzEd,kBmD0E+B;EAGjB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EAEA,sBAAA;EnD5Gb,kBmD6G2C;ApDohuB9C;AoDnhuBgB;EACI,yBAAA;EACA,cjD3LX;AHgtuBT;AoDnhuBgB;EACI,mBAAA;ApDqhuBpB;;AoD/guBA;EACI,eAAA;ApDkhuBJ;AoDhhuBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;ApDkhuBZ;AoDjhuBY;EACI,ejDOD;EiDNC,gBjD/OK;AHkwuBrB;AoDjhuBY;EACI,ejDGD;EiDFC,gBjDnPK;AHswuBrB;AoDhhuBgB;EACI,ejDCL;EiDAK,gBjDvPG;EiDwPH,cjD9NX;AHgvuBT;AoDhhuBgB;EACI,ejDJL;EiDKK,gBjD5PG;EiD6PH,cjDnOX;AHqvuBT;;AoD5guBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,yBAAA;EACA,6DAAA;EnD1KD,gBmD2KyB;EnD1KzB,amD0KmC;ApDghuBtC;ACrvuBI;EmDyNJ;IAcQ,sBAAA;EpDkhuBN;EoDjhuBM;IACI,cAAA;EpDmhuBV;AACF;;AoD/guBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;ApDkhuBR;AoDjhuBQ;EACI,6BAAA;EACA,ejDzCG;EiD0CH,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,UAAA;EACA,cjD5LD;AH+suBX;AoDhhuBI;EACI,WAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,SAAA;ApDkhuBR;;AoD/guBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ApDkhuBJ;AoDjhuBI;EACI,WAAA;EACA,kBAAA;ApDmhuBR;AoDlhuBQ;EACI,WAAA;EACA,YAAA;EACA,iBAAA;ApDohuBZ;AoDhhuBQ;EACI,ejDvVK;EiDwVL,cjDxTJ;EiDyTI,gBjDlVW;EiDqVX,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;ApDkhuBZ;AoDjhuBY;EACG,UAAA;EACA,eAAA;EACA,cAAA;ApDmhuBf;AoD/guBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ApDihuBR;AoDhhuBQ;EACI,mBjDlWF;EiDmWE,cjDrVJ;EiDsVI,ejD3HG;EFvHb,kBmDmP2B;EACjB,kBAAA;EnD3QT,iBmD4QsC;ApDkhuBzC;AoDhhuBQ;EACI,kBAAA;EACA,QAAA;ApDkhuBZ;;AoD9guBA;EACI,YAAA;EACA,cAAA;ApDihuBJ;ACl2uBI;EmD+UJ;IAIQ,YAAA;EpDmhuBN;AACF;;AoDjhuBA;EnD5RG,mBmD6RyB;ApDohuB5B;AoDnhuBI;EACI,gBjDlYW;AHu5uBnB;;AoDlhuBA;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;ApDqhuBJ;ACp3uBI;EmD4VJ;IAKQ,YAAA;EpDuhuBN;AACF;;AoDrhuBA;EACI,mBAAA;ApDwhuBJ;AoDvhuBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,eAAA;ApDyhuBR;AoDxhuBQ;EACI,UAAA;EACA,kBAAA;EACA,iBAAA;ApD0huBZ;AC54uBI;EmD+WI;IAKO,WAAA;IACC,eAAA;EpD4huBd;AACF;AoD3huBY;EACI,SAAA;EACA,UAAA;ApD6huBhB;ACt5uBI;EmDuXQ;IAIO,WAAA;EpD+huBjB;AACF;AoD7huBY;EACI,mBjDhTL;EiDiTK,WAAA;EACA,cAAA;EACA,cjDpZR;EiDqZQ,gBjD7aO;EF4HrB,kBmDkT+B;EnDzU9B,amD0U2C;ApD+huB9C;ACp6uBI;EmD8XQ;InD5SV,gBmDqTmC;EpDiiuBnC;AACF;AoD9huBgB;EACI,mBjD5aV;AH48uBV;;AoDxhuBQ;EACI,gBAAA;EnD1VT,amD2VuC;ApD2huB1C;;AoDvhuBA;EACI,iBAAA;ApD0huBJ;AoDzhuBI;EACI,gBAAA;EnD3WN,kBmD4WwB;EnD3WxB,UmD2WiC;EnD1WjC,QmD0WuC;ApD6huBzC;AoD5huBQ;EACI,8BAAA;EACA,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;EACA,yBAAA;ApD8huBZ;AoD7huBY;EACI,YAAA;ApD+huBhB;AoD5huBgB;EnDnYd,kBmDoYoC;EnDnYpC,QmDmY6C;EnDlY7C,UmDkYiD;EAC/B,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;ApDgiuBpB;AoD5huBgB;EACI,gBAAA;EACA,kCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EnDpZlB,kBmDqZoC;EnDpZpC,QmDoZ6C;EnDnZ7C,UmDmZiD;ApDgiuBnD;AoD7huBY;EACI,8BAAA;ApD+huBhB;AoD9huBgB;EACI,cjD/dZ;AH+/uBR;;AoDzhuBA;EACI,iBAAA;EACA,mBAAA;ApD4huBJ;AoD3huBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,yBAAA;EACA,4BAAA;EACA,kBAAA;ApD6huBR;AoD5huBQ;EACI,iBAAA;ApD8huBZ;;AoDzhuBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EAEA,eAAA;ApD4huBR;AoD3huBQ;EACI,iBAAA;EACA,mBAAA;ApD6huBZ;AClhvBI;EmDmfI;IAIQ,UAAA;EpD+huBd;AACF;ACvhvBI;EmDmfI;IAOQ,WAAA;IACA,kBAAA;EpDiiuBd;AACF;AoD/huBgB;EACI,cAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,mBjDxbT;EiDybS,mBAAA;EACA,yBAAA;EAGA,aAAA;EnD7cjB,iBmD8c+C;ApDiiuBlD;AC1ivBI;EmD8fY;IAaQ,eAAA;InDhdrB,iBmDidmD;EpDmiuBpD;AACF;AoDliuBoB;EACI,yBAAA;EACA,cAAA;EACA,mCAAA;ApDoiuBxB;AoDjiuBgB;EACI,mBjD7iBV;AHglvBV;AoDjiuBgB;EACI,mBjD1cT;AH6+uBX;AoDjiuBgB;EACI,mBAAA;ApDmiuBpB;AoDjiuBgB;EACI,mBjD1jBV;AH6lvBV;AoDjiuBgB;EACI,mBjDjkBV;AHomvBV;;AoD5huBI;EACI,mBAAA;ApD+huBR;AoD9huBQ;EACI,WAAA;EACA,mBjD5kBF;EiD6kBE,kBAAA;EACA,cjDhkBJ;EiDikBI,ejDxVG;EiDyVH,gBjDzlBO;EF2HjB,kBmD+d2B;ApDgiuB7B;AoD7huBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,eAAA;ApD+huBR;AoD9huBQ;EACI,YAAA;EACA,kBAAA;ApDgiuBZ;AoD/huBY;EACI,WAAA;EACA,yBAAA;EACA,ejDlXD;EiDmXC,gBjD/mBK;EiDgnBL,cAAA;EACA,cjDvlBR;EFmGN,gBmDqf+B;EnD5gB9B,amD6gB2C;ApDiiuB9C;AoDhiuBgB;EACI,mBjD5hBP;AH8jvBb;AoDhiuBgB;EACI,mBAAA;ApDkiuBpB;AoDhiuBgB;EACI,mBjDvgBT;AHyivBX;;AoD5huBA;EACI,kBAAA;EnD7hBD,cmD8hByB;ApD+huB5B;AoD9huBI;EnD9hBD,iBmD+hBmC;EAC9B,cjD3nBE;EiD4nBF,ejDrYO;EiDsYP,gBjDtoBW;AHsqvBnB;;AoD7huBA;EACI,mBAAA;ApDgiuBJ;AoD/huBI;EACI,cjDphBG;EiDqhBH,ejD1ZO;EiD2ZP,gBjDhpBa;AHirvBrB;;AoD9huBA;EACI,kBAAA;ApDiiuBJ;;AoD9huBI;EACI,mBjD7oBE;EiD8oBF,kBAAA;EACA,cjDjoBA;EFoGN,kBmD8hBuB;EnDrjBtB,amDsjBmC;ApDiiuBtC;;AoD9huBA;EnDzjBG,amD0jB+B;ApDiiuBlC;AoDhiuBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EAEA,eAAA;ApDkiuBR;AoDjiuBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,UAAA;EACA,mBAAA;ApDmiuBZ;AC7qvBI;EmD+nBI;IAaQ,WAAA;EpDqiuBd;AACF;AoDpiuBY;EACI,aAAA;ApDsiuBhB;AoDpiuBY;EACI,yBAAA;EACA,UAAA;EACA,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBjD9rBN;EiD+rBM,cjDjrBR;EF6EL,amDqmB2C;ApDsiuB9C;AoDriuBgB;EACI,+BAAA;ApDuiuBpB;;AoDjiuBA;EACI,kBAAA;EACA,gBAAA;ApDoiuBJ;AoDniuBI;EACI,gBjDrtBW;EiDstBX,ejDheO;EiDieP,cjD9sBE;EiD+sBF,gBAAA;EACA,mBjDlsBA;EiDmsBA,yBAAA;EAGA,oBAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EnDxmBN,kBmDymBuB;EnDhoBtB,kBmDioBmC;ApDqiuBtC;AoDpiuBQ;EACI,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,iDAAA;EACA,2BjDpuBF;EiDquBE,+CAAA;EnDnnBV,kBmDonB2B;ApDsiuB7B;AoDpiuBQ;EACI,mBjDzuBF;EiD0uBE,cjD5tBJ;AHkwvBR;AoDriuBY;EACI,yBAAA;EACA,2BjD/tBR;AHswvBR;;AoDhiuBQ;EACI,YAAA;EACA,mBjDzuBJ;AH4wvBR;AoDjiuBQ;EACI,eAAA;EnDvqBV,kBmDwqB4B;EnDpqB5B,UmDoqBoD;ApDoiuBtD;;AoDhiuBA;EACI,mBjDjvBI;EiDkvBJ,kBAAA;EACA,aAAA;EACA,6DAAA;EACA,oCAAA;EACA,aAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,sBAAA;ApDmiuBJ;AoDliuBI;EACI,mBjDhwBC;AHoyvBT;AoDniuBQ;EACI,cjDpwBJ;AHyyvBR;AoDliuBI;EACI,oCAAA;ApDoiuBR;AoDniuBQ;EACI,cjD1wBJ;AH+yvBR;AoDliuBI;EACI,sBAAA;ApDoiuBR;AoDliuBI;EACI,ejDrjBO;EiDsjBP,cjDjxBA;EiDkxBA,gBAAA;ApDoiuBR;;AoDjiuBA;EACI,mBjDrxBK;EiDwxBL,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cjDhyBI;EiDiyBJ,ejDh0Ba;EiDi0Bb,gBjDzzBe;AH61vBnB;AoDniuBI;EACI,mBjDlzBE;EiDmzBF,cjDryBA;AH00vBR;;AoDliuBA;EACI,gBAAA;EACA,0BAAA;EACA,kBAAA;ApDqiuBJ;AoDpiuBI;EACI,kBAAA;EACA,WAAA;EACA,mBjDzqBE;EiD0qBF,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,WAAA;ApDsiuBR;AoDpiuBI;EACI,kBAAA;EACA,WAAA;EACA,mBjDnrBE;EiDorBF,WAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;ApDsiuBR;;AoDniuBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;ApDsiuBJ;AoDriuBI;EACI,iBAAA;EACA,mBAAA;EACA,cjD70BC;EiD80BD,eAAA;EACA,gBjDx2BW;EiDy2BX,mBAAA;ApDuiuBR;AoDriuBI;EACI,ejDp3BS;EiDq3BT,cAAA;EACA,gBjD92BW;AHq5vBnB;;AoDniuBI;EACI,SAAA;ApDsiuBR;;AoDniuBA;EACI,yBAAA;EACA,cjD32BM;EiD42BN,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBjD73BmB;EiD83BnB,mBAAA;ApDsiuBJ;AoDriuBI;EACI,mBjDl3BE;EiDm3BF,cjDz2BA;AHg5vBR;;AoDpiuBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;ApDuiuBJ;AoDriuBQ;EACI,ejDzpBG;EiD0pBH,gBjDj5BO;EiDk5BP,cAAA;EACA,gBAAA;ApDuiuBZ;AoDriuBQ;EACI,ejD95BK;EiD+5BL,gBjD15BS;EiD25BT,cjDh4BJ;AHu6vBR;AoDniuBM;EAGM,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;ApDqiuBZ;AoDpiuBU;EACM,iBAAA;ApDsiuBhB;AoDriuBgB;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACI,mBjDx5BZ;EiDy5BY,8DAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;ApDuiuBpB;;AoDhiuBI;EACI,mBAAA;ApDmiuBR;;AoDhiuBA;EACI,yBAAA;EACA,6DAAA;EACA,mBjD16BI;EiD26BJ,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;ApDmiuBJ;AoDliuBI;EACI,yBAAA;ApDoiuBR;AoDliuBI;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,cjDv7BA;EiDw7BA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,mBjDz7BC;EiD07BD,oBAAA;ApDoiuBR;AoDliuBI;EACI,yBAAA;ApDoiuBR;AoDniuBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;ApDqiuBZ;AoDhiuBY;EACI,qBAAA;ApDkiuBhB;AoDhiuBY;EACI,wBAAA;ApDkiuBhB;AoD9huBI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;ApDgiuBR;AoD/huBQ;EACI,oBAAA;EACA,8BAAA;ApDiiuBZ;ACn/vBI;EmDg9BI;IAIQ,iBAAA;EpDmiuBd;AACF;AoDjiuBQ;EACI,kBAAA;EACA,mBjDz/BF;EiD0/BE,cjD5+BJ;EiD6+BI,eAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,4BAAA;EACA,oBAAA;ApDmiuBZ;AoDhiuBI;EACI,aAAA;EACA,kBAAA;ApDkiuBR;AoDjiuBQ;EACI,ejDzhCK;EiD0hCL,gBjDnhCW;EiDohCX,cjD3/BJ;EiD4/BI,mBAAA;ApDmiuBZ;AoDjiuBQ;EACI,cAAA;EACA,eAAA;ApDmiuBZ;AoDjiuBQ;EACI,cAAA;EACA,kBAAA;EACA,gBjD9hCW;EiD+hCX,ejDtiCK;AHykwBjB;;AoD9huBI;EACI,qBAAA;EACA,WAAA;EACA,eAAA;ApDiiuBR;AoDhiuBQ;EACI,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,WAAA;ApDkiuBZ;AoDjiuBY;EACI,yBjDviCN;EiDwiCM,qBjDxiCN;AH2kwBV;AoDjiuBoB;EACI,cjD7hChB;AHgkwBR;AoDhiuBgB;EACI,uBAAA;EACA,oBAAA;ApDkiuBpB;AoDjiuBoB;EACI,cjDpiChB;AHukwBR;AoD7huBI;EACI,gBAAA;EACA,qBAAA;EACA,WAAA;ApD+huBR;AoD9huBQ;EACI,aAAA;EACA,WAAA;ApDgiuBZ;AoD/huBY;EACI,qBAAA;ApDiiuBhB;;AqDnnwBA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;ArDsnwBJ;;AqDnnwBI;EACI,aAAA;ArDsnwBR;AqDrnwBQ;EACI,aAAA;EACA,mBAAA;ArDunwBZ;AqDtnwBY;EACI,eAAA;ArDwnwBhB;AqDpnwBI;EACI,gBAAA;ArDsnwBR;;AC3lwBI;EoDxBJ;IAEQ,sBAAA;ErDsnwBN;AACF;AqDrnwBI;EACI,elD9BS;EkD+BT,cAAA;EpD4EL,kBoD3E6B;EpD4E7B,aoD5EyC;EpDmG1C,kBoDlGuB;ArDwnwBzB;ACxmwBI;EoDpBA;IAMQ,kBAAA;IACA,WAAA;ErD0nwBV;AACF;AqDznwBQ;EACI,gBAAA;ArD2nwBZ;;AqDtnwBI;EACI,clD1BI;AHmpwBZ;AqDvnwBI;EACI,elD+MO;EkD9MP,gBlDzCW;AHkqwBnB;;AqDtnwBA;EACI,yBlDlBG;EkDmBH,qBlDnBG;AH4owBP;AqDxnwBI;EACI,yBlDvCE;EkDwCF,qBlDxCE;AHkqwBV;;AqDvnwBA;EACI,yBlD5CM;EkD6CN,qBlD7CM;AHuqwBV;AqDznwBI;EACI,yBlD7CI;EkD8CJ,qBlD9CI;AHyqwBZ;AC3owBI;EoDWJ;IASG,gBAAA;ErD2nwBD;AACF;AChpwBI;EoDWJ;IAaG,gBAAA;ErD4nwBD;AACF;ACrpwBI;EoDWJ;IAiBG,gBAAA;ErD6nwBD;AACF;;AqD3nwBA;EACI,yBlD9DQ;EkD+DR,qBlD/DQ;AH6rwBZ;AqD7nwBI;EACI,yBlDnEE;EkDoEF,qBlDpEE;AHmswBV;;AqD5nwBA;EACI,yBlD9DK;EkD+DL,qBlD/DK;AH8rwBT;AqD9nwBI;EACI,yBlDzEI;EkD0EJ,qBlD1EI;AH0swBZ;;AqD7nwBA;EACI,yBlD5EM;EkD6EN,qBlD7EM;AH6swBV;AqD/nwBI;EACI,yBlDjFI;EkDkFJ,qBlDlFI;AHmtwBZ;;AqD7nwBI;EACI,SAAA;EpDPN,kBoDQwB;EpDPxB,UoDOiC;EpDNjC,QoDMuC;ArDkowBzC;AqDjowBQ;EACI,aAAA;EACA,gBAAA;ArDmowBZ;AqDlowBY;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EpDiBd,mBoDhB+B;ArDoowBjC;AqDnowBgB;EACI,clDpGV;AHyuwBV;AqDnowBgB;EACI,yBlDrGR;EkDsGQ,qBlDtGR;AH2uwBZ;;AqD/nwBA;EACI,yBlDlGI;EkDmGJ,aAAA;EACA,yBAAA;ArDkowBJ;;AqD/nwBA;EACI,mBAAA;EACA,aAAA;ArDkowBJ;AqDjowBI;EACI,yBlD1GA;EkD6GA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EAEA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDlDyFK;EFlJX,yBoD0D0B;EpDtB1B,kBoDuBuB;EACjB,8BAAA;ArDqowBR;AqDpowBQ;EACI,eAAA;ArDsowBZ;AqDnowBY;EpDjEV,yBoDkEkC;EACpB,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;ArDuowBhB;AqDpowBQ;EACI,elDoFG;EkDnFH,gBlDnKW;EkDoKX,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;ArDsowBZ;AqDrowBY;EACI,clD/JJ;AHsywBZ;AqDpowBQ;EACI,clDpBC;AH0pwBb;AqDpowBQ;EACI,qBlDxKF;EkDyKE,kBAAA;ArDsowBZ;AqDpowBgB;EACI,clD5KV;AHkzwBV;AqDlowBgB;EACI,qBAAA;ArDoowBpB;AqD7nwBY;EACI,gBAAA;ArD+nwBhB;AqD7nwBY;EACI,iBAAA;ArD+nwBhB;AqD7nwBY;EACI,yBlDjLR;EkDkLQ,yBAAA;ArD+nwBhB;AqD9nwBgB;EACI,clDhMR;AHg0wBZ;AqD9nwBgB;EACI,yBlDrMV;EkDsMU,qBlDtMV;AHs0wBV;AqD/nwBoB;EACI,clD1LhB;AH2zwBR;;AqDznwBI;EACI,aAAA;EACA,clD/DI;EFrEV,yBoDqI0B;ArD8nwB5B;AqD7nwBQ;EACI,aAAA;EACA,yBlD7GD;EFST,mBoDqG2B;EAGjB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;ArD+nwBZ;AqD9nwBY;EpDrJV,yBoDsJkC;ArDkowBpC;AqDhowBY;EpDxJV,yBoDyJkC;EpDrJlC,kBoDsJgC;EpDrJhC,MoDqJyC;EpDpJzC,QoDoJ2C;EAC7B,WAAA;EACA,YAAA;EpDxHd,mBoDyH+B;EACjB,mBlDxON;EkD2OM,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,aAAA;ArDsowBhB;AqDrowBgB;EACI,clD1OZ;EFoEN,kBoDuKoC;EpDtKpC,QoDsK6C;EpDnK7C,SoDmK2D;ArDyowB7D;AqDrowBQ;EACI,elDlBG;EkDmBH,gBlDxQO;AH+4wBnB;AqDrowBgB;EACI,clD/GR;AHsvwBZ;AqDnowBgB;EACI,clDrQR;AH04wBZ;AqDjowBQ;EACI,gBAAA;ArDmowBZ;AqDlowBY;EACI,clD9PP;AHk4wBT;AqDlowBY;EACI,clDjRN;AHq5wBV;AqDhowBQ;EACI,qBlDtRF;AHw5wBV;AqDhowBgB;EACI,qBAAA;ArDkowBpB;AqDhowBgB;EACI,cAAA;ArDkowBpB;;AqD5nwBA;EACI,YAAA;EACA,cAAA;ArD+nwBJ;AqD7nwBI;EACI,sDlDvEK;EFtIV,kBoD8M6B;EpD7M7B,aoD6MyC;ArDgowB5C;AqD/nwBQ;EACI,UAAA;ArDiowBZ;AqDhowBY;EACI,WAAA;EACA,YAAA;EACA,yBlD1JN;EFlCR,mBoD6L+B;EAGjB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;ArDkowBhB;AqD7nwBY;EACI,yBlD/TN;EFkHR,kBoD8M+B;EACjB,gBlD3UO;EkD4UP,clDpTR;EkDqTQ,elDpVC;EkDqVD,eAAA;EACA,eAAA;ArD+nwBhB;AqD7nwBY;EACI,elDzVC;EkD0VD,gBlDlVG;EkDmVH,gBAAA;ArD+nwBhB;AqD9nwBgB;EACI,clD1UR;AH08wBZ;AqD7nwBY;EACI,elDpGD;EkDqGC,gBlD3VO;EkD4VP,clDjMH;AHg0wBb;AqD5nwBQ;EACI,kBAAA;EACA,iBAAA;ArD8nwBZ;AqD7nwBY;EACI,gBAAA;EACA,mBlDtMN;EFlCR,kBoDyO+B;EACjB,YAAA;EACA,WAAA;EACA,kBAAA;EACA,elDhXC;AH++wBjB;AqD7nwBY;EACI,kBAAA;EACA,QAAA;EpDtTd,2BoDuTiC;EpDtTjC,mCoDsTiC;EpDrTjC,+BoDqTiC;EACnB,clDnWJ;EF4EV,yBoDwRkC;ArDmowBpC;AqDlowBgB;EACI,clDxWV;AH4+wBV;AqDjowBY;EACI,SAAA;ArDmowBhB;AqDjowBY;EACI,UAAA;ArDmowBhB;AqD/nwBY;EACI,YAAA;EpDlQd,kBoDmQ+B;EACjB,yBAAA;EACA,eAAA;ArDiowBhB;AqDhowBgB;EACI,clDvWb;AHy+wBP;AqDjowBoB;EACI,yBlDzWjB;EkD0WiB,qBlD1WjB;EkD2WiB,clD/WhB;AHk/wBR;AqDhowBgB;EACI,clDvXX;AHy/wBT;AqDjowBoB;EACI,yBlDzXf;EkD0Xe,qBlD1Xf;EkD2Xe,clDvXhB;AH0/wBR;;AqD5nwBA;EACI,YAAA;EACA,aAAA;EACA,yBlDjYI;EkDkYJ,8BAAA;ArD+nwBJ;AqD7nwBQ;EACI,elDtKG;EkDuKH,gBlD9ZW;EkD+ZX,mBAAA;EACA,clDpQE;AHm4wBd;AqD7nwBQ;EpD9TL,qBoD+TiC;EpD9TjC,mBoD8TgD;EACvC,gCAAA;ArDgowBZ;AqD9nwBQ;EACI,yBlDzQF;EFlCR,kBoD4S2B;EACjB,aAAA;ArDgowBZ;AqD/nwBY;EACI,clD/ZJ;EkDgaI,elDpLD;EkDqLC,gBlD5aG;AH6ixBnB;AqD/nwBY;EACI,clDrRH;EkDsRG,elD3LD;EkD4LC,gBlDnbK;AHojxBrB;AqD7nwBY;EACI,mBAAA;ArD+nwBhB;AqD9nwBgB;EACI,eAAA;EACA,gBAAA;EpDtVjB,kBoDuVyC;EpDtVzC,YoDsVqD;ArDiowBxD;AqD5nwBY;EACI,mBAAA;ArD8nwBhB;AqD5nwBoB;EACI,iBAAA;ArD8nwBxB;AqDznwBgB;EACI,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBlD3cV;EFkHR,mBoD0VmC;EACjB,clD/bZ;EkDgcY,elDvOL;EkDwOK,gBlDzdG;EFoGpB,iBoDsXyC;ArD2nwB5C;AqDvnwBQ;EACI,mBAAA;ArDynwBZ;AqDvnwBgB;EACI,kBAAA;ArDynwBpB;AqDvnwBgB;EpDxWd,kBoDyWmC;EACjB,qBlDlUb;AH27wBP;AqDrnwBQ;EACI,yBlDxXD;EkDyXC,aAAA;EpDhXV,kBoDiX2B;ArDunwB7B;AqDpnwBoB;EACI,mBAAA;EACA,clDvVX;EkDwVW,elD7PT;EkD8PS,gBlDrfH;EkDsfG,uBAAA;ArDsnwBxB;AqDrnwBwB;EACI,clDnenB;AH0lxBT;AqDnnwBwB;EACI,mBAAA;EACA,elDtQb;EkDuQa,gBlD9fL;AHmnxBvB;AqD5mwBgB;EACI,cAAA;ArD8mwBpB;AC5kxBI;EoD6dY;IAGQ,oBAAA;ErDgnwBtB;AACF;AqD9mwBgB;EpDrbd,yBoDsbsC;ArDknwBxC;AqDjnwBoB;EACI,sDlDrSR;EFtIb,kBoD4amD;EAC9B,kBAAA;EACA,cAAA;EACA,elD9RT;EkD+RS,clDzgBZ;AH4nxBZ;AqDlnwBwB;EACI,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;ArDonwB5B;AqDhnwBoB;EACI,yBlD3ab;EkD4aa,qBlDthBd;AHwoxBV;AqDjnwBwB;EACI,iGAAA;ArDmnwB5B;AqD7mwBQ;EpDpcL,qBoDqciC;EpDpcjC,mBoDocgD;EACvC,gCAAA;ArDgnwBZ;AqD/mwBY;EACI,elDnjBC;EkDojBD,gBlD5iBG;EkD6iBH,kBAAA;ArDinwBhB;AqD9mwBQ;EACI,UAAA;ArDgnwBZ;AqD/mwBY;EACI,iBAAA;EpDxbd,kBoDyb+B;EACjB,elD7jBC;AH8qxBjB;AqDhnwBgB;EACI,yBlD9hBX;EkD+hBW,qBlD/hBX;AHipxBT;AqDhnwBgB;EACI,yBlDxiBX;EkDyiBW,qBlDziBX;AH2pxBT;AqDhnwBgB;EACI,yBlDljBV;EkDmjBU,qBlDnjBV;AHqqxBV;AqDhnwBgB;EACI,yBlDxjBR;EkDyjBQ,qBlDzjBR;AH2qxBZ;;AqD3mwBI;EACI,aAAA;ArD8mwBR;AqD7mwBQ;EACI,mBAAA;ArD+mwBZ;AqD9mwBY;EACI,clDnkBN;AHmrxBV;AqD7mwBQ;EACI,elD5VG;EkD6VH,gBlDrlBO;AHosxBnB;AqD3mwBgB;EACI,clDnkBZ;AHgrxBR;;AqDvmwBA;EACI,clDvcS;AHijxBb;AqDzmwBI;EACI,YAAA;ArD2mwBR;AqDzmwBI;EACI,aAAA;EACA,clD7cK;AHwjxBb;AqD1mwBQ;EACI,elDnXG;AH+9wBf;AqDzmwBY;EACI,cAAA;EACA,mBAAA;ArD2mwBhB;AqDzmwBY;EACI,clDvdH;AHkkxBb;AqDvmwBY;EACI,cAAA;EACA,gBlDxnBO;EkDynBP,kBAAA;ArDymwBhB;AqDxmwBgB;EpDnkBd,2BoDokBqC;EpDnkBrC,mCoDmkBqC;EpDlkBrC,+BoDkkBqC;EACnB,WAAA;EACA,8BAAA;EACA,UAAA;ArD4mwBpB;AqD1mwBgB;EpDpiBd,kBoDqiBoC;EpDpiBpC,QoDoiB6C;EpDjiB7C,OoDiiB2D;ArD8mwB7D;AqD5mwBgB;EpDviBd,kBoDwiBoC;EpDviBpC,QoDuiB6C;EpDtiB7C,QoDsiBiD;ArDgnwBnD;AqD7mwBY;EACI,mBAAA;ArD+mwBhB;AqD7mwBY;EACI,clD/nBJ;AH8uxBZ;AqD1mwBgB;EACI,clDroBR;EkDsoBQ,WAAA;EACA,eAAA;EACA,YAAA;EACA,8BAAA;EACA,iCAAA;ArD4mwBpB;AqDtmwBoB;EACI,YAAA;ArDwmwBxB;AqDtmwBoB;EACI,8BAAA;ArDwmwBxB;AqDrmwBgC;EACI,gBlDrqBf;EkDsqBe,elD/arB;EkDgbqB,clD1pBxB;AHiwxBZ;AqD/lwBQ;EACI,8BAAA;EpD1kBT,mBoD2kBuC;ArDimwB1C;AqD/lwBQ;EACI,YAAA;ArDimwBZ;;AqD5lwBI;EACI,yBlD3hBE;AH0nxBV;AqD9lwBQ;EACI,elDncG;EkDocH,gBlD3rBO;AH2xxBnB;AqD5lwBQ;EACI,elDhcG;EkDicH,gBlDjsBO;EkDksBP,clDxkBD;EkDykBC,mBAAA;EACA,yBlDviBF;EFlCR,mBoD0kB2B;ArD8lwB7B;AqD3lwBY;EACI,kBAAA;ArD6lwBhB;AqD1lwBQ;EACI,gBAAA;ArD4lwBZ;AqDrlwBoB;EACI,kBAAA;ArDulwBxB;AqDhlwBI;EACI,iBAAA;EACA,elDzeO;EkD0eP,mBAAA;ArDklwBR;AqD/kwBQ;EACI,gBAAA;ArDilwBZ;AqD/kwBQ;EACI,YAAA;EACA,cAAA;ArDilwBZ;AqDhlwBY;EACI,yBAAA;EACA,sDlDjgBH;EF9GX,kBoDgnB+B;ArDklwBjC;AqDhlwBY;EACI,elDzfD;AH2kxBf;AqDjlwBgB;EACI,oBAAA;ArDmlwBpB;AqD/kwBwB;EACI,iBAAA;ArDilwB5B;AqD7kwBgB;EACI,eAAA;EACA,clDhvBR;AH+zxBZ;AqD7kwBgB;EACI,clDpmBP;EkDqmBO,mBAAA;ArD+kwBpB;AqD5kwBY;EACI,elD9gBD;EkD+gBC,yBlDvmBN;EFlCR,kBoD0oB+B;ArD8kwBjC;AqD3kwBgB;EACI,WAAA;ArD6kwBpB;AqD5kwBoB;EACI,WAAA;ArD8kwBxB;AqD7kwBwB;EACI,WAAA;ArD+kwB5B;AqDtkwBY;EACI,kBAAA;EACA,aAAA;EACA,0BAAA;ArDwkwBhB;AqDvkwBgB;EpD/rBd,kBoDgsBoC;EpD/rBpC,MoD+rB6C;EpD9rB7C,QoD8rB+C;EpD5rB/C,OoD4rBsD;EACpC,WAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;ArD4kwBpB;AqDzkwBY;EACI,elDhjBD;EkDijBC,gBlDtyBK;EkDuyBL,clD3oBH;AHstxBb;AqDzkwBY;EACI,elDljBD;EkDmjBC,gBlD1yBO;EkD2yBP,clD/xBJ;EkDgyBI,gBAAA;ArD2kwBhB;AqDzkwBY;EACI,WAAA;EpDnrBd,kBoDorB+B;ArD2kwBjC;AqDxkwBgB;EpD/sBb,kBoDgtByC;EpD/sBzC,aoD+sBqD;EpDxrBtD,kBoDyrBmC;EACjB,yBAAA;ArD2kwBpB;AqDzkwBwB;EACI,elDlkBb;EkDmkBa,gBlD1zBL;EkD2zBK,clD/yBhB;AH03xBZ;AqD1kwB4B;EACI,clD/yBtB;AH23xBV;AqDxkwB4B;EACI,clDxzBtB;AHk4xBV;AqDtkwBoB;EACI,gBAAA;ArDwkwBxB;AqDjkwBQ;EACI,eAAA;EACA,WAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,YAAA;ArDmkwBZ;AqDjkwBQ;EACI,WAAA;EpD5tBV,kBoD6tB2B;ArDmkwB7B;;AqD/jwBA;EACI,clD10BK;AH44xBT;;AqD7jwBY;EACI,WAAA;EACA,YAAA;EpDzuBd,kBoD0uB+B;EACjB,yBAAA;EACA,clD51BJ;EkD61BI,aAAA;EACA,mBAAA;EACA,uBAAA;ArDgkwBhB;;AqD3jwBA;EACQ,UAAA;ArD8jwBR;;AqD3jwBI;EACI,WAAA;ArD8jwBR;AqD3jwBQ;EACI,WAAA;ArD6jwBZ;;AqDzjwBA;EACI,WAAA;ArD4jwBJ;;AqDxjwBQ;EACI,iBAAA;EACA,cAAA;ArD2jwBZ;AqD1jwBY;EACI,eAAA;ArD4jwBhB;;AsDx8xBQ;EACI,aAAA;EACA,SAAA;AtD28xBZ;AsDz8xBY;EACI,YAAA;EACA,yBnDYJ;EmDXI,cnDuBR;EmDtBQ,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AtD28xBhB;;AsDl8xBY;ErDsFT,oBqDrFqC;ErDsFrC,mBqDtFmD;EACtC,iDAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,eAAA;AtDs8xBhB;AsDr8xBgB;EACI,enDiOL;EmDhOK,gBnDvBG;AH89xBvB;AsDt8xBoB;EACI,cnDfd;EmDgBc,iBAAA;AtDw8xBxB;AsDn8xBgB;EACI,iBAAA;EACA,WAAA;AtDq8xBpB;AsDp8xBoB;EACA,eAAA;AtDs8xBpB;AsDp8xBoB;EACI,iBAAA;AtDs8xBxB;AsDr8xBwB;EACI,eAAA;AtDu8xB5B;AsDr8xBwB;EACI,gBAAA;EACA,YAAA;EACA,aAAA;EACA,4CAAA;AtDu8xB5B;AsDt8xB4B;EACI,eAAA;AtDw8xBhC;AsDr8xBwB;EACI,aAAA;EACA,aAAA;EACA,yBnDwGlB;EmDvGkB,mBAAA;AtDu8xB5B;AsDr8xBgC;EACI,aAAA;EACA,SAAA;EACA,mBAAA;AtDu8xBpC;ACz9xBI;EqDe4B;IAKQ,eAAA;EtDy8xBtC;AACF;AsDx8xBoC;EACI,gBAAA;EACA,kBAAA;AtD08xBxC;AsDx8xB4C;EACI,QAAA;AtD08xBhD;;AsD77xBA;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;ErDqCF,kBqDpCmB;AtDg8xBrB;;AsD37xBA;EACI,kBAAA;AtD87xBJ;;AsD57xBA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,iBAAA;EACA,yBnD3FM;EmD4FN,enD+IW;EmD9IX,cnD/EI;AH8gyBR;AsD97xBI;EACI,yBAAA;EACA,cnDhGE;AHgiyBV;;AsD77xBA;EACI,cAAA;AtDg8xBJ;;AsD77xBI;EACI,enDqIO;AH2zxBf;;AsD77xBA;EACI,enDgIW;AHg0xBf;AsD/7xBC;EACO,YAAA;EACA,SAAA;AtDi8xBR;AsD/7xBG;EACa,WAAA;AtDi8xBhB;AsD/7xBK;EACC,wBAAA;AtDi8xBN;AsD57xBQ;EACI,gBAAA;AtD87xBZ;;AsD17xBA;EACI,yBnDhIM;EmDiIN,qBnDjIM;AH8jyBV;;AsD37xBA;EACI,yBAAA;AtD87xBJ;;AsD57xBA;EACI,UAAA;EACA,QAAA;AtD+7xBJ;;AsD77xBA;EACI,YAAA;AtDg8xBJ;;AsD97xBA;EACI,cnD5IQ;EmD6IR,iBAAA;EACA,YAAA;EACA,mBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;AtDi8xBJ;AsDh8xBI;EACI,YAAA;AtDk8xBR;;AsD/7xBA;EACI,eAAA;AtDk8xBJ;;AsDh8xBA;EACI,aAAA;EACA,8BAAA;AtDm8xBJ;;AsDj8xBA;EACI,iBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;AtDo8xBJ;;AsDj8xBI;EACI,enD0DO;EmDzDP,kBAAA;EACA,gBnD5LW;AHgoyBnB;;AsDj8xBA;EACI,aAAA;AtDo8xBJ;AC3lyBI;EqDsJJ;IAGQ,eAAA;EtDs8xBN;AACF;AsDr8xBI;EACI,kBAAA;EACA,YAAA;EACI,aAAA;EACA,mBAAA;EACA,yDAAA;EACA,kBAAA;EACA,iBAAA;AtDu8xBZ;ACzmyBI;EqD2JA;IASY,mBAAA;IACA,cAAA;EtDy8xBd;AACF;AsDx8xBQ;EACG,aAAA;AtD08xBX;AsDx8xBQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;EACA,mBnDpMH;EmDqMG,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cnDpMJ;EmDuMI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;AtD08xBZ;AsDz8xBY;EACI,cnD/MR;EmDgNQ,mBAAA;AtD28xBhB;;AsDt8xBA;EACI,cnDnFS;EmDoFT,kBAAA;EACA,enDMW;EmDLX,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;EACA,gBnDvPiB;AHgsyBrB;;AsDv8xBA;EACI,kBAAA;EACA,UAAA;EACA,UAAA;AtD08xBJ;;AsDx8xBA;EACI,kBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,6BAAA;EACA,0CAAA;EACA,kBAAA;EAGA,gCAAA;AtD28xBJ;;AsDz8xBA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBnDzQM;EmD0QN,mBAAA;EACA,qBAAA;EACA,6BAAA;EACA,yBAAA;EAGA,gCAAA;AtD48xBJ;;AsD18xBA;;EAEI,mBAAA;EACA,2BAAA;EACA,uBAAA;EACA,UAAA;EACA,mBAAA;AtD68xBJ;;AsD38xBA;EACI,yBAAA;AtD88xBJ;;AsD18xBI;EACI,UAAA;AtD68xBR;AsD38xBI;EACI,QAAA;EACA,SAAA;AtD68xBR;AsD38xBI;EACI,mBAAA;EACA,oBAAA;AtD68xBR;AsD38xBI;EACI,eAAA;AtD68xBR;;AsD18xBA;EACI,6BAAA;EACA,cnD/JS;AH4myBb;;AsD38xBA;EACI,6BAAA;EACA,cnDnKS;AHinyBb;;AsD58xBA;EACI,yBnDrTQ;EmDsTR,cnD1SI;AHyvyBR;;AsD78xBA;EACI,kBAAA;AtDg9xBJ;;AsD98xBA;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AtDi9xBJ;;AsD/8xBA;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,mBnD3UM;EmD4UN,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AtDk9xBJ;;AsDh9xBA;EACI,qBnDlVM;AHqyyBV;;AsDj9xBA;EACI,yBnDvUI;EmDwUJ,cnD5UK;AHgyyBT;;AsDl9xBA;EACI,yBnD3UI;EmD4UJ,eAAA;EACA,WAAA;EACA,UAAA;AtDq9xBJ;;AsDl9xBI;EACA,iBAAA;EACA,kBAAA;AtDq9xBJ;AsDn9xBS;EACC,mBAAA;EACA,iBAAA;AtDq9xBV;;AsDh9xBA;EACI,kBAAA;EACA,QAAA;EACA,kBAAA;AtDm9xBJ;;AsDj9xBA;EACI,kBAAA;AtDo9xBJ;;AsDl9xBA;EACI,YAAA;EACA,UAAA;AtDq9xBJ;;AsDn9xBA;EACI,cnDrXQ;EmDsXR,WAAA;EACA,YAAA;AtDs9xBJ;;AsDp9xBA;EACI,kBAAA;AtDu9xBJ;;AsDr9xBA;EACI,YAAA;EACA,kBAAA;EACA,4BAAA;EACA,yDAAA;EACA,mBnDrXI;AH60yBR;;AsDt9xBA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;AtDy9xBJ;;AsDv9xBA;EACI,aAAA;AtD09xBJ;;AsDx9xBA;EACI,YAAA;AtD29xBJ;;AsDz9xBA;EACI,cnDzYM;EmD0YN,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,enD1KW;EmD2KX,gBnDhamB;EmDianB,eAAA;AtD49xBJ;;AsD19xBA;EACI,cnDhZK;EmDiZL,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,enDnLW;EmDoLX,gBnDzamB;EmD0anB,eAAA;AtD69xBJ;;AsD39xBA;EACI,kBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,cnDzRS;AHuvyBb;;AsD39xBI;EACG,yBnD5aK;EmD6aL,cnDjaC;AH+3yBR;AC72yBI;EqD6YA;IAIQ,UAAA;EtDg+xBV;AACF;AsD/9xBO;EACC,yBnDpbE;AHq5yBV;;AsD79xBA;EACI,gBnDncmB;EmDocnB,enD7MW;EmD8MX,mBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;AtDg+xBJ;;AsD99xBA;EACI,gBAAA;EACA,iBAAA;EACA,iDAAA;EACA,aAAA;EACA,8BAAA;AtDi+xBJ;;AsD/9xBA;EACI,cAAA;EACA,iBAAA;EACA,YAAA;EACA,mBAAA;AtDk+xBJ;;AsD/9xBI;EACI,SAAA;AtDk+xBR;AsDj+xBQ;EACI,UAAA;EACA,gBAAA;AtDm+xBZ;AsDj+xBgB;EACI,aAAA;EACA,mBAAA;AtDm+xBpB;AsDl+xBoB;EACI,WAAA;EACA,YAAA;EACA,UAAA;AtDo+xBxB;AsDh+xBY;EACI,aAAA;AtDk+xBhB;AsDh+xBY;EACI,yBnDpdR;AHs7yBR;AsDj+xBgB;EACI,mBAAA;AtDm+xBpB;AsD79xBwB;EACI,yBAAA;AtD+9xB5B;AsDz9xBQ;EACI,UAAA;AtD29xBZ;;AsDv9xBA;EACI,aAAA;AtD09xBJ;;AsDv9xBI;EACI,aAAA;EACA,mBAAA;AtD09xBR;;AsDv9xBA;EACI,aAAA;AtD09xBJ;;AsDx9xBA;EACI,YAAA;AtD29xBJ;;AsDz9xBA;EACI,UAAA;EACA,uBAAA;AtD49xBJ;AsD39xBI;EACI,aAAA;AtD69xBR;AsD39xBI;;EAEI,aAAA;AtD69xBR;;AuD3/yBI;EACI,aAAA;AvD8/yBR;AuD7/yBQ;EACI,gCAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AvD+/yBZ;ACp9yBI;EsD/CI;IAMQ,sBAAA;IACA,kBAAA;EvDigzBd;AACF;AuDhgzBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,cpDMR;EoDLQ,WAAA;EACA,YAAA;EACA,YAAA;AvDkgzBhB;AC7+yBI;EsDtCQ;IAmBQ,aAAA;EvDogzBlB;AACF;AuDjgzBQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,qBAAA;EACA,aAAA;EACA,kBAAA;EACA,mBpDhBJ;EoDiBI,sDAAA;AvDmgzBZ;AClgzBI;EsDfI;IAgBQ,sBAAA;IACA,kBAAA;EvDqgzBd;AACF;AuDpgzBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AvDsgzBhB;AChhzBI;EsDIQ;IAQQ,mBAAA;EvDwgzBlB;AACF;ACrhzBI;EsDIQ;IAWQ,gBAAA;IACA,sBAAA;IACA,uBAAA;EvD0gzBlB;AACF;AuDzgzBgB;EACI,iBAAA;EACA,YAAA;AvD2gzBpB;AuDvgzBgC;EACI,6BAAA;AvDygzBpC;AuDlgzBgB;EACI,mBpDhER;EoDiEQ,iBAAA;EACA,cpDtDZ;EoDuDY,epDuKL;EoDtKK,gBpDlFC;EoDmFD,kBAAA;EACA,YAAA;AvDogzBpB;AuDngzBoB;EACI,mBpD1Ed;AH+kzBV;AC/izBI;EsDiCY;IAYQ,cAAA;EvDsgzBtB;AACF;AuDlgzBgB;EACI,uBAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AvDogzBpB;AuDhgzBQ;EACI,kBAAA;EACA,oBAAA;EACA,gCAAA;AvDkgzBZ;AuDjgzBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AvDmgzBhB;AuDjgzBoB;EACI,cpDnGf;EoDoGe,epD8HT;EoD7HS,gBpD3HH;AH8nzBrB;AuDlgzBwB;EACI,iBAAA;AvDogzB5B;AuD//yBY;EACI,aAAA;EACA,kBAAA;EACA,oCAAA;AvDigzBhB;AuDhgzBgB;EACI,oCAAA;AvDkgzBpB;AuDhgzBgB;EACI,mCAAA;AvDkgzBpB;AuDhgzBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AvDkgzBpB;AuDhgzBwB;EACI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cpDxIlB;EoDyIkB,epDlKX;EoDmKW,gBpD5JL;EoD6JK,aAAA;EACA,mBAAA;AvDkgzB5B;AuDjgzB4B;EACI,cAAA;EACA,iBAAA;AvDmgzBhC;AuDjgzB4B;EACI,cAAA;EACA,yBAAA;AvDmgzBhC;AuDjgzB4B;EACI,cpDpJvB;EoDqJuB,yBAAA;AvDmgzBhC;AuD//yBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cpDxKZ;AHyqzBZ;AuD//yB4B;EACI,cpD/JxB;AHgqzBR;AuD3/yBgB;EACI,cAAA;AvD6/yBpB;AuD3/yBwB;EACI,mBAAA;EACA,cpDtLhB;EoDuLgB,epDoDb;EoDnDa,gBpDpML;EoDqMK,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AvD6/yB5B;AuD5/yB4B;EACI,cpDxLtB;AHsrzBV;AuD1/yBoB;EACI,cpDpDX;EoDqDW,epDsCT;EoDrCS,gBpDnNH;EoDoNG,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AvD4/yBxB;AuDz/yBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AvD2/yBpB;AuD1/yBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AvD4/yBxB;AuD3/yBwB;EACI,kBAAA;AvD6/yB5B;AuD5/yB4B;EACI,WAAA;EACA,YAAA;EACA,aAAA;AvD8/yBhC;AuD7/yBgC;EACI,oBAAA;AvD+/yBpC;AuDz/yB4B;EACI,iBAAA;AvD2/yBhC;AuD1/yBgC;EACI,cpD5O1B;EoD6O0B,wBAAA;EACA,eAAA;AvD4/yBpC;AuDz/yB4B;EACI,iBAAA;AvD2/yBhC;AuD1/yBgC;EACI,cpDhP1B;EoDiP0B,wBAAA;EACA,eAAA;AvD4/yBpC;AuDz/yB4B;EACI,iBAAA;AvD2/yBhC;AuD1/yBgC;EACI,cAAA;EACA,wBAAA;EACA,eAAA;AvD4/yBpC;AuDx/yBwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,epDlCb;EoDmCa,gBpD3RP;EoD4RO,kBAAA;AvD0/yB5B;AuDx/yBgC;EACI,iBAAA;AvD0/yBpC;AuDv/yB4B;EACI,cpDnRtB;AH4wzBV;AuDv/yB4B;EACI,cpDlRtB;AH2wzBV;AuDr/yBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AvDu/yBxB;AuDr/yB4B;EACI,cpD/RtB;EoDgSsB,WAAA;EACA,YAAA;EACA,kBAAA;AvDu/yBhC;AuDr/yB4B;EACI,cpDnSvB;EoDoSuB,WAAA;EACA,YAAA;AvDu/yBhC;AuDh/yBQ;EACI,iBAAA;AvDk/yBZ;AuDj/yBY;EACI,kBAAA;EACA,0CAAA;EACA,mBpD7SR;EoD8SQ,sDAAA;EACA,aAAA;EACA,mBAAA;AvDm/yBhB;AuDl/yBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AvDo/yBpB;AuDl/yBwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cpD7UlB;EoD8UkB,epDvWX;EoDwWW,gBpDjWL;AHq1zBvB;AuDn/yB4B;EACI,cAAA;EACA,iBAAA;AvDq/yBhC;AuDn/yB4B;EACI,cAAA;EACA,yBAAA;AvDq/yBhC;AuDn/yB4B;EACI,cpDvVvB;EoDwVuB,yBAAA;AvDq/yBhC;AuDh/yBwB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cpD5WhB;AH81zBZ;AuDj/yB4B;EACI,WAAA;EACA,YAAA;EACA,cpDjOnB;AHotzBb;AuD9+yBgC;EACI,cpD1W5B;AH01zBR;AuD1+yBgB;EACI,eAAA;EACA,gCAAA;AvD4+yBpB;AuD1+yBwB;EACI,cpDjYhB;EoDkYgB,epDvJb;EoDwJa,gBpD/YL;EoDgZK,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AvD4+yB5B;AuD3+yB4B;EACI,cpDpYtB;AHi3zBV;AuDz+yBoB;EACI,cpDhQX;EoDiQW,epDtKT;EoDuKS,gBpD/ZH;EoDgaG,mBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AvD2+yBxB;AuD1+yBwB;EACI,iBAAA;EACA,WAAA;EACA,YAAA;AvD4+yB5B;AuDz+yBoB;EACI,cpDjRX;EoDkRW,epDvLT;EoDwLS,gBpDhbH;EoDibG,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AvD2+yBxB;AuDx+yBgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AvD0+yBpB;AuDz+yBoB;EACI,iBAAA;AvD2+yBxB;AuDz+yBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AvD2+yBxB;AuD1+yBwB;EACI,kBAAA;AvD4+yB5B;AuD1+yBgC;EACI,oBAAA;AvD4+yBpC;AuDv+yB4B;EACI,iBAAA;AvDy+yBhC;AuDx+yBgC;EACI,cpDxc1B;EoDyc0B,wBAAA;EACA,eAAA;AvD0+yBpC;AuDv+yB4B;EACI,iBAAA;AvDy+yBhC;AuDx+yBgC;EACI,cpD5c1B;EoD6c0B,wBAAA;EACA,eAAA;AvD0+yBpC;AuDv+yB4B;EACI,iBAAA;AvDy+yBhC;AuDx+yBgC;EACI,cAAA;EACA,wBAAA;EACA,eAAA;AvD0+yBpC;AuDt+yBwB;EACI,cAAA;EACA,epDxPb;EoDyPa,gBpDjfP;EoDkfO,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AvDw+yB5B;AuDt+yBgC;EACI,iBAAA;AvDw+yBpC;AuDr+yB4B;EACI,cpD/etB;AHs9zBV;AuDr+yB4B;EACI,cpD9etB;AHq9zBV;AuDn+yBoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AvDq+yBxB;AuDn+yB4B;EACI,cpDlXnB;EoDmXmB,WAAA;EACA,YAAA;EACA,kBAAA;AvDq+yBhC;AuDn+yB4B;EACI,cpD/fvB;EoDggBuB,WAAA;EACA,YAAA;AvDq+yBhC;;AuD19yBQ;EACI,cpDrhBA;AHk/zBZ;;AuDv9yBI;EACI,WAAA;EACA,YAAA;EACA,cpD/YK;AHy2zBb;;AuDv9yBA;EACI,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,epD7TW;EoD8TX,gBpDljBe;EoDmjBf,cpD5hBI;EoD6hBJ,cAAA;AvD09yBJ;AuDz9yBI;EACI,cAAA;EACA,mBpDhiBA;AH2/zBR;;AuDv9yBI;EACI,yBAAA;AvD09yBR;AuDv9yBQ;EACI,uBAAA;AvDy9yBZ;;AuDp9yBI;EACI,kBAAA;AvDu9yBR;AuDr9yBY;EACI,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AvDu9yBhB;;AuDh9yBA;EACI,+BAAA;AvDm9yBJ;;AuDh9yBI;EACI,cAAA;AvDm9yBR;AuDj9yBY;EACI,cpDllBJ;EoDmlBI,epDzWD;EoD0WC,gBpDlmBK;EoDmmBL,aAAA;EACA,mBAAA;EACA,kBAAA;AvDm9yBhB;AuDl9yBgB;EACI,mBpDnlBV;EoDolBU,cpD9kBZ;AHki0BR;AuDn9yBoB;EACI,cpDhlBhB;AHqi0BR;AuD/8yBQ;EACI,iBAAA;AvDi9yBZ;AuD/8yBQ;EACI,WAAA;EACA,YAAA;EACA,cpDzdC;AH06zBb;;AuD58yBI;EACI,mBAAA;EACA,0CAAA;EACA,mBpDpmBA;EoDqmBA,cpDjnBI;EoDknBJ,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;AvD+8yBR;AuD98yBQ;EACI,mBAAA;EACA,mBpD5nBF;EoD6nBE,cpD/mBJ;AH+j0BR;;AuDx8yBgB;EACI,6BAAA;AvD28yBpB;;AuDp8yBA;EACI,WAAA;AvDu8yBJ;;AuDr8yBA;EACI,oBAAA;AvDw8yBJ;;AuDt8yBA;EACI,aAAA;EACA,oBAAA;AvDy8yBJ;;AuDt8yBI;EACI,oBAAA;AvDy8yBR;;AuDp8yBQ;EACI,yBAAA;EACA,oBAAA;AvDu8yBZ;;AuDn8yBA;EACI,WAAA;AvDs8yBJ;;AuDp8yBA;EACI,2BAAA;AvDu8yBJ;;AuDr8yBA;EACI,uBAAA;AvDw8yBJ;;AuDt8yBA;EACI,cpD7hBS;EoD8hBT,epDncW;EoDocX,gBpD5rBiB;AHqo0BrB;;AuDt8yBA;EACI,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,0CAAA;EACA,mBpD1qBI;EoD2qBJ,oBAAA;AvDy8yBJ;AuDx8yBI;EACI,gCAAA;AvD08yBR;AuDz8yBQ;EACI,epD/cG;EoDgdH,gBpDvsBO;EoDwsBP,cpD7rBA;EoD8rBA,mBAAA;EACA,aAAA;EACA,mBAAA;AvD28yBZ;AuD18yBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;EACA,cpDtjBH;AHkg0Bb;AuDx8yBI;EACI,eAAA;EACA,gCAAA;AvD08yBR;AuDz8yBQ;EACI,eAAA;AvD28yBZ;AuD18yBY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,aAAA;AvD48yBhB;AuD38yBgB;EACI,mBAAA;EACA,mBpD3tBR;AHwq0BZ;AuD58yBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AvD88yBxB;AuD58yBoB;EACI,cpDttBhB;AHoq0BR;AuD18yBgB;EACI,epD7fL;EoD8fK,gBpDpvBG;EoDqvBH,cpD1lBP;EoD2lBO,gBAAA;EACA,aAAA;EACA,mBAAA;AvD48yBpB;AuD38yBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AvD68yBxB;AuD18yBgB;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBpD7vBV;EoD8vBU,cpDhvBZ;AH4r0BR;AuDt8yBI;EACI,gBAAA;EACA,aAAA;AvDw8yBR;AuDv8yBQ;EACI,epD3hBG;EoD4hBH,gBpDnxBW;EoDoxBX,cpDxwBA;AHit0BZ;AuDv8yBQ;EACI,eAAA;AvDy8yBZ;AuDx8yBY;EACI,mBAAA;AvD08yBhB;AuDx8yBY;EA0GO,epD/oBJ;EoDgpBI,gBpDx4BE;EoDy4BF,aAAA;EACA,mBAAA;AvDi2yBnB;AuD58yBoB;EACI,iBAAA;AvD88yBxB;AuD78yBwB;EACI,wBAAA;EACA,eAAA;AvD+8yB5B;AuD58yBoB;EACI,cAAA;EACA,aAAA;EACA,mBAAA;AvD88yBxB;AuDz8yBoB;EACI,iBAAA;AvD28yBxB;AuD18yBwB;EACI,wBAAA;EACA,eAAA;AvD48yB5B;AuDz8yBoB;EACI,cpDlyBd;EoDmyBc,aAAA;EACA,mBAAA;AvD28yBxB;AuDt8yBoB;EACI,iBAAA;AvDw8yBxB;AuDv8yBwB;EACI,wBAAA;EACA,eAAA;AvDy8yB5B;AuDt8yBoB;EACI,cpDrzBd;EoDszBc,aAAA;EACA,mBAAA;AvDw8yBxB;AuDn8yBoB;EACI,iBAAA;AvDq8yBxB;AuDp8yBwB;EACI,wBAAA;EACA,eAAA;AvDs8yB5B;AuDn8yBqB;EACG,cAAA;EACA,aAAA;EACA,mBAAA;AvDq8yBxB;AuDh8yBoB;EACI,iBAAA;AvDk8yBxB;AuDj8yBwB;EACI,wBAAA;EACA,eAAA;AvDm8yB5B;AuDh8yBqB;EACG,cpDv0Bf;EoDw0Be,aAAA;EACA,mBAAA;AvDk8yBxB;AuD77yBoB;EACI,iBAAA;AvD+7yBxB;AuD97yBwB;EACI,wBAAA;EACA,eAAA;AvDg8yB5B;AuD77yBoB;EACI,cpD51Bf;EoD61Be,aAAA;EACA,mBAAA;AvD+7yBxB;AuD17yBoB;EACI,iBAAA;AvD47yBxB;AuD37yBwB;EACI,wBAAA;EACA,eAAA;AvD67yB5B;AuD17yBoB;EACI,cpD72Bd;EoD82Bc,aAAA;EACA,mBAAA;AvD47yBxB;AuDp7yBgB;EACI,gBAAA;AvDs7yBpB;;AuD/6yBI;EACI,aAAA;EACA,mBAAA;AvDk7yBR;AuDj7yBQ;EACI,WAAA;EACA,YAAA;AvDm7yBZ;AuDl7yBY;EACI,mBAAA;AvDo7yBhB;;AuD/6yBA;EACI,eAAA;EACA,gCAAA;AvDk7yBJ;AuD/6yBY;EACG,aAAA;EACA,2BAAA;EACA,mBAAA;EACC,aAAA;EACA,epDjrBD;EoDkrBC,gBpDx6BO;EoDy6BP,cpD9wBH;EoD+wBG,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AvDi7yBhB;AuDh7yBgB;EACI,mBAAA;EACA,mBAAA;EACA,aAAA;EACA,cpD35BZ;AH600BR;AuDj7yBoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AvDm7yBxB;AuDh7yBgB;EACI,mBAAA;EACA,cpDp6BZ;AHs10BR;AuD/6yBgB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AvDi7yBpB;AuD/6yBgB;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBpDl8BV;EoDm8BU,cpDr7BZ;AHs20BR;;AuDz6yBA;EACI,mBpDl8BK;EoDm8BL,cpD/7BI;EoDg8BJ,kBAAA;EACA,oBAAA;EACA,aAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AvD46yBJ;AuD36yBI;EACI,aAAA;EACA,mBAAA;AvD66yBR;AuD56yBQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AvD86yBZ;;AuD16yBA;EACI,aAAA;EACA,kBAAA;EACA,mBpDp9BI;AHi40BR;AuD56yBI;EACI,mBAAA;AvD86yBR;AuD56yBI;EACI,kBAAA;AvD86yBR;AuD76yBQ;EACI,cpDv+BA;EoDw+BA,epD3vBG;EoD4vBH,gBpDp/BO;EoDq/BP,kBAAA;AvD+6yBZ;AuD76yBQ;EACI,cpD91BC;EoD+1BD,epDpwBG;EoDqwBH,gBpD7/BS;EoD8/BT,kBAAA;AvD+6yBZ;AuD56yBI;EACI,kBAAA;AvD86yBR;;AuD36yBA;EACI,aAAA;EACA,mBAAA;AvD86yBJ;AuD76yBI;EACI,epD/wBO;EoDgxBP,gBpDvgCW;EoDwgCX,cpD7/BI;EoD8/BJ,gBAAA;EACA,kBAAA;AvD+6yBR;AuD76yBI;EACI,epDxxBO;EoDyxBP,gBpDjhCa;EoDkhCb,cAAA;AvD+6yBR;;AuD56yBA;EACI,mBAAA;EACA,uCAAA;AvD+6yBJ;AuD96yBI;EACI,epDhyBO;EoDiyBP,gBpDxhCe;EoDyhCf,cpD7gCI;EoD8gCJ,mBAAA;AvDg7yBR;AuD96yBI;EACI,epDvyBO;EoDwyBP,gBpDhiCa;EoDiiCb,cpDp4BK;EoDq4BL,mBAAA;AvDg7yBR;AuD76yBQ;EAKI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cpD1hCF;EoD2hCE,epDxzBG;EoDyzBH,gBpD9iCW;EoD+iCX,oBAAA;EACA,mBAAA;AvD26yBZ;AuDv7yBY;EACI,cAAA;EACA,iBAAA;AvDy7yBhB;;AuD36yBA;EACI,yBpDjiCK;AH+80BT;;AuDx6yBiB;EACG,cpDxiCX;EoDyiCW,kBAAA;AvD26yBpB;AuDz6yBiB;EACG,cpD9iCV;AHy90BV;;AuDn6yBQ;EAKI,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,cpD7jCH;EoD8jCG,epD71BG;EoD81BH,gBpDnlCW;EoDolCX,oBAAA;EACA,mBAAA;AvDk6yBZ;AuD96yBY;EACI,cAAA;EACA,iBAAA;AvDg7yBhB;;AuDl6yBA;EACI,uBAAA;EACA,iBAAA;EACA,kBAAA;AvDq6yBJ;AuDp6yBI;EACI,mBAAA;AvDs6yBR;AuDp6yBI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;AvDs6yBR;AuDr6yBQ;EACI,kBAAA;EACA,mBpDllCH;EoDmlCG,cpD/kCJ;AHs/0BR;;AuDl6yBA;EACI,eAAA;AvDq6yBJ;;AuDl6yBI;EACI,mBAAA;AvDq6yBR;AuDp6yBQ;EACI,aAAA;EACA,mBAAA;EACA,cpD19BC;EoD29BD,WAAA;EACA,YAAA;AvDs6yBZ;AuDr6yBY;EACI,iBAAA;AvDu6yBhB;AuDl6yBgB;EACI,iBAAA;EACA,mBAAA;EACA,mBpD3gCT;EoD4gCS,cpDv+BP;EoDw+BO,epD1oCH;EoD2oCG,gBpDroCC;EoDsoCD,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;AvDo6yBpB;AuDn6yBoB;EACI,mBpDloCd;EoDmoCc,cpDrnChB;AH0h1BR;AuDl6yBgB;EACI,mBpDvoCV;EoDwoCU,cpD1nCZ;EoD2nCY,oBAAA;AvDo6yBpB;;AuD35yBY;EACI,UAAA;EACA,YAAA;EACA,WAAA;AvD85yBhB;AuD75yBgB;EACI,6BAAA;EACA,WAAA;EACA,YAAA;AvD+5yBpB;AuD95yBoB;EACI,cpDzpCZ;AHyj1BZ;AuD95yBoB;EACI,6BAAA;AvDg6yBxB;AuD/5yBwB;EACI,cpDhqClB;AHik1BV;;AwDnl1BA;EACI,kBAAA;EACA,mBrD8BI;EqD7BJ,kBAAA;EvDyGD,gBuDxGyB;EvDyGzB,auDzGkC;EACjC,sDAAA;EACA,yBAAA;AxDul1BJ;AwDtl1BI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;AxDwl1BR;AwDvl1BQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AxDyl1BZ;AwDxl1BY;EACI,mBrDMR;EqDLQ,yBAAA;EACA,iBAAA;AxD0l1BhB;AwDtl1BY;EACI,erD+ND;EqD9NC,gBrDzBG;EqD4BH,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AxDwl1BhB;AwDvl1BgB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AxDyl1BpB;AwDtl1BoB;EACI,mBrD5Bd;AHon1BV;AwDpl1BoB;EACI,mBrD3Bf;AHin1BT;AwDhl1BI;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,sBAAA;EACA,mBAAA;AxDkl1BR;AwDjl1BQ;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,kBAAA;AxDml1BZ;AwDll1BY;EACI,kBAAA;AxDol1BhB;AwDjl1BgB;EACI,WAAA;EACA,mBrD5DV;EqD6DU,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AxDml1BpB;AwD/k1BQ;EACI,yBrD8BD;EqD7BC,aAAA;EACA,mBAAA;AxDil1BZ;AwDhl1BY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;AxDkl1BhB;AwDhl1BY;EACI,erDwJD;AH070Bf;AwD/k1BQ;EACI,crDxFF;EqDyFE,erD1GK;EqD2GL,gBrDnGO;EqDoGP,mBAAA;AxDil1BZ;AwD/k1BQ;EACI,erDgJG;EqD/IH,gBrDxGO;AHyr1BnB;AwD/k1BQ;EACI,erD0IG;AHu80Bf;AwD7k1BQ;EAGI,aAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,gBAAA;EACA,yBrDLD;EFdR,auDoBsC;EAC7B,kBAAA;AxD+k1BZ;AwD9k1BY;EACI,crDhHJ;EqDiHI,gBrD9HK;EqD+HL,erDwHD;AHw90Bf;AwD/k1BgB;EACI,cAAA;EACA,crD0BP;EqDzBO,eAAA;AxDil1BpB;AwD5k1BI;EACI,aAAA;AxD8k1BR;AwD3k1BQ;EACI,crDhIA;AH6s1BZ;AwD3k1BQ;EACI,UAAA;EACA,qBAAA;EACA,2BAAA;EACA,sBAAA;EACA,gBAAA;AxD6k1BZ;AwD3k1BQ;EACI,aAAA;AxD6k1BZ;AwDxk1BoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AxD0k1BxB;AwDvk1BwB;EACI,crD1IpB;AHmt1BR;;AwD/j1BI;EACI,aAAA;AxDkk1BR;AwDhk1BI;EACI,MAAA;AxDkk1BR;AwDhk1BI;EACI,cAAA;AxDkk1BR;AwD/j1BQ;EACI,yBAAA;AxDik1BZ;;AwD5j1BI;EACI,gBrD7Le;EqD8Lf,erDyDO;EqDtDP,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EvDhGL,gBuDiG6B;EvDhG7B,iBuDgGsC;EACjC,iDAAA;AxDgk1BR;AwD/j1BQ;EACI,WAAA;EACA,iBAAA;EACA,crDhMF;AHiw1BV;;AwD5j1BI;EACI,YAAA;EACA,YAAA;EACA,SAAA;EACA,yBrDzME;AHww1BV;AwD9j1BQ;EACI,YAAA;AxDgk1BZ;AwD9j1BQ;EACI,QAAA;EACA,UAAA;AxDgk1BZ;AwD/j1BY;EACI,crDnMR;EqDoMQ,erD0BD;EqDzBC,mBAAA;AxDik1BhB;;AwD5j1BA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,mBAAA;AxD+j1BJ;AwD9j1BI;EACI,YAAA;EACA,aAAA;EACA,0BAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AxDgk1BR;AwD/j1BQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,sBAAA;AxDik1BZ;AwDhk1BY;EACI,eAAA;AxDkk1BhB;AwD/j1BQ;EAQI,YAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AxD0j1BZ;AwDpk1BY;EACI,WAAA;EACA,YAAA;EACA,crDtPR;EqDuPQ,kBAAA;EACA,mBrD5PP;AHk01BT;AwD5j1BQ;EACI,SAAA;AxD8j1BZ;AwD7j1BY;EACI,mBAAA;AxD+j1BhB;AwD7j1BY;EACI,gBAAA;AxD+j1BhB;;AwDxj1BQ;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AxD2j1BZ;;AwDtj1BI;EACI,cAAA;AxDyj1BR;;AwDtj1BA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;AxDyj1BJ;AwDvj1BQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;AxDyj1BZ;AwDxj1BY;EAYI,iBAAA;AxD+i1BhB;AwD1j1BgB;EACI,qBAAA;EACA,WAAA;EACA,YAAA;AxD4j1BpB;AwD3j1BoB;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;AxD6j1BxB;AwDzj1BgB;EACI,cAAA;AxD2j1BpB;AwDxj1BoB;EACI,kBAAA;AxD0j1BxB;AwDzj1BwB;EACI,WAAA;EACA,iFAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,kBAAA;EACA,yBAAA;AxD2j1B5B;AwDzj1BwB;EACI,crD7UpB;EqD8UoB,kBAAA;EACA,SAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AxD2j1B5B;;AwDlj1BA;EACI,aAAA;AxDqj1BJ;;AwDnj1BA;EACI,aAAA;AxDsj1BJ;;AwDnj1BI;EACI,kBAAA;AxDsj1BR;AwDrj1BQ;EACI,kBAAA;AxDuj1BZ;AwDrj1BQ;EACI,kBAAA;EACA,UAAA;EACA,QAAA;AxDuj1BZ;AwDtj1BY;EACI,WAAA;EACA,crD1OH;AHky1Bb;AwDpj1BI;EACI,cAAA;AxDsj1BR;;AwDlj1BI;EACI,mBAAA;AxDqj1BR;;AwDlj1BA;EACI,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;AxDqj1BJ;AwDpj1BI;EACI,QAAA;AxDsj1BR;AwDpj1BI;EACI,kBAAA;AxDsj1BR;AwDpj1BI;EACI,qBrDrZE;AH281BV;;AwDlj1BI;EACI,aAAA;AxDqj1BR;;AwDjj1BI;EACI,0CAAA;EACA,crD/QK;EqDgRL,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,erDrbS;EqDsbT,gBrD9aW;AHk+1BnB;AwDnj1BQ;EACI,yBrDvaF;EqDwaE,crD1ZJ;AH+81BR;;AwD/i1BI;EACI,gBrDzbe;EqD0bf,erDnMO;EqDoMP,mBAAA;EACA,crDhbI;AHk+1BZ;;AwD9i1BI;EACI,gBrDjce;EqDkcf,erD3MO;EqD4MP,mBAAA;EACA,crDxbI;AHy+1BZ;;AC381BI;EuD+ZI;IACI,YAAA;ExDgj1BV;EwD9i1BM;IACI,kBAAA;ExDgj1BV;EwD9i1BM;IACI,kBAAA;ExDgj1BV;AACF;ACv91BI;EuD0aI;IACI,YAAA;ExDgj1BV;AACF;;AyD5g2BQ;EACE,iBAAA;AzD+g2BV;ACh+1BI;EwDhDI;IAGI,cAAA;EzDih2BV;AACF;;AyD7g2BA;EACI,gBAAA;AzDgh2BJ;AyD/g2BI;EACI,ctDsJK;AH231Bb;;AyD9g2BA;EACI,mBAAA;AzDih2BJ;;AyD/g2BA;EACI,gBAAA;AzDkh2BJ;;AyDhh2BA;EACI,ctDLM;AHwh2BV;;AyDhh2BI;EACI,iBAAA;AzDmh2BR;;AyD/g2BC;EACC,mBAAA;AzDkh2BF;;AyD/g2BA;EACG,yBtDVO;AH4h2BV;;AyDhh2BA;EACI,gBAAA;EACA,WAAA;AzDmh2BJ;;AyDjh2BA;EACI,gBAAA;AzDoh2BJ;;AC7g2BI;EwDJA;IAEQ,cAAA;EzDoh2BV;AACF;ACnh2BI;EwDAI;IAEQ,2BAAA;IACA,gBAAA;IACA,mBAAA;EzDqh2Bd;AACF;AC1h2BI;EwDSQ;IAEQ,cAAA;IACA,aAAA;EzDmh2BlB;AACF;AChi2BI;EwDOA;IAUQ,sBAAA;IACA,uBAAA;EzDmh2BV;AACF;;A0Dxl2BA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;A1D2l2BJ;AC5i2BI;EyDlDJ;IAKQ,cAAA;E1D6l2BN;AACF;A0D5l2BI;EACI,aAAA;EACA,mBAAA;A1D8l2BR;A0D7l2BQ;EACI,evDsPG;EuDrPH,cAAA;EACA,iBAAA;A1D+l2BZ;A0D9l2BY;EACI,cvDoJH;AH481Bb;;AC7j2BI;EyD7BA;IAEQ,2BAAA;IACI,gBAAA;E1D6l2Bd;AACF;;A0Dvl2BY;EACI,aAAA;EACA,8BAAA;EACA,evD+ND;EuD9NC,mBAAA;EACA,oBAAA;EACA,iDAAA;EACA,mBAAA;A1D0l2BhB;A0Dzl2Ba;EACG,eAAA;EACA,cvDPP;AHkm2BT;A0Dvl2BgB;EACI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBvDqHV;EuDpHU,mBAAA;EACA,mBAAA;A1Dyl2BpB;A0Dxl2BoB;EACI,WAAA;EACA,YAAA;EACA,mBAAA;A1D0l2BxB;;A0Dnl2BA;EACI,aAAA;EACA,SAAA;A1Dsl2BJ;;A0Dpl2BA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;A1Dul2BJ;A0Dtl2BI;EACA,cvDtDM;EuDuDN,evDwLW;EuDvLX,kBAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;A1Dwl2BJ;A0Dtl2BI;EACI,evD6KO;AH261Bf;;A0Drl2BA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;A1Dwl2BJ;A0Dvl2BI;EACA,cvD/DK;EuDgEL,evDqKW;EuDpKX,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;A1Dyl2BJ;A0Dvl2BI;EACI,evD0JO;AH+71Bf;;A0Dtl2BA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;A1Dyl2BJ;A0Dxl2BI;EACA,cvD5EK;EuD6EL,evDkJW;EuDjJX,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;A1D0l2BJ;A0Dxl2BI;EACI,evDuIO;AHm91Bf;;A0Dvl2BA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;A1D0l2BJ;A0Dzl2BI;EACA,cvD/FK;EuDgGL,evD+HW;EuD9HX,WAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,aAAA;EACA,mBAAA;A1D2l2BJ;A0Dzl2BI;EACI,evDoHO;AHu+1Bf;;A0Dxl2BA;EACI,aAAA;A1D2l2BJ;ACxr2BI;EyD4FJ;IAGQ,eAAA;IACA,uBAAA;E1D6l2BN;AACF;;A0D3l2BA;EACI,aAAA;EACA,kBAAA;EACA,WAAA;A1D8l2BJ;;A0D5l2BA;EACI,yBvDrIM;AHou2BV;;A0D7l2BA;EACI,yBvDpIM;AHou2BV;;A0D9l2BA;EACI,yBvDrIK;AHsu2BT;;A0D/l2BA;EACI,YAAA;EACA,WAAA;A1Dkm2BJ;;A0Dhm2BA;EACI,cvDtIK;EuDuIL,yBAAA;A1Dmm2BJ;;A0Djm2BA;EACI,aAAA;A1Dom2BJ;A0Dnm2BI;EACI,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACC,cvDvJA;EuDwJA,YAAA;A1Dqm2BT;A0Dnm2BI;EACI,qBAAA;EACA,kBAAA;EACA,cvDrKI;EuDsKJ,evDuEO;EuDtEN,gBvDlLU;AHux2BnB;A0Dnm2BI;EACI,kBAAA;EACA,cvD5BK;EuD6BL,evD8DO;EuD7DP,gBvD3La;AHgy2BrB;A0Dlm2BQ;EACI,kBAAA;A1Dom2BZ;;A2Dvy2BQ;EACI,yBxD6BJ;EwD5BI,oBAAA;A3D0y2BZ;;A2Dty2BA;EACI,oBAAA;EACA,iDAAA;A3Dyy2BJ;;A2Dty2BI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,0CAAA;EACA,kBAAA;A3Dyy2BR;AC9w2BI;E0DrCA;IAYQ,YAAA;E3D2y2BV;AACF;ACnx2BI;E0DrCA;IAeQ,YAAA;IACA,kBAAA;E3D6y2BV;AACF;ACzx2BI;E0DrCA;IAmBQ,aAAA;E3D+y2BV;AACF;A2D9y2BQ;EACI,6BAAA;EACA,uBAAA;A3Dgz2BZ;ACly2BI;E0DhBI;IAIQ,uBAAA;E3Dkz2Bd;AACF;ACvy2BI;E0DhBI;IAOQ,uBAAA;E3Doz2Bd;AACF;A2Dlz2BQ;EACI,sBAAA;EACA,gBAAA;A3Doz2BZ;A2Dlz2BQ;EACI,kBAAA;A3Doz2BZ;ACnz2BI;E0DFI;IAGQ,iBAAA;E3Dsz2Bd;AACF;A2Drz2BY;EACI,yBxDtBR;EwDuBQ,UAAA;A3Duz2BhB;A2Dtz2BgB;EACI,8BAAA;EACA,gCAAA;EACA,kBAAA;EACA,cxDuGP;AHit2Bb;A2Dpz2BgB;EACI,SAAA;EACA,gBAAA;EACA,UAAA;A3Dsz2BpB;A2Dnz2B4B;EACI,yBxDvCxB;AH412BR;A2Dpz2BgC;EACI,yBxDzC5B;EwD0C4B,mBAAA;A3Dsz2BpC;A2Dpz2BgC;EACI,yBxD7C5B;AHm22BR;A2Dnz2BoC;EACI,qBxDkF3B;AHmu2Bb;A2Dhz2BgC;EACI,yBxDvD5B;EwDwD4B,yBAAA;EACA,iCAAA;EACA,6BAAA;EACA,cxDvExB;AHy32BZ;A2D/y2B4B;EACI,cxD3EpB;AH432BZ;A2D/y2B4B;EACI,cxD9EpB;EwD+EoB,gBxD3FT;EwD4FS,exD2JjB;AHsp2Bf;ACn22BI;E0D+CwB;IAKQ,exDrGnB;EHw52Bf;AACF;A2D9y2BgC;EACI,cAAA;A3Dgz2BpC;A2D/y2BoC;EACI,aAAA;A3Diz2BxC;A2D/y2BoC;EACI,0CAAA;EACA,cxDjG9B;EwDkG8B,kBAAA;EACA,kBAAA;A3Diz2BxC;A2Dhz2BwC;EACI,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBxDzGlC;EwD0GkC,WAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;A3Dkz2B5C;;A2Dry2BA;EACI,SAAA;A3Dwy2BJ;A2Dty2BQ;EACI,exD+GG;EwD9GH,gBxDzIO;EwD0IP,mBAAA;EACA,oBAAA;EACA,iDAAA;A3Dwy2BZ;A2Dpy2BQ;EACI,gBAAA;EACA,iBAAA;A3Dsy2BZ;A2Djy2BQ;EACI,cxDEC;EwDDD,exDjKK;EwDkKL,cAAA;EACA,eAAA;A3Dmy2BZ;;A2D9x2BI;EACI,YAAA;A3Diy2BR;;A2D5x2BQ;EACI,aAAA;A3D+x2BZ;A2D7x2BQ;EACI,2BAAA;A3D+x2BZ;A2D9x2BY;EACI,aAAA;A3Dgy2BhB;A2D9x2BY;EACI,aAAA;A3Dgy2BhB;A2D1x2BQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;A3D4x2BZ;A2D3x2BY;EACI,gBAAA;A3D6x2BhB;ACr72BI;E0D4II;IAeQ,cAAA;E3D8x2Bd;AACF;A2D7x2BY;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A3D+x2BhB;ACl82BI;E0D6JQ;IAQQ,mBAAA;E3Diy2BlB;AACF;A2Dhy2BgB;EACI,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBxD/DV;EwDgEU,mBAAA;EACA,kBAAA;EACA,cAAA;A3Dky2BpB;A2Djy2BoB;EACI,cxDxNd;AH2/2BV;A2D9x2BgB;EACI,exD/OH;EwDgPG,gBxDxOD;AHwg3BnB;A2D9x2BgB;EACI,cxDjFP;EwDkFO,exDSL;AHux2Bf;A2D5x2BgB;EACI,yBxD9NX;AH4/2BT;A2D7x2BoB;EACI,qBxDxOZ;EwDyOY,yBxDzOZ;AHwg3BZ;A2D5x2BgB;EACI,oCAAA;EACA,cxD5OV;EwD6OU,yBAAA;EACA,gBAAA;EACA,kBAAA;A3D8x2BpB;A2D5x2BgB;EACI,cxDlPV;AHgh3BV;A2D5x2BgB;EACI,cxD/OX;EwDgPW,gBxDnQD;AHii3BnB;A2D5x2BgB;EACI,yDAAA;EACA,iBAAA;EACA,cxD7PR;EwD8PQ,kBAAA;A3D8x2BpB;;A2Dlx2BwB;EACI,yBAAA;A3Dqx2B5B;A2Dnx2BwB;EACI,yBAAA;A3Dqx2B5B;;A2D7w2BA;EACI,gBAAA;A3Dgx2BJ;;A2D3w2BY;EACI,gBxDxSG;EwDySH,exDlDD;AHg02Bf;A2D1w2BI;EACI,yBxDvRA;EwDwRA,aAAA;EACA,sDAAA;EACA,kBAAA;EACA,mBAAA;A3D4w2BR;A2D3w2BQ;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,8BAAA;EACA,sCAAA;EACA,4BAAA;EACA,mBAAA;A3D6w2BZ;A2D5w2BY;EACI,gBAAA;A3D8w2BhB;A2D3w2BgB;EACI,yBAAA;EACA,cxDvTV;EwDwTU,0CAAA;EACA,gBAAA;EACA,kBAAA;EACA,exDhVH;AH6l3BjB;A2D1w2BoB;EACI,qBxD1Nb;EwD2Na,cxDlUZ;EwDmUY,yBxDvThB;EwDwTgB,gBxDhVD;AH4l3BvB;A2Dvw2BgB;EACI,gBxDtVG;EwDuVH,exDhGL;AHy22Bf;A2Dtw2BY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBxDhMN;EwDmMM,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,iBAAA;EACA,cAAA;A3Dww2BhB;A2Dtw2BY;EACI,exDxHD;EwDyHC,cxDlNH;EwDmNG,gBxD/WK;EwDgXL,eAAA;A3Dww2BhB;A2Drw2BgB;EACI,yBAAA;EACA,cxDxWR;EwDyWQ,yBxD7VZ;EwD8VY,kBAAA;EACA,iBAAA;EACA,gBxDvXD;EwDwXC,aAAA;EACA,mBAAA;A3Duw2BpB;;A2Dhw2BA;EACI,gCAAA;EACA,mBAAA;A3Dmw2BJ;;A2Dhw2BI;EACI,mBAAA;A3Dmw2BR;AChm3BI;E0D4VA;IAGQ,iCAAA;IACA,6BAAA;E3Dqw2BV;AACF;A2Dpw2BQ;EACI,mBAAA;A3Dsw2BZ;ACzm3BI;E0DkWI;IAGQ,kBAAA;E3Dww2Bd;AACF;AC9m3BI;E0DkWI;IAMQ,mBAAA;E3D0w2Bd;AACF;A2Dzw2BY;EACI,exD5ZC;EwD6ZD,gBxDrZG;AHgq3BnB;A2Dzw2BY;EACI,exDrKD;AHg72Bf;A2Dxw2BQ;EACI,mBAAA;A3D0w2BZ;A2Dzw2BY;EACI,YAAA;A3D2w2BhB;A2Dzw2BoB;EACI,WAAA;EACA,YAAA;EACA,iBAAA;A3D2w2BxB;A2Drw2BQ;EACI,iBAAA;A3Duw2BZ;ACxo3BI;E0DgYI;IAGQ,gBAAA;IACA,yBAAA;IACA,gBAAA;E3Dyw2Bd;AACF;A2Dxw2BY;EACI,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;A3D0w2BhB;A2Dzw2BgB;EACI,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,yBxDxbX;EwDybW,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;A3D2w2BpB;A2D1w2BoB;EACI,cxD1bhB;AHss3BR;;A2Drw2BA;EACI,YAAA;EACA,mBAAA;A3Dww2BJ;ACzr3BI;E0D+aJ;IAIQ,YAAA;E3D0w2BN;AACF;A2Dzw2BI;EACI,WAAA;A3D2w2BR;A2D1w2BQ;EACI,cxDvUC;AHml3Bb;A2Dzw2BI;EACI,YAAA;A3D2w2BR;;A2Dxw2BA;EACI,YAAA;A3D2w2BJ;;A2Dxw2BI;EACI,mBAAA;A3D2w2BR;A2D1w2BQ;EACI,exDvfK;EwDwfL,gBxDhfO;AH4v3BnB;A2D1w2BQ;EACI,cxDzVC;AHqm3Bb;;A2Dvw2BI;EACI,exDjgBS;EwDkgBT,gBxD1fW;AHow3BnB;A2Dxw2BI;EACI,cxDnWK;AH6m3Bb;A2Dvw2BQ;EACI,sDAAA;EACA,mBxD3eJ;EwD4eI,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;A3Dyw2BZ;A2Dxw2BY;EACI,eAAA;A3D0w2BhB;A2Dxw2BY;EACI,gBxD9gBK;EwD+gBL,gBAAA;EACA,cAAA;A3D0w2BhB;A2Dxw2BY;EACI,qBxDxgBN;AHkx3BV;A2Dzw2BgB;EACI,cxD1gBV;AHqx3BV;;A2Dpw2BI;EACI,aAAA;EACA,mBAAA;A3Duw2BR;A2Dtw2BQ;EACI,kBAAA;A3Dww2BZ;A2Dvw2BY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBxD1hBN;EwD2hBM,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;A3Dyw2BhB;A2Dxw2BgB;EACI,yCAAA;A3D0w2BpB;A2Dzw2BoB;EACI,WAAA;EACA,WAAA;EACA,YAAA;EACA,yBxDtiBd;EwDuiBc,kBAAA;EACA,UAAA;A3D2w2BxB;A2Dxw2BgB;EACI,oCAAA;A3D0w2BpB;A2Dzw2BoB;EACI,0CAAA;A3D2w2BxB;A2D1w2BwB;EACI,oCAAA;A3D4w2B5B;A2Dxw2BgB;EACI,mCAAA;A3D0w2BpB;A2Dzw2BoB;EACI,yCAAA;A3D2w2BxB;A2D1w2BwB;EACI,mCAAA;A3D4w2B5B;A2Dxw2BgB;EACI,kCAAA;A3D0w2BpB;A2Dzw2BoB;EACI,wCAAA;A3D2w2BxB;A2D1w2BwB;EACI,kCAAA;A3D4w2B5B;A2Dvw2BY;EACI,eAAA;A3Dyw2BhB;;A2Dpw2BA;EACI,cxD7bS;EwD8bT,eAAA;A3Duw2BJ;A2Dtw2BI;EACI,cxDjlBE;AHy13BV;;A2Drw2BA;EACI,eAAA;A3Dww2BJ;A2Dvw2BI;EACI,kBAAA;EACA,mBAAA;A3Dyw2BR;A2Dxw2BQ;EACI,SAAA;A3D0w2BZ;A2Dxw2BQ;EACI,kBAAA;A3D0w2BZ;;A2Dpw2BQ;EACI,wBAAA;EACA,WAAA;EACA,YAAA;A3Duw2BZ;;A2D/v2BgB;EACI,oBAAA;EACA,gCAAA;A3Dkw2BpB;;A2D1v2BI;EACI,yBxDreE;EwDseF,WAAA;EACA,YAAA;EACA,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,uBAAA;A3D6v2BR;A2D5v2BQ;EACI,WAAA;EACA,YAAA;EACA,cxDxoBA;AHs43BZ;A2D5v2BQ;EACI,yBxD7oBF;AH243BV;A2D7v2BY;EACI,cxDjoBR;AHg43BR;;A2D1v2BA;EACI,mBxDnpBQ;EwDopBR,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;A3D6v2BJ;A2D5v2BI;EACI,qBxDxpBE;AHs53BV;A2D7v2BQ;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,kCAAA;EACA,gBAAA;EACA,cxD1mBE;EwD2mBF,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBxD1pBJ;EwD6pBI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A3D+v2BZ;A2D3v2BQ;EACI,mBAAA;A3D6v2BZ;A2D5v2BY;EACI,cxD1qBR;EwD2qBQ,exD3cD;EwD4cC,gBxDnsBG;EwDosBH,mBAAA;A3D8v2BhB;A2D5v2BY;EACI,cxDhrBR;AH863BR;A2Dzv2BQ;EACI,cxDnjBC;EwDojBD,exD3dG;AHst3Bf;A2Dzv2BQ;EACI,cxD1rBJ;EwD2rBI,exD3dG;EwD4dH,gBxDrtBS;AHg93BrB;;A2Dvv2BA;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A3D0v2BJ;A2Dzv2BI;EACI,yBAAA;EACA,kBAAA;A3D2v2BR;A2D1v2BQ;EACI,WAAA;EACA,YAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A3D4v2BZ;A2D3v2BY;EACI,cxDttBT;AHm93BP;A2D3v2BY;EACI,cxDjuBP;AH893BT;;A2Dvv2BI;EACI,gBxD5vBe;EwD6vBf,exDtgBO;AHgw3Bf;;A2Dtv2BI;EACI,WAAA;EACA,YAAA;EACA,cxD5uBA;AHq+3BR;;A2Dtv2BA;EACI,aAAA;A3Dyv2BJ;;A2Dvv2BA;EACI,YAAA;EACA,YAAA;A3D0v2BJ;;A2Dvv2BI;EACI,UAAA;A3D0v2BR;A2Dxv2BI;EACI,WAAA;A3D0v2BR;A2Dxv2BI;EACI,yBxD5vBC;EwD6vBD,SAAA;A3D0v2BR;A2Dxv2BI;EACI,yBxDhwBC;EwDiwBD,UAAA;A3D0v2BR;A2Dxv2BI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,cxDrxBI;AH+g4BZ;;A2Drv2BQ;EACI,SAAA;EACA,cxDhxBJ;AHwg4BR;A2Dvv2BY;EACI,yBxDhyBN;AHyh4BV;A2Dvv2BY;EACI,yBxD/oBN;AHw43BV;A2Dxv2BgB;EACI,cxDnyBR;EwDoyBQ,WAAA;EACA,YAAA;A3D0v2BpB;A2Dxv2BgB;EACI,yBxD1yBV;AHoi4BV;A2Dzv2BoB;EACI,cxD9xBhB;AHyh4BR;A2Dtv2BQ;EACI,SAAA;A3Dwv2BZ;;A2Dpv2BA;EACI,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cxDxzBQ;AH+i4BZ;;A2Dnv2BQ;EACI,yBxDttBD;EwDutBC,kBAAA;EACA,gBxD50BS;AHkk4BrB;A2Drv2BY;EACI,cxDj0BJ;AHwj4BZ;A2Drv2BY;EACI,yBxDt0BN;EwDu0BM,cxDzzBR;AHgj4BR;A2Dtv2BgB;EACI,cxD3zBZ;AHmj4BR;;A2Dhv2BQ;EACI,cxDh0BL;EwDi0BK,gBxD91BS;AHil4BrB;;A2D9u2BI;EACI,YAAA;A3Div2BR;;A4D5l4BA;EACI,czDkKS;AH673Bb;A4D9l4BI;EACI,YAAA;A5Dgm4BR;A4D9l4BI;EACI,WAAA;A5Dgm4BR;A4D/l4BQ;EACI,mBAAA;A5Dim4BZ;A4D/l4BQ;EACI,kBAAA;A5Dim4BZ;A4D5l4BY;EACI,oBAAA;EACA,mBAAA;A5D8l4BhB;A4D5l4BY;EACI,aAAA;A5D8l4BhB;A4D3l4BwB;EACI,QAAA;E3DsC1B,2B2DrC6C;E3DsC7C,mC2DtC6C;E3DuC7C,+B2DvC6C;A5D+l4B/C;A4D1l4BoB;EACI,kBAAA;A5D4l4BxB;A4Drl4BQ;EACI,iBAAA;A5Dul4BZ;AC7k4BI;E2DRI;IAEQ,aAAA;IACA,mBAAA;E5Dul4Bd;AACF;ACnl4BI;E2DFI;IAEQ,mBAAA;E5Dul4Bd;AACF;ACxl4BI;E2DGY;IAEQ,eAAA;E5Dul4BtB;AACF;AC7l4BI;E2DWA;IAEQ,6BAAA;E5Dol4BV;AACF;AClm4BI;E2DWA;IAKQ,yBAAA;E5Dsl4BV;AACF;ACvm4BI;E2DmBQ;IACI,aAAA;IACA,mBAAA;IACA,WAAA;E5Dul4Bd;AACF;A4Dpl4BI;EACI,yBAAA;EACA,sDzDoKK;EF9GX,kB2DrDuB;A5Dsl4BzB;A4Drl4BQ;EACI,ezD+KG;EyD9KH,gBzDzEO;EyD0EP,gCAAA;E3DyBT,kB2DxBiC;E3DyBjC,mB2DzB6C;A5Dwl4BhD;A4Dtl4BQ;EACI,gBzD9EO;AHsq4BnB;A4Drl4BY;EACI,WAAA;EACA,YAAA;EACA,czD7DR;EFoGN,kB2DtC+B;A5Dul4BjC;A4Dtl4BgB;EACI,qBzD5ER;EyD6EQ,mBzD7ER;AHqq4BZ;A4Drl4BY;EACI,WAAA;A5Dul4BhB;A4Drl4BoB;EACI,ezDsJT;AHi83Bf;A4Dhl4BgB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,czD6CP;EyD5CO,ezDtHH;EyDuHG,gBzDhHG;EFoGpB,iB2DayC;E3DZzC,iB2DYoD;E3DWrD,kB2DVmC;A5Dml4BrC;A4Dll4BoB;EAGI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;A5Dol4BxB;A4Dll4BoB;EACI,mBzDhHZ;EyDiHY,czDrGhB;AHyr4BR;A4D/k4BQ;EACI,ezDiHG;EyDhHH,gBzDrIS;AHst4BrB;A4D/k4BQ;EACI,ezDgHG;EyD/GH,gBzDxIW;EyDyIX,kBAAA;EACA,UAAA;A5Dil4BZ;A4D/k4BQ;EACI,czDrHJ;EyDsHI,mBzDlIA;EFgHV,kB2DmB2B;EACjB,kBAAA;A5Dil4BZ;A4Dhl4BY;E3DrDV,kB2DsDgC;E3DrDhC,M2DqDyC;E3DpDzC,Q2DoD2C;A5Dol4B7C;A4Djl4BgB;EACI,czD9HZ;AHit4BR;A4Dhl4BY;EACI,czDGJ;AH+k4BZ;A4D9k4BI;EACI,WAAA;E3DnCN,kB2DoCuB;A5Dgl4BzB;A4D5k4BY;EACI,YAAA;EACA,YAAA;A5D8k4BhB;A4Drk4BgB;EACI,YAAA;A5Duk4BpB;A4Dlk4BI;EACI,ezDkEO;EyDjEP,gBzDvLe;AH2v4BvB;A4Dlk4BI;EACI,ezD6DO;EyD5DP,gBzD3Le;AH+v4BvB;A4Dnk4BQ;EACI,czDjLA;AHsv4BZ;A4Dpk4BY;EACI,czDrLN;AH2v4BV;A4D/j4BgB;E3D1Ed,0B2D2EmC;A5Dik4BrC;A4Dhk4BoB;EACI,WAAA;EACA,YAAA;E3D9EtB,mB2D+EuC;A5Dkk4BzC;A4Djk4BwB;E3DpHtB,yB2DqH8C;A5Dqk4BhD;A4Dhk4BoB;EACI,qBAAA;A5Dkk4BxB;A4D5j4BI;E3D7FF,0B2D8FuB;EACjB,aAAA;EACA,mBzDpMA;EyDqMA,sDzDaK;AHij4Bb;A4D7j4BQ;EACI,czDpEC;EyDqED,ezDoBG;AH2i4Bf;A4D5j4BI;EACI,yBAAA;EACA,sDzDKK;EF9GX,kB2D0GuB;EACjB,mBzD/MA;EyDgNA,YAAA;A5D8j4BR;A4D7j4BQ;EACI,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;A5D+j4BZ;A4D1j4BQ;EACI,czDxOA;EyDyOA,WAAA;EACA,YAAA;E3D9JV,yB2D+J8B;E3D3H9B,mB2D4H2B;EAGjB,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A5D8j4BZ;A4D7j4BY;EACI,mBzDzPN;AHwz4BV;A4D9j4BgB;EACI,czD7OZ;AH6y4BR;A4D3j4BI;EACI,ezDvBO;EyDwBP,gBzD5Qe;EyD6Qf,gBAAA;A5D6j4BR;A4D5j4BQ;EACI,czDnQA;EyDoQA,iBAAA;EACA,ezD7BG;AH2l4Bf;A4D3j4BY;EACI,ezDjCD;EyDkCC,kBAAA;EACA,qBAAA;EACA,czD7HH;AH0r4Bb;A4D5j4BgB;EACI,WAAA;E3D9LlB,kB2D+LoC;E3D9LpC,Q2D8L6C;E3D3L7C,O2D2L2D;E3DpO3D,2B2DqOqC;E3DpOrC,mC2DoOqC;E3DnOrC,+B2DmOqC;EACnB,UAAA;EACA,WAAA;EACA,mBzDzKT;EFMT,kB2DoKmC;A5Dkk4BrC;A4D3j4BY;EACI,czD7IH;AH0s4Bb;A4D1j4BgB;EACI,czDlSV;AH814BV;A4Dvj4BI;EACI,YAAA;EACA,iCAAA;A5Dyj4BR;A4Dxj4BQ;EACI,YAAA;EACA,gCAAA;EACA,gBAAA;A5D0j4BZ;A4Dzj4BY;EACI,6BAAA;EACA,4BAAA;EACA,mBAAA;A5D2j4BhB;A4Dzj4BY;EACI,gBAAA;EACA,YAAA;EACA,ezDxED;EyDyEC,gBzDjUO;EyDkUP,czDtTJ;EyDuTI,UAAA;EACA,qBAAA;EACA,WAAA;A5D2j4BhB;A4D1j4BgB;E3D9Od,yB2D+OsC;EACpB,sBAAA;EACA,mBAAA;EACA,iCAAA;EACA,ezDlVH;EyDmVG,gBzD3UD;EyD4UC,czDlLP;EyDmLO,eAAA;EACA,WAAA;EACA,iBAAA;A5D8j4BpB;A4D5j4BgB;EACI,eAAA;A5D8j4BpB;A4D5j4BgB;EACI,UAAA;A5D8j4BpB;A4D3j4BoB;EACI,czDhVd;AH644BV;A4Dzj4BY;EACI,YAAA;EACA,UAAA;A5D2j4BhB;A4Dzj4BoB;EACI,eAAA;EACA,WAAA;EACA,YAAA;A5D2j4BxB;A4Dxj4BgB;EACI,iBAAA;A5D0j4BpB;A4Dnj4BQ;EACI,8BAAA;A5Dqj4BZ;A4Dnj4BQ;EACI,qBAAA;EACA,mBAAA;EACA,oBAAA;EACA,0BAAA;EACA,8BAAA;EACA,sDzD/IC;EyDgJD,yBAAA;A5Dqj4BZ;A4Dnj4BQ;EACI,UAAA;EACA,UAAA;EACA,qBAAA;A5Dqj4BZ;A4Dpj4BY;EACI,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;A5Dsj4BhB;A4Drj4BgB;EACI,kBAAA;EACA,WAAA;A5Duj4BpB;A4Dtj4BoB;EACI,czD9OX;AHsy4Bb;A4Dtj4BoB;EACI,gBAAA;A5Dwj4BxB;A4Dvj4BwB;EACG,czDpYjB;AH674BV;A4Dlj4BW;EACK,UAAA;A5Doj4BhB;A4Dhj4BY;EACI,UAAA;A5Dkj4BhB;A4D9i4BoB;EACI,czDrQX;AHqz4Bb;A4D1i4BI;EACI,sDzD7LK;EyD8LL,YAAA;A5D4i4BR;A4D1i4BY;EACI,gBAAA;E3D/Sd,kB2DgT+B;EACjB,eAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;A5D4i4BhB;ACx74BI;E2DgYQ;IAcQ,mBAAA;IACA,qBAAA;E5D8i4BlB;AACF;A4D7i4BgB;EACI,czDjSP;EyDkSO,mBzD/RV;EyDgSU,qBzDhSV;AH+04BV;A4D7i4BgB;EACI,mBzDrbR;EyDsbQ,qBzDtbR;EyDubQ,czD3aZ;AH094BR;A4Dxi4BoB;EACI,mBAAA;EACA,ezDndP;EyDodO,gBzD9cH;EyD+cG,mBAAA;A5D0i4BxB;A4Dzi4BwB;EACI,ezDvdX;EyDwdW,gBzDldP;AH6/4BrB;A4Dzi4BgC;EACI,WAAA;EACA,YAAA;EACA,SAAA;A5D2i4BpC;A4Dli4BI;EACI,ezDveS;AH2g5BjB;;A4Dji4BA;EACI,czDzUS;AH624Bb;;A4Dli4BA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;A5Dqi4BJ;A4Dni4BI;E3D/YF,kB2DgZwB;E3D/YxB,Q2D+YiC;E3D5YjC,U2D4Y+C;E3Drb/C,2B2DsbyB;E3DrbzB,mC2DqbyB;E3DpbzB,+B2DobyB;EACnB,YAAA;A5Dyi4BR;A4Dvi4BI;EACI,kBAAA;A5Dyi4BR;;A4Dti4BA;EACI,mBzD9cU;AHu/4Bd;A4Dxi4BI;EACI,mBzDhdM;AH0/4Bd;;A4Dvi4BA;EACI,mBzDxaS;AHk94Bb;A4Dzi4BI;EACI,mBzD1aK;AHq94Bb;;A4Dxi4BA;EACI,mBzDncU;AH8+4Bd;A4D1i4BI;EACI,mBzDrcM;AHi/4Bd;;A4Dzi4BA;E3DlaG,kB2DmayB;E3DlazB,kB2DkaqC;EACpC,gCAAA;A5D6i4BJ;;A4D3i4BA;E3DtaG,kB2DuayB;E3DtazB,mB2DsaqC;EACpC,gCAAA;A5D+i4BJ;;A4D5i4BI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;A5D+i4BR;A4D7i4BS;EACG,oBAAA;A5D+i4BZ;A4D7i4BQ;EACI,UAAA;A5D+i4BZ;A4D3i4BQ;EACI,czDjhBF;EyDkhBE,iBAAA;EACA,ezD7SG;EyD8SH,gBzDniBS;AHgl5BrB;A4D5i4BY;EACI,czD1hBN;AHwk5BV;A4D1i4BI;EACE,cAAA;EACA,mBAAA;EACA,WAAA;EACA,yBAAA;A5D4i4BN;;A4Dxi4BA;EACE,YAAA;EACA,yBAAA;EACA,qBAAA;A5D2i4BF;;A4Dxi4BA;EACE;IAAqB,SAAA;IAAU,qBAAA;E5D6i4B/B;AACF;A4D3i4BA;EACE,UAAA;EACA,mBAAA;A5D6i4BF;;A4D1i4BA;EACI,mCAAA;EACA,4CAAA;A5D6i4BJ;;A4D1i4BA;EACE,eAAA;EACA,YAAA;E3D1cA,4B2D2ciB;A5D6i4BnB;;A4D3i4BA;EACI,kBAAA;EACA,mBzDxfS;EyDyfT,YAAA;E3DhdF,kB2DidmB;A5D8i4BrB;A4D7i4BI;EACI,ezDzVO;AHw44Bf;A4D7i4BI;EACI,gBzDjlBW;AHgo5BnB;;A4D5i4BA;EACI,aAAA;A5D+i4BJ;A4D9i4BI;EACI,YAAA;EACA,aAAA;E3D7dN,mB2D8duB;EACjB,mBzDpkBA;EyDqkBA,cAAA;A5Dgj4BR;;A4D7i4BA;EACI,eAAA;A5Dgj4BJ;;A4D9i4BA;EACI,YAAA;EACA,aAAA;EACA,eAAA;EACA,aAAA;EACA,MAAA;EACA,YAAA;EACA,mBzDjlBI;EyDklBJ,eAAA;EACA,4BAAA;EACA,+BAAA;EACA,2FAAA;EACA,gBAAA;E3DthBF,yB2DuhBsB;A5Dmj4BxB;ACxn5BI;E2DwjBJ;IAeQ,YAAA;IACA,aAAA;E5Dqj4BN;AACF;A4Dpj4BI;EACI,QAAA;E3D7hBN,yB2D8hB0B;A5Dwj4B5B;A4Dpj4BY;EACI,czDvmBP;AH6p5BT;A4Dlj4BI;EACI,gBzD/nBW;AHmr5BnB;A4Dlj4BI;EACI,ezD1YO;AH874Bf;A4Dlj4BI;EACI,ezD9YO;AHk84Bf;A4Dlj4BI;EACK,ezDnZM;EyDoZP,gBzD1oBe;AH8r5BvB;A4Dlj4BI;EACI,gCAAA;A5Doj4BR;A4Dnj4BQ;EACI,iBAAA;EACA,ezDzZG;EyD0ZH,gBzDjpBW;EF4HrB,kB2DshB2B;EACjB,YAAA;EACA,mBzDtfF;EyDufE,czDzoBA;AH8r5BZ;A4Dpj4BY;EACI,mBzD7oBN;EyD8oBM,czDhoBR;AHsr5BR;A4D9i4BoB;EACI,kBAAA;A5Dgj4BxB;A4D7i4BwB;EACI,mBzDvgBlB;EyDwgBkB,yBAAA;E3D1iB1B,kB2D2iB2C;EACjB,YAAA;EACA,qBAAA;A5D+i4B5B;A4D9i4B4B;EACI,WAAA;EACA,YAAA;A5Dgj4BhC;A4D5i4BoB;EACI,gBAAA;A5D8i4BxB;A4Dxi4BoB;EACI,oBAAA;EACA,iBAAA;EACA,kBAAA;A5D0i4BxB;A4Dvi4BwB;EACI,kBAAA;EACA,mBAAA;EACA,+BAAA;A5Dyi4B5B;A4Dri4BwB;EACI,eAAA;EACA,gBAAA;A5Dui4B5B;A4Dpi4BoB;EACI,mBzDhsBd;EyDisBc,czDnrBhB;AHyt5BR;A4Dri4BwB;EACI,mBzDjsBhB;AHwu5BZ;A4Dhi4BI;EACI,czD1jBK;EyD2jBL,ezDheO;AHkg5Bf;A4Dhi4BI;EACI,gBzDxtBW;AH0v5BnB;A4Dji4BQ;EACI,czD/sBA;AHkv5BZ;;A4D9h4BA;EACI,yBAAA;A5Dii4BJ;;A4D/h4BA;EACI,WAAA;EACA,YAAA;E3DzmBF,mB2D0mBmB;A5Dki4BrB;;A4Dhi4BA;EACI,yBAAA;A5Dmi4BJ;;A4Dji4BA;EACI,yBAAA;A5Doi4BJ;;A4Dli4BA;EACI,czDplBS;AHyn5Bb;;A6D1x5BA;EACE,aAAA;A7D6x5BF;;A6D1x5BA;EACE,aAAA;A7D6x5BF;;A6D1x5BA;EACE,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,YAAA;EACA,YAAA;A7D6x5BF;;A6D1x5BA;EACE,aAAA;A7D6x5BF;;A6D1x5BA;EACE,oCAAA;EACA,oCAAA;EACA,8CAAA;EACA,yBAAA;A7D6x5BF;;A6D1x5BA;EACE,wBAAA;A7D6x5BF;;A6D1x5BA;;EAEE,cAAA;A7D6x5BF;;A6D1x5BA;EACE,YAAA;EACA,YAAA;A7D6x5BF;;A6Dzx5BA;EACE,qBAAA;A7D4x5BF;;A6Dzx5BA;EACE,aAAA;A7D4x5BF;;A6Dzx5BA;EACE,8CAAA;A7D4x5BF;;A6Dzx5BA;EACE,0BAAA;A7D4x5BF;;A6Dzx5BA;EACE,uBAAA;A7D4x5BF;;A6Dzx5BA;EACE,wBAAA;A7D4x5BF;;A6Dzx5BA;EACE,6BAAA;EACA,YAAA;A7D4x5BF;;A6Dzx5BA;EACE,aAAA;A7D4x5BF;;A6Dzx5BA;EACE,cAAA;EACA,yBAAA;A7D4x5BF;;A6Dzx5BA;;EAEE,cAAA;EACA,yBAAA;A7D4x5BF;;A6Dzx5BA;EACE,cAAA;EACA,yBAAA;A7D4x5BF;;A6Dzx5BA;EACE,cAAA;EACA,yBAAA;A7D4x5BF;;A6Dzx5BA;EACE,cAAA;EACA,yBAAA;A7D4x5BF;;A6Dzx5BA;EACE,YAAA;EACA,YAAA;A7D4x5BF;;A6Dzx5BA;EACE,oCAAA;A7D4x5BF;;A6Dzx5BA;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,wCAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;A7D4x5BF;;A6Dzx5BA;EACE,eAAA;EACA,kBAAA;A7D4x5BF;;A6Dzx5BA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,SAAA;EACA,QAAA;EAEA,2BAAA;A7D4x5BF;;A6Dzx5BA;EACE,kBAAA;EACA,UAAA;EACA,UAAA;A7D4x5BF;;A6Dzx5BA;EACE,iBAAA;EACA,kBAAA;EACA,6BAAA;A7D4x5BF;;A6Dxx5BE;EACI,aAAA;A7D2x5BN;A6D1x5BM;EACI,cAAA;A7D4x5BV;AC145BI;E4D2GF;IAMQ,cAAA;E7D6x5BR;E6D5x5BQ;IACI,aAAA;E7D8x5BZ;AACF;A6D5x5BM;EACI,c1DvJA;AHq75BV;A6D3x5BE;EACI,cAAA;EACA,kBAAA;A7D6x5BN;A6D3x5BE;EACI,aAAA;A7D6x5BN;A6D1x5BM;EACI,8BAAA;A7D4x5BV;A6Dxx5Bc;EACI,iBAAA;EACA,kBAAA;EACA,gBAAA;A7D0x5BlB;A6Dnx5BU;EACI,aAAA;A7Dqx5Bd;A6Dnx5BU;EACI,MAAA;EACA,aAAA;A7Dqx5Bd;A6Dnx5BU;EACI,iBAAA;A7Dqx5Bd;AC965BI;E4D+JM;IACI,aAAA;E7Dkx5BZ;E6D/w5BI;IACI,iBAAA;E7Dix5BR;AACF;;A6D7w5BA;EACE,mBAAA;A7Dgx5BF;;A6D5w5BA;EAEE,gBAAA;EACA,qBAAA;EACA,mBAAA;EACA,yBAAA;EACA,WAAA;A7D8w5BF;;A6D3w5BA;EAEE,aAAA;A7D6w5BF;;A6D1w5BA;EACE,uBAAA;A7D6w5BF;;A6D1w5BA;EACE,aAAA;A7D6w5BF;;A6Dpw5BA;EACE,yBAAA;EAEA,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EAEA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,sDAAA;EAGA,yBAAA;EACA,kBAAA;EACA,8BAAA;A7Duw5BF;;A6Dpw5BA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;A7Duw5BF;;A6Dpw5BA;EACE,cAAA;A7Duw5BF;;A6Dpw5BA;EACE,eAAA;A7Duw5BF;;A6Dpw5BA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,cAAA;A7Duw5BF;;A6Dpw5BA;EACE,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kCAAA;EACA,gBAAA;EACA,cAAA;A7Duw5BF;;A6Dpw5BA;EACE,kBAAA;A7Duw5BF;;A6Dnw5BA;EACE,wBAAA;A7Dsw5BF;;A6Dnw5BA;EACE,wBAAA;A7Dsw5BF;;A6Dnw5BA;EACE,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EAEA,eAAA;EACA,mB1DnTM;E0DoTN,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;A7Dqw5BF;;A6Dlw5BA;EACE,eAAA;A7Dqw5BF;;A6Dlw5BA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;A7Dqw5BF;;A6Dlw5BA;EACE,cAAA;A7Dqw5BF;;A6Dlw5BA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;A7Dqw5BF;;A6Dlw5BA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;A7Dqw5BF;;A6Dlw5BA;;EAEE,yBAAA;A7Dqw5BF;;A6Dlw5BA;EACE,WAAA;EACA,WAAA;EACA,UAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;A7Dqw5BF;;A6Dlw5BA;EAIE,4BAAA;A7Dkw5BF;;A6D/v5BA;EACE,kBAAA;EACA,iBAAA;EACA,yBAAA;A7Dkw5BF;;A6D/v5BA;EAEE,yBAAA;EACA,qBAAA;A7Diw5BF;;A6D9v5BA;EACE,uBAAA;A7Diw5BF;;A6D9v5BA;EAME,mBAAA;EACA,gCAAA;A7D4v5BF;;A6Dzv5BA;EAME,mBAAA;EACA,gCAAA;A7Duv5BF;;A6Dpv5BA;EAGE,mBAAA;A7Dqv5BF;;A6Dlv5BA;EAIE,mBAAA;A7Dkv5BF;;A6D/u5BA;EAKE,8BAAA;A7D8u5BF;;A6D3u5BA;EACE,gBAAA;A7D8u5BF;;A6D3u5BA;EAEE,aAAA;A7D6u5BF;;A6D1u5BA;;EAYE,aAAA;A7Dmu5BF;;A6Dhu5BA;EAGE,gBAAA;A7Diu5BF;;A6D9t5BA;EACE,gBAAA;A7Diu5BF;;A6D9t5BA;EAIE,gBAAA;A7D8t5BF;;A6D3t5BA;EAIE,mBAAA;A7D2t5BF;;A6Dxt5BA;EACE,cAAA;A7D2t5BF;;A6Dxt5BA;EACE,yBAAA;EACA,yBAAA;A7D2t5BF;;A6Dxt5BA;EACE,yBAAA;A7D2t5BF;;A6Dxt5BA;EACE,yBAAA;A7D2t5BF;;A6Dxt5BA;EACE,cAAA;A7D2t5BF;;A6Dxt5BA;EACE,2BAAA;A7D2t5BF;;A6Dxt5BA;EACE,gBAAA;A7D2t5BF;;A6Dxt5BA;EACE,gBAAA;A7D2t5BF;;A6Dxt5BA;EACE,WAAA;A7D2t5BF;;A6Dxt5BA;EACE,4BAAA;A7D2t5BF;;A6Dxt5BA;EACE,qBAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;A7D2t5BF;;A6Dzt5BA;EACE,qBAAA;EACA,gBAAA;EACA,YAAA;A7D4t5BF;;A6D1t5BA;EACE,qBAAA;A7D6t5BF;;A6D1t5BA;EACE,yBAAA;EACA,WAAA;A7D6t5BF;;A6D1t5BA;EACE,yBAAA;EACA,WAAA;A7D6t5BF;;A6D3t5BA;EACE,qBAAA;A7D8t5BF;;A6D5t5BA;EACE,uBAAA;EACA,mBAAA;A7D+t5BF;;A6D7t5BA;EACE,eAAA;A7Dgu5BF;;A6D7t5BA;;EAEE,kBAAA;A7Dgu5BF;;A6D9t5BA;EAEE,uBAAA;EACA,mBAAA;EACA,gBAAA;A7Dgu5BF;;A6D9t5BA;EAIE,eAAA;A7D8t5BF;;A6D1t5BA;EACE,WAAA;EACA,UAAA;A7D6t5BF;;A6D3t5BA;;EAEE,WAAA;EACA,UAAA;A7D8t5BF;;A6D5t5BA;;EAEE,yBAAA;EACA,qBAAA;EACA,kCAAA;EACA,0BAAA;A7D+t5BF;;A6D7t5BA;EACE,yBAAA;EACA,qBAAA;EACA,kCAAA;EACA,0BAAA;A7Dgu5BF;;A6D9t5BA;EACE,yBAAA;EACA,qBAAA;EACA,kCAAA;A7Diu5BF;;A6D/t5BA;EACE,2CAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;A7Dku5BF;;A6Dhu5BA;EACE,aAAA;A7Dmu5BF;;A6Dju5BA;EACE,6BAAA;A7Dou5BF;;A6Dlu5BA;;;EAGE,WAAA;A7Dqu5BF;;A6Dnu5BA;EACE,8BAAA;A7Dsu5BF;;A6Dpu5BA;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;A7Duu5BF;;A6Dru5BA;EACE,aAAA;A7Dwu5BF;;A6Dtu5BA;EACE,0CAAA;EACA,yBAAA;EACA,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;A7Dyu5BF;;A6Dvu5BA;EACE,WAAA;EACA,YAAA;A7D0u5BF;;A6Dxu5BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;A7D2u5BF;;A6Dzu5BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;A7D4u5BF;;A6D1u5BA;EACE,aAAA;A7D6u5BF;;A6D3u5BA;EACE,gBAAA;A7D8u5BF;;A6D5u5BA;;;EAGE,kBAAA;A7D+u5BF;;A6D7u5BA;EACE,YAAA;A7Dgv5BF;;A6D9u5BA;EACE,cAAA;A7Div5BF;;A6D/u5BA;EACE,YAAA;A7Dkv5BF;;A6Dhv5BA;EACE,YAAA;A7Dmv5BF;;A6Djv5BA;EACE,gBAAA;EACA,MAAA;A7Dov5BF;;A6Dlv5BA;EACE,uCAAA;A7Dqv5BF;;A6Dnv5BA;EACE,oBAAA;EACA,aAAA;A7Dsv5BF;;A6Dpv5BA;;EAEE,yBAAA;A7Duv5BF;;A6Drv5BA;EACE,yBAAA;A7Dwv5BF;;A6Dtv5BA;EACE,qBAAA;A7Dyv5BF;;A6Dvv5BA;EACE,qBAAA;EACA,2BAAA;EACA,gBAAA;A7D0v5BF;;A6Dxv5BA;EACE,qBAAA;EACA,6BAAA;A7D2v5BF;;A6Dzv5BA;EACE,eAAA;A7D4v5BF;;A6D1v5BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;A7D6v5BF;;A6D3v5BA;EACE,0CAAA;EACA,yBAAA;EACA,kBAAA;EAGA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,+BAAA;EACA,qBAAA;EACA,YAAA;A7D8v5BF;;A6D5v5BA;EACE,aAAA;EACA,mBAAA;A7D+v5BF;;A6D7v5BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;A7Dgw5BF;;A6D9v5BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;A7Diw5BF;;A6D/v5BA;EACE,cAAA;EACA,WAAA;EACA,YAAA;A7Dkw5BF;;A6Dhw5BA;EACE,oCAAA;EACA,kBAAA;EACA,cAAA;A7Dmw5BF;;A6Djw5BA;;EAEE,yBAAA;A7Dow5BF;;A6Dlw5BA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,WAAA;A7Dqw5BF;;A6Dnw5BA;EACE;IACE,YAAA;E7Dsw5BF;AACF;A6Dnw5BE;EACE,cAAA;E5DhtBF,yB4DitBsB;A7Duw5BxB;A6Dhw5BU;E5D3sBP,kB4D4sBuC;A7Dkw5B1C;A6Djw5BY;EACE,qBAAA;EACA,cAAA;A7Dmw5Bd;A6Dhw5BU;EACE,kBAAA;A7Dkw5BZ;A6D9v5BM;EACE,cAAA;A7Dgw5BR;A6D5v5BE;EACE,YAAA;A7D8v5BJ;;A6D1v5BE;EACE,kBAAA;A7D6v5BJ;A6D3v5BE;EACE,OAAA;A7D6v5BJ;A6D3v5BE;EACE,4BAAA;A7D6v5BJ;;A6D1v5BA;EACE,qBAAA;A7D6v5BF;;A6D3v5BA;EACE,qBAAA;EACA,6BAAA;A7D8v5BF;;A6D5v5BA;EACE,gBAAA;A7D+v5BF;;A6D7v5BA;EACE,WAAA;A7Dgw5BF;;A6D9v5BA;EACE,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,UAAA;EACA,aAAA;EACA,6BAAA;EACA,2BAAA;EACA,iCAAA;EACA,WAAA;A7Diw5BF;;A6D/v5BA;;EAGE,yBAAA;A7Diw5BF;;A6D/v5BA;EACE,YAAA;A7Dkw5BF;;A6Dhw5BA;EACE,qBAAA;A7Dmw5BF","sourcesContent":["/****** Utils ******/\n@import \"utils/variables\";\n@import \"utils/mixins\";\n\n/******* Base *******/\n@import \"base/base\";\n@import \"base/background\";\n\n/******* Components ******/\n@import \"components/avatar\";\n@import \"components/boostrap\";\n@import \"components/button\";\n@import \"components/badge\";\n@import \"components/border\";\n@import \"components/calendar\";\n@import \"components/chart\";\n@import \"components/dropdown\";\n@import \"components/icons\";\n@import \"components/progress\";\n@import \"components/pagination\";\n@import \"components/font\";\n@import \"components/typography\";\n@import \"components/alerts\";\n@import \"components/popovers\";\n@import \"components/forms\";\n@import \"components/tables\";\n@import \"components/accordion\";\n@import \"components/breadcrumb\";\n@import \"components/cards\";\n@import \"components/tooltips\";\n@import \"components/navs-tabs\";\n@import \"components/ribbon\";\n@import \"components/popup\";\n@import \"components/grid\";\n\n/******* Vendors ******/\n@import \"vendors/select2\";\n@import \"vendors/datatables\";\n\n/****** Layout ******/\n@import \"layout/content\";\n@import \"layout/common\";\n@import \"layout/darktheme\";\n@import \"layout/header\";\n@import \"layout/header-one\";\n@import \"layout/header-two\";\n@import \"layout/header-three\";\n@import \"layout/header-four\";\n@import \"layout/loader\";\n@import \"layout/sidebar\";\n@import \"layout/notification\";\n@import \"layout/sidebar-settings\";\n@import \"layout/theme-settings\";\n\n/****** Pages ******/\n@import \"pages/chat\";\n@import \"pages/email\";\n@import \"pages/error\";\n@import \"pages/login\";\n@import \"pages/product\";\n@import \"pages/profile\";\n@import \"pages/stocks\";\n@import \"pages/product-list\";\n@import \"pages/pos\";\n@import \"pages/pos-design\";\n@import \"pages/add-product\";\n@import \"pages/notes\";\n@import \"pages/employees-grid\";\n@import \"pages/transfer-list.scss\";\n@import \"pages/attendance-employee\";\n@import \"pages/settings\";\n@import \"pages/file-manager\";\n@import \"pages/customisedstyle\"\n","$breakpoints: (\n  xs: 320px,\n  sm: 568px,\n  custom767: 767px,\n  md: 768px,\n  lg: 1024px,\n  custom575: 575px,\n  custom768: 768px,\n  custom991: 991.98px,\n  custom992: 992px,\n  custom1399: 1399px,\n  custom1199: 1199.98px,\n  custom1024: 1024px,\n  custom1280: 1280px,\n);\n\n// Respond Above\n\n@mixin respond-above($breakpoint) {\n\n  // If the breakpoint exists in the map.\n  @if map-has-key($breakpoints, $breakpoint) {\n\n    // Get the breakpoint value.\n    $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n    // Write the media query.\n    @media (min-width: $breakpoint-value) {\n      @content;\n    }\n\n  // If the breakpoint doesn't exist in the map.\n  } @else {\n\n    // Log a warning.\n    @warn 'Invalid breakpoint: #{$breakpoint}.';\n  }\n}\n\n// Respond Above\n\n@mixin respond-below($breakpoint) {\n\n  // If the breakpoint exists in the map.\n  @if map-has-key($breakpoints, $breakpoint) {\n\n    // Get the breakpoint value.\n    $breakpoint-value: map-get($breakpoints, $breakpoint);\n\n    // Write the media query.\n    @media (max-width: $breakpoint-value) {\n      @content;\n    }\n\n  // If the breakpoint doesn't exist in the map.\n  } @else {\n\n    // Log a warning.\n    @warn 'Invalid breakpoint: #{$breakpoint}.';\n  }\n}\n\n@mixin transform($property) {\n  transform: $property;\n  -webkit-transform: $property;\n  -ms-transform: $property;\n}\n\n// Define vertical, horizontal, or both position\n\n@mixin position-alignment($position) {\n  position: absolute;\n  @if $position == 'vertical' {\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    -ms-transform: translateY(-50%);\n    transform: translateY(-50%);\n  }\n  @else if $position == 'horizontal' {\n    left: 50%;\n    -webkit-transform: translateX(-50%);\n    -ms-transform: translateX(-50%);\n    transform: translate(-50%);\n  }\n  @else if $position == 'both' {\n    top: 50%;\n    left: 50%;\n    -webkit-transform: translate(-50%, -50%);\n    -ms-transform: translate(-50%, -50%);\n    transform: translate(-50%, -50%);\n  }\n}\n\n@mixin transition($property) {\n  -webkit-transition: $property;\n  -ms-transition: $property;\n  transition: $property;\n}\n\n@mixin position($position-value,$top-value,$right-value,$bottom-value,$left-value){\n  position: $position-value;\n  top: $top-value;\n  right: $right-value;\n  bottom: $bottom-value;\n  left: $left-value;\n}\n\n@mixin margin-padding($margin, $padding) {\n   margin: $margin;\n   padding:$padding;\n}\n\n@mixin placeholder-color($color) {\n  &::-webkit-input-placeholder { /* WebKit browsers */\n      color: $color;\n      opacity: 1;\n  }\n  &:-moz-placeholder { /* Mozilla Firefox 4 to 18 */\n      color: $color;\n      opacity: 1;\n  }\n  &::-moz-placeholder { /* Mozilla Firefox 19+ */\n      color: $color;\n      opacity: 1;\n  }\n  &:-ms-input-placeholder { /* Internet Explorer 10+ */\n      color: $color;\n      opacity: 1;\n  }\n}\n\n@mixin rounded($unit) {\n  border-radius: $unit;\n}\n\n@mixin transform-origin($property) {\n  transform-origin: $property;\n  -webkit-transform-origin: $property;\n  -ms-transform-origin: $property;\n}\n\n@mixin box-shadow($inset:inset,$horizontaloffset:10px,$verticaloffset:10px,$blur:10px,$spread:10px,$color: #000000) {\n  -webkit-box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\n  -moz-box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\n  box-shadow: $inset $horizontaloffset $verticaloffset $blur $spread $color;\n}\n\n%animation-effect {   \n  -webkit-transition: all 0.5s;\n  -moz-transition: all 0.5s;\n  -o-transition: all 0.5s;\n  transition: all 0.5s;\n}\n","body {\n\tfont-family: $font-family-primary;\n\tfont-size: $font-size-14;\n\tcolor: $text-color;\n\tline-height: 1.5;\n\tbackground-color: $body-bg;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n}\n::selection {\n  background: $primary;\n  color: $white;\n  text-shadow: none;\n}\nimg {\n\tmax-width: 100%;\n\theight: auto;\n\tvertical-align: inherit;\n}\n*{\n\toutline: none;\n}\nbutton {\n\t@include transition(all 0.5s ease);\n\t&:focus {\n\t\tbox-shadow: none !important;\n\t}\n}\na {\n\tcolor: $primary;\n\tcursor: pointer;\n\ttext-decoration: none;\n\t@include transition(all 0.5s ease);\n\t&:hover {\n\t\tcolor: $primary-hover;\n\t\t@include transition(all 0.5s ease);\n\t}\n\t&:focus {\n\t\toutline: 0;\n\t}\n}\np {\n\tmargin-bottom:20px;\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\nstrong {\n\tfont-weight: $font-weight-bold;\n}\nh1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\n  \tcolor: $title-color;\n  \tfont-family: $font-family-primary;\n\tfont-weight: $font-weight-bold;\n  \tmargin-bottom: 0;\n}\nol, ul {\n  list-style: none;\n  margin-block-end: 0;\n  padding: 0;\n}\nul {\n  list-style: none;\n\t&.list-disc {\n\t  list-style: disc;\n\t  padding-left: 15px;\n\t  ul {\n\t    list-style-type: circle;\n\t  }\n\t}\n\t&.list-decimal {\n\t  list-style: decimal;\n\t  padding-left: 15px;\n\t  ul{\n\t    list-style-type: decimal;\n\t  }\n\t}\n\t&.list-icon {\n\t  list-style: none;\n\t  padding-left: 0;\n\t  > li {\n\t    padding-left: 1.875rem;\n\t    counter-increment: li;\n\t    i,\n\t    .feather-icon,\n\t    .svg-icon {\n\t      display: inline-block;\n\t      height: 20px;\n\t      width: 20px;\n\t      text-align: center;\n\t      margin-left: -1.25rem;\n\t      position: relative;\n\t      left: -10px;\n\t      padding: 1px;\n\t      top: -1px;\n\t      \n\t    }\n\t    i {\n\t      font-size: $font-size-20;\n\t      top: 5px;\n\t    }\n\t  }\n\t}\n\t.btn {\n\t  &-primary {\n\t      &:not(:disabled):not(.disabled) {\n\t          &:active,\n\t          &.active {\n\t              &:focus {\n\t                  box-shadow: none;\n\t              \t}\n\t          \t}\n\t      \t}\n\t  \t}\n\t}\n}\n","// Base Font\n$font-size-base: 14px;\n$font-size-sm: $font-size-base * .875;\n$font-size-lg: $font-size-base * 1.25;\n$font-weight-lighter: lighter;\n$font-weight-light: 300;\n$font-weight-normal: 400;\n$font-weight-medium: 500;\n$font-weight-semibold: 600;\n$font-weight-bold: 700;\n$font-weight-bolder: bolder;\n\n// Font Family\n$font-family-primary: 'Nunito', sans-serif;\n$font-family-secondary: \"Poppins\", sans-serif;\n$font-awesome: \"Fontawesome\";\n\t\n// Theme Colors Variables\n$primary: #FF9F43;\n$primary-hover: darken($primary, 10%);\n$secondary: #092C4C;\n$secondary-hover: darken($secondary, 10%);\n$success: #28C76F;\n$success-hover: darken($success, 10%);\n$info: #17a2b8;\n$info-hover: darken($info, 10%);\n$warning: #FF9900;\n$warning-hover: darken($warning, 10%);\n$danger: #FF0000;\n$danger-hover: darken($danger, 10%);\n$dark: #29344a;\n$light: #f8f9fa;\n$white: #ffffff;\n$black: #000000;\n$purple: #7367F0;\n$pink: #ff63a5;\n$blue: #3577f1;\n$teal: #02a8b5;\n$violet: #423B93;\n$cyan: #299cdb;\n$green: #1dd871;\n$orange: #ffa500;\n$indigo: #4d5ddb;\n$yellow: #ffff00;\n\n// Primary\n$primary-100: #FFF5EC;\n$primary-200: #FFECD9;\n$primary-300: #FFE2C7;\n$primary-400: #FFD9B4;\n$primary-500: #FFCFA1;\n$primary-600: #FFC58E;\n$primary-700: #FFBC7B;\n$primary-800: #FFB269;\n$primary-900: #FFA956;\n\n// Secondary\n$secondary-100: #E6EAED;\n$secondary-200: #CED5DB;\n$secondary-300: #B5C0C9;\n$secondary-400: #9DABB7;\n$secondary-500: #8496A6;\n$secondary-600: #6B8094;\n$secondary-700: #536B82;\n$secondary-800: #3A5670;\n$secondary-900: #22415E;\n\n// Success\n$success-100: #EAF9F1;\n$success-200: #D4F4E2;\n$success-300: #BFEED4;\n$success-400: #A9E9C5;\n$success-500: #94E3B7;\n$success-600: #7EDDA9;\n$success-700: #69D89A;\n$success-800: #53D28C;\n$success-900: #3ECD7D;\n\n// Warning\n$warning-100: #FFF5E6;\n$warning-200: #FFEBCC;\n$warning-300: #FFE0B3;\n$warning-400: #FFD699;\n$warning-500: #FFCC80;\n$warning-600: #FFC266;\n$warning-700: #FFB84D;\n$warning-800: #FFAD33;\n$warning-900: #FFA31A;\n\n// Danger\n$danger-100: #FFE6E6;\n$danger-200: #FFCCCC;\n$danger-300: #FFB3B3;\n$danger-400: #FF9999;\n$danger-500: #FF8080;\n$danger-600: #FF6666;\n$danger-700: #FF4D4D;\n$danger-800: #FF3333;\n$danger-900: #FF1A1A;\n\n// Purple\n$purple-100: #F8F8FA;\n$purple-200: #E3E1FC;\n$purple-300: #D5D1FB;\n$purple-400: #C7C2F9;\n$purple-500: #B9B3F8;\n$purple-600: #ABA4F6;\n$purple-700: #9D95F5;\n$purple-800: #8F85F3;\n$purple-900: #8176F2;\n\n// White\n$white-1: rgba(0,0,0,0.1);\n$white-2: rgba(0,0,0,0.2);\n$white-3: rgba(0,0,0,0.3);\n$white-4: rgba(0,0,0,0.4);\n$white-5: rgba(0,0,0,0.5);\n$white-6: rgba(0,0,0,0.6);\n$white-7: rgba(0,0,0,0.7);\n$white-8: rgba(0,0,0,0.8);\n$white-9: rgba(0,0,0,0.9);\n\n// Gray\n$gray-100: #f3f6f9;\n$gray-200: #eff2f7;\n$gray-300: #e8ebed;\n$gray-400: #dbe0e6;\n$gray-500: #adb5bd;\n$gray-600: #67748E;\n$gray-700: #495057;\n$gray-800: #343a40;\n$gray-900: #212529;\n\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n);\n\n$theme-colors: (\n    \"primary\": $primary,\n    \"secondary\": $secondary,\n    \"success\": $success,\n    \"info\": $info,\n    \"warning\": $warning,\n    \"danger\": $danger,\n    \"dark\": $dark,\n    \"light\": $light,\n    \"black\": $black,\n    \"purple\": $purple,\n    \"yellow\": $yellow,\n    \"teal\": $teal\n);\n\n$text-color: #5B6670;\n$title-color: #1B2850;\n$sub-title: #B8BCC9;\n$body-bg: #FAFBFE;\n$wrapper-bg: #f1f5f6;\n$text-muted: #9595b5;\n$default-background: #f7f8f9;\n$black-bg: #141432;\n$card-dark-bg: #1d1d42;\n$navy: #353570;\n$theme-title: #97A2D2;\n$input-bg: #2c2c50;\n$form-control-bg: #ffffff;\n\n// Social Icons Colors\n$facebook: #3B5998;\n$twitter: #00ACEE;\n$google: #DD4B39;\n$telegram: #0088CC;\n$linkedin: #0E76A8;\n$youtube: #C4302B;\n$instagram: #3F729B;\n$reddit: #C6C6C6;\n$pinterest: #cc2127;\n$vk: #2B587A;\n$rss: #EE802F;\n$skype: #00AFF0;\n$xing: #126567;\n$tumblr: #34526F;\n$email: #6567A5;\n$delicious: #205CC0;\n$stumbleupon: #F74425;\n$digg: #191919;\n$blogger: #FC4F08;\n$flickr: #FF0084;\n$vimeo: #86C9EF;\n$yahoo: #720E9E;\n$gplus: #DD4B39;\n$appstore: #000;\n\n// Gradient Variables\n$primary-gradient: linear-gradient(to right, $primary 0%, #8e77fa 100%);\n$secondary-gradient: linear-gradient(to right, $secondary 0%, #28b7f9 100%);\n$success-gradient: linear-gradient(to right,$success 0%, #5cf9e2 100%);\n$warning-gradient: linear-gradient(to right, $warning 0%, #fbc434 100%);\n$danger-gradient: linear-gradient(to right,$danger 0%, #fd4a68  100%);\n$info-gradient: linear-gradient(to right, $info 0%, #00f2fe  100%);\n$pink-gradient: linear-gradient(to right, $pink 0%, #FFA795 100%);\n$teal-gradient: linear-gradient(to right, $teal 0%, #0695DD 100%);\n$orange-gradient: linear-gradient(to right,$orange 0%,#FBB034 100%);\n$purple-gradient: linear-gradient(to right, $purple 0%, #9b25b7 100%);\n$light-gradient: linear-gradient(to right, $light 0%, #D1D6DE 100%);\n$dark-gradient: linear-gradient(to right, $dark 0%, #54505D 100%);\n\n// Style Anchor Elements\n$link-color: $primary;\n$link-decoration: none;\n$link-shade-percentage: 20%;\n$link-hover-color: darken($link-color, 10%);\n$link-hover-decoration: null;\n$spacer: 1rem;\n\n// Border\n$border-width: 1px;\n$border-style: solid;\n$border-color: $gray-400;\n$default-border: $gray-400;\n$input-border: #e9edf6;\n\n// Border Radius\n$border-radius: 4px;\n$border-radius-sm: 3px;\n$border-radius-lg: 5px;\n$border-radius-xl: 8px;\n$border-radius-xxl: 12px;\n$rounded: 50%;\n$rounded-pill: 1.5rem;\n\n// Box Shadow\n$box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\n$box-shadow-sm: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);\n$box-shadow-lg: 0 5px 10px rgba(30, 32, 37, 0.12);\n\n// Font Size\n$font-size-8: 8px;\n$font-size-9: 9px;\n$font-size-10: 10px;\n$font-size-11: 11px;\n$font-size-12: 12px;\n$font-size-13: 13px;\n$font-size-14: 14px;\n$font-size-15: 15px;\n$font-size-16: 16px;\n$font-size-18: 18px;\n$font-size-20: 20px;\n$font-size-22: 22px;\n$font-size-24: 24px;\n$font-size-26: 26px;\n$font-size-28: 28px;\n$font-size-30: 30px;\n$font-size-32: 32px;\n$font-size-34: 34px;\n$font-size-36: 36px;\n$font-size-40: 40px;\n$font-size-42: 42px;\n$font-size-50: 50px;\n$font-size-54: 54px;\n$font-size-60: 60px;\n\n$h1-fs: 2rem;\n$h2-fs: 1.75rem;\n$h3-fs: 1.5rem;\n$h4-fs: 1.25rem;\n$h5-fs: 1.15rem;\n$h6-fs: 1rem;\n\n$h1-font-size: $font-size-base * 2.5;\n$h2-font-size: $font-size-base * 2;\n$h3-font-size: $font-size-base * 1.75;\n$h4-font-size: $font-size-base * 1.5;\n$h5-font-size: $font-size-base * 1.25;\n$h6-font-size: $font-size-base;\n",".bg-primary {\n    background-color: $primary !important;\n}\n.bg-secondary {\n    background-color: $secondary !important;\n}\n.bg-info {\n    background-color: $info !important;\n}\n.bg-success {\n    background-color: $success !important;\n}\n.bg-warning {\n    background-color: $warning !important;\n}\n.bg-danger {\n    background-color: $danger !important;\n}\n.bg-dark {\n    background-color: $dark !important;\n}\n.bg-light {\n    background-color: $light !important;\n}\n.bg-white {\n    background-color: $white !important;\n}\n.bg-pink {\n    background-color: $pink !important;\n}\n.bg-purple {\n    background-color: $purple !important;\n}\n.bg-teal {\n    background-color: $teal !important;\n}\n.bg-blue {\n    background-color: $blue !important;\n}\n\n.bg-primary {\n    background-color: $primary !important;\n    &.bg-opacity-10 {\n        background-color: rgba($primary,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($primary,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($primary,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($primary,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($primary,1) !important;\n    }\n}\n.bg-secondary {\n    background-color: $secondary !important;\n    &.bg-opacity-10 {\n        background-color: rgba($secondary,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($secondary,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($secondary,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($secondary,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($secondary,1) !important;\n    }\n}\n.bg-info {\n    background-color: $info !important;\n    &.bg-opacity-10 {\n        background-color: rgba($info,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($info,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($info,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($info,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($info,1) !important;\n    }\n}\n.bg-success {\n    background-color: $success !important;\n    &.bg-opacity-10 {\n        background-color: rgba($success,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($success,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($success,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($success,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($success,1) !important;\n    }\n}\n.bg-warning {\n    background-color: $warning !important;\n    &.bg-opacity-10 {\n        background-color: rgba($warning,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($warning,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($warning,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($warning,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($warning,1) !important;\n    }\n}\n.bg-danger {\n    background-color: $danger !important;\n    &.bg-opacity-10 {\n        background-color: rgba($danger,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($danger,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($danger,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($danger,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($danger,1) !important;\n    }\n}\n.bg-dark {\n    background-color: $dark !important;\n    &.bg-opacity-10 {\n        background-color: rgba($dark,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($dark,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($dark,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($dark,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($dark,1) !important;\n    }\n}\n.bg-light {\n    background-color: $light !important;\n    &.bg-opacity-10 {\n        background-color: rgba($light,0.1) !important;\n    }\n    &.bg-opacity-25 {\n        background-color: rgba($light,0.25) !important;\n    }\n    &.bg-opacity-50 {\n        background-color: rgba($light,0.50) !important;\n    }\n    &.bg-opacity-75 {\n        background-color: rgba($light,0.75) !important;\n    }\n    &.bg-opacity-100 {\n        background-color: rgba($light,1) !important;\n    }\n}\n@each $color,\n$value in $theme-colors {\n    .bg-#{$color} {\n        background-color: #{$value} !important;\n        border: 1px solid #{$value} !important;\n        color: $white;\n    }\n}\n.bg-soft-primary {\n    background-color: $primary-300;\n    color: $primary;\n}\n.bg-soft-secondary {\n    background-color: $secondary-300;\n    color: $secondary;\n}\n.bg-soft-success {\n    background-color: $success-300;\n    color: $success;\n}\n.bg-soft-danger {\n    background-color: $danger-300;\n    color: $danger;\n}\n.bg-soft-warning {\n    background-color: $warning-300;\n    color: $warning;\n}\n.bg-soft-info {\n    background-color: rgba($info, 0.3);\n    color: $info;\n}\n.bg-soft-light {\n    background-color: rgba($light, 0.9);\n    color: $text-color;\n}\n.bg-soft-dark {\n    background-color: rgba($dark, 0.3);\n    color: $white;\n}\nbg-light {\n  color: $text-color;\n}\n\n.bg-primary-gradient {\n  background: $primary-gradient !important;\n  color: $white;\n}\n.bg-secondary-gradient {\n  background: $secondary-gradient !important;\n  color: $white;\n}\n.bg-warning-gradient {\n  background: $warning-gradient !important;\n  color: $white;\n}\n.bg-info-gradient {\n  background: $info-gradient !important;\n  color: $white;\n}\n.bg-success-gradient {\n  background: $success-gradient !important;\n  color: $white;\n}\n.bg-danger-gradient {\n  background: $danger-gradient !important;\n  color: $white;\n}\n.bg-orange-gradient {\n  background: $orange-gradient !important;\n  color: $white;\n}\n.bg-purple-gradient {\n  background: $purple-gradient !important;\n  color: $white;\n}\n.bg-teal-gradient {\n  background: $teal-gradient !important;\n  color: $white;\n}\n.bg-light-gradient {\n  background: $light-gradient !important;\n  color: $black;\n}\n.bg-dark-gradient {\n  background: $dark-gradient !important;\n  color: $white;\n}\n.bg-outline-primary {\n  background-color: $white;\n  border: 1px solid $primary;\n  color: $primary;\n}\n.bg-outline-secondary {\n  background-color: $white;\n  border: 1px solid $secondary;\n  color: $secondary;\n}\n.bg-outline-warning {\n  background-color: $white;\n  border: 1px solid $warning;\n  color: $warning;\n}\n.bg-outline-info {\n  background-color: $white;\n  border: 1px solid $info;\n  color: $info;\n}\n.bg-outline-success {\n  background-color: $white;\n  border: 1px solid $success;\n  color: $success;\n}\n.bg-outline-danger {\n  background-color: $white;\n  border: 1px solid $danger;\n  color: $danger;\n}\n.bg-outline-dark {\n  background-color: $white;\n  border: 1px solid $dark;\n  color: $dark;\n}\n.bg-outline-light {\n  background-color: $white;\n  border: 1px solid $light !important;\n  color: $black !important;\n}\n.bg-primary-transparent {\n    background-color: rgba($primary, 0.1) !important;\n    color: $primary !important;\n    &:hover {\n        background-color: rgba($primary, 0.1) !important;\n        color: $primary !important;\n    }\n}\n.bg-secondary-transparent {\n    background-color: rgba($secondary, 0.1) !important;\n    color: $secondary !important;\n    &:hover {\n        background-color: rgba($secondary, 0.1) !important;\n        color: $secondary !important;\n    }\n}\n.bg-info-transparent {\n    background-color: rgba($info, 0.1) !important;\n    color: $info !important;\n    &:hover {\n        background-color: rgba($info, 0.1) !important;\n        color: $info !important;\n    }\n}\n.bg-success-transparent {\n    background-color: rgba($success, 0.1) !important;\n    color: $success !important;\n    &:hover {\n        background-color: rgba($success, 0.1) !important;\n        color: $success !important;\n    }\n}\n.bg-warning-transparent {\n    background-color: rgba($warning, 0.1) !important;\n    color: $warning !important;\n    &:hover {\n        background-color: rgba($warning, 0.1) !important;\n        color: $warning !important;\n    }\n}\n.bg-danger-transparent {\n    background-color: rgba($danger, 0.1) !important;\n    color: $danger !important;\n    &:hover {\n        background-color: rgba($danger, 0.1) !important;\n        color: $danger !important;\n    }\n}\n.bg-light-transparent {\n    background-color: rgba($light, 0.5) !important;\n    color: $light !important;\n    &:hover {\n        background-color: rgba($light, 0.5) !important;\n        color: $text-color !important;\n    }\n}\n.bg-gray-100 {\n    background-color: $gray-100; \n}\n.bg-gray-200 {\n    background-color: $gray-200;\n}\n.bg-gray-300 {\n    background-color: $gray-300;\n}\n.bg-gray-400 {\n    background-color: $gray-400;\n}\n.bg-gray-500 {\n    background-color: $gray-500;\n}\n.bg-gray-600 {\n    background-color: $gray-600;\n}\n.bg-gray-700 {\n    background-color: $gray-700;\n}\n.bg-gray-800 {\n    background-color: $gray-800;\n}\n.bg-gray-900 {\n    background-color: $gray-900;\n}\n.svg-primary {\n    fill: $primary;\n}\n.svg-secondary {\n    fill: $secondary;\n}\n.svg-success {\n    fill: $success;\n}\n.svg-danger {\n    fill: $danger;\n}\n.svg-warning {\n    fill: $warning;\n}\n.svg-white {\n    fill: $white;\n}\n.svg-black {\n    fill: $black;\n}\n.svg-pink {\n    fill: $pink;\n}\n.svg-orange {\n    fill: $orange;\n}\n.svg-purple {\n    fill: $purple;\n}\n.svg-indigo {\n    fill: $indigo;\n}\n.svg-info {\n    fill: $info;\n}\n.svg-yellow {\n    fill: $yellow;\n}\n.svg-light {\n  fill: $light;\n}\n.svg-dark {\n  fill: $dark;\n}\n.svg-teal {\n  fill: $teal;\n}\n.svg-default {\n  fill: $text-color;\n}\n.color-container {\n  width: 5rem;\n  height: 5rem;\n  border-radius: $border-radius;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 3rem;\n}\n.text-container {\n  padding: 0.25rem 0.5rem;\n  border-radius: $border-radius;\n  box-shadow: $box-shadow;\n}\n.color-box {\n    width: 80px;\n    height: 80px;\n    border-radius: $border-radius;\n    margin-right: 0.75rem;\n    margin-bottom: 0.75rem;\n}\n",".avatar {\n    position: relative;\n    height: 2.625rem;\n    width: 2.625rem;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: $border-radius;\n    color: $white;\n    font-weight: $font-weight-medium;\n    a.badge:hover {\n        color: $white;\n    }\n    img {\n        width: 100%;\n        height: 100%;\n        border-radius: $border-radius;\n    }\n    &.avatar-rounded {\n        border-radius: 50%;\n        img {\n            border-radius: 50%;\n        }\n    }\n    &.avatar-radius-0 {\n        border-radius: 0;\n        img {\n            border-radius: 0;\n        }\n    }\n    .avatar-badge {\n        position: absolute;\n        inset-block-start: -4%;\n        inset-inline-end: -0.375rem;\n        width: 1.4rem;\n        height: 1.4rem;\n        font-size: 0.625rem;\n        border: 2px solid $white;\n        border-radius: 50% !important;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    &.online,&.offline {\n        &:before {\n            position: absolute;\n            content: \"\";\n            width: 0.5rem;\n            height: 0.5rem;\n            border-radius: 50%;\n            inset-inline-end: 0;\n            inset-block-end: 0;\n            border: 2px solid $white !important;\n            z-index: 1;\n        }\n    }\n    &.online:before {\n        background-color: $success;\n    }\n    &.offline:before {\n        background-color: $gray-500;\n    }\n    &.avatar-xs {\n        width: 1.25rem;\n        height: 1.25rem;\n        line-height: 1.25rem;\n        font-size: 0.65rem;\n        .avatar-badge {\n            padding: 0.25rem;\n            width:  1rem;\n            height: 1rem;\n            line-height: 1rem;\n            font-size: 0.5rem;\n            inset-block-start: -25%;\n            inset-inline-end: -0.5rem;\n        }\n    }\n    &.avatar-sm {\n        width: 1.75rem;\n        height: 1.75rem;\n        line-height: 1.75rem;\n        font-size: 0.65rem;\n        .avatar-badge {\n            padding: 0.3rem;\n            width:  1.1rem;\n            height: 1.1rem;\n            line-height: 1.1rem;\n            font-size: 0.5rem;\n            inset-block-start: -28%;\n            inset-inline-end: -0.45rem;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.5rem;\n                height: 0.5rem;\n            }\n        }    \n    }\n    &.avatar-md {\n        width: 2.5rem;\n        height: 2.5rem;\n        line-height: 2.5rem;\n        font-size: 0.8rem;\n        .avatar-badge {\n            padding: 0.4rem;\n            width:  1.2rem;\n            height: 1.2rem;\n            line-height: 1.2rem;\n            font-size: 0.65rem;\n            inset-block-start: -6%;\n            inset-inline-end: -13%;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.75rem;\n                height: 0.75rem;\n            }\n        }    \n        svg {\n            width: 1.5rem;\n            height: 1.5rem;\n        }\n    }\n    &.avatar-lg {\n        width: 3rem;\n        height: 3rem;\n        line-height: 3rem;\n        font-size: 1rem;\n        .avatar-badge {\n            inset-block-start: -15%;\n            inset-inline-end: -0.25%;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.8rem;\n                height: 0.8rem;\n            }\n        }    \n        svg {\n            width: 1.8rem;\n            height: 1.8rem;\n        }\n    }\n    &.avatar-xl {\n        width: 4rem;\n        height: 4rem;\n        line-height: 4rem;\n        font-size: 1.25rem;\n        .avatar-badge {\n            inset-block-start: -8%;\n            inset-inline-end: -0.2%;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 0.95rem;\n                height: 0.95rem;\n            }\n        }    \n    }\n    &.avatar-xxl {\n        width: 5rem;\n        height: 5rem;\n        line-height: 5rem;\n        font-size: 1.5rem;\n        .avatar-badge {\n            inset-block-start: -4%;\n            inset-inline-end: 0rem;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 1.05rem;\n                height: 1.05rem;\n                inset-block-end: 0.25rem;\n            }\n        }    \n    }\n    &.avatar-xxxl {\n        width: 6rem;\n        height: 6rem;\n        line-height: 6rem;\n        font-size: 1.75rem;\n        .avatar-badge {\n            inset-block-start: -4%;\n            inset-inline-end: 0rem;\n        }\n        &.online,&.offline {\n            &:before {\n                width: 1.05rem;\n                height: 1.05rem;\n                inset-block-end: 0.25rem;\n            }\n        }    \n    }\n}\n.avatar-list-stacked {\n    padding: 0;\n    &.avatar-group-overlapped {\n        .avatar {\n            margin-right: -.875rem;\n            &:hover{\n                z-index:1;\n            }\n        }\n    }\t\n    &.avatar-group-lg {\n        .avatar { \n            width: 3.25rem;\n            height: 3.25rem;\n            >.initial-wrap {\n                font-size: .95rem;\n            }\n        }\n        &.avatar-group-overlapped .avatar {\n            margin-right: -1rem;\n        }\t\n    }\n    &.avatar-group-sm {\n        .avatar { \n            width: 2rem;\n            height: 2rem;\n            >.initial-wrap {\n                font-size: .6rem;\n            }\n        }\n        &.avatar-group-overlapped .avatar {\n            margin-right: -0.625rem;\n        }\t\n    }\n    .avatar {\n        margin-inline-end: -0.875rem !important;\n        border: 1px solid rgba(0,0,0,0.05);\n        vertical-align: middle;\n        transition: transform ease 200ms;\n        &:last-child {\n            margin-inline-end: 0 !important;\n        }\n        &:hover {\n            z-index: 1;\n            transform: translateY(-0.188rem);\n        }\n    }\n}\n.avatar-group {\n\tdisplay: -webkit-inline-box;\n\tdisplay: -ms-inline-flexbox;\n\tdisplay: inline-flex;\n\t.avatar { \n\t\twidth: 2.625rem;\n\t\theight: 2.625rem;\n\t\t.avatar-img,\n\t\t>.initial-wrap {\n\t\t\tborder:2px solid $white;\n\t\t\tfont-size: .9rem;\n\t\t}\n\t}\n\t&.avatar-group-overlapped {\n\t\t.avatar {\n\t\t\tmargin-right: -.875rem;\n\t\t\t&:hover{\n\t\t\t\tz-index:1;\n\t\t\t}\n\t\t}\n\t}\t\n\t&.avatar-group-lg {\n\t\t.avatar { \n\t\t\twidth: 3.25rem;\n\t\t\theight: 3.25rem;\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: .95rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-group-overlapped .avatar {\n\t\t\tmargin-right: -1rem;\n\t\t}\t\n\t}\n\t&.avatar-group-sm {\n\t\t.avatar { \n\t\t\twidth: 2rem;\n\t\t\theight: 2rem;\n\t\t\t>.initial-wrap {\n\t\t\t\tfont-size: .6rem;\n\t\t\t}\n\t\t}\n\t\t&.avatar-group-overlapped .avatar {\n\t\t\tmargin-right: -0.625rem;\n\t\t}\t\n\t}\n}",".bootstrap-datetimepicker-widget table td.active,\n.bootstrap-datetimepicker-widget table td.active:hover {\n\tbackground-color: $warning;\n\ttext-shadow: unset;\n}\n.bootstrap-datetimepicker-widget table td.today:before {\n\tborder-bottom-color: $warning;\n}\n.bootstrap-datetimepicker-widget table thead tr:first-child th:hover {\n    background: transparent;\n}\n.bor-b1{\n    border-bottom: 1px solid $gray-300;\n}",".btn-submit {\n    background: $primary;\n    color: $white;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    @include margin-padding(null, 10px 20px);\n    @include transition(all 0.2s ease);\n    &:hover{\n        background: $primary-hover;\n        color: $white;\n    }\n    @include respond-below(custom991) {\n        min-width: auto;\n    }\n}\n.btn-submit.chenge-btn {\n    padding: 8px 12px;\n}\n.btn-cancel {\n    background: $gray-600;\n    color: $white;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    @include margin-padding(null, 10px 20px);\n    @include transition(all 0.5s ease);\n    &:hover{\n        background: #424b52;\n        color: $white;\n     }\n    @include respond-below(custom991) {\n        min-width: auto;\n    }\n}\n.btn-cancel.add-cancel {\n    padding: 8px 20px;\n    min-width: 0;\n}\n.btn-submit.add-sale {\n    padding: 8px 20px;\n    min-width: 0;\n}\n.btn-primary {\n    color: $white;\n    background-color: $primary;\n    border-color: $primary;\n}\n.btn-previw {\n    background: $danger;\n    color: $white;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    border-radius: 5px;\n    @include margin-padding(null, 8px 20px);\n    @include transition(all 0.5s ease);\n    &:hover{\n        background: $danger;\n        color: $white;\n     }\n    @include respond-below(custom991) {\n        min-width: auto;\n    }\n}\n.btn-save {\n    background: $primary;\n    color: $white;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    border-radius: 5px;\n    @include margin-padding(null, 8px 20px);\n    @include transition(all 0.2s ease);\n    &:hover{\n        background: $primary-hover;\n        color: $white;\n    }\n    @include respond-below(custom991) {\n        min-width: auto;\n        padding: 5px 7px;\n    }\n}\n.btn-reset {\n    background: $text-color;\n    color: $white;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    border-radius: 5px;\n    @include margin-padding(null, 8px 20px);\n    @include transition(all 0.2s ease);\n    &:hover{\n        background: $secondary;\n        color: $white;\n    }\n    @include respond-below(custom991) {\n        min-width: auto;\n        padding: 5px 7px;\n    }\n}\n.btn-send {\n    background: $primary;\n    @include margin-padding(null, 9px 14px);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    margin-right: 15px;\n    border-radius: 8px;\n    &:hover{\n        background: $primary-hover;\n        color: $white;\n    }\n    .send-mail {\n        margin-right: 10px;\n        width: 16px;\n        height: 16px;\n    }\n}\n.btn-download {\n    background: $secondary;\n    @include margin-padding(null, 9px 14px);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    margin-right: 15px;\n    border-radius: 8px;\n    &:hover{\n        background: $gray-900;\n        color: $white;\n     }\n    .download {\n        margin-right: 10px;\n        width: 16px;\n        height: 16px;\n    }    \n}\n.btn-barcode {\n    background: $danger;\n    @include margin-padding(null, 9px 14px);\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    margin-right: 15px;\n    border-radius: 8px;\n    &:hover{\n        background: $danger;\n        color: $white;\n     }\n    .print {\n        margin-right: 10px;\n        width: 16px;\n        height: 16px;\n    }\n    \n}\n.btn-primary.add-em-payroll {\n    padding: 9px 11px;\n    color: #fff;\n    font-weight: $font-weight-bold;\n    font-size: $font-size-14;\n    border-radius: 8px;\n    .me-2 {\n        width: 16px;\n        height: 16px;\n    }\n}\n.swal2-actions .swal2-confirm.btn:active {\n    background-color: $primary;\n    border-color: $primary;\n}\n.btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active {\n    background-color: $primary;\n    border-color: $primary;\n    color: $white !important;\n}\n.modal {\n    .card {\n        border: 0;\n    }\n}\n.search-input {\n    .btn-searchset {\n        &:active {\n            background-color: transparent;\n            border-color: transparent;\n            svg {\n                color: $secondary;\n            }\n        }\n    }\n}\n.input-blocks {\n    input[type=text] {\n        &.datetimepicker {\n            padding-left: 35px;\n        }\n    }\n}\n.iti__country-list {\n    z-index: 101;\n}\nbutton {\n    cursor: pointer;\n    &:focus{\n        outline: 0;\n        box-shadow: none;\n    }\n}\n.btn {\n    border-radius: $border-radius-sm;\n    padding: 0.625rem 1.25rem;\n    padding: 0.5rem 0.85rem;\n    font-size: 0.85rem;\n    transition: all 0.5s;\n    font-weight: $font-weight-semibold;\n    &:focus {\n        box-shadow: none !important;\n    }\n    &:hover {\n        transition: all 0.5s;\n    }\n    &.btn-lg {\n        padding: 0.65rem 1rem;\n        font-size: 0.95rem;\n    }\n    &.btn-sm {\n        padding: 0.25rem 0.5rem;\n        font-size: 0.75rem;\n    }\n    @each $color,\n    $value in $theme-colors {\n        &.btn-#{$color} {\n            background-color: #{$value} !important;\n            border: 1px solid #{$value} !important;\n            color: $white;\n            box-shadow: 0 4px 20px rgba($value, .15);\n            &:hover,\n            &:focus,\n            &.focus,\n            &:active,\n            &.active {\n                background-color: #{darken($value, 7%)}!important;\n                border:1px solid #{darken($value, 7%)}!important;\n                box-shadow: 0 3px 10px rgba($value, 0.5);\n                color: $white !important;\n            }\n        }\n    }\n    &.btn-light {\n        background-color: $light;\n        border: 1px solid $light;\n        color: $gray-800 !important;\n        &:hover,\n        &:focus,\n        &.focus,\n        &:active,\n        &.active {\n            background-color: lighten($light, 3%);\n            border: 1px solid lighten($light, 3%);\n            box-shadow: 0 0 0 2px rgba($light, .08);\n            color: $dark !important;\n        }\n    }\n}\n\n.btn-group {\n    .btn {\n      padding: 0.45rem 0.75rem;\n    }\n  }\n  .btn-group-lg {\n    .btn {\n      padding: 0.65rem 1rem;\n    }\n  }\n  .btn-group-sm {\n    .btn {\n      padding: 0.25rem 0.5rem;\n    }\n  }\n.btn {\n    &.btn-w-xs {\n      min-width: 5.625rem;\n    }\n    &.btn-w-sm {\n      min-width: 6.975rem;\n    }\n    &.btn-w-md {\n      min-width: 8.125rem;\n    }\n    &.btn-w-lg {\n      min-width: 9.375rem;\n    }\n  }\n  .btn-icon {\n    i {\n      padding: 0rem;\n      margin: -0.5rem;\n    }\n    &.btn-sm {\n      width: 1.75rem;\n      height: 1.75rem;\n      font-size: 0.8rem;\n    }\n    &.btn-lg {\n      width: 2.75rem;\n      height: 2.75rem;\n      font-size: 1.2rem;\n    }\n  }\n  .btn-list {\n    > button, > a {\n      margin: 0 0.375rem 0.375rem 0;\n    }\n  }\n  [dir=\"rtl\"] {\n    .btn-list {\n      button,\n      div,\n      a,\n      input {\n        margin: 0 0 0.375rem 0.375rem;\n      }\n    }\n  }\n  \n  .btn-list {\n    margin-block-end: -0.5rem;\n  }\n  .btn-square {\n    border-radius: 0;\n}\n.btn-group-pill .btn:first-child {\n    border-radius: 60px 0 0 60px;\n  }\n  .btn-group-pill .btn:last-child {\n    border-radius: 0 60px 60px 0;\n  }\n  \n  .btn-group-square .btn:first-child {\n    border-radius: 0px 0 0 0px;\n  }\n  .btn-group-square .btn:last-child {\n    border-radius: 0 0px 0px 0;\n  }\n.btn {\n  &.btn-primary-light {\n    background-color: rgba($primary, 0.1);\n    color: $primary;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $primary;\n      color: $white;\n      border-color: $primary;\n    }\n  }\n  &.btn-secondary-light {\n    background-color: rgba($secondary, 0.1);\n    color: $secondary;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $secondary;\n      color: $white;\n      border-color: $secondary;\n    }\n  }\n  &.btn-warning-light {\n    background-color: rgba($warning, 0.1);\n    color: $warning;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $warning;\n      color: $white;\n      border-color: $warning;\n    }\n  }\n  &.btn-info-light {\n    background-color: rgba($info, 0.1);\n    color: $info;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $info;\n      color: $white;\n      border-color: $info;\n    }\n  }\n  &.btn-success-light {\n    background-color: rgba($success, 0.1);\n    color: $success;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $success;\n      color: $white;\n      border-color: $success;\n    }\n  }\n  &.btn-danger-light {\n    background-color: rgba($danger, 0.1);\n    color: $danger;\n    &:hover,\n    &:focus,\n    &:active {\n      background-color: $danger;\n      color: $white;\n      border-color: $danger;\n    }\n  }\n}\n.btn {\n  &.btn-primary-ghost {\n    background-color: transparent;\n    color: $primary;\n    border: 1px solid $primary;\n    &:active {\n      color: $primary;\n      border: 1px solid $primary;\n      background-color: transparent;\n    }\n  }\n  &.btn-secondary-ghost {\n    background-color: transparent;\n    color: $secondary;\n    border: 1px solid $secondary;\n    &:active {\n      color: $secondary;\n      border: 1px solid $secondary;\n      background-color: transparent;\n    }\n  }\n  &.btn-warning-ghost {\n    background-color: transparent;\n    color: $warning;\n    border: 1px solid $warning;\n    &:active {\n      color: $warning;\n      border: 1px solid $warning;\n      background-color: transparent;\n    }\n  }\n  &.btn-info-ghost {\n    background-color: transparent;\n    color: $info;\n    border: 1px solid $info;\n    &:active {\n      color: $info;\n      border: 1px solid $info;\n      background-color: transparent;\n    }\n  }\n  &.btn-success-ghost {\n    background-color: transparent;\n    color: $success;\n    border: 1px solid $success;\n    &:active {\n      color: $success;\n      border: 1px solid $success;\n      background-color: transparent;\n    }\n  }\n  &.btn-danger-ghost {\n    background-color: transparent;\n    color: $danger;\n    border: 1px solid $danger;\n    &:active {\n      color: $danger;\n      border: 1px solid $danger;\n      background-color: transparent;\n    }\n  }\n}\n.btn-list {\n  button {\n    margin: 0 0.375rem 0.375rem 0;\n  }\n}\n.btn-outline-primary {\n    border: 1px solid $primary !important;\n    color: $primary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $primary !important;\n        border:1px solid $primary !important;\n        box-shadow: 0 3px 10px rgba($primary, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-secondary {\n    border: 1px solid $secondary !important;\n    color: $secondary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $secondary !important;\n        border:1px solid $secondary !important;\n        box-shadow: 0 3px 10px rgba($secondary, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-success {\n    border: 1px solid $success !important;\n    color: $success !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $success !important;\n        border:1px solid $success !important;\n        box-shadow: 0 3px 10px rgba($success, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-danger {\n    border: 1px solid $danger !important;\n    color: $danger !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $danger !important;\n        border:1px solid $danger !important;\n        box-shadow: 0 3px 10px rgba($danger, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-warning {\n    border: 1px solid $warning !important;\n    color: $warning !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $warning !important;\n        border:1px solid $warning !important;\n        box-shadow: 0 3px 10px rgba($warning, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-info {\n    border: 1px solid $info !important;\n    color: $info !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $info !important;\n        border:1px solid $info !important;\n        box-shadow: 0 3px 10px rgba($info, 0.5);\n        color: $white !important;\n    }\n}\n.btn-outline-light {\n    border: 1px solid $light;\n    color: $gray-800 !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $light;\n        border: 1px solid $light;\n        color: $dark !important;\n    }\n}\n.btn-outline-dark {\n    border: 1px solid $dark !important;\n    color: $dark !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n        background-color: $dark !important;\n        border:1px solid $dark !important;\n        box-shadow: 0 3px 10px rgba($dark, 0.5);\n        color: $white !important;\n    }\n}\n.btn-soft-primary {\n    background-color: $primary-300 !important;\n    color: $primary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($primary, .2);\n       border-color: $primary;\n    }    \n}\n.btn-soft-secondary {\n    background-color: $secondary-300 !important;\n    color: $secondary !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($secondary, .2);\n       border-color: $secondary;\n    }    \n}\n.btn-soft-success {\n    background-color: $success-300 !important;\n    color: $success !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($success, .2);\n       border-color: $success;\n    }    \n}\n.btn-soft-danger {\n    background-color: $danger-300 !important;\n    color: $danger !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($danger, .2);\n       border-color: $danger;\n    }    \n}\n.btn-soft-warning {\n    background-color: $warning-300 !important;\n    color: $warning !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($warning, .2);\n       border-color: $warning;\n    }    \n}\n.btn-soft-info {\n    background-color: rgba($info, 0.3) !important;\n    color: $info !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($info, .2);\n       border-color: $info;\n    }    \n}\n.btn-soft-light {\n    background-color: rgba($light, .9) !important;\n    color: $text-color !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($light, .2);\n       border-color: $light;\n       border-color: $text-color;\n    }    \n}\n.btn-soft-dark {\n    background-color: rgba($dark, 0.3) !important;\n    color: $white !important;\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n       box-shadow: 0 3px 12px rgba($dark, .2);\n       border-color: $dark;\n    }    \n}",".badge {\n    &.badge-primary {\n        background: rgba($primary, 0.1);\n        box-shadow: 0 1px 1px rgba($primary, 0.5);\n        color: $primary;\n        \n    }\n}\n@each $color, $value in $theme-colors {\n    .badge {\n        &.badge-#{$color} {\n            background: #{$value};\n            box-shadow: 0 1px 1px rgba($value, 0.5);\n            color: $white;\n        }\n        &.badge-soft-#{$color} {\n            background: rgba($value, 0.1);\n            box-shadow: 0 1px 1px rgba($value, 0.5);\n            color: $value;\n        }\n    }\n}\n.badge{\n    padding: .25rem .45rem;\n    text-transform:capitalize;\n    font-weight: $font-weight-semibold;\n    letter-spacing: 0.5px;\n    border-radius: $border-radius;\n    &.badge-xs {\n        font-size: 10px;\n        padding: 0px 5px;\n        line-height: 18px;\n    }\n    &.badge-sm {\n        font-size: 11px;\n        padding: 5px 8px;\n        line-height: 11px;\n    }\n    &.badge-md {\n        font-size: 12px;\n        padding: 5px 12px;\n        line-height: 1.5;\n    }\n    &.badge-lg {\n        font-size: $font-size-14;\n        padding: 0px 10px;\n        line-height: 30px;\n    }\n    &.badge-xl {\n        font-size: $font-size-16;\n        padding: 0px 15px;\n        line-height: 35px;\n    }\n}",".border-container {\n    display: inline-block;\n    width: 5rem;\n    height: 5rem;\n    margin: 0.25rem;\n    background-color: $light;\n}\n.border {\n    border: 1px solid $border-color !important;\n    &.border-dashed {\n        border-style: dashed !important;\n    }\n    &.border-dotted {\n        border-style: dotted !important;\n    }\n    &.border-primary {\n        border: 1px solid $primary !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($primary, 0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($primary, 0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($primary, 0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($primary, 0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($primary,1) !important;\n        }\n    }\n    &.border-secondary {\n        border: 1px solid $secondary !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($secondary,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($secondary,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($secondary,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($secondary,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($secondary,1) !important;\n        }\n    }\n    &.border-info {\n        border: 1px solid $info !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($info,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($info,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($info,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($info,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($info,1) !important;\n        }\n    }\n    &.border-success {\n        border: 1px solid $success !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($success,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($success,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($success,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($success,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($success,1) !important;\n        }\n    }\n    &.border-warning {\n        border: 1px solid $warning !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($warning,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($warning,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($warning,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($warning,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($warning,1) !important;\n        }\n    }\n    &.border-danger {\n        border: 1px solid $danger !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($danger,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($danger,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($danger,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($danger,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($danger,1) !important;\n        }\n    }\n    &.border-white {\n        border: 1px solid $white !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($white,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($white,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($white,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($white,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($white,1) !important;\n        }\n    }\n    &.border-light {\n        border: 1px solid $light !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($light,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($light,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($light,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($light,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($light,1) !important;\n        }\n    }\n    &.border-dark {\n        border: 1px solid $dark !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($dark,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($dark,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($dark,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($dark,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($dark,1) !important;\n        }\n    }\n    &.border-orange {\n        border: 1px solid $orange !important;\n        opacity: 1;\n        &.border-opacity-10 {\n            border-color: rgba($orange,0.1) !important;\n        }\n        &.border-opacity-25 {\n            border-color: rgba($orange,0.25) !important;\n        }\n        &.border-opacity-50 {\n            border-color: rgba($orange,0.50) !important;\n        }\n        &.border-opacity-75 {\n            border-color: rgba($orange,0.75) !important;\n        }\n        &.border-opacity-100 {\n            border-color: rgba($orange,1) !important;\n        }\n    }\n    &.border-opacity-10 {\n        --bs-border-opacity: 0.1 !important;\n    }\n    &.border-opacity-25 {\n        --bs-border-opacity: 0.25 !important;\n    }\n    &.border-opacity-50 {\n        --bs-border-opacity: 0.5 !important;\n    }\n    &.border-opacity-75 {\n        --bs-border-opacity: 0.75 !important;\n    }\n    &.border-opacity-100 {\n        --bs-border-opacity: 1 !important;\n    }\n    &.border-1 {\n        border-width: 1px !important;\n    }\n    &.border-2 {\n        border-width: 2px !important;\n    }\n    &.border-3 {\n        border-width: 3px !important;\n    }\n    &.border-4 {\n        border-width: 4px !important;\n    }\n    &.border-5 {\n        border-width: 5px !important;\n    }\n    &.border-block-start-dashed {\n        border-top-style: dashed;\n    }\n    &.border-block-start-dotted {\n        border-top-style: dotted;\n    }\n    &.border-inline-end-dashed {\n        border-inline-end-style: dashed;\n    }\n    &.border-inline-end-dotted {\n        border-inline-end-style: dotted;\n    }\n    &.border-block-end-dashed {\n        border-bottom-style: dashed;\n    }\n    &.border-block-end-dotted {\n        border-bottom-style: dotted;\n    }\n    &.border-inline-start-dashed {\n        border-inline-start-style: dashed;\n    }\n    &.border-inline-start-dotted {\n        border-inline-start-style: dotted;\n    }\n    &.border-0 {\n        border: 0 !important;\n    }\n    &.border-top-0 {\n        border-block-start: 0 !important;\n    }\n    &.border-end-0 {\n        border-inline-end: 0 !important;\n    }\n    &.border-bottom-0 {\n        border-block-end: 0 !important;\n    }\n    &.border-start-0 {\n        border-inline-start: 0 !important;\n    }\n}\n.border-top {\n    border-top: 1px solid $border-color !important;\n    &.border-block-start-dashed {\n        border-top-style: dashed !important;\n    }\n    &.border-block-start-dotted {\n        border-top-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.border-end {   \n    border-inline-end: 1px solid $border-color !important;\n    &.border-inline-end-dashed {\n        border-inline-end-style: dashed !important;\n    }\n    &.border-inline-end-dotted {\n        border-inline-end-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.border-bottom {\n    border-bottom: 1px solid $border-color !important;\n    &.border-block-end-dashed {\n        border-bottom-style: dashed !important;\n    }\n    &.border-block-end-dotted {\n        border-bottom-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.border-start {\n    border-inline-start: 1px solid $border-color !important;\n    &.border-inline-start-dashed {\n        border-inline-start-style: dashed !important;\n    }\n    &.border-inline-start-dotted {\n        border-inline-start-style: dotted !important;\n    }\n    &.border-primary {\n        border-color: $primary !important;\n    }\n    &.border-secondary {\n        border-color: $secondary !important;\n    }\n    &.border-warning {\n        border-color: $warning !important;\n    }\n    &.border-info {\n        border-color: $info !important;\n    }\n    &.border-success {\n        border-color: $success !important;\n    }\n    &.border-danger {\n        border-color: $danger !important;\n    }\n    &.border-light {\n        border-color: $light !important;\n    }\n    &.border-dark {\n        border-color: $dark !important;\n    }\n}\n.br-1 {\n    border-radius: 0.0625rem;\n}\n.br-2 {\n    border-radius: 0.125rem;\n}\n.br-3 {\n    border-radius: 0.1875rem;\n}\n.br-4 {\n    border-radius: 0.25rem;\n}\n.br-5 {\n    border-radius: 0.3125rem;\n}\n.br-6 {\n    border-radius: 0.375rem;\n}\n.br-7 {\n    border-radius: 0.4375rem;\n}\n.br-8 {\n    border-radius: 0.5rem;\n}\n.br-9 {\n    border-radius: 0.5625rem;\n}\n.br-10 {\n    border-radius: 0.625rem;\n}\n.br-15 {\n    border-radius: 0.9375rem;\n}\n.br-20 {\n    border-radius: 1.25rem;\n}\n.rounded {\n    border-radius: $border-radius !important;\n}\n\n",".calendar-events {\n    border: 1px solid transparent;\n    cursor: move;\n\t@include margin-padding(null, 10px 15px);\n}\n.calendar-events:hover {\n\tborder-color: $gray-300;\n    background-color: $white;\n}\n.calendar-events i {\n    margin-right: 8px;\n}\n.calendar {\n\tfloat: left;\n\tmargin-bottom: 0;\n}\n.fc-toolbar.fc-header-toolbar {\n    margin-bottom: 1.5rem;\n}\n.none-border .modal-footer {\n\tborder-top: none;\n}\n.fc-toolbar h2 {\n\tfont-size: $font-size-18;\n\tfont-weight: $font-weight-semibold;\n\tfont-family: 'Roboto', sans-serif;\n\tline-height: 30px;\n\ttext-transform: uppercase;\n}\n.fc-day-grid-event .fc-time {\n\tfont-family: 'Roboto', sans-serif;\n}\n.fc-day {\n\tbackground: $white;\n}\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active,\n.fc-toolbar button:focus,\n.fc-toolbar button:hover,\n.fc-toolbar .ui-state-hover {\n\tz-index: 0;\n}\n.fc th.fc-widget-header {\n\tbackground: $gray-300;\n\tfont-size: $font-size-14;\n\tline-height: 20px;\n\tpadding: 10px 0;\n\ttext-transform: uppercase;\n}\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n\tborder-color: #f3f3f3;\n}\n.fc-basic-view .fc-day-number, \n.fc-basic-view .fc-week-number {\n    padding: 2px 5px;\n}\n.fc-button {\n\tbackground: #f1f1f1;\n\tborder: none;\n\tcolor: #797979;\n\ttext-transform: capitalize;\n\tbox-shadow: none !important;\n\tborder-radius: 3px !important;\n\tmargin: 0 3px !important;\n\tpadding: 6px 12px !important;\n\theight: auto !important;\n}\n.fc-text-arrow {\n\tfont-family: inherit;\n\tfont-size: $font-size-16;\n}\n.fc-state-hover {\n\tbackground: #f3f3f3;\n}\n.fc-state-highlight {\n\tbackground: #f0f0f0;\n}\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n\tbackground-color: $primary !important;\n\tcolor: $white !important;\n\ttext-shadow: none !important;\n}\n.fc-cell-overlay {\n\tbackground: #f0f0f0;\n}\n.fc-unthemed .fc-today {\n\tbackground: $white;\n}\n.fc-event {\n\tborder-radius: 2px;\n\tborder: none;\n\tcolor: $white !important;\n\tcursor: move;\n\tfont-size: 13px;\n\tmargin: 1px 7px;\n\tpadding: 5px 5px;\n\ttext-align: center;\n}\n.fc-basic-view td.fc-week-number span {\n\tpadding-right: 8px;\n\tfont-weight: $font-weight-bold;\n\tfont-family: 'Roboto', sans-serif;\n}\n.fc-basic-view td.fc-day-number {\n\tpadding-right: 8px;\n\tfont-weight: $font-weight-bold;\n\tfont-family: 'Roboto', sans-serif;\n}\n.event-form .input-group .form-control {\n\theight: 40px;\n}\n.submit-section {\n\ttext-align: center;\n\tmargin-top: 40px;\n}\n.submit-btn {\n    border-radius: 50px;\n    font-size: $font-size-18;\n    font-weight: $font-weight-semibold;\n    min-width: 200px;\n    padding: 10px 20px;\n}",".apexcharts-legend.apexcharts-align-center.position-right {\n    display: none;\n}\n.apexcharts-toolbar {\n    display: none !important;\n}\n#sales_charts,\n.chart-set{\n    overflow: hidden;\n}\n.apexcharts-canvas {\n    width: 100% !important;\n}\n\n",".img-cropper {\n\t.dropup {\n\t\t.dropdown-toggle {\n\t\t\t&::after {\n\t\t\t\tcontent: '';\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\t}\n}\n.dropdown-auto {\n\toverflow: auto;\n}\n.dropdown-divider {\n\tmargin: 0;\n}\n.dropdown {\n\t.dropdown-toggle {\n\n\t\t&:after {\n      display: inline-block;\n      margin-inline-start: 0.25rem;\n      vertical-align: 0;\n      content: \"\\f078\";\n      font-family: \"Font Awesome 5 Free\";\n      border: 0;\n      font-size: 0.6rem;\n      font-weight: $font-weight-semibold;\n\t\t}\n\n\t\t&.btn-primary {\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t.dropdown-menu {\n\t\tfont-family: $font-family-primary;\n\t}\n}\n.dropdown-menu {\n  border-color: $border-color;\n  box-shadow: 0 1rem 1.125rem rgba(169, 169, 169, 0.15);\n  font-size: 0.875rem;\n  color: $text-color;\n  background-color: $white;\n  padding: 0;\n  z-index: 10;\n}\n.dropdown-divider {\n  border-color: $border-color;\n}\n\n.dropdown-item-text {\n  color: $text-color;\n}\n.dropdown-header {\n  color: $text-color;\n}\n.dropdown-item {\n  color: $text-color;\n  white-space: unset;\n  padding: 0.5rem 0.9375rem;\n  font-size: 0.8125rem;\n\n  &.disabled,\n  &:disabled {\n    color: $text-color;\n    opacity: 0.5;\n  }\n  &:not(.active) {\n    &:hover,\n    &:focus,\n    &:active {\n      color: $primary;\n      background-color: rgba($primary, 0.05);\n    }\n  }\n  &.active {\n    background-color: $primary !important;\n  }\n}\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f078\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f078\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n\n.dropup .dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f077\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.dropend .dropdown-toggle::after {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f054\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.dropstart .dropdown-toggle::before {\n  display: inline-block;\n  margin-inline-start: 0.25rem;\n  vertical-align: 0;\n  content: \"\\f053\";\n  font-family: \"Font Awesome 5 Free\";\n  border: 0;\n  font-size: 0.6rem;\n  font-weight: $font-weight-semibold;\n}\n.btn.dropdown-toggle-split {\n  opacity: 0.85;\n}\n\n.dropdown-menu-dark {\n  background-color: $dark;\n  border-color: rgba(255, 255, 255, 0.1);\n  li a {\n    color: $white;\n  }\n}\n.btn-list {\n\ta.dropdown-item {\n\t\tmargin-block-end: 0;\n\t}\n\t.btn-soft-success  {\n\t\t&:hover {\n\t\t\ttransform: translateY(0);\n\t\t}\n\t}\n\t.btn-soft-danger  {\n\t\t&:hover {\n\t\t\ttransform: translateY(0);\n\t\t}\n\t\t&:active {\n\t\t\n\t\t}\n\t}\n}\n\n.dropdown-menu {\n  @mixin dropdown-menu-color($color) {\n    background-color: $color;\n    li a {\n      color: rgba(255, 255, 255, 0.9);\n    }\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        color: $white;\n      }\n    }\n  }\n  &.dropdown-menu-primary {\n    @include dropdown-menu-color($primary);\n  }\n  &.dropdown-menu-secondary {\n    @include dropdown-menu-color($secondary);\n  }\n  &.dropdown-menu-warning {\n    @include dropdown-menu-color($warning);\n  }\n  &.dropdown-menu-info {\n    @include dropdown-menu-color($info);\n  }\n  &.dropdown-menu-success {\n    @include dropdown-menu-color($success);\n  }\n  &.dropdown-menu-danger {\n    @include dropdown-menu-color($danger);\n  }\n}\n.dropdown-menu {\n  &.dropmenu-item-primary {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($primary, 0.1) !important;\n        color: $primary;\n      }\n    }\n  }\n  &.dropmenu-item-secondary {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($secondary, 0.1) !important;\n        color: $secondary;\n      }\n    }\n  }\n  &.dropmenu-item-warning {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($warning, 0.1) !important;\n        color: $warning;\n      }\n    }\n  }\n  &.dropmenu-item-info {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba($info, 0.1) !important;\n        color: $info;\n      }\n    }\n  }\n  &.dropmenu-item-success {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba(var(--success-rgb), 0.1) !important;\n        color: $success;\n      }\n    }\n  }\n  &.dropmenu-item-danger {\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        background-color: rgba(var(--danger-rgb), 0.1) !important;\n        color: $danger;\n      }\n    }\n  }\n}\n.dropdown-menu {\n  @mixin dropmenu-light-color($color) {\n    backdrop-filter: blur(2rem);\n    .dropdown-item {\n      &:hover,\n      &:focus,\n      &:active,\n      &.active {\n        color: $white;\n        background-color: $color !important;\n      }\n    }\n  }\n  &.dropmenu-light-primary {\n    background-color: rgba(var($secondary), 0.1);\n    @include dropmenu-light-color($primary);\n  }\n  &.dropmenu-light-secondary {\n    background-color: rgba(var($secondary), 0.1);\n    @include dropmenu-light-color($secondary);\n  }\n  &.dropmenu-light-info {\n    background-color: rgba($info, 0.1);\n    @include dropmenu-light-color($info);\n  }\n  &.dropmenu-light-warning {\n    background-color: rgba($warning, 0.1);\n    @include dropmenu-light-color($warning);\n  }\n  &.dropmenu-light-success {\n    background-color: rgba($success, 0.1);\n    @include dropmenu-light-color($success);\n  }\n  &.dropmenu-light-danger {\n    background-color: rgba(var(--danger-rgb), 0.1);\n    @include dropmenu-light-color($danger);\n  }\n}\n.dropdown-divider {\n  margin: 0;\n}\n.bd-example > .dropdown-menu {\n  position: static;\n  display: block;\n}\n\n",".icons-list {\n    padding: 0;\n    display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n      li {\n        display: block;\n        width: 40px;\n        height: 40px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        font-size: $font-size-18;\n        @include rounded(50px);\n        border: 1px solid #e6ebf1;\n        color: $primary;\n        @include margin-padding(5px, null);\n        @include box-shadow(null, 0, 2px, 3px, null, rgb(215, 197, 255));\n    }\n}",".progress {\n    background-color: $gray-300;\n    height: 0.75rem;\n    border-radius: 0.25rem;\n}\n.progress-stacked {\n    background-color: $gray-300;\n}\n.progress-bar {\n    color: $white;\n    background-color: $primary;\n}\n\n@keyframes progress-animate {\n    0% {\n        width: 0;\n    }\n}\n.progress-animate {\n    position: relative;\n    border-radius: 0.625rem;\n    .progress-bar {\n        position: relative;\n        border-radius: 0.625rem;\n        animation:  2s progress-animate;\n    }\n}\n.progress,.progress-stacked {\n    &.progress-xs {\n        height: .3125rem;\n    }\n    &.progress-sm {\n        height: 0.5rem;\n    }\n    &.progress-lg {\n        height: 1rem;\n    }\n    &.progress-xl {\n        height: 1.25rem;\n    }\n}\n.progress-vertical {\n    min-height: 250px;\n    height: 250px;\n    width: 10px;\n    position: relative;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n\n    .progress-bar {\n        width: 100%;\n    }\n\n    &.progress-xl {\n        width: 15px;\n    }\n\n    &.progress-lg {\n        width: 12px;\n    }\n\n    &.progress-sm {\n        width: 8px;\n    }\n\n    &.progress-xs {\n        width: 5px;\n    }\n}\n.progress-vertical-bottom {\n    min-height: 250px;\n    height: 250px;\n    position: relative;\n    width: 10px;\n    display: inline-block;\n    margin-bottom: 0;\n    margin-right: 20px;\n\n    .progress-bar {\n        width: 100%;\n        bottom: 0;\n        position: absolute;\n    }\n\n    &.progress-xl {\n        width: 15px;\n    }\n\n    &.progress-lg {\n        width: 12px;\n    }\n\n    &.progress-sm {\n        width: 8px;\n    }\n\n    &.progress-xs {\n        width: 5px;\n    }\n}\n.progress-custom {\n    overflow: visible;\n    position: relative;\n    .progress-bar {\n        position: relative;\n        overflow: visible;\n        &:after {\n            content: \"\";\n            width: 1.15rem;\n            height: 1.15rem;\n            border-radius: 50%;\n            box-shadow: 0 0.313rem 0.313rem rgba($primary, 0.5);\n            background: $white;\n            position: absolute;\n            inset-inline-end: -0.375rem;\n            inset-block-start: -0.375rem;\n            border: 0.25rem solid $primary;\n        }\n        &.bg-secondary:after {\n            border: 0.25rem solid $secondary;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--secondary-rgb),0.2);\n        }\n        &.bg-warning:after {\n            border: 0.25rem solid $warning;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--warning-rgb),0.2);\n        }\n        &.bg-info:after {\n            border: 0.25rem solid $info;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--info-rgb),0.2);\n        }\n        &.bg-success:after {\n            border: 0.25rem solid $success;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--success-rgb),0.2);\n        }\n        &.bg-danger:after {\n            border: 0.25rem solid $danger;\n            box-shadow: 0 0.313rem 0.313rem rgba(var(--danger-rgb),0.2);\n        }\n    }\n    .progress-bar-value{\n        width: 1.875rem;\n        height: 1.25rem;\n        line-height: 1.25rem;\n        border-radius: 0.188rem;\n        background: $primary;\n        box-shadow: 0 0.313rem 0.313rem rgba(0,0,0,0.4);\n        font-size: 0.625rem;\n        font-weight: $font-weight-semibold;\n        color: $white;\n        text-align: center;\n        position: absolute;\n        inset-block-end: 1.5rem;\n        inset-inline-end: -0.688rem;\n        &:after{\n            content: \"\";\n            border-block-start: 0.438rem solid $primary;\n            border-inline-start: 0.438rem solid transparent;\n            border-inline-end: 0.438rem solid transparent;\n            position: absolute;\n            inset-block-end: -0.375rem;\n            inset-inline-start: 28%;\n        }\n        &.bg-secondary {\n            background-color: $secondary;\n            &:after {\n                border-block-start: 0.438rem solid $secondary;\n            }\n        }\n        &.bg-success {\n            background-color: $success;\n            &:after {\n                border-block-start: 0.438rem solid $success;\n            }\n        }\n        &.bg-warning {\n            background-color: $warning;\n            &:after {\n                border-block-start: 0.438rem solid $warning;\n            }\n        }\n        &.bg-danger {\n            background-color: $danger;\n            &:after {\n                border-block-start: 0.438rem solid $danger;\n            }\n        }\n        &.bg-info {\n            background-color: $info;\n            &:after {\n                border-block-start: 0.438rem solid $info;\n            }\n        }\n    }\n}\n[dir=\"rtl\"] {\n    .progress-bar-title{ \n        border-radius: 0 0.313rem 0.313rem 0;\n    }\n}\n.progress-item-1, .progress-item-2, .progress-item-3{\n    position:absolute;\n\tmargin-block-start:-0.25rem;\n\tz-index:1;\n\theight:0.938rem;\n\twidth:0.938rem;\n\tborder-radius:1.563rem;\n    background-color: $light;\n}\n.progress-item-1{\n\tinset-inline-start:25%;\n}\n.progress-item-2{\n\tinset-inline-start:50%;\n}\n.progress-item-3{\n\tinset-inline-start:75%;\n}\n.custom-progress-3 {\n    overflow: visible;\n    border-radius: 0.625rem;\n    .progress-bar {\n        position: relative;\n        overflow: visible;\n        margin: 0.313rem;\n        border-radius: 0.25rem;\n        &:before {\n            content: \"\";\n            position: absolute;\n            width: 0.25rem;\n            height: 0.25rem;\n            inset-inline-start: 0.125rem;\n            background-color: $white;\n            border-radius: 50%;\n        }\n        .progress-bar-value{\n            border: 0.125rem solid $primary;\n            width: 2.5rem;\n            height: 1.563rem;\n            line-height: 1.313rem;\n            border-radius: 3.125rem;\n            background: $white;\n            font-size: 0.625rem;\n            font-weight: $font-weight-semibold;\n            color: $primary;\n            text-align: center;\n            position: absolute;\n            inset-inline-end: -0.625rem;\n            &.secondary {\n                border: 0.125rem solid $secondary;\n                color: $secondary;\n            }\n            &.warning {\n                border: 0.125rem solid $warning;\n                color: $warning;\n            }\n            &.info {\n                border: 0.125rem solid $info;\n                color: $info;\n            }\n            &.success {\n                border: 0.125rem solid $success;\n                color: $success;\n            }\n            &.danger {\n                border: 0.125rem solid $danger;\n                color: $danger;\n            }\n        }\n    }\n}\n.custom-progress-4 {\n    &.progress {\n        background-color: rgba($primary, 0.1);\n        border-radius: 0.25rem;\n        &.secondary {\n            background-color: rgba($secondary, 0.1);\n            .progress-bar-label {\n                color: $secondary;\n            }\n        }\n        &.warning {\n            background-color: rgba($warning, 0.1);\n            .progress-bar-label {\n                color: $warning;\n            }\n        }\n        &.info {\n            background-color: rgba($info, 0.1);\n            .progress-bar-label {\n                color: $info;\n            }\n        }\n        &.success {\n            background-color: rgba($success, 0.1);\n            .progress-bar-label {\n                color: $success;\n            }\n        }\n        &.danger {\n            background-color: rgba($danger, 0.1);\n            .progress-bar-label {\n                color: $danger;\n            }\n        }\n        .progress-bar {\n            border-radius: 0.25rem;\n        }\n        .progress-bar-label {\n            position: absolute;\n            inset-inline-end: 0.313rem;\n            font-weight: $font-weight-semibold;\n            font-size: 0.813rem;\n            color: $primary;\n        }\n    }\n}",".page-link {\n    color: $text-color;\n    background-color: $white;\n    border: 1px solid $border-color;\n    &:focus {\n        box-shadow: none;\n        background-color: $light;\n    }\n    &:hover {\n        color: $primary;\n        background-color: $light;\n        border-color: $border-color;\n    }\n}\n.page-item.active .page-link {\n    color: $white;\n    background-color: $primary;\n    border-color: $primary;\n}\n.disabled>.page-link, .page-link.disabled {\n    color: $text-color;\n    background-color: $white;\n    border-color: $border-color;\n    opacity: 0.7;\n}\n\n[dir=\"rtl\"] { \n    .pagination{\n        .page-link{\n            .bx-chevron-left::before{\n                content: \"\\ea50\";\n            }\n            .bx-chevron-right::before{\n                content: \"\\ea4d\";\n            }\n            .ri-arrow-right-s-line:before{\n                content: \"\\ea64\";\n            }\n            .ri-arrow-left-s-line:before{\n                content: \"\\ea6e\";\n            }\n        }\n    }\n}\n.pagination-style-1 .pagination {\n    .page-item {\n        margin: 0 0.25rem;\n        .page-link {\n            border: 0;\n            border-radius: $border-radius;\n            font-size: 0.8125rem;\n            i {\n                font-weight: $font-weight-semibold;\n            }\n        }\n        &.active {\n            .page-link {\n                border-radius: $border-radius;\n                background-color: $primary;\n                color: $white;\n            }\n            &:hover {\n                .page-link {\n                    border-radius: $border-radius;\n                    background-color: $primary;\n                    color: $white;\n                }\n            } \n        }\n        &:hover {\n            .page-link {\n                background-color: $light;\n                color: $primary;\n            }\n        }\n    }\n}\n.pagination-style-2 .pagination {\n    border-radius: $border-radius;\n    .page-item {\n        margin: 0 0.25rem;\n        .page-link {\n            border: 0 !important;\n            font-size: 0.8125rem;\n        }\n        &.active {\n            .page-link {\n                background-color: $white;\n                color: $primary;\n                position: relative;\n                font-weight: bold;\n                &:before {\n                    position: absolute;\n                    content: \"\";\n                    inset-block-end: 0;\n                    inset-inline-start: 0;\n                    width: 100%;\n                    height: 0.1rem;\n                    background-color: $primary;\n                }\n            }\n        }\n        &:hover {\n            .page-link {\n                background-color: transparent;\n            }\n        }\n    }\n}\n.pagination-style-3 .pagination {\n    border-radius: 50px;\n    padding: 0.25rem;\n    align-items: center;\n    .page-item {\n        margin: 0 0.25rem;\n        .page-link {\n            border: 0;\n            border-radius: 50px;\n            font-size: 0.8125rem;\n            i {\n                font-weight: $font-weight-semibold;\n            }\n        }\n        &.active {\n            .page-link {\n                background-color: $primary;\n                color: $white;\n            }\n            &:hover {\n                .page-link {\n                    background-color: $primary;\n                }\n            }\n        }\n        &:hover {\n            .page-link {\n                background-color: $light;\n            }\n        }\n    }\n}\n.pagination-style-4 .pagination {\n    .page-item {\n        .page-link {\n            border: 0 !important;\n            font-size: 0.8125rem;\n            border-radius: $border-radius;\n            i {\n                font-weight: $font-weight-semibold;\n            }\n        }\n        &.active {\n            .page-link {\n                border: 0;\n                border-radius: $border-radius;\n                background-color: $primary;\n                color: $white;\n            }\n            &:hover {\n                .page-link {\n                    background-color: $primary;\n                }\n            }\n        }\n        &:hover {\n            .page-link {\n                background-color: transparent;\n            }\n        }\n    }\n}","h1,\nh2,\nh3,\nh4,\nh5,\nh6,\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6 {\n  color: $title-color;\n  font-family: $font-family-primary;\n  font-weight: $font-weight-bold;\n  margin-bottom: 0;\n}\nh1,\n.h1 {\n  font-size: 2rem;\n}\n\nh2,\n.h2 {\n  font-size: 1.75rem;\n}\nh3,\n.h3 {\n  font-size: 1.5rem;\n}\nh4,\n.h4 {\n  font-size: 1.125rem;\n}\nh5,\n.h5 {\n  font-size: 1rem;\n}\nh6,\n.h6 {\n  font-size: 0.875rem;\n}\n.fs-sm {\n  font-size: 0.6875rem; //11px\n}\n.fs-base {\n  font-size: 0.875rem; //14px\n}\n.fs-lg {\n  font-size: 1.125rem; //18px\n}\n\n// (1px-30px are linear, above 30px are step increment of 1)\n.fs-1 {\n  font-size: 0.0625rem; //1px\n}\n.fs-2 {\n  font-size: 0.125rem; //2px\n}\n.fs-3 {\n  font-size: 0.1875rem; //3px\n}\n.fs-4 {\n  font-size: 0.25rem; //4px\n}\n.fs-5 {\n  font-size: 0.3125rem; //5px\n}\n.fs-6 {\n  font-size: 0.375rem; //6px\n}\n.fs-7 {\n  font-size: 0.4375rem; //7px\n}\n.fs-8 {\n  font-size: 0.5rem; //8px\n}\n.fs-9 {\n  font-size: 0.5625rem; //9px\n}\n.fs-10 {\n  font-size: 0.625rem; //10px\n}\n.fs-11 {\n  font-size: 0.6875rem; //11px\n}\n.fs-12 {\n  font-size: 0.75rem; //12px\n}\n.fs-13 {\n  font-size: 0.8125rem; //13px\n}\n.fs-14 {\n  font-size: 0.875rem; //14px\n}\n.fs-15 {\n  font-size: 0.9375rem; //15px\n}\n.fs-16 {\n  font-size: 1rem; //16px\n}\n.fs-17 {\n  font-size: 1.0625rem; //17px\n}\n.fs-18 {\n  font-size: 1.125rem; //18px\n}\n.fs-19 {\n  font-size: 1.1875rem; //19px\n}\n.fs-20 {\n  font-size: 1.25rem; //20px\n}\n.fs-21 {\n  font-size: 1.3125rem; //21px\n}\n.fs-22 {\n  font-size: 1.375rem; //22px\n}\n.fs-23 {\n  font-size: 1.4375rem; //23px\n}\n.fs-24 {\n  font-size: 1.5rem; //24px\n}\n.fs-25 {\n  font-size: 1.5625rem; //25px\n}\n.fs-26 {\n  font-size: 1.625rem; //26px\n}\n.fs-27 {\n  font-size: 1.6875rem; //27px\n}\n.fs-28 {\n  font-size: 1.75rem; //28px\n}\n.fs-29 {\n  font-size: 1.8125rem; //29px\n}\n.fs-30 {\n  font-size: 1.875rem; //30px\n}\n.fs-32 {\n  font-size: 2rem; //32px\n}\n.fs-34 {\n  font-size: 2.125rem; //34px\n}\n.fs-36 {\n  font-size: 2.25rem; //36px\n}\n.fs-38 {\n  font-size: 2.375rem; //38px\n}\n.fs-40 {\n  font-size: 2.5rem; //40px\n}\n\n.text-default {\n  color: $text-color !important;\n}\n.text-muted {\n  color: $text-muted !important;\n}\n.text-primary {\n  color: $primary !important;\n  opacity: 1;\n  &.text-opacity-75 {\n    color: rgba($primary, 0.75) !important;\n  }\n  &.text-opacity-25 {\n    color: rgba($primary, 0.25) !important;\n  }\n  &.text-opacity-50 {\n    color: rgba($primary, 0.50) !important;\n  }\n}\n.text-secondary {\n  color: $secondary !important;\n  opacity: 1;\n}\n.text-info {\n  color: $info !important;\n  opacity: 1;\n}\n.text-success {\n  color: $success !important;\n  opacity: 1;\n}\n.text-warning {\n  color: $warning !important;\n  opacity: 1;\n}\n.text-danger {\n  color: $danger !important;\n  opacity: 1;\n}\n.text-blue {\n  color: $blue !important;\n}\n.text-green {\n  color: $green !important;\n}\n.text-pink {\n  color: $pink !important;\n}\n.text-teal {\n  color: $teal !important;\n}\n.text-orange {\n  color: $orange !important;\n}\n.text-indigo {\n  color: $indigo !important;\n}\n.text-purple {\n  color: $purple !important;\n}\n.text-dark {\n  color: $dark !important;\n}\n.text-light {\n  color: $light !important;\n}\n.text-gray {\n  color: $gray-500 !important;\n}\n.text-black {\n  color: $black !important;\n}\n.text-white {\n  color: $white !important;\n}\n.text-fixed-white {\n  color: $white !important;\n}\n.text-fixed-black {\n  color: $black !important;\n}\n.text-gray-1 {\n  color: $gray-100;\n}\n.text-gray-2 {\n  color: $gray-200;\n}\n.text-gray-3 {\n  color: $gray-300;\n}\n.text-gray-4 {\n  color: $gray-400;\n}\n.text-gray-5 {\n  color: $gray-500;\n}\n.text-gray-6 {\n  color: $gray-600;\n}\n.text-gray-7 {\n  color: $gray-700;\n}\n.text-gray-8 {\n  color: $gray-800;\n}\n.text-gray-9 {\n  color: $gray-900;\n}\n\na {\n  text-decoration: none;\n  color: $text-color;\n\n  &:hover {\n    --bs-text-opacity: 1;\n    opacity: 1;\n    color: $primary;\n  }\n}\n\n.link-primary {\n  color: $primary !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $primary !important;\n  }\n}\n.link-secondary {\n  color: $secondary !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $secondary !important;\n  }\n}\n.link-success {\n  color: $success !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $success !important;\n  }\n}\n.link-danger {\n  color: $danger !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $danger !important;\n  }\n}\n.link-warning {\n  color: $warning !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $warning !important;\n  }\n}\n.link-info {\n  color: $info !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $info !important;\n  }\n}\n.link-light {\n  color: $light !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $light !important;\n  }\n}\n.link-dark {\n  color: $dark !important;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $dark !important;\n  }\n}\nhr {\n  &.text-danger {\n    border-color: $danger !important;\n  }\n}\n\n.blockquote-container {\n  padding: 1.25rem;\n  border-left: 4px solid $default-border;\n  position: relative;\n  &.text-end {\n    border-right: 4px solid $default-border;\n    border-left: 0;\n  }\n}\n.blockquote.custom-blockquote {\n  font-size: 0.85rem;\n  font-weight: $font-weight-semibold;\n  padding: 1rem;\n  border-radius: $border-radius;\n  position: relative;\n  &:before {\n    content: \"\\f10d\";\n    font-family: $font-awesome;\n    z-index: 0;\n    font-size: 2rem;\n    position: absolute;\n    inset-block-start: 0;\n    inset-inline-start: 0.5rem;\n  }\n  &.primary {\n    background-color: rgba($primary, 0.1);\n    border-inline-start: 2px solid $primary;\n    &:before {\n      color: rgba($primary, 0.1);\n    }\n  }\n  &.secondary {\n    background-color: rgba($secondary, 0.1);\n    border-inline-start: 2px solid $secondary;\n    &:before {\n      color: rgba($secondary, 0.1);\n    }\n  }\n  &.info {\n    background-color: rgba($info, 0.1);\n    border-inline-start: 2px solid $info;\n    &:before {\n      color: rgba($info, 0.1);\n    }\n  }\n  &.warning {\n    background-color: rgba($warning, 0.1);\n    border-inline-start: 2px solid $warning;\n    &:before {\n      color: rgba($warning, 0.1);\n    }\n  }\n  &.success {\n    background-color: rgba($success, 0.1);\n    border-inline-start: 2px solid $success;\n    &:before {\n      color: rgba($success, 0.1);\n    }\n  }\n  &.danger {\n    background-color: rgba($danger, 0.1);\n    border-inline-start: 2px solid $danger;\n    &:before {\n      color: rgba($danger, 0.1);\n    }\n  }\n}\n\n[data-theme-mode=\"dark\"] {\n  .shadow-sm {\n    box-shadow: 0 0.125rem 0.25rem rgba(33, 37, 41, 0.3) !important;\n  }\n  .shadow {\n    box-shadow: 0 0.5rem 1rem rgba(33, 37, 41, 0.3) !important;\n  }\n  .shadow-lg {\n    box-shadow: 0 1rem 3rem rgba(33, 37, 41, 0.3) !important;\n  }\n}\n\n@media screen and (min-width: 576px) {\n  .w-sm-auto {\n    width: auto;\n  }\n}\n\n[dir=\"rtl\"] {\n  .text-break {\n    word-wrap: break-word !important;\n    word-break: break-word !important;\n  }\n}\n.transform-none {\n  transform: none !important;\n}\n.w-9 {\n  width: 9px;\n}\n.h-9 {\n  height: 9px;\n}\n.list-circle {\n    list-style: circle;\n    padding-left: 2rem;\n}\n",".alert {\n  padding: 0.625rem 0.85rem;\n  border-radius: $border-radius;\n  font-size: 0.8125rem;\n  &.alert-dismissible {\n    padding: 0.625rem 2.25rem 0.625rem 0.85rem;\n  }\n  i {\n    font-size: $font-size-20;\n  }\n  .btn-close {\n    background-image: none;\n    padding: 0.85rem;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    i {\n      font-size: $font-size-18;\n      line-height: 18px;\n    }\n  }\n  &:last-child {\n    margin-bottom: 0;\n  }\n  .alert-link {\n    font-weight: $font-weight-semibold;\n  }\n}\n[dir=\"rtl\"] {\n  .alert.alert-dismissible {\n    padding: 0.625rem 0.85rem 0.625rem 2.25rem;\n  }\n}\n@mixin custom-close($color) {\n  background-color: $color;\n  color: $white;\n  opacity: 1;\n  border-radius: 50px;\n  box-shadow: $box-shadow;\n  padding: 0.85rem;\n}\n.alert-warning {\n  background-color: rgba($warning, 0.1);\n  color: $warning;\n  border-color: rgba($warning, 0.1);\n  .alert-link {\n    color: $warning;\n  }\n  .btn-close {\n    color: $warning;\n    &.custom-close {\n      @include custom-close($warning);\n    }\n  }\n}\n.alert-primary {\n  background-color: rgba($primary, 0.1);\n  color: $primary;\n  border-color: rgba($primary, 0.1);\n  .alert-link {\n    color: $primary;\n  }\n  .custom-alert-icon {\t\n\tcolor: $primary;\n  }\n  .btn-close {\n    color: $primary;\n    &.custom-close {\n      @include custom-close($primary);\n    }\n  }\n}\n.alert-secondary {\n  background-color: rgba($secondary, 0.1);\n  color: $secondary;\n  border-color: rgba($secondary, 0.1);\n  .alert-link {\n    color: $secondary;\n  }\n  .btn-close {\n    color: $secondary;\n    &.custom-close {\n      @include custom-close($secondary);\n    }\n  }\n}\n.alert-success {\n  background-color: rgba($success, 0.1);\n  color: $success;\n  border-color: rgba($success, 0.1);\n  .alert-link {\n    color: $success;\n  }\n  .btn-close {\n    color: $success;\n    &.custom-close {\n      @include custom-close($success);\n    }\n  }\n}\n.alert-info {\n  background-color: rgba($info, 0.1);\n  color: $info;\n  border-color: rgba($info, 0.1);\n  .alert-link {\n    color: $info;\n  }\n  .btn-close {\n    color: $info;\n    &.custom-close {\n      @include custom-close($info);\n    }\n  }\n}\n.alert-danger {\n  background-color: rgba($danger, 0.1);\n  color: $danger;\n  border-color: rgba($danger, 0.1);\n  .alert-link {\n    color: $danger;\n  }\n  .btn-close {\n    color: $danger;\n    &.custom-close {\n      @include custom-close($danger);\n    }\n  }\n}\n.alert-light {\n  background-color: $light;\n  color: $text-color;\n  border-color: $light;\n  .alert-link {\n    color: $text-color;\n  }\n  .btn-close {\n    color: $text-color;\n    &.custom-close {\n      @include custom-close($light);\n    }\n  }\n}\n.alert-dark {\n  background-color: rgba($dark, 0.1);\n  color: $text-color;\n  border-color: rgba($dark, 0.1);\n  .alert-link {\n    color: $text-color;\n  }\n  .btn-close {\n    color: $white;\n    &.custom-close {\n      @include custom-close($dark);\n    }\n  }\n}\n@mixin alert-solid-color($color) {\n  background-color: $color;\n  color: $white;\n  border-color: $color;\n  .btn-close {\n    color: $white;\n  }\n}\n.alert-solid-primary {\n  @include alert-solid-color($primary);\n}\n.alert-solid-secondary {\n  @include alert-solid-color($secondary);\n}\n.alert-solid-warning {\n  @include alert-solid-color($warning);\n}\n.alert-solid-info {\n  @include alert-solid-color($info);\n}\n.alert-solid-success {\n  @include alert-solid-color($success);\n}\n.alert-solid-danger {\n  @include alert-solid-color($danger);\n}\n.alert-solid-light {\n  background-color: $light;\n  color: $text-color;\n  border-color: $default-border;\n}\n.alert-solid-dark {\n  @include alert-solid-color($dark);\n}\n@mixin outline-alert($color) {\n  background-color: $white;\n  color: $color;\n  border-color: $color;\n  .btn-close {\n    color: $color;\n  }\n}\n.alert-outline-primary {\n  @include outline-alert($primary);\n}\n.alert-outline-secondary {\n  @include outline-alert($secondary);\n}\n.alert-outline-info {\n  @include outline-alert($info);\n}\n.alert-outline-warning {\n  @include outline-alert($warning);\n}\n.alert-outline-success {\n  @include outline-alert($success);\n}\n.alert-outline-danger {\n  @include outline-alert($danger);\n}\n.alert-outline-light {\n  background-color: $white;\n  color: $text-color;\n  border-color: $light;\n}\n.alert-outline-dark {\n  @include outline-alert($dark);\n}\n@mixin custom-alert($color) {\n  border-inline-start: 0.313rem solid $color !important;\n  color: $text-muted;\n  background-color: $white;\n  border: 1px solid $default-border;\n  font-size: 0.813rem;\n  .btn-close {\n    color: $text-color;\n  }\n}\n.alert-primary.custom-alert-icon {\n  @include custom-alert($primary);\n  & > i {\n\tcolor: $primary;\n  }\n}\n.alert-secondary.custom-alert-icon {\n  @include custom-alert($secondary);\n  & > i {\n\tcolor: $secondary;\n  }\n}\n.alert-warning.custom-alert-icon {\n  @include custom-alert($warning);\n  & > i {\n\tcolor: $warning;\n  }\n}\n.alert-danger.custom-alert-icon {\n  @include custom-alert($danger);\n  & > i {\n\tcolor: $danger;\n  }\n}\n.alert-success.custom-alert-icon {\n  @include custom-alert($success);\n}\n.alert-info.custom-alert-icon {\n  @include custom-alert($info);\n}\n.alert-light.custom-alert-icon {\n  @include custom-alert($light);\n}\n.alert-dark.custom-alert-icon {\n  @include custom-alert($dark);\n}\n.custom-alert1 {\n  margin-block-end: 0;\n  background-color: $white;\n  border: 0;\n  padding: 1.25rem;\n  color: $text-color;\n  p {\n    margin-block-end: 2.5rem;\n    color: $text-muted;\n    font-size: 0.8rem;\n  }\n  .custom-alert-icon {\n\tfont-size: $font-size-40;\n    margin-bottom: 0.85rem;\n\ti {\t\t\n\t\tfont-size: $font-size-40;\n\t}\n  }\n  .btn-close {\n    padding: 0;\n    margin-block-end: 1rem;\n  }\n  &.alert-primary {\n    border-block-start: 0.313rem solid $primary;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $primary;\n\t}\n  }\n  &.alert-secondary {\n    border-block-start: 0.313rem solid $secondary;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $secondary;\n\t}\n  }\n  &.alert-warning {\n    border-block-start: 0.313rem solid $warning;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $warning;\n\t}\n  }\n  &.alert-danger {\n    border-block-start: 0.313rem solid $danger;\t\n\t.custom-alert-icon {\t\n\t\tcolor: $danger;\n\t}\n  }\n}\n.alert-img {\n  display: flex;\n  align-items: center;\n  .avatar {\n    border: 1px solid rgba(0, 0, 0, 0.1);\n  }\n}\n@media screen and (max-width: 400px) {\n  .btn-close.custom-close {\n    margin: 9px 9px 9px 0;\n  }\n}\n.op-1-1 {\n    opacity: 1;\n}\n.op-0 {\n    opacity: 0;\n}\n.op-1 {\n    opacity: 0.1;\n}\n.op-2 {\n    opacity: 0.2;\n}\n.op-3 {\n    opacity: 0.3;\n}\n.op-4 {\n    opacity: 0.4;\n}\n.op-5 {\n    opacity: 0.5;\n}\n.op-6 {\n    opacity: 0.6;\n}\n.op-7 {\n    opacity: 0.7;\n}\n.op-8 {\n    opacity: 0.8;\n}\n.op-9 {\n    opacity: 0.9;\n}\n",".custom-popover {\n  --bs-popover-max-width: 12.5rem;\n  --bs-popover-border-color: #{$primary};\n  --bs-popover-header-bg: #{$primary};\n  --bs-popover-header-color: #{$white};\n  --bs-popover-body-padding-x: 1rem;\n  --bs-popover-body-padding-y: 0.5rem;\n}\n.popover {\n  background-color: $white;\n  border: 1px solid $default-border;\n  box-shadow: $box-shadow;\n  font-size: 0.8rem;\n  border-radius: $border-radius;\n  z-index: 999;\n  .popover-header {\n    background-color: $white;\n    border-block-end: 1px solid $default-border;\n  }\n  .popover-body {\n    color: $text-color;\n  }\n  &.only-body {\n    border-radius: 0.3rem;\n  }\n}\n.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n.bs-popover-top > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n.bs-popover-top > .popover-arrow::before {\n  border-top-color: $light;\n}\n.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n.bs-popover-end > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n.bs-popover-end > .popover-arrow::before {\n  border-right-color: $light;\n}\n.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n.bs-popover-start > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n.bs-popover-start > .popover-arrow::before {\n  border-left-color: $light;\n}\n.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n.bs-popover-bottom > .popover-arrow::after,\n.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n.bs-popover-bottom > .popover-arrow::before,\n.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n.bs-popover-bottom .popover-header::before {\n  border-bottom-color: $light;\n}\n\n@mixin pop-header-color($color) {\n  .popover-header {\n    background-color: $color;\n    color: $white;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before {\n    border-bottom-color: $color;\n  }\n}\n.header-primary {\n  @include pop-header-color($primary);\n}\n.header-secondary {\n  @include pop-header-color($secondary);\n}\n.header-warning {\n  @include pop-header-color($warning);\n}\n.header-info {\n  @include pop-header-color($info);\n}\n.header-success {\n  @include pop-header-color($success);\n}\n.header-danger {\n  @include pop-header-color($danger);\n}\n@mixin pop-bgcolor($color) {\n  &.popover {\n      border: 1px solid $color;\n    .popover-header {\n      background-color: $color;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.1);\n      color: $white;\n      border-radius: 0.3rem 0.3rem 0 0;\n    }\n    .popover-body {\n      background-color: $color;\n      color: $white;\n      border-radius: 0 0 0.3rem 0.3rem;\n    }\n  }\n  &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n  &.bs-popover-top > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n  &.bs-popover-top > .popover-arrow::before {\n    border-top-color: $color;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n  &.bs-popover-end > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n  &.bs-popover-end > .popover-arrow::before {\n    border-right-color: $color;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n  &.bs-popover-start > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n  &.bs-popover-start > .popover-arrow::before {\n    border-left-color: $color;\n  }\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n  &.bs-popover-bottom > .popover-arrow::after,\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n  &.bs-popover-bottom > .popover-arrow::before,\n  &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n  &.bs-popover-bottom .popover-header::before {\n    border-bottom-color: $color;\n  }\n}\n.popover-primary {\n  @include pop-bgcolor($primary);\n}\n.popover-secondary {\n  @include pop-bgcolor($secondary);\n}\n.popover-warning {\n  @include pop-bgcolor($warning);\n}\n.popover-info {\n  @include pop-bgcolor($info);\n}\n.popover-success {\n  @include pop-bgcolor($success);\n}\n.popover-danger {\n  @include pop-bgcolor($danger);\n}\n.popover-purple {\n  @include pop-bgcolor($purple);\n}\n.popover-teal {\n  @include pop-bgcolor($teal);\n}\n\n.popover-primary-light {\n    &.popover {\n        border: 1px solid rgba($primary, 0.1);\n      .popover-header {\n        background-color: rgba($primary, 0.1);\n        border-block-end: 1px solid rgba($primary, 0.1);\n        color: $primary;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($primary, 0.1);\n        color: $primary;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($primary, 0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($primary, 0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($primary, 0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($primary, 0.1);\n    }\n}\n.popover-secondary-light {\n    &.popover {\n        border: 1px solid rgba($secondary,0.1);\n      .popover-header {\n        background-color: rgba($secondary,0.1);\n        border-block-end: 1px solid rgba($secondary,0.1);\n        color: $secondary;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($secondary,0.1);\n        color: $secondary;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba(var(--secondary-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($secondary,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba(var(--secondary-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba(var(--secondary-rgb),0.1);\n    }\n}\n.popover-warning-light {\n    &.popover {\n        border: 1px solid rgba($warning,0.1);\n      .popover-header {\n        background-color: rgba($warning,0.1);\n        border-block-end: 1px solid rgba($warning,0.1);\n        color: $warning;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($warning,0.1);\n        color: $warning;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($warning,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($warning,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($warning,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($warning,0.1);\n    }\n}\n.popover-info-light {\n    &.popover {\n        border: 1px solid rgba($info,0.1);\n      .popover-header {\n        background-color: rgba($info,0.1);\n        border-block-end: 1px solid rgba($info,0.1);\n        color: $info;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($info,0.1);\n        color: $info;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($info,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($info,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($info,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($info,0.1);\n    }\n}\n.popover-success-light {\n    &.popover {\n        border: 1px solid rgba($success,0.1);\n      .popover-header {\n        background-color: rgba($success,0.1);\n        border-block-end: 1px solid rgba($success,0.1);\n        color: $success;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($success,0.1);\n        color: $success;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($success,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($success,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($success,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($success,0.1);\n    }\n}\n.popover-danger-light {\n    &.popover {\n        border: 1px solid rgba($danger,0.1);\n      .popover-header {\n        background-color: rgba($danger,0.1);\n        border-block-end: 1px solid rgba($danger,0.1);\n        color: $danger;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba($danger,0.1);\n        color: $danger;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba($danger,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba($danger,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba($danger,0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba($danger,0.1);\n    }\n}\n.popover-purple-light {\n    &.popover {\n        border: 1px solid rgba(var(--purple-rgb),0.1);\n      .popover-header {\n        background-color: rgba(var(--purple-rgb),0.1);\n        border-block-end: 1px solid rgba(var(--purple-rgb),0.1);\n        color: $purple;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba(var(--purple-rgb),0.1);\n        color: $purple;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba(var(--purple-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba(var(--purple-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba(var(--purple-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba(var(--purple-rgb),0.1);\n    }\n}\n.popover-teal-light {\n    &.popover {\n        border: 1px solid rgba(var(--teal-rgb),0.1);\n      .popover-header {\n        background-color: rgba(var(--teal-rgb),0.1);\n        border-block-end: 1px solid rgba(var(--teal-rgb),0.1);\n        color: $teal;\n        border-radius: 0;\n      }\n      .popover-body {\n        background-color: rgba(var(--teal-rgb),0.1);\n        color: $teal;\n      }\n    }\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::after,\n    &.bs-popover-top > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"top\"] > .popover-arrow::before,\n    &.bs-popover-top > .popover-arrow::before {\n      border-top-color: rgba(var(--teal-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::after,\n    &.bs-popover-end > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"right\"] > .popover-arrow::before,\n    &.bs-popover-end > .popover-arrow::before {\n      border-right-color: rgba(var(--teal-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::after,\n    &.bs-popover-start > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"left\"] > .popover-arrow::before,\n    &.bs-popover-start > .popover-arrow::before {\n      border-left-color: rgba(var(--teal-rgb),0.1);\n    }\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::after,\n    &.bs-popover-bottom > .popover-arrow::after,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] > .popover-arrow::before,\n    &.bs-popover-bottom > .popover-arrow::before,\n    &.bs-popover-auto[data-popper-placement^=\"bottom\"] .popover-header::before,\n    &.bs-popover-bottom .popover-header::before {\n      border-bottom-color: rgba(var(--teal-rgb),0.1);\n    }\n}\n.timeline {\n    position: relative;\n    list-style: none;\n    max-width: 1200px;\n    @include margin-padding(0 auto, 20px 0 20px);\n    &:before {\n      content: \" \";\n      position: absolute;\n      width: 3px;\n      margin-left: -1.5px;\n      background-color: $gray-300;\n        @include position(absolute,0,null,0,50%);\n    }\n    > li {\n      position: relative;\n      margin-bottom: 20px;\n      &::before, &::after {\n          content: \" \";\n         display: table;\n      }\n      >.timeline-panel {\n          float: left;\n          position: relative;\n          width: 46%;\n          padding: 20px;\n          border: 1px solid $gray-500;\n            @include rounded(0.25rem);\n            @include box-shadow(null, 0, 1px, 6px, null, rgba(0, 0, 0, .05));\n            &::before {\n                content: \" \";\n                display: inline-block;\n                position: absolute;\n                border-top: 8px solid transparent;\n                border-right: 0 solid $gray-500;\n                border-bottom: 8px solid transparent;\n                border-left: 8px solid $gray-500;\n                  @include position(absolute,26px,-8px,null,null);\n              }\n              &::after {\n                  content: \" \";\n                  display: inline-block;\n                    @include position(absolute,27px,-7px,null,null);\n                  border-top: 7px solid transparent;\n                  border-right: 0 solid $white;\n                  border-bottom: 7px solid transparent;\n                  border-left: 7px solid $white;\n                }\n        }\n    }\n}\n.timeline > li:after {\n  clear: both; \n}\n.timeline>li>.timeline-badge {\n  z-index: 1;\n  width: 50px;\n  height: 50px;\n  margin-left: -25px;\n  text-align: center;\n  font-size: 1.4em;\n  line-height: 50px;\n  color: $white;\n  overflow: hidden;\n    @include rounded(50%);\n    @include position(absolute,16px,null,null,50%);\n}\n.timeline>li.timeline-inverted>.timeline-panel {\n  float: right;\n  &::before {\n      right: auto;\n      left: -8px;\n      border-right-width: 8px;\n      border-left-width: 0;\n    }\n    &::after {\n        right: auto;\n        left: -7px;\n        border-right-width: 7px;\n        border-left-width: 0;\n      }\n}\n.timeline-badge.primary {\n  background-color: $primary;\n}\n.timeline-badge.success {\n  background-color: $success;\n}\n.timeline-badge.warning {\n  background-color: $warning; \n}\n.timeline-badge.danger {\n  background-color: $danger; \n}\n.timeline-badge.info {\n  background-color: $info; \n}\n.timeline-title {\n  margin-top: 0;\n  color: inherit;\n  font-weight: regular; \n}\n.timeline-body > p,\n.timeline-body > ul {\n  margin-bottom: 0; \n}\n.timeline-body > p + p {\n  margin-top: 5px; \n}\n",".form-control {\n  border-color: $input-border;\n  color: $text-color;\n  background-color: $form-control-bg;\n  font-size: 0.875rem;\n  font-weight: $font-weight-normal;\n  line-height: 1.6;\n  border-radius: 0.35rem;\n  padding: 0.5rem 0.85rem;\n\n  &:focus {\n    box-shadow: none;\n    border-color: $input-border;\n    background-color: $white;\n    box-shadow: 0 0.0625rem 0.125rem 0 rgba(0, 0, 0, 0.05);\n    color: $text-color;\n  }\n}\n.form-control[type=\"file\"] {\n  padding: 0.3rem 0.5rem;\n  &.form-control-sm {\n    padding: 0.25rem 0.5rem !important;\n  }\n  &.form-control-lg {\n    padding: 0.5rem 1rem !important;\n  }\n}\n.form-label {\n  font-size: $font-size-14;\n  font-weight: $font-weight-semibold;\n  color: $text-color;\n  margin-bottom: 8px;\n}\n\n.form-text {\n  color: $text-muted;\n}\n\n.form-control-light {\n  background-color: $light;\n  border: 0;\n\n  &:focus {\n    background-color: $light;\n  }\n}\n.form-control-primary {\n  background-color: rgba($primary, 0.1);\n  border: 0;\n  color: $primary;\n\n  &:focus {\n    background-color: rgba($primary, 0.1);\n    color: $primary;\n  }\n}\n.form-input-color {\n  height: 2.25rem;\n  width: 2.25rem;\n  border-radius: $border-radius;\n  overflow: hidden;\n  padding: 0;\n}\n.form-floating > .form-control-plaintext ~ label,\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-select ~ label {\n  color: $text-muted;\n}\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after {\n  background-color: transparent;\n}\n.form-select {\n  background-color: $form-control-bg;\n  border: 1px solid $input-border;\n  color: $text-color;\n  font-size: $font-size-base;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='M6 8l4 4 4-4'/%3e%3c/svg%3e\");\n  background-size: 1.25rem;\n  line-height: 2;\n  option {\n    background-color: $white;\n    padding: 0.35rem 0.75rem;\n    border-radius: 0.25rem;\n    margin-block-end: 0.25rem;\n    &:last-child {\n      margin-block-end: 0;\n    }\n  }\n  option:checked {\n    background-color: rgba(var($primary), 0.2);\n    color: $primary;\n  }\n  option:select {\n    background-color: rgba(var($primary), 0.2);\n    color: $primary;\n  }\n  option:hover {\n    background-color: rgba(var($primary), 0.2);\n    color: $primary;\n  }\n  option:focus {\n    background-color: rgba(var($primary), 0.2);\n    color: $primary;\n  }\n}\n.form-check-input {\n  width: 0.9rem;\n  height: 0.9rem;\n  background-color: $white;\n  border: 1px solid $input-border;\n  &:checked {\n    background-color: $primary;\n    border-color: $primary;\n  }\n  &.form-checked-outline {\n    &:checked {\n      background-color: transparent;\n      border-color: $primary;\n    }\n  }\n  &.form-checked-secondary {\n    &:checked {\n      background-color: $secondary;\n      border-color: $secondary;\n    }\n  }\n  &.form-checked-warning {\n    &:checked {\n      background-color: $warning;\n      border-color: $warning;\n    }\n  }\n  &.form-checked-info {\n    &:checked {\n      background-color: $info;\n      border-color: $info;\n    }\n  }\n  &.form-checked-success {\n    &:checked {\n      background-color: $success;\n      border-color: $success;\n    }\n  }\n  &.form-checked-danger {\n    &:checked {\n      background-color: $danger;\n      border-color: $danger;\n    }\n  }\n  &.form-checked-light {\n    &:checked {\n      background-color: $light;\n      border-color: $light;\n    }\n  }\n  &.form-checked-dark {\n    &:checked {\n      background-color: $dark;\n      border-color: $dark;\n    }\n  }\n  &:focus {\n    box-shadow: none;\n  }\n}\n.form-checked-outline:checked[type=\"checkbox\"] {\n  background-image: none;\n  position: relative;\n  background-color: transparent;\n\n  &:before {\n    content: \"\\F633\";\n    font-family: bootstrap-icons !important;\n    position: absolute;\n    color: $primary;\n    width: 0.625rem;\n    height: 0.625rem;\n    inset-block-start: -1px;\n    inset-inline-start: 0px;\n    font-size: 0.688rem;\n  }\n\n  &.form-checked-secondary {\n    &:before {\n      color: $secondary;\n    }\n  }\n\n  &.form-checked-warning {\n    &:before {\n      color: $warning;\n    }\n  }\n\n  &.form-checked-info {\n    &:before {\n      color: $info;\n    }\n  }\n\n  &.form-checked-success {\n    &:before {\n      color: $success;\n    }\n  }\n\n  &.form-checked-danger {\n    &:before {\n      color: $danger;\n    }\n  }\n\n  &.form-checked-light {\n    &:before {\n      color: $light;\n    }\n  }\n\n  &.form-checked-dark {\n    &:before {\n      color: $dark;\n    }\n  }\n}\n.form-checked-outline:checked[type=\"radio\"] {\n  background-image: none;\n  position: relative;\n  background-color: transparent;\n\n  &:before {\n    content: \"\\F309\";\n    font-family: bootstrap-icons !important;\n    position: absolute;\n    color: $primary;\n    width: 0.625rem;\n    height: 0.625rem;\n    inset-block-start: -1.13rem;\n    inset-inline-start: -0.6rem;\n    font-size: 2rem;\n  }\n\n  &.form-checked-secondary {\n    &:before {\n      color: $secondary;\n    }\n  }\n\n  &.form-checked-warning {\n    &:before {\n      color: $warning;\n    }\n  }\n\n  &.form-checked-info {\n    &:before {\n      color: $info;\n    }\n  }\n\n  &.form-checked-success {\n    &:before {\n      color: $success;\n    }\n  }\n\n  &.form-checked-danger {\n    &:before {\n      color: $danger;\n    }\n  }\n\n  &.form-checked-light {\n    &:before {\n      color: $light;\n    }\n  }\n\n  &.form-checked-dark {\n    &:before {\n      color: $dark;\n    }\n  }\n}\nfieldset:disabled .btn {\n  color: $white;\n  background-color: $primary;\n  border-color: $primary;\n}\n.form-select:focus {\n  border-color: rgba(var($primary), 0.5);\n  outline: 0;\n  box-shadow: none;\n}\n.btn-check:focus + .btn,\n.btn:focus {\n  background-color: none;\n  border-color: none;\n  outline: 0;\n}\n.btn-check:active + .btn:focus,\n.btn-check:checked + .btn:focus,\n.btn.active:focus,\n.btn.show:focus,\n.btn:active:focus {\n  box-shadow: none;\n}\n.form-control,\n.form-select {\n  &:disabled {\n    background-color: $light;\n    color: $text-color;\n  }\n}\n.form-control-plaintext {\n  color: $text-color;\n}\n.form-control::-webkit-file-upload-button {\n  color: $text-color;\n  background-color: $default-background;\n}\n.form-control:hover:not(:disabled):not([readonly])::-webkit-file-upload-button {\n  background-color: $default-background;\n}\n.form-control {\n  &:focus {\n    &::-webkit-input-placeholder,\n    &::placeholder {\n      padding-inline-start: 0.3rem;\n      transition: padding-inline-start 0.1s ease-in;\n    }\n  }\n  &::-webkit-input-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.7;\n    color: $text-color;\n    padding-inline-start: 0px;\n    transition: padding-inline-start 0.1s ease-in;\n  }\n  &:-moz-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.4;\n    color: $text-color;\n  }\n  &::-moz-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.4;\n    color: $text-color;\n  }\n  &:-ms-input-placeholder {\n    font-size: 0.8rem;\n    font-weight: $font-weight-medium;\n    opacity: 0.4;\n    color: $text-color;\n  }\n}\n.form-control-sm {\n  font-size: 0.8rem;\n  padding: 0.25rem 0.8rem;\n}\n.form-control-lg {\n  font-size: 1rem;\n  padding: 0.5rem 1rem;\n}\n\n.form-check-md {\n  .form-check-input {\n    width: 1.15rem;\n    height: 1.15rem;\n  }\n\n  &.form-switch {\n    .form-check-input {\n      width: 2.25rem;\n    }\n  }\n\n  label {\n    margin-inline-start: 0.5rem;\n    font-size: 0.95rem;\n    margin-block-start: 3px;\n  }\n}\n\n.form-check-lg {\n  .form-check-input {\n    width: 1.35rem;\n    height: 1.35rem;\n  }\n\n  &.form-switch {\n    .form-check-input {\n      width: 2.5rem;\n    }\n  }\n\n  label {\n    margin-inline-start: 0.5rem;\n    font-size: 1rem;\n    margin-block-start: 3px;\n  }\n}\n.toggle {\n  width: 3.75rem;\n  height: 1.563rem;\n  background-color: $light;\n  margin-inline-start: 0.625rem;\n  margin-block-end: 0.313rem;\n  padding: 0.125rem;\n  border-radius: 0.188rem;\n  position: relative;\n  overflow: hidden;\n  transition: all 0.2s ease;\n\n  span {\n    position: absolute;\n    inset-block-start: 0.188rem;\n    inset-block-end: 0.25rem;\n    inset-inline-start: 0.188rem;\n    display: block;\n    width: 1.25rem;\n    border-radius: 0.125rem;\n    background-color: $white;\n    box-shadow: 0 0.125rem 0.125rem 0 rgba(0, 0, 0, 0.45);\n    cursor: pointer;\n    transition: all 0.2s ease;\n\n    &::before {\n      content: \"on\";\n      inset-inline-start: -1.563rem;\n    }\n\n    &::after {\n      content: \"off\";\n      inset-inline-end: -1.813rem;\n      color: $text-muted;\n    }\n\n    &::before,\n    &::after {\n      position: absolute;\n      font-size: 0.625rem;\n      font-weight: $font-weight-medium;\n      letter-spacing: 0.5px;\n      text-transform: uppercase;\n      inset-block-start: 0.188rem;\n      line-height: 1.38;\n      transition: all 0.2s ease;\n    }\n  }\n\n  &.on {\n    background-color: rgba(var($primary), 0.3);\n\n    span {\n      background-color: $primary;\n\n      &::before {\n        color: $primary;\n      }\n    }\n\n    &.toggle-secondary {\n      background-color: rgba($secondary, 0.4);\n\n      span {\n        background-color: $secondary;\n\n        &::before {\n          color: $secondary;\n        }\n      }\n    }\n\n    &.toggle-warning {\n      background-color: rgba($warning, 0.4);\n\n      span {\n        background-color: $warning;\n\n        &::before {\n          color: $warning;\n        }\n      }\n    }\n\n    &.toggle-info {\n      background-color: rgba($info, 0.4);\n\n      span {\n        background-color: $info;\n\n        &::before {\n          color: $info;\n        }\n      }\n    }\n\n    &.toggle-success {\n      background-color: rgba($success, 0.4);\n\n      span {\n        background-color: $success;\n\n        &::before {\n          color: $success;\n        }\n      }\n    }\n\n    &.toggle-danger {\n      background-color: rgba($danger, 0.4);\n\n      span {\n        background-color: $danger;\n\n        &::before {\n          color: $danger;\n        }\n      }\n    }\n\n    &.toggle-light {\n      background-color: rgba($light, 0.4);\n\n      span {\n        background-color: $light;\n\n        &::before,\n        &::after {\n          color: $text-muted;\n        }\n      }\n    }\n\n    &.toggle-dark {\n      background-color: rgba($dark, 0.4);\n\n      span {\n        background-color: $dark;\n\n        &::before {\n          color: $white;\n        }\n      }\n    }\n\n    span {\n      inset-inline-start: 2.313rem;\n    }\n\n    &.toggle-sm span {\n      inset-inline-start: 2.313rem;\n\n      &::before {\n        inset-block-start: -1px;\n        inset-inline-start: -1.563rem;\n      }\n    }\n\n    &.toggle-lg span {\n      inset-inline-start: 2.563rem;\n\n      &::before {\n        inset-block-start: 0.5rem;\n        inset-inline-start: -1.75rem;\n      }\n    }\n  }\n\n  &.toggle-sm {\n    height: 1.063rem;\n    width: 3.125rem;\n\n    span {\n      width: 0.625rem;\n      height: 0.625rem;\n\n      &::after {\n        inset-inline-end: -1.875rem;\n        inset-block-start: -1px;\n      }\n    }\n  }\n\n  &.toggle-lg {\n    height: 2.125rem;\n    width: 4.5rem;\n\n    span {\n      width: 1.75rem;\n\n      &::after {\n        inset-block-start: 0.5rem;\n        inset-inline-end: -1.938rem;\n      }\n    }\n  }\n}\n.custom-toggle-switch > input[type=\"checkbox\"] {\n  display: none;\n}\n.custom-toggle-switch > label {\n  cursor: pointer;\n  height: 0;\n  position: relative;\n  width: 2.5rem;\n}\n\n.label-primary {\n  background: $primary;\n  color: $white;\n}\n\n.label-secondary {\n  background: $secondary;\n  color: $white;\n}\n\n.label-warning {\n  background: $warning;\n  color: $white;\n}\n\n.label-info {\n  background: $info;\n  color: $white;\n}\n\n.label-success {\n  background: $success;\n  color: $white;\n}\n\n.label-danger {\n  background: $danger;\n  color: $white;\n}\n\n.label-light {\n  background: $light;\n  color: $white;\n}\n\n.label-dark {\n  background: $dark;\n  color: $white;\n}\n\n.custom-toggle-switch > input[type=\"checkbox\"]:checked + label::before {\n  background: inherit;\n  opacity: 0.5;\n}\n.custom-toggle-switch > label {\n  &::before {\n    background: $text-muted;\n    box-shadow: inset 0px 0px 0.625rem rgba(255,255,255, 0.5);\n    border-radius: 0.5rem;\n    content: \"\";\n    height: 1rem;\n    margin-block-start: -0.5rem;\n    position: absolute;\n    opacity: 0.3;\n    transition: all 0.4s ease-in-out;\n    width: 2.5rem;\n  }\n\n  &::after {\n    background: $white;\n    border-radius: 1rem;\n    box-shadow: 0 0 0.313rem rgba(228, 229, 237, 0.8);\n    content: \"\";\n    height: 1.5rem;\n    inset-inline-start: -0.25rem;\n    margin-block-start: -0.5rem;\n    position: absolute;\n    inset-block-start: -0.25rem;\n    transition: all 0.3s ease-in-out;\n    width: 1.5rem;\n  }\n}\n.custom-toggle-switch > input[type=\"checkbox\"]:checked + label::after {\n  background: inherit;\n  inset-inline-start: 50%;\n}\n\n.custom-toggle-switch.toggle-sm > label::before {\n  height: 10px;\n  width: 27px;\n  border-radius: 10px;\n}\n\n.custom-toggle-switch.toggle-sm input[type=\"checkbox\"]:checked + label::after {\n  inset-inline-start: 13px;\n}\n\n.custom-toggle-switch.toggle-sm > label::after {\n  height: 17px;\n  width: 17px;\n  border-radius: 50%;\n}\n\n.custom-toggle-switch.toggle-lg > label::before {\n  height: 27px;\n  width: 55px;\n  border-radius: 20px;\n}\n\n.custom-toggle-switch.toggle-lg input[type=\"checkbox\"]:checked + label::after {\n  inset-inline-start: 77%;\n}\n\n.custom-toggle-switch.toggle-lg > label::after {\n  height: 35px;\n  width: 35px;\n  margin-block-start: -8px;\n  border-radius: 50%;\n}\n.form-floating > {\n  .form-control-plaintext,\n  .form-control {\n    &::placeholder {\n      color: transparent !important;\n    }\n  }\n}\n.form-floating > .form-control,\n.form-floating > .form-control-plaintext,\n.form-floating > .form-select {\n  height: calc(3.5rem - 4px);\n}\n.form-floating {\n  &.floating-primary {\n    label {\n      color: $primary;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $primary;\n    }\n    & > .form-control:focus ~ label {\n      color: $primary !important;\n    }\n  }\n\n  &.floating-secondary {\n    label {\n      color: $secondary;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $secondary;\n    }\n    & > .form-control:focus ~ label {\n      color: $secondary !important;\n    }\n  }\n\n  &.floating-warning {\n    label {\n      color: $warning;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $warning;\n    }\n    & > .form-control:focus ~ label {\n      color: $warning !important;\n    }\n  }\n\n  &.floating-info {\n    label {\n      color: $info;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $info;\n    }\n    & > .form-control:focus ~ label {\n      color: $info !important;\n    }\n  }\n\n  &.floating-success {\n    label {\n      color: $success;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $success;\n    }\n    & > .form-control:focus ~ label {\n      color: $success !important;\n    }\n  }\n\n  &.floating-danger {\n    label {\n      color: $danger;\n      opacity: 1;\n    }\n\n    input {\n      border: 1px solid $danger;\n    }\n    & > .form-control:focus ~ label {\n      color: $danger !important;\n    }\n  }\n}\n.form-floating > .form-control-plaintext ~ label::after,\n.form-floating > .form-control:focus ~ label::after,\n.form-floating > .form-control:not(:placeholder-shown) ~ label::after,\n.form-floating > .form-select ~ label::after {\n  background-color: $white;\n  border-radius: $border-radius;\n}\n.form-wizard-1 {\n  border-bottom: 0;\n  border-radius: 50px;\n\n  .nav-link {\n    border: 0;\n  }\n\n  &.nav-tabs {\n    .nav-item {\n      margin-inline-end: 1rem;\n      position: relative;\n    }\n\n    .nav-link {\n      padding: 0.25rem 0.4rem;\n      color: $text-muted;\n      display: flex;\n      align-items: center;\n      border-radius: 50px;\n      border: 2px solid transparent;\n\n      i {\n        font-size: 12px;\n        padding: 4px;\n        line-height: 1;\n        border-radius: 50px;\n        border: 2px solid $default-border;\n      }\n\n      &:focus,\n      &:hover {\n        border: 2px solid transparent;\n      }\n\n      &.active {\n        border: 2px solid $primary;\n        border-radius: 50px;\n        color: $primary;\n        background-color: transparent;\n\n        i {\n          border: 2px solid $primary;\n        }\n      }\n    }\n  }\n\n  .nav-item:focus-visible {\n    outline: none;\n  }\n}\n.form-control.is-valid:focus,\n.was-validated .form-control:valid:focus {\n  border-color: $success;\n  box-shadow: none;\n}\n.form-control.is-valid,\n.was-validated .form-control:valid {\n  border-color: $success;\n}\n.form-control-color {\n  width: 1.75rem;\n  height: 1.75rem;\n  overflow: hidden;\n  padding: 0;\n}\n.example-picker {\n  .pcr-button {\n    border-radius: 0.35rem !important;\n    overflow: hidden;\n  }\n}\n[dir=\"rtl\"] {\n  [type=\"email\"],\n  [type=\"number\"],\n  [type=\"tel\"],\n  [type=\"url\"] {\n    direction: rtl;\n  }\n}\n.form-select.is-invalid:not([multiple]):not([size]) {\n  padding-right: 1.125rem;\n  background-size: 16px 28px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);\n}\n.invoice-quantity-container\n  .input-group\n  > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(\n    .valid-feedback\n  ):not(.invalid-tooltip):not(.invalid-feedback) {\n  margin-left: 0;\n}\ninput[type=\"range\"]::-webkit-slider-runnable-track {\n  background-color: $light;\n}\n[dir=\"rtl\"] {\n  .form-checked-outline:checked[type=\"checkbox\"]:before {\n    inset-inline-start: 1px;\n  }\n}\n.form-check {\n  min-height: inherit !important;\n}\n.col-form-label-lg,\n.col-form-label-sm,\n.col-form-label {\n  font-weight: $font-weight-semibold;\n}\n#exampleColorInput::-webkit-color-swatch-wrapper {\n  direction: rtl; \n}\n[data-theme-mode=\"dark\"] {\n  input {\n    &[type=\"week\"],\n    &[type=\"month\"],\n    &[type=\"date\"],\n    &[type=\"datetime-local\"],\n    &[type=\"time\"] {\n      &::-webkit-calendar-picker-indicator {\n        filter: invert(1);\n      }\n    }\n  }\n}\n[dir=\"rtl\"] {\n  input {\n    &[type=\"week\"],\n    &[type=\"month\"],\n    &[type=\"date\"],\n    &[type=\"datetime-local\"],\n    &[type=\"time\"] {\n      text-align: end;\n    }\n  }\n}\n","@mixin tablecolor($color-bg) {\n  background-color: $white;\n  color: $black;\n  --bs-table-color-state: $black;\n  border-color: var(--bs-table-border-color);\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\n  --bs-table-border-color: rgba(#{$color-bg}, 0.05);\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.2);\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.2);\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.2);\n  &.table-striped > tbody > tr:nth-of-type(odd) > * {\n    background-color: var(--bs-table-accent-bg);\n    --bs-table-accent-bg: rgba(#{$color-bg}, 0.2);\n    color: $black;\n  }\n  &.table.table-hover > tbody > tr:hover > * {\n    background-color: var(--bs-table-accent-bg);\n    --bs-table-accent-bg: rgba(#{$color-bg}, 0.4);\n    color: $white;\n  }\n  .table-active {\n    background-color: var(--bs-table-accent-bg);\n    --bs-table-accent-bg: rgb(#{$color-bg});\n    color: $white;\n  }\n}\ncaption {\n  color: $text-muted;\n}\n.table-active{\n  --bs-table-color-state: var(--default-text-color);\n}\n@mixin tablehead($color-bg) {\n  background-color: $white;\n  color: var(--bs-table-color);\n  --bs-table-color-state: #000;\n  --bs-table-color: #{$black};\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\n  --bs-table-border-color: rgba(#{$color-bg}, 0.1);\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.5);\n  --bs-table-striped-color: #{$black};\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.5);\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.5);\n  color: var(--bs-table-color);\n  border-color: var(--bs-table-border-color);\n}\n@mixin table-color($color-bg) {\n  --bs-table-color: #{$black};\n  --bs-table-color-state: $black;\n  --bs-table-bg: rgba(#{$color-bg}, 0.1);\n  --bs-table-border-color: rgba(#{$color-bg}, 0.1);\n  --bs-table-striped-bg: rgba(#{$color-bg}, 0.3);\n  --bs-table-striped-color: #{$black};\n  --bs-table-active-bg: rgba(#{$color-bg}, 0.3);\n  --bs-table-active-color: #{$black};\n  --bs-table-hover-bg: rgba(#{$color-bg}, 0.3);\n  --bs-table-hover-color: #{$black};\n  color: #{$black};\n  border-color: rgba(#{$color-bg}, 0.1);\n  background-color: #{$white};\n}\n.table {\n  color: $text-color;\n  border-color: $default-border;\n  margin-block-end: 0;\n  .checkboxs {\n    margin-bottom: 15px;\n  }\n  tbody {\n    tr {\n      th {\n        font-weight: $font-weight-medium;\n      }\n    }\n  }\n  th,\n  td {\n    padding: 0.75rem;\n    vertical-align: middle;\n    line-height: 1.462;\n    font-size: 0.813rem;\n    white-space: nowrap;\n  }\n  thead tr th {\n    font-weight: $font-weight-semibold;\n    font-size: 15px;\n  }\n  &.table-sm > :not(caption) > * > * {\n    padding: 0.3rem;\n  }\n  &.table-dark {\n    color: $white-7;\n    border-color: rgba($white, 0.1);\n  }\n  .thead-primary th {\n      background-color: $primary;\n      color: $white;\n  }\n  .thead-secondary th {\n      background-color: $secondary;\n      color: $white;\n  }\n  .thead-info th {\n      background-color: $info;\n      color: $white;\n  }\n  .thead-warning th {\n      background-color: $warning;\n      color: $white;\n  }\n  .thead-danger th {\n      background-color: $danger;\n      color: $white;\n  }\n  .thead-success th {\n      background-color: $success;\n      color: $white;\n  }\n  .thead-dark th {\n      background-color: $dark;\n      color: $white;\n  }\n  .thead-light th {\n      background-color: $light;\n      color: $dark;\n  }\n  &.table-primary {\n    @include tablecolor(var(--primary-rgb));\n  }\n  &.table-secondary {\n    @include tablecolor(var(--secondary-rgb));\n  }\n  &.table-warning {\n    @include tablecolor(var(--warning-rgb));\n  }\n  &.table-success {\n    @include tablecolor(var(--success-rgb));\n  }\n  &.table-danger {\n    @include tablecolor(var(--danger-rgb));\n  }\n  &.table-info {\n    @include tablecolor(var(--info-rgb));\n  }\n  &.table-light {\n    @include tablecolor(var(--light-rgb));\n  }\n  &.table-dark {\n    @include tablecolor(var(--dark-rgb));\n  }\n  &.table-bordered {\n    &.border-primary {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($primary, 0.1);\n      }\n    }\n    &.border-info {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($info, 0.1);\n      }\n    }\n    &.border-secondary {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($secondary, 0.1);\n      }\n    }\n    &.border-warning {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($warning, 0.1);\n      }\n    }\n    &.border-success {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($success, 0.1);\n      }\n    }\n    &.border-danger {\n      tbody,\n      td,\n      tfoot,\n      th,\n      thead,\n      tr {\n        border-color: rgba($danger, 0.1);\n      }\n    }\n  }\n  &.table-striped > tbody > tr:nth-of-type(odd) > * {\n    --bs-table-accent-bg: rgba(var(--dark-rgb),0.0125);\n    color: $text-color;\n  }\n  &.table-striped-columns > :not(caption) > tr > :nth-child(2n) {\n    --bs-table-accent-bg: rgba(var(--dark-rgb),0.025);\n    color: $text-color;\n  }\n  tbody.table-group-divider {\n    border-top: 1px solid $default-border;\n  }\n  &.table-hover > tbody > tr:hover > * {\n    --bs-table-accent-bg: #{$default-background};\n    color: $text-color;\n  }\n  .table-active {\n    --bs-table-accent-bg: #{$light};\n    color: $text-color;\n  }\n  thead {\n    &.table-primary {\n      @include tablehead(var(--primary-rgb));\n    }\n    &.table-secondary {\n      @include tablehead(var(--secondary-rgb));\n    }\n    &.table-warning {\n      @include tablehead(var(--warning-rgb));\n    }\n    &.table-success {\n      @include tablehead(var(--success-rgb));\n    }\n    &.table-danger {\n      @include tablehead(var(--danger-rgb));\n    }\n    &.table-info {\n      @include tablehead(var(--info-rgb));\n    }\n    &.table-light {\n      @include tablehead(var(--light-rgb));\n    }\n    &.table-dark {\n      @include tablehead(var(--dark-rgb));\n    }\n  }\n}\n.table-primary {\n  @include table-color(var(--primary-rgb));\n}\n.table-secondary {\n  @include table-color(var(--secondary-rgb));\n}\n.table-warning {\n  @include table-color(var(--warning-rgb));\n}\n.table-success {\n  @include table-color(var(--success-rgb));\n}\n.table-info {\n  @include table-color(var(--info-rgb));\n}\n.table-danger {\n  @include table-color(var(--danger-rgb));\n}\n.table-dark {\n  @include table-color(var(--dark-rgb));\n}\n.table-light {\n  @include table-color(var(--light-rgb));\n}\n[data-theme-mode=\"dark\"] {\n  .table-dark {\n    border-color: rgba(0,0,0,0.025);\n  }\n}\n[dir=\"rtl\"] {\n  .table {\n    margin-inline-end: 1px;\n  }\n}\n.table{\n    margin: 0;\n    tbody{\n        tr{\n            td{\n                color: $gray-700;\n                font-size: $font-size-14; \n                .product-img{\n                    img{\n                        border: 0;\n                    }\n                }\n                .userslist-img {\n                    width:35px;\n                    height: 35px;\n                    margin-right: 8px;\n                    img {\n                        border-radius: 0;\n                    }\n                }\n                .userslist-img.bg-img {\n                    img {\n                        border: 1px solid var(--stroke-table, #E8EBED);\n                        background: lightgray 50% / cover no-repeat;\n                    }\n                }\n                a {\n                    color: $secondary;\n                    font-size: $font-size-14;\n                    font-weight: $font-weight-normal;\n                    line-height: normal;\n                    &.product-img{\n                        margin-right: 5px;\n                        flex-shrink: 0;\n                    }\n                    .info-img {\n                        margin-right: 8px;\n                        width: 16px;\n                        height: 16px;\n                    }\n                    &:hover {\n                        color: $primary;\n                        i {\n                            color: $primary;\n                        }\n                    }\n                }\n                .emp-name {\n                    line-height: 1;\n                    a {\n                        color: $secondary;\n                    }\n                    p {\n                        line-height: 2;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-medium;\n                        color: $text-color;\n                    }\n                    .role {\n                        line-height: unset;\n                    }\n                }\n                .product-imgs{\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    width:40px;\n                    height:40px;\n                    background: #FFEBD8;\n                    font-size: $font-size-14;\n                    color: #FF9F43 !important;\n                    font-weight: $font-weight-medium;\n                    margin-right:10px;\n                }\n            }\n            .data-header {\n                font-weight: $font-weight-semibold;\n                color: $secondary;\n                font-size: $font-size-15;\n                border-bottom: none;\n            }\n            .ref-number {\n                color: $purple;\n            }\n            &.active{\n                border-bottom: 0;\n                td{\n                    font-size: $font-size-18;\n                    color: $gray-700;\n                    font-weight: $font-weight-semibold;\n                    border-bottom: 0;\n                }\n            }\n        }\n        .loss-highlight {\n            td {\n                font-weight: $font-weight-bold;\n                color: $secondary;\n                font-size: $font-size-base;\n                border-top: 1px solid $gray-300;\n            }\n        }\n        .userimgname {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            img {\n                margin-right: 8px;\n                border-radius: 6px;\n                \n            }\n        }\n        .purchase-count {\n            td {\n                padding-bottom: 20px;\n            }\n        }\n        \n    }\n    .Expense-list {\n       tr {\n        td {\n            padding: 15px 17px;\n            a {\n                margin-bottom: 0;\n            }\n        }\n       }\n    }\n    .sales-list {\n        tr {\n            td {\n                padding: 20px 17px;\n            }\n        }\n    }\n    .Expense-list-blk {\n        tr {\n            td {\n                padding: 20px 17px;\n            }\n        }\n    }\n        \n    \n}\n.new {\n    tbody {\n        tr {\n            td {\n                border-bottom: none;\n            }\n        }\n    }\n}\n.table-height{\n    min-height: 300px;\n    @include respond-below(custom991) {\n        min-height: auto;\n        margin-bottom: 15px;\n    }\n}\n.max-widthauto{\n    max-width: 100% !important;\n}\n.dataTables_filter {\n    & + .dataTables_filter {\n        display: none;\n    }\n}\n.dataview {\n    .dataTables_length,\n    .dataTables_info,\n    .dataTables_paginate{\n        display: none !important;\n    }\n}\n.dataTables_length label:before {\n    content: \"Showing 10 of 40 Results\";\n    margin-right: 5px;\n}\n.dataTables_length {\n    float: left;\n    font-size: $font-size-12;\n}\n.productimgname {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    a{\n        color: $secondary;\n        font-weight: $font-weight-medium;\n    }\n    .view-product {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        width: 50px;\n        height: 50px;\n        border-radius: 6px;\n        background: #F8F8F8;\n    }\n}\n.input-blocks{\n    .calc-no{\n        width: 50px !important;\n        text-align: center;\n    }\n}\n.table {\n    .input-blocks {\n        input[type=text] {\n            height:40px;\n        }\n    }\n    .scanner-set{\n        width:40px;\n        height:40px;\n    }\n}\n.card.table-list-card {\n    .card-body {\n        padding: 0;\n    }\n    .table-top {\n        padding: 24px 24px 0;\n    }\n    .table-responsive {\n        padding: 24px;\n        border-top: 1px solid $gray-400;\n        .dataTables_wrapper {\n            border: 0;\n            padding: 0;\n        }\n    }\n    .tabs-set {\n        .nav-tabs {\n            padding: 24px 24px 0;\n            margin-bottom: 0;\n        }\n    }\n}\n.table.profit-table {\n    thead {\n        background-color: #FAFBFE;\n        border-radius: 8px 8px 0px 0px;\n        tr {\n            &:hover {\n                background-color: #FAFBFE;\n            }\n        }\n\n    }\n    tbody {\n        td {\n            border-bottom: 0;\n        }\n        .profit-table-bg { \n            td {\n                color: $secondary;\n                font-weight: $font-weight-bold;\n                border-top: 1px solid $gray-100;\n                background-color: #FAFBFE;\n            }\n        }\n        .table-heading {\n            &:hover {\n                background-color: $white;\n            }\n            td {\n                color: $secondary;\n                font-weight: $font-weight-bold;\n            }\n        }\n    }\n} \n.profit-table-top {\n    .daterange-wraper {\n        margin: 0 10px;\n        input {\n            padding-left: 35px;\n        }\n    }\n}\ntable {\n    td {\n        .shield {\n            width: 14px;\n            height: 14px;\n        }\n    }\n}\n.paysilp-table-border {\n    border: 1px solid $gray-100;\n    th {\n        border-right: 1px solid $gray-100;\n        border-left: 1px solid $gray-100;\n        padding: 15px;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-16;\n    }\n}\n.paysilp-table-borders {\n    td {\n        border-right: 1px solid $gray-100;\n        border-left: 1px solid $gray-100;\n        padding: 5px 15px;\n        color: $text-color;\n    }\n}\n.payslip-border-bottom {\n    border: 1px solid $gray-100;\n    th {\n        padding: 5px 15px;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-16;\n    }\n    td {\n        color: $text-color;\n    }\n}\n.emp-details {\n    margin: 20px 0;\n    .pay-slip-salery {\n        h6 {\n            font-weight: $font-weight-bold !important;\n            margin-bottom: 10px;\n            font-size: $font-size-18 !important;\n        }\n    }\n    .emp-name-id.pay-slip-salery {\n        margin-right: 30px;\n    }\n}\n.slip-logo {\n    @include respond-below(custom575) {\n        flex-shrink: 0;\n        margin-right: 15px;\n    }\n}\n.product-name-slip {\n    h4 {\n        color: $primary;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-18;\n    }\n}\n.pay-slip-box {\n    .modal-header {\n        border-radius: 8px 8px 0 0;\n    }\n    .custom-modal-body {\n        padding: 0;\n    }\n    .card {\n        border: 0;\n        border-radius: 0 0 10px 10px;\n        .card-body {\n            padding: 20px;\n            .emp-details.justify-content-start {\n                max-width: 760px;\n                margin: 20px auto 20px;\n            }\n        }\n    }\n}\n",".accordion-button {\n    background-color: $white;\n    color: $text-color;\n    padding: 0.75rem 1rem;\n    font-size: 0.85rem;\n    font-weight: $font-weight-medium;\n    &:not(.collapsed) {\n        color: $text-color;\n        background-color: $default-background;\n        box-shadow: none;\n    }\n    &:focus {\n        border-color: rgba($primary, 0.3);\n        box-shadow: none;\n    }\n    &:after,&:not(.collapsed)::after {\n        background-image: none;\n    }\n    &:after {\n        content: \"\\f078\";\n        font-family: $font-awesome;\n        font-size: $font-size-12;\n        line-height: 1;\n        background-color: $white;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        border-radius: 3.125rem;\n        color: $text-color;\n    }\n}    \n.accordion-body {\n    padding: 0.75rem 1rem;\n    font-size: 0.8125rem;\n    color: $text-muted;\n}\n.accordion-item {\n    color: $text-color;\n    background-color: $white;\n    border: 1px solid $default-border;\n}\n.accordions-items-seperate {\n    .accordion-item:not(:first-of-type) {\n        margin-block-start: 0.5rem;\n    }\n    .accordion-item {\n        border-block-start: 1px solid $default-border;\n        border-radius: $border-radius;\n        overflow: hidden;\n    }\n}\n.accordion-item:last-of-type {\n    border-bottom-right-radius: 0.35rem;\n    border-bottom-left-radius: 0.35rem;\n}\n.accordion-item:first-of-type {\n    border-top-left-radius: 0.35rem;\n    border-top-right-radius: 0.35rem;\n}\n.accordion {\n    &.accordion-primary {\n        .accordion-button {\n            background-color: rgba($primary, 0.1);\n            color: $primary;\n            &:after { \n                background-color: $primary;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-secondary {\n        .accordion-button {\n            background-color: rgba($secondary,0.1);\n            color: $secondary;\n            &:after { \n                background-color: $secondary;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-success {\n        .accordion-button {\n            background-color: rgba($success,0.1);\n            color: $success;\n            &:after { \n                background-color: $success;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-danger {\n        .accordion-button {\n            background-color: rgba($danger,0.1);\n            color: $danger;\n            &:after { \n                background-color: $danger;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-warning {\n        .accordion-button {\n            background-color: rgba($warning,0.1);\n            color: $warning;\n            &:after { \n                background-color: $warning;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-info {\n        .accordion-button {\n            background-color: rgba($info,0.1);\n            color: $info;\n            &:after { \n                background-color: $info;\n                color: $white;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n}\n.accordion {\n    &.accordion-solid-primary {\n        .accordion-button {\n            background-color: $primary;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $primary;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-secondary {\n        .accordion-button {\n            background-color: $secondary;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $secondary;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-success {\n        .accordion-button {\n            background-color: $success;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $success;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-danger {\n        .accordion-button {\n            background-color: $danger;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $danger;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-warning {\n        .accordion-button {\n            background-color: $warning;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $warning;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n    &.accordion-solid-info {\n        .accordion-button {\n            background-color: $info;\n            color: $white;\n            &:after { \n                background-color: $white;\n                color: $info;\n            }\n            &.collapsed {\n                background-color: $white;\n                color: $text-color;\n                &:after { \n                    background-color: $default-background;\n                    color: $text-color;\n                }\n            }\n        }\n    }\n}\n.accordion {\n    &.accordion-border-primary {\n        .accordion-item {\n            border: 1px solid $primary;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $primary;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $primary;\n                border: 1px solid $primary;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $primary;\n            }\n        }\n    }\n    &.accordion-border-secondary {\n        .accordion-item {\n            border: 1px solid $secondary;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $secondary;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $secondary;\n                border: 1px solid $secondary;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $secondary;\n            }\n        }\n    }\n    &.accordion-border-success {\n        .accordion-item {\n            border: 1px solid $success;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $success;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $success;\n                border: 1px solid $success;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $success;\n            }\n        }\n    }\n    &.accordion-border-danger {\n        .accordion-item {\n            border: 1px solid $danger;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $danger;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $danger;\n                border: 1px solid $danger;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $danger;\n            }\n        }\n    }\n    &.accordion-border-warning {\n        .accordion-item {\n            border: 1px solid $warning;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $warning;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $warning;\n                border: 1px solid $warning;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $warning;\n            }\n        }\n    }\n    &.accordion-border-info {\n        .accordion-item {\n            border: 1px solid $info;\n        }\n        .accordion-button {\n            background-color: $white;\n            color: $info;\n            border-block-end: 0px;\n            &:after { \n                background-color: $white;\n                color: $info;\n                border: 1px solid $info;\n            }\n            &:not(.collapsed) {\n                border-block-end: 1px solid $info;\n            }\n        }\n    }\n}\n.accordion {\n    &.accordionicon-none {\n        .accordion-button:after {\n            display: none;\n        }\n    }\n}\n.accordion {\n    &.accordionicon-left {\n        .accordion-button {\n            padding-inline-start: 2.5rem;\n            &:after {\n                position: absolute;\n                inset-inline-start: 0.625rem;\n            }\n        }\n    }\n}\n.accordion {\n    &.accordion-customicon1 {\n        .accordion-button {\n            &:after {\n                content: \"\\2b\";\n                font-family: $font-awesome;\n                background-color: $default-background;\n            }\n            &:not(.collapsed)::after {\n                content: \"\\f068\";\n\t\t\t\tfont-family: $font-awesome;\n                background-color: $white;\n            }\n        }\n    }\n}\n.customized-accordion {\n    .accordion-item{\n        &.custom-accordion-primary {\n            .accordion-button {\n                background-color: rgba($primary, 0.1);\n                border-inline-start: 0.25rem solid rgba($primary, 0.6);\n                &:after {\n                    background-color: rgba($primary, 0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($primary, 0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($primary, 0.6);\n            }\n        }\n        &.custom-accordion-secondary {\n            .accordion-button {\n                background-color: rgba($secondary,0.1);\n                border-inline-start: 0.25rem solid rgba($secondary,0.6);\n                &:after {\n                    background-color: rgba($secondary,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($secondary,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($secondary,0.6);\n            }\n        }\n        &.custom-accordion-warning {\n            .accordion-button {\n                background-color: rgba($warning,0.1);\n                border-inline-start: 0.25rem solid rgba($warning,0.6);\n                &:after {\n                    background-color: rgba($warning,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($warning,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($warning,0.6);\n            }\n        }\n        &.custom-accordion-info {\n            .accordion-button {\n                background-color: rgba($info,0.1);\n                border-inline-start: 0.25rem solid rgba($info,0.6);\n                &:after {\n                    background-color: rgba($info,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($info,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($info,0.6);\n            }\n        }\n        &.custom-accordion-success {\n            .accordion-button {\n                background-color: rgba($success,0.1);\n                border-inline-start: 0.25rem solid rgba($success,0.6);\n                &:after {\n                    background-color: rgba($success,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($success,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($success,0.6);\n            }\n        }\n        &.custom-accordion-danger {\n            .accordion-button {\n                background-color: rgba($danger,0.1);\n                border-inline-start: 0.25rem solid rgba($danger,0.6);\n                &:after {\n                    background-color: rgba($danger,0.6);\n                    color: $white;\n                }\n            }\n            .accordion-body {\n                background-color: rgba($danger,0.1);\n                padding-block-start: 0;\n                border-inline-start: 0.25rem solid rgba($danger,0.6);\n            }\n        }\n    }\n}",".page-header-breadcrumb {\n  .breadcrumb-item+.breadcrumb-item::before {\n    content: var(--bs-breadcrumb-divider, \"\\ea65\");\n    font-family: \"tabler-icons\" !important;\n  }\n}\n[dir=\"rtl\"] {\n  .page-header-breadcrumb {\n    .breadcrumb-item+.breadcrumb-item::before {\n      content: var(--bs-breadcrumb-divider, \"\\ea64\");\n      font-family: \"tabler-icons\" !important;\n    }\n  }\n}\n.breadcrumb {\n  .breadcrumb-item {\n    a {\n      color: $text-muted;\n    }\n\n    &.active {\n      color: $primary;\n    }\n  }\n}\n.breadcrumb-item+.breadcrumb-item::before {\n  color: $text-muted;\n  opacity: 0.4;\n}\n.breadcrumb-arrow {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"\\f101\";\n    font-family: $font-awesome !important;\n  }\n}\n.breadcrumb-pipe {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"\\f061\";\n    font-family: $font-awesome !important;\n  }\n}\n.breadcrumb-line {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"-\";\n  }\n}\n.breadcrumb-dot {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"•\";\n  }\n}\n.breadcrumb-divide {\n  .breadcrumb-item+.breadcrumb-item::before {\n    color: $text-muted;\n    content: \"\\f054\";\n    font-family: $font-awesome !important;\n  }\n}\n.breadcrumb-separatorless {\n  .breadcrumb-item+.breadcrumb-item::before {\n    content: \"\";\n    display: none;\n  }\n}\n.breadcrumb-colored {\n  padding: 12px 15px;\n  border-radius: $border-radius;\n\tli {\n\t\ta {\n\t\t\tcolor: $white;\n\t\t}\n\t}\n\t.breadcrumb-item {\n    a {\n\t\t\tcolor: $white;\n    }\n\t\t&.active {\n\t\t\tcolor: $white;\n\t\t\topacity: 0.8;\n\t\t}\n\t\t& + .breadcrumb-item {\n      a {\n        color: $white;\n      }\n\t\t\t&::before {\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n\t}\n}\n.embedded-breadcrumb:before {\n  opacity: 0.7;\n}\n[data-theme-mode=\"dark\"] {\n  .embedded-breadcrumb:before {\n    filter: invert(1);\n  }\n}",".card {\n    margin-bottom: 1.5rem;\n    background-color: $white;\n    transition: all .5s ease-in-out;\n    position: relative;\n    border-radius: $border-radius;\n    border:1px solid $border-color;\n    box-shadow: none;\n    .card-body {\n        padding: 1.25rem;\n    }\n    .card-title {\n        font-size: $font-size-18;\n        font-weight: $font-weight-bold;\n        text-transform: capitalize;\n    }\n    .card-header {\n        border-color: $border-color;\n        position: relative;\n        background: transparent;\n        padding: 1rem 1.25rem 1rem;\n        .card-title {\n            margin-bottom: 0rem;\n        }\n        .subtitle {\n            padding-top: 0.3125rem;\n            font-size: 0.875rem;\n            line-height: 1.5; \n        }\n    }\n    .card-footer {\n        border-color: $border-color;\n        background: transparent;\n        padding: 1rem 1.25rem 1rem;\n    }    \n}\n.card-group {\n  .card {    \n      margin-bottom: 1.5rem;\n  }\n}\n.card {\n  &.custom-card {\n  border-radius: $border-radius;\n  border: 0;\n  background-color: $white;\n  position: relative;\n  margin-block-end: 1.5rem;\n  width: 100%;\n  .card-header {\n    padding: 1rem 1.25rem;\n    background-color: transparent !important;\n    border-block-end: 1px solid $default-border;\n    display: flex;\n    align-items: center;\n    position: relative;\n    flex-wrap: wrap;\n    gap: 0.25rem;\n    &:first-child {\n      border-radius: 0.625rem 0.625rem 0 0;\n    }\n    .card-title {\n      position: relative;\n      margin-block-end: 0;\n      font-size: 0.9375rem;\n      font-weight: $font-weight-bold;\n      text-transform: capitalize;\n      .subtitle {\n        margin-block-end: 0;\n        text-transform: initial;\n      }\n    }\n  }\n  .card-footer {\n    background-color: transparent !important;\n    border-block-start: 1px solid $default-border;\n    padding: 1rem 1.5rem;\n    font-size: $font-size-base;\n  }\n  .card-body {\n    padding: 1.5rem;\n    color: $text-color;\n  }\n  .card-link {\n    font-size: 0.75rem;\n  }\n  }\n  .card-text {\n    font-size: 0.813rem;\n  }\n  .footer-card-icon {\n    width: 60px;\n    height: 60px;\n  }\n  &.overlay-card {\n    position: relative;\n    overflow: hidden;\n    color: rgba(255, 255, 255, 0.9);\n    .card-header {\n      border-block-end: 1px solid rgba(255, 255, 255, 0.1);\n    }\n    .card-footer {\n      border-block-start: 1px solid rgba(255, 255, 255, 0.1);\n    }\n    .over-content-bottom {\n      top: auto;\n    }\n    &:before {\n      content: \"\";\n      inset-inline-start: 0;\n      inset-inline-end: 0;\n      inset-block-start: 0;\n      inset-block-end: 0;\n      background-color: rgba(0, 0, 0, 0.2);\n      position: absolute;\n    }\n  }\n  &.card-bg-primary {\n    background-color: $primary;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-secondary {\n    background-color: $secondary;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-warning {\n    background-color: $warning;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-info {\n    background-color: $info;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-success {\n    background-color: $success;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-danger {\n    background-color: $danger;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  &.card-bg-light {\n    background-color: $light;\n    color: $text-color;\n    .card-header {\n      background-color: rgba(0, 0, 0, 0.05) !important;\n      color: $text-color;\n      border-block-end: $default-border;\n    }\n    .card-body {\n      color: $text-color;\n    }\n    .card-footer {\n      background-color: rgba(0, 0, 0, 0.05) !important;\n      color: $text-color;\n      border-block-start: $default-border;\n    }\n  }\n  &.card-bg-dark {\n    background-color: $dark;\n    color: $white;\n    .card-header {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-end: 1px solid rgba(255, 255, 255, 0.2);\n      &:before {\n        background-color: $white;\n      }\n    }\n    .card-body {\n      color: $white;\n    }\n    .card-footer {\n      background-color: rgba(255, 255, 255, 0.1) !important;\n      color: $white;\n      border-block-start: 1px solid rgba(255, 255, 255, 0.2);\n    }\n  }\n  .card-anchor {\n    position: absolute;\n    top: 0;\n    inset-inline-end: 0;\n    bottom: 0;\n    inset-inline-start: 0;\n    z-index: 1;\n    pointer-events: auto;\n    content: \"\";\n  }\n  .collapse-close {\n    display: none;\n  }\n  &.card .collapsed {\n    .collapse-close {\n      display: block;\n    }\n    .collapse-open {\n      display: none;\n    }\n  }\n  &.card-fullscreen {\n    position: fixed;\n    top: 0;\n    inset-inline-start: 0;\n    inset-inline-start: 0;\n    bottom: 0;\n    z-index: 9999;\n    margin: 0;\n  }\n}\n.cals-icon {\n    font-size: $font-size-50;\n    color: $gray-500;\n}\n.callout {\n  padding: 1.25rem;\n  margin-block-start: 1.25rem;\n  margin-block-end: 1.25rem;\n  background-color: $light;\n  border-inline-start: 0.25rem solid $default-border;\n}\n.callout-info {\n  background-color: rgba($info, 0.075);\n  border-color: rgba($info, 0.5);\n}\n.callout-warning {\n  background-color: rgba($warning, 0.075);\n  border-color: rgba($warning, 0.5);\n}\n.callout-danger {\n  background-color: rgba($danger, 0.075);\n  border-color: rgba($danger, 0.5);\n}\n.btn-facebook {\n  background-color: $facebook;\n  color: $white;\n  border: 1px solid $facebook;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: $facebook !important;\n    color: $white !important;\n    border: 1px solid $facebook !important;\n  }\n}\n.btn-instagram {\n  background: #f09433;\n  background: -moz-linear-gradient(\n    45deg,\n    #f09433 0%,\n    #e6683c 25%,\n    #dc2743 50%,\n    #cc2366 75%,\n    #bc1888 100%\n  );\n  background: -webkit-linear-gradient(\n    45deg,\n    #f09433 0%,\n    #e6683c 25%,\n    #dc2743 50%,\n    #cc2366 75%,\n    #bc1888 100%\n  );\n  background: linear-gradient(\n    45deg,\n    #f09433 0%,\n    #e6683c 25%,\n    #dc2743 50%,\n    #cc2366 75%,\n    #bc1888 100%\n  );\n  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f09433', endColorstr='#bc1888',GradientType=1 );\n  color: $white;\n  border: 1px solid transparent;\n  &:hover,\n  &:focus,\n  &:active {\n    color: $white;\n    border: 1px solid transparent;\n  }\n}\n.btn-twitter {\n  background-color: $twitter;\n  color: $white;\n  border: 1px solid $twitter;\n  &:hover,\n  &:focus,\n  &:active {\n    background-color: $twitter !important;\n    color: $white !important;\n    border: 1px solid $twitter !important;\n  }\n}\n.btn-icon {\n    width: 2.313rem;\n    height: 2.313rem;\n    font-size: .95rem;\n    flex-shrink: 0;\n}\n.btn-wave {\n    display: inline-block !important;\n}\n\n@media (max-width: 575px) {\n  .overlay-card {\n      .card-text {\n          font-size: .613rem !important;\n      }\n  }\n}\n@media (max-width: 400px) {\n  .overlay-card {\n      .card-text {\n          font-size: .413rem !important;\n      }\n  }\n}",".tooltip {\n  @mixin tooltip-color($color) {\n    .tooltip-inner {\n      background-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"top\"] .tooltip-arrow::before,\n    &.bs-tooltip-top .tooltip-arrow::before {\n      border-top-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"right\"] .tooltip-arrow::before,\n    &.bs-tooltip-end .tooltip-arrow::before {\n      border-right-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"left\"] .tooltip-arrow::before,\n    &.bs-tooltip-start .tooltip-arrow::before {\n      border-left-color: $color;\n    }\n    &.bs-tooltip-auto[data-popper-placement^=\"bottom\"] .tooltip-arrow::before,\n    &.bs-tooltip-end .tooltip-arrow::before {\n      border-bottom-color: $color;\n    }\n  }\n  &.tooltip-primary {\n    @include tooltip-color($primary);\n  }\n  &.tooltip-secondary {\n    @include tooltip-color($secondary);\n  }\n  &.tooltip-warning {\n    @include tooltip-color($warning);\n  }\n  &.tooltip-info {\n    @include tooltip-color($info);\n  }\n  &.tooltip-success {\n    @include tooltip-color($success);\n  }\n  &.tooltip-danger {\n    @include tooltip-color($danger);\n  }\n  &.tooltip-dark {\n    @include tooltip-color($dark);\n    .tooltip-inner {\n      color: $white;\n    }\n  }\n  &.tooltip-light {\n    @include tooltip-color($light);\n    .tooltip-inner {\n      color: $text-color;\n    }\n  }\n}\n",".nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n  }\n  .nav-link {\n    color: $text-color;\n    border-radius: $border-radius;\n    font-weight: $font-weight-semibold;\n    &.active {\n      background-color: rgba($primary,0.1);\n      color: $primary;\n    }\n  }\n  .navbar-brand {\n    color: $text-color;\n    &:focus ,&:hover {\n      color: $text-color;\n      opacity: 0.9;\n    }\n  }\n  .navbar-nav .nav-link.active,\n  .navbar-nav .show > .nav-link {\n    color: $primary;\n  }\n  .nav-link.disabled {\n    color: $text-color;\n    opacity: 0.3;\n  }\n  .nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {\n    color: rgba($dark,0.5);\n  }\n  .navbar-text {\n    color: $text-color;\n  }\n  .navbar-dark {\n    &.bg-dark {\n      .nav-link,\n      .navbar-brand {\n        color: $white;\n      }\n    }\n    .navbar-nav .nav-link.active,\n    .navbar-nav .show > .nav-link {\n      color: $white;\n    }\n  }\n  .nav-pills .nav-link.active,\n  .nav-pills .show > .nav-link {\n    color: $white;\n    background-color: $primary;\n  }\n\n.nav.nav-style-1 {\n  border: 0;\n  .nav-item {\n    margin-inline-end: 0.25rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n  }\n  .nav-link {\n    &.active {\n        background-color: rgba($primary, 0.1);\n        color: $primary;\n        &:hover {        \n          background: rgba($primary, 0.1);\n        }\n    }\n    &:hover {        \n        background: transparent;\n        color: $primary;\n    }\n  }\n}\n.nav.nav-style-2 {\n  .nav-item .nav-link {\n    border-block-start: 3px solid transparent;\n    &.active {\n      background-color: rgba($primary, 0.1);\n      border-block-start: 3px solid $primary;\n      color: $primary;\n    }\n  }\n}\n.nav.nav-style-3 {\n  .nav-link {\n    border-radius: 0;\n  }\n  .nav-link {\n    border-block-end: 3px solid transparent;\n  }\n  .nav-link.active {\n    background-color: transparent;\n    border-block-end: 3px solid $primary;\n    color: $primary;\n  }\n}\n.nav.nav-style-4 {\n  border: 0;\n  .nav-link {\n    color: $text-muted;\n    border: 0;\n  }\n  .nav-link {\n    margin-bottom: 3px;\n    &.active {\n      background-color: $light;\n      color: $text-color;\n      border: 0;\n    }\n    &:hover,\n    &:focus {\n      border: 0;\n    }\n    &:hover {\n        background-color: $light;\n        color: $text-color;   \n    }\n  }\n}\n.nav-tabs.nav-style-5 {\n  border: 0;\n  .nav-link {\n    color: $text-muted;\n    border: 0;\n    margin-bottom: 3px;\n  }\n  .nav-link {\n    &.active {\n      background-color: $primary;\n      color: $white;\n      border: 0;\n    }\n    &:hover,\n    &:focus {\n      border: 0;\n      background-color: $primary;\n      color: $white;\n    }\n  }\n}\n.nav-style-6 {\n  border: 0;\n  &.nav-pills .nav-link {\n    &.active {\n      border: 1px solid $primary;\n      border-block-end: 2px solid $primary;\n      background-color: transparent;\n      color: $primary;\n    }\n  }\n}\n.nav-tabs-header {\n  border: 0 !important;\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      border: 1px solid transparent;\n      font-size: 0.8rem;\n      padding: 0.4rem 0.5rem;\n      font-weight: $font-weight-medium;\n      &.active {\n        background: rgba($primary, 0.1);\n        color: $primary;\n        border: 1px solid transparent;\n      }\n      &:hover,&:focus {\n        border: 1px solid transparent;\n        background-color: transparent;\n        color: $primary;\n      } \n    }\n  }\n}\n.nav-tabs-footer {\n  border: 0;\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      background-color: transparent;\n      color: $primary;\n      border: 1px solid $primary;\n      font-size: 0.8rem;\n      &.active {\n        background: $primary;\n        color: $white;\n        border: 1px solid $primary;\n      }\n      &:hover,&:focus {\n        border: 1px solid $primary;\n        background-color: transparent;\n         color: $primary;\n      } \n    }\n  }\n}\n.vertical-tabs-2 {\n  border: 0;\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      min-width: 7.5rem;\n      max-width: 7.5rem;\n      text-align: center;\n      border: 1px solid $default-border;\n      margin-bottom: 0.5rem;\n      color: $text-muted;\n      background-color: $light;\n      i {\n        font-size: 1rem;\n      }\n      &.active {\n        background-color: $primary;\n        color: $white;\n        position: relative;\n        &:before {\n          content: \"\";\n          position: absolute;\n          inset-inline-end: -0.5rem;\n          inset-block-start: 38%;\n          transform: rotate(45deg);\n          width: 1rem;\n          height: 1rem;\n          background-color: $primary;\n        }\n        &:hover {\n          color: $white;\n        }\n      }\n      &:hover {\n        color: $primary;\n      }\n    }\n  }\n}\n.vertical-tabs-3 {\n  border: 0;\n  .nav-item {\n    border: 0;\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      min-width: 160px;\n      max-width: 160px;\n      border: 1px solid $primary;\n      padding: 1.3rem;\n      margin-block-end: 0.5rem;\n      i {\n        width: 2rem;\n        height: 2rem;\n        line-height: 2rem;\n        text-align: center;\n        font-size: 1rem;\n        background: $primary;\n        color: $white;\n        border-radius: 3.125rem;\n        font-weight: $font-weight-medium;\n      }\n      &.active {\n        background: $primary;\n        border: 1px solid $primary;\n        color: $white;\n        &:hover {\n          background: $primary;\n          border: 1px solid $primary;\n          color: $white;          \n        }\n        i {\n          background: $white;\n          color: $primary;\n        }\n      }\n      &:hover,&:focus {\n        border: 1px solid $primary;\n        color: $primary;\n          background: transparent;\n      }\n    }\n  }\n}\n.nav.tab-style-1 {\n  border-block-end: 0;\n  padding: 0.65rem;\n  background-color: $light;\n  border-radius: 7px;\n  margin-block-end: 1rem;\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n  }\n  .nav-link {\n    border-radius: 7px;\n    padding: 0.35rem 1rem;\n    &.active {\n      background-color: $primary !important;\n      color: $white !important;\n      box-shadow: $box-shadow;\n      transition: color 0.15s ease-in;\n    }\n  }\n}\n.nav-tabs.tab-style-1 {\n    .nav-link {\n        &:hover {\n        background: transparent;\n        color: $primary;\n      }  \n\n    }\n\n}\n.tab-style-2 {\n  border-block-end: 0;\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      border: 0;\n      i { \n        width: 1.875rem;\n        height: 1.875rem;\n        padding: 0.4rem;\n        border-radius: 50px;\n        background-color: $light;\n        color: $text-color;\n        display: inline-block;\n      }\n      &:hover {\n        border: 0;\n        background: transparent;\n        color: $primary;\n        i {\n          color: $primary;          \n        }\n      }\n      &.active {\n        background-color: transparent;\n        position: relative;\n        border: 0;\n        color: $primary;\n        i { \n          background-color: rgba($primary, 0.1);\n          color: $primary;\n        }\n        &:before {\n          content: \"\";\n          position: absolute;\n          inset-inline-start: 0;\n          inset-inline-end: 0;\n          inset-block-end: 0;\n          width: 100%;\n          height: 0.175rem;\n          background-color: $primary;\n          border-radius: 50px;\n        }\n      }\n    }\n  }\n}\n.tab-style-3 {\n  border-block-end: 0;\n  .nav-item {\n    position: relative;\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      position: relative;\n      border: 0;\n      font-size: 0.75rem;\n      &:before {\n        position: absolute;\n        content: \"\";\n        inset-block-end: -1.063rem;\n        inset-inline-end: 0;\n        inset-inline-start: 0;\n        width: 100%;\n        height: 0.1rem;\n        background-color: $light;\n        border-radius: 50%;\n      }\n      &:after {\n        position: absolute;\n        content: \"\";\n        inset-block-end: -2rem;\n        inset-inline-start: 1.75rem;\n        inset-inline-end: 0;\n        inset-inline-start: 30%;\n        width: 2rem;\n        height: 2rem;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        background-color: $white;\n        border-radius: 50%;\n        border: 2px solid $default-border;\n      }\n      &.home:after {\n        content: \"1\";\n      }\n      &.about:after {\n        content: \"2\";\n      }\n      &.services:after {\n        content: \"3\";\n      }\n      &:hover {\n        border: 0;\n        background: transparent;\n        color: $primary;\n      }\n      &.active {\n        background-color: transparent;\n        border: 0;\n        color: $primary;\n        &:before {\n          background-color: $primary;\n        }\n        &:after {\n          border-color: $primary;\n          color: $primary;\n        }\n      }\n    }\n  }\n}\n.tab-style-4 {\n  &.nav-tabs {\n    border: 0;\n    .nav-item {\n      margin-inline-end: 0.5rem;\n      &:last-child {\n        margin-inline-end: 0;\n      }\n    }\n    .nav-link {\n      border: 0;\n      &:hover {\n        border: 0;\n        background: transparent;\n        color: $primary;\n      }\n      &.active {\n        background-color: transparent;\n        border: 0;\n        color: $primary;\n        position: relative;\n        overflow: hidden;\n        &::before {\n          position: absolute;\n          content: \"\";\n          width: 0.75rem;\n          inset-block-start: 31px;\n          transform: rotate(45deg);\n          inset-inline-start: 47%;\n          overflow: hidden;\n          z-index: 1;\n          height: 0.75rem;\n          background-color: $primary;\n          border: 1px solid $primary;\n        }\n        &:after {\n          position: absolute;\n          content: \"\";\n          width: 40%;\n          height: 1px;\n          inset-inline-start: 30%;\n          inset-block-end: 0;\n          background-color: $primary;\n        }\n      }\n    }\n  }\n}\n#tab-style-4 .tab-pane.active {\n  border: 1px solid $primary;\n  background-color: $primary;\n  color: $white;\n  padding: 16px;\n    border-radius: 7px;\n}\n.tab-style-5 {\n  .nav-item {\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link.active {\n      background: $primary;\n    }\n  }\n}\n.tab-style-6 {\n  border: 0;\n  background-color: $white;\n  border-radius: 7px;\n  color: $primary;\n  padding: 0.5rem;\n  .nav-item {\n    border: 0;\n    margin-inline-end: 0.5rem;\n    &:last-child {\n      margin-inline-end: 0;\n    }\n    .nav-link {\n      color: $primary;\n      padding: 0.5rem 1rem;\n      font-size: 0.813rem;\n      border: 0;\n      font-weight: $font-weight-medium;\n      display: -webkit-box;\n      display: -ms-flexbox;\n      display: flex;\n      align-items: center;\n      -webkit-box-align: center;\n      -ms-flex-align: center;\n      &.active {\n        border: 0;\n        background-color: $primary;\n        color: $white;\n        border: 0;\n        box-shadow: 0px 3px 10px 0px rgba(var(--dark-rgb),0.05);\n      }\n      &:hover,\n      &:focus {\n        border: 0;\n      }\n    }\n  }\n}\n.tab-style-7 {\n  .nav-link {\n    margin-block-end: 0.5rem;\n    font-size: 0.813rem;\n    color: $text-muted;\n    text-align: left;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    &:active,\n    &.active {\n      background-color: rgba($primary, 0.1);\n      color: $primary;\n    }\n  }\n}\n.nav-style-1 {\n  .nav-item {\n    .nav-link {\n      &.active {\n        background-color: rgba($primary, 0.1);\n        color: $primary;\n      }\n    }\n  }\n}\n@media screen and (max-width:400px) {\n  .tab-style-4 {\n    .nav-link{\n      padding-inline: 0.5rem;\n    }\n  }\n}\n\n.nav-tabs {\n    border-bottom: 0;\n    &.nav-tabs-bottom {\n        li {\n            margin-bottom: -1px;\n        }\n    }\n    .nav-link {\n        margin-bottom: -1px;\n        background: 0 0;\n        border: 1px solid transparent;\n        border-top-left-radius: 0.25rem;\n        border-top-right-radius: 0.25rem;\n        &.active {\n          border-color: $gray-300;\n        }\n    }\n    li{\n        a{\n            color: $gray-600;\n            border-bottom-width: 2px;\n            &.active{\n                border-color: transparent;\n                border-bottom-color: $primary;\n                background-color: transparent;\n                @include transition(all 0.2s ease);\n            }\n        }\n    }\n}\n.nav-tabs{\n    .nav-tabs-solid {\n        background-color: $white;\n        border: 0;\n        .active{\n            background-color: $primary;\n            border-color: $primary;\n            color: $white;\n        }\n    }\n}\n.nav-tabs{\n    .nav-link{\n        &:hover{\n            border-color: transparent;\n            color: $primary;\n        }\n    }\n    &.nav-tabs-top{\n        li{\n            a{\n                border-width: 2px 0 0 0;\n                &.active{\n                    border-top-color: $primary;                    \n                    @include rounded(0);\n                }\n                &:hover {\n                    border-top-color: $primary;  \n                    background-color: transparent;                    \n                    @include rounded(0);\n                }\n            }\n        }\n    }\n    &.nav-tabs-bottom{\n        li{\n            a{\n                border-width:0 0 2px  0;\n                &.active, &:hover {\n                    border-bottom-color: $primary;\n                    background: transparent;\n                    @include rounded(0);\n                }\n            }\n        }\n    }\n    &.nav-tabs-solid{\n        background-color: $white;\n        border: 0;\n        &.nav-tabs-rounded{\n            li{\n                a{\n                    &.active {\n                        background-color: $primary;\n                        border-color: $primary;\n                        color: $white;\n                        @include rounded(50px);\n                    }\n                }\n            }  \n        }\n        li{\n            a{\n                &.active{\n                    background-color: $primary;\n                    border-color: $primary;\n                    color: $white;\n                    @include rounded(0);\n                }\n            }\n        }   \n    }\n}\n.nav-link{\n    &:hover{\n        color: $primary;\n    }\n}\n.page-menu{\n    .nav-tabs {\n        li{\n            a{\n                font-size: $font-size-16;\n            }\n        }\n    }\n}\n.tabs-set{\n    .nav-tabs {\n        border-bottom: 0;\n        margin-bottom: 20px;\n        .nav-link{\n            color: $secondary;\n            @include margin-padding(null, 8px 15px);\n            font-size: $font-size-16;\n            font-weight: $font-weight-bold;\n            border: 0;\n            min-width: 120px;\n            margin-right: 10px;\n            border-radius: 8px;\n            background: var(--Stroke, rgba(145, 158, 171, 0.30));\n            @include margin-padding(null, null);\n            &:focus{\n                border-color: transparent;\n            }\n            &:hover{\n                border-color: transparent;\n            }\n            &.active{\n                border:0;\n                border-bottom:2px solid $primary;\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n.tabs-sets{\n    .nav-tabs {\n        border-bottom: 0;\n        @include margin-padding(0 0 40px, null);\n        .nav-link{\n            color: $black;;\n            font-size: $font-size-base;\n            font-weight: $font-weight-bold;\n            border: 0;\n            background: $gray-300;\n            margin-right:10px;\n            @include margin-padding(null, 8px 15px);\n            @include rounded(8px);\n            @include transition(all 0.5s ease);\n            &:focus, &:hover, &.active{\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n@include respond-below(custom768) {\n    .nav-tabs {\n        border-bottom: 0;\n        position: relative;\n        background-color: $white;\n        border: 1px solid #eee;\n        @include margin-padding(null, 5px 0);\n        @include rounded(3px);\n    }\n}",".ribbon1 {\n  position: absolute;\n  inset-block-start: -6.1px;\n  inset-inline-end: 10px;\n  color: $white;\n  z-index: 1;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 20px solid transparent;\n    border-inline-end: 24px solid transparent;\n    border-block-start: 13px solid $danger;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: $font-size-14;\n    line-height: 1;\n    padding: 12px 8px 10px;\n    border-start-end-radius: 8px;\n    &:before,\n    &:after {\n      position: absolute;\n      content: \"\";\n    }\n    &:before {\n      height: 6px;\n      width: 6px;\n      inset-inline-start: -6px;\n      inset-block-start: 0;\n      background: $danger;\n    }\n    &:after {\n      height: 6px;\n      width: 8px;\n      inset-inline-start: -8px;\n      inset-block-start: 0;\n      border-radius: 8px 8px 0 0;\n      background: $danger;\n    }\n  }\n}\n.ribbone {\n  width: 100%;\n  position: relative;\n  background-size: cover;\n  text-transform: uppercase;\n  color: $white;\n  width: 150px;\n  height: 150px;\n  overflow: hidden;\n  position: absolute;\n  z-index: 6;\n  &::after {\n    position: absolute;\n    z-index: -1;\n    content: \"\";\n    display: block;\n    border: 5px solid;\n  }\n  &::before {\n    position: absolute;\n    z-index: -1;\n    content: \"\";\n    display: block;\n    border: 5px solid;\n  }\n  span {\n    position: absolute;\n    display: block;\n    width: 225px;\n    padding: 3px 0;\n    box-shadow: 0 5px 10px rgba(0,0,0, 0.1);\n    color: $white;\n    text-shadow: 0 1px 1px rgba(0,0,0, 0.1);\n    text-transform: capitalize;\n    text-align: center;\n    font-size: 11px;\n  }\n}\n.ribbone1 {\n  position: absolute;\n  inset-block-start: -6.1px;\n  inset-inline-start: 10px;\n  z-index: 1;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 20px solid transparent;\n    border-inline-end: 24px solid transparent;\n    border-block-start: 13px solid $danger;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: $font-size-14;\n    line-height: 1;\n    padding: 12px 8px 10px;\n    border-start-end-radius: 8px;\n    &:after {\n      position: absolute;\n      content: \"\";\n      height: 6px;\n      width: 8px;\n      inset-inline-start: -8px;\n      inset-block-start: 0;\n      border-radius: 8px 8px 0 0;\n      background: $danger;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 6px;\n      width: 6px;\n      inset-inline-start: -6px;\n      inset-block-start: 0;\n      background: $danger;\n    }\n  }\n}\n.arrow-ribbone-left {\n  color: $white;\n  padding: 2px 8px;\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-start: 0;\n  z-index: 6;\n  font-size: 13px;\n}\n.arrow-ribbone-left.bg-purple {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $purple;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-danger {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 112px solid transparent;\n    border-inline-start: 12px solid $danger;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-primary {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-secondary {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $secondary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-success {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $primary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-info {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $info;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-warning {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $warning;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-pink {\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-start: 12px solid $pink;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-left.bg-teal {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $teal;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right {\n  color: $white;\n  padding: 2px 8px;\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-end: 0;\n  z-index: 6;\n  font-size: 13px;\n}\n.arrow-ribbone-right.bg-purple {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $purple;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-danger {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $danger;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-primary {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-secondary {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $secondary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-success {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $primary;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-info {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $info;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-warning {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $warning;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-pink {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $pink;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone-right.bg-teal {\n  &:before {\n    position: absolute;\n    inset-inline-start: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-start: -12px;\n    border-block-start: 12px solid transparent;\n    border-inline-end: 12px solid $teal;\n    border-block-end: 11px solid transparent;\n    width: 0;\n  }\n}\n.arrow-ribbone2 {\n  color: $white;\n  padding: 3px 8px;\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-start: -1px;\n  z-index: 6;\n  font-size: $font-size-30;\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -24px;\n    border-block-start: 24px solid transparent;\n    border-block-end: 24px solid transparent;\n    width: 0;\n  }\n}\n.power-ribbone {\n  width: 56px;\n  height: 56px;\n  overflow: hidden;\n  position: absolute;\n  z-index: 6;\n  span {\n    position: absolute;\n    display: block;\n    width: 82px;\n    padding: 8px 0;\n    color: $white;\n    font: 500 16px/1 Lato, sans-serif;\n    text-shadow: 0 1px 1px rgba(0,0,0, 0.1);\n    text-transform: capitalize;\n    text-align: center;\n  }\n}\n.power-ribbone-top-left {\n  inset-block-start: -6px;\n  inset-inline-start: -9px;\n  span {\n    inset-inline-end: -5px;\n    inset-block-start: 1px;\n    transform: rotate(-45deg);\n    i {\n      transform: rotate(45deg);\n      padding-block-start: 2px;\n      padding-inline-start: 7px;\n    }\n  }\n}\n.power-ribbone-bottom-left {\n  inset-block-end: -6px;\n  inset-inline-start: -9px;\n  span {\n    inset-inline-end: -5px;\n    inset-block-end: 1px;\n    transform: rotate(45deg);\n    i {\n      transform: rotate(-45deg);\n      padding-block-end: 2px;\n      padding-inline-start: 7px;\n    }\n  }\n}\n.power-ribbone-top-right {\n  inset-block-start: -6px;\n  inset-inline-end: -9px;\n  span {\n    inset-inline-start: -5px;\n    inset-block-start: 1px;\n    transform: rotate(45deg);\n    i {\n      transform: rotate(-45deg);\n      padding-block-start: 2px;\n      padding-inline-end: 7px;\n    }\n  }\n}\n.power-ribbone-bottom-right {\n  inset-block-end: -6px;\n  inset-inline-end: -9px;\n  span {\n    inset-inline-start: -5px;\n    inset-block-end: 1px;\n    transform: rotate(-45deg);\n    i {\n      transform: rotate(45deg);\n      padding-block-end: 2px;\n      padding-inline-end: 7px;\n    }\n  }\n}\n.ribbone-top-left {\n  inset-block-start: -10px;\n  inset-inline-start: -10px;\n  &::after {\n    border-block-start-color: transparent;\n    border-inline-start-color: transparent;\n    inset-block-end: 50px;\n    inset-inline-start: 0;\n  }\n  &::before {\n    border-block-start-color: transparent;\n    border-inline-start-color: transparent;\n    inset-block-start: 0;\n    inset-inline-end: 50px;\n  }\n  span {\n    inset-inline-end: 0px;\n    inset-block-start: 24px;\n    transform: rotate(-45deg);\n  }\n}\n.ribbone-top-right {\n  inset-block-start: -10px;\n  inset-inline-end: -10px;\n  &::after {\n    border-block-start-color: transparent;\n    border-inline-end-color: transparent;\n    inset-block-end: 50px;\n    inset-inline-end: 0;\n  }\n  &::before {\n    border-block-start-color: transparent;\n    border-inline-end-color: transparent;\n    inset-block-start: 0;\n    inset-inline-start: 50px;\n  }\n  span {\n    inset-inline-start: 0px;\n    inset-block-start: 24px;\n    transform: rotate(45deg);\n  }\n}\n.ribbone-warning-right {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-end: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $warning;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $warning;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-end-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $warning;\n      height: 6px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 50px;\n      border-start-end-radius: 0;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 3px;\n      background: $warning;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-danger-right {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-end: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $danger;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-end-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $danger;\n      height: 6px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 50px;\n      border-start-end-radius: 0;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-start: -9px;\n      inset-block-start: 3px;\n      background: $danger;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-success-left {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $success;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $success;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-start-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $success;\n      height: 6px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 0;\n      border-start-end-radius: 50px;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 3px;\n      background: $success;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-info-left {\n  position: absolute;\n  inset-block-start: -8px;\n  inset-inline-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    border-inline-start: 17px solid transparent;\n    border-inline-end: 17px solid transparent;\n    border-block-start: 10px solid $info;\n    z-index: 6;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $info;\n    font-size: 13px;\n    line-height: 1;\n    padding: 10px 2px 5px;\n    border-start-start-radius: 10px;\n    z-index: 6;\n    &:after {\n      position: absolute;\n      content: \"\";\n      inset-inline-end: -6px;\n      background: $info;\n      height: 6px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 0;\n      border-start-start-radius: 0;\n      border-start-end-radius: 50px;\n      border-end-start-radius: 0;\n      border-end-end-radius: 0;\n    }\n    &:before {\n      position: absolute;\n      content: \"\";\n      height: 5px;\n      width: 10px;\n      inset-inline-end: -9px;\n      inset-block-start: 3px;\n      background: $info;\n    }\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-ribbone-success-left {\n  position: absolute;\n  inset-inline-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-inline-start: 0;\n    border-inline-start: 18px solid $success;\n    border-inline-end: 18px solid $success;\n    border-block-end: 10px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $success;\n    font-size: 13px;\n    line-height: 1;\n    padding: 12px 3px 20px;\n    z-index: 6;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-ribbone-danger-left {\n  position: absolute;\n  inset-inline-start: 10px;\n  color: $white;\n  width: 30px;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-inline-start: 0;\n    border-inline-start: 15px solid $danger;\n    border-inline-end: 15px solid $danger;\n    border-block-end: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $danger;\n    font-size: 12px;\n    line-height: 1;\n    padding: 12px 0px;\n    z-index: 6;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-ribbone-secondary-right {\n  position: absolute;\n  inset-inline-end: 10px;\n  color: $white;\n  width: 30px;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-inline-end: 0;\n    border-inline-start: 15px solid $secondary;\n    border-inline-end: 15px solid $secondary;\n    border-block-end: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $secondary;\n    font-size: 11px;\n    line-height: 1;\n    padding: 12px 0px;\n    z-index: 6;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-sideleft-ribbone-success-left {\n  position: absolute;\n  inset-block-start: 10px;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-block-start: 0;\n    inset-inline-end: -8px;\n    border-block-start: 13px solid $success;\n    border-block-end: 13px solid $success;\n    border-inline-end: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $success;\n    font-size: 11px;\n    padding: 5px 13px;\n    z-index: 6;\n    height: 26px;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.bookmark-sideright-ribbone-primary-right {\n  position: absolute;\n  inset-block-start: 10px;\n  inset-inline-end: 0;\n  color: $white;\n  &:after {\n    position: absolute;\n    content: \"\";\n    width: 0;\n    height: 0;\n    z-index: 6;\n    inset-block-start: 0;\n    inset-inline-start: -8px;\n    border-block-start: 13px solid $primary;\n    border-block-end: 13px solid $primary;\n    border-inline-start: 8px solid transparent;\n  }\n  span {\n    position: relative;\n    display: block;\n    text-align: center;\n    background: $primary;\n    font-size: 11px;\n    padding: 5px 13px;\n    z-index: 6;\n    height: 26px;\n  }\n  i {\n    color: $white;\n    font-size: $font-size-16;\n    padding-inline-start: 7px;\n    padding-inline-end: 7px;\n  }\n}\n.ribbone-1 {\n  span {\n    &:after {\n      position: absolute;\n      content: \"\";\n    }\n  }\n}\n.arrow-ribbone-2 {\n  color: $white;\n  padding: 3px 8px;\n  position: absolute;\n  z-index: 6;\n  font-size: $font-size-20;\n  &:before {\n    position: absolute;\n    inset-inline-end: 0;\n    inset-block-start: 0;\n    inset-block-end: 0;\n    content: \"\";\n    inset-inline-end: -24px;\n    border-block-start: 16px solid transparent;\n    border-inline-start: 24px solid $purple;\n    border-block-end: 16px solid transparent;\n    width: 0;\n  }\n}\n.ribbone-card {\n  overflow: hidden;\n}\n.fullwidth-primary-ribbons {\n  .bar {\n    color: $white;\n    background-color: $primary;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-color: $primary $primary $primary transparent;\n        border-block-start-color: $primary;\n        border-inline-end-color: $primary;\n        border-block-end-color: $primary;\n        border-inline-start-color: transparent;\n        inset-inline-start: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $primary;\n        border-inline-end-color: transparent;\n        border-block-end-color: $primary;\n        border-inline-start-color: $primary;\n        inset-inline-end: -30px;\n      }\n    }\n  }\n}\n.fullwidth-secondary-ribbons {\n  .bar {\n    color: $white;\n    background-color: $secondary;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $secondary;\n        border-inline-end-color: $secondary;\n        border-block-end-color: $secondary;\n        border-inline-start-color: transparent;\n        inset-inline-start: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $secondary;\n        border-inline-end-color: transparent;\n        border-block-end-color: $secondary;\n        border-inline-start-color: $secondary;\n        inset-inline-end: -30px;\n      }\n    }\n  }\n}\n.fullwidth-arrow-warning-ribbons {\n  .bar {\n    color: $white;\n    background-color: $warning;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $warning;\n        border-inline-end-color: $warning;\n        border-block-end-color: $warning;\n        border-inline-start-color: transparent;\n        inset-inline-start: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start: 18px solid transparent;\n        border-inline-start: 18px solid $warning;\n        border-block-end: 18px solid transparent;\n        border-inline-end: transparent;\n        inset-inline-end: -20px;\n        inset-block-start: -2px;\n      }\n    }\n  }\n}\n.fullwidth-arrow-danger-ribbons-right {\n  .bar {\n    color: $white;\n    background-color: $danger;\n    padding: 5px;\n    text-align: center;\n    position: relative;\n    border: 2px transparent solid;\n    box-shadow: 0 10px 30px -10px $light;\n    span {\n      position: absolute;\n      &:nth-child(1) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-end: -2px;\n      }\n      &:nth-child(3) {\n        border-style: solid;\n        border-width: 11px;\n        z-index: -1;\n        border-color: transparent;\n        inset-block-start: 31px;\n        inset-inline-start: -2px;\n      }\n      &:nth-child(2) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start-color: $danger;\n        border-inline-end-color: transparent;\n        border-block-end-color: $danger;\n        border-inline-start-color: $danger;\n        inset-inline-end: -30px;\n      }\n      &:nth-child(4) {\n        inset-block-start: 18px;\n        border-style: solid;\n        border-width: 18px;\n        z-index: -2;\n        border-block-start: 18px solid transparent;\n        border-inline-end: 18px solid $danger;\n        border-block-end: 18px solid transparent;\n        border-inline-start: transparent;\n        inset-inline-start: -20px;\n        inset-block-start: -2px;\n      }\n    }\n  }\n}\n.power-ribbone {\n  span {\n    svg {\n      width: 15px;\n      height: 15px;\n    }\n  }\n}\n.ribbone-card {\n  .card-body {\n    padding: 25px;\n  }\n}\n.ribbone-row {\n  .feather-zap {\n    width: 15px;\n    height: 15px;\n  }\n}\n[data-bs-toggle=\"card-fullscreen\"] {\n  svg {\n    width: 15px;\n    height: 15px;\n  }\n} \n[data-bs-toggle=\"card-remove\"] {\n  svg {\n    width: 15px;\n    height: 15px;\n  }\n} \nsvg {\n  &.collapse-open,&.collapse-close {\n    width: 15px;\n    height: 15px;\n  }\n}\n.btn-icon {\n  &.btn-danger-light {\n    color: $danger-900;\n    background: $danger-100;\n  }\n}\n.live-rating {\n  &.badge {\n    background: $success-200;\n    color: $success-900;\n  }\n}\n@media (min-width: 576px) {\n  .mx-sm-7 {\n    margin-inline: 3rem !important;\n  }\n}\n[dir=\"rtl\"] {\n  .power-ribbone-top-left span {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-top-left span i {\n    transform: rotate(-45deg);\n  }\n\n  .power-ribbone-bottom-left span {\n    transform: rotate(-45deg);\n  }\n\n  .power-ribbone-bottom-left span i {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-top-right span {\n    transform: rotate(-45deg);\n  }\n\n  .power-ribbone-top-right span i {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-bottom-right span {\n    transform: rotate(45deg);\n  }\n\n  .power-ribbone-bottom-right span i {\n    transform: rotate(-45deg);\n  }\n\n  .ribbone-top-left span {\n    transform: rotate(45deg);\n  }\n\n  .ribbone-top-right span {\n    transform: rotate(-45deg);\n  }\n\n  .ribbon-price .badge {\n    transform: rotate(-45deg);\n  }\n}\n",".modal-barcode {\n    ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        li {\n            @include rounded(7px);\n            width: 25%;\n            margin-bottom: 10px;\n            padding: 0 5px;\n            @include respond-below(custom991) {\n                width: 50%;\n            }\n            a {\n                border: 1px solid $gray-400;\n                @include rounded(10px);\n                display: block;\n                padding: 10px;\n                text-align: center;\n            }\n        }\n    }\n}\n\n.modal{\n    .modal-title {\n        font-weight: $font-weight-bold;\n        @include respond-below(custom991) {\n            font-size: $font-size-16;\n        }\n    }\n\t.logo-lg {\n\t\timg {\n\t\t\twidth: 150px;\n\t\t}\n\t}\n    .close,\n    .btn-close {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        color: $danger-700;\n        opacity: 1;\n        font-size: $font-size-12;\n        width: 22px;\n        height: 22px;\n        border: 0;\n        font-weight: $font-weight-bold;\n        background-color: transparent;\n        @include rounded(50px);\n        &:hover{\n            background-color: transparent;\n            color:$white;\n        }\n    }\n    .modal-footer{\n       border: 0;\n       justify-content: flex-start;\n        .btn {\n            min-width: 130px;\n            @include margin-padding(null, 12px);\n            @include respond-below(custom991) {\n                min-width: auto;\n                @include margin-padding(null, 7px 12px);\n            }\n        }\n        .btn-print {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $primary;\n            color: $primary;\n            img{\n                margin-left: 10px;\n            }\n            &:hover{\n                background: $primary;\n                color: $white;\n                img{\n                    filter: brightness(0) invert(1);\n                }\n            }\n        }\n        .btn-secondary{\n            background: $secondary;\n            &:hover{\n                @include box-shadow(inset, 0, 0px, 0px, 100px, $white);\n                color: $secondary !important;\n            }\n        }\n    }\n    \n    .modal-dialog.right-slider-modal {\n        margin: 0;\n        margin-left: auto;\n        max-width: 1102px;\n    }\n    \n    .modal-dialog.add-centered {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        max-width: 1192px;\n    }\n    .modal-dialog.sales-details-modal {\n        max-width: 1192px;\n    }\n    .modal-dialog.edit-sales-modal {\n        max-width: 1192px;\n    }\n    .edit-add.card.edit-expense {\n        border: 1px solid rgba(0,0,0,.2);\n    }\n    .note-editor.note-frame.card {\n        border: 1px solid rgba(0,0,0,.2) !important; \n    }\n}\n.offcanvas.offcanvas-end {\n    width: auto !important;\n}\n.offcanvas.offcanvas-end.em-payrol-add {\n    max-width: 1192px !important;\n}\n\n.modal {\n    &.animated .modal-dialog {\n        transform: translate(0, 0);\n    }\n    &.effect-scale {\n        .modal-dialog {\n            transform: scale(0.7);\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: scale(1);\n            opacity: 1;\n        }\n    }\n    &.effect-slide-in-right {\n        .modal-dialog {\n            transform: translateX(20%);\n            opacity: 0;\n            transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);\n        }\n        &.show .modal-dialog {\n            transform: translateX(0);\n            opacity: 1;\n        }\n    }\n    &.effect-slide-in-bottom {\n        .modal-dialog {\n            transform: translateY(20%);\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: translateY(0);\n            opacity: 1;\n        }\n    }\n    &.effect-newspaper {\n        .modal-dialog {\n            transform: scale(0) rotate(720deg);\n            opacity: 0;\n        }\n        &.show~.modal-backdrop, .modal-dialog {\n            transition: all 0.5s;\n        }\n        &.show .modal-dialog {\n            transform: scale(1) rotate(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-fall {\n        -webkit-perspective: 1300px;\n        -moz-perspective: 1300px;\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: translateZ(600px) rotateX(20deg);\n            opacity: 0;\n        }\n        &.show .modal-dialog {\n            transition: all 0.3s ease-in;\n            transform: translateZ(0px) rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-flip-horizontal {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: rotateY(-70deg);\n            transition: all 0.3s;\n            opacity: 0;\n        }\n        &.show .modal-dialog {\n            transform: rotateY(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-flip-vertical {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: rotateX(-70deg);\n            transition: all 0.3s;\n            opacity: 0;\n        }\n        &.show .modal-dialog {\n            transform: rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-super-scaled {\n        .modal-dialog {\n            transform: scale(2);\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: scale(1);\n            opacity: 1;\n        }\n    }\n    &.effect-sign {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: rotateX(-60deg);\n            transform-origin: 50% 0;\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-rotate-bottom {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: translateY(100%) rotateX(90deg);\n            transform-origin: 0 100%;\n            opacity: 0;\n            transition: all 0.3s ease-out;\n        }\n        &.show .modal-dialog {\n            transform: translateY(0%) rotateX(0deg);\n            opacity: 1;\n        }\n    }\n    &.effect-rotate-left {\n        perspective: 1300px;\n        .modal-dialog {\n            -moz-transform-style: preserve-3d;\n            transform-style: preserve-3d;\n            transform: translateZ(100px) translateX(-30%) rotateY(90deg);\n            transform-origin: 0 100%;\n            opacity: 0;\n            transition: all 0.3s;\n        }\n        &.show .modal-dialog {\n            transform: translateZ(0px) translateX(0%) rotateY(0deg);\n            opacity: 1;\n        }\n    }\n}",".grid-showcase {\n  margin-bottom: -10px;\n  span, .grid-wrapper {\n    display: block;\n    padding: 10px;\n    margin-bottom: 10px;\n    text-align: center;\n    background-color: rgba(242, 243, 247, 0.7);\n  }\n}\n.grid-align {\n  margin-bottom: -16px;\n}\n.grid-align .row {\n  padding: 15px 0;\n  min-height: 7rem;\n  margin-bottom: 16px;\n}\n.grid-vertical {\n  min-height: 150px;\n  padding: 10px;\n  color: $black;\n}\ntable.table-bordered thead tr th p {\n  margin-bottom: 0;\n}",".select2-container {\n    min-width: 100% !important;\n    z-index: 99;\n    .select2-selection--single {\n        height: 40px;\n    }\n}\n.select2-container--default {\n    .select2-selection--single {\n        border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n        @include rounded(5px);\n        .select2-selection__rendered {\n            color: $text-color;\n            line-height: 38px;\n            @include rounded(5px);\n            padding-left: 10px;\n            font-size: $font-size-14;\n            font-weight: $font-weight-normal;\n        }\n        .select {\n            width: 219px;\n        }\n        .select2-selection__arrow {\n            height: 40px;\n            right: 6px;\n        }\n    }\n}\n.select2-container--default .select2-selection--single .select2-selection__arrow b {\n    @include position(absolute,50%,null,null,50%);\n    border-color: #637381;\n    border-style: solid;\n    border-width: 0 2px 2px 0;\n    padding: 3px;\n    height: 0;\n    margin-left: -6px;\n    margin-top: -3px;\n    width: 0;\n    @include transform(rotate(45deg) translateY(-50%));\n}\n.select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\n    border-color: $black;;\n    border-width: 2px 0 0 2px;\n    margin-top: 3px;\n    @include margin-padding(null, 3px);\n}\n.select2-container--default .select2-results__option--highlighted[aria-selected] {\n    background: $primary;\n    color: $white;\n}\n.select2-container--focus  {\n    .select2-selection--single{\n        background: $white !important;\n        border-color: $primary;\n    }\n}\nspan.select2-container.select2-container--default.select2-container--open {\n    z-index: 9999;\n}\n.select2-container--classic .select2-selection--single,\n.select2-container--default .select2-selection--single,\n.select2-container--default .select2-selection--single .select2-selection__rendered,\n.select2-container--default .select2-selection--single .select2-selection__arrow,\n.select2-container--default .select2-selection--multiple,\n.select2-container--classic .select2-selection--single .select2-selection__arrow,\n.select2-container--classic .select2-selection--single .select2-selection__rendered {\n    border-color: $border-color;\n    color: $text-color;\n    height: 40px;\n    line-height: 40px;\n}\n\n.select2-container--default .select2-selection--multiple {\n    line-height: 27px;\n    height: auto;\n    min-height: 40px;\n}\n\n.select2-container--classic .select2-selection--multiple .select2-selection__choice,\n.select2-container--default .select2-selection--multiple .select2-selection__choice,\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n    background-color: $info;\n    border-color: $info;\n    color: $white;\n}","table.dataTable>thead .sorting:after, \ntable.dataTable>thead .sorting_asc:after,\ntable.dataTable>thead .sorting_desc:after,\ntable.dataTable>thead .sorting_asc_disabled:after, \ntable.dataTable>thead .sorting_desc_disabled:after {\n    right: 0.5em !important;\n    content: \"\\f107\" !important;\n    font-family: 'Font Awesome 5 Free';\n    bottom: 12px !important;\n    color: #BABFC7 !important;\n    font-size: 12px !important;\n    opacity: 1 !important;\n    position: absolute;\n}\ntable.dataTable>thead .sorting:before, \ntable.dataTable>thead .sorting_asc:before, \ntable.dataTable>thead .sorting_desc:before, \ntable.dataTable>thead .sorting_asc_disabled:before, \ntable.dataTable>thead .sorting_desc_disabled:before {\n    right: 0.5em !important;\n    content: \"\\f106\" !important;\n    font-family: 'Font Awesome 5 Free';\n    top: 12px !important;\n    color: #BABFC7 !important;\n    font-size: 12px !important;\n    opacity: 1 !important;\n    position: absolute;\n}\n.dataTables_paginate .paging_numbers {\n    float: right;\n}\n.dataTables_info {\n    float: right;\n    padding-right: 15px;\n    font-size: $font-size-12;\n    color: $gray-700;\n    font-weight: $font-weight-semibold;\n}\n.custom-select {\n    min-width: 80px;\n    background: url(../../../../public/assets/img/icons/dropdown.svg) no-repeat 95% 50%;\n}\n.dataTables_paginate .pagination{\n    li{\n        @include margin-padding(0 5px, null);\n        a{\n            background: var(--Stroke, rgba(145, 158, 171, 0.30));\n            border-radius: 85px !important;\n            width: 30px;\n            height: 30px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            color: #5B6670;\n            &:hover{\n                background: $primary;\n                color: $white;\n            }\n        }\n        &.active a.page-link{\n            background: $primary;\n            border-color: $primary;\n            @include rounded(85px);\n            width: 30px;\n            height: 30px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n        }\n        &.previous.disabled {\n            width: 20px;\n            a {\n                background-color: transparent;\n                border: 0;\n                width: 20px;\n            }\n        }\n        &.next.disabled {\n            width: 20px;\n            a {\n                background-color: transparent;\n                border: 0;\n                width: 20px;\n            }\n        }\n    }\n}\n.dataTables_length,\n.dataTables_paginate {\n    margin-top:15px !important;\n}\ndiv.dataTables_wrapper div.dataTables_info {\n    padding-top: 23px;\n}\ntable.dataTable thead>tr>th.no-sort.sorting_asc:before {\n    display: none;\n}\ntable.dataTable thead>tr>th.no-sort.sorting_asc::after {\n    display: none;\n}\ntable.dataTable thead>tr>th.no-sort.sorting:before {\n    display: none;\n}\ntable.dataTable thead>tr>th.no-sort.sorting::after {\n    display: none;\n}\n",".page-wrapper {\n    @include transition(all 0.5s ease);\n    @include margin-padding( 0 0 0 260px, 66px 0 0);\n    @include position(relative,null,null,null,0);\n    @include transition(all 0.2s ease);\n    @include respond-below(custom991) {\n        @include margin-padding( 0 , 60px 0 0);\n    }\n    .content {\n        @include margin-padding(null, 24px);\n        padding-bottom: 0;\n        @include respond-below(custom991) {\n            @include margin-padding(null, 15px);\n        }\n        .add-item.new-sale-items {\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            width: 100%;\n        }\n    }\n    \n}\n.page-wrapper.details-blk {\n    padding: 0;\n    margin: 0;\n}\n.page-wrapper-new {\n    background: $white;\n    padding: 24px;\n    border-radius: 8px;\n    .card {\n        border: none;\n        .card-body {\n            border-top: 1px solid $gray-100;\n        }\n    }\n    .page-header {\n        margin-bottom: 40px;\n        h4 {\n            font-size: $font-size-20;\n        }\n        .page-btn {\n            .btn-added {\n                padding: 8px 8px;\n            }\n        }\n    } \n}\n.sidebarrightmenu{\n    .page-wrapper {\n        @include margin-padding(0 0 0 350px, null);\n        @include respond-below(custom991) {\n            @include margin-padding(0, null);\n        }\n    }\n}\n.card{\n    .card-header{\n        .dropset {\n            color: $gray-600;\n            @include margin-padding(null, 0 10px);\n        }\n    }\n    .card-body{\n        .loss-data {\n            display: flex;\n            align-items: center;\n            justify-content: flex-end;\n            .input-groupicon {\n                margin-right: 10px;\n            }\n            @include respond-below(custom575) {\n                display: block;\n            }\n        }\n        .input-blocks {\n            label {\n                span {\n                    color: $danger;\n                }\n            }\n        }\n        .text-title {\n            margin-bottom: 20px;\n            p {\n                font-size: $font-size-16;\n                font-weight: $font-weight-semibold;\n                color: $secondary;\n            }\n        }\n        .payroll-info {\n            border-bottom: 1px solid $gray-100;\n            .status-updates {\n                margin-left: 25%;\n            }\n            .status-updates {\n                .form-check-input:checked {\n                    background-color: $primary;\n                    border-color: $primary;\n                }\n                .form-check-input:focus {\n                    box-shadow: none;\n                    border-color: $gray-100;\n                }\n            }\n        }\n        .payroll-title {\n            margin: 20px 0 20px 0;\n            p {\n                font-size: $font-size-16;\n                font-weight: $font-weight-semibold;\n                color: $secondary;\n            }\n        }\n        .sub-form {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            border-bottom: 1px solid $gray-100;\n            .subadd-btn {\n                .btn-add {\n                    border-radius: 8px;\n                    border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n                    background: $secondary;\n                    color: $white;\n                    padding: 7px 9px;\n                    margin-left: 20px;\n                    margin-bottom: -11px;\n                }\n            }\n        }\n        .view-btn {\n            text-align: end;\n        }\n        .summary-blk {\n            margin-bottom: 15px;\n            p {\n                font-size: $font-size-14;\n                font-weight: $font-weight-semibold;\n                color: $secondary;\n            }\n        }\n        .details {\n            td {\n                .view-product {\n                    border-radius: 6px;\n                    background: #F8F8F8;\n                    width: 50px;\n                    height: 50px;\n                    display: flex;\n                    align-items: center;\n                    justify-content: center;\n                    \n                }\n                a {\n                    border-radius: 8px;\n                    border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n                    .feather-trash-2 {\n                        width: 14px;\n                        height: 14px;\n                        color: $danger;\n                    }\n                }\n            }\n        }\n        .payslip-month {\n            justify-content: space-between;\n            align-items: center;\n            .month-of-slip {\n                h4 {\n                    font-weight: $font-weight-bold;\n                }\n            }\n        }\n        .emp-details {\n            justify-content: space-between;\n             align-items: center;\n             background: #FAFBFE;\n             padding: 10px;\n            .emp-name-id {\n                h6 {\n                    font-size: $font-size-15;\n                    font-weight: $font-weight-semibold;\n                    span {\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        color: $text-color;\n                    }\n                }\n            }\n            .emp-location-info {\n                h6 {\n                    font-size: $font-size-15;\n                    font-weight: $font-weight-semibold;\n                    span {\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        color: $text-color;\n                    }\n                }\n            }\n           \n        }\n    }\n}\n.btn-white {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    background-color: $white;\n    border: 1px solid rgba(145, 158, 171, 0.32);\n    color: $secondary;\n    @include margin-padding(null, 3px 10px);\n    @include rounded(5px);\n    min-width: 90px;\n    &:hover {\n        border: 1px solid rgba(145, 158, 171, 0.32);\n    }\n}\n.mail-search {\n    .form-control {\n        height: 40px;\n    }\n}\n.inputcheck {\n    display: block;\n    position: relative;\n    padding-left: 25px;\n    cursor: pointer;\n    color: $black;;\n    font-weight: $font-weight-medium;\n    font-size: $font-size-base;\n    input {\n        @include position(absolute,null,null,null,null);\n        opacity: 0;\n        cursor: pointer;\n        height: 0;\n        width: 0;\n        &:checked {\n            & ~ .checkmark:after {\n                display: block;\n            }\n        }\n      }\n      .checkmark {\n        @include position(absolute,0,null,null,0);\n        height: 20px;\n        width: 20px;\n        border:1px solid $gray-300;\n        background: $light;\n        @include rounded(5px);\n        &:after {\n            content: \"\";\n            position: absolute;\n            display: none;\n        }\n        &:after {\n            @include position(absolute,3px,null,null,6px);\n            width: 5px;\n            height: 10px;\n            border: solid $primary;\n            border-width: 0 2px 2px 0;\n            @include transform(rotate(45deg));\n        }\n      }\n     \n    input {\n        &:checked ~ .checkmark {\n            border:1px solid $primary;\n        }\n     }\n}\n.animation-tada{\n    animation: tada 1.5s ease infinite;\n}\n.quantity-btn{\n    svg{\n        stroke: 1px;\n        width: 16px;\n        height: 16px;\n    }\n}\n","::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n    border-radius: 50px !important;\n}\n::-webkit-scrollbar-track {\n    background: $gray-300;\n}\n::-webkit-scrollbar-thumb {\n    background: $primary;\n}\n::-webkit-scrollbar-thumb:hover {\n    background: $gray-300;\n}\n.swal2-header{\n    .swal2-title{\n        font-size: $font-size-18;\n    }\n}\n.none{\n    display: none !important;\n}\n.text-red{\n    color: $danger !important;\n}\n.text-green{\n    color: $success !important;\n}\n.input-blocks{\n    input[type=text]{\n        &:focus{\n            border-color: $input-border;\n        }\n    }\n}\n.input-group{\n    .scanner-set {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        background: $primary;\n        border-radius: 5px !important;\n        width: 40px;\n        color: $white;\n        font-weight: $font-weight-semibold;\n        padding: 0;\n        &:hover{\n            background: $title-color;\n        }\n    }\n}\n::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n    border-radius: 50px !important;\n}\n::-webkit-scrollbar-track {\n    background: $gray-300;\n}\n::-webkit-scrollbar-thumb {\n    background: $primary;\n}\n::-webkit-scrollbar-thumb:hover {\n    background: $gray-300;\n}\n.swal2-header{\n    .swal2-title{\n        font-size: $font-size-18;\n    }\n}\n.none{\n    display: none !important;\n}\n.text-red{\n    color: $danger !important;\n}\n.text-green{\n    color: $success !important;\n}\n\n.input-blocks{\n    input[type=text]{\n        &:focus{\n            border-color: $input-border;\n        }\n    }\n}\n.page-header {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    margin-bottom: 24px;\n    .breadcrumb {\n        margin-bottom: 0;\n    }\n    @include respond-below(custom575) {\n        margin-bottom: 20px;\n        flex-direction: column;\n        align-items: self-start;\n    }\n    h3{\n        font-weight: $font-weight-bold;\n        color: $secondary;\n        font-size: $font-size-18;\n        @include respond-below(custom991) {\n            font-size: $font-size-base;\n        }\n    }\n    h4 {\n        font-weight: $font-weight-bold;\n        color: $secondary;\n        font-size: $font-size-18;\n        margin-bottom: 5px;\n        @include respond-below(custom991) {\n            font-size: $font-size-18;\n        }\n    }\n    h6 {\n        font-size: $font-size-base;\n        color: $gray-700;\n        font-weight: $font-weight-normal;\n        @include respond-below(custom991) {\n            font-size: $font-size-12;\n        }\n        @include respond-below(custom575) {\n            font-size: $font-size-12;\n            margin-bottom: 20px;\n        }\n    }\n    .btn-filter {\n        background: $primary;\n        width: 34px;\n        height: 34px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        padding: 0;\n        &:hover{\n            background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\n        }\n    }\n    .page-btn {\n        margin-left: 10px;\n        @include respond-below(custom575) {\n            margin-left: 0;\n            margin-top: 20px;\n        }\n    }\n    .btn-added {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        background: $primary;\n        padding: 8px 11px;\n        color: $white;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-14;\n        border-radius: 8px;\n        &:active {\n            color: $white;\n        }\n        img{\n            filter: brightness(0) invert(1);\n        }\n        @include respond-below(custom991) {\n            padding: 10px 10px; \n        }\n        &:hover{\n            background: $title-color;\n        }\n        .me-2 {\n            width: 16px;\n            height: 16px;\n        }\n    }\n    .btn-added.downloader {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        background: $secondary;\n        padding: 9px 11px;\n        color: $white;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-14;\n        border-radius: 8px;\n        margin: 0 15px 0 15px;\n        img{\n            filter: brightness(0) invert(1);\n        }\n        @include respond-below(custom991) {\n            padding: 10px 10px; \n        }\n        &:hover{\n            background: $primary;\n        }\n        .me-2 {\n            width: 16px;\n            height: 16px;\n        }\n    }\n    .btn-added.printer {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        background: $danger;\n        padding: 9px 11px;\n        color: $white;\n        font-weight: $font-weight-bold;\n        font-size: $font-size-14;\n        border-radius: 8px;\n        img{\n            filter: brightness(0) invert(1);\n        }\n        @include respond-below(custom991) {\n            padding: 10px 10px; \n        }\n        &:hover{\n            background: $secondary;\n        }\n        .me-2 {\n            width: 16px;\n            height: 16px;\n        }\n    }\n    .add-item {\n        @include respond-below(custom767) {\n            display: block !important;\n            .page-btn {\n                margin-left: 0;\n            }\n        }\n        .page-btn {\n            @include respond-below(custom575) {\n                 margin-left: 0;\n                 margin-bottom: 24px;\n            }\n        }\n        .page-title.modal-datail {\n            line-height: 2;\n        }\n    }\n    .add-item.d-flex {\n        margin-right: auto;\n    }\n    .add-item.payslip-list {\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        width: 100%;\n    }\n}\n.page-header.paysilp-header {\n    padding: 24px;\n    margin-bottom: 0;\n    border-radius: 8px 8px 0px 0px;\n    background: $body-bg;\n}\n\n.table-top {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    margin-bottom: 25px;\n    @include respond-below(custom575) {\n        flex-wrap: wrap;\n        flex-direction: column;\n        align-items: flex-start;\n        .wordset{\n            margin-top: 25px;\n        }\n    }\n}\n\n.search-set {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    .search-input{\n        position: relative;\n        margin-right: 15px;    \n        input[type=\"search\"] {\n            height: 38px;\n            border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n            background: var(--White, #FFF);\n            width: 298px;\n            @include rounded(8px);\n            padding: 10px;\n            &::placeholder {\n                color: $black;\n            }\n            @include respond-below(custom1199) {\n                width: 220px;\n            }\n            @include respond-below(custom991) {\n                width: 200px;\n            }\n            @include respond-below(custom575) {\n                width: auto;\n            }\n        }\n        .btn-searchset {\n            @include margin-padding(null, null);\n            @include rounded(50px);\n            @include position(absolute,0,0,null,null);\n            border: 0;\n            .feather-search {\n                width: 14px;\n                height: 14px;\n            }\n        }\n    }\n}\n.search-path {\n    margin-left: auto;\n    @include respond-below(custom575) {\n        margin-right: 0;\n        margin-left: 0;\n    }\n    @include respond-below(custom575) {\n        margin-top: 24px;\n    }\n    .info-img {\n        width: 16px;\n        height: 16px;\n        color: $white;\n    }\n    .btn-filter {\n        background: $primary;\n        width: 36px;\n        height: 36px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        padding: 0;\n        margin-right: 15px;\n        span{\n            display: none;\n        }\n        &:hover{\n            background: $title-color;\n        }\n        &.setclose{\n            background: $danger;\n            >img {\n                display:none;\n            }\n            span{\n                display: block;\n                img{\n                    display: block;\n                }\n            }\n        }\n        span{\n            display: none;\n        }\n        > img{\n            display: block;\n        }\n    }\n}\n.form-sort {\n    position: relative;\n    width: 149px;\n    height: 38px;\n    .info-img {\n        position: absolute;\n        top: 50%;\n        z-index: 100;\n        width: 16px;\n        height: 16px;\n        left: 0;\n        margin-left: 10px;\n        color: $text-color;\n        transform: translateY(-50%);\n        line-height: normal;\n    }\n    @include respond-below(custom575) {\n        margin-top: 24px;\n    }\n}\n.swal2-actions{\n    .swal2-confirm{\n        margin-right:10px;\n    }\n}\n.wordset{\n    ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        li {\n            @include margin-padding(0 10px,null);\n            a{\n                display: block;\n            }\n        }\n    }\n} \n.custom-control.custom-checkbox .checkboxs {\n    line-height: 1;\n}\n.custom-control.custom-checkbox .checkmarks {\n    border-radius: 5px;\n}\n.custom-control.custom-checkbox .checkboxs input {\n    cursor: auto;\n}\n.checkboxs {\n    display: block;\n    position: relative;\n    padding-left: 35px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    user-select: none;\n    input {\n        position: absolute;\n        opacity: 0;\n        cursor: pointer;\n        height: 0;\n        width: 0;\n        & ~ .checkmarks {\n            border: 1px solid $gray-500;\n            border-radius: 5px;\n          }\n          &:checked ~ .checkmarks {\n            background-color: $primary;\n            border-color: $primary;\n          }\n          &:checked ~ .checkmarks:after {\n            display: block;\n        }\n    }\n    .checkmarks {\n        height: 15px;\n        width: 15px;\n        @include position(absolute,0,null,null,0);\n        &:after {\n            content: \"\";\n            position: absolute;\n            display: none;\n        }\n        &:after {\n            left: 4px;\n            top: 1px;\n            width: 5px;\n            height: 9px;\n            border: solid $white;\n            border-width: 0 2px 2px 0;\n            @include transform(rotate(45deg));\n          }\n    }\n}\nth,td {\n    .checkboxs {\n        .checkmarks {\n            width: 18px;\n            height: 18px;\n            &::after {\n                left: 6px;\n                top: 3px;\n            }\n        }\n    } \n}\n.image-upload {\n    border: 1px solid rgba(145, 158, 171, 0.32);\n    position: relative;\n    margin-bottom: 35px;\n    border-radius: 5px;\n    &:hover{\n        background:$gray-100;\n    }\n    input[type=\"file\"]{\n        width: 100%;\n        opacity: 0;\n        height: 100px;\n        position: relative;\n        z-index: 9;\n        cursor: pointer;\n    }\n    .image-uploads {\n        text-align: center;\n        width: 100%;\n        @include margin-padding(null, 20px 0);\n        @include rounded(5px);\n        @include position(absolute,0,null,null,null);\n        h4 {\n            font-size: $font-size-base;\n            font-weight: $font-weight-medium;\n            color: $secondary\n        }\n    }\n    &.image-upload-new{\n        input[type=\"file\"]{\n            height: 258px;\n        }\n        .image-uploads {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            height: 100%;\n            flex-direction: column;\n        }\n    }\n}\n.checktoggle {\n    background-color: rgba(115, 103, 240, 0.2);\n    @include rounded(12px);\n    cursor: pointer;\n    display: block;\n    font-size: 0;\n    height: 13px;\n    margin-bottom: 0;\n    position: relative;\n    width: 25px;\n    &:after {\n        content: ' ';\n        display: block;\n        transform: translate(2px, -50%);\n        width: 10px;\n        height: 10px;\n        background-color:$white;\n        transition: left 300ms ease, transform 300ms ease;\n        @include rounded( 50%);\n        @include transform(translate(2px,-50%));\n        @include position(absolute,50%,null,null,0);\n    }\n}\n.check:checked + .checktoggle:after {\n    background-color: $white;\n    left: 100%;\n    transform: translate(calc(-90% - 3px), -45%);\n}\n.check {\n    display: block;\n    margin: 0;\n    padding: 0;\n    width: 0;\n    height: 0;\n    visibility: hidden;\n    opacity: 0;\n    pointer-events: none;\n    position: absolute;\n    &:checked + {\n        .checktoggle {\n            background-color:$success;\n        }\n    }\n}\n#filter_inputs,#filter_inputs1,#filter_inputs2,#filter_inputs3{\n    border:0;\n    margin:0;\n    .card-body{\n        padding: 0 24px 24px 24px;\n    }\n}\n.authentication-check {\n    .checkboxs {\n        padding-left: 22px;\n        .checkmarks {\n            border-radius: 5px;\n            top: 4px;\n        }\n    }\n}\n.input-group {\n    position: relative;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    flex-wrap: nowrap;\n    align-items: stretch;\n    width: 100%;\n}\n#filter_inputs,\n#filter_inputs1,\n#filter_inputs2 {\n    display: none;\n}\n.input-blocks {\n    margin-bottom: 25px;\n    position: relative;\n    .info-img {\n        position: absolute;\n        top: 50%;\n        z-index: 100;\n        width: 16px;\n        height: 16px;\n        left: 4px;\n        margin-left: 10px;\n        color: $text-color;\n        transform: translateY(-50%);\n        line-height: normal;\n    }\n    .info-img.status-icon {\n       margin-top: 2px;\n    }\n    label{\n        margin-bottom: 8px;\n        color: $secondary;\n        font-weight: $font-weight-medium;\n        font-size: $font-size-base;\n        display: block;\n        .manitory{\n            color: $danger;\n        }\n    }\n    .input-groupicon{\n        position: relative;\n        .addonset{\n            position: absolute;\n            right: 12px;\n            top: 50%;\n            line-height: 0;\n            @include transform(translateY(-50%));\n            @include respond-below(custom991) {\n               display: none;\n            }\n        }\n        \n    }\n    .input-groupicon.select-code {\n        input[type=\"text\"],\n        input[type=\"password\"] {\n            padding: 0;\n            &::placeholder {\n                padding-left: 10px !important;\n                \n            }\n        }\n    }   \n    input[type=\"text\"],\n    input[type=\"password\"], input[type=\"email\"] {\n        border:1px solid rgba(145, 158, 171, 0.32);\n        height: 40px;\n        font-size: $font-size-base;\n        font-weight: $font-weight-medium;\n        color: $secondary;\n        @include margin-padding(null, 10px 10px);\n        @include rounded(5px);\n        width: 100%;\n        \n    }\n    .display-btn {\n        color: $white;\n        border-radius: 8px;\n        background: $secondary;\n        padding: 10px 34px;\n        font-size:$font-size-base;\n        font-weight: $font-weight-bold;\n        .info-img {\n            position: absolute;\n            top: 50%;\n            z-index: 999;\n            width: 16px;\n            height: 16px;\n            left: 5px;\n            margin-left: 10px;\n            margin-right: 8px;\n            color: $white;\n            transform: translateY(-50%);\n            line-height: normal;\n        }\n    }\n    .btn-filters {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        background: $primary;\n        color: $white;\n        width: 89px;\n        height: 38px;\n        border-radius: 8px;\n        padding: 0;\n        &:hover{\n            background: $title-color;\n        }\n        &:active {\n            color: $white;\n            background: $title-color;\n        }\n        .feather-search {\n            width: 16px;\n            height: 16px;\n            margin-right: 8px;\n        }\n    }\n    textarea{\n        border:1px solid rgba(145, 158, 171, 0.32);\n        height: 100px;\n        width: 100%;\n        font-size: $font-size-base;\n        font-weight: $font-weight-normal;\n        color: $black;;\n        @include margin-padding(null, 10px 15px);\n        @include rounded(5px);\n    }\n    .text-form {\n        width: 100%;\n    }\n    \n}\n.input-blocks.date-group {\n    margin-top: 29px;\n}\n\n.bd-placeholder-img {\n    margin: .125rem;\n}\n.h-250 {\n    height: 250px;\n}\n","[data-layout-mode=dark_mode] {\n    .searchinputs input {\n        border-color: $black-bg;\n        background: $input-bg;\n    }\n    h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {\n        color: $theme-title;\n    }\n    &[data-nav-color=grey] {\n        .header {\n            background: $black-bg;\n            .user-menu .nav-item-box > a {\n                background: $input-bg;\n            }\n        }\n        .sidebar .slimScrollDiv, .sidebars .slimScrollDiv {\n            background: $black-bg;\n        }\n        .searchinputs input {\n            border-color: $black-bg;\n            background: $input-bg;\n        }\n    }\n    &[data-layout-style=collapsed] {\n        &[data-nav-color=grey] {\n            aside {\n                background: $black-bg;\n            }\n        }\n    }\n    &[data-layout-style=horizontal] {\n        .sidebar.horizontal-sidebar {\n            background: $black-bg;\n            border-top-color: $input-bg;\n        }\n        .horizontal-sidebar .sidebar-menu > ul > li.submenu ul {\n            background: $black-bg;\n        }\n    }\n    &[data-layout-style=modern] {\n        .page-wrapper .content {\n            background: $black-bg;\n        }\n    }\n    --bs-heading-color: $black-bg;\n    --dt-html-background: $black-bg;\n    &:root {\n        --dt-html-background: $black-bg;\n    }\n    &[data-layout-style=collapsed] {\n        aside {\n            background-color: $black-bg;\n        }\n    }\n    .fc-unthemed th, .fc-unthemed td, .fc-unthemed thead, .fc-unthemed tbody, .fc-unthemed .fc-divider, .fc-unthemed .fc-row, .fc-unthemed .fc-popover {\n        border-color: $input-bg !important;\n    }\n    div#global-loader {\n        background-color: $black-bg !important;\n    }\n    body {\n        background-color: $black-bg;\n        color: $theme-title;\n        &.header-collapse {\n            .header {\n                .header-left {\n                    background-color: $black-bg;     \n                }\n            }\n        }\n        &.mini-sidebar\n        {\n            .header-left .logo-white {\n                display: none !important;\n            }\n        } \n        &.expand-menu {\n            .header-left .logo-white {\n                display: block !important;\n            }\n        }\n        .page-wrapper-new {\n            background-color: $black-bg; \n        }\n        label, .form-label, .form-control,.notes-summernote p {\n            color: $theme-title;\n        }\n    }\n    background-color: $black-bg;\n    color: $theme-title;\n    .header {\n        background: $black-bg;\n        border-bottom: 1px solid $navy;\n        .header-left {\n            border-color: $navy; \n            border-bottom: 1px solid $navy;      \n            .logo-normal {\n                display: none;\n            }\n            .logo-white {\n                display: block !important;\n            }\n        }\n    }\n    table {\n        background: $black-bg;\n        --bs-table-bg: transparent;\n    }\n    .sidebar {\n        border-right: 1px solid $navy;\n        background-color: $black-bg;\n        .slimScrollDiv{\n            background: $black-bg;\n        }\n        &.collapsed-sidebar {\n            border: 0;\n        }\n        .sidebar-menu > {\n            ul > li {\n                &.submenu ul {\n                    background: $black-bg;\n                    border-radius: 5px;\n                    padding: 10px 0;\n                    li {\n                        a {                            \n                            color: $gray-500;\n                        }\n                    }\n                }\n                a {\n                    img {\n                        filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);\n                    }\n                    span {\n                        color: $gray-500;\n                    }\n                    &:hover {\n                        img {\n                            color: $gray-500;\n                        }\n                        svg{\n                            filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);\n                        }\n                    }\n                }\n                .submenu-hdr {\n                    color: $gray-500 !important;\n                }\n            }\n        }\n    }\n    .sidebar .sidebar-menu > ul > li.submenu-open ul, .sidebars .sidebar-menu > ul > li.submenu-open ul {\n        border-bottom: 1px solid $navy;\n    }\n    .page-wrapper {\n        background: $black-bg;\n        &.page-wrapper-three {\n            .content {\n                background: $black-bg;\n            }\n        }\n    }\n    #toggle_btn{\n        &:before{\n            border: 2px solid $theme-title;\n        }\n    }\n    .user-menu.nav > li > a.select-store {\n        .user-info .user-name {\n            color: $theme-title;\n        }\n    }\n    .user-info .user-name {\n        color: $theme-title;\n    }\n    .user-menu {\n        .nav-item-box {\n            > a{\n                background: $secondary;\n            }\n        }\n    }\n    .header-left{\n        &.active {\n            #toggle_btn:after {\n                border: 2px solid $theme-title;\n            }\n        }\n    }\n    .dash-widget{\n        background: $card-dark-bg;\n        border: 1px solid $navy;\n        .dash-widgetcontent {\n            h5 {\n                color: $theme-title;\n            }\n            h6 {\n                color: $theme-title;\n            }\n        }\n    }\n    .page-header {\n        h4, h6 {\n            color: $theme-title;\n        }\n    }\n    .form-control {\n        color: $theme-title;\n        border: 1px solid $navy;        \n    }\n    select.form-control {\n        &:focus {\n            color: $theme-title;\n        }\n    }\n    .input-blocks label {\n        color: $theme-title;\n    }\n    .dataTables_info {\n        color: $theme-title;\n    }\n    .setvaluecash ul li a {\n        color: $theme-title;\n    }\n    .inbox-menu li a i {\n        color: $theme-title;\n    }\n    .card{\n        background-color: $card-dark-bg;\n        border: 1px solid $navy;\n        .card-header {\n            border-color: $navy;\n            .card-title {\n                color: $theme-title;\n            }\n        }\n        .card-body {\n            .card-title {\n                color: $theme-title;\n            }\n        }\n    }\n    .modal-content {\n        background-color: $gray-900;\n        .modal-header {\n            border-bottom: 1px solid $navy;\n        }\n    }\n    .inputcheck {\n        color: $theme-title;\n    }\n    .custom_radio {\n        color: $theme-title;\n    }\n    .fc th.fc-widget-header {\n        background-color: $gray-900;\n        border-color: $input-bg;\n    }\n    \n    .fc-day {\n        background-color: $gray-900 !important;\n    }\n    \n    .chat-cont-left .chat-scroll .media {\n        .media-body {\n            .user-name, .user-last-chat {\n                color: $theme-title;\n            }  \n        } \n        &.active, &:hover {\n            background: $title-color;\n        }\n    }\n    .chat-cont-right ul.list-unstyled .media.sent .media-body .msg-box p {    \n        color: $secondary;\n    }\n    .inbox-menu {\n        li {\n            a {\n                color: $theme-title;\n            }\n        }\n    }\n    .increment-decrement .quantity-field {\n        color: $theme-title;\n    }\n    .select2-results__options {\n        color: $gray-800;\n    }\n    .image-upload .image-uploads h4 {\n        color: $theme-title;\n    }\n    .horizontal-sidebar {\n        background: $black-bg;\n        border-top: 1px solid $navy;\n        &.side-three {\n            border-color: $navy;\n        }\n        .sidebar-menu > ul > li {\n            & > a {\n                span {\n                    color: $gray-500;\n                }                \n                img, svg {\n                    filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-         rotate(165deg) brightness(93%) contrast(88%);\n                }\n            }\n            &.submenu ul {            \n                background: $black-bg;\n                li {\n                    a {                        \n                        color: $gray-500;\n                    }\n                    img, svg {\n                        filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%) !important;\n                    }\n                    \n                    & > ul {\n                        box-shadow: none;\n                    }\n                }\n            }\n        }\n       \n    }\n    .sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li ul li.submenu {\n        a {\n            svg {\n                filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);\n            }\n        }\n        ul li a {\n            color: $gray-500;\n        }\n    }\n    .table {\n        thead {\n            background: $black-bg;\n            border-bottom: 1px solid $black-bg;\n            tr{\n                &:hover {\n                    background: transparent;\n                }\n                th{\n                    color: $theme-title;\n                }\n               \n            }\n        }\n        tbody {\n            tr {\n                &:hover {\n                    background: transparent;\n                }\n                td {\n                    color: $theme-title;\n                    border-bottom: 1px solid $navy;\n                    background: $card-dark-bg;\n                    a {\n                        color: $theme-title !important;\n                        &:hover {\n                            color: $primary !important;\n                        }\n                    }\n                    &.action-table-data {\n                        .edit-delete-action {\n                            a {\n                                &:hover {\n                                    background-color: rgb(40, 142, 199);\n                                    border-color: rgb(40, 142, 199);\n                                }\n                            }\n                            .confirm-text {\n                                &:hover {\n                                    background-color: $danger;\n                                    border-color: $danger;\n                                }\n                            }\n                        }\n                        a {\n                            .action-eye {\n                                color: $theme-title\n                            }\n                        }\n                    } \n                }\n            }\n           \n        }\n    }\n    .sidebar.collapsed-sidebar .ui-aside .nav-item .nav-link {\n        border-bottom: $navy;\n    }\n    .sidebar.collapsed-sidebar .sidebar-menu ul li a img {        \n        filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);\n    }\n    .select2-results__option {\n        background: $gray-900;\n        color: $theme-title;\n    }\n    .custom-file-container label {\n        color: $theme-title;\n    }\n    .select2-dropdown {\n        border: 2px solid #26264e;\n    }\n    .swal2-popup {\n        background-color: $gray-900;\n        .swal2-title {\n            color: $theme-title;\n        }\n        .swal2-html-container {\n            color: $theme-title;\n        }\n    }\n    .searchinputs {\n        input {\n            border: 1px solid $navy;\n            background: $card-dark-bg;\n            color: $theme-title;\n            &::placeholder {\n                color: $gray-500;\n            }\n        }\n    }\n    .image-upload-new .productviewscontent .productviewsname {\n        h2,h3 {\n            color: $gray-500;\n        }\n    }\n    .split-card {\n        &::before,&::after {\n            background: $navy;\n        }\n    }\n    input[type=\"email\"]{\n        border: 1px solid $gray-700; \n    }\n    .tabs-set .nav-tabs .nav-link {\n        background: $black-bg;\n        color: $theme-title;\n        &.active {\n            background: $primary;\n            color: $white;\n        }\n    }\n    .bor-b1 {\n        border-bottom: 1px solid $navy;\n    }\n    .total-order ul li {\n        border: 1px solid $navy;\n        &:first-child {\n            border-top: 1px solid $navy;\n        }\n        h4 {\n            border-right: 1px solid $navy;\n        }\n    }\n    hr {\n        background-color: $navy;\n        border-top: 1px solid $navy;\n    }\n    .inputcheck .checkmark {\n        background: transparent;\n    }\n    .productset {\n        background-color: $gray-900;\n        border: 1px solid $navy;\n        .productsetcontent {\n            h4 {\n                color: $gray-500;\n            }\n        }\n    }\n    .graph-sets {\n        .btn-light {\n            background-color: $black-bg !important;\n            color: $gray-500 !important;\n            border: 1px solid $navy !important;\n            box-shadow: none;\n            &:hover {\n               color: $gray-500 !important; \n            }\n        }\n        .btn-white {\n            background-color: $black-bg;\n            color: $gray-500;\n            &:hover {\n               color: $gray-500; \n            }\n        }\n        .dropdown-menu {\n            background-color: $black-bg;\n            border: 1px solid $navy;\n            .dropdown-item {\n                color: $gray-500;\n                &:hover {\n                   color: $gray-500; \n                   background: $gray-900;\n                } \n            }\n        }\n    }\n    .view-all-link {\n        a {\n            color: $theme-title;\n            &:hover {\n                color: $primary;\n            }\n        }\n    }\n    .header {\n        .dropdown-menu {\n            background: $black-bg;\n            color: $theme-title;\n        }\n    }\n    .order-list .orderid{\n        h4, h5 {\n            color: $theme-title;\n        }\n    }\n    .productimg {\n    .productcontet h4{\n        color: $theme-title;\n    }\n    }\n    .topnav-dropdown-header {\n        border-bottom: 1px solid $navy;\n        .notification-title {\n            color: $theme-title;\n        }\n    }\n    .topnav-dropdown-footer {\n        border-top: 1px solid $navy;\n        a {\n            color: $theme-title;\n            &:hover {\n                color: $primary;\n            }\n        }\n    }\n    .user-menu.nav > li > a.select-store {\n        border: 1px solid $navy; \n    }\n    .custom-file-container .custom-file-container__custom-file__custom-file-control__button {\n        color: $theme-title;\n    }\n    .notifications {\n        .notification-list {\n            li {\n                border-bottom: 1px solid $navy;\n                .noti-title {\n                    color: $theme-title;\n                }\n                .noti-details {\n                    color: $gray-500; \n                }\n                .notification-time {\n                    color: $gray-500;\n                }\n            }\n        }\n    }\n    .user-menu.nav {\n        li {\n            &.flag-nav {\n                .dropdown-menu {\n                    .dropdown-item {\n                        color: $gray-500;\n                        &.active{\n                            color: $white;\n                        }\n                        &:hover {\n                           background: $gray-900 url(../../../../public/assets/img/icons/check.svg) no-repeat calc(100% - 12px) center;\n                        } \n                    }\n                }\n            }\n        }\n        &.nav {\n            > li {\n                >  a {\n                    &.dropdown-toggle {\n                        &.nav-link {\n                            &.show {\n                                background: $gray-900;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .profilename {\n        .profileset {\n            h5, h6 {\n                color: $gray-500; \n            }\n        }\n    }\n    .header {\n        .menu-drop-user {\n            .dropdown-item {\n                color: $gray-500;\n                &:hover {\n                   color: $gray-500; \n                   background: $gray-900;\n                } \n            }\n        }\n    }\n    .card {\n        &.bg-white {\n            background-color: $gray-900 !important;\n        }\n        .card-header {\n            background-color: $card-dark-bg;\n            .dropset {\n                color: $gray-500;\n            }\n        }\n        .card-footer {\n            background-color: $gray-900;\n        }\n    }\n    .custom-file-container .custom-file-container__custom-file__custom-file-control {\n        border: 1px solid $navy;\n        .custom-file-container__custom-file__custom-file-control__button {\n            border-left: 1px solid $navy;\n        }\n    }\n    .scanner-set {\n        img {\n            filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);\n            width: 16px;\n        }\n    }\n    .dropdown-menu {\n        background: $black-bg;\n        color: $theme-title;\n        .dropdown-item {\n            color: $gray-500;\n            &:hover {\n               color: $gray-500; \n               background: $gray-900;\n            } \n        }\n    }\n    .page-header {\n        h3 {\n            color: $theme-title;\n        }\n    }\n    .search-set {\n        .search-input {\n            input[type=\"search\"] {\n               border: 1px solid $navy;\n               &::placeholder {\n                    color: $theme-title;\n                }\n            }\n        }\n    }\n    .input-blocks input[type=text], .input-blocks input[type=password],\n    .select2-container--default .select2-selection--single,\n    .select2-container--focus .select2-selection--single, .form-control, .form-select,\n    .select2-container--default .select2-selection--multiple {\n        background: $card-dark-bg  !important;     \n        color: $theme-title;  \n        &::placeholder {\n            color: $theme-title;  \n        } \n    }\n    .select2-container--default .select2-results__option[aria-selected=true] {\n        background: $gray-900 !important; \n        color: $theme-title !important;    \n    }\n    .select2-container--default .select2-selection--single .select2-selection__rendered {   \n        color: $theme-title;\n        border-color: $navy; \n        border: 1px solid $navy; \n    }\n    .select2-container--default .select2-selection--single {\n        border-color: $navy; \n        border: 1px solid $navy; \n    }\n    .select2-container--focus .select2-selection--single {\n        border-color: $navy; \n        border: 1px solid $navy; \n    }\n    .input-blocks{\n        input[type=text]{\n            &:focus{\n                border-color: $navy;\n            }\n        }\n    }\n    .custom-file-container {\n        .custom-file-container__custom-file__custom-file-control {\n            background: $gray-900;\n            color: $theme-title;\n             border-color: transparent;\n        }\n    }\n    .input-group-text {\n        background: $gray-900;\n        color: $theme-title;\n        border:1.5px solid rgba(145, 158, 171, 0.32);\n    }\n    .image-upload {\n        &:hover {\n             background: $gray-900;\n        }\n    }\n    .productdetails {\n        &  > ul {\n            &  > li {\n                h4 {\n                    color: $gray-500;\n                }\n            }\n        }\n    }\n    .profile-set .profile-top .profile-contentname h2 {\n        color: $theme-title;\n    }\n    .total-order {\n        ul {\n            li {\n                h4 {\n                    background: $gray-900;\n                }\n                h5 {\n                    color: $theme-title;\n                }\n            }\n        }\n    }\n    .product-details {\n        background: $gray-900;\n        h6 {\n            color: $theme-title;\n        }\n    }\n    .comp-section {\n        .card-header {\n            border: 1px solid $navy;\n        }\n       .nav-tabs.nav-tabs-solid {\n            background-color: $gray-900;\n        }\n    }\n    .list-group-item {\n        background: $gray-900;\n        color: $theme-title;\n    }\n    .bg-white {\n        background-color: $gray-900 !important;\n    }\n    .section-header {\n        .section-title {\n            color: $theme-title;\n        }\n    }\n    .breadcrumb .breadcrumb-item a {\n        color: $theme-title;\n    }\n    .product-list ul li {\n        .productviews .productviewscontent .productviewsname {\n            h2, h3 {\n                color: $theme-title;\n            }\n        }\n    }\n    .select2-container--default.select2-container--open .select2-selection--single .select2-selection__arrow b {\n        border-color: $theme-title;\n    }\n    .alertify {\n        .ajs-header {\n            background: $gray-900;\n        }\n        .ajs-dialog {\n            background: $gray-900;\n        }\n        .ajs-footer {\n            background: $gray-900;\n            .ajs-buttons .ajs-button {\n                color: $theme-title;\n            }\n        }\n    }\n    .bs-popover-auto[data-popper-placement^=top]>.popover-arrow::after, .bs-popover-top>.popover-arrow::after {\n        border-top-color: $navy;\n    }\n    .popover {\n        background-color: $gray-900;\n        border: 1px solid $navy;\n        .popover-header {\n            background-color: $gray-900;\n            border-bottom: 1px solid $navy;\n        }\n        .popover-body {\n            color: $theme-title;\n        }\n    }\n    .scroll-demo {\n        border: 1px solid $navy;\n    }\n    .timeline:before {\n        background-color: $navy;\n    }\n    .timeline > li  {\n        & > .timeline-panel {\n            border: 1px solid $navy;\n            &::before {\n                border-top: 8px solid transparent;\n                border-right: 0 solid $navy;\n                border-bottom: 8px solid transparent;\n                border-left: 8px solid $navy;\n            }\n            &::after {\n                border-top: 7px solid transparent;\n                border-right: 0 solid $navy;\n                border-bottom: 7px solid transparent;\n                border-left: 7px solid $navy;\n            }\n        }\n        &.timeline-inverted > .timeline-panel:after {\n            border-right-width: 7px;\n            border-left-width: 0;\n        }\n        &.timeline-inverted > .timeline-panel::before {\n            border-right-width: 8px;\n            border-left-width: 0;\n        }\n    }\n    .twitter-bs-wizard .twitter-bs-wizard-nav .nav-link::after {\n        background-color: $navy;\n    }\n    .btn-white {\n        background-color: $black-bg;\n        border: 1px solid $navy;\n        color: $theme-title;  \n    }\n    .calendar-events:hover {\n        background-color: $navy;\n        border: 1px solid $navy;\n        color: $theme-title;  \n    }\n    .fc-button {\n        color: $theme-title;\n        background: $secondary;\n        text-shadow: none;\n    }\n    .sidebar.side-three.horizontal-sidebar .sidebar-menu > ul > li > a {\n        span {\n            color: $gray-500 !important;\n        }\n        img, svg {\n            filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);\n        }\n    }\n    .cardhead .card-header {\n        border-bottom: 1px solid $navy;\n    }\n    .sidebar-content {\n        background: $gray-900;\n        .sidebar-header {\n            border: 1px solid $navy;\n            h5 {\n                color:$white;\n            }\n            a img {\n                filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);\n            }\n        }\n        .switch-wrapper {\n            border-bottom: 1px solid $navy;\n        }\n        .layout-wrap {\n            .status-text {\n                 color: $theme-title;\n            }\n            .status-toggle .checktoggle {\n                background: $theme-title;\n            }\n        }\n    }\n    .login-logo.logo-normal {\n        display: none;\n    }\n    .login-logo.logo-white {\n        display: block !important;\n    }\n    .login-wrapper .login-content {\n        .login-userheading {\n            h3,h4 {\n                color: $theme-title;\n            }\n        }\n        .form-login {\n            label {\n                color: $theme-title;\n            }\n        }\n        .signinform {\n            h4{\n                color: $theme-title;\n                a {\n                    color: $theme-title;\n                }\n            }\n        }\n        .form-sociallink ul li a {\n            color: $theme-title;\n            &:hover {\n                color: $white;\n            }\n        }\n        .form-login {\n            input {\n                background: $gray-900 !important;     \n                color: $theme-title;  \n                &::placeholder {\n                    color: $theme-title;  \n                } \n            }\n        }\n    }\n    .welcome {\n        background-color: $black-bg;\n        color: $theme-title;\n    }\n    .table-top-head {\n        li {\n            a {\n                background-color: $black-bg;\n                border: 1px solid $navy;\n                svg {\n                    color: $theme-title;\n                }\n                &:hover {\n                    background: $title-color;\n                }\n            }\n        }\n    } \n    .sales-cards {\n        .card {\n            h3,p {\n                color: $theme-title !important;\n            }\n        }\n    }\n    .main-chat-blk {\n        .all-chats {\n            background: $secondary;\n        }\n        .chat-member-details .member-details ul li {\n            span,h5 {\n                color: $gray-600;\n            }\n        } \n        .right-sidebar .right-sidebar-wrap {\n            background: $black-bg;\n        }\n        .sidebar-body {\n            .profile-name {\n                color: $theme-title;\n            }\n        }\n        .chat-page-wrapper {\n            .setting-title-head {\n                h4 {\n                    color: $theme-title;\n                }\n            } \n            .left-chat-title {\n                border-bottom-color: $gray-600;\n                background: $black-bg;\n            }\n            .dropdown-menu {\n                background: $black-bg;\n                border-color: $gray-600;\n                .dropdown-item {\n                    color: $theme-title;\n                    i {\n                        color: $theme-title;\n                    }\n                }\n            }\n        } \n        .top-online-contacts {\n            background: $black-bg;\n        }\n        .sidebar-body {\n            background: $black-bg;\n        }\n        .sidebar {\n            .user-list {\n                li {\n                    a {\n                        border-color: $gray-600;\n                    }\n                    .users-list-body {\n                        h5,p {\n                            color: $theme-title;\n                        }\n                        .last-chat-time {\n                            .text-muted {\n                                color: $sub-title !important;\n                            }\n                        }\n                    }\n                }\n            } \n        } \n        .chat {\n            background: $black-bg;\n            .chat-header {\n                background: $black-bg;\n                box-shadow: none;\n                .user-details {\n                    h5,small {\n                        color: $theme-title;\n                    }\n                } \n                li {\n                    a {\n                        i {\n                            color: #67748E;\n                        }\n                    }\n                }\n            }\n            .chat-body .messages .chat-profile-name h6 {\n                color: $theme-title;\n            }\n        } \n        .main-wrapper {\n            .content .sidebar-group .sidebar {\n                border-right-color: $gray-600;\n            }\n        } \n    } \n    .part-name.sub-part-name,.recession-meet-blk .partispant-blk span a {\n        background: $secondary;\n        h4 {\n            color: $theme-title;\n        }\n    }\n    .more-icon a {\n        background: $secondary;\n    }\n    .recession-meet-blk .reccession-head h5 {\n        color: $theme-title;\n    }\n    .welcome {\n        button, a {\n            border-color: $navy;\n            color: $theme-title;\n        }\n    }\n    .bar-code-view {\n        border-color: $navy;        \n    }\n    .productdetails {\n        > ul {\n            > li {\n                border-color: $navy;\n                h4 {\n                    border-color: $navy;                    \n                }\n                &:last-child {\n                    border-color: $navy;                    \n                }\n                &:first-child {\n                    border-color: $navy;                    \n                }\n            }\n        }\n    }\n    .right-user-side {\n        .slimscroll {\n            background: $black-bg;\n            border-color: $gray-600;\n            .left-chat-title {\n                background: $secondary;\n                border-bottom-color: $gray-600 !important;\n                .chat-title h4 {\n                    color: $theme-title;\n                }\n            }\n            .chat-footer {\n                background: $black-bg;\n            }\n        } \n        &.right-side-party {\n            .slimscroll {\n                background: $black-bg;\n                border-color: $gray-600;\n                .left-chat-title {\n                    background: $secondary;\n                    .chat-title h4 {\n                        color: $theme-title;\n                    }\n                }\n                .chat-footer {\n                    background: $black-bg;\n                }\n                .card-body-blk .user-list .user-list-item {\n                    background: $secondary;\n                }\n            } \n        }\n    } \n    .history-modal-profile .right-sidebar-profile {\n        background: $black-bg;\n    }\n    .modal-profile-detail .modal-userlist li {\n        color: $theme-title;\n    }\n    .fc-unthemed td {\n        color: $theme-title;\n    }\n    .notes-dash {\n        background: $black-bg;\n        border-color: $navy;\n        .notes-top-head {\n            border-bottom: 1px solid $navy;\n            h5 {\n                color: $theme-title;\n            }\n        }\n        .content-submenu-tag h6 {\n            color: $theme-title;\n        }\n    }\n    .notes-page-wrapper {\n        .content {\n            .section-bulk-wrap {\n                background: $black-bg;\n                box-shadow: 0px 4px 60px 0px $white-7;\n            }\n            .section-card-body {\n                .notes-card-details {\n                    background: $black-bg;\n                    box-shadow: 0px 4px 60px 0px $white-1;\n                    border-color: $navy;\n                    .notes-card-body {\n                        a {\n                            color: $text-color;\n                        }\n                    }\n                    .notes-wrap-content {\n                        h4 {\n                            a {\n                                color: $theme-title;\n                            }\n                        } \n                    } \n                }\n                .dropdown-menu {\n                    border-color: $navy;\n                }\n            } \n            .notes-card-body {\n                .dropdown-menu {\n                    border-color: $navy;\n                    box-shadow: unset;\n                }\n            }\n            .section-notes-slider {\n                .notes-card {\n                    .notes-card-body {\n                        a {\n                            color: $text-color;\n                        }\n                    }\n                    .notes-slider-content {\n                        h4 {\n                            a {\n                                color: $theme-title;\n                            }\n                        } \n                    } \n                } \n            } \n        }\n    }\n    .todo-today-content .todo-today-header h3 {\n        color: $theme-title;\n    }\n    .todo-wrapper-list {\n        background: $black-bg;\n        border-color: $navy;\n        .todo-inbox-check {\n            .todo-wrapper-list-content {\n                h4 {\n                    color: $theme-title;\n                }\n            } \n        } \n    }\n    .dropdown-menu.notes-menu a.dropdown-item {\n        color: $gray-500;\n    }\n    .notes-header h3 {\n        color: $theme-title;\n    }\n    .custom-modal-header {\n        background: $secondary;\n        .page-title {\n            h4 {\n                color: $theme-title;\n            }\n        }\n    }\n    .search-set .search-input .btn-searchset {\n        color: #5B6670;\n    }\n    .accordion {\n        background: transparent;\n        --bs-accordion-bg: $card-dark-bg;\n        .accordion-item {\n            background: $card-dark-bg;\n        }\n    }\n    .accordion-card-one .accordion-item .accordion-button {\n        &:not(.collapsed) {\n            background: transparent !important;\n        }\n        .addproduct-icon h5 {\n            color: $theme-title;\n        }\n    }\n    .card .card-body.add-product .text-editor.add-list.add .custom-filed {\n        background: transparent;\n    }\n    .bootstrap-tagsinput {\n        background: $black-bg;\n        border: 1px solid $gray-700;\n    }\n    .product-quantity {\n        background: $black-bg;\n        span {\n            color: $theme-title;\n        }\n        input {\n            background: $black-bg;\n            color: $theme-title;\n        }\n    }\n    .searchinputs.list input {\n        background: $black-bg;\n    }\n    .table-tab ul li button.nav-link {\n        color: $theme-title;\n        background-color: $card-dark-bg;\n    }\n    .table-top-head li {\n        .status-toggle {\n            background: $black-bg;\n        }\n    } \n    .barcode-content-list {\n        background: $black-bg;\n        .search-modal-header {\n            background: $gray-900;\n        }\n        .paper-search-size {\n            .search-toggle-list {\n                p {\n                    color: $theme-title;\n                }\n            } \n        } \n    } \n    .barcode-scanner-link {\n        background: $black-bg;\n        h6 {\n            color: $theme-title;\n        }\n    }\n    .seacrh-barcode-item .searchInput {\n        background: $black-bg;\n    }\n    .barcode-scan-header h5 {\n        color: $theme-title;\n    }\n    .modal-body-table {\n        background: $gray-900;\n    }\n    span.customer-toggle,.status-label {\n        color: $theme-title;\n    }\n    .layout-drop-item .drop-item-head h5,p {\n        color: $theme-title;\n    }\n    .total-employees {\n        background: $black-bg;\n        h6 {\n            color: $theme-title;\n        }\n    }\n    .employee-grid-profile {\n        border-color: $gray-700;\n        background: $black-bg;\n        ul.department {\n            background: $gray-900;\n            li {\n                color: $theme-title;\n            }\n        }\n        .profile-info.department-profile-info {\n            background: $gray-900;\n        }\n    }\n    aside {\n        border-color: $navy;\n        &.product-order-list {\n            .block-section {\n                border-color: $navy;\n            }\n            .btn-block {\n                border-color: $navy;\n            }\n        }\n    }\n    .product-wrap .product-list .action a {\n        border-color: $navy;        \n    }\n    .pos-categories, aside, .pos-products .product-info .img-bg{\n        background: $black-bg;\n    }\n    aside.product-order-list .order-total, aside.product-order-list .order-total table {\n        background: $gray-900;\n    }\n    .product-wrap .product-list {\n        box-shadow: none;\n        background: $gray-900;\n    }\n    .pos-categories h5, .pos-categories h6, .order-list h5, .order-list h6, .pos-products .product-info h6.product-name a, .product-wrap .product-list .qty-item .dec, .product-wrap .product-list .qty-item .inc, aside.product-order-list .payment-method .methods .default-cover a span, .product-wrap .product-list .info h6 a, .file-manager aside h5, .file-manager aside ul li a, .file-manager h4, .file-manager h6 a, .file-manager .accordion .accordion-item .accordion-button::after, .fc-toolbar h2, .file-manager, .file-manager .card, .search-dropdown .search-info h6, .search-dropdown .search-info h6 svg, .search-set .search-input .btn-searchset .feather-search {\n        color: $theme-title;\n    }\n    .file-manager aside .dropdown > a .feather-16, .file-manager aside ul li a .feather-16, .file-manager .project-plan ul li, .file-manager .project-plan label, .file-manager .page-header .btn-added .feather-16 {\n        color: $white;\n    }\n    aside.product-order-list .head, .file-manager .info, .file-manager .folders {\n        background: $gray-900;\n    }\n    .file-manager .folders {\n        border-color: $navy;\n        background: $card-dark-bg;\n    }\n    .file-manager .folders, .file-manager .info {\n        box-shadow: none;\n    }\n    aside.product-order-list .payment-method .methods .default-cover img {\n        filter: invert(75%) sepia(66%) saturate(1955%) hue-rotate(327deg) brightness(103%) contrast(102%);\n    }\n    .page-wrapper .content.settings-content,.sidebars {\n        background: $black-bg;\n    }\n    .sidebars.settings-sidebar {\n        .sidebar-menu {\n            .submenu-open {\n                ul {\n                    .submenu {\n                        a {\n                            span {\n                                color: $theme-title;\n                            }\n                            &.active {\n                                background: $secondary;\n                                &.subdrop {\n                                    background: $secondary;\n                                }\n                            }\n                            svg {\n                                color: #67748E;\n                            }\n                        } \n                    } \n                } \n            } \n        }\n    } \n    .security-settings {\n        ul {\n            li {\n                .security-btn .manage-btn {\n                    color: $theme-title;\n                }\n                .security-type {\n                    .security-icon {\n                        background: $secondary;\n                    }\n                } \n            } \n        } \n    } \n    .connected-app-card ul {\n        background: $black-bg;\n        box-shadow: 0px 4px 60px 0px $gray-800;\n        li .integration-btn a {\n            background: $secondary;\n            color: $theme-title;\n        }\n    }\n    .header-left #toggle_btn svg, .btn-row .btn svg {\n        color: $white;\n    }\n    .table.profit-table thead,.table.profit-table tbody .profit-table-bg td {\n        background: $secondary;\n        color: $theme-title;\n    }\n    .comming-soon-pg .coming-soon-box {\n        background: $secondary;\n        opacity: 0.9;\n        .coming-soon-timer li {\n            background: $secondary;\n            color: $theme-title;\n            span {\n                color: $theme-title;\n            }\n        }\n    }\n    .login-wrapper.bg-img .login-content {\n        background: $secondary;\n        opacity: 0.9;\n    }\n    .login-wrapper .login-content .login-logo {\n        display: none;\n    }\n    .pos-modal .modal-header,.pos-modal#hold-order h2 {\n        background: $black-bg;\n        color: $theme-title;\n    }\n    .pos-modal#orders .order-body .record {\n        table {\n            background: transparent;\n        }\n    }\n    .tabs_wrapper ul.tabs li {\n        background: $secondary;\n    }\n    .pos-category {\n        .default-cover {\n            h6 a {\n                color: $theme-title;\n            }\n            span {\n                color: #B8BCC9;\n            }\n        }\n        .owl-item {\n            background: $secondary;\n            box-shadow: none;\n            border-color: $navy;\n            h6 {\n                a {\n                    color: $theme-title;\n                }\n            }\n        }\n    }\n    aside.product-order-list {\n        h6 {\n            color: $theme-title;\n        }\n        .head {\n            h5 {\n                color: $theme-title;\n            }\n        }\n\n    }\n    #print-receipt .modal-body .tax-invoice span, #print-receipt .modal-body table thead th, #print-receipt .modal-body table tbody tr table tr:last-child td {\n        color: $theme-title;\n    }\n    aside.product-order-list .order-total table tr td {\n        border-bottom: none;\n    }\n    #print-receipt .modal-body table {\n        background: none;\n    }\n    .sidebar-footer {\n        background: $black-bg;\n    }\n    .sidebar-content .theme-head h6 {\n        color: $theme-title;\n    }\n    table tbody td.action-table-data a {\n        background: $secondary;\n    }\n    .disabled>.page-link {\n        color: #67748E;\n    }\n    .apply-leave {\n        background: $card-dark-bg;\n    }\n    .card .card-body .payslip-month .month-of-slip h4 {\n        color: $theme-title;\n    }\n    .paysilp-table-border th,.payslip-border-bottom th {\n        color: $theme-title;\n    }\n    .card .card-body .emp-details {\n        .emp-name-id {\n            h6 {\n                color: $theme-title;\n            }\n            span {\n                color: #5B6670;\n            }\n        } \n        .emp-location-info {\n            h6 {\n                color: $theme-title;\n            }\n            span {\n                color: #5B6670;\n            }\n        }\n    } \n    .pay-slip-box .card .card-body .emp-details.justify-content-start {\n        background: $black-bg ;\n    }\n    .card .card-body .emp-details {\n        background: $black-bg ;\n    }\n    .connected-app-card ul li .security-title h5,.appearance-settings h6,.logo-company li .logo-info h6 {\n        color: $theme-title;\n    }\n    .localization-info .setting-info h6 {\n        color: $theme-title;\n    }\n    .login-wrapper .login-content.user-login .login-userset {\n        background: $card-dark-bg;\n        border-color: $card-dark-bg;\n        box-shadow: unset;\n    }\n    .custom-alert1 {\n        background: #212529;\n    }\n    .custom-alert-icon {\n        background: #212529 !important;\n    }\n    .accordion-button,.accordion .accordion-button.collapsed {\n        background: transparent !important;\n        &::after {\n            background: #212529;\n        }\n    }\n    .accordion-body {\n        background: $card-dark-bg;\n    }\n    .offcanvas {\n        background: $card-dark-bg;\n        color: $theme-title !important;\n    }\n    .activity {\n        .activity-list {\n            li {\n                background-color: $black-bg;\n                border: 1px solid $navy;\n                .activity-content {\n                    background-color: $black-bg;\n                }\n                a {\n                    color: $gray-700;\n                    &:hover {\n                        color: $primary;\n                    }\n                    &.name {\n                        color: $gray-400;\n                        &:hover {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    .select2-container--default .select2-results__option--highlighted[aria-selected] {\n        background: #FF9F43 !important;\n        color: #fff !important;\n    }\n    .profile-pic-upload {\n        .profile-pic {\n            span {\n                color: $theme-title;\n            }\n        }\n    }\n    .search-dropdown {\n        .search-info {\n            border-bottom: 1px solid $gray-600;\n        }\n    }\n    .card {\n        .card-body{\n            &.add-product{\n                .addproduct-icon{\n                    border-color: $navy;\n                }    \n            }\n        }\n    }\n    .add-product {\n        .add-icon {\n            a {\n                color: $sub-title;\n            }\n        }\n    }\n    .table-list-card {\n        .table-responsive {\n            border-top: 1px solid $navy;\n        }\n    }\n    .appearance-settings {\n        .theme-type-images {\n            .theme-image {\n                background: $secondary;\n                border-color: $secondary;\n                box-shadow: 0px 4px 60px 0px $white-1;\n            }\n        }\n    }\n    .attendance-widget {\n        .card {\n            .card-body {\n                .card.attendance {\n                    background: $black-bg;\n                }\n            }\n        }\n    }\n    .audio-call-group {\n        ul {\n            li {\n                .user-audio-call {\n                    h5 {\n                        color: $theme-title;\n                    }\n                }\n            }\n        }        \n    }\n    .record-time {\n        span {\n            color: $theme-title;\n        }\n    }\n    .bank-box {\n        &.active {\n             &::after {\n                background-color: $gray-800;\n             }\n        }\n        .bank-header {\n            .bank-name {\n                h6 {\n                    color: $theme-title;\n                }\n                p {\n                    color: $theme-title;\n                }\n            }\n        }\n        .bank-info {\n            h6 {\n                color: $theme-title;\n            }\n        }    \n    }\n    .sidebars.settings-sidebar {\n        .sidebar-menu {\n            .menu-arrow {\n                background-color: $theme-title;\n                &::before {\n                    border-left: 1px solid $black;\n                    border-bottom: 1px solid $black;\n                    color: $black;\n                }\n            }\n        }\n    }\n    .legendLabel {\n        color: $theme-title;\n    }\n    .main-chat-blk {\n        .chat .chat-body {\n            .messages {\n                .chats {\n                    .message-content {\n                        background: $secondary;\n                        color: $theme-title;\n                    }                \n                }    \n                .file-download {                \n                    background: $secondary;\n                    .file-details {\n                        span {\n                            &.file-name {\n                                color: $theme-title;\n                            }\n                        }\n                        ul {\n                            li {\n                                color: $theme-title;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .chat_form {\n            border: 1px solid $navy;\n            box-shadow: 0px 4px 4px $gray-800;\n        }\n        .chat-date {\n            background: $secondary;\n            color: $theme-title;\n            border: 1px solid $navy;\n            &:before {\n                background-color: $navy;\n            }\n        }\n        .chat-line {\n            &:before {\n                background-color: $navy;\n            }\n        }\n    }\n    .notes-page-wrapper {\n        .content {\n            .page-add-notes {\n                border-bottom: 1px solid $navy;\n            }\n        }\n    }\n    .file-manager {\n        aside {\n            box-shadow: 0px 4px 60px 0px $white-7;\n            h5 {\n                border-bottom: 1px solid $navy;\n            }\n        }\n    }\n    .seprator-lg {\n        border-bottom: 1px solid $navy;\n    }\n    .pos-modal.upload-modal {\n        .modal-body {\n            ul {\n                li {\n                    h6 {\n                        a {\n                            color: $theme-title;\n                        }\n                    }\n                }\n            }\n            p {\n                color: $theme-title;\n            }\n        }\n    }\n    .social-media-icons li a i {\n        color: $theme-title;\n    }\n    .employee-grid-profile .dropdown.profile-action svg {\n        color: $theme-title;\n    }\n    .login-wrapper .login-content .login-userset .my-4 p {\n        color: $theme-title;\n    }\n    .alert-secondary {\n        background-color: rgba(9, 44, 76, 0.8);\n        color: $white;\n        border-color: rgba(9, 44, 76, 0.8);\n    }\n    .badge{\n        &.text-dark{\n            color: $white;\n        }\n    }\n    .btn-outline-secondary{\n        border: 1px solid $blue !important;\n        color: $blue !important;\n    }\n    .btn-outline-light {\n        border: 1px solid $light;\n        color: $light !important;\n    }\n    .btn {\n        &.text-dark{\n            color: $white !important;\n        }  \n    }\n    .callout-info {\n        background-color: rgba(23, 162, 184, 0.25);\n        border-color: rgba(23, 162, 184, 0.5);\n        color: $white;\n    }\n    .callout-warning {\n        background-color: rgba(255, 153, 0, 0.25);\n        border-color: rgba(255, 153, 0, 0.5);\n        color: $white;\n    }\n    .callout-danger {\n        background-color: rgba(255, 0, 0, 0.25);\n        border-color: rgba(255, 0, 0, 0.5);\n        color: $white;\n    }\n    .grid-vertical {\n        color: #fff;\n        .bg-light {\n            background-color: transparent !important;\n        }   \n    }\n    .grid-showcase{\n        .text-dark {\n            color: $white !important;\n        }\n    }\n    .btn.btn-secondary-light {\n        background-color: rgba(9, 44, 76, 0.5);\n        color: #489be6;\n    }\n    .nav-tabs{\n        .nav-tabs-rounded {\n            border-radius: 50px;\n        }\n    }\n    .card {\n        .card-footer {\n            background-color: transparent;\n            color: $theme-title;\n        }\n    }\n    .file-manager .all-files {\n        box-shadow: 0px 4px 60px 0px $white-7;\n    }\n    .form-floating {\n        > .form-control-plaintext {\n            ~ label {\n                &::after {\n                    background-color: transparent;\n                }\n            }\n        }\n    }\n    .form-select {\n        border-color: $gray-700; \n    }\n    .productdetails {\n        > ul{\n            > li h6 {\n                color: $white;\n            }\n        }\n    }\n    .connected-app-card {\n        ul {\n            box-shadow: 0px 4px 6px 0px rgba(231, 231, 231, 0.17);\n        }\n    }\n    .login-wrapper {\n        .login-content.user-login {\n            .login-userset {\n                box-shadow: 0px 4px 6px 0px rgba(190, 190, 190, 0.27);\n            }\n        }\n    }\n    .sales-cards {\n        .card.color-info {\n            h3{\n                color: $white !important;\n            }\n            p{\n                color: $white !important;\n            }\n        }\n    }\n    .table{\n        &.table-borderless {\n            tr {\n                td .head-text {\n                    color: $theme-title;\n                }\n            }\n        }\n    }\n    .accordion {\n        .accordion-item {\n            background: transparent;\n        }\n    }\n    .card-text{\n        color: $theme-title;\n    }\n\n    .login-wrapper.login-new {\n        .login-content.user-login{\n            .login-userset form .otp-box input{\n                background: transparent;\n            }\n        }\n    }\n    .file-manager .accordion .accordion-item {\n        border-bottom: 1px solid $navy;\n    }\n    .main-chat-blk .review-files p {\n        color: $theme-title;\n    }\n    .main-chat-blk .chat-action-col > a {\n        color: $text-color;\n    }\n    .social-authent-settings .connected-app-card ul li:first-child {\n        border-bottom: 1px solid $navy;\n    }\n    .notes-page-wrapper {\n        .content {\n            .section-notes-slider {\n                border-bottom: 1px solid $navy;\n            }\n            .section-card-body {\n                .notes-card-details {\n                    .notes-wrap-content {\n                        border-bottom: 1px solid $navy;\n                    }\n                }\n            }\n        }    \n    }\n    .notes-dash .notes-top-head-submenu {\n        border-bottom: 1px solid $navy;\n    }\n    .login-body .login-wrapper .terms li {\n        a {\n            color: $theme-title;\n        }\n    }\n    .input-blocks .bootstrap-tagsinput .tag {  \n        background: $card-dark-bg;     \n        color: $theme-title; \n        border-color: $gray-700; \n    }\n    .company-info {\n        border-bottom: 1px solid $navy;\n    }\n    .apply-leave .leave-apply .leave-date p {\n        color: $theme-title;\n    }\n    .main-chat-blk .chat-page-wrapper .dropdown-menu .dropdown-item:hover {\n        color: $title-color;\n    }\n    .form-floating > .form-control:not(:placeholder-shown) ~ label::after {\n        background-color: transparent;\n    }\n    .form-select {\n        option {\n            background-color: transparent;\n        }\n    }\n    .selected-language {\n        color: $theme-title\n    }\n    .file-manager {\n        aside {\n            box-shadow: 0px 4px 60px 0px $white-7;\n            h6 {\n            color: $theme-title;\n            }\n        }\n    }\n    .table {\n        border-color: $navy;\n        tr {\n            th {\n                border-color: $navy;\n                color: $theme-title;\n            }\n        }\n        &.table-primary {\n            tr {\n                th {\n                    background-color: $card-dark-bg;\n                }\n            }\n        }\n    }\n    .pos-category .owl-nav button {\n        &.owl-next, &.owl-prev {\n            background-color: $card-dark-bg;\n            border: 1px solid $navy;\n            i {\n                color: $theme-title;                \n            }\n        }\n    }        \n    .select2-container--default {\n        &.select2-container--focus {\n            .select2-selection--multiple {\n                border-color: $navy;\n            }\n        }\n        .select2-selection--multiple {\n             border-color: $navy;\n        }\n    }\n    textarea {\n        &::placeholder {\n            color: $theme-title;\n        }\n    }\n}\n",".header {\n    background: $white;\n    border-bottom: 1px solid $gray-400;\n    height: 66px;\n    z-index: 999;\n    @include position(fixed,0,0,null,0);\n    @include transition(all 0.5s ease);\n    .flag-nav {\n        > a {\n            img {\n                border-radius: 50%;\n                width: 22px;\n                height: 22px;\n            }\n        }\n    }\n    .searchinputs{\n        @include transition(all 0.2s ease);\n    }\n    .dropdown-menu {\n        @include transition(all 0.5s ease);\n        @include transform(translate(0px, 100px));\n        box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.05);\n        border:0;\n        margin-top: 10px;\n        &.menu-drop-user {\n            margin-top: 7px !important;\n        }\n        @include respond-below(custom991) {\n            transition: none;\n        }\n    }\n    .header-left {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        float: left;\n        height: 66px;\n        position: relative;\n        text-align: center;\n        width: 260px;\n        z-index: 1;\n        @include margin-padding(null, 0 24px);\n        @include transition(all 0.5s ease);\n        border-right: 1px solid $border-color;\n        border-bottom: 1px solid $border-color;\n        .logo {\n            display: inline-block;\n            line-height: 0;\n            img{\n                width: 140px;\n            }\n            @include respond-below(custom991) {\n                text-align: center;\n                width: 100%;\n                img{\n                    width: 140px;\n                }\n            }\n        }\n        .logo-small{\n            display: none;\n        }\n        @include respond-below(custom991) {\n            position: absolute;\n            width:100%;\n        }\n    }\n\n    @include respond-below(custom991) {\n       .header-left #toggle_btn {\n            display: none;\n        }\n    }\n    @include respond-above(custom991) {\n        #toggle_btn {\n            float: left;\n            font-size: $font-size-26;\n            line-height: 50px;\n            \n            .bar-icon {\n                display: inline-block;\n                width: 21px;\n                span {\n                    background-color: $white;\n                    display: block;\n                    float: left;\n                    height: 2px;\n                    width: 21px;\n                    @include margin-padding(0 0 5px, null);\n                    @include rounded(50px);\n                    &:nth-child(2) {\n                        width: 15px;\n                    }\n                }\n            }\n        }\n\n    }\n    .page-title-box {\n        float: left;\n        height: 60px;\n        margin-bottom: 0;\n        @include margin-padding(null, 17px 20px);\n        @include rounded(0);\n        @include respond-below(custom991) {\n            display: none;\n        }\n        a {\n            color: $primary;\n            font-size: $font-size-11;\n            font-weight: $font-weight-bold;\n            border: 1px solid $primary;\n            @include margin-padding(0, 5px);\n            @include rounded(5px);\n            &:hover{\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n    .mobile_btn {\n        display: none;\n        float: left;\n        @include respond-below(custom991) {\n            color: $primary;\n            font-size: $font-size-24;\n            height: 60px;\n            line-height: 60px;\n            width: 60px;\n            z-index: 10;\n            @include margin-padding(null, 0 20px);\n            @include position(absolute,0,null,null,0);\n            display: block;\n        }\n       \n    }\n    .responsive-search {\n        display: none;\n        color: $white;\n        font-size: $font-size-20;\n        height: 60px;\n        line-height: 60px;\n        @include margin-padding(null, 0 15px);\n        @include respond-below(custom991) {\n            display: block;\n        }\n    }\n    .top-nav-search {\n        form {\n            position: relative;\n            @include respond-below(custom991) {\n                display: none;\n            }\n            .form-control {\n                background-color: rgba(255, 255, 255, 0.1);\n                border: 1px solid rgba(255, 255, 255, 0.15);\n                height: 40px;\n                @include margin-padding(null, 10px 50px 10px 15px);\n                @include rounded(50px);\n                &::-webkit-input-placeholder {\n                    color: rgba(255, 255, 255, 0.7);\n                }\n            }\n            .btn {\n                background-color: transparent;\n                border-color: transparent;\n                color: rgba(255, 255, 255, 0.7);\n                min-height: 40px;\n                @include position(absolute,0,0,null,null);\n            }\n        }\n        @include respond-below(custom991) {\n            &.active{\n                form {\n                    display: block;\n                    @include position(absolute,null,null,null,0);\n                    .form-control {\n                        background-color: $white;\n                    }\n                    .btn {\n                        background-color: transparent;\n                        border-color: transparent;\n                        min-height: 40px;\n                        @include position(absolute,0,0,null,null);\n                        @include margin-padding(null, 7px 15px);\n                    }\n                }\n            }\n        }\n    }\n    .userset {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        .usernames{\n            line-height: initial;\n            text-align: right;\n            padding-right: 10px;\n            span {\n                display: block;\n                line-height: initial;\n            }\n        } \n    }\n    .menu-drop-user{\n        .dropdown-item {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            color: $gray-600;\n            padding: 7px 10px !important;\n            svg {\n                stroke-width: 1px;\n                margin-right: 10px;\n                width: 18px;\n            }\n        }\n        .logout{\n            color: $danger;\n        }\n    }\n    .has-arrow{\n        .dropdown-toggle{\n            @include respond-below(custom991) {\n                > span{\n                    &:nth-child(2) {\n                        display: none;\n                    }\n                }\n                &:after{\n                    display: none !important;\n                }\n            }\n        }\n    }\n    .profilename {\n        .user-img {\n            .status {\n                bottom: 10px;\n            }\n        }\n    }\n    .user-img {\n        display: inline-block;\n        position: relative;\n        img {\n            width: 38px;\n            @include rounded(50%);\n        }\n        .status {\n            border: 2px solid $white;\n            height: 10px;\n            width: 10px;\n            @include margin-padding(0, null);\n            @include position(absolute,null,0,30px,null);\n            @include rounded(50%);\n            display: inline-block;\n            background: $success;\n        }\n    }\n    .mobile-user-menu {\n        color: $white;\n        display: none;\n        float: right;\n        font-size: $font-size-24;\n        height: 60px;\n        line-height: 60px;\n        text-align: right;\n        width: 60px;\n        z-index: 10;\n        @include margin-padding(null, 0 20px);\n        @include position(absolute,0,0,null,null);\n        @include respond-below(custom991) {\n            display: block;\n        }\n        a{\n            color: $primary;\n            padding: 0;\n            &::after{\n                display: none;\n            }\n        }\n        .dropdown-menu{\n            padding: 0;\n            a{\n                color:$gray-800;\n                line-height: 40px; \n                @include margin-padding(null, 0 10px);\n            }\n        }\n    }\n}\n.logo-small img {\n    width: 30px;\n}\n@include respond-above(custom992) {\n    .mini-sidebar{\n        &.expand-menu{\n            .header-left {\n                flex-direction:row;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;\n            }\n        }\n        .header-left {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            width: 80px;\n            @include margin-padding(null, 0);\n            flex-direction:column;\n            .logo-small{\n                display: block;\n                padding: 10px 0 0;\n            }\n            .logo{\n                display: none;\n            }\n        }\n        .menu-arrow{\n            display: none !important;\n        }\n        .chat-user{\n            display: none !important;\n        }\n        .user-menu{\n            .badge{\n                display: flex !important;\n            }  \n        }\n        &.expand-menu{\n            .menu-arrow{\n                display: block !important;\n            }\n            .chat-user{\n                display: block !important;\n            }\n            .logo-small{\n                display: none;\n            }\n            .logo{\n                display: block;\n            }\n            #toggle_btn{\n               opacity: 1;\n            }\n            .header-left{\n                @include margin-padding(null, 0 20px);\n                display: flex;\n            }\n            \n        }\n        .noti-dot{\n            &:before{\n                display: none;\n            }\n        }\n    }\n}\n.header-pos{\n    &.header {\n        position: relative;\n    }\n}\n.searchpart {\n    @include position(fixed,0,0,null,null);\n    height: 100vh;\n    background: $white;\n    z-index: 100000;\n    width: 350px;\n    margin-right: -350px;\n    @include transition(all 0.5s ease);\n    @include box-shadow(null, 0, 0px, 7px, null, rgba(0, 0, 0, .20));\n    &.active{\n        margin-right: 0;\n    }\n    .searchcontent {\n        @include margin-padding(null, 20px);\n        display: block;\n        height: 100%;\n    }\n    .searchhead {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        border-bottom: 1px solid $sub-title;\n        color: $gray-800;\n    }\n    .searchcontents {\n        @include margin-padding(null, 25px 0);\n    }\n    \n    .searchparts {\n        position: relative;\n        input[type=\"text\"] {\n            width: 100%;\n            height: 50px;\n            border: 1px solid $sub-title;\n            @include margin-padding(null, 0 15px);\n            @include rounded(50px);\n        }\n        .btn-searchs {\n            @include position(absolute,5px,10px,null,null);\n            background: $primary;\n            @include rounded(50px);\n            color: $white;\n        }\n    }\n    .recentsearch {\n        margin-top: 15px;\n        border-top: 1px solid $gray-500;\n        padding-top: 15px;\n        h2 {\n            font-size: $font-size-16;\n            margin-bottom: 25px;\n            color: $gray-800;\n            font-weight: $font-weight-bold;\n        }\n        li {\n            border-bottom: 1px solid $gray-500;\n            @include margin-padding(null, 10px);\n            h6 {\n                font-size: $font-size-base;\n            }\n        }\n    }\n    .searchhead h3 {\n        font-weight: $font-weight-semibold;\n        font-size: $font-size-20;\n    }\n}\n.header-pos{\n    @include margin-padding(null, 10px);\n    background: $white;\n    margin-bottom: 20px;\n    border-bottom: 1px solid $gray-300;\n    height: 80px;\n    @include respond-below(custom991) {\n        @include margin-padding(null, 10px);\n        height: auto;\n    }\n    #mobile_btn {\n        display: none;\n        float: left;\n        @include respond-below(custom991) {\n            color: $primary;\n            font-size: $font-size-24;\n            height: 60px;\n            line-height: 60px;\n            width: 60px;\n            z-index: 10;\n            @include margin-padding(null, 0 20px);\n            @include position(absolute,0,null,null,0);\n            display: block;\n        }\n    }\n}\n.header-pos{\n    &.header {\n        .topnav-dropdown-header{\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            height: 40px;\n            @include margin-padding(null, 10px);\n            .clear-noti {\n                color: $danger-700 !important; \n                float: right;\n                font-size: $font-size-11 !important;\n                text-transform: uppercase;\n            }\n        }\n        .topnav-dropdown-footer {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            border-top: 1px solid $gray-300;\n            font-size: $font-size-12;\n            height: 32px;\n            line-height: 32px;\n            a {\n                display: block;\n                text-align: center;\n                color: $gray-800;\n                @include margin-padding(null, 5px 12px);\n                font-size: $font-size-12 !important;\n            }\n        }\n        .user-menu.nav {\n            li {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                height: 40px;\n                 a {\n                    color: $secondary;\n                    line-height: normal;\n                    height: auto;\n                    font-size: $font-size-15;\n                    padding: 0 8px;\n                    &.dropdown-toggle{\n                        &.nav-link.show {\n                            background: transparent;\n                        }\n                    }\n                }\n                &.notification-message{\n                    height: auto;\n                }\n            }\n        }\n        .user-img{\n            img {\n                margin-top: 0;\n            }\n            .status {\n                border: 2px solid $white;\n                height: 10px;\n                width: 10px;\n                margin: 0;\n                @include rounded(50%);\n                display: inline-block;\n                background: $success;\n                @include position(absolute,null,null,6px,0);\n            }\n        }\n    }\n}\n.header-pos{\n    &.header {\n        .user-menu{\n            @include respond-below(custom991) {\n                display: none;\n            }\n            .noti-content {\n                .notification-list {\n                    a {\n                       line-height: normal;\n                       height: auto;\n                       @include margin-padding(null, 8px);\n                   }\n               }\n           }\n        }\n    }\n}\n.header-split{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    @include respond-below(custom991) {\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n    }\n    .header-menu{\n        @include respond-below(custom991) {\n            display: none;\n        }\n        ul{\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            li{\n                margin-right: 10px;\n                a{\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    border:1px solid $gray-300;\n                    color: $black;;\n                    @include rounded(5px);\n                    @include margin-padding(null, 5px 8px);\n                    &.links{\n                        border: 0;\n                    }\n                    &:hover{\n                        background:$primary;\n                        color:$white;\n                        img{\n                            filter: brightness(0) invert(1);\n                        }\n                    }\n                }\n                &.mobile-show{\n                    display: block;\n                    @include respond-below(custom991) {\n                        display: block;\n                    }\n                }\n            }\n        }\n    }\n}\n.mobile-show{\n    display: none;\n    @include respond-below(custom991) {\n        display: block;\n    }\n}\n.header-menus {\n    position: absolute;\n    right: 30px;\n    display: none;\n    @include respond-below(custom991) {\n        display: block;\n    }\n}\n.bar-icon {\n    display: inline-block;\n    width: 31px;\n    margin-top: 20px;\n    span {\n        background-color: $primary;\n        display: block;\n        float: left;\n        height: 3px;\n        margin-bottom: 7px;\n        width: 31px;\n        border-radius: 2px;\n        transition: all 0.5s;\n        &:nth-child(2) {\n            width: 16px;\n        }\n    }\n}\n.menu-opened{\n    .slide-nav{\n        .bar-icon {\n            display: inline-block;\n            width: 31px;\n            margin-top: 20px;\n            span {\n                &:first-child {\n                    position: relative;\n                    top: 10px;\n                    @include transform(rotate(45deg));\n                 }\n                &:nth-child(2) {\n                   display:none;\n                }\n                &:last-child {\n                    @include transform(rotate(135deg));\n                 }\n            }\n        } \n    }\n}\nhr{\n    border-top: 1px solid $gray-300;\n    opacity: 1;\n}\n.profilename {\n    @include margin-padding(null, 0px);\n    .profileset {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        @include margin-padding(null, 10px 10px 3px);\n        h6 {\n            font-size: $font-size-base;\n            color: $secondary;\n            font-weight: $font-weight-medium;\n        }\n        h5 {\n            font-size: $font-size-base;\n            color: $gray-600;\n        }\n        .profilesets {\n            margin-left: 10px;\n        }\n        .user-img img {\n            margin-top: 0;\n        }\n    }\n    .dropdown-item{\n        padding: 8px 5px !important;\n    }\n}\n.show{\n    .user-info {\n        &::after{\n            transform: rotate(-140deg);\n            top: 10px;\n        }  \n    }\n}\n.feather-40 {\n    width: 40px;\n    height: 40px;\n}\n.feather-26 {\n    width: 26px;\n    height: 26px;\n}\n.feather-20 {\n    width: 20px;\n    height: 20px;\n}\n.feather-14 {\n    width: 14px;\n    height: 14px;\n}\n.feather-16 {\n    width: 16px;\n    height: 16px;\n}\n.user-info {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    position: relative;\n    padding: 0 30px 0 0;\n    span {\n        &.user-detail {\n            @include respond-below(custom1199) {\n                display: none;\n            }\n        }\n    }\n    &::after{\n        content: \"\";\n        width: 8px;\n        height: 8px;\n        border-top: 0;\n        border-left: 0;\n        border-right: 2px solid #1B2950;\n        border-bottom: 2px solid #1B2950;\n        border-radius: 1px;\n        transform: rotate(45deg);\n        transition: all 0.5s;\n        top: 8px;\n        position: absolute;\n        right: 12px;\n        @include respond-below(custom1199) {\n            top:  12px;\n        }\n    }\n  .user-role {\n    display: block;\n    color: #67748E;\n    font-size: 12px;\n  }\n  .user-letter {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    color: $white;\n    width: 36px;\n    height: 36px;\n    border-radius: 6px;\n    font-weight: $font-weight-semibold;\n    font-size: $font-size-15;\n    margin-right: 10px;\n    border: 1px solid $border-color;\n    @include respond-below(custom1199) {\n        margin-right: 0;\n    }\n    img {\n        @include rounded(6px);\n    }\n  }\n  .user-name {\n    font-size: $font-size-15;\n    font-weight: $font-weight-semibold;\n    color: #1B2950;\n    display: flex;\n    align-items: center;\n  }\n  .user-name img {\n    margin-left: 10px;\n  }\n}\n.user-menu {\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    margin: 0;\n    position: relative;\n    padding-right: 15px;\n    height: 100%;\n    @include transition(all 0.5s ease);\n    @include respond-below(custom991) {\n        display: none;\n    }\n    > li {\n        margin-left: 18px;\n        margin-inline-end: 0;\n        @include respond-below(custom1199) {\n            margin-left: 8px;\n        }\n        svg {\n            width: 18px;\n            color: #67748E;            \n        }\n        a:hover{\n            svg {\n                color: $primary;\n            }\n        }\n    }\n    .dropdown-toggle{\n        &::after {\n            border: 0;\n            display: none;\n        }\n    }\n    .nav-searchinputs {\n        margin-right: auto;\n        margin-left: 25px;\n    }\n    .nav-item-box > a {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        background: $gray-100;\n        border-radius: 6px;\n        width: 36px;\n        height: 36px;\n        position: relative;\n        &:hover{\n            background: #EEF3F5;\n        }\n    }\n    &.nav{\n       > li{\n        >  a{\n            padding: 0;\n            display: flex;\n            line-height: normal;\n            color: $secondary;\n            .badge {\n                color: $white;\n                font-weight: $font-weight-bold;\n                @include position(absolute,-7px,-7px,null,null);\n                background: $primary;\n                width: 20px;\n                height: 20px;\n                font-size: $font-size-10;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n            }\n            i {\n                font-size: $font-size-20;\n                line-height: 60px;\n            }\n        }\n        &.flag-nav{\n             a{\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                .dropdown-menu {\n                    max-height: 150px;\n                    min-width: 120px;\n                    overflow-y: auto;\n                    .dropdown-item {\n                        @include margin-padding(null, 5px 15px);\n                    }\n                }\n            }\n            .dropdown-menu {\n                padding: 15px;\n                min-width: 210px;\n                .dropdown-item {\n                    @include margin-padding(null, 10px 10px);\n                    color: #67748E;                    \n                    border-radius: 10px;\n                    transition: none;\n                    &.active{\n                        color: $white;\n                    }\n                    &.active,&:hover{\n                        background: #F7F7F7 url(../../../../public/assets/img/icons/check.svg) no-repeat calc(100% - 12px) center;\n                    }\n                }\n                a{\n                    img{\n                        width: 20px;\n                        height: 20px;\n                        border-radius: 50%;\n                        margin-right: 10px;\n                    }\n                }\n            }\n        }\n        }\n    }\n}\n.searchinputs {\n    @include margin-padding(null,  0);\n    position: relative;\n    input{\n        width: 300px;\n        height: 36px;\n        border: 1px solid $gray-100;\n        background: $gray-100;\n        @include margin-padding(null,  0 16px);\n        @include rounded(8px);\n        @include respond-below(custom1199) {\n            width: 170px;\n        }\n    }   \n    .search-addon{\n        span{\n            z-index: 9;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            @include rounded(5px);\n            cursor: pointer;\n            @include position(absolute,50%,16px,null,null);\n            @include transform(translateY(-50%));\n        }\n    }\n}\n.searchinputs {\n    .search-addon {\n        svg {\n            opacity: 0;\n            @include transition(all 0.5s ease);\n            color: $danger-700;\n        }\n    }\n    &.show {\n        .search-addon {\n            svg {\n                opacity: 1;\n            }\n        }\n    }\n}\n.search-dropdown {\n    width: 300px;\n    height: 315px;\n    box-shadow: $box-shadow;\n    padding: 20px;\n    @include rounded(10px);\n    background: $white;\n    margin-top: 0;\n    overflow-y: auto;\n    .search-info {\n        @include margin-padding(0 0 15px 0, 0 0 15px 0); \n        border-bottom: 1px solid $gray-400;\n        font-size: $font-size-14;\n        color: $text-color;\n        &:last-child {\n            border-bottom: none;\n            @include margin-padding(0, 0); \n        }\n        h6 {\n            font-size: $font-size-14;\n            font-weight: $font-weight-bold;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            color: $secondary;\n            margin-bottom: 15px;\n            svg {\n                width: 16px;\n                margin-right: 6px;\n                color: $secondary;\n            }\n        }\n        .search-tags {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            li {\n                margin-right: 10px;\n                &:last-child {\n                    margin-right: 0;\n                }\n                &:hover {\n                    a {\n                        background: $primary;\n                        color: $white;\n                    }\n                }\n                a {\n                    @include margin-padding(null, 5px 10px);\n                    background: $gray-300;\n                    @include rounded(50px);\n                    color: $text-color;\n                }\n            }\n        }\n        .customers {\n            li{\n                margin-bottom: 15px;\n                &:hover {\n                    a {\n                        color: $primary;\n                        img {\n                            border-color: $primary;\n                        }\n                    }\n                }\n                &:last-child {\n                    margin-bottom: 0;\n                }\n                a {\n                    color: $text-color;\n                    font-size: $font-size-15;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    img {\n                        width: 30px;\n                        height: 30px;\n                        @include rounded(100%);\n                        border: 1px solid $gray-100;\n                        @extend %animation-effect;\n                    }\n                }\n            }\n        }\n    }   \n}\n.user-menu.nav {\n    > li {\n        > a {\n            &.dropdown-toggle {\n                &.nav-link {\n                    &.select-store {\n                        &.show {\n                            background: none;\n                        }\n                    }\n                }\n            }\n            &.select-store {\n                padding: 4px 10px;\n                border: 1px solid $border-color;\n                @include rounded(6px);\n                @include respond-below(custom1199) {\n                    padding: 6px 5px;\n                }\n                .user-info {\n                    padding: 3px 25px 3px 0;\n                    @include respond-below(custom1199) {\n                        padding-right: 15px;\n                    }\n                    .user-letter {\n                        width: 20px;\n                        height: 20px;\n                        margin-right: 6px;\n                        border: 0;\n                        img {\n                            @include rounded(100%);\n                        }\n                    }\n                    .user-name {\n                        font-size: $font-size-13;\n                        font-weight:  $font-weight-medium;\n                        color:  $secondary;\n                    }\n                    &:after {\n                        top: 33%;\n                        @include transform(translateY(-33%));\n                        transform: rotate(45deg);\n                        border-color: $text-color;\n                        right: 6px;\n                    }\n                }\n            }\n        }\n    }\n}\n.select-store-dropdown {\n    .dropdown-menu {\n        .dropdown-item {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            img {\n                margin-right: 8px;\n                width: 20px;\n                height: 20px;\n                @include rounded(100%);\n                border:  1px solid $gray-100;\n            }\n        }\n    }\n\n}\n.header-collapse {\n    .user-menu {\n        height:  0;\n        display: none;\n    }\n    .page-wrapper {\n        padding-top:  0;\n    }\n    .header {\n        border-bottom: none;\n        background: transparent;\n        width: 260px;\n        .header-left {\n            background: $white;\n        }\n    }\n    .welcome {\n        #collapse-header {\n            &.active {\n                background: $primary;\n                border-color: $primary;\n                svg {\n                    @include transform(rotate(180deg));\n                    color: $white;\n                }\n            }\n        }\n    }\n}",".page-wrapper-one {\n    margin-left: 0px;\n    padding-top: 130px;\n}\n.header-one {\n    .header-left {\n        border-right: 0 !important;\n        @include margin-padding(null, 25px);\n    }\n}\n.logo-white {\n    display: none !important;\n}\n.sidebar.horizontal-sidebar {\n    position: fixed;\n    width: 100%;\n    height: 68px;\n    background: $white;\n    border-top: 1px solid $gray-400;\n    box-shadow: 0px 4px 14px rgba(198, 198, 198, 0.25);    \n    z-index: 500;\n    .sidebar-menu {\n        @include margin-padding(null, 0 15px);\n        & > ul  {\n           & > li {\n            &.submenu {\n                ul {\n                    li {\n                        a.active {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n                margin-bottom: 0;\n                margin-right: 20px;\n                & > a {\n                    &.active {\n                        background: transparent;\n                    }\n                    @include margin-padding(null, 22px 15px);\n                    @include respond-below(custom1199) {\n                        @include margin-padding(null, 22px 5px);\n                        span {\n                            @include respond-below(custom1199) {\n                                font-size: $font-size-base;\n                            }\n                        }\n                    }\n                    &:hover {\n                        background: transparent;\n                        span {\n                            color:$primary;\n                        }\n                        img, svg {\n                            filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);\n                        }\n                    }\n                    img {\n                        top: 0 !important;\n                        width: auto;\n                    }\n                }\n                a {\n                    font-weight: $font-weight-medium;\n                    font-size: $font-size-15;\n                    color: $gray-600;\n                    img {\n                        position: relative;\n                        top: 3px;\n                        width: 18px;\n                        margin-right: 7px;\n                    }\n                    svg {\n                        width: 18px;\n                        margin-right: 7px;\n                        @include respond-below(custom1199) {\n                            margin-right: 5px;\n                        }\n                    }\n                }\n                .menu-arrow {\n                    position: initial;\n                    transform: rotate(90deg);\n                    margin-left: 15px;\n                }\n                ul {\n                    position: absolute;\n                    width: 250px;\n                    height: auto;\n                    li {\n                        &.submenu {\n                            a {\n                                padding: 8px 15px !important;\n                                .menu-arrow {\n                                    float: right;\n                                    margin-right: 15px;\n                                }\n                                i {\n                                    margin-right: 7px;\n                                }\n                                img {\n                                    position: relative;\n                                    top: 3px;\n                                    width: 18px;\n                                    margin-right: 7px;\n                                }\n                                svg {\n                                    width: 18px;\n                                    margin-right: 7px;\n                                }\n                            }\n                            & ul {\n                                box-shadow: 0px 4px 14px rgb(198 198 198 / 25%);\n                            }\n                            ul {\n                                position: relative;    \n                                @include margin-padding(null, 0); \n                                li {\n                                    a {\n                                        padding: 8px 10px 8px 40px !important;\n                                    }\n                                }                           \n                            }\n                            &.submenu-two {\n                                ul {\n                                    li {\n                                        a {\n                                            margin-left: 10px;\n                                        }\n                                    }\n                                }\n                                &.submenu-three {\n                                    ul {\n                                        li {\n                                            a {\n                                                margin-left: 20px;\n                                            }\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                        a {\n                            padding: 8px 15px !important;\n                            &::after {\n                                content: none !important;\n                            }\n                        }\n                    }\n                }                                \n                @include respond-below(custom1199) {\n                   margin-right: 0;\n                }\n            }\n        }\n    }\n}\n@include respond-above(custom992) {\n    .hide-sidebar {\n        display: none;\n    }\n}\n@include respond-below(custom991) {\n    .horizontal-sidebar {\n        display: none;\n    }\n    .page-wrapper-one {\n        padding-top: 60px;\n    }\n}",".header-two {\n    .header-left {\n        border: 0 !important;        \n        @include margin-padding(null, 0 10px);\n    }\n    .top-nav-search {\n        float: left;\n        margin-left: 10px;\n        .btn {\n            left: 0;\n            right: auto !important;\n        }\n        .searchinputs {\n            input {\n                z-index: 1;\n            }\n        }\n    }\n}\n.sidebar {\n    &.sidebar-two {\n        left: auto;\n        top: 90px;\n        border: 0 !important;\n        .sidebar-menu {\n            & > ul {\n                & > li {\n                    a {  \n                    }\n                    &.submenu {\n                        ul {\n                            li {\n                                a {                      \n                                    display: -webkit-box !important;\n                                    display: -ms-flexbox !important;\n                                    display: flex !important;\n                                    align-items: center;\n                                    -webkit-box-align: center;\n                                    -ms-flex-align: center;\n                                    img {\n                                        width: 18px;\n                                    }\n                                    span {\n                                        margin-left: 10px;\n                                    }\n                                    &::after {\n                                        content: none;\n                                    }\n                                    .menu-arrow {\n                                        top: 10px;\n                                    }\n                                }\n                                ul {\n                                    li {\n                                        a {\n                                            padding: 8px 8px 8px 64px;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n            .menu-arrow {\n                position: absolute;\n                top: 12px;\n                right: 15px\n            }\n        }\n    }\n}\n.page-wrapper-two {\n    .dash-widget {\n        .dash-widgetcontent {\n            margin-left: 10px;\n        }\n    }\n}\n@include respond-below(custom991) {\n    .sidebar.sidebar-two {\n        left: 0;\n        top: 60px;\n    }\n}\n.header-block {\n    @include respond-below(custom991) {\n        display: block !important;\n    }\n}",".page-wrapper-three {\n    margin-left: 0;\n    padding-top: 0;\n    .content {\n        background: $body-bg;\n        border-radius: 20px;\n        margin-top: -82px;\n    }\n}\n.header-three {\n    position: relative;\n    .header-left {\n        border-right: 0 !important;\n        @include margin-padding(null, 25px);\n    }\n}\n.logo-white {\n    display: none !important;\n}\n.sidebar.side-three.horizontal-sidebar {\n    position: relative;\n    top: 0;\n    width: 100%;\n    height: 150px;\n    background: #1B2950;\n    border-top: 1px solid $gray-400;\n    box-shadow: 0px 4px 14px rgba(198, 198, 198, 0.25);    \n    z-index: unset;\n    .sidebar-menu {\n        @include margin-padding(null, 0 15px);\n        & > ul  {\n           & > li {\n                margin-bottom: 0;\n                margin-right: 20px;\n                & > a {\n                    @include margin-padding(null, 22px 15px);\n                    img, svg {\n                        filter:  brightness(0) invert(1);\n                        margin-right: 0;\n                    }\n                    &:hover {\n                        background: transparent;\n                        span {\n                            color:$primary !important;\n                        }\n                        img, svg {\n                            filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);\n                        }\n                    }\n                    img {\n                        top: 0 !important;\n                        width: auto;\n                    }\n                    &::before {\n                        content: \"\";\n                        @include position(absolute, 50%, -10px, null, null);\n                        width: 1px;\n                        height: 15px;\n                        background: #6B7A99;\n                        transform: translateY(-50%);\n                    }\n                }\n                & > a {\n                    span {                        \n                        color: $white  !important;\n                    }\n                }\n                a {\n                    font-weight: $font-weight-medium;\n                    font-size: $font-size-15;\n                    color: $white;\n                    img {\n                        position: relative;\n                        top: 3px;\n                        width: 18px;\n                        margin-right: 7px;\n                        filter:  brightness(0) invert(1);\n                    }\n                    svg {\n                        width: 18px;\n                        margin-right: 7px;\n                    }\n                    &:hover {                        \n                        img, svg {                                        \n                            filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);\n                        }\n                    }\n                }\n                .menu-arrow {\n                    position: initial;\n                    transform: rotate(90deg);\n                    margin-left: 15px;\n                }\n                ul {\n                    position: absolute;\n                    width: 250px;\n                    height: auto;\n                    z-index: 1;\n                    background: #1B2950;\n                    li {\n                        &.submenu {\n                            a {\n                                padding: 8px 15px !important;\n                                color: $white;\n                                .menu-arrow {\n                                    float: right;\n                                    margin-right: 15px;\n                                }\n                                i {\n                                    margin-right: 7px;\n                                }\n                                img {\n                                    position: relative;\n                                    top: 3px;\n                                    width: 18px;\n                                    margin-right: 7px;\n                                }\n                                svg {\n                                    width: 18px;\n                                    margin-right: 7px;\n                                }\n                                &:hover {\n                                    color: $primary;\n                                    img {                                        \n                                        filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);\n                                    }\n                                }\n                            }\n                            & ul {\n                                box-shadow: none;\n                            }\n                            ul {\n                                position: relative;    \n                                @include margin-padding(null, 0); \n                                li {\n                                    a {\n                                        padding: 8px 10px 8px 40px !important;\n                                        color: $white;\n                                    }\n                                }                           \n                            }\n                        }\n                        a {\n                            padding: 8px 15px !important;\n                            &::after {\n                                content: none !important;\n                            }\n                        }\n                    }\n                }                                \n                @include respond-below(custom1199) {\n                   margin-right: 0;\n                }\n                &:last-child {\n                    & > a {\n                        &::before {\n                            content: none;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n@include respond-above(custom992) {\n    .hide-sidebar {\n        display: none;\n    }\n}\n@include respond-below(custom991) {\n    .header-three {\n        position: fixed;\n    }\n    .horizontal-sidebar {\n        display: none;\n    }\n    .page-wrapper-three {\n        padding-top: 60px;\n        .content {\n            margin-top: 0;\n        }\n    }\n}",".sidebar.collapsed-sidebar {\n    border: 0;\n    box-shadow: 0px 4px 14px rgba(198, 198, 198, 0.25);\n    display: none;\n    .sidebar-menu {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        border-radius: 0 20px 20px 0;\n        .ui-aside {\n            float: left;\n            width: 100%;\n            max-width: 66px;\n            margin-left: 0px;\n            color: rgba(255, 255, 255, 0.5);\n            @include transition( all .299s);\n            @include margin-padding(0, 0);\n            box-shadow: 0px 0 14px rgba(198, 198, 198, 0.25);\n            min-height: 100vh;\n            border: 0;\n            position: fixed;\n            left: 0;\n            z-index: 999;\n            .nav-tabs {\n                @include margin-padding(null, 14px 14px 0);\n                border: 0;\n            .nav-item {\n\t\t\t\tmargin-bottom: 10px;\n                .nav-link {\n                    @include margin-padding(null, 5px);\n\t\t\t\t\twidth: 38px;\n\t\t\t\t\theight: 38px;\n                    &:hover {\n                        background-color: $primary;\n                        img {\n\t\t\t\t\t\t\tfilter: brightness(0) invert(1);\n                        }\n\t\t\t\t\t\tsvg {\t\t\t\t\t\t\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t}\n                    }\n                    &:active, &.active {\n\t\t\t\t\t\tbackground-color: $primary;\n                        img {\n\t\t\t\t\t\t\tfilter: brightness(0) invert(1);\n                        }\n\t\t\t\t\t\tsvg {\t\t\t\t\t\t\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t}\n                        &::after {\n                            content: none;\n                        }\n                        border: 0;\n                    }\n                    &::before {\n                        content: none;\n                    }\n                }\n                &:last-child {\n                    .nav-link {\n                    border-bottom: 0;\n                    }\n                }\n            }\n        }\n    }\n}\n    .tab-content-four {\n        padding-top: 20px;\n        margin-left: 80px;\n        width: 100%;\n    }\n    // ul ul {\n    //     display: none;\n    // }\n\n    // .subdrop ul{\n    //     display:block;\n    // }\n    .sidebar-menu {\n        @include margin-padding(null, 0 20px 0 0);\n        ul li {\n            a {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                @include margin-padding(null, 10px 15px 10px 25px);\n                position: relative;\n                color: $gray-600;\n                svg{\n                    width: 18px;\n                    color: $gray-600;\n                }\n                img{\n                    width:18px;\n                    color: $gray-600;\n                }\n                &:hover{\n                    color: $primary;\n                    img {\n                        filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);\n                    }\n                    span{\n                        color: $primary;\n                    }\n                    svg{\n                        color: $primary;\n                    }\n                }\n                &::before {\n                    content: \"\";\n                    @include position(absolute, 50%, null, null, 10px);\n                    transform: translateY(-50%);\n                    background: $gray-500;\n                    width: 5px;\n                    height: 5px;\n                }\n                &.active{\n                    color: $primary;\n                    svg{\n                        color: $primary;\n                    }\n                    img {\n                        filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);\n                    }\n                    span{\n                        color: $primary;\n                    }\n                }\n                span{\n                    margin-left: 0;\n                    font-size: $font-size-15;\n                    font-weight: $font-weight-medium;\n                    color: $gray-600;\n                }\n                .menu-arrow {\n                    display: inline-block;\n                    font-family: \"Font Awesome 5 Free\";\n                    text-rendering: auto;\n                    line-height: 40px;\n                    font-size: $font-size-18;\n                    line-height: 18px;\n                    @include position(absolute,12px,0px,null,null);\n                    @include transform(translate(0, 0));\n                    @include transition(all 0.2s ease);\n                    &.inside-submenu {\n                        right: 15px;\n                        &.inside-submenu-two {\n                            right: 15px\n                        }\n                    }\n                }\n                &.subdrop{\n                    .menu-arrow {\n                        @include transform(rotate(90deg));\n                    }\n                }\n            }\n            &.submenu.submenu-two {\n                ul {\n                    li {\n                        a {\n                            margin-left: 10px;\n                        }\n                    }\n                }\n            }\n            &.submenu.submenu-three {\n                ul {\n                    li {\n                        a {\n                            margin-left: 20px;\n                        }\n                    }\n                }\n            }\n            ul {\n                li {\n                    a {\n                        @include margin-padding(null, 10px 15px 10px 25px);\n                        left: 14px;\n                    }\n                }\n            }\n        }\n    }\n}\n.header-four {\n    .header-left {\n        border-right: 0 !important;\n    }\n}\n.page-wrapper-four {\n    margin-left: 250px;\n}\n\n@include respond-below(custom992) {\n    .page-wrapper-four {\n        margin-left: 0;\n\n    } \n}\n","div#global-loader {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    background: $white;\n    position: fixed;\n    z-index: 999999;\n    width: 100%;\n    height: 100vh;\n        \n    .whirly-loader:not(:required) {\n        animation: whirly-loader 1.25s linear infinite;\n        background: transparent;\n        box-shadow: 0 26px 0 6px $primary, 0.90971px 26.05079px 0 5.93333px $primary, 1.82297px 26.06967px 0 5.86667px $primary, 2.73865px 26.05647px 0 5.8px $primary, 3.65561px 26.01104px 0 5.73333px $primary, 4.57274px 25.93327px 0 5.66667px $primary, 5.48887px 25.8231px 0 5.6px $primary, 6.40287px 25.68049px 0 5.53333px $primary, 7.31358px 25.50548px 0 5.46667px $primary, 8.21985px 25.2981px 0 5.4px $primary, 9.12054px 25.05847px 0 5.33333px $primary, 10.01448px 24.78672px 0 5.26667px $primary, 10.90054px 24.48302px 0 5.2px $primary, 11.77757px 24.1476px 0 5.13333px $primary, 12.64443px 23.78072px 0 5.06667px $primary, 13.5px 23.38269px 0 5px $primary, 14.34315px 22.95384px 0 4.93333px $primary, 15.17277px 22.49455px 0 4.86667px $primary, 15.98776px 22.00526px 0 4.8px $primary, 16.78704px 21.48643px 0 4.73333px $primary, 17.56953px 20.93855px 0 4.66667px $primary, 18.33418px 20.36217px 0 4.6px $primary, 19.07995px 19.75787px 0 4.53333px $primary, 19.80582px 19.12626px 0 4.46667px $primary, 20.5108px 18.468px 0 4.4px $primary, 21.1939px 17.78379px 0 4.33333px $primary, 21.85416px 17.07434px 0 4.26667px $primary, 22.49067px 16.34043px 0 4.2px $primary, 23.10251px 15.58284px 0 4.13333px $primary, 23.68881px 14.80241px 0 4.06667px $primary, 24.24871px 14px 0 4px $primary, 24.7814px 13.1765px 0 3.93333px $primary, 25.28607px 12.33284px 0 3.86667px $primary, 25.76198px 11.46997px 0 3.8px $primary, 26.2084px 10.58888px 0 3.73333px $primary, 26.62462px 9.69057px 0 3.66667px $primary, 27.01001px 8.77608px 0 3.6px $primary, 27.36392px 7.84648px 0 3.53333px $primary, 27.68577px 6.90284px 0 3.46667px $primary, 27.97502px 5.94627px 0 3.4px $primary, 28.23116px 4.97791px 0 3.33333px $primary, 28.4537px 3.99891px 0 3.26667px $primary, 28.64223px 3.01042px 0 3.2px $primary, 28.79635px 2.01364px 0 3.13333px $primary, 28.91571px 1.00976px 0 3.06667px $primary, 29px 0 0 3px $primary, 29.04896px -1.01441px 0 2.93333px $primary, 29.06237px -2.03224px 0 2.86667px $primary, 29.04004px -3.05223px 0 2.8px $primary, 28.98185px -4.07313px 0 2.73333px $primary, 28.88769px -5.09368px 0 2.66667px $primary, 28.75754px -6.1126px 0 2.6px $primary, 28.59138px -7.12863px 0 2.53333px $primary, 28.38926px -8.14049px 0 2.46667px $primary, 28.15127px -9.1469px 0 2.4px $primary, 27.87755px -10.1466px 0 2.33333px $primary, 27.56827px -11.1383px 0 2.26667px $primary, 27.22365px -12.12075px 0 2.2px $primary, 26.84398px -13.09268px 0 2.13333px $primary, 26.42956px -14.05285px 0 2.06667px $primary, 25.98076px -15px 0 2px $primary, 25.49798px -15.93291px 0 1.93333px $primary, 24.98167px -16.85035px 0 1.86667px $primary, 24.43231px -17.75111px 0 1.8px $primary, 23.85046px -18.63402px 0 1.73333px $primary, 23.23668px -19.49789px 0 1.66667px $primary, 22.5916px -20.34157px 0 1.6px $primary, 21.91589px -21.16393px 0 1.53333px $primary, 21.21024px -21.96384px 0 1.46667px $primary, 20.4754px -22.74023px 0 1.4px $primary, 19.71215px -23.49203px 0 1.33333px $primary, 18.92133px -24.2182px 0 1.26667px $primary, 18.10379px -24.91772px 0 1.2px $primary, 17.26042px -25.58963px 0 1.13333px $primary, 16.39217px -26.23295px 0 1.06667px $primary, 15.5px -26.84679px 0 1px $primary, 14.58492px -27.43024px 0 0.93333px $primary, 13.64796px -27.98245px 0 0.86667px $primary, 12.69018px -28.50262px 0 0.8px $primary, 11.7127px -28.98995px 0 0.73333px $primary, 10.71663px -29.4437px 0 0.66667px $primary, 9.70313px -29.86317px 0 0.6px $primary, 8.67339px -30.2477px 0 0.53333px $primary, 7.6286px -30.59666px 0 0.46667px $primary, 6.57001px -30.90946px 0 0.4px $primary, 5.49886px -31.18558px 0 0.33333px $primary, 4.41643px -31.42451px 0 0.26667px $primary, 3.32401px -31.6258px 0 0.2px $primary, 2.22291px -31.78904px 0 0.13333px $primary, 1.11446px -31.91388px 0 0.06667px $primary, 0 -32px 0 0 $primary, -1.11911px -32.04713px 0 -0.06667px $primary, -2.24151px -32.05506px 0 -0.13333px $primary, -3.36582px -32.02361px 0 -0.2px $primary, -4.49065px -31.95265px 0 -0.26667px $primary, -5.61462px -31.84212px 0 -0.33333px $primary, -6.73634px -31.69198px 0 -0.4px $primary, -7.8544px -31.50227px 0 -0.46667px $primary, -8.9674px -31.27305px 0 -0.53333px $primary, -10.07395px -31.00444px 0 -0.6px $primary, -11.17266px -30.69663px 0 -0.66667px $primary, -12.26212px -30.34982px 0 -0.73333px $primary, -13.34096px -29.96429px 0 -0.8px $primary, -14.4078px -29.54036px 0 -0.86667px $primary, -15.46126px -29.07841px 0 -0.93333px $primary, -16.5px -28.57884px 0 -1px $primary, -17.52266px -28.04212px 0 -1.06667px $primary, -18.52792px -27.46878px 0 -1.13333px $primary, -19.51447px -26.85936px 0 -1.2px $primary, -20.48101px -26.21449px 0 -1.26667px $primary, -21.42625px -25.53481px 0 -1.33333px $primary, -22.34896px -24.82104px 0 -1.4px $primary, -23.2479px -24.07391px 0 -1.46667px $primary, -24.12186px -23.29421px 0 -1.53333px $primary, -24.96967px -22.48279px 0 -1.6px $primary, -25.79016px -21.64052px 0 -1.66667px $primary, -26.58223px -20.76831px 0 -1.73333px $primary, -27.34477px -19.86714px 0 -1.8px $primary, -28.07674px -18.938px 0 -1.86667px $primary, -28.7771px -17.98193px 0 -1.93333px $primary, -29.44486px -17px 0 -2px $primary, -30.07908px -15.99333px 0 -2.06667px $primary, -30.67884px -14.96307px 0 -2.13333px $primary, -31.24325px -13.91039px 0 -2.2px $primary, -31.7715px -12.83652px 0 -2.26667px $primary, -32.26278px -11.74269px 0 -2.33333px $primary, -32.71634px -10.63018px 0 -2.4px $primary, -33.13149px -9.5003px 0 -2.46667px $primary, -33.50755px -8.35437px 0 -2.53333px $primary, -33.84391px -7.19374px 0 -2.6px $primary, -34.14px -6.0198px 0 -2.66667px $primary, -34.39531px -4.83395px 0 -2.73333px $primary, -34.60936px -3.63759px 0 -2.8px $primary, -34.78173px -2.43218px 0 -2.86667px $primary, -34.91205px -1.21916px 0 -2.93333px $primary, -35px 0 0 -3px $primary, -35.04531px 1.22381px 0 -3.06667px $primary, -35.04775px 2.45078px 0 -3.13333px $primary, -35.00717px 3.6794px 0 -3.2px $primary, -34.92345px 4.90817px 0 -3.26667px $primary, -34.79654px 6.13557px 0 -3.33333px $primary, -34.62643px 7.36007px 0 -3.4px $primary, -34.41316px 8.58016px 0 -3.46667px $primary, -34.15683px 9.79431px 0 -3.53333px $primary, -33.85761px 11.001px 0 -3.6px $primary, -33.5157px 12.19872px 0 -3.66667px $primary, -33.13137px 13.38594px 0 -3.73333px $primary, -32.70493px 14.56117px 0 -3.8px $primary, -32.23675px 15.72291px 0 -3.86667px $primary, -31.72725px 16.86968px 0 -3.93333px $primary, -31.17691px 18px 0 -4px $primary, -30.58627px 19.11242px 0 -4.06667px $primary, -29.95589px 20.2055px 0 -4.13333px $primary, -29.28642px 21.27783px 0 -4.2px $primary, -28.57852px 22.32799px 0 -4.26667px $primary, -27.83295px 23.35462px 0 -4.33333px $primary, -27.05047px 24.35635px 0 -4.4px $primary, -26.23192px 25.33188px 0 -4.46667px $primary, -25.37819px 26.27988px 0 -4.53333px $primary, -24.49018px 27.1991px 0 -4.6px $primary, -23.56888px 28.0883px 0 -4.66667px $primary, -22.6153px 28.94626px 0 -4.73333px $primary, -21.6305px 29.77183px 0 -4.8px $primary, -20.61558px 30.56385px 0 -4.86667px $primary, -19.57168px 31.32124px 0 -4.93333px $primary, -18.5px 32.04294px 0 -5px $primary, -17.40175px 32.72792px 0 -5.06667px $primary, -16.27818px 33.37522px 0 -5.13333px $primary, -15.1306px 33.98389px 0 -5.2px $primary, -13.96034px 34.55305px 0 -5.26667px $primary, -12.76875px 35.08186px 0 -5.33333px $primary, -11.55724px 35.56951px 0 -5.4px $primary, -10.32721px 36.01527px 0 -5.46667px $primary, -9.08014px 36.41843px 0 -5.53333px $primary, -7.81748px 36.77835px 0 -5.6px $primary, -6.54075px 37.09443px 0 -5.66667px $primary, -5.25147px 37.36612px 0 -5.73333px $primary, -3.95118px 37.59293px 0 -5.8px $primary, -2.64145px 37.77443px 0 -5.86667px $primary, -1.32385px 37.91023px 0 -5.93333px $primary;\n        display: inline-block;\n        height: 8px;\n        overflow: hidden;\n        position: relative;\n        text-indent: -9999px;\n        width: 8px;\n        @include transform-origin(50% 50%);\n        @include rounded(100%);\n    }\n}\n@keyframes loader {\n    to {left: -100vw;}\n  }\n \n@-webkit-keyframes whirly-loader {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg)\n    }\n\n    to {\n        -webkit-transform: rotate(1turn);\n        transform: rotate(1turn)\n    }\n}\n\n@keyframes whirly-loader {\n    0% {\n        -webkit-transform: rotate(0deg);\n        transform: rotate(0deg)\n    }\n\n    to {\n        -webkit-transform: rotate(1turn);\n        transform: rotate(1turn)\n    }\n}",".sidebar,.sidebars {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    background-color: $white;\n    border-right: 1px solid transparent;\n    margin-top: 0;\n    z-index: 1001;\n    @include position(fixed,66px,null,0,0);\n    @include transition(all 0.5s ease);\n    border-right: 1px solid $gray-400;\n    width: 260px;\n    @include respond-below(custom991) {\n        margin-left: -575px;\n        @include transition(all 0.4s ease);\n        z-index: 1041;\n        background: $white;\n    }\n    @include respond-below(custom575) {\n        width: 100%;\n    }\n    .slimScrollDiv {\n        background: $white;\n        border-right: 1px solid transparent;\n        @include respond-below(custom575) {\n            width: 100% !important;\n        }\n    }\n    .sidebar-menu{\n        @include margin-padding(null, 24px);\n    }\n    .sidebar-menu{\n        > ul{\n            > li{\n                margin-bottom: 24px;\n                &.active{\n                    a{\n                        color: $white;\n                    }\n                    svg {\n                        color: #FE9F43\n                    }\n                }\n                svg {\n                    min-width: 16px;\n                    width:  16px;\n                    height:  16px;\n                    margin-right: 10px;\n                }\n                > a{\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    @include margin-padding(null, 10px 15px);\n                    position: relative;\n                    color: $secondary;\n                    svg{\n                        color: #637381;\n                    }\n                    img{\n                        width:18px;\n                        color: #637381;\n                    }\n                    &:hover{\n                        background: rgba(254, 159, 67, 0.08);\n                        color: #FE9F43;\n                        border-radius: 5px;\n                        img {\n                            filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);\n                        }\n                        span{\n                            color: #FE9F43;\n                        }\n                        svg{\n                            color: #FE9F43;\n                        }\n                    }\n                    &.active{\n                        background: rgba(254, 159, 67, 0.08);\n                        color: #FE9F43;\n                        border-radius: 5px;\n                        svg{\n                            color: $white;\n                        }\n                        img {\n                            filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);\n                        }\n                        span{\n                            color: #FE9F43;\n                        }\n                        .menu-arrow{\n                            background: #FFEDDC;\n                            &::before{\n                                border-color: #FE9F43;\n                            }\n                        }\n                    }\n                    span{\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-medium;\n                        color: $gray-600;\n                    }\n                }\n                &.active{\n                    a{\n                        background: rgba(254, 159, 67, 0.08);\n                        border-radius: 5px;\n                        img{\n                            filter: invert(72%) sepia(76%) saturate(1430%) hue-rotate(327deg) brightness(103%) contrast(101%);\n                        }\n                        span{\n                            color: #FE9F43;\n                        }\n                    }\n                }\n                &.submenu{\n                    ul{\n                        border-bottom: 1px solid rgba(222, 226, 230, 0.5);\n                        @include margin-padding(null, 10px 0);\n                        display: none;\n                       li{\n                            a{\n                               font-weight: $font-weight-medium;\n                               font-size: $font-size-base;\n                               color: $secondary;\n                               position: relative;\n                               display: block;\n                               @include margin-padding(null, 8px 8px 8px 40px);\n                               &.active{\n                                   color: $secondary;\n                                   &:after{\n                                    background: #FE9F43;\n                                    border: 2px solid #FDB;\n                                   }\n                               }\n                               &::after{\n                                content: \"\";\n                                background: rgba(50, 71, 92, 0.38);\n                                width: 8px;\n                                height: 8px;\n                                border: 2px solid $white;\n                                @include rounded(50px);\n                                @include position(absolute,16px,null,null,16px);\n                               }\n                               &:hover{\n                                   color:$primary;\n                                   &:after{\n                                    background: #FE9F43;\n                                    border: 2px solid #FDB;\n                                   }\n                               }\n                           }\n                       }\n                    }\n                }\n                &.submenu-open{\n                    ul{\n                        border-bottom: 1px solid $gray-300;\n                        @include margin-padding(null, 0 0 14px 0);\n                        display: block;\n                       li{\n                            a{\n                                display: -webkit-box;\n                                display: -ms-flexbox;\n                                display: flex;\n                                align-items: center;\n                                -webkit-box-align: center;\n                                -ms-flex-align: center;\n                                font-weight: $font-weight-medium;\n                                font-size: $font-size-15;\n                                color: #67748E;\n                                position: relative;\n                                width: 100%;\n                                @include margin-padding(null, 10px 10px 10px 18px);\n                               span {\n                                white-space: nowrap;\n                                font-size: $font-size-base;\n                                color: $text-color;\n                               }\n                               &.active{\n                                   color: $primary;\n                                   a {\n                                       span {\n                                            color: $primary;\n                                       }\n                                   }\n                                   &:after{\n                                    background: #FE9F43;\n                                    border: 2px solid #FDB;\n                                   }\n                               }\n                               &:hover{\n                                   color:$primary;\n                                   &:after{\n                                    background: #FE9F43;\n                                    border: 2px solid #FDB;\n                                   }\n                                   span {\n                                        color:$primary;\n                                   }\n                               }\n                           }  \n                       }\n                       > li \n                       {\n                        &.active a{\n                            background: rgba(254, 159, 67, 0.08);\n                            border-radius: 5px;\n                            color: #FE9F43;\n                            span {\n                                color: $primary;\n                            }\n                        }\n                       }\n                    }\n                    .submenu-hdr {\n                        font-weight: $font-weight-semibold;\n                        font-size: $font-size-base;\n                        color: #1B2950;\n                        margin: 0 0 14px 0;\n                    }\n                    &:first-child {\n                        h6 {\n                            margin-top: 0;\n                        }\n                    }\n                    .submenu {\n                        ul {\n                           \n                            border: 0;\n                            padding-top: 0;\n                            padding-bottom: 0;\n                        }\n                    }\n                }\n            }\n            li {\n                &.active{\n                    a{\n                        color: #FE9F43;\n                    }\n                    svg {\n                        color: #FE9F43\n                    }\n                }\n                .submenu > {\n                    a {\n                        &.active{\n                            background: rgba(254, 159, 67, 0.08);\n                            color: #FE9F43;\n                            border-radius: 5px;\n                            span{\n                                color: #FE9F43;\n                            }\n                            .menu-arrow{\n                                background: #FFEDDC;\n                                &::before{\n                                    border-color: #FE9F43;\n                                }\n                            }\n                        }\n                    }\n                }\n                .submenu .submenu-two > {\n                    a {\n                        &.active{\n                            background: transparent;\n                        }\n                    }\n                }\n                \n            }\n\n        }\n        .submenu-open {\n            &:last-child {\n                margin-bottom: 0;\n                ul {\n                    border-bottom: none;\n                    padding-bottom: 0;\n                }\n            }\n            .submenu {\n                &.submenu-two {\n                    ul {\n                        li {\n                            a {\n                                margin-left: 45px;\n                            }\n                        }\n                    }\n                    &.submenu-three {\n                        ul {\n                            li {\n                                a {\n                                    margin-left: 65px;\n                                }\n                            }\n                        }\n                    }\n                }\n                ul {\n                    li {\n                        a {\n                        margin-left: 25px;\n                        padding-bottom: 4px;\n                        font-size: $font-size-base;\n                        color: $sub-title;\n                        &::after{\n                            content: \"\";\n                            background: rgba(50, 71, 92, 0.38);\n                            width: 8px;\n                            height: 8px;\n                            border: 2px solid $white;\n                            @include rounded(50px);\n                            @include position(absolute,16px,null,null,0);\n                            }\n                            &:hover{\n                                color:$primary;\n                                &:after{\n                                background: #FE9F43;\n                                border: 2px solid #FDB;\n                                }\n                            }\n                        }\n                    }\n                } \n            } \n        }               \n        .menu-arrow {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            text-rendering: auto;\n            line-height: 40px;\n            font-size: $font-size-18;\n            line-height: 16px;\n            background: rgba(27, 41, 80, 0.04);\n            width: 16px;\n            height: 16px;\n            border-radius: 50%;\n            @include position(absolute,12px,15px,null,null);\n            @include transform(translate(0, 0));\n            @include transition(all 0.2s ease);\n            &::before {\n                height: 5px;\n                width: 5px;\n                border-top: 0;\n                content: \"\";\n                border-left: 0;\n                border-right: 1px solid $text-color;\n                border-bottom: 1px solid $text-color;\n                transform: rotate(-45deg);\n                position: absolute;\n                left: 5px;\n                top: 5px;\n            }\n            &.inside-submenu {\n                right: 40px;\n                &.inside-submenu-two {\n                    right: 60px;\n                }\n            }\n        }\n        &.subdrop{\n            .menu-arrow {\n                @include transform(rotate(90deg));                            \n                background: #FFEDDC;\n            }\n        }\n    }\n    .nav-link {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        @include margin-padding(null, 10px);\n        color: $secondary;\n        position: relative;\n        &.active{\n            color: $primary;\n            background: transparent;\n            position: relative;\n            &:after{\n                content: \"\";\n                border-width:10px;\n                border-color: transparent $primary transparent transparent;\n                border-style: solid;\n                @include position(absolute,36px,0,null,null);\n            }\n        }\n        \n    }\n    .sidebar-left {\n        width: 100px;\n        @include box-shadow(null, 5px, 0px, 15px, null, rgba(0, 0, 0, .05));\n    }\n    .sidebar-right {\n        width: 250px;\n        height: 100%;\n        @include transition(all 0.2s ease);\n        display: none;\n        @include respond-below(custom991) {\n            width: calc(100% - 70px);\n        }\n        .slimScrollDiv {\n            width: 250px !important;\n            overflow: visible !important;\n            @include respond-below(custom991) {\n                width: 100% !important;\n            }\n        }\n        .tab-content {\n            @include margin-padding(null, 20px 20px 40px);\n            @include respond-below(custom991) {\n                @include margin-padding(null,10px);\n            }\n        }\n        p {\n            font-size: $font-size-10;\n            color: $gray-500;\n            text-transform: uppercase;\n            font-weight: $font-weight-bold;\n            margin-bottom: 10px;\n        }\n        ul {\n            list-style: none;\n            padding: 0;\n            margin: 0;\n            li {\n                &.active{\n                    a{\n                        background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\n                        color: $white;\n                    }\n                }\n                a {\n                    font-weight: $font-weight-normal;\n                    font-size: $font-size-base;\n                    color: $secondary;\n                    &.active {\n                        color: $primary;\n                    }\n                }\n            }\n        }\n        .menu-arrow {\n            -webkit-transition: -webkit-transform 0.15s;\n            -o-transition: -o-transform 0.15s;\n            transition: transform .15s;\n            display: inline-block;\n            font-family: 'Font Awesome 5 Free';\n            text-rendering: auto;\n            line-height: 40px;\n            font-size: $font-size-18;\n            -webkit-font-smoothing: antialiased;\n            -moz-osx-font-smoothing: grayscale;\n            line-height: 18px;\n            top: 0px;\n            position: relative;\n            font-weight: $font-weight-bold;\n            @include transform(translate(0, 0));\n            &:before {\n                content: \"\\f105\";\n                \n            }\n        }\n    }\n    .sub-menu a {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n    }\n    li {\n        a.subdrop {\n            .menu-arrow {\n                @include transform(rotate(90deg));\n            }\n        }\n    }\n    .nav-items{\n        .nav-link {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-direction: column;\n            flex-direction: column;\n            @include rounded(0);\n            border-bottom: 1px solid $gray-400;\n            @include margin-padding(null, 20px 0);\n            @include transition(all 0.4s ease);\n            &:hover{\n                box-shadow: 0  0 0 150px $violet inset;\n                color: $white;\n            }  \n            span{\n                margin-top: 15px;\n                font-weight:$font-weight-medium;\n            }\n        }\n       \n    }\n    .sidemenu {\n        a {\n            width: 100%;\n            font-weight: $font-weight-medium;\n            display: block;\n            @include rounded(5px);\n            @include margin-padding( 0 0 10px, 10px);\n            &:hover{\n                background: linear-gradient(46.62deg, $primary 0%, $violet 93.64%);\n                color: $white;\n                svg{\n                    color:$white;\n                }\n            }\n            svg {\n                stroke-width: 1px;\n            }\n           \n        }\n    }\n}\n.header-left{    \n        #toggle_btn{\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            position: absolute;\n            opacity: 1;\n            background: $primary;\n            right: -13px;\n            border-radius: 50%;\n            width: 25px;\n            height: 25px;\n            color: $white;\n            cursor: pointer;\n            svg {\n                transform: rotate(180deg);\n            }    \n            &:hover {\n                background: $primary-hover;\n            }       \n        }\n        &.active svg {\n            transform: rotate(0) !important;\n        }\n      \n}\n\n@include respond-above(custom991) {\n    .mini-sidebar {\n        .page-wrapper {\n            margin-left: 80px;\n        }\n        .header-left {\n            #toggle_btn{\n                opacity: 0;\n                &:after {\n                   border:0;\n                }\n            }\n        }\n        &.expand-menu{\n            .header-left {\n                #toggle_btn{\n                    opacity: 1;\n                }\n            }  \n        }\n        .sidebar-right {\n            display: none;\n        }\n        .sidebar {\n            .sidebar-menu{\n               ul{\n                    li{\n                        a {\n                            span{\n                                display:none;\n                            }\n                        }\n                        .submenu-hdr {\n                            display:none;\n                        }                                                       \n                        svg {\n                            margin-right:0;\n                        }\n                    }\n                }\n            } \n        }\n        .sidebar{\n            width: 80px;\n            overflow: hidden;\n        }\n    }\n    // .expand-menu{\n    //     .sidebar-right {\n    //         display: block;\n    //         @include transition(all 0.2s ease);\n    //     }\n    //     .sidebar {\n    //         // width: 260px;\n    //         .sidebar-menu{\n    //            ul{\n    //                > li{\n    //                     > a {\n    //                         @include margin-padding(null, 10px 15px);\n    //                         span{\n    //                             display:inline-block;\n    //                             line-height: 0;\n    //                         }\n    //                     }                        \n    //                     svg {\n    //                         margin-right:10px;\n    //                     }\n    //                 }\n    //             }\n    //             .submenu-hdr {\n    //                 display:block;\n    //             }\n    //         }\n    //     }\n    //     .header-left{\n    //         width: 260px;\n    //     }\n    // }\n    #toggle_btn {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        float: left;\n        margin-left: 15px;\n    }\n}\nbody.mini-sidebar{\n    .sidebar {\n        .sidebar-menu > ul > li.submenu-open ul li a {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            font-weight: $font-weight-medium;\n            font-size: $font-size-15;\n            color: #67748E;\n            position: relative;\n            width: 100%;\n            padding: 10px;\n        }\n    }\n    &.expand-menu {\n        .sidebar {\n            .sidebar-menu > ul > li.submenu-open ul li a {\n                justify-content: left;\n                -webkit-justify-content: left;\n                -ms-flex-pack: left;\n                padding-left:  18px;\n            }\n        }\n    }\n}\n\n.sidebarrightmenu{\n    .sidebar-right{\n        display: block;\n    }\n}\n.slide-nav{\n    .sidebar {\n        margin-left: 0;\n    }\n}\n.sidebar-overlay {\n    display: none;\n    height: 100%;\n    width: 100%;\n    z-index: 99;\n    background-color: rgba(0, 0, 0, 0.6);\n    @include position(fixed,60px,null,null,0);\n    &.opened {\n        display: block;\n    }\n}\n.nosidebar {\n    .sidebar {\n        left: -350px;\n    }\n    .page-wrapper{\n        margin: 0;\n    }\n    #toggle_btn{\n        svg{\n            @include transform(rotate(180deg));\n        }\n    }\n}\n.mini-sidebar{\n    .active.subdrop ~ ul{\n        display: none !important;\n    }\n}\n.mini-sidebar.expand-menu{\n    .active.subdrop ~ ul{\n        display: block !important;\n    }\n}\n.active.subdrop ~ ul{\n    display: block !important;\n}\n\n\n.sidebar {\n    &.horizontal-sidebar {\n        &.sidebar-one {\n            .submenu {\n                ul {\n                    background: $body-bg;\n                }\n            }\n        }\n    }\n}",".topnav-dropdown-header{\n    border-bottom: 1px solid $gray-300;\n    text-align: center;\n    font-size: $font-size-12;\n    height: 32px;\n    line-height: 32px;\n    @include margin-padding(null, 0 12px);\n    .notification-title {\n        color: $gray-800;\n        display: block;\n        float: left;\n        font-size: $font-size-base;\n    }\n    .clear-noti {\n        color: $danger-700;\n        float: right;\n        font-size: $font-size-11;\n        text-transform: uppercase;\n    }\n}\n.notifications {\n    .noti-content {\n        height: 290px;\n        width: 350px;\n        overflow-y: auto;\n        position: relative;\n    }\n    .notification-list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        li {\n            margin-top: 0;\n            border-bottom: 1px solid $gray-100;\n            font-size: $font-size-base;\n            a {\n                display: block;\n                @include margin-padding(null, 12px);\n                @include rounded(2px);\n            }\n            .avatar {\n                width: 34px;\n                height: 34px;\n                margin: 0 10px 0 0;\n                border-radius: 50%;\n                img {\n                    border-radius: 50%;\n                }\n            }\n            .noti-title {\n                color: $gray-800;\n                font-weight: $font-weight-medium;\n            }\n            .noti-details {\n                color: $gray-500;\n                @include margin-padding(0, null);\n            }\n            p.noti-time{\n                @include margin-padding(0, null);\n            } \n            .notification-time {\n                font-size: $font-size-12;\n                line-height: 1.35;\n                color: $gray-600;\n            }\n            .list-item {\n                border: 0;\n                padding: 0;\n                position: relative;\n                .list-left {\n                    height: 48px;\n                    position: absolute;\n                    width: 48px;\n                }\n                .list-body {\n                    @include margin-padding(null, 0 0 0 50px);\n                    .message-author {\n                        color: $gray-800;\n                        float: left;\n                        font-weight: $font-weight-medium;\n                        width: 175px;\n                        display: block;\n                        max-width: 100%;\n                        overflow: hidden;\n                        text-overflow: ellipsis;\n                        white-space: nowrap;\n                    }\n                    .message-time {\n                        color: $gray-600;\n                        float: right;\n                        font-size: $font-size-11;\n                    }\n                    .message-content {\n                        color: $gray-800;\n                        font-size: $font-size-13;\n                        display: block;\n                        max-width: 100%;\n                        overflow: hidden;\n                        text-overflow: ellipsis;\n                        white-space: nowrap;\n                    }\n                }\n            }\n        }\n    }\n}\n.topnav-dropdown-footer {\n    border-top: 1px solid $gray-300;\n    font-size: $font-size-12;\n    height: 32px;\n    line-height: 32px;\n    @include margin-padding(null, 0 12px);\n    a {\n        display: block;\n        text-align: center;\n        color: $gray-800;\n    }\n}\n.list-left {\n    height: 48px;\n    position: absolute;\n    width: 48px;\n}\n.list-body {\n    @include margin-padding(null, 0 0 0 50px);\n    .message-author {\n        color: $gray-800;\n        float: left;\n        font-weight: $font-weight-medium;\n        width: 175px;\n        display: block;\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    .message-time {\n        color: $gray-600;\n        float: right;\n        font-size: $font-size-11;\n    }\n    .message-content {\n        color: $gray-800;\n        font-size: $font-size-13;\n        display: block;\n        max-width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n}\n.activity {\n    width: 100%;\n    .activity-box {\n        position: relative;\n    }\n    .activity-list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n        position: relative;\n        li {\n            background-color: $white;\n            position: relative;\n            border: 1px solid $gray-400;\n            @include margin-padding(0  0 10px,  20px 10px 10px);\n            font-size: $font-size-15;\n            .activity-user {\n                height: 50px;\n                margin: 0;\n                padding: 0;\n                width: 50px;\n                @include position(absolute,12px,null,null,8px);\n            }\n            .activity-content {\n                background-color: $white;\n                position: relative;\n                @include margin-padding(0 0 0 60px, 0);\n            }\n            .time {\n                color: $gray-500;\n                display: block;\n                font-size: $font-size-12;\n                line-height: 1.35;\n            }\n            a.name {\n                color: $black;;\n            }\n            a {\n                color: $secondary;\n                font-weight: $font-weight-semibold;\n                font-size: $font-size-15;\n                img{\n                    width:50px;\n                    height:50px;\n                    border-radius: 5px;\n                }\n            }\n        }\n    }\n    \n}\n",".account-page .customizer-links,.error-page .customizer-links{ \n  display: none;\n}\n.customizer-links {\n    @include position(fixed,50%,0,null,null);\n    @include transform(translateY(-50%));\n    background: $orange;\n    border-radius: 10px 0px 0px 10px;\n    z-index: 3;\n    width: 41px;\n    height: 38px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    @include transition(all 0.3s ease);\n    &:hover {\n        background: $title-color;\n    }\n    ul {\n        li {\n            border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n            &:last-child { \n                border-bottom: 0;\n            }\n            a {\n                padding: 5px;\n                text-align: center;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                border-radius: 5px;\n                svg {\n                    color: $white;\n                    width: 16px;\n                    height: 16px;\n                }\n            }\n        }\n    }\n}\n.sidebar-settings {\n    width: 450px;\n    background-color: $white;\n    @include position(fixed,0,-450px,null,null);\n    height: 100vh;\n    background-color: rgb(0,0,0,0.2);\n    z-index: 9999;\n    overflow-x: hidden;\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    overflow-y: scroll;\n    @include transition(ease all 0.8s);\n    &.show-settings {\n        right: 0;\n        @include transition(ease all 0.8s);\n        -ms-overflow-style: none;\n        scrollbar-width: none;\n        overflow-y: scroll;\n        width: 100%;\n    }\n}\n.sidebar-content {\n    max-width: 450px;\n    width: 100%;\n    @include position(absolute,0,0,null,null);\n    background: $white;\n    height: 100vh;\n    overflow-x: hidden;\n    .sidebar-header {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        @include margin-padding(null, 20px);\n        position: sticky;\n        top: 0;\n        left: 0;\n        right: 0;\n        z-index: 100;\n        background-color: $primary;\n        h5 {\n            font-size: $font-size-20;\n            color: $white;\n            font-weight: $font-weight-bold;\n            margin-bottom: 0;      \n            text-transform: uppercase;      \n            @include respond-below(custom991) {\n                font-size: $font-size-18;\n            }\n        }\n        p {\n            color: $white;\n        }\n        a {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $white;\n            width: 26px;\n            height: 26px;\n            border-radius: 5px; \n            color: $white;\n            svg {\n                width: 15px;\n                height: 15px;\n                color: $white\n            }\n        }\n    }\n    .theme-head {\n        margin-bottom: 20px;\n        h6 {\n            color:$text-color;\n            font-weight: $font-weight-bold;\n            font-size: $font-size-18;\n        }\n    }\n    .sidebar-body {\n        @include margin-padding(null, 20px);\n        .theme-title {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n            color: $gray-600;\n            margin-bottom: 10px;\n        }\n    }\n}\n.switch-wrapper {\n    border-bottom: 1px solid $gray-400;\n    @include margin-padding(0 0 20px, 0 0 20px);\n    #dark-mode-toggle {\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        .light-mode {\n            border-radius: 5px 0 0 5px;\n        }\n        .dark-mode {\n            border-radius: 0 5px 5px 0;\n        }\n        .light-mode, .dark-mode {\n            background: $gray-400;\n            font-size: $font-size-16;\n            color: $black;;\n            display: -webkit-inline-box;\n            display: -ms-inline-flexbox;\n            display: inline-flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            @include margin-padding(null, 11px 18px);\n            cursor: pointer;\n            img {\n                filter: brightness(0) saturate(100%)\n            }\n            &.active {\n                background: $orange;\n                color: $white;\n                img {\n                    filter:  brightness(0) invert(1);\n                }\n            }\n        }\n    }\n}\n.layout-wrap {\n    margin-bottom: 20px;\n    .status-toggle {\n        .checktoggle {\n            background: $black;;\n            width: 25px;\n            height: 15px;\n            :after {\n                width: 12px;\n                height: 12px;\n                right: 4px;\n            }\n        }  \n    } \n    .layout-img {\n        img {\n            max-width: 120px;\n        }\n    }         \n    .status-text {\n        font-size: $font-size-16;\n        color: $black;;\n    }\n}\n.layout-link {\n    position: relative;\n    z-index: 9;\n    width: 100%;\n    height: 100%;\n    display: inline-block;\n}\n.theme-mode {\n    .theme-body-main {\n        padding: 20px 20px 0;\n    }\n    @include margin-padding(0 0 20px,0);\n    .layout-wrap {\n        .check {\n            + label {\n                text-align: center;\n                cursor: pointer;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                flex-direction: column;\n                img {\n                    border-radius: 8px;\n                    border: 1px solid $gray-100;\n                }\n                .theme-name {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    color: $text-color;\n                    font-weight: $font-weight-bold;\n                    font-size: $font-size-base;\n                    margin-top: 10px;\n                    position: relative;\n                    &::before {\n                        content: \"\";\n                        width: 14px;\n                        height: 14px;\n                        border: 1px solid #919EAB4D;\n                        display: block;\n                        margin-right: 5px;\n                        border-radius: 50%;\n                    }\n                }\n            }\n            &:checked {\n                + label {\n                    img {\n                        border-color: $primary;\n                    }\n                    .theme-name {\n                        &::after {\n                            content: \"\";\n                            width: 6px;\n                            height: 6px;\n                            border-radius: 50%;\n                            background-color: $primary;\n                            position: absolute;\n                            left: 4px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n#layout_mode {\n    @include respond-below(custom991) {\n        display: none;\n    }\n}\t\n.sidebar-footer {\n    position: sticky;\n    padding: 20px;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background-color: $white;\n    box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);\n    z-index: 110;\n}","[data-layout-style=box] {\n    &[data-direction=rtl] {\n        body {\n            .page-wrapper {\n                .content {\n                    padding-left: 0;\n                    padding-right: 24px;\n                }\n            }\n        }\n    }\n    body {\n        margin: auto;\n        position: relative;\n        .header {\n            z-index: 9999;\n            left: 100px;\n            right: 100px;\n        }\n        .sidebar {\n            left: 100px;\n        }\n        .page-wrapper {\n            margin: 0 100px 0 380px;\n            .content {\n                padding-right: 0;\n            }\n            &.pos-pg-wrapper {\n                margin-left: 80px !important;\n            }\n        }\n        @include respond-below(custom1399) {\n            .header {\n                left: 70px;\n                right: 70px;\n            }\n            .sidebar {\n                left: 70px;\n            }\n            .page-wrapper {\n                margin: 0 70px 0 350px;\n                &.pos-pg-wrapper {\n                    margin-left: 50px !important;\n                }\n            }\n        }\n        @include respond-below(custom1199) {\n            .header {\n                left: 30px;\n                right: 30px;\n            }\n            .sidebar {\n                left: 30px;\n            }\n            .page-wrapper {\n                margin: 0 30px 0 310px;\n                &.pos-pg-wrapper {\n                    margin-left: 10px !important;\n                }\n            }\n\n        }\n        @include respond-below(custom991) {\n            .header {\n                left: 0;\n                right: 0;\n            }\n            .sidebar {\n                left: 0;\n            }\n            .page-wrapper {\n                margin: 0;\n                .content {\n                    padding-right: 15px;\n                }\n            }\n        }\n    }\n}\n[data-layout-style=collapsed] {\n    &[data-nav-color=grey] {\n        aside {\n            background: $gray-200;\n        }\n    }\n    &[data-nav-color=dark] {\n        aside {\n            background: $black-bg;\n        }\n    }\n    .sidebar {\n        display: none;\n        &.collapsed-sidebar {\n            display: block;\n            .nav-item {\n                margin-right: 0;\n                a {\n                    &:hover {\n                        background: transparent;\n                    }\n                }\n            }\n        }\n        @include respond-below(custom991) {\n            display: block;\n            &.collapsed-sidebar {\n                display: none;\n            }\n        }\n    }\n    // .expand-menu {\n    //     .sidebar .sidebar-menu ul > li > a {\n    //         padding: 18px 15px;\n    //     }\n    //     .sidebar.collapsed-sidebar .sidebar-menu ul li a::before {\n    //         left: 0;\n    //     }\n    //     .sidebar.collapsed-sidebar .sidebar-menu ul li ul li a {\n    //         padding: 10px 15px 10px 25px\n    //     }\n    // }\n}\n[data-layout-style=horizontal] {\n    .sidebar {\n        display: none;\n        &.horizontal-sidebar {\n            display: block;\n        }\n        @include respond-below(custom991) {\n            display: block;\n            &.horizontal-sidebar {\n                display: none;\n            }\n        }\n        .sidebar-menu > ul > li > a.active svg {\n            color: $primary;\n        }\n    }\n    .page-wrapper {\n        margin-left: 0;\n        padding-top: 140px;\n    }\n    .header #toggle_btn {\n        display: none;\n    }\n    .sidebar .sidebar-menu {\n        > ul > li.submenu ul {\n            background: rgb(246, 246, 246);\n        }\n        .nav {\n            > li {\n                > ul {\n                    max-height: 400px;\n                    overflow-x: hidden;\n                    overflow-y: auto;\n                }\n            }\n        }\n    } \n    body {\n        &.header-collapse {\n            .header {\n                display: none;\n            }\n            .horizontal-sidebar {\n                top: 0;\n                border-top: 0;\n            }\n            .page-wrapper {\n                padding-top: 60px;\n            }\n        }\n    }\n    @include respond-below(custom991) {\n        .sidebar {\n            &.collapsed-sidebar {\n                display: none;\n            }\n        }\n        .page-wrapper {\n            padding-top: 80px;\n        }\n    }\n}\n\n[data-layout-style=modern] {\n    .header {\n        position: relative;\n        #toggle_btn {\n            display: none;\n        }\n    }\n    .sidebar {\n        display: none;\n        &.horizontal-sidebar {\n            display: block;\n            background: $black-bg;\n            height: 150px;\n            position: static;\n            z-index: unset;\n            border-top-color: #637381;\n            .sidebar-menu {\n                @include margin-padding(null, 0 15px);\n                & > ul  {\n                   & > li {\n                        margin-bottom: 0;\n                        margin-right: 20px;\n                        & > a {\n                            @include margin-padding(null, 22px 15px);\n                            img, svg {\n                                filter:  brightness(0) invert(1);\n                                margin-right: 0;\n                            }\n                            @include respond-below(custom1199) {\n                                @include margin-padding(null, 22px 5px);\n                            }\n                            &:hover {\n                                background: transparent;\n                                span {\n                                    color:$primary !important;\n                                }\n                                img, svg {\n                                    filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);\n                                }\n                            }\n                            img {\n                                top: 0 !important;\n                                width: auto;\n                            }\n                            &::before {\n                                content: \"\";\n                                @include position(absolute, 50%, -10px, null, null);\n                                width: 1px;\n                                height: 15px;\n                                background: #6B7A99;\n                                transform: translateY(-50%);\n                            }\n                        }\n                        & > a {\n                            span {                        \n                                color: $white  !important;\n                            }\n                        }\n                        a {\n                            font-weight: $font-weight-medium;\n                            font-size: $font-size-15;\n                            color: $white;\n                            img {\n                                position: relative;\n                                top: 3px;\n                                width: 18px;\n                                margin-right: 7px;\n                                filter:  brightness(0) invert(1);\n                                @include respond-below(custom1199) {\n                                    margin-right: 5px;\n                                }\n                            }\n                            svg {\n                                width: 18px;\n                                margin-right: 7px;\n                            }\n                            &:hover {                        \n                                img, svg {                                        \n                                    filter: brightness(0) invert(1);\n                                }\n                            }\n                        }\n                        .menu-arrow {\n                            position: initial;\n                            transform: rotate(90deg);\n                            margin-left: 15px;\n                        }\n                        ul {\n                            position: absolute;\n                            width: 250px;\n                            height: auto;\n                            z-index: 101;\n                            background: #1B2950;\n                            li {\n                                &.submenu {\n                                    a {\n                                        padding: 8px 15px !important;\n                                        color: $white;\n                                        ul {\n                                            li {\n                                                a {\n                                                    &.active {\n                                                        span {\n                                                            color: $primary;\n                                                        }                                                \n                                                    }\n                                                }\n                                            }\n                                        }\n                                        .menu-arrow {\n                                            float: right;\n                                            margin-right: 15px;\n                                        }\n                                        i {\n                                            margin-right: 7px;\n                                        }\n                                        img {\n                                            position: relative;\n                                            top: 3px;\n                                            width: 18px;\n                                            margin-right: 7px;\n                                        }\n                                        svg {\n                                            width: 18px;\n                                            margin-right: 7px;\n                                        }\n                                        &:hover {\n                                            color: $primary;\n                                            img {                                        \n                                                filter: brightness(0) saturate(100%) invert(75%) sepia(10%) saturate(5676%) hue-rotate(326deg) brightness(105%) contrast(112%);\n                                            }\n                                        }\n                                    }\n                                    & ul {\n                                        box-shadow: none;\n                                    }\n                                    ul {\n                                        position: relative;    \n                                        @include margin-padding(null, 0); \n                                        li {\n                                            a {\n                                                padding: 8px 10px 8px 40px !important;\n                                                color: $white;\n                                            }\n                                        }                           \n                                    }\n                                }\n                                a {\n                                    padding: 8px 15px !important;\n                                    &::after {\n                                        content: none !important;\n                                    }\n                                }\n                            }\n                        }                                \n                        @include respond-below(custom1199) {\n                           margin-right: 0;\n                        }\n                        &:last-child {\n                            & > a {\n                                &::before {\n                                    content: none;\n                                }\n                            }\n                        }\n                    }\n                }\n                > ul > li > a {\n                    span {\n                        color: $white !important;\n                    }\n                    &.active {\n                        span {\n                            color: $primary !important;\n                        } \n                    }\n                }\n                > ul > li ul li.submenu {\n                    a {\n                        svg {\n                            filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);\n                        }\n                    }\n                    ul li a {\n                        color: $gray-500;\n                    }\n                }\n            }\n        }\n        ul {\n            &.nav {\n                justify-content: center;\n            }\n        }\n    }\n    .page-wrapper {\n        margin-left: 0;\n        padding-top: 0;\n        .content {\n            max-width: 1280px;\n            margin: -90px auto 0 auto;\n            background: $white;\n            border-radius: 20px;\n            padding-bottom: 20px;\n            @include respond-below(custom1199) {\n                max-width: 950px;\n            }\n        }\n    }\n}\n[data-nav-color=dark] {\n    .header {\n        background: $black-bg;\n        border-bottom: 1px solid #434548;\n        .header-left {\n            border-right: 1px solid $gray-600; \n            border-bottom: 1px solid #434548;           \n            .logo-normal {\n                display: none;\n            }\n            .logo-white {\n                display: block !important;\n            }\n        }\n        .searchinputs {\n            input {\n                color: $theme-title;\n                border-color: $black-bg;\n                background: $input-bg;\n                &::placeholder {\n                    color: $gray-500;\n                }\n            }\n        }\n    }\n    .mini-sidebar {\n        .header-left {\n            .logo-white {\n                display: none !important;\n            }\n            .logo-small {\n                display: block !important;\n            }\n        }\n        &.expand-menu {\n            .logo-small {\n                display: none !important;\n            }\n            .logo-white {\n                display: block !important;\n            }\n        }\n    }\n    #toggle_btn{\n        &:before{\n            border: 2px solid $theme-title\n        }\n    }\n    .user-menu.nav > li > a.select-store {\n        .user-info .user-name {\n            color: $theme-title;\n        }\n    }\n    .user-info .user-name {\n        color: $theme-title;\n    }\n    .user-menu {\n        .nav-item-box {\n            > a{\n                background: $input-bg;\n            }\n        }\n    }\n    .header-left{\n        &.active {\n            #toggle_btn:after {\n                border: 2px solid $theme-title;\n            }\n        }\n    }\n    .sidebar {\n        border-right: 1px solid $gray-600;\n        background-color: $black-bg;\n        .slimScrollDiv{\n            background: $black-bg;\n        }\n        .sidebar-menu > {\n            ul > li {\n                &.submenu ul {\n                    background: $black-bg;\n                    border-radius: 5px;\n                    padding: 10px 0;\n                    li {\n                        a {                            \n                            color: $gray-500;\n                        }\n                    }\n                }\n                a {\n                    img {\n                        filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);\n                    }\n                    span {\n                        color: $gray-500;\n                    }\n                    &:hover {\n                        img {\n                            color: $gray-500;\n                        }\n                        svg{\n                            filter: brightness(0) saturate(100%) invert(65%) sepia(27%) saturate(206%) hue-rotate(165deg) brightness(93%) contrast(88%);\n                        }\n                    }\n                }\n                .submenu-hdr {\n                    color: $gray-500;\n                }\n            }\n        }\n    }\n}\n[data-nav-color=grey] {\n    .header {\n        background: $gray-200;\n        .user-menu .nav-item-box > a {\n            background: $white;\n        }\n    }\n    .sidebar .slimScrollDiv, .sidebars .slimScrollDiv {\n        background: $gray-200;\n    }\n    .searchinputs input {\n        border-color: $gray-200;\n        background: $white;\n    }\n}\n[data-direction=rtl] {\n    &[data-layout-style=collapsed] {\n        .sidebar.collapsed-sidebar {\n            .sidebar-menu {\n                ul {\n                    li a {\n                        padding: 10px 25px 10px 15px;\n                        &::before {\n                            right: 10px;\n                            left: auto;\n                        }\n                        .menu-arrow {\n                            left: 15px;\n                            right: auto;\n                        }\n                    } \n                } \n            } \n            .tab-content-four {\n                margin-right: 10px;\n                margin-left: 0;\n            }\n        } \n    }\n    body {\n        direction: rtl;\n        .me-2 {\n            margin-left: 0.5rem !important;\n            margin-right: 0 !important;\n        }\n        .ms-2 {\n            margin-right: 0.5rem !important;\n            margin-left: 0 !important;\n        }\n        .header {\n            .header-left {\n                float: right;\n                border-left: 1px solid #DEE2E6;\n                #toggle_btn {\n                    left: -13px;\n                    right: auto;\n                }\n                @include respond-above(custom991) {\n                    #toggle_btn {\n                        float: right;\n                        font-size: $font-size-26;\n                        line-height: 50px;\n                        margin-right: 15px;\n                        margin-left: 0;\n                        .bar-icon {\n                            display: inline-block;\n                            width: 21px;\n                            span {\n                                background-color: $white;\n                                display: block;\n                                float: right;\n                                height: 2px;\n                                width: 21px;\n                                @include margin-padding(0 0 5px, null);\n                                @include rounded(50px);\n                                &:nth-child(2) {\n                                    width: 15px;\n                                }\n                            }\n                        }\n                    }\n            \n                }\n            }\n            .user-menu {\n                .nav-searchinputs {\n                    margin-left: auto;\n                    margin-right: 25px;\n                }\n                > li {\n                    > a {\n                        &.select-store {\n                            .user-info {\n                                padding: 3px 0px 3px 25px;\n                                @include respond-below(custom1199) {\n                                    padding-right: 0;\n                                    padding-left: 15px;\n                                }\n                                .user-letter {\n                                    margin-right: 0;\n                                    margin-left: 10px;\n                                }\n                                &:after {\n                                    right: auto;\n                                    left: 6px;\n                                }\n                            }\n                        }\n                    }\n                }\n                &.nav{\n                    > li {\n                        &.flag-nav {\n                            .dropdown-menu {\n                                .dropdown-item {\n                                    &.active,&:hover {\n                                        background: #F7F7F7 url(../../../../public/assets/img/icons/check.svg) no-repeat calc(12% - 12px) center;\n                                    }\n                                }\n                                a {\n                                    img{\n                                        margin-right: 0;\n                                        margin-left: 10px;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            } \n            .user-info {\n                padding: 0 0 0 30px;\n                &::after {\n                    left: 12px;\n                    right: auto;\n                }\n                .user-letter {\n                    margin-left: 10px;\n                    margin-right: 0;\n                }\n            }\n            .select-store-dropdown {\n                .dropdown-menu {\n                    .dropdown-item {\n                        img {\n                            margin-left: 8px;\n                            margin-right: 0;\n                        }\n                    } \n                } \n            } \n        }\n        .sidebar, .sidebars {\n            right: 0;\n            left: auto;\n            .sidebar-menu {\n                .menu-arrow {\n                    left: 15px;\n                    right: auto;\n                }\n                ul {\n                    li {\n                        svg {\n                            margin-left: 10px;\n                            margin-right: 0;\n                        }\n                    }\n                }\n                .submenu-open {\n                    .submenu {\n                        ul {\n                            li {\n                                a {\n                                    margin-right: 25px;\n                                    margin-left: 0;\n                                    padding: 10px 18px 10px 10px;\n                                    &::after {\n                                        right: 0;\n                                        left: auto;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        } \n        .page-wrapper {\n            margin: 0 260px 0 0;\n        }\n        .customizer-links {\n            left: 0;\n            right: auto;\n            border-radius: 0 10px 10px 0px;\n        }\n        .sidebar-settings {\n            left: -450px;\n            right: auto;\n            &.show-settings {\n                left: 0;\n                right: auto;\n            }\n            .sidebar-content {\n                left: 0;\n                right: auto;\n                .layout-wrap {\n                    .check {\n                        + label {\n                            .theme-name {\n                                &::before {\n                                    content: \"\";\n                                    margin-left: 5px;\n                                    margin-right: 0;\n                                    border-radius: 50%;\n                                }\n                            }\n                        }\n                        &:checked {\n                            + label {\n                                .theme-name {\n                                    &::after {\n                                        content: \"\";\n                                        right: 4px;\n                                        left: auto;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .dash-widget {\n            .dash-widgetcontent {\n                margin-right: 20px;\n                margin-left: 0;\n            }\n        } \n        table.dataTable thead th, table.dataTable thead td, table.dataTable tfoot th, table.dataTable tfoot td {\n            text-align: right;\n        }\n        .graph-sets > ul li {\n            margin-left: 35px;\n            margin-right: 0;\n        }\n        .table {\n            tbody {\n                tr {\n                    td {\n                        a.product-img {\n                            margin-left: 5px;\n                            margin-right: 0;\n                        }\n                    } \n                } \n            } \n        } \n        table.dataTable>thead .sorting:after, \n        table.dataTable>thead .sorting_asc:after,\n        table.dataTable>thead .sorting_desc:after,\n        table.dataTable>thead .sorting_asc_disabled:after, \n        table.dataTable>thead .sorting_desc_disabled:after {\n            left: 0.5em !important;\n            right: auto !important;\n        }\n        table.dataTable>thead .sorting:before, \n        table.dataTable>thead .sorting_asc:before, \n        table.dataTable>thead .sorting_desc:before, \n        table.dataTable>thead .sorting_asc_disabled:before, \n        table.dataTable>thead .sorting_desc_disabled:before {\n            left: 0.5em !important;\n            right: auto !important;\n        }\n        table.dataTable thead>tr>th.sorting, table.dataTable thead>tr>th.sorting_asc {\n            padding-left: 25px;\n            padding-right: 17px;\n        }\n    }\n    @include respond-above(custom991) {\n        .mini-sidebar {\n            .page-wrapper {\n                margin-right: 80px;\n            }\n        }\n    }\n    .page-header .page-btn  {\n        margin-right: 15px;\n        margin-left: 0;\n    }\n    .page-header .add-item.d-flex {\n        margin-left: auto;\n        margin-right: 0;\n    }\n    .search-set .search-input .btn-searchset {\n        left: 0;\n        right: auto;\n    }\n}\n\n.sidebar {\n    &.horizontal-sidebar {\n        display: none;\n    }\n}\n\n.pos-modal {\n    .modal-header {\n        h5 {\n            margin-bottom: 0;\n        }\n    } \n} \n.modal {\n    button {\n        &.close {\n            font-size: $font-size-20;\n            &:hover {\n                background: $danger;\n            }\n        }\n    }\n}\n.custom-modal-header {\n    .page-title {\n        h4 {\n            margin-bottom: 0;\n        }\n    } \n} \n.product-wrap {\n\t.product-list {\n\t\t.info {\n\t\t\tspan {\n\t\t\t\tmargin-bottom: 7px;\n                display: inline-block;\n\t\t\t}\n            h6 {\n                a {\n                    margin-bottom: 5px;\n                    display: inline-block;\n                }\n            }\n\t\t}\n\t}\n}\n.tabs_wrapper {\n\tul.tabs {\n\t\tli.active {\n\t\t\tspan {\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n\t}\n}",".main-chat-blk {\n    .slimscroll {\n\t\theight: calc(100vh - 60px) !important;\n    }\n    .slimscroll-active-sidebar {\n        a {\n            color: $text-color;\n        }\n    }\n\n    .emoj-group ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n    }\n    .emoj-group ul li+li {\n        margin-left: 10px;\n    }\n    .emoj-group ul li a {\n        width: 34px;\n        height: 34px;\n        background: #f6f7f8;\n        border-radius: 50px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n    }\n    .emoj-group ul li a i {\n        color: #424242;\n    }\n    .message-content {\n        position: relative;\n    }\n    .message-content:hover .emoj-group {\n        opacity: 1;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n        \n    }\n    .emoj-group {\n        position: absolute;\n        top: 50%;\n        right: -100px;\n        opacity: 0;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n        -webkit-transform: translate(0, -50%);\n        -ms-transform: translate(0, -50%);\n        transform: translate(0, -50%);\n    }\n    .rig-emoji-group {\n        position: absolute;\n        right: 210px;\n    }\n    .wrap-emoji-group {\n        position: absolute;\n        right: 290px;\n    }\n    .emoj-group-list-foot {\n        display: none;\n        position: absolute;\n        top: -50px;\n        left: -90px;\n        transition: all 0.5s ease;\n        -moz-transition: all 0.5s ease;\n        -o-transition: all 0.5s ease;\n        -ms-transition: all 0.5s ease;\n        -webkit-transition: all 0.5s ease;\n    }\n    .emoj-group-list-foot ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        align-items: center;\n        background: #f6f7f8;\n        border-radius: 50px;\n        padding: 5px;\n    }\n    .emoj-group-list-foot ul li a {\n        padding: 0;\n\t\tdisplay: flex;\n\t\talign-items: center;\n    }\n    .emoj-group-list-foot ul li.add-emoj a {\n        background: #EDEDED;\n    }\n    .emoj-group-list-foot ul li.add-emoj a i {\n        font-size: $font-size-20;\n        color: #424242;\n    }\n\n    .down-emoji-circle {\n        position: absolute;\n        left: 10px !important;\n        top: -38px !important;\n    }\n    .emoj-action-foot .down-emoji-circle ul {\n        padding: 10px;\n    }\n    .down-emoji-circle ul li + li {\n        margin-left: 14px\t;\n    }\n    .emoj-action-foot .down-emoji-circle ul li:last-child a {\n        width: 34px;\n        height: 34px;\n        border-radius: 50px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\t.chat-page-wrapper {\n\t\t.content {\n\t\t\tpadding: 0;\n\t\t}\n\t\t.sidebar {\n\t\t\tposition: initial;\n\t\t\t@include respond-below(custom991) {\n\t\t\t\tmargin-left: 0;\n\t\t\t}\n\t\t}\n\t\t.left-chat-title {\n\t\t\tpadding: 24px;\n\t\t\tborder-bottom: 1px solid #E0E0E0;\n\t\t\tmin-height: 72px;\n\t\t}\n\t\t.setting-title-head {\n\t\t\th4 {\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t\tcolor: $secondary;\n\t\t\t\tfont-weight: $font-weight-bold;\n\t\t\t}\n\t\t}\n\t\t.chat .slimscroll {\n\t\t\theight: calc(100vh - 135px) !important;\n\t\t}\n\t\t.dropdown-menu .dropdown-item {\n\t\t\tfont-size: $font-size-14;\n\t\t\tcursor: pointer;\n\t\t\tpadding: 7px 14px;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t.dropdown-menu .dropdown-item i {\n\t\t\tfont-size: $font-size-16;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item span {\n\t\t\tfloat: right;\n\t\t\tfont-size: $font-size-18;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item.active {\n\t\t\tbackground: none;\n\t\t\tcolor: inherit;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item:focus,\n\t\t.dropdown-menu .dropdown-item:hover,\n\t\t.dropdown-menu .dropdown-item:active {\n\t\t\tbackground-color: #e6e6e6;\n\t\t}\n\t\t.dropdown-menu {\n\t\t\tbackground: $white;\n\t\t\tborder: 1px solid #E5E7EB;\n\t\t\tbox-sizing: border-box;\n\t\t\tbox-shadow: 0px 4px 3px 0px rgba(0, 0, 0, 0.1);\n\t\t\tborder-radius: 8px;\n\t\t\tmin-width: 173px;\n\t\t}\n\t\t\n\t\t.dropdown-menu .dropdown-item {\n\t\t\tmargin: 0;\n\t\t\tposition: relative;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t}\n\t\t.dropdown-menu.chat-drop-menu .dropdown-item i {\n\t\t\tfont-size: $font-size-16;\n\t\t\tcolor: #424242;\n\t\t}\n\t\t.dropdown-menu .dropdown-item:hover,\n\t\t.dropdown-menu .dropdown-item:focus,\n\t\t.dropdown-menu .dropdown-item:active {\n\t\t\tbackground-color: #F8ECFF;\n\t\t}\n\t\t.dropdown-menu .dropdown-item span {\n\t\t\tmargin-right: 10px;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t}\n\t\t.contact-close_call {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t}\n\t}\n    \t\t\n@-webkit-keyframes wave {\n\t0%,100%,60% {\n\t\t-webkit-transform: initial;\n\t\ttransform: initial;\n\t}\n\t30% {\n\t\t-webkit-transform: translateY(-5px);\n\t\ttransform: translateY(-5px);\n\t}\n}\n@keyframes wave {\n\t0%,100%,60% {\n\t\t-webkit-transform: initial;\n\t\ttransform: initial;\n\t}\n\t30% {\n\t\t-webkit-transform: translateY(-5px);\n\t\ttransform: translateY(-5px);\n\t}\n}\n.chat {\n\tflex: 1;\n\tdisplay: flex;\n\tflex-direction: column;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\tbackground: $white;\n\t.chat-header {\n\t\tdisplay: flex;\n\t\tdisplay: -webkit-flex;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\tpadding: 15px 24px;\n\t\talign-items: center;\n        border-bottom: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n        background: var(--White, #FFF);\n        box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\n\t\tposition: relative;\n\t\t.user-details {\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\talign-items: center;\n\t\t\t-webkit-align-items: center;\n\t\t\tfigure {\n\t\t\t\tmargin-right: 1rem;\n\t\t\t}\n\t\t\th5 {\n\t\t\t\tfont-size: $font-size-15;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\tmargin-bottom: 4px;\n\t\t\t\tline-height: 1;\n\t\t\t\tcolor: $gray-900;\n\t\t\t}\n\t\t}\n\t\t.chat-options {\n\t\t\tul {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\tdisplay: flex;\n\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\talign-items: center;\n\t\t\t\t-webkit-align-items: center;\n\t\t\t\t>li {\n\t\t\t\t\t>a {\n\t\t\t\t\t\tfont-size: $font-size-14;\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\twidth: 40px;\n\t\t\t\t\t\theight: 40px;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tborder: none;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t-webkit-align-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\t\t}\n\t\t\t\t\t\t&:not(.no-bg) {\n\t\t\t\t\t\t\t&:hover {\n\t\t\t\t\t\t\t\tbackground-color: $gray-100;\n\t\t\t\t\t\t\t\tborder-color: $gray-100;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.chat-body {\n\t\tflex: 1;\n\t\tpadding: 24px;\n\t\tpadding-bottom: 40px;\n\t\t&:not(.no-message) {\n\t\t\toverflow: hidden;\n\t\t}\n\t\t.messages {\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\tflex-direction: column;\n\t\t\t-webkit-flex-direction: column;\n\t\t\talign-items: flex-start;\n\t\t\t-webkit-align-items: flex-start;\n\t\t\t.chats {\n\t\t\t\tmax-width: 75%;\n\t\t\t\tmargin-bottom: 1.5rem;\n\t\t\t\tdisplay: flex;\n\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t}\n\t\t\t\t.chat-time {\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t-webkit-align-items: center;\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t.avatar {\n\t\t\t\t\t\tmargin-right: 1rem;\n\t\t\t\t\t}\n\t\t\t\t\th5 {\n\t\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t}\n\t\t\t\t\t.time {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\tmargin-top: 2px;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tcolor: rgba(247, 247, 247, 0.5);\n\t\t\t\t\t\t\timg {\n\t\t\t\t\t\t\t\twidth: 14px;\n\t\t\t\t\t\t\t\theight: auto;\n\t\t\t\t\t\t\t\tmargin-left: 2px;\n\t\t\t\t\t\t\t\tvertical-align: 0px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content {\n\t\t\t\t\tborder-radius: 0px 15px 15px 15px;\n                    background: var(--light-color, #F6F7F8);\n\t\t\t\t\tpadding: 14px 20px;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tfont-size: $font-size-14;\n\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\tbox-shadow: 0px 6px 12px 0px #00000008;\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $cyan;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content.award-link {\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tmargin-bottom: 2px;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\n\t\t\t\t\timg {\n\t\t\t\t\t\tborder-radius: 10px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content.chat-award-link {\n\t\t\t\t\ta {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.message-content.fancy-msg-box {\n\t\t\t\t\t.image-not-download {\n\t\t\t\t\t\tspan {\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\ttop: 50%;\n\t\t\t\t\t\t\tleft: 50%;\n\t\t\t\t\t\t\t-webkit-transform: translate(-50%, -50%);\n\t\t\t\t\t\t\t-ms-transform: translate(-50%, -50%);\n\t\t\t\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chat-profile-name {\n\t\t\t\th6 {\n\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tspan {\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\t\tpadding-left: 10px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chats.chats-right {\n\t\t\t\tmargin-left: auto;\n\t\t\t\t.chat-time {\n\t\t\t\t\tjustify-content: flex-end;\n\t\t\t\t}\n\t\t\t\t.message-content {\n\t\t\t\t\tborder-radius: 15px 0px 15px 15px;\n                    background: rgba(255, 159, 67, 0.12);\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tpadding: 15px;\n\t\t\t\t\t.chat-time {\n\t\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\t\t-webkit-justify-content: flex-start;\n\t\t\t\t\t\t.time {\n\t\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\t\ti {\n\t\t\t\t\t\t\t\tcolor: $cyan;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.chat-action-btns {\n\t\t\t\t\torder: 2;\n\t\t\t\t\t-webkit-order: 2;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t\t-webkit-flex-wrap: wrap;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t.chat-action-col {\n\t\t\t\t\t\twidth: 20px;\n\t\t\t\t\t\ttext-align: center;\n\t\t\t\t\t}\n\t\t\t\t\t.chat-read-col {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\t\talign-items: flex-end;\n\t\t\t\t\t\t-webkit-align-items: flex-end;\n\t\t\t\t\t\tpadding-bottom: 22px;\n\t\t\t\t\t\tcolor: $gray-600;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.chat-content {\n\t\t\t\t\torder: 1;\n\t\t\t\t\t-webkit-order: 1;\n\t\t\t\t}\n\t\t\t\t.chat-avatar {\n\t\t\t\t\tpadding: 8px 0px 0 15px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.download-col {\n\t\t\t\tposition: relative;\n\t\t\t\tul {\n\t\t\t\t\tlist-style: none;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin: 0 0 5px 0;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\tli+li {\n\t\t\t\t\t\tmargin-left: 5px;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.image-download-col {\n\t\t\t\t\tposition: relative;\n\t\t\t\t\ta {\n\t\t\t\t\t\t>img {\n\t\t\t\t\t\t\tborder: 1px solid transparent;\n\t\t\t\t\t\t\twidth: 80px;\n\t\t\t\t\t\t\tborder-radius: 8px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.image-download-col.image-not-download {\n\t\t\t\t\ta {\n\t\t\t\t\t\t>img {\n\t\t\t\t\t\t\t-webkit-filter: blur(1px);\n\t\t\t\t\t\t\tfilter: blur(1px);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.download-action {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 8px;\n\t\t\t\t\tbottom: 8px;\n\t\t\t\t\tline-height: 0;\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t}\n\t\t\t\t\tdiv+div {\n\t\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t\t}\n\t\t\t\t\tdiv {\n\t\t\t\t\t\timg {\n\t\t\t\t\t\t\twidth: 13px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.file-download {\n\t\t\t\t.download-action {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tright: 8px;\n\t\t\t\t\tbottom: 8px;\n\t\t\t\t\tline-height: 0;\n\t\t\t\t\tbottom: 14px;\n\t\t\t\t\ta {\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t\tfont-size: 10px;\n\t\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\t}\n\t\t\t\t\tdiv+div {\n\t\t\t\t\t\tmargin-left: 8px;\n\t\t\t\t\t}\n\t\t\t\t\tdiv {\n\t\t\t\t\t\timg {\n\t\t\t\t\t\t\twidth: 13px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tposition: relative;\n\t\t\t\tbackground: $gray-300;\n\t\t\t\tborder-radius: 10px;\n\t\t\t\tpadding: 10px;\n\t\t\t\tmargin-bottom: 7px;\n\t\t\t\t.file-type {\n\t\t\t\t\twidth: 54px;\n\t\t\t\t\theight: 54px;\n\t\t\t\t\tbackground-color: $white;\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t\ti {\n\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\tfont-size: $font-size-24;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.file-details {\n\t\t\t\t\tspan.file-name {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\t}\n\t\t\t\t\tspan.file-size {\n\t\t\t\t\t\tcolor: $gray-500;\n\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t\tul {\n\t\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tpadding: 0;\n\t\t\t\t\t\tmargin-bottom: 0;\n\t\t\t\t\t\tli {\n\t\t\t\t\t\t\tlist-style: none;\n\t\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\t\tfont-size: $font-size-14;\n\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t\t\t\twidth: 1px;\n\t\t\t\t\t\t\t\theight: 13px;\n\t\t\t\t\t\t\t\tbackground: #C2C2C2;\n\t\t\t\t\t\t\t\tright: -8px;\n\t\t\t\t\t\t\t\ttop: 5px;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t&:last-child {\n\t\t\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\t\t\tdisplay: none;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\ta {\n\t\t\t\t\t\t\t\tcolor: $primary;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\tli+li {\n\t\t\t\t\t\t\tpadding-left: 15px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.chat-body.no-message {\n\t\tuser-select: none;\n\t}\n\t.chat-footer {\n\t\tposition: relative;\n\t\tform {\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\talign-items: center;\n\t\t\t-webkit-align-items: center;\n\t\t\tposition: relative;\n\t\t\tbottom: 0;\n\t\t\tleft: 0;\n\t\t\tright: 0;\n\t\t\tpadding: 24px;\n\t\t\t@include respond-below(custom991) {\n\t\t\t\tpadding-bottom: 15px;\n\t\t\t}\n\t\t\t.form-buttons {\n\t\t\t\t.btn {\n\t\t\t\t\tmargin-left: 0px;\n\t\t\t\t\tcolor: $gray-400;\n\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\twidth: 20px;\n\t\t\t\t\theight: 20px;\n\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t&:last-child {\n\t\t\t\t\t\tmargin-right: 0;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\t.btn.send-btn {\n\t\t\t\t\twidth: 40px;\n\t\t\t\t\theight: 40px;\n\t\t\t\t\tborder-radius: 6px;\n                    background: $primary;\n\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tcolor: $white !important;\n\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tbackground-color: $white;\n\t\t\t\t\t\tborder-color: $gray-800;\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t&:focus {\n\t\t\t\t\t\tbox-shadow: none;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.specker-col {\n\t\t\t\tspan {\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tfont-size: 25px;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.attach-col {\n\t\t\t\ti {\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t}\n\t\t\t\tright: inherit;\n\t\t\t\tleft: 60px;\n\t\t\t}\n\t\t\t.smile-col {\n\t\t\t\ti {\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\tfont-size: $font-size-22;\n\t\t\t\t}\n\t\t\t\tright: inherit;\n\t\t\t\tleft: 15px;\n\t\t\t}\n\t\t\t.smile-foot {\n\t\t\t\tmargin-right: 10px;\n\t\t\t\t.action-circle {\n\t\t\t\t\twidth: 38px;\n\t\t\t\t\theight: 38px;\n\t\t\t\t\tbackground: $white;\n\t\t\t\t\tborder-radius: 50px;\n\t\t\t\t\tdisplay: -webkit-box;\n\t\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t-webkit-box-align: center;\n\t\t\t\t\t-ms-flex-align: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\t-ms-flex-pack: center;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tbackground-color: $gray-100;\n\t\t\t\t\t\tborder-color: $gray-100;\n\t\t\t\t\t}\n\t\t\t\t\ti {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t\tfont-size: $font-size-18;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\t.form-control {\n\t\t\t\t&::-webkit-input-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t&::-moz-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t&:-ms-input-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t\t&:-moz-placeholder {\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\topacity: 1;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\n}\n.chat-options {\n\tul.list-inline {\n\t\t.list-inline-item {\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n}\n.last-seen {\n\tcolor: $gray-900;\n\tfont-size: $font-size-14;\n}\n.user_callog {\n\tdisplay: flex;\n\tmargin-top: 0px;\n}\n.calllog_p {\n\tmargin-left: 5px;\n}\n.chat-options.chat-option-profile {\n\t.list-inline-item {\n\t\ta {\n\t\t\tbackground: $primary;\n\t\t\twidth: 38px;\n\t\t\theight: 38px;\n\t\t\tborder-radius: 50px;\n\t\t\tcolor: $gray-900;\n\t\t\tpadding: 0;\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\t-ms-flex-pack: center;\n\t\t\tcolor: $white;\n\t\t\t&:hover {\n\t\t\t\tbackground: #1b2950;\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t}\n\t}\n\t.list-inline {\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tmargin-bottom: 0;\n\t\tpadding-bottom: 15px;\n\t}\n}\n.last-seen-profile {\n\tspan {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t\tfont-weight: $font-weight-normal;\n\t\tmargin-bottom: 12px;\n\t\tdisplay: block;\n\t}\n}\n.header_button {\n\tposition: absolute;\n\tright: 5px;\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 20px;\n\tfont-size: $font-size-14;\n\tcolor: $white;\n\ttext-align: center;\n\tbackground: #ffa977;\n\tbottom: 40px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n}\n.btn-warning {\n\t&:hover {\n\t\tcolor: $white;\n\t\tbackground-color: $primary-800;\n\t\tborder-color: $primary-900;\n\t}\n}\n.right_sidebar_profile {\n\tmargin-top: 0px;\n}\n.account_details {\n\tbackground-color: $gray-300;\n\tborder-color: $gray-400;\n\tborder-radius: 5px !important;\n\tborder-bottom: 0 !important;\n}\n.security_details {\n\tbackground-color: $gray-300;\n\tborder-color: $gray-400;\n\tborder-radius: 5px !important;\n\tborder-bottom: 0 !important;\n}\n.close_icon {\n\tfont-size: $font-size-18;\n}\n.button_plus {\n\tmargin-left: 0px;\n}\n.chat-search {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\topacity: 0;\n\tvisibility: hidden;\n\tinput[type=\"text\"] {\n\t\tpadding: 8px 8px 8px 35px;\n\t\twidth: 100%;\n\t\tmin-height: 47px;\n\t\tborder-radius: 0px 0px 5px 5px;\n\t\tborder: 1px solid #E5E7EB;\n\t\tfont-size: 13px;\n\t\tbackground-color: $white;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\t&:hover {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus-visible {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t}\n}\n.chat-search.visible-chat {\n\topacity: 1;\n\tvisibility: visible;\n\ttop: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\tz-index: 9;\n}\n.form-control-feedback {\n\tz-index: 2;\n\tdisplay: block;\n\ttext-align: center;\n\tpointer-events: none;\n\tcolor: rgba(0, 0, 0, 0.4);\n\tposition: absolute;\n\tleft: 13px;\n\ttop: 50%;\n\ttransform: translateY(-50%);\n\t-webkit-transform: translateY(-50%);\n\t-ms-transform: translateY(-50%);\n\ti {\n\t\tfont-size: $font-size-16;\n\t\tcolor: $gray-900;\n\t}\n}\n.user-chat-search {\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\twidth: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\topacity: 0;\n\tvisibility: hidden;\n\tinput[type=\"text\"] {\n\t\tpadding: 8px 8px 8px 35px;\n\t\twidth: 100%;\n\t\tmin-height: 47px;\n\t\tborder-radius: 0px 0px 5px 5px;\n\t\tborder: 1px solid #E5E7EB;\n\t\tfont-size: 13px;\n\t\tbackground-color: $white;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\t&:hover {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t\t&:focus-visible {\n\t\t\tborder-color: $gray-200;\n\t\t}\n\t}\n}\n.user-chat-search.visible-chat {\n\topacity: 1;\n\tvisibility: visible;\n\ttop: 100%;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n\tz-index: 9;\n}\n.all-chats {\n\tposition: relative;\n}\n.close-btn-chat {\n\twidth: 25px;\n\theight: 25px;\n\tborder-radius: 25px;\n\tcolor: $gray-900;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tposition: absolute;\n\tright: 12px;\n\ttop: 9px;\n\tcursor: pointer;\n}\n.user-close-btn-chat {\n\twidth: 25px;\n\theight: 25px;\n\tborder-radius: 25px;\n\tcolor: $gray-900;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tposition: absolute;\n\tright: 12px;\n\ttop: 9px;\n\tcursor: pointer;\n}\n.main_content {\n\twidth: 100% !important;\n}\n.avatar-main {\n\theight: 50px;\n\twidth: 50px;\n}\n.archive-btn {\n\tborder: 1px solid #008024;\n\tcolor: $gray-600;\n\tborder-radius: 4px;\n\tfont-size: 11px;\n\tfont-weight: $font-weight-medium;\n\tpadding: 2px 6px;\n\tmargin-right: 1.5rem;\n}\n.archive-btn-grey {\n\tborder: 1px solid #909090;\n\tcolor: $gray-500;\n\tborder-radius: 4px;\n\tfont-size: 9px;\n\tfont-weight: $font-weight-medium;\n\tpadding: 2px 6px;\n\tmargin-top: .25rem;\n}\n.right_sidebar_icon {\n\tlist-style: none;\n}\n.btn.btn-outline-light {\n\t&:hover {\n\t\tbackground: #e6e6e6;\n\t}\n}\n.chat-avatar {\n\tpadding: 8px 15px 0 8px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: flex-start;\n\t-webkit-align-items: flex-start;\n\tflex-shrink: 0;\n}\n.chat-profile-name {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 5px;\n\t.chat-action-col {\n\t\ta {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t}\n\t}\n}\n.delete-pop-btn {\n\t.btn-primary {\n\t\tmargin: 0 0 0 10px;\n\t}\n}\n.delete-model-head {\n\tpadding: 40px;\n\t.modal-header {\n\t\tpadding: 0;\n\t\tmargin-bottom: 32px;\n\t}\n\t.modal-body {\n\t\tpadding: 0;\n\t}\n}\n.delete-chat-notify {\n\tmargin-bottom: 32px;\n\t.form-check {\n\t\tmargin-bottom: 14px;\n\t}\n}\n.chats.chats-right {\n\tflex-direction: row-reverse;\n\t-webkit-flex-direction: row-reverse;\n}\n.message-star {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\t.avatar {\n\t\twidth: 26px;\n\t\theight: 26px;\n\t\tmargin-right: 10px;\n\t\timg {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\th6 {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\tmargin-bottom: 0;\n\t\tspan {\n\t\t\ti {\n\t\t\t\tcolor: $warning-700;\n\t\t\t}\n\t\t}\n\t}\n}\n.chat-voice-group {\n\tul {\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tpadding: 0;\n\t\tmargin-bottom: 0;\n\t\tli {\n\t\t\tspan {\n\t\t\t\twidth: 28px;\n\t\t\t\theight: 28px;\n\t\t\t\tbackground: $primary;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t-ms-flex-pack: center;\n\t\t\t}\n\t\t}\n\t}\n\tli {\n\t\tmargin-bottom: 0;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t\tfont-weight: $font-weight-normal;\n\t\tlist-style: none;\n\t}\n\tli+li {\n\t\tpadding-left: 10px;\n\t}\n}\n.file-download-col {\n\t.download-action {\n\t\tposition: absolute;\n\t\tright: 8px;\n\t\tbottom: 8px;\n\t\tline-height: 0;\n\t\ta {\n\t\t\tcolor: $white;\n\t\t\tfont-size: 10px;\n\t\t}\n\t\tdiv+div {\n\t\t\tmargin-left: 8px;\n\t\t}\n\t\tdiv {\n\t\t\timg {\n\t\t\t\twidth: 13px;\n\t\t\t}\n\t\t}\n\t}\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tfloat: left;\n\t\t\twidth: 50%;\n\t\t\tpadding: 5px;\n\t\t\t.image-download-col {\n\t\t\t\tposition: relative;\n\t\t\t\ta {\n\t\t\t\t\t>img {\n\t\t\t\t\t\twidth: 100%;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli.full-width {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n.chat-select {\n\t.select2-container {\n\t\t.select2-selection--single {\n\t\t\tborder: 0;\n\t\t\theight: 24px;\n\t\t\t.select2-selection__rendered {\n\t\t\t\tpadding-right: 40px;\n\t\t\t\tpadding-left: 0px;\n\t\t\t}\n\t\t}\n\t}\n\t.select2-container--default {\n\t\t.select2-selection--single {\n\t\t\t.select2-selection__rendered {\n\t\t\t\tcolor: $gray-500;\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t\tfont-weight: normal;\n\t\t\t\tline-height: 24px;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t}\n\t\t\t.select2-selection__arrow {\n\t\t\t\theight: 24px;\n\t\t\t\tright: 7px;\n\t\t\t\tb {\n\t\t\t\t\tborder-color: $gray-700;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-width: 0 2px 2px 0;\n\t\t\t\t\tpadding: 3px;\n\t\t\t\t\theight: 0;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\tmargin-left: -5px;\n\t\t\t\t\tmargin-top: -5px;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\twidth: 0;\n\t\t\t\t\ttransform: rotate(45deg);\n\t\t\t\t\t-webkit-transform: rotate(45deg);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.select2-results__option--highlighted[aria-selected] {\n\t\t\tbackground-color: $secondary-800;\n\t\t}\n\t\t.select2-selection--multiple {\n\t\t\tborder: 1px solid #ddd;\n\t\t\tmin-height: 40px;\n\t\t}\n\t}\n\t.select2-container--default.select2-container--open {\n\t\t.select2-selection--single {\n\t\t\t.select2-selection__arrow {\n\t\t\t\tb {\n\t\t\t\t\tborder-color: $gray-700;\n\t\t\t\t\tborder-width: 2px 0 0 2px;\n\t\t\t\t\tpadding: 3px;\n\t\t\t\t\tmargin-top: -5px;\n\t\t\t\t\tborder-color: $gray-700;\n\t\t\t\t\tborder-style: solid;\n\t\t\t\t\tborder-width: 0 2px 2px 0;\n\t\t\t\t\tpadding: 3px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.select2-container--default.form-control-sm {\n\t\t.select2-selection--single {\n\t\t\t.select2-selection__arrow {\n\t\t\t\ttop: 7px;\n\t\t\t}\n\t\t}\n\t}\n\t.select2-container--open {\n\t\t.select2-dropdown--below {\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n}\n.success-pass {\n\tmargin-bottom: 40px;\n\ttext-align: center;\n}\n.review-files {\n\tp {\n\t\tmargin-bottom: 5px;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t}\n}\n.like-chat-grp {\n\tul {\n\t\tpadding: 0;\n\t\tmargin-bottom: 0;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\tmargin-top: 10px;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\ta {\n\t\t\t\tborder: 1px solid #E0E0E0;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tpadding: 3px 12px;\n\t\t\t\tdisplay: block;\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t-ms-flex-pack: center;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\tfont-size: $font-size-14;\n\t\t\t\timg {\n\t\t\t\t\tmargin-left: 5px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\tli.like-chat {\n\t\t\ta {\n\t\t\t\tbackground: #FEF6DC;\n\t\t\t}\n\t\t}\n\t\tli.comment-chat {\n\t\t\ta {\n\t\t\t\tbackground: #FFE8E9;\n\t\t\t}\n\t\t}\n\t}\n}\n.chat-line {\n\tmargin: 0px 0 20px;\n\tposition: relative;\n\ttext-align: center;\n\twidth: 100%;\n\t&:before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tleft: 0;\n\t\ttop: 50%;\n\t\ttransform: translateY(-50%);\n\t\t-webkit-transform: translateY(-50%);\n\t\t-ms-transform: translateY(-50%);\n\t\tbackground-color: $gray-300;\n\t\twidth: 100%;\n\t\theight: 1px;\n\t}\n}\n.chat-date {\n\tborder-radius: 100px;\n    background: $gray-300;\n\tcolor: $gray-900;\n\tfont-size: $font-size-14;\n\tpadding: 4px 20px;\n\tdisplay: inline-block;\n\tfont-weight: $font-weight-normal;\n\tposition: relative;\n\tborder: 1px solid #E0E0E0;\n}\n.chat+.sidebar-group {\n\tmargin-right: 0px;\n\t.sidebar {\n\t\tmargin-right: 0px;\n\t}\n}\n.group-comman-theme {\n\tpadding: 0 24px;\n\th6 {\n\t\tmargin-bottom: 15px;\n\t}\n\tul {\n\t\tpadding: 0;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 15px;\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tli {\n\t\t\tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n\t\t\talign-items: center;\n\t\t\tlist-style: none;\n\t\t\tborder: 1px solid #E0E0E0;\n\t\t\tborder-radius: 5px;\n\t\t\tpadding: 5px;\n\t\t\tmargin-bottom: 10px;\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t\t.avatar {\n\t\t\t\tflex-shrink: 0;\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t}\n\t}\n}\n.theme-content {\n\th6 {\n\t\tmargin-bottom: 6px;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t}\n\tp {\n\t\tmargin-bottom: 0;\n\t\ttext-align: start;\n\t\t-webkit-line-clamp: 1;\n\t\t-webkit-box-orient: vertical;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t\tdisplay: -webkit-box;\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t}\n}\n.chat-message-grp {\n\tpadding: 24px;\n\tpadding-top: 0;\n\tul {\n\t\tpadding: 0;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tmargin-bottom: 15px;\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0px;\n\t\t\t}\n\t\t\ta {\n\t\t\t\tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\t-webkit-justify-content: space-between;\n\t\t\t\t-ms-flex-pack: space-between;\n\t\t\t\t&:hover {\n\t\t\t\t\t.stared-group {\n\t\t\t\t\t\th6 {\n\t\t\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.stared-group {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tspan {\n\t\twidth: 30px;\n\t\theight: 30px;\n\t\tborder-radius: 6px;\n\t\tmargin-right: 10px;\n\t\tbackground: #F6F7F8;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\ti {\n\t\t\tfont-size: $font-size-16;\n\t\t}\n\t}\n\th6 {\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\tcolor: $text-color;\n\t\tmargin-bottom: 0;\n\t}\n}\n.star-message {\n\tbackground: #FEF6DC;\n\ti {\n\t\tcolor: $warning-700;\n\t}\n}\n.mute-message {\n\tbackground: #EBFDFFFA;\n\ti {\n\t\tcolor: $cyan;\n\t}\n}\n.block-message {\n\tbackground: #FFE8E9;\n\ti {\n\t\tcolor: $purple;\n\t}\n}\n.report-message {\n\tbackground: #F8ECFF;\n\ti {\n\t\tcolor: $secondary;\n\t}\n}\n.delete-message {\n\tbackground: #FFE8E9;\n\ti {\n\t\tcolor: $danger-800;\n\t}\n}\n.count-group {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tspan {\n\t\twidth: 16px;\n\t\theight: 16px;\n\t\tborder-radius: 50px;\n\t\tcolor: $white;\n\t\tfont-size: 10px;\n\t\tbackground: $primary;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tmargin-right: 5px;\n\t}\n\ti {\n\t\tcolor: #424242;\n\t\tfont-size: $font-size-16;\n\t}\n}\n.nav.nav-tabs.chat-tabs {\n\t.nav-item {\n\t\t.nav-link {\n\t\t\tfont-size: $font-size-16;\n\t\t\tfont-weight: bold;\n\t\t\tcolor: $white;\n\t\t\tbackground-color: transparent;\n\t\t\tborder: 0;\n\t\t}\n\t\t.nav-link.active {\n\t\t\tfont-size: $font-size-16;\n\t\t\tfont-weight: bold;\n\t\t\tcolor: $primary-800;\n\t\t}\n\t}\n}\n.header-top {\n\tul {\n\t\tli {\n\t\t\ta {\n\t\t\t\tcolor: $black;\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t}\n\t\t}\n\t}\n}\n.set-search {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tfont-size: $font-size-16;\n\tborder-radius: 50px;\n\twidth: 28px;\n\theight: 28px;\n\t&:hover {\n\t\tbackground: #F5F5F5;\n\t\tborder-color: $gray-100;\n\t}\n}\n.header-action {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n\tli {\n\t\tdisplay: inline-block;\n\t\tmargin-left: 10px;\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-18;\n\t\t}\n\t}\n}\n.user-list {\n\tborder-radius: .25rem;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\tpadding-left: 0;\n\tmargin-bottom: 0;\n\tli {\n\t\ta {\n\t\t\tpadding: 17px 20px;\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\tcursor: pointer;\n\t\t\tborder-radius: 6px;\n\t\t\tmargin-bottom: 10px;\n\t\t\tborder: 0;\n\t\t\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n\t\t}\n\t\t.avatar {\n\t\t\tmargin-right: 0.8rem;\n\t\t\tdisplay: inline-block;\n\t\t\tmargin-bottom: 0;\n\t\t\theight: 46px;\n\t\t\twidth: 46px;\n\t\t\tborder-radius: 50%;\n\t\t\tposition: relative;\n\t\t\tz-index: 0;\n\t\t\t.letter-avatar {\n\t\t\t\twidth: 45px;\n\t\t\t\theight: 45px;\n\t\t\t\tborder-radius: 45px;\n\t\t\t\tmargin-right: 0.8rem;\n\t\t\t\tmargin-bottom: 0;\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\talign-items: center;\n\t\t\t\t-webkit-align-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\t-webkit-justify-content: center;\n\t\t\t\tbackground-color: $gray-400;\n\t\t\t\tfont-size: $font-size-16;\n\t\t\t\tfont-weight: $font-weight-semibold;\n\t\t\t\tcolor: $violet;\n\t\t\t}\n\t\t}\n\t\ta.admin-shade {\n\t\t\tbox-shadow: none;\n\t\t}\n\t}\n\t.avatar {\n\t\t>a {\n\t\t\t>img {\n\t\t\t\twidth: 100%;\n\t\t\t\theight: 100%;\n\t\t\t\tobject-fit: cover;\n\t\t\t}\n\t\t}\n\t\t>img {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tobject-fit: cover;\n\t\t}\n\t}\n}\n.avatar-away {\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tborder-radius: 50%;\n\t\ttop: 0px;\n\t\tright: 2px;\n\t\tborder: 2px solid $white;\n\t\tz-index: 9;\n\t\tbackground-color: $yellow;\n\t}\n}\n.avatar-offline {\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tborder-radius: 50%;\n\t\ttop: 0px;\n\t\tright: 2px;\n\t\tborder: 2px solid $white;\n\t\tz-index: 9;\n\t}\n}\n.avatar-online {\n\t&::before {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: block;\n\t\twidth: 12px;\n\t\theight: 12px;\n\t\tborder-radius: 50%;\n\t\ttop: 0px;\n\t\tright: 2px;\n\t\tborder: 2px solid $white;\n\t\tz-index: 9;\n\t\tbackground-color: $green;\n\t}\n}\n.animate-typing-col {\n\tcolor: $success;\n\t.dot {\n\t\tdisplay: inline-block;\n\t\twidth: 4px;\n\t\theight: 4px;\n\t\tborder-radius: 50%;\n\t\tmargin-right: -1px;\n\t\tbackground: #0D9B35;\n\t\t-webkit-animation: wave 1.3s linear infinite;\n\t\tanimation: wave 1.3s linear infinite;\n\t\topacity: .6;\n\t\t&:nth-child(2) {\n\t\t\t-webkit-animation-delay: -1.1s;\n\t\t\tanimation-delay: -1.1s;\n\t\t}\n\t\t&:nth-child(3) {\n\t\t\t-webkit-animation-delay: -.9s;\n\t\t\tanimation-delay: -.9s;\n\t\t}\n\t}\n}\n.chat_form {\n\tborder-radius: 20px;\n\tmargin-right: 0px;\n\tbackground: $white;\n\tborder: 1px solid #C2C2C2;\n\tbox-shadow: 0px 4px 4px #F5F8FF;\n\tborder-radius: 6px;\n\theight: 40px;\n\tpadding: 10px 10px;\n}\n.contact-close {\n\ta {\n\t\tcolor: $gray-900;\n\t\topacity: 0.5;\n\t\tborder-color: $gray-300;\n\t}\n}\n.main-wrapper {\n\t.content {\n\t\t.sidebar-group.right-sidebar {\n\t\t\t.sidebar {\n\t\t\t\twidth: 310px;\n\t\t\t}\n\t\t}\n\t}\n}\n.primary-title {\n\tcolor: $primary-800;\n\tfont-size: $font-size-14;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tmargin-bottom: 0;\n\ti {\n\t\tfont-size: $font-size-14;\n\t}\n}\n.contact-action {\n\tpadding: 0;\n\tmargin: 0;\n\tlist-style: none;\n\tli {\n\t\tpadding: 11px 0;\n\t\tborder-bottom: 1px solid #f1f1f1;\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: bold;\n\t\t}\n\t}\n\tli.report-contact {\n\t\ta {\n\t\t\tcolor: $danger;\n\t\t}\n\t}\n\tli.delete-chat {\n\t\ta {\n\t\t\tcolor: $danger;\n\t\t}\n\t}\n\tli.sign-out {\n\t\ta {\n\t\t\tcolor: $danger;\n\t\t}\n\t}\n}\n.left-sidebar {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n}\n.left-sidebar-wrap {\n\tbackground: #FBFBFB;\n\toverflow: hidden;\n\twidth: 448px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\tflex: 1;\n}\n.right-sidebar {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\t-webkit-flex-direction: column;\n\tbackground-color: $light;\n\topacity: 100%;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\tposition: relative;\n\twidth: 320px;\n\t.right-sidebar-wrap {\n\t\tbackground-color: $white;\n\t\tborder-left: 1px solid #E0E0E0;\n\t\tborder-radius: 0px;\n\t\tmargin-top: 0px;\n\t\tmargin-bottom: 0px;\n\t\theight: calc(100vh - 0px);\n\t\t.sidebar-body {\n\t\t\tpadding: 0;\n\t\t}\n\t\t.right-sidebar-profile {\n\t\t\tpadding: 24px;\n\t\t\tpadding-bottom: 0;\n\t\t\tmargin-bottom: 15px;\n\t\t}\n\t}\n\t.contact-close_call {\n\t\t.close_profile {\n\t\t\twidth: 25px;\n\t\t\theight: 25px;\n\t\t\tborder-radius: 25px;\n\t\t\tcolor: $gray-900;\n\t\t\tdisplay: flex;\n\t\t\tdisplay: -webkit-flex;\n\t\t\tjustify-content: center;\n\t\t\t-webkit-justify-content: center;\n\t\t\talign-items: center;\n\t\t\t-webkit-align-items: center;\n\t\t\t&.close-star {\n\t\t\t\tcolor: $warning;\n\t\t\t}\n\t\t\t&.close-trash {\n\t\t\t\tcolor: $danger;\n\t\t\t}\n\t\t}\n\t}\n}\n.right-sidebar.video-right-sidebar {\n\twidth: 371px;\n\t.chat {\n\t\t.chat-body {\n\t\t\tpadding-bottom: 110px;\n\t\t}\n\t\tmargin-left: 0 !important;\n\t\tdisplay: block;\n\t}\n}\n.video-call-chat {\n\t.left-chat-title.with-bg {\n\t\tbackground: transparent;\n\t}\n\t.left-chat-title {\n\t\tborder: 0;\n\t}\n\t.chat-title {\n\t\th4 {\n\t\t\tfont-size: $font-size-18;\n\t\t\tfont-weight: $font-weight-semibold;\n\t\t\tcolor: $gray-900;\n\t\t}\n\t\tspan {\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tcolor: $gray-900;\n\t\t}\n\t}\n}\n.chat.video-call-chat {\n\t.chat-body {\n\t\tbackground-image: none;\n\t\t.messages {\n\t\t\t.chats {\n\t\t\t\t.message-content {\n\t\t\t\t\tbackground: #F5F5F5;\n\t\t\t\t}\n\t\t\t}\n\t\t\t.chats.chats-right {\n\t\t\t\t.message-content {\n\t\t\t\t\tbackground: #F8ECFF;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.member-details {\n\tmargin-bottom: 10px;\n}\n.chat-member-details {\n\tpadding: 0 24px;\n\t.member-details {\n\t\tul {\n\t\t\tpadding: 0;\n\t\t\tborder-bottom: 1px solid #EDEDED;\n\t\t\tli {\n\t\t\t\tlist-style: none;\n\t\t\t\tmargin-bottom: 15px;\n\t\t\t\th6 {\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tmargin-bottom: 5px;\n\t\t\t\t}\n\t\t\t\th5 {\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tmargin-bottom: 0px;\n\t\t\t\t}\n\t\t\t\tspan {\n\t\t\t\t\tfont-size: $font-size-16;\n\t\t\t\t\tfont-weight: $font-weight-normal;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t}\n\t\t\t\ta {\n\t\t\t\t\tfont-size: $font-size-15;\n\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\tcolor: $gray-800;\n\t\t\t\t\tborder-radius: 100px;\n\t\t\t\t\tpadding: 5px;\n\t\t\t\t\tbackground: #F5F5F5;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t&:hover {\n\t\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\ta+a {\n\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.right-sidebar.show-right-sidebar {\n\tmargin-right: 0;\n}\n.right-sidebar.video-right-sidebar.show-right-sidebar {\n\tmargin-right: 0;\n}\n.right-sidebar.hide-right-sidebar {\n\tmargin-right: -320px;\n}\n.right-sidebar.video-right-sidebar.hide-right-sidebar {\n\tmargin-right: -371px;\n}\n.status-modal {\n\t.custom-status-close {\n\t\twidth: 25px;\n\t\theight: 25px;\n\t\tborder-radius: 25px;\n\t\tcolor: $gray-900;\n\t\tdisplay: flex;\n\t\tdisplay: -webkit-flex;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\talign-items: center;\n\t\t-webkit-align-items: center;\n\t\tbackground-color: $gray-100;\n\t\tborder-color: $gray-100;\n\t}\n}\n.group-description {\n\t.description-sub {\n\t\th5 {\n\t\t\tspan {\n\t\t\t\ta {\n\t\t\t\t\twidth: 25px;\n\t\t\t\t\theight: 25px;\n\t\t\t\t\tborder-radius: 25px;\n\t\t\t\t\tcolor: $gray-900;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tdisplay: -webkit-flex;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t-webkit-justify-content: center;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t-webkit-align-items: center;\n\t\t\t\t\tborder-color: $gray-100;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.list_group_notread {\n\tcolor: $primary-800 !important;\n}\n.chat-cont-type {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\t.chat-type-wrapper {\n\t\tmargin-bottom: 0;\n\t\tp {\n\t\t\tcolor: $gray-500;\n\t\t\tfont-size: 12px;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tmargin-bottom: 0;\n\t\t}\n\t}\n}\n.group-type-radio {\n\tdisplay: block;\n\tposition: relative;\n\tpadding-left: 35px;\n\tcursor: pointer;\n\tfont-size: $font-size-22;\n\t-webkit-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-normal;\n\tcolor: $gray-900;\n\tmargin-right: 24px;\n\tinput {\n\t\tposition: absolute;\n\t\topacity: 0;\n\t\tcursor: pointer;\n\t\t&:checked {\n\t\t\t~ {\n\t\t\t\t.checkmark {\n\t\t\t\t\tbackground-color: $gray-800;\n\t\t\t\t\t&:after {\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n\t.checkmark {\n\t\t&:after {\n\t\t\ttop: 4px;\n\t\t\tleft: 4px;\n\t\t\twidth: 12px;\n\t\t\theight: 12px;\n\t\t\tborder-radius: 50%;\n\t\t\tbackground: white;\n\t\t}\n\t}\n}\n.checkmark {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\theight: 22px;\n\twidth: 22px;\n\tbackground-color: $white;\n\tborder: 1px solid #E4E4E4;\n\tborder-radius: 50%;\n\t&:after {\n\t\tcontent: \"\";\n\t\tposition: absolute;\n\t\tdisplay: none;\n\t}\n}\n.pass-login {\n\tlabel {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-14;\n\t\tfont-weight: $font-weight-medium;\n\t}\n}\n.select2-container--default {\n\t.select2-results__option--highlighted[aria-selected] {\n\t\tbackground-color: $gray-800 !important;\n\t}\n}\n.right-sidebar-profile {\n\t>.avatar {\n\t\tbackground: rgba(66, 11, 161, 0.1);\n\t}\n}\n.group_img {\n\tposition: relative;\n\tdisplay: inline-block;\n}\n.group-name-search {\n\tmargin-bottom: 14px;\n}\n.parti-wrapper {\n\tmargin-bottom: 14px;\n\tdisplay: flex;\n\talign-items: center;\n}\n.group_header {\n\twidth: 38px !important;\n\theight: 38px !important;\n\tborder: 2px solid $white;\n}\n.last-chat-time {\n\ti.missed-col {\n\t\twidth: 17px;\n\t\tdisplay: inline-block;\n\t\tmargin-top: 10px;\n\t\timg {\n\t\t\tmax-width: 100%;\n\t\t\theight: auto;\n\t\t}\n\t}\n}\n.right-sidebar-head {\n\tpadding: 0px 24px;\n\th5 {\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-semibold;\n\t\tcolor: $gray-900;\n\t\tmargin-bottom: 0px;\n\t}\n}\n.right-sidebar-head.share-media {\n\t.share-media-blk {\n\t\tmargin-bottom: 20px;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\t-ms-flex-pack: space-between;\n\t}\n\t.about-media-tabs {\n\t\t.nav-tabs {\n\t\t\tmargin-bottom: 15px;\n\t\t\tpadding: 5px;\n\t\t\tborder-radius: 8px;\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: space-between;\n\t\t}\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tpadding-bottom: 10px;\n\t\tmargin-bottom: 15px;\n\t\t.nav {\n\t\t\t.nav-item.active {\n\t\t\t\tbackground: $primary;\n\t\t\t\tborder-radius: 6px;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tcolor: $white;\n\t\t\t}\n\t\t\t.nav-item {\n\t\t\t\tpadding: 2px 10px;\n\t\t\t\tfont-size: $font-size-14;\n\t\t\t\tcolor: $gray-900;\n\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\tborder: 0;\n\t\t\t\tmargin-right: 10px;\n\t\t\t\tbackground: $body-bg;\n\t\t\t\tcolor: $secondary;\n\t\t\t\tborder-radius: 6px;\n\t\t\t\t&:last-child {\n\t\t\t\t\tmargin-right: 0px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.share-media-img {\n\t\t\tli {\n\t\t\t\tmargin: 0px 6px 6px 0px;\n\t\t\t\tposition: relative;\n\t\t\t\timg {\n\t\t\t\t\tborder-radius: 8px;\n\t\t\t\t\twidth: 84px;\n\t\t\t\t}\n\t\t\t\tspan {\n\t\t\t\t\ti {\n\t\t\t\t\t\tfont-size: $font-size-20;\n\t\t\t\t\t\tcolor: $white;\n\t\t\t\t\t}\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tcolor: $white;\n\t\t\t\t\tfont-size: 13px;\n\t\t\t\t\tfont-weight: $font-weight-medium;\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\ttop: 50%;\n\t\t\t\t\tleft: 50%;\n\t\t\t\t\t-webkit-transform: translate(-50%, -50%);\n\t\t\t\t\t-ms-transform: translate(-50%, -50%);\n\t\t\t\t\ttransform: translate(-50%, -50%);\n\t\t\t\t}\n\t\t\t\t&:hover {\n\t\t\t\t\tspan {\n\t\t\t\t\t\ti {\n\t\t\t\t\t\t\tcolor: $gray-300;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t\tli.blur-media {\n\t\t\t\timg {\n\t\t\t\t\tfilter: blur(2px);\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.media-file {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n\tmargin-bottom: 15px;\n\t&:last-child {\n\t\tmargin-bottom: 0;\n\t}\n}\n.media-doc-blk {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tspan {\n\t\twidth: 50px;\n\t\theight: 50px;\n\t\tborder-radius: 5px;\n\t\tbackground: #F5F5F5;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\t\t-webkit-justify-content: center;\n\t\t-ms-flex-pack: center;\n\t\tmargin-right: 10px;\n\t\ti {\n\t\t\tfont-size: $font-size-24;\n\t\t}\n\t}\n}\n.document-detail {\n\tul {\n\t\tpadding: 0;\n\t\tmargin-bottom: 0;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tli {\n\t\t\tlist-style: none;\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tposition: relative;\n\t\t\t&::before {\n\t\t\t\tcontent: \"\";\n\t\t\t\tposition: absolute;\n\t\t\t\twidth: 1px;\n\t\t\t\theight: 13px;\n\t\t\t\tbackground: #C2C2C2;\n\t\t\t\tright: -8px;\n\t\t\t\ttop: 5px;\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\t&::before {\n\t\t\t\t\tdisplay: none;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tpadding-left: 15px;\n\t\t}\n\t}\n\th6 {\n\t\tcolor: $gray-900;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t}\n}\n.media-download {\n\ta {\n\t\tcolor: $gray-900;\n\t}\n}\n.social-media-col {\n\tmargin-top: 35px;\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tfloat: left;\n\t\t\ta {\n\t\t\t\tcolor: $violet;\n\t\t\t\tfont-size: $font-size-18;\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t}\n\th6 {\n\t\tfont-weight: $font-weight-semibold;\n\t\tcolor: $black;\n\t\tfont-size: $font-size-15;\n\t\tmargin-bottom: 20px;\n\t}\n}\n.media-link-grp {\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tmargin-bottom: 15px;\n}\n.media-link-detail {\n\th6 {\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-15;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tmargin-bottom: 5px;\n\t\t}\n\t}\n\tspan {\n\t\ta {\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t\tword-break: break-all;\n\t\t}\n\t}\n\ta {\n\t\t&:hover {\n\t\t\tcolor: $gray-800;\n\t\t}\n\t}\n}\n.share-media-blk {\n\ta {\n\t\tcolor: $gray-800;\n\t\tfont-weight: $font-weight-medium;\n\t}\n}\n.link-img {\n\tflex-shrink: 0;\n\timg {\n\t\tborder-radius: 4px;\n\t\tmargin-right: 10px;\n\t}\n}\n.settings-col {\n\th6 {\n\t\tfont-weight: $font-weight-semibold;\n\t\tcolor: $black;\n\t\tfont-size: $font-size-15;\n\t\tmargin-bottom: 20px;\n\t}\n\tmargin-top: 35px;\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tcolor: $gray-600;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t}\n\t\tli+li {\n\t\t\tmargin-top: 15px;\n\t\t}\n\t}\n\t.switch {\n\t\tposition: relative;\n\t\tdisplay: inline-block;\n\t\twidth: 40px;\n\t\theight: 23px;\n\t\tmargin-bottom: 0;\n\t\tmargin-right: 10px;\n\t\tinput {\n\t\t\topacity: 0;\n\t\t\twidth: 0;\n\t\t\theight: 0;\n\t\t}\n\t}\n\t.slider {\n\t\tposition: absolute;\n\t\tcursor: pointer;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tbackground-color: $gray-500;\n\t\t-webkit-transition: .4s;\n\t\ttransition: .4s;\n\t\t&:before {\n\t\t\tposition: absolute;\n\t\t\tcontent: \"\";\n\t\t\theight: 15px;\n\t\t\twidth: 15px;\n\t\t\tleft: 4px;\n\t\t\tbottom: 4px;\n\t\t\tbackground-color: $white;\n\t\t\t-webkit-transition: .4s;\n\t\t\ttransition: .4s;\n\t\t}\n\t}\n\tinput {\n\t\t&:checked+.slider {\n\t\t\tbackground-color: $blue;\n\t\t\t&:before {\n\t\t\t\t-webkit-transform: translateX(16px);\n\t\t\t\t-ms-transform: translateX(16px);\n\t\t\t\ttransform: translateX(16px);\n\t\t\t}\n\t\t}\n\t\t&:focus+.slider {\n\t\t\tbox-shadow: 0 0 1px #2196F3;\n\t\t}\n\t}\n\t.slider.round {\n\t\tborder-radius: 34px;\n\t\t&:before {\n\t\t\tborder-radius: 50%;\n\t\t}\n\t}\n}\n.report-col {\n\tmargin-top: 35px;\n\tpadding: 12px;\n\tpadding-bottom: 50px;\n\t&:after {\n\t\tcontent: \"\";\n\t\tdisplay: table;\n\t\tclear: both;\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\t&:after {\n\t\t\tcontent: \"\";\n\t\t\tdisplay: table;\n\t\t\tclear: both;\n\t\t}\n\t\tli {\n\t\t\tdisplay: block;\n\t\t\twidth: 100%;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tposition: relative;\n\t\t\ta {\n\t\t\t\tcolor: $danger;\n\t\t\t\tpadding-left: 25px;\n\t\t\t\tspan {\n\t\t\t\t\tposition: absolute;\n\t\t\t\t\tleft: 0;\n\t\t\t\t\ttop: 0px;\n\t\t\t\t\tfont-size: $font-size-16;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\tli+li {\n\t\t\tmargin-top: 19px;\n\t\t}\n\t}\n}\n.load-more-btn {\n\tfont-weight: $font-weight-semibold;\n\tmargin-top: 10px;\n\ti {\n\t\tbackground: #0057FF;\n\t\tborder-radius: 50%;\n\t\theight: 12px;\n\t\twidth: 12px;\n\t\tcolor: $white;\n\t\tline-height: 8px;\n\t\tfont-size: 12px;\n\t\tvertical-align: top;\n\t}\n}\n.chat-message-grp.chat-encrypt {\n\tpadding-bottom: 0;\n\tul {\n\t\tborder-bottom: 1px solid #EDEDED;\n\t\tpadding-bottom: 15px;\n\t\tmargin-bottom: 15px;\n\t}\n}\n.participants-list {\n\tpadding: 0px 24px;\n\t.participants-list-group {\n\t\th6.parti-search {\n\t\t\tfont-size: 20px !important;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t}\n\t}\n\tul {\n\t\tlist-style: none;\n\t\tpadding: 0;\n\t\tmargin: 0;\n\t\tli {\n\t\t\tborder: 1px solid #E0E0E0;\n\t\t\tborder-radius: 5px;\n\t\t\tbackground-color: $white;\n\t\t\tpadding: 10px;\n\t\t}\n\t\tli+li {\n\t\t\tmargin-top: 10px;\n\t\t}\n\t}\n\t.users-list-body {\n\t\th5 {\n\t\t\twhite-space: nowrap;\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\t\t\tfont-size: $font-size-15;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tmargin-bottom: 5px;\n\t\t\tcolor: $gray-900;\n\t\t}\n\t\tp {\n\t\t\twhite-space: nowrap;\n\t\t\ttext-overflow: ellipsis;\n\t\t\toverflow: hidden;\n\t\t\tmargin-bottom: 0;\n\t\t\tcolor: $gray-900;\n\t\t\tfont-size: $font-size-14;\n\t\t\tfont-weight: $font-weight-normal;\n\t\t}\n\t\tflex: 1;\n\t\tposition: relative;\n\t\tmin-width: 0px;\n\t\tdisplay: flex;\n\t\tdisplay: -webkit-flex;\n\t\twidth: 100%;\n\t}\n\t.admin-profiles {\n\t\tdisplay: inline-block;\n\t\tcolor: $gray-800;\n\t\tborder-radius: 6px;\n\t\tfont-size: 12px;\n\t\tpadding: 2px 10px;\n\t\tfont-weight: $font-weight-medium;\n\t\tbackground: #F8ECFF;\n\t\t&:hover {\n\t\t\tbackground: #680A83;\n\t\t\tcolor: $white;\n\t\t}\n\t}\n}\n.participants-list-group {\n\tborder-bottom: 1px solid #EDEDED;\n\tpadding-bottom: 15px;\n\tmargin-bottom: 15px;\n\th6 {\n\t\tmargin-bottom: 15px;\n\t\tfont-size: $font-size-15;\n\t\tfont-weight: $font-weight-medium;\n\t\tcolor: $gray-900;\n\t\tdisplay: -webkit-box;\n\t\tdisplay: -ms-flexbox;\n\t\tdisplay: flex;\n\t\t-webkit-box-align: center;\n\t\t-ms-flex-align: center;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\t\t-webkit-justify-content: space-between;\n\t\t-ms-flex-pack: space-between;\n\t}\n}\n.chat-message-grp.group-exits {\n\tpadding: 0px 24px;\n\tpadding-bottom: 30px;\n}\n.grp-delete {\n\t.chat-action-col {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\theight: 100%;\n\t\t>a {\n\t\t\tcolor: $gray-500;\n\t\t}\n\t}\n}\n.chat-action-col {\n\t>a {\n\t\tcolor: $gray-900;\n\t}\n}\n.darkmode-btn {\n\twidth: 35px;\n\theight: 32px;\n\tbackground-color: $blue;\n\tborder: 1px solid #FBFBFB;\n\tborder-radius: 5px;\n\tcolor: $white;\n\tfont-size: $font-size-16;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tmargin: 0 auto;\n\t&:hover {\n\t\tcolor: $white;\n\t}\n\t&:focus {\n\t\tcolor: $white;\n\t}\n}\n.add-contacts-btn {\n\t&:hover {\n\t\tcolor: $white;\n\t}\n\t&:focus {\n\t\tcolor: $white;\n\t}\n\twidth: 25px;\n\theight: 25px;\n\tborder-radius: 30px;\n\tbackground-color: $gray-800;\n\tcolor: $white;\n\tfont-size: 10px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tmargin: 0 auto;\n}\n.group-call-tab {\n\t.nav-tabs {\n\t\t.nav-link {\n\t\t\tcolor: $gray-800;\n\t\t\tborder: 0;\n\t\t\tborder-radius: 10px;\n\t\t\tfont-weight: $font-weight-medium;\n\t\t\tpadding: 6px 25px;\n\t\t\t&:hover {\n\t\t\t\tcolor: $gray-800;\n\t\t\t}\n\t\t}\n\t\t.nav-link+.nav-link {\n\t\t\tmargin-left: 10px;\n\t\t}\n\t\t.nav-link.active {\n\t\t\tbackground-color: rgba(90, 7, 139, 0.1);\n\t\t\tcolor: $gray-800;\n\t\t}\n\t}\n\tnav {\n\t\tpadding: 0 15px 20px;\n\t\tposition: relative;\n\t\t&:before {\n\t\t\tcontent: \"\";\n\t\t\tposition: absolute;\n\t\t\tleft: 0;\n\t\t\tbottom: 0;\n\t\t\twidth: 100%;\n\t\t\tbackground-color: $gray-400;\n\t\t\theight: 1px;\n\t\t}\n\t}\n}\n\n.header_image {\n\twidth: 195px;\n}\n\n.chat_avator_img {\n\tposition: relative;\n}\n\n.group_img {\n\twidth: 40px;\n\theight: 40px;\n\tobject-fit: cover;\n}\n\n.dreams_chat {\n\twidth: 40px;\n\theight: 40px;\n\tobject-fit: cover;\n}\n\n.voice_pop {\n\tpadding-right: 17px;\n}\n\n.status_carousel {\n\tmargin-top: 50px;\n}\n\n.carousel_img {\n\twidth: 650px;\n\theight: 434px;\n}\n\n.video_content {\n\tmin-height: 200px;\n\tmargin-top: 70px;\n}\n\n.voice-call-content {\n\tmin-height: 200px;\n}\n\n.chatimage img {\n\twidth: 120px;\n\theight: 120px;\n}\n\n.send-btn_status {\n\twidth: 52px;\n\theight: 52px;\n\tborder-radius: 50%;\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\talign-items: center;\n\tcolor: $white !important;\n\tbackground-color: #FFA977 !important;\n\tmargin-left: 15px;\n\tfont-size: $font-size-22;\n}\n\n.status_telegram {\n\tcolor: $white;\n}\n\n.media-lists {\n\tdisplay: flex;\n\tjustify-content: flex-start;\n\tmargin: 0 -5px 0px;\n\tflex-wrap: wrap;\n}\n\n.media-lists .media-image {\n\tmargin: 5px;\n\tflex-basis: 74px;\n\tmin-width: 74px;\n}\n\n.media-lists .media-image img {\n\tmax-width: 100%;\n}\n\n.avatar-group .avatar+.avatar {\n\tmargin-left: -.75rem;\n}\n\n.list-group-item {\n\tbackground-color: inherit;\n\tborder-color: #ebebeb;\n}\n\nul.list-inline .list-inline-item {\n\tmargin-bottom: .5rem;\n}\n\n.form-control {\n\tborder-radius: 5px;\n}\n\n.form-control:focus {\n\tbox-shadow: none;\n\tborder-color: #e6e6e6;\n}\n\n.custom-control-label {\n\tline-height: 25px;\n}\n\n.custom-control-input:checked~.custom-control-label::before {\n\tbackground-color: #0a80ff;\n}\n\n.open_drop {\n\tcolor: $white !important;\n}\n\n.send-btn_status:focus {\n\tbox-shadow: none !important;\n\tborder-color: #ffa977 !important;\n}\n\n.avatar {\n\tdisplay: inline-block;\n\tmargin-bottom: 0;\n\theight: 48px;\n\twidth: 48px;\n\tborder-radius: 50%;\n}\n\n.avatar .avatar-title {\n\tcolor: $white;\n\tbackground: #680A83;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\ttext-transform: uppercase;\n\tfont-size: 19px;\n\tfont-weight: $font-weight-semibold;\n}\n\n.avatar > a {\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: block;\n\ttransition: color .3s;\n\tcolor: #0a80ff;\n}\n\n.avatar > a > img,\n.avatar > img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.avatar.avatar-sm {\n\theight: 1.3rem;\n\twidth: 1.3rem;\n}\n\n.avatar.avatar-sm .avatar-title {\n\tfont-size: $font-size-14;\n}\n\n.avatar.avatar-lg {\n\theight: 3.8rem;\n\twidth: 3.8rem;\n}\n\n.avatar.avatar-lg .avatar-title {\n\tfont-size: 29px;\n}\n\n.avatar.avatar-xl {\n\theight: 100px;\n\twidth: 100px;\n}\n\n.header_drop_icon {\n\tborder-radius: 6px;\n}\n\n.accordion-col .accordion-title {\n\tcursor: pointer;\n\tpadding: 15px 0 8px;\n}\n\n.accordion-col .accordion-title .primary-title i {\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\ttransform: rotate(90deg);\n\t-webkit-transform: rotate(90deg);\n\t-ms-transform: rotate(90deg);\n}\n\n.accordion-col .accordion-title.active .primary-title i {\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\ttransform: rotate(270deg);\n\t-webkit-transform: rotate(270deg);\n\t-ms-transform: rotate(270deg);\n}\n\n.accordion-col .accordion-content {\n\tborder-bottom: 1px solid #e6e6e6;\n\tpadding-bottom: 15px;\n}\n\n.accordion-col .accordion-content:last-child {\n\tborder-bottom: 0;\n}\n\n.accordion-col .accordion-content h6 {\n\tfont-size: $font-size-14;\n}\n\n\n\n.status-right {\n\tfont-weight: $font-weight-medium;\n\tcolor: #444444;\n\tfont-size: $font-size-16;\n\ttext-align: center;\n}\n\n.status-right p {\n\tmargin-top: 20px;\n\tmargin-bottom: 0;\n}\n\n.star-drop .btn-outline-light {\n\tcolor: #424242;\n\tborder: 0;\n\tpadding: 0;\n}\n\n.star-drop .btn-outline-light i {\n\tfont-size: $font-size-20;\n}\n\n.star-drop .btn.btn-outline-light:hover {\n\tbackground: transparent;\n\tborder: 0;\n}\n\n.chat.star-chat-group {\n\tbackground-image: none;\n}\n\n.chat.star-chat-group .chat-body {\n\tbackground-image: none;\n}\n\n.chat.star-chat-group .chat-body .messages .chats {\n    max-width: 100%;\n}\n\n.chat.star-chat-group .chat-body .messages .chats .message-content {\n\tbackground: #F5F5F5;\n}\n\n.chat.star-chat-group .chat-body .messages .chats .message-content.award-link a {\n    word-break: break-all;\n}\n\n.chat.star-chat-group .chat-body .messages .chats .message-content.award-link img {\n    max-width: 100%;\n}\n.chat .chat-body .messages .chats.forward-chat-msg {\n\tdisplay: none;\n}\n.chats.forward-chat-msg {\n\tbackground: #EDEDED;\n\tborder-radius: 15px;\n\tpadding: 20px;\n\tborder-left: 2px solid #680A83;\n}\n.chats.forward-chat-msg .chat-avatar {\n\tpadding: 0;\n\tpadding-right: 15px;\n}\n\n.chat-title h4 a {\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-bold;\n\ttext-transform: uppercase;\n\tcolor: #4B0973;\n\tmargin-bottom: 0;\n}\n\n.left-chat-title .add-section > a {\n\twidth: 30px;\n\theight: 30px;\n\tbackground-color: #680A83;\n\tborder-radius: 30px;\n\tcolor: $white;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tfont-size: 13px;\n}\n\n.add-section ul {\n\tlist-style: none;\n\tpadding: 0;\n\tmargin: 0;\n}\n\n.add-section ul li {\n\tfloat: left;\n\tborder-radius: 50px;\n\twidth: 28px;\n\theight: 28px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\t\n    justify-content: center;\n    -webkit-justify-content: center;\n}\n\n.add-section ul li+li {\n\tmargin-left: 10px;\n}\n\n.add-section ul li a {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tfont-size: $font-size-20;\n}\n.all-chats .add-section ul li:hover{\n  background-color: #F5F5F5;\n  border-color: #F5F5F5;\n}\n\n.online {\n\tcolor: #008024;\n\tfont-weight: $font-weight-medium;\n}\n\n.top-online-contacts {\n\tpadding: 24px 24px 0px;\n}\n.fav-title {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n\tmargin-bottom: 15px;\n}\n.fav-title h6 {\n\tmargin-bottom: 0;\n\tfont-size: $font-size-18;\n\tfont-weight: $font-weight-semibold;\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n}\n.fav-title h6 i {\n\tfont-size: $font-size-22;\n}\n.fav-title a {\n\tmargin-bottom: 0;\n\tcolor: $primary;\n\tfont-weight: $font-weight-medium;\n}\n.fav-title a:hover {\n\tcolor: #0A0A0A;\n}\n\n.top-contacts-box .profile-img {\n\tposition: relative;\n\twidth: 46px;\n\theight: 46px;\n}\n\n.top-contacts-box .profile-img img {\n\tmax-width: 100%;\n\theight: auto;\n\tborder-radius: 50px;\n}\n\n.profile-name span {\n\tcolor: #585858;\n\tfont-size: 12px;\n\tdisplay: inline-block;\n\tmargin-top: 9px;\n}\n\n.top-contacts-box .profile-img.online:before {\n\tcontent: \"\";\n\tposition: absolute;\n\tright: 0;\n\ttransform: translateX(-50%);\n\t-webkit-transform: translateX(-50%);\n\t-ms-transform: translateX(-50%);\n\ttop: 0px;\n\tbackground-color: #49E073;\n\twidth: 10px;\n\theight: 10px;\n\tborder: 2px solid $white;\n\tborder-radius: 50px;\n}\n\n.dropdown-menu .dropdown-item span.edit-profile-icon,\n.dropdown-menu .dropdown-item span.profile-icon-col {\n\tfont-size: $font-size-15;\n}\n\n.avatar {\n\tposition: relative;\n\tdisplay: inline-block;\n\twidth: 46px;\n\theight: 46px;\n\tflex-shrink: 0;\n}\n\n.avatar > img {\n\twidth: 100%;\n\theight: 100%;\n\tobject-fit: cover;\n}\n\n.avatar-title {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-color: #650681;\n\tcolor: $white;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.avatar-away::before,\n.avatar-offline::before,\n.avatar-online::before {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\twidth: 25%;\n\theight: 25%;\n\tborder-radius: 50%;\n\tcontent: '';\n\tborder: 2px solid $white;\n}\n\n.avatar-online::before {\n\tbackground-color: #00e65b;\n}\n\n.avatar-offline::before {\n\tbackground-color: #ff0100;\n}\n\n.avatar-away::before {\n\tbackground-color: #ffbc34;\n}\n\n.avatar .border {\n\tborder-width: 3px !important;\n}\n\n.avatar .rounded {\n\tborder-radius: 6px !important;\n}\n\n.avatar .avatar-title {\n\tfont-size: $font-size-18;\n}\n\n.avatar-xs {\n\twidth: 1.65rem;\n\theight: 1.65rem;\n}\n\n.avatar-xs .border {\n\tborder-width: 2px !important;\n}\n\n.avatar-xs .rounded {\n\tborder-radius: 4px !important;\n}\n\n.avatar-xs .avatar-title {\n\tfont-size: 10px;\n}\n\n.avatar-xs.avatar-away::before,\n.avatar-xs.avatar-offline::before,\n.avatar-xs.avatar-online::before {\n\tborder-width: 1px;\n}\n\n.avatar-sm {\n\twidth: 2.5rem;\n\theight: 2.5rem;\n}\n\n.avatar-sm .border {\n\tborder-width: 3px !important;\n}\n\n.avatar-sm .rounded {\n\tborder-radius: 4px !important;\n}\n\n.avatar-sm .avatar-title {\n\tfont-size: $font-size-15;\n}\n\n.avatar-sm.avatar-away::before,\n.avatar-sm.avatar-offline::before,\n.avatar-sm.avatar-online::before {\n\tborder-width: 2px;\n}\n\n.avatar-lg {\n\twidth: 3.75rem;\n\theight: 3.75rem;\n}\n\n.avatar-lg .border {\n\tborder-width: 3px !important;\n}\n\n.avatar-lg .rounded {\n\tborder-radius: 8px !important;\n}\n\n.avatar-lg .avatar-title {\n\tfont-size: $font-size-24;\n}\n\n.avatar-lg.avatar-away::before,\n.avatar-lg.avatar-offline::before,\n.avatar-lg.avatar-online::before {\n\tborder-width: 3px;\n}\n\n.avatar-xl {\n\twidth: 5rem;\n\theight: 5rem;\n}\n\n.avatar-xl .border {\n\tborder-width: 4px !important;\n}\n\n.avatar-xl .rounded {\n\tborder-radius: 8px !important;\n}\n\n.avatar-xl .avatar-title {\n\tfont-size: $font-size-28;\n}\n\n.avatar-xl.avatar-away::before,\n.avatar-xl.avatar-offline::before,\n.avatar-xl.avatar-online::before {\n\tborder-width: 4px;\n}\n\n.avatar-xxl {\n\twidth: 5.125rem;\n\theight: 5.125rem;\n}\n\n.avatar-xxl .border {\n\tborder-width: 6px !important;\n}\n\n.avatar-xxl .rounded {\n\tborder-radius: 8px !important;\n}\n\n.avatar-xxl .avatar-title {\n\tfont-size: $font-size-30;\n}\n\n.avatar-xxl.avatar-away::before,\n.avatar-xxl.avatar-offline::before,\n.avatar-xxl.avatar-online::before {\n\tborder-width: 4px;\n}\n\n.avatar-group {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tpadding-left: 15px;\n\tmargin-left: auto;\n\tmargin-right: 15px;\n\tcursor: pointer;\n}\n\n.avatar-group .avatar+.avatar {\n\tmargin-left: -.75rem;\n}\n\n.avatar-group .avatar-xs+.avatar-xs {\n\tmargin-left: -15px;\n}\n\n.avatar-group .avatar-sm+.avatar-sm {\n\tmargin-left: -.625rem;\n}\n\n.avatar-group .avatar-lg+.avatar-lg {\n\tmargin-left: -1rem;\n}\n\n.avatar-group .avatar-xl+.avatar-xl {\n\tmargin-left: -1.28125rem;\n}\n\n.avatar-group .avatar:hover {\n\tz-index: 1;\n}\n\n.avatar-group.group-col {\n\tdisplay: block;\n}\n\n.avatar-group.group-col > div {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tpadding-bottom: 5px;\n}\n\n.avatar-group.group-col .avatar {\n\tmargin-right: 0;\n}\n\n.contact-close {\n\tfloat: right;\n\tleft: 95%;\n\tright: 0px;\n\tposition: relative;\n\ttop: 5%;\n}\n\n.status_contactclose {\n\tfloat: right;\n\tleft: 95%;\n\tright: 0px;\n\tposition: relative;\n\ttop: 1%;\n}\n\n.status-active {\n\tborder: 4px solid #650681;\n}\n\n.avatar.avatar-xl .avatar-title {\n\tfont-size: 39px;\n}\n\n.nav.nav-tabs {\n\tborder: none;\n\tline-height: 2;\n}\n\n.badge {\n\tpadding: 5px 10px;\n\tfont-size: 11px;\n}\n\n.badge.badge-success {\n\tbackground: #0abb87;\n}\n\n.badge.badge-danger {\n\tbackground: #fd397a;\n}\n\n.badge.badge-secondary {\n\tbackground: dimgray;\n}\n\n.badge.badge-info {\n\tbackground: #00bcd4;\n}\n\n.badge.badge-warning {\n\tbackground: #ffb822;\n}\n\n.badge.badge-dark {\n\tbackground: #3a3f51;\n}\n\n.badge.badge-primary {\n\tbackground: #0a80ff;\n}\n\n.badge.badge-light {\n\tbackground: #e6e6e6;\n}\n\n.btn {\n\tposition: relative;\n}\n\n.btn .badge {\n\tpadding: 2px 6px;\n\tright: 7px;\n\ttop: -7px;\n\tposition: absolute;\n}\n\n.input-group .input-group-text {\n\tfont-size: $font-size-14;\n}\n\n.tooltip > .tooltip-inner {\n    text-align: left;\n    max-width: 500px;\n    --bs-tooltip-bg: $primary;\n}\n.tooltip {\n    --bs-tooltip-bg: $primary;\n}\n.tooltip .arrow {\n\tdisplay: none;\n\tbackground-color: $primary;\n}\n.tooltip .tooltip-inner {\n\tbackground-color: $primary;\n}\n\n.sticky-top {\n\tz-index: auto;\n}\n\n.tab-content {\n\tpadding-top: 30px;\n}\n\n.tab-content .form-item {\n\tmargin-bottom: .8rem;\n}\n\n.main-wrapper {\n\t// height: 100vh;\n\toverflow: hidden;\n}\n\n.main-wrapper .content {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n}\n\n.main-wrapper .content .sidebar-group {\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tflex-direction: column;\n\tposition: relative;\n\tz-index: 99;\n\twidth: 340px;\n\t@include respond-below(custom767) {\n\t\twidth: 100%;\n\t}\n}\n\n.main-wrapper .content .sidebar-group .sidebar {\n\tbackground: $white;\n\toverflow: hidden;\n\twidth: 340px !important;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n\tborder-right: 1px solid rgba(224, 224, 224, 1);\n\t@include respond-below(custom767) {\n\t\twidth: 100%!important;\n\t}\n}\n\n.main-wrapper .content .sidebar-group .sidebar:not(.active) {\n\tdisplay: none;\n}\n\n.header-top {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tmargin-bottom: 30px;\n\tfont-weight: $font-weight-semibold;\n\tbackground-color: #680A83;\n}\n\n.header-top .logo {\n\tmargin-top: 0 !important;\n}\n\n.header-top > span {\n\tfont-size: $font-size-22;\n}\n\n.header-top ul {\n\tmargin-bottom: 0;\n\tdisplay: flex;\n}\n\n.header-top ul.header-action {\n\tmargin-top: 14px !important;\n}\n\n.chat-header ul {\n\tmargin-bottom: 0;\n}\n\n.chat-header ul li:not(.list-inline-item) {\n\tmargin-bottom: 0;\n\twidth: 48px;\n\tmargin-right: 15px !important;\n}\n\n.chat-header ul li:last-child {\n\tmargin-right: 0 !important;\n}\n\n.sidebar-body {\n\tflex: 1;\n\toverflow: auto;\n\tpadding: 24px 24px 10px;\n\twidth: 100%;\n}\n.pin-chat img {\n\tmargin-right: 6px;\n}\n.sidebar-body .profile-name {\n\tfont-weight: $font-weight-semibold;\n\tcolor: #0A0A0A;\n\tfont-size: $font-size-18;\n\tmargin-bottom: 0;\n}\n\n.online-profile {\n\tposition: relative;\n}\n\n.online-profile span {\n\tposition: relative;\n\tcolor: #565656;\n\tfont-size: 13px;\n\tpadding-left: 10px;\n}\n\n.online-profile span:before {\n\tcontent: \"\";\n\tposition: absolute;\n\tleft: 0;\n\ttop: 7px;\n\tbackground-color: #49E073;\n\twidth: 8px;\n\theight: 8px;\n\tborder-radius: 50px;\n}\n\n.close_profile4 {\n\tcolor: $black;\n\tborder-color: #e6e6e6;\n}\n\n.sidebar .user-list li a {\n\tpadding: 10px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\tcursor: pointer;\n\tmargin-bottom: 15px;\n\tborder: 1px solid #E0E0E0;\n\tbox-shadow: none;\n\tborder-radius: 5px;\n\tposition: relative;\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n}\n\n.sidebar .user-list li a:hover {\n\tbackground-color: rgba(254, 159, 67, 0.08);\n\tborder: 1px solid rgba(254, 159, 67, 0.08);\n\ttransition: ease all 0.5s;\n\t-webkit-transition: ease all 0.5s;\n\t-ms-transition: ease all 0.5s;\n}\n\n.sidebar .user-list li.item-typing {\n\tbackground-color: #F1F6FF;\n}\n\n.sidebar .user-list li figure {\n\tmargin-right: 1rem;\n}\n\n.sidebar .user-list li .users-list-body {\n\tflex: 1;\n\tposition: relative;\n\tmin-width: 0px;\n\tdisplay: flex;\n}\n\n.lock-icon {\n\tcolor: #000000;\n}\n\n.sidebar .user-list li .users-list-body > div:first-child {\n\tmin-width: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n\tflex: 1;\n}\n.parti-notify-check {\n\tmargin-bottom: 0 !important;\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.sidebar .user-list li .users-list-body h5 {\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tfont-size: $font-size-15;\n\tfont-weight: $font-weight-medium;\n\tmargin-bottom: 3px;\n\tcolor: #0A0A0A;\n}\n\n.sidebar .user-list li .users-list-body p {\n\twhite-space: nowrap;\n\ttext-overflow: ellipsis;\n\toverflow: hidden;\n\tmargin-bottom: 0;\n\tcolor: #232323;\n\tfont-size: $font-size-14;\n}\n.sidebar .user-list li .users-list-body p.missed-call-col {\n\tcolor: #DE3E44;\n}\n.sidebar .user-list li .users-list-body .last-chat-time {\n\tpadding-left: 15px;\n\tposition: relative;\n}\n\n.sidebar .user-list li .users-list-body .last-chat-time .text-muted {\n\tcolor: #424242 !important;\n\tfont-weight: $font-weight-normal;\n\tfont-size: 12px;\n\tmargin-bottom: 5px;\n\tdisplay: block;\n\ttext-align: right;\n}\n.sidebar .user-list li .users-list-body .last-chat-time .contact-toggle {\n\tcolor: #680A83;\n}\n\n.sidebar .user-list li .users-list-body .last-chat-time .new-message-count {\n\twidth: 20px;\n\theight: 20px;\n\tdisplay: flex;\n\tdisplay: -webkit-flex;\n\talign-items: center;\n\t-webkit-align-items: center;\n\tjustify-content: center;\n\t-webkit-justify-content: center;\n\tline-height: 0;\n\tfont-size: 11px;\n\tbackground-color: $primary;\n\tcolor: $white;\n\tborder-radius: 50%;\n\tmargin-left: auto;\n\tmargin-top: 10px;\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n}\n\n.sidebar .user-list li .users-list-body .last-chat-time .chat-toggle {\n\tposition: absolute;\n\tright: 0;\n\tbottom: 0;\n\topacity: 0;\n\ttext-align: right;\n\ttransition: all .5s ease;\n\t-webkit-transition: all .5s ease;\n\t-ms-transition: all .5s ease;\n\twidth: 18px;\n\theight: 24px;\n}\n\n.sidebar .user-list li.unread h5 {\n\tcolor: $white;\n}\n\n.sidebar .user-list li.unread p {\n\tcolor: $white;\n}\n\n.sidebar .user-list li.unread .text-muted {\n\tcolor: rgba(255, 255, 255, 0.4) !important;\n}\n\n.sidebar .user-list li.user-list-item.item-typing .users-list-body p {\n\tcolor: #0D9B35;\n}\n\n.rightside_tab {\n\tpadding-top: 5px !important;\n}\n.chat-pin {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: flex-end;\n\t-webkit-justify-content: end;\n\t-ms-flex-pack: end;\n\t.green-check {\n\t\tcolor: #0D9B35;\n\t}\n}\n.chat-pin img {\n\twidth: 10px;\n}\n.chat-pin .check {\n\tcolor: #53BDEB;\n}\n.select-message-box {\n\tmargin-top: 50px;\n}\n.select-message-box h4 {\n\tmargin-bottom: 5px;\n}\n.select-message-box p {\n\tmargin-top: 0;\n\tmargin-bottom: 24px;\n\tcolor: #424242;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-normal;\n}\n.select-message-box .btn i {\n\tfont-size: $font-size-15;\n}\n\n.group-description {\n\tpadding: 0px 24px;\n}\n.group-description .description-sub {\n\tborder-bottom: 1px solid #EDEDED;\n\tpadding-bottom: 15px;\n\tmargin-bottom: 15px;\n}\n.group-description h5 {\n\tfont-size: $font-size-15;\n\tfont-weight: $font-weight-medium;\n\tcolor: #0A0A0A;\n\tmargin-bottom: 10px;\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tjustify-content: space-between;\n\t-webkit-justify-content: space-between;\n\t-ms-flex-pack: space-between;\n}\n.group-description h5 a:hover {\n\tcolor: #650681 !important;\n}\n.group-description p { \n\tcolor: #424242;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-normal;\n\tmargin-bottom: 10px;\n}\n.group-description p.description-date { \n\tcolor: #424242;\n\tfont-size: 12px;\n\tfont-weight: $font-weight-normal;\n\tmargin-bottom: 0px;\n}\n.encrypted-message p {\n\tfont-size: 12px;\n\tcolor: #424242;\n\tfont-weight: $font-weight-normal;\n\tmargin-bottom: 0;\n}\n.group-view-all {\n\tmargin-top: 10px;\n}\n.group-view-all a {\n\tcolor: #680A83;\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-medium;\n}\n.group-view-all a:hover {\n\tcolor: #0A0A0A;\n}\n.exit-bg-message {\n\tbackground: #FFE8E9;\n}\n.exit-bg-message i {\n\tcolor: #DE3E44;\n}\n.disapper-message {\n\tbackground: #E7FAF2;\n}\n.disapper-message i {\n\tcolor: #1BA345;\n}\n.group-setting-msg {\n\tbackground: #F8ECFF;\n}\n.group-setting-msg i {\n\tcolor: #680A83;\n}\n.group-setting .stared-group span {\n\twidth: 50px;\n\theight: 50px;\n}\n.edit-set-details p {\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-normal;\n\tcolor: #424242;\n\tmargin-bottom: 0;\n}\n.group-send-msg {\n\tbackground: #FEF6DC;\n}\n.parcipant-check p a {\n\tcolor: #680A83;\n}\n.select-group-chat .dropdown-toggle::after {\n\tdisplay: none;\n}\n.select-group-chat .dropdown-toggle i {\n\tmargin-left: 15px;\n}\n.select-group-chat .dropdown-toggle:hover {\n\tcolor: #0A0A0A;\n}\n.select-group-chat .dropdown-toggle {\n\tfont-weight: $font-weight-semibold;\n\tcolor: #0A0A0A;\n\tfont-size: $font-size-18;\n}\n.select-group-chat .dropdown-menu .dropdown-item {\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-normal;\n\tcolor: #0A0A0A;\n}\n.select-group-chat .dropdown-menu li:first-child .dropdown-item:hover {\n\tborder-radius: 5px 5px 0 0;\n}\n.select-group-chat .dropdown-menu li:last-child .dropdown-item:hover {\n\tborder-radius: 0 0 5px 5px;\n}\n.dropzone {\n\tbackground: $white;\n\tborder: 1px dashed #C2C2C2;\n\tborder-radius: 5px;\n\tpadding: 10px;\n\tmin-height: 70px;\n\ttext-align: center;\n}\n.dropzone.dz-clickable .dz-message {\n\tdisplay: none;\n}\n.dropzone p {\n\tmargin-bottom: 10px;\n\tfont-size: $font-size-16;\n\tfont-weight: $font-weight-medium;\n\tcolor: #0A0A0A;\n}\n.dropzone span {\n\tcolor: #424242;\n\tfont-size: $font-size-14;\n\tfont-weight: $font-weight-normal;\n}\n.uplaod-image img {\n\tborder-radius: 20px;\n}\n.upload-img-file .modal-body {\n\tpadding: 0;\n}\n.upload-img-file .modal-content {\n\tposition: relative;\n}\n.upload-img-file .modal-header {\n\tposition: absolute;\n\ttop: 0;\n\tz-index: 9;\n\tleft:0;\n\tright: 0;\n}\n.upload-image-list {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n}\n.upload-image-list li+li {\n\tmargin-left: 10px;\n}\n.upload-img-file .modal-header .close {\n\tbackground-color: transparent;\n\tcolor: $white;\n}\n.check-star i {\n\tcolor: #FEC001;\n}\n.emoj-group-list {\n\tdisplay: none;\n\tposition: absolute;\n\ttop: -50px;\n\tleft: -90px;\n\ttransition: all 0.5s ease;\n    -moz-transition: all 0.5s ease;\n    -o-transition: all 0.5s ease;\n    -ms-transition: all 0.5s ease;\n    -webkit-transition: all 0.5s ease;\n}\n.emoj-group-list ul {\n\tdisplay: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n\t-webkit-box-align: center;\n\t-ms-flex-align: center;\n\talign-items: center;\n\tbackground: #f6f7f8;\n\tborder-radius: 50px;\n\tpadding: 5px;\n}\n.emoj-group-list ul li a {\n\tpadding: 0;\n}\n.emoj-group-list ul li.add-emoj a {\n\tbackground: #EDEDED;\n}\n.emoj-group-list ul li.add-emoj a i {\n\tfont-size: $font-size-20;\n\tcolor: #424242;\n}\n.chat .slimscroll {\n\theight: calc(100vh - 60px) !important;\n}\n.settings-option {\n\tdisplay: none;\n\ttext-align: right;\n}\n.settings-option a {\n\tfont-size: $font-size-15;\n\tfont-weight: $font-weight-medium;\n\tcolor: #680A83;\n}\n.empty-dark-img {\n\tdisplay: none;\n}\n.bootstrap-datetimepicker-widget span {\n\tposition: relative;\n}\n\n}\n.chat-window{\n    .card{\n        .card-header {\n            background-color: $white;\n            border-bottom: 1px solid $gray-300;\n        }\n    }\n    .badge-success {\n        background-color: $success !important;\n    }\n}\n.chat-page {\n    .footer {\n        display: none;\n    }\n}\n.chat-search{\n    .input-group {\n        .form-control{\n            @include margin-padding(0,0 0 0 36px);\n            height: 46px;\n        }\n        .input-group-prepend {\n        \tdisplay: -webkit-box;\n\t\t\tdisplay: -ms-flexbox;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\t-webkit-box-align: center;\n\t\t\t-ms-flex-align: center;\n            color: $gray-700;\n            pointer-events: none;\n            z-index: 4;\n            @include position(absolute,0,15px,0,null);\n        }\n    }\n}\n.chat-cont-left {\n    .chat-scroll {\n        max-height: calc(100vh - 200px);\n        overflow-y: auto;\n        padding: 0;\n        .media {\n            border-bottom: 1px solid $gray-300;\n            @include margin-padding(0,10px);\n            @include transition(all .2s);\n            &.active {\n                background-color:  $gray-100;\n            }\n            &:hover{\n                background-color:  $gray-100;\n            }\n            .media-img-wrap {\n                @include margin-padding(0  15px 0 0,null);\n                position: relative;\n                .avatar > img {\n                    width: 100%;\n                    height: 100%;\n                    object-fit: cover;\n                }\n            }\n            .media-body {\n                display: -webkit-box;\n\t\t        display: -ms-flexbox;\n\t\t        display: flex;\n\t\t        justify-content: space-between;\n    \t\t\t-webkit-justify-content: space-between;\n    \t\t\t-ms-flex-pack: space-between;\n                .user-name{\n                    max-width: 170px;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                    color: $secondary;\n                    font-size: $font-size-16;\n                    font-weight: $font-weight-bold;\n                }\n                .user-last-chat {\n                    color: $gray-800;\n                    font-size: $font-size-base;\n                    line-height: 24px;\n                    max-width: 170px;\n                    overflow: hidden;\n                    text-overflow: ellipsis;\n                    white-space: nowrap;\n                }\n                .last-chat-time {\n                    color: $gray-600;\n                    font-size:$font-size-13;\n                }\n                 div{\n                    &:last-child {\n                        text-align: right;\n                    }\n                }\n            }\n        }\n    }\n    \n}\n.chat-cont-right {\n    @include transition(all 0.4s);\n    .chat-scroll {\n        max-height: calc(100vh - 293px);\n        overflow-y: auto;\n        \n    }\n    .msg_head {\n        .back-user-list {\n            display: none;\n            @include margin-padding(0 0 0 -10px ,0 10px);\n        }\n    }\n    .img_cont {\n        position: relative;\n        height: 45px;\n        width: 45px;\n        .user_img {\n            height: 45px;\n            min-width: 45px;\n            width: 45px;\n            border: 1.5px solid $primary;\n        }\n    }\n    .user_info {\n        @include margin-padding(0 auto 0 15px,0);\n        width: 100%;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n    ul.list-unstyled {\n        @include margin-padding(0 auto,0);\n        width: 100%;\n        .media{\n            &.sent {\n                margin-bottom: 20px;\n                .avatar {\n                    order: 3;\n                    height: 30px;\n                    width: 30px;\n                }\n                .media-body {\n                \tdisplay: -webkit-box;\n\t\t\t        display: -ms-flexbox;\n\t\t\t        display: flex;\n                    -webkit-box-align: flex-end;\n  \t\t\t\t\t-ms-flex-align: flex-end;\n  \t\t\t\t\talign-items: flex-end;\n                    -ms-flex-direction: column;\n  \t\t\t\t\tflex-direction: column;\n                    @include margin-padding(0 20px 0 0 ,0);\n                    .msg-box {\n                        @include margin-padding(0,0 0 0 50px);\n                        position: relative;\n                        + .msg-box{\n                            @include margin-padding(5px 0 0,0);\n                        }\n                        p{\n                            @include margin-padding(0,0);\n                        }\n                        &:first-child::before {\n                            border-bottom: 6px solid transparent;\n                            border-left: 6px solid #e3e3e3;\n                            border-top: 6px solid #e3e3e3;\n                            border-right: 6px solid transparent;\n                            content: \"\";\n                            height: 0;\n                            width: 0;\n                            @include position(absolute,0,-12px,null,auto);\n                        }\n                       > div {\n                            @include margin-padding(0,10px 15px);\n                            @include rounded(10px);\n                            background-color: #e3e3e3;\n                            display: inline-block;\n                            position: relative;\n                        }\n                        &:first-child > div {\n                            @include rounded(10px 0 10px 10px) ;\n                        }\n                    }\n                    .chat-msg-attachments {\n                    \tdisplay: -webkit-box;\n\t\t\t\t        display: -ms-flexbox;\n\t\t\t\t        display: flex;\n                        @include margin-padding(0 -1px,4px 0);\n                        width: 100%;\n                        .chat-attachment {\n                            position: relative;\n                            max-width: 130px;\n                            overflow: hidden;\n                            &:before {\n                                @include position(absolute,0,0,0,0);\n                                background: $black;\n                                content: \"\";\n                                opacity: 0.4;\n                                @include transition(all .4s);\n                            }\n                            &:hover{\n                                .chat-attach-download{\n                                    opacity: 1\n                                }\n                            }\n                        }\n                       > div {\n                            margin: 0 1px;\n                        }\n                        \n                        img {\n                            max-width: 100%;\n                        }\n                        .chat-attach-download {\n                            @include position(absolute,50%,null,null,50%);\n                            transform: translate(-50%, -50%);\n                            opacity: 0;\n                            @include transition(all .4s);\n                            color: $white;\n                            width: 32px;\n                            line-height: 32px;\n                            background: rgba(255, 255, 255, 0.2);\n                            text-align: center;\n                        }\n                    }\n                    .chat-msg-info {\n                    \tdisplay: -webkit-box;\n  \t\t\t\t\t\tdisplay: -ms-flexbox;\n  \t\t\t\t\t\tdisplay: flex;\n                    \talign-items: center;\n  \t\t\t\t\t\t-webkit-box-align: center;\n  \t\t\t\t\t\t-ms-flex-align: center;\n                        @include margin-padding(5px 0 0,0);\n                        -ms-flex-wrap: wrap;\n  \t\t\t\t\t\tflex-wrap: wrap;\n                        clear: both;\n                        flex-direction: row-reverse;\n                        list-style: none;\n                        li{\n                            @include margin-padding(0,0 0 0 16px);\n                            position: relative;\n\n                            &:not(:last-child)::after {\n                                @include position(absolute,50%,auto,null,8px);\n                                transform: translate(-50%, -50%);\n                                background: $primary;\n                                content: '';\n                                height: 4px;\n                                width: 4px;\n                            }\n                        }\n                        .chat-time {\n                            color: rgba(50, 65, 72, 0.4);\n                        }\n                        a {\n                            color: $gray-800;\n                        }\n                    }\n                }\n            }\n            &.received {\n                position: relative;\n                margin-bottom: 20px;\n                .media-body{\n                    position: relative;\n                    @include margin-padding(0 0 0 20px,0);\n                    &::before {\n                        border-bottom: 6px solid transparent;\n                        border-right: 6px solid $primary;\n                        border-top: 6px solid $primary;\n                        border-left: 6px solid transparent;\n                        content: \"\";\n                        height: 0;\n                        @include position(absolute,0px,auto,null,-6px);\n                        width: 0;\n                    }\n                    > div {\n                        @include margin-padding(0,10px 15px);\n                        @include rounded(10px);\n                        background-color: $primary;\n                        display: table;\n                        position: relative;\n                        p {\n                            color: $white;\n                            @include margin-padding(0,0);\n                        }\n                    }\n                }\n                .msg-box {\n                    display: block;\n                    + .msg-box {\n                        margin-top: 5px;\n                    }\n                    \n            }\n            .chat-msg-info {\n                display: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n        \t\talign-items: center;\n\t\t\t\t-webkit-box-align: center;\n\t\t\t\t-ms-flex-align: center;\n                -ms-flex-wrap: wrap;\n  \t\t\t\tflex-wrap: wrap;\n                @include margin-padding(5px 0 0,0);\n                clear: both;\n                list-style: none;\n                .chat-time {\n                    color: rgba(255,255,255,.8);\n                }\n            }\n            .chat-msg-attachments {\n            \tdisplay: -webkit-box;\n\t\t\t\tdisplay: -ms-flexbox;\n\t\t\t\tdisplay: flex;\n                @include margin-padding(0 -1px,4px 0);\n                width: 100%;\n                .chat-attachment {\n                    position: relative;\n                    max-width: 130px;\n                    overflow: hidden;\n                    &:before {\n                        @include position(absolute,0,0,0,0);\n                        background: $black;\n                        content: \"\";\n                        opacity: 0.4;\n                        @include transition(all .4s);\n                    }\n                    &:hover{\n                        .chat-attach-download{\n                            opacity: 1\n                        }\n                    }\n                }\n               > div {\n                    margin: 0 1px;\n                }\n                \n                img {\n                    max-width: 100%;\n                }\n                .chat-attach-download {\n                    @include position(absolute,50%,null,null,50%);\n                    @include transform(translate(-50%, -50%));\n                    @include transition(all .4s);\n                    opacity: 0;\n                    color: $white;\n                    width: 32px;\n                    line-height: 32px;\n                    background: rgba(255, 255, 255, 0.2);\n                    text-align: center;\n                }\n            }\n        }\n           \n        }\n        .chat-date {\n            font-size: $font-size-base;\n            margin: 1.875rem 0;\n            overflow: hidden;\n            position: relative;\n            text-align: center;\n            text-transform: capitalize;\n            &:before {\n                background-color: #e0e3e4;\n                content: \"\";\n                height: 1px;\n                margin-right: 28px;\n                @include position(absolute,50%,50%,null,null);\n                width: 100%;\n            }\n            &:after {\n                background-color: #e0e3e4;\n                content: \"\";\n                height: 1px;\n                @include margin-padding(0 0 0 28px,null);\n                @include position(absolute,50%,null,null,50%);\n                width: 100%;\n            }\n        }\n    }\n    \n}\n.card-footer {\n    background-color: $white;\n    border-top: 1px solid $gray-300;\n    @include margin-padding(0,1rem 1.5rem);\n    .type_msg {\n        background-color: rgba(0,0,0,0.1) !important;\n        border: 0 !important;\n        overflow-y: auto;\n    }\n}\n@include respond-below(custom992) {\n    .chat-window.chat-slide .chat-cont-right {\n        right: 0;\n        opacity: 1;\n        visibility: visible;\n    }\n\n    .chat-cont-right {\n        @include position(absolute, null, -100px, null, null);\n        opacity: 0;\n        visibility: hidden;\n        z-index: 99;\n    }\n    .chat-cont-right .msg_head .back-user-list {\n        display: flex;\n        align-items: center;\n    }\n}\n\n.msg-typing {\n    width: auto;\n    height: 24px;\n    padding-top: 8px;\n\tspan {\n\t\theight: 8px;\n\t\twidth: 8px;\n\t\tfloat: left;\n\t\tbackground-color: $white;\n\t\tdisplay: block;\n\t\topacity: .4;\n\t\t@include margin-padding(0 1px, null);\n\t\t@include rounded(50%);\n\t\t&:nth-of-type(1) {\n\t\t\tanimation: 1s blink infinite .33333s;\n\t\t}\n\t\t&:nth-of-type(2) {\n\t\t\tanimation: 1s blink infinite .66666s;\n\t\t}\n\t\t:nth-of-type(3) {\n\t\t\tanimation: 1s blink infinite .99999s;\n\t\t}\n\t}\n}\n@keyframes blink {\n\t50% {\n\t\topacity: 1\n\t}\n}\n\n.phone-call-icon {\n\tsvg {\n\t\twidth: 18px;\n\t}\n\t.income-success {\n\t\tcolor: $success;\n\t}\n\t.income-success-missed {\n\t\tcolor: $danger;\n\t}\n}\n.history-modal-profile {\n\t.content {\n\t\tpadding: 24px;\n\t}\n\t.right-sidebar-profile {\n\t\tbackground: $body-bg;\n\t\tborder-radius: 8px;\n\t\tpadding: 24px;\n\t\t.list-inline-item {\n\t\t\ta {\n\t\t\t\tbackground: $primary;\n\t\t\t\twidth: 40px;\n\t\t\t\theight: 40px;\n\t\t\t\tborder-radius: 50px;\n\t\t\t\tdisplay: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n\t\t\t\t&:hover {\n\t\t\t\t\tbackground: #1b2950;\n\t\t\t\t\tcolor: $white;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t\t.avatar {\n\t\t\tmargin-bottom: 24px;\n\t\t\twidth: 150px;\n\t\t\theight: 150px;\n\t\t\timg {\n\t\t\t\tborder-radius: 8px;\n\t\t\t}\n\t\t}\n\t}\n}\n.modal-profile-detail {\n\t.modal-userlist {\n\t\tli {\n\t\t\tfont-size: $font-size-14;\n\t\t\tcolor: $black;\n\t\t\tmargin-bottom: 10px;\n\t\t\tspan {\n\t\t\t\tdisplay: block;\n\t\t\t\tcolor: $text-color;\n\t\t\t}\n\t\t\t&:last-child {\n\t\t\t\tmargin-bottom: 0;\n\t\t\t}\n\t\t}\n\t}\n}",".inbox-menu {\n    display: inline-block;\n    \n    width: 100%;\n    @include margin-padding(0 0 20px,0 );\n    li {\n        display: inline-block;\n        width: 100%;\n        a {\n            color: #333;\n            display: inline-block;\n            padding: 10px 15px;\n            width: 100%;\n            font-weight: $font-weight-semibold;\n            text-transform: capitalize;\n            -webkit-transition: 0.3s ease;\n            -moz-transition: 0.3s ease;\n            transition: 0.3s ease;\n            &:hover{\n                background: rgba(33, 33, 33, 0.05);\n            }\n            i {\n                font-size: $font-size-16;\n                padding-right: 10px;\n                color: #878787;\n            }\n        }\n    }\n}\n.compose-btn {\n    margin-bottom: 25px;\n}\n.top-action-left{\n    .btn-group {\n        margin-bottom: 5px;\n    }\n    .dropdown-toggle{\n        height: 40px;\n        &::after{\n            display: none;\n        }\n    }\n}\n.table-inbox {\n    .starred.fas.fa-star {\n        color: $warning;\n    }\n    .checked {\n        background-color: $gray-300;\n    }\n    tbody{\n        tr{\n            td{\n                font-size: $font-size-14;\n                color: $secondary;\n            }\n        }\n    }\n}\n.unread{\n    .name,\n    .subject,\n    .mail-date{\n        color: $black;\n        font-weight: $font-weight-bold;\n    }\n}\n.email-header{\n    .btn-white{\n        min-width: auto;\n        height: 38px;\n        i{\n            margin-left:5px;\n        }\n    }\n}",".error-box {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    -ms-flex-direction: column;\n    flex-direction: column;\n}\n.comming-soon-pg {\n    background-image: url(../../../../public/assets/img/coming-soon.png);\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    height: 100vh;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    @include respond-below(custom991) {\n        height: 100%;\n    }\n    .coming-soon-box {\n        width: 800px;\n        background-color: rgba(255, 255, 255, 0.95);\n        border-radius: 10px;\n        padding: 40px;\n        text-align: center;\n        @include respond-below(custom1199) {\n            padding: 20px 40px;\n            max-width: 800px;\n        }\n        @include respond-below(custom991) {\n            width: auto;\n            padding: 30px;\n            margin: 20px;\n        }\n        @include respond-below(custom575) {\n            padding: 15px;\n            margin: 10px;\n        }\n        .pos-logo {\n            margin-bottom: 30px;\n            @include respond-below(custom1199) {\n                margin-bottom: 20px;\n            }\n        }\n        span {\n            font-size: $font-size-24;\n            color: $gray-600;\n            font-weight: $font-weight-bold;\n        }\n        h1 {\n            font-size: $font-size-60;\n            font-weight: $font-weight-bold;\n            line-height: normal;\n            @include respond-below(custom1199) {\n                font-size: $font-size-50;\n            }\n            @include respond-below(custom991) {\n                font-size: $font-size-40;\n            }\n            @include respond-below(custom575) {\n                font-size: $font-size-28;\n            }\n            span {\n                font-size: $font-size-60;\n                color: $primary;\n                @include respond-below(custom1199) {\n                    font-size: $font-size-50;\n                }\n                @include respond-below(custom991) {\n                    font-size: $font-size-40;\n                }\n                @include respond-below(custom575) {\n                    font-size: $font-size-28;\n                }\n            }\n        }\n        p {\n            font-size: $font-size-15;\n            max-width: 400px;\n            text-align: center; \n            margin: auto;\n        }\n        .coming-soon-timer {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin: 30px 0;\n            @include respond-below(custom1199) {\n                margin: 20px 0;\n            }\n            li {\n                border: 1px solid $gray-200;\n                background-color: $white;\n                font-size: $font-size-16;\n                width: 85px;\n                height: 85px;\n                border-radius: 8px;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                font-size: $font-size-16;\n                font-weight: $font-weight-medium;\n                flex-direction: column;\n                margin-right: 14px;\n                color: $gray-600;\n                @include respond-below(custom575) {\n                    width: 50px;\n                    height: 50px;\n                    margin-right: 5px;\n                }\n                span {\n                    color: $secondary;\n                    font-size: $font-size-32;\n                    line-height: normal;\n                    @include respond-below(custom575) {\n                        font-size: $font-size-20;\n                    }\n                }\n                &.seperate-dot {\n                    color: $secondary;\n                    width: auto;\n                    height: auto;\n                    border: 0;\n                    border-radius: 0;\n                    background-color: transparent;\n                }\n                &:last-child {\n                    margin-right: 0;\n                }\n            }\n        }\n        .subscribe-form {\n            position: relative;\n            .subscribe-btn {\n                position: absolute;\n                bottom: 10px;\n                right: 10px;\n            }\n            input {\n                height: 58px;\n                padding-right: 130px;\n            }\n            label {\n                color: $secondary;\n                font-weight: $font-weight-semibold;\n            }\n        }\n        .social-media-icons {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin-top: 30px;\n            @include respond-below(custom1199) {\n                margin-top: 20px;\n            }\n            li {\n                margin-right: 5px;\n                &:last-child {\n                    margin-right: 0;\n                }\n                a {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    width: 32px;\n                    height: 32px;\n                    background-color: $secondary;\n                    border-radius: 5px;\n                    &:hover {\n                        background-color: $primary;\n                    }\n                    i {\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n}",".login-wrapper {\n    width: 100%;\n    overflow: hidden;\n    height: 100vh;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    &.bg-img {\n        background-image: url(../../../../public/assets/img/authentication/login-img.jpg);\n        background-repeat: no-repeat;\n        background-size: cover;\n        background-position: center;\n        .login-content {\n            background: rgba(255, 255, 255, 0.80);\n            backdrop-filter: blur(17px);\n        }\n        &.register-wrap {\n            background-image: url(../../../../public/assets/img/authentication/register-img.jpg);\n        }\n        &.forgot-pass-wrap {\n            background-image: url(../../../../public/assets/img/authentication/forgot-password-img.jpg);\n        }\n        &.reset-pass-wrap {\n            background-image: url(../../../../public/assets/img/authentication/reset-password-img.jpg);\n        }\n        &.email-veri-wrap {\n            background-image: url(../../../../public/assets/img/authentication/email-verification-img.jpg);\n        }\n    }\n    .login-content {\n        width: 50%;\n        height: 100vh;\n        @include margin-padding(null, 24px);\n        overflow: auto;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        flex-wrap: wrap;\n        @include respond-below(custom991) {\n            width: 100%;\n        }\n        .login-logo {\n            display: block;\n            max-width: 150px;\n            margin: auto;\n            img {\n                margin-bottom: 25px;\n            }\n        }\n        .login-userset{\n            @include respond-below(custom991) {\n                margin-top: 30px;\n            }\n            .my-4  {\n                margin-top: 50px !important;\n                p {\n                    font-size: $font-size-14;\n                    color: $secondary;\n                    margin-bottom: 0;\n                    font-weight: $font-weight-normal;\n                }\n            }\n            form .otp-box { \n                margin-bottom: 34px;\n                input { \n                    width: 74px; \n                    height: 74px; \n                    background: $white ; \n                    border: 1px solid #E1E1E1; \n                    border-radius: 8px; \n                    text-align: center; \n                    margin-right: 15px; \n                    font-weight: $font-weight-bold; \n                    font-size: $font-size-26; \n                    color: $black; \n                    outline: none;\n                    @include respond-below(custom575) {\n                        width: 50px; \n                        height: 50px; \n                    }\n                }\n            }\n            form .otp-box input::placeholder { \n                color: #74788d;\n            }\n            form .otp-box input:last-child { \n                margin-right: 0px;\n         }\n         .Otp-expire {\n                border-radius: 8px;\n                background: rgba(255, 0, 0, 0.05);\n                padding: 10px 12px;\n                max-width: 200px;\n                margin: auto;\n            \n            p {\n                \n                color: $danger;\n                font-size: $font-size-14;\n                font-weight: $font-weight-normal;\n            }\n         }\n        }\n        .login-userheading {\n            @include margin-padding( 0 0 24px, null);\n             h3 {\n                font-size: $font-size-24;\n                font-weight: $font-weight-bold;\n                @include margin-padding( 0 0 10px, null);\n                color: $black;\n            }\n             h4 {\n                font-size: $font-size-15;\n                font-weight: $font-weight-normal;\n                color: $secondary;\n                line-height: 1.4;\n            }\n            .verfy-mail-content {\n                max-width: 400px;\n                margin-bottom: 40px;\n            }\n        }\n        .form-login {\n            margin-bottom: 15px;\n            label {\n                width: 100%;\n                color: $secondary;\n                margin-bottom:10px;\n                font-size: $font-size-15;\n                font-weight: $font-weight-normal;\n            }\n            .form-addons{\n                position: relative;\n                img{\n                    @include position(absolute,16px,20px,null,null);\n                }\n                \n            }\n            input {\n                width: 100%;\n                height: 40px;\n                border: 1px solid rgba(145, 158, 171, 0.32);\n                @include rounded(5px);\n                @include margin-padding(null, 0 15px);\n                @include transition(all 0.2s ease);\n                &:focus{\n                    border: 1px solid $primary;\n                }\n            }\n            .btn-login {\n                width: 100%;\n                font-weight: $font-weight-bold;\n                font-size: $font-size-14;\n                background: $primary;\n                border-color:$primary ;\n                @include margin-padding(null, 10px);\n                @include transition(all 0.5s ease);\n                margin-top:5px;\n                color: $white;\n                &:hover{\n                   box-shadow:0  50px $white inset !important;\n                   color: $primary;\n                }\n            }\n            .alreadyuser {\n                margin-bottom: 15px;\n                h4 {\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-normal;\n                    color: $sub-title;\n                    a{\n                        color:$primary;\n                        font-weight: $font-weight-semibold;\n                    }\n                }\n            }\n            .custom-control.custom-checkbox {\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                @include respond-below(custom575) {\n                    justify-content: start;\n                }\n                .custom-control-input {\n                    width: auto;\n                    height: auto;\n                }\n                .custom-control-label {\n                    margin-bottom: 0;\n                    margin-left: 8px;\n                }\n            }\n            .forgot-link {\n                color: $danger;\n                font-size: $font-size-15;\n                font-weight: $font-weight-semibold;\n            }\n        }\n        .signinform {\n            margin-bottom: 23px;\n            h4{\n                font-size: $font-size-15;\n                font-weight: $font-weight-normal;\n                color: $secondary;\n                @include respond-below(custom575) {\n                    font-size: $font-size-base;\n                }\n                a{\n                    color: $secondary;\n                    font-weight: $font-weight-bold;\n                    font-size: $font-size-14;\n                }\n            }\n            .hover-a.resend {\n                color: $danger;\n            }\n        }\n        .form-setlogin {\n            text-align: center;\n            position: relative;\n            color: $sub-title;\n            font-size: $font-size-base;\n            font-weight: $font-weight-normal;\n            margin-bottom: 23px;\n            h4{\n                position: relative;\n                font-size: $font-size-base;\n                color: $text-color;\n                font-weight: $font-weight-bold;\n                &:after{\n                    content: \"\";\n                    background: $sub-title;\n                    width:21px;\n                    height: 1px;\n                    @include position(absolute,10px,null,null,200px);\n                    @include respond-below(custom991) {\n                        height: 0px;\n                    }\n                }\n                &:before{\n                    content: \"\";\n                    background:$sub-title;\n                    width:21px;\n                    height: 1px;\n                    @include position(absolute,10px,200px,null,null);\n                    @include respond-below(custom991) {\n                        height: 0px;\n                    }\n                }\n            }\n        }\n        .form-setlogin.or-text {\n            max-width: 365px;\n             margin: auto;\n        }\n        .toggle-password {\n            cursor: pointer;\n            width: 30px;\n            height: 30px;\n            color: $sub-title;\n            font-size: $font-size-18;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            @include rounded(50%);\n            @include transform(translateY(-50%));\n            @include position(absolute,50%,10px,null,null);\n            &:hover{\n                color:$primary;\n            }\n        }\n        .toggle-passwords {\n            cursor: pointer;\n            width: 30px;\n            height: 30px;\n            color: $sub-title;\n            font-size: $font-size-18;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            @include rounded(50%);\n            @include transform(translateY(-50%));\n            @include position(absolute,50%,10px,null,null);\n            &:hover{\n                color:$primary;\n            }\n        }\n        .pass-group {\n            position: relative;\n            font-size: $font-size-base;\n            .fas{\n                font-size: $font-size-13;\n                color: #939ea8;\n            }\n        }\n        .form-sociallink {\n            margin-top: 25px;\n            ul {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                -ms-flex-wrap: wrap;\n                flex-wrap: wrap;\n                li {\n                    text-align: center;\n                    margin-right: 10px;\n                    @include respond-below(custom575) {\n                        width: 100%;\n                        margin-bottom: 20px;\n                        \n                    }\n                    &:last-child {\n                        padding-right: 0;\n                        @include respond-below(custom575) {\n                            padding-right: 0;\n                        }\n                    }\n                    a {\n                        color: $secondary;\n                        width: 100%;\n                        border: 1px  solid rgba(145, 158, 171, 0.23);\n                        background: $white;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        justify-content: center;\n                        -webkit-justify-content: center;\n                        -ms-flex-pack: center;\n                        @include rounded(10px);\n                        @include margin-padding(0 10px 0 0, 15px 53px);\n                        font-weight: $font-weight-medium;\n                        &:hover{\n                            background: $primary;\n                            color: $white;\n                        }\n                        img {\n                            width: 24px;\n                            height: 24px;\n                        }\n                    }\n                    .facebook-logo {\n                        border-radius: 10px;\n                        background: #1877F2;\n                    }\n                    .apple-logo {\n                        border-radius: 10px;\n                        background: $black;\n                    }\n                }\n            }\n        }\n    }\n    .login-content.user-login {\n        width: 100%;\n        padding: 0;\n        overflow: hidden;\n        flex-wrap: nowrap;\n        flex-direction: column;\n        height: auto;\n        margin: 50px 0;\n        .login-userset {\n            background: $white;\n            box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);\n            margin: 0;\n            padding: 40px;\n            border: 1px solid $gray-300;\n        }\n    }\n    .login-img {\n        width: 50%;\n        @include respond-below(custom991) {\n            display: none;\n        }\n         img {\n            width: 100%;\n            height: 100vh;\n        }\n    }\n    .login-userset {\n        .login-logo.login-info {\n            display: block;\n            max-width: 150px;\n            margin: auto;\n\n        }\n    }\n    .login-logo {\n        max-width: 150px;\n        margin: auto;\n    }\n}\n.login-wrapper.login-new {\n    overflow: auto;\n    height: 100vh;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    .login-content.user-login {\n        .login-userset {\n            form .otp-box { \n                margin-bottom: 34px;\n                input { \n                    width: 74px; \n                    height: 74px; \n                    background: $white ; \n                    border: 1px solid #E1E1E1; \n                    border-radius: 8px; \n                    text-align: center; \n                    margin-right: 15px; \n                    font-weight: $font-weight-bold; \n                    font-size: $font-size-26; \n                    color: $black; \n                    outline: none;\n                    @include respond-below(custom575) {\n                        width: 40px; \n                        height: 40px; \n                    }\n                }\n            }\n        }\n    }\n}\n.copyright-text {\n    p {\n        @include respond-below(custom575) {\n            text-align: center;\n            max-width: 215px;\n        }\n    }\n}\n.authentication-check {\n    .custom-checkbox {\n        .checkboxs {\n            span {\n                top: 0;\n            }\n        }\n    }\n}\n.hover-a{\n    position: relative;\n    &:after{\n        content:\"\";\n        height: 2px;\n        width: 100%;\n        background: $primary;\n        @include transform(scale(0));\n        @include transition(all 0.3s ease);\n        @include position(absolute,null,null,-3px,0);\n    }\n    &:hover:after{\n        @include transform(scale(1));\n    }\n    &:hover{\n        color: $primary !important;\n    }\n}\n.login-body {\n    display: table;\n    height: 100vh;\n    min-height: 100vh;\n    margin: auto;\n    position: relative;\n    &::after {\n        content: \"\";\n        background-repeat: no-repeat;\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n    }\n    .login-wrapper {\n        width: 100%;\n        height: 100%;\n        display: table-cell;\n        vertical-align: top;\n        padding-top: 1.875rem;\n        .logo-dark {\n            max-width: 180px;\n            margin: auto;\n            margin-bottom: auto;\n            display: block;\n        }\n        .loginbox {\n            background: var(--White, $white);\n            box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);\n            display: flex;\n            margin: 1.875rem auto;\n            max-width: 450px;\n            width: 100%;\n            .login-right {\n                align-items: center;\n                display: flex;\n                justify-content: center;\n                padding: 2rem;\n                width: auto;\n                .login-right-wrap {\n                    max-width: 100%;\n                    flex: auto;\n                    .login-info {\n                        text-align: center;\n                        margin-bottom: 24px;\n                        img {\n                            border-radius: 100px;\n                            border: 2px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n                            background: lightgray 50% / cover no-repeat;\n                        }\n                        p {\n                            font-size: $font-size-14;\n                            font-weight: $font-weight-bold;\n                            margin-bottom: 24px;\n                        }\n                        h5 {\n                            font-size: $font-size-18;\n                            font-weight: $font-weight-bold;\n                            margin-top: 20px;\n                        }\n                    }\n                    form {\n                        .btn-primary {\n                            border-radius: 5px;\n                            padding: 5px 163px;\n                            background: $primary;\n                            font-weight: $font-weight-bold;\n                            transition: all .5s ease;\n                            &:hover {\n                                color: $primary;\n                                border-color: unset;\n                            }\n                        }\n                        .input-blocks {\n                            margin: 0 0 24px 0;\n                            input[type=password] {\n                                padding: 10px 10px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .terms {\n            justify-content: center;\n            li {\n                margin-right: 20px;\n                &:last-child {\n                    margin-right: 0;\n                }\n            }\n        }\n    }\n}\n\n",".product-list {\n    ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        margin-bottom: 15px;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        &.pagination {\n            li {\n                width: auto;\n                padding: 0;\n            }\n        }\n        li {\n            width: 25%;\n            @include margin-padding(null, 0 15px);\n            @include respond-below(custom991) {\n                width: 50%;\n                @include margin-padding(null, 0 5px);\n            }\n            @include respond-below(custom575) {\n                width: 100%;\n                @include margin-padding(null, 0);\n            }\n            .productviews {\n                border: 1px solid rgba(145, 158, 171, 0.32);\n                @include margin-padding(0 0 10px, 15px 15px 10px);\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                border-radius: 5px;\n                .productviewsimg {\n                    img {\n                        max-width: 48px;\n                        max-height: 48px;\n                    }\n                }\n\n                .productviewscontent {\n                    margin-left: 10px;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    width: calc(100% - 48px);\n\n                    .productviewsname {\n                        h2 {\n                            font-weight: $font-weight-medium;\n                            font-size: $font-size-base;\n                            color: $black;\n                        }\n\n                        h3 {\n                            color: $secondary;\n                            font-size: $font-size-13;\n                            font-weight: $font-weight-normal;\n                        }\n                    }\n                    a {\n                        color: $danger-700;\n                        font-weight: $font-weight-bold;\n                        @include rounded(50px);\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        justify-content: center;\n                        -webkit-justify-content: center;\n                        -ms-flex-pack: center;\n                        font-size: $font-size-20;\n                        width: 22px;\n                        height: 22px;\n                        &:hover{\n                            background: $danger-700;\n                            color: $white;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.bar-code-view {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    width: 282px;\n    border: 1px solid $gray-400;\n    padding: 15px;\n    margin-bottom: 20px;\n    max-width: 100%;\n}\n.input-checkset {\n    ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        li{\n            margin-right:30px;\n            @include respond-below(custom991) {\n                margin-right:10px;\n            }\n        }\n    }\n}\n.productdetails {\n    .product-bar{\n        @include respond-below(custom991) {\n            li {\n             border: 1px solid $gray-400;\n                &:first-child {\n                    border: 1px solid $gray-400;\n                }\n            }\n            h4{\n                width: 50%;\n                border-right: 1px solid $gray-400;\n            }\n            h6 {\n                width: 50%;\n            }\n           \n        }\n    }\n    &.productdetailnew{\n        margin-bottom: 25px;\n        ul{\n            li{\n               \n                h4{\n                    width: 50%;\n               }\n                h6{\n                    width: 50%;\n                    &.manitorygreen{\n                        color: #0F9D58;\n                    }\n                    &.manitoryblue{\n                        color: #2AA4F4;\n                    }\n               }\n            }\n        }\n    }\n    > ul {\n       > li {\n            border: 1px solid $gray-400;\n            border-top: 0;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            -ms-flex-wrap: wrap;\n            flex-wrap: wrap;\n            @include respond-below(custom991) {\n            border: 0;\n            }\n            h4 {\n                color: $secondary;\n                font-size: $font-size-base;\n                font-weight: $font-weight-medium;\n                width: 30%;\n                border-right: 1px solid $gray-400;\n                @include margin-padding(null, 10px);\n                @include respond-below(custom991) {\n                    width: 100%;\n                    border-right: 0;\n                }\n            }\n            h6 {\n                color: $black;\n                font-size: $font-size-base;\n                font-weight: $font-weight-medium;\n                width: 70%;\n                @include margin-padding(null, 10px);\n                @include respond-below(custom991) {\n                    width: 100%;\n                }\n            }\n            .input-checkset{\n                padding: 10px;\n                color: $black;\n                font-size: $font-size-base;\n                font-weight: $font-weight-medium;\n                width: 70%;\n            }\n            &:first-child {\n                border-top: 1px solid $gray-400;\n                @include respond-below(custom991) {\n                    border: 0;\n                }\n            }\n        }\n    }\n    @include respond-below(custom991) {\n        &.product-respon{\n            overflow: hidden;\n            ul{\n                overflow: auto;\n                .input-checkset{\n                  li{\n                    margin-bottom: 15px;\n                  }\n                }\n            }\n        }\n    }\n}\n\n.slider-product {\n    text-align: center;\n    width:100%;\n    img {\n        width: auto !important;\n        margin: 0 0 10px;\n        @include respond-below(custom991) {\n            height: auto;\n        }\n    }\n\n    h4 {\n        font-size: $font-size-base;\n        color: $secondary;\n        font-weight: $font-weight-medium;\n    }\n\n    h6 {\n        font-size: $font-size-13;\n        font-weight: $font-weight-normal;\n        color: $secondary;\n    }\n}\n\n.slider-product-details {\n    .owl-carousel {\n        .owl-nav {\n            position: relative;\n\n            button {\n                width: 21px;\n                height: 21px;\n                color: $gray-900;\n                border: 1px solid $gray-900;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                @include position(absolute,-30px,null,null,null);\n                @include rounded(50px);\n                &:hover {\n                    background: $gray-900;\n                    color: $white;\n                }\n                span {\n                    font-size: $font-size-16;\n                }\n            }\n            .owl-next {\n                @include position(absolute,-30px,0,null,null);\n            }\n        }\n    }\n}\n\n.requiredfield {\n    margin-bottom: 15px;\n    @include respond-below(custom991) {\n        margin-bottom: 10px;\n    }\n    h4 {\n        font-size: $font-size-14;\n        color: $gray-600;\n    }\n}\n\n.action-set {\n    width: 18px;\n    height: 18px;\n    display: inline-block;\n    font-size: $font-size-11;\n    @include rounded(50px);\n}\n.badges{\n    font-size: $font-size-base;\n    font-weight: $font-weight-medium;\n    display: inline-block;\n    @include margin-padding(null, 5px 10px);\n    @include rounded(8px);\n    color: $white;\n    text-align: center;\n    min-width: 80px;\n    &.bg-lightgreen{\n        background:$success;\n    }\n    &.bg-lightred{\n        background:$danger-700;\n    }\n    &.bg-lightyellow{\n        background:$warning;\n    }\n    &.bg-lightpurple{\n        background: rgba(115, 103, 240, 1);\n    }\n    &.bg-lightgrey{\n        background: $gray-600;\n    }\n    &.unstatus-badge {\n        background-color: $danger;\n    }\n    &.status-badge {\n        background-color: $success;\n    }\n}\n.badge-bgsuccess {\n    border-radius: 5px;\n    background: $success;\n    padding: 3px 10px;\n    font-size: $font-size-14;\n}\n.badge-bgdanger {\n    border-radius: 5px;\n    background: $danger;\n    padding: 3px 19px;\n    font-size: $font-size-14;\n}\n.badges.order-badge {\n    border-radius: 5px;\n    background: $warning;\n    padding: 1px 10px;\n}\n.badge-linesuccess,.badges-success {\n    color: $success;\n    @include margin-padding(null, 5px 10px);\n    @include rounded(8px);\n    border: 1px solid $success;\n    font-size: $font-size-base;\n   \n}\n.badge-linedanger,.badge-linedangered {\n    color: $danger;\n    @include margin-padding(null, 5px 10px);\n    @include rounded(8px);\n    border: 1px solid $danger;\n    font-size: $font-size-base;\n   \n       \n}\nspan {\n    &.badge {\n        &.badges-warning {\n            @include margin-padding(null, 5px 10px);\n        }\n    }\n\n}\n.add-icon {\n    span,a {\n        width: 40px;\n        height: 40px;\n        background: $primary;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        @include rounded(5px);\n        @include respond-below(custom575) {\n            position: relative;\n            left: -5px;\n            z-index: 10000;\n        }\n    }\n    .choose-add {\n        width: 40px;\n        height: 40px;\n        border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n        background: $secondary;\n        @include rounded(8px);\n        @include respond-below(custom575) {\n            position: relative;\n            left: -5px;\n            z-index: 10000;\n        }\n        .plus {\n            color: $white;\n            width: 16px;\n            height: 16px;\n        }\n    }\n    a:hover{\n        background: $title-color;\n    }\n}\n.cal-icon{\n    background-image: url(../../../../public/assets/img/icons/calendars.svg);\n    background-repeat: no-repeat;\n    background-position: 95% 50%;\n}\n.calc-no {\n    background: $light;\n    border: 0 !important;\n}\n.total-order {\n    max-width: 430px;\n    width: 100%;\n    @include margin-padding(30px 30px 30px auto, null);\n    ul {\n        @include margin-padding(0,0);\n        li {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            border: 1px solid $light;\n            border-top: 0;\n            h4 {\n                width: 50%;\n                color: $gray-600;\n                font-size: $font-size-base;\n                font-weight: $font-weight-medium;\n                @include margin-padding(null, 10px);\n                border-right: 1px solid  $light;\n                background: $body-bg;\n            }\n            h5 {\n                color:$text-color;\n                font-size: $font-size-base;\n                @include margin-padding(null, 10px);\n                font-weight: $font-weight-normal;\n                text-align: right;\n                width: 50%;\n            }\n            &:first-child {\n                border-top: 1px solid $light;\n            }\n            &.total h5 {\n                color: $secondary;\n                font-weight: $font-weight-bold;\n            }\n            &.total h4 {\n                color: $gray-700;\n                font-weight: $font-weight-bold;\n            }\n        }\n    }\n}\n.card-sales-split {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    padding-bottom: 25px;\n    border-bottom:1px solid $gray-300;\n    @include respond-below(custom991) {\n        padding-bottom: 10px;\n    }\n    @include respond-below(custom575) {\n        flex-direction: column;\n        ul{\n            margin-top: 15px;\n        }\n    }\n    h2 {\n        font-size: $font-size-base;\n        font-weight: $font-weight-semibold;\n    }\n    ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n    }\n    li {\n        margin: 0 15px;\n    }\n}\n.image-upload-new{\n    min-height: 258px;\n    .productviewscontent{\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        text-align: left;\n        margin-top: 15px;\n        .productviewsname{\n           h2{\n            font-weight: $font-weight-medium;\n            font-size: $font-size-base;\n            color: $black;\n           }\n           h3 {\n            color: $secondary;\n            font-size: $font-size-13;\n            font-weight: $font-weight-normal;\n            }\n        }\n        a {\n            width: 22px;\n            height: 22px;\n            color: $danger-700;\n            font-weight: $font-weight-bold;\n            @include rounded(50px);\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            font-size: $font-size-18;\n            &:hover{\n                background: $danger-700;\n                color: $white;\n            }\n        }\n    }\n    .productviews{\n        width: 100%;\n        @include margin-padding(null, 0 10px);\n    }\n}\n.uploadedimage{\n    .image-uploads{\n        max-width: 100%;\n    }\n}\n.productviewset {\n    padding-left: 18px;\n    position: relative;\n    .productviewsimg{\n        max-width: 94px;\n    }\n    .productviewscontent a{\n        background: $white;\n        width: 25px;\n        height: 25px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        @include rounded(5px);\n        @include position(absolute,4px,null,null,82px);\n    }\n}",".profile-set{\n    margin-bottom: 30px;\n    .profile-head {\n        height: 109px;\n        background: linear-gradient(90deg, $danger-700 0%, $primary 100%);\n        @include rounded(0 10px 0 0);\n        @include respond-below(custom991) {\n            @include rounded(10px);\n        }\n    }\n    .profile-top {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        @include respond-below(custom767) {\n            flex-direction: column;\n        }\n        .profile-content {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            @include respond-below(custom767) {\n                flex-direction: column;\n            }\n        }\n        .profile-contentimg {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            margin-top: -40px;\n            width: 130px;\n            position: relative;\n            border: 10px solid $white;\n            @include rounded(50%);\n            box-shadow: 0px 4px 4px 0px #00000040;\n            img {\n                @include rounded(50px);\n            }\n        }\n        .profileupload {\n            input[type=\"file\"] {\n                opacity: 0;\n                width: 34px;\n                height: 34px;\n                display: block;\n                z-index: 9;\n                cursor: pointer;\n                @include position(absolute,null,null,10px,42px);\n            }\n            a {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                background: $primary;\n                width: 34px;\n                height: 34px;\n                z-index:1;\n                @include rounded(50px);\n                @include position(absolute,null,null,10px,41px);\n            }\n        }\n        .profile-contentname {\n            padding-left: 20px;\n            @include respond-below(custom767) {\n                text-align: center;\n                @include margin-padding(null, 20px 0 20px 0);\n            }\n            h2 {\n                font-size: $font-size-18;\n                color: $secondary;\n                font-weight: $font-weight-bold;\n            }\n            h4 {\n                color: #777;\n                font-size: $font-size-base;\n            }\n        }\n    }\n}\n.pass-group {\n    position: relative;\n    .toggle-password,\n    .toggle-passworda {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        transform: translateY(-50%);\n        cursor: pointer;\n        width: 30px;\n        height: 30px;\n        color: $gray-600;\n        font-size: $font-size-base;\n        @include rounded(50%);\n        @include position(absolute,50%,10px,null,null);\n    }\n}\n",".table-tab {\n    ul {\n        margin-bottom: 24px;\n        li {\n            margin-right: 10px;\n            &:last-child {\n                margin-right: 0;\n            }\n            button.nav-link {\n                font-weight: $font-weight-bold;\n                padding: 10px;\n                line-height: normal;\n                color: $secondary;\n                background-color: $gray-400;\n                &.active {\n                    background-color: $primary;\n                    color: $white;\n                }\n            }\n        }\n    }\n    .nav-pills {\n        @include respond-below(custom575) {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n        }\n    }\n}\n.badge {\n    &.badge-bgdanger {\n        background-color: rgba(255, 0, 0, 0.06);\n        color: $danger;\n        padding: 5px 10px;\n    }\n}\nbutton.swal2-styled.swal2-confirm {\n    background-color: $primary;\n    &:hover {\n        background-color: $secondary\n    }\n}\ntable {\n    tbody {\n        td {\n            &.action-table-data {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                a {\n                    height: 31px;\n                    width: 31px;\n                    border: 1px solid rgba(145, 158, 171, 0.30);\n\t\t\t\t\tbackground-color: $white;\n                    border-radius: 8px;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    padding: 8px;\n                    .feather-edit {\n                        color: $blue;\n                        width: 14px;\n                        height: 14px;\n                    }\n                    .action-edit {\n                       color: $text-color;\n                       width: 14px;\n                        height: 14px;\n                    }\n                    .feather-trash-2 {\n                        color: $danger;\n                        width: 14px;\n                        height: 14px;\n                    }\n                    .feather-eye {\n                        width: 14px;\n                        height: 14px;\n                    }\n                    .action-download {\n                        color: $blue;\n                        width: 14px;\n                        height: 14px;\n                        \n                    }\n                    .action-eye {\n                        color: $secondary;\n                        width: 14px;\n                        height: 14px;\n                    }\n                }\n               \n            }\n        }\n        .productimgname {\n            min-width: 200px;\n            a {\n                &.stock-img.product-img {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    margin-right: 8px;\n                    img {\n                        width: 50px;\n                        height: 50px;\n                        max-width: 100%;\n                        margin-right: 0;\n                    }\n                }\n            }\n        }\n    }\n    .edit-delete-action {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        height: 50px;\n        a {\n            padding: 0;\n        }\n\n    }\n    .edit-delete-action.data-view {\n        min-height: 52px;\n    }\n    .edit-delete-action.data-row {\n        height: auto;\n    }\n    .edit-delete-action.data {\n        height: 44px;\n    }\n}\n.table-top-head {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    &.low-stock-top-head {\n        @include respond-below(custom575) {\n            flex-wrap: wrap;  \n           justify-content: start;\n        }\n        li {\n            margin-bottom: 10px;\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n    li {\n        margin-right: 10px;\n        flex-shrink: 0;\n        &:last-child {\n            margin-right: 0;\n        }\n        #collapse-header {\n            margin-right: 0;\n            @include respond-below(custom991) {\n                display: none;\n            }\n        }\n        a {\n            height: 38px;\n            width: 38px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $gray-300;\n            background: $white;\n            border-radius: 8px;\n            padding: 6px;\n            font-size: 18px;\n            svg {\n                height: 20px;\n            }\n            &:hover {\n                background: #e3e3e3;\n            }\n            label {\n                margin-right: 10px;\n            }\n            &.btn-secondary {\n                background-color: $secondary;\n                color: $white;\n                padding: 10px;\n                font-weight: $font-weight-bold;\n                font-size: $font-size-base;\n                &:hover {\n                    background-color: $primary;\n                }\n                svg {\n                    width: 16px;\n                    margin-right: 5px;\n                    color: $white;\n                }\n                @include respond-below(custom767) {\n                    padding: 5px;\n                    font-size: $font-size-base;\n                }\n            }\n            .action-edit.sales-action {\n                color: $blue;\n            }\n        }\n        .status-toggle {\n            height: 38px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            border: 1px solid $gray-100;\n            background: $white;\n            border-radius: 8px;\n            padding: 6px 10px;\n            label {\n                margin-right: 10px;\n            }\n        }\n    }\n}\n.custom-modal-header {\n   background: $body-bg;\n   padding: 24px;\n   .page-title {\n    h4 {\n        font-size: $font-size-18;\n        font-weight: $font-weight-bold;\n        color: $secondary;\n    }\n   }\n}\n.custom-modal-body {\n    padding: 24px;\n    .input-blocks {\n        margin-right: 0;\n    }\n    label {\n        font-size: $font-size-15;\n        font-weight: $font-weight-normal;\n    }\n}\n.status-label {\n    color: #212B36;\n}\n.modal-footer-btn {\n    margin-top: 40px;\n    text-align: right;\n    a {\n        min-width: auto;\n        @include respond-below(custom575) {\n            padding: 10px 10px;\n        }\n    }\n}\n.status-toggle.modal-status label{\n    height: 15px;\n    width: 32px;\n    background-color: #B9B9C3;\n    margin-bottom: 0;\n}\n.status-toggle.modal-status label::after {\n    top: 7px;\n}\ntd {\n    p {\n        &.description-para {\n            max-width: 400px;\n            white-space: break-spaces;\n        }\n    }\n}\n.form-sort {\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        padding-left: 35px;\n    }\n    span.select2-container.select2-container--default.select2-container--open {\n        z-index: 99;\n    }\n}\n#filter_inputs {\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        padding-left: 35px;\n    }\n    input {\n        padding-left: 35px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n    }\n    span.select2-container.select2-container--default.select2-container--open {\n        z-index: 98;\n    }\n}\n#filter_inputs1 {\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        padding-left: 35px;\n    }\n    input {\n        padding-left: 35px;\n    }\n    span.select2-container.select2-container--default.select2-container--open {\n        z-index: 98;\n    }\n}\n#filter_inputs2 {\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        padding-left: 35px;\n    }\n    input {\n        padding-left: 35px;\n    }\n    span.select2-container.select2-container--default.select2-container--open {\n        z-index: 98;\n    }\n}\n.summer-description-box {\n    .card .card-header {\n        padding: 8px;\n        border-bottom: 1px solid rgba(145, 158, 171, 0.32);\n    }\n    .note-editor {\n        border: 1px solid rgba(145, 158, 171, 0.32);\n    }\n    .note-editable {\n        height: 150px !important;\n    }\n    .note-resizebar {\n        display: none;\n    }\n}\n.table tbody {\n    td {\n        a {\n            &.view-note {\n                color: $blue;\n                font-weight: $font-weight-bold;\n            }\n        }\n    }\n}\n\n.userimgname {\n    .product-img {\n        display: inherit;\n        width: 35px;\n        height: 35px;\n        margin-right: 8px;\n    }\n}\n.modal-body-table {\n    background-color: #F6F7F8;\n    padding: 24px;\n    margin-bottom: 20px;\n    border-radius: 8px;\n}\n.product-quantity {\n    border:1px solid $gray-400;\n    background-color: $body-bg;\n    width: 105px;\n    height: 40px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    border-radius: 8px;\n    input {\n        width: 35px;\n        border: 0;\n        background-color: $body-bg;\n        text-align: center;\n\t\theight: 35px !important;\n    }\n    span {\n        color: $secondary;\n        font-size: 0;\n        cursor: pointer;\n        .plus-circle-qty {\n            width: 20px;\n            height: 20px;\n        }\n        .feather-search-qty {\n            width: 20px;\n            height: 20px;\n        }\n    }\n}\n.modal-dialog.stock-adjust-modal {\n    max-width: 800px;\n    .dataTables_length,.dataTables_info,.dataTables_paginate {\n        display: none;\n    }\n}\n.input-blocks.search-form {\n    input {\n        padding-left: 30px;\n    }\n    svg {\n        position: absolute;\n        left: 10px;\n        top: 37px;\n        width: 15px;\n    }\n}\n.badge badge-linedanger {\n    background-color: rgba(255, 0, 0, 0.06);\n    color: $danger;\n    border-radius: 8px;\n    padding: 4px 10px;\n    font-size: $font-size-base;\n}\n.input-groupicon.calender-input input {\n    padding-left: 27px;\n}\nspan {\n    &.customer-toggle {\n        color: $secondary;\n    }\n}\nspan {\n    &.unlimited-text {\n        color: $text-color;\n        margin-top: 5px;\n        display: inline-block;\n    }\n}\n.modal-title-head {\n    h6 {\n        font-size: $font-size-16;\n        display: flex;\n        align-items: center;\n        margin-bottom: 20px;\n        svg {\n            width: 15px;\n            color: $primary;\n            margin-right: 5px;\n        }\n    }\n}\n#phone,#phone2,#phone3 {\n    padding-left: 50px;\n}\n.total-employees {\n    background-color: $body-bg;\n    padding: 10px 8px;\n    margin-right: 24px;\n    border-radius: 8px;\n    h6 {\n        font-size: $font-size-base;\n        color: $secondary;\n        font-weight: $font-weight-bold;\n        display: flex;\n        align-items: center;\n        \n        svg {\n            width: 15px;\n            margin-right: 5px;\n        }\n        span {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            font-size: $font-size-10;\n            width: 18px;\n            height: 18px;\n            background-color: $danger;\n            color: $white;\n            border-radius: 50%;\n            margin-left: 5px;\n        }\n    }\n}\n.search-path.search-path-new {\n    .btn-list,.btn-grid {\n        width: 36px;\n        height: 36px;\n        background-color: $body-bg;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        color: $secondary;\n        margin-right: 15px;\n        border-radius: 8px;\n        &.active {\n            background-color: $primary;\n            color: $white;\n            &:hover {\n                background-color: $secondary;\n                color: $white;\n            }\n        } \n        svg {\n            width: 18px;\n            height: 18px;\n        }\n        &:hover {\n            background-color: $primary;\n            color: $white;\n        }\n    }\n    .form-sort {\n        @include respond-below(custom575) {\n            margin-top: 0;\n        }\n    }\n}\n.layout-box {\n    width: 36px;\n    height: 36px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    background: $primary;\n    color: $white;\n    border-radius: 8px;\n    &:hover {\n        background-color: $secondary;\n        color: $white;\n    }\n}\ntd {\n    span {\n        &.emp-team {\n            display: block;\n            line-height: normal;\n        }\n    }\n}\n.badges-inactive {\n    border: 1px solid $danger;\n    color: $danger;\n    padding: 2px 10px;\n    font-size: $font-size-14;\n    font-weight: $font-weight-semibold;\n    border-radius: 8px;\n}\n.success-email-send.modal-body {\n    padding: 24px;\n    span {\n        svg {\n            width: 40px;\n            height: 40px;\n            color: $success;\n            margin-bottom: 20px;\n        }\n    }\n    h4 {\n        font-size: $font-size-20;\n        font-weight: $font-weight-bold;\n        margin-bottom: 5px;\n    }\n    p {\n        font-size: $font-size-15;\n    }\n    a.btn {\n        padding: 10px 20px;\n    }\n}\n.layout-drop-item {\n    width: 350px;\n    max-height: 400px;\n    overflow-y: scroll;\n    padding: 20px;\n    box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\n    background: $white;\n    border-radius: 8px;\n    position: absolute;\n    right: 0;\n    margin-top: 10px;\n    z-index: 101;\n    display: none;\n    .drop-item-head {\n        border-bottom: 1px solid rgba(145, 158, 171, 0.30);\n        @include margin-padding(0 0 20px, 0 0 20px);\n        h5 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            margin-bottom: 10px;\n        }\n        p {\n            font-size: $font-size-base;\n        }\n    }\n    ul {\n        li {\n            margin-bottom: 20px;\n            span {\n                display: flex;\n                align-items: center;\n                svg {\n                    width: 16px;\n                    margin-right: 5px;\n                }\n            }\n            &:last-child {\n                margin-bottom: 0;\n            }\n        }\n    }\n}\n.layout-hide-box {\n    position: relative;\n}\n.layout-show-box {\n    .layout-drop-item {\n        display: block;\n    }\n}\n.table-top {\n    &.table-top-new {\n        @include respond-below(custom767) {\n            flex-direction: column;\n            align-items: self-start;\n        }\n        .search-path {\n            margin-left: 0;\n            @include respond-below(custom767) {\n                margin-top: 24px;\n            }\n            @include respond-below(custom575) {\n                flex-direction: column;\n                align-items: self-start;\n               \n            }\n            .form-sort {\n                @include respond-below(custom575) {\n                    margin-top: 20px;\n                }\n            }\n        }\n        .search-set {\n            @include respond-below(custom767) {\n                flex-direction: column;\n                align-items: flex-start;\n                .total-employees {\n                    margin: 0 0 20px 0;\n                }\n            }\n        }\n    }\n}\n.badge-applied {\n    background-color: $purple;\n    padding: 2px 10px;\n    color: $white;\n    border-radius: 5px;\n}\n.badge-approved {\n    background-color: $success;\n    padding: 2px 10px;\n    color: $white;\n    border-radius: 5px;\n}\n.badge-reject {\n    background-color: $danger;\n    padding: 2px 10px;\n    color: $white;\n    border-radius: 5px;\n}\n.table tbody tr td a.reason-for-reject {\n    color: $blue;\n    font-weight: $font-weight-semibold;\n}\n.note-editor.note-frame.card {\n    margin-bottom: 0;\n}\ntable tbody td.action-table-data a.cancel-circle {\n    border: 0;\n    padding: 0;\n    svg {\n        color: $primary;\n    }\n    &:hover {\n        background-color: transparent;\n        svg {\n            color: $danger !important;\n        }\n    }\n}\n.apply-leave {\n    background-color: $body-bg;\n    border-radius: 8px;\n    .leave-apply {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        padding: 10px;\n        @include respond-below(custom575) {\n            flex-direction: column;\n            align-items: flex-start;\n        }\n        .leave-date {\n            margin-right: 70px;\n            span {\n                color: $text-color;\n            }\n            p {\n                color: $secondary;\n            }\n            @include respond-below(custom575) {\n                margin-right: 0;\n                margin-bottom: 20px;\n            }\n        }\n        .leave-time {\n            width: 175px;\n        }\n    }\n}\n.input-blocks {\n    .bootstrap-tagsinput {\n        width: 100%;\n        padding: 0 .75rem;\n        box-shadow: none;\n        line-height: 40px;\n        .tag {\n            background-color: $gray-300;\n            color: $secondary;\n            padding: 3px 10px;\n            border-radius: 4px;\n            position: relative;\n            z-index: 1;\n            .remove {\n                &::after {\n                    color: $text-color;\n                }\n            }\n        }\n        input {\n            position: static;\n            width: auto;\n            border: none;\n        }\n    }\n    span.tag-text {\n        color: $text-color;\n        font-size: $font-size-13;\n    }\n}\n.table tbody tr td .sales-dropdown-list a {\n    padding: 10px 20px;\n}\n.no-pagination {\n    .pagination {\n        display: none;\n    }\n}\n#collapse-header.active {\n    background-color: $primary;\n    border-color: unset;\n    svg {\n        color: $white;\n        transform: rotate(180deg);\n        -webkit-transform: rotate(180deg);\n        -ms-transform: rotate(180deg);\n    }\n    &:hover {\n        svg {\n            color: $white;\n        }\n    }\n}\n.edit-delete-action {\n    a {\n        &:hover {\n            background-color: rgb(40, 142, 199);\n            border-color: rgb(40, 142, 199);\n            svg {\n                color: $white !important;\n            }\n        }\n        &.confirm-text {\n            &:hover {\n                background-color: $danger;\n                border-color: $danger;\n            }\n        }\n        &.edit-icon{\n            &:hover {\n                background-color:$secondary;\n                border-color: $secondary;\n            }\n        }\n    }\n}\n.modal {\n    table.table {\n        thead>tr>th.sorting:before {\n            display: none !important;\n        }\n        thead>tr>th.sorting:after {\n            display: none !important;\n        }\n    }\n}\n.profit-head {\n    .input-blocks {\n        .info-img {\n            color: $secondary;\n        }\n        input {\n            padding-left: 35px;\n        }\n    }\n}\n.profile-pic-upload .profile-pic.brand-pic {\n    width: 110px;\n    height: 105px;\n    position: relative;\n    .remove-photo {\n        position: absolute;\n        right: 8px;\n        top: 10px;\n        background: $danger;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 18px;\n        height: 18px;\n        border-radius: 4px;\n        svg {\n            color: $white;\n            width: 14px;\n            height: 14px;\n        }\n    }\n}\n.sales-details-items {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    margin-bottom: 20px;\n    @include respond-below(custom767) {\n        flex-direction: column;\n        align-items: start;\n    }\n    .details-item {\n        @include respond-below(custom767) {\n            margin-bottom: 20px;\n        }\n        h6 {\n            margin-bottom: 15px;\n            font-size: $font-size-15;\n            color: $secondary;\n        }\n        p {\n            font-size: $font-size-base;\n            color: $text-color;\n        }\n        h5 {\n            color: $success;\n            font-size: $font-size-15;\n            span {\n                display: block;\n                color: $text-color;\n            }\n        }\n    }\n}\n.order-text {\n    color: $secondary;\n    font-weight: $font-weight-semibold;\n    font-size: $font-size-base;\n    margin-bottom: 15px;\n}\n.profile-head-action {\n    .badge-linesuccess {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        padding: 3px 10px;\n        height: 24px;\n    }\n    .badge-linedanger {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        padding: 3px 10px;\n        height: 24px;\n    }\n}",".user{\n    &.product-list{\n        align-items: center;\n        .emping{\n            &.d-flex{\n            align-items: center; \n        a {\n        img{\n            border-radius: 6px;\n            margin-right: 8px;\n        }\n    }\n    }\n    }\n    }\n}\n.war-add #phone {\n    height: 38px;\n}\n.war-edit-phone #phone2, .war-edit-phone #phone3 {\n    height: 38px;\n}\n.user.product-list a img{\n    border-radius: 6px;\n    margin-right: 8px;\n}\n.user.user.product-list .emping a{\n    align-items: center;\n}\n.modal.show .modal-dialog.purchase{\n  max-width: 1140px;\n}\n.page-header .btn-added.color{\n    background-color: $secondary;\n    &:hover{\n        background-color: $primary;\n        color: $white;\n    }\n}\n.input-blocks.download{\n    float: right;\n}\n.feather-plus-circles{\n    color: $white;\n}\n.add-icon.plus a{\n    color:$secondary ;\n}\n.import-btn{\n    float: right;\n    margin-bottom: 20px;\n}\n.image-upload.download input[type=file] {\n    height: 150px;\n}\n.image-upload.download{\n    border-radius: 5px;\nborder: 1px dashed var(--Subtitle, #B8BCC9);\nmargin-bottom: 0;\n}\n.modal-footer-btn.download-file{\n    margin-top: 0;\n    margin-bottom: 15px;\n}",".main-wrappers{\n    background-color: $body-bg;\n    &.pos-page{\n        .sidebar{\n            display: none;\n            @include respond-below(custom991) {\n                display: block;                \n            }\n        }\n        #toggle_btn{\n            display: none;\n        }\n    }\n}\n.menu-opened{\n    .pos-page{\n        &.slide-nav{\n            .sidebar{\n                margin-left: 0;\n            }    \n        }\n        .sidebar{\n            margin-left: -100%;\n        }    \n    }\n}\n.product-view {\n    width: 100%;\n    border: 1px solid $gray-300;\n    margin-bottom: 20px;\n    &:hover{\n        border: 1px solid $primary; \n    }\n    .product-viewimg {\n        position: relative;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        max-height: 120px;\n        overflow: hidden;\n        h6 {\n            background: $success;\n            color: $white;\n            font-size: $font-size-8;\n            font-weight: $font-weight-semibold;\n            @include margin-padding(null, 3px);\n            @include position(absolute,null,null,0,0);\n        }\n    }\n    .product-viewcontent {\n        @include margin-padding(null, 13px);\n        h3 {\n            font-size: $font-size-base;\n            color: $black;\n            font-weight: $font-weight-medium;\n        }\n        h4 {\n            font-size: $font-size-12;\n            color: $gray-600;\n            font-weight: $font-weight-medium;\n            margin-bottom: 5px;\n        }\n        h5 {\n            font-size: $font-size-base;\n            color: $gray-600;\n            font-weight: $font-weight-medium;\n        }\n    }\n}\n.main-set{\n    @include margin-padding(null, 0 30px);\n    @include respond-below(custom991) {\n        @include margin-padding(null, 0 10px);\n    }\n}\n.text-underline {\n    position: relative;\n    &::after {\n        content: \"\";\n        background: $gray-600;\n        width: 10px;\n        height: 2px;\n        @include position(absolute,null,null,12px,10px);\n    }\n}\n.select-split{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    margin-bottom: 20px;\n    .select-group{\n        width:calc(100% - 55px)\n    }\n    .btn-filters {\n        width: 40px;\n        height: 40px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        @include margin-padding(0 0 0 15px, 0);\n    }\n    .select2-container--default {\n        .select2-selection--single {\n            background-color: $white;\n            border: 1px solid $gray-300;\n            height: 40px;\n            @include rounded(4px);\n            .select2-selection__rendered{\n                line-height: 40px;\n            }\n            .select2-selection__arrow{\n                height: 40px;\n            }\n        }\n    }\n}\n.table{\n    tr{\n        &:hover{\n            .productimg{\n                .productcontet{\n                    h4{\n                        img{\n                            opacity: 1;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n.table-product{\n    tr{\n        th{\n            font-weight: $font-weight-semibold;\n            color: $gray-600;\n            font-size: $font-size-base;\n        }\n        td{\n            font-weight: $font-weight-semibold;\n            color: $gray-600;\n            font-size: $font-size-base;\n        }\n    }\n}\n.btn-totallabel{\n    color: $white;\n    background: $purple;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    @include rounded(5px);\n    @include margin-padding(0 0 15px, 12px);\n    h5{\n        font-size: $font-size-base;\n        margin: 0;\n        font-weight: $font-weight-semibold;\n    }\n    h6{\n        margin: 0;\n        font-size: $font-size-base;\n        font-weight: $font-weight-semibold;\n    }\n}\n.setvaluecash{\n    margin: 0 0 15px 0;\n    ul{\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        li{\n            width: 33%;\n            margin-right: 10px;\n            &:last-child{\n                margin:0;\n            }\n            a{\n                border:1px solid $gray-300;\n                color: $black;\n                font-size: $font-size-base;\n                font-weight: $font-weight-semibold;\n                min-height: 95px;\n                @include rounded(5px);\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                -ms-flex-direction: column;\n                flex-direction: column;\n                @include margin-padding(null, 10px 20px);\n                &:hover{\n                    border: 1px solid $purple;\n                    color: $purple;\n                }\n                img{\n                    margin-bottom: 10px;\n                }\n            }\n        }\n    }\n}\n.setvalue{\n    padding: 15px 0;\n    ul{\n        li{\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            margin-bottom: 10px;\n            h5{\n                font-size: $font-size-13;\n                font-weight: $font-weight-medium;\n            }\n            h6{\n                font-size: $font-size-13;\n                font-weight: $font-weight-medium;\n            }\n            &.total-value{\n                h5{\n                    font-size: $font-size-16;\n                    font-weight: $font-weight-semibold;\n                    color: $purple;\n                }\n                h6{\n                    font-size: $font-size-16;\n                    font-weight: $font-weight-semibold;\n                    color: $purple;\n                }\n            }\n        }\n    }\n}\n.product-lists{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    border: 1px solid $body-bg;\n    box-shadow: 0px 4px 4px 0px #EDEDED40;\n    @include margin-padding(0 0 15px, 15px);\n    @include respond-below(sm) {\n        flex-direction: column;\n        li{\n            margin: 10px 0;\n        }\n    }\n}\n.increment-decrement {\n    .input-groups{\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        margin-top:10px;\n        input[type=\"button\"] {\n            background-color: transparent;\n            font-size: $font-size-20;\n            border: 1px solid $gray-500;\n            border-radius: 4px;\n            height: 20px;\n            width: 20px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin-top: 0px;\n            line-height: 0;\n            padding: 0;\n            color: $gray-500;\n        }\n    }\n    .quantity-field {\n        width: 30px;\n        text-align: center;\n        background-color: transparent;\n        float: left;\n        border: 0;\n    }\n}\n.productimg {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    .productimgs {\n        width: 82px;\n        margin-right: 13px;\n        img{\n            width: 82px;\n            height: 82px;\n            object-fit: cover;\n        }\n    }\n    .productcontet {\n        h4 {\n            font-size: $font-size-base;\n            color: $black;\n            font-weight: $font-weight-semibold;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin-bottom: 5px;\n            img{\n               opacity: 0;\n               margin-top:5px;\n               display: block;\n            }\n        }\n    }    \n    .productlinkset {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        h5 {\n            background:  $primary;\n            color: $white;\n            font-size: $font-size-12;\n            @include rounded(5px);\n            margin-right: 10px;\n            @include margin-padding(null,2px 10px);\n        }\n        a {\n            position: relative;\n            top: 2px;\n        }\n    }\n}\n.product-table {\n    height: 34vh;\n    overflow: auto;\n    @include respond-below(custom991) {\n        height: auto;\n    }\n}\n.btn-set{\n    @include margin-padding(15px 0 25px, null);\n    h4{\n        font-weight: $font-weight-bold;\n    }\n}\n.product-detils {\n    height: 70vh;\n    overflow-y: auto;\n    overflow-x: hidden;\n    @include respond-below(custom991) {\n        height: auto;\n    }\n}\n.tab-set {\n    margin-bottom: 20px;\n    ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        li {\n            width: 48%;\n            text-align: center;\n            margin-right: 5px;\n            @include respond-below(custom575) {\n               width:100%;\n                margin-right: 0;\n            }\n            &:last-child {\n                margin: 0;\n                width: 50%;\n                @include respond-below(custom575) {\n                   width:100%;\n                }\n            }\n            a {\n                background: $gray-700;\n                width: 100%;\n                display: block;\n                color: $white;\n                font-weight: $font-weight-semibold;\n                @include rounded(5px);\n                @include margin-padding(null, 10px);\n                @include respond-below(custom575) {\n                    @include rounded(0);\n                }\n            }\n            &.active {\n                a {\n                    background:  $primary;\n                }\n            }\n        }\n    }\n}\n#delete{\n    .modal-body{\n        .btn{\n            min-width: 100px;\n            @include margin-padding(null, 10px);\n        }\n    }\n}\n.owl-product{\n    padding-top: 35px;\n    .owl-nav {\n        margin-top: 10px;\n        @include position(absolute,-10px,0,null,null);\n        button{\n            border-radius: 50px !important;\n            width: 20px;\n            height: 20px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            width: 19px;\n            position: relative;\n            height: 19px;\n            background: $white !important;\n            color: $purple !important;\n            span{\n                font-size: 0;\n            }\n            &.owl-next {\n                span:before {\n                    @include position(absolute,2px,5px,null,null);\n                    content: \"\\f054\";\n                    font-family: \"Font Awesome 5 Free\";\n                    font-style: normal;\n                    font-weight: 900;\n                    font-size: 10px;\n                    color: #1A54C7;\n                }\n            }\n            &.owl-prev {\n                span:before {\n                    content: \"\\f053\";\n                    font-family: \"Font Awesome 5 Free\";\n                    font-style: normal;\n                    font-weight: 900;\n                    font-size: 10px;\n                    color: #1A54C7;\n                    @include position(absolute,2px,7px,null,null);\n                }\n            }\n            &:hover{\n                background: #1A54C7 !important;  \n                span:before{\n                    color: $white;\n                }\n            }\n        }\n    }\n    \n}\n.actionproduct{\n    text-align: right;\n    margin-bottom: 15px;\n    ul{\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: flex-end;\n        -webkit-justify-content: end;\n        -ms-flex-pack: end;\n        li{\n            margin-left: 10px;\n        }\n    }\n}\n.btn-pos {\n    ul {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        li{\n            margin-right: 1px;\n            margin-bottom: 10px;\n            @include respond-below(custom991) {\n                width: 48%;\n            }\n            @include respond-below(custom575) {\n                width: 100%;\n                margin-right: 10px;\n            }\n            a{\n                &.btn{\n                    color: #888B94;\n                    font-size: 10px;\n                    width: 100%;\n                    padding: 5px 12px;\n                    background: $gray-300;\n                    border-radius: 50px;\n                    border: 1px solid $gray-300;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    @include margin-padding(null, 5px 12px);\n                    @include respond-below(custom991) {\n                        min-width: auto;\n                        @include margin-padding(null, 6px 15px);\n                    }\n                    &:hover{\n                        border:1px solid #EA5455;\n                        color: #EA5455;\n                        background: rgba(234, 84, 85, 0.06);\n                    }\n                }\n                &.btn-hold{\n                    background: $warning;\n                } \n                &.btn-quation{\n                    background: $gray-600;\n                }   \n                &.btn-void{\n                    background: #D0512E;\n                } \n                &.btn-payment{\n                    background: $success ;\n                }   \n                &.btn-recent{\n                    background: $primary ;\n                }   \n            }\n        }\n    }\n}\n.calculator-set{\n    .calculatortotal {\n        margin-bottom: 15px;\n        h4 {\n            width: 100%;\n            background:  $primary;\n            text-align: center;\n            color: $white;\n            font-size: $font-size-36;\n            font-weight: $font-weight-bold;\n            @include rounded(5px);\n        }\n    }\n    ul{\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        li{\n            width: 33.3%;\n            text-align: center;\n            a{\n                width: 100%;\n                border:1px solid $gray-500;\n                font-size: $font-size-24;\n                font-weight: $font-weight-medium;\n                display: block;\n                color:$black;\n                @include rounded(0);\n                @include margin-padding(null, 10px);\n                &.btn-closes{\n                    background: $danger-700;\n                }\n                &.btn-reverse{\n                    background: #2E7D32;\n                }\n                &:hover{\n                    background: $gray-100;\n                }\n            }\n        }\n    }\n}\n.hold-order {\n    text-align: center;\n    @include margin-padding(15px 0, null);\n    h2 {\n        @include margin-padding(null, 0 0 30px);\n        color:  $primary;\n        font-size: $font-size-36;\n        font-weight: $font-weight-bold;\n    }\n}\n.para-set {\n    margin-bottom: 30px;\n    p {\n        color: $gray-700;\n        font-size: $font-size-13;\n        font-weight: $font-weight-medium;\n    }\n}\n.delete-order {\n    text-align: center;\n}\n.btn-set{\n    h4{\n        background:  $primary;\n        text-align: center;\n        color: $white;\n        @include rounded(5px);\n        @include margin-padding(null, 10px);\n    }\n}\n.header-menuset{\n    @include margin-padding(null, 15px);\n    ul{\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        li{\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            width: 50%;\n            margin-bottom: 10px;\n            @include respond-below(custom991) {\n                width: 100%;\n            }\n            .win-maximize{\n                display: none;\n            }\n            a{\n                border: 1px solid  $primary;\n                width: 95%;\n                text-align: center;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                background:  $primary;\n                color: $white;\n                @include margin-padding(null, 10px);\n                img{\n                    filter: brightness(0) invert(1);\n                }\n            }\n        }\n    }\n}\n.invoice-load-btn {\n    text-align: center;\n    margin-top: 20px;\n    .btn {\n        font-weight: $font-weight-bold;\n        font-size: $font-size-16;\n        color: $primary;\n        min-width: 150px;\n        background: $white;\n        border: 2px solid $primary;\n        display: -webkit-inline-box;\n        display: -ms-inline-flexbox;\n        display: inline-flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        @include rounded(6px);\n        @include margin-padding(null, 12px 15px);\n        span {\n            display: inline-block;\n            width: 25px;\n            height: 25px;\n            margin-right: 8px;\n            vertical-align: 0;\n            border: 3px solid #fc88037d;\n            border-right-color: $primary;\n            animation: .75s linear infinite spinner-border;\n            @include rounded(50%);\n        }\n        &:hover {\n            background: $primary;\n            color: $white;\n            span {\n                border: 3px solid $white;\n                border-right-color: $white;\n            }\n        }\n    }\n}\n.form-new{\n    .input-blocks{\n        input{\n            height: 50px;\n            background: $light;\n        }\n        .scanner-set{\n            min-width: 50px;\n            @include position(relative,null,null,null,-2px);\n        }\n    }\n}\n.product-details{\n    background: $white;\n    border-radius: 5px;\n    padding: 10px;\n    box-shadow: 0px 4px 4px 0px #EDEDED40;\n    border:1px solid #F8F8F8 !important;\n    height: 105px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    flex-direction: column;\n    &:hover{\n        background:$purple;\n        h6{\n            color: $white;\n        }\n    }\n    &.active{\n        background-color:$purple !important;\n        h6{\n            color: $white;\n        }\n    }\n    img{\n        width: auto !important;\n    }\n    h6{\n        font-size: $font-size-13;\n        color: $black;\n        margin-top: 10px;\n    }\n}\n.btn-scanner-set {\n    background: $purple;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    max-width: 160px;\n    margin-left: auto;\n    color: $white;\n    font-size: $font-size-base;\n    font-weight: $font-weight-bold;\n    &:hover{\n        background: $primary;\n        color: $white;\n    }\n}\n.split-card {\n    margin: 0 0 15px;\n    border: 1px dashed $body-bg;\n    position: relative;\n    &::before{\n        position: absolute;\n        content:\"\";\n        background: $body-bg;\n        width: 22px;\n        height: 22px;\n        border-radius: 50px;\n        top: -10px;\n        left: -10px;\n    }\n    &::after{\n        position: absolute;\n        content:\"\";\n        background: $body-bg;\n        width: 22px;\n        height: 22px;\n        border-radius: 50px;\n        top: -10px;\n        right: -10px;\n    }\n}\n.totalitem{\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    margin-bottom: 15px;\n    h4{\n        padding: 7px 13px;\n        background: #F8F8F8;\n        color: $purple;\n        font-size: 12px;\n        font-weight: $font-weight-bold;\n        border-radius: 50px;\n    }\n    a{\n        font-size: $font-size-base;\n        color: #EA5455;\n        font-weight: $font-weight-bold;\n    }\n}\n.card{\n    &.card-order{\n        border: 0;\n    }\n}\n.btn-adds{\n    border: 2px solid $success;\n    color: $success;\n    width: 100%;\n    padding: 10px;\n    border-radius: 5px;\n    font-weight: $font-weight-semibold;\n    margin-bottom: 20px;\n    &:hover{\n        background: $success; \n        color: $white;\n    }\n}\n.order-list {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    margin-bottom: 25px;\n    .orderid{\n        h4{\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n            color: #5E5873;\n            margin-bottom: 0;\n        }\n        h5{\n            font-size: $font-size-base;\n            font-weight: $font-weight-normal;\n            color: $black;\n        }\n    }\n    .actionproducts{\n      >  ul{\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n          >  li{\n                margin-left: 15px;\n                .deletebg{\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                    background: $white;\n                    box-shadow: 0px 4px 14px 0px #C7C7C740;\n                    width: 30px;\n                    height: 30px;\n                    border-radius: 5px;\n                }\n            }\n       }\n    }\n}\n.tabs_wrapper{\n    .owl-product{\n        margin-bottom: 25px;\n    }\n}\n.productset{\n    border: 1px solid #F8F8F8;\n    box-shadow: 0px 4px 4px 0px #EDEDED40;\n    background: $white;\n    margin: 0 0 25px;\n    border-radius: 5px;\n    position: relative;\n    width: 100%;\n    overflow: hidden;\n    &:hover{\n        border:1px solid $purple;\n    }\n    .check-product{\n        display: none;\n        width: 34px;\n        height: 23px;\n        color: $white;\n        position: absolute;\n        left: 0;\n        top:0;\n        background: $purple;\n        border-radius: 4px 0;\n    }\n    &.active{\n        border:1px solid $purple;\n        .check-product{\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n        }   \n    }\n    &:hover{\n        .productsetimg{\n            img{\n                transform: scale(1.2);\n            }\n            h6{\n                transform: translatey(0); \n            }\n        }\n    }\n    .productsetimg{\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        position: relative;\n        overflow: hidden;\n        img{\n            transition: all 0.5s;\n            border-radius: 5px 5px 0px 0px;\n            @include respond-below(custom991) {\n                max-height: 150px;\n            }\n        }\n        h6{\n            position: absolute;\n            background: $primary;\n            color: $white;\n            font-size: 10px;\n            padding: 5px;\n            border-radius: 5px;\n            top: 20px;\n            right: 20px;\n            transform: translatey(-60px);\n            transition: all 0.5s;\n        }\n    }\n    .productsetcontent{\n        padding: 13px;\n        text-align: center;\n        h4{\n            font-size: $font-size-base;\n            font-weight: $font-weight-semibold;\n            color: $black;\n            margin-bottom: 13px;\n        }\n        h5{\n            color: #6E6B7B;\n            font-size: 12px;\n        }\n        h6{\n            color: #EA5455;\n            margin: 0 0 0 auto;\n            font-weight: $font-weight-semibold;\n            font-size: $font-size-base;\n        }\n    }\n}\n.tabs_wrapper{\n    ul.tabs{\n        display: inline-block;\n        width:100%;\n        padding-left:0;\n        li {\n            list-style:none;\n            cursor:pointer;\n            display: inline-block;\n            border-radius:5px;\n            color:white;\n            font-family: sans-serif;\n            width: 100%;\n            &.active{\n                background-color: $primary;\n                border-color: $primary;\n                h6 {\n                    a {\n                        color: $white;\n                    }\n                }\n                .product-details {\n                    background: transparent;\n                    border:0 !important;\n                    h6{\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n    .tabs_container{\n        padding-top:00px;\n        display: inline-block;\n        width:100%;\n        .tab_content{\n            display: none;\n            width: 100%;\n            &.active{\n                display: inline-block;\n            }\n        }\n    }\n}\n",".btn-icon {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n}\n.pos-design {\n    .btn-row {\n        padding: 24px;\n        a {\n            display: flex;\n            align-items: center;\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n    .pos-wrapper {\n        --bs-gutter-x: 0;\n    }\n}\n.btn-row {\n    @include respond-below(custom575) {\n        flex-direction: column;\n    }\n    .btn {\n        font-size: $font-size-base;\n        color:  $white;\n        @include margin-padding(0 10px 0 0, 10px);\n        @include rounded(4px);\n        @include respond-below(custom575) {\n            margin: 0 0 15px 0;\n            width: 100%;\n        }\n        &:last-child{\n            margin-bottom: 0;\n        }\n    }\n}\n.pos-categories, .order-list {\n    h5, h6 {\n        color: $secondary;\n    }\n    h5 {\n        font-size: $font-size-18;\n        font-weight: $font-weight-bold;\n    }\n}\n.btn-info {\n    background-color: $blue;\n    border-color: $blue;\n    &:hover {\n        background-color: $primary;\n        border-color: $primary;\n    }\n}\n.btn-primary {\n    background-color: $primary;\n    border-color: $primary;\n    &:hover {\n        background-color: $secondary;\n        border-color: $secondary;\n    }\n    @include respond-below(custom991)\n\t\t{\n\t\t\tmargin-top: 10px;\n\t\t\t\t}\n    @include respond-below(custom767)\n\t\t{\n\t\t\tmargin-top: 10px;\n\t\t\t\t}\n                @include respond-below(custom575)\n\t\t{\n\t\t\tmargin-top: 10px;\n\t\t\t\t}\n}\n.btn-secondary {\n    background-color: $secondary;\n    border-color: $secondary;\n    &:hover {\n        background-color: $primary;\n        border-color: $primary;\n    }\n}\n.btn-danger {\n    background-color: $danger;\n    border-color: $danger;\n    &:hover {\n        background-color: $secondary;\n        border-color: $secondary;\n    }\n}\n.btn-success {\n    background-color: $success;\n    border-color: $success;\n    &:hover {\n        background-color: $secondary;\n        border-color: $secondary;\n    }\n}\n.owl-carousel {\n    .owl-nav {\n        margin: 0;\n        @include position(absolute,-60px,0,null,null);\n        button {\n            margin-top: 0;\n            margin-bottom: 0;\n            &.owl-next, &.owl-prev {\n                position: relative;\n                width: 28px;\n                height: 28px;\n                @include rounded(28px);\n                i {\n                    color:  $primary;\n                }\n                &:hover {\n                    background-color: $secondary;\n                    border-color: $secondary;\n                }\n            }\n        }\n    }\n}\n.pos-categories {\n    background-color: $light;\n    padding: 24px;\n    border-collapse: collapse;\n}\n\n.pos-category {\n    margin-bottom: 24px;\n    height: 125px;\n    .owl-item {\n        background-color: $white;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n        text-align: center;\n        cursor: pointer;\n        border: 1px solid $gray-100;\n        box-shadow: $box-shadow;\n        @include transition(all 0.5s ease);\n        @include rounded(8px);\n        margin-left: -0.1px!important;\n        li {\n            padding: 15px 0;\n        }\n        a {\n            img {\n                @include transition(all 0.5s ease);\n                min-width:  40px;\n                width: 40px;\n                height: 40px;\n                margin: 0 auto;\n            }\n        }\n        h6 {\n            font-size: $font-size-15;\n            font-weight: $font-weight-semibold;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-top: 10px;\n            width: 100%;\n            margin-bottom: 5px;\n            a {\n                color: $secondary;\n            }\n        }\n        span {\n            color:  $text-color;\n        }\n        &:hover {\n            border-color: $primary;    \n            border-radius: 5px;\n            h6 {\n                a {\n                    color:  $primary;\n                }\n            }\n            a {\n                img {\n                    transform: scale(1.2);\n                }\n            }\n        }\n    }\n    .owl-nav {\n        button {\n            &.owl-next {\n                margin-left: 5px;\n            }\n            &.owl-prev { \n                margin-right: 5px;\n            }\n            &.owl-next, &.owl-prev {\n                background-color: $white;\n                border:  1px solid $gray-100;\n                i {\n                    color:  $secondary;\n                }\n                &:hover {\n                    background-color: $primary;\n                    border-color: $primary;\n                    i {\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n}\n.pos-products {\n    .product-info {\n        padding: 15px;\n        color:  $sub-title;\n        @include transition(all 0.5s ease);\n        .img-bg {\n            height: 117px;\n            background-color: $gray-100;\n            @include rounded(10px);\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            margin-bottom: 10px;\n            position: relative;\n            img {\n                @include transition(all 0.5s ease);\n            }\n            span {\n                @include transition(all 0.5s ease);\n                @include position(absolute,0,0,null,null);\n                width: 18px;\n                height: 18px;\n                @include rounded(100%);\n                background: $success;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                display: none;\n                svg {\n                    color: $white;\n                    @include position(absolute,1px,null,null,1px);\n                }\n            }\n        }\n        h6 {\n            font-size: $font-size-15;\n            font-weight: $font-weight-bold;\n            &.cat-name {\n                a {\n                    color: $sub-title;\n                }\n            }\n            &.product-name {\n                a {\n                    color: $secondary;\n                }\n            }\n        }\n        .price {\n            margin-top: 17px;\n            span {\n                color:  $purple;\n            }\n            p {\n                color: $primary;\n            }\n\n        }\n        &:hover, &.active {\n            border-color: $primary;\n            .img-bg {\n                img {\n                    transform: scale(1.2);\n                }\n                span {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n.product-wrap{ \n    height: 34vh;\n    overflow: auto;\n\n    .product-list {\n        box-shadow: $box-shadow;\n        @include margin-padding(0 0 10px 0, 10px);\n        .product-info {\n            width: 60%;\n            .img-bg {\n                width: 83px;\n                height: 83px;\n                background-color: $body-bg;\n                @include rounded(10px);\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                margin-right: 10px;\n            }\n\n        }\n        .info {\n            span {\n                background-color: $primary;\n                @include rounded(3px);\n                font-weight: $font-weight-semibold;\n                color: $white;\n                font-size: $font-size-base;\n                padding: 0 10px;\n                min-width: 64px;\n            }\n            h6 {\n                font-size: $font-size-base;\n                font-weight: $font-weight-bold;\n                margin-bottom: 0;\n                a {\n                    color: $secondary;\n                }\n            }\n            p {\n                font-size: $font-size-15;\n                font-weight: $font-weight-semibold;\n                color: $text-color;\n            }\n        }\n        .qty-item {\n            position: relative;\n            margin-right: 7px;\n            input {\n                padding: 1px 9px;\n                background: $body-bg;\n                @include rounded(8px);\n                height: 28px;\n                width: 71px;\n                text-align: center;\n                font-size: $font-size-base;\n            }\n            .dec, .inc {\n                position: absolute;\n                top: 50%;\n                @include transform(translateY(-50%));\n                color: $secondary;\n                @include transition(all 0.5s ease);\n                &:hover {\n                    color: $primary;\n                }\n            }\n            .dec {\n                left: 9px;\n            }\n            .inc {\n                right: 9px;\n            }\n        }\n        .action {\n            a {\n                padding: 7px;\n                @include rounded(8px);\n                border: 1px solid $gray-100;\n                cursor: pointer;\n                &.edit-icon {\n                    color: $blue;\n                    &:hover {\n                        background-color: $blue;\n                        border-color: $blue;\n                        color: $white;\n                    }\n                }\n                &.delete-icon {\n                    color: $danger;\n                    &:hover {\n                        background-color: $danger;\n                        border-color: $danger;\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n}\naside {\n    height: 100%;\n    padding: 24px;\n    background-color: $white;\n    border-left: 1px solid $gray-100;\n    &.product-order-list {\n        h6 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            margin-bottom: 20px;\n            color: $title-color;\n        }\n        .block-section {\n            @include margin-padding(20px 0 20px 0, 0 0 20px 0);\n            border-bottom: 1px solid $gray-100;\n        }\n        .head {\n            background-color: $body-bg;\n            @include rounded(8px);\n            padding: 10px;\n            h5 {\n                color: $secondary;\n                font-size: $font-size-18;\n                font-weight: $font-weight-bold;\n            }\n            span {\n                color: $text-color;\n                font-size: $font-size-15;\n                font-weight: $font-weight-medium;\n            }\n        }\n        .customer-info {\n            .input-block {\n                margin-bottom: 10px;\n                .btn {\n                    min-width: 40px;\n                    min-height: 40px;\n                    @include margin-padding(0 0 0 10px, 5px);\n                }\n            }\n        }\n        .product-added {\n            .head-text {\n                margin-bottom: 20px;\n                .trash {\n                    svg {\n                        margin-right: 8px;\n                    }\n                }\n            }\n            h6 {\n                .count {\n                    width: 15px;\n                    height: 15px;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    background: $primary;\n                    @include rounded(100%);\n                    color: $white;\n                    font-size: $font-size-10;\n                    font-weight: $font-weight-semibold;\n                    @include margin-padding(0 0 0 7px, null);\n                }\n            }\n        }\n        .selling-info {\n            margin-bottom: 24px;\n            .input-block {\n                label {\n                    margin-bottom: 5px;\n                }\n                .select2-container--default .select2-selection--single .select2-selection__rendered {\n                    @include rounded(5px);\n                    border-color: $navy;\n                }\n            }\n        }\n        .order-total{\n            background-color: $gray-100;\n            padding: 24px;\n            @include rounded(8px);\n            table {\n                tr {\n                    td {\n                        padding: 0 0 15px 0;\n                        color: $text-color;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-medium;\n                        background: transparent;\n                        &.danger {\n                            color: $danger;\n                        }\n                    }\n                    &:last-child {\n                        td {\n                            padding: 20px 0 0 0;\n                            font-size: $font-size-16;\n                            font-weight: $font-weight-semibold;\n                        }\n                    }\n                }\n            }\n\n        }\n        .payment-method {\n            .methods {\n                .item {\n                    padding: 0 7px;\n                    @include respond-below(custom991) {\n                        padding-bottom: 15px;\n                    }\n                }\n                .default-cover {\n                    @include transition(all 0.5s ease);\n                    a {\n                        box-shadow: $box-shadow-sm;\n                        @include margin-padding(null, 10px 15px);\n                        text-align: center;\n                        display: block;\n                        font-size: $font-size-15;\n                        color: $secondary;\n                        span {\n                            white-space: nowrap;\n                            text-overflow: ellipsis;\n                            overflow: hidden;\n                            display: block;\n                        }\n\n                    }\n                    &:hover {\n                        background-color: $gray-200;\n                        border-color: $primary;\n                        img {\n                            filter: invert(75%) sepia(66%) saturate(1955%) hue-rotate(327deg) brightness(103%) contrast(102%);\n                        }\n                    }\n                }\n            }\n        }\n        .btn-block {\n            @include margin-padding(20px 0 20px 0, 0 0 20px 0);\n            border-bottom: 1px solid $gray-100;\n            .btn {\n                font-size: $font-size-base;\n                font-weight: $font-weight-bold;\n                padding: 13px 10px;\n            }\n        }\n        .btn-row {\n            padding: 0;\n            .btn {\n                margin-right: 5px;\n                @include rounded(4px);\n                font-size: $font-size-base;\n                &.btn-info {\n                    background-color: $purple;\n                    border-color: $purple;\n                }\n                &.btn-danger {\n                    background-color: $danger;\n                    border-color: $danger;\n                }\n                &.btn-success {\n                    background-color: $success;\n                    border-color: $success;\n                }\n                &:hover {\n                    background-color: $secondary;\n                    border-color: $secondary;      \n                }\n            }\n        }\n    }\n}\n#payment-completed {\n    .modal-body {\n        padding: 40px;\n        .icon-head {\n            margin-bottom: 10px;\n            svg {\n                color: $success;\n            }\n        }\n        h4 {\n            font-size: $font-size-20;\n            font-weight: $font-weight-bold;\n        }\n        .modal-footer {\n            .btn {\n                &:hover {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n#print-receipt {\n    color:  $text-color;\n    .modal-dialog {\n        width: 424px;\n    }\n    .modal-body {\n        padding: 30px;\n        color: $text-color;\n        h6 {\n            font-size: $font-size-16;\n        }\n        .info {\n            h6 {\n                margin: 10px 0;\n                font-weight: normal;\n            }\n            a {\n                color: $text-color;\n            }\n        }\n        .tax-invoice {\n            h6 {\n                margin: 10px 0;\n                font-weight: $font-weight-semibold;\n                position: relative;\n                &:after, &:before {\n                    @include transform(translateY(-50%));\n                    content: \"\";\n                    border-top:  1px dashed $text-color;\n                    width: 35%;\n                }\n                &:before {\n                    @include position(absolute,50%,null,null,0);\n                }\n                &:after {\n                    @include position(absolute,50%,0,null,null);\n                }\n            }\n            .invoice-user-name {\n                margin-bottom: 10px;\n            }\n            span {\n                color: $secondary;\n            }\n        }\n        table {\n            thead {\n                th {\n                    color: $secondary;\n                    width: auto;\n                    min-width: auto;\n                    padding: 5px;\n                    border-top: 1px dashed $text-color;\n                    border-bottom: 1px dashed $text-color;\n                }\n            }\n            tbody{ \n\n                tr {\n                    td {\n                        padding: 5px;\n                    }\n                    table {\n                        border-top: 1px dashed $text-color;\n                        tr {\n                            &:last-child {\n                                td {\n                                    font-weight: $font-weight-medium;\n                                    font-size: $font-size-15;\n                                    color: $secondary;\n                                }\n                            }\n                        }    \n                    }\n                }\n            }\n        }\n        .invoice-bar {\n            border-top: 1px dashed $text-color;\n            @include margin-padding(null, 20px 0 0 0);\n        }\n        .btn {\n            width: 200px;\n        }\n    }\n}\n.pos-modal {\n    .modal-header {\n        background-color: $body-bg;\n        h5 {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n        }\n    }\n    &#hold-order {\n        h2 {\n            font-size: $font-size-36;\n            font-weight: $font-weight-bold;\n            color: $gray-900;\n            margin-bottom: 10px;\n            background-color: $body-bg;\n            @include rounded(10px);\n        }\n        .input-block {\n            label {\n                margin-bottom: 5px;\n            }\n        }\n        p {\n            margin-top: 20px;\n        }\n    }\n    &#recents {\n        .table {\n            tbody {\n                tr {\n                    td {\n                        padding: 10px 15px;\n                    }\n                }\n            }\n\n        }\n    }\n    .badge {\n        padding: 5px 10px;\n        font-size: $font-size-15;\n        font-weight: normal;\n    }\n    &#orders {\n        .modal-dialog {\n            max-width: 575px;\n        }\n        .order-body{\n            height: 50vh;\n            overflow: auto;\n            .default-cover {\n                border: 1px solid $gray-100;\n                box-shadow: $box-shadow;\n                @include rounded(8px);\n            }\n            .record {\n                font-size: $font-size-15;\n                td {\n                    padding-bottom: 15px;\n                }\n                tr {\n                    &:last-child {\n                        td {\n                            padding-bottom: 0;\n                        }\n                    }\n                }\n                .colon {\n                    padding: 0 10px;\n                    color: $secondary;\n                }\n                .text {\n                    color: $text-color;\n                    white-space: nowrap;\n                }\n            }\n            p {\n                font-size: $font-size-15;\n                background-color: $body-bg;\n                @include rounded(8px);\n            }\n            .search-set {\n                .search-input {\n                    width: 100%;\n                    label {\n                        width: 100%;\n                        input {\n                            width: 100%;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.upload-modal {\n        .modal-body{ \n            .drag-drop {\n                position: relative;\n                padding: 20px;\n                border:  1px dashed $sub-title;\n                input[type=\"file\"] {\n                    @include position(absolute,0,0,null,0);\n                    width: 100%;\n                    height: 100%;\n                    opacity: 0;\n                    cursor: pointer;\n                }\n            }\n            span {\n                font-size: $font-size-13;\n                font-weight: $font-weight-medium;\n                color: $text-color;\n            }\n            p {\n                font-size: $font-size-16;\n                font-weight: $font-weight-semibold;\n                color: $secondary;\n                margin-bottom: 0;\n            }\n            .progress {\n                height: 6px;\n                @include rounded(5px);\n            }\n            ul {\n                li {\n                    @include margin-padding(0 0 15px 0, 15px);\n                    @include rounded(8px);\n                    border: 1px solid $gray-100;\n                    h6 {\n                        a {\n                            font-size: $font-size-16;\n                            font-weight: $font-weight-semibold;\n                            color: $secondary;\n                            svg {\n                                color:  $success;\n                            }\n                        }\n                        &:hover {\n                            a {\n                                color: $primary;\n                            }\n                        }\n                    }\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n    }\n    &#upload-message {\n        .modal-dialog {\n            position:fixed;\n            bottom:0px;\n            right:24px;\n            margin:0px;\n            left:  auto;\n            top: calc(100% - 300px); \n            width: 600px;\n        }\n        .progress {\n            height: 6px;\n            @include rounded(5px);\n        }\n    }\n}\nlabel span {\n    color: $danger;\n}\n.wordset {\n    ul {\n        li {\n            a {\n                width: 38px;\n                height: 38px;\n                @include rounded(8px);\n                border:  1px solid $gray-100;\n                color: $secondary;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n            }\n        }\n    }\n}\n.w-85 {\n        width:  85%;\n}\n.search-order {\n    .search-input {\n        width: 100%;\n    }\n    .dataTables_filter {\n        label {\n            width: 100%;\n        }\n    }\n}\n.search-set.search-order .search-input input[type=search] {\n    width: 100%;\n}\n.tabs-sets {\n    .wordset {\n        li {\n            margin-right: 8px;\n            margin-left: 0;\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n}",".page-wrapper{\n    .page-header{\n        .back-btn{\n            display: flex;\n            gap: 10px;\n        .page-display{\n            a{\n                padding: 7px;\n                background-color: $secondary;\n                color: $white;\n                display: flex;\n                align-items: center;\n                gap: 8px;\n                border-radius: 8px;\n            }         \n        }\n    }\n    }\n}\n.card{\n    .card-body{\n        &.add-product{\n            .addproduct-icon{\n                @include margin-padding(0 0 20px 0px, 0 0 20px 0);\n                border-bottom: 1px solid rgba(145, 158, 171, 0.30);\n                display: flex;\n                justify-content: space-between;\n                width: 100%;\n                cursor: pointer;\n                h5 {\n                    font-size: $font-size-16;\n                    font-weight: $font-weight-semibold;         \n                    .add-info{\n                        color: $primary;\n                        margin-right: 7px;\n                    }\n                }\n            }\n            .text-editor{\n                &.add-list{\n                    padding-top: 10px;\n                    width: 100%;\n                    h5{\n                    padding-left: 0;\n                    }\n                    &.add{\n                        padding-top: 10px;\n                        .addproduct-icon{\n                            padding-left: 0;\n                        }\n                        .image-upload{\n                            margin-bottom: 0;\n                            width: 137px;\n                            height: 123px;\n                            border: 1px dashed rgba(145, 158, 171, 0.32);\n                            .image-uploads{\n                                padding: 43px 0;\n                            }\n                        }\n                        .custom-filed{\n                            display: flex;\n                            padding: 10px;\n                            background-color: $body-bg;\n                            margin-bottom: 20px;\n                            .input-block{\n                                &.add-lists{\n                                    display: flex;\n                                    gap: 20px;\n                                    align-items: center;\n                                    @include respond-below(custom767) {\n                                        flex-wrap: wrap;\n                                    }\n                                    .checkboxs{\n                                        margin-bottom: 0;\n                                        padding-left: 23px;\n                                        \n                                            .checkmarks{\n                                                top: 3px;\n                                            \n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n.input-blocks.add-product input[type=text]{\n    padding: 6px 15px;\n    width:100%;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    @include rounded(5px);\n}\n// .add-product input {\n//     height: 40px;\n// }\n.input-block.add-product.list{\n    position: relative;\n}\n.btn-primaryadd{\n    position: absolute;\n    top: 32px;\n    right: 4px;\n    padding: 5px 10px;\n    background-color: $primary;\n    font-size: $font-size-14;\n    color: $white;\n    &:hover{\n        border: 1px solid $primary;\n        color: $primary;\n    }\n}\n.input-block input.form-control.list {\n    color: #878A99;\n}\n.edit-add{\n    h6{\n        font-size: $font-size-16; \n    }\n}\n.edit-add {\n    font-size: $font-size-15;\n\t&.card {\n        border: none;\n        margin: 0;\n\t\t.note-editor {\n\t\t\t&.note-frame {\n                margin: 0px;\n\t\t\t\t.note-editing-area {\n\t\t\t\t\t.note-editable {\n\t\t\t\t\t\theight: 130px !important;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n        p{\n            margin-top: 10px;\n        }\n\t}\n}\n.input-blocks.add-products .form-check-input:checked {\n    background-color: $primary;\n    border-color: $primary;\n}\n.input-blocks.add-product.date input[type=text] {\n    padding: 6px 6px 6px 39px;\n}\n.input-blocks.add-product.date .input-groupicon .addonset {\n    left: 12px;\n    top: 48%;\n}\n.btn-addproduct{\n    float: right;\n}\n.addproduct-icon a {\n    color: $secondary;\n    border: 1px solid;\n    padding: 1px;\n    border-radius: 25px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    width: 20px;\n    height: 20px;\n    svg {\n        height: 17px;\n    }\n}\n.card .card-body.add-product .addproduct-icon.list{\n    padding-left: 0;\n}\n.add-newplus{\n    display: flex;\n    justify-content: space-between;\n}\n.plus-down-add{\n    margin-right: 5px;\n    width: 14px;\n    height: 14px;\n    position: relative;\n    top: -2px;\n}\n.add-newplus{\n    span{\n        font-size: $font-size-14;\n        font-style: normal;\n        font-weight: $font-weight-bold;\n    }\n}\n.add-choosen{\n    display: flex;\n    @include respond-below(custom767) {\n        flex-wrap: wrap;\n    }\n    .phone-img{\n        position: relative;\n        width: 137px;\n            height: 123px;\n            border-radius: 10px;\n            border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n            text-align: center;\n            margin-left: 20px;\n            @include respond-below(custom767) {\n                margin-bottom: 10px;\n                margin-left: 0;\n            }\n        img{\n           padding: 10px;            \n        }\n        a {\n            position: absolute;\n            right: 3px;\n            top: 3px;\n            background: $danger;\n            border-radius: 3px;\n            width: 16px;\n            height: 16px;\n            color: $white;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            &:hover {\n                color: $white;\n                background: #e61414;\n            }\n        }\n    }\n}\n.custom_radio, .custom_radio_one {\n    color: $text-color;\n    position: relative;\n    font-size: $font-size-15;\n    padding-left: 25px;\n    margin-bottom: 10px;\n    cursor: pointer;\n    user-select: none;\n    font-weight: $font-weight-normal;\n}\n.custom_radio input, .custom_radio_one input {\n    position: absolute;\n    opacity: 0;\n    padding: 0;\n}\n.custom_radio .checkmark, .custom_radio_one .checkmark {\n    position: absolute;\n    top: 2px;\n    left: 0;\n    height: 15px;\n    width: 15px;\n    background-color: transparent;\n    border: 1px solid rgba(145, 158, 171, 0.3);\n    border-radius: 50%;\n    -webkit-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.custom_radio .checkmark:after, .custom_radio_one .checkmark:after {\n    display: block;\n    content: \"\";\n    position: absolute;\n    top: 4px;\n    left: 4px;\n    opacity: 0;\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: $primary;\n    visibility: visible;\n    transform: scale(0.1);\n    -webkit-transform: scale(0.1);\n    -ms-transform: scale(0.1);\n    -webkit-transition: all 0.3s ease-in-out;\n    -ms-transition: all 0.3s ease-in-out;\n    transition: all 0.3s ease-in-out;\n}\n.custom_radio.active input ~ .checkmark:after, \n.custom_radio_one.active input ~ .checkmark:after {\n    transform: scale(1);\n    -webkit-transform: scale(1);\n    -ms-transform: scale(1);\n    opacity: 1;\n    visibility: visible;\n}\n.custom_radio.active input ~ .checkmark {\n    border: 1px solid $primary;\n}\n\n.single-pill-product {\n    .nav-link {\n        padding: 0;\n    }\n    .nav-pills.list .nav-item button::before {\n        top: 2px;\n        left: 0px;\n    }\n    .nav-pills.list .nav-item button.active::after {\n        top: 6px !important;\n        left: 4px !important;\n    }\n    .form-check-label {\n        cursor: pointer;\n    }\n}\n.nav-pills.list .nav-link.active{\n    background-color: transparent;\n    color: $text-color;\n}\n.nav-pills.list .nav-link{\n    background-color: transparent;\n    color: $text-color;\n}\n.add-icon.tab a{\n    background-color: $secondary;\n    color: $white;\n}\n.nav-pills.list .nav-item button{\n    position: relative;\n}\n.nav-pills.list .nav-item button::before {\n    content: \"\";\n    width: 15px;\n    height: 15px;\n    border: 1px solid #E0E0E0;\n    border-radius: 50%;\n    position: absolute;\n    top: 11px;\n    left: 12px;\n}\n.nav-pills.list .nav-item button.active::after {\n    content: \"\";\n    width: 7px;\n    height: 7px;\n    background: $primary;\n    border-radius: 50%;\n    position: absolute;\n    top: 15px;\n    left: 16px;\n}\n.nav-pills.list .nav-item button.active::before {\n    border-color:$primary;\n}\n.add-icon.tab-icon .feather-trashs{\n    background-color: $white;\n    color: $danger;\n}\n.add-icon.tab-icon a{\n    background-color: $white;\n    font-size: 11px;\n    width: 34px;\n    padding: 0;\n}\n.input-blocks{\n    &.filter-add{\n    margin-right: 0px;\n    margin-bottom: 0px;\n    .input-blocks{\n         &.add-product{\n          margin-bottom: 20px;\n          margin-right: 7px;\n        }\n    }\n}\n}\n.addproduct-icon.list.icon h5 img{\n    position: relative;\n    top: 5px;\n    padding-right: 5px;\n}\n#filter_inputs .table-responsive.product-list input{\n    padding-left: 10px;\n}\ntable tbody td.action-table-data a .add-checkbox{\n    border:none ;\n    padding: 0;\n}\n.feather-pluses{\n    color: $secondary;\n    width: 14px;\n    height: 14px;\n}\n.checkboxs.add-listcheck{\n    padding-left:24px ;\n}\n.searchinputs.list input {\n    width: 357px;\n    position: relative;\n    padding: 10px 31px 10px 10px;\n    border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n    background: $white;\n}\n.feather-16.icon{\n    position: absolute;\n    top: 10px;\n    right: 10px;\n}\n.modal-footer-btn.popup{\n    margin-top: 0;\n}\n.search-dropdown.idea{\n    height: auto;\n}\n.badges-warning {\n    color: $warning;\n    padding: 2px 10px;\n    border-radius: 8px;\n    border: 1px solid $warning;\n    font-size: $font-size-14;\n    font-weight: $font-weight-semibold;\n    min-width: 80px;\n}\n.badge.badge-linedangered{\n    color: $danger;\n    padding: 2px 10px;\n    border-radius: 8px;\n    border: 1px solid $danger;\n    font-size: $font-size-14;\n    font-weight: $font-weight-semibold;\n    min-width: 80px;\n}\n.input-blocks .info-imgs {\n    position: absolute;\n    top: 14px;\n    z-index: 100;\n    width: 16px;\n    height: 16px;\n    left: 5px;\n    margin-left: 5px;\n    color: $text-color;\n}\n.add-product {\n    .add-icon a {\n       background-color: $secondary;\n       color: $white;\n       @include respond-below(custom767) {\n            z-index: 1;\n        }\n       &:hover {\n        background-color: $primary;\n       }\n    }\n}\n.new-employee-field.product .card-title-head h6 {\n    font-weight: $font-weight-semibold;\n    font-size: $font-size-16;\n    align-items: center;\n    margin: 0 ;\n    padding: 0;\n    border-bottom:none;\n}\n.new-employee-field.product .card-title-head{\n    margin: 0 0 20px;\n    padding: 0 0 20px;\n    border-bottom: 1px solid rgba(145, 158, 171, 0.3);\n    display: flex;\n    justify-content: space-between;\n}\n.new-employee-field.product .card-title-head a {\n    color: #878A99;\n    border: 1px solid;\n    padding: 3px;\n    border-radius: 25px;\n}\n.accordion-card-one {\n    .accordion-item {\n        border: 0;\n        .accordion-button {\n            padding: 0;\n            box-shadow: none;\n            .addproduct-icon {\n                h5 {\n                    display: flex;\n                    align-items: center;\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        top: unset;\n                    }\n                }\n            }\n            &::after {\n                display: none;\n            }\n            &:not(.collapsed) {\n                background-color: $white;\n                .accordion-item {\n                    margin-bottom: 40px;\n                }\n            }\n            &.collapsed {\n                .addproduct-icon {\n                    a {\n                        svg {\n                            transform: rotate(180deg);\n                        }\n                    }\n                }\n            }\n        }\n        .accordion-body {\n            padding: 0;\n        }\n    }\n}\n.selected-hide-color {\n    display: none;\n}\n.selected-color-add {\n    .selected-hide-color {\n        display: flex;\n        align-items: center;\n    }\n}\n.variant-table {\n    display: none;\n}\n.variant-select {\n    height: 40px;\n}\n.variant-table {\n    padding: 0;\n    background: transparent;\n    div.dataTables_wrapper div.dataTables_paginate {\n        display: none;\n    }\n    .dataTables_filter,\n    .dataTables_length {\n        display: none;\n    }\n}\n",".notes-page-wrapper {\n    .content {\n        padding: 24px;\n        .page-add-notes {\n            border-bottom: 1px solid $gray-400;\n            padding-bottom: 25px;\n            position: relative;\n            margin-bottom: 0;\n            @include respond-below(custom767) {\n                flex-direction: column;\n                align-items: start;\n            }\n            .notes-tog {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                position: absolute;\n                bottom: -12px;\n                border-radius: 30px;\n                background: #1B2850;\n                color: $white;\n                width: 24px;\n                height: 24px;\n                padding: 5px;\n                @include respond-below(custom991) {\n                    display: none;\n                }\n            }\n        }\n        .section-bulk-wrap {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            margin: 30px 0 24px 0;\n            padding: 20px;\n            border-radius: 8px;\n            background:  $white;\n            box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\n            @include respond-below(custom767) {\n                flex-direction: column;\n                align-items: start;\n            }\n            .bulk-action-type {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                @include respond-below(custom767) {\n                    margin-bottom: 20px;\n                }\n                @include respond-below(custom575) {\n                    margin-bottom: 0;\n                    flex-direction: column;\n                    align-items: self-start;\n                }\n                .select-bluk {\n                    margin-right: 8px;\n                    height: 40px;\n                    .select2-container {\n                        .selection {\n                            .select2-selection {\n                                .select2-selection__rendered {\n                                    padding-left: 10px!important;\n                                }\n                            }\n                        }\n                        \n                    }\n                }\n                .btn-added {\n                    background: $secondary;\n                    padding: 8px 20px;\n                    color: $white;\n                    font-size: $font-size-15;\n                    font-weight: $font-weight-normal;  \n                    margin-right: 15px; \n                    height: 38px; \n                    &:hover {\n                        background: $primary;\n                    }    \n                    @include respond-below(custom575) {\n                        margin: 20px 0;\n                    }           \n                }   \n            }  \n            .form-sort {\n                .fa-filter {\n                    z-index:100!important;\n                    position: absolute;\n                    top: 15px;\n                    left: 15px;\n                    width: 16px;\n                    height: 16px;\n                }\n            } \n        }\n        .section-notes-slider {\n            position: relative;\n            padding-bottom: 40px;\n            border-bottom: 1px solid $gray-400;\n            .notes-content {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;\n                margin-bottom: 20px;\n                .notes-close {\n                    a {\n                        color: $danger;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        i {\n                            margin-right: 6px;\n                        }\n                    }\n                }\n            }\n            .notes-card {\n                padding: 24px;\n                border-radius: 8px;\n                background: rgba(255, 159, 67, 0.03);\n                &.medium {\n                    background: rgba(116, 41, 248, 0.03);\n                }\n                &.high {\n                    background: rgba(234, 84, 85, 0.03);\n                }\n                .notes-card-body {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    p {\n                        &.badged  {\n                            border-radius: 8px;\n                            border: 1px solid  $warning;\n                            padding: 4px 10px; \n                            margin-bottom: 0;\n                            color:$warning;\n                            font-size: $font-size-base;\n                            font-weight: $font-weight-semibold;\n                            display: flex;\n                            align-items: center;\n                            i {\n                                font-size: 7px;\n                                margin-right: 4px;\n                            }\n                            &.medium {\n                                color: #7429F8;\n                                border: 1px solid #7429F8;\n                            }\n                            &.high {\n                                color: $danger;\n                                border: 1px solid $danger;\n                            }\n                        }\n                    }\n                    a {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        color: $secondary;\n                        &.dropdown-item {\n                            &:hover {\n                                color: $white;\n                            }\n                        }   \n                    }\n                \n                }\n                .notes-slider-content {\n                    margin: 24px 0;\n                    h4 {\n                        a {\n                            margin-bottom: 10px;\n                            color:$secondary;\n                            font-size: $font-size-16;\n                            font-weight: $font-weight-semibold;\n                            display: -webkit-box;\n                            -webkit-line-clamp: 1;\n                            -webkit-box-orient: vertical;\n                            overflow: hidden;\n                            &:hover {\n                                color: $warning;\n                            }\n                        }                      \n                    }\n                    p {\n                        color: $text-color;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        margin-bottom: 0px;\n                        display: -webkit-box;\n                        -webkit-line-clamp: 2;\n                        -webkit-box-orient: vertical;\n                        overflow: hidden;\n                    }\n                }\n                .notes-slider-widget {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    .notes-logo {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        a {\n                            margin-right: 15px;\n                            span {\n                                width: 32px;\n                                height: 32px;\n                                display: flex;                                \n                                img {\n                                    border-radius: 100px;\n                                }\n                                \n                            }                           \n                        }   \n                        span {\n                            &.medium-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $success;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.high-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $warning;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.low-square {\n                                margin-right: 5px;\n                                i {\n                                    color: #288EC7;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                        }                     \n                        p {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            color:#288EC7;\n                            font-size: $font-size-15;\n                            font-weight: $font-weight-normal;\n                            margin-bottom: 0px;\n                            i {\n                                &.fa-draw-polygon {\n                                    margin-right: 5px;\n                                }\n                            }\n                            &.medium {\n                                color: $success;\n                            }\n                            &.high {\n                                color: $warning;\n                            }\n                        }\n                    }\n                    .notes-star-delete {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        span {\n                            .fa-star {\n                                color: $warning;\n                                width: 16px;\n                                height: 16px;\n                                margin-right: 10px;\n                            }\n                            .feather-trash-2 {\n                                color: $danger;\n                                width: 16px;\n                                height: 16px;\n                            }\n                        }\n                    }\n                }\n            }\n        }\n        .section-card-body {\n            padding-top: 40px;\n            .notes-card-details {\n                border-radius: 8px;\n                border: 1px solid  rgba(145, 158, 171, 0.30);\n                background: $white;\n                box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);\n                padding: 24px;\n                margin-bottom: 24px;\n                .notes-card-body {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    p {\n                        &.badged  {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            border-radius: 8px;\n                            border: 1px solid  $warning;\n                            padding: 4px 10px; \n                            margin-bottom: 0;\n                            color:$warning;\n                            font-size: $font-size-base;\n                            font-weight: $font-weight-semibold;\n                            i {\n                                font-size: 7px;\n                                margin-right: 4px;\n                            }\n                            &.medium {\n                                color: #7429F8;\n                                border: 1px solid #7429F8;\n                            }\n                            &.high {\n                                color: $danger;\n                                border: 1px solid $danger;\n                            }\n                        }\n                    }\n                    .dropdown-item {\n                        span {\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            color: $secondary;\n                            svg {\n                                width: 14px;\n                                height: 14px;\n                                color: $text-color;\n                            }\n                        }\n                        &:hover {\n                            span {\n                                svg {\n                                    color: $white;\n                                }\n                            }\n                        }\n                    }\n                }\n                .notes-wrap-content {\n                    padding: 20px 0;\n                    border-bottom: 1px solid $gray-400;\n                    h4 {\n                        a {\n                            color:$secondary;\n                            font-size: $font-size-16;\n                            font-weight: $font-weight-semibold;\n                            margin-bottom: 5px;\n                            display: -webkit-box;\n                            -webkit-line-clamp: 1;\n                            -webkit-box-orient: vertical;\n                            overflow: hidden;\n                            &:hover {\n                                color: $warning;\n                            }\n                        }                    \n                    }\n                    .wrap-cal {\n                        color:$text-color;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        margin-bottom: 20px;\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        svg {\n                            margin-right: 5px;\n                            width: 16px;\n                            height: 16px;\n                        }\n                    }\n                    p {\n                        color:$text-color;\n                        font-size: $font-size-15;\n                        font-weight: $font-weight-normal;\n                        margin-bottom: 0px;\n                        display: -webkit-box;\n                        -webkit-line-clamp: 2;\n                        -webkit-box-orient: vertical;\n                        overflow: hidden;\n                    }\n                }\n                .notes-slider-widget {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: space-between;\n                    -webkit-justify-content: space-between;\n                    -ms-flex-pack: space-between;\n                    &.notes-widget-profile {\n                        padding-top: 20px;\n                    }\n                    .notes-logo {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        a{\n                            margin-right: 15px;\n                            span {                            \n                                img {\n                                    border-radius: 100px;\n                                }\n                            } \n                        }                                            \n                        span {\n                            &.medium-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $success;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.high-square {\n                                margin-right: 5px;\n                                i {\n                                    color: $warning;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                            &.low-square {\n                                margin-right: 5px;\n                                i {\n                                    color: #288EC7;\n                                    transform: rotate(45deg);\n                                    font-size: 10px;\n                                }\n                            }\n                        }\n                        p {\n                            color:#288EC7;\n                            font-size: $font-size-15;\n                            font-weight: $font-weight-normal;\n                            margin-bottom: 0px;\n                            display: -webkit-box;\n                            display: -ms-flexbox;\n                            display: flex;\n                            align-items: center;\n                            -webkit-box-align: center;\n                            -ms-flex-align: center;\n                            i {\n                                &.fa-draw-polygon {\n                                    margin-right: 5px;\n                                }\n                            }\n                            &.medium {\n                                color: $success;\n                            }\n                            &.high {\n                                color: $warning;\n                            }\n                        }\n                    }\n                    .notes-star-delete {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                        span {\n                            .feather-star {\n                                color: $text-color;\n                                width: 16px;\n                                height: 16px;\n                                margin-right: 10px;\n                            }\n                            .feather-trash-2 {\n                                color: $danger;\n                                width: 16px;\n                                height: 16px;\n                            }\n                        }\n                    }\n                }\n            }\n        }      \n    }\n}\n.notes-card-details {\n    .notes-card-body {\n        a {\n            color: $secondary;\n        }\n    }\n\n}\n.star-todo-inbox {\n    svg {\n        width: 13px;\n        height: 13px;\n        color: $text-color;\n    }\n}\n.inbox-call-profile {\n    border-radius: 5px;\n    background: #E92990;\n    border: 1px solid #E92990;\n    padding: 4px 10px;\n    font-size: $font-size-14;\n    font-weight: $font-weight-bold;\n    color: $white;\n    margin: 0 20px;\n    &:hover  {\n        color: #E92990;\n        background: $white;\n    }\n}\n.notes-tog {\n    i {\n        transform: rotate(180deg);\n    }\n    &.active {\n        i {\n            transform: rotate(0deg);\n        }\n    }\n}\n.section-bulk-wrap {\n    .form-sort {\n        position: relative;\n        svg {\n            &.feather-filter {\n                position: absolute;\n                z-index: 101;\n                width: 16px;\n                height: 16px;\n                top: 12px;\n                left: 10px;\n            }\n            \n        }\n    }\n}\n\n.page-add-notes.active svg {\n    transform: rotate(0) !important;\n}\n.dropdown-menu {\n    &.notes-menu {\n        z-index: 99999;\n        a {\n            &.dropdown-item {\n                color: $secondary;\n                font-size: $font-size-15;\n                font-weight: $font-weight-normal;\n                display: flex;\n                align-items: center; \n                padding: 10px 20px;   \n                &:hover {\n                    background: $warning;\n                    color: $white;\n                    svg {\n                        color: $white;\n                    }\n                }                          \n            }\n            \n        }   \n        span {\n            margin-right: 8px;\n        }\n        svg {\n            width: 14px;\n            height: 14px;\n            color: $text-color;\n        }\n    } \n}\n.edit-note-head {\n    a {\n        border-radius: 30px;\n        border: 1px solid rgba(145, 158, 171, 0.30);\n        background:  $white;\n        color: $secondary;\n        padding: 15px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        width: 20px;\n        height: 20px;\n        &:hover {\n            border-radius: 20px;\n            background:  $primary;\n            color: $white;\n        }\n    }\n}\n.custom-modal-body {\n    .select2-container {\n        .selection {\n            .select2-selection {\n                .select2-selection__rendered {\n                    padding-left: 10px!important;\n                }\n            }\n        }\n        \n    }\n}\n.bulk-con-wrap {\n    width: 100%;\n}\n.section-bulk-widget {\n    transition: 0.6s all\n}\n.section-notes-dashboard {\n    display: none;\n    transition: 0.6s all\n}\n.notes-tog {\n    i {\n        transition: 0.5s all;\n    }\n}\n.notes-tag-left {\n    .notes-tog {\n        i {\n            transform: rotate(360deg);\n            transition: 0.5s all;\n        }\n    }\n}\n.budgeted-role-notes {\n    width: 100%;\n}\n.notes-summernote .card{\n    margin-bottom: 0 !important;\n}\n.dropdown-item:active {\n    background: transparent;\n}\n.notes-summernote p {\n    color: $text-color;\n    font-size: $font-size-15;\n    font-weight: $font-weight-normal;\n}\n\n.notes-dash {\n    margin-top: 30px;\n    padding: 24px;\n    border-radius: 8px;\n    border: 1px solid  rgba(145, 158, 171, 0.30);\n    background: $white;\n    transition: 0.6s all;\n    .notes-top-head {       \n        border-bottom: 1px solid $gray-400;\n        h5 {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n            color: $secondary;\n            margin-bottom: 15px;\n            display: flex;\n            align-items: center;\n            svg {\n                width: 19px;\n                height: 19px;\n                margin-right: 6px;\n                color: $text-color;\n            }\n        }\n    }\n    .notes-top-head-submenu {\n        padding: 15px 0;\n        border-bottom: 1px solid $gray-400;\n        ul {\n            padding: 15px 0;\n            li {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: space-between;\n                -webkit-justify-content: space-between;\n                -ms-flex-pack: space-between;               \n                padding: 10px;\n                &.active {\n                    border-radius: 10px;\n                    background:  $secondary;\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        margin-right: 8px;\n                    }\n                    p {\n                        color: $white;                        \n                    }\n                }\n\n                p {\n                    font-size: $font-size-15;\n                    font-weight: $font-weight-semibold;\n                    color: $text-color;\n                    margin-bottom: 0;\n                    display: flex;\n                    align-items: center;\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        margin-right: 8px;\n                    }\n                }\n                span {\n                    display: flex;\n                    width: 18px;\n                    height: 18px;\n                    padding: 0px 3px;\n                    justify-content: center;\n                    align-items: center;\n                    border-radius: 12px;\n                    background:  $primary;\n                    color: $white;\n                }\n\n            }\n        }\n    }\n    .content-submenu-tag {\n        margin-top: 15px;\n        padding: 10px;\n        h6 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            color: $secondary;\n        }\n        ul {\n            padding: 10px 0;\n            &.tags-list {\n                margin-bottom: 24px;\n            }\n            li {\n                &.personal {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a {\n                        color: #288EC7;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.social {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a {\n                        color: $warning;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.work {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a{\n                        color: $success;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.public {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                     a{\n                        color: #A02F7A;\n                        display: flex;\n                        align-items: center;\n                     }\n                    \n                }\n                &.medium {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    } \n                     a {\n                        color: $purple;\n                        display: flex;\n                        align-items: center;\n                     }\n                   \n                }\n                &.high {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a {\n                        color: $danger;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                &.low {\n                    span {\n                        margin-right: 8px;\n                        i {\n                            transform: rotate(45deg);\n                            font-size: 10px;\n                        }\n                    }\n                    a  {\n                        color: $warning;\n                        display: flex;\n                        align-items: center;\n                    }\n                    \n                }\n                   font-size: $font-size-15;\n                   font-weight: $font-weight-normal;\n                   display: flex;\n                   align-items: center;\n                +li {\n                    margin-top: 10px;\n                }\n            }\n        }\n    }\n}\n.notes-logo {\n    a {\n        display: flex;\n        align-items: center;\n        span {\n            width: 32px;\n            height: 32px;  \n            img {\n                border-radius: 32px;               \n            }\n        }\n    }\n}\n.notes-top-head-submenu {\n    padding: 15px 0;\n    border-bottom: 1px solid $gray-400;\n    .nav {\n        &.todo-inbox {\n            button.todo-inbox {\n               display:flex;\n               justify-content: flex-start; \n               align-items: center;             \n                padding: 10px;\n                font-size: $font-size-15;\n                font-weight: $font-weight-semibold;\n                color: $text-color;\n                margin-bottom: 0;\n                display: flex;\n                align-items: center;\n                margin-bottom: 5px;\n                border-radius: 10px;\n                &.active {\n                    border-radius: 10px;\n                    background:  #212B36;\n                    padding: 10px;\n                    color: $white;\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        margin-right: 8px;\n                    }               \n                }\n                &:hover {\n                    background:  #212B36;\n                    color: $white;\n                }\n               \n                svg {\n                    width: 16px;\n                    height: 16px;\n                    margin-right: 8px;\n                }\n                span {\n                    display: flex;\n                    width: 20px;\n                    height: 20px;\n                    padding: 0px 3px;\n                    justify-content: center;\n                    align-items: center;\n                    border-radius: 12px;\n                    background:  $primary;\n                    color: $white;\n                }\n                  \n            }            \n        }\n    }\n    \n}\n.notes-trash-btn {\n    background: $danger;\n    color: $white;\n    border-radius: 8px;\n    margin: 4px 0 20px 0;\n    padding: 10px;\n    height: 38px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    span {\n        display: flex;\n        align-items: center;\n        svg {\n            width: 16px;\n            height: 16px;\n            margin-right: 10px;\n        }\n    }\n}\n.delete-popup {\n    padding: 24px;\n    border-radius: 8px;\n    background: $white;\n    .delete-image {\n        margin-bottom: 20px;\n    }\n    .delete-heads {\n        text-align: center;\n        h4 {\n            color: $secondary;\n            font-size: $font-size-20;\n            font-weight: $font-weight-bold;\n            margin-bottom: 5px;\n        }\n        p {\n            color: $text-color;\n            font-size: $font-size-15;\n            font-weight: $font-weight-normal;\n            margin-bottom: 0px;\n        }       \n    }\n    .delete-footer {\n        text-align: center;\n    }\n}\n.edit-page-title {\n    display: flex;\n    align-items: center;\n    h4 {\n        font-size: $font-size-18;\n        font-weight: $font-weight-bold;\n        color: $secondary;\n        margin-bottom: 0;\n        margin-right: 10px;\n    }\n    p {\n        font-size: $font-size-15;\n        font-weight: $font-weight-normal;\n        color: #288EC7;\n    }\n}\n.edit-head-view {\n    margin-bottom: 20px;\n    border-bottom: rgba(145, 158, 171, 0.30);\n    h6 {\n        font-size: $font-size-16;\n        font-weight: $font-weight-semibold;\n        color: $secondary;\n        margin-bottom: 15px;\n    }\n    p {\n        font-size: $font-size-15;\n        font-weight: $font-weight-normal;\n        color: $text-color;\n        margin-bottom: 15px;\n    }\n    p {\n        &.badged {\n            i {\n                font-size: 7px;\n                margin-right: 7px;\n            }\n            border-radius: 8px;\n            border: 1px solid $warning;\n            padding: 4px 10px;\n            margin-bottom: 0;\n            color: $warning;\n            font-size: $font-size-14;\n            font-weight: $font-weight-semibold;\n            display: inline-flex;\n            align-items: center;\n        }\n    }\n}\n.edit-footer-menu a {\n    background-color: $danger;\n}\n.edit-noted-head {\n    a {\n        span {\n            i{\n                 &.fa-trash-alt {\n                    color: $danger;\n                    margin-right: 10px;\n                 }\n                 &.fa-star {\n                    color: $warning;\n                 }\n            }\n        }\n    }\n}\n.edit-head-view {   \n    p {\n        &.badged.high {\n            i {\n                font-size: 7px;\n                margin-right: 7px;\n            }\n            border-radius: 8px;\n            border: 1px solid $danger;\n            padding: 4px 10px;\n            margin-bottom: 0;\n            color: $danger;\n            font-size: $font-size-14;\n            font-weight: $font-weight-semibold;\n            display: inline-flex;\n            align-items: center;\n        }\n    }\n}\n.people-profile-pic {\n    border: none !important;\n    margin-left: 14px;\n    position: relative;\n    img {\n        border-radius: 10px;\n    }\n    a {\n        position: absolute;\n        top: 15px;\n        right: 7px;\n        .x-square-add {\n            border-radius: 3px;\n            background:$danger;\n            color: $white;\n        }       \n    }\n}\n\n.people-customer-walk {\n    max-width: 35px;\n}\n.custom-pagination {\n    .paginations {\n        align-items: center;\n        span {\n            display: flex;\n            align-items: center;\n            color: $text-color;\n            width: 16px;\n            height: 16px;\n            .fa-chevron-left {\n                margin-right: 8px;\n            }\n        }\n        .page-wrap {\n            li {\n                a {\n                    margin-right: 8px;\n                    border-radius: 85px;\n                    background: $gray-400;\n                    color:$text-color;\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-medium;                    \n                    display: flex;\n                    width: 30px;\n                    height: 30px;\n                    padding: 5px;\n                    justify-content: center;\n                    align-items: center;\n                    &.active {\n                        background: $primary;\n                        color: $white;\n                    }                         \n                }  \n                :hover {\n                    background: $primary;\n                    color: $white;\n                    transition: .3s all;\n                }                                   \n            }                \n        }\n    } \n}\n.section-notes-slider {\n    .notes-slider {\n        &.owl-carousel {\n            .owl-nav {\n                top: -44px;\n                right: unset;\n                left: 150px;\n                button {\n                    background-color: transparent;\n                    width: 15px;\n                    height: auto;\n                    i {\n                        color: $secondary;\n                    }\n                    &:hover {\n                        background-color: transparent;\n                        i {\n                            color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n",".employee-grid-profile {\n    text-align: center;\n    background: $white;\n    border-radius: 8px;\n    @include margin-padding(0 0 24px,15px);\n    box-shadow: 0px 4px 60px 0px rgba(190, 190, 190, 0.27);\n    border: 1px solid $gray-400;\n    .profile-head {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: space-between;\n        -webkit-justify-content: space-between;\n        -ms-flex-pack: space-between;\n        margin-bottom: 24px;\n        .profile-head-action {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            .badge badge-linedanger {\n                background: $white;\n                border: 1px solid $danger;\n                padding: 2px 10px;\n            }\n        }\n        .dep-name {\n            h5 {\n                font-size: $font-size-18;\n                font-weight: $font-weight-bold;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                &::before {\n                    content: \"\";\n                    width: 10px;\n                    height: 10px;\n                    border-radius: 50%;\n                    margin-right: 5px;\n                }\n                &.active {\n                    &::before {\n                        background: $success;\n                    }\n                }\n                &.inactive {\n                    &::before {\n                        background: $danger;\n                    }\n                }\n            }\n        }\n    }\n    .profile-info {\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        flex-direction: column;\n        margin-bottom: 15px;\n        .profile-pic {\n            width: 80px;\n            height: 80px;\n            border-radius: 8px;\n            margin-bottom: 15px;\n            position: relative;\n            img {\n                border-radius: 8px;\n            }\n            &.active-profile {\n                &::after {\n                    content: \"\";\n                    background: $success;\n                    border-radius: 50%;\n                    position: absolute;\n                    right: -3px;\n                    bottom: -3px;\n                    padding: 3px;\n                    border: 3px solid $white;\n                }\n            }\n        }\n        &.department-profile-info {\n            background-color: $gray-100;\n            padding: 15px;\n            border-radius: 10px;\n            .profile-pic {\n                width: 40px;\n                height: 40px;\n                margin-bottom: 8px;\n            }\n            h4 {\n                font-size: $font-size-15;\n            }\n        }\n        h5 {\n            color: $primary;\n            font-size: $font-size-base;\n            font-weight: $font-weight-bold;\n            margin-bottom: 10px;\n        }\n        h4 {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n        }\n        span {\n            font-size: $font-size-15;\n        }\n    }\n    ul {\n        &.department {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            text-align: left;\n            background-color: $gray-100;\n            @include margin-padding(null,15px);\n            border-radius: 8px;\n            li {\n                color: $secondary;\n                font-weight: $font-weight-medium;\n                font-size: $font-size-15;\n                span {\n                    display: block;\n                    color: $text-color;\n                    margin-top: 5px;\n                }\n            }\n        }\n    }\n    .dropdown-toggle::after {\n        display: none;\n    }\n    .dropdown.profile-action {\n        svg {\n            color: $secondary;\n        }\n        .dropdown-menu {\n            padding: 0;\n            right: 0px !important;\n            margin-top: 10px !important;\n            left: unset !important;\n            min-width: 130px;\n        }\n        .dropdown-menu a.dropdown-item + a {\n            margin-top: 0;\n        }\n        ul {\n            li {\n                a {\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        margin-right: 8px;\n                    }\n                    &:hover {\n                        svg {\n                            color: $white;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.hide-head {\n    .header {\n        display: none;\n    }\n    .sidebar {\n        top: 0;\n    }\n    .page-wrapper {\n        padding-top: 0;\n    }\n    .full-height {\n        svg {\n            transform: rotate(180deg);\n        }\n    }\n}\n.card-title-head {\n    h6 {\n        font-weight: $font-weight-semibold;\n        font-size: $font-size-16;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        @include margin-padding(0 0 20px,0 0 20px);\n        border-bottom: 1px solid rgba(145, 158, 171, 0.30);\n        svg {\n            width: 20px;\n            margin-right: 5px;\n            color: $primary;\n        }\n    }\n}\n.new-employee-field {\n    .image-upload {\n        width: 120px;\n        height: 38px;\n        border: 0;\n        background-color: $primary;\n        input[type=file] {\n            height: 38px;\n        }\n        .image-uploads {\n            top: 8px;\n            padding: 0;\n            h4 {\n                color: $white;\n                font-size: $font-size-15;\n                line-height: normal;\n            }\n        }\n    }\n}\n.profile-pic-upload {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    margin-bottom: 24px;\n    .profile-pic {\n        width: 120px;\n        height: 120px;\n        border: 1px dashed $text-color;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        border-radius: 10px;\n        margin-right: 24px;\n        position: relative;\n        flex-shrink: 0;\n        span {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            flex-direction: column;\n            svg {\n                margin-right: 0;\n            }\n        }\n        .close-img {\n            .info-img {\n                width: 12px;\n                height: 12px;\n                color: $white;\n                border-radius: 3px;\n                background: $danger;\n            }\n            padding: 2px;\n            position: absolute;\n            top: 10px;\n            right: 12px;\n            \n        }\n    }\n    &.edit-pic {\n        .profile-pic {\n            border: 0;\n            img {\n                border-radius: 10px;\n            }\n            .user-editer {\n                border-radius: 0;\n            }\n        }\n    }\n}\n.pass-info {\n    .input-blocks {\n        svg {\n            position: absolute;\n            right: 10px;\n            top: 36px;\n            width: 15px;\n            left: unset;\n        }\n    }\n}\n.new-employee-field {\n    .other-info {\n        margin: 15px 0;\n    }\n}\n.team-members {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: space-between;\n    -webkit-justify-content: space-between;\n    -ms-flex-pack: space-between;\n    li {\n        ul {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            li {\n                a {\n                    display: inline-block;\n                    width: 24px;\n                    height: 24px;\n                    img {\n                        width: 24px;\n                        height: 24px;\n                        border-radius: 50%;\n                        border: 2px solid $white;\n                    }\n                }\n                margin-left: -7px;\n                &:first-child {\n                    margin-left: 0;\n                }\n                &:last-child {\n                    a {\n                        position: relative;\n                        &::after {\n                            content: \"\";\n                            background: linear-gradient(0deg, rgba(0, 0, 0, 0.70) 0%, rgba(0, 0, 0, 0.70) 100%);\n                            width: 100%;\n                            height: 100%;\n                            position: absolute;\n                            left: 0;\n                            border-radius: 50%;\n                            border: 2px solid $white;\n                        }\n                        span {\n                            color: $white;\n                            position: absolute;\n                            left: 5px;\n                            z-index: 1;\n                            top: 3px;\n                            font-size: 13px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n.dataTables_info {\n    display: none;\n}\ndiv.dataTables_wrapper div.dataTables_length select {\n    display: none;\n}\n.input-blocks {\n    .form-icon {\n        position: relative;\n        input {\n            padding-left: 30px;\n        }\n        .cus-icon {\n            position: absolute;\n            left: 10px;\n            top: 9px;\n            svg {\n                width: 14px;\n                color: $text-color;\n            }\n        }\n    }\n    &.custom-form-check {\n        margin: 15px 0;\n    }\n}\n.modal {\n    .input-blocks {\n        margin-bottom: 15px;\n    }\n}\n.checkboxs.modal-table-check {\n    line-height: normal;\n    margin-right: 13px;\n    margin-bottom: 0;\n    padding-left: 25px;\n    display: inline-block;\n    .checkmarks{\n        top: 3px;\n    }\n    input ~ .checkmarks {\n        border-radius: 5px;\n    }\n    input:checked ~ .checkmarks {\n        border-color: $primary;\n    }\n} \n.no-pagination {\n    .dataTables_length,.paging_numbers {\n        display: none;\n    }\n}\n.modal-table-tab {\n    .nav-link {\n        background-color: rgba(145, 158, 171, 0.30);\n        color: $text-color;\n        padding: 10px 20px;\n        margin-right: 10px;\n        margin-bottom: 15px;\n        font-size: $font-size-base;\n        font-weight: $font-weight-bold;\n        &.active {\n            background-color: $primary;\n            color: $white;\n        }\n    }\n\n}\n.modal-table-item {\n    h4 {\n        font-weight: $font-weight-semibold;\n        font-size: $font-size-16;\n        margin-bottom: 20px;\n        color: $secondary;\n    }\n}\n.break-title {\n    h4 {\n        font-weight: $font-weight-semibold;\n        font-size: $font-size-16;\n        margin-bottom: 10px;\n        color: $secondary;\n    }\n}\n.table-top-new {\n    @include respond-below(custom1199) {\n        .search-set .search-input input[type=search] {\n            width: 140px;\n        }\n        .total-employees {\n            margin-right: 10px;\n        }\n        .search-path .btn-filter,.search-path .btn-filter {\n            margin-right: 10px;\n        }\n    }\n    @include respond-below(custom991) {\n        .search-set .search-input input[type=search] {\n            width: 200px;\n        }\n    }\n}\n",".page-header {\n    .page-btn {\n        &.import {\n          margin-left: 15px;\n          @include respond-below(custom575){\n            margin-left: 0;\n          }\n        }\n    }\n}\n.summer-description-box.transfer{\n    margin-bottom: 0;\n    p {\n        color: $text-color;\n    }\n}\n.summer-description-box.transfer .note-editor {\n    margin-bottom: 10px;\n}\n.modal-body-table.total-orders{\n    margin-bottom: 0;\n}\n.image-upload .image-uploads h4 span {\n    color: $primary;\n}\n.modal-dialog{\n    &.payment{\n        min-width: 1439px;\n    }\n}\n.input-blocks {\n\t&.image-upload-down {\n\t\tmargin-bottom: 15px;\n\t}\n}\n.badges.status-badge.ordered{\n   background-color: $warning;\n}\n.input-blocks.leave-table{\n    margin-bottom: 0;\n    width: 98px;\n}\n.page-header .page-btn.attendance{\n    margin-left: 0px;\n}\n.page-header{\n    &.transfer{\n        @include respond-below(custom767){\n            display: block;\n        }\n        .table-top-head{\n            @include respond-below(custom767){\n                justify-content: flex-start;\n                margin-top: 24px;\n                margin-bottom: 24px;\n        }\n    }\n    .purchase-pg-btn {\n        .page-btn {\n            &:first-child {\n                @include respond-below(custom767){\n                    margin-left: 0;\n                    margin-top: 0;\n                }\n            }\n        }\n        @include respond-below(custom575){\n            flex-direction: column;\n            align-items: self-start;\n        }\n    }\n}\n}",".attendance-header{\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 24px;\n    @include respond-below(custom575){\n        display: block;\n    }\n    .attendance-content{\n        display:flex;\n        align-items: center;\n        h3{\n            font-size: $font-size-20;\n            flex-shrink: 0;\n            margin-left: 10px;\n            span{\n                color: $text-color;\n            }\n        }\n    }\n}\n.table-top-head {\n    &.employe{\n        @include respond-below(custom575){\n            justify-content: flex-start;\n                margin-top: 24px;\n        }\n    }\n}\n.attendance-widget{\n    .card{\n        .card-body{\n            h5{\n                display: flex;\n                justify-content: space-between;\n                font-size: $font-size-20;\n                align-items: center;             \n                padding-bottom: 24px;\n                border-bottom: 1px solid rgba(145, 158, 171, 0.30);\n                margin-bottom: 24px;\n             span{\n                font-size: 13px;\n                color: $purple;\n             }\n            }\n            .card{\n                &.attendance{\n                    display: flex;\n                    padding: 30px 10px;\n                    align-items: center;\n                    background-color: $body-bg;\n                    flex-direction: row;\n                    margin-bottom: 24px;\n                    img{\n                        width: 48px;\n                        height: 48px;\n                        padding-right: 15px;\n                    }\n                }\n            }\n        }\n    }\n}\n.modal-attendance-btn{\n    display: flex;\n    gap: 10px;\n}\n.warming-card{\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    h4{\n    color: $primary;\n    font-size: $font-size-20;\n    border-radius: 8px;\n    width: 64px;\n    height: 64px;\n    background: rgba(255, 159, 67, 0.09);\n    padding: 20px;\n    margin-bottom: 14px;\n    }\n    h6{\n        font-size: $font-size-16;\n    }\n}\n.danger-card{\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    h4{\n    color: $danger;\n    font-size: $font-size-20;\n    width: 64px;\n    height: 64px;\n    border-radius: 8px;\n    background: rgba(255, 0, 0, 0.09);\n    padding: 20px;\n    margin-bottom: 14px;\n    }\n    h6{\n        font-size: $font-size-16;\n    }\n}\n.light-card{\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    h4{\n    color: $purple;\n    font-size: $font-size-20;\n    width: 64px;\n    height: 64px;\n    border-radius: 8px;\n    background:rgba(115, 103, 240, 0.09);\n    padding: 20px;\n    margin-bottom: 14px;\n    }\n    h6{\n        font-size: $font-size-16;\n    }\n}\n.success-card{\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    h4{\n    color: $purple;\n    font-size: $font-size-20;\n    width: 64px;\n    height: 64px;\n    border-radius: 8px;\n    background:rgba(115, 103, 240, 0.09);\n    padding: 20px;\n    margin-bottom: 14px;\n    }\n    h6{\n        font-size: $font-size-16;\n    }\n}\n.widget-attend{\n    display: flex;\n    @include respond-below(custom991) {\n        flex-wrap: wrap;\n        justify-content: center;\n     }\n}\n.box-attend{\n    padding: 10px;\n    text-align: center;\n    width: 100%;\n}\n.progress-bar-success{\n    background-color:$success ;\n}\n.progress-bar-warning{\n    background-color: $warning;\n}\n.progress-bar-danger{\n    background-color: $danger;\n}\n.progress.attendance{\n    width: 127px;\n    height: 7px;\n}\n.badges-inactive.Holiday{\n    color: $purple;\n    border: 1px solid $purple;\n}\n.modal-deletecontent{\n    padding: 24px;\n    .feather-xcircircle{\n        display: flex;\n        width: 40px;\n        height: 40px;\n        justify-content: center;\n        align-items: center;\n         color: $danger;\n         margin: auto;\n    }\n    h4{\n        padding: 20px 0 5px 0;\n        text-align: center;\n        color: $secondary;\n        font-size: $font-size-20;\n         font-weight: $font-weight-bold;\n    }\n    p{\n        text-align: center;\n        color: $text-color;\n        font-size: $font-size-15;\n        font-weight: $font-weight-normal;\n    }\n    .modal-footer-btn{\n        &.delete{\n            text-align: center;\n        }\n    }\n}\n",".page-wrapper {\n    .content {\n        &.settings-content {\n            background-color: $white;\n            padding-bottom: 24px;\n        }\n    }\n}\n.settings-pg-header {\n    padding-bottom: 24px;\n    border-bottom: 1px solid rgba(145, 158, 171, 0.30);\n}\n.sidebars {\n    &.settings-sidebar {\n        position: relative;\n        z-index: 1;\n        top: unset;\n        left: unset;\n        bottom: unset;\n        width: 309px;\n        margin-right: 24px;\n        border-right: 0;\n        border: 1px solid rgba(145, 158, 171, 0.30);\n        border-radius: 8px;\n        @include respond-below(custom1399) {\n            width: 250px;\n        }\n        @include respond-below(custom1199) {\n            width: 200px;\n            margin-right: 15px;\n        }\n        @include respond-below(custom991) {\n            display: none;\n        }\n        .slimScrollDiv {\n            background-color: transparent;\n            width: 309px !important;\n            @include respond-below(custom1399) {\n                width: 250px !important;\n            }\n            @include respond-below(custom1199) {\n                width: 200px !important;\n            }\n        }\n        .theiaStickySidebar {\n            width: 100% !important;\n            margin-top: 10px;\n        }\n        .sidebar-menu {\n            padding: 10px 15px;\n            @include respond-below(custom1199) {\n                padding: 10px 8px;\n            }\n            .menu-arrow {\n                background-color: $white;\n                right: 5px;\n                &::before {\n                    border-left: 1px solid $text-color;\n                    border-bottom: 1px solid $text-color;\n                    border-right: none;\n                    color: $text-color;\n                }\n            }\n            .submenu-open {\n                ul {\n                    margin: 0;\n                    border-bottom: 0;\n                    padding: 0;\n                    .submenu {\n                        a {\n                            &.active {\n                                background-color: $white;\n                                &.subdrop {\n                                    background-color: $white;\n                                    margin-bottom: 10px;\n                                }\n                                .menu-arrow {\n                                    background-color: $white;\n                                }\n                                .menu-arrow {\n                                    &::before {\n                                        border-color: $text-color;\n                                    }\n                                }\n                            }\n                            &.subdrop {\n                                .menu-arrow {\n                                    background-color: $white;\n                                    transform: rotate(180deg);\n                                    -webkit-transform: rotate(180deg);\n                                    -ms-transform: rotate(180deg);\n                                    color: $secondary;\n                                }\n                            }\n                            svg {\n                                color: $secondary;\n                            }\n                            span {\n                                color: $secondary;\n                                font-weight: $font-weight-semibold;\n                                font-size: $font-size-16;\n                                @include respond-below(custom1199) {\n                                    font-size: $font-size-base;\n                                }\n                            }\n                        }\n                        ul {\n                            li {\n                                a {\n                                    margin-left: 0;\n                                    &::after {\n                                        display: none;\n                                    }\n                                    &.active {\n                                        background-color: rgba(254, 159, 67, 0.08);\n                                        color: $primary;\n                                        border-radius: 8px;\n                                        padding: 10px 18px;\n                                        &::after {\n                                            content: \"\";\n                                            width: 7px;\n                                            height: 7px;\n                                            border-radius: 50%;\n                                            background-color: $primary;\n                                            right: 10px;\n                                            left: unset;\n                                            border: 0;\n                                            position: absolute;\n                                            display: block;\n                                        }\n                                    }\n                                }\n                            }\n                        }\n                    }     \n                }\n                \n            }\n        }\n    }\n}\n.settings-page-wrap {\n    flex: 1;\n    .setting-title {\n        h4 {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n            margin-bottom: 20px;\n            padding-bottom: 20px;\n            border-bottom: 1px solid rgba(145, 158, 171, 0.30);\n        }\n    }\n    .card-title-head {\n        h6 {\n            border-bottom: 0;\n            padding-bottom: 0;\n        }\n       \n    }\n    .new-employee-field {\n        span {\n            color: $text-color;\n            font-size: $font-size-base;\n            display: block;\n            margin-top: 5px;\n        }\n    }\n}\n.table-top-head {\n    .feather-rotate-ccw {\n        height: 16px;\n    }\n}\n.security-settings {\n    .no-pagination {\n        .dataTables_filter {\n            display: none\n        }\n        table {\n            margin-top: 24px !important;\n            thead>tr>th.sorting:before {\n                display: none\n            }\n            thead>tr>th.sorting:after {\n                display: none\n            }\n        }\n    \n    }\n    ul {\n        li {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            margin-bottom: 20px;\n            &:last-child {\n                margin-bottom: 0\n            }\n            @include respond-below(custom575) {\n                display: block;\n            }\n            .security-type {\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                @include respond-below(custom575) {\n                    margin-bottom: 20px;\n                }\n                .security-icon {\n                    width: 60px;\n                    height: 60px;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    background-color: $body-bg;\n                    border-radius: 10px;\n                    margin-right: 10px;\n                    flex-shrink: 0;\n                    svg {\n                        color: $primary;\n                    }\n                }\n            }\n            .security-title {\n                h5 {\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-bold;\n                }\n                p {\n                    color: $text-color;\n                    font-size: $font-size-15;\n                }\n            }\n            .security-btn {\n                .btn-danger {\n                    background-color: $danger;\n                    &:hover {\n                        border-color: $secondary;\n                        background-color: $secondary;\n                    }\n                }\n                .badges-connected {\n                    background: rgba(40, 199, 111, 0.05);\n                    color: $success;\n                    border: 1px solid $success;\n                    padding: 3px 6px;\n                    border-radius: 6px;\n                }\n                .fa-check-circle {\n                    color: $success;\n                }\n                .remove-red {\n                    color: $danger;\n                    font-weight: $font-weight-bold;\n                }\n                .manage-btn {\n                    border: 1px solid var(--Stroke, rgba(145, 158, 171, 0.30));\n                    padding: 8px 20px;\n                    color: $secondary;\n                    border-radius: 5px;\n                }\n            }\n        }\n    }\n}\n.mini-sidebar {\n    .sidebars.settings-sidebar {\n        .sidebar-menu {\n            .submenu-open {\n                ul {\n                    .submenu {\n                        .menu-arrow {\n                            display: block !important;\n                        } \n                        .subdrop ~ ul{\n                            display: block !important;\n                        }\n                    } \n                }\n            } \n        } \n    } \n}\n.settings-bottom-btn {\n    margin-top: 40px;\n}\n.connected-app-card {\n    &.email-setting {\n        .security-title {\n            h5 {\n                font-weight: $font-weight-bold;\n                font-size: $font-size-18;\n            }\n        }\n    }\n    ul {\n        background-color: $white;\n        padding: 24px;\n        box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\n        border-radius: 8px;\n        margin-bottom: 24px;\n        li {\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: space-between;\n            -webkit-justify-content: space-between;\n            -ms-flex-pack: space-between;\n            margin-bottom: 20px;\n            &:last-child {\n                margin-bottom: 0;\n            }\n            .connect-btn {\n                a {\n                    border: 1px solid $success;\n                    color: $success;\n                    background-color: rgba(40, 199, 111, 0.05);\n                    padding: 3px 5px;\n                    border-radius: 5px;\n                    font-size: $font-size-base;\n                }\n                &.not-connect {\n                    a {\n                        border-color: $gray-100;\n                        color: $secondary;\n                        background-color: $white;\n                        font-weight: $font-weight-semibold;\n                    }\n                }\n            }\n            .security-title {\n                h5 {\n                    font-weight: $font-weight-semibold;\n                    font-size: $font-size-16;\n                }\n            }\n            .system-app-icon {\n                width: 40px;\n                height: 40px;\n                border-radius: 8px;\n                background-color: $body-bg;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                margin-right: 8px;\n                flex-shrink: 0;\n            }\n            p {\n                font-size: $font-size-13;\n                color: $text-color;\n                font-weight: $font-weight-medium;\n                margin-top: 5px;\n            }\n            .integration-btn {\n                a {\n                    border: 1px solid $gray-100;\n                    color: $secondary;\n                    background-color: $white;\n                    border-radius: 8px;\n                    padding: 5px 10px;\n                    font-weight: $font-weight-bold;\n                    display: flex;\n                    align-items: center;\n                }\n\n            }\n        }\n    }\n}\n.company-info {\n    border-bottom: 1px solid $gray-100;\n    margin-bottom: 24px;\n}\n.logo-company {\n    li {\n        margin-bottom: 20px;\n        @include respond-below(custom575) {\n            flex-direction: column !important;\n            align-items: start !important;\n        }\n        .logo-info {\n            margin-right: 100px;\n            @include respond-below(custom1199) {\n                margin-right: 40px;\n            }\n            @include respond-below(custom575) {\n                margin-bottom: 20px;\n            }\n            h6 {\n                font-size: $font-size-base;\n                font-weight: $font-weight-bold;\n            }\n            p {\n                font-size: $font-size-13;\n            }\n        }\n        .profile-pic-upload {\n            margin-right: 100px;\n            .image-upload {\n                width: 135px;\n                h4 {\n                    svg {\n                        width: 16px;\n                        height: 16px;\n                        margin-right: 8px;\n                    }\n                }\n            }\n\n        }\n        .new-logo {\n            text-align: right;\n            @include respond-below(custom575) {\n                text-align: left;\n                margin-left: 0 !important;\n                margin-top: 20px;\n            }\n            a {\n                width: 60px;\n                height: 60px;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                border: 1px solid $gray-100;;\n                border-radius: 8px;\n                position: relative;\n                span {\n                    width: 16px;\n                    height: 16px;\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    justify-content: center;\n                    -webkit-justify-content: center;\n                    -ms-flex-pack: center;\n                    background-color: $danger;\n                    border-radius: 5px;\n                    position: absolute;\n                    right: 4px;\n                    top: 4px;\n                    svg {\n                        color: $white;\n                    }\n                }\n            }\n        }\n    }\n}\n.localization-select {\n    width: 200px;\n    margin-bottom: 20px;\n    @include respond-below(custom1199) {\n        width: 150px;\n    }\n    &.fixed-width {\n        width: 70px;\n        span {\n            color: $text-color;\n        }\n    }\n    &.width-custom {\n        width: 150px;\n    }\n}\ntextarea {\n    resize: none;\n}\n.localization-info {\n    .setting-info {\n        margin-bottom: 20px;\n        h6 {\n            font-size: $font-size-base;\n            font-weight: $font-weight-bold;\n        }\n        p {\n            color: $text-color;\n        }\n    }\n}\n.appearance-settings {\n    h6 {\n        font-size: $font-size-base;\n        font-weight: $font-weight-bold;\n    }\n    p {\n        color: $text-color;\n    }\n    .theme-type-images {\n        .theme-image {\n            box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\n            background: $white;\n            border-radius: 8px;\n            border: 2px solid $white;\n            padding: 10px;\n            margin-right: 10px;\n            text-align: center;\n            &:last-child {\n                margin-right: 0;\n            }\n            span {\n                font-weight: $font-weight-medium;\n                margin-top: 10px;\n                display: block;\n            }\n            &.active {\n                border-color: $primary;\n                span {\n                    color: $primary;\n                }\n            }\n        }\n    }\n}\n.theme-colors {\n    ul {\n        display: flex;\n        align-items: center;\n        li {\n            margin-right: 10px;\n            span {\n                width: 35px;\n                height: 35px;\n                border-radius: 50%;\n                background-color: $primary;\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                cursor: pointer;\n                position: relative;\n                &.active {\n                    background-color: rgba(255, 159, 67, 0.3);\n                    &:after {\n                        content: \"\";\n                        width: 25px;\n                        height: 25px;\n                        background-color: $primary;\n                        border-radius: 50%;\n                        opacity: 1;\n                    }\n                }\n                &.theme-violet {\n                    background-color: rgba(115, 103, 240, 1);\n                    &.active {\n                        background-color: rgba(115, 103, 240, 0.3);\n                        &:after {\n                            background-color: rgba(115, 103, 240, 1);\n                        }\n                    }\n                }\n                &.theme-blue {\n                    background-color: rgba(40, 142, 199, 1);\n                    &.active {\n                        background-color: rgba(40, 142, 199, 0.3);\n                        &:after {\n                            background-color: rgba(40, 142, 199, 1);\n                        }\n                    }\n                }\n                &.theme-brown {\n                    background-color: rgba(210, 100, 0, 1);\n                    &.active {\n                        background-color: rgba(210, 100, 0, 0.3);\n                        &:after {\n                            background-color: rgba(210, 100, 0, 1);\n                        }\n                    }\n                }\n            }\n            &:last-child {\n                margin-right: 0;\n            }\n        }\n    }\n}\n.input-notify-info {\n    color: $text-color;\n    margin-top: 5px;\n    span {\n        color: $primary;\n    }\n}\n.pos-payment-method {\n    flex-wrap: wrap;\n    .custom-checkbox {\n        margin-right: 24px;\n        margin-bottom: 20px;\n        .checkboxs .checkmarks {\n            top: -1px;\n        }\n        .checkboxs {\n            padding-left: 21px;\n        }\n    }\n}\n.setting-gateway {\n    a {\n        svg {\n            color: rgba(91, 102, 112, 1);\n            width: 18px;\n            height: 18px;\n        }\n    }\n}\n.social-authent-settings {\n    .connected-app-card {\n        ul {\n            li {\n                &:first-child {\n                    padding-bottom: 20px;\n                    border-bottom: 1px solid $gray-100;\n                }\n\n            }\n        }\n    } \n}\n.bank-settings {\n    .btn-list,.btn-grid {\n        background-color: $body-bg;\n        width: 36px;\n        height: 36px;\n        border-radius: 8px;\n        display: -webkit-box;\n        display: -ms-flexbox;\n        display: flex;\n        align-items: center;\n        -webkit-box-align: center;\n        -ms-flex-align: center;\n        justify-content: center;\n        -webkit-justify-content: center;\n        -ms-flex-pack: center;\n        margin-block-end: unset;\n        svg {\n            width: 18px;\n            height: 18px;\n            color: $secondary;\n        }\n        &.active {\n            background-color: $primary;\n            svg {\n                color: $white;\n            }\n        }\n    }\n}\n.bank-box {\n    background: $secondary;\n    padding: 40px;\n    border-radius: 8px;\n    border: 1px solid $secondary;\n    position: relative;\n    margin-bottom: 24px;\n    &.active {\n        border-color: $success;\n        &::after {\n            position: absolute;\n            top: -8px;\n            right: -8px;\n            content: \"\\f058\";\n            font-family: \"Font Awesome 5 Free\";\n            font-weight: 900;\n            color: $success-900;\n            width: 22px;\n            height: 22px;\n            border-radius: 50%;\n            background-color: $white;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n        }\n    }\n    .bank-header {\n        .bank-name {\n            margin-bottom: 24px;\n            h6 {\n                color: $white;\n                font-size: $font-size-18;\n                font-weight: $font-weight-bold;\n                margin-bottom: 10px;\n            }\n            p {\n                color: $white;\n            }\n        }\n    }\n    .bank-info {\n        span {\n            color: $text-color;\n            font-size: $font-size-13;\n        }\n        h6 {\n            color: $white;\n            font-size: $font-size-18;\n            font-weight: $font-weight-medium;\n        }\n    }\n}\n.bank-action-btn {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    align-items: center;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    justify-content: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    a {\n        border: 1px solid $gray-100;\n        border-radius: 8px;\n        svg {\n            width: 14px;\n            height: 14px;\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            &.feather-edit {\n                color: $blue;\n            }\n            &.feather-trash-2 {\n                color: $danger;\n            }\n        }\n    }\n}\n.storage-icon {\n    h6 {\n        font-weight: $font-weight-semibold;\n        font-size: $font-size-16;\n    }\n}\nsvg {\n    &.filter-icon {\n        width: 18px;\n        height: 18px;\n        color: $white;\n    } \n}\n.search-path .btn-filter.setclose > .filter-icon {\n    display: none;\n}\n.page-header .select-language .select2-container .select2-selection--single {\n    height: 41px;\n    width: 160px;\n}\n.language-progress {\n    .progress-bar-warning {\n        width: 80%;\n    }\n    .progress-bar-success {\n        width: 100%;\n    }\n    .progress-bar-violet {\n        background-color: $purple;\n        width: 5%;\n    }\n    .progress-bar-violet-two {\n        background-color: $purple;\n        width: 40%;\n    }\n    span {\n        position: absolute;\n        right: 0;\n        top: -20px;\n        color: $secondary;\n    }\n}\n.table tbody td.action-table-data {\n    .language-action {\n        a {\n            border: 0;\n            color: $white;\n            &:hover {\n                background-color: $primary;\n            }\n            &.language-import {\n                background-color: $body-bg;\n                svg {\n                    color: $secondary;\n                    width: 18px;\n                    height: 18px;\n                }\n                &:hover {\n                    background-color: $primary;\n                    svg {\n                        color: $white;\n                    }\n                }\n            }\n        }\n        .checkboxs .checkmarks {\n            top: -5px;\n        }\n    }\n}\n.selected-language {\n    border: 1px solid $gray-100;\n    padding: 5px 10px;\n    border-radius: 8px;\n    color: $secondary;\n}\n.back-btn {\n    a {\n        &.btn-translation {\n            background-color: $gray-100;\n            border-radius: 5px;\n            font-weight: $font-weight-medium;\n            svg {\n                color: $secondary;\n            }\n            &:hover {\n                background-color: $primary;\n                color: $white;\n                svg {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\ntd {\n    span {\n        &.file-data {\n            color: $blue;\n            font-weight: $font-weight-medium;\n        }\n    }\n}\nth {\n    &.fixed-width {\n        width: 570px;\n    }\n}",".file-manager {\n    color:  $text-color;\n    .search-dropdown {\n        height: auto;\n    }\n    .form-sort {\n        width:  auto;\n        .select2-container--default .select2-selection--single .select2-selection__rendered {\n            padding-right: 27px;\n        }\n        &.owned-by {\n            margin-right: 10px;\n        }\n    }\n    &.notes-page-wrapper { \n        .content {\n            .page-add-notes {\n                padding-bottom: 30px;\n                margin-bottom: 30px;\n            }\n            .section-bulk-wrap {\n                margin-top: 0;\n                .form-sort {\n                    svg {\n                        &.fa-filter {\n                            top: 50%;\n                            @include transform(translateY(-50%));                            \n                        }\n                    }\n                }\n                .bulk-action-type {\n                    .select-bluk {\n                        margin-right: 15px;\n                    }\n                }\n            }\n        }\n    }\n    .page-header {\n        .btn-added {\n            margin-left: 10px;\n        }\n        .form-sort {\n            @include respond-below(custom575) {\n                margin-top: 0;\n                margin-bottom:  15px;\n            }\n        }\n        .table-top-head {\n            @include respond-below(custom575) {\n                margin-bottom: 15px;\n            }\n            li {\n                &:last-child {\n                    @include respond-below(custom991) {\n                        margin-right: 0;\n                    }\n                }\n            }\n        }\n    }\n    .bulk-action-type {\n        @include respond-below(custom767) {\n            align-items: start!important;\n        }\n        @include respond-below(custom575) {\n            display: block!important;\n        }\n        @include respond-below(custom767) {\n            .form-sort {\n                margin-top: 0;\n                margin-bottom: 15px;\n                width: 100%;\n            }\n        }\n    }\n    aside {\n        border: 1px solid $gray-400;\n        box-shadow: $box-shadow;\n        @include rounded(8px);\n        h5 {\n            font-size: $font-size-18;\n            font-weight: $font-weight-bold;\n            border-bottom:  1px solid $gray-100;\n            @include margin-padding(0 0 15px 0, 0 0 15px 0);\n        }\n        .btn {\n            font-weight: $font-weight-bold;\n        }\n        .dropdown {\n            > a { \n                width: auto;\n                height: auto;\n                color:  $white;\n                @include rounded(8px);\n                &:hover, &:focus {\n                    border-color: $secondary;\n                    background: $secondary;\n                }\n            }\n            ul {\n                width: 100%;\n                li {\n                    a {\n                        font-size: $font-size-15;\n                    }\n                }\n            }\n        }\n        ul {\n            li {\n                a {\n                    display: -webkit-box;\n                    display: -ms-flexbox;\n                    display: flex;\n                    align-items: center;\n                    -webkit-box-align: center;\n                    -ms-flex-align: center;\n                    color: $text-color;\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-semibold;\n                    @include margin-padding(0 0 5px 0, 7px 10px);\n                    @include rounded(5px);\n                    span {\n                        display: -webkit-box;\n                        display: -ms-flexbox;\n                        display: flex;\n                        align-items: center;\n                        -webkit-box-align: center;\n                        -ms-flex-align: center;\n                    }\n                    &:hover, &.active {\n                        background: $secondary;\n                        color: $white;\n                    }\n                }\n            }\n        }\n        span {\n            font-size: $font-size-13;\n            font-weight: $font-weight-medium; \n        }\n        h6 {\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            position: relative;\n            z-index: 2;\n        }\n        .space-manager {\n            color:  $white;\n            background: $secondary;\n            @include rounded(8px);\n            position: relative;\n            img {\n                @include position(absolute,0,0,null,null);\n            }\n            h6 {\n                a {\n                    color:  $white;\n                }\n            }\n            p {\n                color:  $sub-title;\n            }\n        }\n    }\n    .progress {\n        height: 6px;\n        @include rounded(5px);\n    }\n    .search-set {\n         .search-input {\n            input[type=search] {\n                width:  170px;\n                height: 40px;\n            }\n\n         }\n\n    }\n    .budgeted-role-notes {\n        .search-set {\n            .search-input {\n                input[type=search] {\n                    width:  298px;\n                }\n            }\n        }\n    }\n    h4 {\n        font-size: $font-size-18;\n        font-weight: $font-weight-semibold;\n    }\n    h6 {\n        font-size: $font-size-16;\n        font-weight: $font-weight-semibold;\n        a {\n            color: $secondary;\n            &:hover {\n                color: $primary;\n            }\n        }\n    }\n    .overview {\n        .detail {\n            a {\n                &.bg {\n                    @include rounded(8px 8px 0 0);\n                    span {\n                        width: 66px;\n                        height: 66px;\n                        @include rounded(100%);\n                        img {\n                            @include transition(all 0.5s ease);\n                        }\n                    }\n                }\n                &:hover {\n                    img {\n                        transform: scale(1.2);\n                    }\n                }\n            }\n        }\n    }\n    .info {\n        @include rounded(0 0 8px 8px);\n        padding: 15px;\n        background: $white;\n        box-shadow: $box-shadow;\n        span {\n            color:  $text-color;\n            font-size: $font-size-13;\n        }\n    }\n    .folders {\n        border: 1px solid $gray-100;\n        box-shadow: $box-shadow;\n        @include rounded(8px);\n        background: $white;\n        width: 320px;\n        h6 {\n            width: 100%;\n            white-space: nowrap;\n            text-overflow: ellipsis;\n            overflow: hidden;\n            margin-right: 8px;\n        }\n    }\n\n    .dropdown {\n        > a {\n            color: $secondary;\n            width: 25px;\n            height: 25px;\n            @include transition(all 0.5s ease);\n            @include rounded(100%);\n            display: -webkit-box;\n            display: -ms-flexbox;\n            display: flex;\n            align-items: center;\n            -webkit-box-align: center;\n            -ms-flex-align: center;\n            justify-content: center;\n            -webkit-justify-content: center;\n            -ms-flex-pack: center;\n            &:hover {\n                background: $primary;\n                i {\n                    color: $white;\n                }\n            }\n        }\n    }\n    .project-plan {\n        font-size: $font-size-13;\n        font-weight: $font-weight-semibold;\n        margin-top: 10px;\n        label {\n            color: $secondary;\n            margin-right: 9px;\n            font-size: $font-size-13;\n        }\n        ul {\n            li {\n                font-size: $font-size-13;\n                position: relative;\n                padding: 0 9px 0 14px;\n                color:  $text-color;\n                &:before {\n                    content:  '';\n                    @include position(absolute,50%,null,null,0);\n                    @include transform(translateY(-50%));\n                    width: 5px;\n                    height: 5px;\n                    background: $gray-400;\n                    @include rounded(5px);\n                }\n            }\n        }\n    }\n    .avatar-wrap {\n        a {\n            svg {\n                color: $text-color;\n            }\n            &:hover {\n                svg {\n                    color: $primary; \n                }\n            }\n        }\n    }\n    .accordion {\n        border:  none;\n        --bs-accordion-border-width: none;\n        .accordion-item {\n            border:  none;\n            border-bottom: 1px solid $gray-100;\n            background: none;\n            &:last-of-type {\n                border-bottom-right-radius: 0;\n                border-bottom-left-radius: 0;\n                border-bottom: none;\n            }\n            .accordion-button {\n                background: none;\n                border:  none;\n                font-size: $font-size-18;\n                font-weight: $font-weight-semibold;\n                color: $secondary;\n                padding: 0;\n                display: inline-block;\n                width: auto;\n                &:after {\n                    @include transition(all 0.8s ease);\n                    background-image: none;\n                    content: \"View All\";\n                    font-family: \"Nunito\", sans-serif;\n                    font-size: $font-size-base;\n                    font-weight: $font-weight-bold;\n                    color: $text-color;\n                    transform:  none;\n                    width: 60px;\n                    text-align: right;\n                }\n                &:not(.collapsed)::after {\n                    content: \"Hide\";\n                }\n                &.collapsed {\n                    padding: 0;\n                }\n                &:hover {\n                    &:after {\n                        color: $primary;\n                    }\n                }\n            }\n            .accordion-body {\n                border: none;\n                padding: 0;\n                .head {\n                    img {\n                        min-width: 32px;\n                        width:  32px;\n                        height: 32px;\n                    }\n                }\n                .owl-carousel {\n                    padding-top: 15px;\n                }\n            }\n\n        }\n    }\n    .owl-carousel {\n        .owl-item {\n            margin-left: -0.1px!important;\n        }\n        .dropdown-menu {\n            left: auto !important;\n            right: 0 !important;\n            top:  27px !important;\n            transform: none !important;\n            background: $white !important;\n            box-shadow: $box-shadow;\n            z-index: 99999 !important;\n        }\n        .owl-nav {\n            top: -26px;\n            left: 43px;\n            display: inline-table;\n            button {\n                margin-top: 0;\n                margin-bottom: 0;\n                background: none;\n                cursor: pointer;\n                &.owl-next, &.owl-prev {\n                    position: relative;\n                    width: 15px;\n                    i {\n                        color: $text-color;\n                    }\n                    &:hover {\n                        background: none;\n                        i {\n                           color: $primary;\n                        }\n                    }\n                }\n            }\n        }\n        &.folders-carousel {\n           .owl-nav {\n                left:  75px;\n            } \n        }\n        &.video-section {\n            .owl-nav {\n                left:  60px;\n            }\n            .info {\n                a {\n                    svg {\n                        color: $text-color;\n                    }\n                }\n            }\n        }\n    }\n    .all-files {\n        box-shadow: $box-shadow;\n        border: none;\n        .btn-grp {\n            a {\n                padding: 6px 8px;\n                @include rounded(8px);\n                cursor: pointer;\n                display: -webkit-box;\n                display: -ms-flexbox;\n                display: flex;\n                align-items: center;\n                -webkit-box-align: center;\n                -ms-flex-align: center;\n                justify-content: center;\n                -webkit-justify-content: center;\n                -ms-flex-pack: center;\n                @include respond-below(custom575) {\n                    margin-bottom: 15px;\n                    display: inline-block;\n                }\n                &.btn-outline-secondary {\n                    color:  $text-color;\n                    background: $body-bg;\n                    border-color: $body-bg;\n                }\n                &:hover {\n                    background: $secondary;\n                    border-color: $secondary;\n                    color: $white;\n                }\n            }\n        }\n        .table { \n            tbody {\n                tr { \n                    td {  \n                        display: table-cell;\n                        font-size: $font-size-base;\n                        font-weight: $font-weight-medium;\n                        white-space: nowrap;\n                        a {\n                            font-size: $font-size-base;\n                            font-weight: $font-weight-medium;\n                            &.product-img { \n                                img {\n                                    width: 32px;\n                                    height: 32px;\n                                    border: 0;\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n    #file-delete {\n        font-size: $font-size-base;\n    }\n}\n.color-primary {\n    color:  $text-color;\n}\n.icon-select {\n    position: relative;\n    width: 149px;\n    height: 38px;\n\n    .icon {\n        @include position(absolute,50%,null,null,10px);\n        @include transform(translateY(-50%));\n        z-index: 100;\n    }\n    .select2-container--default .select2-selection--single .select2-selection__rendered {\n        padding-left: 30px;\n    }\n}\n.bg-light-orange {\n    background: $primary-200;\n    span {\n        background: $primary-200;\n    }\n}\n.bg-light-red {\n    background: $danger-200;\n    span {\n        background: $danger-200;\n    }\n}\n.bg-light-green {\n    background: $success-300;\n    span {\n        background: $success-300;\n    }\n}\n.seprator-sm {\n    @include margin-padding(0 0 24px 0, 0 0 9px 0);\n    border-bottom: 1px solid $gray-100;\n}\n.seprator-lg {\n    @include margin-padding(0 0 24px 0, 0 0 24px 0);\n    border-bottom: 1px solid $gray-100;\n}\n.group-avatar {\n    .avatar {\n        position: relative;\n        width: 43px;\n        height: 43px;\n        line-height: 43px;\n        margin: 0;\n    \n         & +.avatar {\n            margin-left: -1.2rem;\n        }\n        &:hover {\n            z-index: 1;\n        }\n    }\n    .count {\n        a { \n            color: $success;\n            line-height: 27px;\n            font-size: $font-size-13;\n            font-weight: $font-weight-medium;\n            &:hover {\n                color: $primary;\n            }\n        }\n    }\n    .avatar img {\n      display: block;\n      border-radius: 100%;\n      width: 100%;\n      border: 2px solid $white;\n    }\n}\n\n.video-section .item{\n  opacity:0.4;\n  transition:.4s ease all;\n  transform:scale(.8);\n}\n\n@media(max-width:1000px){\n  .video-section .item{margin:0; transform:scale(.9)}\n}\n\n.video-section .active .item{\n  opacity:1;\n  transform:scale(1);\n} \n\n.video-section .owl-item {\n    -webkit-backface-visibility: hidden;\n    -webkit-transform: translateZ(0) scale(1.0, 1.0);\n}\n\n.video-section video{\n  max-width:100%;\n  height:100%;\n  @include rounded(10px 10px 0 0);\n}\n.delete-alert {\n    padding: 10px 20px;\n    background: $danger-200;\n    border:  none;\n    @include rounded(8px);\n    p {\n        font-size: $font-size-15;\n    }\n    .btn {\n        font-weight: $font-weight-bold;\n    }\n}\n.deleted-info {\n    display: none;\n    .bin-bg {\n        width: 184px;\n        height: 184px;\n        @include rounded(100%);\n        background: $light;\n        margin: 0 auto;\n    }\n}\n.popup-toggle {\n    cursor: pointer;\n}\n.toggle-sidebar {\n    width: 456px;\n    padding: 25px;\n    position: fixed;\n    right: -456px;\n    top: 0;\n    height: 100%;\n    background: $white;\n    z-index: 100001;\n    border-top-left-radius: 15px;\n    border-bottom-left-radius: 15px;\n    box-shadow: rgba(50, 50, 93, 0.25) 0px 13px 27px -5px, rgba(0, 0, 0, 0.3) 0px 8px 16px -8px;\n    overflow-y: auto;\n    @include transition(all 0.5s ease);\n    @include respond-below(custom575) {\n        width: 320px;\n        right: -320px;\n    }\n    &.open-sidebar {\n        right: 0;\n        @include transition(all 0.5s ease);\n    }\n    .head {\n        .color-primary {\n            &:hover {\n                color: $danger;\n            }\n        }\n    } \n    h4, h5 {\n        font-weight: $font-weight-bold;\n    }\n    h4 {\n        font-size: $font-size-20;\n    }\n    h5 {\n        font-size: $font-size-18;\n    }\n    h6 {\n         font-size: $font-size-15;\n        font-weight: $font-weight-semibold;\n    }\n    .nav-tabs {\n        border-bottom: 1px solid $gray-100;\n        .nav-link {\n            padding: 8px 20px;\n            font-size: $font-size-16;\n            font-weight: $font-weight-semibold;\n            @include rounded(8px);\n            border: none;\n            background: $body-bg;\n            color: $secondary;\n            &:hover, &.active {\n                background: $primary;\n                color: $white;\n            }\n        }\n    }\n    .tab-content {\n        .tab-pane {\n            ul {\n                li {\n                    h6 {\n                        margin-bottom: 5px;\n                    }\n                    p {\n                        &.location {\n                            background: $body-bg;\n                            border: 1px solid $gray-100;\n                            @include rounded(5px);\n                            padding: 5px;\n                            display: inline-block;\n                            img {\n                                width: 20px;\n                                height: 20px;\n                            }\n                        }\n                    }\n                    .note-editor.note-airframe .note-statusbar, .note-editor.note-frame .note-statusbar {\n                        border-top: none;\n                    }\n                }\n            }\n            .avatar-access {\n                span {\n                    a {\n                        display: inline-flex; \n                        margin-right: 3px;\n                        padding-right: 3px;\n                    }\n                    &:first-child {\n                        a {\n                            margin-right: 10px;\n                            padding-right: 10px;\n                            border-right: 1px solid $gray-100;\n                        }\n                    }\n                    &:last-child {\n                        a {\n                            margin-right: 0;\n                            padding-right: 0;\n                        }\n                    }\n                    .add {\n                        background: $primary;\n                        color:  $white;\n                        &:hover {\n                            background: $secondary;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    p {\n        color: $text-color;\n        font-size: $font-size-15;\n    }\n    .show-all {\n        font-weight: $font-weight-bold;\n        &:hover {\n            color: $secondary;\n        }\n    }\n\n}\n.text-danger {\n    color: $danger!important;\n}\n.avatar-md {\n    width: 45px;\n    height: 45px;\n    @include rounded(45px);\n}\n.text-secondary {\n    color: $secondary!important;\n}\n.text-primary {\n    color: $primary!important;\n}\n.text-default {\n    color: $text-color;\n}","$__basecolor: #2c3038;\n\n.css-1u9des2-indicatorSeparator {\n  display: none;\n}\n\n.ant-tooltip {\n  display: none;\n}\n\n:where(.css-dev-only-do-not-override-1qhpsh8).ant-picker-outlined {\n  background: #ffffff;\n  border-width: 1px;\n  border-style: solid;\n  border-color: #dbe0e6;\n  width: 300px;\n  height: 40px;\n}\n\n.ant-picker-suffix {\n  display: none;\n}\n\n.swal2-confirm {\n  background-color: #ff8d1f !important;\n  border: 1px solid #ff8d1f !important;\n  box-shadow: 0 3px 10px rgba(255, 159, 67, 0.5);\n  color: #ffffff !important;\n}\n\n.worldmap__figure-container {\n  height: 247px !important;\n}\n\n.badge.badge-linesuccess a,\n.badges-success {\n  color: #28c76f;\n}\n\n.filterdatepicker {\n  width: 217px;\n  height: 43px;\n}\n\n\n.ant-table-wrapper .ant-table-column-title {\n  z-index: 0 !important;\n}\n\n.toast-header .btn.btn-close {\n  display: none;\n}\n\n.text-primary .toast-body {\n  background: rgba(255, 159, 67, 0.1) !important;\n}\n\n.swal2-container .swal2-title {\n  font-size: 18px !important;\n}\n\n.rsw-toolbar {\n  height: 40px !important;\n}\n\n.rsw-ce {\n  height: 350px !important;\n}\n\n.linestripe {\n  text-decoration: line-through;\n  opacity: 0.5;\n}\n\n.clipboardcopyedvalue {\n  color: orange;\n}\n\n#infoToast .toast-body {\n  color: #17a2b8;\n  background-color: #e7f6f8;\n}\n\n#primaryToast .toast-body,\n#warningToast .toast-body {\n  color: #ff9f43;\n  background-color: #fff5ec;\n}\n\n#secondaryToast .toast-body {\n  color: #092c4c;\n  background-color: #e6e9ed;\n}\n\n#successToast .toast-body {\n  color: #28c76f;\n  background-color: #e9f9f0;\n}\n\n#dangerToast .toast-body {\n  color: #ff0000;\n  background-color: #ffe5e5;\n}\n\n.formsearch {\n  height: 38px;\n  width: 275px;\n}\n\n.css-1p3m7a8-multiValue {\n  background-color: #17a2b8 !important;\n}\n\n.twitter-bs-wizard .twitter-bs-wizard-nav .step-icon {\n  display: inline-block;\n  width: 56px;\n  height: 56px;\n  line-height: 54px;\n  border: 1px solid rgba(81, 86, 190, 0.2);\n  color: #5156be;\n  text-align: center;\n  border-radius: 50%;\n  position: relative;\n  z-index: 1;\n  font-size: 20px;\n}\n\n.twitter-bs-wizard .twitter-bs-wizard-nav .nav-link {\n  font-size: 14px;\n  position: relative;\n}\n\n.twitter-bs-wizard .twitter-bs-wizard-nav .nav-link::after {\n  content: \"\";\n  position: absolute;\n  width: 75%;\n  height: 2px;\n  background-color: #e9e9ef;\n  left: 62%;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.custom-search {\n  position: relative;\n  top: -28px;\n  left: 10px;\n}\n\n.daterange-wraper {\n  border: 0px solid;\n  border-radius: 4px;\n  border-color: hsl(0, 0%, 80%);\n}\n\n[data-layout-style=horizontal] {\n  .sidebar {\n      display: none;\n      &.horizontal-sidebar {\n          display: block;\n      }\n      @include respond-below(custom991) {\n          display: block;\n          &.horizontal-sidebar {\n              display: none;\n          }\n      }\n      .sidebar-menu > ul > li > a.active svg {\n          color: $primary;\n      }\n  }\n  .page-wrapper {\n      margin-left: 0;\n      padding-top: 140px;\n  }\n  .header #toggle_btn {\n      display: none;\n  }\n  .sidebar .sidebar-menu {\n      > ul > li.submenu ul {\n          background: rgb(246, 246, 246);\n      }\n      .nav {\n          > li {\n              > ul {\n                  max-height: 400px;\n                  overflow-x: hidden;\n                  overflow-y: auto;\n              }\n          }\n      }\n  } \n  body {\n      &.header-collapse {\n          .header {\n              display: none;\n          }\n          .horizontal-sidebar {\n              top: 0;\n              border-top: 0;\n          }\n          .page-wrapper {\n              padding-top: 60px;\n          }\n      }\n  }\n  @include respond-below(custom991) {\n      .sidebar {\n          &.collapsed-sidebar {\n              display: none;\n          }\n      }\n      .page-wrapper {\n          padding-top: 80px;\n      }\n  }\n}\n\n[data-nav-color=\"grey\"] .sidebar {\n  background: #eff2f7;\n}\n\n\n:where(.css-dev-only-do-not-override-1b0bdye).ant-pagination\n  .ant-pagination-item-active {\n  font-weight: 600;\n  border-color: #ff9f43;\n  border-radius: 15px;\n  background-color: #ff9f43;\n  color: #fff;\n}\n\n:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper\n  .ant-table-pagination.ant-pagination {\n  margin: 0px 0;\n}\n\n.ant-select-selection-item {\n  border: none !important;\n}\n\nul.tabs.owl-carousel.pos-category {\n  display: flex;\n}\n\n// .pos-design .slick-track {\n//   width: 100% !important;\n// }\n// .pos-design .slick-slide {\n//   width: 100% !important;\n// }\n.tabs_wrapper ul.tabs div {\n  background-color: #ffffff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  padding: 15px 0;\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  text-align: center;\n  cursor: pointer;\n  border: 1px solid #f3f6f9;\n  box-shadow: 0px 4px 60px 0px rgba(231, 231, 231, 0.47);\n  -webkit-transition: all 0.5s ease;\n  -ms-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n  border-radius: 8px;\n  margin-left: -0.1px !important;\n}\n\n.tabs_wrapper ul.tabs li h6 {\n  font-size: 15px;\n  font-weight: 600;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-top: 10px;\n  width: 100%;\n  margin-bottom: 5px;\n}\n\n.tabs_wrapper ul.tabs li span {\n  color: #5b6670;\n}\n\n.tabs_wrapper ul.tabs li:last-child {\n  margin-right: 0;\n}\n\n.pos-design .tabs_wrapper .slick-arrow.slick-prev::before {\n  content: \"\\f053\";\n  width: 12px;\n  height: 12px;\n  font-size: 12px;\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n  color: #092c4c;\n}\n\n.pos-design .tabs_wrapper .slick-arrow.slick-next::before {\n  content: \"\\f054\";\n  width: 12px;\n  height: 12px;\n  font-size: 12px;\n  font-family: \"Font Awesome 6 Free\";\n  font-weight: 900;\n  color: #092c4c;\n}\n\n.pos-categories {\n  position: relative;\n}\n\n\n:where(.css-dev-only-do-not-override-1b0bdye).ant-picker-dropdown {\n  z-index: 2000 !important;\n}\n\n.mini-sidebar .active.subdrop ~ ul {\n  display: none !important;\n}\n\n.pos-category .slick-slide {\n  list-style: none;\n  cursor: pointer;\n  display: inline-block;\n  border-radius: 5px;\n  color: white;\n  font-family: sans-serif;\n  // width: 100%;\n  padding: 15px 0;\n  background: $white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin-right: 8px;\n}\n\n.pos-category .slick-track .slick-slide:last-child {\n  margin-right: 0;\n}\n\n.pos-slick-item a {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.pos-slick-item span {\n  color: #5b6670;\n}\n\n.pos-slick-item h6 {\n  font-size: 15px;\n  font-weight: 600;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  margin-top: 10px;\n  width: 100%;\n  margin-bottom: 5px;\n}\n\n.owl-carousel.pos-category .slick-prev {\n  left: unset;\n  right: 60px;\n  top: -50px;\n  background-color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 28px;\n}\n\n.owl-carousel.pos-category .slick-prev:hover,\n.owl-carousel.pos-category .slick-next:hover {\n  background-color: #ff9f43;\n}\n\n.owl-carousel.pos-category .slick-next {\n  left: unset;\n  right: 20px;\n  top: -50px;\n  background-color: white;\n  width: 28px;\n  height: 28px;\n  border-radius: 28px;\n}\n\n.ant-table-wrapper\n  .ant-table-tbody\n  .ant-table-row.ant-table-row-selected\n  > .ant-table-cell {\n  background: white !important;\n}\n\n.ant-table-wrapper tfoot > tr > td {\n  position: relative;\n  padding: 2px 16px;\n  overflow-wrap: break-word;\n}\n\n:where(.css-dev-only-do-not-override-1b0bdye).ant-checkbox-checked\n  .ant-checkbox-inner {\n  background-color: #ff9f43;\n  border-color: #ff9f43;\n}\n\n.iconsize {\n  height: 16px !important;\n}\n\n[data-layout-mode=\"dark_mode\"]\n  .ant-table-content\n  table\n  thead.ant-table-thead\n  tr\n  th {\n  background: #141432;\n  border-bottom: 1px solid #141432;\n}\n\n[data-layout-mode=\"dark_mode\"]\n  .ant-table-content\n  table\n  thead.ant-table-thead\n  tr\n  th {\n  background: #141432;\n  border-bottom: 1px solid #141432;\n}\n\n[data-layout-mode=\"dark_mode\"]\n  :where(.css-dev-only-do-not-override-1b0bdye).ant-checkbox\n  .ant-checkbox-inner {\n  background: #141432;\n}\n\n[data-layout-mode=\"dark_mode\"]\n  .ant-spin-nested-loading\n  .ant-spin-container\n  ul.ant-pagination.ant-table-pagination {\n  background: #1d1d42;\n}\n\n[data-layout-mode=\"dark_mode\"]\n  :where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper\n  .ant-table-tbody\n  .ant-table-row.ant-table-row-selected\n  > .ant-table-cell {\n  background: #141432 !important;\n}\n\n.ant-table-content table thead.ant-table-thead tr th {\n  background: none;\n}\n\n:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper\n  .ant-table-column-sorters::after {\n  content: none;\n}\n\n:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper\n  .ant-table-thead\n  > tr\n  > th:not(:last-child):not(.ant-table-selection-column):not(\n    .ant-table-row-expand-icon-cell\n  ):not([colspan])::before,\n:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper\n  .ant-table-thead\n  > tr\n  > td:not(:last-child):not(.ant-table-selection-column):not(\n    .ant-table-row-expand-icon-cell\n  ):not([colspan])::before {\n  content: none;\n}\n\n:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper\n  .ant-table-thead\n  th.ant-table-column-has-sorters:hover {\n  background: none;\n}\n\n.ant-table-content table tr.ant-table-row:hover {\n  background: none;\n}\n\n:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper\n  .ant-table-tbody\n  .ant-table-row\n  > .ant-table-cell-row-hover {\n  background: none;\n}\n\n:where(.css-dev-only-do-not-override-1b0bdye).ant-table-wrapper\n  .ant-table-tbody\n  > tr\n  > td {\n  padding-right: 10px;\n}\n\nul.ant-pagination.ant-table-pagination li button.ant-pagination-item-link {\n  color: #67748e;\n}\n\n[data-layout-mode=\"dark_mode\"] .css-13cymwt-control {\n  background-color: #1d1d42;\n  border: 1px solid#67748E;\n}\n\n[data-layout-mode=\"dark_mode\"] .css-t3ipsp-control {\n  background-color: #1d1d42;\n}\n\n[data-layout-mode=\"dark_mode\"] .css-1nmdiq5-menu {\n  background-color: #1d1d42;\n}\n\n.css-1fdsijx-ValueContainer .css-1dimb5e-singleValue {\n  color: #67748e;\n}\n\n.ant-table-cell .action-table-data {\n  border-bottom: 0 !important;\n}\n\n.ant-table-cell .action-table-data:hover {\n  background: none;\n}\n\n.ant-table-cell.ant-table-cell-row-hover .action-table-data {\n  background: none;\n}\n\n.table-top-head li a.btn {\n  width: 100%;\n}\n\n.section-notes-slider .notes-slider .slick-list .slick-slide div {\n  margin-left: 12px !important;\n}\n\n.css-b62m3t-container .css-13cymwt-control {\n  border-color: #dbe0e6;\n  color: #5b6670;\n  height: 40px;\n  justify-content: center;\n  align-items: center;\n  display: flex;\n}\n.css-b62m3t-container .css-t3ipsp-control {\n  border-color: #dbe0e6;\n  box-shadow: none;\n  height: 40px;\n}\n.css-b62m3t-container .css-t3ipsp-control:hover {\n  border-color: #dbe0e6;\n}\n\ndiv.css-b62m3t-container .react-select__option--is-focused {\n  background-color: #ff9f43;\n  color: #fff;\n}\n\ndiv.css-b62m3t-container .react-select__option--is-selected {\n  background-color: #ff9f43;\n  color: #fff;\n}\n.css-b62m3t-container .css-13cymwt-control:hover {\n  border-color: #dbe0e6;\n}\ndiv.react-select__placeholder.css-1jqq78o-placeholder {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.css-1fdsijx-ValueContainer .css-1dimb5e-singleValue {\n  overflow: unset;\n}\n\n.img-select .css-1jqq78o-placeholder,\n.img-select .css-1dimb5e-singleValue {\n  padding-left: 25px;\n}\n.img-select.recent-select-notes\n  .react-select__single-value.css-1dimb5e-singleValue {\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.react-select__control.css-13cymwt-control\n  .react-select__value-container.css-1fdsijx-ValueContainer\n  .react-select__input-container.css-qbdosj-Input\n  input {\n  height: inherit;\n}\n// react select **\n\n.product-list ul li.ant-pagination-item {\n  width: 32px;\n  padding: 0;\n}\n.product-list ul li.ant-pagination-prev,\n.product-list ul li.ant-pagination-next {\n  width: 32px;\n  padding: 0;\n}\ndiv.fc .fc-button-primary:not(:disabled).fc-button-active,\ndiv.fc .fc-button-primary:not(:disabled):active {\n  background-color: #ff9f43;\n  border-color: #ff9f43;\n  color: var(--fc-button-text-color);\n  text-transform: capitalize;\n}\ndiv.fc .fc-button-primary {\n  background-color: #ff9f43;\n  border-color: #ff9f43;\n  color: var(--fc-button-text-color);\n  text-transform: capitalize;\n}\n.fc .fc-button-primary:disabled {\n  background-color: #ff9f43;\n  border-color: #ff9f43;\n  color: var(--fc-button-text-color);\n}\ndiv.ant-picker.ant-picker-outlined {\n  border: 1px solid rgba(145, 158, 171, 0.32);\n  height: 40px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #092c4c;\n  padding: 10px 10px;\n  border-radius: 5px;\n  width: 100%;\n}\n.ant-picker-suffix span {\n  display: none;\n}\ndiv.ant-picker .ant-picker-input input {\n  padding-left: 25px !important;\n}\n.input-blocks .react-select__control input[type=\"text\"],\n.input-blocks .react-select__control input[type=\"password\"],\n.input-blocks .react-select__control input[type=\"email\"] {\n  height: 0px;\n}\n.modal-header {\n  justify-content: space-between;\n}\n.searchInput div.icon svg {\n  position: absolute;\n  left: 0px;\n  top: 21px;\n  height: 15px;\n  width: 15px;\n  text-align: center;\n  line-height: 55px;\n  color: #5b6670;\n  cursor: pointer;\n}\n.ant-picker-dropdown {\n  z-index: 9999;\n}\ntable tbody div.action-table-data a {\n  border: 1px solid rgba(145, 158, 171, 0.3);\n  background-color: #ffffff;\n  border-radius: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  padding: 8px;\n}\ntable tbody div.action-table-data a .feather-view {\n  width: 14px;\n  height: 14px;\n}\ntable tbody div.action-table-data a .feather-trash-2 {\n  color: #ff0000;\n  width: 14px;\n  height: 14px;\n}\ntable tbody div.action-table-data a .feather-edit {\n  color: #3577f1;\n  width: 14px;\n  height: 14px;\n}\n.orange-text {\n  color: orange;\n}\ndiv.ant-picker.ant-picker-outlined {\n  box-shadow: none;\n}\n#panelsStayOpen-collapseOne .slick-slider div.slick-slide > div,\n#panelsStayOpen-collapseTwo .slick-slider div.slick-slide > div,\n.join-contents .slick-slider div.slick-slide > div {\n  margin-right: 10px;\n}\n.table-top-head .feather-rotate-ccw {\n  height: 16px;\n}\n.table-top-head li a svg {\n  color: #092c4c;\n}\n.table-top-head li a svg {\n  height: 16px;\n}\n#collapse-header svg {\n  height: 20px;\n}\n.stickybar {\n  position: sticky;\n  top: 0;\n}\n.input-blocks.daterange-wraper input[type=\"text\"] {\n  padding: 10px 10px 10px 35px !important;\n}\n#DataTables_Table_0_filter.dataTables_filter.custom-data-table-react {\n  justify-content: end;\n  display: flex;\n}\ndiv.rc-slider-track,\n.rc-slider-tracks {\n  background-color: #ff9f43;\n}\ndiv.rc-slider-handle {\n  border: solid 2px #ff9f43;\n}\nspan.rc-slider-dot-active {\n  border-color: #ff9f43;\n}\ndiv.rc-slider-handle:active {\n  border-color: #ff9f43;\n  box-shadow: 0 0 5px #ff9f43;\n  cursor: grabbing;\n}\n.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n  border-color: #ff9f43;\n  box-shadow: 0 0 0 5px #ff9f43;\n}\n.react-select-min-width .css-b62m3t-container {\n  min-width: 70px;\n}\ntable tbody td > div.action-table-data a .feather-edit {\n  color: #3577f1;\n  width: 14px;\n  height: 14px;\n}\ntable tbody td > div.action-table-data a {\n  border: 1px solid rgba(145, 158, 171, 0.3);\n  background-color: #ffffff;\n  border-radius: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  align-items: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  justify-content: center;\n  -webkit-justify-content: center;\n  -ms-flex-pack: center;\n  padding: 8px;\n}\n.input-groupicon .ant-picker.ant-picker-outlined {\n  display: flex;\n  align-items: center;\n}\ntable tbody td .action-table-data a .action-eye {\n  color: #092c4c;\n  width: 14px;\n  height: 14px;\n}\ntable tbody td .action-table-data a .action-download {\n  color: #3577f1;\n  width: 14px;\n  height: 14px;\n}\ntable tbody td .action-table-data a .action-edit {\n  color: #5b6670;\n  width: 14px;\n  height: 14px;\n}\n.custom-active-hassubroute-false a {\n  background: rgba(254, 159, 67, 0.08);\n  border-radius: 5px;\n  color: #fe9f43;\n}\n.custom-active-hassubroute-false a span.custom-active-span,\n.custom-active-hassubroute-false a svg {\n  color: #fe9f43 !important;\n}\n.input-blocks.search-form i {\n  position: absolute;\n  left: 10px;\n  top: 44px;\n  width: 15px;\n}\n@media (min-width: 991.98px) {\n  .expand-menu.mini-sidebar .sidebar {\n    width: 260px;\n  }\n}\n.expand-menu.mini-sidebar {\n  .sidebar-right {\n    display: block;\n    @include transition(all 0.2s ease);\n  }\n  .sidebar {\n    // width: 260px;\n    .sidebar-menu {\n      ul {\n        > li {\n          > a {\n            @include margin-padding(null, 10px 15px);\n            span {\n              display: inline-block;\n              line-height: 0;\n            }\n          }\n          svg {\n            margin-right: 10px;\n          }\n        }\n      }\n      .submenu-hdr {\n        display: block;\n      }\n    }\n  }\n  .header-left {\n    width: 260px;\n  }\n}\n.expand-menu.mini-sidebar {\n  .sidebar .sidebar-menu ul > li > a {\n    padding: 18px 15px;\n  }\n  .sidebar.collapsed-sidebar .sidebar-menu ul li a::before {\n    left: 0;\n  }\n  .sidebar.collapsed-sidebar .sidebar-menu ul li ul li a {\n    padding: 10px 15px 10px 25px;\n  }\n}\ndiv.rc-slider-handle:hover {\n  border-color: #ff8d1f;\n}\ndiv.rc-slider-handle-dragging.rc-slider-handle-dragging.rc-slider-handle-dragging {\n  border-color: #ff8d1f;\n  box-shadow: 0 0 0 5px #ff8d1f;\n}\n.total-order.max-widthauto ul {\n  margin-top: 20px;\n}\n.feather-dashboard {\n  color: #fff;\n}\n:where(.css-mzwlov).ant-table-wrapper .ant-table-thead >tr>th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before, :where(.css-mzwlov).ant-table-wrapper .ant-table-thead >tr>td:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n  position: absolute;\n  top: 50%;\n  inset-inline-end: 0;\n  width: 1px;\n  height: 1.6em;\n  background-color: transparent;\n  transform: translateY(-50%);\n  transition: background-color 0.2s;\n  content: \"\";\n}\n.edit-delete-action a:hover i.feather-edit,\n.edit-delete-action a:hover i.feather-trash-2\n {\n  color: #ffffff !important;\n}\n#collapse-header.active {\n  border: none;\n}\n.modal .content {\n  padding: 0 !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
